import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  FileUpload: { input: any; output: any; }
};

export enum ActionItemCombinationRelation {
  BeforeRespectivePrescription = 'BEFORE_RESPECTIVE_PRESCRIPTION',
  StartingFromOrBeforeRespectivePrescription = 'STARTING_FROM_OR_BEFORE_RESPECTIVE_PRESCRIPTION',
  StartingFromRespectivePrescription = 'STARTING_FROM_RESPECTIVE_PRESCRIPTION'
}

export enum ActionItemCombinationRule {
  Independently = 'INDEPENDENTLY',
  InCombinationWith = 'IN_COMBINATION_WITH'
}

export enum ActionItemRangeType {
  StartingFrom = 'STARTING_FROM',
  StartingFromConditionBound = 'STARTING_FROM_CONDITION_BOUND',
  Within = 'WITHIN',
  WithinConditionBound = 'WITHIN_CONDITION_BOUND'
}

export enum ActionLogicalOperator {
  AndTo = 'AND_TO',
  Of = 'OF',
  OrTo = 'OR_TO'
}

export type ActionPrescriptionRelationship = {
  order?: Maybe<Scalars['Int']['output']>;
};

export type ActionPrescriptionRelationshipSort = {
  order?: InputMaybe<SortDirection>;
};

export type ActionPrescriptionRelationshipWhere = {
  AND?: InputMaybe<Array<ActionPrescriptionRelationshipWhere>>;
  NOT?: InputMaybe<ActionPrescriptionRelationshipWhere>;
  OR?: InputMaybe<Array<ActionPrescriptionRelationshipWhere>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export enum ActionSetsOperator {
  BiggestOf = 'BIGGEST_OF'
}

export enum ActionType {
  Apply = 'APPLY',
  Deduct = 'DEDUCT',
  SetBasePriceTo = 'SET_BASE_PRICE_TO',
  SetNetPriceTo = 'SET_NET_PRICE_TO'
}

export type ActiveUserSession = {
  __typename?: 'ActiveUserSession';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  loginTimeUtc?: Maybe<Scalars['String']['output']>;
  subjectId: Scalars['String']['output'];
  tokenRefreshTimeUtc?: Maybe<Scalars['String']['output']>;
};

export type ActiveUserSessionEdge = {
  __typename?: 'ActiveUserSessionEdge';
  cursor: Scalars['String']['output'];
  node: ActiveUserSession;
};

export type ActiveUserSessionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ActiveUserSessionSort objects to sort ActiveUserSessions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ActiveUserSessionSort>>;
};

/** Fields to sort ActiveUserSessions by. The order in which sorts are applied is not guaranteed when specifying many fields in one ActiveUserSessionSort object. */
export type ActiveUserSessionSort = {
  email?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  loginTimeUtc?: InputMaybe<SortDirection>;
  subjectId?: InputMaybe<SortDirection>;
  tokenRefreshTimeUtc?: InputMaybe<SortDirection>;
};

export type ActiveUserSessionWhere = {
  AND?: InputMaybe<Array<ActiveUserSessionWhere>>;
  NOT?: InputMaybe<ActiveUserSessionWhere>;
  OR?: InputMaybe<Array<ActiveUserSessionWhere>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  loginTimeUtc?: InputMaybe<Scalars['String']['input']>;
  loginTimeUtc_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  loginTimeUtc_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  loginTimeUtc_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loginTimeUtc_MATCHES?: InputMaybe<Scalars['String']['input']>;
  loginTimeUtc_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  subjectId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  subjectId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  subjectId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  subjectId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  subjectId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tokenRefreshTimeUtc?: InputMaybe<Scalars['String']['input']>;
  tokenRefreshTimeUtc_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tokenRefreshTimeUtc_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tokenRefreshTimeUtc_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tokenRefreshTimeUtc_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tokenRefreshTimeUtc_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ActiveUserSessionsConnection = {
  __typename?: 'ActiveUserSessionsConnection';
  edges: Array<ActiveUserSessionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AdverseEventGrades {
  I = 'I',
  Ii = 'II',
  Iii = 'III',
  Iv = 'IV',
  NoInfo = 'NO_INFO'
}

export enum AdverseEventType {
  AbdominalPain = 'ABDOMINAL_PAIN',
  AcuteHepatitis = 'ACUTE_HEPATITIS',
  Alopecia = 'ALOPECIA',
  AltIncreased = 'ALT_INCREASED',
  Anemia = 'ANEMIA',
  Arthralgia = 'ARTHRALGIA',
  AstIncreased = 'AST_INCREASED',
  BackPain = 'BACK_PAIN',
  BloodCreatinineIncreased = 'BLOOD_CREATININE_INCREASED',
  ChestPain = 'CHEST_PAIN',
  Colitis = 'COLITIS',
  Constipation = 'CONSTIPATION',
  Cough = 'COUGH',
  CreatinineIncreased = 'CREATININE_INCREASED',
  DecreasedAppetite = 'DECREASED_APPETITE',
  DermatologicalToxicity = 'DERMATOLOGICAL_TOXICITY',
  Diarrhoea = 'DIARRHOEA',
  Dizziness = 'DIZZINESS',
  Dysgeusia = 'DYSGEUSIA',
  Dyspepsia = 'DYSPEPSIA',
  Dyspnea = 'DYSPNEA',
  Ecchymosis = 'ECCHYMOSIS',
  Edema = 'EDEMA',
  Endocrinopathies = 'ENDOCRINOPATHIES',
  Epistaxis = 'EPISTAXIS',
  Erythemia = 'ERYTHEMIA',
  Fatique = 'FATIQUE',
  GammaGlutamylTransferaseIncreased = 'GAMMA_GLUTAMYL_TRANSFERASE_INCREASED',
  GlucoseSerumDecreased = 'GLUCOSE_SERUM_DECREASED',
  Headache = 'HEADACHE',
  HemoglobinDecreased = 'HEMOGLOBIN_DECREASED',
  Hepatotoxicity = 'HEPATOTOXICITY',
  Hypertension = 'HYPERTENSION',
  Hypokalemia = 'HYPOKALEMIA',
  Hypopituitarism = 'HYPOPITUITARISM',
  Hypothyroidism = 'HYPOTHYROIDISM',
  Infection = 'INFECTION',
  InjectionSiteReaction = 'INJECTION_SITE_REACTION',
  InterstitialLungDisease = 'INTERSTITIAL_LUNG_DISEASE',
  LeukocytesDecreased = 'LEUKOCYTES_DECREASED',
  Leukopenia = 'LEUKOPENIA',
  LymphocytesDecreased = 'LYMPHOCYTES_DECREASED',
  MusculoskeletalPain = 'MUSCULOSKELETAL_PAIN',
  Myocarditis = 'MYOCARDITIS',
  Nausea = 'NAUSEA',
  NeurologicToxicity = 'NEUROLOGIC_TOXICITY',
  Neutropenia = 'NEUTROPENIA',
  NeutrophilsDecreased = 'NEUTROPHILS_DECREASED',
  NoInfo = 'NO_INFO',
  PainInExtremity = 'PAIN_IN_EXTREMITY',
  PeripheralEdema = 'PERIPHERAL_EDEMA',
  PhotosensitivityReaction = 'PHOTOSENSITIVITY_REACTION',
  PlateletsDecreased = 'PLATELETS_DECREASED',
  Pneumonitis = 'PNEUMONITIS',
  Proteinuria = 'PROTEINURIA',
  Pruritus = 'PRURITUS',
  Pyrexia = 'PYREXIA',
  Rash = 'RASH',
  RenalToxicity = 'RENAL_TOXICITY',
  RespiratoryTractInfection = 'RESPIRATORY_TRACT_INFECTION',
  Somnolence = 'SOMNOLENCE',
  Stomatitis = 'STOMATITIS',
  SystemicHypertension = 'SYSTEMIC_HYPERTENSION',
  Thrombocytopenia = 'THROMBOCYTOPENIA',
  ViralInfection = 'VIRAL_INFECTION',
  Vomiting = 'VOMITING'
}

export type Agreement = {
  __typename?: 'Agreement';
  addedBy: User;
  addedByAggregate?: Maybe<AgreementUserAddedByAggregationSelection>;
  addedByConnection: AgreementAddedByConnection;
  allowedForms?: Maybe<Array<Scalars['String']['output']>>;
  allowedRecords?: Maybe<Array<Scalars['String']['output']>>;
  areCasesCreated: Scalars['Boolean']['output'];
  caseSuspensionIntervalDays?: Maybe<Scalars['Int']['output']>;
  counterparties: Array<Organization>;
  counterpartiesAggregate?: Maybe<AgreementOrganizationCounterpartiesAggregationSelection>;
  counterpartiesConnection: AgreementCounterpartiesConnection;
  country: Country;
  countryAggregate?: Maybe<AgreementCountryCountryAggregationSelection>;
  countryConnection: AgreementCountryConnection;
  coveringFormWaitInterval?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['DateTime']['output'];
  currency: Currency;
  currencyAggregate?: Maybe<AgreementCurrencyCurrencyAggregationSelection>;
  currencyConnection: AgreementCurrencyConnection;
  cycles: Array<CycleConfiguration>;
  cyclesAggregate?: Maybe<AgreementCycleConfigurationCyclesAggregationSelection>;
  cyclesConnection: AgreementCyclesConnection;
  dataContainers: Array<DataContainer>;
  dataContainersAggregate?: Maybe<AgreementDataContainerDataContainersAggregationSelection>;
  dataContainersConnection: AgreementDataContainersConnection;
  dataSource: DataSource;
  dataSourceAggregate?: Maybe<AgreementDataSourceDataSourceAggregationSelection>;
  dataSourceConnection: AgreementDataSourceConnection;
  daysToExpiry?: Maybe<Scalars['Int']['output']>;
  defaultPriceRate?: Maybe<Scalars['Float']['output']>;
  deviceAlternativeSets: Array<DeviceAlternative>;
  deviceAlternativeSetsAggregate?: Maybe<AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection>;
  deviceAlternativeSetsConnection: AgreementDeviceAlternativeSetsConnection;
  dotThresholds?: Maybe<ChartRangeConfiguration>;
  dotThresholdsAggregate?: Maybe<AgreementChartRangeConfigurationDotThresholdsAggregationSelection>;
  dotThresholdsConnection: AgreementDotThresholdsConnection;
  eligibilityConditionSets: Array<EligibilityConditionSet>;
  eligibilityConditionSetsAggregate?: Maybe<AgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection>;
  eligibilityConditionSetsConnection: AgreementEligibilityConditionSetsConnection;
  eligibilityConditionTreatments?: Maybe<Array<Maybe<Treatment>>>;
  enrollingConditionSets: Array<EnrollingConditionSet>;
  enrollingConditionSetsAggregate?: Maybe<AgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection>;
  enrollingConditionSetsConnection: AgreementEnrollingConditionSetsConnection;
  enrollingPeriods: Array<EnrollingPeriod>;
  enrollingPeriodsAggregate?: Maybe<AgreementEnrollingPeriodEnrollingPeriodsAggregationSelection>;
  enrollingPeriodsConnection: AgreementEnrollingPeriodsConnection;
  enrolmentDateType?: Maybe<EnrolmentDateType>;
  expectedDocument: DocumentType;
  financialSummaryConfig: Array<FinancialSummaryColumn>;
  financialSummaryConfigAggregate?: Maybe<AgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection>;
  financialSummaryConfigConnection: AgreementFinancialSummaryConfigConnection;
  firstExecutionDate?: Maybe<Scalars['DateTime']['output']>;
  formattedAmount?: Maybe<Scalars['String']['output']>;
  formattedCounterparties?: Maybe<Scalars['String']['output']>;
  formattedDiseases?: Maybe<Scalars['String']['output']>;
  formattedIndications?: Maybe<Scalars['String']['output']>;
  formattedProducts?: Maybe<Scalars['String']['output']>;
  formattedTags?: Maybe<Scalars['String']['output']>;
  formattedValidityPeriod?: Maybe<Scalars['String']['output']>;
  generics: Array<Generic>;
  id: Scalars['ID']['output'];
  initialVersion?: Maybe<Agreement>;
  initialVersionAggregate?: Maybe<AgreementAgreementInitialVersionAggregationSelection>;
  initialVersionConnection: AgreementInitialVersionConnection;
  initialVersionId: Scalars['ID']['output'];
  isAllowedFormsEnabled: Scalars['Boolean']['output'];
  isAllowedRecordsEnabled: Scalars['Boolean']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAutoCreated?: Maybe<Scalars['Boolean']['output']>;
  isCaseless: Scalars['Boolean']['output'];
  isCoveringIntervalEnabled: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isExtended?: Maybe<Scalars['Boolean']['output']>;
  isFirstVersion: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isInsightsAvailable?: Maybe<Scalars['Boolean']['output']>;
  isLastVersion: Scalars['Boolean']['output'];
  isNewVersionManuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  isRequiredFormsEnabled: Scalars['Boolean']['output'];
  isRequiredRecordsEnabled: Scalars['Boolean']['output'];
  isScenariosInSync?: Maybe<Scalars['Boolean']['output']>;
  isScopeSync?: Maybe<Scalars['Boolean']['output']>;
  isValidityPeriodInSync?: Maybe<Scalars['Boolean']['output']>;
  lastExecutionDate?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedOn?: Maybe<Scalars['Float']['output']>;
  lastVersionValidToDate?: Maybe<Scalars['Date']['output']>;
  limitation?: Maybe<Limitation>;
  limitationAggregate?: Maybe<AgreementLimitationLimitationAggregationSelection>;
  limitationConnection: AgreementLimitationConnection;
  minValidFromDate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  negotiableAttributes: Array<CatalogueAttribute>;
  negotiableAttributesAggregate?: Maybe<AgreementCatalogueAttributeNegotiableAttributesAggregationSelection>;
  negotiableAttributesConnection: AgreementNegotiableAttributesConnection;
  nextVersions: Array<Agreement>;
  nextVersionsAggregate?: Maybe<AgreementAgreementNextVersionsAggregationSelection>;
  nextVersionsConnection: AgreementNextVersionsConnection;
  pushedBy?: Maybe<User>;
  pushedByAggregate?: Maybe<AgreementUserPushedByAggregationSelection>;
  pushedByConnection: AgreementPushedByConnection;
  pushedOn?: Maybe<Scalars['DateTime']['output']>;
  rangeChartConfig?: Maybe<ChartRangeConfiguration>;
  rangeChartConfigAggregate?: Maybe<AgreementChartRangeConfigurationRangeChartConfigAggregationSelection>;
  rangeChartConfigConnection: AgreementRangeChartConfigConnection;
  reportData?: Maybe<Scalars['String']['output']>;
  requiredForms?: Maybe<Array<Scalars['String']['output']>>;
  requiredRecords?: Maybe<Array<Scalars['String']['output']>>;
  scenarios: Array<Scenario>;
  scenariosAggregate?: Maybe<AgreementScenarioScenariosAggregationSelection>;
  scenariosConnection: AgreementScenariosConnection;
  scenariosRelevantBrands: Array<Brand>;
  scenariosRelevantBrandsAggregate?: Maybe<AgreementBrandScenariosRelevantBrandsAggregationSelection>;
  scenariosRelevantBrandsConnection: AgreementScenariosRelevantBrandsConnection;
  status: ContractStatus;
  subjectMatter: AgreementSubjectMatter;
  tags: Array<AgreementTag>;
  tagsAggregate?: Maybe<AgreementAgreementTagTagsAggregationSelection>;
  tagsConnection: AgreementTagsConnection;
  template?: Maybe<AgreementTemplate>;
  templateAggregate?: Maybe<AgreementAgreementTemplateTemplateAggregationSelection>;
  templateConnection: AgreementTemplateConnection;
  tenantIds?: Maybe<Array<Scalars['String']['output']>>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  treatmentPrices: Array<Treatment>;
  treatmentPricesAggregate?: Maybe<AgreementTreatmentTreatmentPricesAggregationSelection>;
  treatmentPricesConnection: AgreementTreatmentPricesConnection;
  userRoles: Array<User>;
  userRolesAggregate?: Maybe<AgreementUserUserRolesAggregationSelection>;
  userRolesConnection: AgreementUserRolesConnection;
  validFromDate: Scalars['Date']['output'];
  validToDate?: Maybe<Scalars['Date']['output']>;
  version: Scalars['Int']['output'];
};


export type AgreementAddedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementAddedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementAddedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementAddedByConnectionSort>>;
  where?: InputMaybe<AgreementAddedByConnectionWhere>;
};


export type AgreementCounterpartiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementCounterpartiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementCounterpartiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementCounterpartiesConnectionSort>>;
  where?: InputMaybe<AgreementCounterpartiesConnectionWhere>;
};


export type AgreementCountryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type AgreementCountryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type AgreementCountryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementCountryConnectionSort>>;
  where?: InputMaybe<AgreementCountryConnectionWhere>;
};


export type AgreementCurrencyArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurrencyOptions>;
  where?: InputMaybe<CurrencyWhere>;
};


export type AgreementCurrencyAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CurrencyWhere>;
};


export type AgreementCurrencyConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementCurrencyConnectionSort>>;
  where?: InputMaybe<AgreementCurrencyConnectionWhere>;
};


export type AgreementCyclesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CycleConfigurationOptions>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type AgreementCyclesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type AgreementCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementCyclesConnectionSort>>;
  where?: InputMaybe<AgreementCyclesConnectionWhere>;
};


export type AgreementDataContainersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DataContainerOptions>;
  where?: InputMaybe<DataContainerWhere>;
};


export type AgreementDataContainersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DataContainerWhere>;
};


export type AgreementDataContainersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementDataContainersConnectionSort>>;
  where?: InputMaybe<AgreementDataContainersConnectionWhere>;
};


export type AgreementDataSourceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DataSourceOptions>;
  where?: InputMaybe<DataSourceWhere>;
};


export type AgreementDataSourceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DataSourceWhere>;
};


export type AgreementDataSourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementDataSourceConnectionSort>>;
  where?: InputMaybe<AgreementDataSourceConnectionWhere>;
};


export type AgreementDeviceAlternativeSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DeviceAlternativeOptions>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type AgreementDeviceAlternativeSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type AgreementDeviceAlternativeSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementDeviceAlternativeSetsConnectionSort>>;
  where?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
};


export type AgreementDotThresholdsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChartRangeConfigurationOptions>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type AgreementDotThresholdsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type AgreementDotThresholdsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementDotThresholdsConnectionSort>>;
  where?: InputMaybe<AgreementDotThresholdsConnectionWhere>;
};


export type AgreementEligibilityConditionSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EligibilityConditionSetOptions>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type AgreementEligibilityConditionSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type AgreementEligibilityConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementEligibilityConditionSetsConnectionSort>>;
  where?: InputMaybe<AgreementEligibilityConditionSetsConnectionWhere>;
};


export type AgreementEnrollingConditionSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingConditionSetOptions>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type AgreementEnrollingConditionSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type AgreementEnrollingConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementEnrollingConditionSetsConnectionSort>>;
  where?: InputMaybe<AgreementEnrollingConditionSetsConnectionWhere>;
};


export type AgreementEnrollingPeriodsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingPeriodOptions>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type AgreementEnrollingPeriodsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type AgreementEnrollingPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementEnrollingPeriodsConnectionSort>>;
  where?: InputMaybe<AgreementEnrollingPeriodsConnectionWhere>;
};


export type AgreementFinancialSummaryConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FinancialSummaryColumnOptions>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type AgreementFinancialSummaryConfigAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type AgreementFinancialSummaryConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementFinancialSummaryConfigConnectionSort>>;
  where?: InputMaybe<AgreementFinancialSummaryConfigConnectionWhere>;
};


export type AgreementInitialVersionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type AgreementInitialVersionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type AgreementInitialVersionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementInitialVersionConnectionSort>>;
  where?: InputMaybe<AgreementInitialVersionConnectionWhere>;
};


export type AgreementLimitationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LimitationOptions>;
  where?: InputMaybe<LimitationWhere>;
};


export type AgreementLimitationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LimitationWhere>;
};


export type AgreementLimitationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementLimitationConnectionSort>>;
  where?: InputMaybe<AgreementLimitationConnectionWhere>;
};


export type AgreementNegotiableAttributesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type AgreementNegotiableAttributesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type AgreementNegotiableAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementNegotiableAttributesConnectionSort>>;
  where?: InputMaybe<AgreementNegotiableAttributesConnectionWhere>;
};


export type AgreementNextVersionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type AgreementNextVersionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type AgreementNextVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementNextVersionsConnectionSort>>;
  where?: InputMaybe<AgreementNextVersionsConnectionWhere>;
};


export type AgreementPushedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementPushedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementPushedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementPushedByConnectionSort>>;
  where?: InputMaybe<AgreementPushedByConnectionWhere>;
};


export type AgreementRangeChartConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChartRangeConfigurationOptions>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type AgreementRangeChartConfigAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type AgreementRangeChartConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementRangeChartConfigConnectionSort>>;
  where?: InputMaybe<AgreementRangeChartConfigConnectionWhere>;
};


export type AgreementScenariosArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioOptions>;
  where?: InputMaybe<ScenarioWhere>;
};


export type AgreementScenariosAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioWhere>;
};


export type AgreementScenariosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScenariosConnectionSort>>;
  where?: InputMaybe<AgreementScenariosConnectionWhere>;
};


export type AgreementScenariosRelevantBrandsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type AgreementScenariosRelevantBrandsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type AgreementScenariosRelevantBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScenariosRelevantBrandsConnectionSort>>;
  where?: InputMaybe<AgreementScenariosRelevantBrandsConnectionWhere>;
};


export type AgreementTagsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTagOptions>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type AgreementTagsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type AgreementTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTagsConnectionSort>>;
  where?: InputMaybe<AgreementTagsConnectionWhere>;
};


export type AgreementTemplateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type AgreementTemplateAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type AgreementTemplateConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateConnectionSort>>;
  where?: InputMaybe<AgreementTemplateConnectionWhere>;
};


export type AgreementTreatmentPricesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type AgreementTreatmentPricesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type AgreementTreatmentPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTreatmentPricesConnectionSort>>;
  where?: InputMaybe<AgreementTreatmentPricesConnectionWhere>;
};


export type AgreementUserRolesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementUserRolesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementUserRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementUserRolesConnectionSort>>;
  where?: InputMaybe<AgreementUserRolesConnectionWhere>;
};

export type AgreementAddedByAggregateInput = {
  AND?: InputMaybe<Array<AgreementAddedByAggregateInput>>;
  NOT?: InputMaybe<AgreementAddedByAggregateInput>;
  OR?: InputMaybe<Array<AgreementAddedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementAddedByNodeAggregationWhereInput>;
};

export type AgreementAddedByConnection = {
  __typename?: 'AgreementAddedByConnection';
  edges: Array<AgreementAddedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementAddedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AgreementAddedByConnectionWhere = {
  AND?: InputMaybe<Array<AgreementAddedByConnectionWhere>>;
  NOT?: InputMaybe<AgreementAddedByConnectionWhere>;
  OR?: InputMaybe<Array<AgreementAddedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementAddedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementAddedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementAddedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementAddedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementAddedByRelationship = {
  __typename?: 'AgreementAddedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AgreementAgreementInitialVersionAggregationSelection = {
  __typename?: 'AgreementAgreementInitialVersionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementAgreementInitialVersionNodeAggregateSelection>;
};

export type AgreementAgreementInitialVersionNodeAggregateSelection = {
  __typename?: 'AgreementAgreementInitialVersionNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type AgreementAgreementNextVersionsAggregationSelection = {
  __typename?: 'AgreementAgreementNextVersionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementAgreementNextVersionsNodeAggregateSelection>;
};

export type AgreementAgreementNextVersionsNodeAggregateSelection = {
  __typename?: 'AgreementAgreementNextVersionsNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type AgreementAgreementTagTagsAggregationSelection = {
  __typename?: 'AgreementAgreementTagTagsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementAgreementTagTagsNodeAggregateSelection>;
};

export type AgreementAgreementTagTagsNodeAggregateSelection = {
  __typename?: 'AgreementAgreementTagTagsNodeAggregateSelection';
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type AgreementAgreementTemplateTemplateAggregationSelection = {
  __typename?: 'AgreementAgreementTemplateTemplateAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementAgreementTemplateTemplateNodeAggregateSelection>;
};

export type AgreementAgreementTemplateTemplateNodeAggregateSelection = {
  __typename?: 'AgreementAgreementTemplateTemplateNodeAggregateSelection';
  addedByName: StringAggregateSelectionNullable;
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  treatments: StringAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type AgreementBrandScenariosRelevantBrandsAggregationSelection = {
  __typename?: 'AgreementBrandScenariosRelevantBrandsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementBrandScenariosRelevantBrandsNodeAggregateSelection>;
};

export type AgreementBrandScenariosRelevantBrandsNodeAggregateSelection = {
  __typename?: 'AgreementBrandScenariosRelevantBrandsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type AgreementCatalogueAttributeNegotiableAttributesAggregationSelection = {
  __typename?: 'AgreementCatalogueAttributeNegotiableAttributesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection>;
};

export type AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection = {
  __typename?: 'AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type AgreementChartRangeConfigurationDotThresholdsAggregationSelection = {
  __typename?: 'AgreementChartRangeConfigurationDotThresholdsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection>;
};

export type AgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection = {
  __typename?: 'AgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection';
  threshold: IntAggregateSelectionNonNullable;
};

export type AgreementChartRangeConfigurationRangeChartConfigAggregationSelection = {
  __typename?: 'AgreementChartRangeConfigurationRangeChartConfigAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection>;
};

export type AgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection = {
  __typename?: 'AgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection';
  from: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  to: IntAggregateSelectionNullable;
};

export type AgreementCounterpartiesAggregateInput = {
  AND?: InputMaybe<Array<AgreementCounterpartiesAggregateInput>>;
  NOT?: InputMaybe<AgreementCounterpartiesAggregateInput>;
  OR?: InputMaybe<Array<AgreementCounterpartiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementCounterpartiesNodeAggregationWhereInput>;
};

export type AgreementCounterpartiesConnection = {
  __typename?: 'AgreementCounterpartiesConnection';
  edges: Array<AgreementCounterpartiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementCounterpartiesConnectionSort = {
  edge?: InputMaybe<AgreementCounterpartyRelationshipSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type AgreementCounterpartiesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementCounterpartiesConnectionWhere>>;
  NOT?: InputMaybe<AgreementCounterpartiesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementCounterpartiesConnectionWhere>>;
  edge?: InputMaybe<AgreementCounterpartyRelationshipWhere>;
  node?: InputMaybe<OrganizationWhere>;
};

export type AgreementCounterpartiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementCounterpartiesNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementCounterpartiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementCounterpartiesNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementCounterpartiesRelationship = AgreementCounterpartyRelationship & {
  __typename?: 'AgreementCounterpartiesRelationship';
  cursor: Scalars['String']['output'];
  isApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  node: Organization;
  role: CounterpartyRole;
};

export type AgreementCounterpartyInput = {
  id: Scalars['ID']['input'];
  isApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  role: CounterpartyRole;
};

export type AgreementCounterpartyRelationship = {
  isApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  role: CounterpartyRole;
};

export type AgreementCounterpartyRelationshipSort = {
  isApprovalRequired?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type AgreementCounterpartyRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementCounterpartyRelationshipWhere>>;
  NOT?: InputMaybe<AgreementCounterpartyRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementCounterpartyRelationshipWhere>>;
  isApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<CounterpartyRole>;
  role_IN?: InputMaybe<Array<CounterpartyRole>>;
};

export type AgreementCountryAggregateInput = {
  AND?: InputMaybe<Array<AgreementCountryAggregateInput>>;
  NOT?: InputMaybe<AgreementCountryAggregateInput>;
  OR?: InputMaybe<Array<AgreementCountryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementCountryNodeAggregationWhereInput>;
};

export type AgreementCountryConnection = {
  __typename?: 'AgreementCountryConnection';
  edges: Array<AgreementCountryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementCountryConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type AgreementCountryConnectionWhere = {
  AND?: InputMaybe<Array<AgreementCountryConnectionWhere>>;
  NOT?: InputMaybe<AgreementCountryConnectionWhere>;
  OR?: InputMaybe<Array<AgreementCountryConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type AgreementCountryCountryAggregationSelection = {
  __typename?: 'AgreementCountryCountryAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementCountryCountryNodeAggregateSelection>;
};

export type AgreementCountryCountryNodeAggregateSelection = {
  __typename?: 'AgreementCountryCountryNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type AgreementCountryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementCountryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementCountryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementCountryNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementCountryRelationship = {
  __typename?: 'AgreementCountryRelationship';
  cursor: Scalars['String']['output'];
  node: Country;
};

export type AgreementCurrencyAggregateInput = {
  AND?: InputMaybe<Array<AgreementCurrencyAggregateInput>>;
  NOT?: InputMaybe<AgreementCurrencyAggregateInput>;
  OR?: InputMaybe<Array<AgreementCurrencyAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementCurrencyNodeAggregationWhereInput>;
};

export type AgreementCurrencyConnection = {
  __typename?: 'AgreementCurrencyConnection';
  edges: Array<AgreementCurrencyRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementCurrencyConnectionSort = {
  node?: InputMaybe<CurrencySort>;
};

export type AgreementCurrencyConnectionWhere = {
  AND?: InputMaybe<Array<AgreementCurrencyConnectionWhere>>;
  NOT?: InputMaybe<AgreementCurrencyConnectionWhere>;
  OR?: InputMaybe<Array<AgreementCurrencyConnectionWhere>>;
  node?: InputMaybe<CurrencyWhere>;
};

export type AgreementCurrencyCurrencyAggregationSelection = {
  __typename?: 'AgreementCurrencyCurrencyAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementCurrencyCurrencyNodeAggregateSelection>;
};

export type AgreementCurrencyCurrencyNodeAggregateSelection = {
  __typename?: 'AgreementCurrencyCurrencyNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNullable;
  symbol: StringAggregateSelectionNullable;
};

export type AgreementCurrencyNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementCurrencyNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementCurrencyNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementCurrencyNodeAggregationWhereInput>>;
  symbol_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementCurrencyRelationship = {
  __typename?: 'AgreementCurrencyRelationship';
  cursor: Scalars['String']['output'];
  node: Currency;
};

export type AgreementCycleConfigurationCyclesAggregationSelection = {
  __typename?: 'AgreementCycleConfigurationCyclesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementCycleConfigurationCyclesNodeAggregateSelection>;
};

export type AgreementCycleConfigurationCyclesNodeAggregateSelection = {
  __typename?: 'AgreementCycleConfigurationCyclesNodeAggregateSelection';
  lengthFrom: IntAggregateSelectionNonNullable;
  lengthTo: IntAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
};

export type AgreementCyclesAggregateInput = {
  AND?: InputMaybe<Array<AgreementCyclesAggregateInput>>;
  NOT?: InputMaybe<AgreementCyclesAggregateInput>;
  OR?: InputMaybe<Array<AgreementCyclesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementCyclesNodeAggregationWhereInput>;
};

export type AgreementCyclesConnection = {
  __typename?: 'AgreementCyclesConnection';
  edges: Array<AgreementCyclesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementCyclesConnectionSort = {
  node?: InputMaybe<CycleConfigurationSort>;
};

export type AgreementCyclesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementCyclesConnectionWhere>>;
  NOT?: InputMaybe<AgreementCyclesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementCyclesConnectionWhere>>;
  node?: InputMaybe<CycleConfigurationWhere>;
};

export type AgreementCyclesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementCyclesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementCyclesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementCyclesNodeAggregationWhereInput>>;
  lengthFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementCyclesRelationship = {
  __typename?: 'AgreementCyclesRelationship';
  cursor: Scalars['String']['output'];
  node: CycleConfiguration;
};

export type AgreementDataContainerDataContainersAggregationSelection = {
  __typename?: 'AgreementDataContainerDataContainersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementDataContainerDataContainersNodeAggregateSelection>;
};

export type AgreementDataContainerDataContainersNodeAggregateSelection = {
  __typename?: 'AgreementDataContainerDataContainersNodeAggregateSelection';
  subType: StringAggregateSelectionNullable;
  timeframeEnd: IntAggregateSelectionNullable;
  timeframeStart: IntAggregateSelectionNullable;
};

export type AgreementDataContainersAggregateInput = {
  AND?: InputMaybe<Array<AgreementDataContainersAggregateInput>>;
  NOT?: InputMaybe<AgreementDataContainersAggregateInput>;
  OR?: InputMaybe<Array<AgreementDataContainersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementDataContainersNodeAggregationWhereInput>;
};

export type AgreementDataContainersConnection = {
  __typename?: 'AgreementDataContainersConnection';
  edges: Array<AgreementDataContainersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementDataContainersConnectionSort = {
  node?: InputMaybe<DataContainerSort>;
};

export type AgreementDataContainersConnectionWhere = {
  AND?: InputMaybe<Array<AgreementDataContainersConnectionWhere>>;
  NOT?: InputMaybe<AgreementDataContainersConnectionWhere>;
  OR?: InputMaybe<Array<AgreementDataContainersConnectionWhere>>;
  node?: InputMaybe<DataContainerWhere>;
};

export type AgreementDataContainersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementDataContainersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementDataContainersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementDataContainersNodeAggregationWhereInput>>;
  subType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementDataContainersRelationship = {
  __typename?: 'AgreementDataContainersRelationship';
  cursor: Scalars['String']['output'];
  node: DataContainer;
};

export type AgreementDataSourceAggregateInput = {
  AND?: InputMaybe<Array<AgreementDataSourceAggregateInput>>;
  NOT?: InputMaybe<AgreementDataSourceAggregateInput>;
  OR?: InputMaybe<Array<AgreementDataSourceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementDataSourceNodeAggregationWhereInput>;
};

export type AgreementDataSourceConnection = {
  __typename?: 'AgreementDataSourceConnection';
  edges: Array<AgreementDataSourceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementDataSourceConnectionSort = {
  node?: InputMaybe<DataSourceSort>;
};

export type AgreementDataSourceConnectionWhere = {
  AND?: InputMaybe<Array<AgreementDataSourceConnectionWhere>>;
  NOT?: InputMaybe<AgreementDataSourceConnectionWhere>;
  OR?: InputMaybe<Array<AgreementDataSourceConnectionWhere>>;
  node?: InputMaybe<DataSourceWhere>;
};

export type AgreementDataSourceDataSourceAggregationSelection = {
  __typename?: 'AgreementDataSourceDataSourceAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementDataSourceDataSourceNodeAggregateSelection>;
};

export type AgreementDataSourceDataSourceNodeAggregateSelection = {
  __typename?: 'AgreementDataSourceDataSourceNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type AgreementDataSourceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementDataSourceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementDataSourceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementDataSourceNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementDataSourceRelationship = {
  __typename?: 'AgreementDataSourceRelationship';
  cursor: Scalars['String']['output'];
  node: DataSource;
};

export type AgreementDecision = {
  __typename?: 'AgreementDecision';
  asOf: Organization;
  asOfAggregate?: Maybe<AgreementDecisionOrganizationAsOfAggregationSelection>;
  asOfConnection: AgreementDecisionAsOfConnection;
  createdOn: Scalars['DateTime']['output'];
  decision: Decision;
  isArchived: Scalars['Boolean']['output'];
  madeBy: User;
  madeByAggregate?: Maybe<AgreementDecisionUserMadeByAggregationSelection>;
  madeByConnection: AgreementDecisionMadeByConnection;
};


export type AgreementDecisionAsOfArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementDecisionAsOfAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementDecisionAsOfConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementDecisionAsOfConnectionSort>>;
  where?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
};


export type AgreementDecisionMadeByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementDecisionMadeByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementDecisionMadeByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementDecisionMadeByConnectionSort>>;
  where?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
};

export type AgreementDecisionAsOfAggregateInput = {
  AND?: InputMaybe<Array<AgreementDecisionAsOfAggregateInput>>;
  NOT?: InputMaybe<AgreementDecisionAsOfAggregateInput>;
  OR?: InputMaybe<Array<AgreementDecisionAsOfAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementDecisionAsOfNodeAggregationWhereInput>;
};

export type AgreementDecisionAsOfConnection = {
  __typename?: 'AgreementDecisionAsOfConnection';
  edges: Array<AgreementDecisionAsOfRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementDecisionAsOfConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type AgreementDecisionAsOfConnectionWhere = {
  AND?: InputMaybe<Array<AgreementDecisionAsOfConnectionWhere>>;
  NOT?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
  OR?: InputMaybe<Array<AgreementDecisionAsOfConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type AgreementDecisionAsOfNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementDecisionAsOfNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementDecisionAsOfNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementDecisionAsOfNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementDecisionAsOfRelationship = {
  __typename?: 'AgreementDecisionAsOfRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type AgreementDecisionEdge = {
  __typename?: 'AgreementDecisionEdge';
  cursor: Scalars['String']['output'];
  node: AgreementDecision;
};

export type AgreementDecisionMadeByAggregateInput = {
  AND?: InputMaybe<Array<AgreementDecisionMadeByAggregateInput>>;
  NOT?: InputMaybe<AgreementDecisionMadeByAggregateInput>;
  OR?: InputMaybe<Array<AgreementDecisionMadeByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementDecisionMadeByNodeAggregationWhereInput>;
};

export type AgreementDecisionMadeByConnection = {
  __typename?: 'AgreementDecisionMadeByConnection';
  edges: Array<AgreementDecisionMadeByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementDecisionMadeByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AgreementDecisionMadeByConnectionWhere = {
  AND?: InputMaybe<Array<AgreementDecisionMadeByConnectionWhere>>;
  NOT?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
  OR?: InputMaybe<Array<AgreementDecisionMadeByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementDecisionMadeByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementDecisionMadeByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementDecisionMadeByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementDecisionMadeByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementDecisionMadeByRelationship = {
  __typename?: 'AgreementDecisionMadeByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AgreementDecisionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementDecisionSort objects to sort AgreementDecisions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementDecisionSort>>;
};

export type AgreementDecisionOrganizationAsOfAggregationSelection = {
  __typename?: 'AgreementDecisionOrganizationAsOfAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementDecisionOrganizationAsOfNodeAggregateSelection>;
};

export type AgreementDecisionOrganizationAsOfNodeAggregateSelection = {
  __typename?: 'AgreementDecisionOrganizationAsOfNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

/** Fields to sort AgreementDecisions by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementDecisionSort object. */
export type AgreementDecisionSort = {
  createdOn?: InputMaybe<SortDirection>;
  decision?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
};

export type AgreementDecisionUserMadeByAggregationSelection = {
  __typename?: 'AgreementDecisionUserMadeByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementDecisionUserMadeByNodeAggregateSelection>;
};

export type AgreementDecisionUserMadeByNodeAggregateSelection = {
  __typename?: 'AgreementDecisionUserMadeByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type AgreementDecisionWhere = {
  AND?: InputMaybe<Array<AgreementDecisionWhere>>;
  NOT?: InputMaybe<AgreementDecisionWhere>;
  OR?: InputMaybe<Array<AgreementDecisionWhere>>;
  asOf?: InputMaybe<OrganizationWhere>;
  asOfAggregate?: InputMaybe<AgreementDecisionAsOfAggregateInput>;
  asOfConnection?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
  asOfConnection_NOT?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
  asOf_NOT?: InputMaybe<OrganizationWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  decision?: InputMaybe<Decision>;
  decision_IN?: InputMaybe<Array<Decision>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  madeBy?: InputMaybe<UserWhere>;
  madeByAggregate?: InputMaybe<AgreementDecisionMadeByAggregateInput>;
  madeByConnection?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
  madeByConnection_NOT?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
  madeBy_NOT?: InputMaybe<UserWhere>;
};

export type AgreementDecisionsConnection = {
  __typename?: 'AgreementDecisionsConnection';
  edges: Array<AgreementDecisionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection = {
  __typename?: 'AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection>;
};

export type AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection = {
  __typename?: 'AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
};

export type AgreementDeviceAlternativeSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementDeviceAlternativeSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementDeviceAlternativeSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementDeviceAlternativeSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementDeviceAlternativeSetsNodeAggregationWhereInput>;
};

export type AgreementDeviceAlternativeSetsConnection = {
  __typename?: 'AgreementDeviceAlternativeSetsConnection';
  edges: Array<AgreementDeviceAlternativeSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementDeviceAlternativeSetsConnectionSort = {
  node?: InputMaybe<DeviceAlternativeSort>;
};

export type AgreementDeviceAlternativeSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementDeviceAlternativeSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementDeviceAlternativeSetsConnectionWhere>>;
  node?: InputMaybe<DeviceAlternativeWhere>;
};

export type AgreementDeviceAlternativeSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementDeviceAlternativeSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementDeviceAlternativeSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementDeviceAlternativeSetsNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementDeviceAlternativeSetsRelationship = {
  __typename?: 'AgreementDeviceAlternativeSetsRelationship';
  cursor: Scalars['String']['output'];
  node: DeviceAlternative;
};

export type AgreementDotThresholdsAggregateInput = {
  AND?: InputMaybe<Array<AgreementDotThresholdsAggregateInput>>;
  NOT?: InputMaybe<AgreementDotThresholdsAggregateInput>;
  OR?: InputMaybe<Array<AgreementDotThresholdsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementDotThresholdsEdgeAggregationWhereInput>;
};

export type AgreementDotThresholdsConnection = {
  __typename?: 'AgreementDotThresholdsConnection';
  edges: Array<AgreementDotThresholdsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementDotThresholdsConnectionSort = {
  edge?: InputMaybe<ThresholdConfigurationRelationshipSort>;
  node?: InputMaybe<ChartRangeConfigurationSort>;
};

export type AgreementDotThresholdsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementDotThresholdsConnectionWhere>>;
  NOT?: InputMaybe<AgreementDotThresholdsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementDotThresholdsConnectionWhere>>;
  edge?: InputMaybe<ThresholdConfigurationRelationshipWhere>;
  node?: InputMaybe<ChartRangeConfigurationWhere>;
};

export type AgreementDotThresholdsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementDotThresholdsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementDotThresholdsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementDotThresholdsEdgeAggregationWhereInput>>;
  threshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementDotThresholdsRelationship = ThresholdConfigurationRelationship & {
  __typename?: 'AgreementDotThresholdsRelationship';
  cursor: Scalars['String']['output'];
  node: ChartRangeConfiguration;
  threshold: Scalars['Int']['output'];
};

export type AgreementEdge = {
  __typename?: 'AgreementEdge';
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type AgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection = {
  __typename?: 'AgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection>;
  node?: Maybe<AgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection>;
};

export type AgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection = {
  __typename?: 'AgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection';
  days: IntAggregateSelectionNullable;
  minimumPercentage: IntAggregateSelectionNullable;
  numberOfAdministeredTreatments: IntAggregateSelectionNullable;
  previousTestNumber: IntAggregateSelectionNullable;
  referenceAdministrationSequenceNumber: IntAggregateSelectionNullable;
  value: IntAggregateSelectionNullable;
};

export type AgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection = {
  __typename?: 'AgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  inputLabel: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
};

export type AgreementEligibilityConditionSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementEligibilityConditionSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementEligibilityConditionSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementEligibilityConditionSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementEligibilityConditionSetsEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementEligibilityConditionSetsNodeAggregationWhereInput>;
};

export type AgreementEligibilityConditionSetsConnection = {
  __typename?: 'AgreementEligibilityConditionSetsConnection';
  edges: Array<AgreementEligibilityConditionSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementEligibilityConditionSetsConnectionSort = {
  edge?: InputMaybe<AgreementTemplateEligibilityConditionRelationshipSort>;
  node?: InputMaybe<EligibilityConditionSetSort>;
};

export type AgreementEligibilityConditionSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementEligibilityConditionSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementEligibilityConditionSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementEligibilityConditionSetsConnectionWhere>>;
  edge?: InputMaybe<AgreementTemplateEligibilityConditionRelationshipWhere>;
  node?: InputMaybe<EligibilityConditionSetWhere>;
};

export type AgreementEligibilityConditionSetsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementEligibilityConditionSetsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementEligibilityConditionSetsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementEligibilityConditionSetsEdgeAggregationWhereInput>>;
  days_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  days_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementEligibilityConditionSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementEligibilityConditionSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementEligibilityConditionSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementEligibilityConditionSetsNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementEligibilityConditionSetsRelationship = AgreementTemplateEligibilityConditionRelationship & {
  __typename?: 'AgreementEligibilityConditionSetsRelationship';
  cursor: Scalars['String']['output'];
  cycleAdherence?: Maybe<CycleAdherence>;
  days?: Maybe<Scalars['Int']['output']>;
  minimumPercentage?: Maybe<Scalars['Int']['output']>;
  node: EligibilityConditionSet;
  numberOfAdministeredRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  numberOfAdministeredTreatments?: Maybe<Scalars['Int']['output']>;
  numberOfAdministeredTreatmentsOperator?: Maybe<ArithmeticalOperator>;
  previousTestNumber?: Maybe<Scalars['Int']['output']>;
  referenceAdministrationSequenceNumber?: Maybe<Scalars['Int']['output']>;
  referenceTestRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  treatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type AgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection = {
  __typename?: 'AgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection>;
};

export type AgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection = {
  __typename?: 'AgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
};

export type AgreementEnrollingConditionSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementEnrollingConditionSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementEnrollingConditionSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementEnrollingConditionSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementEnrollingConditionSetsNodeAggregationWhereInput>;
};

export type AgreementEnrollingConditionSetsConnection = {
  __typename?: 'AgreementEnrollingConditionSetsConnection';
  edges: Array<AgreementEnrollingConditionSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementEnrollingConditionSetsConnectionSort = {
  edge?: InputMaybe<EnrollingConditionSetRelationshipSort>;
  node?: InputMaybe<EnrollingConditionSetSort>;
};

export type AgreementEnrollingConditionSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementEnrollingConditionSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementEnrollingConditionSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementEnrollingConditionSetsConnectionWhere>>;
  edge?: InputMaybe<EnrollingConditionSetRelationshipWhere>;
  node?: InputMaybe<EnrollingConditionSetWhere>;
};

export type AgreementEnrollingConditionSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementEnrollingConditionSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementEnrollingConditionSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementEnrollingConditionSetsNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementEnrollingConditionSetsRelationship = EnrollingConditionSetRelationship & {
  __typename?: 'AgreementEnrollingConditionSetsRelationship';
  cursor: Scalars['String']['output'];
  isExtended?: Maybe<Scalars['Boolean']['output']>;
  node: EnrollingConditionSet;
};

export type AgreementEnrollingPeriodEnrollingPeriodsAggregationSelection = {
  __typename?: 'AgreementEnrollingPeriodEnrollingPeriodsAggregationSelection';
  count: Scalars['Int']['output'];
};

export type AgreementEnrollingPeriodsAggregateInput = {
  AND?: InputMaybe<Array<AgreementEnrollingPeriodsAggregateInput>>;
  NOT?: InputMaybe<AgreementEnrollingPeriodsAggregateInput>;
  OR?: InputMaybe<Array<AgreementEnrollingPeriodsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementEnrollingPeriodsConnection = {
  __typename?: 'AgreementEnrollingPeriodsConnection';
  edges: Array<AgreementEnrollingPeriodsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementEnrollingPeriodsConnectionSort = {
  node?: InputMaybe<EnrollingPeriodSort>;
};

export type AgreementEnrollingPeriodsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementEnrollingPeriodsConnectionWhere>>;
  NOT?: InputMaybe<AgreementEnrollingPeriodsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementEnrollingPeriodsConnectionWhere>>;
  node?: InputMaybe<EnrollingPeriodWhere>;
};

export type AgreementEnrollingPeriodsRelationship = {
  __typename?: 'AgreementEnrollingPeriodsRelationship';
  cursor: Scalars['String']['output'];
  node: EnrollingPeriod;
};

export type AgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection = {
  __typename?: 'AgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection>;
  node?: Maybe<AgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection>;
};

export type AgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection = {
  __typename?: 'AgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection';
  localizationKey: StringAggregateSelectionNullable;
  position: IntAggregateSelectionNullable;
};

export type AgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection = {
  __typename?: 'AgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
};

export type AgreementFinancialSummaryColumnRelationship = {
  hasHelpMessage?: Maybe<Scalars['Boolean']['output']>;
  isIncluded?: Maybe<Scalars['Boolean']['output']>;
  localizationKey?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type AgreementFinancialSummaryColumnRelationshipSort = {
  hasHelpMessage?: InputMaybe<SortDirection>;
  isIncluded?: InputMaybe<SortDirection>;
  localizationKey?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
};

export type AgreementFinancialSummaryColumnRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementFinancialSummaryColumnRelationshipWhere>>;
  NOT?: InputMaybe<AgreementFinancialSummaryColumnRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementFinancialSummaryColumnRelationshipWhere>>;
  hasHelpMessage?: InputMaybe<Scalars['Boolean']['input']>;
  isIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  localizationKey?: InputMaybe<Scalars['String']['input']>;
  localizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  localizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  localizationKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  localizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_GT?: InputMaybe<Scalars['Int']['input']>;
  position_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementFinancialSummaryConfigAggregateInput = {
  AND?: InputMaybe<Array<AgreementFinancialSummaryConfigAggregateInput>>;
  NOT?: InputMaybe<AgreementFinancialSummaryConfigAggregateInput>;
  OR?: InputMaybe<Array<AgreementFinancialSummaryConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementFinancialSummaryConfigEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementFinancialSummaryConfigNodeAggregationWhereInput>;
};

export type AgreementFinancialSummaryConfigConnection = {
  __typename?: 'AgreementFinancialSummaryConfigConnection';
  edges: Array<AgreementFinancialSummaryConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementFinancialSummaryConfigConnectionSort = {
  edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipSort>;
  node?: InputMaybe<FinancialSummaryColumnSort>;
};

export type AgreementFinancialSummaryConfigConnectionWhere = {
  AND?: InputMaybe<Array<AgreementFinancialSummaryConfigConnectionWhere>>;
  NOT?: InputMaybe<AgreementFinancialSummaryConfigConnectionWhere>;
  OR?: InputMaybe<Array<AgreementFinancialSummaryConfigConnectionWhere>>;
  edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipWhere>;
  node?: InputMaybe<FinancialSummaryColumnWhere>;
};

export type AgreementFinancialSummaryConfigEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementFinancialSummaryConfigEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementFinancialSummaryConfigEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementFinancialSummaryConfigEdgeAggregationWhereInput>>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementFinancialSummaryConfigNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementFinancialSummaryConfigNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementFinancialSummaryConfigNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementFinancialSummaryConfigNodeAggregationWhereInput>>;
};

export type AgreementFinancialSummaryConfigRelationship = AgreementFinancialSummaryColumnRelationship & {
  __typename?: 'AgreementFinancialSummaryConfigRelationship';
  cursor: Scalars['String']['output'];
  hasHelpMessage?: Maybe<Scalars['Boolean']['output']>;
  isIncluded?: Maybe<Scalars['Boolean']['output']>;
  localizationKey?: Maybe<Scalars['String']['output']>;
  node: FinancialSummaryColumn;
  position?: Maybe<Scalars['Int']['output']>;
};

export type AgreementInitialVersionAggregateInput = {
  AND?: InputMaybe<Array<AgreementInitialVersionAggregateInput>>;
  NOT?: InputMaybe<AgreementInitialVersionAggregateInput>;
  OR?: InputMaybe<Array<AgreementInitialVersionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementInitialVersionNodeAggregationWhereInput>;
};

export type AgreementInitialVersionConnection = {
  __typename?: 'AgreementInitialVersionConnection';
  edges: Array<AgreementInitialVersionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementInitialVersionConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type AgreementInitialVersionConnectionWhere = {
  AND?: InputMaybe<Array<AgreementInitialVersionConnectionWhere>>;
  NOT?: InputMaybe<AgreementInitialVersionConnectionWhere>;
  OR?: InputMaybe<Array<AgreementInitialVersionConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type AgreementInitialVersionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementInitialVersionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementInitialVersionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementInitialVersionNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementInitialVersionRelationship = {
  __typename?: 'AgreementInitialVersionRelationship';
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type AgreementInput = {
  agreementTags: AgreementTagType;
  agreementTemplateId: Scalars['ID']['input'];
  allowedForms?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  caseSuspensionIntervalDays?: InputMaybe<Scalars['Int']['input']>;
  childAgreementsDefaultStatus?: InputMaybe<ContractStatus>;
  counterparties: Array<AgreementCounterpartyInput>;
  country?: InputMaybe<CountryInput>;
  coveringFormWaitInterval?: InputMaybe<Scalars['Int']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  cycles: Array<CycleConfigurationInput>;
  dataContainers: Array<DataContainerInput>;
  dataSourceId: Scalars['ID']['input'];
  defaultPriceRate?: InputMaybe<Scalars['Float']['input']>;
  deviceAlternativeSets?: InputMaybe<Array<DeviceAlternativeInput>>;
  dotChartConfig: Array<ChartRangeConfigInput>;
  dotThresholds: Array<Scalars['Int']['input']>;
  eligibilityConditionSets?: InputMaybe<Array<EligibilityConditionSetInput>>;
  enrollingConditionSets: Array<EnrollingConditionSetInput>;
  enrollingPeriod?: InputMaybe<EnrollingPeriodInput>;
  enrolmentDateType?: InputMaybe<EnrolmentDateType>;
  expectedDocument?: InputMaybe<DocumentType>;
  financialSummaryConfig: Array<FinancialSummaryConfigInput>;
  formattedAmount?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases?: InputMaybe<Scalars['String']['input']>;
  formattedIndications?: InputMaybe<Scalars['String']['input']>;
  formattedProducts?: InputMaybe<Scalars['String']['input']>;
  hasAlternatives?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  initialVersionId?: InputMaybe<Scalars['ID']['input']>;
  isAllowedFormsEnabled: Scalars['Boolean']['input'];
  isAllowedRecordsEnabled: Scalars['Boolean']['input'];
  isAutoCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isCaseless: Scalars['Boolean']['input'];
  isCoveringIntervalEnabled: Scalars['Boolean']['input'];
  isExtended?: InputMaybe<Scalars['Boolean']['input']>;
  isNewVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isPush?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredFormsEnabled: Scalars['Boolean']['input'];
  isRequiredRecordsEnabled: Scalars['Boolean']['input'];
  ldlChartConfig: Array<ChartRangeConfigInput>;
  limitationId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  negotiableAttributeIds: Array<Scalars['String']['input']>;
  requiredForms?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  scenarios: Array<ScenarioInput>;
  scenariosRelevantBrands: Array<BrandAndGenericInput>;
  status?: InputMaybe<ContractStatus>;
  subjectMatter: AgreementSubjectMatter;
  treatmentNames: Scalars['String']['input'];
  treatmentPrices: Array<TreatmentPriceInput>;
  userRoles: Array<AgreementUserRoleInput>;
  validFromDate: Scalars['Date']['input'];
  validToDate?: InputMaybe<Scalars['Date']['input']>;
  version: Scalars['Int']['input'];
};

export type AgreementLimitationAggregateInput = {
  AND?: InputMaybe<Array<AgreementLimitationAggregateInput>>;
  NOT?: InputMaybe<AgreementLimitationAggregateInput>;
  OR?: InputMaybe<Array<AgreementLimitationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementLimitationNodeAggregationWhereInput>;
};

export type AgreementLimitationConnection = {
  __typename?: 'AgreementLimitationConnection';
  edges: Array<AgreementLimitationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementLimitationConnectionSort = {
  node?: InputMaybe<LimitationSort>;
};

export type AgreementLimitationConnectionWhere = {
  AND?: InputMaybe<Array<AgreementLimitationConnectionWhere>>;
  NOT?: InputMaybe<AgreementLimitationConnectionWhere>;
  OR?: InputMaybe<Array<AgreementLimitationConnectionWhere>>;
  node?: InputMaybe<LimitationWhere>;
};

export type AgreementLimitationLimitationAggregationSelection = {
  __typename?: 'AgreementLimitationLimitationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementLimitationLimitationNodeAggregateSelection>;
};

export type AgreementLimitationLimitationNodeAggregateSelection = {
  __typename?: 'AgreementLimitationLimitationNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  DescriptionDe: StringAggregateSelectionNonNullable;
  DescriptionEn: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  Niveau: StringAggregateSelectionNullable;
  Type: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
};

export type AgreementLimitationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementLimitationNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementLimitationNodeAggregationWhereInput>;
  Niveau_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementLimitationNodeAggregationWhereInput>>;
  Type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AgreementLimitationRelationship = {
  __typename?: 'AgreementLimitationRelationship';
  cursor: Scalars['String']['output'];
  node: Limitation;
};

export type AgreementNegotiableAttributesAggregateInput = {
  AND?: InputMaybe<Array<AgreementNegotiableAttributesAggregateInput>>;
  NOT?: InputMaybe<AgreementNegotiableAttributesAggregateInput>;
  OR?: InputMaybe<Array<AgreementNegotiableAttributesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementNegotiableAttributesNodeAggregationWhereInput>;
};

export type AgreementNegotiableAttributesConnection = {
  __typename?: 'AgreementNegotiableAttributesConnection';
  edges: Array<AgreementNegotiableAttributesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementNegotiableAttributesConnectionSort = {
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type AgreementNegotiableAttributesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementNegotiableAttributesConnectionWhere>>;
  NOT?: InputMaybe<AgreementNegotiableAttributesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementNegotiableAttributesConnectionWhere>>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type AgreementNegotiableAttributesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementNegotiableAttributesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementNegotiableAttributesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementNegotiableAttributesNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementNegotiableAttributesRelationship = {
  __typename?: 'AgreementNegotiableAttributesRelationship';
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
};

export type AgreementNextVersionsAggregateInput = {
  AND?: InputMaybe<Array<AgreementNextVersionsAggregateInput>>;
  NOT?: InputMaybe<AgreementNextVersionsAggregateInput>;
  OR?: InputMaybe<Array<AgreementNextVersionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementNextVersionsNodeAggregationWhereInput>;
};

export type AgreementNextVersionsConnection = {
  __typename?: 'AgreementNextVersionsConnection';
  edges: Array<AgreementNextVersionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementNextVersionsConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type AgreementNextVersionsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementNextVersionsConnectionWhere>>;
  NOT?: InputMaybe<AgreementNextVersionsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementNextVersionsConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type AgreementNextVersionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementNextVersionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementNextVersionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementNextVersionsNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementNextVersionsRelationship = {
  __typename?: 'AgreementNextVersionsRelationship';
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type AgreementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementSort objects to sort Agreements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementSort>>;
};

export type AgreementOrganizationCounterpartiesAggregationSelection = {
  __typename?: 'AgreementOrganizationCounterpartiesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementOrganizationCounterpartiesNodeAggregateSelection>;
};

export type AgreementOrganizationCounterpartiesNodeAggregateSelection = {
  __typename?: 'AgreementOrganizationCounterpartiesNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type AgreementPushedByAggregateInput = {
  AND?: InputMaybe<Array<AgreementPushedByAggregateInput>>;
  NOT?: InputMaybe<AgreementPushedByAggregateInput>;
  OR?: InputMaybe<Array<AgreementPushedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementPushedByNodeAggregationWhereInput>;
};

export type AgreementPushedByConnection = {
  __typename?: 'AgreementPushedByConnection';
  edges: Array<AgreementPushedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementPushedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AgreementPushedByConnectionWhere = {
  AND?: InputMaybe<Array<AgreementPushedByConnectionWhere>>;
  NOT?: InputMaybe<AgreementPushedByConnectionWhere>;
  OR?: InputMaybe<Array<AgreementPushedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementPushedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementPushedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementPushedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementPushedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementPushedByRelationship = {
  __typename?: 'AgreementPushedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AgreementRangeChartConfigAggregateInput = {
  AND?: InputMaybe<Array<AgreementRangeChartConfigAggregateInput>>;
  NOT?: InputMaybe<AgreementRangeChartConfigAggregateInput>;
  OR?: InputMaybe<Array<AgreementRangeChartConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementRangeChartConfigEdgeAggregationWhereInput>;
};

export type AgreementRangeChartConfigConnection = {
  __typename?: 'AgreementRangeChartConfigConnection';
  edges: Array<AgreementRangeChartConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementRangeChartConfigConnectionSort = {
  edge?: InputMaybe<ChartRangeConfigurationRelationshipSort>;
  node?: InputMaybe<ChartRangeConfigurationSort>;
};

export type AgreementRangeChartConfigConnectionWhere = {
  AND?: InputMaybe<Array<AgreementRangeChartConfigConnectionWhere>>;
  NOT?: InputMaybe<AgreementRangeChartConfigConnectionWhere>;
  OR?: InputMaybe<Array<AgreementRangeChartConfigConnectionWhere>>;
  edge?: InputMaybe<ChartRangeConfigurationRelationshipWhere>;
  node?: InputMaybe<ChartRangeConfigurationWhere>;
};

export type AgreementRangeChartConfigEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementRangeChartConfigEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementRangeChartConfigEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementRangeChartConfigEdgeAggregationWhereInput>>;
  from_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  from_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  to_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementRangeChartConfigRelationship = ChartRangeConfigurationRelationship & {
  __typename?: 'AgreementRangeChartConfigRelationship';
  cursor: Scalars['String']['output'];
  from: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  node: ChartRangeConfiguration;
  order: Scalars['Int']['output'];
  to?: Maybe<Scalars['Int']['output']>;
};

export type AgreementRunAttemptInfo = {
  __typename?: 'AgreementRunAttemptInfo';
  agreementIdsToBeAttempted: Array<Scalars['String']['output']>;
  attemptedAgreementCount?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['DateTime']['output'];
  failedAgreementIds: Array<Scalars['String']['output']>;
  filtersAppliedForRun?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isBulkRun?: Maybe<Scalars['Boolean']['output']>;
  nonAttemptedAgreementCount?: Maybe<Scalars['Int']['output']>;
  organizationTriggered?: Maybe<Organization>;
  organizationTriggeredAggregate?: Maybe<AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection>;
  organizationTriggeredConnection: AgreementRunAttemptInfoOrganizationTriggeredConnection;
  runEnd?: Maybe<Scalars['DateTime']['output']>;
  runInitiator?: Maybe<User>;
  runInitiatorAggregate?: Maybe<AgreementRunAttemptInfoUserRunInitiatorAggregationSelection>;
  runInitiatorConnection: AgreementRunAttemptInfoRunInitiatorConnection;
  runStart?: Maybe<Scalars['DateTime']['output']>;
  succeededCount?: Maybe<Scalars['Int']['output']>;
  triggeredEvent?: Maybe<AgreementRunTrigger>;
};


export type AgreementRunAttemptInfoOrganizationTriggeredArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementRunAttemptInfoOrganizationTriggeredAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementRunAttemptInfoOrganizationTriggeredConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredConnectionSort>>;
  where?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere>;
};


export type AgreementRunAttemptInfoRunInitiatorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementRunAttemptInfoRunInitiatorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementRunAttemptInfoRunInitiatorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorConnectionSort>>;
  where?: InputMaybe<AgreementRunAttemptInfoRunInitiatorConnectionWhere>;
};

export type AgreementRunAttemptInfoEdge = {
  __typename?: 'AgreementRunAttemptInfoEdge';
  cursor: Scalars['String']['output'];
  node: AgreementRunAttemptInfo;
};

export type AgreementRunAttemptInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementRunAttemptInfoSort objects to sort AgreementRunAttemptInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementRunAttemptInfoSort>>;
};

export type AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection = {
  __typename?: 'AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection>;
};

export type AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection = {
  __typename?: 'AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type AgreementRunAttemptInfoOrganizationTriggeredAggregateInput = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredAggregateInput>>;
  NOT?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredAggregateInput>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput>;
};

export type AgreementRunAttemptInfoOrganizationTriggeredConnection = {
  __typename?: 'AgreementRunAttemptInfoOrganizationTriggeredConnection';
  edges: Array<AgreementRunAttemptInfoOrganizationTriggeredRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementRunAttemptInfoOrganizationTriggeredConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere>>;
  NOT?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementRunAttemptInfoOrganizationTriggeredRelationship = {
  __typename?: 'AgreementRunAttemptInfoOrganizationTriggeredRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type AgreementRunAttemptInfoRunInitiatorAggregateInput = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorAggregateInput>>;
  NOT?: InputMaybe<AgreementRunAttemptInfoRunInitiatorAggregateInput>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput>;
};

export type AgreementRunAttemptInfoRunInitiatorConnection = {
  __typename?: 'AgreementRunAttemptInfoRunInitiatorConnection';
  edges: Array<AgreementRunAttemptInfoRunInitiatorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementRunAttemptInfoRunInitiatorConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AgreementRunAttemptInfoRunInitiatorConnectionWhere = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorConnectionWhere>>;
  NOT?: InputMaybe<AgreementRunAttemptInfoRunInitiatorConnectionWhere>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementRunAttemptInfoRunInitiatorRelationship = {
  __typename?: 'AgreementRunAttemptInfoRunInitiatorRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

/** Fields to sort AgreementRunAttemptInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementRunAttemptInfoSort object. */
export type AgreementRunAttemptInfoSort = {
  attemptedAgreementCount?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  filtersAppliedForRun?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isBulkRun?: InputMaybe<SortDirection>;
  nonAttemptedAgreementCount?: InputMaybe<SortDirection>;
  runEnd?: InputMaybe<SortDirection>;
  runStart?: InputMaybe<SortDirection>;
  succeededCount?: InputMaybe<SortDirection>;
  triggeredEvent?: InputMaybe<SortDirection>;
};

export type AgreementRunAttemptInfoUserRunInitiatorAggregationSelection = {
  __typename?: 'AgreementRunAttemptInfoUserRunInitiatorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection>;
};

export type AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection = {
  __typename?: 'AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type AgreementRunAttemptInfoWhere = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoWhere>>;
  NOT?: InputMaybe<AgreementRunAttemptInfoWhere>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoWhere>>;
  agreementIdsToBeAttempted?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementIdsToBeAttempted_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  attemptedAgreementCount?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  attemptedAgreementCount_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  failedAgreementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  failedAgreementIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  filtersAppliedForRun?: InputMaybe<Scalars['String']['input']>;
  filtersAppliedForRun_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filtersAppliedForRun_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersAppliedForRun_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filtersAppliedForRun_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filtersAppliedForRun_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isBulkRun?: InputMaybe<Scalars['Boolean']['input']>;
  nonAttemptedAgreementCount?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_GT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nonAttemptedAgreementCount_LT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationTriggered?: InputMaybe<OrganizationWhere>;
  organizationTriggeredAggregate?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredAggregateInput>;
  organizationTriggeredConnection?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere>;
  organizationTriggeredConnection_NOT?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere>;
  organizationTriggered_NOT?: InputMaybe<OrganizationWhere>;
  runEnd?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  runEnd_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  runInitiator?: InputMaybe<UserWhere>;
  runInitiatorAggregate?: InputMaybe<AgreementRunAttemptInfoRunInitiatorAggregateInput>;
  runInitiatorConnection?: InputMaybe<AgreementRunAttemptInfoRunInitiatorConnectionWhere>;
  runInitiatorConnection_NOT?: InputMaybe<AgreementRunAttemptInfoRunInitiatorConnectionWhere>;
  runInitiator_NOT?: InputMaybe<UserWhere>;
  runStart?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  runStart_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  succeededCount?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_GT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  succeededCount_LT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  triggeredEvent?: InputMaybe<AgreementRunTrigger>;
  triggeredEvent_IN?: InputMaybe<Array<InputMaybe<AgreementRunTrigger>>>;
};

export type AgreementRunAttemptInfosConnection = {
  __typename?: 'AgreementRunAttemptInfosConnection';
  edges: Array<AgreementRunAttemptInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AgreementRunFrequency {
  BiWeekly = 'BI_WEEKLY',
  Monthly = 'MONTHLY',
  Never = 'NEVER',
  Nightly = 'NIGHTLY',
  Weekly = 'WEEKLY'
}

export enum AgreementRunTrigger {
  AutomatedRun = 'AUTOMATED_RUN',
  DataAdditionManual = 'DATA_ADDITION_MANUAL',
  DataAdditionUpload = 'DATA_ADDITION_UPLOAD',
  DataEditionDeletionManual = 'DATA_EDITION_DELETION_MANUAL',
  DataEditionDeletionUpload = 'DATA_EDITION_DELETION_UPLOAD'
}

export type AgreementScenarioScenariosAggregationSelection = {
  __typename?: 'AgreementScenarioScenariosAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementScenarioScenariosNodeAggregateSelection>;
};

export type AgreementScenarioScenariosNodeAggregateSelection = {
  __typename?: 'AgreementScenarioScenariosNodeAggregateSelection';
  group: IntAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
};

export type AgreementScenariosAggregateInput = {
  AND?: InputMaybe<Array<AgreementScenariosAggregateInput>>;
  NOT?: InputMaybe<AgreementScenariosAggregateInput>;
  OR?: InputMaybe<Array<AgreementScenariosAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementScenariosNodeAggregationWhereInput>;
};

export type AgreementScenariosConnection = {
  __typename?: 'AgreementScenariosConnection';
  edges: Array<AgreementScenariosRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScenariosConnectionSort = {
  node?: InputMaybe<ScenarioSort>;
};

export type AgreementScenariosConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScenariosConnectionWhere>>;
  NOT?: InputMaybe<AgreementScenariosConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScenariosConnectionWhere>>;
  node?: InputMaybe<ScenarioWhere>;
};

export type AgreementScenariosNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScenariosNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScenariosNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScenariosNodeAggregationWhereInput>>;
  group_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  group_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScenariosRelationship = {
  __typename?: 'AgreementScenariosRelationship';
  cursor: Scalars['String']['output'];
  node: Scenario;
};

export type AgreementScenariosRelevantBrandsAggregateInput = {
  AND?: InputMaybe<Array<AgreementScenariosRelevantBrandsAggregateInput>>;
  NOT?: InputMaybe<AgreementScenariosRelevantBrandsAggregateInput>;
  OR?: InputMaybe<Array<AgreementScenariosRelevantBrandsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementScenariosRelevantBrandsNodeAggregationWhereInput>;
};

export type AgreementScenariosRelevantBrandsConnection = {
  __typename?: 'AgreementScenariosRelevantBrandsConnection';
  edges: Array<AgreementScenariosRelevantBrandsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScenariosRelevantBrandsConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type AgreementScenariosRelevantBrandsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScenariosRelevantBrandsConnectionWhere>>;
  NOT?: InputMaybe<AgreementScenariosRelevantBrandsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScenariosRelevantBrandsConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type AgreementScenariosRelevantBrandsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScenariosRelevantBrandsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScenariosRelevantBrandsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementScenariosRelevantBrandsNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AgreementScenariosRelevantBrandsRelationship = {
  __typename?: 'AgreementScenariosRelevantBrandsRelationship';
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type AgreementScope = {
  __typename?: 'AgreementScope';
  agreementsCount: Scalars['Int']['output'];
  article71Indications: Array<Article71Indication>;
  article71IndicationsAggregate?: Maybe<AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection>;
  article71IndicationsConnection: AgreementScopeArticle71IndicationsConnection;
  code: Scalars['String']['output'];
  countryScopes: Array<Country>;
  countryScopesAggregate?: Maybe<AgreementScopeCountryCountryScopesAggregationSelection>;
  countryScopesConnection: AgreementScopeCountryScopesConnection;
  countryScopesTemplates: Array<AgreementScopeCountryScope>;
  cycles: Array<CycleConfiguration>;
  cyclesAggregate?: Maybe<AgreementScopeCycleConfigurationCyclesAggregationSelection>;
  cyclesConnection: AgreementScopeCyclesConnection;
  diseases: Array<Disease>;
  diseasesAggregate?: Maybe<AgreementScopeDiseaseDiseasesAggregationSelection>;
  diseasesConnection: AgreementScopeDiseasesConnection;
  enrollingConditionSets: Array<EnrollingConditionSet>;
  enrollingConditionSetsAggregate?: Maybe<AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection>;
  enrollingConditionSetsConnection: AgreementScopeEnrollingConditionSetsConnection;
  indications: Array<Indication>;
  indicationsAggregate?: Maybe<AgreementScopeIndicationIndicationsAggregationSelection>;
  indicationsConnection: AgreementScopeIndicationsConnection;
  isDeleted: Scalars['Boolean']['output'];
  logicalOperator: ConditionLogicalOperator;
  order: Scalars['Int']['output'];
  orgScopes?: Maybe<Array<OrganizationScope>>;
  organizationScopes: Array<Organization>;
  organizationScopesAggregate?: Maybe<AgreementScopeOrganizationOrganizationScopesAggregationSelection>;
  organizationScopesAgreements: Array<AgreementScopeOrganizationScope>;
  organizationScopesConnection: AgreementScopeOrganizationScopesConnection;
  organizationsCount: Scalars['Int']['output'];
  scopeId: Scalars['String']['output'];
  tenantIds?: Maybe<Array<Scalars['String']['output']>>;
  treatmentSets: Array<TreatmentSet>;
  treatmentSetsAggregate?: Maybe<AgreementScopeTreatmentSetTreatmentSetsAggregationSelection>;
  treatmentSetsConnection: AgreementScopeTreatmentSetsConnection;
};


export type AgreementScopeArticle71IndicationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Article71IndicationOptions>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type AgreementScopeArticle71IndicationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type AgreementScopeArticle71IndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeArticle71IndicationsConnectionSort>>;
  where?: InputMaybe<AgreementScopeArticle71IndicationsConnectionWhere>;
};


export type AgreementScopeCountryScopesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type AgreementScopeCountryScopesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type AgreementScopeCountryScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeCountryScopesConnectionSort>>;
  where?: InputMaybe<AgreementScopeCountryScopesConnectionWhere>;
};


export type AgreementScopeCyclesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CycleConfigurationOptions>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type AgreementScopeCyclesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type AgreementScopeCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeCyclesConnectionSort>>;
  where?: InputMaybe<AgreementScopeCyclesConnectionWhere>;
};


export type AgreementScopeDiseasesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DiseaseOptions>;
  where?: InputMaybe<DiseaseWhere>;
};


export type AgreementScopeDiseasesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DiseaseWhere>;
};


export type AgreementScopeDiseasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeDiseasesConnectionSort>>;
  where?: InputMaybe<AgreementScopeDiseasesConnectionWhere>;
};


export type AgreementScopeEnrollingConditionSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingConditionSetOptions>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type AgreementScopeEnrollingConditionSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type AgreementScopeEnrollingConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsConnectionSort>>;
  where?: InputMaybe<AgreementScopeEnrollingConditionSetsConnectionWhere>;
};


export type AgreementScopeIndicationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<IndicationOptions>;
  where?: InputMaybe<IndicationWhere>;
};


export type AgreementScopeIndicationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IndicationWhere>;
};


export type AgreementScopeIndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeIndicationsConnectionSort>>;
  where?: InputMaybe<AgreementScopeIndicationsConnectionWhere>;
};


export type AgreementScopeOrganizationScopesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementScopeOrganizationScopesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementScopeOrganizationScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeOrganizationScopesConnectionSort>>;
  where?: InputMaybe<AgreementScopeOrganizationScopesConnectionWhere>;
};


export type AgreementScopeTreatmentSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentSetOptions>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type AgreementScopeTreatmentSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type AgreementScopeTreatmentSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeTreatmentSetsConnectionSort>>;
  where?: InputMaybe<AgreementScopeTreatmentSetsConnectionWhere>;
};

export type AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection = {
  __typename?: 'AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection>;
};

export type AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection = {
  __typename?: 'AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection';
  countryScopeId: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  notes: StringAggregateSelectionNullable;
};

export type AgreementScopeArticle71IndicationsAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeArticle71IndicationsAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeArticle71IndicationsAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeArticle71IndicationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementScopeArticle71IndicationsNodeAggregationWhereInput>;
};

export type AgreementScopeArticle71IndicationsConnection = {
  __typename?: 'AgreementScopeArticle71IndicationsConnection';
  edges: Array<AgreementScopeArticle71IndicationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeArticle71IndicationsConnectionSort = {
  node?: InputMaybe<Article71IndicationSort>;
};

export type AgreementScopeArticle71IndicationsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeArticle71IndicationsConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeArticle71IndicationsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeArticle71IndicationsConnectionWhere>>;
  node?: InputMaybe<Article71IndicationWhere>;
};

export type AgreementScopeArticle71IndicationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeArticle71IndicationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeArticle71IndicationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeArticle71IndicationsNodeAggregationWhereInput>>;
  countryScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  notes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeArticle71IndicationsRelationship = {
  __typename?: 'AgreementScopeArticle71IndicationsRelationship';
  cursor: Scalars['String']['output'];
  node: Article71Indication;
};

export type AgreementScopeCountryCountryScopesAggregationSelection = {
  __typename?: 'AgreementScopeCountryCountryScopesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementScopeCountryCountryScopesEdgeAggregateSelection>;
  node?: Maybe<AgreementScopeCountryCountryScopesNodeAggregateSelection>;
};

export type AgreementScopeCountryCountryScopesEdgeAggregateSelection = {
  __typename?: 'AgreementScopeCountryCountryScopesEdgeAggregateSelection';
  countryScopeId: StringAggregateSelectionNonNullable;
};

export type AgreementScopeCountryCountryScopesNodeAggregateSelection = {
  __typename?: 'AgreementScopeCountryCountryScopesNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type AgreementScopeCountryScope = {
  __typename?: 'AgreementScopeCountryScope';
  countryCode: Scalars['String']['output'];
  countryScopeIds: Array<Scalars['String']['output']>;
  templateIds: Array<Scalars['String']['output']>;
  templateNames: Array<Scalars['String']['output']>;
};

export type AgreementScopeCountryScopeEdge = {
  __typename?: 'AgreementScopeCountryScopeEdge';
  cursor: Scalars['String']['output'];
  node: AgreementScopeCountryScope;
};

export type AgreementScopeCountryScopeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementScopeCountryScopeSort objects to sort AgreementScopeCountryScopes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementScopeCountryScopeSort>>;
};

/** Fields to sort AgreementScopeCountryScopes by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementScopeCountryScopeSort object. */
export type AgreementScopeCountryScopeSort = {
  countryCode?: InputMaybe<SortDirection>;
};

export type AgreementScopeCountryScopeWhere = {
  AND?: InputMaybe<Array<AgreementScopeCountryScopeWhere>>;
  NOT?: InputMaybe<AgreementScopeCountryScopeWhere>;
  OR?: InputMaybe<Array<AgreementScopeCountryScopeWhere>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  countryCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  countryCode_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  countryCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  countryCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  countryScopeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  countryScopeIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  templateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  templateIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  templateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  templateNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type AgreementScopeCountryScopesAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeCountryScopesAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeCountryScopesAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeCountryScopesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementScopeCountryScopesEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementScopeCountryScopesNodeAggregationWhereInput>;
};

export type AgreementScopeCountryScopesConnection = {
  __typename?: 'AgreementScopeCountryScopesConnection';
  edges: Array<AgreementScopeCountryScopesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeCountryScopesConnectionSort = {
  edge?: InputMaybe<CountryScopeRelationshipSort>;
  node?: InputMaybe<CountrySort>;
};

export type AgreementScopeCountryScopesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeCountryScopesConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeCountryScopesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeCountryScopesConnectionWhere>>;
  edge?: InputMaybe<CountryScopeRelationshipWhere>;
  node?: InputMaybe<CountryWhere>;
};

export type AgreementScopeCountryScopesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeCountryScopesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeCountryScopesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeCountryScopesEdgeAggregationWhereInput>>;
  countryScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeCountryScopesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeCountryScopesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeCountryScopesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeCountryScopesNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeCountryScopesRelationship = CountryScopeRelationship & {
  __typename?: 'AgreementScopeCountryScopesRelationship';
  countryScopeId: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  node: Country;
};

export type AgreementScopeCycleConfigurationCyclesAggregationSelection = {
  __typename?: 'AgreementScopeCycleConfigurationCyclesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementScopeCycleConfigurationCyclesNodeAggregateSelection>;
};

export type AgreementScopeCycleConfigurationCyclesNodeAggregateSelection = {
  __typename?: 'AgreementScopeCycleConfigurationCyclesNodeAggregateSelection';
  lengthFrom: IntAggregateSelectionNonNullable;
  lengthTo: IntAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
};

export type AgreementScopeCyclesAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeCyclesAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeCyclesAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeCyclesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementScopeCyclesNodeAggregationWhereInput>;
};

export type AgreementScopeCyclesConnection = {
  __typename?: 'AgreementScopeCyclesConnection';
  edges: Array<AgreementScopeCyclesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeCyclesConnectionSort = {
  node?: InputMaybe<CycleConfigurationSort>;
};

export type AgreementScopeCyclesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeCyclesConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeCyclesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeCyclesConnectionWhere>>;
  node?: InputMaybe<CycleConfigurationWhere>;
};

export type AgreementScopeCyclesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeCyclesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeCyclesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeCyclesNodeAggregationWhereInput>>;
  lengthFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeCyclesRelationship = {
  __typename?: 'AgreementScopeCyclesRelationship';
  cursor: Scalars['String']['output'];
  node: CycleConfiguration;
};

export type AgreementScopeDiseaseDiseasesAggregationSelection = {
  __typename?: 'AgreementScopeDiseaseDiseasesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementScopeDiseaseDiseasesEdgeAggregateSelection>;
  node?: Maybe<AgreementScopeDiseaseDiseasesNodeAggregateSelection>;
};

export type AgreementScopeDiseaseDiseasesEdgeAggregateSelection = {
  __typename?: 'AgreementScopeDiseaseDiseasesEdgeAggregateSelection';
  Score: FloatAggregateSelectionNullable;
};

export type AgreementScopeDiseaseDiseasesNodeAggregateSelection = {
  __typename?: 'AgreementScopeDiseaseDiseasesNodeAggregateSelection';
  Icd10Code: StringAggregateSelectionNonNullable;
  Name: StringAggregateSelectionNonNullable;
};

export type AgreementScopeDiseasesAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeDiseasesAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeDiseasesAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeDiseasesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementScopeDiseasesEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementScopeDiseasesNodeAggregationWhereInput>;
};

export type AgreementScopeDiseasesConnection = {
  __typename?: 'AgreementScopeDiseasesConnection';
  edges: Array<AgreementScopeDiseasesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeDiseasesConnectionSort = {
  edge?: InputMaybe<EnrollingConditionDiseaseRelationshipSort>;
  node?: InputMaybe<DiseaseSort>;
};

export type AgreementScopeDiseasesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeDiseasesConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeDiseasesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeDiseasesConnectionWhere>>;
  edge?: InputMaybe<EnrollingConditionDiseaseRelationshipWhere>;
  node?: InputMaybe<DiseaseWhere>;
};

export type AgreementScopeDiseasesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeDiseasesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeDiseasesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeDiseasesEdgeAggregationWhereInput>>;
  Score_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Score_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  Score_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Score_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  Score_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Score_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  Score_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Score_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AgreementScopeDiseasesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeDiseasesNodeAggregationWhereInput>>;
  Icd10Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementScopeDiseasesNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementScopeDiseasesNodeAggregationWhereInput>>;
};

export type AgreementScopeDiseasesRelationship = EnrollingConditionDiseaseRelationship & {
  __typename?: 'AgreementScopeDiseasesRelationship';
  Score?: Maybe<Scalars['Float']['output']>;
  cursor: Scalars['String']['output'];
  node: Disease;
};

export type AgreementScopeEdge = {
  __typename?: 'AgreementScopeEdge';
  cursor: Scalars['String']['output'];
  node: AgreementScope;
};

export type AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection = {
  __typename?: 'AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection>;
};

export type AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection = {
  __typename?: 'AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
};

export type AgreementScopeEnrollingConditionSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeEnrollingConditionSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput>;
};

export type AgreementScopeEnrollingConditionSetsConnection = {
  __typename?: 'AgreementScopeEnrollingConditionSetsConnection';
  edges: Array<AgreementScopeEnrollingConditionSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeEnrollingConditionSetsConnectionSort = {
  node?: InputMaybe<EnrollingConditionSetSort>;
};

export type AgreementScopeEnrollingConditionSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeEnrollingConditionSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsConnectionWhere>>;
  node?: InputMaybe<EnrollingConditionSetWhere>;
};

export type AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeEnrollingConditionSetsRelationship = {
  __typename?: 'AgreementScopeEnrollingConditionSetsRelationship';
  cursor: Scalars['String']['output'];
  node: EnrollingConditionSet;
};

export type AgreementScopeIndicationIndicationsAggregationSelection = {
  __typename?: 'AgreementScopeIndicationIndicationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementScopeIndicationIndicationsNodeAggregateSelection>;
};

export type AgreementScopeIndicationIndicationsNodeAggregateSelection = {
  __typename?: 'AgreementScopeIndicationIndicationsNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  intent: StringAggregateSelectionNullable;
  intentLocalizationKey: StringAggregateSelectionNullable;
  line: StringAggregateSelectionNullable;
  lineLocalizationKey: StringAggregateSelectionNullable;
  mutation: StringAggregateSelectionNullable;
  mutationLocalizationKey: StringAggregateSelectionNullable;
  type: StringAggregateSelectionNullable;
  typeLocalizationKey: StringAggregateSelectionNullable;
};

export type AgreementScopeIndicationsAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeIndicationsAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeIndicationsAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeIndicationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementScopeIndicationsNodeAggregationWhereInput>;
};

export type AgreementScopeIndicationsConnection = {
  __typename?: 'AgreementScopeIndicationsConnection';
  edges: Array<AgreementScopeIndicationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeIndicationsConnectionSort = {
  node?: InputMaybe<IndicationSort>;
};

export type AgreementScopeIndicationsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeIndicationsConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeIndicationsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeIndicationsConnectionWhere>>;
  node?: InputMaybe<IndicationWhere>;
};

export type AgreementScopeIndicationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeIndicationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeIndicationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeIndicationsNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  intent_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  intent_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  intent_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  intent_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  intent_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  intent_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  intent_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  intent_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  intent_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  intent_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  line_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  line_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  line_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  line_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  line_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  line_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  line_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  line_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  line_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  line_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeIndicationsRelationship = {
  __typename?: 'AgreementScopeIndicationsRelationship';
  cursor: Scalars['String']['output'];
  node: Indication;
};

export type AgreementScopeInput = {
  code: Scalars['String']['input'];
  countryScopes?: InputMaybe<Array<CountryInput>>;
  diseases?: InputMaybe<Array<DiseaseInput>>;
  excludedOn?: InputMaybe<Scalars['Date']['input']>;
  indications?: InputMaybe<Array<IndicationInput>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  logicalOperator?: InputMaybe<ConditionLogicalOperator>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organizationScopes?: InputMaybe<Array<OrganizationInput>>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  treatmentSets: Array<TreatmentSetInput>;
};

export type AgreementScopeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementScopeSort objects to sort AgreementScopes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementScopeSort>>;
};

export type AgreementScopeOrganizationOrganizationScopesAggregationSelection = {
  __typename?: 'AgreementScopeOrganizationOrganizationScopesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection>;
  node?: Maybe<AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection>;
};

export type AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection = {
  __typename?: 'AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection';
  organizationScopeId: StringAggregateSelectionNullable;
};

export type AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection = {
  __typename?: 'AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type AgreementScopeOrganizationScope = {
  __typename?: 'AgreementScopeOrganizationScope';
  agreementId?: Maybe<Scalars['String']['output']>;
  agreementName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  organizationScopeId: Scalars['String']['output'];
};

export type AgreementScopeOrganizationScopeEdge = {
  __typename?: 'AgreementScopeOrganizationScopeEdge';
  cursor: Scalars['String']['output'];
  node: AgreementScopeOrganizationScope;
};

export type AgreementScopeOrganizationScopeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementScopeOrganizationScopeSort objects to sort AgreementScopeOrganizationScopes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementScopeOrganizationScopeSort>>;
};

/** Fields to sort AgreementScopeOrganizationScopes by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementScopeOrganizationScopeSort object. */
export type AgreementScopeOrganizationScopeSort = {
  agreementId?: InputMaybe<SortDirection>;
  agreementName?: InputMaybe<SortDirection>;
  organizationId?: InputMaybe<SortDirection>;
  organizationName?: InputMaybe<SortDirection>;
  organizationScopeId?: InputMaybe<SortDirection>;
};

export type AgreementScopeOrganizationScopeWhere = {
  AND?: InputMaybe<Array<AgreementScopeOrganizationScopeWhere>>;
  NOT?: InputMaybe<AgreementScopeOrganizationScopeWhere>;
  OR?: InputMaybe<Array<AgreementScopeOrganizationScopeWhere>>;
  agreementId?: InputMaybe<Scalars['String']['input']>;
  agreementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName?: InputMaybe<Scalars['String']['input']>;
  agreementName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationScopeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type AgreementScopeOrganizationScopesAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeOrganizationScopesAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeOrganizationScopesAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeOrganizationScopesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementScopeOrganizationScopesEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementScopeOrganizationScopesNodeAggregationWhereInput>;
};

export type AgreementScopeOrganizationScopesConnection = {
  __typename?: 'AgreementScopeOrganizationScopesConnection';
  edges: Array<AgreementScopeOrganizationScopesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeOrganizationScopesConnectionSort = {
  edge?: InputMaybe<OrganizationScopeRelationshipSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type AgreementScopeOrganizationScopesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeOrganizationScopesConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeOrganizationScopesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeOrganizationScopesConnectionWhere>>;
  edge?: InputMaybe<OrganizationScopeRelationshipWhere>;
  node?: InputMaybe<OrganizationWhere>;
};

export type AgreementScopeOrganizationScopesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeOrganizationScopesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeOrganizationScopesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeOrganizationScopesEdgeAggregationWhereInput>>;
  organizationScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeOrganizationScopesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeOrganizationScopesNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementScopeOrganizationScopesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeOrganizationScopesNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeOrganizationScopesRelationship = OrganizationScopeRelationship & {
  __typename?: 'AgreementScopeOrganizationScopesRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
  organizationScopeId?: Maybe<Scalars['String']['output']>;
};

export type AgreementScopeRelationship = {
  excludedOn?: Maybe<Scalars['Date']['output']>;
  isExtended?: Maybe<Scalars['Boolean']['output']>;
};

export type AgreementScopeRelationshipSort = {
  excludedOn?: InputMaybe<SortDirection>;
  isExtended?: InputMaybe<SortDirection>;
};

export type AgreementScopeRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementScopeRelationshipWhere>>;
  NOT?: InputMaybe<AgreementScopeRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementScopeRelationshipWhere>>;
  excludedOn?: InputMaybe<Scalars['Date']['input']>;
  excludedOn_GT?: InputMaybe<Scalars['Date']['input']>;
  excludedOn_GTE?: InputMaybe<Scalars['Date']['input']>;
  excludedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  excludedOn_LT?: InputMaybe<Scalars['Date']['input']>;
  excludedOn_LTE?: InputMaybe<Scalars['Date']['input']>;
  isExtended?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Fields to sort AgreementScopes by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementScopeSort object. */
export type AgreementScopeSort = {
  agreementsCount?: InputMaybe<SortDirection>;
  code?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  logicalOperator?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  organizationsCount?: InputMaybe<SortDirection>;
  scopeId?: InputMaybe<SortDirection>;
};

export type AgreementScopeTreatmentSetTreatmentSetsAggregationSelection = {
  __typename?: 'AgreementScopeTreatmentSetTreatmentSetsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection>;
};

export type AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection = {
  __typename?: 'AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
};

export type AgreementScopeTreatmentSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeTreatmentSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeTreatmentSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeTreatmentSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementScopeTreatmentSetsNodeAggregationWhereInput>;
};

export type AgreementScopeTreatmentSetsConnection = {
  __typename?: 'AgreementScopeTreatmentSetsConnection';
  edges: Array<AgreementScopeTreatmentSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeTreatmentSetsConnectionSort = {
  node?: InputMaybe<TreatmentSetSort>;
};

export type AgreementScopeTreatmentSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeTreatmentSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeTreatmentSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeTreatmentSetsConnectionWhere>>;
  node?: InputMaybe<TreatmentSetWhere>;
};

export type AgreementScopeTreatmentSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeTreatmentSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeTreatmentSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeTreatmentSetsNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeTreatmentSetsRelationship = {
  __typename?: 'AgreementScopeTreatmentSetsRelationship';
  cursor: Scalars['String']['output'];
  node: TreatmentSet;
};

export type AgreementScopeWhere = {
  AND?: InputMaybe<Array<AgreementScopeWhere>>;
  NOT?: InputMaybe<AgreementScopeWhere>;
  OR?: InputMaybe<Array<AgreementScopeWhere>>;
  article71IndicationsAggregate?: InputMaybe<AgreementScopeArticle71IndicationsAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_ALL?: InputMaybe<AgreementScopeArticle71IndicationsConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_NONE?: InputMaybe<AgreementScopeArticle71IndicationsConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_SINGLE?: InputMaybe<AgreementScopeArticle71IndicationsConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_SOME?: InputMaybe<AgreementScopeArticle71IndicationsConnectionWhere>;
  /** Return AgreementScopes where all of the related Article71Indications match this filter */
  article71Indications_ALL?: InputMaybe<Article71IndicationWhere>;
  /** Return AgreementScopes where none of the related Article71Indications match this filter */
  article71Indications_NONE?: InputMaybe<Article71IndicationWhere>;
  /** Return AgreementScopes where one of the related Article71Indications match this filter */
  article71Indications_SINGLE?: InputMaybe<Article71IndicationWhere>;
  /** Return AgreementScopes where some of the related Article71Indications match this filter */
  article71Indications_SOME?: InputMaybe<Article71IndicationWhere>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  countryScopesAggregate?: InputMaybe<AgreementScopeCountryScopesAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeCountryScopesConnections match this filter */
  countryScopesConnection_ALL?: InputMaybe<AgreementScopeCountryScopesConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeCountryScopesConnections match this filter */
  countryScopesConnection_NONE?: InputMaybe<AgreementScopeCountryScopesConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeCountryScopesConnections match this filter */
  countryScopesConnection_SINGLE?: InputMaybe<AgreementScopeCountryScopesConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeCountryScopesConnections match this filter */
  countryScopesConnection_SOME?: InputMaybe<AgreementScopeCountryScopesConnectionWhere>;
  /** Return AgreementScopes where all of the related Countries match this filter */
  countryScopes_ALL?: InputMaybe<CountryWhere>;
  /** Return AgreementScopes where none of the related Countries match this filter */
  countryScopes_NONE?: InputMaybe<CountryWhere>;
  /** Return AgreementScopes where one of the related Countries match this filter */
  countryScopes_SINGLE?: InputMaybe<CountryWhere>;
  /** Return AgreementScopes where some of the related Countries match this filter */
  countryScopes_SOME?: InputMaybe<CountryWhere>;
  cyclesAggregate?: InputMaybe<AgreementScopeCyclesAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeCyclesConnections match this filter */
  cyclesConnection_ALL?: InputMaybe<AgreementScopeCyclesConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeCyclesConnections match this filter */
  cyclesConnection_NONE?: InputMaybe<AgreementScopeCyclesConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeCyclesConnections match this filter */
  cyclesConnection_SINGLE?: InputMaybe<AgreementScopeCyclesConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeCyclesConnections match this filter */
  cyclesConnection_SOME?: InputMaybe<AgreementScopeCyclesConnectionWhere>;
  /** Return AgreementScopes where all of the related CycleConfigurations match this filter */
  cycles_ALL?: InputMaybe<CycleConfigurationWhere>;
  /** Return AgreementScopes where none of the related CycleConfigurations match this filter */
  cycles_NONE?: InputMaybe<CycleConfigurationWhere>;
  /** Return AgreementScopes where one of the related CycleConfigurations match this filter */
  cycles_SINGLE?: InputMaybe<CycleConfigurationWhere>;
  /** Return AgreementScopes where some of the related CycleConfigurations match this filter */
  cycles_SOME?: InputMaybe<CycleConfigurationWhere>;
  diseasesAggregate?: InputMaybe<AgreementScopeDiseasesAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeDiseasesConnections match this filter */
  diseasesConnection_ALL?: InputMaybe<AgreementScopeDiseasesConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeDiseasesConnections match this filter */
  diseasesConnection_NONE?: InputMaybe<AgreementScopeDiseasesConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeDiseasesConnections match this filter */
  diseasesConnection_SINGLE?: InputMaybe<AgreementScopeDiseasesConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeDiseasesConnections match this filter */
  diseasesConnection_SOME?: InputMaybe<AgreementScopeDiseasesConnectionWhere>;
  /** Return AgreementScopes where all of the related Diseases match this filter */
  diseases_ALL?: InputMaybe<DiseaseWhere>;
  /** Return AgreementScopes where none of the related Diseases match this filter */
  diseases_NONE?: InputMaybe<DiseaseWhere>;
  /** Return AgreementScopes where one of the related Diseases match this filter */
  diseases_SINGLE?: InputMaybe<DiseaseWhere>;
  /** Return AgreementScopes where some of the related Diseases match this filter */
  diseases_SOME?: InputMaybe<DiseaseWhere>;
  enrollingConditionSetsAggregate?: InputMaybe<AgreementScopeEnrollingConditionSetsAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_ALL?: InputMaybe<AgreementScopeEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_NONE?: InputMaybe<AgreementScopeEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SINGLE?: InputMaybe<AgreementScopeEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SOME?: InputMaybe<AgreementScopeEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementScopes where all of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_ALL?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return AgreementScopes where none of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_NONE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return AgreementScopes where one of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SINGLE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return AgreementScopes where some of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SOME?: InputMaybe<EnrollingConditionSetWhere>;
  indicationsAggregate?: InputMaybe<AgreementScopeIndicationsAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeIndicationsConnections match this filter */
  indicationsConnection_ALL?: InputMaybe<AgreementScopeIndicationsConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeIndicationsConnections match this filter */
  indicationsConnection_NONE?: InputMaybe<AgreementScopeIndicationsConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeIndicationsConnections match this filter */
  indicationsConnection_SINGLE?: InputMaybe<AgreementScopeIndicationsConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeIndicationsConnections match this filter */
  indicationsConnection_SOME?: InputMaybe<AgreementScopeIndicationsConnectionWhere>;
  /** Return AgreementScopes where all of the related Indications match this filter */
  indications_ALL?: InputMaybe<IndicationWhere>;
  /** Return AgreementScopes where none of the related Indications match this filter */
  indications_NONE?: InputMaybe<IndicationWhere>;
  /** Return AgreementScopes where one of the related Indications match this filter */
  indications_SINGLE?: InputMaybe<IndicationWhere>;
  /** Return AgreementScopes where some of the related Indications match this filter */
  indications_SOME?: InputMaybe<IndicationWhere>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  logicalOperator?: InputMaybe<ConditionLogicalOperator>;
  logicalOperator_IN?: InputMaybe<Array<ConditionLogicalOperator>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationScopesAggregate?: InputMaybe<AgreementScopeOrganizationScopesAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeOrganizationScopesConnections match this filter */
  organizationScopesConnection_ALL?: InputMaybe<AgreementScopeOrganizationScopesConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeOrganizationScopesConnections match this filter */
  organizationScopesConnection_NONE?: InputMaybe<AgreementScopeOrganizationScopesConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeOrganizationScopesConnections match this filter */
  organizationScopesConnection_SINGLE?: InputMaybe<AgreementScopeOrganizationScopesConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeOrganizationScopesConnections match this filter */
  organizationScopesConnection_SOME?: InputMaybe<AgreementScopeOrganizationScopesConnectionWhere>;
  /** Return AgreementScopes where all of the related Organizations match this filter */
  organizationScopes_ALL?: InputMaybe<OrganizationWhere>;
  /** Return AgreementScopes where none of the related Organizations match this filter */
  organizationScopes_NONE?: InputMaybe<OrganizationWhere>;
  /** Return AgreementScopes where one of the related Organizations match this filter */
  organizationScopes_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return AgreementScopes where some of the related Organizations match this filter */
  organizationScopes_SOME?: InputMaybe<OrganizationWhere>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scopeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scopeId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  scopeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  scopeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  treatmentSetsAggregate?: InputMaybe<AgreementScopeTreatmentSetsAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeTreatmentSetsConnections match this filter */
  treatmentSetsConnection_ALL?: InputMaybe<AgreementScopeTreatmentSetsConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeTreatmentSetsConnections match this filter */
  treatmentSetsConnection_NONE?: InputMaybe<AgreementScopeTreatmentSetsConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeTreatmentSetsConnections match this filter */
  treatmentSetsConnection_SINGLE?: InputMaybe<AgreementScopeTreatmentSetsConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeTreatmentSetsConnections match this filter */
  treatmentSetsConnection_SOME?: InputMaybe<AgreementScopeTreatmentSetsConnectionWhere>;
  /** Return AgreementScopes where all of the related TreatmentSets match this filter */
  treatmentSets_ALL?: InputMaybe<TreatmentSetWhere>;
  /** Return AgreementScopes where none of the related TreatmentSets match this filter */
  treatmentSets_NONE?: InputMaybe<TreatmentSetWhere>;
  /** Return AgreementScopes where one of the related TreatmentSets match this filter */
  treatmentSets_SINGLE?: InputMaybe<TreatmentSetWhere>;
  /** Return AgreementScopes where some of the related TreatmentSets match this filter */
  treatmentSets_SOME?: InputMaybe<TreatmentSetWhere>;
};

export type AgreementScopesConnection = {
  __typename?: 'AgreementScopesConnection';
  edges: Array<AgreementScopeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Fields to sort Agreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementSort object. */
export type AgreementSort = {
  areCasesCreated?: InputMaybe<SortDirection>;
  caseSuspensionIntervalDays?: InputMaybe<SortDirection>;
  coveringFormWaitInterval?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  daysToExpiry?: InputMaybe<SortDirection>;
  defaultPriceRate?: InputMaybe<SortDirection>;
  enrolmentDateType?: InputMaybe<SortDirection>;
  expectedDocument?: InputMaybe<SortDirection>;
  firstExecutionDate?: InputMaybe<SortDirection>;
  formattedAmount?: InputMaybe<SortDirection>;
  formattedCounterparties?: InputMaybe<SortDirection>;
  formattedDiseases?: InputMaybe<SortDirection>;
  formattedIndications?: InputMaybe<SortDirection>;
  formattedProducts?: InputMaybe<SortDirection>;
  formattedTags?: InputMaybe<SortDirection>;
  formattedValidityPeriod?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  initialVersionId?: InputMaybe<SortDirection>;
  isAllowedFormsEnabled?: InputMaybe<SortDirection>;
  isAllowedRecordsEnabled?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isAutoCreated?: InputMaybe<SortDirection>;
  isCaseless?: InputMaybe<SortDirection>;
  isCoveringIntervalEnabled?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isExtended?: InputMaybe<SortDirection>;
  isFirstVersion?: InputMaybe<SortDirection>;
  isHidden?: InputMaybe<SortDirection>;
  isInsightsAvailable?: InputMaybe<SortDirection>;
  isLastVersion?: InputMaybe<SortDirection>;
  isNewVersionManuallyCreated?: InputMaybe<SortDirection>;
  isRequiredFormsEnabled?: InputMaybe<SortDirection>;
  isRequiredRecordsEnabled?: InputMaybe<SortDirection>;
  isScenariosInSync?: InputMaybe<SortDirection>;
  isScopeSync?: InputMaybe<SortDirection>;
  isValidityPeriodInSync?: InputMaybe<SortDirection>;
  lastExecutionDate?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  lastVersionValidToDate?: InputMaybe<SortDirection>;
  minValidFromDate?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  pushedOn?: InputMaybe<SortDirection>;
  reportData?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  subjectMatter?: InputMaybe<SortDirection>;
  totalAmount?: InputMaybe<SortDirection>;
  validFromDate?: InputMaybe<SortDirection>;
  validToDate?: InputMaybe<SortDirection>;
  version?: InputMaybe<SortDirection>;
};

export type AgreementSpecificRole = {
  __typename?: 'AgreementSpecificRole';
  agreementId: Scalars['ID']['output'];
  agreementName: Scalars['String']['output'];
  agreementTags: Array<Scalars['String']['output']>;
  agreementUserRole?: Maybe<AgreementUserRole>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AgreementSpecificRoleEdge = {
  __typename?: 'AgreementSpecificRoleEdge';
  cursor: Scalars['String']['output'];
  node: AgreementSpecificRole;
};

export type AgreementSpecificRoleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementSpecificRoleSort objects to sort AgreementSpecificRoles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementSpecificRoleSort>>;
};

/** Fields to sort AgreementSpecificRoles by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementSpecificRoleSort object. */
export type AgreementSpecificRoleSort = {
  agreementId?: InputMaybe<SortDirection>;
  agreementName?: InputMaybe<SortDirection>;
  agreementUserRole?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  userId?: InputMaybe<SortDirection>;
};

export type AgreementSpecificRoleWhere = {
  AND?: InputMaybe<Array<AgreementSpecificRoleWhere>>;
  NOT?: InputMaybe<AgreementSpecificRoleWhere>;
  OR?: InputMaybe<Array<AgreementSpecificRoleWhere>>;
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  agreementId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  agreementId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  agreementId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  agreementId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  agreementName?: InputMaybe<Scalars['String']['input']>;
  agreementName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementTags?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementTags_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  agreementUserRole?: InputMaybe<AgreementUserRole>;
  agreementUserRole_IN?: InputMaybe<Array<InputMaybe<AgreementUserRole>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  userId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type AgreementSpecificRolesConnection = {
  __typename?: 'AgreementSpecificRolesConnection';
  edges: Array<AgreementSpecificRoleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementStatusTransition = {
  __typename?: 'AgreementStatusTransition';
  causedBy?: Maybe<User>;
  causedByAggregate?: Maybe<AgreementStatusTransitionUserCausedByAggregationSelection>;
  causedByConnection: AgreementStatusTransitionCausedByConnection;
  createdOn: Scalars['DateTime']['output'];
  from?: Maybe<ContractStatus>;
  to: ContractStatus;
};


export type AgreementStatusTransitionCausedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementStatusTransitionCausedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementStatusTransitionCausedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementStatusTransitionCausedByConnectionSort>>;
  where?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
};

export type AgreementStatusTransitionCausedByAggregateInput = {
  AND?: InputMaybe<Array<AgreementStatusTransitionCausedByAggregateInput>>;
  NOT?: InputMaybe<AgreementStatusTransitionCausedByAggregateInput>;
  OR?: InputMaybe<Array<AgreementStatusTransitionCausedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementStatusTransitionCausedByNodeAggregationWhereInput>;
};

export type AgreementStatusTransitionCausedByConnection = {
  __typename?: 'AgreementStatusTransitionCausedByConnection';
  edges: Array<AgreementStatusTransitionCausedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementStatusTransitionCausedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AgreementStatusTransitionCausedByConnectionWhere = {
  AND?: InputMaybe<Array<AgreementStatusTransitionCausedByConnectionWhere>>;
  NOT?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
  OR?: InputMaybe<Array<AgreementStatusTransitionCausedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementStatusTransitionCausedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementStatusTransitionCausedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementStatusTransitionCausedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementStatusTransitionCausedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementStatusTransitionCausedByRelationship = {
  __typename?: 'AgreementStatusTransitionCausedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AgreementStatusTransitionEdge = {
  __typename?: 'AgreementStatusTransitionEdge';
  cursor: Scalars['String']['output'];
  node: AgreementStatusTransition;
};

export type AgreementStatusTransitionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementStatusTransitionSort objects to sort AgreementStatusTransitions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementStatusTransitionSort>>;
};

/** Fields to sort AgreementStatusTransitions by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementStatusTransitionSort object. */
export type AgreementStatusTransitionSort = {
  createdOn?: InputMaybe<SortDirection>;
  from?: InputMaybe<SortDirection>;
  to?: InputMaybe<SortDirection>;
};

export type AgreementStatusTransitionUserCausedByAggregationSelection = {
  __typename?: 'AgreementStatusTransitionUserCausedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementStatusTransitionUserCausedByNodeAggregateSelection>;
};

export type AgreementStatusTransitionUserCausedByNodeAggregateSelection = {
  __typename?: 'AgreementStatusTransitionUserCausedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type AgreementStatusTransitionWhere = {
  AND?: InputMaybe<Array<AgreementStatusTransitionWhere>>;
  NOT?: InputMaybe<AgreementStatusTransitionWhere>;
  OR?: InputMaybe<Array<AgreementStatusTransitionWhere>>;
  causedBy?: InputMaybe<UserWhere>;
  causedByAggregate?: InputMaybe<AgreementStatusTransitionCausedByAggregateInput>;
  causedByConnection?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
  causedByConnection_NOT?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
  causedBy_NOT?: InputMaybe<UserWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<ContractStatus>;
  from_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
  to?: InputMaybe<ContractStatus>;
  to_IN?: InputMaybe<Array<ContractStatus>>;
};

export type AgreementStatusTransitionsConnection = {
  __typename?: 'AgreementStatusTransitionsConnection';
  edges: Array<AgreementStatusTransitionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AgreementSubjectMatter {
  Devices = 'DEVICES',
  Drugs = 'DRUGS'
}

export type AgreementTag = {
  __typename?: 'AgreementTag';
  defaultUserRoles: Array<User>;
  defaultUserRolesAggregate?: Maybe<AgreementTagUserDefaultUserRolesAggregationSelection>;
  defaultUserRolesConnection: AgreementTagDefaultUserRolesConnection;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: AgreementTagType;
};


export type AgreementTagDefaultUserRolesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementTagDefaultUserRolesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementTagDefaultUserRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTagDefaultUserRolesConnectionSort>>;
  where?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
};

export type AgreementTagDefaultUserRolesAggregateInput = {
  AND?: InputMaybe<Array<AgreementTagDefaultUserRolesAggregateInput>>;
  NOT?: InputMaybe<AgreementTagDefaultUserRolesAggregateInput>;
  OR?: InputMaybe<Array<AgreementTagDefaultUserRolesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTagDefaultUserRolesNodeAggregationWhereInput>;
};

export type AgreementTagDefaultUserRolesConnection = {
  __typename?: 'AgreementTagDefaultUserRolesConnection';
  edges: Array<AgreementTagDefaultUserRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTagDefaultUserRolesConnectionSort = {
  edge?: InputMaybe<AgreementTagUserRoleRelationshipSort>;
  node?: InputMaybe<UserSort>;
};

export type AgreementTagDefaultUserRolesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTagDefaultUserRolesConnectionWhere>>;
  NOT?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTagDefaultUserRolesConnectionWhere>>;
  edge?: InputMaybe<AgreementTagUserRoleRelationshipWhere>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementTagDefaultUserRolesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTagDefaultUserRolesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTagDefaultUserRolesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTagDefaultUserRolesNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTagDefaultUserRolesRelationship = AgreementTagUserRoleRelationship & {
  __typename?: 'AgreementTagDefaultUserRolesRelationship';
  caseAssignee?: Maybe<AssigneeStatus>;
  cursor: Scalars['String']['output'];
  documentAssignee?: Maybe<AssigneeStatus>;
  isAgreementAssignee?: Maybe<Scalars['Boolean']['output']>;
  node: User;
  role: AgreementUserRole;
};

export type AgreementTagEdge = {
  __typename?: 'AgreementTagEdge';
  cursor: Scalars['String']['output'];
  node: AgreementTag;
};

export type AgreementTagInput = {
  type: AgreementTagType;
};

export type AgreementTagOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementTagSort objects to sort AgreementTags by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementTagSort>>;
};

/** Fields to sort AgreementTags by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementTagSort object. */
export type AgreementTagSort = {
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum AgreementTagType {
  Article_71 = 'ARTICLE_71',
  Custom = 'CUSTOM',
  Sll = 'SLL',
  VolumeBased = 'VOLUME_BASED'
}

export type AgreementTagUserDefaultUserRolesAggregationSelection = {
  __typename?: 'AgreementTagUserDefaultUserRolesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTagUserDefaultUserRolesNodeAggregateSelection>;
};

export type AgreementTagUserDefaultUserRolesNodeAggregateSelection = {
  __typename?: 'AgreementTagUserDefaultUserRolesNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type AgreementTagUserRoleRelationship = {
  caseAssignee?: Maybe<AssigneeStatus>;
  documentAssignee?: Maybe<AssigneeStatus>;
  isAgreementAssignee?: Maybe<Scalars['Boolean']['output']>;
  role: AgreementUserRole;
};

export type AgreementTagUserRoleRelationshipSort = {
  caseAssignee?: InputMaybe<SortDirection>;
  documentAssignee?: InputMaybe<SortDirection>;
  isAgreementAssignee?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type AgreementTagUserRoleRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementTagUserRoleRelationshipWhere>>;
  NOT?: InputMaybe<AgreementTagUserRoleRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementTagUserRoleRelationshipWhere>>;
  caseAssignee?: InputMaybe<AssigneeStatus>;
  caseAssignee_IN?: InputMaybe<Array<InputMaybe<AssigneeStatus>>>;
  documentAssignee?: InputMaybe<AssigneeStatus>;
  documentAssignee_IN?: InputMaybe<Array<InputMaybe<AssigneeStatus>>>;
  isAgreementAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<AgreementUserRole>;
  role_IN?: InputMaybe<Array<AgreementUserRole>>;
};

export type AgreementTagWhere = {
  AND?: InputMaybe<Array<AgreementTagWhere>>;
  NOT?: InputMaybe<AgreementTagWhere>;
  OR?: InputMaybe<Array<AgreementTagWhere>>;
  defaultUserRolesAggregate?: InputMaybe<AgreementTagDefaultUserRolesAggregateInput>;
  /** Return AgreementTags where all of the related AgreementTagDefaultUserRolesConnections match this filter */
  defaultUserRolesConnection_ALL?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
  /** Return AgreementTags where none of the related AgreementTagDefaultUserRolesConnections match this filter */
  defaultUserRolesConnection_NONE?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
  /** Return AgreementTags where one of the related AgreementTagDefaultUserRolesConnections match this filter */
  defaultUserRolesConnection_SINGLE?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
  /** Return AgreementTags where some of the related AgreementTagDefaultUserRolesConnections match this filter */
  defaultUserRolesConnection_SOME?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
  /** Return AgreementTags where all of the related Users match this filter */
  defaultUserRoles_ALL?: InputMaybe<UserWhere>;
  /** Return AgreementTags where none of the related Users match this filter */
  defaultUserRoles_NONE?: InputMaybe<UserWhere>;
  /** Return AgreementTags where one of the related Users match this filter */
  defaultUserRoles_SINGLE?: InputMaybe<UserWhere>;
  /** Return AgreementTags where some of the related Users match this filter */
  defaultUserRoles_SOME?: InputMaybe<UserWhere>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_GT?: InputMaybe<Scalars['Int']['input']>;
  id_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AgreementTagType>;
  type_IN?: InputMaybe<Array<AgreementTagType>>;
};

export type AgreementTagsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTagsAggregateInput>>;
  NOT?: InputMaybe<AgreementTagsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTagsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTagsNodeAggregationWhereInput>;
};

export type AgreementTagsConnection = {
  __typename?: 'AgreementTagsConnection';
  edges: Array<AgreementTagEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTagsConnectionSort = {
  node?: InputMaybe<AgreementTagSort>;
};

export type AgreementTagsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTagsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTagsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTagsConnectionWhere>>;
  node?: InputMaybe<AgreementTagWhere>;
};

export type AgreementTagsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTagsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTagsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTagsNodeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplate = {
  __typename?: 'AgreementTemplate';
  addedBy: User;
  addedByAggregate?: Maybe<AgreementTemplateUserAddedByAggregationSelection>;
  addedByConnection: AgreementTemplateAddedByConnection;
  addedByName?: Maybe<Scalars['String']['output']>;
  agreementQuantity: Scalars['Int']['output'];
  agreements: Array<Agreement>;
  agreementsAggregate?: Maybe<AgreementTemplateAgreementAgreementsAggregationSelection>;
  agreementsConnection: AgreementTemplateAgreementsConnection;
  allowedForms?: Maybe<Array<Scalars['String']['output']>>;
  allowedRecords?: Maybe<Array<Scalars['String']['output']>>;
  caseSuspensionIntervalDays?: Maybe<Scalars['Int']['output']>;
  childAgreementsDefaultStatus?: Maybe<ContractStatus>;
  country: Country;
  countryAggregate?: Maybe<AgreementTemplateCountryCountryAggregationSelection>;
  countryConnection: AgreementTemplateCountryConnection;
  coveringFormWaitInterval?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['DateTime']['output'];
  currency: Currency;
  currencyAggregate?: Maybe<AgreementTemplateCurrencyCurrencyAggregationSelection>;
  currencyConnection: AgreementTemplateCurrencyConnection;
  cycles: Array<CycleConfiguration>;
  cyclesAggregate?: Maybe<AgreementTemplateCycleConfigurationCyclesAggregationSelection>;
  cyclesConnection: AgreementTemplateCyclesConnection;
  defaultPriceRate?: Maybe<Scalars['Float']['output']>;
  deviceAlternativeSets: Array<DeviceAlternative>;
  deviceAlternativeSetsAggregate?: Maybe<AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection>;
  deviceAlternativeSetsConnection: AgreementTemplateDeviceAlternativeSetsConnection;
  dotThresholds?: Maybe<ChartRangeConfiguration>;
  dotThresholdsAggregate?: Maybe<AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection>;
  dotThresholdsConnection: AgreementTemplateDotThresholdsConnection;
  eligibilityConditionSets: Array<EligibilityConditionSet>;
  eligibilityConditionSetsAggregate?: Maybe<AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection>;
  eligibilityConditionSetsConnection: AgreementTemplateEligibilityConditionSetsConnection;
  eligibilityConditionTreatments?: Maybe<Array<Maybe<Treatment>>>;
  enrollingConditionSets: Array<EnrollingConditionSet>;
  enrollingConditionSetsAggregate?: Maybe<AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection>;
  enrollingConditionSetsConnection: AgreementTemplateEnrollingConditionSetsConnection;
  enrollingPeriods: Array<EnrollingPeriod>;
  enrollingPeriodsAggregate?: Maybe<AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection>;
  enrollingPeriodsConnection: AgreementTemplateEnrollingPeriodsConnection;
  enrolmentDateType?: Maybe<EnrolmentDateType>;
  expectedDocument: DocumentType;
  financialSummaryConfig: Array<FinancialSummaryColumn>;
  financialSummaryConfigAggregate?: Maybe<AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection>;
  financialSummaryConfigConnection: AgreementTemplateFinancialSummaryConfigConnection;
  formattedTags?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialVersion?: Maybe<AgreementTemplate>;
  initialVersionAggregate?: Maybe<AgreementTemplateAgreementTemplateInitialVersionAggregationSelection>;
  initialVersionConnection: AgreementTemplateInitialVersionConnection;
  initialVersionId: Scalars['ID']['output'];
  isAllowedFormsEnabled: Scalars['Boolean']['output'];
  isAllowedRecordsEnabled: Scalars['Boolean']['output'];
  isCaseless: Scalars['Boolean']['output'];
  isCoveringIntervalEnabled: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isFirstVersion: Scalars['Boolean']['output'];
  isLastVersion: Scalars['Boolean']['output'];
  isRequiredFormsEnabled: Scalars['Boolean']['output'];
  isRequiredRecordsEnabled: Scalars['Boolean']['output'];
  lastUpdatedOn?: Maybe<Scalars['Float']['output']>;
  limitation?: Maybe<Limitation>;
  limitationAggregate?: Maybe<AgreementTemplateLimitationLimitationAggregationSelection>;
  limitationConnection: AgreementTemplateLimitationConnection;
  name: Scalars['String']['output'];
  negotiableAttributes: Array<CatalogueAttribute>;
  negotiableAttributesAggregate?: Maybe<AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection>;
  negotiableAttributesConnection: AgreementTemplateNegotiableAttributesConnection;
  nextVersions: Array<AgreementTemplate>;
  nextVersionsAggregate?: Maybe<AgreementTemplateAgreementTemplateNextVersionsAggregationSelection>;
  nextVersionsConnection: AgreementTemplateNextVersionsConnection;
  rangeChartConfig?: Maybe<ChartRangeConfiguration>;
  rangeChartConfigAggregate?: Maybe<AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection>;
  rangeChartConfigConnection: AgreementTemplateRangeChartConfigConnection;
  requiredForms?: Maybe<Array<Scalars['String']['output']>>;
  requiredRecords?: Maybe<Array<Scalars['String']['output']>>;
  scenarios: Array<Scenario>;
  scenariosAggregate?: Maybe<AgreementTemplateScenarioScenariosAggregationSelection>;
  scenariosConnection: AgreementTemplateScenariosConnection;
  scenariosRelevantBrands: Array<Brand>;
  scenariosRelevantBrandsAggregate?: Maybe<AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection>;
  scenariosRelevantBrandsConnection: AgreementTemplateScenariosRelevantBrandsConnection;
  subjectMatter: AgreementSubjectMatter;
  tags: Array<AgreementTag>;
  tagsAggregate?: Maybe<AgreementTemplateAgreementTagTagsAggregationSelection>;
  tagsConnection: AgreementTemplateTagsConnection;
  treatmentPrices: Array<Treatment>;
  treatmentPricesAggregate?: Maybe<AgreementTemplateTreatmentTreatmentPricesAggregationSelection>;
  treatmentPricesConnection: AgreementTemplateTreatmentPricesConnection;
  treatments?: Maybe<Scalars['String']['output']>;
  validFromDate: Scalars['Date']['output'];
  validToDate?: Maybe<Scalars['Date']['output']>;
  version: Scalars['Int']['output'];
};


export type AgreementTemplateAddedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementTemplateAddedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementTemplateAddedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateAddedByConnectionSort>>;
  where?: InputMaybe<AgreementTemplateAddedByConnectionWhere>;
};


export type AgreementTemplateAgreementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type AgreementTemplateAgreementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type AgreementTemplateAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateAgreementsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateAgreementsConnectionWhere>;
};


export type AgreementTemplateCountryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type AgreementTemplateCountryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type AgreementTemplateCountryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateCountryConnectionSort>>;
  where?: InputMaybe<AgreementTemplateCountryConnectionWhere>;
};


export type AgreementTemplateCurrencyArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurrencyOptions>;
  where?: InputMaybe<CurrencyWhere>;
};


export type AgreementTemplateCurrencyAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CurrencyWhere>;
};


export type AgreementTemplateCurrencyConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateCurrencyConnectionSort>>;
  where?: InputMaybe<AgreementTemplateCurrencyConnectionWhere>;
};


export type AgreementTemplateCyclesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CycleConfigurationOptions>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type AgreementTemplateCyclesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type AgreementTemplateCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateCyclesConnectionSort>>;
  where?: InputMaybe<AgreementTemplateCyclesConnectionWhere>;
};


export type AgreementTemplateDeviceAlternativeSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DeviceAlternativeOptions>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type AgreementTemplateDeviceAlternativeSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type AgreementTemplateDeviceAlternativeSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateDeviceAlternativeSetsConnectionWhere>;
};


export type AgreementTemplateDotThresholdsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChartRangeConfigurationOptions>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type AgreementTemplateDotThresholdsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type AgreementTemplateDotThresholdsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateDotThresholdsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateDotThresholdsConnectionWhere>;
};


export type AgreementTemplateEligibilityConditionSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EligibilityConditionSetOptions>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type AgreementTemplateEligibilityConditionSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type AgreementTemplateEligibilityConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateEligibilityConditionSetsConnectionWhere>;
};


export type AgreementTemplateEnrollingConditionSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingConditionSetOptions>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type AgreementTemplateEnrollingConditionSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type AgreementTemplateEnrollingConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateEnrollingConditionSetsConnectionWhere>;
};


export type AgreementTemplateEnrollingPeriodsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingPeriodOptions>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type AgreementTemplateEnrollingPeriodsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type AgreementTemplateEnrollingPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateEnrollingPeriodsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateEnrollingPeriodsConnectionWhere>;
};


export type AgreementTemplateFinancialSummaryConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FinancialSummaryColumnOptions>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type AgreementTemplateFinancialSummaryConfigAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type AgreementTemplateFinancialSummaryConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigConnectionSort>>;
  where?: InputMaybe<AgreementTemplateFinancialSummaryConfigConnectionWhere>;
};


export type AgreementTemplateInitialVersionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type AgreementTemplateInitialVersionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type AgreementTemplateInitialVersionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateInitialVersionConnectionSort>>;
  where?: InputMaybe<AgreementTemplateInitialVersionConnectionWhere>;
};


export type AgreementTemplateLimitationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LimitationOptions>;
  where?: InputMaybe<LimitationWhere>;
};


export type AgreementTemplateLimitationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LimitationWhere>;
};


export type AgreementTemplateLimitationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateLimitationConnectionSort>>;
  where?: InputMaybe<AgreementTemplateLimitationConnectionWhere>;
};


export type AgreementTemplateNegotiableAttributesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type AgreementTemplateNegotiableAttributesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type AgreementTemplateNegotiableAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateNegotiableAttributesConnectionSort>>;
  where?: InputMaybe<AgreementTemplateNegotiableAttributesConnectionWhere>;
};


export type AgreementTemplateNextVersionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type AgreementTemplateNextVersionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type AgreementTemplateNextVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateNextVersionsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateNextVersionsConnectionWhere>;
};


export type AgreementTemplateRangeChartConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChartRangeConfigurationOptions>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type AgreementTemplateRangeChartConfigAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type AgreementTemplateRangeChartConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateRangeChartConfigConnectionSort>>;
  where?: InputMaybe<AgreementTemplateRangeChartConfigConnectionWhere>;
};


export type AgreementTemplateScenariosArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioOptions>;
  where?: InputMaybe<ScenarioWhere>;
};


export type AgreementTemplateScenariosAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioWhere>;
};


export type AgreementTemplateScenariosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateScenariosConnectionSort>>;
  where?: InputMaybe<AgreementTemplateScenariosConnectionWhere>;
};


export type AgreementTemplateScenariosRelevantBrandsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type AgreementTemplateScenariosRelevantBrandsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type AgreementTemplateScenariosRelevantBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateScenariosRelevantBrandsConnectionWhere>;
};


export type AgreementTemplateTagsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTagOptions>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type AgreementTemplateTagsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type AgreementTemplateTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateTagsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateTagsConnectionWhere>;
};


export type AgreementTemplateTreatmentPricesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type AgreementTemplateTreatmentPricesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type AgreementTemplateTreatmentPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateTreatmentPricesConnectionSort>>;
  where?: InputMaybe<AgreementTemplateTreatmentPricesConnectionWhere>;
};

export type AgreementTemplateAddedByAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateAddedByAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateAddedByAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateAddedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateAddedByNodeAggregationWhereInput>;
};

export type AgreementTemplateAddedByConnection = {
  __typename?: 'AgreementTemplateAddedByConnection';
  edges: Array<AgreementTemplateAddedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateAddedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AgreementTemplateAddedByConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateAddedByConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateAddedByConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateAddedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementTemplateAddedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateAddedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateAddedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateAddedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateAddedByRelationship = {
  __typename?: 'AgreementTemplateAddedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AgreementTemplateAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateNodeAggregationWhereInput>;
};

export type AgreementTemplateAgreementAgreementsAggregationSelection = {
  __typename?: 'AgreementTemplateAgreementAgreementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateAgreementAgreementsNodeAggregateSelection>;
};

export type AgreementTemplateAgreementAgreementsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateAgreementAgreementsNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateAgreementTagTagsAggregationSelection = {
  __typename?: 'AgreementTemplateAgreementTagTagsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateAgreementTagTagsNodeAggregateSelection>;
};

export type AgreementTemplateAgreementTagTagsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateAgreementTagTagsNodeAggregateSelection';
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type AgreementTemplateAgreementTemplateInitialVersionAggregationSelection = {
  __typename?: 'AgreementTemplateAgreementTemplateInitialVersionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection>;
};

export type AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection = {
  __typename?: 'AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection';
  addedByName: StringAggregateSelectionNullable;
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  treatments: StringAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateAgreementTemplateNextVersionsAggregationSelection = {
  __typename?: 'AgreementTemplateAgreementTemplateNextVersionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection>;
};

export type AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection';
  addedByName: StringAggregateSelectionNullable;
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  treatments: StringAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateAgreementsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateAgreementsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateAgreementsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateAgreementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateAgreementsNodeAggregationWhereInput>;
};

export type AgreementTemplateAgreementsConnection = {
  __typename?: 'AgreementTemplateAgreementsConnection';
  edges: Array<AgreementTemplateAgreementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateAgreementsConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type AgreementTemplateAgreementsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateAgreementsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateAgreementsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateAgreementsConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type AgreementTemplateAgreementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateAgreementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateAgreementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateAgreementsNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateAgreementsRelationship = {
  __typename?: 'AgreementTemplateAgreementsRelationship';
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection = {
  __typename?: 'AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection>;
};

export type AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection = {
  __typename?: 'AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection>;
};

export type AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection = {
  __typename?: 'AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection = {
  __typename?: 'AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection>;
};

export type AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection = {
  __typename?: 'AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection';
  threshold: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection = {
  __typename?: 'AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection>;
};

export type AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection = {
  __typename?: 'AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection';
  from: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  to: IntAggregateSelectionNullable;
};

export type AgreementTemplateConnection = {
  __typename?: 'AgreementTemplateConnection';
  edges: Array<AgreementTemplateRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateConnectionSort = {
  node?: InputMaybe<AgreementTemplateSort>;
};

export type AgreementTemplateConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateConnectionWhere>>;
  node?: InputMaybe<AgreementTemplateWhere>;
};

export type AgreementTemplateCountryAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateCountryAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateCountryAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateCountryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateCountryNodeAggregationWhereInput>;
};

export type AgreementTemplateCountryConnection = {
  __typename?: 'AgreementTemplateCountryConnection';
  edges: Array<AgreementTemplateCountryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateCountryConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type AgreementTemplateCountryConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateCountryConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateCountryConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateCountryConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type AgreementTemplateCountryCountryAggregationSelection = {
  __typename?: 'AgreementTemplateCountryCountryAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateCountryCountryNodeAggregateSelection>;
};

export type AgreementTemplateCountryCountryNodeAggregateSelection = {
  __typename?: 'AgreementTemplateCountryCountryNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type AgreementTemplateCountryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateCountryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateCountryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateCountryNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateCountryRelationship = {
  __typename?: 'AgreementTemplateCountryRelationship';
  cursor: Scalars['String']['output'];
  node: Country;
};

export type AgreementTemplateCurrencyAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateCurrencyAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateCurrencyAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateCurrencyAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateCurrencyNodeAggregationWhereInput>;
};

export type AgreementTemplateCurrencyConnection = {
  __typename?: 'AgreementTemplateCurrencyConnection';
  edges: Array<AgreementTemplateCurrencyRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateCurrencyConnectionSort = {
  node?: InputMaybe<CurrencySort>;
};

export type AgreementTemplateCurrencyConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateCurrencyConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateCurrencyConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateCurrencyConnectionWhere>>;
  node?: InputMaybe<CurrencyWhere>;
};

export type AgreementTemplateCurrencyCurrencyAggregationSelection = {
  __typename?: 'AgreementTemplateCurrencyCurrencyAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateCurrencyCurrencyNodeAggregateSelection>;
};

export type AgreementTemplateCurrencyCurrencyNodeAggregateSelection = {
  __typename?: 'AgreementTemplateCurrencyCurrencyNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNullable;
  symbol: StringAggregateSelectionNullable;
};

export type AgreementTemplateCurrencyNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateCurrencyNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementTemplateCurrencyNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementTemplateCurrencyNodeAggregationWhereInput>>;
  symbol_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateCurrencyRelationship = {
  __typename?: 'AgreementTemplateCurrencyRelationship';
  cursor: Scalars['String']['output'];
  node: Currency;
};

export type AgreementTemplateCycleConfigurationCyclesAggregationSelection = {
  __typename?: 'AgreementTemplateCycleConfigurationCyclesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection>;
};

export type AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection = {
  __typename?: 'AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection';
  lengthFrom: IntAggregateSelectionNonNullable;
  lengthTo: IntAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateCyclesAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateCyclesAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateCyclesAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateCyclesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateCyclesNodeAggregationWhereInput>;
};

export type AgreementTemplateCyclesConnection = {
  __typename?: 'AgreementTemplateCyclesConnection';
  edges: Array<AgreementTemplateCyclesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateCyclesConnectionSort = {
  node?: InputMaybe<CycleConfigurationSort>;
};

export type AgreementTemplateCyclesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateCyclesConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateCyclesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateCyclesConnectionWhere>>;
  node?: InputMaybe<CycleConfigurationWhere>;
};

export type AgreementTemplateCyclesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateCyclesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateCyclesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateCyclesNodeAggregationWhereInput>>;
  lengthFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateCyclesRelationship = {
  __typename?: 'AgreementTemplateCyclesRelationship';
  cursor: Scalars['String']['output'];
  node: CycleConfiguration;
};

export type AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection = {
  __typename?: 'AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection>;
};

export type AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
};

export type AgreementTemplateDeviceAlternativeSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateDeviceAlternativeSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput>;
};

export type AgreementTemplateDeviceAlternativeSetsConnection = {
  __typename?: 'AgreementTemplateDeviceAlternativeSetsConnection';
  edges: Array<AgreementTemplateDeviceAlternativeSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateDeviceAlternativeSetsConnectionSort = {
  node?: InputMaybe<DeviceAlternativeSort>;
};

export type AgreementTemplateDeviceAlternativeSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateDeviceAlternativeSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsConnectionWhere>>;
  node?: InputMaybe<DeviceAlternativeWhere>;
};

export type AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateDeviceAlternativeSetsRelationship = {
  __typename?: 'AgreementTemplateDeviceAlternativeSetsRelationship';
  cursor: Scalars['String']['output'];
  node: DeviceAlternative;
};

export type AgreementTemplateDotThresholdsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateDotThresholdsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateDotThresholdsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateDotThresholdsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementTemplateDotThresholdsEdgeAggregationWhereInput>;
};

export type AgreementTemplateDotThresholdsConnection = {
  __typename?: 'AgreementTemplateDotThresholdsConnection';
  edges: Array<AgreementTemplateDotThresholdsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateDotThresholdsConnectionSort = {
  edge?: InputMaybe<ThresholdConfigurationRelationshipSort>;
  node?: InputMaybe<ChartRangeConfigurationSort>;
};

export type AgreementTemplateDotThresholdsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateDotThresholdsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateDotThresholdsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateDotThresholdsConnectionWhere>>;
  edge?: InputMaybe<ThresholdConfigurationRelationshipWhere>;
  node?: InputMaybe<ChartRangeConfigurationWhere>;
};

export type AgreementTemplateDotThresholdsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateDotThresholdsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateDotThresholdsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateDotThresholdsEdgeAggregationWhereInput>>;
  threshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateDotThresholdsRelationship = ThresholdConfigurationRelationship & {
  __typename?: 'AgreementTemplateDotThresholdsRelationship';
  cursor: Scalars['String']['output'];
  node: ChartRangeConfiguration;
  threshold: Scalars['Int']['output'];
};

export type AgreementTemplateEdge = {
  __typename?: 'AgreementTemplateEdge';
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type AgreementTemplateEligibilityConditionRelationship = {
  cycleAdherence?: Maybe<CycleAdherence>;
  days?: Maybe<Scalars['Int']['output']>;
  minimumPercentage?: Maybe<Scalars['Int']['output']>;
  numberOfAdministeredRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  numberOfAdministeredTreatments?: Maybe<Scalars['Int']['output']>;
  numberOfAdministeredTreatmentsOperator?: Maybe<ArithmeticalOperator>;
  previousTestNumber?: Maybe<Scalars['Int']['output']>;
  referenceAdministrationSequenceNumber?: Maybe<Scalars['Int']['output']>;
  referenceTestRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  treatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type AgreementTemplateEligibilityConditionRelationshipSort = {
  cycleAdherence?: InputMaybe<SortDirection>;
  days?: InputMaybe<SortDirection>;
  minimumPercentage?: InputMaybe<SortDirection>;
  numberOfAdministeredRangeDays?: InputMaybe<SortDirection>;
  numberOfAdministeredTreatments?: InputMaybe<SortDirection>;
  numberOfAdministeredTreatmentsOperator?: InputMaybe<SortDirection>;
  previousTestNumber?: InputMaybe<SortDirection>;
  referenceAdministrationSequenceNumber?: InputMaybe<SortDirection>;
  referenceTestRangeDays?: InputMaybe<SortDirection>;
  treatments?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type AgreementTemplateEligibilityConditionRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementTemplateEligibilityConditionRelationshipWhere>>;
  NOT?: InputMaybe<AgreementTemplateEligibilityConditionRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementTemplateEligibilityConditionRelationshipWhere>>;
  cycleAdherence?: InputMaybe<CycleAdherence>;
  cycleAdherence_IN?: InputMaybe<Array<InputMaybe<CycleAdherence>>>;
  days?: InputMaybe<Scalars['Int']['input']>;
  days_GT?: InputMaybe<Scalars['Int']['input']>;
  days_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  days_LT?: InputMaybe<Scalars['Int']['input']>;
  days_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  minimumPercentage_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredRangeDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfAdministeredRangeDays_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatmentsOperator?: InputMaybe<ArithmeticalOperator>;
  numberOfAdministeredTreatmentsOperator_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  numberOfAdministeredTreatments_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfAdministeredTreatments_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  previousTestNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  referenceAdministrationSequenceNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceTestRangeDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  referenceTestRangeDays_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  treatments_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
  value_GT?: InputMaybe<Scalars['Int']['input']>;
  value_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  value_LT?: InputMaybe<Scalars['Int']['input']>;
  value_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection = {
  __typename?: 'AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection>;
  node?: Maybe<AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection>;
};

export type AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection = {
  __typename?: 'AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection';
  days: IntAggregateSelectionNullable;
  minimumPercentage: IntAggregateSelectionNullable;
  numberOfAdministeredTreatments: IntAggregateSelectionNullable;
  previousTestNumber: IntAggregateSelectionNullable;
  referenceAdministrationSequenceNumber: IntAggregateSelectionNullable;
  value: IntAggregateSelectionNullable;
};

export type AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  inputLabel: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
};

export type AgreementTemplateEligibilityConditionSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateEligibilityConditionSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput>;
};

export type AgreementTemplateEligibilityConditionSetsConnection = {
  __typename?: 'AgreementTemplateEligibilityConditionSetsConnection';
  edges: Array<AgreementTemplateEligibilityConditionSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateEligibilityConditionSetsConnectionSort = {
  edge?: InputMaybe<AgreementTemplateEligibilityConditionRelationshipSort>;
  node?: InputMaybe<EligibilityConditionSetSort>;
};

export type AgreementTemplateEligibilityConditionSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateEligibilityConditionSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsConnectionWhere>>;
  edge?: InputMaybe<AgreementTemplateEligibilityConditionRelationshipWhere>;
  node?: InputMaybe<EligibilityConditionSetWhere>;
};

export type AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput>>;
  days_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  days_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateEligibilityConditionSetsRelationship = AgreementTemplateEligibilityConditionRelationship & {
  __typename?: 'AgreementTemplateEligibilityConditionSetsRelationship';
  cursor: Scalars['String']['output'];
  cycleAdherence?: Maybe<CycleAdherence>;
  days?: Maybe<Scalars['Int']['output']>;
  minimumPercentage?: Maybe<Scalars['Int']['output']>;
  node: EligibilityConditionSet;
  numberOfAdministeredRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  numberOfAdministeredTreatments?: Maybe<Scalars['Int']['output']>;
  numberOfAdministeredTreatmentsOperator?: Maybe<ArithmeticalOperator>;
  previousTestNumber?: Maybe<Scalars['Int']['output']>;
  referenceAdministrationSequenceNumber?: Maybe<Scalars['Int']['output']>;
  referenceTestRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  treatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection = {
  __typename?: 'AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection>;
};

export type AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateEnrollingConditionSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateEnrollingConditionSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput>;
};

export type AgreementTemplateEnrollingConditionSetsConnection = {
  __typename?: 'AgreementTemplateEnrollingConditionSetsConnection';
  edges: Array<AgreementTemplateEnrollingConditionSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateEnrollingConditionSetsConnectionSort = {
  node?: InputMaybe<EnrollingConditionSetSort>;
};

export type AgreementTemplateEnrollingConditionSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateEnrollingConditionSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsConnectionWhere>>;
  node?: InputMaybe<EnrollingConditionSetWhere>;
};

export type AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateEnrollingConditionSetsRelationship = {
  __typename?: 'AgreementTemplateEnrollingConditionSetsRelationship';
  cursor: Scalars['String']['output'];
  node: EnrollingConditionSet;
};

export type AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection = {
  __typename?: 'AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection';
  count: Scalars['Int']['output'];
};

export type AgreementTemplateEnrollingPeriodsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateEnrollingPeriodsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateEnrollingPeriodsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateEnrollingPeriodsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateEnrollingPeriodsConnection = {
  __typename?: 'AgreementTemplateEnrollingPeriodsConnection';
  edges: Array<AgreementTemplateEnrollingPeriodsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateEnrollingPeriodsConnectionSort = {
  node?: InputMaybe<EnrollingPeriodSort>;
};

export type AgreementTemplateEnrollingPeriodsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateEnrollingPeriodsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateEnrollingPeriodsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateEnrollingPeriodsConnectionWhere>>;
  node?: InputMaybe<EnrollingPeriodWhere>;
};

export type AgreementTemplateEnrollingPeriodsRelationship = {
  __typename?: 'AgreementTemplateEnrollingPeriodsRelationship';
  cursor: Scalars['String']['output'];
  node: EnrollingPeriod;
};

export type AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection = {
  __typename?: 'AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection>;
  node?: Maybe<AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection>;
};

export type AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection = {
  __typename?: 'AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection';
  localizationKey: StringAggregateSelectionNullable;
  position: IntAggregateSelectionNullable;
};

export type AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection = {
  __typename?: 'AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
};

export type AgreementTemplateFinancialSummaryConfigAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateFinancialSummaryConfigAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput>;
};

export type AgreementTemplateFinancialSummaryConfigConnection = {
  __typename?: 'AgreementTemplateFinancialSummaryConfigConnection';
  edges: Array<AgreementTemplateFinancialSummaryConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateFinancialSummaryConfigConnectionSort = {
  edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipSort>;
  node?: InputMaybe<FinancialSummaryColumnSort>;
};

export type AgreementTemplateFinancialSummaryConfigConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateFinancialSummaryConfigConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigConnectionWhere>>;
  edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipWhere>;
  node?: InputMaybe<FinancialSummaryColumnWhere>;
};

export type AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput>>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput>>;
};

export type AgreementTemplateFinancialSummaryConfigRelationship = AgreementFinancialSummaryColumnRelationship & {
  __typename?: 'AgreementTemplateFinancialSummaryConfigRelationship';
  cursor: Scalars['String']['output'];
  hasHelpMessage?: Maybe<Scalars['Boolean']['output']>;
  isIncluded?: Maybe<Scalars['Boolean']['output']>;
  localizationKey?: Maybe<Scalars['String']['output']>;
  node: FinancialSummaryColumn;
  position?: Maybe<Scalars['Int']['output']>;
};

export type AgreementTemplateInitialVersionAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateInitialVersionAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateInitialVersionAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateInitialVersionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateInitialVersionNodeAggregationWhereInput>;
};

export type AgreementTemplateInitialVersionConnection = {
  __typename?: 'AgreementTemplateInitialVersionConnection';
  edges: Array<AgreementTemplateInitialVersionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateInitialVersionConnectionSort = {
  node?: InputMaybe<AgreementTemplateSort>;
};

export type AgreementTemplateInitialVersionConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateInitialVersionConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateInitialVersionConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateInitialVersionConnectionWhere>>;
  node?: InputMaybe<AgreementTemplateWhere>;
};

export type AgreementTemplateInitialVersionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateInitialVersionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateInitialVersionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateInitialVersionNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateInitialVersionRelationship = {
  __typename?: 'AgreementTemplateInitialVersionRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type AgreementTemplateInput = {
  agreementTags: AgreementTagType;
  allowedForms?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  caseSuspensionIntervalDays?: InputMaybe<Scalars['Int']['input']>;
  childAgreementsDefaultStatus?: InputMaybe<ContractStatus>;
  country?: InputMaybe<CountryInput>;
  coveringFormWaitInterval?: InputMaybe<Scalars['Int']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  cycles: Array<CycleConfigurationInput>;
  defaultPriceRate?: InputMaybe<Scalars['Float']['input']>;
  deviceAlternativeSets?: InputMaybe<Array<DeviceAlternativeInput>>;
  dotChartConfig: Array<ChartRangeConfigInput>;
  dotThresholds: Array<Scalars['Int']['input']>;
  eligibilityConditionSets: Array<EligibilityConditionSetInput>;
  enrollingConditionSets: Array<EnrollingConditionSetInput>;
  enrollingPeriod?: InputMaybe<EnrollingPeriodInput>;
  enrolmentDateType?: InputMaybe<EnrolmentDateType>;
  expectedDocument: DocumentType;
  financialSummaryConfig: Array<FinancialSummaryConfigInput>;
  hasAlternatives: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  initialVersionId?: InputMaybe<Scalars['ID']['input']>;
  isAllowedFormsEnabled: Scalars['Boolean']['input'];
  isAllowedRecordsEnabled: Scalars['Boolean']['input'];
  isCaseless: Scalars['Boolean']['input'];
  isChildAgreementCreationAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isCoveringIntervalEnabled: Scalars['Boolean']['input'];
  isNewVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredFormsEnabled: Scalars['Boolean']['input'];
  isRequiredRecordsEnabled: Scalars['Boolean']['input'];
  ldlChartConfig: Array<ChartRangeConfigInput>;
  limitationId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  negotiableAttributeIds: Array<Scalars['String']['input']>;
  requiredForms?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  scenarios: Array<ScenarioInput>;
  scenariosRelevantBrands: Array<BrandAndGenericInput>;
  subjectMatter: AgreementSubjectMatter;
  treatmentNames: Scalars['String']['input'];
  treatmentPrices: Array<TreatmentPriceInput>;
  validFromDate: Scalars['Date']['input'];
  validToDate?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateLimitationAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateLimitationAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateLimitationAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateLimitationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateLimitationNodeAggregationWhereInput>;
};

export type AgreementTemplateLimitationConnection = {
  __typename?: 'AgreementTemplateLimitationConnection';
  edges: Array<AgreementTemplateLimitationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateLimitationConnectionSort = {
  node?: InputMaybe<LimitationSort>;
};

export type AgreementTemplateLimitationConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateLimitationConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateLimitationConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateLimitationConnectionWhere>>;
  node?: InputMaybe<LimitationWhere>;
};

export type AgreementTemplateLimitationLimitationAggregationSelection = {
  __typename?: 'AgreementTemplateLimitationLimitationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateLimitationLimitationNodeAggregateSelection>;
};

export type AgreementTemplateLimitationLimitationNodeAggregateSelection = {
  __typename?: 'AgreementTemplateLimitationLimitationNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  DescriptionDe: StringAggregateSelectionNonNullable;
  DescriptionEn: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  Niveau: StringAggregateSelectionNullable;
  Type: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
};

export type AgreementTemplateLimitationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateLimitationNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementTemplateLimitationNodeAggregationWhereInput>;
  Niveau_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementTemplateLimitationNodeAggregationWhereInput>>;
  Type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AgreementTemplateLimitationRelationship = {
  __typename?: 'AgreementTemplateLimitationRelationship';
  cursor: Scalars['String']['output'];
  node: Limitation;
};

export type AgreementTemplateNegotiableAttributesAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateNegotiableAttributesAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateNegotiableAttributesAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateNegotiableAttributesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateNegotiableAttributesNodeAggregationWhereInput>;
};

export type AgreementTemplateNegotiableAttributesConnection = {
  __typename?: 'AgreementTemplateNegotiableAttributesConnection';
  edges: Array<AgreementTemplateNegotiableAttributesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateNegotiableAttributesConnectionSort = {
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type AgreementTemplateNegotiableAttributesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateNegotiableAttributesConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateNegotiableAttributesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateNegotiableAttributesConnectionWhere>>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type AgreementTemplateNegotiableAttributesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateNegotiableAttributesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateNegotiableAttributesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateNegotiableAttributesNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateNegotiableAttributesRelationship = {
  __typename?: 'AgreementTemplateNegotiableAttributesRelationship';
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
};

export type AgreementTemplateNextVersionsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateNextVersionsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateNextVersionsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateNextVersionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateNextVersionsNodeAggregationWhereInput>;
};

export type AgreementTemplateNextVersionsConnection = {
  __typename?: 'AgreementTemplateNextVersionsConnection';
  edges: Array<AgreementTemplateNextVersionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateNextVersionsConnectionSort = {
  node?: InputMaybe<AgreementTemplateSort>;
};

export type AgreementTemplateNextVersionsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateNextVersionsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateNextVersionsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateNextVersionsConnectionWhere>>;
  node?: InputMaybe<AgreementTemplateWhere>;
};

export type AgreementTemplateNextVersionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateNextVersionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateNextVersionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateNextVersionsNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateNextVersionsRelationship = {
  __typename?: 'AgreementTemplateNextVersionsRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type AgreementTemplateNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementTemplateSort objects to sort AgreementTemplates by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementTemplateSort>>;
};

export type AgreementTemplateRangeChartConfigAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateRangeChartConfigAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateRangeChartConfigAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateRangeChartConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementTemplateRangeChartConfigEdgeAggregationWhereInput>;
};

export type AgreementTemplateRangeChartConfigConnection = {
  __typename?: 'AgreementTemplateRangeChartConfigConnection';
  edges: Array<AgreementTemplateRangeChartConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateRangeChartConfigConnectionSort = {
  edge?: InputMaybe<ChartRangeConfigurationRelationshipSort>;
  node?: InputMaybe<ChartRangeConfigurationSort>;
};

export type AgreementTemplateRangeChartConfigConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateRangeChartConfigConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateRangeChartConfigConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateRangeChartConfigConnectionWhere>>;
  edge?: InputMaybe<ChartRangeConfigurationRelationshipWhere>;
  node?: InputMaybe<ChartRangeConfigurationWhere>;
};

export type AgreementTemplateRangeChartConfigEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateRangeChartConfigEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateRangeChartConfigEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateRangeChartConfigEdgeAggregationWhereInput>>;
  from_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  from_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  to_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateRangeChartConfigRelationship = ChartRangeConfigurationRelationship & {
  __typename?: 'AgreementTemplateRangeChartConfigRelationship';
  cursor: Scalars['String']['output'];
  from: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  node: ChartRangeConfiguration;
  order: Scalars['Int']['output'];
  to?: Maybe<Scalars['Int']['output']>;
};

export type AgreementTemplateRelationship = {
  __typename?: 'AgreementTemplateRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type AgreementTemplateScenarioScenariosAggregationSelection = {
  __typename?: 'AgreementTemplateScenarioScenariosAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateScenarioScenariosNodeAggregateSelection>;
};

export type AgreementTemplateScenarioScenariosNodeAggregateSelection = {
  __typename?: 'AgreementTemplateScenarioScenariosNodeAggregateSelection';
  group: IntAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateScenariosAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateScenariosAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateScenariosAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateScenariosAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateScenariosNodeAggregationWhereInput>;
};

export type AgreementTemplateScenariosConnection = {
  __typename?: 'AgreementTemplateScenariosConnection';
  edges: Array<AgreementTemplateScenariosRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateScenariosConnectionSort = {
  node?: InputMaybe<ScenarioSort>;
};

export type AgreementTemplateScenariosConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateScenariosConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateScenariosConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateScenariosConnectionWhere>>;
  node?: InputMaybe<ScenarioWhere>;
};

export type AgreementTemplateScenariosNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateScenariosNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateScenariosNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateScenariosNodeAggregationWhereInput>>;
  group_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  group_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateScenariosRelationship = {
  __typename?: 'AgreementTemplateScenariosRelationship';
  cursor: Scalars['String']['output'];
  node: Scenario;
};

export type AgreementTemplateScenariosRelevantBrandsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateScenariosRelevantBrandsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput>;
};

export type AgreementTemplateScenariosRelevantBrandsConnection = {
  __typename?: 'AgreementTemplateScenariosRelevantBrandsConnection';
  edges: Array<AgreementTemplateScenariosRelevantBrandsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateScenariosRelevantBrandsConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type AgreementTemplateScenariosRelevantBrandsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateScenariosRelevantBrandsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AgreementTemplateScenariosRelevantBrandsRelationship = {
  __typename?: 'AgreementTemplateScenariosRelevantBrandsRelationship';
  cursor: Scalars['String']['output'];
  node: Brand;
};

/** Fields to sort AgreementTemplates by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementTemplateSort object. */
export type AgreementTemplateSort = {
  addedByName?: InputMaybe<SortDirection>;
  agreementQuantity?: InputMaybe<SortDirection>;
  caseSuspensionIntervalDays?: InputMaybe<SortDirection>;
  childAgreementsDefaultStatus?: InputMaybe<SortDirection>;
  coveringFormWaitInterval?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  defaultPriceRate?: InputMaybe<SortDirection>;
  enrolmentDateType?: InputMaybe<SortDirection>;
  expectedDocument?: InputMaybe<SortDirection>;
  formattedTags?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  initialVersionId?: InputMaybe<SortDirection>;
  isAllowedFormsEnabled?: InputMaybe<SortDirection>;
  isAllowedRecordsEnabled?: InputMaybe<SortDirection>;
  isCaseless?: InputMaybe<SortDirection>;
  isCoveringIntervalEnabled?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isFirstVersion?: InputMaybe<SortDirection>;
  isLastVersion?: InputMaybe<SortDirection>;
  isRequiredFormsEnabled?: InputMaybe<SortDirection>;
  isRequiredRecordsEnabled?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  subjectMatter?: InputMaybe<SortDirection>;
  treatments?: InputMaybe<SortDirection>;
  validFromDate?: InputMaybe<SortDirection>;
  validToDate?: InputMaybe<SortDirection>;
  version?: InputMaybe<SortDirection>;
};

export type AgreementTemplateTagsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateTagsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateTagsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateTagsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateTagsNodeAggregationWhereInput>;
};

export type AgreementTemplateTagsConnection = {
  __typename?: 'AgreementTemplateTagsConnection';
  edges: Array<AgreementTemplateTagsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateTagsConnectionSort = {
  node?: InputMaybe<AgreementTagSort>;
};

export type AgreementTemplateTagsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateTagsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateTagsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateTagsConnectionWhere>>;
  node?: InputMaybe<AgreementTagWhere>;
};

export type AgreementTemplateTagsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateTagsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateTagsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateTagsNodeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateTagsRelationship = {
  __typename?: 'AgreementTemplateTagsRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementTag;
};

export type AgreementTemplateTreatmentPriceRelationship = {
  basePriceType?: Maybe<PriceType>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type AgreementTemplateTreatmentPriceRelationshipSort = {
  basePriceType?: InputMaybe<SortDirection>;
  price?: InputMaybe<SortDirection>;
};

export type AgreementTemplateTreatmentPriceRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementTemplateTreatmentPriceRelationshipWhere>>;
  NOT?: InputMaybe<AgreementTemplateTreatmentPriceRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementTemplateTreatmentPriceRelationshipWhere>>;
  basePriceType?: InputMaybe<PriceType>;
  basePriceType_IN?: InputMaybe<Array<InputMaybe<PriceType>>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  price_GT?: InputMaybe<Scalars['Float']['input']>;
  price_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  price_LT?: InputMaybe<Scalars['Float']['input']>;
  price_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AgreementTemplateTreatmentPricesAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateTreatmentPricesAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateTreatmentPricesAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateTreatmentPricesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementTemplateTreatmentPricesEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementTemplateTreatmentPricesNodeAggregationWhereInput>;
};

export type AgreementTemplateTreatmentPricesConnection = {
  __typename?: 'AgreementTemplateTreatmentPricesConnection';
  edges: Array<AgreementTemplateTreatmentPricesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateTreatmentPricesConnectionSort = {
  edge?: InputMaybe<AgreementTemplateTreatmentPriceRelationshipSort>;
  node?: InputMaybe<TreatmentSort>;
};

export type AgreementTemplateTreatmentPricesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateTreatmentPricesConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateTreatmentPricesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateTreatmentPricesConnectionWhere>>;
  edge?: InputMaybe<AgreementTemplateTreatmentPriceRelationshipWhere>;
  node?: InputMaybe<TreatmentWhere>;
};

export type AgreementTemplateTreatmentPricesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateTreatmentPricesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateTreatmentPricesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateTreatmentPricesEdgeAggregationWhereInput>>;
  price_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AgreementTemplateTreatmentPricesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateTreatmentPricesNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementTemplateTreatmentPricesNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementTemplateTreatmentPricesNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateTreatmentPricesRelationship = AgreementTemplateTreatmentPriceRelationship & {
  __typename?: 'AgreementTemplateTreatmentPricesRelationship';
  basePriceType?: Maybe<PriceType>;
  cursor: Scalars['String']['output'];
  node: Treatment;
  price?: Maybe<Scalars['Float']['output']>;
};

export type AgreementTemplateTreatmentTreatmentPricesAggregationSelection = {
  __typename?: 'AgreementTemplateTreatmentTreatmentPricesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection>;
  node?: Maybe<AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection>;
};

export type AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection = {
  __typename?: 'AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection';
  price: FloatAggregateSelectionNullable;
};

export type AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection = {
  __typename?: 'AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type AgreementTemplateUserAddedByAggregationSelection = {
  __typename?: 'AgreementTemplateUserAddedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateUserAddedByNodeAggregateSelection>;
};

export type AgreementTemplateUserAddedByNodeAggregateSelection = {
  __typename?: 'AgreementTemplateUserAddedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type AgreementTemplateVersionCreationResponse = {
  __typename?: 'AgreementTemplateVersionCreationResponse';
  conflicted?: Maybe<Array<Maybe<Agreement>>>;
  hasNewVersionManuallyCreated?: Maybe<Array<Maybe<Agreement>>>;
  nominal?: Maybe<Array<Maybe<Agreement>>>;
  templateAgreementId: Scalars['String']['output'];
};

export type AgreementTemplateVersionCreationResponseEdge = {
  __typename?: 'AgreementTemplateVersionCreationResponseEdge';
  cursor: Scalars['String']['output'];
  node: AgreementTemplateVersionCreationResponse;
};

export type AgreementTemplateVersionCreationResponseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementTemplateVersionCreationResponseSort objects to sort AgreementTemplateVersionCreationResponses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementTemplateVersionCreationResponseSort>>;
};

/** Fields to sort AgreementTemplateVersionCreationResponses by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementTemplateVersionCreationResponseSort object. */
export type AgreementTemplateVersionCreationResponseSort = {
  templateAgreementId?: InputMaybe<SortDirection>;
};

export type AgreementTemplateVersionCreationResponseWhere = {
  AND?: InputMaybe<Array<AgreementTemplateVersionCreationResponseWhere>>;
  NOT?: InputMaybe<AgreementTemplateVersionCreationResponseWhere>;
  OR?: InputMaybe<Array<AgreementTemplateVersionCreationResponseWhere>>;
  templateAgreementId?: InputMaybe<Scalars['String']['input']>;
  templateAgreementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  templateAgreementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  templateAgreementId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  templateAgreementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  templateAgreementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type AgreementTemplateVersionCreationResponsesConnection = {
  __typename?: 'AgreementTemplateVersionCreationResponsesConnection';
  edges: Array<AgreementTemplateVersionCreationResponseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateWhere = {
  AND?: InputMaybe<Array<AgreementTemplateWhere>>;
  NOT?: InputMaybe<AgreementTemplateWhere>;
  OR?: InputMaybe<Array<AgreementTemplateWhere>>;
  addedBy?: InputMaybe<UserWhere>;
  addedByAggregate?: InputMaybe<AgreementTemplateAddedByAggregateInput>;
  addedByConnection?: InputMaybe<AgreementTemplateAddedByConnectionWhere>;
  addedByConnection_NOT?: InputMaybe<AgreementTemplateAddedByConnectionWhere>;
  addedByName?: InputMaybe<Scalars['String']['input']>;
  addedByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  addedByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedByName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  addedByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedBy_NOT?: InputMaybe<UserWhere>;
  agreementsAggregate?: InputMaybe<AgreementTemplateAgreementsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateAgreementsConnections match this filter */
  agreementsConnection_ALL?: InputMaybe<AgreementTemplateAgreementsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateAgreementsConnections match this filter */
  agreementsConnection_NONE?: InputMaybe<AgreementTemplateAgreementsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateAgreementsConnections match this filter */
  agreementsConnection_SINGLE?: InputMaybe<AgreementTemplateAgreementsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateAgreementsConnections match this filter */
  agreementsConnection_SOME?: InputMaybe<AgreementTemplateAgreementsConnectionWhere>;
  /** Return AgreementTemplates where all of the related Agreements match this filter */
  agreements_ALL?: InputMaybe<AgreementWhere>;
  /** Return AgreementTemplates where none of the related Agreements match this filter */
  agreements_NONE?: InputMaybe<AgreementWhere>;
  /** Return AgreementTemplates where one of the related Agreements match this filter */
  agreements_SINGLE?: InputMaybe<AgreementWhere>;
  /** Return AgreementTemplates where some of the related Agreements match this filter */
  agreements_SOME?: InputMaybe<AgreementWhere>;
  allowedForms?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedForms_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  allowedRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedRecords_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  caseSuspensionIntervalDays?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  caseSuspensionIntervalDays_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_LTE?: InputMaybe<Scalars['Int']['input']>;
  childAgreementsDefaultStatus?: InputMaybe<ContractStatus>;
  childAgreementsDefaultStatus_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
  country?: InputMaybe<CountryWhere>;
  countryAggregate?: InputMaybe<AgreementTemplateCountryAggregateInput>;
  countryConnection?: InputMaybe<AgreementTemplateCountryConnectionWhere>;
  countryConnection_NOT?: InputMaybe<AgreementTemplateCountryConnectionWhere>;
  country_NOT?: InputMaybe<CountryWhere>;
  coveringFormWaitInterval?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  coveringFormWaitInterval_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<CurrencyWhere>;
  currencyAggregate?: InputMaybe<AgreementTemplateCurrencyAggregateInput>;
  currencyConnection?: InputMaybe<AgreementTemplateCurrencyConnectionWhere>;
  currencyConnection_NOT?: InputMaybe<AgreementTemplateCurrencyConnectionWhere>;
  currency_NOT?: InputMaybe<CurrencyWhere>;
  cyclesAggregate?: InputMaybe<AgreementTemplateCyclesAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateCyclesConnections match this filter */
  cyclesConnection_ALL?: InputMaybe<AgreementTemplateCyclesConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateCyclesConnections match this filter */
  cyclesConnection_NONE?: InputMaybe<AgreementTemplateCyclesConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateCyclesConnections match this filter */
  cyclesConnection_SINGLE?: InputMaybe<AgreementTemplateCyclesConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateCyclesConnections match this filter */
  cyclesConnection_SOME?: InputMaybe<AgreementTemplateCyclesConnectionWhere>;
  /** Return AgreementTemplates where all of the related CycleConfigurations match this filter */
  cycles_ALL?: InputMaybe<CycleConfigurationWhere>;
  /** Return AgreementTemplates where none of the related CycleConfigurations match this filter */
  cycles_NONE?: InputMaybe<CycleConfigurationWhere>;
  /** Return AgreementTemplates where one of the related CycleConfigurations match this filter */
  cycles_SINGLE?: InputMaybe<CycleConfigurationWhere>;
  /** Return AgreementTemplates where some of the related CycleConfigurations match this filter */
  cycles_SOME?: InputMaybe<CycleConfigurationWhere>;
  defaultPriceRate?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  defaultPriceRate_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_LTE?: InputMaybe<Scalars['Float']['input']>;
  deviceAlternativeSetsAggregate?: InputMaybe<AgreementTemplateDeviceAlternativeSetsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_ALL?: InputMaybe<AgreementTemplateDeviceAlternativeSetsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_NONE?: InputMaybe<AgreementTemplateDeviceAlternativeSetsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_SINGLE?: InputMaybe<AgreementTemplateDeviceAlternativeSetsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_SOME?: InputMaybe<AgreementTemplateDeviceAlternativeSetsConnectionWhere>;
  /** Return AgreementTemplates where all of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_ALL?: InputMaybe<DeviceAlternativeWhere>;
  /** Return AgreementTemplates where none of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_NONE?: InputMaybe<DeviceAlternativeWhere>;
  /** Return AgreementTemplates where one of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_SINGLE?: InputMaybe<DeviceAlternativeWhere>;
  /** Return AgreementTemplates where some of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_SOME?: InputMaybe<DeviceAlternativeWhere>;
  dotThresholds?: InputMaybe<ChartRangeConfigurationWhere>;
  dotThresholdsAggregate?: InputMaybe<AgreementTemplateDotThresholdsAggregateInput>;
  dotThresholdsConnection?: InputMaybe<AgreementTemplateDotThresholdsConnectionWhere>;
  dotThresholdsConnection_NOT?: InputMaybe<AgreementTemplateDotThresholdsConnectionWhere>;
  dotThresholds_NOT?: InputMaybe<ChartRangeConfigurationWhere>;
  eligibilityConditionSetsAggregate?: InputMaybe<AgreementTemplateEligibilityConditionSetsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_ALL?: InputMaybe<AgreementTemplateEligibilityConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_NONE?: InputMaybe<AgreementTemplateEligibilityConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_SINGLE?: InputMaybe<AgreementTemplateEligibilityConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_SOME?: InputMaybe<AgreementTemplateEligibilityConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where all of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_ALL?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return AgreementTemplates where none of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_NONE?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return AgreementTemplates where one of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_SINGLE?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return AgreementTemplates where some of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_SOME?: InputMaybe<EligibilityConditionSetWhere>;
  enrollingConditionSetsAggregate?: InputMaybe<AgreementTemplateEnrollingConditionSetsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_ALL?: InputMaybe<AgreementTemplateEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_NONE?: InputMaybe<AgreementTemplateEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SINGLE?: InputMaybe<AgreementTemplateEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SOME?: InputMaybe<AgreementTemplateEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where all of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_ALL?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return AgreementTemplates where none of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_NONE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return AgreementTemplates where one of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SINGLE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return AgreementTemplates where some of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SOME?: InputMaybe<EnrollingConditionSetWhere>;
  enrollingPeriodsAggregate?: InputMaybe<AgreementTemplateEnrollingPeriodsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_ALL?: InputMaybe<AgreementTemplateEnrollingPeriodsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_NONE?: InputMaybe<AgreementTemplateEnrollingPeriodsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_SINGLE?: InputMaybe<AgreementTemplateEnrollingPeriodsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_SOME?: InputMaybe<AgreementTemplateEnrollingPeriodsConnectionWhere>;
  /** Return AgreementTemplates where all of the related EnrollingPeriods match this filter */
  enrollingPeriods_ALL?: InputMaybe<EnrollingPeriodWhere>;
  /** Return AgreementTemplates where none of the related EnrollingPeriods match this filter */
  enrollingPeriods_NONE?: InputMaybe<EnrollingPeriodWhere>;
  /** Return AgreementTemplates where one of the related EnrollingPeriods match this filter */
  enrollingPeriods_SINGLE?: InputMaybe<EnrollingPeriodWhere>;
  /** Return AgreementTemplates where some of the related EnrollingPeriods match this filter */
  enrollingPeriods_SOME?: InputMaybe<EnrollingPeriodWhere>;
  enrolmentDateType?: InputMaybe<EnrolmentDateType>;
  enrolmentDateType_IN?: InputMaybe<Array<InputMaybe<EnrolmentDateType>>>;
  expectedDocument?: InputMaybe<DocumentType>;
  expectedDocument_IN?: InputMaybe<Array<DocumentType>>;
  financialSummaryConfigAggregate?: InputMaybe<AgreementTemplateFinancialSummaryConfigAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_ALL?: InputMaybe<AgreementTemplateFinancialSummaryConfigConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_NONE?: InputMaybe<AgreementTemplateFinancialSummaryConfigConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_SINGLE?: InputMaybe<AgreementTemplateFinancialSummaryConfigConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_SOME?: InputMaybe<AgreementTemplateFinancialSummaryConfigConnectionWhere>;
  /** Return AgreementTemplates where all of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_ALL?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return AgreementTemplates where none of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_NONE?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return AgreementTemplates where one of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_SINGLE?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return AgreementTemplates where some of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_SOME?: InputMaybe<FinancialSummaryColumnWhere>;
  formattedTags?: InputMaybe<Scalars['String']['input']>;
  formattedTags_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedTags_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedTags_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedTags_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initialVersion?: InputMaybe<AgreementTemplateWhere>;
  initialVersionAggregate?: InputMaybe<AgreementTemplateInitialVersionAggregateInput>;
  initialVersionConnection?: InputMaybe<AgreementTemplateInitialVersionConnectionWhere>;
  initialVersionConnection_NOT?: InputMaybe<AgreementTemplateInitialVersionConnectionWhere>;
  initialVersionId?: InputMaybe<Scalars['ID']['input']>;
  initialVersionId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  initialVersionId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initialVersionId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  initialVersionId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initialVersion_NOT?: InputMaybe<AgreementTemplateWhere>;
  isAllowedFormsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowedRecordsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCaseless?: InputMaybe<Scalars['Boolean']['input']>;
  isCoveringIntervalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isLastVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredFormsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredRecordsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  limitation?: InputMaybe<LimitationWhere>;
  limitationAggregate?: InputMaybe<AgreementTemplateLimitationAggregateInput>;
  limitationConnection?: InputMaybe<AgreementTemplateLimitationConnectionWhere>;
  limitationConnection_NOT?: InputMaybe<AgreementTemplateLimitationConnectionWhere>;
  limitation_NOT?: InputMaybe<LimitationWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  negotiableAttributesAggregate?: InputMaybe<AgreementTemplateNegotiableAttributesAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_ALL?: InputMaybe<AgreementTemplateNegotiableAttributesConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_NONE?: InputMaybe<AgreementTemplateNegotiableAttributesConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_SINGLE?: InputMaybe<AgreementTemplateNegotiableAttributesConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_SOME?: InputMaybe<AgreementTemplateNegotiableAttributesConnectionWhere>;
  /** Return AgreementTemplates where all of the related CatalogueAttributes match this filter */
  negotiableAttributes_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return AgreementTemplates where none of the related CatalogueAttributes match this filter */
  negotiableAttributes_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return AgreementTemplates where one of the related CatalogueAttributes match this filter */
  negotiableAttributes_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return AgreementTemplates where some of the related CatalogueAttributes match this filter */
  negotiableAttributes_SOME?: InputMaybe<CatalogueAttributeWhere>;
  nextVersionsAggregate?: InputMaybe<AgreementTemplateNextVersionsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateNextVersionsConnections match this filter */
  nextVersionsConnection_ALL?: InputMaybe<AgreementTemplateNextVersionsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateNextVersionsConnections match this filter */
  nextVersionsConnection_NONE?: InputMaybe<AgreementTemplateNextVersionsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateNextVersionsConnections match this filter */
  nextVersionsConnection_SINGLE?: InputMaybe<AgreementTemplateNextVersionsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateNextVersionsConnections match this filter */
  nextVersionsConnection_SOME?: InputMaybe<AgreementTemplateNextVersionsConnectionWhere>;
  /** Return AgreementTemplates where all of the related AgreementTemplates match this filter */
  nextVersions_ALL?: InputMaybe<AgreementTemplateWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplates match this filter */
  nextVersions_NONE?: InputMaybe<AgreementTemplateWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplates match this filter */
  nextVersions_SINGLE?: InputMaybe<AgreementTemplateWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplates match this filter */
  nextVersions_SOME?: InputMaybe<AgreementTemplateWhere>;
  rangeChartConfig?: InputMaybe<ChartRangeConfigurationWhere>;
  rangeChartConfigAggregate?: InputMaybe<AgreementTemplateRangeChartConfigAggregateInput>;
  rangeChartConfigConnection?: InputMaybe<AgreementTemplateRangeChartConfigConnectionWhere>;
  rangeChartConfigConnection_NOT?: InputMaybe<AgreementTemplateRangeChartConfigConnectionWhere>;
  rangeChartConfig_NOT?: InputMaybe<ChartRangeConfigurationWhere>;
  requiredForms?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredForms_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  requiredRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredRecords_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  scenariosAggregate?: InputMaybe<AgreementTemplateScenariosAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateScenariosConnections match this filter */
  scenariosConnection_ALL?: InputMaybe<AgreementTemplateScenariosConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateScenariosConnections match this filter */
  scenariosConnection_NONE?: InputMaybe<AgreementTemplateScenariosConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateScenariosConnections match this filter */
  scenariosConnection_SINGLE?: InputMaybe<AgreementTemplateScenariosConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateScenariosConnections match this filter */
  scenariosConnection_SOME?: InputMaybe<AgreementTemplateScenariosConnectionWhere>;
  scenariosRelevantBrandsAggregate?: InputMaybe<AgreementTemplateScenariosRelevantBrandsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_ALL?: InputMaybe<AgreementTemplateScenariosRelevantBrandsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_NONE?: InputMaybe<AgreementTemplateScenariosRelevantBrandsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_SINGLE?: InputMaybe<AgreementTemplateScenariosRelevantBrandsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_SOME?: InputMaybe<AgreementTemplateScenariosRelevantBrandsConnectionWhere>;
  /** Return AgreementTemplates where all of the related Brands match this filter */
  scenariosRelevantBrands_ALL?: InputMaybe<BrandWhere>;
  /** Return AgreementTemplates where none of the related Brands match this filter */
  scenariosRelevantBrands_NONE?: InputMaybe<BrandWhere>;
  /** Return AgreementTemplates where one of the related Brands match this filter */
  scenariosRelevantBrands_SINGLE?: InputMaybe<BrandWhere>;
  /** Return AgreementTemplates where some of the related Brands match this filter */
  scenariosRelevantBrands_SOME?: InputMaybe<BrandWhere>;
  /** Return AgreementTemplates where all of the related Scenarios match this filter */
  scenarios_ALL?: InputMaybe<ScenarioWhere>;
  /** Return AgreementTemplates where none of the related Scenarios match this filter */
  scenarios_NONE?: InputMaybe<ScenarioWhere>;
  /** Return AgreementTemplates where one of the related Scenarios match this filter */
  scenarios_SINGLE?: InputMaybe<ScenarioWhere>;
  /** Return AgreementTemplates where some of the related Scenarios match this filter */
  scenarios_SOME?: InputMaybe<ScenarioWhere>;
  subjectMatter?: InputMaybe<AgreementSubjectMatter>;
  subjectMatter_IN?: InputMaybe<Array<AgreementSubjectMatter>>;
  tagsAggregate?: InputMaybe<AgreementTemplateTagsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateTagsConnections match this filter */
  tagsConnection_ALL?: InputMaybe<AgreementTemplateTagsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateTagsConnections match this filter */
  tagsConnection_NONE?: InputMaybe<AgreementTemplateTagsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateTagsConnections match this filter */
  tagsConnection_SINGLE?: InputMaybe<AgreementTemplateTagsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateTagsConnections match this filter */
  tagsConnection_SOME?: InputMaybe<AgreementTemplateTagsConnectionWhere>;
  /** Return AgreementTemplates where all of the related AgreementTags match this filter */
  tags_ALL?: InputMaybe<AgreementTagWhere>;
  /** Return AgreementTemplates where none of the related AgreementTags match this filter */
  tags_NONE?: InputMaybe<AgreementTagWhere>;
  /** Return AgreementTemplates where one of the related AgreementTags match this filter */
  tags_SINGLE?: InputMaybe<AgreementTagWhere>;
  /** Return AgreementTemplates where some of the related AgreementTags match this filter */
  tags_SOME?: InputMaybe<AgreementTagWhere>;
  treatmentPricesAggregate?: InputMaybe<AgreementTemplateTreatmentPricesAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateTreatmentPricesConnections match this filter */
  treatmentPricesConnection_ALL?: InputMaybe<AgreementTemplateTreatmentPricesConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateTreatmentPricesConnections match this filter */
  treatmentPricesConnection_NONE?: InputMaybe<AgreementTemplateTreatmentPricesConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateTreatmentPricesConnections match this filter */
  treatmentPricesConnection_SINGLE?: InputMaybe<AgreementTemplateTreatmentPricesConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateTreatmentPricesConnections match this filter */
  treatmentPricesConnection_SOME?: InputMaybe<AgreementTemplateTreatmentPricesConnectionWhere>;
  /** Return AgreementTemplates where all of the related Treatments match this filter */
  treatmentPrices_ALL?: InputMaybe<TreatmentWhere>;
  /** Return AgreementTemplates where none of the related Treatments match this filter */
  treatmentPrices_NONE?: InputMaybe<TreatmentWhere>;
  /** Return AgreementTemplates where one of the related Treatments match this filter */
  treatmentPrices_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return AgreementTemplates where some of the related Treatments match this filter */
  treatmentPrices_SOME?: InputMaybe<TreatmentWhere>;
  treatments?: InputMaybe<Scalars['String']['input']>;
  treatments_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  treatments_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  treatments_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  treatments_MATCHES?: InputMaybe<Scalars['String']['input']>;
  treatments_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  validFromDate?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  validFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_GT?: InputMaybe<Scalars['Int']['input']>;
  version_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_LT?: InputMaybe<Scalars['Int']['input']>;
  version_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplatesConnection = {
  __typename?: 'AgreementTemplatesConnection';
  edges: Array<AgreementTemplateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTreatmentPriceRelationship = {
  basePriceType?: Maybe<PriceType>;
  price: Scalars['Float']['output'];
};

export type AgreementTreatmentPriceRelationshipSort = {
  basePriceType?: InputMaybe<SortDirection>;
  price?: InputMaybe<SortDirection>;
};

export type AgreementTreatmentPriceRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementTreatmentPriceRelationshipWhere>>;
  NOT?: InputMaybe<AgreementTreatmentPriceRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementTreatmentPriceRelationshipWhere>>;
  basePriceType?: InputMaybe<PriceType>;
  basePriceType_IN?: InputMaybe<Array<InputMaybe<PriceType>>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  price_GT?: InputMaybe<Scalars['Float']['input']>;
  price_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  price_LT?: InputMaybe<Scalars['Float']['input']>;
  price_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AgreementTreatmentPricesAggregateInput = {
  AND?: InputMaybe<Array<AgreementTreatmentPricesAggregateInput>>;
  NOT?: InputMaybe<AgreementTreatmentPricesAggregateInput>;
  OR?: InputMaybe<Array<AgreementTreatmentPricesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementTreatmentPricesEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementTreatmentPricesNodeAggregationWhereInput>;
};

export type AgreementTreatmentPricesConnection = {
  __typename?: 'AgreementTreatmentPricesConnection';
  edges: Array<AgreementTreatmentPricesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTreatmentPricesConnectionSort = {
  edge?: InputMaybe<AgreementTreatmentPriceRelationshipSort>;
  node?: InputMaybe<TreatmentSort>;
};

export type AgreementTreatmentPricesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTreatmentPricesConnectionWhere>>;
  NOT?: InputMaybe<AgreementTreatmentPricesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTreatmentPricesConnectionWhere>>;
  edge?: InputMaybe<AgreementTreatmentPriceRelationshipWhere>;
  node?: InputMaybe<TreatmentWhere>;
};

export type AgreementTreatmentPricesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTreatmentPricesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTreatmentPricesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTreatmentPricesEdgeAggregationWhereInput>>;
  price_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AgreementTreatmentPricesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTreatmentPricesNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementTreatmentPricesNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementTreatmentPricesNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTreatmentPricesRelationship = AgreementTreatmentPriceRelationship & {
  __typename?: 'AgreementTreatmentPricesRelationship';
  basePriceType?: Maybe<PriceType>;
  cursor: Scalars['String']['output'];
  node: Treatment;
  price: Scalars['Float']['output'];
};

export type AgreementTreatmentTreatmentPricesAggregationSelection = {
  __typename?: 'AgreementTreatmentTreatmentPricesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementTreatmentTreatmentPricesEdgeAggregateSelection>;
  node?: Maybe<AgreementTreatmentTreatmentPricesNodeAggregateSelection>;
};

export type AgreementTreatmentTreatmentPricesEdgeAggregateSelection = {
  __typename?: 'AgreementTreatmentTreatmentPricesEdgeAggregateSelection';
  price: FloatAggregateSelectionNonNullable;
};

export type AgreementTreatmentTreatmentPricesNodeAggregateSelection = {
  __typename?: 'AgreementTreatmentTreatmentPricesNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type AgreementUserAddedByAggregationSelection = {
  __typename?: 'AgreementUserAddedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementUserAddedByNodeAggregateSelection>;
};

export type AgreementUserAddedByNodeAggregateSelection = {
  __typename?: 'AgreementUserAddedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type AgreementUserPushedByAggregationSelection = {
  __typename?: 'AgreementUserPushedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementUserPushedByNodeAggregateSelection>;
};

export type AgreementUserPushedByNodeAggregateSelection = {
  __typename?: 'AgreementUserPushedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export enum AgreementUserRole {
  Approver = 'APPROVER',
  Editor = 'EDITOR',
  FullAccessUser = 'FULL_ACCESS_USER',
  LimitedAccessUser = 'LIMITED_ACCESS_USER',
  Owner = 'OWNER'
}

export type AgreementUserRoleInput = {
  id: Scalars['ID']['input'];
  isAssignee: Scalars['Boolean']['input'];
  role: AgreementUserRole;
};

export type AgreementUserRoleRelationship = {
  canApprove: Scalars['Boolean']['output'];
  canModifyFinancials: Scalars['Boolean']['output'];
  canViewFinancials: Scalars['Boolean']['output'];
  isAssignee?: Maybe<Scalars['Boolean']['output']>;
  role: AgreementUserRole;
};

export type AgreementUserRoleRelationshipSort = {
  canApprove?: InputMaybe<SortDirection>;
  canModifyFinancials?: InputMaybe<SortDirection>;
  canViewFinancials?: InputMaybe<SortDirection>;
  isAssignee?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type AgreementUserRoleRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementUserRoleRelationshipWhere>>;
  NOT?: InputMaybe<AgreementUserRoleRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementUserRoleRelationshipWhere>>;
  canApprove?: InputMaybe<Scalars['Boolean']['input']>;
  canModifyFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  canViewFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  isAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<AgreementUserRole>;
  role_IN?: InputMaybe<Array<AgreementUserRole>>;
};

export type AgreementUserRolesAggregateInput = {
  AND?: InputMaybe<Array<AgreementUserRolesAggregateInput>>;
  NOT?: InputMaybe<AgreementUserRolesAggregateInput>;
  OR?: InputMaybe<Array<AgreementUserRolesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementUserRolesNodeAggregationWhereInput>;
};

export type AgreementUserRolesConnection = {
  __typename?: 'AgreementUserRolesConnection';
  edges: Array<AgreementUserRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementUserRolesConnectionSort = {
  edge?: InputMaybe<AgreementUserRoleRelationshipSort>;
  node?: InputMaybe<UserSort>;
};

export type AgreementUserRolesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementUserRolesConnectionWhere>>;
  NOT?: InputMaybe<AgreementUserRolesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementUserRolesConnectionWhere>>;
  edge?: InputMaybe<AgreementUserRoleRelationshipWhere>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementUserRolesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementUserRolesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementUserRolesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementUserRolesNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementUserRolesRelationship = AgreementUserRoleRelationship & {
  __typename?: 'AgreementUserRolesRelationship';
  canApprove: Scalars['Boolean']['output'];
  canModifyFinancials: Scalars['Boolean']['output'];
  canViewFinancials: Scalars['Boolean']['output'];
  cursor: Scalars['String']['output'];
  isAssignee?: Maybe<Scalars['Boolean']['output']>;
  node: User;
  role: AgreementUserRole;
};

export type AgreementUserUserRolesAggregationSelection = {
  __typename?: 'AgreementUserUserRolesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementUserUserRolesNodeAggregateSelection>;
};

export type AgreementUserUserRolesNodeAggregateSelection = {
  __typename?: 'AgreementUserUserRolesNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type AgreementWhere = {
  AND?: InputMaybe<Array<AgreementWhere>>;
  NOT?: InputMaybe<AgreementWhere>;
  OR?: InputMaybe<Array<AgreementWhere>>;
  addedBy?: InputMaybe<UserWhere>;
  addedByAggregate?: InputMaybe<AgreementAddedByAggregateInput>;
  addedByConnection?: InputMaybe<AgreementAddedByConnectionWhere>;
  addedByConnection_NOT?: InputMaybe<AgreementAddedByConnectionWhere>;
  addedBy_NOT?: InputMaybe<UserWhere>;
  allowedForms?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedForms_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  allowedRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedRecords_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  caseSuspensionIntervalDays?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  caseSuspensionIntervalDays_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartiesAggregate?: InputMaybe<AgreementCounterpartiesAggregateInput>;
  /** Return Agreements where all of the related AgreementCounterpartiesConnections match this filter */
  counterpartiesConnection_ALL?: InputMaybe<AgreementCounterpartiesConnectionWhere>;
  /** Return Agreements where none of the related AgreementCounterpartiesConnections match this filter */
  counterpartiesConnection_NONE?: InputMaybe<AgreementCounterpartiesConnectionWhere>;
  /** Return Agreements where one of the related AgreementCounterpartiesConnections match this filter */
  counterpartiesConnection_SINGLE?: InputMaybe<AgreementCounterpartiesConnectionWhere>;
  /** Return Agreements where some of the related AgreementCounterpartiesConnections match this filter */
  counterpartiesConnection_SOME?: InputMaybe<AgreementCounterpartiesConnectionWhere>;
  /** Return Agreements where all of the related Organizations match this filter */
  counterparties_ALL?: InputMaybe<OrganizationWhere>;
  /** Return Agreements where none of the related Organizations match this filter */
  counterparties_NONE?: InputMaybe<OrganizationWhere>;
  /** Return Agreements where one of the related Organizations match this filter */
  counterparties_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return Agreements where some of the related Organizations match this filter */
  counterparties_SOME?: InputMaybe<OrganizationWhere>;
  country?: InputMaybe<CountryWhere>;
  countryAggregate?: InputMaybe<AgreementCountryAggregateInput>;
  countryConnection?: InputMaybe<AgreementCountryConnectionWhere>;
  countryConnection_NOT?: InputMaybe<AgreementCountryConnectionWhere>;
  country_NOT?: InputMaybe<CountryWhere>;
  coveringFormWaitInterval?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  coveringFormWaitInterval_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<CurrencyWhere>;
  currencyAggregate?: InputMaybe<AgreementCurrencyAggregateInput>;
  currencyConnection?: InputMaybe<AgreementCurrencyConnectionWhere>;
  currencyConnection_NOT?: InputMaybe<AgreementCurrencyConnectionWhere>;
  currency_NOT?: InputMaybe<CurrencyWhere>;
  cyclesAggregate?: InputMaybe<AgreementCyclesAggregateInput>;
  /** Return Agreements where all of the related AgreementCyclesConnections match this filter */
  cyclesConnection_ALL?: InputMaybe<AgreementCyclesConnectionWhere>;
  /** Return Agreements where none of the related AgreementCyclesConnections match this filter */
  cyclesConnection_NONE?: InputMaybe<AgreementCyclesConnectionWhere>;
  /** Return Agreements where one of the related AgreementCyclesConnections match this filter */
  cyclesConnection_SINGLE?: InputMaybe<AgreementCyclesConnectionWhere>;
  /** Return Agreements where some of the related AgreementCyclesConnections match this filter */
  cyclesConnection_SOME?: InputMaybe<AgreementCyclesConnectionWhere>;
  /** Return Agreements where all of the related CycleConfigurations match this filter */
  cycles_ALL?: InputMaybe<CycleConfigurationWhere>;
  /** Return Agreements where none of the related CycleConfigurations match this filter */
  cycles_NONE?: InputMaybe<CycleConfigurationWhere>;
  /** Return Agreements where one of the related CycleConfigurations match this filter */
  cycles_SINGLE?: InputMaybe<CycleConfigurationWhere>;
  /** Return Agreements where some of the related CycleConfigurations match this filter */
  cycles_SOME?: InputMaybe<CycleConfigurationWhere>;
  dataContainersAggregate?: InputMaybe<AgreementDataContainersAggregateInput>;
  /** Return Agreements where all of the related AgreementDataContainersConnections match this filter */
  dataContainersConnection_ALL?: InputMaybe<AgreementDataContainersConnectionWhere>;
  /** Return Agreements where none of the related AgreementDataContainersConnections match this filter */
  dataContainersConnection_NONE?: InputMaybe<AgreementDataContainersConnectionWhere>;
  /** Return Agreements where one of the related AgreementDataContainersConnections match this filter */
  dataContainersConnection_SINGLE?: InputMaybe<AgreementDataContainersConnectionWhere>;
  /** Return Agreements where some of the related AgreementDataContainersConnections match this filter */
  dataContainersConnection_SOME?: InputMaybe<AgreementDataContainersConnectionWhere>;
  /** Return Agreements where all of the related DataContainers match this filter */
  dataContainers_ALL?: InputMaybe<DataContainerWhere>;
  /** Return Agreements where none of the related DataContainers match this filter */
  dataContainers_NONE?: InputMaybe<DataContainerWhere>;
  /** Return Agreements where one of the related DataContainers match this filter */
  dataContainers_SINGLE?: InputMaybe<DataContainerWhere>;
  /** Return Agreements where some of the related DataContainers match this filter */
  dataContainers_SOME?: InputMaybe<DataContainerWhere>;
  dataSource?: InputMaybe<DataSourceWhere>;
  dataSourceAggregate?: InputMaybe<AgreementDataSourceAggregateInput>;
  dataSourceConnection?: InputMaybe<AgreementDataSourceConnectionWhere>;
  dataSourceConnection_NOT?: InputMaybe<AgreementDataSourceConnectionWhere>;
  dataSource_NOT?: InputMaybe<DataSourceWhere>;
  daysToExpiry?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  daysToExpiry_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  defaultPriceRate_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_LTE?: InputMaybe<Scalars['Float']['input']>;
  deviceAlternativeSetsAggregate?: InputMaybe<AgreementDeviceAlternativeSetsAggregateInput>;
  /** Return Agreements where all of the related AgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_ALL?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return Agreements where none of the related AgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_NONE?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return Agreements where one of the related AgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_SINGLE?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return Agreements where some of the related AgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_SOME?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return Agreements where all of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_ALL?: InputMaybe<DeviceAlternativeWhere>;
  /** Return Agreements where none of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_NONE?: InputMaybe<DeviceAlternativeWhere>;
  /** Return Agreements where one of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_SINGLE?: InputMaybe<DeviceAlternativeWhere>;
  /** Return Agreements where some of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_SOME?: InputMaybe<DeviceAlternativeWhere>;
  dotThresholds?: InputMaybe<ChartRangeConfigurationWhere>;
  dotThresholdsAggregate?: InputMaybe<AgreementDotThresholdsAggregateInput>;
  dotThresholdsConnection?: InputMaybe<AgreementDotThresholdsConnectionWhere>;
  dotThresholdsConnection_NOT?: InputMaybe<AgreementDotThresholdsConnectionWhere>;
  dotThresholds_NOT?: InputMaybe<ChartRangeConfigurationWhere>;
  eligibilityConditionSetsAggregate?: InputMaybe<AgreementEligibilityConditionSetsAggregateInput>;
  /** Return Agreements where all of the related AgreementEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_ALL?: InputMaybe<AgreementEligibilityConditionSetsConnectionWhere>;
  /** Return Agreements where none of the related AgreementEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_NONE?: InputMaybe<AgreementEligibilityConditionSetsConnectionWhere>;
  /** Return Agreements where one of the related AgreementEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_SINGLE?: InputMaybe<AgreementEligibilityConditionSetsConnectionWhere>;
  /** Return Agreements where some of the related AgreementEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_SOME?: InputMaybe<AgreementEligibilityConditionSetsConnectionWhere>;
  /** Return Agreements where all of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_ALL?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return Agreements where none of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_NONE?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return Agreements where one of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_SINGLE?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return Agreements where some of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_SOME?: InputMaybe<EligibilityConditionSetWhere>;
  enrollingConditionSetsAggregate?: InputMaybe<AgreementEnrollingConditionSetsAggregateInput>;
  /** Return Agreements where all of the related AgreementEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_ALL?: InputMaybe<AgreementEnrollingConditionSetsConnectionWhere>;
  /** Return Agreements where none of the related AgreementEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_NONE?: InputMaybe<AgreementEnrollingConditionSetsConnectionWhere>;
  /** Return Agreements where one of the related AgreementEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SINGLE?: InputMaybe<AgreementEnrollingConditionSetsConnectionWhere>;
  /** Return Agreements where some of the related AgreementEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SOME?: InputMaybe<AgreementEnrollingConditionSetsConnectionWhere>;
  /** Return Agreements where all of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_ALL?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return Agreements where none of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_NONE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return Agreements where one of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SINGLE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return Agreements where some of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SOME?: InputMaybe<EnrollingConditionSetWhere>;
  enrollingPeriodsAggregate?: InputMaybe<AgreementEnrollingPeriodsAggregateInput>;
  /** Return Agreements where all of the related AgreementEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_ALL?: InputMaybe<AgreementEnrollingPeriodsConnectionWhere>;
  /** Return Agreements where none of the related AgreementEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_NONE?: InputMaybe<AgreementEnrollingPeriodsConnectionWhere>;
  /** Return Agreements where one of the related AgreementEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_SINGLE?: InputMaybe<AgreementEnrollingPeriodsConnectionWhere>;
  /** Return Agreements where some of the related AgreementEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_SOME?: InputMaybe<AgreementEnrollingPeriodsConnectionWhere>;
  /** Return Agreements where all of the related EnrollingPeriods match this filter */
  enrollingPeriods_ALL?: InputMaybe<EnrollingPeriodWhere>;
  /** Return Agreements where none of the related EnrollingPeriods match this filter */
  enrollingPeriods_NONE?: InputMaybe<EnrollingPeriodWhere>;
  /** Return Agreements where one of the related EnrollingPeriods match this filter */
  enrollingPeriods_SINGLE?: InputMaybe<EnrollingPeriodWhere>;
  /** Return Agreements where some of the related EnrollingPeriods match this filter */
  enrollingPeriods_SOME?: InputMaybe<EnrollingPeriodWhere>;
  enrolmentDateType?: InputMaybe<EnrolmentDateType>;
  enrolmentDateType_IN?: InputMaybe<Array<InputMaybe<EnrolmentDateType>>>;
  expectedDocument?: InputMaybe<DocumentType>;
  expectedDocument_IN?: InputMaybe<Array<DocumentType>>;
  financialSummaryConfigAggregate?: InputMaybe<AgreementFinancialSummaryConfigAggregateInput>;
  /** Return Agreements where all of the related AgreementFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_ALL?: InputMaybe<AgreementFinancialSummaryConfigConnectionWhere>;
  /** Return Agreements where none of the related AgreementFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_NONE?: InputMaybe<AgreementFinancialSummaryConfigConnectionWhere>;
  /** Return Agreements where one of the related AgreementFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_SINGLE?: InputMaybe<AgreementFinancialSummaryConfigConnectionWhere>;
  /** Return Agreements where some of the related AgreementFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_SOME?: InputMaybe<AgreementFinancialSummaryConfigConnectionWhere>;
  /** Return Agreements where all of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_ALL?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return Agreements where none of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_NONE?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return Agreements where one of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_SINGLE?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return Agreements where some of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_SOME?: InputMaybe<FinancialSummaryColumnWhere>;
  firstExecutionDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstExecutionDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedAmount_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedCounterparties_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedDiseases_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedIndications?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedIndications_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedProducts?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedProducts_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags?: InputMaybe<Scalars['String']['input']>;
  formattedTags_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedTags_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedTags_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedTags_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedValidityPeriod_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initialVersion?: InputMaybe<AgreementWhere>;
  initialVersionAggregate?: InputMaybe<AgreementInitialVersionAggregateInput>;
  initialVersionConnection?: InputMaybe<AgreementInitialVersionConnectionWhere>;
  initialVersionConnection_NOT?: InputMaybe<AgreementInitialVersionConnectionWhere>;
  initialVersionId?: InputMaybe<Scalars['ID']['input']>;
  initialVersionId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  initialVersionId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initialVersionId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  initialVersionId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initialVersion_NOT?: InputMaybe<AgreementWhere>;
  isAllowedFormsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowedRecordsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isCaseless?: InputMaybe<Scalars['Boolean']['input']>;
  isCoveringIntervalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isExtended?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isInsightsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isLastVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isNewVersionManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredFormsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredRecordsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isScenariosInSync?: InputMaybe<Scalars['Boolean']['input']>;
  isScopeSync?: InputMaybe<Scalars['Boolean']['input']>;
  isValidityPeriodInSync?: InputMaybe<Scalars['Boolean']['input']>;
  lastExecutionDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastExecutionDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastVersionValidToDate?: InputMaybe<Scalars['Date']['input']>;
  lastVersionValidToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  lastVersionValidToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  lastVersionValidToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lastVersionValidToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  lastVersionValidToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  limitation?: InputMaybe<LimitationWhere>;
  limitationAggregate?: InputMaybe<AgreementLimitationAggregateInput>;
  limitationConnection?: InputMaybe<AgreementLimitationConnectionWhere>;
  limitationConnection_NOT?: InputMaybe<AgreementLimitationConnectionWhere>;
  limitation_NOT?: InputMaybe<LimitationWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  negotiableAttributesAggregate?: InputMaybe<AgreementNegotiableAttributesAggregateInput>;
  /** Return Agreements where all of the related AgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_ALL?: InputMaybe<AgreementNegotiableAttributesConnectionWhere>;
  /** Return Agreements where none of the related AgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_NONE?: InputMaybe<AgreementNegotiableAttributesConnectionWhere>;
  /** Return Agreements where one of the related AgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_SINGLE?: InputMaybe<AgreementNegotiableAttributesConnectionWhere>;
  /** Return Agreements where some of the related AgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_SOME?: InputMaybe<AgreementNegotiableAttributesConnectionWhere>;
  /** Return Agreements where all of the related CatalogueAttributes match this filter */
  negotiableAttributes_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return Agreements where none of the related CatalogueAttributes match this filter */
  negotiableAttributes_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return Agreements where one of the related CatalogueAttributes match this filter */
  negotiableAttributes_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return Agreements where some of the related CatalogueAttributes match this filter */
  negotiableAttributes_SOME?: InputMaybe<CatalogueAttributeWhere>;
  nextVersionsAggregate?: InputMaybe<AgreementNextVersionsAggregateInput>;
  /** Return Agreements where all of the related AgreementNextVersionsConnections match this filter */
  nextVersionsConnection_ALL?: InputMaybe<AgreementNextVersionsConnectionWhere>;
  /** Return Agreements where none of the related AgreementNextVersionsConnections match this filter */
  nextVersionsConnection_NONE?: InputMaybe<AgreementNextVersionsConnectionWhere>;
  /** Return Agreements where one of the related AgreementNextVersionsConnections match this filter */
  nextVersionsConnection_SINGLE?: InputMaybe<AgreementNextVersionsConnectionWhere>;
  /** Return Agreements where some of the related AgreementNextVersionsConnections match this filter */
  nextVersionsConnection_SOME?: InputMaybe<AgreementNextVersionsConnectionWhere>;
  /** Return Agreements where all of the related Agreements match this filter */
  nextVersions_ALL?: InputMaybe<AgreementWhere>;
  /** Return Agreements where none of the related Agreements match this filter */
  nextVersions_NONE?: InputMaybe<AgreementWhere>;
  /** Return Agreements where one of the related Agreements match this filter */
  nextVersions_SINGLE?: InputMaybe<AgreementWhere>;
  /** Return Agreements where some of the related Agreements match this filter */
  nextVersions_SOME?: InputMaybe<AgreementWhere>;
  pushedBy?: InputMaybe<UserWhere>;
  pushedByAggregate?: InputMaybe<AgreementPushedByAggregateInput>;
  pushedByConnection?: InputMaybe<AgreementPushedByConnectionWhere>;
  pushedByConnection_NOT?: InputMaybe<AgreementPushedByConnectionWhere>;
  pushedBy_NOT?: InputMaybe<UserWhere>;
  pushedOn?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  pushedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  rangeChartConfig?: InputMaybe<ChartRangeConfigurationWhere>;
  rangeChartConfigAggregate?: InputMaybe<AgreementRangeChartConfigAggregateInput>;
  rangeChartConfigConnection?: InputMaybe<AgreementRangeChartConfigConnectionWhere>;
  rangeChartConfigConnection_NOT?: InputMaybe<AgreementRangeChartConfigConnectionWhere>;
  rangeChartConfig_NOT?: InputMaybe<ChartRangeConfigurationWhere>;
  reportData?: InputMaybe<Scalars['String']['input']>;
  reportData_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  reportData_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  reportData_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportData_MATCHES?: InputMaybe<Scalars['String']['input']>;
  reportData_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  requiredForms?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredForms_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  requiredRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredRecords_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  scenariosAggregate?: InputMaybe<AgreementScenariosAggregateInput>;
  /** Return Agreements where all of the related AgreementScenariosConnections match this filter */
  scenariosConnection_ALL?: InputMaybe<AgreementScenariosConnectionWhere>;
  /** Return Agreements where none of the related AgreementScenariosConnections match this filter */
  scenariosConnection_NONE?: InputMaybe<AgreementScenariosConnectionWhere>;
  /** Return Agreements where one of the related AgreementScenariosConnections match this filter */
  scenariosConnection_SINGLE?: InputMaybe<AgreementScenariosConnectionWhere>;
  /** Return Agreements where some of the related AgreementScenariosConnections match this filter */
  scenariosConnection_SOME?: InputMaybe<AgreementScenariosConnectionWhere>;
  scenariosRelevantBrandsAggregate?: InputMaybe<AgreementScenariosRelevantBrandsAggregateInput>;
  /** Return Agreements where all of the related AgreementScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_ALL?: InputMaybe<AgreementScenariosRelevantBrandsConnectionWhere>;
  /** Return Agreements where none of the related AgreementScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_NONE?: InputMaybe<AgreementScenariosRelevantBrandsConnectionWhere>;
  /** Return Agreements where one of the related AgreementScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_SINGLE?: InputMaybe<AgreementScenariosRelevantBrandsConnectionWhere>;
  /** Return Agreements where some of the related AgreementScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_SOME?: InputMaybe<AgreementScenariosRelevantBrandsConnectionWhere>;
  /** Return Agreements where all of the related Brands match this filter */
  scenariosRelevantBrands_ALL?: InputMaybe<BrandWhere>;
  /** Return Agreements where none of the related Brands match this filter */
  scenariosRelevantBrands_NONE?: InputMaybe<BrandWhere>;
  /** Return Agreements where one of the related Brands match this filter */
  scenariosRelevantBrands_SINGLE?: InputMaybe<BrandWhere>;
  /** Return Agreements where some of the related Brands match this filter */
  scenariosRelevantBrands_SOME?: InputMaybe<BrandWhere>;
  /** Return Agreements where all of the related Scenarios match this filter */
  scenarios_ALL?: InputMaybe<ScenarioWhere>;
  /** Return Agreements where none of the related Scenarios match this filter */
  scenarios_NONE?: InputMaybe<ScenarioWhere>;
  /** Return Agreements where one of the related Scenarios match this filter */
  scenarios_SINGLE?: InputMaybe<ScenarioWhere>;
  /** Return Agreements where some of the related Scenarios match this filter */
  scenarios_SOME?: InputMaybe<ScenarioWhere>;
  status?: InputMaybe<ContractStatus>;
  status_IN?: InputMaybe<Array<ContractStatus>>;
  subjectMatter?: InputMaybe<AgreementSubjectMatter>;
  subjectMatter_IN?: InputMaybe<Array<AgreementSubjectMatter>>;
  tagsAggregate?: InputMaybe<AgreementTagsAggregateInput>;
  /** Return Agreements where all of the related AgreementTagsConnections match this filter */
  tagsConnection_ALL?: InputMaybe<AgreementTagsConnectionWhere>;
  /** Return Agreements where none of the related AgreementTagsConnections match this filter */
  tagsConnection_NONE?: InputMaybe<AgreementTagsConnectionWhere>;
  /** Return Agreements where one of the related AgreementTagsConnections match this filter */
  tagsConnection_SINGLE?: InputMaybe<AgreementTagsConnectionWhere>;
  /** Return Agreements where some of the related AgreementTagsConnections match this filter */
  tagsConnection_SOME?: InputMaybe<AgreementTagsConnectionWhere>;
  /** Return Agreements where all of the related AgreementTags match this filter */
  tags_ALL?: InputMaybe<AgreementTagWhere>;
  /** Return Agreements where none of the related AgreementTags match this filter */
  tags_NONE?: InputMaybe<AgreementTagWhere>;
  /** Return Agreements where one of the related AgreementTags match this filter */
  tags_SINGLE?: InputMaybe<AgreementTagWhere>;
  /** Return Agreements where some of the related AgreementTags match this filter */
  tags_SOME?: InputMaybe<AgreementTagWhere>;
  template?: InputMaybe<AgreementTemplateWhere>;
  templateAggregate?: InputMaybe<AgreementTemplateAggregateInput>;
  templateConnection?: InputMaybe<AgreementTemplateConnectionWhere>;
  templateConnection_NOT?: InputMaybe<AgreementTemplateConnectionWhere>;
  template_NOT?: InputMaybe<AgreementTemplateWhere>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatmentPricesAggregate?: InputMaybe<AgreementTreatmentPricesAggregateInput>;
  /** Return Agreements where all of the related AgreementTreatmentPricesConnections match this filter */
  treatmentPricesConnection_ALL?: InputMaybe<AgreementTreatmentPricesConnectionWhere>;
  /** Return Agreements where none of the related AgreementTreatmentPricesConnections match this filter */
  treatmentPricesConnection_NONE?: InputMaybe<AgreementTreatmentPricesConnectionWhere>;
  /** Return Agreements where one of the related AgreementTreatmentPricesConnections match this filter */
  treatmentPricesConnection_SINGLE?: InputMaybe<AgreementTreatmentPricesConnectionWhere>;
  /** Return Agreements where some of the related AgreementTreatmentPricesConnections match this filter */
  treatmentPricesConnection_SOME?: InputMaybe<AgreementTreatmentPricesConnectionWhere>;
  /** Return Agreements where all of the related Treatments match this filter */
  treatmentPrices_ALL?: InputMaybe<TreatmentWhere>;
  /** Return Agreements where none of the related Treatments match this filter */
  treatmentPrices_NONE?: InputMaybe<TreatmentWhere>;
  /** Return Agreements where one of the related Treatments match this filter */
  treatmentPrices_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return Agreements where some of the related Treatments match this filter */
  treatmentPrices_SOME?: InputMaybe<TreatmentWhere>;
  userRolesAggregate?: InputMaybe<AgreementUserRolesAggregateInput>;
  /** Return Agreements where all of the related AgreementUserRolesConnections match this filter */
  userRolesConnection_ALL?: InputMaybe<AgreementUserRolesConnectionWhere>;
  /** Return Agreements where none of the related AgreementUserRolesConnections match this filter */
  userRolesConnection_NONE?: InputMaybe<AgreementUserRolesConnectionWhere>;
  /** Return Agreements where one of the related AgreementUserRolesConnections match this filter */
  userRolesConnection_SINGLE?: InputMaybe<AgreementUserRolesConnectionWhere>;
  /** Return Agreements where some of the related AgreementUserRolesConnections match this filter */
  userRolesConnection_SOME?: InputMaybe<AgreementUserRolesConnectionWhere>;
  /** Return Agreements where all of the related Users match this filter */
  userRoles_ALL?: InputMaybe<UserWhere>;
  /** Return Agreements where none of the related Users match this filter */
  userRoles_NONE?: InputMaybe<UserWhere>;
  /** Return Agreements where one of the related Users match this filter */
  userRoles_SINGLE?: InputMaybe<UserWhere>;
  /** Return Agreements where some of the related Users match this filter */
  userRoles_SOME?: InputMaybe<UserWhere>;
  validFromDate?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  validFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_GT?: InputMaybe<Scalars['Int']['input']>;
  version_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_LT?: InputMaybe<Scalars['Int']['input']>;
  version_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementsConnection = {
  __typename?: 'AgreementsConnection';
  edges: Array<AgreementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Alert = {
  __typename?: 'Alert';
  check: RunCheck;
  checkAggregate?: Maybe<AlertRunCheckCheckAggregationSelection>;
  checkConnection: AlertCheckConnection;
  createdOn: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  entityUniqueIdentifier: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedOn: Scalars['DateTime']['output'];
  message?: Maybe<Scalars['String']['output']>;
  organizationCountry: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};


export type AlertCheckArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RunCheckOptions>;
  where?: InputMaybe<RunCheckWhere>;
};


export type AlertCheckAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RunCheckWhere>;
};


export type AlertCheckConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AlertCheckConnectionSort>>;
  where?: InputMaybe<AlertCheckConnectionWhere>;
};

export type AlertCheckAggregateInput = {
  AND?: InputMaybe<Array<AlertCheckAggregateInput>>;
  NOT?: InputMaybe<AlertCheckAggregateInput>;
  OR?: InputMaybe<Array<AlertCheckAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AlertCheckNodeAggregationWhereInput>;
};

export type AlertCheckConnection = {
  __typename?: 'AlertCheckConnection';
  edges: Array<AlertCheckRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AlertCheckConnectionSort = {
  node?: InputMaybe<RunCheckSort>;
};

export type AlertCheckConnectionWhere = {
  AND?: InputMaybe<Array<AlertCheckConnectionWhere>>;
  NOT?: InputMaybe<AlertCheckConnectionWhere>;
  OR?: InputMaybe<Array<AlertCheckConnectionWhere>>;
  node?: InputMaybe<RunCheckWhere>;
};

export type AlertCheckNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AlertCheckNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AlertCheckNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AlertCheckNodeAggregationWhereInput>>;
  checkKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  checkKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  checkKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  checkKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  checkKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  checkKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  checkKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  checkKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  checkKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  checkKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  checkName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  checkName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  checkName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  checkName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  checkName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  checkName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  checkName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  checkName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  checkName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  checkName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  startedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertCheckRelationship = {
  __typename?: 'AlertCheckRelationship';
  cursor: Scalars['String']['output'];
  node: RunCheck;
};

export type AlertEdge = {
  __typename?: 'AlertEdge';
  cursor: Scalars['String']['output'];
  node: Alert;
};

export type AlertOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AlertSort objects to sort Alerts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AlertSort>>;
};

export type AlertRunCheckCheckAggregationSelection = {
  __typename?: 'AlertRunCheckCheckAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AlertRunCheckCheckNodeAggregateSelection>;
};

export type AlertRunCheckCheckNodeAggregateSelection = {
  __typename?: 'AlertRunCheckCheckNodeAggregateSelection';
  checkKey: StringAggregateSelectionNonNullable;
  checkName: StringAggregateSelectionNonNullable;
  completedOn: DateTimeAggregateSelectionNonNullable;
  count: IntAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  startedOn: DateTimeAggregateSelectionNonNullable;
  triggeredBy: StringAggregateSelectionNonNullable;
};

/** Fields to sort Alerts by. The order in which sorts are applied is not guaranteed when specifying many fields in one AlertSort object. */
export type AlertSort = {
  createdOn?: InputMaybe<SortDirection>;
  entityId?: InputMaybe<SortDirection>;
  entityUniqueIdentifier?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  message?: InputMaybe<SortDirection>;
  organizationCountry?: InputMaybe<SortDirection>;
  organizationName?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
};

export type AlertWhere = {
  AND?: InputMaybe<Array<AlertWhere>>;
  NOT?: InputMaybe<AlertWhere>;
  OR?: InputMaybe<Array<AlertWhere>>;
  check?: InputMaybe<RunCheckWhere>;
  checkAggregate?: InputMaybe<AlertCheckAggregateInput>;
  checkConnection?: InputMaybe<AlertCheckConnectionWhere>;
  checkConnection_NOT?: InputMaybe<AlertCheckConnectionWhere>;
  check_NOT?: InputMaybe<RunCheckWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  entityId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  entityId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  entityId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  entityId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  entityUniqueIdentifier?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_GT?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_GTE?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  entityUniqueIdentifier_LT?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_LTE?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  message_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  message_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message_MATCHES?: InputMaybe<Scalars['String']['input']>;
  message_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationCountry?: InputMaybe<Scalars['String']['input']>;
  organizationCountry_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationCountry_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationCountry_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationCountry_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationCountry_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type AlertsConnection = {
  __typename?: 'AlertsConnection';
  edges: Array<AlertEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AmountOfThresholdBasis {
  GrossAmount = 'GROSS_AMOUNT',
  NetAmount = 'NET_AMOUNT'
}

export enum AmountsType {
  TotalAmount = 'TOTAL_AMOUNT'
}

export type ApplyUserRolesToAllInput = {
  agreementTag: AgreementTagType;
  userId: Scalars['String']['input'];
};

export enum ArithmeticalOperator {
  Both = 'BOTH',
  Equal = 'EQUAL',
  GreaterThen = 'GREATER_THEN',
  GreaterThenOrEqual = 'GREATER_THEN_OR_EQUAL',
  LessThen = 'LESS_THEN',
  LessThenOrEqual = 'LESS_THEN_OR_EQUAL'
}

export type Art71MasterDataImpacts = {
  __typename?: 'Art71MasterDataImpacts';
  agreementId: Scalars['ID']['output'];
  refundImpacts: Array<MasterDataRefundImpact>;
  tenantId: Scalars['String']['output'];
};

export type Art71MasterDataImpactsConnection = {
  __typename?: 'Art71MasterDataImpactsConnection';
  edges: Array<Art71MasterDataImpactsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Art71MasterDataImpactsEdge = {
  __typename?: 'Art71MasterDataImpactsEdge';
  cursor: Scalars['String']['output'];
  node: Art71MasterDataImpacts;
};

export type Art71MasterDataImpactsInput = {
  affectedRefundIds: Array<Scalars['String']['input']>;
  agreementId: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
};

export type Art71MasterDataImpactsOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more Art71MasterDataImpactsSort objects to sort Art71MasterDataImpacts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<Art71MasterDataImpactsSort>>;
};

/** Fields to sort Art71MasterDataImpacts by. The order in which sorts are applied is not guaranteed when specifying many fields in one Art71MasterDataImpactsSort object. */
export type Art71MasterDataImpactsSort = {
  agreementId?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
};

export type Art71MasterDataImpactsWhere = {
  AND?: InputMaybe<Array<Art71MasterDataImpactsWhere>>;
  NOT?: InputMaybe<Art71MasterDataImpactsWhere>;
  OR?: InputMaybe<Array<Art71MasterDataImpactsWhere>>;
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  agreementId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  agreementId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  agreementId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  agreementId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type Article71Indication = {
  __typename?: 'Article71Indication';
  agreementScope?: Maybe<AgreementScope>;
  agreementScopeAggregate?: Maybe<Article71IndicationAgreementScopeAgreementScopeAggregationSelection>;
  agreementScopeConnection: Article71IndicationAgreementScopeConnection;
  agreementTemplate?: Maybe<AgreementTemplate>;
  agreementTemplateAggregate?: Maybe<Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection>;
  agreementTemplateConnection: Article71IndicationAgreementTemplateConnection;
  approvalDate?: Maybe<Scalars['Date']['output']>;
  brand: Brand;
  brandAggregate?: Maybe<Article71IndicationBrandBrandAggregationSelection>;
  brandConnection: Article71IndicationBrandConnection;
  cases: Array<Case>;
  casesAggregate?: Maybe<Article71IndicationCaseCasesAggregationSelection>;
  casesConnection: Article71IndicationCasesConnection;
  countryScopeId?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedOn: Scalars['DateTime']['output'];
  mainIndication?: Maybe<MainIndication>;
  mainIndicationAggregate?: Maybe<Article71IndicationMainIndicationMainIndicationAggregationSelection>;
  mainIndicationConnection: Article71IndicationMainIndicationConnection;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  sllAdditionDate?: Maybe<Scalars['Date']['output']>;
};


export type Article71IndicationAgreementScopeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementScopeOptions>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type Article71IndicationAgreementScopeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type Article71IndicationAgreementScopeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Article71IndicationAgreementScopeConnectionSort>>;
  where?: InputMaybe<Article71IndicationAgreementScopeConnectionWhere>;
};


export type Article71IndicationAgreementTemplateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type Article71IndicationAgreementTemplateAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type Article71IndicationAgreementTemplateConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Article71IndicationAgreementTemplateConnectionSort>>;
  where?: InputMaybe<Article71IndicationAgreementTemplateConnectionWhere>;
};


export type Article71IndicationBrandArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type Article71IndicationBrandAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type Article71IndicationBrandConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Article71IndicationBrandConnectionSort>>;
  where?: InputMaybe<Article71IndicationBrandConnectionWhere>;
};


export type Article71IndicationCasesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type Article71IndicationCasesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type Article71IndicationCasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Article71IndicationCasesConnectionSort>>;
  where?: InputMaybe<Article71IndicationCasesConnectionWhere>;
};


export type Article71IndicationMainIndicationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MainIndicationOptions>;
  where?: InputMaybe<MainIndicationWhere>;
};


export type Article71IndicationMainIndicationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MainIndicationWhere>;
};


export type Article71IndicationMainIndicationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Article71IndicationMainIndicationConnectionSort>>;
  where?: InputMaybe<Article71IndicationMainIndicationConnectionWhere>;
};

export type Article71IndicationAgreementScopeAggregateInput = {
  AND?: InputMaybe<Array<Article71IndicationAgreementScopeAggregateInput>>;
  NOT?: InputMaybe<Article71IndicationAgreementScopeAggregateInput>;
  OR?: InputMaybe<Array<Article71IndicationAgreementScopeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<Article71IndicationAgreementScopeNodeAggregationWhereInput>;
};

export type Article71IndicationAgreementScopeAgreementScopeAggregationSelection = {
  __typename?: 'Article71IndicationAgreementScopeAgreementScopeAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection>;
};

export type Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection = {
  __typename?: 'Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
  scopeId: StringAggregateSelectionNonNullable;
};

export type Article71IndicationAgreementScopeConnection = {
  __typename?: 'Article71IndicationAgreementScopeConnection';
  edges: Array<Article71IndicationAgreementScopeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Article71IndicationAgreementScopeConnectionSort = {
  node?: InputMaybe<AgreementScopeSort>;
};

export type Article71IndicationAgreementScopeConnectionWhere = {
  AND?: InputMaybe<Array<Article71IndicationAgreementScopeConnectionWhere>>;
  NOT?: InputMaybe<Article71IndicationAgreementScopeConnectionWhere>;
  OR?: InputMaybe<Array<Article71IndicationAgreementScopeConnectionWhere>>;
  node?: InputMaybe<AgreementScopeWhere>;
};

export type Article71IndicationAgreementScopeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<Article71IndicationAgreementScopeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<Article71IndicationAgreementScopeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<Article71IndicationAgreementScopeNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type Article71IndicationAgreementScopeRelationship = {
  __typename?: 'Article71IndicationAgreementScopeRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementScope;
};

export type Article71IndicationAgreementTemplateAggregateInput = {
  AND?: InputMaybe<Array<Article71IndicationAgreementTemplateAggregateInput>>;
  NOT?: InputMaybe<Article71IndicationAgreementTemplateAggregateInput>;
  OR?: InputMaybe<Array<Article71IndicationAgreementTemplateAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<Article71IndicationAgreementTemplateNodeAggregationWhereInput>;
};

export type Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection = {
  __typename?: 'Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection>;
};

export type Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection = {
  __typename?: 'Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection';
  addedByName: StringAggregateSelectionNullable;
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  treatments: StringAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type Article71IndicationAgreementTemplateConnection = {
  __typename?: 'Article71IndicationAgreementTemplateConnection';
  edges: Array<Article71IndicationAgreementTemplateRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Article71IndicationAgreementTemplateConnectionSort = {
  node?: InputMaybe<AgreementTemplateSort>;
};

export type Article71IndicationAgreementTemplateConnectionWhere = {
  AND?: InputMaybe<Array<Article71IndicationAgreementTemplateConnectionWhere>>;
  NOT?: InputMaybe<Article71IndicationAgreementTemplateConnectionWhere>;
  OR?: InputMaybe<Array<Article71IndicationAgreementTemplateConnectionWhere>>;
  node?: InputMaybe<AgreementTemplateWhere>;
};

export type Article71IndicationAgreementTemplateNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<Article71IndicationAgreementTemplateNodeAggregationWhereInput>>;
  NOT?: InputMaybe<Article71IndicationAgreementTemplateNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<Article71IndicationAgreementTemplateNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type Article71IndicationAgreementTemplateRelationship = {
  __typename?: 'Article71IndicationAgreementTemplateRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type Article71IndicationBrandAggregateInput = {
  AND?: InputMaybe<Array<Article71IndicationBrandAggregateInput>>;
  NOT?: InputMaybe<Article71IndicationBrandAggregateInput>;
  OR?: InputMaybe<Array<Article71IndicationBrandAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<Article71IndicationBrandNodeAggregationWhereInput>;
};

export type Article71IndicationBrandBrandAggregationSelection = {
  __typename?: 'Article71IndicationBrandBrandAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<Article71IndicationBrandBrandNodeAggregateSelection>;
};

export type Article71IndicationBrandBrandNodeAggregateSelection = {
  __typename?: 'Article71IndicationBrandBrandNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type Article71IndicationBrandConnection = {
  __typename?: 'Article71IndicationBrandConnection';
  edges: Array<Article71IndicationBrandRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Article71IndicationBrandConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type Article71IndicationBrandConnectionWhere = {
  AND?: InputMaybe<Array<Article71IndicationBrandConnectionWhere>>;
  NOT?: InputMaybe<Article71IndicationBrandConnectionWhere>;
  OR?: InputMaybe<Array<Article71IndicationBrandConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type Article71IndicationBrandNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<Article71IndicationBrandNodeAggregationWhereInput>>;
  NOT?: InputMaybe<Article71IndicationBrandNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<Article71IndicationBrandNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Article71IndicationBrandRelationship = {
  __typename?: 'Article71IndicationBrandRelationship';
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type Article71IndicationCaseCasesAggregationSelection = {
  __typename?: 'Article71IndicationCaseCasesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<Article71IndicationCaseCasesNodeAggregateSelection>;
};

export type Article71IndicationCaseCasesNodeAggregateSelection = {
  __typename?: 'Article71IndicationCaseCasesNodeAggregateSelection';
  creationDate: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
};

export type Article71IndicationCasesAggregateInput = {
  AND?: InputMaybe<Array<Article71IndicationCasesAggregateInput>>;
  NOT?: InputMaybe<Article71IndicationCasesAggregateInput>;
  OR?: InputMaybe<Array<Article71IndicationCasesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<Article71IndicationCasesNodeAggregationWhereInput>;
};

export type Article71IndicationCasesConnection = {
  __typename?: 'Article71IndicationCasesConnection';
  edges: Array<Article71IndicationCasesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Article71IndicationCasesConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type Article71IndicationCasesConnectionWhere = {
  AND?: InputMaybe<Array<Article71IndicationCasesConnectionWhere>>;
  NOT?: InputMaybe<Article71IndicationCasesConnectionWhere>;
  OR?: InputMaybe<Array<Article71IndicationCasesConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type Article71IndicationCasesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<Article71IndicationCasesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<Article71IndicationCasesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<Article71IndicationCasesNodeAggregationWhereInput>>;
  creationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Article71IndicationCasesRelationship = {
  __typename?: 'Article71IndicationCasesRelationship';
  cursor: Scalars['String']['output'];
  node: Case;
};

export type Article71IndicationEdge = {
  __typename?: 'Article71IndicationEdge';
  cursor: Scalars['String']['output'];
  node: Article71Indication;
};

export type Article71IndicationInput = {
  agreementScopeId?: InputMaybe<Scalars['ID']['input']>;
  agreementTemplateId?: InputMaybe<Scalars['ID']['input']>;
  approvalDate?: InputMaybe<Scalars['Date']['input']>;
  countryScopeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isToBeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  sllAdditionDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Article71IndicationMainIndicationAggregateInput = {
  AND?: InputMaybe<Array<Article71IndicationMainIndicationAggregateInput>>;
  NOT?: InputMaybe<Article71IndicationMainIndicationAggregateInput>;
  OR?: InputMaybe<Array<Article71IndicationMainIndicationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<Article71IndicationMainIndicationNodeAggregationWhereInput>;
};

export type Article71IndicationMainIndicationConnection = {
  __typename?: 'Article71IndicationMainIndicationConnection';
  edges: Array<Article71IndicationMainIndicationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Article71IndicationMainIndicationConnectionSort = {
  node?: InputMaybe<MainIndicationSort>;
};

export type Article71IndicationMainIndicationConnectionWhere = {
  AND?: InputMaybe<Array<Article71IndicationMainIndicationConnectionWhere>>;
  NOT?: InputMaybe<Article71IndicationMainIndicationConnectionWhere>;
  OR?: InputMaybe<Array<Article71IndicationMainIndicationConnectionWhere>>;
  node?: InputMaybe<MainIndicationWhere>;
};

export type Article71IndicationMainIndicationMainIndicationAggregationSelection = {
  __typename?: 'Article71IndicationMainIndicationMainIndicationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<Article71IndicationMainIndicationMainIndicationNodeAggregateSelection>;
};

export type Article71IndicationMainIndicationMainIndicationNodeAggregateSelection = {
  __typename?: 'Article71IndicationMainIndicationMainIndicationNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
};

export type Article71IndicationMainIndicationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<Article71IndicationMainIndicationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<Article71IndicationMainIndicationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<Article71IndicationMainIndicationNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Article71IndicationMainIndicationRelationship = {
  __typename?: 'Article71IndicationMainIndicationRelationship';
  cursor: Scalars['String']['output'];
  node: MainIndication;
};

export type Article71IndicationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more Article71IndicationSort objects to sort Article71Indications by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<Article71IndicationSort>>;
};

/** Fields to sort Article71Indications by. The order in which sorts are applied is not guaranteed when specifying many fields in one Article71IndicationSort object. */
export type Article71IndicationSort = {
  approvalDate?: InputMaybe<SortDirection>;
  countryScopeId?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  notes?: InputMaybe<SortDirection>;
  sllAdditionDate?: InputMaybe<SortDirection>;
};

export type Article71IndicationWhere = {
  AND?: InputMaybe<Array<Article71IndicationWhere>>;
  NOT?: InputMaybe<Article71IndicationWhere>;
  OR?: InputMaybe<Array<Article71IndicationWhere>>;
  agreementScope?: InputMaybe<AgreementScopeWhere>;
  agreementScopeAggregate?: InputMaybe<Article71IndicationAgreementScopeAggregateInput>;
  agreementScopeConnection?: InputMaybe<Article71IndicationAgreementScopeConnectionWhere>;
  agreementScopeConnection_NOT?: InputMaybe<Article71IndicationAgreementScopeConnectionWhere>;
  agreementScope_NOT?: InputMaybe<AgreementScopeWhere>;
  agreementTemplate?: InputMaybe<AgreementTemplateWhere>;
  agreementTemplateAggregate?: InputMaybe<Article71IndicationAgreementTemplateAggregateInput>;
  agreementTemplateConnection?: InputMaybe<Article71IndicationAgreementTemplateConnectionWhere>;
  agreementTemplateConnection_NOT?: InputMaybe<Article71IndicationAgreementTemplateConnectionWhere>;
  agreementTemplate_NOT?: InputMaybe<AgreementTemplateWhere>;
  approvalDate?: InputMaybe<Scalars['Date']['input']>;
  approvalDate_GT?: InputMaybe<Scalars['Date']['input']>;
  approvalDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  approvalDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  approvalDate_LT?: InputMaybe<Scalars['Date']['input']>;
  approvalDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  brand?: InputMaybe<BrandWhere>;
  brandAggregate?: InputMaybe<Article71IndicationBrandAggregateInput>;
  brandConnection?: InputMaybe<Article71IndicationBrandConnectionWhere>;
  brandConnection_NOT?: InputMaybe<Article71IndicationBrandConnectionWhere>;
  brand_NOT?: InputMaybe<BrandWhere>;
  casesAggregate?: InputMaybe<Article71IndicationCasesAggregateInput>;
  /** Return Article71Indications where all of the related Article71IndicationCasesConnections match this filter */
  casesConnection_ALL?: InputMaybe<Article71IndicationCasesConnectionWhere>;
  /** Return Article71Indications where none of the related Article71IndicationCasesConnections match this filter */
  casesConnection_NONE?: InputMaybe<Article71IndicationCasesConnectionWhere>;
  /** Return Article71Indications where one of the related Article71IndicationCasesConnections match this filter */
  casesConnection_SINGLE?: InputMaybe<Article71IndicationCasesConnectionWhere>;
  /** Return Article71Indications where some of the related Article71IndicationCasesConnections match this filter */
  casesConnection_SOME?: InputMaybe<Article71IndicationCasesConnectionWhere>;
  /** Return Article71Indications where all of the related Cases match this filter */
  cases_ALL?: InputMaybe<CaseWhere>;
  /** Return Article71Indications where none of the related Cases match this filter */
  cases_NONE?: InputMaybe<CaseWhere>;
  /** Return Article71Indications where one of the related Cases match this filter */
  cases_SINGLE?: InputMaybe<CaseWhere>;
  /** Return Article71Indications where some of the related Cases match this filter */
  cases_SOME?: InputMaybe<CaseWhere>;
  countryScopeId?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryScopeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  mainIndication?: InputMaybe<MainIndicationWhere>;
  mainIndicationAggregate?: InputMaybe<Article71IndicationMainIndicationAggregateInput>;
  mainIndicationConnection?: InputMaybe<Article71IndicationMainIndicationConnectionWhere>;
  mainIndicationConnection_NOT?: InputMaybe<Article71IndicationMainIndicationConnectionWhere>;
  mainIndication_NOT?: InputMaybe<MainIndicationWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  notes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  notes_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes_MATCHES?: InputMaybe<Scalars['String']['input']>;
  notes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sllAdditionDate?: InputMaybe<Scalars['Date']['input']>;
  sllAdditionDate_GT?: InputMaybe<Scalars['Date']['input']>;
  sllAdditionDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  sllAdditionDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  sllAdditionDate_LT?: InputMaybe<Scalars['Date']['input']>;
  sllAdditionDate_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type Article71IndicationsConnection = {
  __typename?: 'Article71IndicationsConnection';
  edges: Array<Article71IndicationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum Article71Status {
  NotSlReimbursedArt_71B = 'NOT_SL_REIMBURSED_ART_71_B',
  SlReimbursedWithoutPm = 'SL_REIMBURSED_WITHOUT_PM',
  SlReimbursedWithPmOffLabel = 'SL_REIMBURSED_WITH_PM_OFF_LABEL',
  SlReimbursedWithPmOffLimitation = 'SL_REIMBURSED_WITH_PM_OFF_LIMITATION'
}

export enum AssigneeStatus {
  No = 'NO',
  YesAlways = 'YES_ALWAYS',
  YesWhenCreator = 'YES_WHEN_CREATOR'
}

export enum AttributeSize {
  Extralong = 'EXTRALONG',
  Long = 'LONG',
  Medium = 'MEDIUM',
  Short = 'SHORT'
}

export type AuthOrganization = {
  __typename?: 'AuthOrganization';
  emailEncryptionEnabled: Scalars['Boolean']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  publicAgreementsEnabled: Scalars['Boolean']['output'];
  twoFactorEnabled: Scalars['Boolean']['output'];
};

export type AuthOrganizationEdge = {
  __typename?: 'AuthOrganizationEdge';
  cursor: Scalars['String']['output'];
  node: AuthOrganization;
};

export type AuthOrganizationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AuthOrganizationSort objects to sort AuthOrganizations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AuthOrganizationSort>>;
};

/** Fields to sort AuthOrganizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one AuthOrganizationSort object. */
export type AuthOrganizationSort = {
  emailEncryptionEnabled?: InputMaybe<SortDirection>;
  externalId?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  publicAgreementsEnabled?: InputMaybe<SortDirection>;
  twoFactorEnabled?: InputMaybe<SortDirection>;
};

export type AuthOrganizationWhere = {
  AND?: InputMaybe<Array<AuthOrganizationWhere>>;
  NOT?: InputMaybe<AuthOrganizationWhere>;
  OR?: InputMaybe<Array<AuthOrganizationWhere>>;
  emailEncryptionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  externalId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  externalId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  externalId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_GT?: InputMaybe<Scalars['Int']['input']>;
  id_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publicAgreementsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthOrganizationsConnection = {
  __typename?: 'AuthOrganizationsConnection';
  edges: Array<AuthOrganizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AutogenerationTrigger {
  UncoveredClaimQuest = 'UNCOVERED_CLAIM_QUEST'
}

export type AvailableTranslations = {
  __typename?: 'AvailableTranslations';
  de: TranslationsWithChangedKeys;
  en: TranslationsWithChangedKeys;
  platform: Platform;
};

export type AvailableTranslationsConnection = {
  __typename?: 'AvailableTranslationsConnection';
  edges: Array<AvailableTranslationsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AvailableTranslationsEdge = {
  __typename?: 'AvailableTranslationsEdge';
  cursor: Scalars['String']['output'];
  node: AvailableTranslations;
};

export type AvailableTranslationsOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AvailableTranslationsSort objects to sort AvailableTranslations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AvailableTranslationsSort>>;
};

/** Fields to sort AvailableTranslations by. The order in which sorts are applied is not guaranteed when specifying many fields in one AvailableTranslationsSort object. */
export type AvailableTranslationsSort = {
  platform?: InputMaybe<SortDirection>;
};

export type AvailableTranslationsWhere = {
  AND?: InputMaybe<Array<AvailableTranslationsWhere>>;
  NOT?: InputMaybe<AvailableTranslationsWhere>;
  OR?: InputMaybe<Array<AvailableTranslationsWhere>>;
  platform?: InputMaybe<Platform>;
  platform_IN?: InputMaybe<Array<Platform>>;
};

export type AverageGenericPrice = {
  __typename?: 'AverageGenericPrice';
  Price?: Maybe<Scalars['String']['output']>;
  ValidFromDate?: Maybe<Scalars['Date']['output']>;
};

export type AverageGenericPriceEdge = {
  __typename?: 'AverageGenericPriceEdge';
  cursor: Scalars['String']['output'];
  node: AverageGenericPrice;
};

export type AverageGenericPriceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AverageGenericPriceSort objects to sort AverageGenericPrices by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AverageGenericPriceSort>>;
};

/** Fields to sort AverageGenericPrices by. The order in which sorts are applied is not guaranteed when specifying many fields in one AverageGenericPriceSort object. */
export type AverageGenericPriceSort = {
  Price?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
};

export type AverageGenericPriceWhere = {
  AND?: InputMaybe<Array<AverageGenericPriceWhere>>;
  NOT?: InputMaybe<AverageGenericPriceWhere>;
  OR?: InputMaybe<Array<AverageGenericPriceWhere>>;
  Price?: InputMaybe<Scalars['String']['input']>;
  Price_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Price_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Price_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Price_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Price_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type AverageGenericPricesConnection = {
  __typename?: 'AverageGenericPricesConnection';
  edges: Array<AverageGenericPriceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreement = {
  __typename?: 'BaseAgreement';
  addedBy: User;
  addedByAggregate?: Maybe<BaseAgreementUserAddedByAggregationSelection>;
  addedByConnection: BaseAgreementAddedByConnection;
  allowedFormFlexEntityTypes?: Maybe<Array<FlexEntityType>>;
  allowedForms?: Maybe<Array<Scalars['String']['output']>>;
  allowedRecordFlexEntityTypes?: Maybe<Array<FlexEntityType>>;
  allowedRecords?: Maybe<Array<Scalars['String']['output']>>;
  canUserViewFinancials: Scalars['Boolean']['output'];
  caseSuspensionIntervalDays?: Maybe<Scalars['Int']['output']>;
  caselessAgreementDataSnapshot?: Maybe<Scalars['String']['output']>;
  cases: Array<Case>;
  casesAggregate?: Maybe<BaseAgreementCaseCasesAggregationSelection>;
  casesConnection: BaseAgreementCasesConnection;
  counterparties: Array<Organization>;
  counterpartiesAggregate?: Maybe<BaseAgreementOrganizationCounterpartiesAggregationSelection>;
  counterpartiesConnection: BaseAgreementCounterpartiesConnection;
  country: Country;
  countryAggregate?: Maybe<BaseAgreementCountryCountryAggregationSelection>;
  countryConnection: BaseAgreementCountryConnection;
  coveringFormWaitInterval?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['DateTime']['output'];
  currency?: Maybe<Currency>;
  currencyAggregate?: Maybe<BaseAgreementCurrencyCurrencyAggregationSelection>;
  currencyConnection: BaseAgreementCurrencyConnection;
  cycles: Array<CycleConfiguration>;
  cyclesAggregate?: Maybe<BaseAgreementCycleConfigurationCyclesAggregationSelection>;
  cyclesConnection: BaseAgreementCyclesConnection;
  dataContainers: Array<DataContainer>;
  dataContainersAggregate?: Maybe<BaseAgreementDataContainerDataContainersAggregationSelection>;
  dataContainersConnection: BaseAgreementDataContainersConnection;
  dataSource: DataSource;
  dataSourceAggregate?: Maybe<BaseAgreementDataSourceDataSourceAggregationSelection>;
  dataSourceConnection: BaseAgreementDataSourceConnection;
  daysToExpiry?: Maybe<Scalars['Int']['output']>;
  decisions: Array<AgreementDecision>;
  decisionsAggregate?: Maybe<BaseAgreementAgreementDecisionDecisionsAggregationSelection>;
  decisionsConnection: BaseAgreementDecisionsConnection;
  defaultPriceRate?: Maybe<Scalars['Float']['output']>;
  deviceAlternativeSets: Array<DeviceAlternative>;
  deviceAlternativeSetsAggregate?: Maybe<BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection>;
  deviceAlternativeSetsConnection: BaseAgreementDeviceAlternativeSetsConnection;
  dotThresholds?: Maybe<ChartRangeConfiguration>;
  dotThresholdsAggregate?: Maybe<BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection>;
  dotThresholdsConnection: BaseAgreementDotThresholdsConnection;
  eligibilityConditionSets: Array<EligibilityConditionSet>;
  eligibilityConditionSetsAggregate?: Maybe<BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection>;
  eligibilityConditionSetsConnection: BaseAgreementEligibilityConditionSetsConnection;
  eligibilityConditionTreatments?: Maybe<Array<Maybe<Treatment>>>;
  enrollingConditionSets: Array<EnrollingConditionSet>;
  enrollingConditionSetsAggregate?: Maybe<BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection>;
  enrollingConditionSetsConnection: BaseAgreementEnrollingConditionSetsConnection;
  enrollingPeriods: Array<EnrollingPeriod>;
  enrollingPeriodsAggregate?: Maybe<BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection>;
  enrollingPeriodsConnection: BaseAgreementEnrollingPeriodsConnection;
  enrolmentDateType?: Maybe<EnrolmentDateType>;
  expectedDocument: DocumentType;
  financialDataPoints: Array<FlexFinancialDataPoint>;
  financialDataPointsAggregate?: Maybe<BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection>;
  financialDataPointsConnection: BaseAgreementFinancialDataPointsConnection;
  financialSummaryConfig: Array<FinancialSummaryColumn>;
  financialSummaryConfigAggregate?: Maybe<BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection>;
  financialSummaryConfigConnection: BaseAgreementFinancialSummaryConfigConnection;
  firstExecutionDate?: Maybe<Scalars['DateTime']['output']>;
  formattedAmount?: Maybe<Scalars['String']['output']>;
  formattedCounterparties?: Maybe<Scalars['String']['output']>;
  formattedDiseases?: Maybe<Scalars['String']['output']>;
  formattedIndications?: Maybe<Scalars['String']['output']>;
  formattedProducts?: Maybe<Scalars['String']['output']>;
  formattedTags: Scalars['String']['output'];
  formattedValidityPeriod?: Maybe<Scalars['String']['output']>;
  generics: Array<Generic>;
  id: Scalars['ID']['output'];
  initialVersion?: Maybe<BaseAgreement>;
  initialVersionAggregate?: Maybe<BaseAgreementBaseAgreementInitialVersionAggregationSelection>;
  initialVersionConnection: BaseAgreementInitialVersionConnection;
  initialVersionId: Scalars['String']['output'];
  isAllowedFormsEnabled: Scalars['Boolean']['output'];
  isAllowedRecordsEnabled: Scalars['Boolean']['output'];
  isCaseless: Scalars['Boolean']['output'];
  isCoveringIntervalEnabled: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isExtended?: Maybe<Scalars['Boolean']['output']>;
  isFirstVersion: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isInsightsAvailable?: Maybe<Scalars['Boolean']['output']>;
  isLastVersion: Scalars['Boolean']['output'];
  isRequiredFormsEnabled: Scalars['Boolean']['output'];
  isRequiredRecordsEnabled: Scalars['Boolean']['output'];
  isScenariosInSync?: Maybe<Scalars['Boolean']['output']>;
  isScopeSync?: Maybe<Scalars['Boolean']['output']>;
  isValidityPeriodInSync?: Maybe<Scalars['Boolean']['output']>;
  lastExecutionDate?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedOn?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  negotiableAttributes: Array<CatalogueAttribute>;
  negotiableAttributesAggregate?: Maybe<BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection>;
  negotiableAttributesConnection: BaseAgreementNegotiableAttributesConnection;
  nextVersions: Array<BaseAgreement>;
  nextVersionsAggregate?: Maybe<BaseAgreementBaseAgreementNextVersionsAggregationSelection>;
  nextVersionsConnection: BaseAgreementNextVersionsConnection;
  participatingCounterparties: Array<Organization>;
  pushedBy?: Maybe<User>;
  pushedByAggregate?: Maybe<BaseAgreementUserPushedByAggregationSelection>;
  pushedByConnection: BaseAgreementPushedByConnection;
  pushedOn?: Maybe<Scalars['DateTime']['output']>;
  rangeChartConfig?: Maybe<ChartRangeConfiguration>;
  rangeChartConfigAggregate?: Maybe<BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection>;
  rangeChartConfigConnection: BaseAgreementRangeChartConfigConnection;
  reportData?: Maybe<Scalars['String']['output']>;
  requiredFormFlexEntityTypes?: Maybe<Array<FlexEntityType>>;
  requiredForms?: Maybe<Array<Scalars['String']['output']>>;
  requiredRecordFlexEntityTypes?: Maybe<Array<FlexEntityType>>;
  requiredRecords?: Maybe<Array<Scalars['String']['output']>>;
  scenarios: Array<Scenario>;
  scenariosAggregate?: Maybe<BaseAgreementScenarioScenariosAggregationSelection>;
  scenariosConnection: BaseAgreementScenariosConnection;
  scenariosRelevantBrands: Array<Brand>;
  scenariosRelevantBrandsAggregate?: Maybe<BaseAgreementBrandScenariosRelevantBrandsAggregationSelection>;
  scenariosRelevantBrandsConnection: BaseAgreementScenariosRelevantBrandsConnection;
  status: ContractStatus;
  statusTransitions: Array<AgreementStatusTransition>;
  statusTransitionsAggregate?: Maybe<BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection>;
  statusTransitionsConnection: BaseAgreementStatusTransitionsConnection;
  subjectMatter: AgreementSubjectMatter;
  tags: Array<AgreementTag>;
  tagsAggregate?: Maybe<BaseAgreementAgreementTagTagsAggregationSelection>;
  tagsConnection: BaseAgreementTagsConnection;
  template?: Maybe<AgreementTemplate>;
  templateAggregate?: Maybe<BaseAgreementAgreementTemplateTemplateAggregationSelection>;
  templateConnection: BaseAgreementTemplateConnection;
  tenantIds: Array<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  treatmentPrices: Array<Treatment>;
  treatmentPricesAggregate?: Maybe<BaseAgreementTreatmentTreatmentPricesAggregationSelection>;
  treatmentPricesConnection: BaseAgreementTreatmentPricesConnection;
  userContexts: Array<UserContext>;
  userContextsAggregate?: Maybe<BaseAgreementUserContextUserContextsAggregationSelection>;
  userContextsConnection: BaseAgreementUserContextsConnection;
  userOrganizationRole?: Maybe<CounterpartyRole>;
  userRoles: Array<User>;
  userRolesAggregate?: Maybe<BaseAgreementUserUserRolesAggregationSelection>;
  userRolesConnection: BaseAgreementUserRolesConnection;
  validFromDate: Scalars['Date']['output'];
  validToDate?: Maybe<Scalars['Date']['output']>;
  version: Scalars['Int']['output'];
};


export type BaseAgreementAddedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type BaseAgreementAddedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type BaseAgreementAddedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementAddedByConnectionSort>>;
  where?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
};


export type BaseAgreementCasesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type BaseAgreementCasesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type BaseAgreementCasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementCasesConnectionSort>>;
  where?: InputMaybe<BaseAgreementCasesConnectionWhere>;
};


export type BaseAgreementCounterpartiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type BaseAgreementCounterpartiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type BaseAgreementCounterpartiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementCounterpartiesConnectionSort>>;
  where?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
};


export type BaseAgreementCountryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type BaseAgreementCountryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type BaseAgreementCountryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementCountryConnectionSort>>;
  where?: InputMaybe<BaseAgreementCountryConnectionWhere>;
};


export type BaseAgreementCurrencyArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurrencyOptions>;
  where?: InputMaybe<CurrencyWhere>;
};


export type BaseAgreementCurrencyAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CurrencyWhere>;
};


export type BaseAgreementCurrencyConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementCurrencyConnectionSort>>;
  where?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
};


export type BaseAgreementCyclesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CycleConfigurationOptions>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type BaseAgreementCyclesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type BaseAgreementCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementCyclesConnectionSort>>;
  where?: InputMaybe<BaseAgreementCyclesConnectionWhere>;
};


export type BaseAgreementDataContainersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DataContainerOptions>;
  where?: InputMaybe<DataContainerWhere>;
};


export type BaseAgreementDataContainersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DataContainerWhere>;
};


export type BaseAgreementDataContainersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementDataContainersConnectionSort>>;
  where?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
};


export type BaseAgreementDataSourceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DataSourceOptions>;
  where?: InputMaybe<DataSourceWhere>;
};


export type BaseAgreementDataSourceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DataSourceWhere>;
};


export type BaseAgreementDataSourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementDataSourceConnectionSort>>;
  where?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
};


export type BaseAgreementDecisionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementDecisionOptions>;
  where?: InputMaybe<AgreementDecisionWhere>;
};


export type BaseAgreementDecisionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementDecisionWhere>;
};


export type BaseAgreementDecisionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementDecisionsConnectionSort>>;
  where?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
};


export type BaseAgreementDeviceAlternativeSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DeviceAlternativeOptions>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type BaseAgreementDeviceAlternativeSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type BaseAgreementDeviceAlternativeSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsConnectionSort>>;
  where?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
};


export type BaseAgreementDotThresholdsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChartRangeConfigurationOptions>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type BaseAgreementDotThresholdsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type BaseAgreementDotThresholdsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementDotThresholdsConnectionSort>>;
  where?: InputMaybe<BaseAgreementDotThresholdsConnectionWhere>;
};


export type BaseAgreementEligibilityConditionSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EligibilityConditionSetOptions>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type BaseAgreementEligibilityConditionSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type BaseAgreementEligibilityConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsConnectionSort>>;
  where?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
};


export type BaseAgreementEnrollingConditionSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingConditionSetOptions>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type BaseAgreementEnrollingConditionSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type BaseAgreementEnrollingConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsConnectionSort>>;
  where?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
};


export type BaseAgreementEnrollingPeriodsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingPeriodOptions>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type BaseAgreementEnrollingPeriodsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type BaseAgreementEnrollingPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementEnrollingPeriodsConnectionSort>>;
  where?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
};


export type BaseAgreementFinancialDataPointsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type BaseAgreementFinancialDataPointsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type BaseAgreementFinancialDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementFinancialDataPointsConnectionSort>>;
  where?: InputMaybe<BaseAgreementFinancialDataPointsConnectionWhere>;
};


export type BaseAgreementFinancialSummaryConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FinancialSummaryColumnOptions>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type BaseAgreementFinancialSummaryConfigAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type BaseAgreementFinancialSummaryConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigConnectionSort>>;
  where?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
};


export type BaseAgreementInitialVersionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BaseAgreementOptions>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type BaseAgreementInitialVersionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type BaseAgreementInitialVersionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementInitialVersionConnectionSort>>;
  where?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
};


export type BaseAgreementNegotiableAttributesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type BaseAgreementNegotiableAttributesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type BaseAgreementNegotiableAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementNegotiableAttributesConnectionSort>>;
  where?: InputMaybe<BaseAgreementNegotiableAttributesConnectionWhere>;
};


export type BaseAgreementNextVersionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BaseAgreementOptions>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type BaseAgreementNextVersionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type BaseAgreementNextVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementNextVersionsConnectionSort>>;
  where?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
};


export type BaseAgreementPushedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type BaseAgreementPushedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type BaseAgreementPushedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementPushedByConnectionSort>>;
  where?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
};


export type BaseAgreementRangeChartConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChartRangeConfigurationOptions>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type BaseAgreementRangeChartConfigAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type BaseAgreementRangeChartConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementRangeChartConfigConnectionSort>>;
  where?: InputMaybe<BaseAgreementRangeChartConfigConnectionWhere>;
};


export type BaseAgreementScenariosArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioOptions>;
  where?: InputMaybe<ScenarioWhere>;
};


export type BaseAgreementScenariosAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioWhere>;
};


export type BaseAgreementScenariosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementScenariosConnectionSort>>;
  where?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
};


export type BaseAgreementScenariosRelevantBrandsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type BaseAgreementScenariosRelevantBrandsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type BaseAgreementScenariosRelevantBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsConnectionSort>>;
  where?: InputMaybe<BaseAgreementScenariosRelevantBrandsConnectionWhere>;
};


export type BaseAgreementStatusTransitionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementStatusTransitionOptions>;
  where?: InputMaybe<AgreementStatusTransitionWhere>;
};


export type BaseAgreementStatusTransitionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementStatusTransitionWhere>;
};


export type BaseAgreementStatusTransitionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementStatusTransitionsConnectionSort>>;
  where?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
};


export type BaseAgreementTagsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTagOptions>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type BaseAgreementTagsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type BaseAgreementTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementTagsConnectionSort>>;
  where?: InputMaybe<BaseAgreementTagsConnectionWhere>;
};


export type BaseAgreementTemplateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type BaseAgreementTemplateAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type BaseAgreementTemplateConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementTemplateConnectionSort>>;
  where?: InputMaybe<BaseAgreementTemplateConnectionWhere>;
};


export type BaseAgreementTreatmentPricesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type BaseAgreementTreatmentPricesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type BaseAgreementTreatmentPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementTreatmentPricesConnectionSort>>;
  where?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
};


export type BaseAgreementUserContextsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserContextOptions>;
  where?: InputMaybe<UserContextWhere>;
};


export type BaseAgreementUserContextsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserContextWhere>;
};


export type BaseAgreementUserContextsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementUserContextsConnectionSort>>;
  where?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
};


export type BaseAgreementUserRolesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type BaseAgreementUserRolesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type BaseAgreementUserRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementUserRolesConnectionSort>>;
  where?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
};

export type BaseAgreementAddedByAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementAddedByAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementAddedByAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementAddedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementAddedByNodeAggregationWhereInput>;
};

export type BaseAgreementAddedByConnection = {
  __typename?: 'BaseAgreementAddedByConnection';
  edges: Array<BaseAgreementAddedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementAddedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type BaseAgreementAddedByConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementAddedByConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementAddedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type BaseAgreementAddedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementAddedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementAddedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementAddedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementAddedByRelationship = {
  __typename?: 'BaseAgreementAddedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type BaseAgreementAgreementDecisionDecisionsAggregationSelection = {
  __typename?: 'BaseAgreementAgreementDecisionDecisionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection>;
};

export type BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection = {
  __typename?: 'BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
};

export type BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection = {
  __typename?: 'BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection>;
};

export type BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection = {
  __typename?: 'BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
};

export type BaseAgreementAgreementTagTagsAggregationSelection = {
  __typename?: 'BaseAgreementAgreementTagTagsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementAgreementTagTagsNodeAggregateSelection>;
};

export type BaseAgreementAgreementTagTagsNodeAggregateSelection = {
  __typename?: 'BaseAgreementAgreementTagTagsNodeAggregateSelection';
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type BaseAgreementAgreementTemplateTemplateAggregationSelection = {
  __typename?: 'BaseAgreementAgreementTemplateTemplateAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementAgreementTemplateTemplateNodeAggregateSelection>;
};

export type BaseAgreementAgreementTemplateTemplateNodeAggregateSelection = {
  __typename?: 'BaseAgreementAgreementTemplateTemplateNodeAggregateSelection';
  addedByName: StringAggregateSelectionNullable;
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  treatments: StringAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type BaseAgreementBaseAgreementInitialVersionAggregationSelection = {
  __typename?: 'BaseAgreementBaseAgreementInitialVersionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection>;
};

export type BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection = {
  __typename?: 'BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  caselessAgreementDataSnapshot: StringAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type BaseAgreementBaseAgreementNextVersionsAggregationSelection = {
  __typename?: 'BaseAgreementBaseAgreementNextVersionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection>;
};

export type BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection = {
  __typename?: 'BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  caselessAgreementDataSnapshot: StringAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type BaseAgreementBrandScenariosRelevantBrandsAggregationSelection = {
  __typename?: 'BaseAgreementBrandScenariosRelevantBrandsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection>;
};

export type BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection = {
  __typename?: 'BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type BaseAgreementCaseCasesAggregationSelection = {
  __typename?: 'BaseAgreementCaseCasesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementCaseCasesNodeAggregateSelection>;
};

export type BaseAgreementCaseCasesNodeAggregateSelection = {
  __typename?: 'BaseAgreementCaseCasesNodeAggregateSelection';
  creationDate: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
};

export type BaseAgreementCasesAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementCasesAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementCasesAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementCasesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementCasesNodeAggregationWhereInput>;
};

export type BaseAgreementCasesConnection = {
  __typename?: 'BaseAgreementCasesConnection';
  edges: Array<BaseAgreementCasesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementCasesConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type BaseAgreementCasesConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementCasesConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementCasesConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementCasesConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type BaseAgreementCasesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementCasesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementCasesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementCasesNodeAggregationWhereInput>>;
  creationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BaseAgreementCasesRelationship = {
  __typename?: 'BaseAgreementCasesRelationship';
  cursor: Scalars['String']['output'];
  node: Case;
};

export type BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection = {
  __typename?: 'BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection>;
};

export type BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection = {
  __typename?: 'BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection = {
  __typename?: 'BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection>;
};

export type BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection = {
  __typename?: 'BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection';
  threshold: IntAggregateSelectionNonNullable;
};

export type BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection = {
  __typename?: 'BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection>;
};

export type BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection = {
  __typename?: 'BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection';
  from: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  to: IntAggregateSelectionNullable;
};

export type BaseAgreementCounterpartiesAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementCounterpartiesAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementCounterpartiesAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementCounterpartiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementCounterpartiesNodeAggregationWhereInput>;
};

export type BaseAgreementCounterpartiesConnection = {
  __typename?: 'BaseAgreementCounterpartiesConnection';
  edges: Array<BaseAgreementCounterpartiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementCounterpartiesConnectionSort = {
  edge?: InputMaybe<BaseAgreementCounterpartyRelationshipSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type BaseAgreementCounterpartiesConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementCounterpartiesConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementCounterpartiesConnectionWhere>>;
  edge?: InputMaybe<BaseAgreementCounterpartyRelationshipWhere>;
  node?: InputMaybe<OrganizationWhere>;
};

export type BaseAgreementCounterpartiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementCounterpartiesNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<BaseAgreementCounterpartiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementCounterpartiesNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementCounterpartiesRelationship = BaseAgreementCounterpartyRelationship & {
  __typename?: 'BaseAgreementCounterpartiesRelationship';
  cursor: Scalars['String']['output'];
  isApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  node: Organization;
  role: CounterpartyRole;
};

export type BaseAgreementCounterpartyRelationship = {
  isApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  role: CounterpartyRole;
};

export type BaseAgreementCounterpartyRelationshipSort = {
  isApprovalRequired?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type BaseAgreementCounterpartyRelationshipWhere = {
  AND?: InputMaybe<Array<BaseAgreementCounterpartyRelationshipWhere>>;
  NOT?: InputMaybe<BaseAgreementCounterpartyRelationshipWhere>;
  OR?: InputMaybe<Array<BaseAgreementCounterpartyRelationshipWhere>>;
  isApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<CounterpartyRole>;
  role_IN?: InputMaybe<Array<CounterpartyRole>>;
};

export type BaseAgreementCountryAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementCountryAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementCountryAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementCountryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementCountryNodeAggregationWhereInput>;
};

export type BaseAgreementCountryConnection = {
  __typename?: 'BaseAgreementCountryConnection';
  edges: Array<BaseAgreementCountryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementCountryConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type BaseAgreementCountryConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementCountryConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementCountryConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementCountryConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type BaseAgreementCountryCountryAggregationSelection = {
  __typename?: 'BaseAgreementCountryCountryAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementCountryCountryNodeAggregateSelection>;
};

export type BaseAgreementCountryCountryNodeAggregateSelection = {
  __typename?: 'BaseAgreementCountryCountryNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type BaseAgreementCountryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementCountryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementCountryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementCountryNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementCountryRelationship = {
  __typename?: 'BaseAgreementCountryRelationship';
  cursor: Scalars['String']['output'];
  node: Country;
};

export type BaseAgreementCurrencyAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementCurrencyAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementCurrencyAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementCurrencyAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementCurrencyNodeAggregationWhereInput>;
};

export type BaseAgreementCurrencyConnection = {
  __typename?: 'BaseAgreementCurrencyConnection';
  edges: Array<BaseAgreementCurrencyRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementCurrencyConnectionSort = {
  node?: InputMaybe<CurrencySort>;
};

export type BaseAgreementCurrencyConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementCurrencyConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementCurrencyConnectionWhere>>;
  node?: InputMaybe<CurrencyWhere>;
};

export type BaseAgreementCurrencyCurrencyAggregationSelection = {
  __typename?: 'BaseAgreementCurrencyCurrencyAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementCurrencyCurrencyNodeAggregateSelection>;
};

export type BaseAgreementCurrencyCurrencyNodeAggregateSelection = {
  __typename?: 'BaseAgreementCurrencyCurrencyNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNullable;
  symbol: StringAggregateSelectionNullable;
};

export type BaseAgreementCurrencyNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementCurrencyNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<BaseAgreementCurrencyNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<BaseAgreementCurrencyNodeAggregationWhereInput>>;
  symbol_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementCurrencyRelationship = {
  __typename?: 'BaseAgreementCurrencyRelationship';
  cursor: Scalars['String']['output'];
  node: Currency;
};

export type BaseAgreementCycleConfigurationCyclesAggregationSelection = {
  __typename?: 'BaseAgreementCycleConfigurationCyclesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementCycleConfigurationCyclesNodeAggregateSelection>;
};

export type BaseAgreementCycleConfigurationCyclesNodeAggregateSelection = {
  __typename?: 'BaseAgreementCycleConfigurationCyclesNodeAggregateSelection';
  lengthFrom: IntAggregateSelectionNonNullable;
  lengthTo: IntAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
};

export type BaseAgreementCyclesAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementCyclesAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementCyclesAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementCyclesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementCyclesNodeAggregationWhereInput>;
};

export type BaseAgreementCyclesConnection = {
  __typename?: 'BaseAgreementCyclesConnection';
  edges: Array<BaseAgreementCyclesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementCyclesConnectionSort = {
  node?: InputMaybe<CycleConfigurationSort>;
};

export type BaseAgreementCyclesConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementCyclesConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementCyclesConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementCyclesConnectionWhere>>;
  node?: InputMaybe<CycleConfigurationWhere>;
};

export type BaseAgreementCyclesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementCyclesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementCyclesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementCyclesNodeAggregationWhereInput>>;
  lengthFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementCyclesRelationship = {
  __typename?: 'BaseAgreementCyclesRelationship';
  cursor: Scalars['String']['output'];
  node: CycleConfiguration;
};

export type BaseAgreementDataContainerDataContainersAggregationSelection = {
  __typename?: 'BaseAgreementDataContainerDataContainersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementDataContainerDataContainersNodeAggregateSelection>;
};

export type BaseAgreementDataContainerDataContainersNodeAggregateSelection = {
  __typename?: 'BaseAgreementDataContainerDataContainersNodeAggregateSelection';
  subType: StringAggregateSelectionNullable;
  timeframeEnd: IntAggregateSelectionNullable;
  timeframeStart: IntAggregateSelectionNullable;
};

export type BaseAgreementDataContainersAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementDataContainersAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementDataContainersAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementDataContainersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementDataContainersNodeAggregationWhereInput>;
};

export type BaseAgreementDataContainersConnection = {
  __typename?: 'BaseAgreementDataContainersConnection';
  edges: Array<BaseAgreementDataContainersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementDataContainersConnectionSort = {
  node?: InputMaybe<DataContainerSort>;
};

export type BaseAgreementDataContainersConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementDataContainersConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementDataContainersConnectionWhere>>;
  node?: InputMaybe<DataContainerWhere>;
};

export type BaseAgreementDataContainersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementDataContainersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementDataContainersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementDataContainersNodeAggregationWhereInput>>;
  subType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementDataContainersRelationship = {
  __typename?: 'BaseAgreementDataContainersRelationship';
  cursor: Scalars['String']['output'];
  node: DataContainer;
};

export type BaseAgreementDataSourceAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementDataSourceAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementDataSourceAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementDataSourceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementDataSourceNodeAggregationWhereInput>;
};

export type BaseAgreementDataSourceConnection = {
  __typename?: 'BaseAgreementDataSourceConnection';
  edges: Array<BaseAgreementDataSourceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementDataSourceConnectionSort = {
  node?: InputMaybe<DataSourceSort>;
};

export type BaseAgreementDataSourceConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementDataSourceConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementDataSourceConnectionWhere>>;
  node?: InputMaybe<DataSourceWhere>;
};

export type BaseAgreementDataSourceDataSourceAggregationSelection = {
  __typename?: 'BaseAgreementDataSourceDataSourceAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementDataSourceDataSourceNodeAggregateSelection>;
};

export type BaseAgreementDataSourceDataSourceNodeAggregateSelection = {
  __typename?: 'BaseAgreementDataSourceDataSourceNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type BaseAgreementDataSourceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementDataSourceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementDataSourceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementDataSourceNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementDataSourceRelationship = {
  __typename?: 'BaseAgreementDataSourceRelationship';
  cursor: Scalars['String']['output'];
  node: DataSource;
};

export type BaseAgreementDecisionsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementDecisionsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementDecisionsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementDecisionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementDecisionsNodeAggregationWhereInput>;
};

export type BaseAgreementDecisionsConnection = {
  __typename?: 'BaseAgreementDecisionsConnection';
  edges: Array<BaseAgreementDecisionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementDecisionsConnectionSort = {
  node?: InputMaybe<AgreementDecisionSort>;
};

export type BaseAgreementDecisionsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementDecisionsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementDecisionsConnectionWhere>>;
  node?: InputMaybe<AgreementDecisionWhere>;
};

export type BaseAgreementDecisionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementDecisionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementDecisionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementDecisionsNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BaseAgreementDecisionsRelationship = {
  __typename?: 'BaseAgreementDecisionsRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementDecision;
};

export type BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection = {
  __typename?: 'BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection>;
};

export type BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection = {
  __typename?: 'BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
};

export type BaseAgreementDeviceAlternativeSetsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementDeviceAlternativeSetsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput>;
};

export type BaseAgreementDeviceAlternativeSetsConnection = {
  __typename?: 'BaseAgreementDeviceAlternativeSetsConnection';
  edges: Array<BaseAgreementDeviceAlternativeSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementDeviceAlternativeSetsConnectionSort = {
  node?: InputMaybe<DeviceAlternativeSort>;
};

export type BaseAgreementDeviceAlternativeSetsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsConnectionWhere>>;
  node?: InputMaybe<DeviceAlternativeWhere>;
};

export type BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementDeviceAlternativeSetsRelationship = {
  __typename?: 'BaseAgreementDeviceAlternativeSetsRelationship';
  cursor: Scalars['String']['output'];
  node: DeviceAlternative;
};

export type BaseAgreementDotThresholdsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementDotThresholdsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementDotThresholdsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementDotThresholdsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<BaseAgreementDotThresholdsEdgeAggregationWhereInput>;
};

export type BaseAgreementDotThresholdsConnection = {
  __typename?: 'BaseAgreementDotThresholdsConnection';
  edges: Array<BaseAgreementDotThresholdsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementDotThresholdsConnectionSort = {
  edge?: InputMaybe<ThresholdConfigurationRelationshipSort>;
  node?: InputMaybe<ChartRangeConfigurationSort>;
};

export type BaseAgreementDotThresholdsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementDotThresholdsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementDotThresholdsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementDotThresholdsConnectionWhere>>;
  edge?: InputMaybe<ThresholdConfigurationRelationshipWhere>;
  node?: InputMaybe<ChartRangeConfigurationWhere>;
};

export type BaseAgreementDotThresholdsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementDotThresholdsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementDotThresholdsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementDotThresholdsEdgeAggregationWhereInput>>;
  threshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementDotThresholdsRelationship = ThresholdConfigurationRelationship & {
  __typename?: 'BaseAgreementDotThresholdsRelationship';
  cursor: Scalars['String']['output'];
  node: ChartRangeConfiguration;
  threshold: Scalars['Int']['output'];
};

export type BaseAgreementEdge = {
  __typename?: 'BaseAgreementEdge';
  cursor: Scalars['String']['output'];
  node: BaseAgreement;
};

export type BaseAgreementEligibilityConditionRelationship = {
  cycleAdherence?: Maybe<CycleAdherence>;
  days?: Maybe<Scalars['Int']['output']>;
  minimumPercentage?: Maybe<Scalars['Int']['output']>;
  numberOfAdministeredRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  numberOfAdministeredTreatments?: Maybe<Scalars['Int']['output']>;
  numberOfAdministeredTreatmentsOperator?: Maybe<ArithmeticalOperator>;
  previousTestNumber?: Maybe<Scalars['Int']['output']>;
  referenceAdministrationSequenceNumber?: Maybe<Scalars['Int']['output']>;
  referenceTestRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  treatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type BaseAgreementEligibilityConditionRelationshipSort = {
  cycleAdherence?: InputMaybe<SortDirection>;
  days?: InputMaybe<SortDirection>;
  minimumPercentage?: InputMaybe<SortDirection>;
  numberOfAdministeredRangeDays?: InputMaybe<SortDirection>;
  numberOfAdministeredTreatments?: InputMaybe<SortDirection>;
  numberOfAdministeredTreatmentsOperator?: InputMaybe<SortDirection>;
  previousTestNumber?: InputMaybe<SortDirection>;
  referenceAdministrationSequenceNumber?: InputMaybe<SortDirection>;
  referenceTestRangeDays?: InputMaybe<SortDirection>;
  treatments?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type BaseAgreementEligibilityConditionRelationshipWhere = {
  AND?: InputMaybe<Array<BaseAgreementEligibilityConditionRelationshipWhere>>;
  NOT?: InputMaybe<BaseAgreementEligibilityConditionRelationshipWhere>;
  OR?: InputMaybe<Array<BaseAgreementEligibilityConditionRelationshipWhere>>;
  cycleAdherence?: InputMaybe<CycleAdherence>;
  cycleAdherence_IN?: InputMaybe<Array<InputMaybe<CycleAdherence>>>;
  days?: InputMaybe<Scalars['Int']['input']>;
  days_GT?: InputMaybe<Scalars['Int']['input']>;
  days_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  days_LT?: InputMaybe<Scalars['Int']['input']>;
  days_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  minimumPercentage_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredRangeDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfAdministeredRangeDays_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatmentsOperator?: InputMaybe<ArithmeticalOperator>;
  numberOfAdministeredTreatmentsOperator_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  numberOfAdministeredTreatments_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfAdministeredTreatments_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  previousTestNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  referenceAdministrationSequenceNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceTestRangeDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  referenceTestRangeDays_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  treatments_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
  value_GT?: InputMaybe<Scalars['Int']['input']>;
  value_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  value_LT?: InputMaybe<Scalars['Int']['input']>;
  value_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection = {
  __typename?: 'BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection>;
  node?: Maybe<BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection>;
};

export type BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection = {
  __typename?: 'BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection';
  days: IntAggregateSelectionNullable;
  minimumPercentage: IntAggregateSelectionNullable;
  numberOfAdministeredTreatments: IntAggregateSelectionNullable;
  previousTestNumber: IntAggregateSelectionNullable;
  referenceAdministrationSequenceNumber: IntAggregateSelectionNullable;
  value: IntAggregateSelectionNullable;
};

export type BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection = {
  __typename?: 'BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  inputLabel: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
};

export type BaseAgreementEligibilityConditionSetsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementEligibilityConditionSetsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput>;
  node?: InputMaybe<BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput>;
};

export type BaseAgreementEligibilityConditionSetsConnection = {
  __typename?: 'BaseAgreementEligibilityConditionSetsConnection';
  edges: Array<BaseAgreementEligibilityConditionSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementEligibilityConditionSetsConnectionSort = {
  edge?: InputMaybe<BaseAgreementEligibilityConditionRelationshipSort>;
  node?: InputMaybe<EligibilityConditionSetSort>;
};

export type BaseAgreementEligibilityConditionSetsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsConnectionWhere>>;
  edge?: InputMaybe<BaseAgreementEligibilityConditionRelationshipWhere>;
  node?: InputMaybe<EligibilityConditionSetWhere>;
};

export type BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput>>;
  days_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  days_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementEligibilityConditionSetsRelationship = BaseAgreementEligibilityConditionRelationship & {
  __typename?: 'BaseAgreementEligibilityConditionSetsRelationship';
  cursor: Scalars['String']['output'];
  cycleAdherence?: Maybe<CycleAdherence>;
  days?: Maybe<Scalars['Int']['output']>;
  minimumPercentage?: Maybe<Scalars['Int']['output']>;
  node: EligibilityConditionSet;
  numberOfAdministeredRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  numberOfAdministeredTreatments?: Maybe<Scalars['Int']['output']>;
  numberOfAdministeredTreatmentsOperator?: Maybe<ArithmeticalOperator>;
  previousTestNumber?: Maybe<Scalars['Int']['output']>;
  referenceAdministrationSequenceNumber?: Maybe<Scalars['Int']['output']>;
  referenceTestRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  treatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection = {
  __typename?: 'BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection>;
};

export type BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection = {
  __typename?: 'BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
};

export type BaseAgreementEnrollingConditionSetsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementEnrollingConditionSetsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput>;
};

export type BaseAgreementEnrollingConditionSetsConnection = {
  __typename?: 'BaseAgreementEnrollingConditionSetsConnection';
  edges: Array<BaseAgreementEnrollingConditionSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementEnrollingConditionSetsConnectionSort = {
  node?: InputMaybe<EnrollingConditionSetSort>;
};

export type BaseAgreementEnrollingConditionSetsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsConnectionWhere>>;
  node?: InputMaybe<EnrollingConditionSetWhere>;
};

export type BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementEnrollingConditionSetsRelationship = {
  __typename?: 'BaseAgreementEnrollingConditionSetsRelationship';
  cursor: Scalars['String']['output'];
  node: EnrollingConditionSet;
};

export type BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection = {
  __typename?: 'BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection';
  count: Scalars['Int']['output'];
};

export type BaseAgreementEnrollingPeriodsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementEnrollingPeriodsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementEnrollingPeriodsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementEnrollingPeriodsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementEnrollingPeriodsConnection = {
  __typename?: 'BaseAgreementEnrollingPeriodsConnection';
  edges: Array<BaseAgreementEnrollingPeriodsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementEnrollingPeriodsConnectionSort = {
  node?: InputMaybe<EnrollingPeriodSort>;
};

export type BaseAgreementEnrollingPeriodsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementEnrollingPeriodsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementEnrollingPeriodsConnectionWhere>>;
  node?: InputMaybe<EnrollingPeriodWhere>;
};

export type BaseAgreementEnrollingPeriodsRelationship = {
  __typename?: 'BaseAgreementEnrollingPeriodsRelationship';
  cursor: Scalars['String']['output'];
  node: EnrollingPeriod;
};

export type BaseAgreementFinancialDataPointsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementFinancialDataPointsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementFinancialDataPointsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementFinancialDataPointsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementFinancialDataPointsNodeAggregationWhereInput>;
};

export type BaseAgreementFinancialDataPointsConnection = {
  __typename?: 'BaseAgreementFinancialDataPointsConnection';
  edges: Array<BaseAgreementFinancialDataPointsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementFinancialDataPointsConnectionSort = {
  node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type BaseAgreementFinancialDataPointsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementFinancialDataPointsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementFinancialDataPointsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementFinancialDataPointsConnectionWhere>>;
  node?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type BaseAgreementFinancialDataPointsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementFinancialDataPointsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementFinancialDataPointsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementFinancialDataPointsNodeAggregationWhereInput>>;
  basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type BaseAgreementFinancialDataPointsRelationship = {
  __typename?: 'BaseAgreementFinancialDataPointsRelationship';
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
};

export type BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection = {
  __typename?: 'BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection>;
  node?: Maybe<BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection>;
};

export type BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection = {
  __typename?: 'BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection';
  localizationKey: StringAggregateSelectionNullable;
  position: IntAggregateSelectionNullable;
};

export type BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection = {
  __typename?: 'BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
};

export type BaseAgreementFinancialSummaryConfigAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementFinancialSummaryConfigAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput>;
  node?: InputMaybe<BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput>;
};

export type BaseAgreementFinancialSummaryConfigConnection = {
  __typename?: 'BaseAgreementFinancialSummaryConfigConnection';
  edges: Array<BaseAgreementFinancialSummaryConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementFinancialSummaryConfigConnectionSort = {
  edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipSort>;
  node?: InputMaybe<FinancialSummaryColumnSort>;
};

export type BaseAgreementFinancialSummaryConfigConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigConnectionWhere>>;
  edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipWhere>;
  node?: InputMaybe<FinancialSummaryColumnWhere>;
};

export type BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput>>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput>>;
};

export type BaseAgreementFinancialSummaryConfigRelationship = AgreementFinancialSummaryColumnRelationship & {
  __typename?: 'BaseAgreementFinancialSummaryConfigRelationship';
  cursor: Scalars['String']['output'];
  hasHelpMessage?: Maybe<Scalars['Boolean']['output']>;
  isIncluded?: Maybe<Scalars['Boolean']['output']>;
  localizationKey?: Maybe<Scalars['String']['output']>;
  node: FinancialSummaryColumn;
  position?: Maybe<Scalars['Int']['output']>;
};

export type BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection = {
  __typename?: 'BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection>;
};

export type BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection = {
  __typename?: 'BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  currencyCode: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  generatedUuid: IdAggregateSelectionNonNullable;
  netPrices: StringAggregateSelectionNullable;
  payable: FloatAggregateSelectionNonNullable;
  payablePercentage: FloatAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNonNullable;
  refundDeltaNumber: IntAggregateSelectionNonNullable;
  refundable: FloatAggregateSelectionNonNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  scenarioZeroMainNetPrices: StringAggregateSelectionNullable;
  scenarioZeroNetPrices: StringAggregateSelectionNullable;
  scenarioZeroRelevantNetPrices: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
  variable: FloatAggregateSelectionNonNullable;
  variablePercentage: FloatAggregateSelectionNullable;
};

export type BaseAgreementInitialVersionAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementInitialVersionAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementInitialVersionAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementInitialVersionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementInitialVersionNodeAggregationWhereInput>;
};

export type BaseAgreementInitialVersionConnection = {
  __typename?: 'BaseAgreementInitialVersionConnection';
  edges: Array<BaseAgreementInitialVersionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementInitialVersionConnectionSort = {
  node?: InputMaybe<BaseAgreementSort>;
};

export type BaseAgreementInitialVersionConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementInitialVersionConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementInitialVersionConnectionWhere>>;
  node?: InputMaybe<BaseAgreementWhere>;
};

export type BaseAgreementInitialVersionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementInitialVersionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementInitialVersionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementInitialVersionNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementInitialVersionRelationship = {
  __typename?: 'BaseAgreementInitialVersionRelationship';
  cursor: Scalars['String']['output'];
  node: BaseAgreement;
};

export type BaseAgreementNegotiableAttributesAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementNegotiableAttributesAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementNegotiableAttributesAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementNegotiableAttributesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementNegotiableAttributesNodeAggregationWhereInput>;
};

export type BaseAgreementNegotiableAttributesConnection = {
  __typename?: 'BaseAgreementNegotiableAttributesConnection';
  edges: Array<BaseAgreementNegotiableAttributesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementNegotiableAttributesConnectionSort = {
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type BaseAgreementNegotiableAttributesConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementNegotiableAttributesConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementNegotiableAttributesConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementNegotiableAttributesConnectionWhere>>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type BaseAgreementNegotiableAttributesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementNegotiableAttributesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementNegotiableAttributesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementNegotiableAttributesNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementNegotiableAttributesRelationship = {
  __typename?: 'BaseAgreementNegotiableAttributesRelationship';
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
};

export type BaseAgreementNextVersionsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementNextVersionsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementNextVersionsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementNextVersionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementNextVersionsNodeAggregationWhereInput>;
};

export type BaseAgreementNextVersionsConnection = {
  __typename?: 'BaseAgreementNextVersionsConnection';
  edges: Array<BaseAgreementNextVersionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementNextVersionsConnectionSort = {
  node?: InputMaybe<BaseAgreementSort>;
};

export type BaseAgreementNextVersionsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementNextVersionsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementNextVersionsConnectionWhere>>;
  node?: InputMaybe<BaseAgreementWhere>;
};

export type BaseAgreementNextVersionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementNextVersionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementNextVersionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementNextVersionsNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementNextVersionsRelationship = {
  __typename?: 'BaseAgreementNextVersionsRelationship';
  cursor: Scalars['String']['output'];
  node: BaseAgreement;
};

export type BaseAgreementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more BaseAgreementSort objects to sort BaseAgreements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<BaseAgreementSort>>;
};

export type BaseAgreementOrganizationCounterpartiesAggregationSelection = {
  __typename?: 'BaseAgreementOrganizationCounterpartiesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementOrganizationCounterpartiesNodeAggregateSelection>;
};

export type BaseAgreementOrganizationCounterpartiesNodeAggregateSelection = {
  __typename?: 'BaseAgreementOrganizationCounterpartiesNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type BaseAgreementPushedByAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementPushedByAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementPushedByAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementPushedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementPushedByNodeAggregationWhereInput>;
};

export type BaseAgreementPushedByConnection = {
  __typename?: 'BaseAgreementPushedByConnection';
  edges: Array<BaseAgreementPushedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementPushedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type BaseAgreementPushedByConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementPushedByConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementPushedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type BaseAgreementPushedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementPushedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementPushedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementPushedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementPushedByRelationship = {
  __typename?: 'BaseAgreementPushedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type BaseAgreementRangeChartConfigAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementRangeChartConfigAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementRangeChartConfigAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementRangeChartConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<BaseAgreementRangeChartConfigEdgeAggregationWhereInput>;
};

export type BaseAgreementRangeChartConfigConnection = {
  __typename?: 'BaseAgreementRangeChartConfigConnection';
  edges: Array<BaseAgreementRangeChartConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementRangeChartConfigConnectionSort = {
  edge?: InputMaybe<ChartRangeConfigurationRelationshipSort>;
  node?: InputMaybe<ChartRangeConfigurationSort>;
};

export type BaseAgreementRangeChartConfigConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementRangeChartConfigConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementRangeChartConfigConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementRangeChartConfigConnectionWhere>>;
  edge?: InputMaybe<ChartRangeConfigurationRelationshipWhere>;
  node?: InputMaybe<ChartRangeConfigurationWhere>;
};

export type BaseAgreementRangeChartConfigEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementRangeChartConfigEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementRangeChartConfigEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementRangeChartConfigEdgeAggregationWhereInput>>;
  from_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  from_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  to_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementRangeChartConfigRelationship = ChartRangeConfigurationRelationship & {
  __typename?: 'BaseAgreementRangeChartConfigRelationship';
  cursor: Scalars['String']['output'];
  from: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  node: ChartRangeConfiguration;
  order: Scalars['Int']['output'];
  to?: Maybe<Scalars['Int']['output']>;
};

export type BaseAgreementScenarioScenariosAggregationSelection = {
  __typename?: 'BaseAgreementScenarioScenariosAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementScenarioScenariosNodeAggregateSelection>;
};

export type BaseAgreementScenarioScenariosNodeAggregateSelection = {
  __typename?: 'BaseAgreementScenarioScenariosNodeAggregateSelection';
  group: IntAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
};

export type BaseAgreementScenariosAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementScenariosAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementScenariosAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementScenariosAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementScenariosNodeAggregationWhereInput>;
};

export type BaseAgreementScenariosConnection = {
  __typename?: 'BaseAgreementScenariosConnection';
  edges: Array<BaseAgreementScenariosRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementScenariosConnectionSort = {
  node?: InputMaybe<ScenarioSort>;
};

export type BaseAgreementScenariosConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementScenariosConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementScenariosConnectionWhere>>;
  node?: InputMaybe<ScenarioWhere>;
};

export type BaseAgreementScenariosNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementScenariosNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementScenariosNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementScenariosNodeAggregationWhereInput>>;
  group_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  group_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementScenariosRelationship = {
  __typename?: 'BaseAgreementScenariosRelationship';
  cursor: Scalars['String']['output'];
  node: Scenario;
};

export type BaseAgreementScenariosRelevantBrandsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementScenariosRelevantBrandsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput>;
};

export type BaseAgreementScenariosRelevantBrandsConnection = {
  __typename?: 'BaseAgreementScenariosRelevantBrandsConnection';
  edges: Array<BaseAgreementScenariosRelevantBrandsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementScenariosRelevantBrandsConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type BaseAgreementScenariosRelevantBrandsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementScenariosRelevantBrandsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BaseAgreementScenariosRelevantBrandsRelationship = {
  __typename?: 'BaseAgreementScenariosRelevantBrandsRelationship';
  cursor: Scalars['String']['output'];
  node: Brand;
};

/** Fields to sort BaseAgreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one BaseAgreementSort object. */
export type BaseAgreementSort = {
  canUserViewFinancials?: InputMaybe<SortDirection>;
  caseSuspensionIntervalDays?: InputMaybe<SortDirection>;
  caselessAgreementDataSnapshot?: InputMaybe<SortDirection>;
  coveringFormWaitInterval?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  daysToExpiry?: InputMaybe<SortDirection>;
  defaultPriceRate?: InputMaybe<SortDirection>;
  enrolmentDateType?: InputMaybe<SortDirection>;
  expectedDocument?: InputMaybe<SortDirection>;
  firstExecutionDate?: InputMaybe<SortDirection>;
  formattedAmount?: InputMaybe<SortDirection>;
  formattedCounterparties?: InputMaybe<SortDirection>;
  formattedDiseases?: InputMaybe<SortDirection>;
  formattedIndications?: InputMaybe<SortDirection>;
  formattedProducts?: InputMaybe<SortDirection>;
  formattedTags?: InputMaybe<SortDirection>;
  formattedValidityPeriod?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  initialVersionId?: InputMaybe<SortDirection>;
  isAllowedFormsEnabled?: InputMaybe<SortDirection>;
  isAllowedRecordsEnabled?: InputMaybe<SortDirection>;
  isCaseless?: InputMaybe<SortDirection>;
  isCoveringIntervalEnabled?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isExtended?: InputMaybe<SortDirection>;
  isFirstVersion?: InputMaybe<SortDirection>;
  isHidden?: InputMaybe<SortDirection>;
  isInsightsAvailable?: InputMaybe<SortDirection>;
  isLastVersion?: InputMaybe<SortDirection>;
  isRequiredFormsEnabled?: InputMaybe<SortDirection>;
  isRequiredRecordsEnabled?: InputMaybe<SortDirection>;
  isScenariosInSync?: InputMaybe<SortDirection>;
  isScopeSync?: InputMaybe<SortDirection>;
  isValidityPeriodInSync?: InputMaybe<SortDirection>;
  lastExecutionDate?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  pushedOn?: InputMaybe<SortDirection>;
  reportData?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  subjectMatter?: InputMaybe<SortDirection>;
  totalAmount?: InputMaybe<SortDirection>;
  userOrganizationRole?: InputMaybe<SortDirection>;
  validFromDate?: InputMaybe<SortDirection>;
  validToDate?: InputMaybe<SortDirection>;
  version?: InputMaybe<SortDirection>;
};

export type BaseAgreementStatusTransitionsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementStatusTransitionsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementStatusTransitionsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementStatusTransitionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementStatusTransitionsNodeAggregationWhereInput>;
};

export type BaseAgreementStatusTransitionsConnection = {
  __typename?: 'BaseAgreementStatusTransitionsConnection';
  edges: Array<BaseAgreementStatusTransitionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementStatusTransitionsConnectionSort = {
  node?: InputMaybe<AgreementStatusTransitionSort>;
};

export type BaseAgreementStatusTransitionsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementStatusTransitionsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementStatusTransitionsConnectionWhere>>;
  node?: InputMaybe<AgreementStatusTransitionWhere>;
};

export type BaseAgreementStatusTransitionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementStatusTransitionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementStatusTransitionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementStatusTransitionsNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BaseAgreementStatusTransitionsRelationship = {
  __typename?: 'BaseAgreementStatusTransitionsRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementStatusTransition;
};

export type BaseAgreementTagsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementTagsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementTagsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementTagsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementTagsNodeAggregationWhereInput>;
};

export type BaseAgreementTagsConnection = {
  __typename?: 'BaseAgreementTagsConnection';
  edges: Array<BaseAgreementTagsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementTagsConnectionSort = {
  node?: InputMaybe<AgreementTagSort>;
};

export type BaseAgreementTagsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementTagsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementTagsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementTagsConnectionWhere>>;
  node?: InputMaybe<AgreementTagWhere>;
};

export type BaseAgreementTagsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementTagsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementTagsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementTagsNodeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementTagsRelationship = {
  __typename?: 'BaseAgreementTagsRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementTag;
};

export type BaseAgreementTemplateAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementTemplateAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementTemplateAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementTemplateAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementTemplateNodeAggregationWhereInput>;
};

export type BaseAgreementTemplateConnection = {
  __typename?: 'BaseAgreementTemplateConnection';
  edges: Array<BaseAgreementTemplateRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementTemplateConnectionSort = {
  node?: InputMaybe<AgreementTemplateSort>;
};

export type BaseAgreementTemplateConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementTemplateConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementTemplateConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementTemplateConnectionWhere>>;
  node?: InputMaybe<AgreementTemplateWhere>;
};

export type BaseAgreementTemplateNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementTemplateNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementTemplateNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementTemplateNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementTemplateRelationship = {
  __typename?: 'BaseAgreementTemplateRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type BaseAgreementTreatmentPriceRelationship = {
  basePriceType?: Maybe<PriceType>;
  price: Scalars['Float']['output'];
};

export type BaseAgreementTreatmentPriceRelationshipSort = {
  basePriceType?: InputMaybe<SortDirection>;
  price?: InputMaybe<SortDirection>;
};

export type BaseAgreementTreatmentPriceRelationshipWhere = {
  AND?: InputMaybe<Array<BaseAgreementTreatmentPriceRelationshipWhere>>;
  NOT?: InputMaybe<BaseAgreementTreatmentPriceRelationshipWhere>;
  OR?: InputMaybe<Array<BaseAgreementTreatmentPriceRelationshipWhere>>;
  basePriceType?: InputMaybe<PriceType>;
  basePriceType_IN?: InputMaybe<Array<InputMaybe<PriceType>>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  price_GT?: InputMaybe<Scalars['Float']['input']>;
  price_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  price_LT?: InputMaybe<Scalars['Float']['input']>;
  price_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type BaseAgreementTreatmentPricesAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementTreatmentPricesAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementTreatmentPricesAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementTreatmentPricesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<BaseAgreementTreatmentPricesEdgeAggregationWhereInput>;
  node?: InputMaybe<BaseAgreementTreatmentPricesNodeAggregationWhereInput>;
};

export type BaseAgreementTreatmentPricesConnection = {
  __typename?: 'BaseAgreementTreatmentPricesConnection';
  edges: Array<BaseAgreementTreatmentPricesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementTreatmentPricesConnectionSort = {
  edge?: InputMaybe<BaseAgreementTreatmentPriceRelationshipSort>;
  node?: InputMaybe<TreatmentSort>;
};

export type BaseAgreementTreatmentPricesConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementTreatmentPricesConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementTreatmentPricesConnectionWhere>>;
  edge?: InputMaybe<BaseAgreementTreatmentPriceRelationshipWhere>;
  node?: InputMaybe<TreatmentWhere>;
};

export type BaseAgreementTreatmentPricesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementTreatmentPricesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementTreatmentPricesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementTreatmentPricesEdgeAggregationWhereInput>>;
  price_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type BaseAgreementTreatmentPricesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementTreatmentPricesNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<BaseAgreementTreatmentPricesNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<BaseAgreementTreatmentPricesNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementTreatmentPricesRelationship = BaseAgreementTreatmentPriceRelationship & {
  __typename?: 'BaseAgreementTreatmentPricesRelationship';
  basePriceType?: Maybe<PriceType>;
  cursor: Scalars['String']['output'];
  node: Treatment;
  price: Scalars['Float']['output'];
};

export type BaseAgreementTreatmentTreatmentPricesAggregationSelection = {
  __typename?: 'BaseAgreementTreatmentTreatmentPricesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection>;
  node?: Maybe<BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection>;
};

export type BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection = {
  __typename?: 'BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection';
  price: FloatAggregateSelectionNonNullable;
};

export type BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection = {
  __typename?: 'BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type BaseAgreementUserAddedByAggregationSelection = {
  __typename?: 'BaseAgreementUserAddedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementUserAddedByNodeAggregateSelection>;
};

export type BaseAgreementUserAddedByNodeAggregateSelection = {
  __typename?: 'BaseAgreementUserAddedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type BaseAgreementUserContextUserContextsAggregationSelection = {
  __typename?: 'BaseAgreementUserContextUserContextsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<BaseAgreementUserContextUserContextsEdgeAggregateSelection>;
  node?: Maybe<BaseAgreementUserContextUserContextsNodeAggregateSelection>;
};

export type BaseAgreementUserContextUserContextsEdgeAggregateSelection = {
  __typename?: 'BaseAgreementUserContextUserContextsEdgeAggregateSelection';
  categoryInput: StringAggregateSelectionNullable;
  rebateObjective: StringAggregateSelectionNullable;
  timeframeLabel: StringAggregateSelectionNonNullable;
};

export type BaseAgreementUserContextUserContextsNodeAggregateSelection = {
  __typename?: 'BaseAgreementUserContextUserContextsNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  filtersAgreements: StringAggregateSelectionNullable;
  filtersCustomConditions: StringAggregateSelectionNullable;
  filtersModels: StringAggregateSelectionNullable;
};

export type BaseAgreementUserContextsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementUserContextsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementUserContextsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementUserContextsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<BaseAgreementUserContextsEdgeAggregationWhereInput>;
  node?: InputMaybe<BaseAgreementUserContextsNodeAggregationWhereInput>;
};

export type BaseAgreementUserContextsConnection = {
  __typename?: 'BaseAgreementUserContextsConnection';
  edges: Array<BaseAgreementUserContextsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementUserContextsConnectionSort = {
  edge?: InputMaybe<ScenarioInsightsUserContextSort>;
  node?: InputMaybe<UserContextSort>;
};

export type BaseAgreementUserContextsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementUserContextsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementUserContextsConnectionWhere>>;
  edge?: InputMaybe<ScenarioInsightsUserContextWhere>;
  node?: InputMaybe<UserContextWhere>;
};

export type BaseAgreementUserContextsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementUserContextsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementUserContextsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementUserContextsEdgeAggregationWhereInput>>;
  categoryInput_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementUserContextsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementUserContextsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementUserContextsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementUserContextsNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersCustomConditions_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersCustomConditions_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersCustomConditions_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersCustomConditions_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersCustomConditions_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersCustomConditions_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersCustomConditions_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersCustomConditions_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersCustomConditions_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersCustomConditions_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersCustomConditions_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersCustomConditions_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersCustomConditions_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersCustomConditions_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersCustomConditions_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersModels_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersModels_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersModels_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersModels_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersModels_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersModels_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersModels_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersModels_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersModels_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersModels_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersModels_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersModels_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersModels_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersModels_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersModels_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementUserContextsRelationship = ScenarioInsightsUserContext & {
  __typename?: 'BaseAgreementUserContextsRelationship';
  categoryInput?: Maybe<Scalars['String']['output']>;
  cursor: Scalars['String']['output'];
  groups?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  node: UserContext;
  rebateObjective?: Maybe<Scalars['String']['output']>;
  timeframeLabel: Scalars['String']['output'];
};

export type BaseAgreementUserPushedByAggregationSelection = {
  __typename?: 'BaseAgreementUserPushedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementUserPushedByNodeAggregateSelection>;
};

export type BaseAgreementUserPushedByNodeAggregateSelection = {
  __typename?: 'BaseAgreementUserPushedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type BaseAgreementUserRoleRelationship = {
  canApprove: Scalars['Boolean']['output'];
  canModifyFinancials: Scalars['Boolean']['output'];
  canViewFinancials: Scalars['Boolean']['output'];
  isAssignee?: Maybe<Scalars['Boolean']['output']>;
  role: AgreementUserRole;
};

export type BaseAgreementUserRoleRelationshipSort = {
  canApprove?: InputMaybe<SortDirection>;
  canModifyFinancials?: InputMaybe<SortDirection>;
  canViewFinancials?: InputMaybe<SortDirection>;
  isAssignee?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type BaseAgreementUserRoleRelationshipWhere = {
  AND?: InputMaybe<Array<BaseAgreementUserRoleRelationshipWhere>>;
  NOT?: InputMaybe<BaseAgreementUserRoleRelationshipWhere>;
  OR?: InputMaybe<Array<BaseAgreementUserRoleRelationshipWhere>>;
  canApprove?: InputMaybe<Scalars['Boolean']['input']>;
  canModifyFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  canViewFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  isAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<AgreementUserRole>;
  role_IN?: InputMaybe<Array<AgreementUserRole>>;
};

export type BaseAgreementUserRolesAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementUserRolesAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementUserRolesAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementUserRolesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementUserRolesNodeAggregationWhereInput>;
};

export type BaseAgreementUserRolesConnection = {
  __typename?: 'BaseAgreementUserRolesConnection';
  edges: Array<BaseAgreementUserRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementUserRolesConnectionSort = {
  edge?: InputMaybe<BaseAgreementUserRoleRelationshipSort>;
  node?: InputMaybe<UserSort>;
};

export type BaseAgreementUserRolesConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementUserRolesConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementUserRolesConnectionWhere>>;
  edge?: InputMaybe<BaseAgreementUserRoleRelationshipWhere>;
  node?: InputMaybe<UserWhere>;
};

export type BaseAgreementUserRolesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementUserRolesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementUserRolesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementUserRolesNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementUserRolesRelationship = BaseAgreementUserRoleRelationship & {
  __typename?: 'BaseAgreementUserRolesRelationship';
  canApprove: Scalars['Boolean']['output'];
  canModifyFinancials: Scalars['Boolean']['output'];
  canViewFinancials: Scalars['Boolean']['output'];
  cursor: Scalars['String']['output'];
  isAssignee?: Maybe<Scalars['Boolean']['output']>;
  node: User;
  role: AgreementUserRole;
};

export type BaseAgreementUserUserRolesAggregationSelection = {
  __typename?: 'BaseAgreementUserUserRolesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementUserUserRolesNodeAggregateSelection>;
};

export type BaseAgreementUserUserRolesNodeAggregateSelection = {
  __typename?: 'BaseAgreementUserUserRolesNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type BaseAgreementWhere = {
  AND?: InputMaybe<Array<BaseAgreementWhere>>;
  NOT?: InputMaybe<BaseAgreementWhere>;
  OR?: InputMaybe<Array<BaseAgreementWhere>>;
  addedBy?: InputMaybe<UserWhere>;
  addedByAggregate?: InputMaybe<BaseAgreementAddedByAggregateInput>;
  addedByConnection?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
  addedByConnection_NOT?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
  addedBy_NOT?: InputMaybe<UserWhere>;
  allowedForms?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedForms_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  allowedRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedRecords_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  caseSuspensionIntervalDays?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  caseSuspensionIntervalDays_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot?: InputMaybe<Scalars['String']['input']>;
  caselessAgreementDataSnapshot_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  caselessAgreementDataSnapshot_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  caselessAgreementDataSnapshot_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caselessAgreementDataSnapshot_MATCHES?: InputMaybe<Scalars['String']['input']>;
  caselessAgreementDataSnapshot_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  casesAggregate?: InputMaybe<BaseAgreementCasesAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementCasesConnections match this filter */
  casesConnection_ALL?: InputMaybe<BaseAgreementCasesConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementCasesConnections match this filter */
  casesConnection_NONE?: InputMaybe<BaseAgreementCasesConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementCasesConnections match this filter */
  casesConnection_SINGLE?: InputMaybe<BaseAgreementCasesConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementCasesConnections match this filter */
  casesConnection_SOME?: InputMaybe<BaseAgreementCasesConnectionWhere>;
  /** Return BaseAgreements where all of the related Cases match this filter */
  cases_ALL?: InputMaybe<CaseWhere>;
  /** Return BaseAgreements where none of the related Cases match this filter */
  cases_NONE?: InputMaybe<CaseWhere>;
  /** Return BaseAgreements where one of the related Cases match this filter */
  cases_SINGLE?: InputMaybe<CaseWhere>;
  /** Return BaseAgreements where some of the related Cases match this filter */
  cases_SOME?: InputMaybe<CaseWhere>;
  counterpartiesAggregate?: InputMaybe<BaseAgreementCounterpartiesAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementCounterpartiesConnections match this filter */
  counterpartiesConnection_ALL?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementCounterpartiesConnections match this filter */
  counterpartiesConnection_NONE?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementCounterpartiesConnections match this filter */
  counterpartiesConnection_SINGLE?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementCounterpartiesConnections match this filter */
  counterpartiesConnection_SOME?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
  /** Return BaseAgreements where all of the related Organizations match this filter */
  counterparties_ALL?: InputMaybe<OrganizationWhere>;
  /** Return BaseAgreements where none of the related Organizations match this filter */
  counterparties_NONE?: InputMaybe<OrganizationWhere>;
  /** Return BaseAgreements where one of the related Organizations match this filter */
  counterparties_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return BaseAgreements where some of the related Organizations match this filter */
  counterparties_SOME?: InputMaybe<OrganizationWhere>;
  country?: InputMaybe<CountryWhere>;
  countryAggregate?: InputMaybe<BaseAgreementCountryAggregateInput>;
  countryConnection?: InputMaybe<BaseAgreementCountryConnectionWhere>;
  countryConnection_NOT?: InputMaybe<BaseAgreementCountryConnectionWhere>;
  country_NOT?: InputMaybe<CountryWhere>;
  coveringFormWaitInterval?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  coveringFormWaitInterval_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<CurrencyWhere>;
  currencyAggregate?: InputMaybe<BaseAgreementCurrencyAggregateInput>;
  currencyConnection?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
  currencyConnection_NOT?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
  currency_NOT?: InputMaybe<CurrencyWhere>;
  cyclesAggregate?: InputMaybe<BaseAgreementCyclesAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementCyclesConnections match this filter */
  cyclesConnection_ALL?: InputMaybe<BaseAgreementCyclesConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementCyclesConnections match this filter */
  cyclesConnection_NONE?: InputMaybe<BaseAgreementCyclesConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementCyclesConnections match this filter */
  cyclesConnection_SINGLE?: InputMaybe<BaseAgreementCyclesConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementCyclesConnections match this filter */
  cyclesConnection_SOME?: InputMaybe<BaseAgreementCyclesConnectionWhere>;
  /** Return BaseAgreements where all of the related CycleConfigurations match this filter */
  cycles_ALL?: InputMaybe<CycleConfigurationWhere>;
  /** Return BaseAgreements where none of the related CycleConfigurations match this filter */
  cycles_NONE?: InputMaybe<CycleConfigurationWhere>;
  /** Return BaseAgreements where one of the related CycleConfigurations match this filter */
  cycles_SINGLE?: InputMaybe<CycleConfigurationWhere>;
  /** Return BaseAgreements where some of the related CycleConfigurations match this filter */
  cycles_SOME?: InputMaybe<CycleConfigurationWhere>;
  dataContainersAggregate?: InputMaybe<BaseAgreementDataContainersAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementDataContainersConnections match this filter */
  dataContainersConnection_ALL?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementDataContainersConnections match this filter */
  dataContainersConnection_NONE?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementDataContainersConnections match this filter */
  dataContainersConnection_SINGLE?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementDataContainersConnections match this filter */
  dataContainersConnection_SOME?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
  /** Return BaseAgreements where all of the related DataContainers match this filter */
  dataContainers_ALL?: InputMaybe<DataContainerWhere>;
  /** Return BaseAgreements where none of the related DataContainers match this filter */
  dataContainers_NONE?: InputMaybe<DataContainerWhere>;
  /** Return BaseAgreements where one of the related DataContainers match this filter */
  dataContainers_SINGLE?: InputMaybe<DataContainerWhere>;
  /** Return BaseAgreements where some of the related DataContainers match this filter */
  dataContainers_SOME?: InputMaybe<DataContainerWhere>;
  dataSource?: InputMaybe<DataSourceWhere>;
  dataSourceAggregate?: InputMaybe<BaseAgreementDataSourceAggregateInput>;
  dataSourceConnection?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
  dataSourceConnection_NOT?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
  dataSource_NOT?: InputMaybe<DataSourceWhere>;
  daysToExpiry?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  daysToExpiry_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_LTE?: InputMaybe<Scalars['Int']['input']>;
  decisionsAggregate?: InputMaybe<BaseAgreementDecisionsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementDecisionsConnections match this filter */
  decisionsConnection_ALL?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementDecisionsConnections match this filter */
  decisionsConnection_NONE?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementDecisionsConnections match this filter */
  decisionsConnection_SINGLE?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementDecisionsConnections match this filter */
  decisionsConnection_SOME?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
  /** Return BaseAgreements where all of the related AgreementDecisions match this filter */
  decisions_ALL?: InputMaybe<AgreementDecisionWhere>;
  /** Return BaseAgreements where none of the related AgreementDecisions match this filter */
  decisions_NONE?: InputMaybe<AgreementDecisionWhere>;
  /** Return BaseAgreements where one of the related AgreementDecisions match this filter */
  decisions_SINGLE?: InputMaybe<AgreementDecisionWhere>;
  /** Return BaseAgreements where some of the related AgreementDecisions match this filter */
  decisions_SOME?: InputMaybe<AgreementDecisionWhere>;
  defaultPriceRate?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  defaultPriceRate_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_LTE?: InputMaybe<Scalars['Float']['input']>;
  deviceAlternativeSetsAggregate?: InputMaybe<BaseAgreementDeviceAlternativeSetsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_ALL?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_NONE?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_SINGLE?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_SOME?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return BaseAgreements where all of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_ALL?: InputMaybe<DeviceAlternativeWhere>;
  /** Return BaseAgreements where none of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_NONE?: InputMaybe<DeviceAlternativeWhere>;
  /** Return BaseAgreements where one of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_SINGLE?: InputMaybe<DeviceAlternativeWhere>;
  /** Return BaseAgreements where some of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_SOME?: InputMaybe<DeviceAlternativeWhere>;
  dotThresholds?: InputMaybe<ChartRangeConfigurationWhere>;
  dotThresholdsAggregate?: InputMaybe<BaseAgreementDotThresholdsAggregateInput>;
  dotThresholdsConnection?: InputMaybe<BaseAgreementDotThresholdsConnectionWhere>;
  dotThresholdsConnection_NOT?: InputMaybe<BaseAgreementDotThresholdsConnectionWhere>;
  dotThresholds_NOT?: InputMaybe<ChartRangeConfigurationWhere>;
  eligibilityConditionSetsAggregate?: InputMaybe<BaseAgreementEligibilityConditionSetsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_ALL?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_NONE?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_SINGLE?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_SOME?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
  /** Return BaseAgreements where all of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_ALL?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return BaseAgreements where none of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_NONE?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return BaseAgreements where one of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_SINGLE?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return BaseAgreements where some of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_SOME?: InputMaybe<EligibilityConditionSetWhere>;
  enrollingConditionSetsAggregate?: InputMaybe<BaseAgreementEnrollingConditionSetsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_ALL?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_NONE?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SINGLE?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SOME?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
  /** Return BaseAgreements where all of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_ALL?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return BaseAgreements where none of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_NONE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return BaseAgreements where one of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SINGLE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return BaseAgreements where some of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SOME?: InputMaybe<EnrollingConditionSetWhere>;
  enrollingPeriodsAggregate?: InputMaybe<BaseAgreementEnrollingPeriodsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_ALL?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_NONE?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_SINGLE?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_SOME?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
  /** Return BaseAgreements where all of the related EnrollingPeriods match this filter */
  enrollingPeriods_ALL?: InputMaybe<EnrollingPeriodWhere>;
  /** Return BaseAgreements where none of the related EnrollingPeriods match this filter */
  enrollingPeriods_NONE?: InputMaybe<EnrollingPeriodWhere>;
  /** Return BaseAgreements where one of the related EnrollingPeriods match this filter */
  enrollingPeriods_SINGLE?: InputMaybe<EnrollingPeriodWhere>;
  /** Return BaseAgreements where some of the related EnrollingPeriods match this filter */
  enrollingPeriods_SOME?: InputMaybe<EnrollingPeriodWhere>;
  enrolmentDateType?: InputMaybe<EnrolmentDateType>;
  enrolmentDateType_IN?: InputMaybe<Array<InputMaybe<EnrolmentDateType>>>;
  expectedDocument?: InputMaybe<DocumentType>;
  expectedDocument_IN?: InputMaybe<Array<DocumentType>>;
  financialDataPointsAggregate?: InputMaybe<BaseAgreementFinancialDataPointsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_ALL?: InputMaybe<BaseAgreementFinancialDataPointsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_NONE?: InputMaybe<BaseAgreementFinancialDataPointsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SINGLE?: InputMaybe<BaseAgreementFinancialDataPointsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SOME?: InputMaybe<BaseAgreementFinancialDataPointsConnectionWhere>;
  /** Return BaseAgreements where all of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_ALL?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return BaseAgreements where none of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_NONE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return BaseAgreements where one of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SINGLE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return BaseAgreements where some of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SOME?: InputMaybe<FlexFinancialDataPointWhere>;
  financialSummaryConfigAggregate?: InputMaybe<BaseAgreementFinancialSummaryConfigAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_ALL?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_NONE?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_SINGLE?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_SOME?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
  /** Return BaseAgreements where all of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_ALL?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return BaseAgreements where none of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_NONE?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return BaseAgreements where one of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_SINGLE?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return BaseAgreements where some of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_SOME?: InputMaybe<FinancialSummaryColumnWhere>;
  firstExecutionDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstExecutionDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedAmount_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedCounterparties_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedDiseases_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedIndications?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedIndications_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedProducts?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedProducts_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags?: InputMaybe<Scalars['String']['input']>;
  formattedTags_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedTags_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedTags_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedTags_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedValidityPeriod_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initialVersion?: InputMaybe<BaseAgreementWhere>;
  initialVersionAggregate?: InputMaybe<BaseAgreementInitialVersionAggregateInput>;
  initialVersionConnection?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
  initialVersionConnection_NOT?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
  initialVersionId?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  initialVersionId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  initialVersion_NOT?: InputMaybe<BaseAgreementWhere>;
  isAllowedFormsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowedRecordsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCaseless?: InputMaybe<Scalars['Boolean']['input']>;
  isCoveringIntervalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isExtended?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isInsightsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isLastVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredFormsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredRecordsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isScenariosInSync?: InputMaybe<Scalars['Boolean']['input']>;
  isScopeSync?: InputMaybe<Scalars['Boolean']['input']>;
  isValidityPeriodInSync?: InputMaybe<Scalars['Boolean']['input']>;
  lastExecutionDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastExecutionDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  negotiableAttributesAggregate?: InputMaybe<BaseAgreementNegotiableAttributesAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_ALL?: InputMaybe<BaseAgreementNegotiableAttributesConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_NONE?: InputMaybe<BaseAgreementNegotiableAttributesConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_SINGLE?: InputMaybe<BaseAgreementNegotiableAttributesConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_SOME?: InputMaybe<BaseAgreementNegotiableAttributesConnectionWhere>;
  /** Return BaseAgreements where all of the related CatalogueAttributes match this filter */
  negotiableAttributes_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return BaseAgreements where none of the related CatalogueAttributes match this filter */
  negotiableAttributes_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return BaseAgreements where one of the related CatalogueAttributes match this filter */
  negotiableAttributes_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return BaseAgreements where some of the related CatalogueAttributes match this filter */
  negotiableAttributes_SOME?: InputMaybe<CatalogueAttributeWhere>;
  nextVersionsAggregate?: InputMaybe<BaseAgreementNextVersionsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementNextVersionsConnections match this filter */
  nextVersionsConnection_ALL?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementNextVersionsConnections match this filter */
  nextVersionsConnection_NONE?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementNextVersionsConnections match this filter */
  nextVersionsConnection_SINGLE?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementNextVersionsConnections match this filter */
  nextVersionsConnection_SOME?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
  /** Return BaseAgreements where all of the related BaseAgreements match this filter */
  nextVersions_ALL?: InputMaybe<BaseAgreementWhere>;
  /** Return BaseAgreements where none of the related BaseAgreements match this filter */
  nextVersions_NONE?: InputMaybe<BaseAgreementWhere>;
  /** Return BaseAgreements where one of the related BaseAgreements match this filter */
  nextVersions_SINGLE?: InputMaybe<BaseAgreementWhere>;
  /** Return BaseAgreements where some of the related BaseAgreements match this filter */
  nextVersions_SOME?: InputMaybe<BaseAgreementWhere>;
  pushedBy?: InputMaybe<UserWhere>;
  pushedByAggregate?: InputMaybe<BaseAgreementPushedByAggregateInput>;
  pushedByConnection?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
  pushedByConnection_NOT?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
  pushedBy_NOT?: InputMaybe<UserWhere>;
  pushedOn?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  pushedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  rangeChartConfig?: InputMaybe<ChartRangeConfigurationWhere>;
  rangeChartConfigAggregate?: InputMaybe<BaseAgreementRangeChartConfigAggregateInput>;
  rangeChartConfigConnection?: InputMaybe<BaseAgreementRangeChartConfigConnectionWhere>;
  rangeChartConfigConnection_NOT?: InputMaybe<BaseAgreementRangeChartConfigConnectionWhere>;
  rangeChartConfig_NOT?: InputMaybe<ChartRangeConfigurationWhere>;
  reportData?: InputMaybe<Scalars['String']['input']>;
  reportData_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  reportData_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  reportData_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportData_MATCHES?: InputMaybe<Scalars['String']['input']>;
  reportData_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  requiredForms?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredForms_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  requiredRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredRecords_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  scenariosAggregate?: InputMaybe<BaseAgreementScenariosAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementScenariosConnections match this filter */
  scenariosConnection_ALL?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementScenariosConnections match this filter */
  scenariosConnection_NONE?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementScenariosConnections match this filter */
  scenariosConnection_SINGLE?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementScenariosConnections match this filter */
  scenariosConnection_SOME?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
  scenariosRelevantBrandsAggregate?: InputMaybe<BaseAgreementScenariosRelevantBrandsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_ALL?: InputMaybe<BaseAgreementScenariosRelevantBrandsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_NONE?: InputMaybe<BaseAgreementScenariosRelevantBrandsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_SINGLE?: InputMaybe<BaseAgreementScenariosRelevantBrandsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_SOME?: InputMaybe<BaseAgreementScenariosRelevantBrandsConnectionWhere>;
  /** Return BaseAgreements where all of the related Brands match this filter */
  scenariosRelevantBrands_ALL?: InputMaybe<BrandWhere>;
  /** Return BaseAgreements where none of the related Brands match this filter */
  scenariosRelevantBrands_NONE?: InputMaybe<BrandWhere>;
  /** Return BaseAgreements where one of the related Brands match this filter */
  scenariosRelevantBrands_SINGLE?: InputMaybe<BrandWhere>;
  /** Return BaseAgreements where some of the related Brands match this filter */
  scenariosRelevantBrands_SOME?: InputMaybe<BrandWhere>;
  /** Return BaseAgreements where all of the related Scenarios match this filter */
  scenarios_ALL?: InputMaybe<ScenarioWhere>;
  /** Return BaseAgreements where none of the related Scenarios match this filter */
  scenarios_NONE?: InputMaybe<ScenarioWhere>;
  /** Return BaseAgreements where one of the related Scenarios match this filter */
  scenarios_SINGLE?: InputMaybe<ScenarioWhere>;
  /** Return BaseAgreements where some of the related Scenarios match this filter */
  scenarios_SOME?: InputMaybe<ScenarioWhere>;
  status?: InputMaybe<ContractStatus>;
  statusTransitionsAggregate?: InputMaybe<BaseAgreementStatusTransitionsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementStatusTransitionsConnections match this filter */
  statusTransitionsConnection_ALL?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementStatusTransitionsConnections match this filter */
  statusTransitionsConnection_NONE?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementStatusTransitionsConnections match this filter */
  statusTransitionsConnection_SINGLE?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementStatusTransitionsConnections match this filter */
  statusTransitionsConnection_SOME?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
  /** Return BaseAgreements where all of the related AgreementStatusTransitions match this filter */
  statusTransitions_ALL?: InputMaybe<AgreementStatusTransitionWhere>;
  /** Return BaseAgreements where none of the related AgreementStatusTransitions match this filter */
  statusTransitions_NONE?: InputMaybe<AgreementStatusTransitionWhere>;
  /** Return BaseAgreements where one of the related AgreementStatusTransitions match this filter */
  statusTransitions_SINGLE?: InputMaybe<AgreementStatusTransitionWhere>;
  /** Return BaseAgreements where some of the related AgreementStatusTransitions match this filter */
  statusTransitions_SOME?: InputMaybe<AgreementStatusTransitionWhere>;
  status_IN?: InputMaybe<Array<ContractStatus>>;
  subjectMatter?: InputMaybe<AgreementSubjectMatter>;
  subjectMatter_IN?: InputMaybe<Array<AgreementSubjectMatter>>;
  tagsAggregate?: InputMaybe<BaseAgreementTagsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementTagsConnections match this filter */
  tagsConnection_ALL?: InputMaybe<BaseAgreementTagsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementTagsConnections match this filter */
  tagsConnection_NONE?: InputMaybe<BaseAgreementTagsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementTagsConnections match this filter */
  tagsConnection_SINGLE?: InputMaybe<BaseAgreementTagsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementTagsConnections match this filter */
  tagsConnection_SOME?: InputMaybe<BaseAgreementTagsConnectionWhere>;
  /** Return BaseAgreements where all of the related AgreementTags match this filter */
  tags_ALL?: InputMaybe<AgreementTagWhere>;
  /** Return BaseAgreements where none of the related AgreementTags match this filter */
  tags_NONE?: InputMaybe<AgreementTagWhere>;
  /** Return BaseAgreements where one of the related AgreementTags match this filter */
  tags_SINGLE?: InputMaybe<AgreementTagWhere>;
  /** Return BaseAgreements where some of the related AgreementTags match this filter */
  tags_SOME?: InputMaybe<AgreementTagWhere>;
  template?: InputMaybe<AgreementTemplateWhere>;
  templateAggregate?: InputMaybe<BaseAgreementTemplateAggregateInput>;
  templateConnection?: InputMaybe<BaseAgreementTemplateConnectionWhere>;
  templateConnection_NOT?: InputMaybe<BaseAgreementTemplateConnectionWhere>;
  template_NOT?: InputMaybe<AgreementTemplateWhere>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatmentPricesAggregate?: InputMaybe<BaseAgreementTreatmentPricesAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementTreatmentPricesConnections match this filter */
  treatmentPricesConnection_ALL?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementTreatmentPricesConnections match this filter */
  treatmentPricesConnection_NONE?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementTreatmentPricesConnections match this filter */
  treatmentPricesConnection_SINGLE?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementTreatmentPricesConnections match this filter */
  treatmentPricesConnection_SOME?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
  /** Return BaseAgreements where all of the related Treatments match this filter */
  treatmentPrices_ALL?: InputMaybe<TreatmentWhere>;
  /** Return BaseAgreements where none of the related Treatments match this filter */
  treatmentPrices_NONE?: InputMaybe<TreatmentWhere>;
  /** Return BaseAgreements where one of the related Treatments match this filter */
  treatmentPrices_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return BaseAgreements where some of the related Treatments match this filter */
  treatmentPrices_SOME?: InputMaybe<TreatmentWhere>;
  userContextsAggregate?: InputMaybe<BaseAgreementUserContextsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementUserContextsConnections match this filter */
  userContextsConnection_ALL?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementUserContextsConnections match this filter */
  userContextsConnection_NONE?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementUserContextsConnections match this filter */
  userContextsConnection_SINGLE?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementUserContextsConnections match this filter */
  userContextsConnection_SOME?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
  /** Return BaseAgreements where all of the related UserContexts match this filter */
  userContexts_ALL?: InputMaybe<UserContextWhere>;
  /** Return BaseAgreements where none of the related UserContexts match this filter */
  userContexts_NONE?: InputMaybe<UserContextWhere>;
  /** Return BaseAgreements where one of the related UserContexts match this filter */
  userContexts_SINGLE?: InputMaybe<UserContextWhere>;
  /** Return BaseAgreements where some of the related UserContexts match this filter */
  userContexts_SOME?: InputMaybe<UserContextWhere>;
  userRolesAggregate?: InputMaybe<BaseAgreementUserRolesAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementUserRolesConnections match this filter */
  userRolesConnection_ALL?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementUserRolesConnections match this filter */
  userRolesConnection_NONE?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementUserRolesConnections match this filter */
  userRolesConnection_SINGLE?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementUserRolesConnections match this filter */
  userRolesConnection_SOME?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
  /** Return BaseAgreements where all of the related Users match this filter */
  userRoles_ALL?: InputMaybe<UserWhere>;
  /** Return BaseAgreements where none of the related Users match this filter */
  userRoles_NONE?: InputMaybe<UserWhere>;
  /** Return BaseAgreements where one of the related Users match this filter */
  userRoles_SINGLE?: InputMaybe<UserWhere>;
  /** Return BaseAgreements where some of the related Users match this filter */
  userRoles_SOME?: InputMaybe<UserWhere>;
  validFromDate?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  validFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_GT?: InputMaybe<Scalars['Int']['input']>;
  version_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_LT?: InputMaybe<Scalars['Int']['input']>;
  version_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementsConnection = {
  __typename?: 'BaseAgreementsConnection';
  edges: Array<BaseAgreementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Brand = {
  __typename?: 'Brand';
  Name: Scalars['String']['output'];
  art71DataLastUpdatedBy?: Maybe<User>;
  art71DataLastUpdatedByAggregate?: Maybe<BrandUserArt71DataLastUpdatedByAggregationSelection>;
  art71DataLastUpdatedByConnection: BrandArt71DataLastUpdatedByConnection;
  art71DataLastUpdatedByEmail?: Maybe<Scalars['String']['output']>;
  art71DataLastUpdatedOn?: Maybe<Scalars['DateTime']['output']>;
  article71Indications: Array<Article71Indication>;
  article71IndicationsAggregate?: Maybe<BrandArticle71IndicationArticle71IndicationsAggregationSelection>;
  article71IndicationsConnection: BrandArticle71IndicationsConnection;
  id: Scalars['ID']['output'];
  isPatented?: Maybe<Scalars['Boolean']['output']>;
  mainIndications: Array<MainIndication>;
  mainIndicationsAggregate?: Maybe<BrandMainIndicationMainIndicationsAggregationSelection>;
  mainIndicationsConnection: BrandMainIndicationsConnection;
  patentExpiryDate?: Maybe<Scalars['Date']['output']>;
  preparations: Array<Preparation>;
  preparationsAggregate?: Maybe<BrandPreparationPreparationsAggregationSelection>;
  preparationsConnection: BrandPreparationsConnection;
};


export type BrandArt71DataLastUpdatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type BrandArt71DataLastUpdatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type BrandArt71DataLastUpdatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BrandArt71DataLastUpdatedByConnectionSort>>;
  where?: InputMaybe<BrandArt71DataLastUpdatedByConnectionWhere>;
};


export type BrandArticle71IndicationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Article71IndicationOptions>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type BrandArticle71IndicationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type BrandArticle71IndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BrandArticle71IndicationsConnectionSort>>;
  where?: InputMaybe<BrandArticle71IndicationsConnectionWhere>;
};


export type BrandMainIndicationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MainIndicationOptions>;
  where?: InputMaybe<MainIndicationWhere>;
};


export type BrandMainIndicationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MainIndicationWhere>;
};


export type BrandMainIndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BrandMainIndicationsConnectionSort>>;
  where?: InputMaybe<BrandMainIndicationsConnectionWhere>;
};


export type BrandPreparationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type BrandPreparationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationWhere>;
};


export type BrandPreparationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BrandPreparationsConnectionSort>>;
  where?: InputMaybe<BrandPreparationsConnectionWhere>;
};

export type BrandAndGenericInput = {
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type BrandArt71DataLastUpdatedByAggregateInput = {
  AND?: InputMaybe<Array<BrandArt71DataLastUpdatedByAggregateInput>>;
  NOT?: InputMaybe<BrandArt71DataLastUpdatedByAggregateInput>;
  OR?: InputMaybe<Array<BrandArt71DataLastUpdatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BrandArt71DataLastUpdatedByNodeAggregationWhereInput>;
};

export type BrandArt71DataLastUpdatedByConnection = {
  __typename?: 'BrandArt71DataLastUpdatedByConnection';
  edges: Array<BrandArt71DataLastUpdatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BrandArt71DataLastUpdatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type BrandArt71DataLastUpdatedByConnectionWhere = {
  AND?: InputMaybe<Array<BrandArt71DataLastUpdatedByConnectionWhere>>;
  NOT?: InputMaybe<BrandArt71DataLastUpdatedByConnectionWhere>;
  OR?: InputMaybe<Array<BrandArt71DataLastUpdatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type BrandArt71DataLastUpdatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BrandArt71DataLastUpdatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BrandArt71DataLastUpdatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BrandArt71DataLastUpdatedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BrandArt71DataLastUpdatedByRelationship = {
  __typename?: 'BrandArt71DataLastUpdatedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type BrandArticle71IndicationArticle71IndicationsAggregationSelection = {
  __typename?: 'BrandArticle71IndicationArticle71IndicationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection>;
};

export type BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection = {
  __typename?: 'BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection';
  countryScopeId: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  notes: StringAggregateSelectionNullable;
};

export type BrandArticle71IndicationsAggregateInput = {
  AND?: InputMaybe<Array<BrandArticle71IndicationsAggregateInput>>;
  NOT?: InputMaybe<BrandArticle71IndicationsAggregateInput>;
  OR?: InputMaybe<Array<BrandArticle71IndicationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BrandArticle71IndicationsNodeAggregationWhereInput>;
};

export type BrandArticle71IndicationsConnection = {
  __typename?: 'BrandArticle71IndicationsConnection';
  edges: Array<BrandArticle71IndicationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BrandArticle71IndicationsConnectionSort = {
  node?: InputMaybe<Article71IndicationSort>;
};

export type BrandArticle71IndicationsConnectionWhere = {
  AND?: InputMaybe<Array<BrandArticle71IndicationsConnectionWhere>>;
  NOT?: InputMaybe<BrandArticle71IndicationsConnectionWhere>;
  OR?: InputMaybe<Array<BrandArticle71IndicationsConnectionWhere>>;
  node?: InputMaybe<Article71IndicationWhere>;
};

export type BrandArticle71IndicationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BrandArticle71IndicationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BrandArticle71IndicationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BrandArticle71IndicationsNodeAggregationWhereInput>>;
  countryScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  notes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BrandArticle71IndicationsRelationship = {
  __typename?: 'BrandArticle71IndicationsRelationship';
  cursor: Scalars['String']['output'];
  node: Article71Indication;
};

export type BrandEdge = {
  __typename?: 'BrandEdge';
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type BrandInput = {
  Name: Scalars['String']['input'];
  article71Indications?: InputMaybe<Array<Article71IndicationInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPatented?: InputMaybe<Scalars['Boolean']['input']>;
  mainIndications?: InputMaybe<Array<MainIndicationInput>>;
  patentExpiryDate?: InputMaybe<Scalars['Date']['input']>;
};

export type BrandMainIndicationMainIndicationsAggregationSelection = {
  __typename?: 'BrandMainIndicationMainIndicationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BrandMainIndicationMainIndicationsNodeAggregateSelection>;
};

export type BrandMainIndicationMainIndicationsNodeAggregateSelection = {
  __typename?: 'BrandMainIndicationMainIndicationsNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
};

export type BrandMainIndicationsAggregateInput = {
  AND?: InputMaybe<Array<BrandMainIndicationsAggregateInput>>;
  NOT?: InputMaybe<BrandMainIndicationsAggregateInput>;
  OR?: InputMaybe<Array<BrandMainIndicationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BrandMainIndicationsNodeAggregationWhereInput>;
};

export type BrandMainIndicationsConnection = {
  __typename?: 'BrandMainIndicationsConnection';
  edges: Array<BrandMainIndicationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BrandMainIndicationsConnectionSort = {
  node?: InputMaybe<MainIndicationSort>;
};

export type BrandMainIndicationsConnectionWhere = {
  AND?: InputMaybe<Array<BrandMainIndicationsConnectionWhere>>;
  NOT?: InputMaybe<BrandMainIndicationsConnectionWhere>;
  OR?: InputMaybe<Array<BrandMainIndicationsConnectionWhere>>;
  node?: InputMaybe<MainIndicationWhere>;
};

export type BrandMainIndicationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BrandMainIndicationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BrandMainIndicationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BrandMainIndicationsNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BrandMainIndicationsRelationship = {
  __typename?: 'BrandMainIndicationsRelationship';
  cursor: Scalars['String']['output'];
  node: MainIndication;
};

export type BrandOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more BrandSort objects to sort Brands by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<BrandSort>>;
};

export type BrandPreparationPreparationsAggregationSelection = {
  __typename?: 'BrandPreparationPreparationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BrandPreparationPreparationsNodeAggregateSelection>;
};

export type BrandPreparationPreparationsNodeAggregateSelection = {
  __typename?: 'BrandPreparationPreparationsNodeAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type BrandPreparationsAggregateInput = {
  AND?: InputMaybe<Array<BrandPreparationsAggregateInput>>;
  NOT?: InputMaybe<BrandPreparationsAggregateInput>;
  OR?: InputMaybe<Array<BrandPreparationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BrandPreparationsNodeAggregationWhereInput>;
};

export type BrandPreparationsConnection = {
  __typename?: 'BrandPreparationsConnection';
  edges: Array<BrandPreparationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BrandPreparationsConnectionSort = {
  node?: InputMaybe<PreparationSort>;
};

export type BrandPreparationsConnectionWhere = {
  AND?: InputMaybe<Array<BrandPreparationsConnectionWhere>>;
  NOT?: InputMaybe<BrandPreparationsConnectionWhere>;
  OR?: InputMaybe<Array<BrandPreparationsConnectionWhere>>;
  node?: InputMaybe<PreparationWhere>;
};

export type BrandPreparationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BrandPreparationsNodeAggregationWhereInput>>;
  AtcCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<BrandPreparationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BrandPreparationsNodeAggregationWhereInput>>;
  SwissmedicNo5_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BrandPreparationsRelationship = {
  __typename?: 'BrandPreparationsRelationship';
  cursor: Scalars['String']['output'];
  node: Preparation;
};

/** Fields to sort Brands by. The order in which sorts are applied is not guaranteed when specifying many fields in one BrandSort object. */
export type BrandSort = {
  Name?: InputMaybe<SortDirection>;
  art71DataLastUpdatedByEmail?: InputMaybe<SortDirection>;
  art71DataLastUpdatedOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isPatented?: InputMaybe<SortDirection>;
  patentExpiryDate?: InputMaybe<SortDirection>;
};

export type BrandUserArt71DataLastUpdatedByAggregationSelection = {
  __typename?: 'BrandUserArt71DataLastUpdatedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BrandUserArt71DataLastUpdatedByNodeAggregateSelection>;
};

export type BrandUserArt71DataLastUpdatedByNodeAggregateSelection = {
  __typename?: 'BrandUserArt71DataLastUpdatedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type BrandWhere = {
  AND?: InputMaybe<Array<BrandWhere>>;
  NOT?: InputMaybe<BrandWhere>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  OR?: InputMaybe<Array<BrandWhere>>;
  art71DataLastUpdatedBy?: InputMaybe<UserWhere>;
  art71DataLastUpdatedByAggregate?: InputMaybe<BrandArt71DataLastUpdatedByAggregateInput>;
  art71DataLastUpdatedByConnection?: InputMaybe<BrandArt71DataLastUpdatedByConnectionWhere>;
  art71DataLastUpdatedByConnection_NOT?: InputMaybe<BrandArt71DataLastUpdatedByConnectionWhere>;
  art71DataLastUpdatedByEmail?: InputMaybe<Scalars['String']['input']>;
  art71DataLastUpdatedByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  art71DataLastUpdatedByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  art71DataLastUpdatedByEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  art71DataLastUpdatedByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  art71DataLastUpdatedByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  art71DataLastUpdatedBy_NOT?: InputMaybe<UserWhere>;
  art71DataLastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  art71DataLastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  article71IndicationsAggregate?: InputMaybe<BrandArticle71IndicationsAggregateInput>;
  /** Return Brands where all of the related BrandArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_ALL?: InputMaybe<BrandArticle71IndicationsConnectionWhere>;
  /** Return Brands where none of the related BrandArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_NONE?: InputMaybe<BrandArticle71IndicationsConnectionWhere>;
  /** Return Brands where one of the related BrandArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_SINGLE?: InputMaybe<BrandArticle71IndicationsConnectionWhere>;
  /** Return Brands where some of the related BrandArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_SOME?: InputMaybe<BrandArticle71IndicationsConnectionWhere>;
  /** Return Brands where all of the related Article71Indications match this filter */
  article71Indications_ALL?: InputMaybe<Article71IndicationWhere>;
  /** Return Brands where none of the related Article71Indications match this filter */
  article71Indications_NONE?: InputMaybe<Article71IndicationWhere>;
  /** Return Brands where one of the related Article71Indications match this filter */
  article71Indications_SINGLE?: InputMaybe<Article71IndicationWhere>;
  /** Return Brands where some of the related Article71Indications match this filter */
  article71Indications_SOME?: InputMaybe<Article71IndicationWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isPatented?: InputMaybe<Scalars['Boolean']['input']>;
  mainIndicationsAggregate?: InputMaybe<BrandMainIndicationsAggregateInput>;
  /** Return Brands where all of the related BrandMainIndicationsConnections match this filter */
  mainIndicationsConnection_ALL?: InputMaybe<BrandMainIndicationsConnectionWhere>;
  /** Return Brands where none of the related BrandMainIndicationsConnections match this filter */
  mainIndicationsConnection_NONE?: InputMaybe<BrandMainIndicationsConnectionWhere>;
  /** Return Brands where one of the related BrandMainIndicationsConnections match this filter */
  mainIndicationsConnection_SINGLE?: InputMaybe<BrandMainIndicationsConnectionWhere>;
  /** Return Brands where some of the related BrandMainIndicationsConnections match this filter */
  mainIndicationsConnection_SOME?: InputMaybe<BrandMainIndicationsConnectionWhere>;
  /** Return Brands where all of the related MainIndications match this filter */
  mainIndications_ALL?: InputMaybe<MainIndicationWhere>;
  /** Return Brands where none of the related MainIndications match this filter */
  mainIndications_NONE?: InputMaybe<MainIndicationWhere>;
  /** Return Brands where one of the related MainIndications match this filter */
  mainIndications_SINGLE?: InputMaybe<MainIndicationWhere>;
  /** Return Brands where some of the related MainIndications match this filter */
  mainIndications_SOME?: InputMaybe<MainIndicationWhere>;
  patentExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  patentExpiryDate_GT?: InputMaybe<Scalars['Date']['input']>;
  patentExpiryDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  patentExpiryDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  patentExpiryDate_LT?: InputMaybe<Scalars['Date']['input']>;
  patentExpiryDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  preparationsAggregate?: InputMaybe<BrandPreparationsAggregateInput>;
  /** Return Brands where all of the related BrandPreparationsConnections match this filter */
  preparationsConnection_ALL?: InputMaybe<BrandPreparationsConnectionWhere>;
  /** Return Brands where none of the related BrandPreparationsConnections match this filter */
  preparationsConnection_NONE?: InputMaybe<BrandPreparationsConnectionWhere>;
  /** Return Brands where one of the related BrandPreparationsConnections match this filter */
  preparationsConnection_SINGLE?: InputMaybe<BrandPreparationsConnectionWhere>;
  /** Return Brands where some of the related BrandPreparationsConnections match this filter */
  preparationsConnection_SOME?: InputMaybe<BrandPreparationsConnectionWhere>;
  /** Return Brands where all of the related Preparations match this filter */
  preparations_ALL?: InputMaybe<PreparationWhere>;
  /** Return Brands where none of the related Preparations match this filter */
  preparations_NONE?: InputMaybe<PreparationWhere>;
  /** Return Brands where one of the related Preparations match this filter */
  preparations_SINGLE?: InputMaybe<PreparationWhere>;
  /** Return Brands where some of the related Preparations match this filter */
  preparations_SOME?: InputMaybe<PreparationWhere>;
};

export type BrandsConnection = {
  __typename?: 'BrandsConnection';
  edges: Array<BrandEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CachedAgreementListItem = {
  __typename?: 'CachedAgreementListItem';
  formattedCounterparties?: Maybe<Scalars['String']['output']>;
  formattedProducts?: Maybe<Scalars['String']['output']>;
  formattedTags?: Maybe<Scalars['String']['output']>;
  formattedValidityPeriod?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  initialVersionId?: Maybe<Scalars['String']['output']>;
  lastUpdatedOn?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ContractStatus>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  validFromDate?: Maybe<Scalars['String']['output']>;
  validToDate?: Maybe<Scalars['String']['output']>;
};

export type CachedAgreementListItemEdge = {
  __typename?: 'CachedAgreementListItemEdge';
  cursor: Scalars['String']['output'];
  node: CachedAgreementListItem;
};

export type CachedAgreementListItemOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CachedAgreementListItemSort objects to sort CachedAgreementListItems by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CachedAgreementListItemSort>>;
};

/** Fields to sort CachedAgreementListItems by. The order in which sorts are applied is not guaranteed when specifying many fields in one CachedAgreementListItemSort object. */
export type CachedAgreementListItemSort = {
  formattedCounterparties?: InputMaybe<SortDirection>;
  formattedProducts?: InputMaybe<SortDirection>;
  formattedTags?: InputMaybe<SortDirection>;
  formattedValidityPeriod?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  initialVersionId?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  totalAmount?: InputMaybe<SortDirection>;
  validFromDate?: InputMaybe<SortDirection>;
  validToDate?: InputMaybe<SortDirection>;
};

export type CachedAgreementListItemWhere = {
  AND?: InputMaybe<Array<CachedAgreementListItemWhere>>;
  NOT?: InputMaybe<CachedAgreementListItemWhere>;
  OR?: InputMaybe<Array<CachedAgreementListItemWhere>>;
  formattedCounterparties?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedCounterparties_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedProducts?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedProducts_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags?: InputMaybe<Scalars['String']['input']>;
  formattedTags_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedTags_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedTags_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedTags_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedValidityPeriod_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  initialVersionId?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  initialVersionId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContractStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  validFromDate?: InputMaybe<Scalars['String']['input']>;
  validFromDate_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  validFromDate_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  validFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validFromDate_MATCHES?: InputMaybe<Scalars['String']['input']>;
  validFromDate_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  validToDate?: InputMaybe<Scalars['String']['input']>;
  validToDate_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  validToDate_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  validToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validToDate_MATCHES?: InputMaybe<Scalars['String']['input']>;
  validToDate_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CachedAgreementListItemsConnection = {
  __typename?: 'CachedAgreementListItemsConnection';
  edges: Array<CachedAgreementListItemEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CanPushAgreementInput = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  diseaseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  indicationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  nonObservingCounterpartyTenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum CanadianPriceType {
  AlbertaListPrice = 'ALBERTA_LIST_PRICE',
  AlbertaListPricePercent = 'ALBERTA_LIST_PRICE_PERCENT',
  AlbertaMarkedUpPrice = 'ALBERTA_MARKED_UP_PRICE',
  AlbertaMarkedUpPricePercent = 'ALBERTA_MARKED_UP_PRICE_PERCENT',
  BritishColumbiaListPrice = 'BRITISH_COLUMBIA_LIST_PRICE',
  BritishColumbiaListPricePercent = 'BRITISH_COLUMBIA_LIST_PRICE_PERCENT',
  BritishColumbiaMarkedUpPrice = 'BRITISH_COLUMBIA_MARKED_UP_PRICE',
  BritishColumbiaMarkedUpPricePercent = 'BRITISH_COLUMBIA_MARKED_UP_PRICE_PERCENT',
  ManitobaListPrice = 'MANITOBA_LIST_PRICE',
  ManitobaListPricePercent = 'MANITOBA_LIST_PRICE_PERCENT',
  ManitobaMarkedUpPrice = 'MANITOBA_MARKED_UP_PRICE',
  ManitobaMarkedUpPricePercent = 'MANITOBA_MARKED_UP_PRICE_PERCENT',
  NewfoundlandAndLabradorListPrice = 'NEWFOUNDLAND_AND_LABRADOR_LIST_PRICE',
  NewfoundlandAndLabradorListPricePercent = 'NEWFOUNDLAND_AND_LABRADOR_LIST_PRICE_PERCENT',
  NewfoundlandAndLabradorMarkedUpPrice = 'NEWFOUNDLAND_AND_LABRADOR_MARKED_UP_PRICE',
  NewfoundlandAndLabradorMarkedUpPricePercent = 'NEWFOUNDLAND_AND_LABRADOR_MARKED_UP_PRICE_PERCENT',
  NewBrunswickListPrice = 'NEW_BRUNSWICK_LIST_PRICE',
  NewBrunswickListPricePercent = 'NEW_BRUNSWICK_LIST_PRICE_PERCENT',
  NewBrunswickMarkedUpPrice = 'NEW_BRUNSWICK_MARKED_UP_PRICE',
  NewBrunswickMarkedUpPricePercent = 'NEW_BRUNSWICK_MARKED_UP_PRICE_PERCENT',
  NihbListPrice = 'NIHB_LIST_PRICE',
  NihbListPricePercent = 'NIHB_LIST_PRICE_PERCENT',
  NihbMarkedUpPrice = 'NIHB_MARKED_UP_PRICE',
  NihbMarkedUpPricePercent = 'NIHB_MARKED_UP_PRICE_PERCENT',
  NorthwestTerritoriesListPrice = 'NORTHWEST_TERRITORIES_LIST_PRICE',
  NorthwestTerritoriesListPricePercent = 'NORTHWEST_TERRITORIES_LIST_PRICE_PERCENT',
  NorthwestTerritoriesMarkedUpPrice = 'NORTHWEST_TERRITORIES_MARKED_UP_PRICE',
  NorthwestTerritoriesMarkedUpPricePercent = 'NORTHWEST_TERRITORIES_MARKED_UP_PRICE_PERCENT',
  NovaScotiaListPrice = 'NOVA_SCOTIA_LIST_PRICE',
  NovaScotiaListPricePercent = 'NOVA_SCOTIA_LIST_PRICE_PERCENT',
  NovaScotiaMarkedUpPrice = 'NOVA_SCOTIA_MARKED_UP_PRICE',
  NovaScotiaMarkedUpPricePercent = 'NOVA_SCOTIA_MARKED_UP_PRICE_PERCENT',
  NunavutListPrice = 'NUNAVUT_LIST_PRICE',
  NunavutListPricePercent = 'NUNAVUT_LIST_PRICE_PERCENT',
  NunavutMarkedUpPrice = 'NUNAVUT_MARKED_UP_PRICE',
  NunavutMarkedUpPricePercent = 'NUNAVUT_MARKED_UP_PRICE_PERCENT',
  OntarioListPrice = 'ONTARIO_LIST_PRICE',
  OntarioListPricePercent = 'ONTARIO_LIST_PRICE_PERCENT',
  OntarioMarkedUpPrice = 'ONTARIO_MARKED_UP_PRICE',
  OntarioMarkedUpPricePercent = 'ONTARIO_MARKED_UP_PRICE_PERCENT',
  PrinceEdwardIslandListPrice = 'PRINCE_EDWARD_ISLAND_LIST_PRICE',
  PrinceEdwardIslandListPricePercent = 'PRINCE_EDWARD_ISLAND_LIST_PRICE_PERCENT',
  PrinceEdwardIslandMarkedUpPrice = 'PRINCE_EDWARD_ISLAND_MARKED_UP_PRICE',
  PrinceEdwardIslandMarkedUpPricePercent = 'PRINCE_EDWARD_ISLAND_MARKED_UP_PRICE_PERCENT',
  QuebecListPrice = 'QUEBEC_LIST_PRICE',
  QuebecListPricePercent = 'QUEBEC_LIST_PRICE_PERCENT',
  QuebecMarkedUpPrice = 'QUEBEC_MARKED_UP_PRICE',
  QuebecMarkedUpPricePercent = 'QUEBEC_MARKED_UP_PRICE_PERCENT',
  SaskatchewanListPrice = 'SASKATCHEWAN_LIST_PRICE',
  SaskatchewanListPricePercent = 'SASKATCHEWAN_LIST_PRICE_PERCENT',
  SaskatchewanMarkedUpPrice = 'SASKATCHEWAN_MARKED_UP_PRICE',
  SaskatchewanMarkedUpPricePercent = 'SASKATCHEWAN_MARKED_UP_PRICE_PERCENT',
  VacListPrice = 'VAC_LIST_PRICE',
  VacListPricePercent = 'VAC_LIST_PRICE_PERCENT',
  VacMarkedUpPrice = 'VAC_MARKED_UP_PRICE',
  VacMarkedUpPricePercent = 'VAC_MARKED_UP_PRICE_PERCENT',
  YukonListPrice = 'YUKON_LIST_PRICE',
  YukonListPricePercent = 'YUKON_LIST_PRICE_PERCENT',
  YukonMarkedUpPrice = 'YUKON_MARKED_UP_PRICE',
  YukonMarkedUpPricePercent = 'YUKON_MARKED_UP_PRICE_PERCENT'
}

export type Case = {
  __typename?: 'Case';
  agreement?: Maybe<Agreement>;
  baseAgreement: Agreement;
  baseAgreementAggregate?: Maybe<CaseAgreementBaseAgreementAggregationSelection>;
  baseAgreementConnection: CaseBaseAgreementConnection;
  creationDate: Scalars['DateTime']['output'];
  financialDataPoints: Array<FlexFinancialDataPoint>;
  financialDataPointsAggregate?: Maybe<CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection>;
  financialDataPointsConnection: CaseFinancialDataPointsConnection;
  flexEntities: Array<FlexEntity>;
  flexEntitiesAggregate?: Maybe<CaseFlexEntityFlexEntitiesAggregationSelection>;
  flexEntitiesConnection: CaseFlexEntitiesConnection;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  negotiationRounds: Array<NegotiationRound>;
  negotiationRoundsAggregate?: Maybe<CaseNegotiationRoundNegotiationRoundsAggregationSelection>;
  negotiationRoundsConnection: CaseNegotiationRoundsConnection;
  preparationBrandName?: Maybe<Scalars['String']['output']>;
  refunds: Array<Refund>;
  refundsAggregate?: Maybe<CaseRefundRefundsAggregationSelection>;
  refundsConnection: CaseRefundsConnection;
  relevantArticle71Indication?: Maybe<Article71Indication>;
  relevantArticle71IndicationAggregate?: Maybe<CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection>;
  relevantArticle71IndicationConnection: CaseRelevantArticle71IndicationConnection;
  submissionDate?: Maybe<Scalars['DateTime']['output']>;
};


export type CaseBaseAgreementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type CaseBaseAgreementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type CaseBaseAgreementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseBaseAgreementConnectionSort>>;
  where?: InputMaybe<CaseBaseAgreementConnectionWhere>;
};


export type CaseFinancialDataPointsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type CaseFinancialDataPointsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type CaseFinancialDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseFinancialDataPointsConnectionSort>>;
  where?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
};


export type CaseFlexEntitiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type CaseFlexEntitiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type CaseFlexEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseFlexEntitiesConnectionSort>>;
  where?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
};


export type CaseNegotiationRoundsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NegotiationRoundOptions>;
  where?: InputMaybe<NegotiationRoundWhere>;
};


export type CaseNegotiationRoundsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NegotiationRoundWhere>;
};


export type CaseNegotiationRoundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseNegotiationRoundsConnectionSort>>;
  where?: InputMaybe<CaseNegotiationRoundsConnectionWhere>;
};


export type CaseRefundsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type CaseRefundsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RefundWhere>;
};


export type CaseRefundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseRefundsConnectionSort>>;
  where?: InputMaybe<CaseRefundsConnectionWhere>;
};


export type CaseRelevantArticle71IndicationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Article71IndicationOptions>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type CaseRelevantArticle71IndicationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type CaseRelevantArticle71IndicationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseRelevantArticle71IndicationConnectionSort>>;
  where?: InputMaybe<CaseRelevantArticle71IndicationConnectionWhere>;
};

export type CaseAgreementBaseAgreementAggregationSelection = {
  __typename?: 'CaseAgreementBaseAgreementAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CaseAgreementBaseAgreementNodeAggregateSelection>;
};

export type CaseAgreementBaseAgreementNodeAggregateSelection = {
  __typename?: 'CaseAgreementBaseAgreementNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection = {
  __typename?: 'CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection>;
};

export type CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection = {
  __typename?: 'CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection';
  countryScopeId: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  notes: StringAggregateSelectionNullable;
};

export type CaseBaseAgreementAggregateInput = {
  AND?: InputMaybe<Array<CaseBaseAgreementAggregateInput>>;
  NOT?: InputMaybe<CaseBaseAgreementAggregateInput>;
  OR?: InputMaybe<Array<CaseBaseAgreementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseBaseAgreementNodeAggregationWhereInput>;
};

export type CaseBaseAgreementConnection = {
  __typename?: 'CaseBaseAgreementConnection';
  edges: Array<CaseBaseAgreementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseBaseAgreementConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type CaseBaseAgreementConnectionWhere = {
  AND?: InputMaybe<Array<CaseBaseAgreementConnectionWhere>>;
  NOT?: InputMaybe<CaseBaseAgreementConnectionWhere>;
  OR?: InputMaybe<Array<CaseBaseAgreementConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type CaseBaseAgreementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseBaseAgreementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseBaseAgreementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseBaseAgreementNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseBaseAgreementRelationship = {
  __typename?: 'CaseBaseAgreementRelationship';
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type CaseEdge = {
  __typename?: 'CaseEdge';
  cursor: Scalars['String']['output'];
  node: Case;
};

export type CaseFinancialDataPointsAggregateInput = {
  AND?: InputMaybe<Array<CaseFinancialDataPointsAggregateInput>>;
  NOT?: InputMaybe<CaseFinancialDataPointsAggregateInput>;
  OR?: InputMaybe<Array<CaseFinancialDataPointsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseFinancialDataPointsNodeAggregationWhereInput>;
};

export type CaseFinancialDataPointsConnection = {
  __typename?: 'CaseFinancialDataPointsConnection';
  edges: Array<CaseFinancialDataPointsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseFinancialDataPointsConnectionSort = {
  node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type CaseFinancialDataPointsConnectionWhere = {
  AND?: InputMaybe<Array<CaseFinancialDataPointsConnectionWhere>>;
  NOT?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
  OR?: InputMaybe<Array<CaseFinancialDataPointsConnectionWhere>>;
  node?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type CaseFinancialDataPointsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseFinancialDataPointsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseFinancialDataPointsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseFinancialDataPointsNodeAggregationWhereInput>>;
  basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type CaseFinancialDataPointsRelationship = {
  __typename?: 'CaseFinancialDataPointsRelationship';
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
};

export type CaseFlexEntitiesAggregateInput = {
  AND?: InputMaybe<Array<CaseFlexEntitiesAggregateInput>>;
  NOT?: InputMaybe<CaseFlexEntitiesAggregateInput>;
  OR?: InputMaybe<Array<CaseFlexEntitiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseFlexEntitiesNodeAggregationWhereInput>;
};

export type CaseFlexEntitiesConnection = {
  __typename?: 'CaseFlexEntitiesConnection';
  edges: Array<CaseFlexEntitiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseFlexEntitiesConnectionSort = {
  edge?: InputMaybe<CaseFlexEntityRelationshipSort>;
  node?: InputMaybe<FlexEntitySort>;
};

export type CaseFlexEntitiesConnectionWhere = {
  AND?: InputMaybe<Array<CaseFlexEntitiesConnectionWhere>>;
  NOT?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
  OR?: InputMaybe<Array<CaseFlexEntitiesConnectionWhere>>;
  edge?: InputMaybe<CaseFlexEntityRelationshipWhere>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type CaseFlexEntitiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseFlexEntitiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseFlexEntitiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseFlexEntitiesNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseFlexEntitiesRelationship = CaseFlexEntityRelationship & {
  __typename?: 'CaseFlexEntitiesRelationship';
  cursor: Scalars['String']['output'];
  isStartingPoint: Scalars['Boolean']['output'];
  node: FlexEntity;
};

export type CaseFlexEntityFlexEntitiesAggregationSelection = {
  __typename?: 'CaseFlexEntityFlexEntitiesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CaseFlexEntityFlexEntitiesNodeAggregateSelection>;
};

export type CaseFlexEntityFlexEntitiesNodeAggregateSelection = {
  __typename?: 'CaseFlexEntityFlexEntitiesNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type CaseFlexEntityRelationship = {
  isStartingPoint: Scalars['Boolean']['output'];
};

export type CaseFlexEntityRelationshipSort = {
  isStartingPoint?: InputMaybe<SortDirection>;
};

export type CaseFlexEntityRelationshipWhere = {
  AND?: InputMaybe<Array<CaseFlexEntityRelationshipWhere>>;
  NOT?: InputMaybe<CaseFlexEntityRelationshipWhere>;
  OR?: InputMaybe<Array<CaseFlexEntityRelationshipWhere>>;
  isStartingPoint?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection = {
  __typename?: 'CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection>;
};

export type CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection = {
  __typename?: 'CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  currencyCode: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  generatedUuid: IdAggregateSelectionNonNullable;
  netPrices: StringAggregateSelectionNullable;
  payable: FloatAggregateSelectionNonNullable;
  payablePercentage: FloatAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNonNullable;
  refundDeltaNumber: IntAggregateSelectionNonNullable;
  refundable: FloatAggregateSelectionNonNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  scenarioZeroMainNetPrices: StringAggregateSelectionNullable;
  scenarioZeroNetPrices: StringAggregateSelectionNullable;
  scenarioZeroRelevantNetPrices: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
  variable: FloatAggregateSelectionNonNullable;
  variablePercentage: FloatAggregateSelectionNullable;
};

export type CaseNegotiationRoundNegotiationRoundsAggregationSelection = {
  __typename?: 'CaseNegotiationRoundNegotiationRoundsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection>;
};

export type CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection = {
  __typename?: 'CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection';
  changedOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type CaseNegotiationRoundsAggregateInput = {
  AND?: InputMaybe<Array<CaseNegotiationRoundsAggregateInput>>;
  NOT?: InputMaybe<CaseNegotiationRoundsAggregateInput>;
  OR?: InputMaybe<Array<CaseNegotiationRoundsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseNegotiationRoundsNodeAggregationWhereInput>;
};

export type CaseNegotiationRoundsConnection = {
  __typename?: 'CaseNegotiationRoundsConnection';
  edges: Array<CaseNegotiationRoundsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseNegotiationRoundsConnectionSort = {
  node?: InputMaybe<NegotiationRoundSort>;
};

export type CaseNegotiationRoundsConnectionWhere = {
  AND?: InputMaybe<Array<CaseNegotiationRoundsConnectionWhere>>;
  NOT?: InputMaybe<CaseNegotiationRoundsConnectionWhere>;
  OR?: InputMaybe<Array<CaseNegotiationRoundsConnectionWhere>>;
  node?: InputMaybe<NegotiationRoundWhere>;
};

export type CaseNegotiationRoundsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseNegotiationRoundsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseNegotiationRoundsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseNegotiationRoundsNodeAggregationWhereInput>>;
  changedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseNegotiationRoundsRelationship = {
  __typename?: 'CaseNegotiationRoundsRelationship';
  cursor: Scalars['String']['output'];
  node: NegotiationRound;
};

export type CaseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CaseSort objects to sort Cases by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CaseSort>>;
};

export type CaseRefundRefundsAggregationSelection = {
  __typename?: 'CaseRefundRefundsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CaseRefundRefundsNodeAggregateSelection>;
};

export type CaseRefundRefundsNodeAggregateSelection = {
  __typename?: 'CaseRefundRefundsNodeAggregateSelection';
  agreementId: StringAggregateSelectionNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type CaseRefundsAggregateInput = {
  AND?: InputMaybe<Array<CaseRefundsAggregateInput>>;
  NOT?: InputMaybe<CaseRefundsAggregateInput>;
  OR?: InputMaybe<Array<CaseRefundsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseRefundsNodeAggregationWhereInput>;
};

export type CaseRefundsConnection = {
  __typename?: 'CaseRefundsConnection';
  edges: Array<CaseRefundsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseRefundsConnectionSort = {
  node?: InputMaybe<RefundSort>;
};

export type CaseRefundsConnectionWhere = {
  AND?: InputMaybe<Array<CaseRefundsConnectionWhere>>;
  NOT?: InputMaybe<CaseRefundsConnectionWhere>;
  OR?: InputMaybe<Array<CaseRefundsConnectionWhere>>;
  node?: InputMaybe<RefundWhere>;
};

export type CaseRefundsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseRefundsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseRefundsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseRefundsNodeAggregationWhereInput>>;
  agreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseRefundsRelationship = {
  __typename?: 'CaseRefundsRelationship';
  cursor: Scalars['String']['output'];
  node: Refund;
};

export type CaseRelevantArticle71IndicationAggregateInput = {
  AND?: InputMaybe<Array<CaseRelevantArticle71IndicationAggregateInput>>;
  NOT?: InputMaybe<CaseRelevantArticle71IndicationAggregateInput>;
  OR?: InputMaybe<Array<CaseRelevantArticle71IndicationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseRelevantArticle71IndicationNodeAggregationWhereInput>;
};

export type CaseRelevantArticle71IndicationConnection = {
  __typename?: 'CaseRelevantArticle71IndicationConnection';
  edges: Array<CaseRelevantArticle71IndicationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseRelevantArticle71IndicationConnectionSort = {
  node?: InputMaybe<Article71IndicationSort>;
};

export type CaseRelevantArticle71IndicationConnectionWhere = {
  AND?: InputMaybe<Array<CaseRelevantArticle71IndicationConnectionWhere>>;
  NOT?: InputMaybe<CaseRelevantArticle71IndicationConnectionWhere>;
  OR?: InputMaybe<Array<CaseRelevantArticle71IndicationConnectionWhere>>;
  node?: InputMaybe<Article71IndicationWhere>;
};

export type CaseRelevantArticle71IndicationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseRelevantArticle71IndicationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseRelevantArticle71IndicationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseRelevantArticle71IndicationNodeAggregationWhereInput>>;
  countryScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  notes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseRelevantArticle71IndicationRelationship = {
  __typename?: 'CaseRelevantArticle71IndicationRelationship';
  cursor: Scalars['String']['output'];
  node: Article71Indication;
};

/** Fields to sort Cases by. The order in which sorts are applied is not guaranteed when specifying many fields in one CaseSort object. */
export type CaseSort = {
  agreement?: InputMaybe<SortDirection>;
  creationDate?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  preparationBrandName?: InputMaybe<SortDirection>;
  submissionDate?: InputMaybe<SortDirection>;
};

export type CaseWhere = {
  AND?: InputMaybe<Array<CaseWhere>>;
  NOT?: InputMaybe<CaseWhere>;
  OR?: InputMaybe<Array<CaseWhere>>;
  baseAgreement?: InputMaybe<AgreementWhere>;
  baseAgreementAggregate?: InputMaybe<CaseBaseAgreementAggregateInput>;
  baseAgreementConnection?: InputMaybe<CaseBaseAgreementConnectionWhere>;
  baseAgreementConnection_NOT?: InputMaybe<CaseBaseAgreementConnectionWhere>;
  baseAgreement_NOT?: InputMaybe<AgreementWhere>;
  creationDate?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creationDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  financialDataPointsAggregate?: InputMaybe<CaseFinancialDataPointsAggregateInput>;
  /** Return Cases where all of the related CaseFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_ALL?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
  /** Return Cases where none of the related CaseFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_NONE?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
  /** Return Cases where one of the related CaseFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SINGLE?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
  /** Return Cases where some of the related CaseFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SOME?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
  /** Return Cases where all of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_ALL?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return Cases where none of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_NONE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return Cases where one of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SINGLE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return Cases where some of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SOME?: InputMaybe<FlexFinancialDataPointWhere>;
  flexEntitiesAggregate?: InputMaybe<CaseFlexEntitiesAggregateInput>;
  /** Return Cases where all of the related CaseFlexEntitiesConnections match this filter */
  flexEntitiesConnection_ALL?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
  /** Return Cases where none of the related CaseFlexEntitiesConnections match this filter */
  flexEntitiesConnection_NONE?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
  /** Return Cases where one of the related CaseFlexEntitiesConnections match this filter */
  flexEntitiesConnection_SINGLE?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
  /** Return Cases where some of the related CaseFlexEntitiesConnections match this filter */
  flexEntitiesConnection_SOME?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
  /** Return Cases where all of the related FlexEntities match this filter */
  flexEntities_ALL?: InputMaybe<FlexEntityWhere>;
  /** Return Cases where none of the related FlexEntities match this filter */
  flexEntities_NONE?: InputMaybe<FlexEntityWhere>;
  /** Return Cases where one of the related FlexEntities match this filter */
  flexEntities_SINGLE?: InputMaybe<FlexEntityWhere>;
  /** Return Cases where some of the related FlexEntities match this filter */
  flexEntities_SOME?: InputMaybe<FlexEntityWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  negotiationRoundsAggregate?: InputMaybe<CaseNegotiationRoundsAggregateInput>;
  /** Return Cases where all of the related CaseNegotiationRoundsConnections match this filter */
  negotiationRoundsConnection_ALL?: InputMaybe<CaseNegotiationRoundsConnectionWhere>;
  /** Return Cases where none of the related CaseNegotiationRoundsConnections match this filter */
  negotiationRoundsConnection_NONE?: InputMaybe<CaseNegotiationRoundsConnectionWhere>;
  /** Return Cases where one of the related CaseNegotiationRoundsConnections match this filter */
  negotiationRoundsConnection_SINGLE?: InputMaybe<CaseNegotiationRoundsConnectionWhere>;
  /** Return Cases where some of the related CaseNegotiationRoundsConnections match this filter */
  negotiationRoundsConnection_SOME?: InputMaybe<CaseNegotiationRoundsConnectionWhere>;
  /** Return Cases where all of the related NegotiationRounds match this filter */
  negotiationRounds_ALL?: InputMaybe<NegotiationRoundWhere>;
  /** Return Cases where none of the related NegotiationRounds match this filter */
  negotiationRounds_NONE?: InputMaybe<NegotiationRoundWhere>;
  /** Return Cases where one of the related NegotiationRounds match this filter */
  negotiationRounds_SINGLE?: InputMaybe<NegotiationRoundWhere>;
  /** Return Cases where some of the related NegotiationRounds match this filter */
  negotiationRounds_SOME?: InputMaybe<NegotiationRoundWhere>;
  preparationBrandName?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationBrandName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  refundsAggregate?: InputMaybe<CaseRefundsAggregateInput>;
  /** Return Cases where all of the related CaseRefundsConnections match this filter */
  refundsConnection_ALL?: InputMaybe<CaseRefundsConnectionWhere>;
  /** Return Cases where none of the related CaseRefundsConnections match this filter */
  refundsConnection_NONE?: InputMaybe<CaseRefundsConnectionWhere>;
  /** Return Cases where one of the related CaseRefundsConnections match this filter */
  refundsConnection_SINGLE?: InputMaybe<CaseRefundsConnectionWhere>;
  /** Return Cases where some of the related CaseRefundsConnections match this filter */
  refundsConnection_SOME?: InputMaybe<CaseRefundsConnectionWhere>;
  /** Return Cases where all of the related Refunds match this filter */
  refunds_ALL?: InputMaybe<RefundWhere>;
  /** Return Cases where none of the related Refunds match this filter */
  refunds_NONE?: InputMaybe<RefundWhere>;
  /** Return Cases where one of the related Refunds match this filter */
  refunds_SINGLE?: InputMaybe<RefundWhere>;
  /** Return Cases where some of the related Refunds match this filter */
  refunds_SOME?: InputMaybe<RefundWhere>;
  relevantArticle71Indication?: InputMaybe<Article71IndicationWhere>;
  relevantArticle71IndicationAggregate?: InputMaybe<CaseRelevantArticle71IndicationAggregateInput>;
  relevantArticle71IndicationConnection?: InputMaybe<CaseRelevantArticle71IndicationConnectionWhere>;
  relevantArticle71IndicationConnection_NOT?: InputMaybe<CaseRelevantArticle71IndicationConnectionWhere>;
  relevantArticle71Indication_NOT?: InputMaybe<Article71IndicationWhere>;
  submissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  submissionDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CasesConnection = {
  __typename?: 'CasesConnection';
  edges: Array<CaseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CatalogueAttribute = {
  __typename?: 'CatalogueAttribute';
  arrayPossible?: Maybe<Scalars['Boolean']['output']>;
  attributeClasses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  caption: Scalars['String']['output'];
  customCondition?: Maybe<CustomCondition>;
  customConditionAggregate?: Maybe<CatalogueAttributeCustomConditionCustomConditionAggregationSelection>;
  customConditionConnection: CatalogueAttributeCustomConditionConnection;
  dataSubType?: Maybe<DataSubType>;
  dataType: DataType;
  decimalPrecision?: Maybe<Scalars['Int']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  dependsOn: Array<CatalogueAttribute>;
  dependsOnAggregate?: Maybe<CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection>;
  dependsOnConnection: CatalogueAttributeDependsOnConnection;
  expectedWidth?: Maybe<AttributeSize>;
  flexEntityTypes: Array<FlexEntityType>;
  flexEntityTypesAggregate?: Maybe<CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection>;
  flexEntityTypesConnection: CatalogueAttributeFlexEntityTypesConnection;
  hasDependant: Array<CatalogueAttribute>;
  hasDependantAggregate?: Maybe<CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection>;
  hasDependantConnection: CatalogueAttributeHasDependantConnection;
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  isNegotiable?: Maybe<Scalars['Boolean']['output']>;
  longLabelLocalizationKey: Scalars['String']['output'];
  maxLength?: Maybe<Scalars['Int']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  mutuallyRelevant: Array<CatalogueAttribute>;
  mutuallyRelevantAggregate?: Maybe<CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection>;
  mutuallyRelevantConnection: CatalogueAttributeMutuallyRelevantConnection;
  rules?: Maybe<Scalars['String']['output']>;
  shortLabelLocalizationKey: Scalars['String']['output'];
  type?: Maybe<CatalogueAttributeType>;
  validation?: Maybe<StatusHistorical>;
  values?: Maybe<Scalars['String']['output']>;
};


export type CatalogueAttributeCustomConditionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CustomConditionOptions>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type CatalogueAttributeCustomConditionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type CatalogueAttributeCustomConditionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CatalogueAttributeCustomConditionConnectionSort>>;
  where?: InputMaybe<CatalogueAttributeCustomConditionConnectionWhere>;
};


export type CatalogueAttributeDependsOnArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CatalogueAttributeDependsOnAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CatalogueAttributeDependsOnConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CatalogueAttributeDependsOnConnectionSort>>;
  where?: InputMaybe<CatalogueAttributeDependsOnConnectionWhere>;
};


export type CatalogueAttributeFlexEntityTypesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityTypeOptions>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type CatalogueAttributeFlexEntityTypesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type CatalogueAttributeFlexEntityTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesConnectionSort>>;
  where?: InputMaybe<CatalogueAttributeFlexEntityTypesConnectionWhere>;
};


export type CatalogueAttributeHasDependantArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CatalogueAttributeHasDependantAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CatalogueAttributeHasDependantConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CatalogueAttributeHasDependantConnectionSort>>;
  where?: InputMaybe<CatalogueAttributeHasDependantConnectionWhere>;
};


export type CatalogueAttributeMutuallyRelevantArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CatalogueAttributeMutuallyRelevantAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CatalogueAttributeMutuallyRelevantConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantConnectionSort>>;
  where?: InputMaybe<CatalogueAttributeMutuallyRelevantConnectionWhere>;
};

export type CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection>;
  node?: Maybe<CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection>;
};

export type CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection';
  comment: StringAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
};

export type CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection>;
  node?: Maybe<CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection>;
};

export type CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection';
  comment: StringAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
};

export type CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection>;
  node?: Maybe<CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection>;
};

export type CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection';
  comment: StringAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
};

export type CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type CatalogueAttributeCustomConditionAggregateInput = {
  AND?: InputMaybe<Array<CatalogueAttributeCustomConditionAggregateInput>>;
  NOT?: InputMaybe<CatalogueAttributeCustomConditionAggregateInput>;
  OR?: InputMaybe<Array<CatalogueAttributeCustomConditionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CatalogueAttributeCustomConditionNodeAggregationWhereInput>;
};

export type CatalogueAttributeCustomConditionConnection = {
  __typename?: 'CatalogueAttributeCustomConditionConnection';
  edges: Array<CatalogueAttributeCustomConditionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CatalogueAttributeCustomConditionConnectionSort = {
  node?: InputMaybe<CustomConditionSort>;
};

export type CatalogueAttributeCustomConditionConnectionWhere = {
  AND?: InputMaybe<Array<CatalogueAttributeCustomConditionConnectionWhere>>;
  NOT?: InputMaybe<CatalogueAttributeCustomConditionConnectionWhere>;
  OR?: InputMaybe<Array<CatalogueAttributeCustomConditionConnectionWhere>>;
  node?: InputMaybe<CustomConditionWhere>;
};

export type CatalogueAttributeCustomConditionCustomConditionAggregationSelection = {
  __typename?: 'CatalogueAttributeCustomConditionCustomConditionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection>;
};

export type CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection = {
  __typename?: 'CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  description: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type CatalogueAttributeCustomConditionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeCustomConditionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeCustomConditionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeCustomConditionNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeCustomConditionRelationship = {
  __typename?: 'CatalogueAttributeCustomConditionRelationship';
  cursor: Scalars['String']['output'];
  node: CustomCondition;
};

export type CatalogueAttributeDependsOnAggregateInput = {
  AND?: InputMaybe<Array<CatalogueAttributeDependsOnAggregateInput>>;
  NOT?: InputMaybe<CatalogueAttributeDependsOnAggregateInput>;
  OR?: InputMaybe<Array<CatalogueAttributeDependsOnAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<CatalogueAttributeDependsOnEdgeAggregationWhereInput>;
  node?: InputMaybe<CatalogueAttributeDependsOnNodeAggregationWhereInput>;
};

export type CatalogueAttributeDependsOnConnection = {
  __typename?: 'CatalogueAttributeDependsOnConnection';
  edges: Array<CatalogueAttributeDependsOnRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CatalogueAttributeDependsOnConnectionSort = {
  edge?: InputMaybe<DependencyAttributeSort>;
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type CatalogueAttributeDependsOnConnectionWhere = {
  AND?: InputMaybe<Array<CatalogueAttributeDependsOnConnectionWhere>>;
  NOT?: InputMaybe<CatalogueAttributeDependsOnConnectionWhere>;
  OR?: InputMaybe<Array<CatalogueAttributeDependsOnConnectionWhere>>;
  edge?: InputMaybe<DependencyAttributeWhere>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type CatalogueAttributeDependsOnEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeDependsOnEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeDependsOnEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeDependsOnEdgeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeDependsOnNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeDependsOnNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeDependsOnNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeDependsOnNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeDependsOnRelationship = DependencyAttribute & {
  __typename?: 'CatalogueAttributeDependsOnRelationship';
  comment?: Maybe<Scalars['String']['output']>;
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
  rules?: Maybe<Scalars['String']['output']>;
};

export type CatalogueAttributeEdge = {
  __typename?: 'CatalogueAttributeEdge';
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
};

export type CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection = {
  __typename?: 'CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection>;
};

export type CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection = {
  __typename?: 'CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  attributeCount: IntAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  description: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  idPrefix: StringAggregateSelectionNonNullable;
  localizationKey: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tooltipText: StringAggregateSelectionNullable;
};

export type CatalogueAttributeFlexEntityTypesAggregateInput = {
  AND?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesAggregateInput>>;
  NOT?: InputMaybe<CatalogueAttributeFlexEntityTypesAggregateInput>;
  OR?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput>;
};

export type CatalogueAttributeFlexEntityTypesConnection = {
  __typename?: 'CatalogueAttributeFlexEntityTypesConnection';
  edges: Array<CatalogueAttributeFlexEntityTypesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CatalogueAttributeFlexEntityTypesConnectionSort = {
  edge?: InputMaybe<FlexEntityTypeCatalogueAttributeRelationshipSort>;
  node?: InputMaybe<FlexEntityTypeSort>;
};

export type CatalogueAttributeFlexEntityTypesConnectionWhere = {
  AND?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesConnectionWhere>>;
  NOT?: InputMaybe<CatalogueAttributeFlexEntityTypesConnectionWhere>;
  OR?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesConnectionWhere>>;
  edge?: InputMaybe<FlexEntityTypeCatalogueAttributeRelationshipWhere>;
  node?: InputMaybe<FlexEntityTypeWhere>;
};

export type CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeFlexEntityTypesRelationship = FlexEntityTypeCatalogueAttributeRelationship & {
  __typename?: 'CatalogueAttributeFlexEntityTypesRelationship';
  cursor: Scalars['String']['output'];
  isDisplayedInCaseDetails?: Maybe<Scalars['Boolean']['output']>;
  isDisplayedInCaseTable?: Maybe<Scalars['Boolean']['output']>;
  node: FlexEntityType;
};

export type CatalogueAttributeHasDependantAggregateInput = {
  AND?: InputMaybe<Array<CatalogueAttributeHasDependantAggregateInput>>;
  NOT?: InputMaybe<CatalogueAttributeHasDependantAggregateInput>;
  OR?: InputMaybe<Array<CatalogueAttributeHasDependantAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<CatalogueAttributeHasDependantEdgeAggregationWhereInput>;
  node?: InputMaybe<CatalogueAttributeHasDependantNodeAggregationWhereInput>;
};

export type CatalogueAttributeHasDependantConnection = {
  __typename?: 'CatalogueAttributeHasDependantConnection';
  edges: Array<CatalogueAttributeHasDependantRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CatalogueAttributeHasDependantConnectionSort = {
  edge?: InputMaybe<DependencyAttributeSort>;
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type CatalogueAttributeHasDependantConnectionWhere = {
  AND?: InputMaybe<Array<CatalogueAttributeHasDependantConnectionWhere>>;
  NOT?: InputMaybe<CatalogueAttributeHasDependantConnectionWhere>;
  OR?: InputMaybe<Array<CatalogueAttributeHasDependantConnectionWhere>>;
  edge?: InputMaybe<DependencyAttributeWhere>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type CatalogueAttributeHasDependantEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeHasDependantEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeHasDependantEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeHasDependantEdgeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeHasDependantNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeHasDependantNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeHasDependantNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeHasDependantNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeHasDependantRelationship = DependencyAttribute & {
  __typename?: 'CatalogueAttributeHasDependantRelationship';
  comment?: Maybe<Scalars['String']['output']>;
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
  rules?: Maybe<Scalars['String']['output']>;
};

export type CatalogueAttributeMutuallyRelevantAggregateInput = {
  AND?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantAggregateInput>>;
  NOT?: InputMaybe<CatalogueAttributeMutuallyRelevantAggregateInput>;
  OR?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput>;
  node?: InputMaybe<CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput>;
};

export type CatalogueAttributeMutuallyRelevantConnection = {
  __typename?: 'CatalogueAttributeMutuallyRelevantConnection';
  edges: Array<CatalogueAttributeMutuallyRelevantRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CatalogueAttributeMutuallyRelevantConnectionSort = {
  edge?: InputMaybe<DependencyAttributeSort>;
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type CatalogueAttributeMutuallyRelevantConnectionWhere = {
  AND?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantConnectionWhere>>;
  NOT?: InputMaybe<CatalogueAttributeMutuallyRelevantConnectionWhere>;
  OR?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantConnectionWhere>>;
  edge?: InputMaybe<DependencyAttributeWhere>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeMutuallyRelevantRelationship = DependencyAttribute & {
  __typename?: 'CatalogueAttributeMutuallyRelevantRelationship';
  comment?: Maybe<Scalars['String']['output']>;
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
  rules?: Maybe<Scalars['String']['output']>;
};

export type CatalogueAttributeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CatalogueAttributeSort objects to sort CatalogueAttributes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CatalogueAttributeSort>>;
};

/** Fields to sort CatalogueAttributes by. The order in which sorts are applied is not guaranteed when specifying many fields in one CatalogueAttributeSort object. */
export type CatalogueAttributeSort = {
  arrayPossible?: InputMaybe<SortDirection>;
  caption?: InputMaybe<SortDirection>;
  dataSubType?: InputMaybe<SortDirection>;
  dataType?: InputMaybe<SortDirection>;
  decimalPrecision?: InputMaybe<SortDirection>;
  defaultValue?: InputMaybe<SortDirection>;
  expectedWidth?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  identifier?: InputMaybe<SortDirection>;
  isNegotiable?: InputMaybe<SortDirection>;
  longLabelLocalizationKey?: InputMaybe<SortDirection>;
  maxLength?: InputMaybe<SortDirection>;
  minLength?: InputMaybe<SortDirection>;
  rules?: InputMaybe<SortDirection>;
  shortLabelLocalizationKey?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  validation?: InputMaybe<SortDirection>;
  values?: InputMaybe<SortDirection>;
};

export enum CatalogueAttributeType {
  Form = 'FORM',
  Patient = 'PATIENT',
  Record = 'RECORD'
}

export type CatalogueAttributeWhere = {
  AND?: InputMaybe<Array<CatalogueAttributeWhere>>;
  NOT?: InputMaybe<CatalogueAttributeWhere>;
  OR?: InputMaybe<Array<CatalogueAttributeWhere>>;
  arrayPossible?: InputMaybe<Scalars['Boolean']['input']>;
  attributeClasses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributeClasses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  caption_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  caption_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  caption_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  caption_MATCHES?: InputMaybe<Scalars['String']['input']>;
  caption_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  customCondition?: InputMaybe<CustomConditionWhere>;
  customConditionAggregate?: InputMaybe<CatalogueAttributeCustomConditionAggregateInput>;
  customConditionConnection?: InputMaybe<CatalogueAttributeCustomConditionConnectionWhere>;
  customConditionConnection_NOT?: InputMaybe<CatalogueAttributeCustomConditionConnectionWhere>;
  customCondition_NOT?: InputMaybe<CustomConditionWhere>;
  dataSubType?: InputMaybe<DataSubType>;
  dataSubType_IN?: InputMaybe<Array<InputMaybe<DataSubType>>>;
  dataType?: InputMaybe<DataType>;
  dataType_IN?: InputMaybe<Array<DataType>>;
  decimalPrecision?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  decimalPrecision_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  defaultValue_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  defaultValue_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  defaultValue_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultValue_MATCHES?: InputMaybe<Scalars['String']['input']>;
  defaultValue_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  dependsOnAggregate?: InputMaybe<CatalogueAttributeDependsOnAggregateInput>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributeDependsOnConnections match this filter */
  dependsOnConnection_ALL?: InputMaybe<CatalogueAttributeDependsOnConnectionWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributeDependsOnConnections match this filter */
  dependsOnConnection_NONE?: InputMaybe<CatalogueAttributeDependsOnConnectionWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributeDependsOnConnections match this filter */
  dependsOnConnection_SINGLE?: InputMaybe<CatalogueAttributeDependsOnConnectionWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributeDependsOnConnections match this filter */
  dependsOnConnection_SOME?: InputMaybe<CatalogueAttributeDependsOnConnectionWhere>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributes match this filter */
  dependsOn_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributes match this filter */
  dependsOn_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributes match this filter */
  dependsOn_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributes match this filter */
  dependsOn_SOME?: InputMaybe<CatalogueAttributeWhere>;
  expectedWidth?: InputMaybe<AttributeSize>;
  expectedWidth_IN?: InputMaybe<Array<InputMaybe<AttributeSize>>>;
  flexEntityTypesAggregate?: InputMaybe<CatalogueAttributeFlexEntityTypesAggregateInput>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributeFlexEntityTypesConnections match this filter */
  flexEntityTypesConnection_ALL?: InputMaybe<CatalogueAttributeFlexEntityTypesConnectionWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributeFlexEntityTypesConnections match this filter */
  flexEntityTypesConnection_NONE?: InputMaybe<CatalogueAttributeFlexEntityTypesConnectionWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributeFlexEntityTypesConnections match this filter */
  flexEntityTypesConnection_SINGLE?: InputMaybe<CatalogueAttributeFlexEntityTypesConnectionWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributeFlexEntityTypesConnections match this filter */
  flexEntityTypesConnection_SOME?: InputMaybe<CatalogueAttributeFlexEntityTypesConnectionWhere>;
  /** Return CatalogueAttributes where all of the related FlexEntityTypes match this filter */
  flexEntityTypes_ALL?: InputMaybe<FlexEntityTypeWhere>;
  /** Return CatalogueAttributes where none of the related FlexEntityTypes match this filter */
  flexEntityTypes_NONE?: InputMaybe<FlexEntityTypeWhere>;
  /** Return CatalogueAttributes where one of the related FlexEntityTypes match this filter */
  flexEntityTypes_SINGLE?: InputMaybe<FlexEntityTypeWhere>;
  /** Return CatalogueAttributes where some of the related FlexEntityTypes match this filter */
  flexEntityTypes_SOME?: InputMaybe<FlexEntityTypeWhere>;
  hasDependantAggregate?: InputMaybe<CatalogueAttributeHasDependantAggregateInput>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributeHasDependantConnections match this filter */
  hasDependantConnection_ALL?: InputMaybe<CatalogueAttributeHasDependantConnectionWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributeHasDependantConnections match this filter */
  hasDependantConnection_NONE?: InputMaybe<CatalogueAttributeHasDependantConnectionWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributeHasDependantConnections match this filter */
  hasDependantConnection_SINGLE?: InputMaybe<CatalogueAttributeHasDependantConnectionWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributeHasDependantConnections match this filter */
  hasDependantConnection_SOME?: InputMaybe<CatalogueAttributeHasDependantConnectionWhere>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributes match this filter */
  hasDependant_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributes match this filter */
  hasDependant_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributes match this filter */
  hasDependant_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributes match this filter */
  hasDependant_SOME?: InputMaybe<CatalogueAttributeWhere>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifier_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  identifier_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  identifier_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  identifier_MATCHES?: InputMaybe<Scalars['String']['input']>;
  identifier_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isNegotiable?: InputMaybe<Scalars['Boolean']['input']>;
  longLabelLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  longLabelLocalizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  longLabelLocalizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  longLabelLocalizationKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  longLabelLocalizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  longLabelLocalizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  maxLength_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxLength_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength?: InputMaybe<Scalars['Int']['input']>;
  minLength_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  minLength_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutuallyRelevantAggregate?: InputMaybe<CatalogueAttributeMutuallyRelevantAggregateInput>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributeMutuallyRelevantConnections match this filter */
  mutuallyRelevantConnection_ALL?: InputMaybe<CatalogueAttributeMutuallyRelevantConnectionWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributeMutuallyRelevantConnections match this filter */
  mutuallyRelevantConnection_NONE?: InputMaybe<CatalogueAttributeMutuallyRelevantConnectionWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributeMutuallyRelevantConnections match this filter */
  mutuallyRelevantConnection_SINGLE?: InputMaybe<CatalogueAttributeMutuallyRelevantConnectionWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributeMutuallyRelevantConnections match this filter */
  mutuallyRelevantConnection_SOME?: InputMaybe<CatalogueAttributeMutuallyRelevantConnectionWhere>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributes match this filter */
  mutuallyRelevant_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributes match this filter */
  mutuallyRelevant_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributes match this filter */
  mutuallyRelevant_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributes match this filter */
  mutuallyRelevant_SOME?: InputMaybe<CatalogueAttributeWhere>;
  rules?: InputMaybe<Scalars['String']['input']>;
  rules_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  rules_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  rules_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rules_MATCHES?: InputMaybe<Scalars['String']['input']>;
  rules_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortLabelLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  shortLabelLocalizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortLabelLocalizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortLabelLocalizationKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  shortLabelLocalizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  shortLabelLocalizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CatalogueAttributeType>;
  type_IN?: InputMaybe<Array<InputMaybe<CatalogueAttributeType>>>;
  validation?: InputMaybe<StatusHistorical>;
  validation_IN?: InputMaybe<Array<InputMaybe<StatusHistorical>>>;
  values?: InputMaybe<Scalars['String']['input']>;
  values_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  values_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  values_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  values_MATCHES?: InputMaybe<Scalars['String']['input']>;
  values_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CatalogueAttributesConnection = {
  __typename?: 'CatalogueAttributesConnection';
  edges: Array<CatalogueAttributeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChartRangeConfigInput = {
  from: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type ChartRangeConfiguration = {
  __typename?: 'ChartRangeConfiguration';
  chartType: ConfigurableChartType;
};

export type ChartRangeConfigurationEdge = {
  __typename?: 'ChartRangeConfigurationEdge';
  cursor: Scalars['String']['output'];
  node: ChartRangeConfiguration;
};

export type ChartRangeConfigurationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ChartRangeConfigurationSort objects to sort ChartRangeConfigurations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ChartRangeConfigurationSort>>;
};

export type ChartRangeConfigurationRelationship = {
  from: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  to?: Maybe<Scalars['Int']['output']>;
};

export type ChartRangeConfigurationRelationshipSort = {
  from?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  to?: InputMaybe<SortDirection>;
};

export type ChartRangeConfigurationRelationshipWhere = {
  AND?: InputMaybe<Array<ChartRangeConfigurationRelationshipWhere>>;
  NOT?: InputMaybe<ChartRangeConfigurationRelationshipWhere>;
  OR?: InputMaybe<Array<ChartRangeConfigurationRelationshipWhere>>;
  from?: InputMaybe<Scalars['Int']['input']>;
  from_GT?: InputMaybe<Scalars['Int']['input']>;
  from_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  from_LT?: InputMaybe<Scalars['Int']['input']>;
  from_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
  to_GT?: InputMaybe<Scalars['Int']['input']>;
  to_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  to_LT?: InputMaybe<Scalars['Int']['input']>;
  to_LTE?: InputMaybe<Scalars['Int']['input']>;
};

/** Fields to sort ChartRangeConfigurations by. The order in which sorts are applied is not guaranteed when specifying many fields in one ChartRangeConfigurationSort object. */
export type ChartRangeConfigurationSort = {
  chartType?: InputMaybe<SortDirection>;
};

export type ChartRangeConfigurationWhere = {
  AND?: InputMaybe<Array<ChartRangeConfigurationWhere>>;
  NOT?: InputMaybe<ChartRangeConfigurationWhere>;
  OR?: InputMaybe<Array<ChartRangeConfigurationWhere>>;
  chartType?: InputMaybe<ConfigurableChartType>;
  chartType_IN?: InputMaybe<Array<ConfigurableChartType>>;
};

export type ChartRangeConfigurationsConnection = {
  __typename?: 'ChartRangeConfigurationsConnection';
  edges: Array<ChartRangeConfigurationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CheckedType = {
  __typename?: 'CheckedType';
  results: Array<IntegrityCheckCompleteResult>;
  typeName: Scalars['String']['output'];
};

export type CheckedTypeEdge = {
  __typename?: 'CheckedTypeEdge';
  cursor: Scalars['String']['output'];
  node: CheckedType;
};

export type CheckedTypeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CheckedTypeSort objects to sort CheckedTypes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CheckedTypeSort>>;
};

/** Fields to sort CheckedTypes by. The order in which sorts are applied is not guaranteed when specifying many fields in one CheckedTypeSort object. */
export type CheckedTypeSort = {
  typeName?: InputMaybe<SortDirection>;
};

export type CheckedTypeWhere = {
  AND?: InputMaybe<Array<CheckedTypeWhere>>;
  NOT?: InputMaybe<CheckedTypeWhere>;
  OR?: InputMaybe<Array<CheckedTypeWhere>>;
  typeName?: InputMaybe<Scalars['String']['input']>;
  typeName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  typeName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  typeName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  typeName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  typeName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CheckedTypesConnection = {
  __typename?: 'CheckedTypesConnection';
  edges: Array<CheckedTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClusterWorkerMetric = {
  __typename?: 'ClusterWorkerMetric';
  capturedAt?: Maybe<Scalars['Float']['output']>;
  cpuPercent: Scalars['Float']['output'];
  heapTotalBytes: Scalars['Float']['output'];
  heapUsedBytes: Scalars['Float']['output'];
  nodeIndex?: Maybe<Scalars['Int']['output']>;
  pid: Scalars['Int']['output'];
  purposes?: Maybe<Array<Scalars['String']['output']>>;
  rssBytes: Scalars['Float']['output'];
};

export type ClusterWorkerMetricEdge = {
  __typename?: 'ClusterWorkerMetricEdge';
  cursor: Scalars['String']['output'];
  node: ClusterWorkerMetric;
};

export type ClusterWorkerMetricOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ClusterWorkerMetricSort objects to sort ClusterWorkerMetrics by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ClusterWorkerMetricSort>>;
};

/** Fields to sort ClusterWorkerMetrics by. The order in which sorts are applied is not guaranteed when specifying many fields in one ClusterWorkerMetricSort object. */
export type ClusterWorkerMetricSort = {
  capturedAt?: InputMaybe<SortDirection>;
  cpuPercent?: InputMaybe<SortDirection>;
  heapTotalBytes?: InputMaybe<SortDirection>;
  heapUsedBytes?: InputMaybe<SortDirection>;
  nodeIndex?: InputMaybe<SortDirection>;
  pid?: InputMaybe<SortDirection>;
  rssBytes?: InputMaybe<SortDirection>;
};

export type ClusterWorkerMetricWhere = {
  AND?: InputMaybe<Array<ClusterWorkerMetricWhere>>;
  NOT?: InputMaybe<ClusterWorkerMetricWhere>;
  OR?: InputMaybe<Array<ClusterWorkerMetricWhere>>;
  capturedAt?: InputMaybe<Scalars['Float']['input']>;
  capturedAt_GT?: InputMaybe<Scalars['Float']['input']>;
  capturedAt_GTE?: InputMaybe<Scalars['Float']['input']>;
  capturedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  capturedAt_LT?: InputMaybe<Scalars['Float']['input']>;
  capturedAt_LTE?: InputMaybe<Scalars['Float']['input']>;
  cpuPercent?: InputMaybe<Scalars['Float']['input']>;
  cpuPercent_GT?: InputMaybe<Scalars['Float']['input']>;
  cpuPercent_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpuPercent_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  cpuPercent_LT?: InputMaybe<Scalars['Float']['input']>;
  cpuPercent_LTE?: InputMaybe<Scalars['Float']['input']>;
  heapTotalBytes?: InputMaybe<Scalars['Float']['input']>;
  heapTotalBytes_GT?: InputMaybe<Scalars['Float']['input']>;
  heapTotalBytes_GTE?: InputMaybe<Scalars['Float']['input']>;
  heapTotalBytes_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  heapTotalBytes_LT?: InputMaybe<Scalars['Float']['input']>;
  heapTotalBytes_LTE?: InputMaybe<Scalars['Float']['input']>;
  heapUsedBytes?: InputMaybe<Scalars['Float']['input']>;
  heapUsedBytes_GT?: InputMaybe<Scalars['Float']['input']>;
  heapUsedBytes_GTE?: InputMaybe<Scalars['Float']['input']>;
  heapUsedBytes_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  heapUsedBytes_LT?: InputMaybe<Scalars['Float']['input']>;
  heapUsedBytes_LTE?: InputMaybe<Scalars['Float']['input']>;
  nodeIndex?: InputMaybe<Scalars['Int']['input']>;
  nodeIndex_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeIndex_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeIndex_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nodeIndex_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeIndex_LTE?: InputMaybe<Scalars['Int']['input']>;
  pid?: InputMaybe<Scalars['Int']['input']>;
  pid_GT?: InputMaybe<Scalars['Int']['input']>;
  pid_GTE?: InputMaybe<Scalars['Int']['input']>;
  pid_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  pid_LT?: InputMaybe<Scalars['Int']['input']>;
  pid_LTE?: InputMaybe<Scalars['Int']['input']>;
  purposes?: InputMaybe<Array<Scalars['String']['input']>>;
  purposes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  rssBytes?: InputMaybe<Scalars['Float']['input']>;
  rssBytes_GT?: InputMaybe<Scalars['Float']['input']>;
  rssBytes_GTE?: InputMaybe<Scalars['Float']['input']>;
  rssBytes_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  rssBytes_LT?: InputMaybe<Scalars['Float']['input']>;
  rssBytes_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ClusterWorkerMetricsConnection = {
  __typename?: 'ClusterWorkerMetricsConnection';
  edges: Array<ClusterWorkerMetricEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClusterWorkersSnapshot = {
  __typename?: 'ClusterWorkersSnapshot';
  generatedAt: Scalars['Float']['output'];
  nodes: Array<ClusterWorkerMetric>;
  primary?: Maybe<ClusterWorkerMetric>;
};

export type ClusterWorkersSnapshotEdge = {
  __typename?: 'ClusterWorkersSnapshotEdge';
  cursor: Scalars['String']['output'];
  node: ClusterWorkersSnapshot;
};

export type ClusterWorkersSnapshotOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ClusterWorkersSnapshotSort objects to sort ClusterWorkersSnapshots by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ClusterWorkersSnapshotSort>>;
};

/** Fields to sort ClusterWorkersSnapshots by. The order in which sorts are applied is not guaranteed when specifying many fields in one ClusterWorkersSnapshotSort object. */
export type ClusterWorkersSnapshotSort = {
  generatedAt?: InputMaybe<SortDirection>;
};

export type ClusterWorkersSnapshotWhere = {
  AND?: InputMaybe<Array<ClusterWorkersSnapshotWhere>>;
  NOT?: InputMaybe<ClusterWorkersSnapshotWhere>;
  OR?: InputMaybe<Array<ClusterWorkersSnapshotWhere>>;
  generatedAt?: InputMaybe<Scalars['Float']['input']>;
  generatedAt_GT?: InputMaybe<Scalars['Float']['input']>;
  generatedAt_GTE?: InputMaybe<Scalars['Float']['input']>;
  generatedAt_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  generatedAt_LT?: InputMaybe<Scalars['Float']['input']>;
  generatedAt_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ClusterWorkersSnapshotsConnection = {
  __typename?: 'ClusterWorkersSnapshotsConnection';
  edges: Array<ClusterWorkersSnapshotEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum CodeCategory {
  Din = 'DIN',
  Gtin = 'GTIN',
  Ndc = 'NDC',
  Pharmacode = 'PHARMACODE',
  Swissmedicno8 = 'SWISSMEDICNO8'
}

export enum ConditionConsideredRating {
  A = 'A',
  Ab = 'AB',
  B = 'B',
  C = 'C',
  D = 'D',
  NoRating = 'NO_RATING'
}

export enum ConditionConsideredSecIntervention {
  PerCohort = 'PER_COHORT'
}

export enum ConditionLogicalOperator {
  And = 'AND',
  Or = 'OR'
}

export enum ConditionType {
  ActiveIngredientQuantity = 'ACTIVE_INGREDIENT_QUANTITY',
  AdverseEvent = 'ADVERSE_EVENT',
  AmountOf = 'AMOUNT_OF',
  Article71Status = 'ARTICLE71_STATUS',
  Event = 'EVENT',
  LdlLevel = 'LDL_LEVEL',
  Patent = 'PATENT',
  PrescriptionNumber = 'PRESCRIPTION_NUMBER',
  Rating = 'RATING',
  Response = 'RESPONSE',
  SecondaryInterventionRate = 'SECONDARY_INTERVENTION_RATE',
  Surgery = 'SURGERY',
  TreatmentDuration = 'TREATMENT_DURATION'
}

export type Config = {
  __typename?: 'Config';
  cacheLockLifetimeSeconds: Scalars['Int']['output'];
  questAutocompletionLockLifetimeSeconds: Scalars['Int']['output'];
};

export type ConfigEdge = {
  __typename?: 'ConfigEdge';
  cursor: Scalars['String']['output'];
  node: Config;
};

export type ConfigOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ConfigSort objects to sort Configs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ConfigSort>>;
};

/** Fields to sort Configs by. The order in which sorts are applied is not guaranteed when specifying many fields in one ConfigSort object. */
export type ConfigSort = {
  cacheLockLifetimeSeconds?: InputMaybe<SortDirection>;
  questAutocompletionLockLifetimeSeconds?: InputMaybe<SortDirection>;
};

export type ConfigWhere = {
  AND?: InputMaybe<Array<ConfigWhere>>;
  NOT?: InputMaybe<ConfigWhere>;
  OR?: InputMaybe<Array<ConfigWhere>>;
  cacheLockLifetimeSeconds?: InputMaybe<Scalars['Int']['input']>;
  cacheLockLifetimeSeconds_GT?: InputMaybe<Scalars['Int']['input']>;
  cacheLockLifetimeSeconds_GTE?: InputMaybe<Scalars['Int']['input']>;
  cacheLockLifetimeSeconds_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  cacheLockLifetimeSeconds_LT?: InputMaybe<Scalars['Int']['input']>;
  cacheLockLifetimeSeconds_LTE?: InputMaybe<Scalars['Int']['input']>;
  questAutocompletionLockLifetimeSeconds?: InputMaybe<Scalars['Int']['input']>;
  questAutocompletionLockLifetimeSeconds_GT?: InputMaybe<Scalars['Int']['input']>;
  questAutocompletionLockLifetimeSeconds_GTE?: InputMaybe<Scalars['Int']['input']>;
  questAutocompletionLockLifetimeSeconds_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  questAutocompletionLockLifetimeSeconds_LT?: InputMaybe<Scalars['Int']['input']>;
  questAutocompletionLockLifetimeSeconds_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ConfigsConnection = {
  __typename?: 'ConfigsConnection';
  edges: Array<ConfigEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ConfigurableChartType {
  DoT = 'DoT',
  Ldl = 'LDL'
}

export type ContactPersonInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum ContractStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  InApproval = 'IN_APPROVAL',
  Open = 'OPEN',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Running = 'RUNNING',
  Terminated = 'TERMINATED'
}

export type CosmosMetric = {
  __typename?: 'CosmosMetric';
  cachedAt?: Maybe<Scalars['Float']['output']>;
  cpuPercent?: Maybe<Scalars['Float']['output']>;
  memoryPercent?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  storagePercent?: Maybe<Scalars['Float']['output']>;
  unavailable: Scalars['Boolean']['output'];
};

export type CosmosMetricEdge = {
  __typename?: 'CosmosMetricEdge';
  cursor: Scalars['String']['output'];
  node: CosmosMetric;
};

export type CosmosMetricOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CosmosMetricSort objects to sort CosmosMetrics by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CosmosMetricSort>>;
};

/** Fields to sort CosmosMetrics by. The order in which sorts are applied is not guaranteed when specifying many fields in one CosmosMetricSort object. */
export type CosmosMetricSort = {
  cachedAt?: InputMaybe<SortDirection>;
  cpuPercent?: InputMaybe<SortDirection>;
  memoryPercent?: InputMaybe<SortDirection>;
  reason?: InputMaybe<SortDirection>;
  storagePercent?: InputMaybe<SortDirection>;
  unavailable?: InputMaybe<SortDirection>;
};

export type CosmosMetricWhere = {
  AND?: InputMaybe<Array<CosmosMetricWhere>>;
  NOT?: InputMaybe<CosmosMetricWhere>;
  OR?: InputMaybe<Array<CosmosMetricWhere>>;
  cachedAt?: InputMaybe<Scalars['Float']['input']>;
  cachedAt_GT?: InputMaybe<Scalars['Float']['input']>;
  cachedAt_GTE?: InputMaybe<Scalars['Float']['input']>;
  cachedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  cachedAt_LT?: InputMaybe<Scalars['Float']['input']>;
  cachedAt_LTE?: InputMaybe<Scalars['Float']['input']>;
  cpuPercent?: InputMaybe<Scalars['Float']['input']>;
  cpuPercent_GT?: InputMaybe<Scalars['Float']['input']>;
  cpuPercent_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpuPercent_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  cpuPercent_LT?: InputMaybe<Scalars['Float']['input']>;
  cpuPercent_LTE?: InputMaybe<Scalars['Float']['input']>;
  memoryPercent?: InputMaybe<Scalars['Float']['input']>;
  memoryPercent_GT?: InputMaybe<Scalars['Float']['input']>;
  memoryPercent_GTE?: InputMaybe<Scalars['Float']['input']>;
  memoryPercent_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  memoryPercent_LT?: InputMaybe<Scalars['Float']['input']>;
  memoryPercent_LTE?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  reason_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  reason_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reason_MATCHES?: InputMaybe<Scalars['String']['input']>;
  reason_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  storagePercent?: InputMaybe<Scalars['Float']['input']>;
  storagePercent_GT?: InputMaybe<Scalars['Float']['input']>;
  storagePercent_GTE?: InputMaybe<Scalars['Float']['input']>;
  storagePercent_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  storagePercent_LT?: InputMaybe<Scalars['Float']['input']>;
  storagePercent_LTE?: InputMaybe<Scalars['Float']['input']>;
  unavailable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosMetricsConnection = {
  __typename?: 'CosmosMetricsConnection';
  edges: Array<CosmosMetricEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum CountdownOperator {
  Before = 'BEFORE',
  StartingFrom = 'STARTING_FROM'
}

export enum CountdownPoint {
  Earliest = 'EARLIEST',
  Highest = 'HIGHEST',
  Latest = 'LATEST'
}

export enum CounterpartyRole {
  Buyer = 'BUYER',
  Observer = 'OBSERVER',
  Seller = 'SELLER'
}

export type CountriesConnection = {
  __typename?: 'CountriesConnection';
  edges: Array<CountryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Country = {
  __typename?: 'Country';
  CallingCodes: Array<Scalars['String']['output']>;
  agreementCount: Scalars['Int']['output'];
  alpha2Code: Scalars['String']['output'];
  alpha3Code: Scalars['String']['output'];
  codeCategories: Array<CodeCategory>;
  currencies: Array<Currency>;
  currenciesAggregate?: Maybe<CountryCurrencyCurrenciesAggregationSelection>;
  currenciesConnection: CountryCurrenciesConnection;
  currencyCount: Scalars['Int']['output'];
  flag: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numericCode: Scalars['String']['output'];
  organizationCount: Scalars['Int']['output'];
  organizations: Array<Organization>;
  organizationsAggregate?: Maybe<CountryOrganizationOrganizationsAggregationSelection>;
  organizationsConnection: CountryOrganizationsConnection;
  scopes: Array<AgreementScope>;
  scopesAggregate?: Maybe<CountryAgreementScopeScopesAggregationSelection>;
  scopesConnection: CountryScopesConnection;
  templateCount: Scalars['Int']['output'];
  treatments: Array<Treatment>;
  treatmentsAggregate?: Maybe<CountryTreatmentTreatmentsAggregationSelection>;
  treatmentsConnection: CountryTreatmentsConnection;
};


export type CountryCurrenciesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurrencyOptions>;
  where?: InputMaybe<CurrencyWhere>;
};


export type CountryCurrenciesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CurrencyWhere>;
};


export type CountryCurrenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CountryCurrenciesConnectionSort>>;
  where?: InputMaybe<CountryCurrenciesConnectionWhere>;
};


export type CountryOrganizationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type CountryOrganizationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type CountryOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CountryOrganizationsConnectionSort>>;
  where?: InputMaybe<CountryOrganizationsConnectionWhere>;
};


export type CountryScopesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementScopeOptions>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type CountryScopesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type CountryScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CountryScopesConnectionSort>>;
  where?: InputMaybe<CountryScopesConnectionWhere>;
};


export type CountryTreatmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type CountryTreatmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type CountryTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CountryTreatmentsConnectionSort>>;
  where?: InputMaybe<CountryTreatmentsConnectionWhere>;
};

export type CountryAgreementScopeScopesAggregationSelection = {
  __typename?: 'CountryAgreementScopeScopesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CountryAgreementScopeScopesEdgeAggregateSelection>;
  node?: Maybe<CountryAgreementScopeScopesNodeAggregateSelection>;
};

export type CountryAgreementScopeScopesEdgeAggregateSelection = {
  __typename?: 'CountryAgreementScopeScopesEdgeAggregateSelection';
  countryScopeId: StringAggregateSelectionNonNullable;
};

export type CountryAgreementScopeScopesNodeAggregateSelection = {
  __typename?: 'CountryAgreementScopeScopesNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
  scopeId: StringAggregateSelectionNonNullable;
};

export type CountryCurrenciesAggregateInput = {
  AND?: InputMaybe<Array<CountryCurrenciesAggregateInput>>;
  NOT?: InputMaybe<CountryCurrenciesAggregateInput>;
  OR?: InputMaybe<Array<CountryCurrenciesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CountryCurrenciesNodeAggregationWhereInput>;
};

export type CountryCurrenciesConnection = {
  __typename?: 'CountryCurrenciesConnection';
  edges: Array<CountryCurrenciesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountryCurrenciesConnectionSort = {
  node?: InputMaybe<CurrencySort>;
};

export type CountryCurrenciesConnectionWhere = {
  AND?: InputMaybe<Array<CountryCurrenciesConnectionWhere>>;
  NOT?: InputMaybe<CountryCurrenciesConnectionWhere>;
  OR?: InputMaybe<Array<CountryCurrenciesConnectionWhere>>;
  node?: InputMaybe<CurrencyWhere>;
};

export type CountryCurrenciesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CountryCurrenciesNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<CountryCurrenciesNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<CountryCurrenciesNodeAggregationWhereInput>>;
  symbol_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CountryCurrenciesRelationship = {
  __typename?: 'CountryCurrenciesRelationship';
  cursor: Scalars['String']['output'];
  node: Currency;
};

export type CountryCurrencyCurrenciesAggregationSelection = {
  __typename?: 'CountryCurrencyCurrenciesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CountryCurrencyCurrenciesNodeAggregateSelection>;
};

export type CountryCurrencyCurrenciesNodeAggregateSelection = {
  __typename?: 'CountryCurrencyCurrenciesNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNullable;
  symbol: StringAggregateSelectionNullable;
};

export type CountryEdge = {
  __typename?: 'CountryEdge';
  cursor: Scalars['String']['output'];
  node: Country;
};

export type CountryInput = {
  countryScopeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type CountryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CountrySort objects to sort Countries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CountrySort>>;
};

export type CountryOrganizationOrganizationsAggregationSelection = {
  __typename?: 'CountryOrganizationOrganizationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CountryOrganizationOrganizationsNodeAggregateSelection>;
};

export type CountryOrganizationOrganizationsNodeAggregateSelection = {
  __typename?: 'CountryOrganizationOrganizationsNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type CountryOrganizationsAggregateInput = {
  AND?: InputMaybe<Array<CountryOrganizationsAggregateInput>>;
  NOT?: InputMaybe<CountryOrganizationsAggregateInput>;
  OR?: InputMaybe<Array<CountryOrganizationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CountryOrganizationsNodeAggregationWhereInput>;
};

export type CountryOrganizationsConnection = {
  __typename?: 'CountryOrganizationsConnection';
  edges: Array<CountryOrganizationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountryOrganizationsConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type CountryOrganizationsConnectionWhere = {
  AND?: InputMaybe<Array<CountryOrganizationsConnectionWhere>>;
  NOT?: InputMaybe<CountryOrganizationsConnectionWhere>;
  OR?: InputMaybe<Array<CountryOrganizationsConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type CountryOrganizationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CountryOrganizationsNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<CountryOrganizationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CountryOrganizationsNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CountryOrganizationsRelationship = {
  __typename?: 'CountryOrganizationsRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type CountryScopeRelationship = {
  countryScopeId: Scalars['String']['output'];
};

export type CountryScopeRelationshipSort = {
  countryScopeId?: InputMaybe<SortDirection>;
};

export type CountryScopeRelationshipWhere = {
  AND?: InputMaybe<Array<CountryScopeRelationshipWhere>>;
  NOT?: InputMaybe<CountryScopeRelationshipWhere>;
  OR?: InputMaybe<Array<CountryScopeRelationshipWhere>>;
  countryScopeId?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  countryScopeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CountryScopesAggregateInput = {
  AND?: InputMaybe<Array<CountryScopesAggregateInput>>;
  NOT?: InputMaybe<CountryScopesAggregateInput>;
  OR?: InputMaybe<Array<CountryScopesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<CountryScopesEdgeAggregationWhereInput>;
  node?: InputMaybe<CountryScopesNodeAggregationWhereInput>;
};

export type CountryScopesConnection = {
  __typename?: 'CountryScopesConnection';
  edges: Array<CountryScopesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountryScopesConnectionSort = {
  edge?: InputMaybe<CountryScopeRelationshipSort>;
  node?: InputMaybe<AgreementScopeSort>;
};

export type CountryScopesConnectionWhere = {
  AND?: InputMaybe<Array<CountryScopesConnectionWhere>>;
  NOT?: InputMaybe<CountryScopesConnectionWhere>;
  OR?: InputMaybe<Array<CountryScopesConnectionWhere>>;
  edge?: InputMaybe<CountryScopeRelationshipWhere>;
  node?: InputMaybe<AgreementScopeWhere>;
};

export type CountryScopesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<CountryScopesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<CountryScopesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<CountryScopesEdgeAggregationWhereInput>>;
  countryScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CountryScopesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CountryScopesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CountryScopesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CountryScopesNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CountryScopesRelationship = CountryScopeRelationship & {
  __typename?: 'CountryScopesRelationship';
  countryScopeId: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  node: AgreementScope;
};

/** Fields to sort Countries by. The order in which sorts are applied is not guaranteed when specifying many fields in one CountrySort object. */
export type CountrySort = {
  agreementCount?: InputMaybe<SortDirection>;
  alpha2Code?: InputMaybe<SortDirection>;
  alpha3Code?: InputMaybe<SortDirection>;
  currencyCount?: InputMaybe<SortDirection>;
  flag?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  numericCode?: InputMaybe<SortDirection>;
  organizationCount?: InputMaybe<SortDirection>;
  templateCount?: InputMaybe<SortDirection>;
};

export type CountryTreatmentTreatmentsAggregationSelection = {
  __typename?: 'CountryTreatmentTreatmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CountryTreatmentTreatmentsNodeAggregateSelection>;
};

export type CountryTreatmentTreatmentsNodeAggregateSelection = {
  __typename?: 'CountryTreatmentTreatmentsNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type CountryTreatmentsAggregateInput = {
  AND?: InputMaybe<Array<CountryTreatmentsAggregateInput>>;
  NOT?: InputMaybe<CountryTreatmentsAggregateInput>;
  OR?: InputMaybe<Array<CountryTreatmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CountryTreatmentsNodeAggregationWhereInput>;
};

export type CountryTreatmentsConnection = {
  __typename?: 'CountryTreatmentsConnection';
  edges: Array<CountryTreatmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountryTreatmentsConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type CountryTreatmentsConnectionWhere = {
  AND?: InputMaybe<Array<CountryTreatmentsConnectionWhere>>;
  NOT?: InputMaybe<CountryTreatmentsConnectionWhere>;
  OR?: InputMaybe<Array<CountryTreatmentsConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type CountryTreatmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CountryTreatmentsNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<CountryTreatmentsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<CountryTreatmentsNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CountryTreatmentsRelationship = {
  __typename?: 'CountryTreatmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type CountryWhere = {
  AND?: InputMaybe<Array<CountryWhere>>;
  CallingCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  CallingCodes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<CountryWhere>;
  OR?: InputMaybe<Array<CountryWhere>>;
  alpha2Code?: InputMaybe<Scalars['String']['input']>;
  alpha2Code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  alpha2Code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  alpha2Code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  alpha2Code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  alpha2Code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  alpha3Code?: InputMaybe<Scalars['String']['input']>;
  alpha3Code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  alpha3Code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  alpha3Code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  alpha3Code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  alpha3Code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  codeCategories?: InputMaybe<Array<CodeCategory>>;
  codeCategories_INCLUDES?: InputMaybe<CodeCategory>;
  currenciesAggregate?: InputMaybe<CountryCurrenciesAggregateInput>;
  /** Return Countries where all of the related CountryCurrenciesConnections match this filter */
  currenciesConnection_ALL?: InputMaybe<CountryCurrenciesConnectionWhere>;
  /** Return Countries where none of the related CountryCurrenciesConnections match this filter */
  currenciesConnection_NONE?: InputMaybe<CountryCurrenciesConnectionWhere>;
  /** Return Countries where one of the related CountryCurrenciesConnections match this filter */
  currenciesConnection_SINGLE?: InputMaybe<CountryCurrenciesConnectionWhere>;
  /** Return Countries where some of the related CountryCurrenciesConnections match this filter */
  currenciesConnection_SOME?: InputMaybe<CountryCurrenciesConnectionWhere>;
  /** Return Countries where all of the related Currencies match this filter */
  currencies_ALL?: InputMaybe<CurrencyWhere>;
  /** Return Countries where none of the related Currencies match this filter */
  currencies_NONE?: InputMaybe<CurrencyWhere>;
  /** Return Countries where one of the related Currencies match this filter */
  currencies_SINGLE?: InputMaybe<CurrencyWhere>;
  /** Return Countries where some of the related Currencies match this filter */
  currencies_SOME?: InputMaybe<CurrencyWhere>;
  flag?: InputMaybe<Scalars['String']['input']>;
  flag_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  flag_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  flag_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  flag_MATCHES?: InputMaybe<Scalars['String']['input']>;
  flag_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  numericCode?: InputMaybe<Scalars['String']['input']>;
  numericCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  numericCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  numericCode_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  numericCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  numericCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationsAggregate?: InputMaybe<CountryOrganizationsAggregateInput>;
  /** Return Countries where all of the related CountryOrganizationsConnections match this filter */
  organizationsConnection_ALL?: InputMaybe<CountryOrganizationsConnectionWhere>;
  /** Return Countries where none of the related CountryOrganizationsConnections match this filter */
  organizationsConnection_NONE?: InputMaybe<CountryOrganizationsConnectionWhere>;
  /** Return Countries where one of the related CountryOrganizationsConnections match this filter */
  organizationsConnection_SINGLE?: InputMaybe<CountryOrganizationsConnectionWhere>;
  /** Return Countries where some of the related CountryOrganizationsConnections match this filter */
  organizationsConnection_SOME?: InputMaybe<CountryOrganizationsConnectionWhere>;
  /** Return Countries where all of the related Organizations match this filter */
  organizations_ALL?: InputMaybe<OrganizationWhere>;
  /** Return Countries where none of the related Organizations match this filter */
  organizations_NONE?: InputMaybe<OrganizationWhere>;
  /** Return Countries where one of the related Organizations match this filter */
  organizations_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return Countries where some of the related Organizations match this filter */
  organizations_SOME?: InputMaybe<OrganizationWhere>;
  scopesAggregate?: InputMaybe<CountryScopesAggregateInput>;
  /** Return Countries where all of the related CountryScopesConnections match this filter */
  scopesConnection_ALL?: InputMaybe<CountryScopesConnectionWhere>;
  /** Return Countries where none of the related CountryScopesConnections match this filter */
  scopesConnection_NONE?: InputMaybe<CountryScopesConnectionWhere>;
  /** Return Countries where one of the related CountryScopesConnections match this filter */
  scopesConnection_SINGLE?: InputMaybe<CountryScopesConnectionWhere>;
  /** Return Countries where some of the related CountryScopesConnections match this filter */
  scopesConnection_SOME?: InputMaybe<CountryScopesConnectionWhere>;
  /** Return Countries where all of the related AgreementScopes match this filter */
  scopes_ALL?: InputMaybe<AgreementScopeWhere>;
  /** Return Countries where none of the related AgreementScopes match this filter */
  scopes_NONE?: InputMaybe<AgreementScopeWhere>;
  /** Return Countries where one of the related AgreementScopes match this filter */
  scopes_SINGLE?: InputMaybe<AgreementScopeWhere>;
  /** Return Countries where some of the related AgreementScopes match this filter */
  scopes_SOME?: InputMaybe<AgreementScopeWhere>;
  treatmentsAggregate?: InputMaybe<CountryTreatmentsAggregateInput>;
  /** Return Countries where all of the related CountryTreatmentsConnections match this filter */
  treatmentsConnection_ALL?: InputMaybe<CountryTreatmentsConnectionWhere>;
  /** Return Countries where none of the related CountryTreatmentsConnections match this filter */
  treatmentsConnection_NONE?: InputMaybe<CountryTreatmentsConnectionWhere>;
  /** Return Countries where one of the related CountryTreatmentsConnections match this filter */
  treatmentsConnection_SINGLE?: InputMaybe<CountryTreatmentsConnectionWhere>;
  /** Return Countries where some of the related CountryTreatmentsConnections match this filter */
  treatmentsConnection_SOME?: InputMaybe<CountryTreatmentsConnectionWhere>;
  /** Return Countries where all of the related Treatments match this filter */
  treatments_ALL?: InputMaybe<TreatmentWhere>;
  /** Return Countries where none of the related Treatments match this filter */
  treatments_NONE?: InputMaybe<TreatmentWhere>;
  /** Return Countries where one of the related Treatments match this filter */
  treatments_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return Countries where some of the related Treatments match this filter */
  treatments_SOME?: InputMaybe<TreatmentWhere>;
};

export enum CoverageRequestRating {
  A = 'A',
  Ab = 'AB',
  B = 'B',
  C = 'C',
  D = 'D',
  NoRating = 'NO_RATING'
}

export enum CoverageRequestTherapyDecision {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Trial = 'TRIAL'
}

export type CrossCountryPrice = {
  __typename?: 'CrossCountryPrice';
  Price?: Maybe<Scalars['String']['output']>;
  ValidFromDate?: Maybe<Scalars['Date']['output']>;
};

export type CrossCountryPriceEdge = {
  __typename?: 'CrossCountryPriceEdge';
  cursor: Scalars['String']['output'];
  node: CrossCountryPrice;
};

export type CrossCountryPriceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CrossCountryPriceSort objects to sort CrossCountryPrices by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CrossCountryPriceSort>>;
};

/** Fields to sort CrossCountryPrices by. The order in which sorts are applied is not guaranteed when specifying many fields in one CrossCountryPriceSort object. */
export type CrossCountryPriceSort = {
  Price?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
};

export type CrossCountryPriceWhere = {
  AND?: InputMaybe<Array<CrossCountryPriceWhere>>;
  NOT?: InputMaybe<CrossCountryPriceWhere>;
  OR?: InputMaybe<Array<CrossCountryPriceWhere>>;
  Price?: InputMaybe<Scalars['String']['input']>;
  Price_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Price_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Price_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Price_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Price_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type CrossCountryPricesConnection = {
  __typename?: 'CrossCountryPricesConnection';
  edges: Array<CrossCountryPriceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurrenciesConnection = {
  __typename?: 'CurrenciesConnection';
  edges: Array<CurrencyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  Code?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  agreements: Array<Agreement>;
  agreementsAggregate?: Maybe<CurrencyAgreementAgreementsAggregationSelection>;
  agreementsConnection: CurrencyAgreementsConnection;
  countries: Array<Country>;
  countriesAggregate?: Maybe<CurrencyCountryCountriesAggregationSelection>;
  countriesConnection: CurrencyCountriesConnection;
  prices: Array<Price>;
  pricesAggregate?: Maybe<CurrencyPricePricesAggregationSelection>;
  pricesConnection: CurrencyPricesConnection;
  symbol?: Maybe<Scalars['String']['output']>;
};


export type CurrencyAgreementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type CurrencyAgreementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type CurrencyAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurrencyAgreementsConnectionSort>>;
  where?: InputMaybe<CurrencyAgreementsConnectionWhere>;
};


export type CurrencyCountriesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type CurrencyCountriesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type CurrencyCountriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurrencyCountriesConnectionSort>>;
  where?: InputMaybe<CurrencyCountriesConnectionWhere>;
};


export type CurrencyPricesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PriceOptions>;
  where?: InputMaybe<PriceWhere>;
};


export type CurrencyPricesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PriceWhere>;
};


export type CurrencyPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurrencyPricesConnectionSort>>;
  where?: InputMaybe<CurrencyPricesConnectionWhere>;
};

export type CurrencyAgreementAgreementsAggregationSelection = {
  __typename?: 'CurrencyAgreementAgreementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CurrencyAgreementAgreementsNodeAggregateSelection>;
};

export type CurrencyAgreementAgreementsNodeAggregateSelection = {
  __typename?: 'CurrencyAgreementAgreementsNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type CurrencyAgreementsAggregateInput = {
  AND?: InputMaybe<Array<CurrencyAgreementsAggregateInput>>;
  NOT?: InputMaybe<CurrencyAgreementsAggregateInput>;
  OR?: InputMaybe<Array<CurrencyAgreementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurrencyAgreementsNodeAggregationWhereInput>;
};

export type CurrencyAgreementsConnection = {
  __typename?: 'CurrencyAgreementsConnection';
  edges: Array<CurrencyAgreementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurrencyAgreementsConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type CurrencyAgreementsConnectionWhere = {
  AND?: InputMaybe<Array<CurrencyAgreementsConnectionWhere>>;
  NOT?: InputMaybe<CurrencyAgreementsConnectionWhere>;
  OR?: InputMaybe<Array<CurrencyAgreementsConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type CurrencyAgreementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurrencyAgreementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurrencyAgreementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurrencyAgreementsNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyAgreementsRelationship = {
  __typename?: 'CurrencyAgreementsRelationship';
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type CurrencyCountriesAggregateInput = {
  AND?: InputMaybe<Array<CurrencyCountriesAggregateInput>>;
  NOT?: InputMaybe<CurrencyCountriesAggregateInput>;
  OR?: InputMaybe<Array<CurrencyCountriesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurrencyCountriesNodeAggregationWhereInput>;
};

export type CurrencyCountriesConnection = {
  __typename?: 'CurrencyCountriesConnection';
  edges: Array<CurrencyCountriesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurrencyCountriesConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type CurrencyCountriesConnectionWhere = {
  AND?: InputMaybe<Array<CurrencyCountriesConnectionWhere>>;
  NOT?: InputMaybe<CurrencyCountriesConnectionWhere>;
  OR?: InputMaybe<Array<CurrencyCountriesConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type CurrencyCountriesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurrencyCountriesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurrencyCountriesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurrencyCountriesNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyCountriesRelationship = {
  __typename?: 'CurrencyCountriesRelationship';
  cursor: Scalars['String']['output'];
  node: Country;
};

export type CurrencyCountryCountriesAggregationSelection = {
  __typename?: 'CurrencyCountryCountriesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CurrencyCountryCountriesNodeAggregateSelection>;
};

export type CurrencyCountryCountriesNodeAggregateSelection = {
  __typename?: 'CurrencyCountryCountriesNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type CurrencyEdge = {
  __typename?: 'CurrencyEdge';
  cursor: Scalars['String']['output'];
  node: Currency;
};

export type CurrencyOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CurrencySort objects to sort Currencies by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CurrencySort>>;
};

export type CurrencyPricePricesAggregationSelection = {
  __typename?: 'CurrencyPricePricesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CurrencyPricePricesNodeAggregateSelection>;
};

export type CurrencyPricePricesNodeAggregateSelection = {
  __typename?: 'CurrencyPricePricesNodeAggregateSelection';
  Price: StringAggregateSelectionNonNullable;
  PriceChangeTypeDescriptionDe: StringAggregateSelectionNullable;
  PriceChangeTypeDescriptionFr: StringAggregateSelectionNullable;
  PriceChangeTypeDescriptionIt: StringAggregateSelectionNullable;
  PriceTypeDescriptionDe: StringAggregateSelectionNullable;
  PriceTypeDescriptionFr: StringAggregateSelectionNullable;
  PriceTypeDescriptionIt: StringAggregateSelectionNullable;
  countriesConsidered: StringAggregateSelectionNullable;
  uniqueCode: StringAggregateSelectionNonNullable;
};

export type CurrencyPricesAggregateInput = {
  AND?: InputMaybe<Array<CurrencyPricesAggregateInput>>;
  NOT?: InputMaybe<CurrencyPricesAggregateInput>;
  OR?: InputMaybe<Array<CurrencyPricesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurrencyPricesNodeAggregationWhereInput>;
};

export type CurrencyPricesConnection = {
  __typename?: 'CurrencyPricesConnection';
  edges: Array<CurrencyPricesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurrencyPricesConnectionSort = {
  node?: InputMaybe<PriceSort>;
};

export type CurrencyPricesConnectionWhere = {
  AND?: InputMaybe<Array<CurrencyPricesConnectionWhere>>;
  NOT?: InputMaybe<CurrencyPricesConnectionWhere>;
  OR?: InputMaybe<Array<CurrencyPricesConnectionWhere>>;
  node?: InputMaybe<PriceWhere>;
};

export type CurrencyPricesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurrencyPricesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurrencyPricesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurrencyPricesNodeAggregationWhereInput>>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Price_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Price_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyPricesRelationship = {
  __typename?: 'CurrencyPricesRelationship';
  cursor: Scalars['String']['output'];
  node: Price;
};

/** Fields to sort Currencies by. The order in which sorts are applied is not guaranteed when specifying many fields in one CurrencySort object. */
export type CurrencySort = {
  Code?: InputMaybe<SortDirection>;
  Name?: InputMaybe<SortDirection>;
  symbol?: InputMaybe<SortDirection>;
};

export type CurrencyWhere = {
  AND?: InputMaybe<Array<CurrencyWhere>>;
  Code?: InputMaybe<Scalars['String']['input']>;
  Code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Code_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<CurrencyWhere>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  OR?: InputMaybe<Array<CurrencyWhere>>;
  agreementsAggregate?: InputMaybe<CurrencyAgreementsAggregateInput>;
  /** Return Currencies where all of the related CurrencyAgreementsConnections match this filter */
  agreementsConnection_ALL?: InputMaybe<CurrencyAgreementsConnectionWhere>;
  /** Return Currencies where none of the related CurrencyAgreementsConnections match this filter */
  agreementsConnection_NONE?: InputMaybe<CurrencyAgreementsConnectionWhere>;
  /** Return Currencies where one of the related CurrencyAgreementsConnections match this filter */
  agreementsConnection_SINGLE?: InputMaybe<CurrencyAgreementsConnectionWhere>;
  /** Return Currencies where some of the related CurrencyAgreementsConnections match this filter */
  agreementsConnection_SOME?: InputMaybe<CurrencyAgreementsConnectionWhere>;
  /** Return Currencies where all of the related Agreements match this filter */
  agreements_ALL?: InputMaybe<AgreementWhere>;
  /** Return Currencies where none of the related Agreements match this filter */
  agreements_NONE?: InputMaybe<AgreementWhere>;
  /** Return Currencies where one of the related Agreements match this filter */
  agreements_SINGLE?: InputMaybe<AgreementWhere>;
  /** Return Currencies where some of the related Agreements match this filter */
  agreements_SOME?: InputMaybe<AgreementWhere>;
  countriesAggregate?: InputMaybe<CurrencyCountriesAggregateInput>;
  /** Return Currencies where all of the related CurrencyCountriesConnections match this filter */
  countriesConnection_ALL?: InputMaybe<CurrencyCountriesConnectionWhere>;
  /** Return Currencies where none of the related CurrencyCountriesConnections match this filter */
  countriesConnection_NONE?: InputMaybe<CurrencyCountriesConnectionWhere>;
  /** Return Currencies where one of the related CurrencyCountriesConnections match this filter */
  countriesConnection_SINGLE?: InputMaybe<CurrencyCountriesConnectionWhere>;
  /** Return Currencies where some of the related CurrencyCountriesConnections match this filter */
  countriesConnection_SOME?: InputMaybe<CurrencyCountriesConnectionWhere>;
  /** Return Currencies where all of the related Countries match this filter */
  countries_ALL?: InputMaybe<CountryWhere>;
  /** Return Currencies where none of the related Countries match this filter */
  countries_NONE?: InputMaybe<CountryWhere>;
  /** Return Currencies where one of the related Countries match this filter */
  countries_SINGLE?: InputMaybe<CountryWhere>;
  /** Return Currencies where some of the related Countries match this filter */
  countries_SOME?: InputMaybe<CountryWhere>;
  pricesAggregate?: InputMaybe<CurrencyPricesAggregateInput>;
  /** Return Currencies where all of the related CurrencyPricesConnections match this filter */
  pricesConnection_ALL?: InputMaybe<CurrencyPricesConnectionWhere>;
  /** Return Currencies where none of the related CurrencyPricesConnections match this filter */
  pricesConnection_NONE?: InputMaybe<CurrencyPricesConnectionWhere>;
  /** Return Currencies where one of the related CurrencyPricesConnections match this filter */
  pricesConnection_SINGLE?: InputMaybe<CurrencyPricesConnectionWhere>;
  /** Return Currencies where some of the related CurrencyPricesConnections match this filter */
  pricesConnection_SOME?: InputMaybe<CurrencyPricesConnectionWhere>;
  /** Return Currencies where all of the related Prices match this filter */
  prices_ALL?: InputMaybe<PriceWhere>;
  /** Return Currencies where none of the related Prices match this filter */
  prices_NONE?: InputMaybe<PriceWhere>;
  /** Return Currencies where one of the related Prices match this filter */
  prices_SINGLE?: InputMaybe<PriceWhere>;
  /** Return Currencies where some of the related Prices match this filter */
  prices_SOME?: InputMaybe<PriceWhere>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  symbol_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  symbol_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  symbol_MATCHES?: InputMaybe<Scalars['String']['input']>;
  symbol_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CustomConclusiveConditionDropdownOptionInput = {
  isNewOption?: InputMaybe<Scalars['Boolean']['input']>;
  isToBeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CustomCondition = {
  __typename?: 'CustomCondition';
  agreementCount: Scalars['Int']['output'];
  attribute: CatalogueAttribute;
  attributeAggregate?: Maybe<CustomConditionCatalogueAttributeAttributeAggregationSelection>;
  attributeConnection: CustomConditionAttributeConnection;
  conditionType: CustomConditionType;
  createdBy?: Maybe<User>;
  createdByAggregate?: Maybe<CustomConditionUserCreatedByAggregationSelection>;
  createdByConnection: CustomConditionCreatedByConnection;
  createdOn: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fieldType: CustomConditionFieldType;
  id: Scalars['ID']['output'];
  lastUpdatedOn: Scalars['DateTime']['output'];
  modelCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
};


export type CustomConditionAttributeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CustomConditionAttributeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CustomConditionAttributeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CustomConditionAttributeConnectionSort>>;
  where?: InputMaybe<CustomConditionAttributeConnectionWhere>;
};


export type CustomConditionCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type CustomConditionCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type CustomConditionCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CustomConditionCreatedByConnectionSort>>;
  where?: InputMaybe<CustomConditionCreatedByConnectionWhere>;
};

export type CustomConditionAttributeAggregateInput = {
  AND?: InputMaybe<Array<CustomConditionAttributeAggregateInput>>;
  NOT?: InputMaybe<CustomConditionAttributeAggregateInput>;
  OR?: InputMaybe<Array<CustomConditionAttributeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CustomConditionAttributeNodeAggregationWhereInput>;
};

export type CustomConditionAttributeConnection = {
  __typename?: 'CustomConditionAttributeConnection';
  edges: Array<CustomConditionAttributeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomConditionAttributeConnectionSort = {
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type CustomConditionAttributeConnectionWhere = {
  AND?: InputMaybe<Array<CustomConditionAttributeConnectionWhere>>;
  NOT?: InputMaybe<CustomConditionAttributeConnectionWhere>;
  OR?: InputMaybe<Array<CustomConditionAttributeConnectionWhere>>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type CustomConditionAttributeInput = {
  identifier: Scalars['String']['input'];
};

export type CustomConditionAttributeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CustomConditionAttributeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CustomConditionAttributeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CustomConditionAttributeNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomConditionAttributeRelationship = {
  __typename?: 'CustomConditionAttributeRelationship';
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
};

export type CustomConditionCatalogueAttributeAttributeAggregationSelection = {
  __typename?: 'CustomConditionCatalogueAttributeAttributeAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CustomConditionCatalogueAttributeAttributeNodeAggregateSelection>;
};

export type CustomConditionCatalogueAttributeAttributeNodeAggregateSelection = {
  __typename?: 'CustomConditionCatalogueAttributeAttributeNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type CustomConditionCreatedByAggregateInput = {
  AND?: InputMaybe<Array<CustomConditionCreatedByAggregateInput>>;
  NOT?: InputMaybe<CustomConditionCreatedByAggregateInput>;
  OR?: InputMaybe<Array<CustomConditionCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CustomConditionCreatedByNodeAggregationWhereInput>;
};

export type CustomConditionCreatedByConnection = {
  __typename?: 'CustomConditionCreatedByConnection';
  edges: Array<CustomConditionCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomConditionCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type CustomConditionCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<CustomConditionCreatedByConnectionWhere>>;
  NOT?: InputMaybe<CustomConditionCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<CustomConditionCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type CustomConditionCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CustomConditionCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CustomConditionCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CustomConditionCreatedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomConditionCreatedByRelationship = {
  __typename?: 'CustomConditionCreatedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type CustomConditionEdge = {
  __typename?: 'CustomConditionEdge';
  cursor: Scalars['String']['output'];
  node: CustomCondition;
};

export enum CustomConditionEventFrequency {
  AtLeastOnce = 'AT_LEAST_ONCE'
}

export enum CustomConditionEventResult {
  WithAConcreteResultUnavailable = 'WITH_A_CONCRETE_RESULT_UNAVAILABLE'
}

export enum CustomConditionEventType {
  Occurred = 'OCCURRED'
}

export enum CustomConditionFieldType {
  Boolean = 'BOOLEAN',
  Dropdown = 'DROPDOWN'
}

export type CustomConditionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CustomConditionSort objects to sort CustomConditions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CustomConditionSort>>;
};

/** Fields to sort CustomConditions by. The order in which sorts are applied is not guaranteed when specifying many fields in one CustomConditionSort object. */
export type CustomConditionSort = {
  agreementCount?: InputMaybe<SortDirection>;
  conditionType?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  fieldType?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  modelCount?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export enum CustomConditionType {
  Conclusive = 'CONCLUSIVE',
  Enrolment = 'ENROLMENT'
}

export type CustomConditionUserCreatedByAggregationSelection = {
  __typename?: 'CustomConditionUserCreatedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CustomConditionUserCreatedByNodeAggregateSelection>;
};

export type CustomConditionUserCreatedByNodeAggregateSelection = {
  __typename?: 'CustomConditionUserCreatedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type CustomConditionWhere = {
  AND?: InputMaybe<Array<CustomConditionWhere>>;
  NOT?: InputMaybe<CustomConditionWhere>;
  OR?: InputMaybe<Array<CustomConditionWhere>>;
  attribute?: InputMaybe<CatalogueAttributeWhere>;
  attributeAggregate?: InputMaybe<CustomConditionAttributeAggregateInput>;
  attributeConnection?: InputMaybe<CustomConditionAttributeConnectionWhere>;
  attributeConnection_NOT?: InputMaybe<CustomConditionAttributeConnectionWhere>;
  attribute_NOT?: InputMaybe<CatalogueAttributeWhere>;
  conditionType?: InputMaybe<CustomConditionType>;
  conditionType_IN?: InputMaybe<Array<CustomConditionType>>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<CustomConditionCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<CustomConditionCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<CustomConditionCreatedByConnectionWhere>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_MATCHES?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<CustomConditionFieldType>;
  fieldType_IN?: InputMaybe<Array<CustomConditionFieldType>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  options_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type CustomConditionsConnection = {
  __typename?: 'CustomConditionsConnection';
  edges: Array<CustomConditionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomIntegrityCheck = {
  __typename?: 'CustomIntegrityCheck';
  createdOn: Scalars['DateTime']['output'];
  expression: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  typeName: Scalars['String']['output'];
};

export type CustomIntegrityCheckEdge = {
  __typename?: 'CustomIntegrityCheckEdge';
  cursor: Scalars['String']['output'];
  node: CustomIntegrityCheck;
};

export type CustomIntegrityCheckOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CustomIntegrityCheckSort objects to sort CustomIntegrityChecks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CustomIntegrityCheckSort>>;
};

/** Fields to sort CustomIntegrityChecks by. The order in which sorts are applied is not guaranteed when specifying many fields in one CustomIntegrityCheckSort object. */
export type CustomIntegrityCheckSort = {
  createdOn?: InputMaybe<SortDirection>;
  expression?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  typeName?: InputMaybe<SortDirection>;
};

export type CustomIntegrityCheckWhere = {
  AND?: InputMaybe<Array<CustomIntegrityCheckWhere>>;
  NOT?: InputMaybe<CustomIntegrityCheckWhere>;
  OR?: InputMaybe<Array<CustomIntegrityCheckWhere>>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expression?: InputMaybe<Scalars['String']['input']>;
  expression_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  expression_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  expression_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  expression_MATCHES?: InputMaybe<Scalars['String']['input']>;
  expression_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  typeName?: InputMaybe<Scalars['String']['input']>;
  typeName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  typeName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  typeName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  typeName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  typeName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CustomIntegrityChecksConnection = {
  __typename?: 'CustomIntegrityChecksConnection';
  edges: Array<CustomIntegrityCheckEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum CycleAdherence {
  SemiStrict = 'SEMI_STRICT',
  Soft = 'SOFT',
  Strict = 'STRICT'
}

export type CycleConfiguration = {
  __typename?: 'CycleConfiguration';
  cycleStartingPoint: CycleStartingPoint;
  lengthFrom: Scalars['Int']['output'];
  lengthTo?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  recordType?: Maybe<FlexEntityType>;
  recordTypeAggregate?: Maybe<CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection>;
  recordTypeConnection: CycleConfigurationRecordTypeConnection;
  scope: AgreementScope;
  scopeAggregate?: Maybe<CycleConfigurationAgreementScopeScopeAggregationSelection>;
  scopeConnection: CycleConfigurationScopeConnection;
  startingTreatment?: Maybe<Treatment>;
  startingTreatmentAggregate?: Maybe<CycleConfigurationTreatmentStartingTreatmentAggregationSelection>;
  startingTreatmentBrand?: Maybe<Brand>;
  startingTreatmentBrandAggregate?: Maybe<CycleConfigurationBrandStartingTreatmentBrandAggregationSelection>;
  startingTreatmentBrandConnection: CycleConfigurationStartingTreatmentBrandConnection;
  startingTreatmentConnection: CycleConfigurationStartingTreatmentConnection;
  startingTreatmentGeneric?: Maybe<Generic>;
  startingTreatmentGenericAggregate?: Maybe<CycleConfigurationGenericStartingTreatmentGenericAggregationSelection>;
  startingTreatmentGenericConnection: CycleConfigurationStartingTreatmentGenericConnection;
  therapies: Array<CycleTherapyConfiguration>;
  therapiesAggregate?: Maybe<CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection>;
  therapiesConnection: CycleConfigurationTherapiesConnection;
};


export type CycleConfigurationRecordTypeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityTypeOptions>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type CycleConfigurationRecordTypeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type CycleConfigurationRecordTypeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleConfigurationRecordTypeConnectionSort>>;
  where?: InputMaybe<CycleConfigurationRecordTypeConnectionWhere>;
};


export type CycleConfigurationScopeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementScopeOptions>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type CycleConfigurationScopeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type CycleConfigurationScopeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleConfigurationScopeConnectionSort>>;
  where?: InputMaybe<CycleConfigurationScopeConnectionWhere>;
};


export type CycleConfigurationStartingTreatmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type CycleConfigurationStartingTreatmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type CycleConfigurationStartingTreatmentBrandArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type CycleConfigurationStartingTreatmentBrandAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type CycleConfigurationStartingTreatmentBrandConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandConnectionSort>>;
  where?: InputMaybe<CycleConfigurationStartingTreatmentBrandConnectionWhere>;
};


export type CycleConfigurationStartingTreatmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleConfigurationStartingTreatmentConnectionSort>>;
  where?: InputMaybe<CycleConfigurationStartingTreatmentConnectionWhere>;
};


export type CycleConfigurationStartingTreatmentGenericArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type CycleConfigurationStartingTreatmentGenericAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type CycleConfigurationStartingTreatmentGenericConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericConnectionSort>>;
  where?: InputMaybe<CycleConfigurationStartingTreatmentGenericConnectionWhere>;
};


export type CycleConfigurationTherapiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CycleTherapyConfigurationOptions>;
  where?: InputMaybe<CycleTherapyConfigurationWhere>;
};


export type CycleConfigurationTherapiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CycleTherapyConfigurationWhere>;
};


export type CycleConfigurationTherapiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleConfigurationTherapiesConnectionSort>>;
  where?: InputMaybe<CycleConfigurationTherapiesConnectionWhere>;
};

export type CycleConfigurationAgreementScopeScopeAggregationSelection = {
  __typename?: 'CycleConfigurationAgreementScopeScopeAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CycleConfigurationAgreementScopeScopeNodeAggregateSelection>;
};

export type CycleConfigurationAgreementScopeScopeNodeAggregateSelection = {
  __typename?: 'CycleConfigurationAgreementScopeScopeNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
  scopeId: StringAggregateSelectionNonNullable;
};

export type CycleConfigurationBrandStartingTreatmentBrandAggregationSelection = {
  __typename?: 'CycleConfigurationBrandStartingTreatmentBrandAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection>;
};

export type CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection = {
  __typename?: 'CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection = {
  __typename?: 'CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection>;
};

export type CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection = {
  __typename?: 'CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection';
  cycleToleranceFrom: IntAggregateSelectionNullable;
  cycleToleranceTo: IntAggregateSelectionNullable;
  dosageFrom: FloatAggregateSelectionNullable;
  dosageTo: FloatAggregateSelectionNullable;
  packQuantityFrom: IntAggregateSelectionNullable;
  packQuantityTo: IntAggregateSelectionNullable;
  recordGapFrom: IntAggregateSelectionNullable;
  recordGapTo: IntAggregateSelectionNullable;
  recordQuantityFrom: IntAggregateSelectionNullable;
  recordQuantityTo: IntAggregateSelectionNullable;
};

export type CycleConfigurationEdge = {
  __typename?: 'CycleConfigurationEdge';
  cursor: Scalars['String']['output'];
  node: CycleConfiguration;
};

export type CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection = {
  __typename?: 'CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection>;
};

export type CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection = {
  __typename?: 'CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  attributeCount: IntAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  description: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  idPrefix: StringAggregateSelectionNonNullable;
  localizationKey: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tooltipText: StringAggregateSelectionNullable;
};

export type CycleConfigurationGenericStartingTreatmentGenericAggregationSelection = {
  __typename?: 'CycleConfigurationGenericStartingTreatmentGenericAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection>;
};

export type CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection = {
  __typename?: 'CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type CycleConfigurationInput = {
  cycleStartingPoint: CycleStartingPoint;
  lengthFrom: Scalars['Int']['input'];
  lengthTo?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  recordTypeId: Scalars['String']['input'];
  scopeCode?: InputMaybe<Scalars['String']['input']>;
  startingTreatmentBrandName?: InputMaybe<Scalars['String']['input']>;
  startingTreatmentCode?: InputMaybe<Scalars['String']['input']>;
  startingTreatmentGenericName?: InputMaybe<Scalars['String']['input']>;
  therapies?: InputMaybe<Array<CycleTherapyConfigurationInput>>;
};

export type CycleConfigurationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CycleConfigurationSort objects to sort CycleConfigurations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CycleConfigurationSort>>;
};

export type CycleConfigurationRecordTypeAggregateInput = {
  AND?: InputMaybe<Array<CycleConfigurationRecordTypeAggregateInput>>;
  NOT?: InputMaybe<CycleConfigurationRecordTypeAggregateInput>;
  OR?: InputMaybe<Array<CycleConfigurationRecordTypeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleConfigurationRecordTypeNodeAggregationWhereInput>;
};

export type CycleConfigurationRecordTypeConnection = {
  __typename?: 'CycleConfigurationRecordTypeConnection';
  edges: Array<CycleConfigurationRecordTypeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleConfigurationRecordTypeConnectionSort = {
  node?: InputMaybe<FlexEntityTypeSort>;
};

export type CycleConfigurationRecordTypeConnectionWhere = {
  AND?: InputMaybe<Array<CycleConfigurationRecordTypeConnectionWhere>>;
  NOT?: InputMaybe<CycleConfigurationRecordTypeConnectionWhere>;
  OR?: InputMaybe<Array<CycleConfigurationRecordTypeConnectionWhere>>;
  node?: InputMaybe<FlexEntityTypeWhere>;
};

export type CycleConfigurationRecordTypeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleConfigurationRecordTypeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CycleConfigurationRecordTypeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CycleConfigurationRecordTypeNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CycleConfigurationRecordTypeRelationship = {
  __typename?: 'CycleConfigurationRecordTypeRelationship';
  cursor: Scalars['String']['output'];
  node: FlexEntityType;
};

export type CycleConfigurationScopeAggregateInput = {
  AND?: InputMaybe<Array<CycleConfigurationScopeAggregateInput>>;
  NOT?: InputMaybe<CycleConfigurationScopeAggregateInput>;
  OR?: InputMaybe<Array<CycleConfigurationScopeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleConfigurationScopeNodeAggregationWhereInput>;
};

export type CycleConfigurationScopeConnection = {
  __typename?: 'CycleConfigurationScopeConnection';
  edges: Array<CycleConfigurationScopeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleConfigurationScopeConnectionSort = {
  node?: InputMaybe<AgreementScopeSort>;
};

export type CycleConfigurationScopeConnectionWhere = {
  AND?: InputMaybe<Array<CycleConfigurationScopeConnectionWhere>>;
  NOT?: InputMaybe<CycleConfigurationScopeConnectionWhere>;
  OR?: InputMaybe<Array<CycleConfigurationScopeConnectionWhere>>;
  node?: InputMaybe<AgreementScopeWhere>;
};

export type CycleConfigurationScopeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleConfigurationScopeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CycleConfigurationScopeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CycleConfigurationScopeNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CycleConfigurationScopeRelationship = {
  __typename?: 'CycleConfigurationScopeRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementScope;
};

/** Fields to sort CycleConfigurations by. The order in which sorts are applied is not guaranteed when specifying many fields in one CycleConfigurationSort object. */
export type CycleConfigurationSort = {
  cycleStartingPoint?: InputMaybe<SortDirection>;
  lengthFrom?: InputMaybe<SortDirection>;
  lengthTo?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
};

export type CycleConfigurationStartingTreatmentAggregateInput = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentAggregateInput>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentAggregateInput>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleConfigurationStartingTreatmentNodeAggregationWhereInput>;
};

export type CycleConfigurationStartingTreatmentBrandAggregateInput = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandAggregateInput>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentBrandAggregateInput>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput>;
};

export type CycleConfigurationStartingTreatmentBrandConnection = {
  __typename?: 'CycleConfigurationStartingTreatmentBrandConnection';
  edges: Array<CycleConfigurationStartingTreatmentBrandRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleConfigurationStartingTreatmentBrandConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type CycleConfigurationStartingTreatmentBrandConnectionWhere = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandConnectionWhere>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentBrandConnectionWhere>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CycleConfigurationStartingTreatmentBrandRelationship = {
  __typename?: 'CycleConfigurationStartingTreatmentBrandRelationship';
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type CycleConfigurationStartingTreatmentConnection = {
  __typename?: 'CycleConfigurationStartingTreatmentConnection';
  edges: Array<CycleConfigurationStartingTreatmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleConfigurationStartingTreatmentConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type CycleConfigurationStartingTreatmentConnectionWhere = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentConnectionWhere>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentConnectionWhere>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type CycleConfigurationStartingTreatmentGenericAggregateInput = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericAggregateInput>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentGenericAggregateInput>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput>;
};

export type CycleConfigurationStartingTreatmentGenericConnection = {
  __typename?: 'CycleConfigurationStartingTreatmentGenericConnection';
  edges: Array<CycleConfigurationStartingTreatmentGenericRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleConfigurationStartingTreatmentGenericConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type CycleConfigurationStartingTreatmentGenericConnectionWhere = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericConnectionWhere>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentGenericConnectionWhere>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput>>;
};

export type CycleConfigurationStartingTreatmentGenericRelationship = {
  __typename?: 'CycleConfigurationStartingTreatmentGenericRelationship';
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type CycleConfigurationStartingTreatmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CycleConfigurationStartingTreatmentRelationship = {
  __typename?: 'CycleConfigurationStartingTreatmentRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type CycleConfigurationTherapiesAggregateInput = {
  AND?: InputMaybe<Array<CycleConfigurationTherapiesAggregateInput>>;
  NOT?: InputMaybe<CycleConfigurationTherapiesAggregateInput>;
  OR?: InputMaybe<Array<CycleConfigurationTherapiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleConfigurationTherapiesNodeAggregationWhereInput>;
};

export type CycleConfigurationTherapiesConnection = {
  __typename?: 'CycleConfigurationTherapiesConnection';
  edges: Array<CycleConfigurationTherapiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleConfigurationTherapiesConnectionSort = {
  node?: InputMaybe<CycleTherapyConfigurationSort>;
};

export type CycleConfigurationTherapiesConnectionWhere = {
  AND?: InputMaybe<Array<CycleConfigurationTherapiesConnectionWhere>>;
  NOT?: InputMaybe<CycleConfigurationTherapiesConnectionWhere>;
  OR?: InputMaybe<Array<CycleConfigurationTherapiesConnectionWhere>>;
  node?: InputMaybe<CycleTherapyConfigurationWhere>;
};

export type CycleConfigurationTherapiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleConfigurationTherapiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CycleConfigurationTherapiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CycleConfigurationTherapiesNodeAggregationWhereInput>>;
  cycleToleranceFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  packQuantityFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packQuantityFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  packQuantityFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  packQuantityFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  packQuantityFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  packQuantityFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packQuantityTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  packQuantityTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  packQuantityTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  packQuantityTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  packQuantityTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recordGapFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  recordGapFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  recordGapFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  recordGapFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  recordGapFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recordGapTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  recordGapTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  recordGapTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  recordGapTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  recordGapTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CycleConfigurationTherapiesRelationship = {
  __typename?: 'CycleConfigurationTherapiesRelationship';
  cursor: Scalars['String']['output'];
  node: CycleTherapyConfiguration;
};

export type CycleConfigurationTreatmentStartingTreatmentAggregationSelection = {
  __typename?: 'CycleConfigurationTreatmentStartingTreatmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection>;
};

export type CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection = {
  __typename?: 'CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type CycleConfigurationWhere = {
  AND?: InputMaybe<Array<CycleConfigurationWhere>>;
  NOT?: InputMaybe<CycleConfigurationWhere>;
  OR?: InputMaybe<Array<CycleConfigurationWhere>>;
  cycleStartingPoint?: InputMaybe<CycleStartingPoint>;
  cycleStartingPoint_IN?: InputMaybe<Array<CycleStartingPoint>>;
  lengthFrom?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  lengthFrom_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lengthTo_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordType?: InputMaybe<FlexEntityTypeWhere>;
  recordTypeAggregate?: InputMaybe<CycleConfigurationRecordTypeAggregateInput>;
  recordTypeConnection?: InputMaybe<CycleConfigurationRecordTypeConnectionWhere>;
  recordTypeConnection_NOT?: InputMaybe<CycleConfigurationRecordTypeConnectionWhere>;
  recordType_NOT?: InputMaybe<FlexEntityTypeWhere>;
  scope?: InputMaybe<AgreementScopeWhere>;
  scopeAggregate?: InputMaybe<CycleConfigurationScopeAggregateInput>;
  scopeConnection?: InputMaybe<CycleConfigurationScopeConnectionWhere>;
  scopeConnection_NOT?: InputMaybe<CycleConfigurationScopeConnectionWhere>;
  scope_NOT?: InputMaybe<AgreementScopeWhere>;
  startingTreatment?: InputMaybe<TreatmentWhere>;
  startingTreatmentAggregate?: InputMaybe<CycleConfigurationStartingTreatmentAggregateInput>;
  startingTreatmentBrand?: InputMaybe<BrandWhere>;
  startingTreatmentBrandAggregate?: InputMaybe<CycleConfigurationStartingTreatmentBrandAggregateInput>;
  startingTreatmentBrandConnection?: InputMaybe<CycleConfigurationStartingTreatmentBrandConnectionWhere>;
  startingTreatmentBrandConnection_NOT?: InputMaybe<CycleConfigurationStartingTreatmentBrandConnectionWhere>;
  startingTreatmentBrand_NOT?: InputMaybe<BrandWhere>;
  startingTreatmentConnection?: InputMaybe<CycleConfigurationStartingTreatmentConnectionWhere>;
  startingTreatmentConnection_NOT?: InputMaybe<CycleConfigurationStartingTreatmentConnectionWhere>;
  startingTreatmentGeneric?: InputMaybe<GenericWhere>;
  startingTreatmentGenericAggregate?: InputMaybe<CycleConfigurationStartingTreatmentGenericAggregateInput>;
  startingTreatmentGenericConnection?: InputMaybe<CycleConfigurationStartingTreatmentGenericConnectionWhere>;
  startingTreatmentGenericConnection_NOT?: InputMaybe<CycleConfigurationStartingTreatmentGenericConnectionWhere>;
  startingTreatmentGeneric_NOT?: InputMaybe<GenericWhere>;
  startingTreatment_NOT?: InputMaybe<TreatmentWhere>;
  therapiesAggregate?: InputMaybe<CycleConfigurationTherapiesAggregateInput>;
  /** Return CycleConfigurations where all of the related CycleConfigurationTherapiesConnections match this filter */
  therapiesConnection_ALL?: InputMaybe<CycleConfigurationTherapiesConnectionWhere>;
  /** Return CycleConfigurations where none of the related CycleConfigurationTherapiesConnections match this filter */
  therapiesConnection_NONE?: InputMaybe<CycleConfigurationTherapiesConnectionWhere>;
  /** Return CycleConfigurations where one of the related CycleConfigurationTherapiesConnections match this filter */
  therapiesConnection_SINGLE?: InputMaybe<CycleConfigurationTherapiesConnectionWhere>;
  /** Return CycleConfigurations where some of the related CycleConfigurationTherapiesConnections match this filter */
  therapiesConnection_SOME?: InputMaybe<CycleConfigurationTherapiesConnectionWhere>;
  /** Return CycleConfigurations where all of the related CycleTherapyConfigurations match this filter */
  therapies_ALL?: InputMaybe<CycleTherapyConfigurationWhere>;
  /** Return CycleConfigurations where none of the related CycleTherapyConfigurations match this filter */
  therapies_NONE?: InputMaybe<CycleTherapyConfigurationWhere>;
  /** Return CycleConfigurations where one of the related CycleTherapyConfigurations match this filter */
  therapies_SINGLE?: InputMaybe<CycleTherapyConfigurationWhere>;
  /** Return CycleConfigurations where some of the related CycleTherapyConfigurations match this filter */
  therapies_SOME?: InputMaybe<CycleTherapyConfigurationWhere>;
};

export type CycleConfigurationsConnection = {
  __typename?: 'CycleConfigurationsConnection';
  edges: Array<CycleConfigurationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum CycleStartingPoint {
  PreviousCycleFirstRecord = 'PREVIOUS_CYCLE_FIRST_RECORD',
  PreviousCycleLastRecord = 'PREVIOUS_CYCLE_LAST_RECORD'
}

export type CycleTherapyConfiguration = {
  __typename?: 'CycleTherapyConfiguration';
  cycleToleranceFrom?: Maybe<Scalars['Int']['output']>;
  cycleToleranceTo?: Maybe<Scalars['Int']['output']>;
  dosageFrom?: Maybe<Scalars['Float']['output']>;
  dosageTo?: Maybe<Scalars['Float']['output']>;
  expectedDays?: Maybe<Array<Scalars['Int']['output']>>;
  packQuantityFrom?: Maybe<Scalars['Int']['output']>;
  packQuantityTo?: Maybe<Scalars['Int']['output']>;
  recordGapFrom?: Maybe<Scalars['Int']['output']>;
  recordGapTo?: Maybe<Scalars['Int']['output']>;
  recordQuantityFrom?: Maybe<Scalars['Int']['output']>;
  recordQuantityTo?: Maybe<Scalars['Int']['output']>;
  treatmentSet: TreatmentSet;
  treatmentSetAggregate?: Maybe<CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection>;
  treatmentSetConnection: CycleTherapyConfigurationTreatmentSetConnection;
};


export type CycleTherapyConfigurationTreatmentSetArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentSetOptions>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type CycleTherapyConfigurationTreatmentSetAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type CycleTherapyConfigurationTreatmentSetConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetConnectionSort>>;
  where?: InputMaybe<CycleTherapyConfigurationTreatmentSetConnectionWhere>;
};

export type CycleTherapyConfigurationEdge = {
  __typename?: 'CycleTherapyConfigurationEdge';
  cursor: Scalars['String']['output'];
  node: CycleTherapyConfiguration;
};

export type CycleTherapyConfigurationInput = {
  cycleToleranceFrom?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo?: InputMaybe<Scalars['Int']['input']>;
  dosageFrom?: InputMaybe<Scalars['Float']['input']>;
  dosageTo?: InputMaybe<Scalars['Float']['input']>;
  expectedDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  genericName: Scalars['String']['input'];
  packQuantityFrom?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo?: InputMaybe<Scalars['Int']['input']>;
};

export type CycleTherapyConfigurationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CycleTherapyConfigurationSort objects to sort CycleTherapyConfigurations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CycleTherapyConfigurationSort>>;
};

/** Fields to sort CycleTherapyConfigurations by. The order in which sorts are applied is not guaranteed when specifying many fields in one CycleTherapyConfigurationSort object. */
export type CycleTherapyConfigurationSort = {
  cycleToleranceFrom?: InputMaybe<SortDirection>;
  cycleToleranceTo?: InputMaybe<SortDirection>;
  dosageFrom?: InputMaybe<SortDirection>;
  dosageTo?: InputMaybe<SortDirection>;
  packQuantityFrom?: InputMaybe<SortDirection>;
  packQuantityTo?: InputMaybe<SortDirection>;
  recordGapFrom?: InputMaybe<SortDirection>;
  recordGapTo?: InputMaybe<SortDirection>;
  recordQuantityFrom?: InputMaybe<SortDirection>;
  recordQuantityTo?: InputMaybe<SortDirection>;
};

export type CycleTherapyConfigurationTreatmentSetAggregateInput = {
  AND?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetAggregateInput>>;
  NOT?: InputMaybe<CycleTherapyConfigurationTreatmentSetAggregateInput>;
  OR?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput>;
};

export type CycleTherapyConfigurationTreatmentSetConnection = {
  __typename?: 'CycleTherapyConfigurationTreatmentSetConnection';
  edges: Array<CycleTherapyConfigurationTreatmentSetRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleTherapyConfigurationTreatmentSetConnectionSort = {
  node?: InputMaybe<TreatmentSetSort>;
};

export type CycleTherapyConfigurationTreatmentSetConnectionWhere = {
  AND?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetConnectionWhere>>;
  NOT?: InputMaybe<CycleTherapyConfigurationTreatmentSetConnectionWhere>;
  OR?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetConnectionWhere>>;
  node?: InputMaybe<TreatmentSetWhere>;
};

export type CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CycleTherapyConfigurationTreatmentSetRelationship = {
  __typename?: 'CycleTherapyConfigurationTreatmentSetRelationship';
  cursor: Scalars['String']['output'];
  node: TreatmentSet;
};

export type CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection = {
  __typename?: 'CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection>;
};

export type CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection = {
  __typename?: 'CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
};

export type CycleTherapyConfigurationWhere = {
  AND?: InputMaybe<Array<CycleTherapyConfigurationWhere>>;
  NOT?: InputMaybe<CycleTherapyConfigurationWhere>;
  OR?: InputMaybe<Array<CycleTherapyConfigurationWhere>>;
  cycleToleranceFrom?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cycleToleranceFrom_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cycleToleranceTo_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageFrom?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  dosageFrom_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  dosageTo_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_LTE?: InputMaybe<Scalars['Float']['input']>;
  expectedDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  expectedDays_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  packQuantityFrom_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_LTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  packQuantityTo_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recordGapFrom_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recordGapTo_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recordQuantityFrom_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recordQuantityTo_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatmentSet?: InputMaybe<TreatmentSetWhere>;
  treatmentSetAggregate?: InputMaybe<CycleTherapyConfigurationTreatmentSetAggregateInput>;
  treatmentSetConnection?: InputMaybe<CycleTherapyConfigurationTreatmentSetConnectionWhere>;
  treatmentSetConnection_NOT?: InputMaybe<CycleTherapyConfigurationTreatmentSetConnectionWhere>;
  treatmentSet_NOT?: InputMaybe<TreatmentSetWhere>;
};

export type CycleTherapyConfigurationsConnection = {
  __typename?: 'CycleTherapyConfigurationsConnection';
  edges: Array<CycleTherapyConfigurationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DqcDetailedReportRaw = {
  __typename?: 'DQCDetailedReportRaw';
  checkKey: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
};

export type DqcDetailedReportRawEdge = {
  __typename?: 'DQCDetailedReportRawEdge';
  cursor: Scalars['String']['output'];
  node: DqcDetailedReportRaw;
};

export type DqcDetailedReportRawOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DQCDetailedReportRawSort objects to sort DqcDetailedReportRaws by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DqcDetailedReportRawSort>>;
};

/** Fields to sort DqcDetailedReportRaws by. The order in which sorts are applied is not guaranteed when specifying many fields in one DQCDetailedReportRawSort object. */
export type DqcDetailedReportRawSort = {
  checkKey?: InputMaybe<SortDirection>;
  entityId?: InputMaybe<SortDirection>;
  organizationName?: InputMaybe<SortDirection>;
};

export type DqcDetailedReportRawWhere = {
  AND?: InputMaybe<Array<DqcDetailedReportRawWhere>>;
  NOT?: InputMaybe<DqcDetailedReportRawWhere>;
  OR?: InputMaybe<Array<DqcDetailedReportRawWhere>>;
  checkKey?: InputMaybe<Scalars['String']['input']>;
  checkKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  checkKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  checkKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  checkKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  checkKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  entityId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  entityId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  entityId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  entityId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DataContainer = {
  __typename?: 'DataContainer';
  creationWays?: Maybe<Array<DataContainerCreationWay>>;
  isStartingPoint?: Maybe<Scalars['Boolean']['output']>;
  providers: Array<Organization>;
  providersAggregate?: Maybe<DataContainerOrganizationProvidersAggregationSelection>;
  providersConnection: DataContainerProvidersConnection;
  restrictedDataPointNames: Array<Scalars['String']['output']>;
  sharedDataPointNames: Array<Scalars['String']['output']>;
  sharingTrigger: DataContainerSharingTrigger;
  subType?: Maybe<Scalars['String']['output']>;
  timeframeEnd?: Maybe<Scalars['Int']['output']>;
  timeframeRangeType?: Maybe<TimeframeRangeType>;
  timeframeStart?: Maybe<Scalars['Int']['output']>;
  timeframeStartingPoint?: Maybe<TimeframeStartingPoint>;
  type: DataContainerType;
};


export type DataContainerProvidersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type DataContainerProvidersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type DataContainerProvidersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DataContainerProvidersConnectionSort>>;
  where?: InputMaybe<DataContainerProvidersConnectionWhere>;
};

export enum DataContainerCreationWay {
  ManualEntry = 'MANUAL_ENTRY',
  Upload = 'UPLOAD'
}

export type DataContainerEdge = {
  __typename?: 'DataContainerEdge';
  cursor: Scalars['String']['output'];
  node: DataContainer;
};

export type DataContainerInput = {
  creationWays?: InputMaybe<Array<DataContainerCreationWay>>;
  isStartingPoint?: InputMaybe<Scalars['Boolean']['input']>;
  providers: Array<DataContainerOrganizationInput>;
  restrictedDataPointNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedDataPointNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sharingTrigger: DataContainerSharingTrigger;
  subType?: InputMaybe<Scalars['String']['input']>;
  timeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeType?: InputMaybe<TimeframeRangeType>;
  timeframeStart?: InputMaybe<Scalars['Int']['input']>;
  timeframeStartingPoint?: InputMaybe<TimeframeStartingPoint>;
  type: FlexContainerType;
};

export type DataContainerOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DataContainerSort objects to sort DataContainers by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DataContainerSort>>;
};

export type DataContainerOrganizationInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type DataContainerOrganizationProvidersAggregationSelection = {
  __typename?: 'DataContainerOrganizationProvidersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DataContainerOrganizationProvidersNodeAggregateSelection>;
};

export type DataContainerOrganizationProvidersNodeAggregateSelection = {
  __typename?: 'DataContainerOrganizationProvidersNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type DataContainerProvidersAggregateInput = {
  AND?: InputMaybe<Array<DataContainerProvidersAggregateInput>>;
  NOT?: InputMaybe<DataContainerProvidersAggregateInput>;
  OR?: InputMaybe<Array<DataContainerProvidersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DataContainerProvidersNodeAggregationWhereInput>;
};

export type DataContainerProvidersConnection = {
  __typename?: 'DataContainerProvidersConnection';
  edges: Array<DataContainerProvidersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DataContainerProvidersConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type DataContainerProvidersConnectionWhere = {
  AND?: InputMaybe<Array<DataContainerProvidersConnectionWhere>>;
  NOT?: InputMaybe<DataContainerProvidersConnectionWhere>;
  OR?: InputMaybe<Array<DataContainerProvidersConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type DataContainerProvidersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DataContainerProvidersNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<DataContainerProvidersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DataContainerProvidersNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DataContainerProvidersRelationship = {
  __typename?: 'DataContainerProvidersRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export enum DataContainerSharingTrigger {
  AgreementInclusion = 'AGREEMENT_INCLUSION',
  InvoiceCreation = 'INVOICE_CREATION',
  Never = 'NEVER'
}

/** Fields to sort DataContainers by. The order in which sorts are applied is not guaranteed when specifying many fields in one DataContainerSort object. */
export type DataContainerSort = {
  isStartingPoint?: InputMaybe<SortDirection>;
  sharingTrigger?: InputMaybe<SortDirection>;
  subType?: InputMaybe<SortDirection>;
  timeframeEnd?: InputMaybe<SortDirection>;
  timeframeRangeType?: InputMaybe<SortDirection>;
  timeframeStart?: InputMaybe<SortDirection>;
  timeframeStartingPoint?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum DataContainerType {
  Form = 'FORM',
  Record = 'RECORD'
}

export type DataContainerWhere = {
  AND?: InputMaybe<Array<DataContainerWhere>>;
  NOT?: InputMaybe<DataContainerWhere>;
  OR?: InputMaybe<Array<DataContainerWhere>>;
  creationWays?: InputMaybe<Array<DataContainerCreationWay>>;
  creationWays_INCLUDES?: InputMaybe<DataContainerCreationWay>;
  providersAggregate?: InputMaybe<DataContainerProvidersAggregateInput>;
  /** Return DataContainers where all of the related DataContainerProvidersConnections match this filter */
  providersConnection_ALL?: InputMaybe<DataContainerProvidersConnectionWhere>;
  /** Return DataContainers where none of the related DataContainerProvidersConnections match this filter */
  providersConnection_NONE?: InputMaybe<DataContainerProvidersConnectionWhere>;
  /** Return DataContainers where one of the related DataContainerProvidersConnections match this filter */
  providersConnection_SINGLE?: InputMaybe<DataContainerProvidersConnectionWhere>;
  /** Return DataContainers where some of the related DataContainerProvidersConnections match this filter */
  providersConnection_SOME?: InputMaybe<DataContainerProvidersConnectionWhere>;
  /** Return DataContainers where all of the related Organizations match this filter */
  providers_ALL?: InputMaybe<OrganizationWhere>;
  /** Return DataContainers where none of the related Organizations match this filter */
  providers_NONE?: InputMaybe<OrganizationWhere>;
  /** Return DataContainers where one of the related Organizations match this filter */
  providers_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return DataContainers where some of the related Organizations match this filter */
  providers_SOME?: InputMaybe<OrganizationWhere>;
  restrictedDataPointNames?: InputMaybe<Array<Scalars['String']['input']>>;
  restrictedDataPointNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  sharedDataPointNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedDataPointNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  sharingTrigger?: InputMaybe<DataContainerSharingTrigger>;
  sharingTrigger_IN?: InputMaybe<Array<DataContainerSharingTrigger>>;
  subType?: InputMaybe<Scalars['String']['input']>;
  subType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  subType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  subType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subType_MATCHES?: InputMaybe<Scalars['String']['input']>;
  subType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeType?: InputMaybe<TimeframeRangeType>;
  timeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
  timeframeStart?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeStart_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStartingPoint?: InputMaybe<TimeframeStartingPoint>;
  timeframeStartingPoint_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
  type?: InputMaybe<DataContainerType>;
  type_IN?: InputMaybe<Array<DataContainerType>>;
};

export type DataContainersConnection = {
  __typename?: 'DataContainersConnection';
  edges: Array<DataContainerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DataSource = {
  __typename?: 'DataSource';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DataSourceEdge = {
  __typename?: 'DataSourceEdge';
  cursor: Scalars['String']['output'];
  node: DataSource;
};

export type DataSourceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DataSourceSort objects to sort DataSources by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DataSourceSort>>;
};

/** Fields to sort DataSources by. The order in which sorts are applied is not guaranteed when specifying many fields in one DataSourceSort object. */
export type DataSourceSort = {
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type DataSourceWhere = {
  AND?: InputMaybe<Array<DataSourceWhere>>;
  NOT?: InputMaybe<DataSourceWhere>;
  OR?: InputMaybe<Array<DataSourceWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DataSourcesConnection = {
  __typename?: 'DataSourcesConnection';
  edges: Array<DataSourceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum DataSubType {
  Chat = 'CHAT',
  Table = 'TABLE'
}

export enum DataType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Number = 'NUMBER',
  Text = 'TEXT',
  Widget = 'WIDGET'
}

export type DateTimeAggregateSelectionNonNullable = {
  __typename?: 'DateTimeAggregateSelectionNonNullable';
  max: Scalars['DateTime']['output'];
  min: Scalars['DateTime']['output'];
};

export type DateTimeAggregateSelectionNullable = {
  __typename?: 'DateTimeAggregateSelectionNullable';
  max?: Maybe<Scalars['DateTime']['output']>;
  min?: Maybe<Scalars['DateTime']['output']>;
};

export enum Decision {
  Approve = 'APPROVE',
  Reject = 'REJECT'
}

export type DefaultAgreementRoleInfo = {
  __typename?: 'DefaultAgreementRoleInfo';
  caseAssignee?: Maybe<AssigneeStatus>;
  documentAssignee?: Maybe<AssigneeStatus>;
  firstName?: Maybe<Scalars['String']['output']>;
  isAgreementAssignee?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  role: AgreementUserRole;
  tagName: Scalars['String']['output'];
  tagType: AgreementTagType;
  userId: Scalars['String']['output'];
};

export type DefaultAgreementRoleInfoEdge = {
  __typename?: 'DefaultAgreementRoleInfoEdge';
  cursor: Scalars['String']['output'];
  node: DefaultAgreementRoleInfo;
};

export type DefaultAgreementRoleInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DefaultAgreementRoleInfoSort objects to sort DefaultAgreementRoleInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DefaultAgreementRoleInfoSort>>;
};

/** Fields to sort DefaultAgreementRoleInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one DefaultAgreementRoleInfoSort object. */
export type DefaultAgreementRoleInfoSort = {
  caseAssignee?: InputMaybe<SortDirection>;
  documentAssignee?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  isAgreementAssignee?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  tagName?: InputMaybe<SortDirection>;
  tagType?: InputMaybe<SortDirection>;
  userId?: InputMaybe<SortDirection>;
};

export type DefaultAgreementRoleInfoWhere = {
  AND?: InputMaybe<Array<DefaultAgreementRoleInfoWhere>>;
  NOT?: InputMaybe<DefaultAgreementRoleInfoWhere>;
  OR?: InputMaybe<Array<DefaultAgreementRoleInfoWhere>>;
  caseAssignee?: InputMaybe<AssigneeStatus>;
  caseAssignee_IN?: InputMaybe<Array<InputMaybe<AssigneeStatus>>>;
  documentAssignee?: InputMaybe<AssigneeStatus>;
  documentAssignee_IN?: InputMaybe<Array<InputMaybe<AssigneeStatus>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isAgreementAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<AgreementUserRole>;
  role_IN?: InputMaybe<Array<AgreementUserRole>>;
  tagName?: InputMaybe<Scalars['String']['input']>;
  tagName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tagName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tagName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tagName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tagName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<AgreementTagType>;
  tagType_IN?: InputMaybe<Array<AgreementTagType>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  userId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultAgreementRoleInfosConnection = {
  __typename?: 'DefaultAgreementRoleInfosConnection';
  edges: Array<DefaultAgreementRoleInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DefaultReceiverProperties = {
  email: Scalars['String']['output'];
  notificationId: Scalars['Int']['output'];
  tagType: AgreementTagType;
};

export type DefaultReceiverPropertiesSort = {
  email?: InputMaybe<SortDirection>;
  notificationId?: InputMaybe<SortDirection>;
  tagType?: InputMaybe<SortDirection>;
};

export type DefaultReceiverPropertiesWhere = {
  AND?: InputMaybe<Array<DefaultReceiverPropertiesWhere>>;
  NOT?: InputMaybe<DefaultReceiverPropertiesWhere>;
  OR?: InputMaybe<Array<DefaultReceiverPropertiesWhere>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  notificationId_GT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_GTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  notificationId_LT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_LTE?: InputMaybe<Scalars['Int']['input']>;
  tagType?: InputMaybe<AgreementTagType>;
  tagType_IN?: InputMaybe<Array<AgreementTagType>>;
};

export type DefaultUserRoleUpdateInput = {
  agreementAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  agreementTag: AgreementTagType;
  caseAssignee?: InputMaybe<AssigneeStatus>;
  documentAssignee?: InputMaybe<AssigneeStatus>;
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum DeltaType {
  Any = 'ANY',
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type DependencyAttribute = {
  comment?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Scalars['String']['output']>;
};

export type DependencyAttributeSort = {
  comment?: InputMaybe<SortDirection>;
  rules?: InputMaybe<SortDirection>;
};

export type DependencyAttributeWhere = {
  AND?: InputMaybe<Array<DependencyAttributeWhere>>;
  NOT?: InputMaybe<DependencyAttributeWhere>;
  OR?: InputMaybe<Array<DependencyAttributeWhere>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comment_MATCHES?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
  rules_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  rules_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  rules_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rules_MATCHES?: InputMaybe<Scalars['String']['input']>;
  rules_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceAgreementInput = {
  allowedForms?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  counterparties: Array<AgreementCounterpartyInput>;
  coveringFormWaitInterval?: InputMaybe<Scalars['Int']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  dataContainers: Array<DataContainerInput>;
  dataSourceId: Scalars['ID']['input'];
  financialSummaryConfig: Array<FinancialSummaryConfigInput>;
  formattedAmount?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties?: InputMaybe<Scalars['String']['input']>;
  formattedProducts?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  initialVersionId?: InputMaybe<Scalars['ID']['input']>;
  isAllowedFormsEnabled: Scalars['Boolean']['input'];
  isAllowedRecordsEnabled: Scalars['Boolean']['input'];
  isCoveringIntervalEnabled: Scalars['Boolean']['input'];
  isInsightsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isPush?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredFormsEnabled: Scalars['Boolean']['input'];
  isRequiredRecordsEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  requiredForms?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  scenarios: Array<ScenarioInput>;
  status?: InputMaybe<ContractStatus>;
  subjectMatter: AgreementSubjectMatter;
  tags: Array<AgreementTagInput>;
  userRoles: Array<AgreementUserRoleInput>;
  validFromDate: Scalars['Date']['input'];
  validToDate?: InputMaybe<Scalars['Date']['input']>;
};

export type DeviceAlternative = {
  __typename?: 'DeviceAlternative';
  alternatives: Array<Treatment>;
  alternativesAggregate?: Maybe<DeviceAlternativeTreatmentAlternativesAggregationSelection>;
  alternativesConnection: DeviceAlternativeAlternativesConnection;
  code: Scalars['String']['output'];
  deviceProduct: Treatment;
  deviceProductAggregate?: Maybe<DeviceAlternativeTreatmentDeviceProductAggregationSelection>;
  deviceProductConnection: DeviceAlternativeDeviceProductConnection;
};


export type DeviceAlternativeAlternativesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type DeviceAlternativeAlternativesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type DeviceAlternativeAlternativesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DeviceAlternativeAlternativesConnectionSort>>;
  where?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
};


export type DeviceAlternativeDeviceProductArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type DeviceAlternativeDeviceProductAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type DeviceAlternativeDeviceProductConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DeviceAlternativeDeviceProductConnectionSort>>;
  where?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
};

export type DeviceAlternativeAlternativesAggregateInput = {
  AND?: InputMaybe<Array<DeviceAlternativeAlternativesAggregateInput>>;
  NOT?: InputMaybe<DeviceAlternativeAlternativesAggregateInput>;
  OR?: InputMaybe<Array<DeviceAlternativeAlternativesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DeviceAlternativeAlternativesNodeAggregationWhereInput>;
};

export type DeviceAlternativeAlternativesConnection = {
  __typename?: 'DeviceAlternativeAlternativesConnection';
  edges: Array<DeviceAlternativeAlternativesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceAlternativeAlternativesConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type DeviceAlternativeAlternativesConnectionWhere = {
  AND?: InputMaybe<Array<DeviceAlternativeAlternativesConnectionWhere>>;
  NOT?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
  OR?: InputMaybe<Array<DeviceAlternativeAlternativesConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type DeviceAlternativeAlternativesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DeviceAlternativeAlternativesNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<DeviceAlternativeAlternativesNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<DeviceAlternativeAlternativesNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceAlternativeAlternativesRelationship = {
  __typename?: 'DeviceAlternativeAlternativesRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type DeviceAlternativeDeviceProductAggregateInput = {
  AND?: InputMaybe<Array<DeviceAlternativeDeviceProductAggregateInput>>;
  NOT?: InputMaybe<DeviceAlternativeDeviceProductAggregateInput>;
  OR?: InputMaybe<Array<DeviceAlternativeDeviceProductAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DeviceAlternativeDeviceProductNodeAggregationWhereInput>;
};

export type DeviceAlternativeDeviceProductConnection = {
  __typename?: 'DeviceAlternativeDeviceProductConnection';
  edges: Array<DeviceAlternativeDeviceProductRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceAlternativeDeviceProductConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type DeviceAlternativeDeviceProductConnectionWhere = {
  AND?: InputMaybe<Array<DeviceAlternativeDeviceProductConnectionWhere>>;
  NOT?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
  OR?: InputMaybe<Array<DeviceAlternativeDeviceProductConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type DeviceAlternativeDeviceProductNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DeviceAlternativeDeviceProductNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<DeviceAlternativeDeviceProductNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<DeviceAlternativeDeviceProductNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceAlternativeDeviceProductRelationship = {
  __typename?: 'DeviceAlternativeDeviceProductRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type DeviceAlternativeEdge = {
  __typename?: 'DeviceAlternativeEdge';
  cursor: Scalars['String']['output'];
  node: DeviceAlternative;
};

export type DeviceAlternativeInput = {
  alternatives: Array<TreatmentInput>;
  code: Scalars['String']['input'];
  deviceProduct: TreatmentInput;
};

export type DeviceAlternativeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DeviceAlternativeSort objects to sort DeviceAlternatives by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DeviceAlternativeSort>>;
};

/** Fields to sort DeviceAlternatives by. The order in which sorts are applied is not guaranteed when specifying many fields in one DeviceAlternativeSort object. */
export type DeviceAlternativeSort = {
  code?: InputMaybe<SortDirection>;
};

export type DeviceAlternativeTreatmentAlternativesAggregationSelection = {
  __typename?: 'DeviceAlternativeTreatmentAlternativesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DeviceAlternativeTreatmentAlternativesNodeAggregateSelection>;
};

export type DeviceAlternativeTreatmentAlternativesNodeAggregateSelection = {
  __typename?: 'DeviceAlternativeTreatmentAlternativesNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type DeviceAlternativeTreatmentDeviceProductAggregationSelection = {
  __typename?: 'DeviceAlternativeTreatmentDeviceProductAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection>;
};

export type DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection = {
  __typename?: 'DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type DeviceAlternativeWhere = {
  AND?: InputMaybe<Array<DeviceAlternativeWhere>>;
  NOT?: InputMaybe<DeviceAlternativeWhere>;
  OR?: InputMaybe<Array<DeviceAlternativeWhere>>;
  alternativesAggregate?: InputMaybe<DeviceAlternativeAlternativesAggregateInput>;
  /** Return DeviceAlternatives where all of the related DeviceAlternativeAlternativesConnections match this filter */
  alternativesConnection_ALL?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
  /** Return DeviceAlternatives where none of the related DeviceAlternativeAlternativesConnections match this filter */
  alternativesConnection_NONE?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
  /** Return DeviceAlternatives where one of the related DeviceAlternativeAlternativesConnections match this filter */
  alternativesConnection_SINGLE?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
  /** Return DeviceAlternatives where some of the related DeviceAlternativeAlternativesConnections match this filter */
  alternativesConnection_SOME?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
  /** Return DeviceAlternatives where all of the related Treatments match this filter */
  alternatives_ALL?: InputMaybe<TreatmentWhere>;
  /** Return DeviceAlternatives where none of the related Treatments match this filter */
  alternatives_NONE?: InputMaybe<TreatmentWhere>;
  /** Return DeviceAlternatives where one of the related Treatments match this filter */
  alternatives_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return DeviceAlternatives where some of the related Treatments match this filter */
  alternatives_SOME?: InputMaybe<TreatmentWhere>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  deviceProduct?: InputMaybe<TreatmentWhere>;
  deviceProductAggregate?: InputMaybe<DeviceAlternativeDeviceProductAggregateInput>;
  deviceProductConnection?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
  deviceProductConnection_NOT?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
  deviceProduct_NOT?: InputMaybe<TreatmentWhere>;
};

export type DeviceAlternativesConnection = {
  __typename?: 'DeviceAlternativesConnection';
  edges: Array<DeviceAlternativeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DisabledDataCheck = {
  __typename?: 'DisabledDataCheck';
  createdOn: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type DisabledDataCheckEdge = {
  __typename?: 'DisabledDataCheckEdge';
  cursor: Scalars['String']['output'];
  node: DisabledDataCheck;
};

export type DisabledDataCheckOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DisabledDataCheckSort objects to sort DisabledDataChecks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DisabledDataCheckSort>>;
};

/** Fields to sort DisabledDataChecks by. The order in which sorts are applied is not guaranteed when specifying many fields in one DisabledDataCheckSort object. */
export type DisabledDataCheckSort = {
  createdOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
};

export type DisabledDataCheckWhere = {
  AND?: InputMaybe<Array<DisabledDataCheckWhere>>;
  NOT?: InputMaybe<DisabledDataCheckWhere>;
  OR?: InputMaybe<Array<DisabledDataCheckWhere>>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type DisabledDataChecksConnection = {
  __typename?: 'DisabledDataChecksConnection';
  edges: Array<DisabledDataCheckEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Disease = {
  __typename?: 'Disease';
  Icd10Code: Scalars['String']['output'];
  Name: Scalars['String']['output'];
};

export type DiseaseEdge = {
  __typename?: 'DiseaseEdge';
  cursor: Scalars['String']['output'];
  node: Disease;
};

export type DiseaseInput = {
  Icd10Code: Scalars['String']['input'];
  Name: Scalars['String']['input'];
  Score?: InputMaybe<Scalars['Float']['input']>;
};

export type DiseaseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DiseaseSort objects to sort Diseases by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DiseaseSort>>;
};

/** Fields to sort Diseases by. The order in which sorts are applied is not guaranteed when specifying many fields in one DiseaseSort object. */
export type DiseaseSort = {
  Icd10Code?: InputMaybe<SortDirection>;
  Name?: InputMaybe<SortDirection>;
};

export type DiseaseWhere = {
  AND?: InputMaybe<Array<DiseaseWhere>>;
  Icd10Code?: InputMaybe<Scalars['String']['input']>;
  Icd10Code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Icd10Code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Icd10Code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Icd10Code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Icd10Code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<DiseaseWhere>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  OR?: InputMaybe<Array<DiseaseWhere>>;
};

export type DiseasesConnection = {
  __typename?: 'DiseasesConnection';
  edges: Array<DiseaseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Document = {
  __typename?: 'Document';
  counterParties?: Maybe<Scalars['String']['output']>;
  coveragePeriod?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['DateTime']['output'];
  documentRefundGroups: Array<DocumentRefundGroup>;
  documentRefundGroupsAggregate?: Maybe<DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection>;
  documentRefundGroupsConnection: DocumentDocumentRefundGroupsConnection;
  id: Scalars['ID']['output'];
  isConfirmedBySeller?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isSentToSmartMip?: Maybe<Scalars['Boolean']['output']>;
  issuedOn?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedOn?: Maybe<Scalars['DateTime']['output']>;
  refunds: Array<Refund>;
  refundsAggregate?: Maybe<DocumentRefundRefundsAggregationSelection>;
  refundsConnection: DocumentRefundsConnection;
  settledOn?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<DocumentStatus>;
  tenantIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<DocumentType>;
};


export type DocumentDocumentRefundGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentRefundGroupOptions>;
  where?: InputMaybe<DocumentRefundGroupWhere>;
};


export type DocumentDocumentRefundGroupsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentRefundGroupWhere>;
};


export type DocumentDocumentRefundGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentDocumentRefundGroupsConnectionSort>>;
  where?: InputMaybe<DocumentDocumentRefundGroupsConnectionWhere>;
};


export type DocumentRefundsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type DocumentRefundsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RefundWhere>;
};


export type DocumentRefundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentRefundsConnectionSort>>;
  where?: InputMaybe<DocumentRefundsConnectionWhere>;
};

export type DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection = {
  __typename?: 'DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection>;
};

export type DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection = {
  __typename?: 'DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
};

export type DocumentDocumentRefundGroupsAggregateInput = {
  AND?: InputMaybe<Array<DocumentDocumentRefundGroupsAggregateInput>>;
  NOT?: InputMaybe<DocumentDocumentRefundGroupsAggregateInput>;
  OR?: InputMaybe<Array<DocumentDocumentRefundGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentDocumentRefundGroupsNodeAggregationWhereInput>;
};

export type DocumentDocumentRefundGroupsConnection = {
  __typename?: 'DocumentDocumentRefundGroupsConnection';
  edges: Array<DocumentDocumentRefundGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentDocumentRefundGroupsConnectionSort = {
  node?: InputMaybe<DocumentRefundGroupSort>;
};

export type DocumentDocumentRefundGroupsConnectionWhere = {
  AND?: InputMaybe<Array<DocumentDocumentRefundGroupsConnectionWhere>>;
  NOT?: InputMaybe<DocumentDocumentRefundGroupsConnectionWhere>;
  OR?: InputMaybe<Array<DocumentDocumentRefundGroupsConnectionWhere>>;
  node?: InputMaybe<DocumentRefundGroupWhere>;
};

export type DocumentDocumentRefundGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentDocumentRefundGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentDocumentRefundGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentDocumentRefundGroupsNodeAggregationWhereInput>>;
};

export type DocumentDocumentRefundGroupsRelationship = {
  __typename?: 'DocumentDocumentRefundGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: DocumentRefundGroup;
};

export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type DocumentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentSort objects to sort Documents by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentSort>>;
};

export type DocumentRefundFinancialDataPoint = {
  connectionId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<FinancialDataPointStatus>;
};

export type DocumentRefundFinancialDataPointSort = {
  connectionId?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type DocumentRefundFinancialDataPointWhere = {
  AND?: InputMaybe<Array<DocumentRefundFinancialDataPointWhere>>;
  NOT?: InputMaybe<DocumentRefundFinancialDataPointWhere>;
  OR?: InputMaybe<Array<DocumentRefundFinancialDataPointWhere>>;
  connectionId?: InputMaybe<Scalars['ID']['input']>;
  connectionId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  connectionId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  connectionId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  connectionId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<FinancialDataPointStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<FinancialDataPointStatus>>>;
};

export type DocumentRefundGroup = {
  __typename?: 'DocumentRefundGroup';
  agreement?: Maybe<Agreement>;
  agreementAggregate?: Maybe<DocumentRefundGroupAgreementAgreementAggregationSelection>;
  agreementConnection: DocumentRefundGroupAgreementConnection;
  case?: Maybe<Case>;
  caseAggregate?: Maybe<DocumentRefundGroupCaseCaseAggregationSelection>;
  caseConnection: DocumentRefundGroupCaseConnection;
  document: Document;
  documentAggregate?: Maybe<DocumentRefundGroupDocumentDocumentAggregationSelection>;
  documentConnection: DocumentRefundGroupDocumentConnection;
  documentStatus?: Maybe<DocumentStatus>;
  id: Scalars['ID']['output'];
  message: Array<Message>;
  messageAggregate?: Maybe<DocumentRefundGroupMessageMessageAggregationSelection>;
  messageConnection: DocumentRefundGroupMessageConnection;
  messageCount?: Maybe<Scalars['Int']['output']>;
  refunds: Array<Refund>;
  refundsAggregate?: Maybe<DocumentRefundGroupRefundRefundsAggregationSelection>;
  refundsConnection: DocumentRefundGroupRefundsConnection;
  tenantIds: Array<Scalars['String']['output']>;
  threadMessageCount: Scalars['Int']['output'];
};


export type DocumentRefundGroupAgreementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type DocumentRefundGroupAgreementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type DocumentRefundGroupAgreementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentRefundGroupAgreementConnectionSort>>;
  where?: InputMaybe<DocumentRefundGroupAgreementConnectionWhere>;
};


export type DocumentRefundGroupCaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type DocumentRefundGroupCaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type DocumentRefundGroupCaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentRefundGroupCaseConnectionSort>>;
  where?: InputMaybe<DocumentRefundGroupCaseConnectionWhere>;
};


export type DocumentRefundGroupDocumentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type DocumentRefundGroupDocumentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type DocumentRefundGroupDocumentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentRefundGroupDocumentConnectionSort>>;
  where?: InputMaybe<DocumentRefundGroupDocumentConnectionWhere>;
};


export type DocumentRefundGroupMessageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type DocumentRefundGroupMessageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type DocumentRefundGroupMessageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentRefundGroupMessageConnectionSort>>;
  where?: InputMaybe<DocumentRefundGroupMessageConnectionWhere>;
};


export type DocumentRefundGroupRefundsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type DocumentRefundGroupRefundsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RefundWhere>;
};


export type DocumentRefundGroupRefundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentRefundGroupRefundsConnectionSort>>;
  where?: InputMaybe<DocumentRefundGroupRefundsConnectionWhere>;
};

export type DocumentRefundGroupAgreementAggregateInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupAgreementAggregateInput>>;
  NOT?: InputMaybe<DocumentRefundGroupAgreementAggregateInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupAgreementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentRefundGroupAgreementNodeAggregationWhereInput>;
};

export type DocumentRefundGroupAgreementAgreementAggregationSelection = {
  __typename?: 'DocumentRefundGroupAgreementAgreementAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentRefundGroupAgreementAgreementNodeAggregateSelection>;
};

export type DocumentRefundGroupAgreementAgreementNodeAggregateSelection = {
  __typename?: 'DocumentRefundGroupAgreementAgreementNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type DocumentRefundGroupAgreementConnection = {
  __typename?: 'DocumentRefundGroupAgreementConnection';
  edges: Array<DocumentRefundGroupAgreementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundGroupAgreementConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type DocumentRefundGroupAgreementConnectionWhere = {
  AND?: InputMaybe<Array<DocumentRefundGroupAgreementConnectionWhere>>;
  NOT?: InputMaybe<DocumentRefundGroupAgreementConnectionWhere>;
  OR?: InputMaybe<Array<DocumentRefundGroupAgreementConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type DocumentRefundGroupAgreementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupAgreementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRefundGroupAgreementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupAgreementNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentRefundGroupAgreementRelationship = {
  __typename?: 'DocumentRefundGroupAgreementRelationship';
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type DocumentRefundGroupCaseAggregateInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupCaseAggregateInput>>;
  NOT?: InputMaybe<DocumentRefundGroupCaseAggregateInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupCaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentRefundGroupCaseNodeAggregationWhereInput>;
};

export type DocumentRefundGroupCaseCaseAggregationSelection = {
  __typename?: 'DocumentRefundGroupCaseCaseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentRefundGroupCaseCaseNodeAggregateSelection>;
};

export type DocumentRefundGroupCaseCaseNodeAggregateSelection = {
  __typename?: 'DocumentRefundGroupCaseCaseNodeAggregateSelection';
  creationDate: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
};

export type DocumentRefundGroupCaseConnection = {
  __typename?: 'DocumentRefundGroupCaseConnection';
  edges: Array<DocumentRefundGroupCaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundGroupCaseConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type DocumentRefundGroupCaseConnectionWhere = {
  AND?: InputMaybe<Array<DocumentRefundGroupCaseConnectionWhere>>;
  NOT?: InputMaybe<DocumentRefundGroupCaseConnectionWhere>;
  OR?: InputMaybe<Array<DocumentRefundGroupCaseConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type DocumentRefundGroupCaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupCaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRefundGroupCaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupCaseNodeAggregationWhereInput>>;
  creationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentRefundGroupCaseRelationship = {
  __typename?: 'DocumentRefundGroupCaseRelationship';
  cursor: Scalars['String']['output'];
  node: Case;
};

export type DocumentRefundGroupDocumentAggregateInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupDocumentAggregateInput>>;
  NOT?: InputMaybe<DocumentRefundGroupDocumentAggregateInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupDocumentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentRefundGroupDocumentNodeAggregationWhereInput>;
};

export type DocumentRefundGroupDocumentConnection = {
  __typename?: 'DocumentRefundGroupDocumentConnection';
  edges: Array<DocumentRefundGroupDocumentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundGroupDocumentConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type DocumentRefundGroupDocumentConnectionWhere = {
  AND?: InputMaybe<Array<DocumentRefundGroupDocumentConnectionWhere>>;
  NOT?: InputMaybe<DocumentRefundGroupDocumentConnectionWhere>;
  OR?: InputMaybe<Array<DocumentRefundGroupDocumentConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type DocumentRefundGroupDocumentDocumentAggregationSelection = {
  __typename?: 'DocumentRefundGroupDocumentDocumentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentRefundGroupDocumentDocumentNodeAggregateSelection>;
};

export type DocumentRefundGroupDocumentDocumentNodeAggregateSelection = {
  __typename?: 'DocumentRefundGroupDocumentDocumentNodeAggregateSelection';
  counterParties: StringAggregateSelectionNullable;
  coveragePeriod: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  issuedOn: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
};

export type DocumentRefundGroupDocumentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupDocumentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRefundGroupDocumentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupDocumentNodeAggregationWhereInput>>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentRefundGroupDocumentRelationship = {
  __typename?: 'DocumentRefundGroupDocumentRelationship';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type DocumentRefundGroupEdge = {
  __typename?: 'DocumentRefundGroupEdge';
  cursor: Scalars['String']['output'];
  node: DocumentRefundGroup;
};

export type DocumentRefundGroupMessageAggregateInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupMessageAggregateInput>>;
  NOT?: InputMaybe<DocumentRefundGroupMessageAggregateInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupMessageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentRefundGroupMessageNodeAggregationWhereInput>;
};

export type DocumentRefundGroupMessageConnection = {
  __typename?: 'DocumentRefundGroupMessageConnection';
  edges: Array<DocumentRefundGroupMessageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundGroupMessageConnectionSort = {
  node?: InputMaybe<MessageSort>;
};

export type DocumentRefundGroupMessageConnectionWhere = {
  AND?: InputMaybe<Array<DocumentRefundGroupMessageConnectionWhere>>;
  NOT?: InputMaybe<DocumentRefundGroupMessageConnectionWhere>;
  OR?: InputMaybe<Array<DocumentRefundGroupMessageConnectionWhere>>;
  node?: InputMaybe<MessageWhere>;
};

export type DocumentRefundGroupMessageMessageAggregationSelection = {
  __typename?: 'DocumentRefundGroupMessageMessageAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentRefundGroupMessageMessageNodeAggregateSelection>;
};

export type DocumentRefundGroupMessageMessageNodeAggregateSelection = {
  __typename?: 'DocumentRefundGroupMessageMessageNodeAggregateSelection';
  content: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
};

export type DocumentRefundGroupMessageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupMessageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRefundGroupMessageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupMessageNodeAggregationWhereInput>>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type DocumentRefundGroupMessageRelationship = {
  __typename?: 'DocumentRefundGroupMessageRelationship';
  cursor: Scalars['String']['output'];
  node: Message;
};

export type DocumentRefundGroupOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentRefundGroupSort objects to sort DocumentRefundGroups by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentRefundGroupSort>>;
};

export type DocumentRefundGroupRefundRefundsAggregationSelection = {
  __typename?: 'DocumentRefundGroupRefundRefundsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentRefundGroupRefundRefundsNodeAggregateSelection>;
};

export type DocumentRefundGroupRefundRefundsNodeAggregateSelection = {
  __typename?: 'DocumentRefundGroupRefundRefundsNodeAggregateSelection';
  agreementId: StringAggregateSelectionNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type DocumentRefundGroupRefundsAggregateInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupRefundsAggregateInput>>;
  NOT?: InputMaybe<DocumentRefundGroupRefundsAggregateInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupRefundsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentRefundGroupRefundsNodeAggregationWhereInput>;
};

export type DocumentRefundGroupRefundsConnection = {
  __typename?: 'DocumentRefundGroupRefundsConnection';
  edges: Array<DocumentRefundGroupRefundsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundGroupRefundsConnectionSort = {
  node?: InputMaybe<RefundSort>;
};

export type DocumentRefundGroupRefundsConnectionWhere = {
  AND?: InputMaybe<Array<DocumentRefundGroupRefundsConnectionWhere>>;
  NOT?: InputMaybe<DocumentRefundGroupRefundsConnectionWhere>;
  OR?: InputMaybe<Array<DocumentRefundGroupRefundsConnectionWhere>>;
  node?: InputMaybe<RefundWhere>;
};

export type DocumentRefundGroupRefundsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupRefundsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRefundGroupRefundsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupRefundsNodeAggregationWhereInput>>;
  agreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentRefundGroupRefundsRelationship = {
  __typename?: 'DocumentRefundGroupRefundsRelationship';
  cursor: Scalars['String']['output'];
  node: Refund;
};

/** Fields to sort DocumentRefundGroups by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentRefundGroupSort object. */
export type DocumentRefundGroupSort = {
  documentStatus?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  messageCount?: InputMaybe<SortDirection>;
  threadMessageCount?: InputMaybe<SortDirection>;
};

export type DocumentRefundGroupWhere = {
  AND?: InputMaybe<Array<DocumentRefundGroupWhere>>;
  NOT?: InputMaybe<DocumentRefundGroupWhere>;
  OR?: InputMaybe<Array<DocumentRefundGroupWhere>>;
  agreement?: InputMaybe<AgreementWhere>;
  agreementAggregate?: InputMaybe<DocumentRefundGroupAgreementAggregateInput>;
  agreementConnection?: InputMaybe<DocumentRefundGroupAgreementConnectionWhere>;
  agreementConnection_NOT?: InputMaybe<DocumentRefundGroupAgreementConnectionWhere>;
  agreement_NOT?: InputMaybe<AgreementWhere>;
  case?: InputMaybe<CaseWhere>;
  caseAggregate?: InputMaybe<DocumentRefundGroupCaseAggregateInput>;
  caseConnection?: InputMaybe<DocumentRefundGroupCaseConnectionWhere>;
  caseConnection_NOT?: InputMaybe<DocumentRefundGroupCaseConnectionWhere>;
  case_NOT?: InputMaybe<CaseWhere>;
  document?: InputMaybe<DocumentWhere>;
  documentAggregate?: InputMaybe<DocumentRefundGroupDocumentAggregateInput>;
  documentConnection?: InputMaybe<DocumentRefundGroupDocumentConnectionWhere>;
  documentConnection_NOT?: InputMaybe<DocumentRefundGroupDocumentConnectionWhere>;
  document_NOT?: InputMaybe<DocumentWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  messageAggregate?: InputMaybe<DocumentRefundGroupMessageAggregateInput>;
  /** Return DocumentRefundGroups where all of the related DocumentRefundGroupMessageConnections match this filter */
  messageConnection_ALL?: InputMaybe<DocumentRefundGroupMessageConnectionWhere>;
  /** Return DocumentRefundGroups where none of the related DocumentRefundGroupMessageConnections match this filter */
  messageConnection_NONE?: InputMaybe<DocumentRefundGroupMessageConnectionWhere>;
  /** Return DocumentRefundGroups where one of the related DocumentRefundGroupMessageConnections match this filter */
  messageConnection_SINGLE?: InputMaybe<DocumentRefundGroupMessageConnectionWhere>;
  /** Return DocumentRefundGroups where some of the related DocumentRefundGroupMessageConnections match this filter */
  messageConnection_SOME?: InputMaybe<DocumentRefundGroupMessageConnectionWhere>;
  /** Return DocumentRefundGroups where all of the related Messages match this filter */
  message_ALL?: InputMaybe<MessageWhere>;
  /** Return DocumentRefundGroups where none of the related Messages match this filter */
  message_NONE?: InputMaybe<MessageWhere>;
  /** Return DocumentRefundGroups where one of the related Messages match this filter */
  message_SINGLE?: InputMaybe<MessageWhere>;
  /** Return DocumentRefundGroups where some of the related Messages match this filter */
  message_SOME?: InputMaybe<MessageWhere>;
  refundsAggregate?: InputMaybe<DocumentRefundGroupRefundsAggregateInput>;
  /** Return DocumentRefundGroups where all of the related DocumentRefundGroupRefundsConnections match this filter */
  refundsConnection_ALL?: InputMaybe<DocumentRefundGroupRefundsConnectionWhere>;
  /** Return DocumentRefundGroups where none of the related DocumentRefundGroupRefundsConnections match this filter */
  refundsConnection_NONE?: InputMaybe<DocumentRefundGroupRefundsConnectionWhere>;
  /** Return DocumentRefundGroups where one of the related DocumentRefundGroupRefundsConnections match this filter */
  refundsConnection_SINGLE?: InputMaybe<DocumentRefundGroupRefundsConnectionWhere>;
  /** Return DocumentRefundGroups where some of the related DocumentRefundGroupRefundsConnections match this filter */
  refundsConnection_SOME?: InputMaybe<DocumentRefundGroupRefundsConnectionWhere>;
  /** Return DocumentRefundGroups where all of the related Refunds match this filter */
  refunds_ALL?: InputMaybe<RefundWhere>;
  /** Return DocumentRefundGroups where none of the related Refunds match this filter */
  refunds_NONE?: InputMaybe<RefundWhere>;
  /** Return DocumentRefundGroups where one of the related Refunds match this filter */
  refunds_SINGLE?: InputMaybe<RefundWhere>;
  /** Return DocumentRefundGroups where some of the related Refunds match this filter */
  refunds_SOME?: InputMaybe<RefundWhere>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentRefundGroupsConnection = {
  __typename?: 'DocumentRefundGroupsConnection';
  edges: Array<DocumentRefundGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundRefundsAggregationSelection = {
  __typename?: 'DocumentRefundRefundsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentRefundRefundsNodeAggregateSelection>;
};

export type DocumentRefundRefundsNodeAggregateSelection = {
  __typename?: 'DocumentRefundRefundsNodeAggregateSelection';
  agreementId: StringAggregateSelectionNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type DocumentRefundsAggregateInput = {
  AND?: InputMaybe<Array<DocumentRefundsAggregateInput>>;
  NOT?: InputMaybe<DocumentRefundsAggregateInput>;
  OR?: InputMaybe<Array<DocumentRefundsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentRefundsNodeAggregationWhereInput>;
};

export type DocumentRefundsConnection = {
  __typename?: 'DocumentRefundsConnection';
  edges: Array<DocumentRefundsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundsConnectionSort = {
  node?: InputMaybe<RefundSort>;
};

export type DocumentRefundsConnectionWhere = {
  AND?: InputMaybe<Array<DocumentRefundsConnectionWhere>>;
  NOT?: InputMaybe<DocumentRefundsConnectionWhere>;
  OR?: InputMaybe<Array<DocumentRefundsConnectionWhere>>;
  node?: InputMaybe<RefundWhere>;
};

export type DocumentRefundsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRefundsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRefundsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRefundsNodeAggregationWhereInput>>;
  agreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentRefundsRelationship = {
  __typename?: 'DocumentRefundsRelationship';
  cursor: Scalars['String']['output'];
  node: Refund;
};

/** Fields to sort Documents by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentSort object. */
export type DocumentSort = {
  counterParties?: InputMaybe<SortDirection>;
  coveragePeriod?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isConfirmedBySeller?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isSentToSmartMip?: InputMaybe<SortDirection>;
  issuedOn?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  settledOn?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum DocumentStatus {
  InApproval = 'IN_APPROVAL',
  InReview = 'IN_REVIEW',
  Issued = 'ISSUED',
  Settled = 'SETTLED',
  WorkingDraft = 'WORKING_DRAFT'
}

export enum DocumentType {
  CreditNote = 'CREDIT_NOTE',
  FreeOfCharge = 'FREE_OF_CHARGE',
  Invoice = 'INVOICE'
}

export type DocumentWhere = {
  AND?: InputMaybe<Array<DocumentWhere>>;
  NOT?: InputMaybe<DocumentWhere>;
  OR?: InputMaybe<Array<DocumentWhere>>;
  counterParties?: InputMaybe<Scalars['String']['input']>;
  counterParties_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  counterParties_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  counterParties_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  counterParties_MATCHES?: InputMaybe<Scalars['String']['input']>;
  counterParties_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  coveragePeriod?: InputMaybe<Scalars['String']['input']>;
  coveragePeriod_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  coveragePeriod_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  coveragePeriod_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  coveragePeriod_MATCHES?: InputMaybe<Scalars['String']['input']>;
  coveragePeriod_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  documentRefundGroupsAggregate?: InputMaybe<DocumentDocumentRefundGroupsAggregateInput>;
  /** Return Documents where all of the related DocumentDocumentRefundGroupsConnections match this filter */
  documentRefundGroupsConnection_ALL?: InputMaybe<DocumentDocumentRefundGroupsConnectionWhere>;
  /** Return Documents where none of the related DocumentDocumentRefundGroupsConnections match this filter */
  documentRefundGroupsConnection_NONE?: InputMaybe<DocumentDocumentRefundGroupsConnectionWhere>;
  /** Return Documents where one of the related DocumentDocumentRefundGroupsConnections match this filter */
  documentRefundGroupsConnection_SINGLE?: InputMaybe<DocumentDocumentRefundGroupsConnectionWhere>;
  /** Return Documents where some of the related DocumentDocumentRefundGroupsConnections match this filter */
  documentRefundGroupsConnection_SOME?: InputMaybe<DocumentDocumentRefundGroupsConnectionWhere>;
  /** Return Documents where all of the related DocumentRefundGroups match this filter */
  documentRefundGroups_ALL?: InputMaybe<DocumentRefundGroupWhere>;
  /** Return Documents where none of the related DocumentRefundGroups match this filter */
  documentRefundGroups_NONE?: InputMaybe<DocumentRefundGroupWhere>;
  /** Return Documents where one of the related DocumentRefundGroups match this filter */
  documentRefundGroups_SINGLE?: InputMaybe<DocumentRefundGroupWhere>;
  /** Return Documents where some of the related DocumentRefundGroups match this filter */
  documentRefundGroups_SOME?: InputMaybe<DocumentRefundGroupWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isConfirmedBySeller?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isSentToSmartMip?: InputMaybe<Scalars['Boolean']['input']>;
  issuedOn?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  issuedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  refundsAggregate?: InputMaybe<DocumentRefundsAggregateInput>;
  /** Return Documents where all of the related DocumentRefundsConnections match this filter */
  refundsConnection_ALL?: InputMaybe<DocumentRefundsConnectionWhere>;
  /** Return Documents where none of the related DocumentRefundsConnections match this filter */
  refundsConnection_NONE?: InputMaybe<DocumentRefundsConnectionWhere>;
  /** Return Documents where one of the related DocumentRefundsConnections match this filter */
  refundsConnection_SINGLE?: InputMaybe<DocumentRefundsConnectionWhere>;
  /** Return Documents where some of the related DocumentRefundsConnections match this filter */
  refundsConnection_SOME?: InputMaybe<DocumentRefundsConnectionWhere>;
  /** Return Documents where all of the related Refunds match this filter */
  refunds_ALL?: InputMaybe<RefundWhere>;
  /** Return Documents where none of the related Refunds match this filter */
  refunds_NONE?: InputMaybe<RefundWhere>;
  /** Return Documents where one of the related Refunds match this filter */
  refunds_SINGLE?: InputMaybe<RefundWhere>;
  /** Return Documents where some of the related Refunds match this filter */
  refunds_SOME?: InputMaybe<RefundWhere>;
  settledOn?: InputMaybe<Scalars['Date']['input']>;
  settledOn_GT?: InputMaybe<Scalars['Date']['input']>;
  settledOn_GTE?: InputMaybe<Scalars['Date']['input']>;
  settledOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  settledOn_LT?: InputMaybe<Scalars['Date']['input']>;
  settledOn_LTE?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<DocumentStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  tenantIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DocumentType>;
  type_IN?: InputMaybe<Array<InputMaybe<DocumentType>>>;
};

export type DocumentsConnection = {
  __typename?: 'DocumentsConnection';
  edges: Array<DocumentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Domain = {
  __typename?: 'Domain';
  children: Array<Domain>;
  childrenAggregate?: Maybe<DomainDomainChildrenAggregationSelection>;
  childrenConnection: DomainChildrenConnection;
  createdBy?: Maybe<User>;
  createdByAggregate?: Maybe<DomainUserCreatedByAggregationSelection>;
  createdByConnection: DomainCreatedByConnection;
  createdOn: Scalars['DateTime']['output'];
  deletedByEmail?: Maybe<Scalars['String']['output']>;
  deletedOn: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Domain>;
  parentAggregate?: Maybe<DomainDomainParentAggregationSelection>;
  parentConnection: DomainParentConnection;
  productBlueprint: Array<ProductBlueprint>;
  productBlueprintAggregate?: Maybe<DomainProductBlueprintProductBlueprintAggregationSelection>;
  productBlueprintConnection: DomainProductBlueprintConnection;
  simulationCount: Scalars['Int']['output'];
  simulations: Array<Simulation>;
  simulationsAggregate?: Maybe<DomainSimulationSimulationsAggregationSelection>;
  simulationsConnection: DomainSimulationsConnection;
  tenantId: Scalars['String']['output'];
  userCount: Scalars['Int']['output'];
  users: Array<User>;
  usersAggregate?: Maybe<DomainUserUsersAggregationSelection>;
  usersConnection: DomainUsersConnection;
};


export type DomainChildrenArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DomainOptions>;
  where?: InputMaybe<DomainWhere>;
};


export type DomainChildrenAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DomainWhere>;
};


export type DomainChildrenConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DomainChildrenConnectionSort>>;
  where?: InputMaybe<DomainChildrenConnectionWhere>;
};


export type DomainCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DomainCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DomainCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DomainCreatedByConnectionSort>>;
  where?: InputMaybe<DomainCreatedByConnectionWhere>;
};


export type DomainParentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DomainOptions>;
  where?: InputMaybe<DomainWhere>;
};


export type DomainParentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DomainWhere>;
};


export type DomainParentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DomainParentConnectionSort>>;
  where?: InputMaybe<DomainParentConnectionWhere>;
};


export type DomainProductBlueprintArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProductBlueprintOptions>;
  where?: InputMaybe<ProductBlueprintWhere>;
};


export type DomainProductBlueprintAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductBlueprintWhere>;
};


export type DomainProductBlueprintConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DomainProductBlueprintConnectionSort>>;
  where?: InputMaybe<DomainProductBlueprintConnectionWhere>;
};


export type DomainSimulationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SimulationOptions>;
  where?: InputMaybe<SimulationWhere>;
};


export type DomainSimulationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SimulationWhere>;
};


export type DomainSimulationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DomainSimulationsConnectionSort>>;
  where?: InputMaybe<DomainSimulationsConnectionWhere>;
};


export type DomainUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DomainUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DomainUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DomainUsersConnectionSort>>;
  where?: InputMaybe<DomainUsersConnectionWhere>;
};

export type DomainChildrenAggregateInput = {
  AND?: InputMaybe<Array<DomainChildrenAggregateInput>>;
  NOT?: InputMaybe<DomainChildrenAggregateInput>;
  OR?: InputMaybe<Array<DomainChildrenAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DomainChildrenNodeAggregationWhereInput>;
};

export type DomainChildrenConnection = {
  __typename?: 'DomainChildrenConnection';
  edges: Array<DomainChildrenRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DomainChildrenConnectionSort = {
  node?: InputMaybe<DomainSort>;
};

export type DomainChildrenConnectionWhere = {
  AND?: InputMaybe<Array<DomainChildrenConnectionWhere>>;
  NOT?: InputMaybe<DomainChildrenConnectionWhere>;
  OR?: InputMaybe<Array<DomainChildrenConnectionWhere>>;
  node?: InputMaybe<DomainWhere>;
};

export type DomainChildrenNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DomainChildrenNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DomainChildrenNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DomainChildrenNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  level_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  level_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DomainChildrenRelationship = {
  __typename?: 'DomainChildrenRelationship';
  cursor: Scalars['String']['output'];
  node: Domain;
};

export type DomainCreatedByAggregateInput = {
  AND?: InputMaybe<Array<DomainCreatedByAggregateInput>>;
  NOT?: InputMaybe<DomainCreatedByAggregateInput>;
  OR?: InputMaybe<Array<DomainCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DomainCreatedByNodeAggregationWhereInput>;
};

export type DomainCreatedByConnection = {
  __typename?: 'DomainCreatedByConnection';
  edges: Array<DomainCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DomainCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type DomainCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<DomainCreatedByConnectionWhere>>;
  NOT?: InputMaybe<DomainCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<DomainCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type DomainCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DomainCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DomainCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DomainCreatedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DomainCreatedByRelationship = {
  __typename?: 'DomainCreatedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type DomainDomainChildrenAggregationSelection = {
  __typename?: 'DomainDomainChildrenAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DomainDomainChildrenNodeAggregateSelection>;
};

export type DomainDomainChildrenNodeAggregateSelection = {
  __typename?: 'DomainDomainChildrenNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  level: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DomainDomainParentAggregationSelection = {
  __typename?: 'DomainDomainParentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DomainDomainParentNodeAggregateSelection>;
};

export type DomainDomainParentNodeAggregateSelection = {
  __typename?: 'DomainDomainParentNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  level: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DomainEdge = {
  __typename?: 'DomainEdge';
  cursor: Scalars['String']['output'];
  node: Domain;
};

export type DomainOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DomainSort objects to sort Domains by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DomainSort>>;
};

export type DomainParentAggregateInput = {
  AND?: InputMaybe<Array<DomainParentAggregateInput>>;
  NOT?: InputMaybe<DomainParentAggregateInput>;
  OR?: InputMaybe<Array<DomainParentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DomainParentNodeAggregationWhereInput>;
};

export type DomainParentConnection = {
  __typename?: 'DomainParentConnection';
  edges: Array<DomainParentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DomainParentConnectionSort = {
  node?: InputMaybe<DomainSort>;
};

export type DomainParentConnectionWhere = {
  AND?: InputMaybe<Array<DomainParentConnectionWhere>>;
  NOT?: InputMaybe<DomainParentConnectionWhere>;
  OR?: InputMaybe<Array<DomainParentConnectionWhere>>;
  node?: InputMaybe<DomainWhere>;
};

export type DomainParentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DomainParentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DomainParentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DomainParentNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  level_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  level_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DomainParentRelationship = {
  __typename?: 'DomainParentRelationship';
  cursor: Scalars['String']['output'];
  node: Domain;
};

export type DomainProductBlueprintAggregateInput = {
  AND?: InputMaybe<Array<DomainProductBlueprintAggregateInput>>;
  NOT?: InputMaybe<DomainProductBlueprintAggregateInput>;
  OR?: InputMaybe<Array<DomainProductBlueprintAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DomainProductBlueprintNodeAggregationWhereInput>;
};

export type DomainProductBlueprintConnection = {
  __typename?: 'DomainProductBlueprintConnection';
  edges: Array<DomainProductBlueprintRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DomainProductBlueprintConnectionSort = {
  node?: InputMaybe<ProductBlueprintSort>;
};

export type DomainProductBlueprintConnectionWhere = {
  AND?: InputMaybe<Array<DomainProductBlueprintConnectionWhere>>;
  NOT?: InputMaybe<DomainProductBlueprintConnectionWhere>;
  OR?: InputMaybe<Array<DomainProductBlueprintConnectionWhere>>;
  node?: InputMaybe<ProductBlueprintWhere>;
};

export type DomainProductBlueprintNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DomainProductBlueprintNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DomainProductBlueprintNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DomainProductBlueprintNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formValues_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formValues_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indication_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  indication_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  indications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  productName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  productName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  publishedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DomainProductBlueprintProductBlueprintAggregationSelection = {
  __typename?: 'DomainProductBlueprintProductBlueprintAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DomainProductBlueprintProductBlueprintNodeAggregateSelection>;
};

export type DomainProductBlueprintProductBlueprintNodeAggregateSelection = {
  __typename?: 'DomainProductBlueprintProductBlueprintNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  addedOn: DateTimeAggregateSelectionNonNullable;
  formValues: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  indication: StringAggregateSelectionNonNullable;
  indications: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  productName: StringAggregateSelectionNonNullable;
  publishedOn: DateTimeAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  updatedOn: DateTimeAggregateSelectionNonNullable;
};

export type DomainProductBlueprintRelationship = {
  __typename?: 'DomainProductBlueprintRelationship';
  cursor: Scalars['String']['output'];
  node: ProductBlueprint;
};

export type DomainSimulationSimulationsAggregationSelection = {
  __typename?: 'DomainSimulationSimulationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DomainSimulationSimulationsNodeAggregateSelection>;
};

export type DomainSimulationSimulationsNodeAggregateSelection = {
  __typename?: 'DomainSimulationSimulationsNodeAggregateSelection';
  businessCase: StringAggregateSelectionNullable;
  comments: StringAggregateSelectionNullable;
  configuration: StringAggregateSelectionNonNullable;
  counterparty: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNullable;
  createdByName: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  domainName: StringAggregateSelectionNullable;
  formattedContent: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  indications: StringAggregateSelectionNonNullable;
  lastUpdatedByEmail: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  lockedSections: StringAggregateSelectionNullable;
  model: StringAggregateSelectionNonNullable;
  product: StringAggregateSelectionNonNullable;
  shortName: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  version: IntAggregateSelectionNonNullable;
};

export type DomainSimulationsAggregateInput = {
  AND?: InputMaybe<Array<DomainSimulationsAggregateInput>>;
  NOT?: InputMaybe<DomainSimulationsAggregateInput>;
  OR?: InputMaybe<Array<DomainSimulationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DomainSimulationsNodeAggregationWhereInput>;
};

export type DomainSimulationsConnection = {
  __typename?: 'DomainSimulationsConnection';
  edges: Array<DomainSimulationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DomainSimulationsConnectionSort = {
  node?: InputMaybe<SimulationSort>;
};

export type DomainSimulationsConnectionWhere = {
  AND?: InputMaybe<Array<DomainSimulationsConnectionWhere>>;
  NOT?: InputMaybe<DomainSimulationsConnectionWhere>;
  OR?: InputMaybe<Array<DomainSimulationsConnectionWhere>>;
  node?: InputMaybe<SimulationWhere>;
};

export type DomainSimulationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DomainSimulationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DomainSimulationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DomainSimulationsNodeAggregationWhereInput>>;
  businessCase_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  businessCase_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  configuration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterparty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domainName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domainName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  indications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSections_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  model_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  model_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DomainSimulationsRelationship = {
  __typename?: 'DomainSimulationsRelationship';
  cursor: Scalars['String']['output'];
  node: Simulation;
};

/** Fields to sort Domains by. The order in which sorts are applied is not guaranteed when specifying many fields in one DomainSort object. */
export type DomainSort = {
  createdOn?: InputMaybe<SortDirection>;
  deletedByEmail?: InputMaybe<SortDirection>;
  deletedOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  level?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  simulationCount?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  userCount?: InputMaybe<SortDirection>;
};

export type DomainUserCreatedByAggregationSelection = {
  __typename?: 'DomainUserCreatedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DomainUserCreatedByNodeAggregateSelection>;
};

export type DomainUserCreatedByNodeAggregateSelection = {
  __typename?: 'DomainUserCreatedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type DomainUserUsersAggregationSelection = {
  __typename?: 'DomainUserUsersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DomainUserUsersNodeAggregateSelection>;
};

export type DomainUserUsersNodeAggregateSelection = {
  __typename?: 'DomainUserUsersNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type DomainUsersAggregateInput = {
  AND?: InputMaybe<Array<DomainUsersAggregateInput>>;
  NOT?: InputMaybe<DomainUsersAggregateInput>;
  OR?: InputMaybe<Array<DomainUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DomainUsersNodeAggregationWhereInput>;
};

export type DomainUsersConnection = {
  __typename?: 'DomainUsersConnection';
  edges: Array<DomainUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DomainUsersConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type DomainUsersConnectionWhere = {
  AND?: InputMaybe<Array<DomainUsersConnectionWhere>>;
  NOT?: InputMaybe<DomainUsersConnectionWhere>;
  OR?: InputMaybe<Array<DomainUsersConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type DomainUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DomainUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DomainUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DomainUsersNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DomainUsersRelationship = {
  __typename?: 'DomainUsersRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type DomainWhere = {
  AND?: InputMaybe<Array<DomainWhere>>;
  NOT?: InputMaybe<DomainWhere>;
  OR?: InputMaybe<Array<DomainWhere>>;
  childrenAggregate?: InputMaybe<DomainChildrenAggregateInput>;
  /** Return Domains where all of the related DomainChildrenConnections match this filter */
  childrenConnection_ALL?: InputMaybe<DomainChildrenConnectionWhere>;
  /** Return Domains where none of the related DomainChildrenConnections match this filter */
  childrenConnection_NONE?: InputMaybe<DomainChildrenConnectionWhere>;
  /** Return Domains where one of the related DomainChildrenConnections match this filter */
  childrenConnection_SINGLE?: InputMaybe<DomainChildrenConnectionWhere>;
  /** Return Domains where some of the related DomainChildrenConnections match this filter */
  childrenConnection_SOME?: InputMaybe<DomainChildrenConnectionWhere>;
  /** Return Domains where all of the related Domains match this filter */
  children_ALL?: InputMaybe<DomainWhere>;
  /** Return Domains where none of the related Domains match this filter */
  children_NONE?: InputMaybe<DomainWhere>;
  /** Return Domains where one of the related Domains match this filter */
  children_SINGLE?: InputMaybe<DomainWhere>;
  /** Return Domains where some of the related Domains match this filter */
  children_SOME?: InputMaybe<DomainWhere>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<DomainCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<DomainCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<DomainCreatedByConnectionWhere>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deletedByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  deletedOn?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  deletedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  level_GT?: InputMaybe<Scalars['Int']['input']>;
  level_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  level_LT?: InputMaybe<Scalars['Int']['input']>;
  level_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<DomainWhere>;
  parentAggregate?: InputMaybe<DomainParentAggregateInput>;
  parentConnection?: InputMaybe<DomainParentConnectionWhere>;
  parentConnection_NOT?: InputMaybe<DomainParentConnectionWhere>;
  parent_NOT?: InputMaybe<DomainWhere>;
  productBlueprintAggregate?: InputMaybe<DomainProductBlueprintAggregateInput>;
  /** Return Domains where all of the related DomainProductBlueprintConnections match this filter */
  productBlueprintConnection_ALL?: InputMaybe<DomainProductBlueprintConnectionWhere>;
  /** Return Domains where none of the related DomainProductBlueprintConnections match this filter */
  productBlueprintConnection_NONE?: InputMaybe<DomainProductBlueprintConnectionWhere>;
  /** Return Domains where one of the related DomainProductBlueprintConnections match this filter */
  productBlueprintConnection_SINGLE?: InputMaybe<DomainProductBlueprintConnectionWhere>;
  /** Return Domains where some of the related DomainProductBlueprintConnections match this filter */
  productBlueprintConnection_SOME?: InputMaybe<DomainProductBlueprintConnectionWhere>;
  /** Return Domains where all of the related ProductBlueprints match this filter */
  productBlueprint_ALL?: InputMaybe<ProductBlueprintWhere>;
  /** Return Domains where none of the related ProductBlueprints match this filter */
  productBlueprint_NONE?: InputMaybe<ProductBlueprintWhere>;
  /** Return Domains where one of the related ProductBlueprints match this filter */
  productBlueprint_SINGLE?: InputMaybe<ProductBlueprintWhere>;
  /** Return Domains where some of the related ProductBlueprints match this filter */
  productBlueprint_SOME?: InputMaybe<ProductBlueprintWhere>;
  simulationsAggregate?: InputMaybe<DomainSimulationsAggregateInput>;
  /** Return Domains where all of the related DomainSimulationsConnections match this filter */
  simulationsConnection_ALL?: InputMaybe<DomainSimulationsConnectionWhere>;
  /** Return Domains where none of the related DomainSimulationsConnections match this filter */
  simulationsConnection_NONE?: InputMaybe<DomainSimulationsConnectionWhere>;
  /** Return Domains where one of the related DomainSimulationsConnections match this filter */
  simulationsConnection_SINGLE?: InputMaybe<DomainSimulationsConnectionWhere>;
  /** Return Domains where some of the related DomainSimulationsConnections match this filter */
  simulationsConnection_SOME?: InputMaybe<DomainSimulationsConnectionWhere>;
  /** Return Domains where all of the related Simulations match this filter */
  simulations_ALL?: InputMaybe<SimulationWhere>;
  /** Return Domains where none of the related Simulations match this filter */
  simulations_NONE?: InputMaybe<SimulationWhere>;
  /** Return Domains where one of the related Simulations match this filter */
  simulations_SINGLE?: InputMaybe<SimulationWhere>;
  /** Return Domains where some of the related Simulations match this filter */
  simulations_SOME?: InputMaybe<SimulationWhere>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersAggregate?: InputMaybe<DomainUsersAggregateInput>;
  /** Return Domains where all of the related DomainUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<DomainUsersConnectionWhere>;
  /** Return Domains where none of the related DomainUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<DomainUsersConnectionWhere>;
  /** Return Domains where one of the related DomainUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<DomainUsersConnectionWhere>;
  /** Return Domains where some of the related DomainUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<DomainUsersConnectionWhere>;
  /** Return Domains where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return Domains where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return Domains where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return Domains where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
};

export type DomainsConnection = {
  __typename?: 'DomainsConnection';
  edges: Array<DomainEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DqcDetailedReportRawsConnection = {
  __typename?: 'DqcDetailedReportRawsConnection';
  edges: Array<DqcDetailedReportRawEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DummyEnumReferences = {
  __typename?: 'DummyEnumReferences';
  adverseEventGrades?: Maybe<AdverseEventGrades>;
  canadianPriceType?: Maybe<CanadianPriceType>;
  cycleAdherence?: Maybe<CycleAdherence>;
  cycleStartingPoint?: Maybe<CycleStartingPoint>;
  decision?: Maybe<CoverageRequestTherapyDecision>;
  ldlTestUom?: Maybe<LdlTestUom>;
  pathologicalResponse?: Maybe<PathologicalResponseType>;
  rating?: Maybe<CoverageRequestRating>;
  response?: Maybe<ResponseType>;
  responseType?: Maybe<ResponseType>;
  scopeId?: Maybe<ScopeId>;
  testPurposeType?: Maybe<TestPurposeType>;
  testType?: Maybe<TestType>;
  testUoMType?: Maybe<TestUoMType>;
  transfusionType?: Maybe<TransfusionType>;
  unitedResponseType?: Maybe<UnitedResponseType>;
};

export type DummyEnumReferencesConnection = {
  __typename?: 'DummyEnumReferencesConnection';
  edges: Array<DummyEnumReferencesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DummyEnumReferencesEdge = {
  __typename?: 'DummyEnumReferencesEdge';
  cursor: Scalars['String']['output'];
  node: DummyEnumReferences;
};

export type DummyEnumReferencesOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DummyEnumReferencesSort objects to sort DummyEnumReferences by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DummyEnumReferencesSort>>;
};

/** Fields to sort DummyEnumReferences by. The order in which sorts are applied is not guaranteed when specifying many fields in one DummyEnumReferencesSort object. */
export type DummyEnumReferencesSort = {
  adverseEventGrades?: InputMaybe<SortDirection>;
  canadianPriceType?: InputMaybe<SortDirection>;
  cycleAdherence?: InputMaybe<SortDirection>;
  cycleStartingPoint?: InputMaybe<SortDirection>;
  decision?: InputMaybe<SortDirection>;
  ldlTestUom?: InputMaybe<SortDirection>;
  pathologicalResponse?: InputMaybe<SortDirection>;
  rating?: InputMaybe<SortDirection>;
  response?: InputMaybe<SortDirection>;
  responseType?: InputMaybe<SortDirection>;
  scopeId?: InputMaybe<SortDirection>;
  testPurposeType?: InputMaybe<SortDirection>;
  testType?: InputMaybe<SortDirection>;
  testUoMType?: InputMaybe<SortDirection>;
  transfusionType?: InputMaybe<SortDirection>;
  unitedResponseType?: InputMaybe<SortDirection>;
};

export type DummyEnumReferencesWhere = {
  AND?: InputMaybe<Array<DummyEnumReferencesWhere>>;
  NOT?: InputMaybe<DummyEnumReferencesWhere>;
  OR?: InputMaybe<Array<DummyEnumReferencesWhere>>;
  adverseEventGrades?: InputMaybe<AdverseEventGrades>;
  adverseEventGrades_IN?: InputMaybe<Array<InputMaybe<AdverseEventGrades>>>;
  canadianPriceType?: InputMaybe<CanadianPriceType>;
  canadianPriceType_IN?: InputMaybe<Array<InputMaybe<CanadianPriceType>>>;
  cycleAdherence?: InputMaybe<CycleAdherence>;
  cycleAdherence_IN?: InputMaybe<Array<InputMaybe<CycleAdherence>>>;
  cycleStartingPoint?: InputMaybe<CycleStartingPoint>;
  cycleStartingPoint_IN?: InputMaybe<Array<InputMaybe<CycleStartingPoint>>>;
  decision?: InputMaybe<CoverageRequestTherapyDecision>;
  decision_IN?: InputMaybe<Array<InputMaybe<CoverageRequestTherapyDecision>>>;
  ldlTestUom?: InputMaybe<LdlTestUom>;
  ldlTestUom_IN?: InputMaybe<Array<InputMaybe<LdlTestUom>>>;
  pathologicalResponse?: InputMaybe<PathologicalResponseType>;
  pathologicalResponse_IN?: InputMaybe<Array<InputMaybe<PathologicalResponseType>>>;
  rating?: InputMaybe<CoverageRequestRating>;
  rating_IN?: InputMaybe<Array<InputMaybe<CoverageRequestRating>>>;
  response?: InputMaybe<ResponseType>;
  responseType?: InputMaybe<ResponseType>;
  responseType_IN?: InputMaybe<Array<InputMaybe<ResponseType>>>;
  response_IN?: InputMaybe<Array<InputMaybe<ResponseType>>>;
  scopeId?: InputMaybe<ScopeId>;
  scopeId_IN?: InputMaybe<Array<InputMaybe<ScopeId>>>;
  testPurposeType?: InputMaybe<TestPurposeType>;
  testPurposeType_IN?: InputMaybe<Array<InputMaybe<TestPurposeType>>>;
  testType?: InputMaybe<TestType>;
  testType_IN?: InputMaybe<Array<InputMaybe<TestType>>>;
  testUoMType?: InputMaybe<TestUoMType>;
  testUoMType_IN?: InputMaybe<Array<InputMaybe<TestUoMType>>>;
  transfusionType?: InputMaybe<TransfusionType>;
  transfusionType_IN?: InputMaybe<Array<InputMaybe<TransfusionType>>>;
  unitedResponseType?: InputMaybe<UnitedResponseType>;
  unitedResponseType_IN?: InputMaybe<Array<InputMaybe<UnitedResponseType>>>;
};

export type EligibilityConditionSet = {
  __typename?: 'EligibilityConditionSet';
  code: Scalars['String']['output'];
  inputLabel?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  treatments: Array<Treatment>;
  treatmentsAggregate?: Maybe<EligibilityConditionSetTreatmentTreatmentsAggregationSelection>;
  treatmentsConnection: EligibilityConditionSetTreatmentsConnection;
};


export type EligibilityConditionSetTreatmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type EligibilityConditionSetTreatmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type EligibilityConditionSetTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EligibilityConditionSetTreatmentsConnectionSort>>;
  where?: InputMaybe<EligibilityConditionSetTreatmentsConnectionWhere>;
};

export type EligibilityConditionSetEdge = {
  __typename?: 'EligibilityConditionSetEdge';
  cursor: Scalars['String']['output'];
  node: EligibilityConditionSet;
};

export type EligibilityConditionSetInput = {
  code: Scalars['String']['input'];
  cycleAdherence?: InputMaybe<CycleAdherence>;
  days?: InputMaybe<Scalars['Int']['input']>;
  generic?: InputMaybe<Scalars['String']['input']>;
  inputLabel?: InputMaybe<Scalars['String']['input']>;
  minimumPercentage?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  numberOfAdministeredRangeDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfAdministeredTreatments?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatmentsOperator?: InputMaybe<ArithmeticalOperator>;
  preparations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previousTestNumber?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  referenceTestRangeDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type EligibilityConditionSetOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EligibilityConditionSetSort objects to sort EligibilityConditionSets by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EligibilityConditionSetSort>>;
};

/** Fields to sort EligibilityConditionSets by. The order in which sorts are applied is not guaranteed when specifying many fields in one EligibilityConditionSetSort object. */
export type EligibilityConditionSetSort = {
  code?: InputMaybe<SortDirection>;
  inputLabel?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type EligibilityConditionSetTreatmentTreatmentsAggregationSelection = {
  __typename?: 'EligibilityConditionSetTreatmentTreatmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection>;
};

export type EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection = {
  __typename?: 'EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type EligibilityConditionSetTreatmentsAggregateInput = {
  AND?: InputMaybe<Array<EligibilityConditionSetTreatmentsAggregateInput>>;
  NOT?: InputMaybe<EligibilityConditionSetTreatmentsAggregateInput>;
  OR?: InputMaybe<Array<EligibilityConditionSetTreatmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EligibilityConditionSetTreatmentsNodeAggregationWhereInput>;
};

export type EligibilityConditionSetTreatmentsConnection = {
  __typename?: 'EligibilityConditionSetTreatmentsConnection';
  edges: Array<EligibilityConditionSetTreatmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EligibilityConditionSetTreatmentsConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type EligibilityConditionSetTreatmentsConnectionWhere = {
  AND?: InputMaybe<Array<EligibilityConditionSetTreatmentsConnectionWhere>>;
  NOT?: InputMaybe<EligibilityConditionSetTreatmentsConnectionWhere>;
  OR?: InputMaybe<Array<EligibilityConditionSetTreatmentsConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type EligibilityConditionSetTreatmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EligibilityConditionSetTreatmentsNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<EligibilityConditionSetTreatmentsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<EligibilityConditionSetTreatmentsNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EligibilityConditionSetTreatmentsRelationship = {
  __typename?: 'EligibilityConditionSetTreatmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type EligibilityConditionSetWhere = {
  AND?: InputMaybe<Array<EligibilityConditionSetWhere>>;
  NOT?: InputMaybe<EligibilityConditionSetWhere>;
  OR?: InputMaybe<Array<EligibilityConditionSetWhere>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  inputLabel?: InputMaybe<Scalars['String']['input']>;
  inputLabel_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  inputLabel_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  inputLabel_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inputLabel_MATCHES?: InputMaybe<Scalars['String']['input']>;
  inputLabel_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  treatmentsAggregate?: InputMaybe<EligibilityConditionSetTreatmentsAggregateInput>;
  /** Return EligibilityConditionSets where all of the related EligibilityConditionSetTreatmentsConnections match this filter */
  treatmentsConnection_ALL?: InputMaybe<EligibilityConditionSetTreatmentsConnectionWhere>;
  /** Return EligibilityConditionSets where none of the related EligibilityConditionSetTreatmentsConnections match this filter */
  treatmentsConnection_NONE?: InputMaybe<EligibilityConditionSetTreatmentsConnectionWhere>;
  /** Return EligibilityConditionSets where one of the related EligibilityConditionSetTreatmentsConnections match this filter */
  treatmentsConnection_SINGLE?: InputMaybe<EligibilityConditionSetTreatmentsConnectionWhere>;
  /** Return EligibilityConditionSets where some of the related EligibilityConditionSetTreatmentsConnections match this filter */
  treatmentsConnection_SOME?: InputMaybe<EligibilityConditionSetTreatmentsConnectionWhere>;
  /** Return EligibilityConditionSets where all of the related Treatments match this filter */
  treatments_ALL?: InputMaybe<TreatmentWhere>;
  /** Return EligibilityConditionSets where none of the related Treatments match this filter */
  treatments_NONE?: InputMaybe<TreatmentWhere>;
  /** Return EligibilityConditionSets where one of the related Treatments match this filter */
  treatments_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return EligibilityConditionSets where some of the related Treatments match this filter */
  treatments_SOME?: InputMaybe<TreatmentWhere>;
};

export type EligibilityConditionSetsConnection = {
  __typename?: 'EligibilityConditionSetsConnection';
  edges: Array<EligibilityConditionSetEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EncapsulatedFeature = {
  __typename?: 'EncapsulatedFeature';
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type EncapsulatedFeatureConfiguration = {
  __typename?: 'EncapsulatedFeatureConfiguration';
  isEnabled: Scalars['Boolean']['output'];
  ofType: EncapsulatedFeature;
  ofTypeAggregate?: Maybe<EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection>;
  ofTypeConnection: EncapsulatedFeatureConfigurationOfTypeConnection;
  setFor: Organization;
  setForAggregate?: Maybe<EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection>;
  setForConnection: EncapsulatedFeatureConfigurationSetForConnection;
  value?: Maybe<Scalars['String']['output']>;
};


export type EncapsulatedFeatureConfigurationOfTypeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EncapsulatedFeatureOptions>;
  where?: InputMaybe<EncapsulatedFeatureWhere>;
};


export type EncapsulatedFeatureConfigurationOfTypeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EncapsulatedFeatureWhere>;
};


export type EncapsulatedFeatureConfigurationOfTypeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeConnectionSort>>;
  where?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeConnectionWhere>;
};


export type EncapsulatedFeatureConfigurationSetForArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type EncapsulatedFeatureConfigurationSetForAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type EncapsulatedFeatureConfigurationSetForConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForConnectionSort>>;
  where?: InputMaybe<EncapsulatedFeatureConfigurationSetForConnectionWhere>;
};

export type EncapsulatedFeatureConfigurationEdge = {
  __typename?: 'EncapsulatedFeatureConfigurationEdge';
  cursor: Scalars['String']['output'];
  node: EncapsulatedFeatureConfiguration;
};

export type EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection = {
  __typename?: 'EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection>;
};

export type EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection = {
  __typename?: 'EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection';
  key: StringAggregateSelectionNonNullable;
  title: StringAggregateSelectionNonNullable;
};

export type EncapsulatedFeatureConfigurationInput = {
  isEnabled: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type EncapsulatedFeatureConfigurationOfTypeAggregateInput = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeAggregateInput>>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeAggregateInput>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput>;
};

export type EncapsulatedFeatureConfigurationOfTypeConnection = {
  __typename?: 'EncapsulatedFeatureConfigurationOfTypeConnection';
  edges: Array<EncapsulatedFeatureConfigurationOfTypeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EncapsulatedFeatureConfigurationOfTypeConnectionSort = {
  node?: InputMaybe<EncapsulatedFeatureSort>;
};

export type EncapsulatedFeatureConfigurationOfTypeConnectionWhere = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeConnectionWhere>>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeConnectionWhere>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeConnectionWhere>>;
  node?: InputMaybe<EncapsulatedFeatureWhere>;
};

export type EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput>>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EncapsulatedFeatureConfigurationOfTypeRelationship = {
  __typename?: 'EncapsulatedFeatureConfigurationOfTypeRelationship';
  cursor: Scalars['String']['output'];
  node: EncapsulatedFeature;
};

export type EncapsulatedFeatureConfigurationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EncapsulatedFeatureConfigurationSort objects to sort EncapsulatedFeatureConfigurations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EncapsulatedFeatureConfigurationSort>>;
};

export type EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection = {
  __typename?: 'EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection>;
};

export type EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection = {
  __typename?: 'EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type EncapsulatedFeatureConfigurationSetForAggregateInput = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForAggregateInput>>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationSetForAggregateInput>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput>;
};

export type EncapsulatedFeatureConfigurationSetForConnection = {
  __typename?: 'EncapsulatedFeatureConfigurationSetForConnection';
  edges: Array<EncapsulatedFeatureConfigurationSetForRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EncapsulatedFeatureConfigurationSetForConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type EncapsulatedFeatureConfigurationSetForConnectionWhere = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForConnectionWhere>>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationSetForConnectionWhere>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EncapsulatedFeatureConfigurationSetForRelationship = {
  __typename?: 'EncapsulatedFeatureConfigurationSetForRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

/** Fields to sort EncapsulatedFeatureConfigurations by. The order in which sorts are applied is not guaranteed when specifying many fields in one EncapsulatedFeatureConfigurationSort object. */
export type EncapsulatedFeatureConfigurationSort = {
  isEnabled?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type EncapsulatedFeatureConfigurationWhere = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationWhere>>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationWhere>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ofType?: InputMaybe<EncapsulatedFeatureWhere>;
  ofTypeAggregate?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeAggregateInput>;
  ofTypeConnection?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeConnectionWhere>;
  ofTypeConnection_NOT?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeConnectionWhere>;
  ofType_NOT?: InputMaybe<EncapsulatedFeatureWhere>;
  setFor?: InputMaybe<OrganizationWhere>;
  setForAggregate?: InputMaybe<EncapsulatedFeatureConfigurationSetForAggregateInput>;
  setForConnection?: InputMaybe<EncapsulatedFeatureConfigurationSetForConnectionWhere>;
  setForConnection_NOT?: InputMaybe<EncapsulatedFeatureConfigurationSetForConnectionWhere>;
  setFor_NOT?: InputMaybe<OrganizationWhere>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  value_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_MATCHES?: InputMaybe<Scalars['String']['input']>;
  value_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type EncapsulatedFeatureConfigurationsConnection = {
  __typename?: 'EncapsulatedFeatureConfigurationsConnection';
  edges: Array<EncapsulatedFeatureConfigurationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EncapsulatedFeatureEdge = {
  __typename?: 'EncapsulatedFeatureEdge';
  cursor: Scalars['String']['output'];
  node: EncapsulatedFeature;
};

export type EncapsulatedFeatureOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EncapsulatedFeatureSort objects to sort EncapsulatedFeatures by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EncapsulatedFeatureSort>>;
};

/** Fields to sort EncapsulatedFeatures by. The order in which sorts are applied is not guaranteed when specifying many fields in one EncapsulatedFeatureSort object. */
export type EncapsulatedFeatureSort = {
  key?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type EncapsulatedFeatureWhere = {
  AND?: InputMaybe<Array<EncapsulatedFeatureWhere>>;
  NOT?: InputMaybe<EncapsulatedFeatureWhere>;
  OR?: InputMaybe<Array<EncapsulatedFeatureWhere>>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  key_MATCHES?: InputMaybe<Scalars['String']['input']>;
  key_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_MATCHES?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type EncapsulatedFeaturesConnection = {
  __typename?: 'EncapsulatedFeaturesConnection';
  edges: Array<EncapsulatedFeatureEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EncryptionInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  encryptionType?: InputMaybe<EncryptionType>;
  organizationId: Scalars['Int']['input'];
};

export enum EncryptionType {
  Hin = 'HIN'
}

export type EnrollingCondition = {
  __typename?: 'EnrollingCondition';
  attributeValue?: Maybe<Scalars['String']['output']>;
  bothOperatorFirst?: Maybe<ArithmeticalOperator>;
  bothOperatorSecond?: Maybe<ArithmeticalOperator>;
  conditionType: EnrollingConditionType;
  countdownOperator?: Maybe<CountdownOperator>;
  customCondition?: Maybe<CustomCondition>;
  customConditionAggregate?: Maybe<EnrollingConditionCustomConditionCustomConditionAggregationSelection>;
  customConditionConnection: EnrollingConditionCustomConditionConnection;
  cycleLimitFrom?: Maybe<Scalars['Int']['output']>;
  cycleLimitTo?: Maybe<Scalars['Int']['output']>;
  includedGenerics: Array<Generic>;
  includedGenericsAggregate?: Maybe<EnrollingConditionGenericIncludedGenericsAggregationSelection>;
  includedGenericsConnection: EnrollingConditionIncludedGenericsConnection;
  inclusionType?: Maybe<InclusionType>;
  operator?: Maybe<ArithmeticalOperator>;
  rangeInputEnd?: Maybe<Scalars['Int']['output']>;
  rangeInputStart?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Array<CoverageRequestRating>>;
  resultSelectionType?: Maybe<ResultSelectionType>;
  therapyDecision?: Maybe<Array<CoverageRequestTherapyDecision>>;
  timeframeRangeEnd?: Maybe<Scalars['Int']['output']>;
  timeframeRangeStart?: Maybe<Scalars['Int']['output']>;
  timeframeRangeType?: Maybe<TimeframeRangeType>;
  timeframeStartingPoint?: Maybe<TimeframeStartingPoint>;
};


export type EnrollingConditionCustomConditionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CustomConditionOptions>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type EnrollingConditionCustomConditionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type EnrollingConditionCustomConditionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnrollingConditionCustomConditionConnectionSort>>;
  where?: InputMaybe<EnrollingConditionCustomConditionConnectionWhere>;
};


export type EnrollingConditionIncludedGenericsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type EnrollingConditionIncludedGenericsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type EnrollingConditionIncludedGenericsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnrollingConditionIncludedGenericsConnectionSort>>;
  where?: InputMaybe<EnrollingConditionIncludedGenericsConnectionWhere>;
};

export type EnrollingConditionCustomConditionAggregateInput = {
  AND?: InputMaybe<Array<EnrollingConditionCustomConditionAggregateInput>>;
  NOT?: InputMaybe<EnrollingConditionCustomConditionAggregateInput>;
  OR?: InputMaybe<Array<EnrollingConditionCustomConditionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EnrollingConditionCustomConditionNodeAggregationWhereInput>;
};

export type EnrollingConditionCustomConditionConnection = {
  __typename?: 'EnrollingConditionCustomConditionConnection';
  edges: Array<EnrollingConditionCustomConditionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingConditionCustomConditionConnectionSort = {
  node?: InputMaybe<CustomConditionSort>;
};

export type EnrollingConditionCustomConditionConnectionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionCustomConditionConnectionWhere>>;
  NOT?: InputMaybe<EnrollingConditionCustomConditionConnectionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionCustomConditionConnectionWhere>>;
  node?: InputMaybe<CustomConditionWhere>;
};

export type EnrollingConditionCustomConditionCustomConditionAggregationSelection = {
  __typename?: 'EnrollingConditionCustomConditionCustomConditionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection>;
};

export type EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection = {
  __typename?: 'EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  description: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type EnrollingConditionCustomConditionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrollingConditionCustomConditionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EnrollingConditionCustomConditionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EnrollingConditionCustomConditionNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EnrollingConditionCustomConditionRelationship = {
  __typename?: 'EnrollingConditionCustomConditionRelationship';
  cursor: Scalars['String']['output'];
  node: CustomCondition;
};

export type EnrollingConditionDiseaseRelationship = {
  Score?: Maybe<Scalars['Float']['output']>;
};

export type EnrollingConditionDiseaseRelationshipSort = {
  Score?: InputMaybe<SortDirection>;
};

export type EnrollingConditionDiseaseRelationshipWhere = {
  AND?: InputMaybe<Array<EnrollingConditionDiseaseRelationshipWhere>>;
  NOT?: InputMaybe<EnrollingConditionDiseaseRelationshipWhere>;
  OR?: InputMaybe<Array<EnrollingConditionDiseaseRelationshipWhere>>;
  Score?: InputMaybe<Scalars['Float']['input']>;
  Score_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Score_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type EnrollingConditionEdge = {
  __typename?: 'EnrollingConditionEdge';
  cursor: Scalars['String']['output'];
  node: EnrollingCondition;
};

export type EnrollingConditionGenericIncludedGenericsAggregationSelection = {
  __typename?: 'EnrollingConditionGenericIncludedGenericsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EnrollingConditionGenericIncludedGenericsNodeAggregateSelection>;
};

export type EnrollingConditionGenericIncludedGenericsNodeAggregateSelection = {
  __typename?: 'EnrollingConditionGenericIncludedGenericsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type EnrollingConditionIncludedGenericsAggregateInput = {
  AND?: InputMaybe<Array<EnrollingConditionIncludedGenericsAggregateInput>>;
  NOT?: InputMaybe<EnrollingConditionIncludedGenericsAggregateInput>;
  OR?: InputMaybe<Array<EnrollingConditionIncludedGenericsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EnrollingConditionIncludedGenericsNodeAggregationWhereInput>;
};

export type EnrollingConditionIncludedGenericsConnection = {
  __typename?: 'EnrollingConditionIncludedGenericsConnection';
  edges: Array<EnrollingConditionIncludedGenericsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingConditionIncludedGenericsConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type EnrollingConditionIncludedGenericsConnectionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionIncludedGenericsConnectionWhere>>;
  NOT?: InputMaybe<EnrollingConditionIncludedGenericsConnectionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionIncludedGenericsConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type EnrollingConditionIncludedGenericsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrollingConditionIncludedGenericsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EnrollingConditionIncludedGenericsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<EnrollingConditionIncludedGenericsNodeAggregationWhereInput>>;
};

export type EnrollingConditionIncludedGenericsRelationship = {
  __typename?: 'EnrollingConditionIncludedGenericsRelationship';
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type EnrollingConditionInput = {
  attributeValue?: InputMaybe<Scalars['String']['input']>;
  bothOperatorFirst?: InputMaybe<ArithmeticalOperator>;
  bothOperatorSecond?: InputMaybe<ArithmeticalOperator>;
  conditionType: EnrollingConditionType;
  countdownOperator?: InputMaybe<CountdownOperator>;
  customCondition?: InputMaybe<Scalars['String']['input']>;
  cycleLimitFrom?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo?: InputMaybe<Scalars['Int']['input']>;
  includedGenerics?: InputMaybe<Array<Scalars['String']['input']>>;
  inclusionType?: InputMaybe<InclusionType>;
  operator?: InputMaybe<ArithmeticalOperator>;
  rangeInputEnd?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Array<CoverageRequestRating>>;
  resultSelectionType?: InputMaybe<ResultSelectionType>;
  therapyDecision?: InputMaybe<Array<CoverageRequestTherapyDecision>>;
  timeframeRangeEnd?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeType?: InputMaybe<TimeframeRangeType>;
  timeframeStartingPoint?: InputMaybe<TimeframeStartingPoint>;
};

export type EnrollingConditionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EnrollingConditionSort objects to sort EnrollingConditions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EnrollingConditionSort>>;
};

export type EnrollingConditionSet = {
  __typename?: 'EnrollingConditionSet';
  agreement?: Maybe<Agreement>;
  agreementAggregate?: Maybe<EnrollingConditionSetAgreementAgreementAggregationSelection>;
  agreementConnection: EnrollingConditionSetAgreementConnection;
  conditions: Array<EnrollingCondition>;
  conditionsAggregate?: Maybe<EnrollingConditionSetEnrollingConditionConditionsAggregationSelection>;
  conditionsConnection: EnrollingConditionSetConditionsConnection;
  isDiseaseNotEnrollingCondition?: Maybe<Scalars['Boolean']['output']>;
  isIndicationNotEnrollingCondition?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Int']['output'];
  scopes: Array<AgreementScope>;
  scopesAggregate?: Maybe<EnrollingConditionSetAgreementScopeScopesAggregationSelection>;
  scopesConnection: EnrollingConditionSetScopesConnection;
  template?: Maybe<AgreementTemplate>;
  templateAggregate?: Maybe<EnrollingConditionSetAgreementTemplateTemplateAggregationSelection>;
  templateConnection: EnrollingConditionSetTemplateConnection;
};


export type EnrollingConditionSetAgreementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type EnrollingConditionSetAgreementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type EnrollingConditionSetAgreementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnrollingConditionSetAgreementConnectionSort>>;
  where?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
};


export type EnrollingConditionSetConditionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingConditionOptions>;
  where?: InputMaybe<EnrollingConditionWhere>;
};


export type EnrollingConditionSetConditionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingConditionWhere>;
};


export type EnrollingConditionSetConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnrollingConditionSetConditionsConnectionSort>>;
  where?: InputMaybe<EnrollingConditionSetConditionsConnectionWhere>;
};


export type EnrollingConditionSetScopesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementScopeOptions>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type EnrollingConditionSetScopesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type EnrollingConditionSetScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnrollingConditionSetScopesConnectionSort>>;
  where?: InputMaybe<EnrollingConditionSetScopesConnectionWhere>;
};


export type EnrollingConditionSetTemplateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type EnrollingConditionSetTemplateAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type EnrollingConditionSetTemplateConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnrollingConditionSetTemplateConnectionSort>>;
  where?: InputMaybe<EnrollingConditionSetTemplateConnectionWhere>;
};

export type EnrollingConditionSetAgreementAggregateInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetAgreementAggregateInput>>;
  NOT?: InputMaybe<EnrollingConditionSetAgreementAggregateInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetAgreementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EnrollingConditionSetAgreementNodeAggregationWhereInput>;
};

export type EnrollingConditionSetAgreementAgreementAggregationSelection = {
  __typename?: 'EnrollingConditionSetAgreementAgreementAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EnrollingConditionSetAgreementAgreementNodeAggregateSelection>;
};

export type EnrollingConditionSetAgreementAgreementNodeAggregateSelection = {
  __typename?: 'EnrollingConditionSetAgreementAgreementNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type EnrollingConditionSetAgreementConnection = {
  __typename?: 'EnrollingConditionSetAgreementConnection';
  edges: Array<EnrollingConditionSetAgreementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingConditionSetAgreementConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type EnrollingConditionSetAgreementConnectionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionSetAgreementConnectionWhere>>;
  NOT?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionSetAgreementConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type EnrollingConditionSetAgreementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetAgreementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EnrollingConditionSetAgreementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetAgreementNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EnrollingConditionSetAgreementRelationship = {
  __typename?: 'EnrollingConditionSetAgreementRelationship';
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type EnrollingConditionSetAgreementScopeScopesAggregationSelection = {
  __typename?: 'EnrollingConditionSetAgreementScopeScopesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection>;
};

export type EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection = {
  __typename?: 'EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
  scopeId: StringAggregateSelectionNonNullable;
};

export type EnrollingConditionSetAgreementTemplateTemplateAggregationSelection = {
  __typename?: 'EnrollingConditionSetAgreementTemplateTemplateAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection>;
};

export type EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection = {
  __typename?: 'EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection';
  addedByName: StringAggregateSelectionNullable;
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  treatments: StringAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type EnrollingConditionSetConditionsAggregateInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetConditionsAggregateInput>>;
  NOT?: InputMaybe<EnrollingConditionSetConditionsAggregateInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetConditionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EnrollingConditionSetConditionsNodeAggregationWhereInput>;
};

export type EnrollingConditionSetConditionsConnection = {
  __typename?: 'EnrollingConditionSetConditionsConnection';
  edges: Array<EnrollingConditionSetConditionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingConditionSetConditionsConnectionSort = {
  node?: InputMaybe<EnrollingConditionSort>;
};

export type EnrollingConditionSetConditionsConnectionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionSetConditionsConnectionWhere>>;
  NOT?: InputMaybe<EnrollingConditionSetConditionsConnectionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionSetConditionsConnectionWhere>>;
  node?: InputMaybe<EnrollingConditionWhere>;
};

export type EnrollingConditionSetConditionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetConditionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EnrollingConditionSetConditionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetConditionsNodeAggregationWhereInput>>;
  attributeValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attributeValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  attributeValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  attributeValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  attributeValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  attributeValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rangeInputEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  rangeInputEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  rangeInputEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  rangeInputEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  rangeInputEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rangeInputStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  rangeInputStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  rangeInputStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  rangeInputStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  rangeInputStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EnrollingConditionSetConditionsRelationship = {
  __typename?: 'EnrollingConditionSetConditionsRelationship';
  cursor: Scalars['String']['output'];
  node: EnrollingCondition;
};

export type EnrollingConditionSetEdge = {
  __typename?: 'EnrollingConditionSetEdge';
  cursor: Scalars['String']['output'];
  node: EnrollingConditionSet;
};

export type EnrollingConditionSetEnrollingConditionConditionsAggregationSelection = {
  __typename?: 'EnrollingConditionSetEnrollingConditionConditionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection>;
};

export type EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection = {
  __typename?: 'EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection';
  attributeValue: StringAggregateSelectionNullable;
  cycleLimitFrom: IntAggregateSelectionNullable;
  cycleLimitTo: IntAggregateSelectionNullable;
  rangeInputEnd: IntAggregateSelectionNullable;
  rangeInputStart: IntAggregateSelectionNullable;
  timeframeRangeEnd: IntAggregateSelectionNullable;
  timeframeRangeStart: IntAggregateSelectionNullable;
};

export type EnrollingConditionSetInput = {
  conditions: Array<EnrollingConditionInput>;
  isDiseaseNotEnrollingCondition?: InputMaybe<Scalars['Boolean']['input']>;
  isIndicationNotEnrollingCondition?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  scopes: Array<AgreementScopeInput>;
};

export type EnrollingConditionSetOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EnrollingConditionSetSort objects to sort EnrollingConditionSets by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EnrollingConditionSetSort>>;
};

export type EnrollingConditionSetRelationship = {
  isExtended?: Maybe<Scalars['Boolean']['output']>;
};

export type EnrollingConditionSetRelationshipSort = {
  isExtended?: InputMaybe<SortDirection>;
};

export type EnrollingConditionSetRelationshipWhere = {
  AND?: InputMaybe<Array<EnrollingConditionSetRelationshipWhere>>;
  NOT?: InputMaybe<EnrollingConditionSetRelationshipWhere>;
  OR?: InputMaybe<Array<EnrollingConditionSetRelationshipWhere>>;
  isExtended?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnrollingConditionSetScopesAggregateInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetScopesAggregateInput>>;
  NOT?: InputMaybe<EnrollingConditionSetScopesAggregateInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetScopesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EnrollingConditionSetScopesNodeAggregationWhereInput>;
};

export type EnrollingConditionSetScopesConnection = {
  __typename?: 'EnrollingConditionSetScopesConnection';
  edges: Array<EnrollingConditionSetScopesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingConditionSetScopesConnectionSort = {
  edge?: InputMaybe<AgreementScopeRelationshipSort>;
  node?: InputMaybe<AgreementScopeSort>;
};

export type EnrollingConditionSetScopesConnectionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionSetScopesConnectionWhere>>;
  NOT?: InputMaybe<EnrollingConditionSetScopesConnectionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionSetScopesConnectionWhere>>;
  edge?: InputMaybe<AgreementScopeRelationshipWhere>;
  node?: InputMaybe<AgreementScopeWhere>;
};

export type EnrollingConditionSetScopesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetScopesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EnrollingConditionSetScopesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetScopesNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EnrollingConditionSetScopesRelationship = AgreementScopeRelationship & {
  __typename?: 'EnrollingConditionSetScopesRelationship';
  cursor: Scalars['String']['output'];
  excludedOn?: Maybe<Scalars['Date']['output']>;
  isExtended?: Maybe<Scalars['Boolean']['output']>;
  node: AgreementScope;
};

/** Fields to sort EnrollingConditionSets by. The order in which sorts are applied is not guaranteed when specifying many fields in one EnrollingConditionSetSort object. */
export type EnrollingConditionSetSort = {
  isDiseaseNotEnrollingCondition?: InputMaybe<SortDirection>;
  isIndicationNotEnrollingCondition?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
};

export type EnrollingConditionSetTemplateAggregateInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetTemplateAggregateInput>>;
  NOT?: InputMaybe<EnrollingConditionSetTemplateAggregateInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetTemplateAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EnrollingConditionSetTemplateNodeAggregationWhereInput>;
};

export type EnrollingConditionSetTemplateConnection = {
  __typename?: 'EnrollingConditionSetTemplateConnection';
  edges: Array<EnrollingConditionSetTemplateRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingConditionSetTemplateConnectionSort = {
  node?: InputMaybe<AgreementTemplateSort>;
};

export type EnrollingConditionSetTemplateConnectionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionSetTemplateConnectionWhere>>;
  NOT?: InputMaybe<EnrollingConditionSetTemplateConnectionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionSetTemplateConnectionWhere>>;
  node?: InputMaybe<AgreementTemplateWhere>;
};

export type EnrollingConditionSetTemplateNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetTemplateNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EnrollingConditionSetTemplateNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetTemplateNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EnrollingConditionSetTemplateRelationship = {
  __typename?: 'EnrollingConditionSetTemplateRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type EnrollingConditionSetWhere = {
  AND?: InputMaybe<Array<EnrollingConditionSetWhere>>;
  NOT?: InputMaybe<EnrollingConditionSetWhere>;
  OR?: InputMaybe<Array<EnrollingConditionSetWhere>>;
  agreement?: InputMaybe<AgreementWhere>;
  agreementAggregate?: InputMaybe<EnrollingConditionSetAgreementAggregateInput>;
  agreementConnection?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
  agreementConnection_NOT?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
  agreement_NOT?: InputMaybe<AgreementWhere>;
  conditionsAggregate?: InputMaybe<EnrollingConditionSetConditionsAggregateInput>;
  /** Return EnrollingConditionSets where all of the related EnrollingConditionSetConditionsConnections match this filter */
  conditionsConnection_ALL?: InputMaybe<EnrollingConditionSetConditionsConnectionWhere>;
  /** Return EnrollingConditionSets where none of the related EnrollingConditionSetConditionsConnections match this filter */
  conditionsConnection_NONE?: InputMaybe<EnrollingConditionSetConditionsConnectionWhere>;
  /** Return EnrollingConditionSets where one of the related EnrollingConditionSetConditionsConnections match this filter */
  conditionsConnection_SINGLE?: InputMaybe<EnrollingConditionSetConditionsConnectionWhere>;
  /** Return EnrollingConditionSets where some of the related EnrollingConditionSetConditionsConnections match this filter */
  conditionsConnection_SOME?: InputMaybe<EnrollingConditionSetConditionsConnectionWhere>;
  /** Return EnrollingConditionSets where all of the related EnrollingConditions match this filter */
  conditions_ALL?: InputMaybe<EnrollingConditionWhere>;
  /** Return EnrollingConditionSets where none of the related EnrollingConditions match this filter */
  conditions_NONE?: InputMaybe<EnrollingConditionWhere>;
  /** Return EnrollingConditionSets where one of the related EnrollingConditions match this filter */
  conditions_SINGLE?: InputMaybe<EnrollingConditionWhere>;
  /** Return EnrollingConditionSets where some of the related EnrollingConditions match this filter */
  conditions_SOME?: InputMaybe<EnrollingConditionWhere>;
  isDiseaseNotEnrollingCondition?: InputMaybe<Scalars['Boolean']['input']>;
  isIndicationNotEnrollingCondition?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopesAggregate?: InputMaybe<EnrollingConditionSetScopesAggregateInput>;
  /** Return EnrollingConditionSets where all of the related EnrollingConditionSetScopesConnections match this filter */
  scopesConnection_ALL?: InputMaybe<EnrollingConditionSetScopesConnectionWhere>;
  /** Return EnrollingConditionSets where none of the related EnrollingConditionSetScopesConnections match this filter */
  scopesConnection_NONE?: InputMaybe<EnrollingConditionSetScopesConnectionWhere>;
  /** Return EnrollingConditionSets where one of the related EnrollingConditionSetScopesConnections match this filter */
  scopesConnection_SINGLE?: InputMaybe<EnrollingConditionSetScopesConnectionWhere>;
  /** Return EnrollingConditionSets where some of the related EnrollingConditionSetScopesConnections match this filter */
  scopesConnection_SOME?: InputMaybe<EnrollingConditionSetScopesConnectionWhere>;
  /** Return EnrollingConditionSets where all of the related AgreementScopes match this filter */
  scopes_ALL?: InputMaybe<AgreementScopeWhere>;
  /** Return EnrollingConditionSets where none of the related AgreementScopes match this filter */
  scopes_NONE?: InputMaybe<AgreementScopeWhere>;
  /** Return EnrollingConditionSets where one of the related AgreementScopes match this filter */
  scopes_SINGLE?: InputMaybe<AgreementScopeWhere>;
  /** Return EnrollingConditionSets where some of the related AgreementScopes match this filter */
  scopes_SOME?: InputMaybe<AgreementScopeWhere>;
  template?: InputMaybe<AgreementTemplateWhere>;
  templateAggregate?: InputMaybe<EnrollingConditionSetTemplateAggregateInput>;
  templateConnection?: InputMaybe<EnrollingConditionSetTemplateConnectionWhere>;
  templateConnection_NOT?: InputMaybe<EnrollingConditionSetTemplateConnectionWhere>;
  template_NOT?: InputMaybe<AgreementTemplateWhere>;
};

export type EnrollingConditionSetsConnection = {
  __typename?: 'EnrollingConditionSetsConnection';
  edges: Array<EnrollingConditionSetEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Fields to sort EnrollingConditions by. The order in which sorts are applied is not guaranteed when specifying many fields in one EnrollingConditionSort object. */
export type EnrollingConditionSort = {
  attributeValue?: InputMaybe<SortDirection>;
  bothOperatorFirst?: InputMaybe<SortDirection>;
  bothOperatorSecond?: InputMaybe<SortDirection>;
  conditionType?: InputMaybe<SortDirection>;
  countdownOperator?: InputMaybe<SortDirection>;
  cycleLimitFrom?: InputMaybe<SortDirection>;
  cycleLimitTo?: InputMaybe<SortDirection>;
  inclusionType?: InputMaybe<SortDirection>;
  operator?: InputMaybe<SortDirection>;
  rangeInputEnd?: InputMaybe<SortDirection>;
  rangeInputStart?: InputMaybe<SortDirection>;
  resultSelectionType?: InputMaybe<SortDirection>;
  timeframeRangeEnd?: InputMaybe<SortDirection>;
  timeframeRangeStart?: InputMaybe<SortDirection>;
  timeframeRangeType?: InputMaybe<SortDirection>;
  timeframeStartingPoint?: InputMaybe<SortDirection>;
};

export enum EnrollingConditionType {
  CustomCondition = 'CUSTOM_CONDITION',
  CycleLimit = 'CYCLE_LIMIT',
  DataGuidance = 'DATA_GUIDANCE',
  LdlLevel = 'LDL_LEVEL',
  NotYetConfirmed = 'NOT_YET_CONFIRMED',
  OutsideValidityPeriod = 'OUTSIDE_VALIDITY_PERIOD',
  PatientAge = 'PATIENT_AGE',
  PreviousTherapy = 'PREVIOUS_THERAPY',
  Rating = 'RATING',
  Rejected = 'REJECTED',
  TherapyDecision = 'THERAPY_DECISION',
  Uncertain = 'UNCERTAIN',
  Unknown = 'UNKNOWN'
}

export type EnrollingConditionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionWhere>>;
  NOT?: InputMaybe<EnrollingConditionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionWhere>>;
  attributeValue?: InputMaybe<Scalars['String']['input']>;
  attributeValue_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  attributeValue_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  attributeValue_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributeValue_MATCHES?: InputMaybe<Scalars['String']['input']>;
  attributeValue_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  bothOperatorFirst?: InputMaybe<ArithmeticalOperator>;
  bothOperatorFirst_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  bothOperatorSecond?: InputMaybe<ArithmeticalOperator>;
  bothOperatorSecond_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  conditionType?: InputMaybe<EnrollingConditionType>;
  conditionType_IN?: InputMaybe<Array<EnrollingConditionType>>;
  countdownOperator?: InputMaybe<CountdownOperator>;
  countdownOperator_IN?: InputMaybe<Array<InputMaybe<CountdownOperator>>>;
  customCondition?: InputMaybe<CustomConditionWhere>;
  customConditionAggregate?: InputMaybe<EnrollingConditionCustomConditionAggregateInput>;
  customConditionConnection?: InputMaybe<EnrollingConditionCustomConditionConnectionWhere>;
  customConditionConnection_NOT?: InputMaybe<EnrollingConditionCustomConditionConnectionWhere>;
  customCondition_NOT?: InputMaybe<CustomConditionWhere>;
  cycleLimitFrom?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cycleLimitFrom_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cycleLimitTo_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_LTE?: InputMaybe<Scalars['Int']['input']>;
  includedGenericsAggregate?: InputMaybe<EnrollingConditionIncludedGenericsAggregateInput>;
  /** Return EnrollingConditions where all of the related EnrollingConditionIncludedGenericsConnections match this filter */
  includedGenericsConnection_ALL?: InputMaybe<EnrollingConditionIncludedGenericsConnectionWhere>;
  /** Return EnrollingConditions where none of the related EnrollingConditionIncludedGenericsConnections match this filter */
  includedGenericsConnection_NONE?: InputMaybe<EnrollingConditionIncludedGenericsConnectionWhere>;
  /** Return EnrollingConditions where one of the related EnrollingConditionIncludedGenericsConnections match this filter */
  includedGenericsConnection_SINGLE?: InputMaybe<EnrollingConditionIncludedGenericsConnectionWhere>;
  /** Return EnrollingConditions where some of the related EnrollingConditionIncludedGenericsConnections match this filter */
  includedGenericsConnection_SOME?: InputMaybe<EnrollingConditionIncludedGenericsConnectionWhere>;
  /** Return EnrollingConditions where all of the related Generics match this filter */
  includedGenerics_ALL?: InputMaybe<GenericWhere>;
  /** Return EnrollingConditions where none of the related Generics match this filter */
  includedGenerics_NONE?: InputMaybe<GenericWhere>;
  /** Return EnrollingConditions where one of the related Generics match this filter */
  includedGenerics_SINGLE?: InputMaybe<GenericWhere>;
  /** Return EnrollingConditions where some of the related Generics match this filter */
  includedGenerics_SOME?: InputMaybe<GenericWhere>;
  inclusionType?: InputMaybe<InclusionType>;
  inclusionType_IN?: InputMaybe<Array<InputMaybe<InclusionType>>>;
  operator?: InputMaybe<ArithmeticalOperator>;
  operator_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  rangeInputEnd?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rangeInputEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rangeInputStart_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Array<CoverageRequestRating>>;
  rating_INCLUDES?: InputMaybe<CoverageRequestRating>;
  resultSelectionType?: InputMaybe<ResultSelectionType>;
  resultSelectionType_IN?: InputMaybe<Array<InputMaybe<ResultSelectionType>>>;
  therapyDecision?: InputMaybe<Array<CoverageRequestTherapyDecision>>;
  therapyDecision_INCLUDES?: InputMaybe<CoverageRequestTherapyDecision>;
  timeframeRangeEnd?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeRangeEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeRangeStart_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeType?: InputMaybe<TimeframeRangeType>;
  timeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
  timeframeStartingPoint?: InputMaybe<TimeframeStartingPoint>;
  timeframeStartingPoint_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
};

export type EnrollingConditionsConnection = {
  __typename?: 'EnrollingConditionsConnection';
  edges: Array<EnrollingConditionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingPeriod = {
  __typename?: 'EnrollingPeriod';
  from: Scalars['Date']['output'];
  to: Scalars['Date']['output'];
};

export type EnrollingPeriodEdge = {
  __typename?: 'EnrollingPeriodEdge';
  cursor: Scalars['String']['output'];
  node: EnrollingPeriod;
};

export type EnrollingPeriodInput = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export type EnrollingPeriodOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EnrollingPeriodSort objects to sort EnrollingPeriods by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EnrollingPeriodSort>>;
};

/** Fields to sort EnrollingPeriods by. The order in which sorts are applied is not guaranteed when specifying many fields in one EnrollingPeriodSort object. */
export type EnrollingPeriodSort = {
  from?: InputMaybe<SortDirection>;
  to?: InputMaybe<SortDirection>;
};

export type EnrollingPeriodWhere = {
  AND?: InputMaybe<Array<EnrollingPeriodWhere>>;
  NOT?: InputMaybe<EnrollingPeriodWhere>;
  OR?: InputMaybe<Array<EnrollingPeriodWhere>>;
  from?: InputMaybe<Scalars['Date']['input']>;
  from_GT?: InputMaybe<Scalars['Date']['input']>;
  from_GTE?: InputMaybe<Scalars['Date']['input']>;
  from_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  from_LT?: InputMaybe<Scalars['Date']['input']>;
  from_LTE?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  to_GT?: InputMaybe<Scalars['Date']['input']>;
  to_GTE?: InputMaybe<Scalars['Date']['input']>;
  to_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  to_LT?: InputMaybe<Scalars['Date']['input']>;
  to_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type EnrollingPeriodsConnection = {
  __typename?: 'EnrollingPeriodsConnection';
  edges: Array<EnrollingPeriodEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum EnrolmentDateType {
  DiagnosisDate = 'DIAGNOSIS_DATE',
  FirstRecordDate = 'FIRST_RECORD_DATE',
  RecordDate = 'RECORD_DATE',
  RequestReceiptDate = 'REQUEST_RECEIPT_DATE'
}

export enum EntityPriceType {
  Case = 'CASE',
  Cycle = 'CYCLE',
  Gram = 'GRAM',
  Milligram = 'MILLIGRAM',
  Millilitre = 'MILLILITRE',
  Pack = 'PACK'
}

export type EntityTypeMappingRelationship = {
  data?: Maybe<Scalars['String']['output']>;
};

export type EntityTypeMappingRelationshipSort = {
  data?: InputMaybe<SortDirection>;
};

export type EntityTypeMappingRelationshipWhere = {
  AND?: InputMaybe<Array<EntityTypeMappingRelationshipWhere>>;
  NOT?: InputMaybe<EntityTypeMappingRelationshipWhere>;
  OR?: InputMaybe<Array<EntityTypeMappingRelationshipWhere>>;
  data?: InputMaybe<Scalars['String']['input']>;
  data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  data_MATCHES?: InputMaybe<Scalars['String']['input']>;
  data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type EntryModule = {
  __typename?: 'EntryModule';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type EntryModuleEdge = {
  __typename?: 'EntryModuleEdge';
  cursor: Scalars['String']['output'];
  node: EntryModule;
};

export type EntryModuleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EntryModuleSort objects to sort EntryModules by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EntryModuleSort>>;
};

/** Fields to sort EntryModules by. The order in which sorts are applied is not guaranteed when specifying many fields in one EntryModuleSort object. */
export type EntryModuleSort = {
  code?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type EntryModuleWhere = {
  AND?: InputMaybe<Array<EntryModuleWhere>>;
  NOT?: InputMaybe<EntryModuleWhere>;
  OR?: InputMaybe<Array<EntryModuleWhere>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_GT?: InputMaybe<Scalars['Int']['input']>;
  id_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type EntryModulesConnection = {
  __typename?: 'EntryModulesConnection';
  edges: Array<EntryModuleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExFactoryPrice = {
  __typename?: 'ExFactoryPrice';
  Price?: Maybe<Scalars['String']['output']>;
  ValidFromDate?: Maybe<Scalars['Date']['output']>;
};

export type ExFactoryPriceEdge = {
  __typename?: 'ExFactoryPriceEdge';
  cursor: Scalars['String']['output'];
  node: ExFactoryPrice;
};

export type ExFactoryPriceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExFactoryPriceSort objects to sort ExFactoryPrices by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExFactoryPriceSort>>;
};

/** Fields to sort ExFactoryPrices by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExFactoryPriceSort object. */
export type ExFactoryPriceSort = {
  Price?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
};

export type ExFactoryPriceWhere = {
  AND?: InputMaybe<Array<ExFactoryPriceWhere>>;
  NOT?: InputMaybe<ExFactoryPriceWhere>;
  OR?: InputMaybe<Array<ExFactoryPriceWhere>>;
  Price?: InputMaybe<Scalars['String']['input']>;
  Price_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Price_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Price_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Price_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Price_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type ExFactoryPricesConnection = {
  __typename?: 'ExFactoryPricesConnection';
  edges: Array<ExFactoryPriceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExistingUserInput = {
  domains?: InputMaybe<Array<Scalars['ID']['input']>>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isReassigned?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locked: Scalars['Boolean']['input'];
  modules: Array<InputMaybe<ModuleInput>>;
  organization: OrganizationInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  role: Roles;
  subscribedToNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FinancialDataPointStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Removed = 'REMOVED',
  Undecided = 'UNDECIDED'
}

export type FinancialSummaryColumn = {
  __typename?: 'FinancialSummaryColumn';
  id: Scalars['ID']['output'];
  name: FinancialSummaryColumnName;
};

export type FinancialSummaryColumnEdge = {
  __typename?: 'FinancialSummaryColumnEdge';
  cursor: Scalars['String']['output'];
  node: FinancialSummaryColumn;
};

export enum FinancialSummaryColumnName {
  AlbertaListPrice = 'ALBERTA_LIST_PRICE',
  AlbertaMarkedUpPrice = 'ALBERTA_MARKED_UP_PRICE',
  BaselinePrice = 'BASELINE_PRICE',
  BritishColumbiaListPrice = 'BRITISH_COLUMBIA_LIST_PRICE',
  BritishColumbiaMarkedUpPrice = 'BRITISH_COLUMBIA_MARKED_UP_PRICE',
  Discounts = 'DISCOUNTS',
  ExFactoryPrice = 'EX_FACTORY_PRICE',
  GrossAmount = 'GROSS_AMOUNT',
  ManitobaListPrice = 'MANITOBA_LIST_PRICE',
  ManitobaMarkedUpPrice = 'MANITOBA_MARKED_UP_PRICE',
  NetAmount = 'NET_AMOUNT',
  NetAvgDiscountRate = 'NET_AVG_DISCOUNT_RATE',
  NetAvgPrice = 'NET_AVG_PRICE',
  NetPrice = 'NET_PRICE',
  NewfoundlandAndLabradorListPrice = 'NEWFOUNDLAND_AND_LABRADOR_LIST_PRICE',
  NewfoundlandAndLabradorMarkedUpPrice = 'NEWFOUNDLAND_AND_LABRADOR_MARKED_UP_PRICE',
  NewBrunswickListPrice = 'NEW_BRUNSWICK_LIST_PRICE',
  NewBrunswickMarkedUpPrice = 'NEW_BRUNSWICK_MARKED_UP_PRICE',
  NihbListPrice = 'NIHB_LIST_PRICE',
  NihbMarkedUpPrice = 'NIHB_MARKED_UP_PRICE',
  NorthwestTerritoriesListPrice = 'NORTHWEST_TERRITORIES_LIST_PRICE',
  NorthwestTerritoriesMarkedUpPrice = 'NORTHWEST_TERRITORIES_MARKED_UP_PRICE',
  NovaScotiaListPrice = 'NOVA_SCOTIA_LIST_PRICE',
  NovaScotiaMarkedUpPrice = 'NOVA_SCOTIA_MARKED_UP_PRICE',
  NunavutListPrice = 'NUNAVUT_LIST_PRICE',
  NunavutMarkedUpPrice = 'NUNAVUT_MARKED_UP_PRICE',
  OntarioListPrice = 'ONTARIO_LIST_PRICE',
  OntarioMarkedUpPrice = 'ONTARIO_MARKED_UP_PRICE',
  PrinceEdwardIslandListPrice = 'PRINCE_EDWARD_ISLAND_LIST_PRICE',
  PrinceEdwardIslandMarkedUpPrice = 'PRINCE_EDWARD_ISLAND_MARKED_UP_PRICE',
  Product = 'PRODUCT',
  PublicPrice = 'PUBLIC_PRICE',
  Quantity = 'QUANTITY',
  QuebecListPrice = 'QUEBEC_LIST_PRICE',
  QuebecMarkedUpPrice = 'QUEBEC_MARKED_UP_PRICE',
  SaskatchewanListPrice = 'SASKATCHEWAN_LIST_PRICE',
  SaskatchewanMarkedUpPrice = 'SASKATCHEWAN_MARKED_UP_PRICE',
  TotalDiscounts = 'TOTAL_DISCOUNTS',
  VacListPrice = 'VAC_LIST_PRICE',
  VacMarkedUpPrice = 'VAC_MARKED_UP_PRICE',
  Variable = 'VARIABLE',
  YukonListPrice = 'YUKON_LIST_PRICE',
  YukonMarkedUpPrice = 'YUKON_MARKED_UP_PRICE'
}

export type FinancialSummaryColumnOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FinancialSummaryColumnSort objects to sort FinancialSummaryColumns by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FinancialSummaryColumnSort>>;
};

/** Fields to sort FinancialSummaryColumns by. The order in which sorts are applied is not guaranteed when specifying many fields in one FinancialSummaryColumnSort object. */
export type FinancialSummaryColumnSort = {
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type FinancialSummaryColumnWhere = {
  AND?: InputMaybe<Array<FinancialSummaryColumnWhere>>;
  NOT?: InputMaybe<FinancialSummaryColumnWhere>;
  OR?: InputMaybe<Array<FinancialSummaryColumnWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<FinancialSummaryColumnName>;
  name_IN?: InputMaybe<Array<FinancialSummaryColumnName>>;
};

export type FinancialSummaryColumnsConnection = {
  __typename?: 'FinancialSummaryColumnsConnection';
  edges: Array<FinancialSummaryColumnEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FinancialSummaryConfigInput = {
  hasHelpMessage: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  isIncluded: Scalars['Boolean']['input'];
  localizationKey?: InputMaybe<Scalars['String']['input']>;
  name: FinancialSummaryColumnName;
  position: Scalars['Int']['input'];
};

export enum FlexContainerType {
  Form = 'FORM',
  Record = 'RECORD'
}

export type FlexEntitiesConnection = {
  __typename?: 'FlexEntitiesConnection';
  edges: Array<FlexEntityEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntity = {
  __typename?: 'FlexEntity';
  autogenerationTrigger?: Maybe<AutogenerationTrigger>;
  cases: Array<Case>;
  casesAggregate?: Maybe<FlexEntityCaseCasesAggregationSelection>;
  casesConnection: FlexEntityCasesConnection;
  containerType: FlexContainerType;
  coverageStartDate?: Maybe<Scalars['Date']['output']>;
  createdBy: User;
  createdByAggregate?: Maybe<FlexEntityUserCreatedByAggregationSelection>;
  createdByConnection: FlexEntityCreatedByConnection;
  createdByEmail: Scalars['String']['output'];
  createdByName: Scalars['String']['output'];
  createdOn: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  dataKeys: Scalars['String']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  dateAttributeName?: Maybe<Scalars['String']['output']>;
  decisionTherapy?: Maybe<CoverageRequestTherapyDecision>;
  documentStatus?: Maybe<DocumentStatus>;
  externalFormId?: Maybe<Scalars['String']['output']>;
  financialDataPoints: Array<FlexFinancialDataPoint>;
  financialDataPointsAggregate?: Maybe<FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection>;
  financialDataPointsConnection: FlexEntityFinancialDataPointsConnection;
  firstPrescriptionDate?: Maybe<Scalars['Date']['output']>;
  flexEntityName: Scalars['String']['output'];
  generics: Array<Generic>;
  genericsAggregate?: Maybe<FlexEntityGenericGenericsAggregationSelection>;
  genericsConnection: FlexEntityGenericsConnection;
  hasRefunds: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  indirectCases: Array<Case>;
  insuranceClaimId?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isAutogenerated: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isOrphaned: Scalars['Boolean']['output'];
  isRevoked: Scalars['Boolean']['output'];
  isUploaded: Scalars['Boolean']['output'];
  lastUpdatedOn?: Maybe<Scalars['DateTime']['output']>;
  occurrence?: Maybe<OccurrenceEnum>;
  otherLastFinancialDataPoints: Array<FlexFinancialDataPoint>;
  patient?: Maybe<Patient>;
  patientAggregate?: Maybe<FlexEntityPatientPatientAggregationSelection>;
  patientConnection: FlexEntityPatientConnection;
  patientId?: Maybe<Scalars['String']['output']>;
  patientIdKeys: Array<Scalars['String']['output']>;
  predecessor?: Maybe<FlexEntity>;
  predecessorAggregate?: Maybe<FlexEntityFlexEntityPredecessorAggregationSelection>;
  predecessorConnection: FlexEntityPredecessorConnection;
  preparationBrandNames?: Maybe<Scalars['String']['output']>;
  preparationGenericNames?: Maybe<Scalars['String']['output']>;
  purchase?: Maybe<Purchase>;
  purchaseAggregate?: Maybe<FlexEntityPurchasePurchaseAggregationSelection>;
  purchaseConnection: FlexEntityPurchaseConnection;
  purchaseId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<CoverageRequestRating>;
  refundStatus?: Maybe<RefundStatus>;
  source?: Maybe<FlexEntity>;
  sourceAggregate?: Maybe<FlexEntityFlexEntitySourceAggregationSelection>;
  sourceConnection: FlexEntitySourceConnection;
  sourced: Array<FlexEntity>;
  sourcedAggregate?: Maybe<FlexEntityFlexEntitySourcedAggregationSelection>;
  sourcedConnection: FlexEntitySourcedConnection;
  status?: Maybe<FlexFormStatus>;
  successor?: Maybe<FlexEntity>;
  successorAggregate?: Maybe<FlexEntityFlexEntitySuccessorAggregationSelection>;
  successorConnection: FlexEntitySuccessorConnection;
  tenantId: Scalars['String']['output'];
  therapyTrialStartDate?: Maybe<Scalars['Date']['output']>;
  type: FlexEntityType;
  typeAggregate?: Maybe<FlexEntityFlexEntityTypeTypeAggregationSelection>;
  typeConnection: FlexEntityTypeConnection;
  upload?: Maybe<Upload>;
  uploadAggregate?: Maybe<FlexEntityUploadUploadAggregationSelection>;
  uploadConnection: FlexEntityUploadConnection;
  uuid: Scalars['String']['output'];
  viewCaseId?: Maybe<Scalars['String']['output']>;
  viewCases?: Maybe<Scalars['String']['output']>;
  viewCreatedByName?: Maybe<Scalars['String']['output']>;
  viewDate?: Maybe<Scalars['Date']['output']>;
  viewFormattedContentDe?: Maybe<Scalars['String']['output']>;
  viewFormattedContentEn?: Maybe<Scalars['String']['output']>;
  viewSourceRefundStatus?: Maybe<RefundStatus>;
  viewSuccessorId?: Maybe<Scalars['String']['output']>;
};


export type FlexEntityCasesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type FlexEntityCasesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type FlexEntityCasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityCasesConnectionSort>>;
  where?: InputMaybe<FlexEntityCasesConnectionWhere>;
};


export type FlexEntityCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type FlexEntityCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type FlexEntityCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityCreatedByConnectionSort>>;
  where?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
};


export type FlexEntityFinancialDataPointsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type FlexEntityFinancialDataPointsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type FlexEntityFinancialDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityFinancialDataPointsConnectionSort>>;
  where?: InputMaybe<FlexEntityFinancialDataPointsConnectionWhere>;
};


export type FlexEntityGenericsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type FlexEntityGenericsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type FlexEntityGenericsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityGenericsConnectionSort>>;
  where?: InputMaybe<FlexEntityGenericsConnectionWhere>;
};


export type FlexEntityIndirectCasesArgs = {
  agreementId?: InputMaybe<Scalars['ID']['input']>;
};


export type FlexEntityOtherLastFinancialDataPointsArgs = {
  agreementId?: InputMaybe<Scalars['ID']['input']>;
};


export type FlexEntityPatientArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PatientOptions>;
  where?: InputMaybe<PatientWhere>;
};


export type FlexEntityPatientAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PatientWhere>;
};


export type FlexEntityPatientConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityPatientConnectionSort>>;
  where?: InputMaybe<FlexEntityPatientConnectionWhere>;
};


export type FlexEntityPredecessorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntityPredecessorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntityPredecessorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityPredecessorConnectionSort>>;
  where?: InputMaybe<FlexEntityPredecessorConnectionWhere>;
};


export type FlexEntityPurchaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PurchaseOptions>;
  where?: InputMaybe<PurchaseWhere>;
};


export type FlexEntityPurchaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PurchaseWhere>;
};


export type FlexEntityPurchaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityPurchaseConnectionSort>>;
  where?: InputMaybe<FlexEntityPurchaseConnectionWhere>;
};


export type FlexEntitySourceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntitySourceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntitySourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntitySourceConnectionSort>>;
  where?: InputMaybe<FlexEntitySourceConnectionWhere>;
};


export type FlexEntitySourcedArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntitySourcedAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntitySourcedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntitySourcedConnectionSort>>;
  where?: InputMaybe<FlexEntitySourcedConnectionWhere>;
};


export type FlexEntitySuccessorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntitySuccessorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntitySuccessorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntitySuccessorConnectionSort>>;
  where?: InputMaybe<FlexEntitySuccessorConnectionWhere>;
};


export type FlexEntityTypeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityTypeOptions>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type FlexEntityTypeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type FlexEntityTypeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityTypeConnectionSort>>;
  where?: InputMaybe<FlexEntityTypeConnectionWhere>;
};


export type FlexEntityUploadArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UploadOptions>;
  where?: InputMaybe<UploadWhere>;
};


export type FlexEntityUploadAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UploadWhere>;
};


export type FlexEntityUploadConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityUploadConnectionSort>>;
  where?: InputMaybe<FlexEntityUploadConnectionWhere>;
};

export type FlexEntityCaseCasesAggregationSelection = {
  __typename?: 'FlexEntityCaseCasesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityCaseCasesNodeAggregateSelection>;
};

export type FlexEntityCaseCasesNodeAggregateSelection = {
  __typename?: 'FlexEntityCaseCasesNodeAggregateSelection';
  creationDate: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
};

export type FlexEntityCasesAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityCasesAggregateInput>>;
  NOT?: InputMaybe<FlexEntityCasesAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityCasesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityCasesNodeAggregationWhereInput>;
};

export type FlexEntityCasesConnection = {
  __typename?: 'FlexEntityCasesConnection';
  edges: Array<FlexEntityCasesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityCasesConnectionSort = {
  edge?: InputMaybe<CaseFlexEntityRelationshipSort>;
  node?: InputMaybe<CaseSort>;
};

export type FlexEntityCasesConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityCasesConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityCasesConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityCasesConnectionWhere>>;
  edge?: InputMaybe<CaseFlexEntityRelationshipWhere>;
  node?: InputMaybe<CaseWhere>;
};

export type FlexEntityCasesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityCasesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityCasesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityCasesNodeAggregationWhereInput>>;
  creationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FlexEntityCasesRelationship = CaseFlexEntityRelationship & {
  __typename?: 'FlexEntityCasesRelationship';
  cursor: Scalars['String']['output'];
  isStartingPoint: Scalars['Boolean']['output'];
  node: Case;
};

export type FlexEntityCreatedByAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityCreatedByAggregateInput>>;
  NOT?: InputMaybe<FlexEntityCreatedByAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityCreatedByNodeAggregationWhereInput>;
};

export type FlexEntityCreatedByConnection = {
  __typename?: 'FlexEntityCreatedByConnection';
  edges: Array<FlexEntityCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type FlexEntityCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityCreatedByConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type FlexEntityCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityCreatedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityCreatedByRelationship = {
  __typename?: 'FlexEntityCreatedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type FlexEntityEdge = {
  __typename?: 'FlexEntityEdge';
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export enum FlexEntityFeature {
  Deletion = 'DELETION',
  Editing = 'EDITING',
  Saving = 'SAVING',
  Submission = 'SUBMISSION'
}

export type FlexEntityFinancialDataPointsAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityFinancialDataPointsAggregateInput>>;
  NOT?: InputMaybe<FlexEntityFinancialDataPointsAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityFinancialDataPointsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityFinancialDataPointsNodeAggregationWhereInput>;
};

export type FlexEntityFinancialDataPointsConnection = {
  __typename?: 'FlexEntityFinancialDataPointsConnection';
  edges: Array<FlexEntityFinancialDataPointsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityFinancialDataPointsConnectionSort = {
  node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type FlexEntityFinancialDataPointsConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityFinancialDataPointsConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityFinancialDataPointsConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityFinancialDataPointsConnectionWhere>>;
  node?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type FlexEntityFinancialDataPointsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityFinancialDataPointsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityFinancialDataPointsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityFinancialDataPointsNodeAggregationWhereInput>>;
  basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type FlexEntityFinancialDataPointsRelationship = {
  __typename?: 'FlexEntityFinancialDataPointsRelationship';
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
};

export type FlexEntityFlexEntityPredecessorAggregationSelection = {
  __typename?: 'FlexEntityFlexEntityPredecessorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityFlexEntityPredecessorNodeAggregateSelection>;
};

export type FlexEntityFlexEntityPredecessorNodeAggregateSelection = {
  __typename?: 'FlexEntityFlexEntityPredecessorNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type FlexEntityFlexEntitySourceAggregationSelection = {
  __typename?: 'FlexEntityFlexEntitySourceAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityFlexEntitySourceNodeAggregateSelection>;
};

export type FlexEntityFlexEntitySourceNodeAggregateSelection = {
  __typename?: 'FlexEntityFlexEntitySourceNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type FlexEntityFlexEntitySourcedAggregationSelection = {
  __typename?: 'FlexEntityFlexEntitySourcedAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityFlexEntitySourcedNodeAggregateSelection>;
};

export type FlexEntityFlexEntitySourcedNodeAggregateSelection = {
  __typename?: 'FlexEntityFlexEntitySourcedNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type FlexEntityFlexEntitySuccessorAggregationSelection = {
  __typename?: 'FlexEntityFlexEntitySuccessorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityFlexEntitySuccessorNodeAggregateSelection>;
};

export type FlexEntityFlexEntitySuccessorNodeAggregateSelection = {
  __typename?: 'FlexEntityFlexEntitySuccessorNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type FlexEntityFlexEntityTypeTypeAggregationSelection = {
  __typename?: 'FlexEntityFlexEntityTypeTypeAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityFlexEntityTypeTypeNodeAggregateSelection>;
};

export type FlexEntityFlexEntityTypeTypeNodeAggregateSelection = {
  __typename?: 'FlexEntityFlexEntityTypeTypeNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  attributeCount: IntAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  description: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  idPrefix: StringAggregateSelectionNonNullable;
  localizationKey: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tooltipText: StringAggregateSelectionNullable;
};

export type FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection = {
  __typename?: 'FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection>;
};

export type FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection = {
  __typename?: 'FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  currencyCode: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  generatedUuid: IdAggregateSelectionNonNullable;
  netPrices: StringAggregateSelectionNullable;
  payable: FloatAggregateSelectionNonNullable;
  payablePercentage: FloatAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNonNullable;
  refundDeltaNumber: IntAggregateSelectionNonNullable;
  refundable: FloatAggregateSelectionNonNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  scenarioZeroMainNetPrices: StringAggregateSelectionNullable;
  scenarioZeroNetPrices: StringAggregateSelectionNullable;
  scenarioZeroRelevantNetPrices: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
  variable: FloatAggregateSelectionNonNullable;
  variablePercentage: FloatAggregateSelectionNullable;
};

export type FlexEntityGenericGenericsAggregationSelection = {
  __typename?: 'FlexEntityGenericGenericsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityGenericGenericsNodeAggregateSelection>;
};

export type FlexEntityGenericGenericsNodeAggregateSelection = {
  __typename?: 'FlexEntityGenericGenericsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type FlexEntityGenericsAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityGenericsAggregateInput>>;
  NOT?: InputMaybe<FlexEntityGenericsAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityGenericsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityGenericsNodeAggregationWhereInput>;
};

export type FlexEntityGenericsConnection = {
  __typename?: 'FlexEntityGenericsConnection';
  edges: Array<FlexEntityGenericsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityGenericsConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type FlexEntityGenericsConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityGenericsConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityGenericsConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityGenericsConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type FlexEntityGenericsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityGenericsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityGenericsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<FlexEntityGenericsNodeAggregationWhereInput>>;
};

export type FlexEntityGenericsRelationship = {
  __typename?: 'FlexEntityGenericsRelationship';
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type FlexEntityInput = {
  containerType: FlexContainerType;
  creationWays: Array<DataContainerCreationWay>;
  description: Scalars['String']['input'];
  features: Array<FlexEntityFeature>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idPrefix: Scalars['String']['input'];
  ignoredAttributes: Array<Scalars['String']['input']>;
  isArchived: Scalars['Boolean']['input'];
  isOptional: Scalars['Boolean']['input'];
  isStartingPoint: Scalars['Boolean']['input'];
  localizationKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sections: Array<FlexEntitySectionInput>;
  tooltipText?: InputMaybe<Scalars['String']['input']>;
};

export type FlexEntityOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexEntitySort objects to sort FlexEntities by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexEntitySort>>;
};

export type FlexEntityPatientAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityPatientAggregateInput>>;
  NOT?: InputMaybe<FlexEntityPatientAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityPatientAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityPatientNodeAggregationWhereInput>;
};

export type FlexEntityPatientConnection = {
  __typename?: 'FlexEntityPatientConnection';
  edges: Array<FlexEntityPatientRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityPatientConnectionSort = {
  node?: InputMaybe<PatientSort>;
};

export type FlexEntityPatientConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityPatientConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityPatientConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityPatientConnectionWhere>>;
  node?: InputMaybe<PatientWhere>;
};

export type FlexEntityPatientNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityPatientNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityPatientNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityPatientNodeAggregationWhereInput>>;
  initials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeStamp_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  yearOfBirth_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityPatientPatientAggregationSelection = {
  __typename?: 'FlexEntityPatientPatientAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityPatientPatientNodeAggregateSelection>;
};

export type FlexEntityPatientPatientNodeAggregateSelection = {
  __typename?: 'FlexEntityPatientPatientNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  initials: StringAggregateSelectionNullable;
  insuranceId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  timeStamp: DateTimeAggregateSelectionNonNullable;
  yearOfBirth: IntAggregateSelectionNullable;
};

export type FlexEntityPatientRelationship = {
  __typename?: 'FlexEntityPatientRelationship';
  cursor: Scalars['String']['output'];
  node: Patient;
};

export type FlexEntityPredecessorAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityPredecessorAggregateInput>>;
  NOT?: InputMaybe<FlexEntityPredecessorAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityPredecessorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityPredecessorNodeAggregationWhereInput>;
};

export type FlexEntityPredecessorConnection = {
  __typename?: 'FlexEntityPredecessorConnection';
  edges: Array<FlexEntityPredecessorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityPredecessorConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntityPredecessorConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityPredecessorConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityPredecessorConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityPredecessorConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntityPredecessorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityPredecessorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityPredecessorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityPredecessorNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityPredecessorRelationship = {
  __typename?: 'FlexEntityPredecessorRelationship';
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type FlexEntityPurchaseAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityPurchaseAggregateInput>>;
  NOT?: InputMaybe<FlexEntityPurchaseAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityPurchaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityPurchaseNodeAggregationWhereInput>;
};

export type FlexEntityPurchaseConnection = {
  __typename?: 'FlexEntityPurchaseConnection';
  edges: Array<FlexEntityPurchaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityPurchaseConnectionSort = {
  node?: InputMaybe<PurchaseSort>;
};

export type FlexEntityPurchaseConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityPurchaseConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityPurchaseConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityPurchaseConnectionWhere>>;
  node?: InputMaybe<PurchaseWhere>;
};

export type FlexEntityPurchaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityPurchaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityPurchaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityPurchaseNodeAggregationWhereInput>>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeStamp_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FlexEntityPurchasePurchaseAggregationSelection = {
  __typename?: 'FlexEntityPurchasePurchaseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityPurchasePurchaseNodeAggregateSelection>;
};

export type FlexEntityPurchasePurchaseNodeAggregateSelection = {
  __typename?: 'FlexEntityPurchasePurchaseNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  purchaseId: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNullable;
  timeStamp: DateTimeAggregateSelectionNonNullable;
};

export type FlexEntityPurchaseRelationship = {
  __typename?: 'FlexEntityPurchaseRelationship';
  cursor: Scalars['String']['output'];
  node: Purchase;
};

export type FlexEntityRowInput = {
  fields: Array<FlexFieldsInput>;
  position: Scalars['Int']['input'];
};

export type FlexEntitySectionInput = {
  isArray?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderShown?: InputMaybe<Scalars['Boolean']['input']>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  localizableKey: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  position: Scalars['Int']['input'];
  rows: Array<FlexEntityRowInput>;
};

/** Fields to sort FlexEntities by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntitySort object. */
export type FlexEntitySort = {
  autogenerationTrigger?: InputMaybe<SortDirection>;
  containerType?: InputMaybe<SortDirection>;
  coverageStartDate?: InputMaybe<SortDirection>;
  createdByEmail?: InputMaybe<SortDirection>;
  createdByName?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  data?: InputMaybe<SortDirection>;
  dataKeys?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  dateAttributeName?: InputMaybe<SortDirection>;
  decisionTherapy?: InputMaybe<SortDirection>;
  documentStatus?: InputMaybe<SortDirection>;
  externalFormId?: InputMaybe<SortDirection>;
  firstPrescriptionDate?: InputMaybe<SortDirection>;
  flexEntityName?: InputMaybe<SortDirection>;
  hasRefunds?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  insuranceClaimId?: InputMaybe<SortDirection>;
  invoiceDate?: InputMaybe<SortDirection>;
  invoiceNumber?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isAutogenerated?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isOrphaned?: InputMaybe<SortDirection>;
  isRevoked?: InputMaybe<SortDirection>;
  isUploaded?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  occurrence?: InputMaybe<SortDirection>;
  patientId?: InputMaybe<SortDirection>;
  preparationBrandNames?: InputMaybe<SortDirection>;
  preparationGenericNames?: InputMaybe<SortDirection>;
  purchaseId?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
  rating?: InputMaybe<SortDirection>;
  refundStatus?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  therapyTrialStartDate?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  viewCaseId?: InputMaybe<SortDirection>;
  viewCases?: InputMaybe<SortDirection>;
  viewCreatedByName?: InputMaybe<SortDirection>;
  viewDate?: InputMaybe<SortDirection>;
  viewFormattedContentDe?: InputMaybe<SortDirection>;
  viewFormattedContentEn?: InputMaybe<SortDirection>;
  viewSourceRefundStatus?: InputMaybe<SortDirection>;
  viewSuccessorId?: InputMaybe<SortDirection>;
};

export type FlexEntitySourceAggregateInput = {
  AND?: InputMaybe<Array<FlexEntitySourceAggregateInput>>;
  NOT?: InputMaybe<FlexEntitySourceAggregateInput>;
  OR?: InputMaybe<Array<FlexEntitySourceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntitySourceNodeAggregationWhereInput>;
};

export type FlexEntitySourceConnection = {
  __typename?: 'FlexEntitySourceConnection';
  edges: Array<FlexEntitySourceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntitySourceConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntitySourceConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntitySourceConnectionWhere>>;
  NOT?: InputMaybe<FlexEntitySourceConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntitySourceConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntitySourceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntitySourceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntitySourceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntitySourceNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntitySourceRelationship = {
  __typename?: 'FlexEntitySourceRelationship';
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type FlexEntitySourcedAggregateInput = {
  AND?: InputMaybe<Array<FlexEntitySourcedAggregateInput>>;
  NOT?: InputMaybe<FlexEntitySourcedAggregateInput>;
  OR?: InputMaybe<Array<FlexEntitySourcedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntitySourcedNodeAggregationWhereInput>;
};

export type FlexEntitySourcedConnection = {
  __typename?: 'FlexEntitySourcedConnection';
  edges: Array<FlexEntitySourcedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntitySourcedConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntitySourcedConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntitySourcedConnectionWhere>>;
  NOT?: InputMaybe<FlexEntitySourcedConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntitySourcedConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntitySourcedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntitySourcedNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntitySourcedNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntitySourcedNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntitySourcedRelationship = {
  __typename?: 'FlexEntitySourcedRelationship';
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type FlexEntitySuccessorAggregateInput = {
  AND?: InputMaybe<Array<FlexEntitySuccessorAggregateInput>>;
  NOT?: InputMaybe<FlexEntitySuccessorAggregateInput>;
  OR?: InputMaybe<Array<FlexEntitySuccessorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntitySuccessorNodeAggregationWhereInput>;
};

export type FlexEntitySuccessorConnection = {
  __typename?: 'FlexEntitySuccessorConnection';
  edges: Array<FlexEntitySuccessorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntitySuccessorConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntitySuccessorConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntitySuccessorConnectionWhere>>;
  NOT?: InputMaybe<FlexEntitySuccessorConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntitySuccessorConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntitySuccessorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntitySuccessorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntitySuccessorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntitySuccessorNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntitySuccessorRelationship = {
  __typename?: 'FlexEntitySuccessorRelationship';
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type FlexEntityType = {
  __typename?: 'FlexEntityType';
  addedBy: User;
  addedByAggregate?: Maybe<FlexEntityTypeUserAddedByAggregationSelection>;
  addedByConnection: FlexEntityTypeAddedByConnection;
  addedByName: Scalars['String']['output'];
  agreementCount: Scalars['Int']['output'];
  attributeCount: Scalars['Int']['output'];
  catalogueAttributes: Array<CatalogueAttribute>;
  catalogueAttributesAggregate?: Maybe<FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection>;
  catalogueAttributesConnection: FlexEntityTypeCatalogueAttributesConnection;
  containerType: FlexContainerType;
  createdOn: Scalars['DateTime']['output'];
  creationWays: Array<DataContainerCreationWay>;
  data: Scalars['String']['output'];
  description: Scalars['String']['output'];
  features: Array<FlexEntityFeature>;
  id: Scalars['ID']['output'];
  idPrefix: Scalars['String']['output'];
  ignoredAttributes: Array<Scalars['String']['output']>;
  instances: Array<FlexEntity>;
  instancesAggregate?: Maybe<FlexEntityTypeFlexEntityInstancesAggregationSelection>;
  instancesConnection: FlexEntityTypeInstancesConnection;
  isArchived: Scalars['Boolean']['output'];
  isOptional: Scalars['Boolean']['output'];
  isReadOnly?: Maybe<Scalars['Boolean']['output']>;
  isStartingPoint: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  mappingInstances: Array<Organization>;
  mappingInstancesAggregate?: Maybe<FlexEntityTypeOrganizationMappingInstancesAggregationSelection>;
  mappingInstancesConnection: FlexEntityTypeMappingInstancesConnection;
  name: Scalars['String']['output'];
  orgDataMappings?: Maybe<Array<Scalars['String']['output']>>;
  recordTypes: Array<FlexEntityType>;
  recordTypesAggregate?: Maybe<FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection>;
  recordTypesConnection: FlexEntityTypeRecordTypesConnection;
  tooltipText?: Maybe<Scalars['String']['output']>;
};


export type FlexEntityTypeAddedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type FlexEntityTypeAddedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type FlexEntityTypeAddedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityTypeAddedByConnectionSort>>;
  where?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
};


export type FlexEntityTypeCatalogueAttributesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type FlexEntityTypeCatalogueAttributesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type FlexEntityTypeCatalogueAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesConnectionSort>>;
  where?: InputMaybe<FlexEntityTypeCatalogueAttributesConnectionWhere>;
};


export type FlexEntityTypeInstancesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntityTypeInstancesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntityTypeInstancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityTypeInstancesConnectionSort>>;
  where?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
};


export type FlexEntityTypeMappingInstancesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type FlexEntityTypeMappingInstancesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type FlexEntityTypeMappingInstancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityTypeMappingInstancesConnectionSort>>;
  where?: InputMaybe<FlexEntityTypeMappingInstancesConnectionWhere>;
};


export type FlexEntityTypeRecordTypesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityTypeOptions>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type FlexEntityTypeRecordTypesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type FlexEntityTypeRecordTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityTypeRecordTypesConnectionSort>>;
  where?: InputMaybe<FlexEntityTypeRecordTypesConnectionWhere>;
};

export type FlexEntityTypeAddedByAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityTypeAddedByAggregateInput>>;
  NOT?: InputMaybe<FlexEntityTypeAddedByAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityTypeAddedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityTypeAddedByNodeAggregationWhereInput>;
};

export type FlexEntityTypeAddedByConnection = {
  __typename?: 'FlexEntityTypeAddedByConnection';
  edges: Array<FlexEntityTypeAddedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityTypeAddedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type FlexEntityTypeAddedByConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeAddedByConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeAddedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type FlexEntityTypeAddedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeAddedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityTypeAddedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeAddedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeAddedByRelationship = {
  __typename?: 'FlexEntityTypeAddedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type FlexEntityTypeAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityTypeAggregateInput>>;
  NOT?: InputMaybe<FlexEntityTypeAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityTypeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityTypeNodeAggregationWhereInput>;
};

export type FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection = {
  __typename?: 'FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection>;
};

export type FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection = {
  __typename?: 'FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type FlexEntityTypeCatalogueAttributeRelationship = {
  isDisplayedInCaseDetails?: Maybe<Scalars['Boolean']['output']>;
  isDisplayedInCaseTable?: Maybe<Scalars['Boolean']['output']>;
};

export type FlexEntityTypeCatalogueAttributeRelationshipSort = {
  isDisplayedInCaseDetails?: InputMaybe<SortDirection>;
  isDisplayedInCaseTable?: InputMaybe<SortDirection>;
};

export type FlexEntityTypeCatalogueAttributeRelationshipWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeCatalogueAttributeRelationshipWhere>>;
  NOT?: InputMaybe<FlexEntityTypeCatalogueAttributeRelationshipWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeCatalogueAttributeRelationshipWhere>>;
  isDisplayedInCaseDetails?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayedInCaseTable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlexEntityTypeCatalogueAttributesAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesAggregateInput>>;
  NOT?: InputMaybe<FlexEntityTypeCatalogueAttributesAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput>;
};

export type FlexEntityTypeCatalogueAttributesConnection = {
  __typename?: 'FlexEntityTypeCatalogueAttributesConnection';
  edges: Array<FlexEntityTypeCatalogueAttributesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityTypeCatalogueAttributesConnectionSort = {
  edge?: InputMaybe<FlexEntityTypeCatalogueAttributeRelationshipSort>;
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type FlexEntityTypeCatalogueAttributesConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityTypeCatalogueAttributesConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesConnectionWhere>>;
  edge?: InputMaybe<FlexEntityTypeCatalogueAttributeRelationshipWhere>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeCatalogueAttributesRelationship = FlexEntityTypeCatalogueAttributeRelationship & {
  __typename?: 'FlexEntityTypeCatalogueAttributesRelationship';
  cursor: Scalars['String']['output'];
  isDisplayedInCaseDetails?: Maybe<Scalars['Boolean']['output']>;
  isDisplayedInCaseTable?: Maybe<Scalars['Boolean']['output']>;
  node: CatalogueAttribute;
};

export type FlexEntityTypeConnection = {
  __typename?: 'FlexEntityTypeConnection';
  edges: Array<FlexEntityTypeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityTypeConnectionSort = {
  node?: InputMaybe<FlexEntityTypeSort>;
};

export type FlexEntityTypeConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityTypeConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeConnectionWhere>>;
  node?: InputMaybe<FlexEntityTypeWhere>;
};

export type FlexEntityTypeEdge = {
  __typename?: 'FlexEntityTypeEdge';
  cursor: Scalars['String']['output'];
  node: FlexEntityType;
};

export type FlexEntityTypeFlexEntityInstancesAggregationSelection = {
  __typename?: 'FlexEntityTypeFlexEntityInstancesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityTypeFlexEntityInstancesNodeAggregateSelection>;
};

export type FlexEntityTypeFlexEntityInstancesNodeAggregateSelection = {
  __typename?: 'FlexEntityTypeFlexEntityInstancesNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection = {
  __typename?: 'FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection>;
};

export type FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection = {
  __typename?: 'FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  attributeCount: IntAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  description: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  idPrefix: StringAggregateSelectionNonNullable;
  localizationKey: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tooltipText: StringAggregateSelectionNullable;
};

export type FlexEntityTypeInstancesAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityTypeInstancesAggregateInput>>;
  NOT?: InputMaybe<FlexEntityTypeInstancesAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityTypeInstancesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityTypeInstancesNodeAggregationWhereInput>;
};

export type FlexEntityTypeInstancesConnection = {
  __typename?: 'FlexEntityTypeInstancesConnection';
  edges: Array<FlexEntityTypeInstancesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityTypeInstancesConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntityTypeInstancesConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeInstancesConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeInstancesConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntityTypeInstancesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeInstancesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityTypeInstancesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeInstancesNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeInstancesRelationship = {
  __typename?: 'FlexEntityTypeInstancesRelationship';
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type FlexEntityTypeMappingInstancesAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityTypeMappingInstancesAggregateInput>>;
  NOT?: InputMaybe<FlexEntityTypeMappingInstancesAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityTypeMappingInstancesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<FlexEntityTypeMappingInstancesEdgeAggregationWhereInput>;
  node?: InputMaybe<FlexEntityTypeMappingInstancesNodeAggregationWhereInput>;
};

export type FlexEntityTypeMappingInstancesConnection = {
  __typename?: 'FlexEntityTypeMappingInstancesConnection';
  edges: Array<FlexEntityTypeMappingInstancesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityTypeMappingInstancesConnectionSort = {
  edge?: InputMaybe<EntityTypeMappingRelationshipSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type FlexEntityTypeMappingInstancesConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeMappingInstancesConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityTypeMappingInstancesConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeMappingInstancesConnectionWhere>>;
  edge?: InputMaybe<EntityTypeMappingRelationshipWhere>;
  node?: InputMaybe<OrganizationWhere>;
};

export type FlexEntityTypeMappingInstancesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeMappingInstancesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityTypeMappingInstancesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeMappingInstancesEdgeAggregationWhereInput>>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeMappingInstancesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeMappingInstancesNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<FlexEntityTypeMappingInstancesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeMappingInstancesNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeMappingInstancesRelationship = EntityTypeMappingRelationship & {
  __typename?: 'FlexEntityTypeMappingInstancesRelationship';
  cursor: Scalars['String']['output'];
  data?: Maybe<Scalars['String']['output']>;
  node: Organization;
};

export type FlexEntityTypeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityTypeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexEntityTypeSort objects to sort FlexEntityTypes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexEntityTypeSort>>;
};

export type FlexEntityTypeOrganizationMappingInstancesAggregationSelection = {
  __typename?: 'FlexEntityTypeOrganizationMappingInstancesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection>;
  node?: Maybe<FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection>;
};

export type FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection = {
  __typename?: 'FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection';
  data: StringAggregateSelectionNullable;
};

export type FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection = {
  __typename?: 'FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type FlexEntityTypeRecordTypesAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityTypeRecordTypesAggregateInput>>;
  NOT?: InputMaybe<FlexEntityTypeRecordTypesAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityTypeRecordTypesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityTypeRecordTypesNodeAggregationWhereInput>;
};

export type FlexEntityTypeRecordTypesConnection = {
  __typename?: 'FlexEntityTypeRecordTypesConnection';
  edges: Array<FlexEntityTypeRecordTypesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityTypeRecordTypesConnectionSort = {
  node?: InputMaybe<FlexEntityTypeSort>;
};

export type FlexEntityTypeRecordTypesConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeRecordTypesConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityTypeRecordTypesConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeRecordTypesConnectionWhere>>;
  node?: InputMaybe<FlexEntityTypeWhere>;
};

export type FlexEntityTypeRecordTypesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeRecordTypesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityTypeRecordTypesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeRecordTypesNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeRecordTypesRelationship = {
  __typename?: 'FlexEntityTypeRecordTypesRelationship';
  cursor: Scalars['String']['output'];
  node: FlexEntityType;
};

export type FlexEntityTypeRelationship = {
  __typename?: 'FlexEntityTypeRelationship';
  cursor: Scalars['String']['output'];
  node: FlexEntityType;
};

/** Fields to sort FlexEntityTypes by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntityTypeSort object. */
export type FlexEntityTypeSort = {
  addedByName?: InputMaybe<SortDirection>;
  agreementCount?: InputMaybe<SortDirection>;
  attributeCount?: InputMaybe<SortDirection>;
  containerType?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  data?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  idPrefix?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isOptional?: InputMaybe<SortDirection>;
  isReadOnly?: InputMaybe<SortDirection>;
  isStartingPoint?: InputMaybe<SortDirection>;
  localizationKey?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  tooltipText?: InputMaybe<SortDirection>;
};

export type FlexEntityTypeUserAddedByAggregationSelection = {
  __typename?: 'FlexEntityTypeUserAddedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityTypeUserAddedByNodeAggregateSelection>;
};

export type FlexEntityTypeUserAddedByNodeAggregateSelection = {
  __typename?: 'FlexEntityTypeUserAddedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type FlexEntityTypeWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeWhere>>;
  NOT?: InputMaybe<FlexEntityTypeWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeWhere>>;
  addedBy?: InputMaybe<UserWhere>;
  addedByAggregate?: InputMaybe<FlexEntityTypeAddedByAggregateInput>;
  addedByConnection?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
  addedByConnection_NOT?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
  addedByName?: InputMaybe<Scalars['String']['input']>;
  addedByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  addedByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedByName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  addedByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  addedByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedBy_NOT?: InputMaybe<UserWhere>;
  attributeCount?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  attributeCount_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  catalogueAttributesAggregate?: InputMaybe<FlexEntityTypeCatalogueAttributesAggregateInput>;
  /** Return FlexEntityTypes where all of the related FlexEntityTypeCatalogueAttributesConnections match this filter */
  catalogueAttributesConnection_ALL?: InputMaybe<FlexEntityTypeCatalogueAttributesConnectionWhere>;
  /** Return FlexEntityTypes where none of the related FlexEntityTypeCatalogueAttributesConnections match this filter */
  catalogueAttributesConnection_NONE?: InputMaybe<FlexEntityTypeCatalogueAttributesConnectionWhere>;
  /** Return FlexEntityTypes where one of the related FlexEntityTypeCatalogueAttributesConnections match this filter */
  catalogueAttributesConnection_SINGLE?: InputMaybe<FlexEntityTypeCatalogueAttributesConnectionWhere>;
  /** Return FlexEntityTypes where some of the related FlexEntityTypeCatalogueAttributesConnections match this filter */
  catalogueAttributesConnection_SOME?: InputMaybe<FlexEntityTypeCatalogueAttributesConnectionWhere>;
  /** Return FlexEntityTypes where all of the related CatalogueAttributes match this filter */
  catalogueAttributes_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return FlexEntityTypes where none of the related CatalogueAttributes match this filter */
  catalogueAttributes_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return FlexEntityTypes where one of the related CatalogueAttributes match this filter */
  catalogueAttributes_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return FlexEntityTypes where some of the related CatalogueAttributes match this filter */
  catalogueAttributes_SOME?: InputMaybe<CatalogueAttributeWhere>;
  containerType?: InputMaybe<FlexContainerType>;
  containerType_IN?: InputMaybe<Array<FlexContainerType>>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationWays?: InputMaybe<Array<DataContainerCreationWay>>;
  creationWays_INCLUDES?: InputMaybe<DataContainerCreationWay>;
  data?: InputMaybe<Scalars['String']['input']>;
  data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  data_MATCHES?: InputMaybe<Scalars['String']['input']>;
  data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  description_MATCHES?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<FlexEntityFeature>>;
  features_INCLUDES?: InputMaybe<FlexEntityFeature>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idPrefix?: InputMaybe<Scalars['String']['input']>;
  idPrefix_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  idPrefix_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  idPrefix_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  idPrefix_MATCHES?: InputMaybe<Scalars['String']['input']>;
  idPrefix_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  ignoredAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  ignoredAttributes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  instancesAggregate?: InputMaybe<FlexEntityTypeInstancesAggregateInput>;
  /** Return FlexEntityTypes where all of the related FlexEntityTypeInstancesConnections match this filter */
  instancesConnection_ALL?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
  /** Return FlexEntityTypes where none of the related FlexEntityTypeInstancesConnections match this filter */
  instancesConnection_NONE?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
  /** Return FlexEntityTypes where one of the related FlexEntityTypeInstancesConnections match this filter */
  instancesConnection_SINGLE?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
  /** Return FlexEntityTypes where some of the related FlexEntityTypeInstancesConnections match this filter */
  instancesConnection_SOME?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
  /** Return FlexEntityTypes where all of the related FlexEntities match this filter */
  instances_ALL?: InputMaybe<FlexEntityWhere>;
  /** Return FlexEntityTypes where none of the related FlexEntities match this filter */
  instances_NONE?: InputMaybe<FlexEntityWhere>;
  /** Return FlexEntityTypes where one of the related FlexEntities match this filter */
  instances_SINGLE?: InputMaybe<FlexEntityWhere>;
  /** Return FlexEntityTypes where some of the related FlexEntities match this filter */
  instances_SOME?: InputMaybe<FlexEntityWhere>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  isReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isStartingPoint?: InputMaybe<Scalars['Boolean']['input']>;
  localizationKey?: InputMaybe<Scalars['String']['input']>;
  localizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  localizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  localizationKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  localizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  localizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mappingInstancesAggregate?: InputMaybe<FlexEntityTypeMappingInstancesAggregateInput>;
  /** Return FlexEntityTypes where all of the related FlexEntityTypeMappingInstancesConnections match this filter */
  mappingInstancesConnection_ALL?: InputMaybe<FlexEntityTypeMappingInstancesConnectionWhere>;
  /** Return FlexEntityTypes where none of the related FlexEntityTypeMappingInstancesConnections match this filter */
  mappingInstancesConnection_NONE?: InputMaybe<FlexEntityTypeMappingInstancesConnectionWhere>;
  /** Return FlexEntityTypes where one of the related FlexEntityTypeMappingInstancesConnections match this filter */
  mappingInstancesConnection_SINGLE?: InputMaybe<FlexEntityTypeMappingInstancesConnectionWhere>;
  /** Return FlexEntityTypes where some of the related FlexEntityTypeMappingInstancesConnections match this filter */
  mappingInstancesConnection_SOME?: InputMaybe<FlexEntityTypeMappingInstancesConnectionWhere>;
  /** Return FlexEntityTypes where all of the related Organizations match this filter */
  mappingInstances_ALL?: InputMaybe<OrganizationWhere>;
  /** Return FlexEntityTypes where none of the related Organizations match this filter */
  mappingInstances_NONE?: InputMaybe<OrganizationWhere>;
  /** Return FlexEntityTypes where one of the related Organizations match this filter */
  mappingInstances_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return FlexEntityTypes where some of the related Organizations match this filter */
  mappingInstances_SOME?: InputMaybe<OrganizationWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  orgDataMappings?: InputMaybe<Array<Scalars['String']['input']>>;
  orgDataMappings_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  recordTypesAggregate?: InputMaybe<FlexEntityTypeRecordTypesAggregateInput>;
  /** Return FlexEntityTypes where all of the related FlexEntityTypeRecordTypesConnections match this filter */
  recordTypesConnection_ALL?: InputMaybe<FlexEntityTypeRecordTypesConnectionWhere>;
  /** Return FlexEntityTypes where none of the related FlexEntityTypeRecordTypesConnections match this filter */
  recordTypesConnection_NONE?: InputMaybe<FlexEntityTypeRecordTypesConnectionWhere>;
  /** Return FlexEntityTypes where one of the related FlexEntityTypeRecordTypesConnections match this filter */
  recordTypesConnection_SINGLE?: InputMaybe<FlexEntityTypeRecordTypesConnectionWhere>;
  /** Return FlexEntityTypes where some of the related FlexEntityTypeRecordTypesConnections match this filter */
  recordTypesConnection_SOME?: InputMaybe<FlexEntityTypeRecordTypesConnectionWhere>;
  /** Return FlexEntityTypes where all of the related FlexEntityTypes match this filter */
  recordTypes_ALL?: InputMaybe<FlexEntityTypeWhere>;
  /** Return FlexEntityTypes where none of the related FlexEntityTypes match this filter */
  recordTypes_NONE?: InputMaybe<FlexEntityTypeWhere>;
  /** Return FlexEntityTypes where one of the related FlexEntityTypes match this filter */
  recordTypes_SINGLE?: InputMaybe<FlexEntityTypeWhere>;
  /** Return FlexEntityTypes where some of the related FlexEntityTypes match this filter */
  recordTypes_SOME?: InputMaybe<FlexEntityTypeWhere>;
  tooltipText?: InputMaybe<Scalars['String']['input']>;
  tooltipText_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tooltipText_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tooltipText_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tooltipText_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tooltipText_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type FlexEntityTypesConnection = {
  __typename?: 'FlexEntityTypesConnection';
  edges: Array<FlexEntityTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityUploadAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityUploadAggregateInput>>;
  NOT?: InputMaybe<FlexEntityUploadAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityUploadAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityUploadNodeAggregationWhereInput>;
};

export type FlexEntityUploadConnection = {
  __typename?: 'FlexEntityUploadConnection';
  edges: Array<FlexEntityUploadRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityUploadConnectionSort = {
  node?: InputMaybe<UploadSort>;
};

export type FlexEntityUploadConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityUploadConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityUploadConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityUploadConnectionWhere>>;
  node?: InputMaybe<UploadWhere>;
};

export type FlexEntityUploadNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityUploadNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityUploadNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityUploadNodeAggregationWhereInput>>;
  timestamp_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FlexEntityUploadRelationship = {
  __typename?: 'FlexEntityUploadRelationship';
  cursor: Scalars['String']['output'];
  node: Upload;
};

export type FlexEntityUploadUploadAggregationSelection = {
  __typename?: 'FlexEntityUploadUploadAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityUploadUploadNodeAggregateSelection>;
};

export type FlexEntityUploadUploadNodeAggregateSelection = {
  __typename?: 'FlexEntityUploadUploadNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  timestamp: DateTimeAggregateSelectionNonNullable;
};

export type FlexEntityUserCreatedByAggregationSelection = {
  __typename?: 'FlexEntityUserCreatedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityUserCreatedByNodeAggregateSelection>;
};

export type FlexEntityUserCreatedByNodeAggregateSelection = {
  __typename?: 'FlexEntityUserCreatedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type FlexEntityWhere = {
  AND?: InputMaybe<Array<FlexEntityWhere>>;
  NOT?: InputMaybe<FlexEntityWhere>;
  OR?: InputMaybe<Array<FlexEntityWhere>>;
  autogenerationTrigger?: InputMaybe<AutogenerationTrigger>;
  autogenerationTrigger_IN?: InputMaybe<Array<InputMaybe<AutogenerationTrigger>>>;
  casesAggregate?: InputMaybe<FlexEntityCasesAggregateInput>;
  /** Return FlexEntities where all of the related FlexEntityCasesConnections match this filter */
  casesConnection_ALL?: InputMaybe<FlexEntityCasesConnectionWhere>;
  /** Return FlexEntities where none of the related FlexEntityCasesConnections match this filter */
  casesConnection_NONE?: InputMaybe<FlexEntityCasesConnectionWhere>;
  /** Return FlexEntities where one of the related FlexEntityCasesConnections match this filter */
  casesConnection_SINGLE?: InputMaybe<FlexEntityCasesConnectionWhere>;
  /** Return FlexEntities where some of the related FlexEntityCasesConnections match this filter */
  casesConnection_SOME?: InputMaybe<FlexEntityCasesConnectionWhere>;
  /** Return FlexEntities where all of the related Cases match this filter */
  cases_ALL?: InputMaybe<CaseWhere>;
  /** Return FlexEntities where none of the related Cases match this filter */
  cases_NONE?: InputMaybe<CaseWhere>;
  /** Return FlexEntities where one of the related Cases match this filter */
  cases_SINGLE?: InputMaybe<CaseWhere>;
  /** Return FlexEntities where some of the related Cases match this filter */
  cases_SOME?: InputMaybe<CaseWhere>;
  containerType?: InputMaybe<FlexContainerType>;
  containerType_IN?: InputMaybe<Array<FlexContainerType>>;
  coverageStartDate?: InputMaybe<Scalars['Date']['input']>;
  coverageStartDate_GT?: InputMaybe<Scalars['Date']['input']>;
  coverageStartDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  coverageStartDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  coverageStartDate_LT?: InputMaybe<Scalars['Date']['input']>;
  coverageStartDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<FlexEntityCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByName?: InputMaybe<Scalars['String']['input']>;
  createdByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  createdByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  createdByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  dataKeys?: InputMaybe<Scalars['String']['input']>;
  dataKeys_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  dataKeys_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  dataKeys_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  dataKeys_MATCHES?: InputMaybe<Scalars['String']['input']>;
  dataKeys_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  data_MATCHES?: InputMaybe<Scalars['String']['input']>;
  data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_GT?: InputMaybe<Scalars['Date']['input']>;
  date_GTE?: InputMaybe<Scalars['Date']['input']>;
  date_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  date_LT?: InputMaybe<Scalars['Date']['input']>;
  date_LTE?: InputMaybe<Scalars['Date']['input']>;
  decisionTherapy?: InputMaybe<CoverageRequestTherapyDecision>;
  decisionTherapy_IN?: InputMaybe<Array<InputMaybe<CoverageRequestTherapyDecision>>>;
  externalFormId?: InputMaybe<Scalars['String']['input']>;
  externalFormId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  externalFormId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalFormId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalFormId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  externalFormId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  financialDataPointsAggregate?: InputMaybe<FlexEntityFinancialDataPointsAggregateInput>;
  /** Return FlexEntities where all of the related FlexEntityFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_ALL?: InputMaybe<FlexEntityFinancialDataPointsConnectionWhere>;
  /** Return FlexEntities where none of the related FlexEntityFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_NONE?: InputMaybe<FlexEntityFinancialDataPointsConnectionWhere>;
  /** Return FlexEntities where one of the related FlexEntityFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SINGLE?: InputMaybe<FlexEntityFinancialDataPointsConnectionWhere>;
  /** Return FlexEntities where some of the related FlexEntityFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SOME?: InputMaybe<FlexEntityFinancialDataPointsConnectionWhere>;
  /** Return FlexEntities where all of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_ALL?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return FlexEntities where none of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_NONE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return FlexEntities where one of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SINGLE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return FlexEntities where some of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SOME?: InputMaybe<FlexFinancialDataPointWhere>;
  flexEntityName?: InputMaybe<Scalars['String']['input']>;
  flexEntityName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  flexEntityName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  flexEntityName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  flexEntityName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  flexEntityName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  genericsAggregate?: InputMaybe<FlexEntityGenericsAggregateInput>;
  /** Return FlexEntities where all of the related FlexEntityGenericsConnections match this filter */
  genericsConnection_ALL?: InputMaybe<FlexEntityGenericsConnectionWhere>;
  /** Return FlexEntities where none of the related FlexEntityGenericsConnections match this filter */
  genericsConnection_NONE?: InputMaybe<FlexEntityGenericsConnectionWhere>;
  /** Return FlexEntities where one of the related FlexEntityGenericsConnections match this filter */
  genericsConnection_SINGLE?: InputMaybe<FlexEntityGenericsConnectionWhere>;
  /** Return FlexEntities where some of the related FlexEntityGenericsConnections match this filter */
  genericsConnection_SOME?: InputMaybe<FlexEntityGenericsConnectionWhere>;
  /** Return FlexEntities where all of the related Generics match this filter */
  generics_ALL?: InputMaybe<GenericWhere>;
  /** Return FlexEntities where none of the related Generics match this filter */
  generics_NONE?: InputMaybe<GenericWhere>;
  /** Return FlexEntities where one of the related Generics match this filter */
  generics_SINGLE?: InputMaybe<GenericWhere>;
  /** Return FlexEntities where some of the related Generics match this filter */
  generics_SOME?: InputMaybe<GenericWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  insuranceClaimId?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  insuranceClaimId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  invoiceDate?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_GT?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  invoiceDate_LT?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  invoiceNumber_MATCHES?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isAutogenerated?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurrence?: InputMaybe<OccurrenceEnum>;
  occurrence_IN?: InputMaybe<Array<InputMaybe<OccurrenceEnum>>>;
  patient?: InputMaybe<PatientWhere>;
  patientAggregate?: InputMaybe<FlexEntityPatientAggregateInput>;
  patientConnection?: InputMaybe<FlexEntityPatientConnectionWhere>;
  patientConnection_NOT?: InputMaybe<FlexEntityPatientConnectionWhere>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  patientIdKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  patientIdKeys_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  patientId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  patientId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  patientId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  patient_NOT?: InputMaybe<PatientWhere>;
  predecessor?: InputMaybe<FlexEntityWhere>;
  predecessorAggregate?: InputMaybe<FlexEntityPredecessorAggregateInput>;
  predecessorConnection?: InputMaybe<FlexEntityPredecessorConnectionWhere>;
  predecessorConnection_NOT?: InputMaybe<FlexEntityPredecessorConnectionWhere>;
  predecessor_NOT?: InputMaybe<FlexEntityWhere>;
  preparationBrandNames?: InputMaybe<Scalars['String']['input']>;
  preparationBrandNames_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preparationBrandNames_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationBrandNames_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationBrandNames_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preparationBrandNames_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationGenericNames_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<PurchaseWhere>;
  purchaseAggregate?: InputMaybe<FlexEntityPurchaseAggregateInput>;
  purchaseConnection?: InputMaybe<FlexEntityPurchaseConnectionWhere>;
  purchaseConnection_NOT?: InputMaybe<FlexEntityPurchaseConnectionWhere>;
  purchaseId?: InputMaybe<Scalars['String']['input']>;
  purchaseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  purchaseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchaseId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  purchaseId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  purchaseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchase_NOT?: InputMaybe<PurchaseWhere>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantity_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  quantity_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_LTE?: InputMaybe<Scalars['Float']['input']>;
  rating?: InputMaybe<CoverageRequestRating>;
  rating_IN?: InputMaybe<Array<InputMaybe<CoverageRequestRating>>>;
  source?: InputMaybe<FlexEntityWhere>;
  sourceAggregate?: InputMaybe<FlexEntitySourceAggregateInput>;
  sourceConnection?: InputMaybe<FlexEntitySourceConnectionWhere>;
  sourceConnection_NOT?: InputMaybe<FlexEntitySourceConnectionWhere>;
  source_NOT?: InputMaybe<FlexEntityWhere>;
  sourcedAggregate?: InputMaybe<FlexEntitySourcedAggregateInput>;
  /** Return FlexEntities where all of the related FlexEntitySourcedConnections match this filter */
  sourcedConnection_ALL?: InputMaybe<FlexEntitySourcedConnectionWhere>;
  /** Return FlexEntities where none of the related FlexEntitySourcedConnections match this filter */
  sourcedConnection_NONE?: InputMaybe<FlexEntitySourcedConnectionWhere>;
  /** Return FlexEntities where one of the related FlexEntitySourcedConnections match this filter */
  sourcedConnection_SINGLE?: InputMaybe<FlexEntitySourcedConnectionWhere>;
  /** Return FlexEntities where some of the related FlexEntitySourcedConnections match this filter */
  sourcedConnection_SOME?: InputMaybe<FlexEntitySourcedConnectionWhere>;
  /** Return FlexEntities where all of the related FlexEntities match this filter */
  sourced_ALL?: InputMaybe<FlexEntityWhere>;
  /** Return FlexEntities where none of the related FlexEntities match this filter */
  sourced_NONE?: InputMaybe<FlexEntityWhere>;
  /** Return FlexEntities where one of the related FlexEntities match this filter */
  sourced_SINGLE?: InputMaybe<FlexEntityWhere>;
  /** Return FlexEntities where some of the related FlexEntities match this filter */
  sourced_SOME?: InputMaybe<FlexEntityWhere>;
  status?: InputMaybe<FlexFormStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<FlexFormStatus>>>;
  successor?: InputMaybe<FlexEntityWhere>;
  successorAggregate?: InputMaybe<FlexEntitySuccessorAggregateInput>;
  successorConnection?: InputMaybe<FlexEntitySuccessorConnectionWhere>;
  successorConnection_NOT?: InputMaybe<FlexEntitySuccessorConnectionWhere>;
  successor_NOT?: InputMaybe<FlexEntityWhere>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  therapyTrialStartDate?: InputMaybe<Scalars['Date']['input']>;
  therapyTrialStartDate_GT?: InputMaybe<Scalars['Date']['input']>;
  therapyTrialStartDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  therapyTrialStartDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  therapyTrialStartDate_LT?: InputMaybe<Scalars['Date']['input']>;
  therapyTrialStartDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<FlexEntityTypeWhere>;
  typeAggregate?: InputMaybe<FlexEntityTypeAggregateInput>;
  typeConnection?: InputMaybe<FlexEntityTypeConnectionWhere>;
  typeConnection_NOT?: InputMaybe<FlexEntityTypeConnectionWhere>;
  type_NOT?: InputMaybe<FlexEntityTypeWhere>;
  upload?: InputMaybe<UploadWhere>;
  uploadAggregate?: InputMaybe<FlexEntityUploadAggregateInput>;
  uploadConnection?: InputMaybe<FlexEntityUploadConnectionWhere>;
  uploadConnection_NOT?: InputMaybe<FlexEntityUploadConnectionWhere>;
  upload_NOT?: InputMaybe<UploadWhere>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid_MATCHES?: InputMaybe<Scalars['String']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCaseId?: InputMaybe<Scalars['String']['input']>;
  viewCaseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewCaseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCaseId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewCaseId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewCaseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCases?: InputMaybe<Scalars['String']['input']>;
  viewCases_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewCases_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCases_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewCases_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewCases_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCreatedByName?: InputMaybe<Scalars['String']['input']>;
  viewCreatedByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewCreatedByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCreatedByName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewCreatedByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewCreatedByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewDate?: InputMaybe<Scalars['Date']['input']>;
  viewDate_GT?: InputMaybe<Scalars['Date']['input']>;
  viewDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  viewDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  viewDate_LT?: InputMaybe<Scalars['Date']['input']>;
  viewDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  viewFormattedContentDe?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewFormattedContentDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewFormattedContentEn_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewSourceRefundStatus?: InputMaybe<RefundStatus>;
  viewSourceRefundStatus_IN?: InputMaybe<Array<InputMaybe<RefundStatus>>>;
  viewSuccessorId?: InputMaybe<Scalars['String']['input']>;
  viewSuccessorId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewSuccessorId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewSuccessorId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewSuccessorId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewSuccessorId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type FlexFieldsInput = {
  id: Scalars['String']['input'];
  isDisplayedInCaseDetails?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayedInCaseTable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlexFinancialDataPoint = {
  __typename?: 'FlexFinancialDataPoint';
  agreement?: Maybe<Agreement>;
  agreementAggregate?: Maybe<FlexFinancialDataPointAgreementAgreementAggregationSelection>;
  agreementConnection: FlexFinancialDataPointAgreementConnection;
  basePrice: Scalars['Float']['output'];
  basePriceType?: Maybe<PriceType>;
  cannotBeSourceOfRefund?: Maybe<Scalars['Boolean']['output']>;
  createdOn: Scalars['DateTime']['output'];
  currencyCode?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  documentStatus?: Maybe<DocumentStatus>;
  evaluates: FlexEntity;
  evaluatesAggregate?: Maybe<FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection>;
  evaluatesConnection: FlexFinancialDataPointEvaluatesConnection;
  evaluationSnapshot?: Maybe<Scalars['String']['output']>;
  failReason?: Maybe<ScenarioActionFailure>;
  generatedFor?: Maybe<Case>;
  generatedForAggregate?: Maybe<FlexFinancialDataPointCaseGeneratedForAggregationSelection>;
  generatedForConnection: FlexFinancialDataPointGeneratedForConnection;
  generatedUuid: Scalars['ID']['output'];
  isDefaultPriceRateApplied?: Maybe<Scalars['Boolean']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isDelta: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  netPrices?: Maybe<Scalars['String']['output']>;
  payable: Scalars['Float']['output'];
  payablePercentage?: Maybe<Scalars['Float']['output']>;
  prescriptionDate: Scalars['Date']['output'];
  quantity: Scalars['Float']['output'];
  refundDeltaNumber: Scalars['Int']['output'];
  refundable: Scalars['Float']['output'];
  refundablePercentage?: Maybe<Scalars['Float']['output']>;
  revokedOn?: Maybe<Scalars['DateTime']['output']>;
  scenarioZeroMainNetPrices?: Maybe<Scalars['String']['output']>;
  scenarioZeroNetPrices?: Maybe<Scalars['String']['output']>;
  scenarioZeroRelevantNetPrices?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<Refund>;
  sourceDocumentAggregate?: Maybe<FlexFinancialDataPointRefundSourceDocumentAggregationSelection>;
  sourceDocumentConnection: FlexFinancialDataPointSourceDocumentConnection;
  sourceDocumentState?: Maybe<Document>;
  sourceRefund?: Maybe<Refund>;
  sourceRefundAggregate?: Maybe<FlexFinancialDataPointRefundSourceRefundAggregationSelection>;
  sourceRefundConnection: FlexFinancialDataPointSourceRefundConnection;
  treatment: Treatment;
  treatmentAggregate?: Maybe<FlexFinancialDataPointTreatmentTreatmentAggregationSelection>;
  treatmentConnection: FlexFinancialDataPointTreatmentConnection;
  uuid: Scalars['ID']['output'];
  variable: Scalars['Float']['output'];
  variablePercentage?: Maybe<Scalars['Float']['output']>;
};


export type FlexFinancialDataPointAgreementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type FlexFinancialDataPointAgreementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type FlexFinancialDataPointAgreementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexFinancialDataPointAgreementConnectionSort>>;
  where?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
};


export type FlexFinancialDataPointEvaluatesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexFinancialDataPointEvaluatesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexFinancialDataPointEvaluatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexFinancialDataPointEvaluatesConnectionSort>>;
  where?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
};


export type FlexFinancialDataPointGeneratedForArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type FlexFinancialDataPointGeneratedForAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type FlexFinancialDataPointGeneratedForConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexFinancialDataPointGeneratedForConnectionSort>>;
  where?: InputMaybe<FlexFinancialDataPointGeneratedForConnectionWhere>;
};


export type FlexFinancialDataPointSourceDocumentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type FlexFinancialDataPointSourceDocumentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RefundWhere>;
};


export type FlexFinancialDataPointSourceDocumentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentConnectionSort>>;
  where?: InputMaybe<FlexFinancialDataPointSourceDocumentConnectionWhere>;
};


export type FlexFinancialDataPointSourceRefundArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type FlexFinancialDataPointSourceRefundAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RefundWhere>;
};


export type FlexFinancialDataPointSourceRefundConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexFinancialDataPointSourceRefundConnectionSort>>;
  where?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
};


export type FlexFinancialDataPointTreatmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type FlexFinancialDataPointTreatmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type FlexFinancialDataPointTreatmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexFinancialDataPointTreatmentConnectionSort>>;
  where?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
};

export type FlexFinancialDataPointAgreementAggregateInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointAgreementAggregateInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointAgreementAggregateInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointAgreementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexFinancialDataPointAgreementNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointAgreementAgreementAggregationSelection = {
  __typename?: 'FlexFinancialDataPointAgreementAgreementAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexFinancialDataPointAgreementAgreementNodeAggregateSelection>;
};

export type FlexFinancialDataPointAgreementAgreementNodeAggregateSelection = {
  __typename?: 'FlexFinancialDataPointAgreementAgreementNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type FlexFinancialDataPointAgreementConnection = {
  __typename?: 'FlexFinancialDataPointAgreementConnection';
  edges: Array<FlexFinancialDataPointAgreementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexFinancialDataPointAgreementConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type FlexFinancialDataPointAgreementConnectionWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointAgreementConnectionWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointAgreementConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type FlexFinancialDataPointAgreementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointAgreementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointAgreementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointAgreementNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexFinancialDataPointAgreementRelationship = {
  __typename?: 'FlexFinancialDataPointAgreementRelationship';
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type FlexFinancialDataPointCaseGeneratedForAggregationSelection = {
  __typename?: 'FlexFinancialDataPointCaseGeneratedForAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection>;
};

export type FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection = {
  __typename?: 'FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection';
  creationDate: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
};

export type FlexFinancialDataPointEdge = {
  __typename?: 'FlexFinancialDataPointEdge';
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
};

export type FlexFinancialDataPointEvaluatesAggregateInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointEvaluatesAggregateInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointEvaluatesAggregateInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointEvaluatesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexFinancialDataPointEvaluatesNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointEvaluatesConnection = {
  __typename?: 'FlexFinancialDataPointEvaluatesConnection';
  edges: Array<FlexFinancialDataPointEvaluatesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexFinancialDataPointEvaluatesConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type FlexFinancialDataPointEvaluatesConnectionWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointEvaluatesConnectionWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointEvaluatesConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type FlexFinancialDataPointEvaluatesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointEvaluatesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointEvaluatesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointEvaluatesNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexFinancialDataPointEvaluatesRelationship = {
  __typename?: 'FlexFinancialDataPointEvaluatesRelationship';
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection = {
  __typename?: 'FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection>;
};

export type FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection = {
  __typename?: 'FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type FlexFinancialDataPointGeneratedForAggregateInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointGeneratedForAggregateInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointGeneratedForAggregateInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointGeneratedForAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexFinancialDataPointGeneratedForNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointGeneratedForConnection = {
  __typename?: 'FlexFinancialDataPointGeneratedForConnection';
  edges: Array<FlexFinancialDataPointGeneratedForRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexFinancialDataPointGeneratedForConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type FlexFinancialDataPointGeneratedForConnectionWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointGeneratedForConnectionWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointGeneratedForConnectionWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointGeneratedForConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type FlexFinancialDataPointGeneratedForNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointGeneratedForNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointGeneratedForNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointGeneratedForNodeAggregationWhereInput>>;
  creationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FlexFinancialDataPointGeneratedForRelationship = {
  __typename?: 'FlexFinancialDataPointGeneratedForRelationship';
  cursor: Scalars['String']['output'];
  node: Case;
};

export type FlexFinancialDataPointOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexFinancialDataPointSort objects to sort FlexFinancialDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexFinancialDataPointSort>>;
};

export type FlexFinancialDataPointRefundSourceDocumentAggregationSelection = {
  __typename?: 'FlexFinancialDataPointRefundSourceDocumentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection>;
};

export type FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection = {
  __typename?: 'FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection';
  agreementId: StringAggregateSelectionNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type FlexFinancialDataPointRefundSourceRefundAggregationSelection = {
  __typename?: 'FlexFinancialDataPointRefundSourceRefundAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection>;
};

export type FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection = {
  __typename?: 'FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection';
  agreementId: StringAggregateSelectionNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

/** Fields to sort FlexFinancialDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexFinancialDataPointSort object. */
export type FlexFinancialDataPointSort = {
  basePrice?: InputMaybe<SortDirection>;
  basePriceType?: InputMaybe<SortDirection>;
  cannotBeSourceOfRefund?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  currencyCode?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  documentStatus?: InputMaybe<SortDirection>;
  evaluationSnapshot?: InputMaybe<SortDirection>;
  failReason?: InputMaybe<SortDirection>;
  generatedUuid?: InputMaybe<SortDirection>;
  isDefaultPriceRateApplied?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isDelta?: InputMaybe<SortDirection>;
  isLast?: InputMaybe<SortDirection>;
  netPrices?: InputMaybe<SortDirection>;
  payable?: InputMaybe<SortDirection>;
  payablePercentage?: InputMaybe<SortDirection>;
  prescriptionDate?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
  refundDeltaNumber?: InputMaybe<SortDirection>;
  refundable?: InputMaybe<SortDirection>;
  refundablePercentage?: InputMaybe<SortDirection>;
  revokedOn?: InputMaybe<SortDirection>;
  scenarioZeroMainNetPrices?: InputMaybe<SortDirection>;
  scenarioZeroNetPrices?: InputMaybe<SortDirection>;
  scenarioZeroRelevantNetPrices?: InputMaybe<SortDirection>;
  sourceDocumentState?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  variable?: InputMaybe<SortDirection>;
  variablePercentage?: InputMaybe<SortDirection>;
};

export type FlexFinancialDataPointSourceDocumentAggregateInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentAggregateInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointSourceDocumentAggregateInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointSourceDocumentConnection = {
  __typename?: 'FlexFinancialDataPointSourceDocumentConnection';
  edges: Array<FlexFinancialDataPointSourceDocumentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexFinancialDataPointSourceDocumentConnectionSort = {
  node?: InputMaybe<RefundSort>;
};

export type FlexFinancialDataPointSourceDocumentConnectionWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentConnectionWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointSourceDocumentConnectionWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentConnectionWhere>>;
  node?: InputMaybe<RefundWhere>;
};

export type FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput>>;
  agreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexFinancialDataPointSourceDocumentRelationship = {
  __typename?: 'FlexFinancialDataPointSourceDocumentRelationship';
  cursor: Scalars['String']['output'];
  node: Refund;
};

export type FlexFinancialDataPointSourceRefundAggregateInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointSourceRefundAggregateInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointSourceRefundAggregateInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointSourceRefundAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexFinancialDataPointSourceRefundNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointSourceRefundConnection = {
  __typename?: 'FlexFinancialDataPointSourceRefundConnection';
  edges: Array<FlexFinancialDataPointSourceRefundRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexFinancialDataPointSourceRefundConnectionSort = {
  node?: InputMaybe<RefundSort>;
};

export type FlexFinancialDataPointSourceRefundConnectionWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointSourceRefundConnectionWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointSourceRefundConnectionWhere>>;
  node?: InputMaybe<RefundWhere>;
};

export type FlexFinancialDataPointSourceRefundNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointSourceRefundNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointSourceRefundNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointSourceRefundNodeAggregationWhereInput>>;
  agreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexFinancialDataPointSourceRefundRelationship = {
  __typename?: 'FlexFinancialDataPointSourceRefundRelationship';
  cursor: Scalars['String']['output'];
  node: Refund;
};

export type FlexFinancialDataPointTreatmentAggregateInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointTreatmentAggregateInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointTreatmentAggregateInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointTreatmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexFinancialDataPointTreatmentNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointTreatmentConnection = {
  __typename?: 'FlexFinancialDataPointTreatmentConnection';
  edges: Array<FlexFinancialDataPointTreatmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexFinancialDataPointTreatmentConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type FlexFinancialDataPointTreatmentConnectionWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointTreatmentConnectionWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointTreatmentConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type FlexFinancialDataPointTreatmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointTreatmentNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<FlexFinancialDataPointTreatmentNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<FlexFinancialDataPointTreatmentNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexFinancialDataPointTreatmentRelationship = {
  __typename?: 'FlexFinancialDataPointTreatmentRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type FlexFinancialDataPointTreatmentTreatmentAggregationSelection = {
  __typename?: 'FlexFinancialDataPointTreatmentTreatmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection>;
};

export type FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection = {
  __typename?: 'FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type FlexFinancialDataPointWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointWhere>>;
  agreement?: InputMaybe<AgreementWhere>;
  agreementAggregate?: InputMaybe<FlexFinancialDataPointAgreementAggregateInput>;
  agreementConnection?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
  agreementConnection_NOT?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
  agreement_NOT?: InputMaybe<AgreementWhere>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  basePriceType?: InputMaybe<PriceType>;
  basePriceType_IN?: InputMaybe<Array<InputMaybe<PriceType>>>;
  basePrice_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  basePrice_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  cannotBeSourceOfRefund?: InputMaybe<Scalars['Boolean']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  currencyCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currencyCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currencyCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currencyCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currencyCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_GT?: InputMaybe<Scalars['Date']['input']>;
  date_GTE?: InputMaybe<Scalars['Date']['input']>;
  date_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  date_LT?: InputMaybe<Scalars['Date']['input']>;
  date_LTE?: InputMaybe<Scalars['Date']['input']>;
  evaluates?: InputMaybe<FlexEntityWhere>;
  evaluatesAggregate?: InputMaybe<FlexFinancialDataPointEvaluatesAggregateInput>;
  evaluatesConnection?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
  evaluatesConnection_NOT?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
  evaluates_NOT?: InputMaybe<FlexEntityWhere>;
  evaluationSnapshot?: InputMaybe<Scalars['String']['input']>;
  evaluationSnapshot_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  evaluationSnapshot_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  evaluationSnapshot_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  evaluationSnapshot_MATCHES?: InputMaybe<Scalars['String']['input']>;
  evaluationSnapshot_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  failReason?: InputMaybe<ScenarioActionFailure>;
  failReason_IN?: InputMaybe<Array<InputMaybe<ScenarioActionFailure>>>;
  generatedFor?: InputMaybe<CaseWhere>;
  generatedForAggregate?: InputMaybe<FlexFinancialDataPointGeneratedForAggregateInput>;
  generatedForConnection?: InputMaybe<FlexFinancialDataPointGeneratedForConnectionWhere>;
  generatedForConnection_NOT?: InputMaybe<FlexFinancialDataPointGeneratedForConnectionWhere>;
  generatedFor_NOT?: InputMaybe<CaseWhere>;
  generatedUuid?: InputMaybe<Scalars['ID']['input']>;
  generatedUuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  generatedUuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  generatedUuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  generatedUuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isDefaultPriceRateApplied?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isDelta?: InputMaybe<Scalars['Boolean']['input']>;
  isLast?: InputMaybe<Scalars['Boolean']['input']>;
  netPrices?: InputMaybe<Scalars['String']['input']>;
  netPrices_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  netPrices_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  netPrices_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  netPrices_MATCHES?: InputMaybe<Scalars['String']['input']>;
  netPrices_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  payable?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  payablePercentage_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  payable_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_LTE?: InputMaybe<Scalars['Float']['input']>;
  prescriptionDate?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_GT?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  prescriptionDate_LT?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantity_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  quantity_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  refundDeltaNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundable?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  refundablePercentage_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  refundable_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  revokedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroMainNetPrices_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroMainNetPrices_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroMainNetPrices_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scenarioZeroMainNetPrices_MATCHES?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroMainNetPrices_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroNetPrices?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroNetPrices_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroNetPrices_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroNetPrices_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scenarioZeroNetPrices_MATCHES?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroNetPrices_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroRelevantNetPrices?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroRelevantNetPrices_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroRelevantNetPrices_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroRelevantNetPrices_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scenarioZeroRelevantNetPrices_MATCHES?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroRelevantNetPrices_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceDocument?: InputMaybe<RefundWhere>;
  sourceDocumentAggregate?: InputMaybe<FlexFinancialDataPointSourceDocumentAggregateInput>;
  sourceDocumentConnection?: InputMaybe<FlexFinancialDataPointSourceDocumentConnectionWhere>;
  sourceDocumentConnection_NOT?: InputMaybe<FlexFinancialDataPointSourceDocumentConnectionWhere>;
  sourceDocument_NOT?: InputMaybe<RefundWhere>;
  sourceRefund?: InputMaybe<RefundWhere>;
  sourceRefundAggregate?: InputMaybe<FlexFinancialDataPointSourceRefundAggregateInput>;
  sourceRefundConnection?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
  sourceRefundConnection_NOT?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
  sourceRefund_NOT?: InputMaybe<RefundWhere>;
  treatment?: InputMaybe<TreatmentWhere>;
  treatmentAggregate?: InputMaybe<FlexFinancialDataPointTreatmentAggregateInput>;
  treatmentConnection?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
  treatmentConnection_NOT?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
  treatment_NOT?: InputMaybe<TreatmentWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  variable?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  variablePercentage_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  variable_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type FlexFinancialDataPointsConnection = {
  __typename?: 'FlexFinancialDataPointsConnection';
  edges: Array<FlexFinancialDataPointEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum FlexFormStatus {
  CoolingPeriod = 'COOLING_PERIOD',
  Draft = 'DRAFT',
  Matched = 'MATCHED',
  Revoked = 'REVOKED',
  Submitted = 'SUBMITTED',
  Unmatched = 'UNMATCHED'
}

export type FlexQueriesConnection = {
  __typename?: 'FlexQueriesConnection';
  edges: Array<FlexQueryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexQuery = {
  __typename?: 'FlexQuery';
  createdBy: User;
  createdByAggregate?: Maybe<FlexQueryUserCreatedByAggregationSelection>;
  createdByConnection: FlexQueryCreatedByConnection;
  createdOn: Scalars['Float']['output'];
  cypherQuery: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paramsConfig?: Maybe<Scalars['String']['output']>;
  runs: Array<FlexQueryRun>;
  runsAggregate?: Maybe<FlexQueryFlexQueryRunRunsAggregationSelection>;
  runsConnection: FlexQueryRunsConnection;
  updatedBy?: Maybe<User>;
  updatedByAggregate?: Maybe<FlexQueryUserUpdatedByAggregationSelection>;
  updatedByConnection: FlexQueryUpdatedByConnection;
  updatedOn?: Maybe<Scalars['Float']['output']>;
};


export type FlexQueryCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type FlexQueryCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type FlexQueryCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexQueryCreatedByConnectionSort>>;
  where?: InputMaybe<FlexQueryCreatedByConnectionWhere>;
};


export type FlexQueryRunsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexQueryRunOptions>;
  where?: InputMaybe<FlexQueryRunWhere>;
};


export type FlexQueryRunsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexQueryRunWhere>;
};


export type FlexQueryRunsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexQueryRunsConnectionSort>>;
  where?: InputMaybe<FlexQueryRunsConnectionWhere>;
};


export type FlexQueryUpdatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type FlexQueryUpdatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type FlexQueryUpdatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexQueryUpdatedByConnectionSort>>;
  where?: InputMaybe<FlexQueryUpdatedByConnectionWhere>;
};

export type FlexQueryCreatedByAggregateInput = {
  AND?: InputMaybe<Array<FlexQueryCreatedByAggregateInput>>;
  NOT?: InputMaybe<FlexQueryCreatedByAggregateInput>;
  OR?: InputMaybe<Array<FlexQueryCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexQueryCreatedByNodeAggregationWhereInput>;
};

export type FlexQueryCreatedByConnection = {
  __typename?: 'FlexQueryCreatedByConnection';
  edges: Array<FlexQueryCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexQueryCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type FlexQueryCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<FlexQueryCreatedByConnectionWhere>>;
  NOT?: InputMaybe<FlexQueryCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<FlexQueryCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type FlexQueryCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexQueryCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexQueryCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexQueryCreatedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexQueryCreatedByRelationship = {
  __typename?: 'FlexQueryCreatedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type FlexQueryEdge = {
  __typename?: 'FlexQueryEdge';
  cursor: Scalars['String']['output'];
  node: FlexQuery;
};

export type FlexQueryFlexQueryRunRunsAggregationSelection = {
  __typename?: 'FlexQueryFlexQueryRunRunsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexQueryFlexQueryRunRunsNodeAggregateSelection>;
};

export type FlexQueryFlexQueryRunRunsNodeAggregateSelection = {
  __typename?: 'FlexQueryFlexQueryRunRunsNodeAggregateSelection';
  lastExecutionOn: FloatAggregateSelectionNonNullable;
  serializedParams: StringAggregateSelectionNullable;
};

export type FlexQueryInput = {
  cypherQuery: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  paramsConfig?: InputMaybe<Scalars['String']['input']>;
};

export type FlexQueryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexQuerySort objects to sort FlexQueries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexQuerySort>>;
};

export type FlexQueryRun = {
  __typename?: 'FlexQueryRun';
  lastExecutionOn: Scalars['Float']['output'];
  query: FlexQuery;
  queryAggregate?: Maybe<FlexQueryRunFlexQueryQueryAggregationSelection>;
  queryConnection: FlexQueryRunQueryConnection;
  serializedParams?: Maybe<Scalars['String']['output']>;
  startedBy: User;
  startedByAggregate?: Maybe<FlexQueryRunUserStartedByAggregationSelection>;
  startedByConnection: FlexQueryRunStartedByConnection;
};


export type FlexQueryRunQueryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexQueryOptions>;
  where?: InputMaybe<FlexQueryWhere>;
};


export type FlexQueryRunQueryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexQueryWhere>;
};


export type FlexQueryRunQueryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexQueryRunQueryConnectionSort>>;
  where?: InputMaybe<FlexQueryRunQueryConnectionWhere>;
};


export type FlexQueryRunStartedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type FlexQueryRunStartedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type FlexQueryRunStartedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexQueryRunStartedByConnectionSort>>;
  where?: InputMaybe<FlexQueryRunStartedByConnectionWhere>;
};

export type FlexQueryRunEdge = {
  __typename?: 'FlexQueryRunEdge';
  cursor: Scalars['String']['output'];
  node: FlexQueryRun;
};

export type FlexQueryRunFlexQueryQueryAggregationSelection = {
  __typename?: 'FlexQueryRunFlexQueryQueryAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexQueryRunFlexQueryQueryNodeAggregateSelection>;
};

export type FlexQueryRunFlexQueryQueryNodeAggregateSelection = {
  __typename?: 'FlexQueryRunFlexQueryQueryNodeAggregateSelection';
  createdOn: FloatAggregateSelectionNonNullable;
  cypherQuery: StringAggregateSelectionNonNullable;
  id: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  paramsConfig: StringAggregateSelectionNullable;
  updatedOn: FloatAggregateSelectionNullable;
};

export type FlexQueryRunOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexQueryRunSort objects to sort FlexQueryRuns by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexQueryRunSort>>;
};

export type FlexQueryRunQueryAggregateInput = {
  AND?: InputMaybe<Array<FlexQueryRunQueryAggregateInput>>;
  NOT?: InputMaybe<FlexQueryRunQueryAggregateInput>;
  OR?: InputMaybe<Array<FlexQueryRunQueryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexQueryRunQueryNodeAggregationWhereInput>;
};

export type FlexQueryRunQueryConnection = {
  __typename?: 'FlexQueryRunQueryConnection';
  edges: Array<FlexQueryRunQueryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexQueryRunQueryConnectionSort = {
  node?: InputMaybe<FlexQuerySort>;
};

export type FlexQueryRunQueryConnectionWhere = {
  AND?: InputMaybe<Array<FlexQueryRunQueryConnectionWhere>>;
  NOT?: InputMaybe<FlexQueryRunQueryConnectionWhere>;
  OR?: InputMaybe<Array<FlexQueryRunQueryConnectionWhere>>;
  node?: InputMaybe<FlexQueryWhere>;
};

export type FlexQueryRunQueryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexQueryRunQueryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexQueryRunQueryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexQueryRunQueryNodeAggregationWhereInput>>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  cypherQuery_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cypherQuery_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cypherQuery_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cypherQuery_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cypherQuery_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  cypherQuery_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cypherQuery_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cypherQuery_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cypherQuery_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cypherQuery_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cypherQuery_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cypherQuery_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cypherQuery_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cypherQuery_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cypherQuery_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paramsConfig_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paramsConfig_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  paramsConfig_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  paramsConfig_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  paramsConfig_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  paramsConfig_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paramsConfig_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paramsConfig_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paramsConfig_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paramsConfig_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paramsConfig_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paramsConfig_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paramsConfig_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paramsConfig_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paramsConfig_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type FlexQueryRunQueryRelationship = {
  __typename?: 'FlexQueryRunQueryRelationship';
  cursor: Scalars['String']['output'];
  node: FlexQuery;
};

/** Fields to sort FlexQueryRuns by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexQueryRunSort object. */
export type FlexQueryRunSort = {
  lastExecutionOn?: InputMaybe<SortDirection>;
  serializedParams?: InputMaybe<SortDirection>;
};

export type FlexQueryRunStartedByAggregateInput = {
  AND?: InputMaybe<Array<FlexQueryRunStartedByAggregateInput>>;
  NOT?: InputMaybe<FlexQueryRunStartedByAggregateInput>;
  OR?: InputMaybe<Array<FlexQueryRunStartedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexQueryRunStartedByNodeAggregationWhereInput>;
};

export type FlexQueryRunStartedByConnection = {
  __typename?: 'FlexQueryRunStartedByConnection';
  edges: Array<FlexQueryRunStartedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexQueryRunStartedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type FlexQueryRunStartedByConnectionWhere = {
  AND?: InputMaybe<Array<FlexQueryRunStartedByConnectionWhere>>;
  NOT?: InputMaybe<FlexQueryRunStartedByConnectionWhere>;
  OR?: InputMaybe<Array<FlexQueryRunStartedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type FlexQueryRunStartedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexQueryRunStartedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexQueryRunStartedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexQueryRunStartedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexQueryRunStartedByRelationship = {
  __typename?: 'FlexQueryRunStartedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type FlexQueryRunUserStartedByAggregationSelection = {
  __typename?: 'FlexQueryRunUserStartedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexQueryRunUserStartedByNodeAggregateSelection>;
};

export type FlexQueryRunUserStartedByNodeAggregateSelection = {
  __typename?: 'FlexQueryRunUserStartedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type FlexQueryRunWhere = {
  AND?: InputMaybe<Array<FlexQueryRunWhere>>;
  NOT?: InputMaybe<FlexQueryRunWhere>;
  OR?: InputMaybe<Array<FlexQueryRunWhere>>;
  lastExecutionOn?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_GT?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  lastExecutionOn_LT?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  query?: InputMaybe<FlexQueryWhere>;
  queryAggregate?: InputMaybe<FlexQueryRunQueryAggregateInput>;
  queryConnection?: InputMaybe<FlexQueryRunQueryConnectionWhere>;
  queryConnection_NOT?: InputMaybe<FlexQueryRunQueryConnectionWhere>;
  query_NOT?: InputMaybe<FlexQueryWhere>;
  serializedParams?: InputMaybe<Scalars['String']['input']>;
  serializedParams_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  serializedParams_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  serializedParams_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  serializedParams_MATCHES?: InputMaybe<Scalars['String']['input']>;
  serializedParams_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  startedBy?: InputMaybe<UserWhere>;
  startedByAggregate?: InputMaybe<FlexQueryRunStartedByAggregateInput>;
  startedByConnection?: InputMaybe<FlexQueryRunStartedByConnectionWhere>;
  startedByConnection_NOT?: InputMaybe<FlexQueryRunStartedByConnectionWhere>;
  startedBy_NOT?: InputMaybe<UserWhere>;
};

export type FlexQueryRunsAggregateInput = {
  AND?: InputMaybe<Array<FlexQueryRunsAggregateInput>>;
  NOT?: InputMaybe<FlexQueryRunsAggregateInput>;
  OR?: InputMaybe<Array<FlexQueryRunsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexQueryRunsNodeAggregationWhereInput>;
};

export type FlexQueryRunsConnection = {
  __typename?: 'FlexQueryRunsConnection';
  edges: Array<FlexQueryRunsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexQueryRunsConnectionSort = {
  node?: InputMaybe<FlexQueryRunSort>;
};

export type FlexQueryRunsConnectionWhere = {
  AND?: InputMaybe<Array<FlexQueryRunsConnectionWhere>>;
  NOT?: InputMaybe<FlexQueryRunsConnectionWhere>;
  OR?: InputMaybe<Array<FlexQueryRunsConnectionWhere>>;
  node?: InputMaybe<FlexQueryRunWhere>;
};

export type FlexQueryRunsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexQueryRunsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexQueryRunsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexQueryRunsNodeAggregationWhereInput>>;
  lastExecutionOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastExecutionOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  serializedParams_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  serializedParams_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  serializedParams_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  serializedParams_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  serializedParams_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  serializedParams_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  serializedParams_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  serializedParams_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  serializedParams_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  serializedParams_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  serializedParams_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  serializedParams_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  serializedParams_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  serializedParams_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  serializedParams_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexQueryRunsRelationship = {
  __typename?: 'FlexQueryRunsRelationship';
  cursor: Scalars['String']['output'];
  node: FlexQueryRun;
};

/** Fields to sort FlexQueries by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexQuerySort object. */
export type FlexQuerySort = {
  createdOn?: InputMaybe<SortDirection>;
  cypherQuery?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  paramsConfig?: InputMaybe<SortDirection>;
  updatedOn?: InputMaybe<SortDirection>;
};

export type FlexQueryUpdatedByAggregateInput = {
  AND?: InputMaybe<Array<FlexQueryUpdatedByAggregateInput>>;
  NOT?: InputMaybe<FlexQueryUpdatedByAggregateInput>;
  OR?: InputMaybe<Array<FlexQueryUpdatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexQueryUpdatedByNodeAggregationWhereInput>;
};

export type FlexQueryUpdatedByConnection = {
  __typename?: 'FlexQueryUpdatedByConnection';
  edges: Array<FlexQueryUpdatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexQueryUpdatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type FlexQueryUpdatedByConnectionWhere = {
  AND?: InputMaybe<Array<FlexQueryUpdatedByConnectionWhere>>;
  NOT?: InputMaybe<FlexQueryUpdatedByConnectionWhere>;
  OR?: InputMaybe<Array<FlexQueryUpdatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type FlexQueryUpdatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexQueryUpdatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexQueryUpdatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexQueryUpdatedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexQueryUpdatedByRelationship = {
  __typename?: 'FlexQueryUpdatedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type FlexQueryUserCreatedByAggregationSelection = {
  __typename?: 'FlexQueryUserCreatedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexQueryUserCreatedByNodeAggregateSelection>;
};

export type FlexQueryUserCreatedByNodeAggregateSelection = {
  __typename?: 'FlexQueryUserCreatedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type FlexQueryUserUpdatedByAggregationSelection = {
  __typename?: 'FlexQueryUserUpdatedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FlexQueryUserUpdatedByNodeAggregateSelection>;
};

export type FlexQueryUserUpdatedByNodeAggregateSelection = {
  __typename?: 'FlexQueryUserUpdatedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type FlexQueryWhere = {
  AND?: InputMaybe<Array<FlexQueryWhere>>;
  NOT?: InputMaybe<FlexQueryWhere>;
  OR?: InputMaybe<Array<FlexQueryWhere>>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<FlexQueryCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<FlexQueryCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<FlexQueryCreatedByConnectionWhere>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  createdOn?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  cypherQuery?: InputMaybe<Scalars['String']['input']>;
  cypherQuery_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  cypherQuery_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  cypherQuery_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  cypherQuery_MATCHES?: InputMaybe<Scalars['String']['input']>;
  cypherQuery_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  paramsConfig?: InputMaybe<Scalars['String']['input']>;
  paramsConfig_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  paramsConfig_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  paramsConfig_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paramsConfig_MATCHES?: InputMaybe<Scalars['String']['input']>;
  paramsConfig_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  runsAggregate?: InputMaybe<FlexQueryRunsAggregateInput>;
  /** Return FlexQueries where all of the related FlexQueryRunsConnections match this filter */
  runsConnection_ALL?: InputMaybe<FlexQueryRunsConnectionWhere>;
  /** Return FlexQueries where none of the related FlexQueryRunsConnections match this filter */
  runsConnection_NONE?: InputMaybe<FlexQueryRunsConnectionWhere>;
  /** Return FlexQueries where one of the related FlexQueryRunsConnections match this filter */
  runsConnection_SINGLE?: InputMaybe<FlexQueryRunsConnectionWhere>;
  /** Return FlexQueries where some of the related FlexQueryRunsConnections match this filter */
  runsConnection_SOME?: InputMaybe<FlexQueryRunsConnectionWhere>;
  /** Return FlexQueries where all of the related FlexQueryRuns match this filter */
  runs_ALL?: InputMaybe<FlexQueryRunWhere>;
  /** Return FlexQueries where none of the related FlexQueryRuns match this filter */
  runs_NONE?: InputMaybe<FlexQueryRunWhere>;
  /** Return FlexQueries where one of the related FlexQueryRuns match this filter */
  runs_SINGLE?: InputMaybe<FlexQueryRunWhere>;
  /** Return FlexQueries where some of the related FlexQueryRuns match this filter */
  runs_SOME?: InputMaybe<FlexQueryRunWhere>;
  updatedBy?: InputMaybe<UserWhere>;
  updatedByAggregate?: InputMaybe<FlexQueryUpdatedByAggregateInput>;
  updatedByConnection?: InputMaybe<FlexQueryUpdatedByConnectionWhere>;
  updatedByConnection_NOT?: InputMaybe<FlexQueryUpdatedByConnectionWhere>;
  updatedBy_NOT?: InputMaybe<UserWhere>;
  updatedOn?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_GT?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedOn_LT?: InputMaybe<Scalars['Float']['input']>;
  updatedOn_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatAggregateSelectionNonNullable = {
  __typename?: 'FloatAggregateSelectionNonNullable';
  average: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  sum: Scalars['Float']['output'];
};

export type FloatAggregateSelectionNullable = {
  __typename?: 'FloatAggregateSelectionNullable';
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
};

export type Generic = {
  __typename?: 'Generic';
  Name: Scalars['String']['output'];
  agreementCount: Scalars['Int']['output'];
  createdBy?: Maybe<User>;
  createdByAggregate?: Maybe<GenericUserCreatedByAggregationSelection>;
  createdByConnection: GenericCreatedByConnection;
  creationWay: MasterDataCreationWay;
  id: Scalars['ID']['output'];
  preparations: Array<Preparation>;
  preparationsAggregate?: Maybe<GenericPreparationPreparationsAggregationSelection>;
  preparationsConnection: GenericPreparationsConnection;
  treatmentSets: Array<TreatmentSet>;
  treatmentSetsAggregate?: Maybe<GenericTreatmentSetTreatmentSetsAggregationSelection>;
  treatmentSetsConnection: GenericTreatmentSetsConnection;
  usedInRecordOrForms: Scalars['Boolean']['output'];
};


export type GenericCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type GenericCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type GenericCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GenericCreatedByConnectionSort>>;
  where?: InputMaybe<GenericCreatedByConnectionWhere>;
};


export type GenericPreparationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type GenericPreparationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationWhere>;
};


export type GenericPreparationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GenericPreparationsConnectionSort>>;
  where?: InputMaybe<GenericPreparationsConnectionWhere>;
};


export type GenericTreatmentSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentSetOptions>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type GenericTreatmentSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type GenericTreatmentSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GenericTreatmentSetsConnectionSort>>;
  where?: InputMaybe<GenericTreatmentSetsConnectionWhere>;
};

export type GenericCreatedByAggregateInput = {
  AND?: InputMaybe<Array<GenericCreatedByAggregateInput>>;
  NOT?: InputMaybe<GenericCreatedByAggregateInput>;
  OR?: InputMaybe<Array<GenericCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GenericCreatedByNodeAggregationWhereInput>;
};

export type GenericCreatedByConnection = {
  __typename?: 'GenericCreatedByConnection';
  edges: Array<GenericCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GenericCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type GenericCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<GenericCreatedByConnectionWhere>>;
  NOT?: InputMaybe<GenericCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<GenericCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type GenericCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GenericCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GenericCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GenericCreatedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GenericCreatedByRelationship = {
  __typename?: 'GenericCreatedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type GenericEdge = {
  __typename?: 'GenericEdge';
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type GenericInput = {
  Name: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  preparations?: InputMaybe<Array<PreparationInput>>;
};

export type GenericOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more GenericSort objects to sort Generics by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<GenericSort>>;
};

export type GenericPreparationPreparationsAggregationSelection = {
  __typename?: 'GenericPreparationPreparationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<GenericPreparationPreparationsNodeAggregateSelection>;
};

export type GenericPreparationPreparationsNodeAggregateSelection = {
  __typename?: 'GenericPreparationPreparationsNodeAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type GenericPreparationsAggregateInput = {
  AND?: InputMaybe<Array<GenericPreparationsAggregateInput>>;
  NOT?: InputMaybe<GenericPreparationsAggregateInput>;
  OR?: InputMaybe<Array<GenericPreparationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GenericPreparationsNodeAggregationWhereInput>;
};

export type GenericPreparationsConnection = {
  __typename?: 'GenericPreparationsConnection';
  edges: Array<GenericPreparationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GenericPreparationsConnectionSort = {
  node?: InputMaybe<PreparationSort>;
};

export type GenericPreparationsConnectionWhere = {
  AND?: InputMaybe<Array<GenericPreparationsConnectionWhere>>;
  NOT?: InputMaybe<GenericPreparationsConnectionWhere>;
  OR?: InputMaybe<Array<GenericPreparationsConnectionWhere>>;
  node?: InputMaybe<PreparationWhere>;
};

export type GenericPreparationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GenericPreparationsNodeAggregationWhereInput>>;
  AtcCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<GenericPreparationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GenericPreparationsNodeAggregationWhereInput>>;
  SwissmedicNo5_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GenericPreparationsRelationship = {
  __typename?: 'GenericPreparationsRelationship';
  cursor: Scalars['String']['output'];
  node: Preparation;
};

/** Fields to sort Generics by. The order in which sorts are applied is not guaranteed when specifying many fields in one GenericSort object. */
export type GenericSort = {
  Name?: InputMaybe<SortDirection>;
  agreementCount?: InputMaybe<SortDirection>;
  creationWay?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  usedInRecordOrForms?: InputMaybe<SortDirection>;
};

export type GenericTreatmentSetTreatmentSetsAggregationSelection = {
  __typename?: 'GenericTreatmentSetTreatmentSetsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<GenericTreatmentSetTreatmentSetsNodeAggregateSelection>;
};

export type GenericTreatmentSetTreatmentSetsNodeAggregateSelection = {
  __typename?: 'GenericTreatmentSetTreatmentSetsNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
};

export type GenericTreatmentSetsAggregateInput = {
  AND?: InputMaybe<Array<GenericTreatmentSetsAggregateInput>>;
  NOT?: InputMaybe<GenericTreatmentSetsAggregateInput>;
  OR?: InputMaybe<Array<GenericTreatmentSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GenericTreatmentSetsNodeAggregationWhereInput>;
};

export type GenericTreatmentSetsConnection = {
  __typename?: 'GenericTreatmentSetsConnection';
  edges: Array<GenericTreatmentSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GenericTreatmentSetsConnectionSort = {
  node?: InputMaybe<TreatmentSetSort>;
};

export type GenericTreatmentSetsConnectionWhere = {
  AND?: InputMaybe<Array<GenericTreatmentSetsConnectionWhere>>;
  NOT?: InputMaybe<GenericTreatmentSetsConnectionWhere>;
  OR?: InputMaybe<Array<GenericTreatmentSetsConnectionWhere>>;
  node?: InputMaybe<TreatmentSetWhere>;
};

export type GenericTreatmentSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GenericTreatmentSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GenericTreatmentSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GenericTreatmentSetsNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GenericTreatmentSetsRelationship = {
  __typename?: 'GenericTreatmentSetsRelationship';
  cursor: Scalars['String']['output'];
  node: TreatmentSet;
};

export type GenericUserCreatedByAggregationSelection = {
  __typename?: 'GenericUserCreatedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<GenericUserCreatedByNodeAggregateSelection>;
};

export type GenericUserCreatedByNodeAggregateSelection = {
  __typename?: 'GenericUserCreatedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type GenericWhere = {
  AND?: InputMaybe<Array<GenericWhere>>;
  NOT?: InputMaybe<GenericWhere>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  OR?: InputMaybe<Array<GenericWhere>>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<GenericCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<GenericCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<GenericCreatedByConnectionWhere>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  creationWay?: InputMaybe<MasterDataCreationWay>;
  creationWay_IN?: InputMaybe<Array<MasterDataCreationWay>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  preparationsAggregate?: InputMaybe<GenericPreparationsAggregateInput>;
  /** Return Generics where all of the related GenericPreparationsConnections match this filter */
  preparationsConnection_ALL?: InputMaybe<GenericPreparationsConnectionWhere>;
  /** Return Generics where none of the related GenericPreparationsConnections match this filter */
  preparationsConnection_NONE?: InputMaybe<GenericPreparationsConnectionWhere>;
  /** Return Generics where one of the related GenericPreparationsConnections match this filter */
  preparationsConnection_SINGLE?: InputMaybe<GenericPreparationsConnectionWhere>;
  /** Return Generics where some of the related GenericPreparationsConnections match this filter */
  preparationsConnection_SOME?: InputMaybe<GenericPreparationsConnectionWhere>;
  /** Return Generics where all of the related Preparations match this filter */
  preparations_ALL?: InputMaybe<PreparationWhere>;
  /** Return Generics where none of the related Preparations match this filter */
  preparations_NONE?: InputMaybe<PreparationWhere>;
  /** Return Generics where one of the related Preparations match this filter */
  preparations_SINGLE?: InputMaybe<PreparationWhere>;
  /** Return Generics where some of the related Preparations match this filter */
  preparations_SOME?: InputMaybe<PreparationWhere>;
  treatmentSetsAggregate?: InputMaybe<GenericTreatmentSetsAggregateInput>;
  /** Return Generics where all of the related GenericTreatmentSetsConnections match this filter */
  treatmentSetsConnection_ALL?: InputMaybe<GenericTreatmentSetsConnectionWhere>;
  /** Return Generics where none of the related GenericTreatmentSetsConnections match this filter */
  treatmentSetsConnection_NONE?: InputMaybe<GenericTreatmentSetsConnectionWhere>;
  /** Return Generics where one of the related GenericTreatmentSetsConnections match this filter */
  treatmentSetsConnection_SINGLE?: InputMaybe<GenericTreatmentSetsConnectionWhere>;
  /** Return Generics where some of the related GenericTreatmentSetsConnections match this filter */
  treatmentSetsConnection_SOME?: InputMaybe<GenericTreatmentSetsConnectionWhere>;
  /** Return Generics where all of the related TreatmentSets match this filter */
  treatmentSets_ALL?: InputMaybe<TreatmentSetWhere>;
  /** Return Generics where none of the related TreatmentSets match this filter */
  treatmentSets_NONE?: InputMaybe<TreatmentSetWhere>;
  /** Return Generics where one of the related TreatmentSets match this filter */
  treatmentSets_SINGLE?: InputMaybe<TreatmentSetWhere>;
  /** Return Generics where some of the related TreatmentSets match this filter */
  treatmentSets_SOME?: InputMaybe<TreatmentSetWhere>;
};

export type GenericsConnection = {
  __typename?: 'GenericsConnection';
  edges: Array<GenericEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GetBrandReportItem = {
  __typename?: 'GetBrandReportItem';
  agreementIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brand?: Maybe<Scalars['String']['output']>;
  caseIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  disease?: Maybe<Scalars['String']['output']>;
  indicationCode?: Maybe<Scalars['String']['output']>;
  patientIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GetBrandReportItemEdge = {
  __typename?: 'GetBrandReportItemEdge';
  cursor: Scalars['String']['output'];
  node: GetBrandReportItem;
};

export type GetBrandReportItemOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more GetBrandReportItemSort objects to sort GetBrandReportItems by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<GetBrandReportItemSort>>;
};

/** Fields to sort GetBrandReportItems by. The order in which sorts are applied is not guaranteed when specifying many fields in one GetBrandReportItemSort object. */
export type GetBrandReportItemSort = {
  brand?: InputMaybe<SortDirection>;
  disease?: InputMaybe<SortDirection>;
  indicationCode?: InputMaybe<SortDirection>;
};

export type GetBrandReportItemWhere = {
  AND?: InputMaybe<Array<GetBrandReportItemWhere>>;
  NOT?: InputMaybe<GetBrandReportItemWhere>;
  OR?: InputMaybe<Array<GetBrandReportItemWhere>>;
  agreementIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  brand_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  brand_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  brand_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brand_MATCHES?: InputMaybe<Scalars['String']['input']>;
  brand_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  caseIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caseIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  disease?: InputMaybe<Scalars['String']['input']>;
  disease_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  disease_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  disease_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disease_MATCHES?: InputMaybe<Scalars['String']['input']>;
  disease_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  indicationCode?: InputMaybe<Scalars['String']['input']>;
  indicationCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  indicationCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  indicationCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indicationCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  indicationCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type GetBrandReportItemsConnection = {
  __typename?: 'GetBrandReportItemsConnection';
  edges: Array<GetBrandReportItemEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GetIndicationReportItem = {
  __typename?: 'GetIndicationReportItem';
  agreementIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brands?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  caseIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  disease?: Maybe<Scalars['String']['output']>;
  indication?: Maybe<Indication>;
  patientIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GetIndicationReportItemEdge = {
  __typename?: 'GetIndicationReportItemEdge';
  cursor: Scalars['String']['output'];
  node: GetIndicationReportItem;
};

export type GetIndicationReportItemOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more GetIndicationReportItemSort objects to sort GetIndicationReportItems by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<GetIndicationReportItemSort>>;
};

/** Fields to sort GetIndicationReportItems by. The order in which sorts are applied is not guaranteed when specifying many fields in one GetIndicationReportItemSort object. */
export type GetIndicationReportItemSort = {
  disease?: InputMaybe<SortDirection>;
};

export type GetIndicationReportItemWhere = {
  AND?: InputMaybe<Array<GetIndicationReportItemWhere>>;
  NOT?: InputMaybe<GetIndicationReportItemWhere>;
  OR?: InputMaybe<Array<GetIndicationReportItemWhere>>;
  agreementIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brands_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  caseIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caseIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  disease?: InputMaybe<Scalars['String']['input']>;
  disease_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  disease_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  disease_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disease_MATCHES?: InputMaybe<Scalars['String']['input']>;
  disease_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type GetIndicationReportItemsConnection = {
  __typename?: 'GetIndicationReportItemsConnection';
  edges: Array<GetIndicationReportItemEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GetTranslationsVariables = {
  environment: Scalars['String']['input'];
  languages: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type GlobalLock = {
  __typename?: 'GlobalLock';
  createdOn: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creatorAggregate?: Maybe<GlobalLockUserCreatorAggregationSelection>;
  creatorConnection: GlobalLockCreatorConnection;
  heldBy: Scalars['DateTime']['output'];
  lockType: LockType;
  resourceId?: Maybe<Scalars['String']['output']>;
};


export type GlobalLockCreatorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type GlobalLockCreatorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type GlobalLockCreatorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GlobalLockCreatorConnectionSort>>;
  where?: InputMaybe<GlobalLockCreatorConnectionWhere>;
};

export type GlobalLockCreatorAggregateInput = {
  AND?: InputMaybe<Array<GlobalLockCreatorAggregateInput>>;
  NOT?: InputMaybe<GlobalLockCreatorAggregateInput>;
  OR?: InputMaybe<Array<GlobalLockCreatorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GlobalLockCreatorNodeAggregationWhereInput>;
};

export type GlobalLockCreatorConnection = {
  __typename?: 'GlobalLockCreatorConnection';
  edges: Array<GlobalLockCreatorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GlobalLockCreatorConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type GlobalLockCreatorConnectionWhere = {
  AND?: InputMaybe<Array<GlobalLockCreatorConnectionWhere>>;
  NOT?: InputMaybe<GlobalLockCreatorConnectionWhere>;
  OR?: InputMaybe<Array<GlobalLockCreatorConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type GlobalLockCreatorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GlobalLockCreatorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GlobalLockCreatorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GlobalLockCreatorNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalLockCreatorRelationship = {
  __typename?: 'GlobalLockCreatorRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type GlobalLockEdge = {
  __typename?: 'GlobalLockEdge';
  cursor: Scalars['String']['output'];
  node: GlobalLock;
};

export type GlobalLockOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more GlobalLockSort objects to sort GlobalLocks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<GlobalLockSort>>;
};

/** Fields to sort GlobalLocks by. The order in which sorts are applied is not guaranteed when specifying many fields in one GlobalLockSort object. */
export type GlobalLockSort = {
  createdOn?: InputMaybe<SortDirection>;
  heldBy?: InputMaybe<SortDirection>;
  lockType?: InputMaybe<SortDirection>;
  resourceId?: InputMaybe<SortDirection>;
};

export type GlobalLockUserCreatorAggregationSelection = {
  __typename?: 'GlobalLockUserCreatorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<GlobalLockUserCreatorNodeAggregateSelection>;
};

export type GlobalLockUserCreatorNodeAggregateSelection = {
  __typename?: 'GlobalLockUserCreatorNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type GlobalLockWhere = {
  AND?: InputMaybe<Array<GlobalLockWhere>>;
  NOT?: InputMaybe<GlobalLockWhere>;
  OR?: InputMaybe<Array<GlobalLockWhere>>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<UserWhere>;
  creatorAggregate?: InputMaybe<GlobalLockCreatorAggregateInput>;
  creatorConnection?: InputMaybe<GlobalLockCreatorConnectionWhere>;
  creatorConnection_NOT?: InputMaybe<GlobalLockCreatorConnectionWhere>;
  creator_NOT?: InputMaybe<UserWhere>;
  heldBy?: InputMaybe<Scalars['DateTime']['input']>;
  heldBy_GT?: InputMaybe<Scalars['DateTime']['input']>;
  heldBy_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  heldBy_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  heldBy_LT?: InputMaybe<Scalars['DateTime']['input']>;
  heldBy_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockType?: InputMaybe<LockType>;
  lockType_IN?: InputMaybe<Array<LockType>>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  resourceId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  resourceId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  resourceId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resourceId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  resourceId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalLocksConnection = {
  __typename?: 'GlobalLocksConnection';
  edges: Array<GlobalLockEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IdAggregateSelectionNonNullable = {
  __typename?: 'IDAggregateSelectionNonNullable';
  longest: Scalars['ID']['output'];
  shortest: Scalars['ID']['output'];
};

export type IdAggregateSelectionNullable = {
  __typename?: 'IDAggregateSelectionNullable';
  longest?: Maybe<Scalars['ID']['output']>;
  shortest?: Maybe<Scalars['ID']['output']>;
};

export type ITimeframe = {
  rollingRangeType?: Maybe<RollingRangeType>;
  startingPoint?: Maybe<TimeframeStartingPoint>;
  timeframeEnd?: Maybe<Scalars['Int']['output']>;
  timeframeRangeType?: Maybe<TimeframeRangeType>;
  timeframeRelation?: Maybe<TimeframeRelation>;
  timeframeStart?: Maybe<Scalars['Int']['output']>;
};

export type ITreatmentCondition = {
  brands?: Maybe<Array<Brand>>;
  generics?: Maybe<Array<Generic>>;
  treatments?: Maybe<Array<Treatment>>;
};

export type Icd10Attribute = {
  __typename?: 'Icd10Attribute';
  BeginOffset?: Maybe<Scalars['Int']['output']>;
  EndOffset?: Maybe<Scalars['Int']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  RelationshipScore?: Maybe<Scalars['Float']['output']>;
  Score?: Maybe<Scalars['Float']['output']>;
  Text?: Maybe<Scalars['String']['output']>;
  Traits?: Maybe<Array<Maybe<Icd10Trait>>>;
  Type?: Maybe<Scalars['String']['output']>;
};

export type Icd10AttributeEdge = {
  __typename?: 'Icd10AttributeEdge';
  cursor: Scalars['String']['output'];
  node: Icd10Attribute;
};

export type Icd10AttributeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more Icd10AttributeSort objects to sort Icd10Attributes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<Icd10AttributeSort>>;
};

/** Fields to sort Icd10Attributes by. The order in which sorts are applied is not guaranteed when specifying many fields in one Icd10AttributeSort object. */
export type Icd10AttributeSort = {
  BeginOffset?: InputMaybe<SortDirection>;
  EndOffset?: InputMaybe<SortDirection>;
  Id?: InputMaybe<SortDirection>;
  RelationshipScore?: InputMaybe<SortDirection>;
  Score?: InputMaybe<SortDirection>;
  Text?: InputMaybe<SortDirection>;
  Type?: InputMaybe<SortDirection>;
};

export type Icd10AttributeWhere = {
  AND?: InputMaybe<Array<Icd10AttributeWhere>>;
  BeginOffset?: InputMaybe<Scalars['Int']['input']>;
  BeginOffset_GT?: InputMaybe<Scalars['Int']['input']>;
  BeginOffset_GTE?: InputMaybe<Scalars['Int']['input']>;
  BeginOffset_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  BeginOffset_LT?: InputMaybe<Scalars['Int']['input']>;
  BeginOffset_LTE?: InputMaybe<Scalars['Int']['input']>;
  EndOffset?: InputMaybe<Scalars['Int']['input']>;
  EndOffset_GT?: InputMaybe<Scalars['Int']['input']>;
  EndOffset_GTE?: InputMaybe<Scalars['Int']['input']>;
  EndOffset_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  EndOffset_LT?: InputMaybe<Scalars['Int']['input']>;
  EndOffset_LTE?: InputMaybe<Scalars['Int']['input']>;
  Id?: InputMaybe<Scalars['Int']['input']>;
  Id_GT?: InputMaybe<Scalars['Int']['input']>;
  Id_GTE?: InputMaybe<Scalars['Int']['input']>;
  Id_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  Id_LT?: InputMaybe<Scalars['Int']['input']>;
  Id_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<Icd10AttributeWhere>;
  OR?: InputMaybe<Array<Icd10AttributeWhere>>;
  RelationshipScore?: InputMaybe<Scalars['Float']['input']>;
  RelationshipScore_GT?: InputMaybe<Scalars['Float']['input']>;
  RelationshipScore_GTE?: InputMaybe<Scalars['Float']['input']>;
  RelationshipScore_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  RelationshipScore_LT?: InputMaybe<Scalars['Float']['input']>;
  RelationshipScore_LTE?: InputMaybe<Scalars['Float']['input']>;
  Score?: InputMaybe<Scalars['Float']['input']>;
  Score_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Score_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_LTE?: InputMaybe<Scalars['Float']['input']>;
  Text?: InputMaybe<Scalars['String']['input']>;
  Text_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Text_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Text_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Text_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Text_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Scalars['String']['input']>;
  Type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Type_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type Icd10AttributesConnection = {
  __typename?: 'Icd10AttributesConnection';
  edges: Array<Icd10AttributeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Icd10Concept = {
  __typename?: 'Icd10Concept';
  Code?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Score?: Maybe<Scalars['Float']['output']>;
};

export type Icd10ConceptEdge = {
  __typename?: 'Icd10ConceptEdge';
  cursor: Scalars['String']['output'];
  node: Icd10Concept;
};

export type Icd10ConceptOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more Icd10ConceptSort objects to sort Icd10Concepts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<Icd10ConceptSort>>;
};

/** Fields to sort Icd10Concepts by. The order in which sorts are applied is not guaranteed when specifying many fields in one Icd10ConceptSort object. */
export type Icd10ConceptSort = {
  Code?: InputMaybe<SortDirection>;
  Description?: InputMaybe<SortDirection>;
  Score?: InputMaybe<SortDirection>;
};

export type Icd10ConceptWhere = {
  AND?: InputMaybe<Array<Icd10ConceptWhere>>;
  Code?: InputMaybe<Scalars['String']['input']>;
  Code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Code_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Description_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<Icd10ConceptWhere>;
  OR?: InputMaybe<Array<Icd10ConceptWhere>>;
  Score?: InputMaybe<Scalars['Float']['input']>;
  Score_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Score_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type Icd10ConceptsConnection = {
  __typename?: 'Icd10ConceptsConnection';
  edges: Array<Icd10ConceptEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Icd10EntitiesConnection = {
  __typename?: 'Icd10EntitiesConnection';
  edges: Array<Icd10EntityEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Icd10Entity = {
  __typename?: 'Icd10Entity';
  Attributes?: Maybe<Array<Maybe<Icd10Attribute>>>;
  BeginOffset?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Scalars['String']['output']>;
  EndOffset?: Maybe<Scalars['Int']['output']>;
  ICD10CMConcepts?: Maybe<Array<Maybe<Icd10Concept>>>;
  Id?: Maybe<Scalars['Int']['output']>;
  Score?: Maybe<Scalars['Float']['output']>;
  Text?: Maybe<Scalars['String']['output']>;
  Traits?: Maybe<Array<Maybe<Icd10Trait>>>;
  Type?: Maybe<Scalars['String']['output']>;
};

export type Icd10EntityEdge = {
  __typename?: 'Icd10EntityEdge';
  cursor: Scalars['String']['output'];
  node: Icd10Entity;
};

export type Icd10EntityOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more Icd10EntitySort objects to sort Icd10Entities by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<Icd10EntitySort>>;
};

/** Fields to sort Icd10Entities by. The order in which sorts are applied is not guaranteed when specifying many fields in one Icd10EntitySort object. */
export type Icd10EntitySort = {
  BeginOffset?: InputMaybe<SortDirection>;
  Category?: InputMaybe<SortDirection>;
  EndOffset?: InputMaybe<SortDirection>;
  Id?: InputMaybe<SortDirection>;
  Score?: InputMaybe<SortDirection>;
  Text?: InputMaybe<SortDirection>;
  Type?: InputMaybe<SortDirection>;
};

export type Icd10EntityWhere = {
  AND?: InputMaybe<Array<Icd10EntityWhere>>;
  BeginOffset?: InputMaybe<Scalars['Int']['input']>;
  BeginOffset_GT?: InputMaybe<Scalars['Int']['input']>;
  BeginOffset_GTE?: InputMaybe<Scalars['Int']['input']>;
  BeginOffset_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  BeginOffset_LT?: InputMaybe<Scalars['Int']['input']>;
  BeginOffset_LTE?: InputMaybe<Scalars['Int']['input']>;
  Category?: InputMaybe<Scalars['String']['input']>;
  Category_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Category_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Category_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Category_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Category_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  EndOffset?: InputMaybe<Scalars['Int']['input']>;
  EndOffset_GT?: InputMaybe<Scalars['Int']['input']>;
  EndOffset_GTE?: InputMaybe<Scalars['Int']['input']>;
  EndOffset_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  EndOffset_LT?: InputMaybe<Scalars['Int']['input']>;
  EndOffset_LTE?: InputMaybe<Scalars['Int']['input']>;
  Id?: InputMaybe<Scalars['Int']['input']>;
  Id_GT?: InputMaybe<Scalars['Int']['input']>;
  Id_GTE?: InputMaybe<Scalars['Int']['input']>;
  Id_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  Id_LT?: InputMaybe<Scalars['Int']['input']>;
  Id_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<Icd10EntityWhere>;
  OR?: InputMaybe<Array<Icd10EntityWhere>>;
  Score?: InputMaybe<Scalars['Float']['input']>;
  Score_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Score_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_LTE?: InputMaybe<Scalars['Float']['input']>;
  Text?: InputMaybe<Scalars['String']['input']>;
  Text_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Text_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Text_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Text_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Text_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Scalars['String']['input']>;
  Type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Type_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type Icd10Suggestions = {
  __typename?: 'Icd10Suggestions';
  Entities?: Maybe<Array<Maybe<Icd10Entity>>>;
  ModelVersion?: Maybe<Scalars['String']['output']>;
  PaginationToken?: Maybe<Scalars['String']['output']>;
};

export type Icd10SuggestionsConnection = {
  __typename?: 'Icd10SuggestionsConnection';
  edges: Array<Icd10SuggestionsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Icd10SuggestionsEdge = {
  __typename?: 'Icd10SuggestionsEdge';
  cursor: Scalars['String']['output'];
  node: Icd10Suggestions;
};

export type Icd10SuggestionsOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more Icd10SuggestionsSort objects to sort Icd10Suggestions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<Icd10SuggestionsSort>>;
};

/** Fields to sort Icd10Suggestions by. The order in which sorts are applied is not guaranteed when specifying many fields in one Icd10SuggestionsSort object. */
export type Icd10SuggestionsSort = {
  ModelVersion?: InputMaybe<SortDirection>;
  PaginationToken?: InputMaybe<SortDirection>;
};

export type Icd10SuggestionsWhere = {
  AND?: InputMaybe<Array<Icd10SuggestionsWhere>>;
  ModelVersion?: InputMaybe<Scalars['String']['input']>;
  ModelVersion_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ModelVersion_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ModelVersion_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ModelVersion_MATCHES?: InputMaybe<Scalars['String']['input']>;
  ModelVersion_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<Icd10SuggestionsWhere>;
  OR?: InputMaybe<Array<Icd10SuggestionsWhere>>;
  PaginationToken?: InputMaybe<Scalars['String']['input']>;
  PaginationToken_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PaginationToken_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PaginationToken_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PaginationToken_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PaginationToken_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type Icd10Trait = {
  __typename?: 'Icd10Trait';
  Name?: Maybe<Scalars['String']['output']>;
  Score?: Maybe<Scalars['Float']['output']>;
};

export type Icd10TraitEdge = {
  __typename?: 'Icd10TraitEdge';
  cursor: Scalars['String']['output'];
  node: Icd10Trait;
};

export type Icd10TraitOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more Icd10TraitSort objects to sort Icd10Traits by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<Icd10TraitSort>>;
};

/** Fields to sort Icd10Traits by. The order in which sorts are applied is not guaranteed when specifying many fields in one Icd10TraitSort object. */
export type Icd10TraitSort = {
  Name?: InputMaybe<SortDirection>;
  Score?: InputMaybe<SortDirection>;
};

export type Icd10TraitWhere = {
  AND?: InputMaybe<Array<Icd10TraitWhere>>;
  NOT?: InputMaybe<Icd10TraitWhere>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  OR?: InputMaybe<Array<Icd10TraitWhere>>;
  Score?: InputMaybe<Scalars['Float']['input']>;
  Score_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Score_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type Icd10TraitsConnection = {
  __typename?: 'Icd10TraitsConnection';
  edges: Array<Icd10TraitEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ImpactCategory {
  DescriptionChange = 'DESCRIPTION_CHANGE',
  GenericChange = 'GENERIC_CHANGE',
  GtinChange = 'GTIN_CHANGE',
  LimitationAddition = 'LIMITATION_ADDITION',
  LimitationTargetAbsent = 'LIMITATION_TARGET_ABSENT',
  PackAddition = 'PACK_ADDITION',
  PackRemoval = 'PACK_REMOVAL',
  PreparationAddition = 'PREPARATION_ADDITION',
  PriceAddition = 'PRICE_ADDITION'
}

export type ImpactItem = {
  __typename?: 'ImpactItem';
  category: ImpactCategory;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  severity: ImpactSeverity;
};

export type ImpactItemEdge = {
  __typename?: 'ImpactItemEdge';
  cursor: Scalars['String']['output'];
  node: ImpactItem;
};

export type ImpactItemOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ImpactItemSort objects to sort ImpactItems by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ImpactItemSort>>;
};

/** Fields to sort ImpactItems by. The order in which sorts are applied is not guaranteed when specifying many fields in one ImpactItemSort object. */
export type ImpactItemSort = {
  category?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  severity?: InputMaybe<SortDirection>;
};

export type ImpactItemWhere = {
  AND?: InputMaybe<Array<ImpactItemWhere>>;
  NOT?: InputMaybe<ImpactItemWhere>;
  OR?: InputMaybe<Array<ImpactItemWhere>>;
  category?: InputMaybe<ImpactCategory>;
  category_IN?: InputMaybe<Array<ImpactCategory>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<ImpactSeverity>;
  severity_IN?: InputMaybe<Array<ImpactSeverity>>;
};

export type ImpactItemsConnection = {
  __typename?: 'ImpactItemsConnection';
  edges: Array<ImpactItemEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ImpactSeverity {
  Critical = 'CRITICAL',
  Info = 'INFO',
  Warning = 'WARNING'
}

export enum InclusionType {
  Included = 'INCLUDED',
  NotIncluded = 'NOT_INCLUDED'
}

export type Indication = {
  __typename?: 'Indication';
  agreementCount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  intent?: Maybe<Scalars['String']['output']>;
  intentLocalizationKey?: Maybe<Scalars['String']['output']>;
  isCustom: Scalars['Boolean']['output'];
  line?: Maybe<Scalars['String']['output']>;
  lineLocalizationKey?: Maybe<Scalars['String']['output']>;
  modelCount: Scalars['Int']['output'];
  mutation?: Maybe<Scalars['String']['output']>;
  mutationLocalizationKey?: Maybe<Scalars['String']['output']>;
  organizations: Array<Organization>;
  type?: Maybe<Scalars['String']['output']>;
  typeLocalizationKey?: Maybe<Scalars['String']['output']>;
};

export type IndicationEdge = {
  __typename?: 'IndicationEdge';
  cursor: Scalars['String']['output'];
  node: Indication;
};

export type IndicationInput = {
  code: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  intentLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  line?: InputMaybe<Scalars['String']['input']>;
  lineLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  mutation?: InputMaybe<Scalars['String']['input']>;
  mutationLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  typeLocalizationKey?: InputMaybe<Scalars['String']['input']>;
};

export type IndicationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more IndicationSort objects to sort Indications by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<IndicationSort>>;
};

/** Fields to sort Indications by. The order in which sorts are applied is not guaranteed when specifying many fields in one IndicationSort object. */
export type IndicationSort = {
  agreementCount?: InputMaybe<SortDirection>;
  code?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  intent?: InputMaybe<SortDirection>;
  intentLocalizationKey?: InputMaybe<SortDirection>;
  isCustom?: InputMaybe<SortDirection>;
  line?: InputMaybe<SortDirection>;
  lineLocalizationKey?: InputMaybe<SortDirection>;
  modelCount?: InputMaybe<SortDirection>;
  mutation?: InputMaybe<SortDirection>;
  mutationLocalizationKey?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  typeLocalizationKey?: InputMaybe<SortDirection>;
};

export type IndicationWhere = {
  AND?: InputMaybe<Array<IndicationWhere>>;
  NOT?: InputMaybe<IndicationWhere>;
  OR?: InputMaybe<Array<IndicationWhere>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  intentLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  intentLocalizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  intentLocalizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  intentLocalizationKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intentLocalizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  intentLocalizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  intent_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  intent_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  intent_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intent_MATCHES?: InputMaybe<Scalars['String']['input']>;
  intent_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  line?: InputMaybe<Scalars['String']['input']>;
  lineLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  lineLocalizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lineLocalizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lineLocalizationKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lineLocalizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lineLocalizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  line_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  line_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  line_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  line_MATCHES?: InputMaybe<Scalars['String']['input']>;
  line_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mutation?: InputMaybe<Scalars['String']['input']>;
  mutationLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  mutationLocalizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mutationLocalizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mutationLocalizationKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mutationLocalizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  mutationLocalizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mutation_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mutation_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mutation_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mutation_MATCHES?: InputMaybe<Scalars['String']['input']>;
  mutation_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  typeLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  typeLocalizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  typeLocalizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  typeLocalizationKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeLocalizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  typeLocalizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_MATCHES?: InputMaybe<Scalars['String']['input']>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type IndicationsConnection = {
  __typename?: 'IndicationsConnection';
  edges: Array<IndicationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IntAggregateSelectionNonNullable = {
  __typename?: 'IntAggregateSelectionNonNullable';
  average: Scalars['Float']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  sum: Scalars['Int']['output'];
};

export type IntAggregateSelectionNullable = {
  __typename?: 'IntAggregateSelectionNullable';
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  sum?: Maybe<Scalars['Int']['output']>;
};

export type IntegrityCheckCompleteResult = {
  __typename?: 'IntegrityCheckCompleteResult';
  dbNodeId: Scalars['Int']['output'];
  failedChecks: Array<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type IntegrityCheckCompleteResultEdge = {
  __typename?: 'IntegrityCheckCompleteResultEdge';
  cursor: Scalars['String']['output'];
  node: IntegrityCheckCompleteResult;
};

export type IntegrityCheckCompleteResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more IntegrityCheckCompleteResultSort objects to sort IntegrityCheckCompleteResults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<IntegrityCheckCompleteResultSort>>;
};

/** Fields to sort IntegrityCheckCompleteResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one IntegrityCheckCompleteResultSort object. */
export type IntegrityCheckCompleteResultSort = {
  dbNodeId?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
};

export type IntegrityCheckCompleteResultWhere = {
  AND?: InputMaybe<Array<IntegrityCheckCompleteResultWhere>>;
  NOT?: InputMaybe<IntegrityCheckCompleteResultWhere>;
  OR?: InputMaybe<Array<IntegrityCheckCompleteResultWhere>>;
  dbNodeId?: InputMaybe<Scalars['Int']['input']>;
  dbNodeId_GT?: InputMaybe<Scalars['Int']['input']>;
  dbNodeId_GTE?: InputMaybe<Scalars['Int']['input']>;
  dbNodeId_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  dbNodeId_LT?: InputMaybe<Scalars['Int']['input']>;
  dbNodeId_LTE?: InputMaybe<Scalars['Int']['input']>;
  failedChecks?: InputMaybe<Array<Scalars['String']['input']>>;
  failedChecks_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrityCheckCompleteResultsConnection = {
  __typename?: 'IntegrityCheckCompleteResultsConnection';
  edges: Array<IntegrityCheckCompleteResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IntegrityCheckTypes = {
  __typename?: 'IntegrityCheckTypes';
  all: Array<Scalars['String']['output']>;
  inQueue: Array<Scalars['String']['output']>;
};

export type IntegrityCheckTypesConnection = {
  __typename?: 'IntegrityCheckTypesConnection';
  edges: Array<IntegrityCheckTypesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IntegrityCheckTypesEdge = {
  __typename?: 'IntegrityCheckTypesEdge';
  cursor: Scalars['String']['output'];
  node: IntegrityCheckTypes;
};

export type IntegrityCheckTypesOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrityCheckTypesWhere = {
  AND?: InputMaybe<Array<IntegrityCheckTypesWhere>>;
  NOT?: InputMaybe<IntegrityCheckTypesWhere>;
  OR?: InputMaybe<Array<IntegrityCheckTypesWhere>>;
  all?: InputMaybe<Array<Scalars['String']['input']>>;
  all_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  inQueue?: InputMaybe<Array<Scalars['String']['input']>>;
  inQueue_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export enum InterventionOccurrence {
  FirstSurgeryDate = 'FIRST_SURGERY_DATE'
}

export enum InterventionType {
  RelatedToPaf = 'RELATED_TO_PAF'
}

export enum ItemScope {
  All = 'ALL',
  Last = 'LAST',
  Repetingitems = 'REPETINGITEMS',
  Specific = 'SPECIFIC'
}

export enum LdlTestUom {
  MgPerDl = 'MG_PER_DL',
  MmolPerL = 'MMOL_PER_L'
}

export type Limitation = {
  __typename?: 'Limitation';
  Code?: Maybe<Scalars['String']['output']>;
  DescriptionDe: Scalars['String']['output'];
  DescriptionEn?: Maybe<Scalars['String']['output']>;
  DescriptionFr?: Maybe<Scalars['String']['output']>;
  DescriptionIt?: Maybe<Scalars['String']['output']>;
  HasPriceModel: Scalars['Boolean']['output'];
  Niveau?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  ValidFromDate?: Maybe<Scalars['Date']['output']>;
  ValidThruDate?: Maybe<Scalars['Date']['output']>;
  agreementTemplate?: Maybe<AgreementTemplate>;
  agreementTemplateAggregate?: Maybe<LimitationAgreementTemplateAgreementTemplateAggregationSelection>;
  agreementTemplateConnection: LimitationAgreementTemplateConnection;
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  isClassified: Scalars['Boolean']['output'];
  isValidFromDateSetByImportDate?: Maybe<Scalars['Boolean']['output']>;
  limitsPreparations: Array<Preparation>;
  limitsPreparationsAggregate?: Maybe<LimitationPreparationLimitsPreparationsAggregationSelection>;
  limitsPreparationsConnection: LimitationLimitsPreparationsConnection;
  limitsTreatment: Array<Treatment>;
  limitsTreatmentsBySelf: Array<Treatment>;
  limitsTreatmentsBySelfAggregate?: Maybe<LimitationTreatmentLimitsTreatmentsBySelfAggregationSelection>;
  limitsTreatmentsBySelfConnection: LimitationLimitsTreatmentsBySelfConnection;
  limitsTreatmentsThroughPreparation: Array<Treatment>;
  limitsTreatmentsThroughPreparationAggregate?: Maybe<LimitationTreatmentLimitsTreatmentsThroughPreparationAggregationSelection>;
  limitsTreatmentsThroughPreparationConnection: LimitationLimitsTreatmentsThroughPreparationConnection;
  uuid: Scalars['ID']['output'];
};


export type LimitationAgreementTemplateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type LimitationAgreementTemplateAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type LimitationAgreementTemplateConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LimitationAgreementTemplateConnectionSort>>;
  where?: InputMaybe<LimitationAgreementTemplateConnectionWhere>;
};


export type LimitationLimitsPreparationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type LimitationLimitsPreparationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationWhere>;
};


export type LimitationLimitsPreparationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LimitationLimitsPreparationsConnectionSort>>;
  where?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
};


export type LimitationLimitsTreatmentsBySelfArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type LimitationLimitsTreatmentsBySelfAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type LimitationLimitsTreatmentsBySelfConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LimitationLimitsTreatmentsBySelfConnectionSort>>;
  where?: InputMaybe<LimitationLimitsTreatmentsBySelfConnectionWhere>;
};


export type LimitationLimitsTreatmentsThroughPreparationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type LimitationLimitsTreatmentsThroughPreparationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type LimitationLimitsTreatmentsThroughPreparationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LimitationLimitsTreatmentsThroughPreparationConnectionSort>>;
  where?: InputMaybe<LimitationLimitsTreatmentsThroughPreparationConnectionWhere>;
};

export type LimitationAgreementTemplateAggregateInput = {
  AND?: InputMaybe<Array<LimitationAgreementTemplateAggregateInput>>;
  NOT?: InputMaybe<LimitationAgreementTemplateAggregateInput>;
  OR?: InputMaybe<Array<LimitationAgreementTemplateAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LimitationAgreementTemplateNodeAggregationWhereInput>;
};

export type LimitationAgreementTemplateAgreementTemplateAggregationSelection = {
  __typename?: 'LimitationAgreementTemplateAgreementTemplateAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LimitationAgreementTemplateAgreementTemplateNodeAggregateSelection>;
};

export type LimitationAgreementTemplateAgreementTemplateNodeAggregateSelection = {
  __typename?: 'LimitationAgreementTemplateAgreementTemplateNodeAggregateSelection';
  addedByName: StringAggregateSelectionNullable;
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  treatments: StringAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type LimitationAgreementTemplateConnection = {
  __typename?: 'LimitationAgreementTemplateConnection';
  edges: Array<LimitationAgreementTemplateRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LimitationAgreementTemplateConnectionSort = {
  node?: InputMaybe<AgreementTemplateSort>;
};

export type LimitationAgreementTemplateConnectionWhere = {
  AND?: InputMaybe<Array<LimitationAgreementTemplateConnectionWhere>>;
  NOT?: InputMaybe<LimitationAgreementTemplateConnectionWhere>;
  OR?: InputMaybe<Array<LimitationAgreementTemplateConnectionWhere>>;
  node?: InputMaybe<AgreementTemplateWhere>;
};

export type LimitationAgreementTemplateNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LimitationAgreementTemplateNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LimitationAgreementTemplateNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LimitationAgreementTemplateNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LimitationAgreementTemplateRelationship = {
  __typename?: 'LimitationAgreementTemplateRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type LimitationEdge = {
  __typename?: 'LimitationEdge';
  cursor: Scalars['String']['output'];
  node: Limitation;
};

export type LimitationLimitsPreparationsAggregateInput = {
  AND?: InputMaybe<Array<LimitationLimitsPreparationsAggregateInput>>;
  NOT?: InputMaybe<LimitationLimitsPreparationsAggregateInput>;
  OR?: InputMaybe<Array<LimitationLimitsPreparationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LimitationLimitsPreparationsNodeAggregationWhereInput>;
};

export type LimitationLimitsPreparationsConnection = {
  __typename?: 'LimitationLimitsPreparationsConnection';
  edges: Array<LimitationLimitsPreparationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LimitationLimitsPreparationsConnectionSort = {
  node?: InputMaybe<PreparationSort>;
};

export type LimitationLimitsPreparationsConnectionWhere = {
  AND?: InputMaybe<Array<LimitationLimitsPreparationsConnectionWhere>>;
  NOT?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
  OR?: InputMaybe<Array<LimitationLimitsPreparationsConnectionWhere>>;
  node?: InputMaybe<PreparationWhere>;
};

export type LimitationLimitsPreparationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LimitationLimitsPreparationsNodeAggregationWhereInput>>;
  AtcCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<LimitationLimitsPreparationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LimitationLimitsPreparationsNodeAggregationWhereInput>>;
  SwissmedicNo5_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LimitationLimitsPreparationsRelationship = {
  __typename?: 'LimitationLimitsPreparationsRelationship';
  cursor: Scalars['String']['output'];
  node: Preparation;
};

export type LimitationLimitsTreatmentsBySelfAggregateInput = {
  AND?: InputMaybe<Array<LimitationLimitsTreatmentsBySelfAggregateInput>>;
  NOT?: InputMaybe<LimitationLimitsTreatmentsBySelfAggregateInput>;
  OR?: InputMaybe<Array<LimitationLimitsTreatmentsBySelfAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LimitationLimitsTreatmentsBySelfNodeAggregationWhereInput>;
};

export type LimitationLimitsTreatmentsBySelfConnection = {
  __typename?: 'LimitationLimitsTreatmentsBySelfConnection';
  edges: Array<LimitationLimitsTreatmentsBySelfRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LimitationLimitsTreatmentsBySelfConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type LimitationLimitsTreatmentsBySelfConnectionWhere = {
  AND?: InputMaybe<Array<LimitationLimitsTreatmentsBySelfConnectionWhere>>;
  NOT?: InputMaybe<LimitationLimitsTreatmentsBySelfConnectionWhere>;
  OR?: InputMaybe<Array<LimitationLimitsTreatmentsBySelfConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type LimitationLimitsTreatmentsBySelfNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LimitationLimitsTreatmentsBySelfNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<LimitationLimitsTreatmentsBySelfNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<LimitationLimitsTreatmentsBySelfNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LimitationLimitsTreatmentsBySelfRelationship = {
  __typename?: 'LimitationLimitsTreatmentsBySelfRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type LimitationLimitsTreatmentsThroughPreparationAggregateInput = {
  AND?: InputMaybe<Array<LimitationLimitsTreatmentsThroughPreparationAggregateInput>>;
  NOT?: InputMaybe<LimitationLimitsTreatmentsThroughPreparationAggregateInput>;
  OR?: InputMaybe<Array<LimitationLimitsTreatmentsThroughPreparationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LimitationLimitsTreatmentsThroughPreparationNodeAggregationWhereInput>;
};

export type LimitationLimitsTreatmentsThroughPreparationConnection = {
  __typename?: 'LimitationLimitsTreatmentsThroughPreparationConnection';
  edges: Array<LimitationLimitsTreatmentsThroughPreparationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LimitationLimitsTreatmentsThroughPreparationConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type LimitationLimitsTreatmentsThroughPreparationConnectionWhere = {
  AND?: InputMaybe<Array<LimitationLimitsTreatmentsThroughPreparationConnectionWhere>>;
  NOT?: InputMaybe<LimitationLimitsTreatmentsThroughPreparationConnectionWhere>;
  OR?: InputMaybe<Array<LimitationLimitsTreatmentsThroughPreparationConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type LimitationLimitsTreatmentsThroughPreparationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LimitationLimitsTreatmentsThroughPreparationNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<LimitationLimitsTreatmentsThroughPreparationNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<LimitationLimitsTreatmentsThroughPreparationNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LimitationLimitsTreatmentsThroughPreparationRelationship = {
  __typename?: 'LimitationLimitsTreatmentsThroughPreparationRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type LimitationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LimitationSort objects to sort Limitations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LimitationSort>>;
};

export type LimitationPreparationLimitsPreparationsAggregationSelection = {
  __typename?: 'LimitationPreparationLimitsPreparationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LimitationPreparationLimitsPreparationsNodeAggregateSelection>;
};

export type LimitationPreparationLimitsPreparationsNodeAggregateSelection = {
  __typename?: 'LimitationPreparationLimitsPreparationsNodeAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

/** Fields to sort Limitations by. The order in which sorts are applied is not guaranteed when specifying many fields in one LimitationSort object. */
export type LimitationSort = {
  Code?: InputMaybe<SortDirection>;
  DescriptionDe?: InputMaybe<SortDirection>;
  DescriptionEn?: InputMaybe<SortDirection>;
  DescriptionFr?: InputMaybe<SortDirection>;
  DescriptionIt?: InputMaybe<SortDirection>;
  HasPriceModel?: InputMaybe<SortDirection>;
  Niveau?: InputMaybe<SortDirection>;
  Type?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
  ValidThruDate?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  isClassified?: InputMaybe<SortDirection>;
  isValidFromDateSetByImportDate?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type LimitationTreatmentLimitsTreatmentsBySelfAggregationSelection = {
  __typename?: 'LimitationTreatmentLimitsTreatmentsBySelfAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LimitationTreatmentLimitsTreatmentsBySelfNodeAggregateSelection>;
};

export type LimitationTreatmentLimitsTreatmentsBySelfNodeAggregateSelection = {
  __typename?: 'LimitationTreatmentLimitsTreatmentsBySelfNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type LimitationTreatmentLimitsTreatmentsThroughPreparationAggregationSelection = {
  __typename?: 'LimitationTreatmentLimitsTreatmentsThroughPreparationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LimitationTreatmentLimitsTreatmentsThroughPreparationNodeAggregateSelection>;
};

export type LimitationTreatmentLimitsTreatmentsThroughPreparationNodeAggregateSelection = {
  __typename?: 'LimitationTreatmentLimitsTreatmentsThroughPreparationNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type LimitationWhere = {
  AND?: InputMaybe<Array<LimitationWhere>>;
  Code?: InputMaybe<Scalars['String']['input']>;
  Code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Code_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  DescriptionDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionEn?: InputMaybe<Scalars['String']['input']>;
  DescriptionEn_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DescriptionEn_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionEn_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  DescriptionEn_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DescriptionEn_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  DescriptionFr_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  DescriptionIt_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  HasPriceModel?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<LimitationWhere>;
  Niveau?: InputMaybe<Scalars['String']['input']>;
  Niveau_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Niveau_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Niveau_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Niveau_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Niveau_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  OR?: InputMaybe<Array<LimitationWhere>>;
  Type?: InputMaybe<Scalars['String']['input']>;
  Type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Type_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidThruDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  agreementTemplate?: InputMaybe<AgreementTemplateWhere>;
  agreementTemplateAggregate?: InputMaybe<LimitationAgreementTemplateAggregateInput>;
  agreementTemplateConnection?: InputMaybe<LimitationAgreementTemplateConnectionWhere>;
  agreementTemplateConnection_NOT?: InputMaybe<LimitationAgreementTemplateConnectionWhere>;
  agreementTemplate_NOT?: InputMaybe<AgreementTemplateWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  isClassified?: InputMaybe<Scalars['Boolean']['input']>;
  isValidFromDateSetByImportDate?: InputMaybe<Scalars['Boolean']['input']>;
  limitsPreparationsAggregate?: InputMaybe<LimitationLimitsPreparationsAggregateInput>;
  /** Return Limitations where all of the related LimitationLimitsPreparationsConnections match this filter */
  limitsPreparationsConnection_ALL?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
  /** Return Limitations where none of the related LimitationLimitsPreparationsConnections match this filter */
  limitsPreparationsConnection_NONE?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
  /** Return Limitations where one of the related LimitationLimitsPreparationsConnections match this filter */
  limitsPreparationsConnection_SINGLE?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
  /** Return Limitations where some of the related LimitationLimitsPreparationsConnections match this filter */
  limitsPreparationsConnection_SOME?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
  /** Return Limitations where all of the related Preparations match this filter */
  limitsPreparations_ALL?: InputMaybe<PreparationWhere>;
  /** Return Limitations where none of the related Preparations match this filter */
  limitsPreparations_NONE?: InputMaybe<PreparationWhere>;
  /** Return Limitations where one of the related Preparations match this filter */
  limitsPreparations_SINGLE?: InputMaybe<PreparationWhere>;
  /** Return Limitations where some of the related Preparations match this filter */
  limitsPreparations_SOME?: InputMaybe<PreparationWhere>;
  limitsTreatmentsBySelfAggregate?: InputMaybe<LimitationLimitsTreatmentsBySelfAggregateInput>;
  /** Return Limitations where all of the related LimitationLimitsTreatmentsBySelfConnections match this filter */
  limitsTreatmentsBySelfConnection_ALL?: InputMaybe<LimitationLimitsTreatmentsBySelfConnectionWhere>;
  /** Return Limitations where none of the related LimitationLimitsTreatmentsBySelfConnections match this filter */
  limitsTreatmentsBySelfConnection_NONE?: InputMaybe<LimitationLimitsTreatmentsBySelfConnectionWhere>;
  /** Return Limitations where one of the related LimitationLimitsTreatmentsBySelfConnections match this filter */
  limitsTreatmentsBySelfConnection_SINGLE?: InputMaybe<LimitationLimitsTreatmentsBySelfConnectionWhere>;
  /** Return Limitations where some of the related LimitationLimitsTreatmentsBySelfConnections match this filter */
  limitsTreatmentsBySelfConnection_SOME?: InputMaybe<LimitationLimitsTreatmentsBySelfConnectionWhere>;
  /** Return Limitations where all of the related Treatments match this filter */
  limitsTreatmentsBySelf_ALL?: InputMaybe<TreatmentWhere>;
  /** Return Limitations where none of the related Treatments match this filter */
  limitsTreatmentsBySelf_NONE?: InputMaybe<TreatmentWhere>;
  /** Return Limitations where one of the related Treatments match this filter */
  limitsTreatmentsBySelf_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return Limitations where some of the related Treatments match this filter */
  limitsTreatmentsBySelf_SOME?: InputMaybe<TreatmentWhere>;
  limitsTreatmentsThroughPreparationAggregate?: InputMaybe<LimitationLimitsTreatmentsThroughPreparationAggregateInput>;
  /** Return Limitations where all of the related LimitationLimitsTreatmentsThroughPreparationConnections match this filter */
  limitsTreatmentsThroughPreparationConnection_ALL?: InputMaybe<LimitationLimitsTreatmentsThroughPreparationConnectionWhere>;
  /** Return Limitations where none of the related LimitationLimitsTreatmentsThroughPreparationConnections match this filter */
  limitsTreatmentsThroughPreparationConnection_NONE?: InputMaybe<LimitationLimitsTreatmentsThroughPreparationConnectionWhere>;
  /** Return Limitations where one of the related LimitationLimitsTreatmentsThroughPreparationConnections match this filter */
  limitsTreatmentsThroughPreparationConnection_SINGLE?: InputMaybe<LimitationLimitsTreatmentsThroughPreparationConnectionWhere>;
  /** Return Limitations where some of the related LimitationLimitsTreatmentsThroughPreparationConnections match this filter */
  limitsTreatmentsThroughPreparationConnection_SOME?: InputMaybe<LimitationLimitsTreatmentsThroughPreparationConnectionWhere>;
  /** Return Limitations where all of the related Treatments match this filter */
  limitsTreatmentsThroughPreparation_ALL?: InputMaybe<TreatmentWhere>;
  /** Return Limitations where none of the related Treatments match this filter */
  limitsTreatmentsThroughPreparation_NONE?: InputMaybe<TreatmentWhere>;
  /** Return Limitations where one of the related Treatments match this filter */
  limitsTreatmentsThroughPreparation_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return Limitations where some of the related Treatments match this filter */
  limitsTreatmentsThroughPreparation_SOME?: InputMaybe<TreatmentWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type LimitationsConnection = {
  __typename?: 'LimitationsConnection';
  edges: Array<LimitationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocalizationKeySuggestions = {
  __typename?: 'LocalizationKeySuggestions';
  localizationKeys: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type LocalizationKeySuggestionsConnection = {
  __typename?: 'LocalizationKeySuggestionsConnection';
  edges: Array<LocalizationKeySuggestionsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocalizationKeySuggestionsEdge = {
  __typename?: 'LocalizationKeySuggestionsEdge';
  cursor: Scalars['String']['output'];
  node: LocalizationKeySuggestions;
};

export type LocalizationKeySuggestionsOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LocalizationKeySuggestionsSort objects to sort LocalizationKeySuggestions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LocalizationKeySuggestionsSort>>;
};

/** Fields to sort LocalizationKeySuggestions by. The order in which sorts are applied is not guaranteed when specifying many fields in one LocalizationKeySuggestionsSort object. */
export type LocalizationKeySuggestionsSort = {
  name?: InputMaybe<SortDirection>;
};

export type LocalizationKeySuggestionsWhere = {
  AND?: InputMaybe<Array<LocalizationKeySuggestionsWhere>>;
  NOT?: InputMaybe<LocalizationKeySuggestionsWhere>;
  OR?: InputMaybe<Array<LocalizationKeySuggestionsWhere>>;
  localizationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  localizationKeys_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export enum LockType {
  CoreCacheClean = 'CORE_CACHE_CLEAN',
  DocumentAutoReminder = 'DOCUMENT_AUTO_REMINDER',
  LibraryCacheClean = 'LIBRARY_CACHE_CLEAN',
  QuestAutoCompletion = 'QUEST_AUTO_COMPLETION',
  RunDataQualityChecks = 'RUN_DATA_QUALITY_CHECKS',
  SimulatorMigration = 'SIMULATOR_MIGRATION'
}

export type MainIndication = {
  __typename?: 'MainIndication';
  article71Indication: Article71Indication;
  article71IndicationAggregate?: Maybe<MainIndicationArticle71IndicationArticle71IndicationAggregationSelection>;
  article71IndicationConnection: MainIndicationArticle71IndicationConnection;
  brand: Brand;
  brandAggregate?: Maybe<MainIndicationBrandBrandAggregationSelection>;
  brandConnection: MainIndicationBrandConnection;
  createdOn: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedOn: Scalars['DateTime']['output'];
  validFromDate?: Maybe<Scalars['Date']['output']>;
  validToDate?: Maybe<Scalars['Date']['output']>;
};


export type MainIndicationArticle71IndicationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Article71IndicationOptions>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type MainIndicationArticle71IndicationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type MainIndicationArticle71IndicationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MainIndicationArticle71IndicationConnectionSort>>;
  where?: InputMaybe<MainIndicationArticle71IndicationConnectionWhere>;
};


export type MainIndicationBrandArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type MainIndicationBrandAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type MainIndicationBrandConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MainIndicationBrandConnectionSort>>;
  where?: InputMaybe<MainIndicationBrandConnectionWhere>;
};

export type MainIndicationArticle71IndicationAggregateInput = {
  AND?: InputMaybe<Array<MainIndicationArticle71IndicationAggregateInput>>;
  NOT?: InputMaybe<MainIndicationArticle71IndicationAggregateInput>;
  OR?: InputMaybe<Array<MainIndicationArticle71IndicationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MainIndicationArticle71IndicationNodeAggregationWhereInput>;
};

export type MainIndicationArticle71IndicationArticle71IndicationAggregationSelection = {
  __typename?: 'MainIndicationArticle71IndicationArticle71IndicationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection>;
};

export type MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection = {
  __typename?: 'MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection';
  countryScopeId: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  notes: StringAggregateSelectionNullable;
};

export type MainIndicationArticle71IndicationConnection = {
  __typename?: 'MainIndicationArticle71IndicationConnection';
  edges: Array<MainIndicationArticle71IndicationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MainIndicationArticle71IndicationConnectionSort = {
  node?: InputMaybe<Article71IndicationSort>;
};

export type MainIndicationArticle71IndicationConnectionWhere = {
  AND?: InputMaybe<Array<MainIndicationArticle71IndicationConnectionWhere>>;
  NOT?: InputMaybe<MainIndicationArticle71IndicationConnectionWhere>;
  OR?: InputMaybe<Array<MainIndicationArticle71IndicationConnectionWhere>>;
  node?: InputMaybe<Article71IndicationWhere>;
};

export type MainIndicationArticle71IndicationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MainIndicationArticle71IndicationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MainIndicationArticle71IndicationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MainIndicationArticle71IndicationNodeAggregationWhereInput>>;
  countryScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  notes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MainIndicationArticle71IndicationRelationship = {
  __typename?: 'MainIndicationArticle71IndicationRelationship';
  cursor: Scalars['String']['output'];
  node: Article71Indication;
};

export type MainIndicationBrandAggregateInput = {
  AND?: InputMaybe<Array<MainIndicationBrandAggregateInput>>;
  NOT?: InputMaybe<MainIndicationBrandAggregateInput>;
  OR?: InputMaybe<Array<MainIndicationBrandAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MainIndicationBrandNodeAggregationWhereInput>;
};

export type MainIndicationBrandBrandAggregationSelection = {
  __typename?: 'MainIndicationBrandBrandAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<MainIndicationBrandBrandNodeAggregateSelection>;
};

export type MainIndicationBrandBrandNodeAggregateSelection = {
  __typename?: 'MainIndicationBrandBrandNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type MainIndicationBrandConnection = {
  __typename?: 'MainIndicationBrandConnection';
  edges: Array<MainIndicationBrandRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MainIndicationBrandConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type MainIndicationBrandConnectionWhere = {
  AND?: InputMaybe<Array<MainIndicationBrandConnectionWhere>>;
  NOT?: InputMaybe<MainIndicationBrandConnectionWhere>;
  OR?: InputMaybe<Array<MainIndicationBrandConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type MainIndicationBrandNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MainIndicationBrandNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MainIndicationBrandNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<MainIndicationBrandNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MainIndicationBrandRelationship = {
  __typename?: 'MainIndicationBrandRelationship';
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type MainIndicationEdge = {
  __typename?: 'MainIndicationEdge';
  cursor: Scalars['String']['output'];
  node: MainIndication;
};

export type MainIndicationInput = {
  article71IndicationId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isToBeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  validFromDate?: InputMaybe<Scalars['Date']['input']>;
  validToDate?: InputMaybe<Scalars['Date']['input']>;
};

export type MainIndicationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MainIndicationSort objects to sort MainIndications by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MainIndicationSort>>;
};

/** Fields to sort MainIndications by. The order in which sorts are applied is not guaranteed when specifying many fields in one MainIndicationSort object. */
export type MainIndicationSort = {
  createdOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  validFromDate?: InputMaybe<SortDirection>;
  validToDate?: InputMaybe<SortDirection>;
};

export type MainIndicationWhere = {
  AND?: InputMaybe<Array<MainIndicationWhere>>;
  NOT?: InputMaybe<MainIndicationWhere>;
  OR?: InputMaybe<Array<MainIndicationWhere>>;
  article71Indication?: InputMaybe<Article71IndicationWhere>;
  article71IndicationAggregate?: InputMaybe<MainIndicationArticle71IndicationAggregateInput>;
  article71IndicationConnection?: InputMaybe<MainIndicationArticle71IndicationConnectionWhere>;
  article71IndicationConnection_NOT?: InputMaybe<MainIndicationArticle71IndicationConnectionWhere>;
  article71Indication_NOT?: InputMaybe<Article71IndicationWhere>;
  brand?: InputMaybe<BrandWhere>;
  brandAggregate?: InputMaybe<MainIndicationBrandAggregateInput>;
  brandConnection?: InputMaybe<MainIndicationBrandConnectionWhere>;
  brandConnection_NOT?: InputMaybe<MainIndicationBrandConnectionWhere>;
  brand_NOT?: InputMaybe<BrandWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  validFromDate?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type MainIndicationsConnection = {
  __typename?: 'MainIndicationsConnection';
  edges: Array<MainIndicationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum MasterDataCreationWay {
  Imported = 'IMPORTED',
  ManualEntry = 'MANUAL_ENTRY'
}

export type MasterDataRefundImpact = {
  __typename?: 'MasterDataRefundImpact';
  agreementVersion?: Maybe<Scalars['Int']['output']>;
  documentCreator?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  documentReviewer?: Maybe<Scalars['String']['output']>;
  refundId: Scalars['String']['output'];
};

export type MasterDataRefundImpactEdge = {
  __typename?: 'MasterDataRefundImpactEdge';
  cursor: Scalars['String']['output'];
  node: MasterDataRefundImpact;
};

export type MasterDataRefundImpactOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MasterDataRefundImpactSort objects to sort MasterDataRefundImpacts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MasterDataRefundImpactSort>>;
};

/** Fields to sort MasterDataRefundImpacts by. The order in which sorts are applied is not guaranteed when specifying many fields in one MasterDataRefundImpactSort object. */
export type MasterDataRefundImpactSort = {
  agreementVersion?: InputMaybe<SortDirection>;
  documentCreator?: InputMaybe<SortDirection>;
  documentId?: InputMaybe<SortDirection>;
  documentReviewer?: InputMaybe<SortDirection>;
  refundId?: InputMaybe<SortDirection>;
};

export type MasterDataRefundImpactWhere = {
  AND?: InputMaybe<Array<MasterDataRefundImpactWhere>>;
  NOT?: InputMaybe<MasterDataRefundImpactWhere>;
  OR?: InputMaybe<Array<MasterDataRefundImpactWhere>>;
  agreementVersion?: InputMaybe<Scalars['Int']['input']>;
  agreementVersion_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementVersion_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementVersion_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  agreementVersion_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementVersion_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentCreator?: InputMaybe<Scalars['String']['input']>;
  documentCreator_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentCreator_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentCreator_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentCreator_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentCreator_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReviewer?: InputMaybe<Scalars['String']['input']>;
  documentReviewer_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentReviewer_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReviewer_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentReviewer_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentReviewer_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  refundId?: InputMaybe<Scalars['String']['input']>;
  refundId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  refundId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  refundId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  refundId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  refundId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type MasterDataRefundImpactsConnection = {
  __typename?: 'MasterDataRefundImpactsConnection';
  edges: Array<MasterDataRefundImpactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MasterDataUploadHistoryRecord = {
  __typename?: 'MasterDataUploadHistoryRecord';
  confirmedBy?: Maybe<Scalars['String']['output']>;
  confirmedOn?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Scalars['String']['output']>;
  startedBy: Scalars['String']['output'];
  startedOn: Scalars['DateTime']['output'];
  status?: Maybe<MasterDataUploadStatus>;
};

export type MasterDataUploadHistoryRecordEdge = {
  __typename?: 'MasterDataUploadHistoryRecordEdge';
  cursor: Scalars['String']['output'];
  node: MasterDataUploadHistoryRecord;
};

export type MasterDataUploadHistoryRecordOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MasterDataUploadHistoryRecordSort objects to sort MasterDataUploadHistoryRecords by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MasterDataUploadHistoryRecordSort>>;
};

/** Fields to sort MasterDataUploadHistoryRecords by. The order in which sorts are applied is not guaranteed when specifying many fields in one MasterDataUploadHistoryRecordSort object. */
export type MasterDataUploadHistoryRecordSort = {
  confirmedBy?: InputMaybe<SortDirection>;
  confirmedOn?: InputMaybe<SortDirection>;
  error?: InputMaybe<SortDirection>;
  report?: InputMaybe<SortDirection>;
  startedBy?: InputMaybe<SortDirection>;
  startedOn?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type MasterDataUploadHistoryRecordWhere = {
  AND?: InputMaybe<Array<MasterDataUploadHistoryRecordWhere>>;
  NOT?: InputMaybe<MasterDataUploadHistoryRecordWhere>;
  OR?: InputMaybe<Array<MasterDataUploadHistoryRecordWhere>>;
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
  confirmedBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  confirmedBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  confirmedBy_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmedBy_MATCHES?: InputMaybe<Scalars['String']['input']>;
  confirmedBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  confirmedOn?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  confirmedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  error_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  error_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  error_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  error_MATCHES?: InputMaybe<Scalars['String']['input']>;
  error_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['String']['input']>;
  report_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  report_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  report_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  report_MATCHES?: InputMaybe<Scalars['String']['input']>;
  report_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  startedBy?: InputMaybe<Scalars['String']['input']>;
  startedBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  startedBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  startedBy_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  startedBy_MATCHES?: InputMaybe<Scalars['String']['input']>;
  startedBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  startedOn?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<MasterDataUploadStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<MasterDataUploadStatus>>>;
};

export type MasterDataUploadHistoryRecordsConnection = {
  __typename?: 'MasterDataUploadHistoryRecordsConnection';
  edges: Array<MasterDataUploadHistoryRecordEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum MasterDataUploadStatus {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Ongoing = 'ONGOING'
}

export type Message = {
  __typename?: 'Message';
  case: Case;
  caseAggregate?: Maybe<MessageCaseCaseAggregationSelection>;
  caseConnection: MessageCaseConnection;
  content?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['Float']['output']>;
  mentions: Array<User>;
  mentionsAggregate?: Maybe<MessageUserMentionsAggregationSelection>;
  mentionsConnection: MessageMentionsConnection;
  sentBy: User;
  sentByAggregate?: Maybe<MessageUserSentByAggregationSelection>;
  sentByConnection: MessageSentByConnection;
  tenantIds: Array<Scalars['String']['output']>;
};


export type MessageCaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type MessageCaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type MessageCaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageCaseConnectionSort>>;
  where?: InputMaybe<MessageCaseConnectionWhere>;
};


export type MessageMentionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type MessageMentionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type MessageMentionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageMentionsConnectionSort>>;
  where?: InputMaybe<MessageMentionsConnectionWhere>;
};


export type MessageSentByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type MessageSentByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type MessageSentByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageSentByConnectionSort>>;
  where?: InputMaybe<MessageSentByConnectionWhere>;
};

export type MessageCaseAggregateInput = {
  AND?: InputMaybe<Array<MessageCaseAggregateInput>>;
  NOT?: InputMaybe<MessageCaseAggregateInput>;
  OR?: InputMaybe<Array<MessageCaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MessageCaseNodeAggregationWhereInput>;
};

export type MessageCaseCaseAggregationSelection = {
  __typename?: 'MessageCaseCaseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<MessageCaseCaseNodeAggregateSelection>;
};

export type MessageCaseCaseNodeAggregateSelection = {
  __typename?: 'MessageCaseCaseNodeAggregateSelection';
  creationDate: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
};

export type MessageCaseConnection = {
  __typename?: 'MessageCaseConnection';
  edges: Array<MessageCaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageCaseConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type MessageCaseConnectionWhere = {
  AND?: InputMaybe<Array<MessageCaseConnectionWhere>>;
  NOT?: InputMaybe<MessageCaseConnectionWhere>;
  OR?: InputMaybe<Array<MessageCaseConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type MessageCaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageCaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageCaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageCaseNodeAggregationWhereInput>>;
  creationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MessageCaseRelationship = {
  __typename?: 'MessageCaseRelationship';
  cursor: Scalars['String']['output'];
  node: Case;
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor: Scalars['String']['output'];
  node: Message;
};

export type MessageMentionsAggregateInput = {
  AND?: InputMaybe<Array<MessageMentionsAggregateInput>>;
  NOT?: InputMaybe<MessageMentionsAggregateInput>;
  OR?: InputMaybe<Array<MessageMentionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MessageMentionsNodeAggregationWhereInput>;
};

export type MessageMentionsConnection = {
  __typename?: 'MessageMentionsConnection';
  edges: Array<MessageMentionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageMentionsConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type MessageMentionsConnectionWhere = {
  AND?: InputMaybe<Array<MessageMentionsConnectionWhere>>;
  NOT?: InputMaybe<MessageMentionsConnectionWhere>;
  OR?: InputMaybe<Array<MessageMentionsConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type MessageMentionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageMentionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageMentionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageMentionsNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageMentionsRelationship = {
  __typename?: 'MessageMentionsRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type MessageOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MessageSort objects to sort Messages by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MessageSort>>;
};

export type MessageSentByAggregateInput = {
  AND?: InputMaybe<Array<MessageSentByAggregateInput>>;
  NOT?: InputMaybe<MessageSentByAggregateInput>;
  OR?: InputMaybe<Array<MessageSentByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MessageSentByNodeAggregationWhereInput>;
};

export type MessageSentByConnection = {
  __typename?: 'MessageSentByConnection';
  edges: Array<MessageSentByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageSentByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type MessageSentByConnectionWhere = {
  AND?: InputMaybe<Array<MessageSentByConnectionWhere>>;
  NOT?: InputMaybe<MessageSentByConnectionWhere>;
  OR?: InputMaybe<Array<MessageSentByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type MessageSentByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageSentByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageSentByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageSentByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageSentByRelationship = {
  __typename?: 'MessageSentByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

/** Fields to sort Messages by. The order in which sorts are applied is not guaranteed when specifying many fields in one MessageSort object. */
export type MessageSort = {
  content?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
};

export type MessageUserMentionsAggregationSelection = {
  __typename?: 'MessageUserMentionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<MessageUserMentionsNodeAggregateSelection>;
};

export type MessageUserMentionsNodeAggregateSelection = {
  __typename?: 'MessageUserMentionsNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type MessageUserSentByAggregationSelection = {
  __typename?: 'MessageUserSentByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<MessageUserSentByNodeAggregateSelection>;
};

export type MessageUserSentByNodeAggregateSelection = {
  __typename?: 'MessageUserSentByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type MessageWhere = {
  AND?: InputMaybe<Array<MessageWhere>>;
  NOT?: InputMaybe<MessageWhere>;
  OR?: InputMaybe<Array<MessageWhere>>;
  case?: InputMaybe<CaseWhere>;
  caseAggregate?: InputMaybe<MessageCaseAggregateInput>;
  caseConnection?: InputMaybe<MessageCaseConnectionWhere>;
  caseConnection_NOT?: InputMaybe<MessageCaseConnectionWhere>;
  case_NOT?: InputMaybe<CaseWhere>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  content_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  content_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_MATCHES?: InputMaybe<Scalars['String']['input']>;
  content_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdOn_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  mentionsAggregate?: InputMaybe<MessageMentionsAggregateInput>;
  /** Return Messages where all of the related MessageMentionsConnections match this filter */
  mentionsConnection_ALL?: InputMaybe<MessageMentionsConnectionWhere>;
  /** Return Messages where none of the related MessageMentionsConnections match this filter */
  mentionsConnection_NONE?: InputMaybe<MessageMentionsConnectionWhere>;
  /** Return Messages where one of the related MessageMentionsConnections match this filter */
  mentionsConnection_SINGLE?: InputMaybe<MessageMentionsConnectionWhere>;
  /** Return Messages where some of the related MessageMentionsConnections match this filter */
  mentionsConnection_SOME?: InputMaybe<MessageMentionsConnectionWhere>;
  /** Return Messages where all of the related Users match this filter */
  mentions_ALL?: InputMaybe<UserWhere>;
  /** Return Messages where none of the related Users match this filter */
  mentions_NONE?: InputMaybe<UserWhere>;
  /** Return Messages where one of the related Users match this filter */
  mentions_SINGLE?: InputMaybe<UserWhere>;
  /** Return Messages where some of the related Users match this filter */
  mentions_SOME?: InputMaybe<UserWhere>;
  sentBy?: InputMaybe<UserWhere>;
  sentByAggregate?: InputMaybe<MessageSentByAggregateInput>;
  sentByConnection?: InputMaybe<MessageSentByConnectionWhere>;
  sentByConnection_NOT?: InputMaybe<MessageSentByConnectionWhere>;
  sentBy_NOT?: InputMaybe<UserWhere>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type MessagesConnection = {
  __typename?: 'MessagesConnection';
  edges: Array<MessageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MissingTranslationKeys = {
  __typename?: 'MissingTranslationKeys';
  key: Scalars['String']['output'];
  language: Scalars['String']['output'];
  serverEnvironment: Scalars['String']['output'];
  source: Scalars['String']['output'];
  timeStamp?: Maybe<Scalars['Float']['output']>;
};

export type MissingTranslationKeysConnection = {
  __typename?: 'MissingTranslationKeysConnection';
  edges: Array<MissingTranslationKeysEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MissingTranslationKeysEdge = {
  __typename?: 'MissingTranslationKeysEdge';
  cursor: Scalars['String']['output'];
  node: MissingTranslationKeys;
};

export type MissingTranslationKeysOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MissingTranslationKeysSort objects to sort MissingTranslationKeys by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MissingTranslationKeysSort>>;
};

/** Fields to sort MissingTranslationKeys by. The order in which sorts are applied is not guaranteed when specifying many fields in one MissingTranslationKeysSort object. */
export type MissingTranslationKeysSort = {
  key?: InputMaybe<SortDirection>;
  language?: InputMaybe<SortDirection>;
  serverEnvironment?: InputMaybe<SortDirection>;
  source?: InputMaybe<SortDirection>;
  timeStamp?: InputMaybe<SortDirection>;
};

export type MissingTranslationKeysWhere = {
  AND?: InputMaybe<Array<MissingTranslationKeysWhere>>;
  NOT?: InputMaybe<MissingTranslationKeysWhere>;
  OR?: InputMaybe<Array<MissingTranslationKeysWhere>>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  key_MATCHES?: InputMaybe<Scalars['String']['input']>;
  key_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  language_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  language_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  language_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  language_MATCHES?: InputMaybe<Scalars['String']['input']>;
  language_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  serverEnvironment?: InputMaybe<Scalars['String']['input']>;
  serverEnvironment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  serverEnvironment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  serverEnvironment_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  serverEnvironment_MATCHES?: InputMaybe<Scalars['String']['input']>;
  serverEnvironment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  source_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  source_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  source_MATCHES?: InputMaybe<Scalars['String']['input']>;
  source_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeStamp?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_GT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  timeStamp_LT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type Module = {
  __typename?: 'Module';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ModuleEdge = {
  __typename?: 'ModuleEdge';
  cursor: Scalars['String']['output'];
  node: Module;
};

export type ModuleInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type ModuleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ModuleSort objects to sort Modules by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ModuleSort>>;
};

/** Fields to sort Modules by. The order in which sorts are applied is not guaranteed when specifying many fields in one ModuleSort object. */
export type ModuleSort = {
  code?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type ModuleWhere = {
  AND?: InputMaybe<Array<ModuleWhere>>;
  NOT?: InputMaybe<ModuleWhere>;
  OR?: InputMaybe<Array<ModuleWhere>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_GT?: InputMaybe<Scalars['Int']['input']>;
  id_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ModulesConnection = {
  __typename?: 'ModulesConnection';
  edges: Array<ModuleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum MonitoringType {
  ChangedBetween = 'CHANGED_BETWEEN'
}

export type Mutation = {
  __typename?: 'Mutation';
  AddModule?: Maybe<Scalars['Boolean']['output']>;
  AddTranslations?: Maybe<Scalars['Boolean']['output']>;
  AddUserSubscribed?: Maybe<Scalars['Int']['output']>;
  ApplyDefaultUserRolesToAll?: Maybe<Scalars['Boolean']['output']>;
  ArchiveFlexEntity: FlexEntity;
  AssignUserDomains?: Maybe<Scalars['String']['output']>;
  CancelBagUpload?: Maybe<Scalars['Int']['output']>;
  CancelIntegrityChecks?: Maybe<Scalars['Int']['output']>;
  CheckSyncAgreements: Array<SyncResponse>;
  CreateApiKey?: Maybe<Scalars['String']['output']>;
  CreateDocument?: Maybe<Scalars['String']['output']>;
  CreateNewTermAndPolicyVersion: PolicyVersion;
  CreateOrUpdateBrandIndications?: Maybe<Brand>;
  CreateOrUpdateFlexQuery: QueryResult;
  CreateOrUpdateGeneric?: Maybe<Generic>;
  CreateOrUpdatePerformanceCounters?: Maybe<Scalars['Int']['output']>;
  CreateOrUpdateProductBlueprint: ProductBlueprint;
  CreateOrganization?: Maybe<AuthOrganization>;
  CreateSftpDirectory?: Maybe<Scalars['Int']['output']>;
  CreateUser?: Maybe<StoreUser>;
  DeleteAgreement?: Maybe<Scalars['Int']['output']>;
  DeleteCustomCondition?: Maybe<Scalars['Boolean']['output']>;
  DeleteDocument?: Maybe<Scalars['String']['output']>;
  DeleteFlexQuery?: Maybe<Scalars['Int']['output']>;
  DeleteGeneric?: Maybe<Generic>;
  DeleteSimulations?: Maybe<Scalars['Boolean']['output']>;
  DeleteTranslationKeys?: Maybe<Scalars['Boolean']['output']>;
  DeleteTranslationValue?: Maybe<Scalars['Boolean']['output']>;
  DeleteUser?: Maybe<StoreUser>;
  FlushAirtableCache?: Maybe<Scalars['Boolean']['output']>;
  FlushCoreChosenCache?: Maybe<Scalars['Int']['output']>;
  MigrateAllSimulatorData?: Maybe<Scalars['Boolean']['output']>;
  RefreshApiKey?: Maybe<Scalars['String']['output']>;
  ReleaseSimulatorMigrationLock?: Maybe<Scalars['Boolean']['output']>;
  RemoveModule?: Maybe<Scalars['Boolean']['output']>;
  RemoveSftpDirectory?: Maybe<Scalars['String']['output']>;
  RemoveTranslations?: Maybe<Scalars['Boolean']['output']>;
  RemoveUserSubscribed?: Maybe<Scalars['Int']['output']>;
  RemoveUsersFromValidityExpirationReminderNotification?: Maybe<Scalars['Int']['output']>;
  ResendUserRegEmail?: Maybe<Scalars['Boolean']['output']>;
  RevokeApiKey?: Maybe<Scalars['String']['output']>;
  RollbackSimulatorMigration?: Maybe<Scalars['Boolean']['output']>;
  RunAgreements?: Maybe<Scalars['Int']['output']>;
  RunDataCheck?: Maybe<Scalars['Int']['output']>;
  RunDataQualityChecks?: Maybe<Scalars['Boolean']['output']>;
  RunIntegrityChecks?: Maybe<Scalars['Int']['output']>;
  RunQuestAutoCompletion?: Maybe<Scalars['Int']['output']>;
  SaveAgreement: Agreement;
  SaveAgreementTemplate?: Maybe<AgreementTemplateVersionCreationResponse>;
  SaveAutoDocumentReviewReminderParams?: Maybe<Scalars['Int']['output']>;
  SaveAutoIssuanceParams?: Maybe<Scalars['Int']['output']>;
  SaveCustomIntegrityChecks?: Maybe<Scalars['String']['output']>;
  SaveDeviceAgreement?: Maybe<Agreement>;
  SaveDocumentSftpPath?: Maybe<Scalars['Int']['output']>;
  SaveEnabledSsoTypes?: Maybe<Scalars['Int']['output']>;
  SaveFlexEntity: FlexEntity;
  SaveNotifications?: Maybe<Scalars['Int']['output']>;
  SaveUploadLimitations?: Maybe<Scalars['Int']['output']>;
  SetAgreementHidden?: Maybe<Agreement>;
  SetAgreementRunTriggersFeature?: Maybe<Scalars['Int']['output']>;
  SetAgreementTemplateDeleted?: Maybe<AgreementTemplate>;
  SetAutomatedRunFrequencyFeature?: Maybe<Scalars['Int']['output']>;
  SetDownloadPublicAgreementFeature?: Maybe<Scalars['Int']['output']>;
  SetEmailEncryptionFeature?: Maybe<Scalars['Int']['output']>;
  SetLibraryGPTFeature?: Maybe<Scalars['Int']['output']>;
  SetMonitoring?: Maybe<Scalars['Int']['output']>;
  SetNavlinPricesFeature?: Maybe<Scalars['Int']['output']>;
  SetPerformanceThreshold?: Maybe<Scalars['Int']['output']>;
  SetPublicAgreementFeature?: Maybe<Scalars['Int']['output']>;
  SetSimulatorBreakdownFeature?: Maybe<Scalars['Int']['output']>;
  SetSimulatorModelValidityFeature?: Maybe<Scalars['Int']['output']>;
  SetSimulatorPVThresholdsFeature?: Maybe<Scalars['Int']['output']>;
  SetSimulatorProductInputFeature?: Maybe<Scalars['Int']['output']>;
  SetSimulatorWasteReportingFeature?: Maybe<Scalars['Int']['output']>;
  SetValidityCoverageFeature?: Maybe<Scalars['Int']['output']>;
  SetValueEncapsulatedFeatureUpdate?: Maybe<Scalars['Int']['output']>;
  StartBagUpload?: Maybe<Scalars['Int']['output']>;
  SubmitQuery: NinjaQuerySubmitResult;
  SubscribeUsersToValidityExpirationReminderNotification?: Maybe<Scalars['Int']['output']>;
  SyncAgreements?: Maybe<Scalars['Boolean']['output']>;
  UpdateAgreementCache?: Maybe<Scalars['Int']['output']>;
  UpdateAgreementName?: Maybe<Array<Maybe<Agreement>>>;
  UpdateAgreementScope?: Maybe<Scalars['Boolean']['output']>;
  UpdateAgreementUserRoles?: Maybe<Scalars['Boolean']['output']>;
  UpdateConditionSets?: Maybe<Scalars['Int']['output']>;
  UpdateCustomCondition?: Maybe<Scalars['Boolean']['output']>;
  UpdateDataChecksState?: Maybe<Scalars['Int']['output']>;
  UpdateDefaultUserRole?: Maybe<Scalars['Boolean']['output']>;
  UpdateEncapsulatedFeatureConfiguration?: Maybe<Scalars['Int']['output']>;
  UpdateIndication?: Maybe<Scalars['Boolean']['output']>;
  UpdateLegalEntities?: Maybe<Array<Maybe<Organization>>>;
  UpdateMasterLanguageTranslations?: Maybe<Scalars['Boolean']['output']>;
  UpdateMissingKey?: Maybe<Scalars['Boolean']['output']>;
  UpdateOrganization?: Maybe<AuthOrganization>;
  UpdateTranslation?: Maybe<Scalars['Boolean']['output']>;
  UpdateUser?: Maybe<StoreUser>;
  UpdateUserContextFiltersAgreements?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersBrandIndications?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersCountries?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersCustomConditions?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersFlexQueries?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersFlexibleFormsRecords?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersIndications?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersLocalization?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersMissingKeys?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersModels?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersPerformanceMeasurements?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersPerformanceProfiles?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersProductBlueprints?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersProducts?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersScopes?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersTermsAndPolicies?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersUsers?: Maybe<Scalars['Int']['output']>;
  UpdateUserRole?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAddModuleArgs = {
  id: Scalars['String']['input'];
  input?: InputMaybe<ModuleInput>;
  orgId: Scalars['String']['input'];
};


export type MutationAddTranslationsArgs = {
  orgId: Scalars['String']['input'];
  updatedLanguages?: InputMaybe<Array<InputMaybe<TranslationsInput>>>;
};


export type MutationAddUserSubscribedArgs = {
  notificationId: Scalars['Int']['input'];
  orgId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationApplyDefaultUserRolesToAllArgs = {
  input?: InputMaybe<ApplyUserRolesToAllInput>;
};


export type MutationArchiveFlexEntityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignUserDomainsArgs = {
  req?: InputMaybe<UserAssignDomainsInput>;
};


export type MutationCheckSyncAgreementsArgs = {
  agreementIds: Array<Scalars['String']['input']>;
  syncTypes: Array<SyncType>;
  templateId: Scalars['String']['input'];
};


export type MutationCreateApiKeyArgs = {
  owner: Scalars['String']['input'];
};


export type MutationCreateDocumentArgs = {
  createdByEmail: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  refundIds: Array<Scalars['ID']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationCreateNewTermAndPolicyVersionArgs = {
  input: TermsAndPoliciesInput;
};


export type MutationCreateOrUpdateBrandIndicationsArgs = {
  impacts?: InputMaybe<Array<Art71MasterDataImpactsInput>>;
  input: BrandInput;
};


export type MutationCreateOrUpdateFlexQueryArgs = {
  input: FlexQueryInput;
};


export type MutationCreateOrUpdateGenericArgs = {
  input: GenericInput;
};


export type MutationCreateOrUpdatePerformanceCountersArgs = {
  input: Array<PerformanceCounterInput>;
};


export type MutationCreateOrUpdateProductBlueprintArgs = {
  input: VasProductBlueprintInput;
};


export type MutationCreateOrganizationArgs = {
  BIC?: InputMaybe<Scalars['String']['input']>;
  IBAN?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  agreementRunTriggers: Array<AgreementRunTrigger>;
  automatedRunFrequency?: InputMaybe<AgreementRunFrequency>;
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<ContactPersonInput>;
  country: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  domicile?: InputMaybe<Scalars['String']['input']>;
  downloadPAFeatureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  eIN?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  isCaseAutomaticDiscontinuationAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalExposureAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  libraryGPTFeatureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  libraryNavlinPricesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paymentTerms: Scalars['Int']['input'];
  pharmaId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  publicAgreementsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  rebateProcessorId?: InputMaybe<Scalars['String']['input']>;
  simulatorBreakdownEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  simulatorModelValidityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  simulatorPVThresholdsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  simulatorProductInputEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  simulatorWasteReportingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSftpDirectoryArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  user?: InputMaybe<UserInput>;
};


export type MutationDeleteAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomConditionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationDeleteFlexQueryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteGenericArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSimulationsArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteTranslationKeysArgs = {
  environment: Scalars['String']['input'];
  keys: Array<Scalars['String']['input']>;
  languages: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationDeleteTranslationValueArgs = {
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  environment: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteUserArgs = {
  user?: InputMaybe<ExistingUserInput>;
};


export type MutationFlushCoreChosenCacheArgs = {
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  typeNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationRefreshApiKeyArgs = {
  owner: Scalars['String']['input'];
};


export type MutationRemoveModuleArgs = {
  id: Scalars['String']['input'];
  moduleId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveSftpDirectoryArgs = {
  path: Scalars['String']['input'];
};


export type MutationRemoveTranslationsArgs = {
  lang: Translations;
  orgId: Scalars['String']['input'];
};


export type MutationRemoveUserSubscribedArgs = {
  notificationId: Scalars['Int']['input'];
  orgId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveUsersFromValidityExpirationReminderNotificationArgs = {
  input: EncapsulatedFeatureConfigurationInput;
};


export type MutationResendUserRegEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationRevokeApiKeyArgs = {
  owner: Scalars['String']['input'];
};


export type MutationRunAgreementsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRunDataCheckArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRunIntegrityChecksArgs = {
  typeNames: Array<Scalars['String']['input']>;
};


export type MutationRunQuestAutoCompletionArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationSaveAgreementArgs = {
  input: AgreementInput;
};


export type MutationSaveAgreementTemplateArgs = {
  input: AgreementTemplateInput;
};


export type MutationSaveAutoDocumentReviewReminderParamsArgs = {
  documentReviewReminderDelay?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderRecurrentStep?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationSaveAutoIssuanceParamsArgs = {
  autoIssuanceDelay?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold?: InputMaybe<Scalars['Float']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationSaveCustomIntegrityChecksArgs = {
  inputs?: InputMaybe<Array<InputMaybe<SaveCustomIntegrityCheckInput>>>;
};


export type MutationSaveDeviceAgreementArgs = {
  input: DeviceAgreementInput;
};


export type MutationSaveDocumentSftpPathArgs = {
  organizationId: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveEnabledSsoTypesArgs = {
  organizationId: Scalars['ID']['input'];
  ssoTypes: Array<SingleSignOnType>;
};


export type MutationSaveFlexEntityArgs = {
  input: FlexEntityInput;
};


export type MutationSaveNotificationsArgs = {
  input: OrgNotificationInput;
};


export type MutationSaveUploadLimitationsArgs = {
  input: Array<UploadLimitationInput>;
};


export type MutationSetAgreementHiddenArgs = {
  id: Scalars['ID']['input'];
  isHidden: Scalars['Boolean']['input'];
};


export type MutationSetAgreementRunTriggersFeatureArgs = {
  organizationId: Scalars['String']['input'];
  runTriggers: Array<AgreementRunTrigger>;
};


export type MutationSetAgreementTemplateDeletedArgs = {
  id: Scalars['ID']['input'];
  isDeleted: Scalars['Boolean']['input'];
};


export type MutationSetAutomatedRunFrequencyFeatureArgs = {
  organizationId: Scalars['String']['input'];
  runFrequency?: InputMaybe<AgreementRunFrequency>;
};


export type MutationSetDownloadPublicAgreementFeatureArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationSetEmailEncryptionFeatureArgs = {
  input: EncryptionInput;
};


export type MutationSetLibraryGptFeatureArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationSetMonitoringArgs = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetNavlinPricesFeatureArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationSetPerformanceThresholdArgs = {
  input: PerformanceThresholdInput;
};


export type MutationSetPublicAgreementFeatureArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['Int']['input'];
};


export type MutationSetSimulatorBreakdownFeatureArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationSetSimulatorModelValidityFeatureArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationSetSimulatorPvThresholdsFeatureArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationSetSimulatorProductInputFeatureArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationSetSimulatorWasteReportingFeatureArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationSetValidityCoverageFeatureArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationSetValueEncapsulatedFeatureUpdateArgs = {
  featureKey: Scalars['String']['input'];
  featureValue?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationStartBagUploadArgs = {
  file?: InputMaybe<Scalars['FileUpload']['input']>;
  preliminary?: InputMaybe<Scalars['Boolean']['input']>;
  rewrite?: InputMaybe<Scalars['Boolean']['input']>;
  translate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSubmitQueryArgs = {
  input: QueryCheckInput;
};


export type MutationSubscribeUsersToValidityExpirationReminderNotificationArgs = {
  input: EncapsulatedFeatureConfigurationInput;
};


export type MutationSyncAgreementsArgs = {
  agreementIds: Array<Scalars['String']['input']>;
  forceSync: Scalars['Boolean']['input'];
  syncTypes: Array<SyncType>;
  templateId: Scalars['String']['input'];
};


export type MutationUpdateAgreementCacheArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationUpdateAgreementNameArgs = {
  initialVersionId: Scalars['String']['input'];
  input: Scalars['String']['input'];
};


export type MutationUpdateAgreementScopeArgs = {
  input: AgreementScopeInput;
};


export type MutationUpdateAgreementUserRolesArgs = {
  input?: InputMaybe<UserRoleRequestUpdateInput>;
};


export type MutationUpdateConditionSetsArgs = {
  scopeCodes: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCustomConditionArgs = {
  input: UpdateCustomConditionInput;
};


export type MutationUpdateDataChecksStateArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateDefaultUserRoleArgs = {
  input?: InputMaybe<DefaultUserRoleUpdateInput>;
  orgId: Scalars['String']['input'];
};


export type MutationUpdateEncapsulatedFeatureConfigurationArgs = {
  input: EncapsulatedFeatureConfigurationInput;
};


export type MutationUpdateIndicationArgs = {
  input: UpdateIndicationInput;
};


export type MutationUpdateLegalEntitiesArgs = {
  organizationIds: Array<InputMaybe<Scalars['String']['input']>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMasterLanguageTranslationsArgs = {
  language: Scalars['String']['input'];
  serializedKeys: Scalars['String']['input'];
  targetEnvironment: Scalars['String']['input'];
};


export type MutationUpdateMissingKeyArgs = {
  input?: InputMaybe<UpdateMissingKeyInput>;
};


export type MutationUpdateOrganizationArgs = {
  BIC?: InputMaybe<Scalars['String']['input']>;
  IBAN?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  agreementRunTriggers: Array<AgreementRunTrigger>;
  automatedRunFrequency?: InputMaybe<AgreementRunFrequency>;
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<ContactPersonInput>;
  country: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  domicile?: InputMaybe<Scalars['String']['input']>;
  dualApprovalThreshold?: InputMaybe<Scalars['Int']['input']>;
  eIN?: InputMaybe<Scalars['String']['input']>;
  emailEncryptionEnabled: Scalars['Boolean']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isCaseAutomaticDiscontinuationAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalExposureAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paymentTerms: Scalars['Int']['input'];
  pharmaId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  publicAgreementsEnabled: Scalars['Boolean']['input'];
  rebateProcessorId?: InputMaybe<Scalars['String']['input']>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTranslationArgs = {
  payload: UpdateTranslationPayload;
};


export type MutationUpdateUserArgs = {
  user?: InputMaybe<ExistingUserInput>;
};


export type MutationUpdateUserContextFiltersAgreementsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersBrandIndicationsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersCountriesArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersCustomConditionsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersFlexQueriesArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersFlexibleFormsRecordsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersIndicationsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersLocalizationArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersMissingKeysArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersModelsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersPerformanceMeasurementsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersPerformanceProfilesArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersProductBlueprintsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersProductsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersScopesArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersTermsAndPoliciesArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersUsersArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserRoleArgs = {
  id: Scalars['String']['input'];
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NegotiationRound = {
  __typename?: 'NegotiationRound';
  case: Case;
  caseAggregate?: Maybe<NegotiationRoundCaseCaseAggregationSelection>;
  caseConnection: NegotiationRoundCaseConnection;
  changedOn: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastProposedBy: Scalars['String']['output'];
  proposedBy: Organization;
  proposedByAggregate?: Maybe<NegotiationRoundOrganizationProposedByAggregationSelection>;
  proposedByConnection: NegotiationRoundProposedByConnection;
  source: FlexEntity;
  sourceAggregate?: Maybe<NegotiationRoundFlexEntitySourceAggregationSelection>;
  sourceConnection: NegotiationRoundSourceConnection;
  status: NegotiationRoundStatus;
  updatedBy: Array<User>;
  updatedByAggregate?: Maybe<NegotiationRoundUserUpdatedByAggregationSelection>;
  updatedByConnection: NegotiationRoundUpdatedByConnection;
};


export type NegotiationRoundCaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type NegotiationRoundCaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type NegotiationRoundCaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NegotiationRoundCaseConnectionSort>>;
  where?: InputMaybe<NegotiationRoundCaseConnectionWhere>;
};


export type NegotiationRoundProposedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type NegotiationRoundProposedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type NegotiationRoundProposedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NegotiationRoundProposedByConnectionSort>>;
  where?: InputMaybe<NegotiationRoundProposedByConnectionWhere>;
};


export type NegotiationRoundSourceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type NegotiationRoundSourceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type NegotiationRoundSourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NegotiationRoundSourceConnectionSort>>;
  where?: InputMaybe<NegotiationRoundSourceConnectionWhere>;
};


export type NegotiationRoundUpdatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type NegotiationRoundUpdatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type NegotiationRoundUpdatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NegotiationRoundUpdatedByConnectionSort>>;
  where?: InputMaybe<NegotiationRoundUpdatedByConnectionWhere>;
};

export type NegotiationRoundCaseAggregateInput = {
  AND?: InputMaybe<Array<NegotiationRoundCaseAggregateInput>>;
  NOT?: InputMaybe<NegotiationRoundCaseAggregateInput>;
  OR?: InputMaybe<Array<NegotiationRoundCaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NegotiationRoundCaseNodeAggregationWhereInput>;
};

export type NegotiationRoundCaseCaseAggregationSelection = {
  __typename?: 'NegotiationRoundCaseCaseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NegotiationRoundCaseCaseNodeAggregateSelection>;
};

export type NegotiationRoundCaseCaseNodeAggregateSelection = {
  __typename?: 'NegotiationRoundCaseCaseNodeAggregateSelection';
  creationDate: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
};

export type NegotiationRoundCaseConnection = {
  __typename?: 'NegotiationRoundCaseConnection';
  edges: Array<NegotiationRoundCaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NegotiationRoundCaseConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type NegotiationRoundCaseConnectionWhere = {
  AND?: InputMaybe<Array<NegotiationRoundCaseConnectionWhere>>;
  NOT?: InputMaybe<NegotiationRoundCaseConnectionWhere>;
  OR?: InputMaybe<Array<NegotiationRoundCaseConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type NegotiationRoundCaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NegotiationRoundCaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NegotiationRoundCaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NegotiationRoundCaseNodeAggregationWhereInput>>;
  creationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NegotiationRoundCaseRelationship = {
  __typename?: 'NegotiationRoundCaseRelationship';
  cursor: Scalars['String']['output'];
  node: Case;
};

export type NegotiationRoundEdge = {
  __typename?: 'NegotiationRoundEdge';
  cursor: Scalars['String']['output'];
  node: NegotiationRound;
};

export type NegotiationRoundFlexEntitySourceAggregationSelection = {
  __typename?: 'NegotiationRoundFlexEntitySourceAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NegotiationRoundFlexEntitySourceNodeAggregateSelection>;
};

export type NegotiationRoundFlexEntitySourceNodeAggregateSelection = {
  __typename?: 'NegotiationRoundFlexEntitySourceNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type NegotiationRoundOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NegotiationRoundSort objects to sort NegotiationRounds by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NegotiationRoundSort>>;
};

export type NegotiationRoundOrganizationProposedByAggregationSelection = {
  __typename?: 'NegotiationRoundOrganizationProposedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NegotiationRoundOrganizationProposedByNodeAggregateSelection>;
};

export type NegotiationRoundOrganizationProposedByNodeAggregateSelection = {
  __typename?: 'NegotiationRoundOrganizationProposedByNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type NegotiationRoundProposedByAggregateInput = {
  AND?: InputMaybe<Array<NegotiationRoundProposedByAggregateInput>>;
  NOT?: InputMaybe<NegotiationRoundProposedByAggregateInput>;
  OR?: InputMaybe<Array<NegotiationRoundProposedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NegotiationRoundProposedByNodeAggregationWhereInput>;
};

export type NegotiationRoundProposedByConnection = {
  __typename?: 'NegotiationRoundProposedByConnection';
  edges: Array<NegotiationRoundProposedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NegotiationRoundProposedByConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type NegotiationRoundProposedByConnectionWhere = {
  AND?: InputMaybe<Array<NegotiationRoundProposedByConnectionWhere>>;
  NOT?: InputMaybe<NegotiationRoundProposedByConnectionWhere>;
  OR?: InputMaybe<Array<NegotiationRoundProposedByConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type NegotiationRoundProposedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NegotiationRoundProposedByNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<NegotiationRoundProposedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NegotiationRoundProposedByNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NegotiationRoundProposedByRelationship = {
  __typename?: 'NegotiationRoundProposedByRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

/** Fields to sort NegotiationRounds by. The order in which sorts are applied is not guaranteed when specifying many fields in one NegotiationRoundSort object. */
export type NegotiationRoundSort = {
  changedOn?: InputMaybe<SortDirection>;
  data?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastProposedBy?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type NegotiationRoundSourceAggregateInput = {
  AND?: InputMaybe<Array<NegotiationRoundSourceAggregateInput>>;
  NOT?: InputMaybe<NegotiationRoundSourceAggregateInput>;
  OR?: InputMaybe<Array<NegotiationRoundSourceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NegotiationRoundSourceNodeAggregationWhereInput>;
};

export type NegotiationRoundSourceConnection = {
  __typename?: 'NegotiationRoundSourceConnection';
  edges: Array<NegotiationRoundSourceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NegotiationRoundSourceConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type NegotiationRoundSourceConnectionWhere = {
  AND?: InputMaybe<Array<NegotiationRoundSourceConnectionWhere>>;
  NOT?: InputMaybe<NegotiationRoundSourceConnectionWhere>;
  OR?: InputMaybe<Array<NegotiationRoundSourceConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type NegotiationRoundSourceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NegotiationRoundSourceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NegotiationRoundSourceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NegotiationRoundSourceNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NegotiationRoundSourceRelationship = {
  __typename?: 'NegotiationRoundSourceRelationship';
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export enum NegotiationRoundStatus {
  Accepted = 'ACCEPTED',
  AcceptedWithoutReview = 'ACCEPTED_WITHOUT_REVIEW',
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED'
}

export type NegotiationRoundUpdatedByAggregateInput = {
  AND?: InputMaybe<Array<NegotiationRoundUpdatedByAggregateInput>>;
  NOT?: InputMaybe<NegotiationRoundUpdatedByAggregateInput>;
  OR?: InputMaybe<Array<NegotiationRoundUpdatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NegotiationRoundUpdatedByNodeAggregationWhereInput>;
};

export type NegotiationRoundUpdatedByConnection = {
  __typename?: 'NegotiationRoundUpdatedByConnection';
  edges: Array<NegotiationRoundUpdatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NegotiationRoundUpdatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type NegotiationRoundUpdatedByConnectionWhere = {
  AND?: InputMaybe<Array<NegotiationRoundUpdatedByConnectionWhere>>;
  NOT?: InputMaybe<NegotiationRoundUpdatedByConnectionWhere>;
  OR?: InputMaybe<Array<NegotiationRoundUpdatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type NegotiationRoundUpdatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NegotiationRoundUpdatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NegotiationRoundUpdatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NegotiationRoundUpdatedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NegotiationRoundUpdatedByRelationship = {
  __typename?: 'NegotiationRoundUpdatedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type NegotiationRoundUserUpdatedByAggregationSelection = {
  __typename?: 'NegotiationRoundUserUpdatedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NegotiationRoundUserUpdatedByNodeAggregateSelection>;
};

export type NegotiationRoundUserUpdatedByNodeAggregateSelection = {
  __typename?: 'NegotiationRoundUserUpdatedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type NegotiationRoundWhere = {
  AND?: InputMaybe<Array<NegotiationRoundWhere>>;
  NOT?: InputMaybe<NegotiationRoundWhere>;
  OR?: InputMaybe<Array<NegotiationRoundWhere>>;
  case?: InputMaybe<CaseWhere>;
  caseAggregate?: InputMaybe<NegotiationRoundCaseAggregateInput>;
  caseConnection?: InputMaybe<NegotiationRoundCaseConnectionWhere>;
  caseConnection_NOT?: InputMaybe<NegotiationRoundCaseConnectionWhere>;
  case_NOT?: InputMaybe<CaseWhere>;
  changedOn?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  changedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  data_MATCHES?: InputMaybe<Scalars['String']['input']>;
  data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  proposedBy?: InputMaybe<OrganizationWhere>;
  proposedByAggregate?: InputMaybe<NegotiationRoundProposedByAggregateInput>;
  proposedByConnection?: InputMaybe<NegotiationRoundProposedByConnectionWhere>;
  proposedByConnection_NOT?: InputMaybe<NegotiationRoundProposedByConnectionWhere>;
  proposedBy_NOT?: InputMaybe<OrganizationWhere>;
  source?: InputMaybe<FlexEntityWhere>;
  sourceAggregate?: InputMaybe<NegotiationRoundSourceAggregateInput>;
  sourceConnection?: InputMaybe<NegotiationRoundSourceConnectionWhere>;
  sourceConnection_NOT?: InputMaybe<NegotiationRoundSourceConnectionWhere>;
  source_NOT?: InputMaybe<FlexEntityWhere>;
  status?: InputMaybe<NegotiationRoundStatus>;
  status_IN?: InputMaybe<Array<NegotiationRoundStatus>>;
  updatedByAggregate?: InputMaybe<NegotiationRoundUpdatedByAggregateInput>;
  /** Return NegotiationRounds where all of the related NegotiationRoundUpdatedByConnections match this filter */
  updatedByConnection_ALL?: InputMaybe<NegotiationRoundUpdatedByConnectionWhere>;
  /** Return NegotiationRounds where none of the related NegotiationRoundUpdatedByConnections match this filter */
  updatedByConnection_NONE?: InputMaybe<NegotiationRoundUpdatedByConnectionWhere>;
  /** Return NegotiationRounds where one of the related NegotiationRoundUpdatedByConnections match this filter */
  updatedByConnection_SINGLE?: InputMaybe<NegotiationRoundUpdatedByConnectionWhere>;
  /** Return NegotiationRounds where some of the related NegotiationRoundUpdatedByConnections match this filter */
  updatedByConnection_SOME?: InputMaybe<NegotiationRoundUpdatedByConnectionWhere>;
  /** Return NegotiationRounds where all of the related Users match this filter */
  updatedBy_ALL?: InputMaybe<UserWhere>;
  /** Return NegotiationRounds where none of the related Users match this filter */
  updatedBy_NONE?: InputMaybe<UserWhere>;
  /** Return NegotiationRounds where one of the related Users match this filter */
  updatedBy_SINGLE?: InputMaybe<UserWhere>;
  /** Return NegotiationRounds where some of the related Users match this filter */
  updatedBy_SOME?: InputMaybe<UserWhere>;
};

export type NegotiationRoundsConnection = {
  __typename?: 'NegotiationRoundsConnection';
  edges: Array<NegotiationRoundEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Neo4JClusterMemberMetricsConnection = {
  __typename?: 'Neo4JClusterMemberMetricsConnection';
  edges: Array<Neo4jClusterMemberMetricEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Neo4JClusterMetricsConnection = {
  __typename?: 'Neo4JClusterMetricsConnection';
  edges: Array<Neo4jClusterMetricsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Neo4jClusterMemberMetric = {
  __typename?: 'Neo4jClusterMemberMetric';
  boltAddress: Scalars['String']['output'];
  cpuLoadPercent?: Maybe<Scalars['Float']['output']>;
  freePhysicalMemoryBytes?: Maybe<Scalars['Float']['output']>;
  heapMaxBytes?: Maybe<Scalars['Float']['output']>;
  heapUsedBytes?: Maybe<Scalars['Float']['output']>;
  role: Scalars['String']['output'];
  totalPhysicalMemoryBytes?: Maybe<Scalars['Float']['output']>;
};

export type Neo4jClusterMemberMetricEdge = {
  __typename?: 'Neo4jClusterMemberMetricEdge';
  cursor: Scalars['String']['output'];
  node: Neo4jClusterMemberMetric;
};

export type Neo4jClusterMemberMetricOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more Neo4jClusterMemberMetricSort objects to sort Neo4JClusterMemberMetrics by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<Neo4jClusterMemberMetricSort>>;
};

/** Fields to sort Neo4JClusterMemberMetrics by. The order in which sorts are applied is not guaranteed when specifying many fields in one Neo4jClusterMemberMetricSort object. */
export type Neo4jClusterMemberMetricSort = {
  boltAddress?: InputMaybe<SortDirection>;
  cpuLoadPercent?: InputMaybe<SortDirection>;
  freePhysicalMemoryBytes?: InputMaybe<SortDirection>;
  heapMaxBytes?: InputMaybe<SortDirection>;
  heapUsedBytes?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  totalPhysicalMemoryBytes?: InputMaybe<SortDirection>;
};

export type Neo4jClusterMemberMetricWhere = {
  AND?: InputMaybe<Array<Neo4jClusterMemberMetricWhere>>;
  NOT?: InputMaybe<Neo4jClusterMemberMetricWhere>;
  OR?: InputMaybe<Array<Neo4jClusterMemberMetricWhere>>;
  boltAddress?: InputMaybe<Scalars['String']['input']>;
  boltAddress_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  boltAddress_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  boltAddress_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  boltAddress_MATCHES?: InputMaybe<Scalars['String']['input']>;
  boltAddress_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  cpuLoadPercent?: InputMaybe<Scalars['Float']['input']>;
  cpuLoadPercent_GT?: InputMaybe<Scalars['Float']['input']>;
  cpuLoadPercent_GTE?: InputMaybe<Scalars['Float']['input']>;
  cpuLoadPercent_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  cpuLoadPercent_LT?: InputMaybe<Scalars['Float']['input']>;
  cpuLoadPercent_LTE?: InputMaybe<Scalars['Float']['input']>;
  freePhysicalMemoryBytes?: InputMaybe<Scalars['Float']['input']>;
  freePhysicalMemoryBytes_GT?: InputMaybe<Scalars['Float']['input']>;
  freePhysicalMemoryBytes_GTE?: InputMaybe<Scalars['Float']['input']>;
  freePhysicalMemoryBytes_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  freePhysicalMemoryBytes_LT?: InputMaybe<Scalars['Float']['input']>;
  freePhysicalMemoryBytes_LTE?: InputMaybe<Scalars['Float']['input']>;
  heapMaxBytes?: InputMaybe<Scalars['Float']['input']>;
  heapMaxBytes_GT?: InputMaybe<Scalars['Float']['input']>;
  heapMaxBytes_GTE?: InputMaybe<Scalars['Float']['input']>;
  heapMaxBytes_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  heapMaxBytes_LT?: InputMaybe<Scalars['Float']['input']>;
  heapMaxBytes_LTE?: InputMaybe<Scalars['Float']['input']>;
  heapUsedBytes?: InputMaybe<Scalars['Float']['input']>;
  heapUsedBytes_GT?: InputMaybe<Scalars['Float']['input']>;
  heapUsedBytes_GTE?: InputMaybe<Scalars['Float']['input']>;
  heapUsedBytes_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  heapUsedBytes_LT?: InputMaybe<Scalars['Float']['input']>;
  heapUsedBytes_LTE?: InputMaybe<Scalars['Float']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  role_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  role_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  role_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  role_MATCHES?: InputMaybe<Scalars['String']['input']>;
  role_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  totalPhysicalMemoryBytes?: InputMaybe<Scalars['Float']['input']>;
  totalPhysicalMemoryBytes_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPhysicalMemoryBytes_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPhysicalMemoryBytes_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalPhysicalMemoryBytes_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPhysicalMemoryBytes_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type Neo4jClusterMetrics = {
  __typename?: 'Neo4jClusterMetrics';
  cachedAt?: Maybe<Scalars['Float']['output']>;
  members: Array<Neo4jClusterMemberMetric>;
  stale: Scalars['Boolean']['output'];
};

export type Neo4jClusterMetricsEdge = {
  __typename?: 'Neo4jClusterMetricsEdge';
  cursor: Scalars['String']['output'];
  node: Neo4jClusterMetrics;
};

export type Neo4jClusterMetricsOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more Neo4jClusterMetricsSort objects to sort Neo4JClusterMetrics by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<Neo4jClusterMetricsSort>>;
};

/** Fields to sort Neo4JClusterMetrics by. The order in which sorts are applied is not guaranteed when specifying many fields in one Neo4jClusterMetricsSort object. */
export type Neo4jClusterMetricsSort = {
  cachedAt?: InputMaybe<SortDirection>;
  stale?: InputMaybe<SortDirection>;
};

export type Neo4jClusterMetricsWhere = {
  AND?: InputMaybe<Array<Neo4jClusterMetricsWhere>>;
  NOT?: InputMaybe<Neo4jClusterMetricsWhere>;
  OR?: InputMaybe<Array<Neo4jClusterMetricsWhere>>;
  cachedAt?: InputMaybe<Scalars['Float']['input']>;
  cachedAt_GT?: InputMaybe<Scalars['Float']['input']>;
  cachedAt_GTE?: InputMaybe<Scalars['Float']['input']>;
  cachedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  cachedAt_LT?: InputMaybe<Scalars['Float']['input']>;
  cachedAt_LTE?: InputMaybe<Scalars['Float']['input']>;
  stale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NinjaQueriesConnection = {
  __typename?: 'NinjaQueriesConnection';
  edges: Array<NinjaQueryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NinjaQuery = {
  __typename?: 'NinjaQuery';
  createdByEmail: Scalars['String']['output'];
  createdOn: Scalars['Float']['output'];
  cypherQuery: Scalars['String']['output'];
  serializedCypherParams?: Maybe<Scalars['String']['output']>;
};

export type NinjaQueryEdge = {
  __typename?: 'NinjaQueryEdge';
  cursor: Scalars['String']['output'];
  node: NinjaQuery;
};

export type NinjaQueryImpact = {
  __typename?: 'NinjaQueryImpact';
  constraintsAdded: Scalars['Int']['output'];
  constraintsRemoved: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  indexesAdded: Scalars['Int']['output'];
  indexesRemoved: Scalars['Int']['output'];
  isValid: Scalars['Boolean']['output'];
  labelsAdded: Scalars['Int']['output'];
  labelsRemoved: Scalars['Int']['output'];
  nodesCreated: Scalars['Int']['output'];
  nodesDeleted: Scalars['Int']['output'];
  propertiesSet: Scalars['Int']['output'];
  queryResult?: Maybe<Scalars['String']['output']>;
  relationshipsCreated: Scalars['Int']['output'];
  relationshipsDeleted: Scalars['Int']['output'];
};

export type NinjaQueryImpactEdge = {
  __typename?: 'NinjaQueryImpactEdge';
  cursor: Scalars['String']['output'];
  node: NinjaQueryImpact;
};

export type NinjaQueryImpactOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NinjaQueryImpactSort objects to sort NinjaQueryImpacts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NinjaQueryImpactSort>>;
};

/** Fields to sort NinjaQueryImpacts by. The order in which sorts are applied is not guaranteed when specifying many fields in one NinjaQueryImpactSort object. */
export type NinjaQueryImpactSort = {
  constraintsAdded?: InputMaybe<SortDirection>;
  constraintsRemoved?: InputMaybe<SortDirection>;
  errorMessage?: InputMaybe<SortDirection>;
  indexesAdded?: InputMaybe<SortDirection>;
  indexesRemoved?: InputMaybe<SortDirection>;
  isValid?: InputMaybe<SortDirection>;
  labelsAdded?: InputMaybe<SortDirection>;
  labelsRemoved?: InputMaybe<SortDirection>;
  nodesCreated?: InputMaybe<SortDirection>;
  nodesDeleted?: InputMaybe<SortDirection>;
  propertiesSet?: InputMaybe<SortDirection>;
  queryResult?: InputMaybe<SortDirection>;
  relationshipsCreated?: InputMaybe<SortDirection>;
  relationshipsDeleted?: InputMaybe<SortDirection>;
};

export type NinjaQueryImpactWhere = {
  AND?: InputMaybe<Array<NinjaQueryImpactWhere>>;
  NOT?: InputMaybe<NinjaQueryImpactWhere>;
  OR?: InputMaybe<Array<NinjaQueryImpactWhere>>;
  constraintsAdded?: InputMaybe<Scalars['Int']['input']>;
  constraintsAdded_GT?: InputMaybe<Scalars['Int']['input']>;
  constraintsAdded_GTE?: InputMaybe<Scalars['Int']['input']>;
  constraintsAdded_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  constraintsAdded_LT?: InputMaybe<Scalars['Int']['input']>;
  constraintsAdded_LTE?: InputMaybe<Scalars['Int']['input']>;
  constraintsRemoved?: InputMaybe<Scalars['Int']['input']>;
  constraintsRemoved_GT?: InputMaybe<Scalars['Int']['input']>;
  constraintsRemoved_GTE?: InputMaybe<Scalars['Int']['input']>;
  constraintsRemoved_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  constraintsRemoved_LT?: InputMaybe<Scalars['Int']['input']>;
  constraintsRemoved_LTE?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorMessage_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  errorMessage_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  errorMessage_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorMessage_MATCHES?: InputMaybe<Scalars['String']['input']>;
  errorMessage_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  indexesAdded?: InputMaybe<Scalars['Int']['input']>;
  indexesAdded_GT?: InputMaybe<Scalars['Int']['input']>;
  indexesAdded_GTE?: InputMaybe<Scalars['Int']['input']>;
  indexesAdded_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  indexesAdded_LT?: InputMaybe<Scalars['Int']['input']>;
  indexesAdded_LTE?: InputMaybe<Scalars['Int']['input']>;
  indexesRemoved?: InputMaybe<Scalars['Int']['input']>;
  indexesRemoved_GT?: InputMaybe<Scalars['Int']['input']>;
  indexesRemoved_GTE?: InputMaybe<Scalars['Int']['input']>;
  indexesRemoved_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  indexesRemoved_LT?: InputMaybe<Scalars['Int']['input']>;
  indexesRemoved_LTE?: InputMaybe<Scalars['Int']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  labelsAdded?: InputMaybe<Scalars['Int']['input']>;
  labelsAdded_GT?: InputMaybe<Scalars['Int']['input']>;
  labelsAdded_GTE?: InputMaybe<Scalars['Int']['input']>;
  labelsAdded_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  labelsAdded_LT?: InputMaybe<Scalars['Int']['input']>;
  labelsAdded_LTE?: InputMaybe<Scalars['Int']['input']>;
  labelsRemoved?: InputMaybe<Scalars['Int']['input']>;
  labelsRemoved_GT?: InputMaybe<Scalars['Int']['input']>;
  labelsRemoved_GTE?: InputMaybe<Scalars['Int']['input']>;
  labelsRemoved_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  labelsRemoved_LT?: InputMaybe<Scalars['Int']['input']>;
  labelsRemoved_LTE?: InputMaybe<Scalars['Int']['input']>;
  nodesCreated?: InputMaybe<Scalars['Int']['input']>;
  nodesCreated_GT?: InputMaybe<Scalars['Int']['input']>;
  nodesCreated_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodesCreated_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  nodesCreated_LT?: InputMaybe<Scalars['Int']['input']>;
  nodesCreated_LTE?: InputMaybe<Scalars['Int']['input']>;
  nodesDeleted?: InputMaybe<Scalars['Int']['input']>;
  nodesDeleted_GT?: InputMaybe<Scalars['Int']['input']>;
  nodesDeleted_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodesDeleted_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  nodesDeleted_LT?: InputMaybe<Scalars['Int']['input']>;
  nodesDeleted_LTE?: InputMaybe<Scalars['Int']['input']>;
  propertiesSet?: InputMaybe<Scalars['Int']['input']>;
  propertiesSet_GT?: InputMaybe<Scalars['Int']['input']>;
  propertiesSet_GTE?: InputMaybe<Scalars['Int']['input']>;
  propertiesSet_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  propertiesSet_LT?: InputMaybe<Scalars['Int']['input']>;
  propertiesSet_LTE?: InputMaybe<Scalars['Int']['input']>;
  queryResult?: InputMaybe<Scalars['String']['input']>;
  queryResult_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  queryResult_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  queryResult_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryResult_MATCHES?: InputMaybe<Scalars['String']['input']>;
  queryResult_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  relationshipsCreated?: InputMaybe<Scalars['Int']['input']>;
  relationshipsCreated_GT?: InputMaybe<Scalars['Int']['input']>;
  relationshipsCreated_GTE?: InputMaybe<Scalars['Int']['input']>;
  relationshipsCreated_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationshipsCreated_LT?: InputMaybe<Scalars['Int']['input']>;
  relationshipsCreated_LTE?: InputMaybe<Scalars['Int']['input']>;
  relationshipsDeleted?: InputMaybe<Scalars['Int']['input']>;
  relationshipsDeleted_GT?: InputMaybe<Scalars['Int']['input']>;
  relationshipsDeleted_GTE?: InputMaybe<Scalars['Int']['input']>;
  relationshipsDeleted_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationshipsDeleted_LT?: InputMaybe<Scalars['Int']['input']>;
  relationshipsDeleted_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NinjaQueryImpactsConnection = {
  __typename?: 'NinjaQueryImpactsConnection';
  edges: Array<NinjaQueryImpactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NinjaQueryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NinjaQuerySort objects to sort NinjaQueries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NinjaQuerySort>>;
};

/** Fields to sort NinjaQueries by. The order in which sorts are applied is not guaranteed when specifying many fields in one NinjaQuerySort object. */
export type NinjaQuerySort = {
  createdByEmail?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  cypherQuery?: InputMaybe<SortDirection>;
  serializedCypherParams?: InputMaybe<SortDirection>;
};

export type NinjaQuerySubmitResult = {
  __typename?: 'NinjaQuerySubmitResult';
  impact: NinjaQueryImpact;
  query: NinjaQuery;
};

export type NinjaQuerySubmitResultEdge = {
  __typename?: 'NinjaQuerySubmitResultEdge';
  cursor: Scalars['String']['output'];
  node: NinjaQuerySubmitResult;
};

export type NinjaQuerySubmitResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type NinjaQuerySubmitResultWhere = {
  AND?: InputMaybe<Array<NinjaQuerySubmitResultWhere>>;
  NOT?: InputMaybe<NinjaQuerySubmitResultWhere>;
  OR?: InputMaybe<Array<NinjaQuerySubmitResultWhere>>;
};

export type NinjaQuerySubmitResultsConnection = {
  __typename?: 'NinjaQuerySubmitResultsConnection';
  edges: Array<NinjaQuerySubmitResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum NinjaQueryTargetDb {
  Core = 'CORE',
  Mls = 'MLS'
}

export type NinjaQueryWhere = {
  AND?: InputMaybe<Array<NinjaQueryWhere>>;
  NOT?: InputMaybe<NinjaQueryWhere>;
  OR?: InputMaybe<Array<NinjaQueryWhere>>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  cypherQuery?: InputMaybe<Scalars['String']['input']>;
  cypherQuery_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  cypherQuery_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  cypherQuery_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  cypherQuery_MATCHES?: InputMaybe<Scalars['String']['input']>;
  cypherQuery_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  serializedCypherParams?: InputMaybe<Scalars['String']['input']>;
  serializedCypherParams_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  serializedCypherParams_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  serializedCypherParams_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  serializedCypherParams_MATCHES?: InputMaybe<Scalars['String']['input']>;
  serializedCypherParams_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export enum Occurrence {
  ForTheFirstTime = 'FOR_THE_FIRST_TIME',
  ForTheFourthTime = 'FOR_THE_FOURTH_TIME',
  ForTheSecondTime = 'FOR_THE_SECOND_TIME',
  ForTheThirdTime = 'FOR_THE_THIRD_TIME'
}

export enum OccurrenceEnum {
  AutoGenerated = 'AUTO_GENERATED',
  FormEntry = 'FORM_ENTRY',
  FormUpload = 'FORM_UPLOAD',
  RecordEntry = 'RECORD_ENTRY',
  RecordImport = 'RECORD_IMPORT',
  RecordUpload = 'RECORD_UPLOAD'
}

export type OidDcUser = {
  __typename?: 'OidDcUser';
  role?: Maybe<Scalars['String']['output']>;
};

export type OidDcUserEdge = {
  __typename?: 'OidDcUserEdge';
  cursor: Scalars['String']['output'];
  node: OidDcUser;
};

export type OidDcUserOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more OidDcUserSort objects to sort OidDcUsers by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<OidDcUserSort>>;
};

/** Fields to sort OidDcUsers by. The order in which sorts are applied is not guaranteed when specifying many fields in one OidDcUserSort object. */
export type OidDcUserSort = {
  role?: InputMaybe<SortDirection>;
};

export type OidDcUserWhere = {
  AND?: InputMaybe<Array<OidDcUserWhere>>;
  NOT?: InputMaybe<OidDcUserWhere>;
  OR?: InputMaybe<Array<OidDcUserWhere>>;
  role?: InputMaybe<Scalars['String']['input']>;
  role_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  role_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  role_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role_MATCHES?: InputMaybe<Scalars['String']['input']>;
  role_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type OidDcUsersConnection = {
  __typename?: 'OidDcUsersConnection';
  edges: Array<OidDcUserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrgNotificationInput = {
  notifications: Array<QuestNotificationInput>;
  orgId: Scalars['String']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  BIC?: Maybe<Scalars['String']['output']>;
  IBAN?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  aggregationPriority?: Maybe<Scalars['Int']['output']>;
  agreementRunAttempts: Array<AgreementRunAttemptInfo>;
  agreementRunAttemptsAggregate?: Maybe<OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection>;
  agreementRunAttemptsConnection: OrganizationAgreementRunAttemptsConnection;
  agreementRunTriggers: Array<AgreementRunTrigger>;
  agreementTagNames: Array<Scalars['String']['output']>;
  agreements: Array<Agreement>;
  agreementsAggregate?: Maybe<OrganizationAgreementAgreementsAggregationSelection>;
  agreementsConnection: OrganizationAgreementsConnection;
  autoIssuanceDelay?: Maybe<Scalars['Float']['output']>;
  autoIssuanceThreshold?: Maybe<Scalars['Float']['output']>;
  automatedRunFrequency: AgreementRunFrequency;
  billingAddress?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  contactOccupation?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country: Country;
  countryAggregate?: Maybe<OrganizationCountryCountryAggregationSelection>;
  countryConnection: OrganizationCountryConnection;
  createdOn?: Maybe<Scalars['Float']['output']>;
  currencyCodes: Array<Currency>;
  customTranslations?: Maybe<Array<Maybe<Translations>>>;
  defaultReceivers: Array<Organization>;
  defaultReceiversAggregate?: Maybe<OrganizationOrganizationDefaultReceiversAggregationSelection>;
  defaultReceiversConnection: OrganizationDefaultReceiversConnection;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  documentReviewReminderDelay?: Maybe<Scalars['Float']['output']>;
  documentReviewReminderRecurrentStep?: Maybe<Scalars['Float']['output']>;
  documentSftpSavePath?: Maybe<Scalars['String']['output']>;
  domicile?: Maybe<Scalars['String']['output']>;
  downloadPAFeatureEnabled?: Maybe<Scalars['Boolean']['output']>;
  dualApprovalThreshold?: Maybe<Scalars['Int']['output']>;
  eIN?: Maybe<Scalars['String']['output']>;
  encapsulatedFeatures: Array<EncapsulatedFeatureConfiguration>;
  encapsulatedFeaturesAggregate?: Maybe<OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection>;
  encapsulatedFeaturesConnection: OrganizationEncapsulatedFeaturesConnection;
  fax?: Maybe<Scalars['String']['output']>;
  flexEntityTypeMappings: Array<FlexEntityType>;
  flexEntityTypeMappingsAggregate?: Maybe<OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection>;
  flexEntityTypeMappingsConnection: OrganizationFlexEntityTypeMappingsConnection;
  id: Scalars['ID']['output'];
  isCaseAutomaticDiscontinuationAllowed?: Maybe<Scalars['Boolean']['output']>;
  isExternalExposureAllowed?: Maybe<Scalars['Boolean']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  libraryGPTFeatureEnabled?: Maybe<Scalars['Boolean']['output']>;
  libraryNavlinPricesEnabled?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  paymentTerms: Scalars['Int']['output'];
  pharmaId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  questNotifications: Array<QuestNotification>;
  questNotificationsAggregate?: Maybe<OrganizationQuestNotificationQuestNotificationsAggregationSelection>;
  questNotificationsConnection: OrganizationQuestNotificationsConnection;
  rebateProcessorId?: Maybe<Scalars['String']['output']>;
  simulatorBreakdownEnabled?: Maybe<Scalars['Boolean']['output']>;
  simulatorModelValidityEnabled?: Maybe<Scalars['Boolean']['output']>;
  simulatorPVThresholdsEnabled?: Maybe<Scalars['Boolean']['output']>;
  simulatorProductInputEnabled?: Maybe<Scalars['Boolean']['output']>;
  simulatorWasteReportingEnabled?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  validityCoverageEnabled?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type OrganizationAgreementRunAttemptsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementRunAttemptInfoOptions>;
  where?: InputMaybe<AgreementRunAttemptInfoWhere>;
};


export type OrganizationAgreementRunAttemptsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementRunAttemptInfoWhere>;
};


export type OrganizationAgreementRunAttemptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationAgreementRunAttemptsConnectionSort>>;
  where?: InputMaybe<OrganizationAgreementRunAttemptsConnectionWhere>;
};


export type OrganizationAgreementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type OrganizationAgreementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type OrganizationAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationAgreementsConnectionSort>>;
  where?: InputMaybe<OrganizationAgreementsConnectionWhere>;
};


export type OrganizationCountryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type OrganizationCountryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type OrganizationCountryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationCountryConnectionSort>>;
  where?: InputMaybe<OrganizationCountryConnectionWhere>;
};


export type OrganizationDefaultReceiversArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type OrganizationDefaultReceiversAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type OrganizationDefaultReceiversConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationDefaultReceiversConnectionSort>>;
  where?: InputMaybe<OrganizationDefaultReceiversConnectionWhere>;
};


export type OrganizationEncapsulatedFeaturesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EncapsulatedFeatureConfigurationOptions>;
  where?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
};


export type OrganizationEncapsulatedFeaturesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
};


export type OrganizationEncapsulatedFeaturesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationEncapsulatedFeaturesConnectionSort>>;
  where?: InputMaybe<OrganizationEncapsulatedFeaturesConnectionWhere>;
};


export type OrganizationFlexEntityTypeMappingsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityTypeOptions>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type OrganizationFlexEntityTypeMappingsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type OrganizationFlexEntityTypeMappingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsConnectionSort>>;
  where?: InputMaybe<OrganizationFlexEntityTypeMappingsConnectionWhere>;
};


export type OrganizationQuestNotificationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QuestNotificationOptions>;
  where?: InputMaybe<QuestNotificationWhere>;
};


export type OrganizationQuestNotificationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestNotificationWhere>;
};


export type OrganizationQuestNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationQuestNotificationsConnectionSort>>;
  where?: InputMaybe<OrganizationQuestNotificationsConnectionWhere>;
};

export type OrganizationAgreementAgreementsAggregationSelection = {
  __typename?: 'OrganizationAgreementAgreementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<OrganizationAgreementAgreementsNodeAggregateSelection>;
};

export type OrganizationAgreementAgreementsNodeAggregateSelection = {
  __typename?: 'OrganizationAgreementAgreementsNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection = {
  __typename?: 'OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection>;
};

export type OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection = {
  __typename?: 'OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection';
  attemptedAgreementCount: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  filtersAppliedForRun: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  nonAttemptedAgreementCount: IntAggregateSelectionNullable;
  runEnd: DateTimeAggregateSelectionNullable;
  runStart: DateTimeAggregateSelectionNullable;
  succeededCount: IntAggregateSelectionNullable;
};

export type OrganizationAgreementRunAttemptsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationAgreementRunAttemptsAggregateInput>>;
  NOT?: InputMaybe<OrganizationAgreementRunAttemptsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationAgreementRunAttemptsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationAgreementRunAttemptsNodeAggregationWhereInput>;
};

export type OrganizationAgreementRunAttemptsConnection = {
  __typename?: 'OrganizationAgreementRunAttemptsConnection';
  edges: Array<OrganizationAgreementRunAttemptsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationAgreementRunAttemptsConnectionSort = {
  node?: InputMaybe<AgreementRunAttemptInfoSort>;
};

export type OrganizationAgreementRunAttemptsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationAgreementRunAttemptsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationAgreementRunAttemptsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationAgreementRunAttemptsConnectionWhere>>;
  node?: InputMaybe<AgreementRunAttemptInfoWhere>;
};

export type OrganizationAgreementRunAttemptsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationAgreementRunAttemptsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationAgreementRunAttemptsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationAgreementRunAttemptsNodeAggregationWhereInput>>;
  attemptedAgreementCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  runEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  succeededCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationAgreementRunAttemptsRelationship = {
  __typename?: 'OrganizationAgreementRunAttemptsRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementRunAttemptInfo;
};

export type OrganizationAgreementsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationAgreementsAggregateInput>>;
  NOT?: InputMaybe<OrganizationAgreementsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationAgreementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationAgreementsNodeAggregationWhereInput>;
};

export type OrganizationAgreementsConnection = {
  __typename?: 'OrganizationAgreementsConnection';
  edges: Array<OrganizationAgreementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationAgreementsConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type OrganizationAgreementsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationAgreementsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationAgreementsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationAgreementsConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type OrganizationAgreementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationAgreementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationAgreementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationAgreementsNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationAgreementsRelationship = {
  __typename?: 'OrganizationAgreementsRelationship';
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type OrganizationCountryAggregateInput = {
  AND?: InputMaybe<Array<OrganizationCountryAggregateInput>>;
  NOT?: InputMaybe<OrganizationCountryAggregateInput>;
  OR?: InputMaybe<Array<OrganizationCountryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationCountryNodeAggregationWhereInput>;
};

export type OrganizationCountryConnection = {
  __typename?: 'OrganizationCountryConnection';
  edges: Array<OrganizationCountryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationCountryConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type OrganizationCountryConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationCountryConnectionWhere>>;
  NOT?: InputMaybe<OrganizationCountryConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationCountryConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type OrganizationCountryCountryAggregationSelection = {
  __typename?: 'OrganizationCountryCountryAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<OrganizationCountryCountryNodeAggregateSelection>;
};

export type OrganizationCountryCountryNodeAggregateSelection = {
  __typename?: 'OrganizationCountryCountryNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type OrganizationCountryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationCountryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationCountryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationCountryNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationCountryRelationship = {
  __typename?: 'OrganizationCountryRelationship';
  cursor: Scalars['String']['output'];
  node: Country;
};

export type OrganizationDefaultReceiversAggregateInput = {
  AND?: InputMaybe<Array<OrganizationDefaultReceiversAggregateInput>>;
  NOT?: InputMaybe<OrganizationDefaultReceiversAggregateInput>;
  OR?: InputMaybe<Array<OrganizationDefaultReceiversAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrganizationDefaultReceiversEdgeAggregationWhereInput>;
  node?: InputMaybe<OrganizationDefaultReceiversNodeAggregationWhereInput>;
};

export type OrganizationDefaultReceiversConnection = {
  __typename?: 'OrganizationDefaultReceiversConnection';
  edges: Array<OrganizationDefaultReceiversRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationDefaultReceiversConnectionSort = {
  edge?: InputMaybe<DefaultReceiverPropertiesSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type OrganizationDefaultReceiversConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationDefaultReceiversConnectionWhere>>;
  NOT?: InputMaybe<OrganizationDefaultReceiversConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationDefaultReceiversConnectionWhere>>;
  edge?: InputMaybe<DefaultReceiverPropertiesWhere>;
  node?: InputMaybe<OrganizationWhere>;
};

export type OrganizationDefaultReceiversEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationDefaultReceiversEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationDefaultReceiversEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationDefaultReceiversEdgeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notificationId_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  notificationId_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  notificationId_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  notificationId_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  notificationId_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notificationId_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationDefaultReceiversNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationDefaultReceiversNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<OrganizationDefaultReceiversNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationDefaultReceiversNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationDefaultReceiversRelationship = DefaultReceiverProperties & {
  __typename?: 'OrganizationDefaultReceiversRelationship';
  cursor: Scalars['String']['output'];
  email: Scalars['String']['output'];
  node: Organization;
  notificationId: Scalars['Int']['output'];
  tagType: AgreementTagType;
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection = {
  __typename?: 'OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection>;
};

export type OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection = {
  __typename?: 'OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection';
  value: StringAggregateSelectionNullable;
};

export type OrganizationEncapsulatedFeaturesAggregateInput = {
  AND?: InputMaybe<Array<OrganizationEncapsulatedFeaturesAggregateInput>>;
  NOT?: InputMaybe<OrganizationEncapsulatedFeaturesAggregateInput>;
  OR?: InputMaybe<Array<OrganizationEncapsulatedFeaturesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationEncapsulatedFeaturesNodeAggregationWhereInput>;
};

export type OrganizationEncapsulatedFeaturesConnection = {
  __typename?: 'OrganizationEncapsulatedFeaturesConnection';
  edges: Array<OrganizationEncapsulatedFeaturesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationEncapsulatedFeaturesConnectionSort = {
  node?: InputMaybe<EncapsulatedFeatureConfigurationSort>;
};

export type OrganizationEncapsulatedFeaturesConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationEncapsulatedFeaturesConnectionWhere>>;
  NOT?: InputMaybe<OrganizationEncapsulatedFeaturesConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationEncapsulatedFeaturesConnectionWhere>>;
  node?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
};

export type OrganizationEncapsulatedFeaturesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationEncapsulatedFeaturesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationEncapsulatedFeaturesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationEncapsulatedFeaturesNodeAggregationWhereInput>>;
  value_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationEncapsulatedFeaturesRelationship = {
  __typename?: 'OrganizationEncapsulatedFeaturesRelationship';
  cursor: Scalars['String']['output'];
  node: EncapsulatedFeatureConfiguration;
};

export type OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection = {
  __typename?: 'OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection>;
  node?: Maybe<OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection>;
};

export type OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection = {
  __typename?: 'OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection';
  data: StringAggregateSelectionNullable;
};

export type OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection = {
  __typename?: 'OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  attributeCount: IntAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  description: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  idPrefix: StringAggregateSelectionNonNullable;
  localizationKey: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tooltipText: StringAggregateSelectionNullable;
};

export type OrganizationFlexEntityTypeMappingsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsAggregateInput>>;
  NOT?: InputMaybe<OrganizationFlexEntityTypeMappingsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput>;
  node?: InputMaybe<OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput>;
};

export type OrganizationFlexEntityTypeMappingsConnection = {
  __typename?: 'OrganizationFlexEntityTypeMappingsConnection';
  edges: Array<OrganizationFlexEntityTypeMappingsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationFlexEntityTypeMappingsConnectionSort = {
  edge?: InputMaybe<EntityTypeMappingRelationshipSort>;
  node?: InputMaybe<FlexEntityTypeSort>;
};

export type OrganizationFlexEntityTypeMappingsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationFlexEntityTypeMappingsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsConnectionWhere>>;
  edge?: InputMaybe<EntityTypeMappingRelationshipWhere>;
  node?: InputMaybe<FlexEntityTypeWhere>;
};

export type OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput>>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationFlexEntityTypeMappingsRelationship = EntityTypeMappingRelationship & {
  __typename?: 'OrganizationFlexEntityTypeMappingsRelationship';
  cursor: Scalars['String']['output'];
  data?: Maybe<Scalars['String']['output']>;
  node: FlexEntityType;
};

export type OrganizationInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more OrganizationSort objects to sort Organizations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<OrganizationSort>>;
};

export type OrganizationOrganizationDefaultReceiversAggregationSelection = {
  __typename?: 'OrganizationOrganizationDefaultReceiversAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<OrganizationOrganizationDefaultReceiversEdgeAggregateSelection>;
  node?: Maybe<OrganizationOrganizationDefaultReceiversNodeAggregateSelection>;
};

export type OrganizationOrganizationDefaultReceiversEdgeAggregateSelection = {
  __typename?: 'OrganizationOrganizationDefaultReceiversEdgeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  notificationId: IntAggregateSelectionNonNullable;
};

export type OrganizationOrganizationDefaultReceiversNodeAggregateSelection = {
  __typename?: 'OrganizationOrganizationDefaultReceiversNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type OrganizationQuestNotificationQuestNotificationsAggregationSelection = {
  __typename?: 'OrganizationQuestNotificationQuestNotificationsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection>;
  node?: Maybe<OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection>;
};

export type OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection = {
  __typename?: 'OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection';
  autocompletionThreshold: IntAggregateSelectionNullable;
  threshold: IntAggregateSelectionNullable;
};

export type OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection = {
  __typename?: 'OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection';
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type OrganizationQuestNotificationsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationQuestNotificationsAggregateInput>>;
  NOT?: InputMaybe<OrganizationQuestNotificationsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationQuestNotificationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrganizationQuestNotificationsEdgeAggregationWhereInput>;
  node?: InputMaybe<OrganizationQuestNotificationsNodeAggregationWhereInput>;
};

export type OrganizationQuestNotificationsConnection = {
  __typename?: 'OrganizationQuestNotificationsConnection';
  edges: Array<OrganizationQuestNotificationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationQuestNotificationsConnectionSort = {
  edge?: InputMaybe<OrganizationQuestRelationshipSort>;
  node?: InputMaybe<QuestNotificationSort>;
};

export type OrganizationQuestNotificationsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationQuestNotificationsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationQuestNotificationsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationQuestNotificationsConnectionWhere>>;
  edge?: InputMaybe<OrganizationQuestRelationshipWhere>;
  node?: InputMaybe<QuestNotificationWhere>;
};

export type OrganizationQuestNotificationsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationQuestNotificationsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationQuestNotificationsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationQuestNotificationsEdgeAggregationWhereInput>>;
  autocompletionThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationQuestNotificationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationQuestNotificationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationQuestNotificationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationQuestNotificationsNodeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationQuestNotificationsRelationship = OrganizationQuestRelationship & {
  __typename?: 'OrganizationQuestNotificationsRelationship';
  active?: Maybe<Scalars['Boolean']['output']>;
  amountType?: Maybe<AmountsType>;
  autocompletionThreshold?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isAutocompletionEnabled?: Maybe<Scalars['Boolean']['output']>;
  node: QuestNotification;
  threshold?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationQuestRelationship = {
  active?: Maybe<Scalars['Boolean']['output']>;
  amountType?: Maybe<AmountsType>;
  autocompletionThreshold?: Maybe<Scalars['Int']['output']>;
  isAutocompletionEnabled?: Maybe<Scalars['Boolean']['output']>;
  threshold?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationQuestRelationshipSort = {
  active?: InputMaybe<SortDirection>;
  amountType?: InputMaybe<SortDirection>;
  autocompletionThreshold?: InputMaybe<SortDirection>;
  isAutocompletionEnabled?: InputMaybe<SortDirection>;
  threshold?: InputMaybe<SortDirection>;
};

export type OrganizationQuestRelationshipWhere = {
  AND?: InputMaybe<Array<OrganizationQuestRelationshipWhere>>;
  NOT?: InputMaybe<OrganizationQuestRelationshipWhere>;
  OR?: InputMaybe<Array<OrganizationQuestRelationshipWhere>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amountType?: InputMaybe<AmountsType>;
  amountType_IN?: InputMaybe<Array<InputMaybe<AmountsType>>>;
  autocompletionThreshold?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  autocompletionThreshold_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_LTE?: InputMaybe<Scalars['Int']['input']>;
  isAutocompletionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
  threshold_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  threshold_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationScope = {
  __typename?: 'OrganizationScope';
  orgId: Scalars['String']['output'];
  organizationScopeId?: Maybe<Scalars['String']['output']>;
};

export type OrganizationScopeEdge = {
  __typename?: 'OrganizationScopeEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationScope;
};

export type OrganizationScopeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more OrganizationScopeSort objects to sort OrganizationScopes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<OrganizationScopeSort>>;
};

export type OrganizationScopeRelationship = {
  organizationScopeId?: Maybe<Scalars['String']['output']>;
};

export type OrganizationScopeRelationshipSort = {
  organizationScopeId?: InputMaybe<SortDirection>;
};

export type OrganizationScopeRelationshipWhere = {
  AND?: InputMaybe<Array<OrganizationScopeRelationshipWhere>>;
  NOT?: InputMaybe<OrganizationScopeRelationshipWhere>;
  OR?: InputMaybe<Array<OrganizationScopeRelationshipWhere>>;
  organizationScopeId?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationScopeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

/** Fields to sort OrganizationScopes by. The order in which sorts are applied is not guaranteed when specifying many fields in one OrganizationScopeSort object. */
export type OrganizationScopeSort = {
  orgId?: InputMaybe<SortDirection>;
  organizationScopeId?: InputMaybe<SortDirection>;
};

export type OrganizationScopeWhere = {
  AND?: InputMaybe<Array<OrganizationScopeWhere>>;
  NOT?: InputMaybe<OrganizationScopeWhere>;
  OR?: InputMaybe<Array<OrganizationScopeWhere>>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  orgId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  orgId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  orgId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  orgId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  orgId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationScopeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationScopesConnection = {
  __typename?: 'OrganizationScopesConnection';
  edges: Array<OrganizationScopeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Fields to sort Organizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one OrganizationSort object. */
export type OrganizationSort = {
  BIC?: InputMaybe<SortDirection>;
  IBAN?: InputMaybe<SortDirection>;
  accountName?: InputMaybe<SortDirection>;
  accountNumber?: InputMaybe<SortDirection>;
  aggregationPriority?: InputMaybe<SortDirection>;
  autoIssuanceDelay?: InputMaybe<SortDirection>;
  autoIssuanceThreshold?: InputMaybe<SortDirection>;
  automatedRunFrequency?: InputMaybe<SortDirection>;
  billingAddress?: InputMaybe<SortDirection>;
  contactEmail?: InputMaybe<SortDirection>;
  contactFirstName?: InputMaybe<SortDirection>;
  contactLastName?: InputMaybe<SortDirection>;
  contactOccupation?: InputMaybe<SortDirection>;
  contactPhone?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  deliveryAddress?: InputMaybe<SortDirection>;
  documentReviewReminderDelay?: InputMaybe<SortDirection>;
  documentReviewReminderRecurrentStep?: InputMaybe<SortDirection>;
  documentSftpSavePath?: InputMaybe<SortDirection>;
  domicile?: InputMaybe<SortDirection>;
  downloadPAFeatureEnabled?: InputMaybe<SortDirection>;
  dualApprovalThreshold?: InputMaybe<SortDirection>;
  eIN?: InputMaybe<SortDirection>;
  fax?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isCaseAutomaticDiscontinuationAllowed?: InputMaybe<SortDirection>;
  isExternalExposureAllowed?: InputMaybe<SortDirection>;
  legalName?: InputMaybe<SortDirection>;
  libraryGPTFeatureEnabled?: InputMaybe<SortDirection>;
  libraryNavlinPricesEnabled?: InputMaybe<SortDirection>;
  logo?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  organizationId?: InputMaybe<SortDirection>;
  paymentTerms?: InputMaybe<SortDirection>;
  pharmaId?: InputMaybe<SortDirection>;
  phone?: InputMaybe<SortDirection>;
  rebateProcessorId?: InputMaybe<SortDirection>;
  simulatorBreakdownEnabled?: InputMaybe<SortDirection>;
  simulatorModelValidityEnabled?: InputMaybe<SortDirection>;
  simulatorPVThresholdsEnabled?: InputMaybe<SortDirection>;
  simulatorProductInputEnabled?: InputMaybe<SortDirection>;
  simulatorWasteReportingEnabled?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  validityCoverageEnabled?: InputMaybe<SortDirection>;
  website?: InputMaybe<SortDirection>;
};

export type OrganizationWhere = {
  AND?: InputMaybe<Array<OrganizationWhere>>;
  BIC?: InputMaybe<Scalars['String']['input']>;
  BIC_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  BIC_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  BIC_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  BIC_MATCHES?: InputMaybe<Scalars['String']['input']>;
  BIC_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  IBAN?: InputMaybe<Scalars['String']['input']>;
  IBAN_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  IBAN_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  IBAN_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  IBAN_MATCHES?: InputMaybe<Scalars['String']['input']>;
  IBAN_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<OrganizationWhere>;
  OR?: InputMaybe<Array<OrganizationWhere>>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  accountName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  accountName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  accountName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  accountName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountNumber_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  accountNumber_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  accountNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  accountNumber_MATCHES?: InputMaybe<Scalars['String']['input']>;
  accountNumber_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  aggregationPriority?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  aggregationPriority_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementRunAttemptsAggregate?: InputMaybe<OrganizationAgreementRunAttemptsAggregateInput>;
  /** Return Organizations where all of the related OrganizationAgreementRunAttemptsConnections match this filter */
  agreementRunAttemptsConnection_ALL?: InputMaybe<OrganizationAgreementRunAttemptsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationAgreementRunAttemptsConnections match this filter */
  agreementRunAttemptsConnection_NONE?: InputMaybe<OrganizationAgreementRunAttemptsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationAgreementRunAttemptsConnections match this filter */
  agreementRunAttemptsConnection_SINGLE?: InputMaybe<OrganizationAgreementRunAttemptsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationAgreementRunAttemptsConnections match this filter */
  agreementRunAttemptsConnection_SOME?: InputMaybe<OrganizationAgreementRunAttemptsConnectionWhere>;
  /** Return Organizations where all of the related AgreementRunAttemptInfos match this filter */
  agreementRunAttempts_ALL?: InputMaybe<AgreementRunAttemptInfoWhere>;
  /** Return Organizations where none of the related AgreementRunAttemptInfos match this filter */
  agreementRunAttempts_NONE?: InputMaybe<AgreementRunAttemptInfoWhere>;
  /** Return Organizations where one of the related AgreementRunAttemptInfos match this filter */
  agreementRunAttempts_SINGLE?: InputMaybe<AgreementRunAttemptInfoWhere>;
  /** Return Organizations where some of the related AgreementRunAttemptInfos match this filter */
  agreementRunAttempts_SOME?: InputMaybe<AgreementRunAttemptInfoWhere>;
  agreementRunTriggers?: InputMaybe<Array<AgreementRunTrigger>>;
  agreementRunTriggers_INCLUDES?: InputMaybe<AgreementRunTrigger>;
  agreementsAggregate?: InputMaybe<OrganizationAgreementsAggregateInput>;
  /** Return Organizations where all of the related OrganizationAgreementsConnections match this filter */
  agreementsConnection_ALL?: InputMaybe<OrganizationAgreementsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationAgreementsConnections match this filter */
  agreementsConnection_NONE?: InputMaybe<OrganizationAgreementsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationAgreementsConnections match this filter */
  agreementsConnection_SINGLE?: InputMaybe<OrganizationAgreementsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationAgreementsConnections match this filter */
  agreementsConnection_SOME?: InputMaybe<OrganizationAgreementsConnectionWhere>;
  /** Return Organizations where all of the related Agreements match this filter */
  agreements_ALL?: InputMaybe<AgreementWhere>;
  /** Return Organizations where none of the related Agreements match this filter */
  agreements_NONE?: InputMaybe<AgreementWhere>;
  /** Return Organizations where one of the related Agreements match this filter */
  agreements_SINGLE?: InputMaybe<AgreementWhere>;
  /** Return Organizations where some of the related Agreements match this filter */
  agreements_SOME?: InputMaybe<AgreementWhere>;
  autoIssuanceDelay?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  autoIssuanceDelay_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  autoIssuanceThreshold_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_LTE?: InputMaybe<Scalars['Float']['input']>;
  automatedRunFrequency?: InputMaybe<AgreementRunFrequency>;
  automatedRunFrequency_IN?: InputMaybe<Array<AgreementRunFrequency>>;
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingAddress_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  billingAddress_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  billingAddress_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  billingAddress_MATCHES?: InputMaybe<Scalars['String']['input']>;
  billingAddress_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contactEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  contactEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactFirstName?: InputMaybe<Scalars['String']['input']>;
  contactFirstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contactFirstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactFirstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactFirstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  contactFirstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  contactLastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contactLastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactLastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactLastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  contactLastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactOccupation?: InputMaybe<Scalars['String']['input']>;
  contactOccupation_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contactOccupation_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactOccupation_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactOccupation_MATCHES?: InputMaybe<Scalars['String']['input']>;
  contactOccupation_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  contactPhone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contactPhone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactPhone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactPhone_MATCHES?: InputMaybe<Scalars['String']['input']>;
  contactPhone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryWhere>;
  countryAggregate?: InputMaybe<OrganizationCountryAggregateInput>;
  countryConnection?: InputMaybe<OrganizationCountryConnectionWhere>;
  countryConnection_NOT?: InputMaybe<OrganizationCountryConnectionWhere>;
  country_NOT?: InputMaybe<CountryWhere>;
  createdOn?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdOn_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  customTranslations?: InputMaybe<Array<InputMaybe<Translations>>>;
  customTranslations_INCLUDES?: InputMaybe<Translations>;
  defaultReceiversAggregate?: InputMaybe<OrganizationDefaultReceiversAggregateInput>;
  /** Return Organizations where all of the related OrganizationDefaultReceiversConnections match this filter */
  defaultReceiversConnection_ALL?: InputMaybe<OrganizationDefaultReceiversConnectionWhere>;
  /** Return Organizations where none of the related OrganizationDefaultReceiversConnections match this filter */
  defaultReceiversConnection_NONE?: InputMaybe<OrganizationDefaultReceiversConnectionWhere>;
  /** Return Organizations where one of the related OrganizationDefaultReceiversConnections match this filter */
  defaultReceiversConnection_SINGLE?: InputMaybe<OrganizationDefaultReceiversConnectionWhere>;
  /** Return Organizations where some of the related OrganizationDefaultReceiversConnections match this filter */
  defaultReceiversConnection_SOME?: InputMaybe<OrganizationDefaultReceiversConnectionWhere>;
  /** Return Organizations where all of the related Organizations match this filter */
  defaultReceivers_ALL?: InputMaybe<OrganizationWhere>;
  /** Return Organizations where none of the related Organizations match this filter */
  defaultReceivers_NONE?: InputMaybe<OrganizationWhere>;
  /** Return Organizations where one of the related Organizations match this filter */
  defaultReceivers_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return Organizations where some of the related Organizations match this filter */
  defaultReceivers_SOME?: InputMaybe<OrganizationWhere>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryAddress_MATCHES?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReviewReminderDelay?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  documentReviewReminderDelay_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  documentReviewReminderRecurrentStep_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath?: InputMaybe<Scalars['String']['input']>;
  documentSftpSavePath_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSftpSavePath_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSftpSavePath_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSftpSavePath_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSftpSavePath_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  domicile?: InputMaybe<Scalars['String']['input']>;
  domicile_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  domicile_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  domicile_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domicile_MATCHES?: InputMaybe<Scalars['String']['input']>;
  domicile_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  downloadPAFeatureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dualApprovalThreshold?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dualApprovalThreshold_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN?: InputMaybe<Scalars['String']['input']>;
  eIN_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  eIN_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  eIN_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eIN_MATCHES?: InputMaybe<Scalars['String']['input']>;
  eIN_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  encapsulatedFeaturesAggregate?: InputMaybe<OrganizationEncapsulatedFeaturesAggregateInput>;
  /** Return Organizations where all of the related OrganizationEncapsulatedFeaturesConnections match this filter */
  encapsulatedFeaturesConnection_ALL?: InputMaybe<OrganizationEncapsulatedFeaturesConnectionWhere>;
  /** Return Organizations where none of the related OrganizationEncapsulatedFeaturesConnections match this filter */
  encapsulatedFeaturesConnection_NONE?: InputMaybe<OrganizationEncapsulatedFeaturesConnectionWhere>;
  /** Return Organizations where one of the related OrganizationEncapsulatedFeaturesConnections match this filter */
  encapsulatedFeaturesConnection_SINGLE?: InputMaybe<OrganizationEncapsulatedFeaturesConnectionWhere>;
  /** Return Organizations where some of the related OrganizationEncapsulatedFeaturesConnections match this filter */
  encapsulatedFeaturesConnection_SOME?: InputMaybe<OrganizationEncapsulatedFeaturesConnectionWhere>;
  /** Return Organizations where all of the related EncapsulatedFeatureConfigurations match this filter */
  encapsulatedFeatures_ALL?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
  /** Return Organizations where none of the related EncapsulatedFeatureConfigurations match this filter */
  encapsulatedFeatures_NONE?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
  /** Return Organizations where one of the related EncapsulatedFeatureConfigurations match this filter */
  encapsulatedFeatures_SINGLE?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
  /** Return Organizations where some of the related EncapsulatedFeatureConfigurations match this filter */
  encapsulatedFeatures_SOME?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fax_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fax_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fax_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fax_MATCHES?: InputMaybe<Scalars['String']['input']>;
  fax_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  flexEntityTypeMappingsAggregate?: InputMaybe<OrganizationFlexEntityTypeMappingsAggregateInput>;
  /** Return Organizations where all of the related OrganizationFlexEntityTypeMappingsConnections match this filter */
  flexEntityTypeMappingsConnection_ALL?: InputMaybe<OrganizationFlexEntityTypeMappingsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationFlexEntityTypeMappingsConnections match this filter */
  flexEntityTypeMappingsConnection_NONE?: InputMaybe<OrganizationFlexEntityTypeMappingsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationFlexEntityTypeMappingsConnections match this filter */
  flexEntityTypeMappingsConnection_SINGLE?: InputMaybe<OrganizationFlexEntityTypeMappingsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationFlexEntityTypeMappingsConnections match this filter */
  flexEntityTypeMappingsConnection_SOME?: InputMaybe<OrganizationFlexEntityTypeMappingsConnectionWhere>;
  /** Return Organizations where all of the related FlexEntityTypes match this filter */
  flexEntityTypeMappings_ALL?: InputMaybe<FlexEntityTypeWhere>;
  /** Return Organizations where none of the related FlexEntityTypes match this filter */
  flexEntityTypeMappings_NONE?: InputMaybe<FlexEntityTypeWhere>;
  /** Return Organizations where one of the related FlexEntityTypes match this filter */
  flexEntityTypeMappings_SINGLE?: InputMaybe<FlexEntityTypeWhere>;
  /** Return Organizations where some of the related FlexEntityTypes match this filter */
  flexEntityTypeMappings_SOME?: InputMaybe<FlexEntityTypeWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isCaseAutomaticDiscontinuationAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalExposureAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  legalName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  legalName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legalName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  legalName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  libraryGPTFeatureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  libraryNavlinPricesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  logo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  logo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  logo_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo_MATCHES?: InputMaybe<Scalars['String']['input']>;
  logo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  paymentTerms_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId?: InputMaybe<Scalars['String']['input']>;
  pharmaId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  pharmaId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  pharmaId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pharmaId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  pharmaId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  phone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  phone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone_MATCHES?: InputMaybe<Scalars['String']['input']>;
  phone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  questNotificationsAggregate?: InputMaybe<OrganizationQuestNotificationsAggregateInput>;
  /** Return Organizations where all of the related OrganizationQuestNotificationsConnections match this filter */
  questNotificationsConnection_ALL?: InputMaybe<OrganizationQuestNotificationsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationQuestNotificationsConnections match this filter */
  questNotificationsConnection_NONE?: InputMaybe<OrganizationQuestNotificationsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationQuestNotificationsConnections match this filter */
  questNotificationsConnection_SINGLE?: InputMaybe<OrganizationQuestNotificationsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationQuestNotificationsConnections match this filter */
  questNotificationsConnection_SOME?: InputMaybe<OrganizationQuestNotificationsConnectionWhere>;
  /** Return Organizations where all of the related QuestNotifications match this filter */
  questNotifications_ALL?: InputMaybe<QuestNotificationWhere>;
  /** Return Organizations where none of the related QuestNotifications match this filter */
  questNotifications_NONE?: InputMaybe<QuestNotificationWhere>;
  /** Return Organizations where one of the related QuestNotifications match this filter */
  questNotifications_SINGLE?: InputMaybe<QuestNotificationWhere>;
  /** Return Organizations where some of the related QuestNotifications match this filter */
  questNotifications_SOME?: InputMaybe<QuestNotificationWhere>;
  rebateProcessorId?: InputMaybe<Scalars['String']['input']>;
  rebateProcessorId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  rebateProcessorId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  rebateProcessorId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rebateProcessorId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  rebateProcessorId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  simulatorBreakdownEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  simulatorModelValidityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  simulatorPVThresholdsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  simulatorProductInputEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  simulatorWasteReportingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  validityCoverageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  website_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  website_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  website_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  website_MATCHES?: InputMaybe<Scalars['String']['input']>;
  website_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationsConnection = {
  __typename?: 'OrganizationsConnection';
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum OutcomeBasedStatus {
  NonTreatmentRelated = 'NON_TREATMENT_RELATED',
  TreatmentRelated = 'TREATMENT_RELATED'
}

export enum PackOptionType {
  Specific = 'SPECIFIC',
  Whole = 'WHOLE'
}

export enum PackVolumeUoMType {
  Stk = 'Stk'
}

/** Pagination information (Relay) */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Partner = {
  __typename?: 'Partner';
  Description?: Maybe<Scalars['String']['output']>;
  PartnerType?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  Place?: Maybe<Scalars['String']['output']>;
  Street?: Maybe<Scalars['String']['output']>;
  ZipCode?: Maybe<Scalars['Int']['output']>;
  treatment?: Maybe<Treatment>;
  treatmentAggregate?: Maybe<PartnerTreatmentTreatmentAggregationSelection>;
  treatmentConnection: PartnerTreatmentConnection;
};


export type PartnerTreatmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type PartnerTreatmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type PartnerTreatmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PartnerTreatmentConnectionSort>>;
  where?: InputMaybe<PartnerTreatmentConnectionWhere>;
};

export type PartnerEdge = {
  __typename?: 'PartnerEdge';
  cursor: Scalars['String']['output'];
  node: Partner;
};

export type PartnerOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PartnerSort objects to sort Partners by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PartnerSort>>;
};

/** Fields to sort Partners by. The order in which sorts are applied is not guaranteed when specifying many fields in one PartnerSort object. */
export type PartnerSort = {
  Description?: InputMaybe<SortDirection>;
  PartnerType?: InputMaybe<SortDirection>;
  Phone?: InputMaybe<SortDirection>;
  Place?: InputMaybe<SortDirection>;
  Street?: InputMaybe<SortDirection>;
  ZipCode?: InputMaybe<SortDirection>;
};

export type PartnerTreatmentAggregateInput = {
  AND?: InputMaybe<Array<PartnerTreatmentAggregateInput>>;
  NOT?: InputMaybe<PartnerTreatmentAggregateInput>;
  OR?: InputMaybe<Array<PartnerTreatmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PartnerTreatmentNodeAggregationWhereInput>;
};

export type PartnerTreatmentConnection = {
  __typename?: 'PartnerTreatmentConnection';
  edges: Array<PartnerTreatmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartnerTreatmentConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type PartnerTreatmentConnectionWhere = {
  AND?: InputMaybe<Array<PartnerTreatmentConnectionWhere>>;
  NOT?: InputMaybe<PartnerTreatmentConnectionWhere>;
  OR?: InputMaybe<Array<PartnerTreatmentConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type PartnerTreatmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PartnerTreatmentNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<PartnerTreatmentNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PartnerTreatmentNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerTreatmentRelationship = {
  __typename?: 'PartnerTreatmentRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type PartnerTreatmentTreatmentAggregationSelection = {
  __typename?: 'PartnerTreatmentTreatmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PartnerTreatmentTreatmentNodeAggregateSelection>;
};

export type PartnerTreatmentTreatmentNodeAggregateSelection = {
  __typename?: 'PartnerTreatmentTreatmentNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type PartnerWhere = {
  AND?: InputMaybe<Array<PartnerWhere>>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Description_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<PartnerWhere>;
  OR?: InputMaybe<Array<PartnerWhere>>;
  PartnerType?: InputMaybe<Scalars['String']['input']>;
  PartnerType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PartnerType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PartnerType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PartnerType_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PartnerType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Phone?: InputMaybe<Scalars['String']['input']>;
  Phone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Phone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Phone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Phone_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Phone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Place?: InputMaybe<Scalars['String']['input']>;
  Place_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Place_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Place_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Place_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Place_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Street?: InputMaybe<Scalars['String']['input']>;
  Street_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Street_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Street_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Street_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Street_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ZipCode?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_GT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_GTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ZipCode_LT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatment?: InputMaybe<TreatmentWhere>;
  treatmentAggregate?: InputMaybe<PartnerTreatmentAggregateInput>;
  treatmentConnection?: InputMaybe<PartnerTreatmentConnectionWhere>;
  treatmentConnection_NOT?: InputMaybe<PartnerTreatmentConnectionWhere>;
  treatment_NOT?: InputMaybe<TreatmentWhere>;
};

export type PartnersConnection = {
  __typename?: 'PartnersConnection';
  edges: Array<PartnerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum PatentStatus {
  NotValid = 'NOT_VALID',
  Valid = 'VALID'
}

export enum PathologicalResponseType {
  NoPcr = 'NO_PCR',
  Pcr = 'PCR'
}

export type Patient = {
  __typename?: 'Patient';
  assignedFlexEntities: Array<FlexEntity>;
  assignedFlexEntitiesAggregate?: Maybe<PatientFlexEntityAssignedFlexEntitiesAggregationSelection>;
  assignedFlexEntitiesConnection: PatientAssignedFlexEntitiesConnection;
  cases: Array<Case>;
  casesAggregate?: Maybe<PatientCaseCasesAggregationSelection>;
  casesConnection: PatientCasesConnection;
  id: Scalars['ID']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  insuranceId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  timeStamp: Scalars['DateTime']['output'];
  yearOfBirth?: Maybe<Scalars['Int']['output']>;
};


export type PatientAssignedFlexEntitiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type PatientAssignedFlexEntitiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type PatientAssignedFlexEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PatientAssignedFlexEntitiesConnectionSort>>;
  where?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
};


export type PatientCasesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type PatientCasesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type PatientCasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PatientCasesConnectionSort>>;
  where?: InputMaybe<PatientCasesConnectionWhere>;
};

export type PatientAssignedFlexEntitiesAggregateInput = {
  AND?: InputMaybe<Array<PatientAssignedFlexEntitiesAggregateInput>>;
  NOT?: InputMaybe<PatientAssignedFlexEntitiesAggregateInput>;
  OR?: InputMaybe<Array<PatientAssignedFlexEntitiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PatientAssignedFlexEntitiesNodeAggregationWhereInput>;
};

export type PatientAssignedFlexEntitiesConnection = {
  __typename?: 'PatientAssignedFlexEntitiesConnection';
  edges: Array<PatientAssignedFlexEntitiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PatientAssignedFlexEntitiesConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type PatientAssignedFlexEntitiesConnectionWhere = {
  AND?: InputMaybe<Array<PatientAssignedFlexEntitiesConnectionWhere>>;
  NOT?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
  OR?: InputMaybe<Array<PatientAssignedFlexEntitiesConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type PatientAssignedFlexEntitiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PatientAssignedFlexEntitiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PatientAssignedFlexEntitiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PatientAssignedFlexEntitiesNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PatientAssignedFlexEntitiesRelationship = {
  __typename?: 'PatientAssignedFlexEntitiesRelationship';
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type PatientCaseCasesAggregationSelection = {
  __typename?: 'PatientCaseCasesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PatientCaseCasesNodeAggregateSelection>;
};

export type PatientCaseCasesNodeAggregateSelection = {
  __typename?: 'PatientCaseCasesNodeAggregateSelection';
  creationDate: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
};

export type PatientCasesAggregateInput = {
  AND?: InputMaybe<Array<PatientCasesAggregateInput>>;
  NOT?: InputMaybe<PatientCasesAggregateInput>;
  OR?: InputMaybe<Array<PatientCasesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PatientCasesNodeAggregationWhereInput>;
};

export type PatientCasesConnection = {
  __typename?: 'PatientCasesConnection';
  edges: Array<PatientCasesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PatientCasesConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type PatientCasesConnectionWhere = {
  AND?: InputMaybe<Array<PatientCasesConnectionWhere>>;
  NOT?: InputMaybe<PatientCasesConnectionWhere>;
  OR?: InputMaybe<Array<PatientCasesConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type PatientCasesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PatientCasesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PatientCasesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PatientCasesNodeAggregationWhereInput>>;
  creationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PatientCasesRelationship = {
  __typename?: 'PatientCasesRelationship';
  cursor: Scalars['String']['output'];
  node: Case;
};

export type PatientEdge = {
  __typename?: 'PatientEdge';
  cursor: Scalars['String']['output'];
  node: Patient;
};

export type PatientFlexEntityAssignedFlexEntitiesAggregationSelection = {
  __typename?: 'PatientFlexEntityAssignedFlexEntitiesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection>;
};

export type PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection = {
  __typename?: 'PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type PatientOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PatientSort objects to sort Patients by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PatientSort>>;
};

export enum PatientScope {
  PerAgreement = 'PER_AGREEMENT',
  PerPatient = 'PER_PATIENT'
}

/** Fields to sort Patients by. The order in which sorts are applied is not guaranteed when specifying many fields in one PatientSort object. */
export type PatientSort = {
  id?: InputMaybe<SortDirection>;
  initials?: InputMaybe<SortDirection>;
  insuranceId?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  timeStamp?: InputMaybe<SortDirection>;
  yearOfBirth?: InputMaybe<SortDirection>;
};

export type PatientWhere = {
  AND?: InputMaybe<Array<PatientWhere>>;
  NOT?: InputMaybe<PatientWhere>;
  OR?: InputMaybe<Array<PatientWhere>>;
  assignedFlexEntitiesAggregate?: InputMaybe<PatientAssignedFlexEntitiesAggregateInput>;
  /** Return Patients where all of the related PatientAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_ALL?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
  /** Return Patients where none of the related PatientAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_NONE?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
  /** Return Patients where one of the related PatientAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_SINGLE?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
  /** Return Patients where some of the related PatientAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_SOME?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
  /** Return Patients where all of the related FlexEntities match this filter */
  assignedFlexEntities_ALL?: InputMaybe<FlexEntityWhere>;
  /** Return Patients where none of the related FlexEntities match this filter */
  assignedFlexEntities_NONE?: InputMaybe<FlexEntityWhere>;
  /** Return Patients where one of the related FlexEntities match this filter */
  assignedFlexEntities_SINGLE?: InputMaybe<FlexEntityWhere>;
  /** Return Patients where some of the related FlexEntities match this filter */
  assignedFlexEntities_SOME?: InputMaybe<FlexEntityWhere>;
  casesAggregate?: InputMaybe<PatientCasesAggregateInput>;
  /** Return Patients where all of the related PatientCasesConnections match this filter */
  casesConnection_ALL?: InputMaybe<PatientCasesConnectionWhere>;
  /** Return Patients where none of the related PatientCasesConnections match this filter */
  casesConnection_NONE?: InputMaybe<PatientCasesConnectionWhere>;
  /** Return Patients where one of the related PatientCasesConnections match this filter */
  casesConnection_SINGLE?: InputMaybe<PatientCasesConnectionWhere>;
  /** Return Patients where some of the related PatientCasesConnections match this filter */
  casesConnection_SOME?: InputMaybe<PatientCasesConnectionWhere>;
  /** Return Patients where all of the related Cases match this filter */
  cases_ALL?: InputMaybe<CaseWhere>;
  /** Return Patients where none of the related Cases match this filter */
  cases_NONE?: InputMaybe<CaseWhere>;
  /** Return Patients where one of the related Cases match this filter */
  cases_SINGLE?: InputMaybe<CaseWhere>;
  /** Return Patients where some of the related Cases match this filter */
  cases_SOME?: InputMaybe<CaseWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  initials_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  initials_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  initials_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  initials_MATCHES?: InputMaybe<Scalars['String']['input']>;
  initials_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  insuranceId?: InputMaybe<Scalars['String']['input']>;
  insuranceId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  insuranceId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  insuranceId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  insuranceId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  insuranceId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeStamp?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  timeStamp_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  yearOfBirth?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  yearOfBirth_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PatientsConnection = {
  __typename?: 'PatientsConnection';
  edges: Array<PatientEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceCounter = {
  __typename?: 'PerformanceCounter';
  conditions?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PerformanceCounterEdge = {
  __typename?: 'PerformanceCounterEdge';
  cursor: Scalars['String']['output'];
  node: PerformanceCounter;
};

export type PerformanceCounterInput = {
  conditions?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type PerformanceCounterOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PerformanceCounterSort objects to sort PerformanceCounters by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PerformanceCounterSort>>;
};

/** Fields to sort PerformanceCounters by. The order in which sorts are applied is not guaranteed when specifying many fields in one PerformanceCounterSort object. */
export type PerformanceCounterSort = {
  conditions?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type PerformanceCounterWhere = {
  AND?: InputMaybe<Array<PerformanceCounterWhere>>;
  NOT?: InputMaybe<PerformanceCounterWhere>;
  OR?: InputMaybe<Array<PerformanceCounterWhere>>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  conditions_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  conditions_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  conditions_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  conditions_MATCHES?: InputMaybe<Scalars['String']['input']>;
  conditions_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PerformanceCountersConnection = {
  __typename?: 'PerformanceCountersConnection';
  edges: Array<PerformanceCounterEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceMeasurement = {
  __typename?: 'PerformanceMeasurement';
  completedOn?: Maybe<Scalars['DateTime']['output']>;
  counter: PerformanceCounter;
  counterAggregate?: Maybe<PerformanceMeasurementPerformanceCounterCounterAggregationSelection>;
  counterConnection: PerformanceMeasurementCounterConnection;
  id: Scalars['ID']['output'];
  isAverage?: Maybe<Scalars['Boolean']['output']>;
  nestedMeasurements: Array<PerformanceMeasurement>;
  nestedMeasurementsAggregate?: Maybe<PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection>;
  nestedMeasurementsConnection: PerformanceMeasurementNestedMeasurementsConnection;
  parent?: Maybe<PerformanceMeasurement>;
  parentAggregate?: Maybe<PerformanceMeasurementPerformanceMeasurementParentAggregationSelection>;
  parentConnection: PerformanceMeasurementParentConnection;
  payload?: Maybe<Scalars['String']['output']>;
  startedOn: Scalars['DateTime']['output'];
};


export type PerformanceMeasurementCounterArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PerformanceCounterOptions>;
  where?: InputMaybe<PerformanceCounterWhere>;
};


export type PerformanceMeasurementCounterAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PerformanceCounterWhere>;
};


export type PerformanceMeasurementCounterConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformanceMeasurementCounterConnectionSort>>;
  where?: InputMaybe<PerformanceMeasurementCounterConnectionWhere>;
};


export type PerformanceMeasurementNestedMeasurementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PerformanceMeasurementOptions>;
  where?: InputMaybe<PerformanceMeasurementWhere>;
};


export type PerformanceMeasurementNestedMeasurementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PerformanceMeasurementWhere>;
};


export type PerformanceMeasurementNestedMeasurementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsConnectionSort>>;
  where?: InputMaybe<PerformanceMeasurementNestedMeasurementsConnectionWhere>;
};


export type PerformanceMeasurementParentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PerformanceMeasurementOptions>;
  where?: InputMaybe<PerformanceMeasurementWhere>;
};


export type PerformanceMeasurementParentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PerformanceMeasurementWhere>;
};


export type PerformanceMeasurementParentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformanceMeasurementParentConnectionSort>>;
  where?: InputMaybe<PerformanceMeasurementParentConnectionWhere>;
};

export type PerformanceMeasurementCounterAggregateInput = {
  AND?: InputMaybe<Array<PerformanceMeasurementCounterAggregateInput>>;
  NOT?: InputMaybe<PerformanceMeasurementCounterAggregateInput>;
  OR?: InputMaybe<Array<PerformanceMeasurementCounterAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PerformanceMeasurementCounterNodeAggregationWhereInput>;
};

export type PerformanceMeasurementCounterConnection = {
  __typename?: 'PerformanceMeasurementCounterConnection';
  edges: Array<PerformanceMeasurementCounterRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceMeasurementCounterConnectionSort = {
  node?: InputMaybe<PerformanceCounterSort>;
};

export type PerformanceMeasurementCounterConnectionWhere = {
  AND?: InputMaybe<Array<PerformanceMeasurementCounterConnectionWhere>>;
  NOT?: InputMaybe<PerformanceMeasurementCounterConnectionWhere>;
  OR?: InputMaybe<Array<PerformanceMeasurementCounterConnectionWhere>>;
  node?: InputMaybe<PerformanceCounterWhere>;
};

export type PerformanceMeasurementCounterNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PerformanceMeasurementCounterNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PerformanceMeasurementCounterNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PerformanceMeasurementCounterNodeAggregationWhereInput>>;
  conditions_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  conditions_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformanceMeasurementCounterRelationship = {
  __typename?: 'PerformanceMeasurementCounterRelationship';
  cursor: Scalars['String']['output'];
  node: PerformanceCounter;
};

export type PerformanceMeasurementEdge = {
  __typename?: 'PerformanceMeasurementEdge';
  cursor: Scalars['String']['output'];
  node: PerformanceMeasurement;
};

export type PerformanceMeasurementNestedMeasurementsAggregateInput = {
  AND?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsAggregateInput>>;
  NOT?: InputMaybe<PerformanceMeasurementNestedMeasurementsAggregateInput>;
  OR?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput>;
};

export type PerformanceMeasurementNestedMeasurementsConnection = {
  __typename?: 'PerformanceMeasurementNestedMeasurementsConnection';
  edges: Array<PerformanceMeasurementNestedMeasurementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceMeasurementNestedMeasurementsConnectionSort = {
  node?: InputMaybe<PerformanceMeasurementSort>;
};

export type PerformanceMeasurementNestedMeasurementsConnectionWhere = {
  AND?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsConnectionWhere>>;
  NOT?: InputMaybe<PerformanceMeasurementNestedMeasurementsConnectionWhere>;
  OR?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsConnectionWhere>>;
  node?: InputMaybe<PerformanceMeasurementWhere>;
};

export type PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput>>;
  completedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  payload_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  payload_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  startedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PerformanceMeasurementNestedMeasurementsRelationship = {
  __typename?: 'PerformanceMeasurementNestedMeasurementsRelationship';
  cursor: Scalars['String']['output'];
  node: PerformanceMeasurement;
};

export type PerformanceMeasurementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PerformanceMeasurementSort objects to sort PerformanceMeasurements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PerformanceMeasurementSort>>;
};

export type PerformanceMeasurementParentAggregateInput = {
  AND?: InputMaybe<Array<PerformanceMeasurementParentAggregateInput>>;
  NOT?: InputMaybe<PerformanceMeasurementParentAggregateInput>;
  OR?: InputMaybe<Array<PerformanceMeasurementParentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PerformanceMeasurementParentNodeAggregationWhereInput>;
};

export type PerformanceMeasurementParentConnection = {
  __typename?: 'PerformanceMeasurementParentConnection';
  edges: Array<PerformanceMeasurementParentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceMeasurementParentConnectionSort = {
  node?: InputMaybe<PerformanceMeasurementSort>;
};

export type PerformanceMeasurementParentConnectionWhere = {
  AND?: InputMaybe<Array<PerformanceMeasurementParentConnectionWhere>>;
  NOT?: InputMaybe<PerformanceMeasurementParentConnectionWhere>;
  OR?: InputMaybe<Array<PerformanceMeasurementParentConnectionWhere>>;
  node?: InputMaybe<PerformanceMeasurementWhere>;
};

export type PerformanceMeasurementParentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PerformanceMeasurementParentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PerformanceMeasurementParentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PerformanceMeasurementParentNodeAggregationWhereInput>>;
  completedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  payload_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  payload_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  startedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PerformanceMeasurementParentRelationship = {
  __typename?: 'PerformanceMeasurementParentRelationship';
  cursor: Scalars['String']['output'];
  node: PerformanceMeasurement;
};

export type PerformanceMeasurementPerformanceCounterCounterAggregationSelection = {
  __typename?: 'PerformanceMeasurementPerformanceCounterCounterAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection>;
};

export type PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection = {
  __typename?: 'PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection';
  conditions: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection = {
  __typename?: 'PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection>;
};

export type PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection = {
  __typename?: 'PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection';
  completedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  payload: StringAggregateSelectionNullable;
  startedOn: DateTimeAggregateSelectionNonNullable;
};

export type PerformanceMeasurementPerformanceMeasurementParentAggregationSelection = {
  __typename?: 'PerformanceMeasurementPerformanceMeasurementParentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection>;
};

export type PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection = {
  __typename?: 'PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection';
  completedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  payload: StringAggregateSelectionNullable;
  startedOn: DateTimeAggregateSelectionNonNullable;
};

/** Fields to sort PerformanceMeasurements by. The order in which sorts are applied is not guaranteed when specifying many fields in one PerformanceMeasurementSort object. */
export type PerformanceMeasurementSort = {
  completedOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isAverage?: InputMaybe<SortDirection>;
  payload?: InputMaybe<SortDirection>;
  startedOn?: InputMaybe<SortDirection>;
};

export type PerformanceMeasurementWhere = {
  AND?: InputMaybe<Array<PerformanceMeasurementWhere>>;
  NOT?: InputMaybe<PerformanceMeasurementWhere>;
  OR?: InputMaybe<Array<PerformanceMeasurementWhere>>;
  completedOn?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  completedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  counter?: InputMaybe<PerformanceCounterWhere>;
  counterAggregate?: InputMaybe<PerformanceMeasurementCounterAggregateInput>;
  counterConnection?: InputMaybe<PerformanceMeasurementCounterConnectionWhere>;
  counterConnection_NOT?: InputMaybe<PerformanceMeasurementCounterConnectionWhere>;
  counter_NOT?: InputMaybe<PerformanceCounterWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isAverage?: InputMaybe<Scalars['Boolean']['input']>;
  nestedMeasurementsAggregate?: InputMaybe<PerformanceMeasurementNestedMeasurementsAggregateInput>;
  /** Return PerformanceMeasurements where all of the related PerformanceMeasurementNestedMeasurementsConnections match this filter */
  nestedMeasurementsConnection_ALL?: InputMaybe<PerformanceMeasurementNestedMeasurementsConnectionWhere>;
  /** Return PerformanceMeasurements where none of the related PerformanceMeasurementNestedMeasurementsConnections match this filter */
  nestedMeasurementsConnection_NONE?: InputMaybe<PerformanceMeasurementNestedMeasurementsConnectionWhere>;
  /** Return PerformanceMeasurements where one of the related PerformanceMeasurementNestedMeasurementsConnections match this filter */
  nestedMeasurementsConnection_SINGLE?: InputMaybe<PerformanceMeasurementNestedMeasurementsConnectionWhere>;
  /** Return PerformanceMeasurements where some of the related PerformanceMeasurementNestedMeasurementsConnections match this filter */
  nestedMeasurementsConnection_SOME?: InputMaybe<PerformanceMeasurementNestedMeasurementsConnectionWhere>;
  /** Return PerformanceMeasurements where all of the related PerformanceMeasurements match this filter */
  nestedMeasurements_ALL?: InputMaybe<PerformanceMeasurementWhere>;
  /** Return PerformanceMeasurements where none of the related PerformanceMeasurements match this filter */
  nestedMeasurements_NONE?: InputMaybe<PerformanceMeasurementWhere>;
  /** Return PerformanceMeasurements where one of the related PerformanceMeasurements match this filter */
  nestedMeasurements_SINGLE?: InputMaybe<PerformanceMeasurementWhere>;
  /** Return PerformanceMeasurements where some of the related PerformanceMeasurements match this filter */
  nestedMeasurements_SOME?: InputMaybe<PerformanceMeasurementWhere>;
  parent?: InputMaybe<PerformanceMeasurementWhere>;
  parentAggregate?: InputMaybe<PerformanceMeasurementParentAggregateInput>;
  parentConnection?: InputMaybe<PerformanceMeasurementParentConnectionWhere>;
  parentConnection_NOT?: InputMaybe<PerformanceMeasurementParentConnectionWhere>;
  parent_NOT?: InputMaybe<PerformanceMeasurementWhere>;
  payload?: InputMaybe<Scalars['String']['input']>;
  payload_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  payload_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  payload_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payload_MATCHES?: InputMaybe<Scalars['String']['input']>;
  payload_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  startedOn?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PerformanceMeasurementsConnection = {
  __typename?: 'PerformanceMeasurementsConnection';
  edges: Array<PerformanceMeasurementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceThreshold = {
  __typename?: 'PerformanceThreshold';
  conditions?: Maybe<Scalars['String']['output']>;
  counter: PerformanceCounter;
  counterAggregate?: Maybe<PerformanceThresholdPerformanceCounterCounterAggregationSelection>;
  counterConnection: PerformanceThresholdCounterConnection;
  dataSizeQuotient?: Maybe<Scalars['String']['output']>;
  notifiedUsers: Array<User>;
  notifiedUsersAggregate?: Maybe<PerformanceThresholdUserNotifiedUsersAggregationSelection>;
  notifiedUsersConnection: PerformanceThresholdNotifiedUsersConnection;
  percentage?: Maybe<Scalars['Int']['output']>;
  property?: Maybe<Scalars['String']['output']>;
};


export type PerformanceThresholdCounterArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PerformanceCounterOptions>;
  where?: InputMaybe<PerformanceCounterWhere>;
};


export type PerformanceThresholdCounterAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PerformanceCounterWhere>;
};


export type PerformanceThresholdCounterConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformanceThresholdCounterConnectionSort>>;
  where?: InputMaybe<PerformanceThresholdCounterConnectionWhere>;
};


export type PerformanceThresholdNotifiedUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type PerformanceThresholdNotifiedUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type PerformanceThresholdNotifiedUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformanceThresholdNotifiedUsersConnectionSort>>;
  where?: InputMaybe<PerformanceThresholdNotifiedUsersConnectionWhere>;
};

export type PerformanceThresholdCounterAggregateInput = {
  AND?: InputMaybe<Array<PerformanceThresholdCounterAggregateInput>>;
  NOT?: InputMaybe<PerformanceThresholdCounterAggregateInput>;
  OR?: InputMaybe<Array<PerformanceThresholdCounterAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PerformanceThresholdCounterNodeAggregationWhereInput>;
};

export type PerformanceThresholdCounterConnection = {
  __typename?: 'PerformanceThresholdCounterConnection';
  edges: Array<PerformanceThresholdCounterRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceThresholdCounterConnectionSort = {
  node?: InputMaybe<PerformanceCounterSort>;
};

export type PerformanceThresholdCounterConnectionWhere = {
  AND?: InputMaybe<Array<PerformanceThresholdCounterConnectionWhere>>;
  NOT?: InputMaybe<PerformanceThresholdCounterConnectionWhere>;
  OR?: InputMaybe<Array<PerformanceThresholdCounterConnectionWhere>>;
  node?: InputMaybe<PerformanceCounterWhere>;
};

export type PerformanceThresholdCounterNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PerformanceThresholdCounterNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PerformanceThresholdCounterNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PerformanceThresholdCounterNodeAggregationWhereInput>>;
  conditions_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  conditions_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformanceThresholdCounterRelationship = {
  __typename?: 'PerformanceThresholdCounterRelationship';
  cursor: Scalars['String']['output'];
  node: PerformanceCounter;
};

export type PerformanceThresholdEdge = {
  __typename?: 'PerformanceThresholdEdge';
  cursor: Scalars['String']['output'];
  node: PerformanceThreshold;
};

export type PerformanceThresholdInput = {
  counterType: Scalars['String']['input'];
  dataSizeQuotient?: InputMaybe<Scalars['String']['input']>;
  notifiedUserIds: Array<Scalars['ID']['input']>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
};

export type PerformanceThresholdNotifiedUsersAggregateInput = {
  AND?: InputMaybe<Array<PerformanceThresholdNotifiedUsersAggregateInput>>;
  NOT?: InputMaybe<PerformanceThresholdNotifiedUsersAggregateInput>;
  OR?: InputMaybe<Array<PerformanceThresholdNotifiedUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PerformanceThresholdNotifiedUsersNodeAggregationWhereInput>;
};

export type PerformanceThresholdNotifiedUsersConnection = {
  __typename?: 'PerformanceThresholdNotifiedUsersConnection';
  edges: Array<PerformanceThresholdNotifiedUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceThresholdNotifiedUsersConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type PerformanceThresholdNotifiedUsersConnectionWhere = {
  AND?: InputMaybe<Array<PerformanceThresholdNotifiedUsersConnectionWhere>>;
  NOT?: InputMaybe<PerformanceThresholdNotifiedUsersConnectionWhere>;
  OR?: InputMaybe<Array<PerformanceThresholdNotifiedUsersConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type PerformanceThresholdNotifiedUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PerformanceThresholdNotifiedUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PerformanceThresholdNotifiedUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PerformanceThresholdNotifiedUsersNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformanceThresholdNotifiedUsersRelationship = {
  __typename?: 'PerformanceThresholdNotifiedUsersRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type PerformanceThresholdOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PerformanceThresholdSort objects to sort PerformanceThresholds by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PerformanceThresholdSort>>;
};

export type PerformanceThresholdPerformanceCounterCounterAggregationSelection = {
  __typename?: 'PerformanceThresholdPerformanceCounterCounterAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection>;
};

export type PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection = {
  __typename?: 'PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection';
  conditions: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

/** Fields to sort PerformanceThresholds by. The order in which sorts are applied is not guaranteed when specifying many fields in one PerformanceThresholdSort object. */
export type PerformanceThresholdSort = {
  conditions?: InputMaybe<SortDirection>;
  dataSizeQuotient?: InputMaybe<SortDirection>;
  percentage?: InputMaybe<SortDirection>;
  property?: InputMaybe<SortDirection>;
};

export type PerformanceThresholdUserNotifiedUsersAggregationSelection = {
  __typename?: 'PerformanceThresholdUserNotifiedUsersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PerformanceThresholdUserNotifiedUsersNodeAggregateSelection>;
};

export type PerformanceThresholdUserNotifiedUsersNodeAggregateSelection = {
  __typename?: 'PerformanceThresholdUserNotifiedUsersNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type PerformanceThresholdWhere = {
  AND?: InputMaybe<Array<PerformanceThresholdWhere>>;
  NOT?: InputMaybe<PerformanceThresholdWhere>;
  OR?: InputMaybe<Array<PerformanceThresholdWhere>>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  conditions_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  conditions_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  conditions_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  conditions_MATCHES?: InputMaybe<Scalars['String']['input']>;
  conditions_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<PerformanceCounterWhere>;
  counterAggregate?: InputMaybe<PerformanceThresholdCounterAggregateInput>;
  counterConnection?: InputMaybe<PerformanceThresholdCounterConnectionWhere>;
  counterConnection_NOT?: InputMaybe<PerformanceThresholdCounterConnectionWhere>;
  counter_NOT?: InputMaybe<PerformanceCounterWhere>;
  dataSizeQuotient?: InputMaybe<Scalars['String']['input']>;
  dataSizeQuotient_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  dataSizeQuotient_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  dataSizeQuotient_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataSizeQuotient_MATCHES?: InputMaybe<Scalars['String']['input']>;
  dataSizeQuotient_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notifiedUsersAggregate?: InputMaybe<PerformanceThresholdNotifiedUsersAggregateInput>;
  /** Return PerformanceThresholds where all of the related PerformanceThresholdNotifiedUsersConnections match this filter */
  notifiedUsersConnection_ALL?: InputMaybe<PerformanceThresholdNotifiedUsersConnectionWhere>;
  /** Return PerformanceThresholds where none of the related PerformanceThresholdNotifiedUsersConnections match this filter */
  notifiedUsersConnection_NONE?: InputMaybe<PerformanceThresholdNotifiedUsersConnectionWhere>;
  /** Return PerformanceThresholds where one of the related PerformanceThresholdNotifiedUsersConnections match this filter */
  notifiedUsersConnection_SINGLE?: InputMaybe<PerformanceThresholdNotifiedUsersConnectionWhere>;
  /** Return PerformanceThresholds where some of the related PerformanceThresholdNotifiedUsersConnections match this filter */
  notifiedUsersConnection_SOME?: InputMaybe<PerformanceThresholdNotifiedUsersConnectionWhere>;
  /** Return PerformanceThresholds where all of the related Users match this filter */
  notifiedUsers_ALL?: InputMaybe<UserWhere>;
  /** Return PerformanceThresholds where none of the related Users match this filter */
  notifiedUsers_NONE?: InputMaybe<UserWhere>;
  /** Return PerformanceThresholds where one of the related Users match this filter */
  notifiedUsers_SINGLE?: InputMaybe<UserWhere>;
  /** Return PerformanceThresholds where some of the related Users match this filter */
  notifiedUsers_SOME?: InputMaybe<UserWhere>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  percentage_GT?: InputMaybe<Scalars['Int']['input']>;
  percentage_GTE?: InputMaybe<Scalars['Int']['input']>;
  percentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  percentage_LT?: InputMaybe<Scalars['Int']['input']>;
  percentage_LTE?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
  property_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  property_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  property_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property_MATCHES?: InputMaybe<Scalars['String']['input']>;
  property_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PerformanceThresholdsConnection = {
  __typename?: 'PerformanceThresholdsConnection';
  edges: Array<PerformanceThresholdEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PgBossMetrics = {
  __typename?: 'PgBossMetrics';
  maintenanceSecondsAgo?: Maybe<Scalars['Float']['output']>;
  maintenanceStatus: Scalars['String']['output'];
  overallStatus: Scalars['String']['output'];
  queues: Array<PgBossQueueStat>;
  sampledAt: Scalars['Float']['output'];
};

export type PgBossMetricsConnection = {
  __typename?: 'PgBossMetricsConnection';
  edges: Array<PgBossMetricsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PgBossMetricsEdge = {
  __typename?: 'PgBossMetricsEdge';
  cursor: Scalars['String']['output'];
  node: PgBossMetrics;
};

export type PgBossMetricsOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PgBossMetricsSort objects to sort PgBossMetrics by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PgBossMetricsSort>>;
};

/** Fields to sort PgBossMetrics by. The order in which sorts are applied is not guaranteed when specifying many fields in one PgBossMetricsSort object. */
export type PgBossMetricsSort = {
  maintenanceSecondsAgo?: InputMaybe<SortDirection>;
  maintenanceStatus?: InputMaybe<SortDirection>;
  overallStatus?: InputMaybe<SortDirection>;
  sampledAt?: InputMaybe<SortDirection>;
};

export type PgBossMetricsWhere = {
  AND?: InputMaybe<Array<PgBossMetricsWhere>>;
  NOT?: InputMaybe<PgBossMetricsWhere>;
  OR?: InputMaybe<Array<PgBossMetricsWhere>>;
  maintenanceSecondsAgo?: InputMaybe<Scalars['Float']['input']>;
  maintenanceSecondsAgo_GT?: InputMaybe<Scalars['Float']['input']>;
  maintenanceSecondsAgo_GTE?: InputMaybe<Scalars['Float']['input']>;
  maintenanceSecondsAgo_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  maintenanceSecondsAgo_LT?: InputMaybe<Scalars['Float']['input']>;
  maintenanceSecondsAgo_LTE?: InputMaybe<Scalars['Float']['input']>;
  maintenanceStatus?: InputMaybe<Scalars['String']['input']>;
  maintenanceStatus_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  maintenanceStatus_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  maintenanceStatus_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  maintenanceStatus_MATCHES?: InputMaybe<Scalars['String']['input']>;
  maintenanceStatus_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  overallStatus?: InputMaybe<Scalars['String']['input']>;
  overallStatus_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  overallStatus_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  overallStatus_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  overallStatus_MATCHES?: InputMaybe<Scalars['String']['input']>;
  overallStatus_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sampledAt?: InputMaybe<Scalars['Float']['input']>;
  sampledAt_GT?: InputMaybe<Scalars['Float']['input']>;
  sampledAt_GTE?: InputMaybe<Scalars['Float']['input']>;
  sampledAt_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  sampledAt_LT?: InputMaybe<Scalars['Float']['input']>;
  sampledAt_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type PgBossQueueStat = {
  __typename?: 'PgBossQueueStat';
  active: Scalars['Int']['output'];
  backlog: Scalars['Int']['output'];
  queue: Scalars['String']['output'];
  recentFailures: Scalars['Int']['output'];
  stale: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type PgBossQueueStatEdge = {
  __typename?: 'PgBossQueueStatEdge';
  cursor: Scalars['String']['output'];
  node: PgBossQueueStat;
};

export type PgBossQueueStatOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PgBossQueueStatSort objects to sort PgBossQueueStats by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PgBossQueueStatSort>>;
};

/** Fields to sort PgBossQueueStats by. The order in which sorts are applied is not guaranteed when specifying many fields in one PgBossQueueStatSort object. */
export type PgBossQueueStatSort = {
  active?: InputMaybe<SortDirection>;
  backlog?: InputMaybe<SortDirection>;
  queue?: InputMaybe<SortDirection>;
  recentFailures?: InputMaybe<SortDirection>;
  stale?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type PgBossQueueStatWhere = {
  AND?: InputMaybe<Array<PgBossQueueStatWhere>>;
  NOT?: InputMaybe<PgBossQueueStatWhere>;
  OR?: InputMaybe<Array<PgBossQueueStatWhere>>;
  active?: InputMaybe<Scalars['Int']['input']>;
  active_GT?: InputMaybe<Scalars['Int']['input']>;
  active_GTE?: InputMaybe<Scalars['Int']['input']>;
  active_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  active_LT?: InputMaybe<Scalars['Int']['input']>;
  active_LTE?: InputMaybe<Scalars['Int']['input']>;
  backlog?: InputMaybe<Scalars['Int']['input']>;
  backlog_GT?: InputMaybe<Scalars['Int']['input']>;
  backlog_GTE?: InputMaybe<Scalars['Int']['input']>;
  backlog_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  backlog_LT?: InputMaybe<Scalars['Int']['input']>;
  backlog_LTE?: InputMaybe<Scalars['Int']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  queue_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  queue_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  queue_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  queue_MATCHES?: InputMaybe<Scalars['String']['input']>;
  queue_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  recentFailures?: InputMaybe<Scalars['Int']['input']>;
  recentFailures_GT?: InputMaybe<Scalars['Int']['input']>;
  recentFailures_GTE?: InputMaybe<Scalars['Int']['input']>;
  recentFailures_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  recentFailures_LT?: InputMaybe<Scalars['Int']['input']>;
  recentFailures_LTE?: InputMaybe<Scalars['Int']['input']>;
  stale?: InputMaybe<Scalars['Int']['input']>;
  stale_GT?: InputMaybe<Scalars['Int']['input']>;
  stale_GTE?: InputMaybe<Scalars['Int']['input']>;
  stale_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  stale_LT?: InputMaybe<Scalars['Int']['input']>;
  stale_LTE?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  status_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  status_MATCHES?: InputMaybe<Scalars['String']['input']>;
  status_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PgBossQueueStatsConnection = {
  __typename?: 'PgBossQueueStatsConnection';
  edges: Array<PgBossQueueStatEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum Platform {
  LyfegenPlatform = 'LYFEGEN_PLATFORM',
  PlatformEmail = 'PLATFORM_EMAIL'
}

export type PolicyType = {
  __typename?: 'PolicyType';
  type: Scalars['String']['output'];
  versions: Array<PolicyVersion>;
  versionsAggregate?: Maybe<PolicyTypePolicyVersionVersionsAggregationSelection>;
  versionsConnection: PolicyTypeVersionsConnection;
};


export type PolicyTypeVersionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PolicyVersionOptions>;
  where?: InputMaybe<PolicyVersionWhere>;
};


export type PolicyTypeVersionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PolicyVersionWhere>;
};


export type PolicyTypeVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PolicyTypeVersionsConnectionSort>>;
  where?: InputMaybe<PolicyTypeVersionsConnectionWhere>;
};

export type PolicyTypeEdge = {
  __typename?: 'PolicyTypeEdge';
  cursor: Scalars['String']['output'];
  node: PolicyType;
};

export type PolicyTypeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PolicyTypeSort objects to sort PolicyTypes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PolicyTypeSort>>;
};

export type PolicyTypePolicyVersionVersionsAggregationSelection = {
  __typename?: 'PolicyTypePolicyVersionVersionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PolicyTypePolicyVersionVersionsNodeAggregateSelection>;
};

export type PolicyTypePolicyVersionVersionsNodeAggregateSelection = {
  __typename?: 'PolicyTypePolicyVersionVersionsNodeAggregateSelection';
  editedBy: StringAggregateSelectionNonNullable;
  editedDate: FloatAggregateSelectionNonNullable;
  text: StringAggregateSelectionNonNullable;
  type: StringAggregateSelectionNonNullable;
};

/** Fields to sort PolicyTypes by. The order in which sorts are applied is not guaranteed when specifying many fields in one PolicyTypeSort object. */
export type PolicyTypeSort = {
  type?: InputMaybe<SortDirection>;
};

export type PolicyTypeVersionsAggregateInput = {
  AND?: InputMaybe<Array<PolicyTypeVersionsAggregateInput>>;
  NOT?: InputMaybe<PolicyTypeVersionsAggregateInput>;
  OR?: InputMaybe<Array<PolicyTypeVersionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PolicyTypeVersionsNodeAggregationWhereInput>;
};

export type PolicyTypeVersionsConnection = {
  __typename?: 'PolicyTypeVersionsConnection';
  edges: Array<PolicyTypeVersionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PolicyTypeVersionsConnectionSort = {
  node?: InputMaybe<PolicyVersionSort>;
};

export type PolicyTypeVersionsConnectionWhere = {
  AND?: InputMaybe<Array<PolicyTypeVersionsConnectionWhere>>;
  NOT?: InputMaybe<PolicyTypeVersionsConnectionWhere>;
  OR?: InputMaybe<Array<PolicyTypeVersionsConnectionWhere>>;
  node?: InputMaybe<PolicyVersionWhere>;
};

export type PolicyTypeVersionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PolicyTypeVersionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PolicyTypeVersionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PolicyTypeVersionsNodeAggregationWhereInput>>;
  editedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  editedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  editedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  editedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  editedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  editedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  editedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  editedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  editedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  editedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  editedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  editedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  editedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  editedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  editedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  editedDate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  editedDate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  editedDate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  editedDate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  editedDate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  editedDate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  editedDate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  editedDate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  editedDate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  editedDate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  editedDate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  editedDate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  editedDate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  editedDate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  editedDate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  editedDate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  editedDate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  editedDate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  editedDate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  editedDate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PolicyTypeVersionsRelationship = {
  __typename?: 'PolicyTypeVersionsRelationship';
  cursor: Scalars['String']['output'];
  node: PolicyVersion;
};

export type PolicyTypeWhere = {
  AND?: InputMaybe<Array<PolicyTypeWhere>>;
  NOT?: InputMaybe<PolicyTypeWhere>;
  OR?: InputMaybe<Array<PolicyTypeWhere>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_MATCHES?: InputMaybe<Scalars['String']['input']>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  versionsAggregate?: InputMaybe<PolicyTypeVersionsAggregateInput>;
  /** Return PolicyTypes where all of the related PolicyTypeVersionsConnections match this filter */
  versionsConnection_ALL?: InputMaybe<PolicyTypeVersionsConnectionWhere>;
  /** Return PolicyTypes where none of the related PolicyTypeVersionsConnections match this filter */
  versionsConnection_NONE?: InputMaybe<PolicyTypeVersionsConnectionWhere>;
  /** Return PolicyTypes where one of the related PolicyTypeVersionsConnections match this filter */
  versionsConnection_SINGLE?: InputMaybe<PolicyTypeVersionsConnectionWhere>;
  /** Return PolicyTypes where some of the related PolicyTypeVersionsConnections match this filter */
  versionsConnection_SOME?: InputMaybe<PolicyTypeVersionsConnectionWhere>;
  /** Return PolicyTypes where all of the related PolicyVersions match this filter */
  versions_ALL?: InputMaybe<PolicyVersionWhere>;
  /** Return PolicyTypes where none of the related PolicyVersions match this filter */
  versions_NONE?: InputMaybe<PolicyVersionWhere>;
  /** Return PolicyTypes where one of the related PolicyVersions match this filter */
  versions_SINGLE?: InputMaybe<PolicyVersionWhere>;
  /** Return PolicyTypes where some of the related PolicyVersions match this filter */
  versions_SOME?: InputMaybe<PolicyVersionWhere>;
};

export type PolicyTypesConnection = {
  __typename?: 'PolicyTypesConnection';
  edges: Array<PolicyTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PolicyVersion = {
  __typename?: 'PolicyVersion';
  editedBy: Scalars['String']['output'];
  editedDate: Scalars['Float']['output'];
  isLastVersion?: Maybe<Scalars['Boolean']['output']>;
  policyType: PolicyType;
  policyTypeAggregate?: Maybe<PolicyVersionPolicyTypePolicyTypeAggregationSelection>;
  policyTypeConnection: PolicyVersionPolicyTypeConnection;
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};


export type PolicyVersionPolicyTypeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PolicyTypeOptions>;
  where?: InputMaybe<PolicyTypeWhere>;
};


export type PolicyVersionPolicyTypeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PolicyTypeWhere>;
};


export type PolicyVersionPolicyTypeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PolicyVersionPolicyTypeConnectionSort>>;
  where?: InputMaybe<PolicyVersionPolicyTypeConnectionWhere>;
};

export type PolicyVersionEdge = {
  __typename?: 'PolicyVersionEdge';
  cursor: Scalars['String']['output'];
  node: PolicyVersion;
};

export type PolicyVersionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PolicyVersionSort objects to sort PolicyVersions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PolicyVersionSort>>;
};

export type PolicyVersionPolicyTypeAggregateInput = {
  AND?: InputMaybe<Array<PolicyVersionPolicyTypeAggregateInput>>;
  NOT?: InputMaybe<PolicyVersionPolicyTypeAggregateInput>;
  OR?: InputMaybe<Array<PolicyVersionPolicyTypeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PolicyVersionPolicyTypeNodeAggregationWhereInput>;
};

export type PolicyVersionPolicyTypeConnection = {
  __typename?: 'PolicyVersionPolicyTypeConnection';
  edges: Array<PolicyVersionPolicyTypeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PolicyVersionPolicyTypeConnectionSort = {
  node?: InputMaybe<PolicyTypeSort>;
};

export type PolicyVersionPolicyTypeConnectionWhere = {
  AND?: InputMaybe<Array<PolicyVersionPolicyTypeConnectionWhere>>;
  NOT?: InputMaybe<PolicyVersionPolicyTypeConnectionWhere>;
  OR?: InputMaybe<Array<PolicyVersionPolicyTypeConnectionWhere>>;
  node?: InputMaybe<PolicyTypeWhere>;
};

export type PolicyVersionPolicyTypeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PolicyVersionPolicyTypeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PolicyVersionPolicyTypeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PolicyVersionPolicyTypeNodeAggregationWhereInput>>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PolicyVersionPolicyTypePolicyTypeAggregationSelection = {
  __typename?: 'PolicyVersionPolicyTypePolicyTypeAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PolicyVersionPolicyTypePolicyTypeNodeAggregateSelection>;
};

export type PolicyVersionPolicyTypePolicyTypeNodeAggregateSelection = {
  __typename?: 'PolicyVersionPolicyTypePolicyTypeNodeAggregateSelection';
  type: StringAggregateSelectionNonNullable;
};

export type PolicyVersionPolicyTypeRelationship = {
  __typename?: 'PolicyVersionPolicyTypeRelationship';
  cursor: Scalars['String']['output'];
  node: PolicyType;
};

/** Fields to sort PolicyVersions by. The order in which sorts are applied is not guaranteed when specifying many fields in one PolicyVersionSort object. */
export type PolicyVersionSort = {
  editedBy?: InputMaybe<SortDirection>;
  editedDate?: InputMaybe<SortDirection>;
  isLastVersion?: InputMaybe<SortDirection>;
  text?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type PolicyVersionWhere = {
  AND?: InputMaybe<Array<PolicyVersionWhere>>;
  NOT?: InputMaybe<PolicyVersionWhere>;
  OR?: InputMaybe<Array<PolicyVersionWhere>>;
  editedBy?: InputMaybe<Scalars['String']['input']>;
  editedBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  editedBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  editedBy_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  editedBy_MATCHES?: InputMaybe<Scalars['String']['input']>;
  editedBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  editedDate?: InputMaybe<Scalars['Float']['input']>;
  editedDate_GT?: InputMaybe<Scalars['Float']['input']>;
  editedDate_GTE?: InputMaybe<Scalars['Float']['input']>;
  editedDate_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  editedDate_LT?: InputMaybe<Scalars['Float']['input']>;
  editedDate_LTE?: InputMaybe<Scalars['Float']['input']>;
  isLastVersion?: InputMaybe<Scalars['Boolean']['input']>;
  policyType?: InputMaybe<PolicyTypeWhere>;
  policyTypeAggregate?: InputMaybe<PolicyVersionPolicyTypeAggregateInput>;
  policyTypeConnection?: InputMaybe<PolicyVersionPolicyTypeConnectionWhere>;
  policyTypeConnection_NOT?: InputMaybe<PolicyVersionPolicyTypeConnectionWhere>;
  policyType_NOT?: InputMaybe<PolicyTypeWhere>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  text_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  text_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  text_MATCHES?: InputMaybe<Scalars['String']['input']>;
  text_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_MATCHES?: InputMaybe<Scalars['String']['input']>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PolicyVersionsConnection = {
  __typename?: 'PolicyVersionsConnection';
  edges: Array<PolicyVersionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostgresMetric = {
  __typename?: 'PostgresMetric';
  commitRatePerSecond?: Maybe<Scalars['Float']['output']>;
  database?: Maybe<Scalars['String']['output']>;
  numBackends?: Maybe<Scalars['Int']['output']>;
  rollbackRatePerSecond?: Maybe<Scalars['Float']['output']>;
  sampledAt?: Maybe<Scalars['Float']['output']>;
  xactCommitCumulative?: Maybe<Scalars['Float']['output']>;
  xactRollbackCumulative?: Maybe<Scalars['Float']['output']>;
};

export type PostgresMetricEdge = {
  __typename?: 'PostgresMetricEdge';
  cursor: Scalars['String']['output'];
  node: PostgresMetric;
};

export type PostgresMetricOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PostgresMetricSort objects to sort PostgresMetrics by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PostgresMetricSort>>;
};

/** Fields to sort PostgresMetrics by. The order in which sorts are applied is not guaranteed when specifying many fields in one PostgresMetricSort object. */
export type PostgresMetricSort = {
  commitRatePerSecond?: InputMaybe<SortDirection>;
  database?: InputMaybe<SortDirection>;
  numBackends?: InputMaybe<SortDirection>;
  rollbackRatePerSecond?: InputMaybe<SortDirection>;
  sampledAt?: InputMaybe<SortDirection>;
  xactCommitCumulative?: InputMaybe<SortDirection>;
  xactRollbackCumulative?: InputMaybe<SortDirection>;
};

export type PostgresMetricWhere = {
  AND?: InputMaybe<Array<PostgresMetricWhere>>;
  NOT?: InputMaybe<PostgresMetricWhere>;
  OR?: InputMaybe<Array<PostgresMetricWhere>>;
  commitRatePerSecond?: InputMaybe<Scalars['Float']['input']>;
  commitRatePerSecond_GT?: InputMaybe<Scalars['Float']['input']>;
  commitRatePerSecond_GTE?: InputMaybe<Scalars['Float']['input']>;
  commitRatePerSecond_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  commitRatePerSecond_LT?: InputMaybe<Scalars['Float']['input']>;
  commitRatePerSecond_LTE?: InputMaybe<Scalars['Float']['input']>;
  database?: InputMaybe<Scalars['String']['input']>;
  database_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  database_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  database_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  database_MATCHES?: InputMaybe<Scalars['String']['input']>;
  database_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  numBackends?: InputMaybe<Scalars['Int']['input']>;
  numBackends_GT?: InputMaybe<Scalars['Int']['input']>;
  numBackends_GTE?: InputMaybe<Scalars['Int']['input']>;
  numBackends_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numBackends_LT?: InputMaybe<Scalars['Int']['input']>;
  numBackends_LTE?: InputMaybe<Scalars['Int']['input']>;
  rollbackRatePerSecond?: InputMaybe<Scalars['Float']['input']>;
  rollbackRatePerSecond_GT?: InputMaybe<Scalars['Float']['input']>;
  rollbackRatePerSecond_GTE?: InputMaybe<Scalars['Float']['input']>;
  rollbackRatePerSecond_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  rollbackRatePerSecond_LT?: InputMaybe<Scalars['Float']['input']>;
  rollbackRatePerSecond_LTE?: InputMaybe<Scalars['Float']['input']>;
  sampledAt?: InputMaybe<Scalars['Float']['input']>;
  sampledAt_GT?: InputMaybe<Scalars['Float']['input']>;
  sampledAt_GTE?: InputMaybe<Scalars['Float']['input']>;
  sampledAt_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sampledAt_LT?: InputMaybe<Scalars['Float']['input']>;
  sampledAt_LTE?: InputMaybe<Scalars['Float']['input']>;
  xactCommitCumulative?: InputMaybe<Scalars['Float']['input']>;
  xactCommitCumulative_GT?: InputMaybe<Scalars['Float']['input']>;
  xactCommitCumulative_GTE?: InputMaybe<Scalars['Float']['input']>;
  xactCommitCumulative_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  xactCommitCumulative_LT?: InputMaybe<Scalars['Float']['input']>;
  xactCommitCumulative_LTE?: InputMaybe<Scalars['Float']['input']>;
  xactRollbackCumulative?: InputMaybe<Scalars['Float']['input']>;
  xactRollbackCumulative_GT?: InputMaybe<Scalars['Float']['input']>;
  xactRollbackCumulative_GTE?: InputMaybe<Scalars['Float']['input']>;
  xactRollbackCumulative_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  xactRollbackCumulative_LT?: InputMaybe<Scalars['Float']['input']>;
  xactRollbackCumulative_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type PostgresMetricsConnection = {
  __typename?: 'PostgresMetricsConnection';
  edges: Array<PostgresMetricEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Preparation = {
  __typename?: 'Preparation';
  AtcCode?: Maybe<Scalars['String']['output']>;
  BrandName: Scalars['String']['output'];
  DescriptionDe?: Maybe<Scalars['String']['output']>;
  DescriptionFr?: Maybe<Scalars['String']['output']>;
  DescriptionIt?: Maybe<Scalars['String']['output']>;
  GenericName?: Maybe<Scalars['String']['output']>;
  ReleaseDate?: Maybe<Scalars['Date']['output']>;
  SubjectMatter: AgreementSubjectMatter;
  SwissmedicNo5?: Maybe<Scalars['String']['output']>;
  brand: Brand;
  brandAggregate?: Maybe<PreparationBrandBrandAggregationSelection>;
  brandConnection: PreparationBrandConnection;
  countries: Array<Country>;
  countriesAggregate?: Maybe<PreparationCountryCountriesAggregationSelection>;
  countriesConnection: PreparationCountriesConnection;
  generic?: Maybe<Generic>;
  genericAggregate?: Maybe<PreparationGenericGenericAggregationSelection>;
  genericConnection: PreparationGenericConnection;
  hasLimitation: Scalars['Boolean']['output'];
  hasLimitations: Array<Limitation>;
  hasLimitationsAggregate?: Maybe<PreparationLimitationHasLimitationsAggregationSelection>;
  hasLimitationsConnection: PreparationHasLimitationsConnection;
  id: Scalars['ID']['output'];
  regulates: Array<Treatment>;
  regulatesAggregate?: Maybe<PreparationTreatmentRegulatesAggregationSelection>;
  regulatesConnection: PreparationRegulatesConnection;
};


export type PreparationBrandArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type PreparationBrandAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type PreparationBrandConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PreparationBrandConnectionSort>>;
  where?: InputMaybe<PreparationBrandConnectionWhere>;
};


export type PreparationCountriesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type PreparationCountriesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type PreparationCountriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PreparationCountriesConnectionSort>>;
  where?: InputMaybe<PreparationCountriesConnectionWhere>;
};


export type PreparationGenericArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type PreparationGenericAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type PreparationGenericConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PreparationGenericConnectionSort>>;
  where?: InputMaybe<PreparationGenericConnectionWhere>;
};


export type PreparationHasLimitationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LimitationOptions>;
  where?: InputMaybe<LimitationWhere>;
};


export type PreparationHasLimitationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LimitationWhere>;
};


export type PreparationHasLimitationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PreparationHasLimitationsConnectionSort>>;
  where?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
};


export type PreparationRegulatesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type PreparationRegulatesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type PreparationRegulatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PreparationRegulatesConnectionSort>>;
  where?: InputMaybe<PreparationRegulatesConnectionWhere>;
};

export type PreparationBrandAggregateInput = {
  AND?: InputMaybe<Array<PreparationBrandAggregateInput>>;
  NOT?: InputMaybe<PreparationBrandAggregateInput>;
  OR?: InputMaybe<Array<PreparationBrandAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PreparationBrandNodeAggregationWhereInput>;
};

export type PreparationBrandBrandAggregationSelection = {
  __typename?: 'PreparationBrandBrandAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PreparationBrandBrandNodeAggregateSelection>;
};

export type PreparationBrandBrandNodeAggregateSelection = {
  __typename?: 'PreparationBrandBrandNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type PreparationBrandConnection = {
  __typename?: 'PreparationBrandConnection';
  edges: Array<PreparationBrandRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationBrandConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type PreparationBrandConnectionWhere = {
  AND?: InputMaybe<Array<PreparationBrandConnectionWhere>>;
  NOT?: InputMaybe<PreparationBrandConnectionWhere>;
  OR?: InputMaybe<Array<PreparationBrandConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type PreparationBrandNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PreparationBrandNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PreparationBrandNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PreparationBrandNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PreparationBrandRelationship = {
  __typename?: 'PreparationBrandRelationship';
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type PreparationCountriesAggregateInput = {
  AND?: InputMaybe<Array<PreparationCountriesAggregateInput>>;
  NOT?: InputMaybe<PreparationCountriesAggregateInput>;
  OR?: InputMaybe<Array<PreparationCountriesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PreparationCountriesNodeAggregationWhereInput>;
};

export type PreparationCountriesConnection = {
  __typename?: 'PreparationCountriesConnection';
  edges: Array<PreparationCountriesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationCountriesConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type PreparationCountriesConnectionWhere = {
  AND?: InputMaybe<Array<PreparationCountriesConnectionWhere>>;
  NOT?: InputMaybe<PreparationCountriesConnectionWhere>;
  OR?: InputMaybe<Array<PreparationCountriesConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type PreparationCountriesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PreparationCountriesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PreparationCountriesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PreparationCountriesNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PreparationCountriesRelationship = {
  __typename?: 'PreparationCountriesRelationship';
  cursor: Scalars['String']['output'];
  node: Country;
};

export type PreparationCountryCountriesAggregationSelection = {
  __typename?: 'PreparationCountryCountriesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PreparationCountryCountriesNodeAggregateSelection>;
};

export type PreparationCountryCountriesNodeAggregateSelection = {
  __typename?: 'PreparationCountryCountriesNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type PreparationEdge = {
  __typename?: 'PreparationEdge';
  cursor: Scalars['String']['output'];
  node: Preparation;
};

export type PreparationGenericAggregateInput = {
  AND?: InputMaybe<Array<PreparationGenericAggregateInput>>;
  NOT?: InputMaybe<PreparationGenericAggregateInput>;
  OR?: InputMaybe<Array<PreparationGenericAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PreparationGenericNodeAggregationWhereInput>;
};

export type PreparationGenericConnection = {
  __typename?: 'PreparationGenericConnection';
  edges: Array<PreparationGenericRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationGenericConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type PreparationGenericConnectionWhere = {
  AND?: InputMaybe<Array<PreparationGenericConnectionWhere>>;
  NOT?: InputMaybe<PreparationGenericConnectionWhere>;
  OR?: InputMaybe<Array<PreparationGenericConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type PreparationGenericGenericAggregationSelection = {
  __typename?: 'PreparationGenericGenericAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PreparationGenericGenericNodeAggregateSelection>;
};

export type PreparationGenericGenericNodeAggregateSelection = {
  __typename?: 'PreparationGenericGenericNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type PreparationGenericNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PreparationGenericNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PreparationGenericNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PreparationGenericNodeAggregationWhereInput>>;
};

export type PreparationGenericRelationship = {
  __typename?: 'PreparationGenericRelationship';
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type PreparationHasLimitationsAggregateInput = {
  AND?: InputMaybe<Array<PreparationHasLimitationsAggregateInput>>;
  NOT?: InputMaybe<PreparationHasLimitationsAggregateInput>;
  OR?: InputMaybe<Array<PreparationHasLimitationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PreparationHasLimitationsNodeAggregationWhereInput>;
};

export type PreparationHasLimitationsConnection = {
  __typename?: 'PreparationHasLimitationsConnection';
  edges: Array<PreparationHasLimitationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationHasLimitationsConnectionSort = {
  node?: InputMaybe<LimitationSort>;
};

export type PreparationHasLimitationsConnectionWhere = {
  AND?: InputMaybe<Array<PreparationHasLimitationsConnectionWhere>>;
  NOT?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
  OR?: InputMaybe<Array<PreparationHasLimitationsConnectionWhere>>;
  node?: InputMaybe<LimitationWhere>;
};

export type PreparationHasLimitationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PreparationHasLimitationsNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<PreparationHasLimitationsNodeAggregationWhereInput>;
  Niveau_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PreparationHasLimitationsNodeAggregationWhereInput>>;
  Type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PreparationHasLimitationsRelationship = {
  __typename?: 'PreparationHasLimitationsRelationship';
  cursor: Scalars['String']['output'];
  node: Limitation;
};

export type PreparationInput = {
  AtcCode: Scalars['String']['input'];
  BrandName: Scalars['String']['input'];
  GenericName?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isToBeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  treatments?: InputMaybe<Array<TreatmentInput>>;
};

export type PreparationLimitationHasLimitationsAggregationSelection = {
  __typename?: 'PreparationLimitationHasLimitationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PreparationLimitationHasLimitationsNodeAggregateSelection>;
};

export type PreparationLimitationHasLimitationsNodeAggregateSelection = {
  __typename?: 'PreparationLimitationHasLimitationsNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  DescriptionDe: StringAggregateSelectionNonNullable;
  DescriptionEn: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  Niveau: StringAggregateSelectionNullable;
  Type: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
};

export type PreparationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PreparationSort objects to sort Preparations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PreparationSort>>;
};

export type PreparationRegulatesAggregateInput = {
  AND?: InputMaybe<Array<PreparationRegulatesAggregateInput>>;
  NOT?: InputMaybe<PreparationRegulatesAggregateInput>;
  OR?: InputMaybe<Array<PreparationRegulatesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PreparationRegulatesNodeAggregationWhereInput>;
};

export type PreparationRegulatesConnection = {
  __typename?: 'PreparationRegulatesConnection';
  edges: Array<PreparationRegulatesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationRegulatesConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type PreparationRegulatesConnectionWhere = {
  AND?: InputMaybe<Array<PreparationRegulatesConnectionWhere>>;
  NOT?: InputMaybe<PreparationRegulatesConnectionWhere>;
  OR?: InputMaybe<Array<PreparationRegulatesConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type PreparationRegulatesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PreparationRegulatesNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<PreparationRegulatesNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PreparationRegulatesNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PreparationRegulatesRelationship = {
  __typename?: 'PreparationRegulatesRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

/** Fields to sort Preparations by. The order in which sorts are applied is not guaranteed when specifying many fields in one PreparationSort object. */
export type PreparationSort = {
  AtcCode?: InputMaybe<SortDirection>;
  BrandName?: InputMaybe<SortDirection>;
  DescriptionDe?: InputMaybe<SortDirection>;
  DescriptionFr?: InputMaybe<SortDirection>;
  DescriptionIt?: InputMaybe<SortDirection>;
  GenericName?: InputMaybe<SortDirection>;
  ReleaseDate?: InputMaybe<SortDirection>;
  SubjectMatter?: InputMaybe<SortDirection>;
  SwissmedicNo5?: InputMaybe<SortDirection>;
  hasLimitation?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
};

export type PreparationStatus = {
  __typename?: 'PreparationStatus';
  FlagApd?: Maybe<Scalars['String']['output']>;
  IntegrationDate: Scalars['Date']['output'];
  StatusTypeCodeSl?: Maybe<Scalars['String']['output']>;
  StatusTypeDescriptionSl?: Maybe<Scalars['String']['output']>;
  ValidFromDate: Scalars['Date']['output'];
  ValidThruDate: Scalars['Date']['output'];
  preparation?: Maybe<Preparation>;
  preparationAggregate?: Maybe<PreparationStatusPreparationPreparationAggregationSelection>;
  preparationConnection: PreparationStatusPreparationConnection;
};


export type PreparationStatusPreparationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type PreparationStatusPreparationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationWhere>;
};


export type PreparationStatusPreparationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PreparationStatusPreparationConnectionSort>>;
  where?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
};

export type PreparationStatusEdge = {
  __typename?: 'PreparationStatusEdge';
  cursor: Scalars['String']['output'];
  node: PreparationStatus;
};

export type PreparationStatusOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PreparationStatusSort objects to sort PreparationStatuses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PreparationStatusSort>>;
};

export type PreparationStatusPreparationAggregateInput = {
  AND?: InputMaybe<Array<PreparationStatusPreparationAggregateInput>>;
  NOT?: InputMaybe<PreparationStatusPreparationAggregateInput>;
  OR?: InputMaybe<Array<PreparationStatusPreparationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PreparationStatusPreparationNodeAggregationWhereInput>;
};

export type PreparationStatusPreparationConnection = {
  __typename?: 'PreparationStatusPreparationConnection';
  edges: Array<PreparationStatusPreparationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationStatusPreparationConnectionSort = {
  node?: InputMaybe<PreparationSort>;
};

export type PreparationStatusPreparationConnectionWhere = {
  AND?: InputMaybe<Array<PreparationStatusPreparationConnectionWhere>>;
  NOT?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
  OR?: InputMaybe<Array<PreparationStatusPreparationConnectionWhere>>;
  node?: InputMaybe<PreparationWhere>;
};

export type PreparationStatusPreparationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PreparationStatusPreparationNodeAggregationWhereInput>>;
  AtcCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<PreparationStatusPreparationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PreparationStatusPreparationNodeAggregationWhereInput>>;
  SwissmedicNo5_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PreparationStatusPreparationPreparationAggregationSelection = {
  __typename?: 'PreparationStatusPreparationPreparationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PreparationStatusPreparationPreparationNodeAggregateSelection>;
};

export type PreparationStatusPreparationPreparationNodeAggregateSelection = {
  __typename?: 'PreparationStatusPreparationPreparationNodeAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type PreparationStatusPreparationRelationship = {
  __typename?: 'PreparationStatusPreparationRelationship';
  cursor: Scalars['String']['output'];
  node: Preparation;
};

/** Fields to sort PreparationStatuses by. The order in which sorts are applied is not guaranteed when specifying many fields in one PreparationStatusSort object. */
export type PreparationStatusSort = {
  FlagApd?: InputMaybe<SortDirection>;
  IntegrationDate?: InputMaybe<SortDirection>;
  StatusTypeCodeSl?: InputMaybe<SortDirection>;
  StatusTypeDescriptionSl?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
  ValidThruDate?: InputMaybe<SortDirection>;
};

export type PreparationStatusWhere = {
  AND?: InputMaybe<Array<PreparationStatusWhere>>;
  FlagApd?: InputMaybe<Scalars['String']['input']>;
  FlagApd_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  FlagApd_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  FlagApd_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FlagApd_MATCHES?: InputMaybe<Scalars['String']['input']>;
  FlagApd_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  IntegrationDate?: InputMaybe<Scalars['Date']['input']>;
  IntegrationDate_GT?: InputMaybe<Scalars['Date']['input']>;
  IntegrationDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  IntegrationDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  IntegrationDate_LT?: InputMaybe<Scalars['Date']['input']>;
  IntegrationDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  NOT?: InputMaybe<PreparationStatusWhere>;
  OR?: InputMaybe<Array<PreparationStatusWhere>>;
  StatusTypeCodeSl?: InputMaybe<Scalars['String']['input']>;
  StatusTypeCodeSl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  StatusTypeCodeSl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  StatusTypeCodeSl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  StatusTypeCodeSl_MATCHES?: InputMaybe<Scalars['String']['input']>;
  StatusTypeCodeSl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  StatusTypeDescriptionSl?: InputMaybe<Scalars['String']['input']>;
  StatusTypeDescriptionSl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  StatusTypeDescriptionSl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  StatusTypeDescriptionSl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  StatusTypeDescriptionSl_MATCHES?: InputMaybe<Scalars['String']['input']>;
  StatusTypeDescriptionSl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  ValidThruDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  preparation?: InputMaybe<PreparationWhere>;
  preparationAggregate?: InputMaybe<PreparationStatusPreparationAggregateInput>;
  preparationConnection?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
  preparationConnection_NOT?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
  preparation_NOT?: InputMaybe<PreparationWhere>;
};

export type PreparationStatusesConnection = {
  __typename?: 'PreparationStatusesConnection';
  edges: Array<PreparationStatusEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationTreatmentRegulatesAggregationSelection = {
  __typename?: 'PreparationTreatmentRegulatesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PreparationTreatmentRegulatesNodeAggregateSelection>;
};

export type PreparationTreatmentRegulatesNodeAggregateSelection = {
  __typename?: 'PreparationTreatmentRegulatesNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type PreparationWhere = {
  AND?: InputMaybe<Array<PreparationWhere>>;
  AtcCode?: InputMaybe<Scalars['String']['input']>;
  AtcCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  AtcCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  AtcCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  AtcCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  AtcCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  BrandName?: InputMaybe<Scalars['String']['input']>;
  BrandName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  BrandName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  BrandName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  BrandName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  BrandName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  DescriptionDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  DescriptionFr_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  DescriptionIt_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  GenericName?: InputMaybe<Scalars['String']['input']>;
  GenericName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  GenericName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  GenericName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  GenericName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  GenericName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<PreparationWhere>;
  OR?: InputMaybe<Array<PreparationWhere>>;
  ReleaseDate?: InputMaybe<Scalars['Date']['input']>;
  ReleaseDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ReleaseDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ReleaseDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ReleaseDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ReleaseDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  SubjectMatter?: InputMaybe<AgreementSubjectMatter>;
  SubjectMatter_IN?: InputMaybe<Array<AgreementSubjectMatter>>;
  SwissmedicNo5?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo5_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo5_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo5_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SwissmedicNo5_MATCHES?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo5_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandWhere>;
  brandAggregate?: InputMaybe<PreparationBrandAggregateInput>;
  brandConnection?: InputMaybe<PreparationBrandConnectionWhere>;
  brandConnection_NOT?: InputMaybe<PreparationBrandConnectionWhere>;
  brand_NOT?: InputMaybe<BrandWhere>;
  countriesAggregate?: InputMaybe<PreparationCountriesAggregateInput>;
  /** Return Preparations where all of the related PreparationCountriesConnections match this filter */
  countriesConnection_ALL?: InputMaybe<PreparationCountriesConnectionWhere>;
  /** Return Preparations where none of the related PreparationCountriesConnections match this filter */
  countriesConnection_NONE?: InputMaybe<PreparationCountriesConnectionWhere>;
  /** Return Preparations where one of the related PreparationCountriesConnections match this filter */
  countriesConnection_SINGLE?: InputMaybe<PreparationCountriesConnectionWhere>;
  /** Return Preparations where some of the related PreparationCountriesConnections match this filter */
  countriesConnection_SOME?: InputMaybe<PreparationCountriesConnectionWhere>;
  /** Return Preparations where all of the related Countries match this filter */
  countries_ALL?: InputMaybe<CountryWhere>;
  /** Return Preparations where none of the related Countries match this filter */
  countries_NONE?: InputMaybe<CountryWhere>;
  /** Return Preparations where one of the related Countries match this filter */
  countries_SINGLE?: InputMaybe<CountryWhere>;
  /** Return Preparations where some of the related Countries match this filter */
  countries_SOME?: InputMaybe<CountryWhere>;
  generic?: InputMaybe<GenericWhere>;
  genericAggregate?: InputMaybe<PreparationGenericAggregateInput>;
  genericConnection?: InputMaybe<PreparationGenericConnectionWhere>;
  genericConnection_NOT?: InputMaybe<PreparationGenericConnectionWhere>;
  generic_NOT?: InputMaybe<GenericWhere>;
  hasLimitationsAggregate?: InputMaybe<PreparationHasLimitationsAggregateInput>;
  /** Return Preparations where all of the related PreparationHasLimitationsConnections match this filter */
  hasLimitationsConnection_ALL?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
  /** Return Preparations where none of the related PreparationHasLimitationsConnections match this filter */
  hasLimitationsConnection_NONE?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
  /** Return Preparations where one of the related PreparationHasLimitationsConnections match this filter */
  hasLimitationsConnection_SINGLE?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
  /** Return Preparations where some of the related PreparationHasLimitationsConnections match this filter */
  hasLimitationsConnection_SOME?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
  /** Return Preparations where all of the related Limitations match this filter */
  hasLimitations_ALL?: InputMaybe<LimitationWhere>;
  /** Return Preparations where none of the related Limitations match this filter */
  hasLimitations_NONE?: InputMaybe<LimitationWhere>;
  /** Return Preparations where one of the related Limitations match this filter */
  hasLimitations_SINGLE?: InputMaybe<LimitationWhere>;
  /** Return Preparations where some of the related Limitations match this filter */
  hasLimitations_SOME?: InputMaybe<LimitationWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  regulatesAggregate?: InputMaybe<PreparationRegulatesAggregateInput>;
  /** Return Preparations where all of the related PreparationRegulatesConnections match this filter */
  regulatesConnection_ALL?: InputMaybe<PreparationRegulatesConnectionWhere>;
  /** Return Preparations where none of the related PreparationRegulatesConnections match this filter */
  regulatesConnection_NONE?: InputMaybe<PreparationRegulatesConnectionWhere>;
  /** Return Preparations where one of the related PreparationRegulatesConnections match this filter */
  regulatesConnection_SINGLE?: InputMaybe<PreparationRegulatesConnectionWhere>;
  /** Return Preparations where some of the related PreparationRegulatesConnections match this filter */
  regulatesConnection_SOME?: InputMaybe<PreparationRegulatesConnectionWhere>;
  /** Return Preparations where all of the related Treatments match this filter */
  regulates_ALL?: InputMaybe<TreatmentWhere>;
  /** Return Preparations where none of the related Treatments match this filter */
  regulates_NONE?: InputMaybe<TreatmentWhere>;
  /** Return Preparations where one of the related Treatments match this filter */
  regulates_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return Preparations where some of the related Treatments match this filter */
  regulates_SOME?: InputMaybe<TreatmentWhere>;
};

export type PreparationsConnection = {
  __typename?: 'PreparationsConnection';
  edges: Array<PreparationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Price = {
  __typename?: 'Price';
  Price: Scalars['String']['output'];
  PriceChangeTypeDescriptionDe?: Maybe<Scalars['String']['output']>;
  PriceChangeTypeDescriptionFr?: Maybe<Scalars['String']['output']>;
  PriceChangeTypeDescriptionIt?: Maybe<Scalars['String']['output']>;
  PriceTypeDescriptionDe?: Maybe<Scalars['String']['output']>;
  PriceTypeDescriptionFr?: Maybe<Scalars['String']['output']>;
  PriceTypeDescriptionIt?: Maybe<Scalars['String']['output']>;
  ValidFromDate: Scalars['Date']['output'];
  ValidToDate?: Maybe<Scalars['Date']['output']>;
  countriesConsidered?: Maybe<Scalars['String']['output']>;
  currency: Currency;
  currencyAggregate?: Maybe<PriceCurrencyCurrencyAggregationSelection>;
  currencyConnection: PriceCurrencyConnection;
  priceType: PriceCategory;
  treatment?: Maybe<Treatment>;
  treatmentAggregate?: Maybe<PriceTreatmentTreatmentAggregationSelection>;
  treatmentConnection: PriceTreatmentConnection;
  uniqueCode: Scalars['String']['output'];
};


export type PriceCurrencyArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurrencyOptions>;
  where?: InputMaybe<CurrencyWhere>;
};


export type PriceCurrencyAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CurrencyWhere>;
};


export type PriceCurrencyConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PriceCurrencyConnectionSort>>;
  where?: InputMaybe<PriceCurrencyConnectionWhere>;
};


export type PriceTreatmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type PriceTreatmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type PriceTreatmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PriceTreatmentConnectionSort>>;
  where?: InputMaybe<PriceTreatmentConnectionWhere>;
};

export enum PriceCategory {
  AlbertaListPrice = 'ALBERTA_LIST_PRICE',
  AlbertaMarkedUpPrice = 'ALBERTA_MARKED_UP_PRICE',
  AverageGeneric = 'AVERAGE_GENERIC',
  BritishColumbiaListPrice = 'BRITISH_COLUMBIA_LIST_PRICE',
  BritishColumbiaMarkedUpPrice = 'BRITISH_COLUMBIA_MARKED_UP_PRICE',
  CrossCountry = 'CROSS_COUNTRY',
  Internal = 'INTERNAL',
  ManitobaListPrice = 'MANITOBA_LIST_PRICE',
  ManitobaMarkedUpPrice = 'MANITOBA_MARKED_UP_PRICE',
  NewfoundlandAndLabradorListPrice = 'NEWFOUNDLAND_AND_LABRADOR_LIST_PRICE',
  NewfoundlandAndLabradorMarkedUpPrice = 'NEWFOUNDLAND_AND_LABRADOR_MARKED_UP_PRICE',
  NewBrunswickListPrice = 'NEW_BRUNSWICK_LIST_PRICE',
  NewBrunswickMarkedUpPrice = 'NEW_BRUNSWICK_MARKED_UP_PRICE',
  NihbListPrice = 'NIHB_LIST_PRICE',
  NihbMarkedUpPrice = 'NIHB_MARKED_UP_PRICE',
  NorthwestTerritoriesListPrice = 'NORTHWEST_TERRITORIES_LIST_PRICE',
  NorthwestTerritoriesMarkedUpPrice = 'NORTHWEST_TERRITORIES_MARKED_UP_PRICE',
  NovaScotiaListPrice = 'NOVA_SCOTIA_LIST_PRICE',
  NovaScotiaMarkedUpPrice = 'NOVA_SCOTIA_MARKED_UP_PRICE',
  NunavutListPrice = 'NUNAVUT_LIST_PRICE',
  NunavutMarkedUpPrice = 'NUNAVUT_MARKED_UP_PRICE',
  OntarioListPrice = 'ONTARIO_LIST_PRICE',
  OntarioMarkedUpPrice = 'ONTARIO_MARKED_UP_PRICE',
  OriginalDrugExFactoryPrice = 'ORIGINAL_DRUG_EX_FACTORY_PRICE',
  Pexf = 'PEXF',
  Ppub = 'PPUB',
  PrinceEdwardIslandListPrice = 'PRINCE_EDWARD_ISLAND_LIST_PRICE',
  PrinceEdwardIslandMarkedUpPrice = 'PRINCE_EDWARD_ISLAND_MARKED_UP_PRICE',
  QuebecListPrice = 'QUEBEC_LIST_PRICE',
  QuebecMarkedUpPrice = 'QUEBEC_MARKED_UP_PRICE',
  SaskatchewanListPrice = 'SASKATCHEWAN_LIST_PRICE',
  SaskatchewanMarkedUpPrice = 'SASKATCHEWAN_MARKED_UP_PRICE',
  VacListPrice = 'VAC_LIST_PRICE',
  VacMarkedUpPrice = 'VAC_MARKED_UP_PRICE',
  YukonListPrice = 'YUKON_LIST_PRICE',
  YukonMarkedUpPrice = 'YUKON_MARKED_UP_PRICE'
}

export type PriceCurrencyAggregateInput = {
  AND?: InputMaybe<Array<PriceCurrencyAggregateInput>>;
  NOT?: InputMaybe<PriceCurrencyAggregateInput>;
  OR?: InputMaybe<Array<PriceCurrencyAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PriceCurrencyNodeAggregationWhereInput>;
};

export type PriceCurrencyConnection = {
  __typename?: 'PriceCurrencyConnection';
  edges: Array<PriceCurrencyRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PriceCurrencyConnectionSort = {
  node?: InputMaybe<CurrencySort>;
};

export type PriceCurrencyConnectionWhere = {
  AND?: InputMaybe<Array<PriceCurrencyConnectionWhere>>;
  NOT?: InputMaybe<PriceCurrencyConnectionWhere>;
  OR?: InputMaybe<Array<PriceCurrencyConnectionWhere>>;
  node?: InputMaybe<CurrencyWhere>;
};

export type PriceCurrencyCurrencyAggregationSelection = {
  __typename?: 'PriceCurrencyCurrencyAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PriceCurrencyCurrencyNodeAggregateSelection>;
};

export type PriceCurrencyCurrencyNodeAggregateSelection = {
  __typename?: 'PriceCurrencyCurrencyNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNullable;
  symbol: StringAggregateSelectionNullable;
};

export type PriceCurrencyNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PriceCurrencyNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<PriceCurrencyNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PriceCurrencyNodeAggregationWhereInput>>;
  symbol_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PriceCurrencyRelationship = {
  __typename?: 'PriceCurrencyRelationship';
  cursor: Scalars['String']['output'];
  node: Currency;
};

export type PriceEdge = {
  __typename?: 'PriceEdge';
  cursor: Scalars['String']['output'];
  node: Price;
};

export type PriceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PriceSort objects to sort Prices by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PriceSort>>;
};

/** Fields to sort Prices by. The order in which sorts are applied is not guaranteed when specifying many fields in one PriceSort object. */
export type PriceSort = {
  Price?: InputMaybe<SortDirection>;
  PriceChangeTypeDescriptionDe?: InputMaybe<SortDirection>;
  PriceChangeTypeDescriptionFr?: InputMaybe<SortDirection>;
  PriceChangeTypeDescriptionIt?: InputMaybe<SortDirection>;
  PriceTypeDescriptionDe?: InputMaybe<SortDirection>;
  PriceTypeDescriptionFr?: InputMaybe<SortDirection>;
  PriceTypeDescriptionIt?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
  ValidToDate?: InputMaybe<SortDirection>;
  countriesConsidered?: InputMaybe<SortDirection>;
  priceType?: InputMaybe<SortDirection>;
  uniqueCode?: InputMaybe<SortDirection>;
};

export type PriceTreatmentAggregateInput = {
  AND?: InputMaybe<Array<PriceTreatmentAggregateInput>>;
  NOT?: InputMaybe<PriceTreatmentAggregateInput>;
  OR?: InputMaybe<Array<PriceTreatmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PriceTreatmentNodeAggregationWhereInput>;
};

export type PriceTreatmentConnection = {
  __typename?: 'PriceTreatmentConnection';
  edges: Array<PriceTreatmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PriceTreatmentConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type PriceTreatmentConnectionWhere = {
  AND?: InputMaybe<Array<PriceTreatmentConnectionWhere>>;
  NOT?: InputMaybe<PriceTreatmentConnectionWhere>;
  OR?: InputMaybe<Array<PriceTreatmentConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type PriceTreatmentInput = {
  Price: Scalars['String']['input'];
  ValidFromDate: Scalars['Date']['input'];
  ValidToDate?: InputMaybe<Scalars['Date']['input']>;
  countriesConsidered?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  isToBeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  priceType: PriceCategory;
  uniqueCode: Scalars['String']['input'];
};

export type PriceTreatmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PriceTreatmentNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<PriceTreatmentNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PriceTreatmentNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PriceTreatmentRelationship = {
  __typename?: 'PriceTreatmentRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type PriceTreatmentTreatmentAggregationSelection = {
  __typename?: 'PriceTreatmentTreatmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PriceTreatmentTreatmentNodeAggregateSelection>;
};

export type PriceTreatmentTreatmentNodeAggregateSelection = {
  __typename?: 'PriceTreatmentTreatmentNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export enum PriceType {
  AlbertaListPrice = 'ALBERTA_LIST_PRICE',
  AlbertaListPricePercent = 'ALBERTA_LIST_PRICE_PERCENT',
  AlbertaMarkedUpPrice = 'ALBERTA_MARKED_UP_PRICE',
  AlbertaMarkedUpPricePercent = 'ALBERTA_MARKED_UP_PRICE_PERCENT',
  AvgGenericPercent = 'AVG_GENERIC_PERCENT',
  BritishColumbiaListPrice = 'BRITISH_COLUMBIA_LIST_PRICE',
  BritishColumbiaListPricePercent = 'BRITISH_COLUMBIA_LIST_PRICE_PERCENT',
  BritishColumbiaMarkedUpPrice = 'BRITISH_COLUMBIA_MARKED_UP_PRICE',
  BritishColumbiaMarkedUpPricePercent = 'BRITISH_COLUMBIA_MARKED_UP_PRICE_PERCENT',
  CrossCountryPercent = 'CROSS_COUNTRY_PERCENT',
  CustomPrice = 'CUSTOM_PRICE',
  CustomPricePercent = 'CUSTOM_PRICE_PERCENT',
  DiffBetweenExFactoryAndCrossCountry = 'DIFF_BETWEEN_EX_FACTORY_AND_CROSS_COUNTRY',
  ExFactoryPrice = 'EX_FACTORY_PRICE',
  ExFactoryPricePercent = 'EX_FACTORY_PRICE_PERCENT',
  ManitobaListPrice = 'MANITOBA_LIST_PRICE',
  ManitobaListPricePercent = 'MANITOBA_LIST_PRICE_PERCENT',
  ManitobaMarkedUpPrice = 'MANITOBA_MARKED_UP_PRICE',
  ManitobaMarkedUpPricePercent = 'MANITOBA_MARKED_UP_PRICE_PERCENT',
  NetPrice = 'NET_PRICE',
  NetPricePercent = 'NET_PRICE_PERCENT',
  NewfoundlandAndLabradorListPrice = 'NEWFOUNDLAND_AND_LABRADOR_LIST_PRICE',
  NewfoundlandAndLabradorListPricePercent = 'NEWFOUNDLAND_AND_LABRADOR_LIST_PRICE_PERCENT',
  NewfoundlandAndLabradorMarkedUpPrice = 'NEWFOUNDLAND_AND_LABRADOR_MARKED_UP_PRICE',
  NewfoundlandAndLabradorMarkedUpPricePercent = 'NEWFOUNDLAND_AND_LABRADOR_MARKED_UP_PRICE_PERCENT',
  NewBrunswickListPrice = 'NEW_BRUNSWICK_LIST_PRICE',
  NewBrunswickListPricePercent = 'NEW_BRUNSWICK_LIST_PRICE_PERCENT',
  NewBrunswickMarkedUpPrice = 'NEW_BRUNSWICK_MARKED_UP_PRICE',
  NewBrunswickMarkedUpPricePercent = 'NEW_BRUNSWICK_MARKED_UP_PRICE_PERCENT',
  NihbListPrice = 'NIHB_LIST_PRICE',
  NihbListPricePercent = 'NIHB_LIST_PRICE_PERCENT',
  NihbMarkedUpPrice = 'NIHB_MARKED_UP_PRICE',
  NihbMarkedUpPricePercent = 'NIHB_MARKED_UP_PRICE_PERCENT',
  NorthwestTerritoriesListPrice = 'NORTHWEST_TERRITORIES_LIST_PRICE',
  NorthwestTerritoriesListPricePercent = 'NORTHWEST_TERRITORIES_LIST_PRICE_PERCENT',
  NorthwestTerritoriesMarkedUpPrice = 'NORTHWEST_TERRITORIES_MARKED_UP_PRICE',
  NorthwestTerritoriesMarkedUpPricePercent = 'NORTHWEST_TERRITORIES_MARKED_UP_PRICE_PERCENT',
  NovaScotiaListPrice = 'NOVA_SCOTIA_LIST_PRICE',
  NovaScotiaListPricePercent = 'NOVA_SCOTIA_LIST_PRICE_PERCENT',
  NovaScotiaMarkedUpPrice = 'NOVA_SCOTIA_MARKED_UP_PRICE',
  NovaScotiaMarkedUpPricePercent = 'NOVA_SCOTIA_MARKED_UP_PRICE_PERCENT',
  NunavutListPrice = 'NUNAVUT_LIST_PRICE',
  NunavutListPricePercent = 'NUNAVUT_LIST_PRICE_PERCENT',
  NunavutMarkedUpPrice = 'NUNAVUT_MARKED_UP_PRICE',
  NunavutMarkedUpPricePercent = 'NUNAVUT_MARKED_UP_PRICE_PERCENT',
  OntarioListPrice = 'ONTARIO_LIST_PRICE',
  OntarioListPricePercent = 'ONTARIO_LIST_PRICE_PERCENT',
  OntarioMarkedUpPrice = 'ONTARIO_MARKED_UP_PRICE',
  OntarioMarkedUpPricePercent = 'ONTARIO_MARKED_UP_PRICE_PERCENT',
  OriginalDrugExFactoryPricePercent = 'ORIGINAL_DRUG_EX_FACTORY_PRICE_PERCENT',
  PrinceEdwardIslandListPrice = 'PRINCE_EDWARD_ISLAND_LIST_PRICE',
  PrinceEdwardIslandListPricePercent = 'PRINCE_EDWARD_ISLAND_LIST_PRICE_PERCENT',
  PrinceEdwardIslandMarkedUpPrice = 'PRINCE_EDWARD_ISLAND_MARKED_UP_PRICE',
  PrinceEdwardIslandMarkedUpPricePercent = 'PRINCE_EDWARD_ISLAND_MARKED_UP_PRICE_PERCENT',
  PublicPrice = 'PUBLIC_PRICE',
  PublicPricePercent = 'PUBLIC_PRICE_PERCENT',
  QuebecListPrice = 'QUEBEC_LIST_PRICE',
  QuebecListPricePercent = 'QUEBEC_LIST_PRICE_PERCENT',
  QuebecMarkedUpPrice = 'QUEBEC_MARKED_UP_PRICE',
  QuebecMarkedUpPricePercent = 'QUEBEC_MARKED_UP_PRICE_PERCENT',
  RecordDiscountPercent = 'RECORD_DISCOUNT_PERCENT',
  RecordPricePercent = 'RECORD_PRICE_PERCENT',
  SaskatchewanListPrice = 'SASKATCHEWAN_LIST_PRICE',
  SaskatchewanListPricePercent = 'SASKATCHEWAN_LIST_PRICE_PERCENT',
  SaskatchewanMarkedUpPrice = 'SASKATCHEWAN_MARKED_UP_PRICE',
  SaskatchewanMarkedUpPricePercent = 'SASKATCHEWAN_MARKED_UP_PRICE_PERCENT',
  ScenarioZeroMainNetPrice = 'SCENARIO_ZERO_MAIN_NET_PRICE',
  ScenarioZeroMainNetPricePercent = 'SCENARIO_ZERO_MAIN_NET_PRICE_PERCENT',
  ScenarioZeroNetPrice = 'SCENARIO_ZERO_NET_PRICE',
  ScenarioZeroNetPricePercent = 'SCENARIO_ZERO_NET_PRICE_PERCENT',
  ScenarioZeroRelevantNetPrice = 'SCENARIO_ZERO_RELEVANT_NET_PRICE',
  ScenarioZeroRelevantNetPricePercent = 'SCENARIO_ZERO_RELEVANT_NET_PRICE_PERCENT',
  VacListPrice = 'VAC_LIST_PRICE',
  VacListPricePercent = 'VAC_LIST_PRICE_PERCENT',
  VacMarkedUpPrice = 'VAC_MARKED_UP_PRICE',
  VacMarkedUpPricePercent = 'VAC_MARKED_UP_PRICE_PERCENT',
  YukonListPrice = 'YUKON_LIST_PRICE',
  YukonListPricePercent = 'YUKON_LIST_PRICE_PERCENT',
  YukonMarkedUpPrice = 'YUKON_MARKED_UP_PRICE',
  YukonMarkedUpPricePercent = 'YUKON_MARKED_UP_PRICE_PERCENT'
}

export type PriceWhere = {
  AND?: InputMaybe<Array<PriceWhere>>;
  NOT?: InputMaybe<PriceWhere>;
  OR?: InputMaybe<Array<PriceWhere>>;
  Price?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionDe?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PriceChangeTypeDescriptionDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionFr?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionFr_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionFr_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionFr_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PriceChangeTypeDescriptionFr_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionFr_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionIt?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionIt_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionIt_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionIt_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PriceChangeTypeDescriptionIt_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionIt_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionDe?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PriceTypeDescriptionDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionFr?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionFr_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionFr_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionFr_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PriceTypeDescriptionFr_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionFr_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionIt?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionIt_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionIt_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionIt_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PriceTypeDescriptionIt_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionIt_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Price_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Price_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Price_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Price_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Price_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  ValidToDate?: InputMaybe<Scalars['Date']['input']>;
  ValidToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  countriesConsidered?: InputMaybe<Scalars['String']['input']>;
  countriesConsidered_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  countriesConsidered_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  countriesConsidered_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countriesConsidered_MATCHES?: InputMaybe<Scalars['String']['input']>;
  countriesConsidered_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyWhere>;
  currencyAggregate?: InputMaybe<PriceCurrencyAggregateInput>;
  currencyConnection?: InputMaybe<PriceCurrencyConnectionWhere>;
  currencyConnection_NOT?: InputMaybe<PriceCurrencyConnectionWhere>;
  currency_NOT?: InputMaybe<CurrencyWhere>;
  priceType?: InputMaybe<PriceCategory>;
  priceType_IN?: InputMaybe<Array<PriceCategory>>;
  treatment?: InputMaybe<TreatmentWhere>;
  treatmentAggregate?: InputMaybe<PriceTreatmentAggregateInput>;
  treatmentConnection?: InputMaybe<PriceTreatmentConnectionWhere>;
  treatmentConnection_NOT?: InputMaybe<PriceTreatmentConnectionWhere>;
  treatment_NOT?: InputMaybe<TreatmentWhere>;
  uniqueCode?: InputMaybe<Scalars['String']['input']>;
  uniqueCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  uniqueCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  uniqueCode_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  uniqueCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  uniqueCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PricesConnection = {
  __typename?: 'PricesConnection';
  edges: Array<PriceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductBlueprint = {
  __typename?: 'ProductBlueprint';
  addedBy: User;
  addedByAggregate?: Maybe<ProductBlueprintUserAddedByAggregationSelection>;
  addedByConnection: ProductBlueprintAddedByConnection;
  addedByName: Scalars['String']['output'];
  addedOn: Scalars['DateTime']['output'];
  domains: Array<Domain>;
  domainsAggregate?: Maybe<ProductBlueprintDomainDomainsAggregationSelection>;
  domainsConnection: ProductBlueprintDomainsConnection;
  formValues: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  indication: Scalars['String']['output'];
  indications: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  publishedBy?: Maybe<User>;
  publishedByAggregate?: Maybe<ProductBlueprintUserPublishedByAggregationSelection>;
  publishedByConnection: ProductBlueprintPublishedByConnection;
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  simulationCount?: Maybe<Scalars['Int']['output']>;
  simulations?: Maybe<Simulation>;
  simulationsAggregate?: Maybe<ProductBlueprintSimulationSimulationsAggregationSelection>;
  simulationsConnection: ProductBlueprintSimulationsConnection;
  status: ProductBlueprintStatus;
  tenantId: Scalars['String']['output'];
  updatedBy?: Maybe<User>;
  updatedByAggregate?: Maybe<ProductBlueprintUserUpdatedByAggregationSelection>;
  updatedByConnection: ProductBlueprintUpdatedByConnection;
  updatedOn: Scalars['DateTime']['output'];
};


export type ProductBlueprintAddedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ProductBlueprintAddedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ProductBlueprintAddedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProductBlueprintAddedByConnectionSort>>;
  where?: InputMaybe<ProductBlueprintAddedByConnectionWhere>;
};


export type ProductBlueprintDomainsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DomainOptions>;
  where?: InputMaybe<DomainWhere>;
};


export type ProductBlueprintDomainsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DomainWhere>;
};


export type ProductBlueprintDomainsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProductBlueprintDomainsConnectionSort>>;
  where?: InputMaybe<ProductBlueprintDomainsConnectionWhere>;
};


export type ProductBlueprintPublishedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ProductBlueprintPublishedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ProductBlueprintPublishedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProductBlueprintPublishedByConnectionSort>>;
  where?: InputMaybe<ProductBlueprintPublishedByConnectionWhere>;
};


export type ProductBlueprintSimulationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SimulationOptions>;
  where?: InputMaybe<SimulationWhere>;
};


export type ProductBlueprintSimulationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SimulationWhere>;
};


export type ProductBlueprintSimulationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProductBlueprintSimulationsConnectionSort>>;
  where?: InputMaybe<ProductBlueprintSimulationsConnectionWhere>;
};


export type ProductBlueprintUpdatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ProductBlueprintUpdatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ProductBlueprintUpdatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProductBlueprintUpdatedByConnectionSort>>;
  where?: InputMaybe<ProductBlueprintUpdatedByConnectionWhere>;
};

export type ProductBlueprintAddedByAggregateInput = {
  AND?: InputMaybe<Array<ProductBlueprintAddedByAggregateInput>>;
  NOT?: InputMaybe<ProductBlueprintAddedByAggregateInput>;
  OR?: InputMaybe<Array<ProductBlueprintAddedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProductBlueprintAddedByNodeAggregationWhereInput>;
};

export type ProductBlueprintAddedByConnection = {
  __typename?: 'ProductBlueprintAddedByConnection';
  edges: Array<ProductBlueprintAddedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductBlueprintAddedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type ProductBlueprintAddedByConnectionWhere = {
  AND?: InputMaybe<Array<ProductBlueprintAddedByConnectionWhere>>;
  NOT?: InputMaybe<ProductBlueprintAddedByConnectionWhere>;
  OR?: InputMaybe<Array<ProductBlueprintAddedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type ProductBlueprintAddedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductBlueprintAddedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProductBlueprintAddedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProductBlueprintAddedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductBlueprintAddedByRelationship = {
  __typename?: 'ProductBlueprintAddedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type ProductBlueprintDomainDomainsAggregationSelection = {
  __typename?: 'ProductBlueprintDomainDomainsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProductBlueprintDomainDomainsNodeAggregateSelection>;
};

export type ProductBlueprintDomainDomainsNodeAggregateSelection = {
  __typename?: 'ProductBlueprintDomainDomainsNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  level: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type ProductBlueprintDomainsAggregateInput = {
  AND?: InputMaybe<Array<ProductBlueprintDomainsAggregateInput>>;
  NOT?: InputMaybe<ProductBlueprintDomainsAggregateInput>;
  OR?: InputMaybe<Array<ProductBlueprintDomainsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProductBlueprintDomainsNodeAggregationWhereInput>;
};

export type ProductBlueprintDomainsConnection = {
  __typename?: 'ProductBlueprintDomainsConnection';
  edges: Array<ProductBlueprintDomainsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductBlueprintDomainsConnectionSort = {
  node?: InputMaybe<DomainSort>;
};

export type ProductBlueprintDomainsConnectionWhere = {
  AND?: InputMaybe<Array<ProductBlueprintDomainsConnectionWhere>>;
  NOT?: InputMaybe<ProductBlueprintDomainsConnectionWhere>;
  OR?: InputMaybe<Array<ProductBlueprintDomainsConnectionWhere>>;
  node?: InputMaybe<DomainWhere>;
};

export type ProductBlueprintDomainsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductBlueprintDomainsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProductBlueprintDomainsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProductBlueprintDomainsNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  level_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  level_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductBlueprintDomainsRelationship = {
  __typename?: 'ProductBlueprintDomainsRelationship';
  cursor: Scalars['String']['output'];
  node: Domain;
};

export type ProductBlueprintEdge = {
  __typename?: 'ProductBlueprintEdge';
  cursor: Scalars['String']['output'];
  node: ProductBlueprint;
};

export type ProductBlueprintOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ProductBlueprintSort objects to sort ProductBlueprints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ProductBlueprintSort>>;
};

export type ProductBlueprintPublishedByAggregateInput = {
  AND?: InputMaybe<Array<ProductBlueprintPublishedByAggregateInput>>;
  NOT?: InputMaybe<ProductBlueprintPublishedByAggregateInput>;
  OR?: InputMaybe<Array<ProductBlueprintPublishedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProductBlueprintPublishedByNodeAggregationWhereInput>;
};

export type ProductBlueprintPublishedByConnection = {
  __typename?: 'ProductBlueprintPublishedByConnection';
  edges: Array<ProductBlueprintPublishedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductBlueprintPublishedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type ProductBlueprintPublishedByConnectionWhere = {
  AND?: InputMaybe<Array<ProductBlueprintPublishedByConnectionWhere>>;
  NOT?: InputMaybe<ProductBlueprintPublishedByConnectionWhere>;
  OR?: InputMaybe<Array<ProductBlueprintPublishedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type ProductBlueprintPublishedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductBlueprintPublishedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProductBlueprintPublishedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProductBlueprintPublishedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductBlueprintPublishedByRelationship = {
  __typename?: 'ProductBlueprintPublishedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type ProductBlueprintResult = {
  __typename?: 'ProductBlueprintResult';
  addedBy: User;
  addedByName: Scalars['String']['output'];
  addedOn: Scalars['DateTime']['output'];
  domains: Array<Domain>;
  formValues: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  indications: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  publishedBy?: Maybe<User>;
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  simulationCount?: Maybe<Scalars['Int']['output']>;
  status: ProductBlueprintStatus;
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  updatedBy: User;
  updatedOn: Scalars['DateTime']['output'];
};

export type ProductBlueprintResultEdge = {
  __typename?: 'ProductBlueprintResultEdge';
  cursor: Scalars['String']['output'];
  node: ProductBlueprintResult;
};

export type ProductBlueprintResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ProductBlueprintResultSort objects to sort ProductBlueprintResults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ProductBlueprintResultSort>>;
};

/** Fields to sort ProductBlueprintResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one ProductBlueprintResultSort object. */
export type ProductBlueprintResultSort = {
  addedByName?: InputMaybe<SortDirection>;
  addedOn?: InputMaybe<SortDirection>;
  formValues?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  indications?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  productName?: InputMaybe<SortDirection>;
  publishedOn?: InputMaybe<SortDirection>;
  simulationCount?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  tenantName?: InputMaybe<SortDirection>;
  updatedOn?: InputMaybe<SortDirection>;
};

export type ProductBlueprintResultWhere = {
  AND?: InputMaybe<Array<ProductBlueprintResultWhere>>;
  NOT?: InputMaybe<ProductBlueprintResultWhere>;
  OR?: InputMaybe<Array<ProductBlueprintResultWhere>>;
  addedByName?: InputMaybe<Scalars['String']['input']>;
  addedByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  addedByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedByName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  addedByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  addedByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedOn?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  addedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formValues?: InputMaybe<Scalars['String']['input']>;
  formValues_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formValues_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formValues_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  formValues_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formValues_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  indications?: InputMaybe<Scalars['String']['input']>;
  indications_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  indications_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  indications_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  indications_MATCHES?: InputMaybe<Scalars['String']['input']>;
  indications_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  productName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  productName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  productName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  productName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publishedOn?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  simulationCount?: InputMaybe<Scalars['Int']['input']>;
  simulationCount_GT?: InputMaybe<Scalars['Int']['input']>;
  simulationCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  simulationCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  simulationCount_LT?: InputMaybe<Scalars['Int']['input']>;
  simulationCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ProductBlueprintStatus>;
  status_IN?: InputMaybe<Array<ProductBlueprintStatus>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantName?: InputMaybe<Scalars['String']['input']>;
  tenantName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductBlueprintResultsConnection = {
  __typename?: 'ProductBlueprintResultsConnection';
  edges: Array<ProductBlueprintResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductBlueprintSimulationSimulationsAggregationSelection = {
  __typename?: 'ProductBlueprintSimulationSimulationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProductBlueprintSimulationSimulationsNodeAggregateSelection>;
};

export type ProductBlueprintSimulationSimulationsNodeAggregateSelection = {
  __typename?: 'ProductBlueprintSimulationSimulationsNodeAggregateSelection';
  businessCase: StringAggregateSelectionNullable;
  comments: StringAggregateSelectionNullable;
  configuration: StringAggregateSelectionNonNullable;
  counterparty: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNullable;
  createdByName: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  domainName: StringAggregateSelectionNullable;
  formattedContent: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  indications: StringAggregateSelectionNonNullable;
  lastUpdatedByEmail: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  lockedSections: StringAggregateSelectionNullable;
  model: StringAggregateSelectionNonNullable;
  product: StringAggregateSelectionNonNullable;
  shortName: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  version: IntAggregateSelectionNonNullable;
};

export type ProductBlueprintSimulationsAggregateInput = {
  AND?: InputMaybe<Array<ProductBlueprintSimulationsAggregateInput>>;
  NOT?: InputMaybe<ProductBlueprintSimulationsAggregateInput>;
  OR?: InputMaybe<Array<ProductBlueprintSimulationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProductBlueprintSimulationsNodeAggregationWhereInput>;
};

export type ProductBlueprintSimulationsConnection = {
  __typename?: 'ProductBlueprintSimulationsConnection';
  edges: Array<ProductBlueprintSimulationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductBlueprintSimulationsConnectionSort = {
  node?: InputMaybe<SimulationSort>;
};

export type ProductBlueprintSimulationsConnectionWhere = {
  AND?: InputMaybe<Array<ProductBlueprintSimulationsConnectionWhere>>;
  NOT?: InputMaybe<ProductBlueprintSimulationsConnectionWhere>;
  OR?: InputMaybe<Array<ProductBlueprintSimulationsConnectionWhere>>;
  node?: InputMaybe<SimulationWhere>;
};

export type ProductBlueprintSimulationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductBlueprintSimulationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProductBlueprintSimulationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProductBlueprintSimulationsNodeAggregationWhereInput>>;
  businessCase_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  businessCase_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  configuration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterparty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domainName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domainName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  indications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSections_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  model_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  model_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductBlueprintSimulationsRelationship = {
  __typename?: 'ProductBlueprintSimulationsRelationship';
  cursor: Scalars['String']['output'];
  node: Simulation;
};

/** Fields to sort ProductBlueprints by. The order in which sorts are applied is not guaranteed when specifying many fields in one ProductBlueprintSort object. */
export type ProductBlueprintSort = {
  addedByName?: InputMaybe<SortDirection>;
  addedOn?: InputMaybe<SortDirection>;
  formValues?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  indication?: InputMaybe<SortDirection>;
  indications?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  productName?: InputMaybe<SortDirection>;
  publishedOn?: InputMaybe<SortDirection>;
  simulationCount?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  updatedOn?: InputMaybe<SortDirection>;
};

export enum ProductBlueprintStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type ProductBlueprintUpdatedByAggregateInput = {
  AND?: InputMaybe<Array<ProductBlueprintUpdatedByAggregateInput>>;
  NOT?: InputMaybe<ProductBlueprintUpdatedByAggregateInput>;
  OR?: InputMaybe<Array<ProductBlueprintUpdatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProductBlueprintUpdatedByNodeAggregationWhereInput>;
};

export type ProductBlueprintUpdatedByConnection = {
  __typename?: 'ProductBlueprintUpdatedByConnection';
  edges: Array<ProductBlueprintUpdatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductBlueprintUpdatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type ProductBlueprintUpdatedByConnectionWhere = {
  AND?: InputMaybe<Array<ProductBlueprintUpdatedByConnectionWhere>>;
  NOT?: InputMaybe<ProductBlueprintUpdatedByConnectionWhere>;
  OR?: InputMaybe<Array<ProductBlueprintUpdatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type ProductBlueprintUpdatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductBlueprintUpdatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProductBlueprintUpdatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProductBlueprintUpdatedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductBlueprintUpdatedByRelationship = {
  __typename?: 'ProductBlueprintUpdatedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type ProductBlueprintUserAddedByAggregationSelection = {
  __typename?: 'ProductBlueprintUserAddedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProductBlueprintUserAddedByNodeAggregateSelection>;
};

export type ProductBlueprintUserAddedByNodeAggregateSelection = {
  __typename?: 'ProductBlueprintUserAddedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type ProductBlueprintUserPublishedByAggregationSelection = {
  __typename?: 'ProductBlueprintUserPublishedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProductBlueprintUserPublishedByNodeAggregateSelection>;
};

export type ProductBlueprintUserPublishedByNodeAggregateSelection = {
  __typename?: 'ProductBlueprintUserPublishedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type ProductBlueprintUserUpdatedByAggregationSelection = {
  __typename?: 'ProductBlueprintUserUpdatedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProductBlueprintUserUpdatedByNodeAggregateSelection>;
};

export type ProductBlueprintUserUpdatedByNodeAggregateSelection = {
  __typename?: 'ProductBlueprintUserUpdatedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type ProductBlueprintWhere = {
  AND?: InputMaybe<Array<ProductBlueprintWhere>>;
  NOT?: InputMaybe<ProductBlueprintWhere>;
  OR?: InputMaybe<Array<ProductBlueprintWhere>>;
  addedBy?: InputMaybe<UserWhere>;
  addedByAggregate?: InputMaybe<ProductBlueprintAddedByAggregateInput>;
  addedByConnection?: InputMaybe<ProductBlueprintAddedByConnectionWhere>;
  addedByConnection_NOT?: InputMaybe<ProductBlueprintAddedByConnectionWhere>;
  addedByName?: InputMaybe<Scalars['String']['input']>;
  addedByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  addedByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedByName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  addedByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  addedByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedBy_NOT?: InputMaybe<UserWhere>;
  addedOn?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  addedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domainsAggregate?: InputMaybe<ProductBlueprintDomainsAggregateInput>;
  /** Return ProductBlueprints where all of the related ProductBlueprintDomainsConnections match this filter */
  domainsConnection_ALL?: InputMaybe<ProductBlueprintDomainsConnectionWhere>;
  /** Return ProductBlueprints where none of the related ProductBlueprintDomainsConnections match this filter */
  domainsConnection_NONE?: InputMaybe<ProductBlueprintDomainsConnectionWhere>;
  /** Return ProductBlueprints where one of the related ProductBlueprintDomainsConnections match this filter */
  domainsConnection_SINGLE?: InputMaybe<ProductBlueprintDomainsConnectionWhere>;
  /** Return ProductBlueprints where some of the related ProductBlueprintDomainsConnections match this filter */
  domainsConnection_SOME?: InputMaybe<ProductBlueprintDomainsConnectionWhere>;
  /** Return ProductBlueprints where all of the related Domains match this filter */
  domains_ALL?: InputMaybe<DomainWhere>;
  /** Return ProductBlueprints where none of the related Domains match this filter */
  domains_NONE?: InputMaybe<DomainWhere>;
  /** Return ProductBlueprints where one of the related Domains match this filter */
  domains_SINGLE?: InputMaybe<DomainWhere>;
  /** Return ProductBlueprints where some of the related Domains match this filter */
  domains_SOME?: InputMaybe<DomainWhere>;
  formValues?: InputMaybe<Scalars['String']['input']>;
  formValues_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formValues_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formValues_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  formValues_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formValues_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  indication?: InputMaybe<Scalars['String']['input']>;
  indication_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  indication_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  indication_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  indication_MATCHES?: InputMaybe<Scalars['String']['input']>;
  indication_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  indications?: InputMaybe<Scalars['String']['input']>;
  indications_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  indications_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  indications_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  indications_MATCHES?: InputMaybe<Scalars['String']['input']>;
  indications_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  productName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  productName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  productName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  productName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publishedBy?: InputMaybe<UserWhere>;
  publishedByAggregate?: InputMaybe<ProductBlueprintPublishedByAggregateInput>;
  publishedByConnection?: InputMaybe<ProductBlueprintPublishedByConnectionWhere>;
  publishedByConnection_NOT?: InputMaybe<ProductBlueprintPublishedByConnectionWhere>;
  publishedBy_NOT?: InputMaybe<UserWhere>;
  publishedOn?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  simulations?: InputMaybe<SimulationWhere>;
  simulationsAggregate?: InputMaybe<ProductBlueprintSimulationsAggregateInput>;
  simulationsConnection?: InputMaybe<ProductBlueprintSimulationsConnectionWhere>;
  simulationsConnection_NOT?: InputMaybe<ProductBlueprintSimulationsConnectionWhere>;
  simulations_NOT?: InputMaybe<SimulationWhere>;
  status?: InputMaybe<ProductBlueprintStatus>;
  status_IN?: InputMaybe<Array<ProductBlueprintStatus>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<UserWhere>;
  updatedByAggregate?: InputMaybe<ProductBlueprintUpdatedByAggregateInput>;
  updatedByConnection?: InputMaybe<ProductBlueprintUpdatedByConnectionWhere>;
  updatedByConnection_NOT?: InputMaybe<ProductBlueprintUpdatedByConnectionWhere>;
  updatedBy_NOT?: InputMaybe<UserWhere>;
  updatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductBlueprintsConnection = {
  __typename?: 'ProductBlueprintsConnection';
  edges: Array<ProductBlueprintEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicPrice = {
  __typename?: 'PublicPrice';
  Price?: Maybe<Scalars['String']['output']>;
  ValidFromDate?: Maybe<Scalars['Date']['output']>;
};

export type PublicPriceEdge = {
  __typename?: 'PublicPriceEdge';
  cursor: Scalars['String']['output'];
  node: PublicPrice;
};

export type PublicPriceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PublicPriceSort objects to sort PublicPrices by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PublicPriceSort>>;
};

/** Fields to sort PublicPrices by. The order in which sorts are applied is not guaranteed when specifying many fields in one PublicPriceSort object. */
export type PublicPriceSort = {
  Price?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
};

export type PublicPriceWhere = {
  AND?: InputMaybe<Array<PublicPriceWhere>>;
  NOT?: InputMaybe<PublicPriceWhere>;
  OR?: InputMaybe<Array<PublicPriceWhere>>;
  Price?: InputMaybe<Scalars['String']['input']>;
  Price_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Price_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Price_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Price_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Price_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type PublicPricesConnection = {
  __typename?: 'PublicPricesConnection';
  edges: Array<PublicPriceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Purchase = {
  __typename?: 'Purchase';
  agreement: Agreement;
  agreementAggregate?: Maybe<PurchaseAgreementAgreementAggregationSelection>;
  agreementConnection: PurchaseAgreementConnection;
  assignedFlexEntities: Array<FlexEntity>;
  assignedFlexEntitiesAggregate?: Maybe<PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection>;
  assignedFlexEntitiesConnection: PurchaseAssignedFlexEntitiesConnection;
  id: Scalars['ID']['output'];
  maxCoverageStartDate?: Maybe<Scalars['Date']['output']>;
  maxTherapyTrialStartDate?: Maybe<Scalars['Date']['output']>;
  purchaseDate?: Maybe<Scalars['Date']['output']>;
  purchaseId: Scalars['String']['output'];
  refunds: Array<Refund>;
  refundsAggregate?: Maybe<PurchaseRefundRefundsAggregationSelection>;
  refundsConnection: PurchaseRefundsConnection;
  tenantId?: Maybe<Scalars['String']['output']>;
  timeStamp: Scalars['DateTime']['output'];
};


export type PurchaseAgreementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type PurchaseAgreementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type PurchaseAgreementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PurchaseAgreementConnectionSort>>;
  where?: InputMaybe<PurchaseAgreementConnectionWhere>;
};


export type PurchaseAssignedFlexEntitiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type PurchaseAssignedFlexEntitiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type PurchaseAssignedFlexEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PurchaseAssignedFlexEntitiesConnectionSort>>;
  where?: InputMaybe<PurchaseAssignedFlexEntitiesConnectionWhere>;
};


export type PurchaseRefundsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type PurchaseRefundsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RefundWhere>;
};


export type PurchaseRefundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PurchaseRefundsConnectionSort>>;
  where?: InputMaybe<PurchaseRefundsConnectionWhere>;
};

export type PurchaseAgreementAggregateInput = {
  AND?: InputMaybe<Array<PurchaseAgreementAggregateInput>>;
  NOT?: InputMaybe<PurchaseAgreementAggregateInput>;
  OR?: InputMaybe<Array<PurchaseAgreementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PurchaseAgreementNodeAggregationWhereInput>;
};

export type PurchaseAgreementAgreementAggregationSelection = {
  __typename?: 'PurchaseAgreementAgreementAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PurchaseAgreementAgreementNodeAggregateSelection>;
};

export type PurchaseAgreementAgreementNodeAggregateSelection = {
  __typename?: 'PurchaseAgreementAgreementNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type PurchaseAgreementConnection = {
  __typename?: 'PurchaseAgreementConnection';
  edges: Array<PurchaseAgreementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PurchaseAgreementConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type PurchaseAgreementConnectionWhere = {
  AND?: InputMaybe<Array<PurchaseAgreementConnectionWhere>>;
  NOT?: InputMaybe<PurchaseAgreementConnectionWhere>;
  OR?: InputMaybe<Array<PurchaseAgreementConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type PurchaseAgreementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PurchaseAgreementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PurchaseAgreementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PurchaseAgreementNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseAgreementRelationship = {
  __typename?: 'PurchaseAgreementRelationship';
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type PurchaseAssignedFlexEntitiesAggregateInput = {
  AND?: InputMaybe<Array<PurchaseAssignedFlexEntitiesAggregateInput>>;
  NOT?: InputMaybe<PurchaseAssignedFlexEntitiesAggregateInput>;
  OR?: InputMaybe<Array<PurchaseAssignedFlexEntitiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PurchaseAssignedFlexEntitiesNodeAggregationWhereInput>;
};

export type PurchaseAssignedFlexEntitiesConnection = {
  __typename?: 'PurchaseAssignedFlexEntitiesConnection';
  edges: Array<PurchaseAssignedFlexEntitiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PurchaseAssignedFlexEntitiesConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type PurchaseAssignedFlexEntitiesConnectionWhere = {
  AND?: InputMaybe<Array<PurchaseAssignedFlexEntitiesConnectionWhere>>;
  NOT?: InputMaybe<PurchaseAssignedFlexEntitiesConnectionWhere>;
  OR?: InputMaybe<Array<PurchaseAssignedFlexEntitiesConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type PurchaseAssignedFlexEntitiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PurchaseAssignedFlexEntitiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PurchaseAssignedFlexEntitiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PurchaseAssignedFlexEntitiesNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseAssignedFlexEntitiesRelationship = {
  __typename?: 'PurchaseAssignedFlexEntitiesRelationship';
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type PurchaseEdge = {
  __typename?: 'PurchaseEdge';
  cursor: Scalars['String']['output'];
  node: Purchase;
};

export type PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection = {
  __typename?: 'PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection>;
};

export type PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection = {
  __typename?: 'PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type PurchaseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PurchaseSort objects to sort Purchases by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PurchaseSort>>;
};

export type PurchaseRefundRefundsAggregationSelection = {
  __typename?: 'PurchaseRefundRefundsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PurchaseRefundRefundsNodeAggregateSelection>;
};

export type PurchaseRefundRefundsNodeAggregateSelection = {
  __typename?: 'PurchaseRefundRefundsNodeAggregateSelection';
  agreementId: StringAggregateSelectionNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type PurchaseRefundsAggregateInput = {
  AND?: InputMaybe<Array<PurchaseRefundsAggregateInput>>;
  NOT?: InputMaybe<PurchaseRefundsAggregateInput>;
  OR?: InputMaybe<Array<PurchaseRefundsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PurchaseRefundsNodeAggregationWhereInput>;
};

export type PurchaseRefundsConnection = {
  __typename?: 'PurchaseRefundsConnection';
  edges: Array<PurchaseRefundsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PurchaseRefundsConnectionSort = {
  node?: InputMaybe<RefundSort>;
};

export type PurchaseRefundsConnectionWhere = {
  AND?: InputMaybe<Array<PurchaseRefundsConnectionWhere>>;
  NOT?: InputMaybe<PurchaseRefundsConnectionWhere>;
  OR?: InputMaybe<Array<PurchaseRefundsConnectionWhere>>;
  node?: InputMaybe<RefundWhere>;
};

export type PurchaseRefundsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PurchaseRefundsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PurchaseRefundsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PurchaseRefundsNodeAggregationWhereInput>>;
  agreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseRefundsRelationship = {
  __typename?: 'PurchaseRefundsRelationship';
  cursor: Scalars['String']['output'];
  node: Refund;
};

/** Fields to sort Purchases by. The order in which sorts are applied is not guaranteed when specifying many fields in one PurchaseSort object. */
export type PurchaseSort = {
  id?: InputMaybe<SortDirection>;
  maxCoverageStartDate?: InputMaybe<SortDirection>;
  maxTherapyTrialStartDate?: InputMaybe<SortDirection>;
  purchaseDate?: InputMaybe<SortDirection>;
  purchaseId?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  timeStamp?: InputMaybe<SortDirection>;
};

export type PurchaseWhere = {
  AND?: InputMaybe<Array<PurchaseWhere>>;
  NOT?: InputMaybe<PurchaseWhere>;
  OR?: InputMaybe<Array<PurchaseWhere>>;
  agreement?: InputMaybe<AgreementWhere>;
  agreementAggregate?: InputMaybe<PurchaseAgreementAggregateInput>;
  agreementConnection?: InputMaybe<PurchaseAgreementConnectionWhere>;
  agreementConnection_NOT?: InputMaybe<PurchaseAgreementConnectionWhere>;
  agreement_NOT?: InputMaybe<AgreementWhere>;
  assignedFlexEntitiesAggregate?: InputMaybe<PurchaseAssignedFlexEntitiesAggregateInput>;
  /** Return Purchases where all of the related PurchaseAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_ALL?: InputMaybe<PurchaseAssignedFlexEntitiesConnectionWhere>;
  /** Return Purchases where none of the related PurchaseAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_NONE?: InputMaybe<PurchaseAssignedFlexEntitiesConnectionWhere>;
  /** Return Purchases where one of the related PurchaseAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_SINGLE?: InputMaybe<PurchaseAssignedFlexEntitiesConnectionWhere>;
  /** Return Purchases where some of the related PurchaseAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_SOME?: InputMaybe<PurchaseAssignedFlexEntitiesConnectionWhere>;
  /** Return Purchases where all of the related FlexEntities match this filter */
  assignedFlexEntities_ALL?: InputMaybe<FlexEntityWhere>;
  /** Return Purchases where none of the related FlexEntities match this filter */
  assignedFlexEntities_NONE?: InputMaybe<FlexEntityWhere>;
  /** Return Purchases where one of the related FlexEntities match this filter */
  assignedFlexEntities_SINGLE?: InputMaybe<FlexEntityWhere>;
  /** Return Purchases where some of the related FlexEntities match this filter */
  assignedFlexEntities_SOME?: InputMaybe<FlexEntityWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  purchaseDate?: InputMaybe<Scalars['Date']['input']>;
  purchaseDate_GT?: InputMaybe<Scalars['Date']['input']>;
  purchaseDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  purchaseDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  purchaseDate_LT?: InputMaybe<Scalars['Date']['input']>;
  purchaseDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  purchaseId?: InputMaybe<Scalars['String']['input']>;
  purchaseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  purchaseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchaseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  purchaseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  refundsAggregate?: InputMaybe<PurchaseRefundsAggregateInput>;
  /** Return Purchases where all of the related PurchaseRefundsConnections match this filter */
  refundsConnection_ALL?: InputMaybe<PurchaseRefundsConnectionWhere>;
  /** Return Purchases where none of the related PurchaseRefundsConnections match this filter */
  refundsConnection_NONE?: InputMaybe<PurchaseRefundsConnectionWhere>;
  /** Return Purchases where one of the related PurchaseRefundsConnections match this filter */
  refundsConnection_SINGLE?: InputMaybe<PurchaseRefundsConnectionWhere>;
  /** Return Purchases where some of the related PurchaseRefundsConnections match this filter */
  refundsConnection_SOME?: InputMaybe<PurchaseRefundsConnectionWhere>;
  /** Return Purchases where all of the related Refunds match this filter */
  refunds_ALL?: InputMaybe<RefundWhere>;
  /** Return Purchases where none of the related Refunds match this filter */
  refunds_NONE?: InputMaybe<RefundWhere>;
  /** Return Purchases where one of the related Refunds match this filter */
  refunds_SINGLE?: InputMaybe<RefundWhere>;
  /** Return Purchases where some of the related Refunds match this filter */
  refunds_SOME?: InputMaybe<RefundWhere>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeStamp?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  timeStamp_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timeStamp_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PurchasesConnection = {
  __typename?: 'PurchasesConnection';
  edges: Array<PurchaseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  CanPushAgreement?: Maybe<Scalars['Boolean']['output']>;
  CheckBrandsAndTreatments?: Maybe<Scalars['String']['output']>;
  CheckCountryScopesEditable: Array<ScopeCheckResult>;
  CheckMasterDataUpdateImpact: Array<Art71MasterDataImpacts>;
  CheckQuery: NinjaQueryImpact;
  DownloadDetailedReport: Array<DqcDetailedReportRaw>;
  GeActiveUploadOrganizationNames: Array<Scalars['String']['output']>;
  GetActiveUploadOrganizations: Array<Scalars['String']['output']>;
  GetActiveUserSessions: Array<ActiveUserSession>;
  GetAgreementListFromCache: Array<CachedAgreementListItem>;
  GetAgreementWorkerStates: Array<RunningJobState>;
  GetAllAgreementsSpecificRoles: Array<AgreementSpecificRole>;
  GetAllOrganizationDomains: Array<Domain>;
  GetAllUsersFromOrganization: Array<UserOrganizationInfo>;
  GetBrandReport: Array<Maybe<GetBrandReportItem>>;
  GetClusterWorkerMetrics: ClusterWorkersSnapshot;
  GetConfig?: Maybe<Config>;
  GetCosmosMetrics: CosmosMetric;
  GetCurrentUser?: Maybe<OidDcUser>;
  GetCustomTranslations: Scalars['String']['output'];
  GetDefaultAgreementRoles: Array<DefaultAgreementRoleInfo>;
  GetEligibilityConditionSets: Array<EligibilityConditionSet>;
  GetEnabledSsoTypes: Array<SingleSignOnType>;
  GetExtendedOrg?: Maybe<Organization>;
  GetFinancialSummaryLocalizationKeySuggestions: Array<LocalizationKeySuggestions>;
  GetGeneralConfiguration: Array<UserOrgSettingsData>;
  GetIcd10Suggestions?: Maybe<Icd10Suggestions>;
  GetIndicationReport: Array<Maybe<GetIndicationReportItem>>;
  GetIsStfpPathExist: Scalars['Boolean']['output'];
  GetLegalEntities?: Maybe<Array<Maybe<Organization>>>;
  GetMissingTranslationKeys: Array<Maybe<MissingTranslationKeys>>;
  GetModules: Array<Maybe<Module>>;
  GetNeo4jClusterMetrics: Neo4jClusterMetrics;
  GetNewVersionMinStartDate: Scalars['Date']['output'];
  GetOrganization?: Maybe<AuthOrganization>;
  GetOrganizationAgreementTags: Array<Scalars['String']['output']>;
  GetOrganizationBrands: Array<Brand>;
  GetOrganizationDomains: Array<Domain>;
  GetOrganizationMetricsData: Scalars['String']['output'];
  GetOrganizations?: Maybe<Array<Maybe<AuthOrganization>>>;
  GetOrganizationsFilteredByCountry?: Maybe<Array<Maybe<Organization>>>;
  GetPgBossMetrics?: Maybe<PgBossMetrics>;
  GetPlatformUrl: Scalars['String']['output'];
  GetPostgresMetrics?: Maybe<PostgresMetric>;
  GetProductBlueprintById?: Maybe<ProductBlueprint>;
  GetProductBlueprints?: Maybe<Array<ProductBlueprintResult>>;
  GetRunChecksState: Array<RunnableCheck>;
  GetRunnableChecks: Array<Scalars['String']['output']>;
  GetRunningChecks: Array<RunningJobState>;
  GetSftpSubdirectories: Array<Scalars['String']['output']>;
  GetSlowestGraphqlRequests: SlowGraphqlRequestsResult;
  GetTermsAndPolicies?: Maybe<Array<PolicyVersion>>;
  GetTermsAndPoliciesPair?: Maybe<Array<Maybe<PolicyVersion>>>;
  GetTranslations: Scalars['String']['output'];
  GetTranslationsWithChangedKeys: AvailableTranslations;
  GetTypesToCheck: IntegrityCheckTypes;
  GetUploadState?: Maybe<UploadState>;
  GetUser?: Maybe<StoreUser>;
  GetUserContextFiltersAgreements?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersBrandIndications?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersCountries?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersCustomConditions?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersFlexQueries?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersFlexibleFormsRecords?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersIndications?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersLocalization?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersMissingKeys?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersModels?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersPerformanceMeasurements?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersPerformanceProfiles?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersProductBlueprints?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersProducts?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersScopes?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersTermsAndPolicies?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersUsers?: Maybe<Scalars['String']['output']>;
  GetUserCreatedSimulationsCount?: Maybe<SimulationCount>;
  GetUserDefaultRole: Scalars['String']['output'];
  GetUsers: Array<Maybe<User>>;
  GetUsersByModuleAndOrg: Array<StoreUser>;
  PreparationLimitationsCount: Scalars['Int']['output'];
  RunFlexQuery: QueryResult;
  activeUserSessions: Array<ActiveUserSession>;
  activeUserSessionsConnection: ActiveUserSessionsConnection;
  agreementDecisions: Array<AgreementDecision>;
  agreementDecisionsConnection: AgreementDecisionsConnection;
  agreementRunAttemptInfos: Array<AgreementRunAttemptInfo>;
  agreementRunAttemptInfosConnection: AgreementRunAttemptInfosConnection;
  agreementScopeCountryScopes: Array<AgreementScopeCountryScope>;
  agreementScopeCountryScopesConnection: AgreementScopeCountryScopesConnection;
  agreementScopeOrganizationScopes: Array<AgreementScopeOrganizationScope>;
  agreementScopeOrganizationScopesConnection: AgreementScopeOrganizationScopesConnection;
  agreementScopes: Array<AgreementScope>;
  agreementScopesConnection: AgreementScopesConnection;
  agreementSpecificRoles: Array<AgreementSpecificRole>;
  agreementSpecificRolesConnection: AgreementSpecificRolesConnection;
  agreementStatusTransitions: Array<AgreementStatusTransition>;
  agreementStatusTransitionsConnection: AgreementStatusTransitionsConnection;
  agreementTags: Array<AgreementTag>;
  agreementTagsConnection: AgreementTagsConnection;
  agreementTemplateVersionCreationResponses: Array<AgreementTemplateVersionCreationResponse>;
  agreementTemplateVersionCreationResponsesConnection: AgreementTemplateVersionCreationResponsesConnection;
  agreementTemplates: Array<AgreementTemplate>;
  agreementTemplatesConnection: AgreementTemplatesConnection;
  agreements: Array<Agreement>;
  agreementsConnection: AgreementsConnection;
  alerts: Array<Alert>;
  alertsConnection: AlertsConnection;
  art71MasterDataImpacts: Array<Art71MasterDataImpacts>;
  art71MasterDataImpactsConnection: Art71MasterDataImpactsConnection;
  article71Indications: Array<Article71Indication>;
  article71IndicationsConnection: Article71IndicationsConnection;
  authOrganizations: Array<AuthOrganization>;
  authOrganizationsConnection: AuthOrganizationsConnection;
  availableTranslations: Array<AvailableTranslations>;
  availableTranslationsConnection: AvailableTranslationsConnection;
  averageGenericPrices: Array<AverageGenericPrice>;
  averageGenericPricesConnection: AverageGenericPricesConnection;
  baseAgreements: Array<BaseAgreement>;
  baseAgreementsConnection: BaseAgreementsConnection;
  brands: Array<Brand>;
  brandsConnection: BrandsConnection;
  cachedAgreementListItems: Array<CachedAgreementListItem>;
  cachedAgreementListItemsConnection: CachedAgreementListItemsConnection;
  cases: Array<Case>;
  casesConnection: CasesConnection;
  catalogueAttributes: Array<CatalogueAttribute>;
  catalogueAttributesConnection: CatalogueAttributesConnection;
  chartRangeConfigurations: Array<ChartRangeConfiguration>;
  chartRangeConfigurationsConnection: ChartRangeConfigurationsConnection;
  checkedTypes: Array<CheckedType>;
  checkedTypesConnection: CheckedTypesConnection;
  clusterWorkerMetrics: Array<ClusterWorkerMetric>;
  clusterWorkerMetricsConnection: ClusterWorkerMetricsConnection;
  clusterWorkersSnapshots: Array<ClusterWorkersSnapshot>;
  clusterWorkersSnapshotsConnection: ClusterWorkersSnapshotsConnection;
  configs: Array<Config>;
  configsConnection: ConfigsConnection;
  coreNinjaQueries: Array<NinjaQuery>;
  cosmosMetrics: Array<CosmosMetric>;
  cosmosMetricsConnection: CosmosMetricsConnection;
  countries: Array<Country>;
  countriesConnection: CountriesConnection;
  crossCountryPrices: Array<CrossCountryPrice>;
  crossCountryPricesConnection: CrossCountryPricesConnection;
  currencies: Array<Currency>;
  currenciesConnection: CurrenciesConnection;
  customConditions: Array<CustomCondition>;
  customConditionsConnection: CustomConditionsConnection;
  customIntegrityChecks: Array<CustomIntegrityCheck>;
  customIntegrityChecksConnection: CustomIntegrityChecksConnection;
  cycleConfigurations: Array<CycleConfiguration>;
  cycleConfigurationsConnection: CycleConfigurationsConnection;
  cycleTherapyConfigurations: Array<CycleTherapyConfiguration>;
  cycleTherapyConfigurationsConnection: CycleTherapyConfigurationsConnection;
  dataContainers: Array<DataContainer>;
  dataContainersConnection: DataContainersConnection;
  dataSources: Array<DataSource>;
  dataSourcesConnection: DataSourcesConnection;
  defaultAgreementRoleInfos: Array<DefaultAgreementRoleInfo>;
  defaultAgreementRoleInfosConnection: DefaultAgreementRoleInfosConnection;
  deviceAlternatives: Array<DeviceAlternative>;
  deviceAlternativesConnection: DeviceAlternativesConnection;
  disabledDataChecks: Array<DisabledDataCheck>;
  disabledDataChecksConnection: DisabledDataChecksConnection;
  diseases: Array<Disease>;
  diseasesConnection: DiseasesConnection;
  documentRefundGroups: Array<DocumentRefundGroup>;
  documentRefundGroupsConnection: DocumentRefundGroupsConnection;
  documents: Array<Document>;
  documentsConnection: DocumentsConnection;
  domains: Array<Domain>;
  domainsConnection: DomainsConnection;
  dqcDetailedReportRaws: Array<DqcDetailedReportRaw>;
  dqcDetailedReportRawsConnection: DqcDetailedReportRawsConnection;
  dummyEnumReferences: Array<DummyEnumReferences>;
  dummyEnumReferencesConnection: DummyEnumReferencesConnection;
  eligibilityConditionSets: Array<EligibilityConditionSet>;
  eligibilityConditionSetsConnection: EligibilityConditionSetsConnection;
  encapsulatedFeatureConfigurations: Array<EncapsulatedFeatureConfiguration>;
  encapsulatedFeatureConfigurationsConnection: EncapsulatedFeatureConfigurationsConnection;
  encapsulatedFeatures: Array<EncapsulatedFeature>;
  encapsulatedFeaturesConnection: EncapsulatedFeaturesConnection;
  enrollingConditionSets: Array<EnrollingConditionSet>;
  enrollingConditionSetsConnection: EnrollingConditionSetsConnection;
  enrollingConditions: Array<EnrollingCondition>;
  enrollingConditionsConnection: EnrollingConditionsConnection;
  enrollingPeriods: Array<EnrollingPeriod>;
  enrollingPeriodsConnection: EnrollingPeriodsConnection;
  entryModules: Array<EntryModule>;
  entryModulesConnection: EntryModulesConnection;
  exFactoryPrices: Array<ExFactoryPrice>;
  exFactoryPricesConnection: ExFactoryPricesConnection;
  financialSummaryColumns: Array<FinancialSummaryColumn>;
  financialSummaryColumnsConnection: FinancialSummaryColumnsConnection;
  flexEntities: Array<FlexEntity>;
  flexEntitiesConnection: FlexEntitiesConnection;
  flexEntityTypes: Array<FlexEntityType>;
  flexEntityTypesConnection: FlexEntityTypesConnection;
  flexFinancialDataPoints: Array<FlexFinancialDataPoint>;
  flexFinancialDataPointsConnection: FlexFinancialDataPointsConnection;
  flexQueries: Array<FlexQuery>;
  flexQueriesConnection: FlexQueriesConnection;
  flexQueryRuns: Array<FlexQueryRun>;
  flexQueryRunsConnection: FlexQueryRunsConnection;
  generics: Array<Generic>;
  genericsConnection: GenericsConnection;
  getBrandReportItems: Array<GetBrandReportItem>;
  getBrandReportItemsConnection: GetBrandReportItemsConnection;
  getIndicationReportItems: Array<GetIndicationReportItem>;
  getIndicationReportItemsConnection: GetIndicationReportItemsConnection;
  globalLocks: Array<GlobalLock>;
  globalLocksConnection: GlobalLocksConnection;
  icd10Attributes: Array<Icd10Attribute>;
  icd10AttributesConnection: Icd10AttributesConnection;
  icd10Concepts: Array<Icd10Concept>;
  icd10ConceptsConnection: Icd10ConceptsConnection;
  icd10Entities: Array<Icd10Entity>;
  icd10EntitiesConnection: Icd10EntitiesConnection;
  icd10Suggestions: Array<Icd10Suggestions>;
  icd10SuggestionsConnection: Icd10SuggestionsConnection;
  icd10Traits: Array<Icd10Trait>;
  icd10TraitsConnection: Icd10TraitsConnection;
  impactItems: Array<ImpactItem>;
  impactItemsConnection: ImpactItemsConnection;
  indications: Array<Indication>;
  indicationsConnection: IndicationsConnection;
  integrityCheckCompleteResults: Array<IntegrityCheckCompleteResult>;
  integrityCheckCompleteResultsConnection: IntegrityCheckCompleteResultsConnection;
  integrityCheckTypes: Array<IntegrityCheckTypes>;
  integrityCheckTypesConnection: IntegrityCheckTypesConnection;
  libraryNinjaQueries: Array<NinjaQuery>;
  limitations: Array<Limitation>;
  limitationsConnection: LimitationsConnection;
  localizationKeySuggestions: Array<LocalizationKeySuggestions>;
  localizationKeySuggestionsConnection: LocalizationKeySuggestionsConnection;
  mainIndications: Array<MainIndication>;
  mainIndicationsConnection: MainIndicationsConnection;
  masterDataRefundImpacts: Array<MasterDataRefundImpact>;
  masterDataRefundImpactsConnection: MasterDataRefundImpactsConnection;
  masterDataUploadHistoryRecords: Array<MasterDataUploadHistoryRecord>;
  masterDataUploadHistoryRecordsConnection: MasterDataUploadHistoryRecordsConnection;
  messages: Array<Message>;
  messagesConnection: MessagesConnection;
  missingTranslationKeys: Array<MissingTranslationKeys>;
  missingTranslationKeysConnection: MissingTranslationKeysConnection;
  modules: Array<Module>;
  modulesConnection: ModulesConnection;
  negotiationRounds: Array<NegotiationRound>;
  negotiationRoundsConnection: NegotiationRoundsConnection;
  neo4JClusterMemberMetrics: Array<Neo4jClusterMemberMetric>;
  neo4JClusterMemberMetricsConnection: Neo4JClusterMemberMetricsConnection;
  neo4JClusterMetrics: Array<Neo4jClusterMetrics>;
  neo4JClusterMetricsConnection: Neo4JClusterMetricsConnection;
  ninjaQueries: Array<NinjaQuery>;
  ninjaQueriesConnection: NinjaQueriesConnection;
  ninjaQueryImpacts: Array<NinjaQueryImpact>;
  ninjaQueryImpactsConnection: NinjaQueryImpactsConnection;
  ninjaQuerySubmitResults: Array<NinjaQuerySubmitResult>;
  ninjaQuerySubmitResultsConnection: NinjaQuerySubmitResultsConnection;
  oidDcUsers: Array<OidDcUser>;
  oidDcUsersConnection: OidDcUsersConnection;
  organizationScopes: Array<OrganizationScope>;
  organizationScopesConnection: OrganizationScopesConnection;
  organizations: Array<Organization>;
  organizationsConnection: OrganizationsConnection;
  partners: Array<Partner>;
  partnersConnection: PartnersConnection;
  patients: Array<Patient>;
  patientsConnection: PatientsConnection;
  performanceCounters: Array<PerformanceCounter>;
  performanceCountersConnection: PerformanceCountersConnection;
  performanceMeasurements: Array<PerformanceMeasurement>;
  performanceMeasurementsConnection: PerformanceMeasurementsConnection;
  performanceThresholds: Array<PerformanceThreshold>;
  performanceThresholdsConnection: PerformanceThresholdsConnection;
  pgBossMetrics: Array<PgBossMetrics>;
  pgBossMetricsConnection: PgBossMetricsConnection;
  pgBossQueueStats: Array<PgBossQueueStat>;
  pgBossQueueStatsConnection: PgBossQueueStatsConnection;
  policyTypes: Array<PolicyType>;
  policyTypesConnection: PolicyTypesConnection;
  policyVersions: Array<PolicyVersion>;
  policyVersionsConnection: PolicyVersionsConnection;
  postgresMetrics: Array<PostgresMetric>;
  postgresMetricsConnection: PostgresMetricsConnection;
  preparationStatuses: Array<PreparationStatus>;
  preparationStatusesConnection: PreparationStatusesConnection;
  preparations: Array<Preparation>;
  preparationsConnection: PreparationsConnection;
  prices: Array<Price>;
  pricesConnection: PricesConnection;
  productBlueprintResults: Array<ProductBlueprintResult>;
  productBlueprintResultsConnection: ProductBlueprintResultsConnection;
  productBlueprints: Array<ProductBlueprint>;
  productBlueprintsConnection: ProductBlueprintsConnection;
  publicPrices: Array<PublicPrice>;
  publicPricesConnection: PublicPricesConnection;
  purchases: Array<Purchase>;
  purchasesConnection: PurchasesConnection;
  queryLogs: Array<QueryLog>;
  queryLogsConnection: QueryLogsConnection;
  queryResults: Array<QueryResult>;
  queryResultsConnection: QueryResultsConnection;
  questNotifications: Array<QuestNotification>;
  questNotificationsConnection: QuestNotificationsConnection;
  refunds: Array<Refund>;
  refundsConnection: RefundsConnection;
  runCheckValues: Array<RunCheckValues>;
  runCheckValuesConnection: RunCheckValuesConnection;
  runChecks: Array<RunCheck>;
  runChecksConnection: RunChecksConnection;
  runDqcReports: Array<RunDqcReport>;
  runDqcReportsConnection: RunDqcReportsConnection;
  runnableChecks: Array<RunnableCheck>;
  runnableChecksConnection: RunnableChecksConnection;
  runningJobStates: Array<RunningJobState>;
  runningJobStatesConnection: RunningJobStatesConnection;
  scenarioActions: Array<ScenarioAction>;
  scenarioActionsConnection: ScenarioActionsConnection;
  scenarioConditions: Array<ScenarioCondition>;
  scenarioConditionsConnection: ScenarioConditionsConnection;
  scenarios: Array<Scenario>;
  scenariosConnection: ScenariosConnection;
  scopeCheckResults: Array<ScopeCheckResult>;
  scopeCheckResultsConnection: ScopeCheckResultsConnection;
  simulationCounts: Array<SimulationCount>;
  simulationCountsConnection: SimulationCountsConnection;
  simulationUserWithRoles: Array<SimulationUserWithRole>;
  simulationUserWithRolesConnection: SimulationUserWithRolesConnection;
  simulations: Array<Simulation>;
  simulationsConnection: SimulationsConnection;
  slowGraphqlOperations: Array<SlowGraphqlOperation>;
  slowGraphqlOperationsConnection: SlowGraphqlOperationsConnection;
  slowGraphqlRequestsResults: Array<SlowGraphqlRequestsResult>;
  slowGraphqlRequestsResultsConnection: SlowGraphqlRequestsResultsConnection;
  storeUsers: Array<StoreUser>;
  storeUsersConnection: StoreUsersConnection;
  syncRefundImpacts: Array<SyncRefundImpact>;
  syncRefundImpactsConnection: SyncRefundImpactsConnection;
  syncResponses: Array<SyncResponse>;
  syncResponsesConnection: SyncResponsesConnection;
  systemTasks: Array<SystemTask>;
  systemTasksConnection: SystemTasksConnection;
  translations: Array<Translation>;
  translationsConnection: TranslationsConnection;
  translationsWithChangedKeys: Array<TranslationsWithChangedKeys>;
  translationsWithChangedKeysConnection: TranslationsWithChangedKeysConnection;
  treatmentSets: Array<TreatmentSet>;
  treatmentSetsConnection: TreatmentSetsConnection;
  treatments: Array<Treatment>;
  treatmentsConnection: TreatmentsConnection;
  uploadLimitations: Array<UploadLimitation>;
  uploadLimitationsConnection: UploadLimitationsConnection;
  uploadStates: Array<UploadState>;
  uploadStatesConnection: UploadStatesConnection;
  uploads: Array<Upload>;
  uploadsConnection: UploadsConnection;
  userAvailableEntryModules: Array<UserAvailableEntryModule>;
  userAvailableEntryModulesConnection: UserAvailableEntryModulesConnection;
  userContexts: Array<UserContext>;
  userContextsConnection: UserContextsConnection;
  userOrgSettingsData: Array<UserOrgSettingsData>;
  userOrgSettingsDataConnection: UserOrgSettingsDataConnection;
  userOrganizationInfos: Array<UserOrganizationInfo>;
  userOrganizationInfosConnection: UserOrganizationInfosConnection;
  users: Array<User>;
  usersConnection: UsersConnection;
};


export type QueryCanPushAgreementArgs = {
  input?: InputMaybe<CanPushAgreementInput>;
};


export type QueryCheckBrandsAndTreatmentsArgs = {
  brandNames: Array<Scalars['String']['input']>;
  gtins?: InputMaybe<Array<Scalars['String']['input']>>;
  pharmaCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCheckCountryScopesEditableArgs = {
  scopeIds: Array<Scalars['String']['input']>;
};


export type QueryCheckMasterDataUpdateImpactArgs = {
  input: BrandInput;
};


export type QueryCheckQueryArgs = {
  input: QueryCheckInput;
};


export type QueryDownloadDetailedReportArgs = {
  identifier: Scalars['String']['input'];
};


export type QueryGetAgreementWorkerStatesArgs = {
  createdOnFrom: Scalars['DateTime']['input'];
};


export type QueryGetAllAgreementsSpecificRolesArgs = {
  id: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  users?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetAllOrganizationDomainsArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAllUsersFromOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCustomTranslationsArgs = {
  variables: GetTranslationsVariables;
};


export type QueryGetDefaultAgreementRolesArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetEnabledSsoTypesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetExtendedOrgArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetGeneralConfigurationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetIcd10SuggestionsArgs = {
  text: Scalars['String']['input'];
};


export type QueryGetIsStfpPathExistArgs = {
  path: Scalars['String']['input'];
};


export type QueryGetLegalEntitiesArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryGetNewVersionMinStartDateArgs = {
  initialVersionId: Scalars['ID']['input'];
};


export type QueryGetOrganizationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetOrganizationAgreementTagsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOrganizationBrandsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetOrganizationDomainsArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetOrganizationMetricsDataArgs = {
  validFromDate: Scalars['String']['input'];
  validToDate: Scalars['String']['input'];
};


export type QueryGetOrganizationsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetOrganizationsFilteredByCountryArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetProductBlueprintByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetRunningChecksArgs = {
  createdOnFrom: Scalars['DateTime']['input'];
};


export type QueryGetSftpSubdirectoriesArgs = {
  parent: Scalars['String']['input'];
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetSlowestGraphqlRequestsArgs = {
  days: Scalars['Int']['input'];
};


export type QueryGetTermsAndPoliciesPairArgs = {
  skipNumber?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};


export type QueryGetTranslationsArgs = {
  variables: GetTranslationsVariables;
};


export type QueryGetTranslationsWithChangedKeysArgs = {
  orgId: Scalars['String']['input'];
};


export type QueryGetUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUserCreatedSimulationsCountArgs = {
  domainIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};


export type QueryGetUserDefaultRoleArgs = {
  id: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};


export type QueryGetUsersArgs = {
  userIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryGetUsersByModuleAndOrgArgs = {
  moduleIds: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRunFlexQueryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  serializedParams?: InputMaybe<Scalars['String']['input']>;
};


export type QueryActiveUserSessionsArgs = {
  options?: InputMaybe<ActiveUserSessionOptions>;
  where?: InputMaybe<ActiveUserSessionWhere>;
};


export type QueryActiveUserSessionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ActiveUserSessionSort>>>;
  where?: InputMaybe<ActiveUserSessionWhere>;
};


export type QueryAgreementDecisionsArgs = {
  options?: InputMaybe<AgreementDecisionOptions>;
  where?: InputMaybe<AgreementDecisionWhere>;
};


export type QueryAgreementDecisionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementDecisionSort>>>;
  where?: InputMaybe<AgreementDecisionWhere>;
};


export type QueryAgreementRunAttemptInfosArgs = {
  options?: InputMaybe<AgreementRunAttemptInfoOptions>;
  where?: InputMaybe<AgreementRunAttemptInfoWhere>;
};


export type QueryAgreementRunAttemptInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementRunAttemptInfoSort>>>;
  where?: InputMaybe<AgreementRunAttemptInfoWhere>;
};


export type QueryAgreementScopeCountryScopesArgs = {
  options?: InputMaybe<AgreementScopeCountryScopeOptions>;
  where?: InputMaybe<AgreementScopeCountryScopeWhere>;
};


export type QueryAgreementScopeCountryScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementScopeCountryScopeSort>>>;
  where?: InputMaybe<AgreementScopeCountryScopeWhere>;
};


export type QueryAgreementScopeOrganizationScopesArgs = {
  options?: InputMaybe<AgreementScopeOrganizationScopeOptions>;
  where?: InputMaybe<AgreementScopeOrganizationScopeWhere>;
};


export type QueryAgreementScopeOrganizationScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementScopeOrganizationScopeSort>>>;
  where?: InputMaybe<AgreementScopeOrganizationScopeWhere>;
};


export type QueryAgreementScopesArgs = {
  options?: InputMaybe<AgreementScopeOptions>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type QueryAgreementScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementScopeSort>>>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type QueryAgreementSpecificRolesArgs = {
  options?: InputMaybe<AgreementSpecificRoleOptions>;
  where?: InputMaybe<AgreementSpecificRoleWhere>;
};


export type QueryAgreementSpecificRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementSpecificRoleSort>>>;
  where?: InputMaybe<AgreementSpecificRoleWhere>;
};


export type QueryAgreementStatusTransitionsArgs = {
  options?: InputMaybe<AgreementStatusTransitionOptions>;
  where?: InputMaybe<AgreementStatusTransitionWhere>;
};


export type QueryAgreementStatusTransitionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementStatusTransitionSort>>>;
  where?: InputMaybe<AgreementStatusTransitionWhere>;
};


export type QueryAgreementTagsArgs = {
  options?: InputMaybe<AgreementTagOptions>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type QueryAgreementTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementTagSort>>>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type QueryAgreementTemplateVersionCreationResponsesArgs = {
  options?: InputMaybe<AgreementTemplateVersionCreationResponseOptions>;
  where?: InputMaybe<AgreementTemplateVersionCreationResponseWhere>;
};


export type QueryAgreementTemplateVersionCreationResponsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementTemplateVersionCreationResponseSort>>>;
  where?: InputMaybe<AgreementTemplateVersionCreationResponseWhere>;
};


export type QueryAgreementTemplatesArgs = {
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type QueryAgreementTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementTemplateSort>>>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type QueryAgreementsArgs = {
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type QueryAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementSort>>>;
  where?: InputMaybe<AgreementWhere>;
};


export type QueryAlertsArgs = {
  options?: InputMaybe<AlertOptions>;
  where?: InputMaybe<AlertWhere>;
};


export type QueryAlertsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AlertSort>>>;
  where?: InputMaybe<AlertWhere>;
};


export type QueryArt71MasterDataImpactsArgs = {
  options?: InputMaybe<Art71MasterDataImpactsOptions>;
  where?: InputMaybe<Art71MasterDataImpactsWhere>;
};


export type QueryArt71MasterDataImpactsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Art71MasterDataImpactsSort>>>;
  where?: InputMaybe<Art71MasterDataImpactsWhere>;
};


export type QueryArticle71IndicationsArgs = {
  options?: InputMaybe<Article71IndicationOptions>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type QueryArticle71IndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Article71IndicationSort>>>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type QueryAuthOrganizationsArgs = {
  options?: InputMaybe<AuthOrganizationOptions>;
  where?: InputMaybe<AuthOrganizationWhere>;
};


export type QueryAuthOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AuthOrganizationSort>>>;
  where?: InputMaybe<AuthOrganizationWhere>;
};


export type QueryAvailableTranslationsArgs = {
  options?: InputMaybe<AvailableTranslationsOptions>;
  where?: InputMaybe<AvailableTranslationsWhere>;
};


export type QueryAvailableTranslationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AvailableTranslationsSort>>>;
  where?: InputMaybe<AvailableTranslationsWhere>;
};


export type QueryAverageGenericPricesArgs = {
  options?: InputMaybe<AverageGenericPriceOptions>;
  where?: InputMaybe<AverageGenericPriceWhere>;
};


export type QueryAverageGenericPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AverageGenericPriceSort>>>;
  where?: InputMaybe<AverageGenericPriceWhere>;
};


export type QueryBaseAgreementsArgs = {
  options?: InputMaybe<BaseAgreementOptions>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type QueryBaseAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BaseAgreementSort>>>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type QueryBrandsArgs = {
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type QueryBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BrandSort>>>;
  where?: InputMaybe<BrandWhere>;
};


export type QueryCachedAgreementListItemsArgs = {
  options?: InputMaybe<CachedAgreementListItemOptions>;
  where?: InputMaybe<CachedAgreementListItemWhere>;
};


export type QueryCachedAgreementListItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CachedAgreementListItemSort>>>;
  where?: InputMaybe<CachedAgreementListItemWhere>;
};


export type QueryCasesArgs = {
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type QueryCasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CaseSort>>>;
  where?: InputMaybe<CaseWhere>;
};


export type QueryCatalogueAttributesArgs = {
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type QueryCatalogueAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CatalogueAttributeSort>>>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type QueryChartRangeConfigurationsArgs = {
  options?: InputMaybe<ChartRangeConfigurationOptions>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type QueryChartRangeConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ChartRangeConfigurationSort>>>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type QueryCheckedTypesArgs = {
  options?: InputMaybe<CheckedTypeOptions>;
  where?: InputMaybe<CheckedTypeWhere>;
};


export type QueryCheckedTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CheckedTypeSort>>>;
  where?: InputMaybe<CheckedTypeWhere>;
};


export type QueryClusterWorkerMetricsArgs = {
  options?: InputMaybe<ClusterWorkerMetricOptions>;
  where?: InputMaybe<ClusterWorkerMetricWhere>;
};


export type QueryClusterWorkerMetricsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClusterWorkerMetricSort>>>;
  where?: InputMaybe<ClusterWorkerMetricWhere>;
};


export type QueryClusterWorkersSnapshotsArgs = {
  options?: InputMaybe<ClusterWorkersSnapshotOptions>;
  where?: InputMaybe<ClusterWorkersSnapshotWhere>;
};


export type QueryClusterWorkersSnapshotsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClusterWorkersSnapshotSort>>>;
  where?: InputMaybe<ClusterWorkersSnapshotWhere>;
};


export type QueryConfigsArgs = {
  options?: InputMaybe<ConfigOptions>;
  where?: InputMaybe<ConfigWhere>;
};


export type QueryConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ConfigSort>>>;
  where?: InputMaybe<ConfigWhere>;
};


export type QueryCosmosMetricsArgs = {
  options?: InputMaybe<CosmosMetricOptions>;
  where?: InputMaybe<CosmosMetricWhere>;
};


export type QueryCosmosMetricsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CosmosMetricSort>>>;
  where?: InputMaybe<CosmosMetricWhere>;
};


export type QueryCountriesArgs = {
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type QueryCountriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CountrySort>>>;
  where?: InputMaybe<CountryWhere>;
};


export type QueryCrossCountryPricesArgs = {
  options?: InputMaybe<CrossCountryPriceOptions>;
  where?: InputMaybe<CrossCountryPriceWhere>;
};


export type QueryCrossCountryPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CrossCountryPriceSort>>>;
  where?: InputMaybe<CrossCountryPriceWhere>;
};


export type QueryCurrenciesArgs = {
  options?: InputMaybe<CurrencyOptions>;
  where?: InputMaybe<CurrencyWhere>;
};


export type QueryCurrenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CurrencySort>>>;
  where?: InputMaybe<CurrencyWhere>;
};


export type QueryCustomConditionsArgs = {
  options?: InputMaybe<CustomConditionOptions>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type QueryCustomConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CustomConditionSort>>>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type QueryCustomIntegrityChecksArgs = {
  options?: InputMaybe<CustomIntegrityCheckOptions>;
  where?: InputMaybe<CustomIntegrityCheckWhere>;
};


export type QueryCustomIntegrityChecksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CustomIntegrityCheckSort>>>;
  where?: InputMaybe<CustomIntegrityCheckWhere>;
};


export type QueryCycleConfigurationsArgs = {
  options?: InputMaybe<CycleConfigurationOptions>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type QueryCycleConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CycleConfigurationSort>>>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type QueryCycleTherapyConfigurationsArgs = {
  options?: InputMaybe<CycleTherapyConfigurationOptions>;
  where?: InputMaybe<CycleTherapyConfigurationWhere>;
};


export type QueryCycleTherapyConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CycleTherapyConfigurationSort>>>;
  where?: InputMaybe<CycleTherapyConfigurationWhere>;
};


export type QueryDataContainersArgs = {
  options?: InputMaybe<DataContainerOptions>;
  where?: InputMaybe<DataContainerWhere>;
};


export type QueryDataContainersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DataContainerSort>>>;
  where?: InputMaybe<DataContainerWhere>;
};


export type QueryDataSourcesArgs = {
  options?: InputMaybe<DataSourceOptions>;
  where?: InputMaybe<DataSourceWhere>;
};


export type QueryDataSourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DataSourceSort>>>;
  where?: InputMaybe<DataSourceWhere>;
};


export type QueryDefaultAgreementRoleInfosArgs = {
  options?: InputMaybe<DefaultAgreementRoleInfoOptions>;
  where?: InputMaybe<DefaultAgreementRoleInfoWhere>;
};


export type QueryDefaultAgreementRoleInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DefaultAgreementRoleInfoSort>>>;
  where?: InputMaybe<DefaultAgreementRoleInfoWhere>;
};


export type QueryDeviceAlternativesArgs = {
  options?: InputMaybe<DeviceAlternativeOptions>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type QueryDeviceAlternativesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DeviceAlternativeSort>>>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type QueryDisabledDataChecksArgs = {
  options?: InputMaybe<DisabledDataCheckOptions>;
  where?: InputMaybe<DisabledDataCheckWhere>;
};


export type QueryDisabledDataChecksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DisabledDataCheckSort>>>;
  where?: InputMaybe<DisabledDataCheckWhere>;
};


export type QueryDiseasesArgs = {
  options?: InputMaybe<DiseaseOptions>;
  where?: InputMaybe<DiseaseWhere>;
};


export type QueryDiseasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DiseaseSort>>>;
  where?: InputMaybe<DiseaseWhere>;
};


export type QueryDocumentRefundGroupsArgs = {
  options?: InputMaybe<DocumentRefundGroupOptions>;
  where?: InputMaybe<DocumentRefundGroupWhere>;
};


export type QueryDocumentRefundGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentRefundGroupSort>>>;
  where?: InputMaybe<DocumentRefundGroupWhere>;
};


export type QueryDocumentsArgs = {
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type QueryDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentSort>>>;
  where?: InputMaybe<DocumentWhere>;
};


export type QueryDomainsArgs = {
  options?: InputMaybe<DomainOptions>;
  where?: InputMaybe<DomainWhere>;
};


export type QueryDomainsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DomainSort>>>;
  where?: InputMaybe<DomainWhere>;
};


export type QueryDqcDetailedReportRawsArgs = {
  options?: InputMaybe<DqcDetailedReportRawOptions>;
  where?: InputMaybe<DqcDetailedReportRawWhere>;
};


export type QueryDqcDetailedReportRawsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DqcDetailedReportRawSort>>>;
  where?: InputMaybe<DqcDetailedReportRawWhere>;
};


export type QueryDummyEnumReferencesArgs = {
  options?: InputMaybe<DummyEnumReferencesOptions>;
  where?: InputMaybe<DummyEnumReferencesWhere>;
};


export type QueryDummyEnumReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DummyEnumReferencesSort>>>;
  where?: InputMaybe<DummyEnumReferencesWhere>;
};


export type QueryEligibilityConditionSetsArgs = {
  options?: InputMaybe<EligibilityConditionSetOptions>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type QueryEligibilityConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EligibilityConditionSetSort>>>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type QueryEncapsulatedFeatureConfigurationsArgs = {
  options?: InputMaybe<EncapsulatedFeatureConfigurationOptions>;
  where?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
};


export type QueryEncapsulatedFeatureConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EncapsulatedFeatureConfigurationSort>>>;
  where?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
};


export type QueryEncapsulatedFeaturesArgs = {
  options?: InputMaybe<EncapsulatedFeatureOptions>;
  where?: InputMaybe<EncapsulatedFeatureWhere>;
};


export type QueryEncapsulatedFeaturesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EncapsulatedFeatureSort>>>;
  where?: InputMaybe<EncapsulatedFeatureWhere>;
};


export type QueryEnrollingConditionSetsArgs = {
  options?: InputMaybe<EnrollingConditionSetOptions>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type QueryEnrollingConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EnrollingConditionSetSort>>>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type QueryEnrollingConditionsArgs = {
  options?: InputMaybe<EnrollingConditionOptions>;
  where?: InputMaybe<EnrollingConditionWhere>;
};


export type QueryEnrollingConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EnrollingConditionSort>>>;
  where?: InputMaybe<EnrollingConditionWhere>;
};


export type QueryEnrollingPeriodsArgs = {
  options?: InputMaybe<EnrollingPeriodOptions>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type QueryEnrollingPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EnrollingPeriodSort>>>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type QueryEntryModulesArgs = {
  options?: InputMaybe<EntryModuleOptions>;
  where?: InputMaybe<EntryModuleWhere>;
};


export type QueryEntryModulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EntryModuleSort>>>;
  where?: InputMaybe<EntryModuleWhere>;
};


export type QueryExFactoryPricesArgs = {
  options?: InputMaybe<ExFactoryPriceOptions>;
  where?: InputMaybe<ExFactoryPriceWhere>;
};


export type QueryExFactoryPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ExFactoryPriceSort>>>;
  where?: InputMaybe<ExFactoryPriceWhere>;
};


export type QueryFinancialSummaryColumnsArgs = {
  options?: InputMaybe<FinancialSummaryColumnOptions>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type QueryFinancialSummaryColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FinancialSummaryColumnSort>>>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type QueryFlexEntitiesArgs = {
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type QueryFlexEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexEntitySort>>>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type QueryFlexEntityTypesArgs = {
  options?: InputMaybe<FlexEntityTypeOptions>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type QueryFlexEntityTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexEntityTypeSort>>>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type QueryFlexFinancialDataPointsArgs = {
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type QueryFlexFinancialDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexFinancialDataPointSort>>>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type QueryFlexQueriesArgs = {
  options?: InputMaybe<FlexQueryOptions>;
  where?: InputMaybe<FlexQueryWhere>;
};


export type QueryFlexQueriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexQuerySort>>>;
  where?: InputMaybe<FlexQueryWhere>;
};


export type QueryFlexQueryRunsArgs = {
  options?: InputMaybe<FlexQueryRunOptions>;
  where?: InputMaybe<FlexQueryRunWhere>;
};


export type QueryFlexQueryRunsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexQueryRunSort>>>;
  where?: InputMaybe<FlexQueryRunWhere>;
};


export type QueryGenericsArgs = {
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type QueryGenericsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericSort>>>;
  where?: InputMaybe<GenericWhere>;
};


export type QueryGetBrandReportItemsArgs = {
  options?: InputMaybe<GetBrandReportItemOptions>;
  where?: InputMaybe<GetBrandReportItemWhere>;
};


export type QueryGetBrandReportItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GetBrandReportItemSort>>>;
  where?: InputMaybe<GetBrandReportItemWhere>;
};


export type QueryGetIndicationReportItemsArgs = {
  options?: InputMaybe<GetIndicationReportItemOptions>;
  where?: InputMaybe<GetIndicationReportItemWhere>;
};


export type QueryGetIndicationReportItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GetIndicationReportItemSort>>>;
  where?: InputMaybe<GetIndicationReportItemWhere>;
};


export type QueryGlobalLocksArgs = {
  options?: InputMaybe<GlobalLockOptions>;
  where?: InputMaybe<GlobalLockWhere>;
};


export type QueryGlobalLocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GlobalLockSort>>>;
  where?: InputMaybe<GlobalLockWhere>;
};


export type QueryIcd10AttributesArgs = {
  options?: InputMaybe<Icd10AttributeOptions>;
  where?: InputMaybe<Icd10AttributeWhere>;
};


export type QueryIcd10AttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Icd10AttributeSort>>>;
  where?: InputMaybe<Icd10AttributeWhere>;
};


export type QueryIcd10ConceptsArgs = {
  options?: InputMaybe<Icd10ConceptOptions>;
  where?: InputMaybe<Icd10ConceptWhere>;
};


export type QueryIcd10ConceptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Icd10ConceptSort>>>;
  where?: InputMaybe<Icd10ConceptWhere>;
};


export type QueryIcd10EntitiesArgs = {
  options?: InputMaybe<Icd10EntityOptions>;
  where?: InputMaybe<Icd10EntityWhere>;
};


export type QueryIcd10EntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Icd10EntitySort>>>;
  where?: InputMaybe<Icd10EntityWhere>;
};


export type QueryIcd10SuggestionsArgs = {
  options?: InputMaybe<Icd10SuggestionsOptions>;
  where?: InputMaybe<Icd10SuggestionsWhere>;
};


export type QueryIcd10SuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Icd10SuggestionsSort>>>;
  where?: InputMaybe<Icd10SuggestionsWhere>;
};


export type QueryIcd10TraitsArgs = {
  options?: InputMaybe<Icd10TraitOptions>;
  where?: InputMaybe<Icd10TraitWhere>;
};


export type QueryIcd10TraitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Icd10TraitSort>>>;
  where?: InputMaybe<Icd10TraitWhere>;
};


export type QueryImpactItemsArgs = {
  options?: InputMaybe<ImpactItemOptions>;
  where?: InputMaybe<ImpactItemWhere>;
};


export type QueryImpactItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ImpactItemSort>>>;
  where?: InputMaybe<ImpactItemWhere>;
};


export type QueryIndicationsArgs = {
  options?: InputMaybe<IndicationOptions>;
  where?: InputMaybe<IndicationWhere>;
};


export type QueryIndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<IndicationSort>>>;
  where?: InputMaybe<IndicationWhere>;
};


export type QueryIntegrityCheckCompleteResultsArgs = {
  options?: InputMaybe<IntegrityCheckCompleteResultOptions>;
  where?: InputMaybe<IntegrityCheckCompleteResultWhere>;
};


export type QueryIntegrityCheckCompleteResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<IntegrityCheckCompleteResultSort>>>;
  where?: InputMaybe<IntegrityCheckCompleteResultWhere>;
};


export type QueryIntegrityCheckTypesArgs = {
  options?: InputMaybe<IntegrityCheckTypesOptions>;
  where?: InputMaybe<IntegrityCheckTypesWhere>;
};


export type QueryIntegrityCheckTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IntegrityCheckTypesWhere>;
};


export type QueryLimitationsArgs = {
  options?: InputMaybe<LimitationOptions>;
  where?: InputMaybe<LimitationWhere>;
};


export type QueryLimitationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LimitationSort>>>;
  where?: InputMaybe<LimitationWhere>;
};


export type QueryLocalizationKeySuggestionsArgs = {
  options?: InputMaybe<LocalizationKeySuggestionsOptions>;
  where?: InputMaybe<LocalizationKeySuggestionsWhere>;
};


export type QueryLocalizationKeySuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LocalizationKeySuggestionsSort>>>;
  where?: InputMaybe<LocalizationKeySuggestionsWhere>;
};


export type QueryMainIndicationsArgs = {
  options?: InputMaybe<MainIndicationOptions>;
  where?: InputMaybe<MainIndicationWhere>;
};


export type QueryMainIndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MainIndicationSort>>>;
  where?: InputMaybe<MainIndicationWhere>;
};


export type QueryMasterDataRefundImpactsArgs = {
  options?: InputMaybe<MasterDataRefundImpactOptions>;
  where?: InputMaybe<MasterDataRefundImpactWhere>;
};


export type QueryMasterDataRefundImpactsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MasterDataRefundImpactSort>>>;
  where?: InputMaybe<MasterDataRefundImpactWhere>;
};


export type QueryMasterDataUploadHistoryRecordsArgs = {
  options?: InputMaybe<MasterDataUploadHistoryRecordOptions>;
  where?: InputMaybe<MasterDataUploadHistoryRecordWhere>;
};


export type QueryMasterDataUploadHistoryRecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MasterDataUploadHistoryRecordSort>>>;
  where?: InputMaybe<MasterDataUploadHistoryRecordWhere>;
};


export type QueryMessagesArgs = {
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type QueryMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MessageSort>>>;
  where?: InputMaybe<MessageWhere>;
};


export type QueryMissingTranslationKeysArgs = {
  options?: InputMaybe<MissingTranslationKeysOptions>;
  where?: InputMaybe<MissingTranslationKeysWhere>;
};


export type QueryMissingTranslationKeysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MissingTranslationKeysSort>>>;
  where?: InputMaybe<MissingTranslationKeysWhere>;
};


export type QueryModulesArgs = {
  options?: InputMaybe<ModuleOptions>;
  where?: InputMaybe<ModuleWhere>;
};


export type QueryModulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ModuleSort>>>;
  where?: InputMaybe<ModuleWhere>;
};


export type QueryNegotiationRoundsArgs = {
  options?: InputMaybe<NegotiationRoundOptions>;
  where?: InputMaybe<NegotiationRoundWhere>;
};


export type QueryNegotiationRoundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NegotiationRoundSort>>>;
  where?: InputMaybe<NegotiationRoundWhere>;
};


export type QueryNeo4JClusterMemberMetricsArgs = {
  options?: InputMaybe<Neo4jClusterMemberMetricOptions>;
  where?: InputMaybe<Neo4jClusterMemberMetricWhere>;
};


export type QueryNeo4JClusterMemberMetricsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Neo4jClusterMemberMetricSort>>>;
  where?: InputMaybe<Neo4jClusterMemberMetricWhere>;
};


export type QueryNeo4JClusterMetricsArgs = {
  options?: InputMaybe<Neo4jClusterMetricsOptions>;
  where?: InputMaybe<Neo4jClusterMetricsWhere>;
};


export type QueryNeo4JClusterMetricsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Neo4jClusterMetricsSort>>>;
  where?: InputMaybe<Neo4jClusterMetricsWhere>;
};


export type QueryNinjaQueriesArgs = {
  options?: InputMaybe<NinjaQueryOptions>;
  where?: InputMaybe<NinjaQueryWhere>;
};


export type QueryNinjaQueriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NinjaQuerySort>>>;
  where?: InputMaybe<NinjaQueryWhere>;
};


export type QueryNinjaQueryImpactsArgs = {
  options?: InputMaybe<NinjaQueryImpactOptions>;
  where?: InputMaybe<NinjaQueryImpactWhere>;
};


export type QueryNinjaQueryImpactsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NinjaQueryImpactSort>>>;
  where?: InputMaybe<NinjaQueryImpactWhere>;
};


export type QueryNinjaQuerySubmitResultsArgs = {
  options?: InputMaybe<NinjaQuerySubmitResultOptions>;
  where?: InputMaybe<NinjaQuerySubmitResultWhere>;
};


export type QueryNinjaQuerySubmitResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NinjaQuerySubmitResultWhere>;
};


export type QueryOidDcUsersArgs = {
  options?: InputMaybe<OidDcUserOptions>;
  where?: InputMaybe<OidDcUserWhere>;
};


export type QueryOidDcUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OidDcUserSort>>>;
  where?: InputMaybe<OidDcUserWhere>;
};


export type QueryOrganizationScopesArgs = {
  options?: InputMaybe<OrganizationScopeOptions>;
  where?: InputMaybe<OrganizationScopeWhere>;
};


export type QueryOrganizationScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrganizationScopeSort>>>;
  where?: InputMaybe<OrganizationScopeWhere>;
};


export type QueryOrganizationsArgs = {
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type QueryOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrganizationSort>>>;
  where?: InputMaybe<OrganizationWhere>;
};


export type QueryPartnersArgs = {
  options?: InputMaybe<PartnerOptions>;
  where?: InputMaybe<PartnerWhere>;
};


export type QueryPartnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PartnerSort>>>;
  where?: InputMaybe<PartnerWhere>;
};


export type QueryPatientsArgs = {
  options?: InputMaybe<PatientOptions>;
  where?: InputMaybe<PatientWhere>;
};


export type QueryPatientsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PatientSort>>>;
  where?: InputMaybe<PatientWhere>;
};


export type QueryPerformanceCountersArgs = {
  options?: InputMaybe<PerformanceCounterOptions>;
  where?: InputMaybe<PerformanceCounterWhere>;
};


export type QueryPerformanceCountersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PerformanceCounterSort>>>;
  where?: InputMaybe<PerformanceCounterWhere>;
};


export type QueryPerformanceMeasurementsArgs = {
  options?: InputMaybe<PerformanceMeasurementOptions>;
  where?: InputMaybe<PerformanceMeasurementWhere>;
};


export type QueryPerformanceMeasurementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PerformanceMeasurementSort>>>;
  where?: InputMaybe<PerformanceMeasurementWhere>;
};


export type QueryPerformanceThresholdsArgs = {
  options?: InputMaybe<PerformanceThresholdOptions>;
  where?: InputMaybe<PerformanceThresholdWhere>;
};


export type QueryPerformanceThresholdsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PerformanceThresholdSort>>>;
  where?: InputMaybe<PerformanceThresholdWhere>;
};


export type QueryPgBossMetricsArgs = {
  options?: InputMaybe<PgBossMetricsOptions>;
  where?: InputMaybe<PgBossMetricsWhere>;
};


export type QueryPgBossMetricsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PgBossMetricsSort>>>;
  where?: InputMaybe<PgBossMetricsWhere>;
};


export type QueryPgBossQueueStatsArgs = {
  options?: InputMaybe<PgBossQueueStatOptions>;
  where?: InputMaybe<PgBossQueueStatWhere>;
};


export type QueryPgBossQueueStatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PgBossQueueStatSort>>>;
  where?: InputMaybe<PgBossQueueStatWhere>;
};


export type QueryPolicyTypesArgs = {
  options?: InputMaybe<PolicyTypeOptions>;
  where?: InputMaybe<PolicyTypeWhere>;
};


export type QueryPolicyTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PolicyTypeSort>>>;
  where?: InputMaybe<PolicyTypeWhere>;
};


export type QueryPolicyVersionsArgs = {
  options?: InputMaybe<PolicyVersionOptions>;
  where?: InputMaybe<PolicyVersionWhere>;
};


export type QueryPolicyVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PolicyVersionSort>>>;
  where?: InputMaybe<PolicyVersionWhere>;
};


export type QueryPostgresMetricsArgs = {
  options?: InputMaybe<PostgresMetricOptions>;
  where?: InputMaybe<PostgresMetricWhere>;
};


export type QueryPostgresMetricsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PostgresMetricSort>>>;
  where?: InputMaybe<PostgresMetricWhere>;
};


export type QueryPreparationStatusesArgs = {
  options?: InputMaybe<PreparationStatusOptions>;
  where?: InputMaybe<PreparationStatusWhere>;
};


export type QueryPreparationStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PreparationStatusSort>>>;
  where?: InputMaybe<PreparationStatusWhere>;
};


export type QueryPreparationsArgs = {
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type QueryPreparationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PreparationSort>>>;
  where?: InputMaybe<PreparationWhere>;
};


export type QueryPricesArgs = {
  options?: InputMaybe<PriceOptions>;
  where?: InputMaybe<PriceWhere>;
};


export type QueryPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PriceSort>>>;
  where?: InputMaybe<PriceWhere>;
};


export type QueryProductBlueprintResultsArgs = {
  options?: InputMaybe<ProductBlueprintResultOptions>;
  where?: InputMaybe<ProductBlueprintResultWhere>;
};


export type QueryProductBlueprintResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ProductBlueprintResultSort>>>;
  where?: InputMaybe<ProductBlueprintResultWhere>;
};


export type QueryProductBlueprintsArgs = {
  options?: InputMaybe<ProductBlueprintOptions>;
  where?: InputMaybe<ProductBlueprintWhere>;
};


export type QueryProductBlueprintsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ProductBlueprintSort>>>;
  where?: InputMaybe<ProductBlueprintWhere>;
};


export type QueryPublicPricesArgs = {
  options?: InputMaybe<PublicPriceOptions>;
  where?: InputMaybe<PublicPriceWhere>;
};


export type QueryPublicPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PublicPriceSort>>>;
  where?: InputMaybe<PublicPriceWhere>;
};


export type QueryPurchasesArgs = {
  options?: InputMaybe<PurchaseOptions>;
  where?: InputMaybe<PurchaseWhere>;
};


export type QueryPurchasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PurchaseSort>>>;
  where?: InputMaybe<PurchaseWhere>;
};


export type QueryQueryLogsArgs = {
  options?: InputMaybe<QueryLogOptions>;
  where?: InputMaybe<QueryLogWhere>;
};


export type QueryQueryLogsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QueryLogSort>>>;
  where?: InputMaybe<QueryLogWhere>;
};


export type QueryQueryResultsArgs = {
  options?: InputMaybe<QueryResultOptions>;
  where?: InputMaybe<QueryResultWhere>;
};


export type QueryQueryResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QueryResultSort>>>;
  where?: InputMaybe<QueryResultWhere>;
};


export type QueryQuestNotificationsArgs = {
  options?: InputMaybe<QuestNotificationOptions>;
  where?: InputMaybe<QuestNotificationWhere>;
};


export type QueryQuestNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestNotificationSort>>>;
  where?: InputMaybe<QuestNotificationWhere>;
};


export type QueryRefundsArgs = {
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type QueryRefundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RefundSort>>>;
  where?: InputMaybe<RefundWhere>;
};


export type QueryRunCheckValuesArgs = {
  options?: InputMaybe<RunCheckValuesOptions>;
  where?: InputMaybe<RunCheckValuesWhere>;
};


export type QueryRunCheckValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RunCheckValuesSort>>>;
  where?: InputMaybe<RunCheckValuesWhere>;
};


export type QueryRunChecksArgs = {
  options?: InputMaybe<RunCheckOptions>;
  where?: InputMaybe<RunCheckWhere>;
};


export type QueryRunChecksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RunCheckSort>>>;
  where?: InputMaybe<RunCheckWhere>;
};


export type QueryRunDqcReportsArgs = {
  options?: InputMaybe<RunDqcReportOptions>;
  where?: InputMaybe<RunDqcReportWhere>;
};


export type QueryRunDqcReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RunDqcReportSort>>>;
  where?: InputMaybe<RunDqcReportWhere>;
};


export type QueryRunnableChecksArgs = {
  options?: InputMaybe<RunnableCheckOptions>;
  where?: InputMaybe<RunnableCheckWhere>;
};


export type QueryRunnableChecksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RunnableCheckSort>>>;
  where?: InputMaybe<RunnableCheckWhere>;
};


export type QueryRunningJobStatesArgs = {
  options?: InputMaybe<RunningJobStateOptions>;
  where?: InputMaybe<RunningJobStateWhere>;
};


export type QueryRunningJobStatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RunningJobStateSort>>>;
  where?: InputMaybe<RunningJobStateWhere>;
};


export type QueryScenarioActionsArgs = {
  options?: InputMaybe<ScenarioActionOptions>;
  where?: InputMaybe<ScenarioActionWhere>;
};


export type QueryScenarioActionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ScenarioActionSort>>>;
  where?: InputMaybe<ScenarioActionWhere>;
};


export type QueryScenarioConditionsArgs = {
  options?: InputMaybe<ScenarioConditionOptions>;
  where?: InputMaybe<ScenarioConditionWhere>;
};


export type QueryScenarioConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ScenarioConditionSort>>>;
  where?: InputMaybe<ScenarioConditionWhere>;
};


export type QueryScenariosArgs = {
  options?: InputMaybe<ScenarioOptions>;
  where?: InputMaybe<ScenarioWhere>;
};


export type QueryScenariosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ScenarioSort>>>;
  where?: InputMaybe<ScenarioWhere>;
};


export type QueryScopeCheckResultsArgs = {
  options?: InputMaybe<ScopeCheckResultOptions>;
  where?: InputMaybe<ScopeCheckResultWhere>;
};


export type QueryScopeCheckResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ScopeCheckResultSort>>>;
  where?: InputMaybe<ScopeCheckResultWhere>;
};


export type QuerySimulationCountsArgs = {
  options?: InputMaybe<SimulationCountOptions>;
  where?: InputMaybe<SimulationCountWhere>;
};


export type QuerySimulationCountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SimulationCountSort>>>;
  where?: InputMaybe<SimulationCountWhere>;
};


export type QuerySimulationUserWithRolesArgs = {
  options?: InputMaybe<SimulationUserWithRoleOptions>;
  where?: InputMaybe<SimulationUserWithRoleWhere>;
};


export type QuerySimulationUserWithRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SimulationUserWithRoleSort>>>;
  where?: InputMaybe<SimulationUserWithRoleWhere>;
};


export type QuerySimulationsArgs = {
  options?: InputMaybe<SimulationOptions>;
  where?: InputMaybe<SimulationWhere>;
};


export type QuerySimulationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SimulationSort>>>;
  where?: InputMaybe<SimulationWhere>;
};


export type QuerySlowGraphqlOperationsArgs = {
  options?: InputMaybe<SlowGraphqlOperationOptions>;
  where?: InputMaybe<SlowGraphqlOperationWhere>;
};


export type QuerySlowGraphqlOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SlowGraphqlOperationSort>>>;
  where?: InputMaybe<SlowGraphqlOperationWhere>;
};


export type QuerySlowGraphqlRequestsResultsArgs = {
  options?: InputMaybe<SlowGraphqlRequestsResultOptions>;
  where?: InputMaybe<SlowGraphqlRequestsResultWhere>;
};


export type QuerySlowGraphqlRequestsResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SlowGraphqlRequestsResultSort>>>;
  where?: InputMaybe<SlowGraphqlRequestsResultWhere>;
};


export type QueryStoreUsersArgs = {
  options?: InputMaybe<StoreUserOptions>;
  where?: InputMaybe<StoreUserWhere>;
};


export type QueryStoreUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StoreUserSort>>>;
  where?: InputMaybe<StoreUserWhere>;
};


export type QuerySyncRefundImpactsArgs = {
  options?: InputMaybe<SyncRefundImpactOptions>;
  where?: InputMaybe<SyncRefundImpactWhere>;
};


export type QuerySyncRefundImpactsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SyncRefundImpactSort>>>;
  where?: InputMaybe<SyncRefundImpactWhere>;
};


export type QuerySyncResponsesArgs = {
  options?: InputMaybe<SyncResponseOptions>;
  where?: InputMaybe<SyncResponseWhere>;
};


export type QuerySyncResponsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SyncResponseSort>>>;
  where?: InputMaybe<SyncResponseWhere>;
};


export type QuerySystemTasksArgs = {
  options?: InputMaybe<SystemTaskOptions>;
  where?: InputMaybe<SystemTaskWhere>;
};


export type QuerySystemTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SystemTaskSort>>>;
  where?: InputMaybe<SystemTaskWhere>;
};


export type QueryTranslationsArgs = {
  options?: InputMaybe<TranslationOptions>;
  where?: InputMaybe<TranslationWhere>;
};


export type QueryTranslationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TranslationSort>>>;
  where?: InputMaybe<TranslationWhere>;
};


export type QueryTranslationsWithChangedKeysArgs = {
  options?: InputMaybe<TranslationsWithChangedKeysOptions>;
  where?: InputMaybe<TranslationsWithChangedKeysWhere>;
};


export type QueryTranslationsWithChangedKeysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TranslationsWithChangedKeysSort>>>;
  where?: InputMaybe<TranslationsWithChangedKeysWhere>;
};


export type QueryTreatmentSetsArgs = {
  options?: InputMaybe<TreatmentSetOptions>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type QueryTreatmentSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TreatmentSetSort>>>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type QueryTreatmentsArgs = {
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type QueryTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TreatmentSort>>>;
  where?: InputMaybe<TreatmentWhere>;
};


export type QueryUploadLimitationsArgs = {
  options?: InputMaybe<UploadLimitationOptions>;
  where?: InputMaybe<UploadLimitationWhere>;
};


export type QueryUploadLimitationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UploadLimitationSort>>>;
  where?: InputMaybe<UploadLimitationWhere>;
};


export type QueryUploadStatesArgs = {
  options?: InputMaybe<UploadStateOptions>;
  where?: InputMaybe<UploadStateWhere>;
};


export type QueryUploadStatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UploadStateSort>>>;
  where?: InputMaybe<UploadStateWhere>;
};


export type QueryUploadsArgs = {
  options?: InputMaybe<UploadOptions>;
  where?: InputMaybe<UploadWhere>;
};


export type QueryUploadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UploadSort>>>;
  where?: InputMaybe<UploadWhere>;
};


export type QueryUserAvailableEntryModulesArgs = {
  options?: InputMaybe<UserAvailableEntryModuleOptions>;
  where?: InputMaybe<UserAvailableEntryModuleWhere>;
};


export type QueryUserAvailableEntryModulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserAvailableEntryModuleSort>>>;
  where?: InputMaybe<UserAvailableEntryModuleWhere>;
};


export type QueryUserContextsArgs = {
  options?: InputMaybe<UserContextOptions>;
  where?: InputMaybe<UserContextWhere>;
};


export type QueryUserContextsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserContextSort>>>;
  where?: InputMaybe<UserContextWhere>;
};


export type QueryUserOrgSettingsDataArgs = {
  options?: InputMaybe<UserOrgSettingsDataOptions>;
  where?: InputMaybe<UserOrgSettingsDataWhere>;
};


export type QueryUserOrgSettingsDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserOrgSettingsDataSort>>>;
  where?: InputMaybe<UserOrgSettingsDataWhere>;
};


export type QueryUserOrganizationInfosArgs = {
  options?: InputMaybe<UserOrganizationInfoOptions>;
  where?: InputMaybe<UserOrganizationInfoWhere>;
};


export type QueryUserOrganizationInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserOrganizationInfoSort>>>;
  where?: InputMaybe<UserOrganizationInfoWhere>;
};


export type QueryUsersArgs = {
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserSort>>>;
  where?: InputMaybe<UserWhere>;
};

export type QueryCheckInput = {
  cypherQuery: Scalars['String']['input'];
  serializedCypherParams?: InputMaybe<Scalars['String']['input']>;
  targetDbType: NinjaQueryTargetDb;
};

export type QueryLog = {
  __typename?: 'QueryLog';
  createdOn: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pushedByUserEmail: Scalars['String']['output'];
};

export type QueryLogEdge = {
  __typename?: 'QueryLogEdge';
  cursor: Scalars['String']['output'];
  node: QueryLog;
};

export type QueryLogOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more QueryLogSort objects to sort QueryLogs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<QueryLogSort>>;
};

/** Fields to sort QueryLogs by. The order in which sorts are applied is not guaranteed when specifying many fields in one QueryLogSort object. */
export type QueryLogSort = {
  createdOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  pushedByUserEmail?: InputMaybe<SortDirection>;
};

export type QueryLogWhere = {
  AND?: InputMaybe<Array<QueryLogWhere>>;
  NOT?: InputMaybe<QueryLogWhere>;
  OR?: InputMaybe<Array<QueryLogWhere>>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  pushedByUserEmail?: InputMaybe<Scalars['String']['input']>;
  pushedByUserEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  pushedByUserEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  pushedByUserEmail_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  pushedByUserEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  pushedByUserEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type QueryLogsConnection = {
  __typename?: 'QueryLogsConnection';
  edges: Array<QueryLogEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryResult = {
  __typename?: 'QueryResult';
  data?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export type QueryResultEdge = {
  __typename?: 'QueryResultEdge';
  cursor: Scalars['String']['output'];
  node: QueryResult;
};

export type QueryResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more QueryResultSort objects to sort QueryResults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<QueryResultSort>>;
};

/** Fields to sort QueryResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one QueryResultSort object. */
export type QueryResultSort = {
  data?: InputMaybe<SortDirection>;
  error?: InputMaybe<SortDirection>;
};

export type QueryResultWhere = {
  AND?: InputMaybe<Array<QueryResultWhere>>;
  NOT?: InputMaybe<QueryResultWhere>;
  OR?: InputMaybe<Array<QueryResultWhere>>;
  data?: InputMaybe<Scalars['String']['input']>;
  data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  data_MATCHES?: InputMaybe<Scalars['String']['input']>;
  data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  error_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  error_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  error_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  error_MATCHES?: InputMaybe<Scalars['String']['input']>;
  error_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type QueryResultsConnection = {
  __typename?: 'QueryResultsConnection';
  edges: Array<QueryResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestNotification = {
  __typename?: 'QuestNotification';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subscribed: Array<Organization>;
  subscribedAggregate?: Maybe<QuestNotificationOrganizationSubscribedAggregationSelection>;
  subscribedConnection: QuestNotificationSubscribedConnection;
};


export type QuestNotificationSubscribedArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type QuestNotificationSubscribedAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type QuestNotificationSubscribedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QuestNotificationSubscribedConnectionSort>>;
  where?: InputMaybe<QuestNotificationSubscribedConnectionWhere>;
};

export type QuestNotificationEdge = {
  __typename?: 'QuestNotificationEdge';
  cursor: Scalars['String']['output'];
  node: QuestNotification;
};

export type QuestNotificationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amountType?: InputMaybe<AmountsType>;
  autocompletionThreshold?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isAutocompletionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestNotificationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more QuestNotificationSort objects to sort QuestNotifications by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<QuestNotificationSort>>;
};

export type QuestNotificationOrganizationSubscribedAggregationSelection = {
  __typename?: 'QuestNotificationOrganizationSubscribedAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<QuestNotificationOrganizationSubscribedEdgeAggregateSelection>;
  node?: Maybe<QuestNotificationOrganizationSubscribedNodeAggregateSelection>;
};

export type QuestNotificationOrganizationSubscribedEdgeAggregateSelection = {
  __typename?: 'QuestNotificationOrganizationSubscribedEdgeAggregateSelection';
  autocompletionThreshold: IntAggregateSelectionNullable;
  threshold: IntAggregateSelectionNullable;
};

export type QuestNotificationOrganizationSubscribedNodeAggregateSelection = {
  __typename?: 'QuestNotificationOrganizationSubscribedNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

/** Fields to sort QuestNotifications by. The order in which sorts are applied is not guaranteed when specifying many fields in one QuestNotificationSort object. */
export type QuestNotificationSort = {
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type QuestNotificationSubscribedAggregateInput = {
  AND?: InputMaybe<Array<QuestNotificationSubscribedAggregateInput>>;
  NOT?: InputMaybe<QuestNotificationSubscribedAggregateInput>;
  OR?: InputMaybe<Array<QuestNotificationSubscribedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<QuestNotificationSubscribedEdgeAggregationWhereInput>;
  node?: InputMaybe<QuestNotificationSubscribedNodeAggregationWhereInput>;
};

export type QuestNotificationSubscribedConnection = {
  __typename?: 'QuestNotificationSubscribedConnection';
  edges: Array<QuestNotificationSubscribedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestNotificationSubscribedConnectionSort = {
  edge?: InputMaybe<OrganizationQuestRelationshipSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type QuestNotificationSubscribedConnectionWhere = {
  AND?: InputMaybe<Array<QuestNotificationSubscribedConnectionWhere>>;
  NOT?: InputMaybe<QuestNotificationSubscribedConnectionWhere>;
  OR?: InputMaybe<Array<QuestNotificationSubscribedConnectionWhere>>;
  edge?: InputMaybe<OrganizationQuestRelationshipWhere>;
  node?: InputMaybe<OrganizationWhere>;
};

export type QuestNotificationSubscribedEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestNotificationSubscribedEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestNotificationSubscribedEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestNotificationSubscribedEdgeAggregationWhereInput>>;
  autocompletionThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestNotificationSubscribedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestNotificationSubscribedNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<QuestNotificationSubscribedNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestNotificationSubscribedNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestNotificationSubscribedRelationship = OrganizationQuestRelationship & {
  __typename?: 'QuestNotificationSubscribedRelationship';
  active?: Maybe<Scalars['Boolean']['output']>;
  amountType?: Maybe<AmountsType>;
  autocompletionThreshold?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isAutocompletionEnabled?: Maybe<Scalars['Boolean']['output']>;
  node: Organization;
  threshold?: Maybe<Scalars['Int']['output']>;
};

export type QuestNotificationWhere = {
  AND?: InputMaybe<Array<QuestNotificationWhere>>;
  NOT?: InputMaybe<QuestNotificationWhere>;
  OR?: InputMaybe<Array<QuestNotificationWhere>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_GT?: InputMaybe<Scalars['Int']['input']>;
  id_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subscribedAggregate?: InputMaybe<QuestNotificationSubscribedAggregateInput>;
  /** Return QuestNotifications where all of the related QuestNotificationSubscribedConnections match this filter */
  subscribedConnection_ALL?: InputMaybe<QuestNotificationSubscribedConnectionWhere>;
  /** Return QuestNotifications where none of the related QuestNotificationSubscribedConnections match this filter */
  subscribedConnection_NONE?: InputMaybe<QuestNotificationSubscribedConnectionWhere>;
  /** Return QuestNotifications where one of the related QuestNotificationSubscribedConnections match this filter */
  subscribedConnection_SINGLE?: InputMaybe<QuestNotificationSubscribedConnectionWhere>;
  /** Return QuestNotifications where some of the related QuestNotificationSubscribedConnections match this filter */
  subscribedConnection_SOME?: InputMaybe<QuestNotificationSubscribedConnectionWhere>;
  /** Return QuestNotifications where all of the related Organizations match this filter */
  subscribed_ALL?: InputMaybe<OrganizationWhere>;
  /** Return QuestNotifications where none of the related Organizations match this filter */
  subscribed_NONE?: InputMaybe<OrganizationWhere>;
  /** Return QuestNotifications where one of the related Organizations match this filter */
  subscribed_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return QuestNotifications where some of the related Organizations match this filter */
  subscribed_SOME?: InputMaybe<OrganizationWhere>;
};

export type QuestNotificationsConnection = {
  __typename?: 'QuestNotificationsConnection';
  edges: Array<QuestNotificationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum RecordNature {
  Administered = 'ADMINISTERED',
  Prescribed = 'PRESCRIBED',
  Purchased = 'PURCHASED'
}

export type Refund = {
  __typename?: 'Refund';
  agreement?: Maybe<Agreement>;
  agreementAggregate?: Maybe<RefundAgreementAgreementAggregationSelection>;
  agreementConnection: RefundAgreementConnection;
  agreementId?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  case?: Maybe<Case>;
  caseAggregate?: Maybe<RefundCaseCaseAggregationSelection>;
  caseConnection: RefundCaseConnection;
  caseId?: Maybe<Scalars['String']['output']>;
  caseOrAgreementId: Scalars['String']['output'];
  createdOn: Scalars['Date']['output'];
  documentFinancialDataPoint?: Maybe<FlexFinancialDataPoint>;
  documentFinancialDataPointAggregate?: Maybe<RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection>;
  documentFinancialDataPointConnection: RefundDocumentFinancialDataPointConnection;
  documents?: Maybe<Document>;
  documentsAggregate?: Maybe<RefundDocumentDocumentsAggregationSelection>;
  documentsConnection: RefundDocumentsConnection;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  sourceFinancialDataPoint: FlexFinancialDataPoint;
  sourceFinancialDataPointAggregate?: Maybe<RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection>;
  sourceFinancialDataPointConnection: RefundSourceFinancialDataPointConnection;
  status: RefundStatus;
  tenantIds: Array<Scalars['String']['output']>;
};


export type RefundAgreementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type RefundAgreementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type RefundAgreementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundAgreementConnectionSort>>;
  where?: InputMaybe<RefundAgreementConnectionWhere>;
};


export type RefundCaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type RefundCaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type RefundCaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundCaseConnectionSort>>;
  where?: InputMaybe<RefundCaseConnectionWhere>;
};


export type RefundDocumentFinancialDataPointArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type RefundDocumentFinancialDataPointAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type RefundDocumentFinancialDataPointConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundDocumentFinancialDataPointConnectionSort>>;
  where?: InputMaybe<RefundDocumentFinancialDataPointConnectionWhere>;
};


export type RefundDocumentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type RefundDocumentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type RefundDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundDocumentsConnectionSort>>;
  where?: InputMaybe<RefundDocumentsConnectionWhere>;
};


export type RefundSourceFinancialDataPointArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type RefundSourceFinancialDataPointAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type RefundSourceFinancialDataPointConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundSourceFinancialDataPointConnectionSort>>;
  where?: InputMaybe<RefundSourceFinancialDataPointConnectionWhere>;
};

export type RefundAgreementAggregateInput = {
  AND?: InputMaybe<Array<RefundAgreementAggregateInput>>;
  NOT?: InputMaybe<RefundAgreementAggregateInput>;
  OR?: InputMaybe<Array<RefundAgreementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundAgreementNodeAggregationWhereInput>;
};

export type RefundAgreementAgreementAggregationSelection = {
  __typename?: 'RefundAgreementAgreementAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RefundAgreementAgreementNodeAggregateSelection>;
};

export type RefundAgreementAgreementNodeAggregateSelection = {
  __typename?: 'RefundAgreementAgreementNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type RefundAgreementConnection = {
  __typename?: 'RefundAgreementConnection';
  edges: Array<RefundAgreementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundAgreementConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type RefundAgreementConnectionWhere = {
  AND?: InputMaybe<Array<RefundAgreementConnectionWhere>>;
  NOT?: InputMaybe<RefundAgreementConnectionWhere>;
  OR?: InputMaybe<Array<RefundAgreementConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type RefundAgreementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundAgreementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundAgreementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundAgreementNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RefundAgreementRelationship = {
  __typename?: 'RefundAgreementRelationship';
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type RefundCaseAggregateInput = {
  AND?: InputMaybe<Array<RefundCaseAggregateInput>>;
  NOT?: InputMaybe<RefundCaseAggregateInput>;
  OR?: InputMaybe<Array<RefundCaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundCaseNodeAggregationWhereInput>;
};

export type RefundCaseCaseAggregationSelection = {
  __typename?: 'RefundCaseCaseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RefundCaseCaseNodeAggregateSelection>;
};

export type RefundCaseCaseNodeAggregateSelection = {
  __typename?: 'RefundCaseCaseNodeAggregateSelection';
  creationDate: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
};

export type RefundCaseConnection = {
  __typename?: 'RefundCaseConnection';
  edges: Array<RefundCaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundCaseConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type RefundCaseConnectionWhere = {
  AND?: InputMaybe<Array<RefundCaseConnectionWhere>>;
  NOT?: InputMaybe<RefundCaseConnectionWhere>;
  OR?: InputMaybe<Array<RefundCaseConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type RefundCaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundCaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundCaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundCaseNodeAggregationWhereInput>>;
  creationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  creationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RefundCaseRelationship = {
  __typename?: 'RefundCaseRelationship';
  cursor: Scalars['String']['output'];
  node: Case;
};

export type RefundDocumentDocumentsAggregationSelection = {
  __typename?: 'RefundDocumentDocumentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RefundDocumentDocumentsNodeAggregateSelection>;
};

export type RefundDocumentDocumentsNodeAggregateSelection = {
  __typename?: 'RefundDocumentDocumentsNodeAggregateSelection';
  counterParties: StringAggregateSelectionNullable;
  coveragePeriod: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  issuedOn: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
};

export type RefundDocumentFinancialDataPointAggregateInput = {
  AND?: InputMaybe<Array<RefundDocumentFinancialDataPointAggregateInput>>;
  NOT?: InputMaybe<RefundDocumentFinancialDataPointAggregateInput>;
  OR?: InputMaybe<Array<RefundDocumentFinancialDataPointAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<RefundDocumentFinancialDataPointEdgeAggregationWhereInput>;
  node?: InputMaybe<RefundDocumentFinancialDataPointNodeAggregationWhereInput>;
};

export type RefundDocumentFinancialDataPointConnection = {
  __typename?: 'RefundDocumentFinancialDataPointConnection';
  edges: Array<RefundDocumentFinancialDataPointRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundDocumentFinancialDataPointConnectionSort = {
  edge?: InputMaybe<DocumentRefundFinancialDataPointSort>;
  node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type RefundDocumentFinancialDataPointConnectionWhere = {
  AND?: InputMaybe<Array<RefundDocumentFinancialDataPointConnectionWhere>>;
  NOT?: InputMaybe<RefundDocumentFinancialDataPointConnectionWhere>;
  OR?: InputMaybe<Array<RefundDocumentFinancialDataPointConnectionWhere>>;
  edge?: InputMaybe<DocumentRefundFinancialDataPointWhere>;
  node?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type RefundDocumentFinancialDataPointEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundDocumentFinancialDataPointEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundDocumentFinancialDataPointEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundDocumentFinancialDataPointEdgeAggregationWhereInput>>;
};

export type RefundDocumentFinancialDataPointNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundDocumentFinancialDataPointNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundDocumentFinancialDataPointNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundDocumentFinancialDataPointNodeAggregationWhereInput>>;
  basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type RefundDocumentFinancialDataPointRelationship = DocumentRefundFinancialDataPoint & {
  __typename?: 'RefundDocumentFinancialDataPointRelationship';
  connectionId?: Maybe<Scalars['ID']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
  status?: Maybe<FinancialDataPointStatus>;
};

export type RefundDocumentsAggregateInput = {
  AND?: InputMaybe<Array<RefundDocumentsAggregateInput>>;
  NOT?: InputMaybe<RefundDocumentsAggregateInput>;
  OR?: InputMaybe<Array<RefundDocumentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundDocumentsNodeAggregationWhereInput>;
};

export type RefundDocumentsConnection = {
  __typename?: 'RefundDocumentsConnection';
  edges: Array<RefundDocumentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundDocumentsConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type RefundDocumentsConnectionWhere = {
  AND?: InputMaybe<Array<RefundDocumentsConnectionWhere>>;
  NOT?: InputMaybe<RefundDocumentsConnectionWhere>;
  OR?: InputMaybe<Array<RefundDocumentsConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type RefundDocumentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundDocumentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundDocumentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundDocumentsNodeAggregationWhereInput>>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RefundDocumentsRelationship = {
  __typename?: 'RefundDocumentsRelationship';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type RefundEdge = {
  __typename?: 'RefundEdge';
  cursor: Scalars['String']['output'];
  node: Refund;
};

export type RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection = {
  __typename?: 'RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection>;
  node?: Maybe<RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection>;
};

export type RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection = {
  __typename?: 'RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection';
  connectionId: IdAggregateSelectionNullable;
};

export type RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection = {
  __typename?: 'RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  currencyCode: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  generatedUuid: IdAggregateSelectionNonNullable;
  netPrices: StringAggregateSelectionNullable;
  payable: FloatAggregateSelectionNonNullable;
  payablePercentage: FloatAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNonNullable;
  refundDeltaNumber: IntAggregateSelectionNonNullable;
  refundable: FloatAggregateSelectionNonNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  scenarioZeroMainNetPrices: StringAggregateSelectionNullable;
  scenarioZeroNetPrices: StringAggregateSelectionNullable;
  scenarioZeroRelevantNetPrices: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
  variable: FloatAggregateSelectionNonNullable;
  variablePercentage: FloatAggregateSelectionNullable;
};

export type RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection = {
  __typename?: 'RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection>;
};

export type RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection = {
  __typename?: 'RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  currencyCode: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  generatedUuid: IdAggregateSelectionNonNullable;
  netPrices: StringAggregateSelectionNullable;
  payable: FloatAggregateSelectionNonNullable;
  payablePercentage: FloatAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNonNullable;
  refundDeltaNumber: IntAggregateSelectionNonNullable;
  refundable: FloatAggregateSelectionNonNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  scenarioZeroMainNetPrices: StringAggregateSelectionNullable;
  scenarioZeroNetPrices: StringAggregateSelectionNullable;
  scenarioZeroRelevantNetPrices: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
  variable: FloatAggregateSelectionNonNullable;
  variablePercentage: FloatAggregateSelectionNullable;
};

export type RefundOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RefundSort objects to sort Refunds by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RefundSort>>;
};

/** Fields to sort Refunds by. The order in which sorts are applied is not guaranteed when specifying many fields in one RefundSort object. */
export type RefundSort = {
  agreementId?: InputMaybe<SortDirection>;
  amount?: InputMaybe<SortDirection>;
  caseId?: InputMaybe<SortDirection>;
  caseOrAgreementId?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type RefundSourceFinancialDataPointAggregateInput = {
  AND?: InputMaybe<Array<RefundSourceFinancialDataPointAggregateInput>>;
  NOT?: InputMaybe<RefundSourceFinancialDataPointAggregateInput>;
  OR?: InputMaybe<Array<RefundSourceFinancialDataPointAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundSourceFinancialDataPointNodeAggregationWhereInput>;
};

export type RefundSourceFinancialDataPointConnection = {
  __typename?: 'RefundSourceFinancialDataPointConnection';
  edges: Array<RefundSourceFinancialDataPointRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundSourceFinancialDataPointConnectionSort = {
  node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type RefundSourceFinancialDataPointConnectionWhere = {
  AND?: InputMaybe<Array<RefundSourceFinancialDataPointConnectionWhere>>;
  NOT?: InputMaybe<RefundSourceFinancialDataPointConnectionWhere>;
  OR?: InputMaybe<Array<RefundSourceFinancialDataPointConnectionWhere>>;
  node?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type RefundSourceFinancialDataPointNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundSourceFinancialDataPointNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundSourceFinancialDataPointNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundSourceFinancialDataPointNodeAggregationWhereInput>>;
  basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type RefundSourceFinancialDataPointRelationship = {
  __typename?: 'RefundSourceFinancialDataPointRelationship';
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
};

export enum RefundStatus {
  Declined = 'DECLINED',
  Invoiced = 'INVOICED',
  New = 'NEW',
  Pending = 'PENDING',
  Settled = 'SETTLED'
}

export type RefundWhere = {
  AND?: InputMaybe<Array<RefundWhere>>;
  NOT?: InputMaybe<RefundWhere>;
  OR?: InputMaybe<Array<RefundWhere>>;
  agreement?: InputMaybe<AgreementWhere>;
  agreementAggregate?: InputMaybe<RefundAgreementAggregateInput>;
  agreementConnection?: InputMaybe<RefundAgreementConnectionWhere>;
  agreementConnection_NOT?: InputMaybe<RefundAgreementConnectionWhere>;
  agreementId?: InputMaybe<Scalars['String']['input']>;
  agreementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreement_NOT?: InputMaybe<AgreementWhere>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  amount_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  case?: InputMaybe<CaseWhere>;
  caseAggregate?: InputMaybe<RefundCaseAggregateInput>;
  caseConnection?: InputMaybe<RefundCaseConnectionWhere>;
  caseConnection_NOT?: InputMaybe<RefundCaseConnectionWhere>;
  caseId?: InputMaybe<Scalars['String']['input']>;
  caseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  caseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  caseId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caseId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  caseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  caseOrAgreementId?: InputMaybe<Scalars['String']['input']>;
  caseOrAgreementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  caseOrAgreementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  caseOrAgreementId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  caseOrAgreementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  caseOrAgreementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  case_NOT?: InputMaybe<CaseWhere>;
  createdOn?: InputMaybe<Scalars['Date']['input']>;
  createdOn_GT?: InputMaybe<Scalars['Date']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['Date']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['Date']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['Date']['input']>;
  documentFinancialDataPoint?: InputMaybe<FlexFinancialDataPointWhere>;
  documentFinancialDataPointAggregate?: InputMaybe<RefundDocumentFinancialDataPointAggregateInput>;
  documentFinancialDataPointConnection?: InputMaybe<RefundDocumentFinancialDataPointConnectionWhere>;
  documentFinancialDataPointConnection_NOT?: InputMaybe<RefundDocumentFinancialDataPointConnectionWhere>;
  documentFinancialDataPoint_NOT?: InputMaybe<FlexFinancialDataPointWhere>;
  documents?: InputMaybe<DocumentWhere>;
  documentsAggregate?: InputMaybe<RefundDocumentsAggregateInput>;
  documentsConnection?: InputMaybe<RefundDocumentsConnectionWhere>;
  documentsConnection_NOT?: InputMaybe<RefundDocumentsConnectionWhere>;
  documents_NOT?: InputMaybe<DocumentWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  sourceFinancialDataPoint?: InputMaybe<FlexFinancialDataPointWhere>;
  sourceFinancialDataPointAggregate?: InputMaybe<RefundSourceFinancialDataPointAggregateInput>;
  sourceFinancialDataPointConnection?: InputMaybe<RefundSourceFinancialDataPointConnectionWhere>;
  sourceFinancialDataPointConnection_NOT?: InputMaybe<RefundSourceFinancialDataPointConnectionWhere>;
  sourceFinancialDataPoint_NOT?: InputMaybe<FlexFinancialDataPointWhere>;
  status?: InputMaybe<RefundStatus>;
  status_IN?: InputMaybe<Array<RefundStatus>>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type RefundsConnection = {
  __typename?: 'RefundsConnection';
  edges: Array<RefundEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum Reintervention {
  DidNotOccur = 'DID_NOT_OCCUR',
  Occured = 'OCCURED'
}

export enum ResponseBaseStatus {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export enum ResponseInclusionType {
  Is = 'IS',
  IsNot = 'IS_NOT'
}

export enum ResponseType {
  CompleteResponse = 'COMPLETE_RESPONSE',
  NoInfo = 'NO_INFO',
  PartialResponse = 'PARTIAL_RESPONSE',
  PathologicalCompleteResponse = 'PATHOLOGICAL_COMPLETE_RESPONSE',
  ProgressiveDisease = 'PROGRESSIVE_DISEASE',
  StableDisease = 'STABLE_DISEASE'
}

export enum ResultSelectionType {
  Earliest = 'EARLIEST',
  Highest = 'HIGHEST',
  Latest = 'LATEST',
  Lowest = 'LOWEST'
}

export enum Roles {
  Administrator = 'Administrator',
  SuperUser = 'SuperUser',
  User = 'User'
}

export enum RollingRangeType {
  CalendarMonth = 'CALENDAR_MONTH',
  CalendarQuarter = 'CALENDAR_QUARTER',
  CalendarYear = 'CALENDAR_YEAR',
  Exactly = 'EXACTLY'
}

export type RunCheck = {
  __typename?: 'RunCheck';
  alerts: Array<Alert>;
  alertsAggregate?: Maybe<RunCheckAlertAlertsAggregationSelection>;
  alertsConnection: RunCheckAlertsConnection;
  checkKey: Scalars['String']['output'];
  checkName: Scalars['String']['output'];
  completedOn: Scalars['DateTime']['output'];
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  startedOn: Scalars['DateTime']['output'];
  triggerKind: RunCheckTrigger;
  triggeredBy: Scalars['String']['output'];
  values: Array<RunCheckValues>;
  valuesAggregate?: Maybe<RunCheckRunCheckValuesValuesAggregationSelection>;
  valuesConnection: RunCheckValuesConnection;
};


export type RunCheckAlertsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AlertOptions>;
  where?: InputMaybe<AlertWhere>;
};


export type RunCheckAlertsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AlertWhere>;
};


export type RunCheckAlertsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RunCheckAlertsConnectionSort>>;
  where?: InputMaybe<RunCheckAlertsConnectionWhere>;
};


export type RunCheckValuesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RunCheckValuesOptions>;
  where?: InputMaybe<RunCheckValuesWhere>;
};


export type RunCheckValuesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RunCheckValuesWhere>;
};


export type RunCheckValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RunCheckValuesConnectionSort>>;
  where?: InputMaybe<RunCheckValuesConnectionWhere>;
};

export type RunCheckAlertAlertsAggregationSelection = {
  __typename?: 'RunCheckAlertAlertsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RunCheckAlertAlertsNodeAggregateSelection>;
};

export type RunCheckAlertAlertsNodeAggregateSelection = {
  __typename?: 'RunCheckAlertAlertsNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  entityId: StringAggregateSelectionNonNullable;
  entityUniqueIdentifier: IntAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  message: StringAggregateSelectionNullable;
  organizationCountry: StringAggregateSelectionNonNullable;
  organizationName: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type RunCheckAlertsAggregateInput = {
  AND?: InputMaybe<Array<RunCheckAlertsAggregateInput>>;
  NOT?: InputMaybe<RunCheckAlertsAggregateInput>;
  OR?: InputMaybe<Array<RunCheckAlertsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RunCheckAlertsNodeAggregationWhereInput>;
};

export type RunCheckAlertsConnection = {
  __typename?: 'RunCheckAlertsConnection';
  edges: Array<RunCheckAlertsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RunCheckAlertsConnectionSort = {
  node?: InputMaybe<AlertSort>;
};

export type RunCheckAlertsConnectionWhere = {
  AND?: InputMaybe<Array<RunCheckAlertsConnectionWhere>>;
  NOT?: InputMaybe<RunCheckAlertsConnectionWhere>;
  OR?: InputMaybe<Array<RunCheckAlertsConnectionWhere>>;
  node?: InputMaybe<AlertWhere>;
};

export type RunCheckAlertsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RunCheckAlertsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RunCheckAlertsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RunCheckAlertsNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  entityId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  entityId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  entityId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  entityId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  entityId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  entityId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  entityId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  entityId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  entityId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  entityId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  entityId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  entityId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  entityId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  entityId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  entityId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  entityUniqueIdentifier_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  entityUniqueIdentifier_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  entityUniqueIdentifier_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  entityUniqueIdentifier_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  entityUniqueIdentifier_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  entityUniqueIdentifier_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationCountry_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationCountry_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationCountry_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationCountry_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationCountry_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationCountry_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationCountry_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationCountry_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationCountry_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationCountry_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationCountry_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationCountry_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationCountry_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationCountry_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationCountry_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RunCheckAlertsRelationship = {
  __typename?: 'RunCheckAlertsRelationship';
  cursor: Scalars['String']['output'];
  node: Alert;
};

export type RunCheckEdge = {
  __typename?: 'RunCheckEdge';
  cursor: Scalars['String']['output'];
  node: RunCheck;
};

export type RunCheckOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RunCheckSort objects to sort RunChecks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RunCheckSort>>;
};

export type RunCheckRunCheckValuesValuesAggregationSelection = {
  __typename?: 'RunCheckRunCheckValuesValuesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RunCheckRunCheckValuesValuesNodeAggregateSelection>;
};

export type RunCheckRunCheckValuesValuesNodeAggregateSelection = {
  __typename?: 'RunCheckRunCheckValuesValuesNodeAggregateSelection';
  tenantId: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNonNullable;
};

/** Fields to sort RunChecks by. The order in which sorts are applied is not guaranteed when specifying many fields in one RunCheckSort object. */
export type RunCheckSort = {
  checkKey?: InputMaybe<SortDirection>;
  checkName?: InputMaybe<SortDirection>;
  completedOn?: InputMaybe<SortDirection>;
  count?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  startedOn?: InputMaybe<SortDirection>;
  triggerKind?: InputMaybe<SortDirection>;
  triggeredBy?: InputMaybe<SortDirection>;
};

export enum RunCheckTrigger {
  Aggregator = 'AGGREGATOR',
  MigrationQuery = 'MIGRATION_QUERY',
  NinjaQuery = 'NINJA_QUERY',
  OnDemand = 'ON_DEMAND',
  Scheduled = 'SCHEDULED'
}

export type RunCheckValues = {
  __typename?: 'RunCheckValues';
  check: RunCheck;
  checkAggregate?: Maybe<RunCheckValuesRunCheckCheckAggregationSelection>;
  checkConnection: RunCheckValuesCheckConnection;
  tenantId: Scalars['String']['output'];
  values: Scalars['String']['output'];
};


export type RunCheckValuesCheckArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RunCheckOptions>;
  where?: InputMaybe<RunCheckWhere>;
};


export type RunCheckValuesCheckAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RunCheckWhere>;
};


export type RunCheckValuesCheckConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RunCheckValuesCheckConnectionSort>>;
  where?: InputMaybe<RunCheckValuesCheckConnectionWhere>;
};

export type RunCheckValuesAggregateInput = {
  AND?: InputMaybe<Array<RunCheckValuesAggregateInput>>;
  NOT?: InputMaybe<RunCheckValuesAggregateInput>;
  OR?: InputMaybe<Array<RunCheckValuesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RunCheckValuesNodeAggregationWhereInput>;
};

export type RunCheckValuesCheckAggregateInput = {
  AND?: InputMaybe<Array<RunCheckValuesCheckAggregateInput>>;
  NOT?: InputMaybe<RunCheckValuesCheckAggregateInput>;
  OR?: InputMaybe<Array<RunCheckValuesCheckAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RunCheckValuesCheckNodeAggregationWhereInput>;
};

export type RunCheckValuesCheckConnection = {
  __typename?: 'RunCheckValuesCheckConnection';
  edges: Array<RunCheckValuesCheckRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RunCheckValuesCheckConnectionSort = {
  edge?: InputMaybe<RunCheckValuesWithTypeRelationshipSort>;
  node?: InputMaybe<RunCheckSort>;
};

export type RunCheckValuesCheckConnectionWhere = {
  AND?: InputMaybe<Array<RunCheckValuesCheckConnectionWhere>>;
  NOT?: InputMaybe<RunCheckValuesCheckConnectionWhere>;
  OR?: InputMaybe<Array<RunCheckValuesCheckConnectionWhere>>;
  edge?: InputMaybe<RunCheckValuesWithTypeRelationshipWhere>;
  node?: InputMaybe<RunCheckWhere>;
};

export type RunCheckValuesCheckNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RunCheckValuesCheckNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RunCheckValuesCheckNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RunCheckValuesCheckNodeAggregationWhereInput>>;
  checkKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  checkKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  checkKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  checkKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  checkKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  checkKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  checkKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  checkKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  checkKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  checkKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  checkName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  checkName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  checkName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  checkName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  checkName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  checkName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  checkName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  checkName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  checkName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  checkName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  startedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RunCheckValuesCheckRelationship = RunCheckValuesWithTypeRelationship & {
  __typename?: 'RunCheckValuesCheckRelationship';
  cursor: Scalars['String']['output'];
  node: RunCheck;
  type: RunCheckValuesType;
};

export type RunCheckValuesConnection = {
  __typename?: 'RunCheckValuesConnection';
  edges: Array<RunCheckValuesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RunCheckValuesConnectionSort = {
  edge?: InputMaybe<RunCheckValuesWithTypeRelationshipSort>;
  node?: InputMaybe<RunCheckValuesSort>;
};

export type RunCheckValuesConnectionWhere = {
  AND?: InputMaybe<Array<RunCheckValuesConnectionWhere>>;
  NOT?: InputMaybe<RunCheckValuesConnectionWhere>;
  OR?: InputMaybe<Array<RunCheckValuesConnectionWhere>>;
  edge?: InputMaybe<RunCheckValuesWithTypeRelationshipWhere>;
  node?: InputMaybe<RunCheckValuesWhere>;
};

export type RunCheckValuesEdge = {
  __typename?: 'RunCheckValuesEdge';
  cursor: Scalars['String']['output'];
  node: RunCheckValues;
};

export type RunCheckValuesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RunCheckValuesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RunCheckValuesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RunCheckValuesNodeAggregationWhereInput>>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RunCheckValuesOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RunCheckValuesSort objects to sort RunCheckValues by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RunCheckValuesSort>>;
};

export type RunCheckValuesRelationship = RunCheckValuesWithTypeRelationship & {
  __typename?: 'RunCheckValuesRelationship';
  cursor: Scalars['String']['output'];
  node: RunCheckValues;
  type: RunCheckValuesType;
};

export type RunCheckValuesRunCheckCheckAggregationSelection = {
  __typename?: 'RunCheckValuesRunCheckCheckAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RunCheckValuesRunCheckCheckNodeAggregateSelection>;
};

export type RunCheckValuesRunCheckCheckNodeAggregateSelection = {
  __typename?: 'RunCheckValuesRunCheckCheckNodeAggregateSelection';
  checkKey: StringAggregateSelectionNonNullable;
  checkName: StringAggregateSelectionNonNullable;
  completedOn: DateTimeAggregateSelectionNonNullable;
  count: IntAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  startedOn: DateTimeAggregateSelectionNonNullable;
  triggeredBy: StringAggregateSelectionNonNullable;
};

/** Fields to sort RunCheckValues by. The order in which sorts are applied is not guaranteed when specifying many fields in one RunCheckValuesSort object. */
export type RunCheckValuesSort = {
  tenantId?: InputMaybe<SortDirection>;
  values?: InputMaybe<SortDirection>;
};

export enum RunCheckValuesType {
  Current = 'CURRENT',
  Previous = 'PREVIOUS'
}

export type RunCheckValuesWhere = {
  AND?: InputMaybe<Array<RunCheckValuesWhere>>;
  NOT?: InputMaybe<RunCheckValuesWhere>;
  OR?: InputMaybe<Array<RunCheckValuesWhere>>;
  check?: InputMaybe<RunCheckWhere>;
  checkAggregate?: InputMaybe<RunCheckValuesCheckAggregateInput>;
  checkConnection?: InputMaybe<RunCheckValuesCheckConnectionWhere>;
  checkConnection_NOT?: InputMaybe<RunCheckValuesCheckConnectionWhere>;
  check_NOT?: InputMaybe<RunCheckWhere>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Scalars['String']['input']>;
  values_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  values_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  values_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  values_MATCHES?: InputMaybe<Scalars['String']['input']>;
  values_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type RunCheckValuesWithTypeRelationship = {
  type: RunCheckValuesType;
};

export type RunCheckValuesWithTypeRelationshipSort = {
  type?: InputMaybe<SortDirection>;
};

export type RunCheckValuesWithTypeRelationshipWhere = {
  AND?: InputMaybe<Array<RunCheckValuesWithTypeRelationshipWhere>>;
  NOT?: InputMaybe<RunCheckValuesWithTypeRelationshipWhere>;
  OR?: InputMaybe<Array<RunCheckValuesWithTypeRelationshipWhere>>;
  type?: InputMaybe<RunCheckValuesType>;
  type_IN?: InputMaybe<Array<RunCheckValuesType>>;
};

export type RunCheckWhere = {
  AND?: InputMaybe<Array<RunCheckWhere>>;
  NOT?: InputMaybe<RunCheckWhere>;
  OR?: InputMaybe<Array<RunCheckWhere>>;
  alertsAggregate?: InputMaybe<RunCheckAlertsAggregateInput>;
  /** Return RunChecks where all of the related RunCheckAlertsConnections match this filter */
  alertsConnection_ALL?: InputMaybe<RunCheckAlertsConnectionWhere>;
  /** Return RunChecks where none of the related RunCheckAlertsConnections match this filter */
  alertsConnection_NONE?: InputMaybe<RunCheckAlertsConnectionWhere>;
  /** Return RunChecks where one of the related RunCheckAlertsConnections match this filter */
  alertsConnection_SINGLE?: InputMaybe<RunCheckAlertsConnectionWhere>;
  /** Return RunChecks where some of the related RunCheckAlertsConnections match this filter */
  alertsConnection_SOME?: InputMaybe<RunCheckAlertsConnectionWhere>;
  /** Return RunChecks where all of the related Alerts match this filter */
  alerts_ALL?: InputMaybe<AlertWhere>;
  /** Return RunChecks where none of the related Alerts match this filter */
  alerts_NONE?: InputMaybe<AlertWhere>;
  /** Return RunChecks where one of the related Alerts match this filter */
  alerts_SINGLE?: InputMaybe<AlertWhere>;
  /** Return RunChecks where some of the related Alerts match this filter */
  alerts_SOME?: InputMaybe<AlertWhere>;
  checkKey?: InputMaybe<Scalars['String']['input']>;
  checkKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  checkKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  checkKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  checkKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  checkKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  checkName?: InputMaybe<Scalars['String']['input']>;
  checkName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  checkName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  checkName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  checkName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  checkName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  completedOn?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  completedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  startedOn?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  triggerKind?: InputMaybe<RunCheckTrigger>;
  triggerKind_IN?: InputMaybe<Array<RunCheckTrigger>>;
  triggeredBy?: InputMaybe<Scalars['String']['input']>;
  triggeredBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  triggeredBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  triggeredBy_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  triggeredBy_MATCHES?: InputMaybe<Scalars['String']['input']>;
  triggeredBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  valuesAggregate?: InputMaybe<RunCheckValuesAggregateInput>;
  /** Return RunChecks where all of the related RunCheckValuesConnections match this filter */
  valuesConnection_ALL?: InputMaybe<RunCheckValuesConnectionWhere>;
  /** Return RunChecks where none of the related RunCheckValuesConnections match this filter */
  valuesConnection_NONE?: InputMaybe<RunCheckValuesConnectionWhere>;
  /** Return RunChecks where one of the related RunCheckValuesConnections match this filter */
  valuesConnection_SINGLE?: InputMaybe<RunCheckValuesConnectionWhere>;
  /** Return RunChecks where some of the related RunCheckValuesConnections match this filter */
  valuesConnection_SOME?: InputMaybe<RunCheckValuesConnectionWhere>;
  /** Return RunChecks where all of the related RunCheckValues match this filter */
  values_ALL?: InputMaybe<RunCheckValuesWhere>;
  /** Return RunChecks where none of the related RunCheckValues match this filter */
  values_NONE?: InputMaybe<RunCheckValuesWhere>;
  /** Return RunChecks where one of the related RunCheckValues match this filter */
  values_SINGLE?: InputMaybe<RunCheckValuesWhere>;
  /** Return RunChecks where some of the related RunCheckValues match this filter */
  values_SOME?: InputMaybe<RunCheckValuesWhere>;
};

export type RunChecksConnection = {
  __typename?: 'RunChecksConnection';
  edges: Array<RunCheckEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RunDqcReport = {
  __typename?: 'RunDQCReport';
  checks: Array<RunCheck>;
  checksAggregate?: Maybe<RunDqcReportRunCheckChecksAggregationSelection>;
  checksConnection: RunDqcReportChecksConnection;
  completedOn: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  triggeredBy: Scalars['String']['output'];
};


export type RunDqcReportChecksArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RunCheckOptions>;
  where?: InputMaybe<RunCheckWhere>;
};


export type RunDqcReportChecksAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RunCheckWhere>;
};


export type RunDqcReportChecksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RunDqcReportChecksConnectionSort>>;
  where?: InputMaybe<RunDqcReportChecksConnectionWhere>;
};

export type RunDqcReportChecksAggregateInput = {
  AND?: InputMaybe<Array<RunDqcReportChecksAggregateInput>>;
  NOT?: InputMaybe<RunDqcReportChecksAggregateInput>;
  OR?: InputMaybe<Array<RunDqcReportChecksAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RunDqcReportChecksNodeAggregationWhereInput>;
};

export type RunDqcReportChecksConnection = {
  __typename?: 'RunDQCReportChecksConnection';
  edges: Array<RunDqcReportChecksRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RunDqcReportChecksConnectionSort = {
  node?: InputMaybe<RunCheckSort>;
};

export type RunDqcReportChecksConnectionWhere = {
  AND?: InputMaybe<Array<RunDqcReportChecksConnectionWhere>>;
  NOT?: InputMaybe<RunDqcReportChecksConnectionWhere>;
  OR?: InputMaybe<Array<RunDqcReportChecksConnectionWhere>>;
  node?: InputMaybe<RunCheckWhere>;
};

export type RunDqcReportChecksNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RunDqcReportChecksNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RunDqcReportChecksNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RunDqcReportChecksNodeAggregationWhereInput>>;
  checkKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  checkKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  checkKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  checkKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  checkKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  checkKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  checkKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  checkKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  checkKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  checkKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  checkKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  checkName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  checkName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  checkName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  checkName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  checkName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  checkName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  checkName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  checkName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  checkName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  checkName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  checkName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  startedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  triggeredBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RunDqcReportChecksRelationship = {
  __typename?: 'RunDQCReportChecksRelationship';
  cursor: Scalars['String']['output'];
  node: RunCheck;
};

export type RunDqcReportEdge = {
  __typename?: 'RunDQCReportEdge';
  cursor: Scalars['String']['output'];
  node: RunDqcReport;
};

export type RunDqcReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RunDQCReportSort objects to sort RunDqcReports by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RunDqcReportSort>>;
};

export type RunDqcReportRunCheckChecksAggregationSelection = {
  __typename?: 'RunDQCReportRunCheckChecksAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RunDqcReportRunCheckChecksNodeAggregateSelection>;
};

export type RunDqcReportRunCheckChecksNodeAggregateSelection = {
  __typename?: 'RunDQCReportRunCheckChecksNodeAggregateSelection';
  checkKey: StringAggregateSelectionNonNullable;
  checkName: StringAggregateSelectionNonNullable;
  completedOn: DateTimeAggregateSelectionNonNullable;
  count: IntAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  startedOn: DateTimeAggregateSelectionNonNullable;
  triggeredBy: StringAggregateSelectionNonNullable;
};

/** Fields to sort RunDqcReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one RunDQCReportSort object. */
export type RunDqcReportSort = {
  completedOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  triggeredBy?: InputMaybe<SortDirection>;
};

export type RunDqcReportWhere = {
  AND?: InputMaybe<Array<RunDqcReportWhere>>;
  NOT?: InputMaybe<RunDqcReportWhere>;
  OR?: InputMaybe<Array<RunDqcReportWhere>>;
  checksAggregate?: InputMaybe<RunDqcReportChecksAggregateInput>;
  /** Return RunDQCReports where all of the related RunDQCReportChecksConnections match this filter */
  checksConnection_ALL?: InputMaybe<RunDqcReportChecksConnectionWhere>;
  /** Return RunDQCReports where none of the related RunDQCReportChecksConnections match this filter */
  checksConnection_NONE?: InputMaybe<RunDqcReportChecksConnectionWhere>;
  /** Return RunDQCReports where one of the related RunDQCReportChecksConnections match this filter */
  checksConnection_SINGLE?: InputMaybe<RunDqcReportChecksConnectionWhere>;
  /** Return RunDQCReports where some of the related RunDQCReportChecksConnections match this filter */
  checksConnection_SOME?: InputMaybe<RunDqcReportChecksConnectionWhere>;
  /** Return RunDQCReports where all of the related RunChecks match this filter */
  checks_ALL?: InputMaybe<RunCheckWhere>;
  /** Return RunDQCReports where none of the related RunChecks match this filter */
  checks_NONE?: InputMaybe<RunCheckWhere>;
  /** Return RunDQCReports where one of the related RunChecks match this filter */
  checks_SINGLE?: InputMaybe<RunCheckWhere>;
  /** Return RunDQCReports where some of the related RunChecks match this filter */
  checks_SOME?: InputMaybe<RunCheckWhere>;
  completedOn?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  completedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  triggeredBy?: InputMaybe<Scalars['String']['input']>;
  triggeredBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  triggeredBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  triggeredBy_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  triggeredBy_MATCHES?: InputMaybe<Scalars['String']['input']>;
  triggeredBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type RunDqcReportsConnection = {
  __typename?: 'RunDqcReportsConnection';
  edges: Array<RunDqcReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RunnableCheck = {
  __typename?: 'RunnableCheck';
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RunnableCheckEdge = {
  __typename?: 'RunnableCheckEdge';
  cursor: Scalars['String']['output'];
  node: RunnableCheck;
};

export type RunnableCheckOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RunnableCheckSort objects to sort RunnableChecks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RunnableCheckSort>>;
};

/** Fields to sort RunnableChecks by. The order in which sorts are applied is not guaranteed when specifying many fields in one RunnableCheckSort object. */
export type RunnableCheckSort = {
  isDisabled?: InputMaybe<SortDirection>;
  key?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type RunnableCheckWhere = {
  AND?: InputMaybe<Array<RunnableCheckWhere>>;
  NOT?: InputMaybe<RunnableCheckWhere>;
  OR?: InputMaybe<Array<RunnableCheckWhere>>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  key_MATCHES?: InputMaybe<Scalars['String']['input']>;
  key_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type RunnableChecksConnection = {
  __typename?: 'RunnableChecksConnection';
  edges: Array<RunnableCheckEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RunningJobState = {
  __typename?: 'RunningJobState';
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type RunningJobStateEdge = {
  __typename?: 'RunningJobStateEdge';
  cursor: Scalars['String']['output'];
  node: RunningJobState;
};

export type RunningJobStateOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RunningJobStateSort objects to sort RunningJobStates by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RunningJobStateSort>>;
};

/** Fields to sort RunningJobStates by. The order in which sorts are applied is not guaranteed when specifying many fields in one RunningJobStateSort object. */
export type RunningJobStateSort = {
  createdOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type RunningJobStateWhere = {
  AND?: InputMaybe<Array<RunningJobStateWhere>>;
  NOT?: InputMaybe<RunningJobStateWhere>;
  OR?: InputMaybe<Array<RunningJobStateWhere>>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  status_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  status_MATCHES?: InputMaybe<Scalars['String']['input']>;
  status_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type RunningJobStatesConnection = {
  __typename?: 'RunningJobStatesConnection';
  edges: Array<RunningJobStateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SaveCustomIntegrityCheckInput = {
  expression: Scalars['String']['input'];
  name: Scalars['String']['input'];
  typeName: Scalars['String']['input'];
};

export type Scenario = {
  __typename?: 'Scenario';
  actionSets?: Maybe<Scalars['Boolean']['output']>;
  actionSetsOperator?: Maybe<ActionSetsOperator>;
  actions: Array<ScenarioAction>;
  actionsAggregate?: Maybe<ScenarioScenarioActionActionsAggregationSelection>;
  actionsConnection: ScenarioActionsConnection;
  conditions: Array<ScenarioCondition>;
  conditionsAggregate?: Maybe<ScenarioScenarioConditionConditionsAggregationSelection>;
  conditionsConnection: ScenarioConditionsConnection;
  group?: Maybe<Scalars['Int']['output']>;
  hasMultipleBasePrices?: Maybe<Scalars['Boolean']['output']>;
  isGrouped?: Maybe<Scalars['Boolean']['output']>;
  isProRating?: Maybe<Scalars['Boolean']['output']>;
  isRelevantForArt71?: Maybe<Scalars['Boolean']['output']>;
  operator: ConditionLogicalOperator;
  order: Scalars['Int']['output'];
};


export type ScenarioActionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioActionOptions>;
  where?: InputMaybe<ScenarioActionWhere>;
};


export type ScenarioActionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioActionWhere>;
};


export type ScenarioActionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionsConnectionSort>>;
  where?: InputMaybe<ScenarioActionsConnectionWhere>;
};


export type ScenarioConditionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioConditionOptions>;
  where?: InputMaybe<ScenarioConditionWhere>;
};


export type ScenarioConditionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioConditionWhere>;
};


export type ScenarioConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioConditionsConnectionSort>>;
  where?: InputMaybe<ScenarioConditionsConnectionWhere>;
};

export type ScenarioAction = ITimeframe & {
  __typename?: 'ScenarioAction';
  actionLogicalOperator?: Maybe<ActionLogicalOperator>;
  actionSet?: Maybe<Scalars['Int']['output']>;
  actionType: ActionType;
  adHocPriceTypes?: Maybe<Array<PriceType>>;
  brands: Array<Brand>;
  brandsAggregate?: Maybe<ScenarioActionBrandBrandsAggregationSelection>;
  brandsConnection: ScenarioActionBrandsConnection;
  combinedItemBrands: Array<Brand>;
  combinedItemBrandsAggregate?: Maybe<ScenarioActionBrandCombinedItemBrandsAggregationSelection>;
  combinedItemBrandsConnection: ScenarioActionCombinedItemBrandsConnection;
  combinedItemGenericNames: Array<Scalars['String']['output']>;
  combinedItemGenerics: Array<Generic>;
  combinedItemGenericsAggregate?: Maybe<ScenarioActionGenericCombinedItemGenericsAggregationSelection>;
  combinedItemGenericsConnection: ScenarioActionCombinedItemGenericsConnection;
  combinedItemTimeframeEnd?: Maybe<Scalars['Int']['output']>;
  combinedItemTimeframeRangeType?: Maybe<TimeframeRangeType>;
  combinedItemTimeframeStart?: Maybe<Scalars['Int']['output']>;
  combinedItemTreatments: Array<Treatment>;
  combinedItemTreatmentsAggregate?: Maybe<ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection>;
  combinedItemTreatmentsConnection: ScenarioActionCombinedItemTreatmentsConnection;
  cycle?: Maybe<CycleConfiguration>;
  cycleAggregate?: Maybe<ScenarioActionCycleConfigurationCycleAggregationSelection>;
  cycleConnection: ScenarioActionCycleConnection;
  endItemNumber?: Maybe<Scalars['Int']['output']>;
  entityPriceType?: Maybe<EntityPriceType>;
  genericName?: Maybe<Scalars['String']['output']>;
  generics: Array<Generic>;
  genericsAggregate?: Maybe<ScenarioActionGenericGenericsAggregationSelection>;
  genericsConnection: ScenarioActionGenericsConnection;
  ingredientEndItemNumber?: Maybe<Scalars['Float']['output']>;
  ingredientRangeType?: Maybe<ActionItemRangeType>;
  ingredientStartItemNumber?: Maybe<Scalars['Float']['output']>;
  isAdHocDiscount: Scalars['Boolean']['output'];
  isCombinedScenarioRelevantDrugsActive?: Maybe<Scalars['Boolean']['output']>;
  isNamedTimeRangeUsed?: Maybe<Scalars['Boolean']['output']>;
  isScenarioRelevantDrugsActive?: Maybe<Scalars['Boolean']['output']>;
  isSortedByPackOrder?: Maybe<Scalars['Boolean']['output']>;
  itemCombinationRelation?: Maybe<ActionItemCombinationRelation>;
  itemCombinationRule?: Maybe<ActionItemCombinationRule>;
  itemRangeType?: Maybe<ActionItemRangeType>;
  itemScope: ItemScope;
  order: Scalars['Int']['output'];
  packOptionType?: Maybe<PackOptionType>;
  priceType?: Maybe<PriceType>;
  recordNature?: Maybe<RecordNature>;
  rollingRangeType?: Maybe<RollingRangeType>;
  scenario: Scenario;
  scenarioAggregate?: Maybe<ScenarioActionScenarioScenarioAggregationSelection>;
  scenarioConnection: ScenarioActionScenarioConnection;
  startItemNumber?: Maybe<Scalars['Int']['output']>;
  startingPoint?: Maybe<TimeframeStartingPoint>;
  timeframeEnd?: Maybe<Scalars['Int']['output']>;
  timeframeRangeType?: Maybe<TimeframeRangeType>;
  timeframeRelation?: Maybe<TimeframeRelation>;
  timeframeStart?: Maybe<Scalars['Int']['output']>;
  treatments: Array<Treatment>;
  treatmentsAggregate?: Maybe<ScenarioActionTreatmentTreatmentsAggregationSelection>;
  treatmentsConnection: ScenarioActionTreatmentsConnection;
  uoMType?: Maybe<UoMType>;
  value?: Maybe<Scalars['Float']['output']>;
};


export type ScenarioActionBrandsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type ScenarioActionBrandsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type ScenarioActionBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionBrandsConnectionSort>>;
  where?: InputMaybe<ScenarioActionBrandsConnectionWhere>;
};


export type ScenarioActionCombinedItemBrandsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type ScenarioActionCombinedItemBrandsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type ScenarioActionCombinedItemBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionCombinedItemBrandsConnectionSort>>;
  where?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
};


export type ScenarioActionCombinedItemGenericsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type ScenarioActionCombinedItemGenericsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type ScenarioActionCombinedItemGenericsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionCombinedItemGenericsConnectionSort>>;
  where?: InputMaybe<ScenarioActionCombinedItemGenericsConnectionWhere>;
};


export type ScenarioActionCombinedItemTreatmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type ScenarioActionCombinedItemTreatmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type ScenarioActionCombinedItemTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsConnectionSort>>;
  where?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
};


export type ScenarioActionCycleArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CycleConfigurationOptions>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type ScenarioActionCycleAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type ScenarioActionCycleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionCycleConnectionSort>>;
  where?: InputMaybe<ScenarioActionCycleConnectionWhere>;
};


export type ScenarioActionGenericsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type ScenarioActionGenericsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type ScenarioActionGenericsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionGenericsConnectionSort>>;
  where?: InputMaybe<ScenarioActionGenericsConnectionWhere>;
};


export type ScenarioActionScenarioArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioOptions>;
  where?: InputMaybe<ScenarioWhere>;
};


export type ScenarioActionScenarioAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioWhere>;
};


export type ScenarioActionScenarioConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionScenarioConnectionSort>>;
  where?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
};


export type ScenarioActionTreatmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type ScenarioActionTreatmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type ScenarioActionTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionTreatmentsConnectionSort>>;
  where?: InputMaybe<ScenarioActionTreatmentsConnectionWhere>;
};

export type ScenarioActionBrandBrandsAggregationSelection = {
  __typename?: 'ScenarioActionBrandBrandsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ScenarioActionBrandBrandsEdgeAggregateSelection>;
  node?: Maybe<ScenarioActionBrandBrandsNodeAggregateSelection>;
};

export type ScenarioActionBrandBrandsEdgeAggregateSelection = {
  __typename?: 'ScenarioActionBrandBrandsEdgeAggregateSelection';
  order: IntAggregateSelectionNullable;
};

export type ScenarioActionBrandBrandsNodeAggregateSelection = {
  __typename?: 'ScenarioActionBrandBrandsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type ScenarioActionBrandCombinedItemBrandsAggregationSelection = {
  __typename?: 'ScenarioActionBrandCombinedItemBrandsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection>;
};

export type ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection = {
  __typename?: 'ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type ScenarioActionBrandsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionBrandsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionBrandsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionBrandsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ScenarioActionBrandsEdgeAggregationWhereInput>;
  node?: InputMaybe<ScenarioActionBrandsNodeAggregationWhereInput>;
};

export type ScenarioActionBrandsConnection = {
  __typename?: 'ScenarioActionBrandsConnection';
  edges: Array<ScenarioActionBrandsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionBrandsConnectionSort = {
  edge?: InputMaybe<ActionPrescriptionRelationshipSort>;
  node?: InputMaybe<BrandSort>;
};

export type ScenarioActionBrandsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionBrandsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionBrandsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionBrandsConnectionWhere>>;
  edge?: InputMaybe<ActionPrescriptionRelationshipWhere>;
  node?: InputMaybe<BrandWhere>;
};

export type ScenarioActionBrandsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionBrandsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionBrandsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioActionBrandsEdgeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionBrandsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionBrandsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionBrandsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioActionBrandsNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScenarioActionBrandsRelationship = ActionPrescriptionRelationship & {
  __typename?: 'ScenarioActionBrandsRelationship';
  cursor: Scalars['String']['output'];
  node: Brand;
  order?: Maybe<Scalars['Int']['output']>;
};

export type ScenarioActionCombinedItemBrandsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemBrandsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemBrandsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemBrandsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioActionCombinedItemBrandsNodeAggregationWhereInput>;
};

export type ScenarioActionCombinedItemBrandsConnection = {
  __typename?: 'ScenarioActionCombinedItemBrandsConnection';
  edges: Array<ScenarioActionCombinedItemBrandsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionCombinedItemBrandsConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type ScenarioActionCombinedItemBrandsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemBrandsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemBrandsConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type ScenarioActionCombinedItemBrandsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemBrandsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemBrandsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemBrandsNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScenarioActionCombinedItemBrandsRelationship = {
  __typename?: 'ScenarioActionCombinedItemBrandsRelationship';
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type ScenarioActionCombinedItemGenericsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemGenericsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemGenericsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemGenericsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioActionCombinedItemGenericsNodeAggregationWhereInput>;
};

export type ScenarioActionCombinedItemGenericsConnection = {
  __typename?: 'ScenarioActionCombinedItemGenericsConnection';
  edges: Array<ScenarioActionCombinedItemGenericsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionCombinedItemGenericsConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type ScenarioActionCombinedItemGenericsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemGenericsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemGenericsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemGenericsConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type ScenarioActionCombinedItemGenericsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemGenericsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemGenericsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemGenericsNodeAggregationWhereInput>>;
};

export type ScenarioActionCombinedItemGenericsRelationship = {
  __typename?: 'ScenarioActionCombinedItemGenericsRelationship';
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type ScenarioActionCombinedItemTreatmentsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemTreatmentsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput>;
};

export type ScenarioActionCombinedItemTreatmentsConnection = {
  __typename?: 'ScenarioActionCombinedItemTreatmentsConnection';
  edges: Array<ScenarioActionCombinedItemTreatmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionCombinedItemTreatmentsConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type ScenarioActionCombinedItemTreatmentsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionCombinedItemTreatmentsRelationship = {
  __typename?: 'ScenarioActionCombinedItemTreatmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type ScenarioActionCycleAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionCycleAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionCycleAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionCycleAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioActionCycleNodeAggregationWhereInput>;
};

export type ScenarioActionCycleConfigurationCycleAggregationSelection = {
  __typename?: 'ScenarioActionCycleConfigurationCycleAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioActionCycleConfigurationCycleNodeAggregateSelection>;
};

export type ScenarioActionCycleConfigurationCycleNodeAggregateSelection = {
  __typename?: 'ScenarioActionCycleConfigurationCycleNodeAggregateSelection';
  lengthFrom: IntAggregateSelectionNonNullable;
  lengthTo: IntAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
};

export type ScenarioActionCycleConnection = {
  __typename?: 'ScenarioActionCycleConnection';
  edges: Array<ScenarioActionCycleRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionCycleConnectionSort = {
  node?: InputMaybe<CycleConfigurationSort>;
};

export type ScenarioActionCycleConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionCycleConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionCycleConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionCycleConnectionWhere>>;
  node?: InputMaybe<CycleConfigurationWhere>;
};

export type ScenarioActionCycleNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionCycleNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionCycleNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioActionCycleNodeAggregationWhereInput>>;
  lengthFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionCycleRelationship = {
  __typename?: 'ScenarioActionCycleRelationship';
  cursor: Scalars['String']['output'];
  node: CycleConfiguration;
};

export type ScenarioActionEdge = {
  __typename?: 'ScenarioActionEdge';
  cursor: Scalars['String']['output'];
  node: ScenarioAction;
};

export enum ScenarioActionFailure {
  AddedAfterDiscontinuation = 'ADDED_AFTER_DISCONTINUATION',
  Combination = 'COMBINATION',
  Other = 'OTHER'
}

export type ScenarioActionGenericCombinedItemGenericsAggregationSelection = {
  __typename?: 'ScenarioActionGenericCombinedItemGenericsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection>;
};

export type ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection = {
  __typename?: 'ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type ScenarioActionGenericGenericsAggregationSelection = {
  __typename?: 'ScenarioActionGenericGenericsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ScenarioActionGenericGenericsEdgeAggregateSelection>;
  node?: Maybe<ScenarioActionGenericGenericsNodeAggregateSelection>;
};

export type ScenarioActionGenericGenericsEdgeAggregateSelection = {
  __typename?: 'ScenarioActionGenericGenericsEdgeAggregateSelection';
  order: IntAggregateSelectionNullable;
};

export type ScenarioActionGenericGenericsNodeAggregateSelection = {
  __typename?: 'ScenarioActionGenericGenericsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type ScenarioActionGenericsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionGenericsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionGenericsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionGenericsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ScenarioActionGenericsEdgeAggregationWhereInput>;
  node?: InputMaybe<ScenarioActionGenericsNodeAggregationWhereInput>;
};

export type ScenarioActionGenericsConnection = {
  __typename?: 'ScenarioActionGenericsConnection';
  edges: Array<ScenarioActionGenericsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionGenericsConnectionSort = {
  edge?: InputMaybe<ActionPrescriptionRelationshipSort>;
  node?: InputMaybe<GenericSort>;
};

export type ScenarioActionGenericsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionGenericsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionGenericsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionGenericsConnectionWhere>>;
  edge?: InputMaybe<ActionPrescriptionRelationshipWhere>;
  node?: InputMaybe<GenericWhere>;
};

export type ScenarioActionGenericsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionGenericsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionGenericsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioActionGenericsEdgeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionGenericsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionGenericsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionGenericsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioActionGenericsNodeAggregationWhereInput>>;
};

export type ScenarioActionGenericsRelationship = ActionPrescriptionRelationship & {
  __typename?: 'ScenarioActionGenericsRelationship';
  cursor: Scalars['String']['output'];
  node: Generic;
  order?: Maybe<Scalars['Int']['output']>;
};

export type ScenarioActionInput = {
  actionLogicalOperator?: InputMaybe<ActionLogicalOperator>;
  actionSet?: InputMaybe<Scalars['Int']['input']>;
  actionType: ActionType;
  adHocPriceTypes?: InputMaybe<Array<PriceType>>;
  brandNames: Array<BrandAndGenericInput>;
  combinedItemBrandNames: Array<Scalars['String']['input']>;
  combinedItemGenericNames: Array<Scalars['String']['input']>;
  combinedItemTimeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeRangeType?: InputMaybe<TimeframeRangeType>;
  combinedItemTimeframeStart?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTreatments: Array<TreatmentInput>;
  cycleOrder?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber?: InputMaybe<Scalars['Int']['input']>;
  entityPriceType?: InputMaybe<EntityPriceType>;
  genericNames: Array<BrandAndGenericInput>;
  ingredientEndItemNumber?: InputMaybe<Scalars['Float']['input']>;
  ingredientRangeType?: InputMaybe<ActionItemRangeType>;
  ingredientStartItemNumber?: InputMaybe<Scalars['Float']['input']>;
  isAdHocDiscount: Scalars['Boolean']['input'];
  isCombinedScenarioRelevantDrugsActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNamedTimeRangeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  isScenarioRelevantDrugsActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSortedByPackOrder?: InputMaybe<Scalars['Boolean']['input']>;
  itemCombinationRelation?: InputMaybe<ActionItemCombinationRelation>;
  itemCombinationRule?: InputMaybe<ActionItemCombinationRule>;
  itemRangeType?: InputMaybe<ActionItemRangeType>;
  itemScope: ItemScope;
  order: Scalars['Int']['input'];
  packOptionType?: InputMaybe<PackOptionType>;
  priceType?: InputMaybe<PriceType>;
  recordNature?: InputMaybe<RecordNature>;
  rollingRangeType?: InputMaybe<RollingRangeType>;
  startItemNumber?: InputMaybe<Scalars['Int']['input']>;
  startingPoint?: InputMaybe<TimeframeStartingPoint>;
  timeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeType?: InputMaybe<TimeframeRangeType>;
  timeframeRelation?: InputMaybe<TimeframeRelation>;
  timeframeStart?: InputMaybe<Scalars['Int']['input']>;
  treatments: Array<TreatmentInput>;
  uoMType?: InputMaybe<UoMType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type ScenarioActionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ScenarioActionSort objects to sort ScenarioActions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ScenarioActionSort>>;
};

export type ScenarioActionScenarioAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionScenarioAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionScenarioAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionScenarioAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioActionScenarioNodeAggregationWhereInput>;
};

export type ScenarioActionScenarioConnection = {
  __typename?: 'ScenarioActionScenarioConnection';
  edges: Array<ScenarioActionScenarioRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionScenarioConnectionSort = {
  node?: InputMaybe<ScenarioSort>;
};

export type ScenarioActionScenarioConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionScenarioConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionScenarioConnectionWhere>>;
  node?: InputMaybe<ScenarioWhere>;
};

export type ScenarioActionScenarioNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionScenarioNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionScenarioNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioActionScenarioNodeAggregationWhereInput>>;
  group_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  group_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionScenarioRelationship = {
  __typename?: 'ScenarioActionScenarioRelationship';
  cursor: Scalars['String']['output'];
  node: Scenario;
};

export type ScenarioActionScenarioScenarioAggregationSelection = {
  __typename?: 'ScenarioActionScenarioScenarioAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioActionScenarioScenarioNodeAggregateSelection>;
};

export type ScenarioActionScenarioScenarioNodeAggregateSelection = {
  __typename?: 'ScenarioActionScenarioScenarioNodeAggregateSelection';
  group: IntAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
};

/** Fields to sort ScenarioActions by. The order in which sorts are applied is not guaranteed when specifying many fields in one ScenarioActionSort object. */
export type ScenarioActionSort = {
  actionLogicalOperator?: InputMaybe<SortDirection>;
  actionSet?: InputMaybe<SortDirection>;
  actionType?: InputMaybe<SortDirection>;
  combinedItemTimeframeEnd?: InputMaybe<SortDirection>;
  combinedItemTimeframeRangeType?: InputMaybe<SortDirection>;
  combinedItemTimeframeStart?: InputMaybe<SortDirection>;
  endItemNumber?: InputMaybe<SortDirection>;
  entityPriceType?: InputMaybe<SortDirection>;
  genericName?: InputMaybe<SortDirection>;
  ingredientEndItemNumber?: InputMaybe<SortDirection>;
  ingredientRangeType?: InputMaybe<SortDirection>;
  ingredientStartItemNumber?: InputMaybe<SortDirection>;
  isAdHocDiscount?: InputMaybe<SortDirection>;
  isCombinedScenarioRelevantDrugsActive?: InputMaybe<SortDirection>;
  isNamedTimeRangeUsed?: InputMaybe<SortDirection>;
  isScenarioRelevantDrugsActive?: InputMaybe<SortDirection>;
  isSortedByPackOrder?: InputMaybe<SortDirection>;
  itemCombinationRelation?: InputMaybe<SortDirection>;
  itemCombinationRule?: InputMaybe<SortDirection>;
  itemRangeType?: InputMaybe<SortDirection>;
  itemScope?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  packOptionType?: InputMaybe<SortDirection>;
  priceType?: InputMaybe<SortDirection>;
  recordNature?: InputMaybe<SortDirection>;
  rollingRangeType?: InputMaybe<SortDirection>;
  startItemNumber?: InputMaybe<SortDirection>;
  startingPoint?: InputMaybe<SortDirection>;
  timeframeEnd?: InputMaybe<SortDirection>;
  timeframeRangeType?: InputMaybe<SortDirection>;
  timeframeRelation?: InputMaybe<SortDirection>;
  timeframeStart?: InputMaybe<SortDirection>;
  uoMType?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection = {
  __typename?: 'ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection>;
};

export type ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection = {
  __typename?: 'ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type ScenarioActionTreatmentTreatmentsAggregationSelection = {
  __typename?: 'ScenarioActionTreatmentTreatmentsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ScenarioActionTreatmentTreatmentsEdgeAggregateSelection>;
  node?: Maybe<ScenarioActionTreatmentTreatmentsNodeAggregateSelection>;
};

export type ScenarioActionTreatmentTreatmentsEdgeAggregateSelection = {
  __typename?: 'ScenarioActionTreatmentTreatmentsEdgeAggregateSelection';
  order: IntAggregateSelectionNullable;
};

export type ScenarioActionTreatmentTreatmentsNodeAggregateSelection = {
  __typename?: 'ScenarioActionTreatmentTreatmentsNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type ScenarioActionTreatmentsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionTreatmentsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionTreatmentsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionTreatmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ScenarioActionTreatmentsEdgeAggregationWhereInput>;
  node?: InputMaybe<ScenarioActionTreatmentsNodeAggregationWhereInput>;
};

export type ScenarioActionTreatmentsConnection = {
  __typename?: 'ScenarioActionTreatmentsConnection';
  edges: Array<ScenarioActionTreatmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionTreatmentsConnectionSort = {
  edge?: InputMaybe<ActionPrescriptionRelationshipSort>;
  node?: InputMaybe<TreatmentSort>;
};

export type ScenarioActionTreatmentsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionTreatmentsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionTreatmentsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionTreatmentsConnectionWhere>>;
  edge?: InputMaybe<ActionPrescriptionRelationshipWhere>;
  node?: InputMaybe<TreatmentWhere>;
};

export type ScenarioActionTreatmentsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionTreatmentsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionTreatmentsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioActionTreatmentsEdgeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionTreatmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionTreatmentsNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<ScenarioActionTreatmentsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioActionTreatmentsNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionTreatmentsRelationship = ActionPrescriptionRelationship & {
  __typename?: 'ScenarioActionTreatmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
  order?: Maybe<Scalars['Int']['output']>;
};

export type ScenarioActionWhere = {
  AND?: InputMaybe<Array<ScenarioActionWhere>>;
  NOT?: InputMaybe<ScenarioActionWhere>;
  OR?: InputMaybe<Array<ScenarioActionWhere>>;
  actionLogicalOperator?: InputMaybe<ActionLogicalOperator>;
  actionLogicalOperator_IN?: InputMaybe<Array<InputMaybe<ActionLogicalOperator>>>;
  actionSet?: InputMaybe<Scalars['Int']['input']>;
  actionSet_GT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_GTE?: InputMaybe<Scalars['Int']['input']>;
  actionSet_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  actionSet_LT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_LTE?: InputMaybe<Scalars['Int']['input']>;
  actionType?: InputMaybe<ActionType>;
  actionType_IN?: InputMaybe<Array<ActionType>>;
  adHocPriceTypes?: InputMaybe<Array<PriceType>>;
  adHocPriceTypes_INCLUDES?: InputMaybe<PriceType>;
  brandsAggregate?: InputMaybe<ScenarioActionBrandsAggregateInput>;
  /** Return ScenarioActions where all of the related ScenarioActionBrandsConnections match this filter */
  brandsConnection_ALL?: InputMaybe<ScenarioActionBrandsConnectionWhere>;
  /** Return ScenarioActions where none of the related ScenarioActionBrandsConnections match this filter */
  brandsConnection_NONE?: InputMaybe<ScenarioActionBrandsConnectionWhere>;
  /** Return ScenarioActions where one of the related ScenarioActionBrandsConnections match this filter */
  brandsConnection_SINGLE?: InputMaybe<ScenarioActionBrandsConnectionWhere>;
  /** Return ScenarioActions where some of the related ScenarioActionBrandsConnections match this filter */
  brandsConnection_SOME?: InputMaybe<ScenarioActionBrandsConnectionWhere>;
  /** Return ScenarioActions where all of the related Brands match this filter */
  brands_ALL?: InputMaybe<BrandWhere>;
  /** Return ScenarioActions where none of the related Brands match this filter */
  brands_NONE?: InputMaybe<BrandWhere>;
  /** Return ScenarioActions where one of the related Brands match this filter */
  brands_SINGLE?: InputMaybe<BrandWhere>;
  /** Return ScenarioActions where some of the related Brands match this filter */
  brands_SOME?: InputMaybe<BrandWhere>;
  combinedItemBrandsAggregate?: InputMaybe<ScenarioActionCombinedItemBrandsAggregateInput>;
  /** Return ScenarioActions where all of the related ScenarioActionCombinedItemBrandsConnections match this filter */
  combinedItemBrandsConnection_ALL?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
  /** Return ScenarioActions where none of the related ScenarioActionCombinedItemBrandsConnections match this filter */
  combinedItemBrandsConnection_NONE?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
  /** Return ScenarioActions where one of the related ScenarioActionCombinedItemBrandsConnections match this filter */
  combinedItemBrandsConnection_SINGLE?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
  /** Return ScenarioActions where some of the related ScenarioActionCombinedItemBrandsConnections match this filter */
  combinedItemBrandsConnection_SOME?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
  /** Return ScenarioActions where all of the related Brands match this filter */
  combinedItemBrands_ALL?: InputMaybe<BrandWhere>;
  /** Return ScenarioActions where none of the related Brands match this filter */
  combinedItemBrands_NONE?: InputMaybe<BrandWhere>;
  /** Return ScenarioActions where one of the related Brands match this filter */
  combinedItemBrands_SINGLE?: InputMaybe<BrandWhere>;
  /** Return ScenarioActions where some of the related Brands match this filter */
  combinedItemBrands_SOME?: InputMaybe<BrandWhere>;
  combinedItemGenericNames?: InputMaybe<Array<Scalars['String']['input']>>;
  combinedItemGenericNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  combinedItemGenericsAggregate?: InputMaybe<ScenarioActionCombinedItemGenericsAggregateInput>;
  /** Return ScenarioActions where all of the related ScenarioActionCombinedItemGenericsConnections match this filter */
  combinedItemGenericsConnection_ALL?: InputMaybe<ScenarioActionCombinedItemGenericsConnectionWhere>;
  /** Return ScenarioActions where none of the related ScenarioActionCombinedItemGenericsConnections match this filter */
  combinedItemGenericsConnection_NONE?: InputMaybe<ScenarioActionCombinedItemGenericsConnectionWhere>;
  /** Return ScenarioActions where one of the related ScenarioActionCombinedItemGenericsConnections match this filter */
  combinedItemGenericsConnection_SINGLE?: InputMaybe<ScenarioActionCombinedItemGenericsConnectionWhere>;
  /** Return ScenarioActions where some of the related ScenarioActionCombinedItemGenericsConnections match this filter */
  combinedItemGenericsConnection_SOME?: InputMaybe<ScenarioActionCombinedItemGenericsConnectionWhere>;
  /** Return ScenarioActions where all of the related Generics match this filter */
  combinedItemGenerics_ALL?: InputMaybe<GenericWhere>;
  /** Return ScenarioActions where none of the related Generics match this filter */
  combinedItemGenerics_NONE?: InputMaybe<GenericWhere>;
  /** Return ScenarioActions where one of the related Generics match this filter */
  combinedItemGenerics_SINGLE?: InputMaybe<GenericWhere>;
  /** Return ScenarioActions where some of the related Generics match this filter */
  combinedItemGenerics_SOME?: InputMaybe<GenericWhere>;
  combinedItemTimeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  combinedItemTimeframeEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeRangeType?: InputMaybe<TimeframeRangeType>;
  combinedItemTimeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
  combinedItemTimeframeStart?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  combinedItemTimeframeStart_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTreatmentsAggregate?: InputMaybe<ScenarioActionCombinedItemTreatmentsAggregateInput>;
  /** Return ScenarioActions where all of the related ScenarioActionCombinedItemTreatmentsConnections match this filter */
  combinedItemTreatmentsConnection_ALL?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
  /** Return ScenarioActions where none of the related ScenarioActionCombinedItemTreatmentsConnections match this filter */
  combinedItemTreatmentsConnection_NONE?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
  /** Return ScenarioActions where one of the related ScenarioActionCombinedItemTreatmentsConnections match this filter */
  combinedItemTreatmentsConnection_SINGLE?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
  /** Return ScenarioActions where some of the related ScenarioActionCombinedItemTreatmentsConnections match this filter */
  combinedItemTreatmentsConnection_SOME?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
  /** Return ScenarioActions where all of the related Treatments match this filter */
  combinedItemTreatments_ALL?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioActions where none of the related Treatments match this filter */
  combinedItemTreatments_NONE?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioActions where one of the related Treatments match this filter */
  combinedItemTreatments_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioActions where some of the related Treatments match this filter */
  combinedItemTreatments_SOME?: InputMaybe<TreatmentWhere>;
  cycle?: InputMaybe<CycleConfigurationWhere>;
  cycleAggregate?: InputMaybe<ScenarioActionCycleAggregateInput>;
  cycleConnection?: InputMaybe<ScenarioActionCycleConnectionWhere>;
  cycleConnection_NOT?: InputMaybe<ScenarioActionCycleConnectionWhere>;
  cycle_NOT?: InputMaybe<CycleConfigurationWhere>;
  endItemNumber?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endItemNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  entityPriceType?: InputMaybe<EntityPriceType>;
  entityPriceType_IN?: InputMaybe<Array<InputMaybe<EntityPriceType>>>;
  genericName?: InputMaybe<Scalars['String']['input']>;
  genericName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  genericName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  genericName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genericName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  genericName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  genericsAggregate?: InputMaybe<ScenarioActionGenericsAggregateInput>;
  /** Return ScenarioActions where all of the related ScenarioActionGenericsConnections match this filter */
  genericsConnection_ALL?: InputMaybe<ScenarioActionGenericsConnectionWhere>;
  /** Return ScenarioActions where none of the related ScenarioActionGenericsConnections match this filter */
  genericsConnection_NONE?: InputMaybe<ScenarioActionGenericsConnectionWhere>;
  /** Return ScenarioActions where one of the related ScenarioActionGenericsConnections match this filter */
  genericsConnection_SINGLE?: InputMaybe<ScenarioActionGenericsConnectionWhere>;
  /** Return ScenarioActions where some of the related ScenarioActionGenericsConnections match this filter */
  genericsConnection_SOME?: InputMaybe<ScenarioActionGenericsConnectionWhere>;
  /** Return ScenarioActions where all of the related Generics match this filter */
  generics_ALL?: InputMaybe<GenericWhere>;
  /** Return ScenarioActions where none of the related Generics match this filter */
  generics_NONE?: InputMaybe<GenericWhere>;
  /** Return ScenarioActions where one of the related Generics match this filter */
  generics_SINGLE?: InputMaybe<GenericWhere>;
  /** Return ScenarioActions where some of the related Generics match this filter */
  generics_SOME?: InputMaybe<GenericWhere>;
  ingredientEndItemNumber?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  ingredientEndItemNumber_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientRangeType?: InputMaybe<ActionItemRangeType>;
  ingredientRangeType_IN?: InputMaybe<Array<InputMaybe<ActionItemRangeType>>>;
  ingredientStartItemNumber?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  ingredientStartItemNumber_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_LTE?: InputMaybe<Scalars['Float']['input']>;
  isAdHocDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  isCombinedScenarioRelevantDrugsActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNamedTimeRangeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  isScenarioRelevantDrugsActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSortedByPackOrder?: InputMaybe<Scalars['Boolean']['input']>;
  itemCombinationRelation?: InputMaybe<ActionItemCombinationRelation>;
  itemCombinationRelation_IN?: InputMaybe<Array<InputMaybe<ActionItemCombinationRelation>>>;
  itemCombinationRule?: InputMaybe<ActionItemCombinationRule>;
  itemCombinationRule_IN?: InputMaybe<Array<InputMaybe<ActionItemCombinationRule>>>;
  itemRangeType?: InputMaybe<ActionItemRangeType>;
  itemRangeType_IN?: InputMaybe<Array<InputMaybe<ActionItemRangeType>>>;
  itemScope?: InputMaybe<ItemScope>;
  itemScope_IN?: InputMaybe<Array<ItemScope>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  packOptionType?: InputMaybe<PackOptionType>;
  packOptionType_IN?: InputMaybe<Array<InputMaybe<PackOptionType>>>;
  priceType?: InputMaybe<PriceType>;
  priceType_IN?: InputMaybe<Array<InputMaybe<PriceType>>>;
  recordNature?: InputMaybe<RecordNature>;
  recordNature_IN?: InputMaybe<Array<InputMaybe<RecordNature>>>;
  rollingRangeType?: InputMaybe<RollingRangeType>;
  rollingRangeType_IN?: InputMaybe<Array<InputMaybe<RollingRangeType>>>;
  scenario?: InputMaybe<ScenarioWhere>;
  scenarioAggregate?: InputMaybe<ScenarioActionScenarioAggregateInput>;
  scenarioConnection?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
  scenarioConnection_NOT?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
  scenario_NOT?: InputMaybe<ScenarioWhere>;
  startItemNumber?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startItemNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  startingPoint?: InputMaybe<TimeframeStartingPoint>;
  startingPoint_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
  timeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeType?: InputMaybe<TimeframeRangeType>;
  timeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
  timeframeRelation?: InputMaybe<TimeframeRelation>;
  timeframeRelation_IN?: InputMaybe<Array<InputMaybe<TimeframeRelation>>>;
  timeframeStart?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeStart_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatmentsAggregate?: InputMaybe<ScenarioActionTreatmentsAggregateInput>;
  /** Return ScenarioActions where all of the related ScenarioActionTreatmentsConnections match this filter */
  treatmentsConnection_ALL?: InputMaybe<ScenarioActionTreatmentsConnectionWhere>;
  /** Return ScenarioActions where none of the related ScenarioActionTreatmentsConnections match this filter */
  treatmentsConnection_NONE?: InputMaybe<ScenarioActionTreatmentsConnectionWhere>;
  /** Return ScenarioActions where one of the related ScenarioActionTreatmentsConnections match this filter */
  treatmentsConnection_SINGLE?: InputMaybe<ScenarioActionTreatmentsConnectionWhere>;
  /** Return ScenarioActions where some of the related ScenarioActionTreatmentsConnections match this filter */
  treatmentsConnection_SOME?: InputMaybe<ScenarioActionTreatmentsConnectionWhere>;
  /** Return ScenarioActions where all of the related Treatments match this filter */
  treatments_ALL?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioActions where none of the related Treatments match this filter */
  treatments_NONE?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioActions where one of the related Treatments match this filter */
  treatments_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioActions where some of the related Treatments match this filter */
  treatments_SOME?: InputMaybe<TreatmentWhere>;
  uoMType?: InputMaybe<UoMType>;
  uoMType_IN?: InputMaybe<Array<InputMaybe<UoMType>>>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ScenarioActionsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioActionsNodeAggregationWhereInput>;
};

export type ScenarioActionsConnection = {
  __typename?: 'ScenarioActionsConnection';
  edges: Array<ScenarioActionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionsConnectionSort = {
  node?: InputMaybe<ScenarioActionSort>;
};

export type ScenarioActionsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionsConnectionWhere>>;
  node?: InputMaybe<ScenarioActionWhere>;
};

export type ScenarioActionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioActionsNodeAggregationWhereInput>>;
  actionSet_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actionSet_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  actionSet_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  actionSet_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  actionSet_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  actionSet_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  actionSet_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actionSet_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  actionSet_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  endItemNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  endItemNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  endItemNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  endItemNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  endItemNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  genericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  genericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  genericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  genericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  genericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  genericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ingredientEndItemNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  startItemNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  startItemNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  startItemNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  startItemNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  startItemNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ScenarioActionsRelationship = {
  __typename?: 'ScenarioActionsRelationship';
  cursor: Scalars['String']['output'];
  node: ScenarioAction;
};

export type ScenarioCondition = ITimeframe & ITreatmentCondition & {
  __typename?: 'ScenarioCondition';
  adverseEvents?: Maybe<Array<AdverseEventType>>;
  amountOfThresholdBasis?: Maybe<AmountOfThresholdBasis>;
  article71Status?: Maybe<Article71Status>;
  bothOperatorFirst?: Maybe<ArithmeticalOperator>;
  bothOperatorSecond?: Maybe<ArithmeticalOperator>;
  brands: Array<Brand>;
  brandsAggregate?: Maybe<ScenarioConditionBrandBrandsAggregationSelection>;
  brandsConnection: ScenarioConditionBrandsConnection;
  comparedCountdownPoint?: Maybe<CountdownPoint>;
  comparedStartingPoint?: Maybe<TimeframeStartingPoint>;
  comparedTimeframeEnd?: Maybe<Scalars['Int']['output']>;
  comparedTimeframeRangeType?: Maybe<TimeframeRangeType>;
  comparedTimeframeRelation?: Maybe<TimeframeRelation>;
  comparedTimeframeStart?: Maybe<Scalars['Int']['output']>;
  conditionStatus?: Maybe<Array<OutcomeBasedStatus>>;
  conditionType: ConditionType;
  consideredRating?: Maybe<ConditionConsideredRating>;
  consideredSecInterventionRate?: Maybe<ConditionConsideredSecIntervention>;
  countdownPoint?: Maybe<CountdownPoint>;
  customCondition?: Maybe<CustomCondition>;
  customConditionAggregate?: Maybe<ScenarioConditionCustomConditionCustomConditionAggregationSelection>;
  customConditionConnection: ScenarioConditionCustomConditionConnection;
  deltaType?: Maybe<DeltaType>;
  discontinuationReason?: Maybe<TreatmentDiscontinuationReason>;
  endRangeValue?: Maybe<Scalars['Float']['output']>;
  eventCategory?: Maybe<Scalars['String']['output']>;
  eventFrequency?: Maybe<CustomConditionEventFrequency>;
  eventResult?: Maybe<CustomConditionEventResult>;
  eventSubCategories?: Maybe<Array<Scalars['String']['output']>>;
  eventType?: Maybe<CustomConditionEventType>;
  generics: Array<Generic>;
  genericsAggregate?: Maybe<ScenarioConditionGenericGenericsAggregationSelection>;
  genericsConnection: ScenarioConditionGenericsConnection;
  grades?: Maybe<Array<AdverseEventGrades>>;
  intervention?: Maybe<InterventionType>;
  interventionOccurrence?: Maybe<InterventionOccurrence>;
  isNamedTimeRangeUsed?: Maybe<Scalars['Boolean']['output']>;
  isScenarioRelevantDrugsActive?: Maybe<Scalars['Boolean']['output']>;
  monitoringType?: Maybe<MonitoringType>;
  occurence?: Maybe<Occurrence>;
  operator?: Maybe<ArithmeticalOperator>;
  order: Scalars['Int']['output'];
  patentStatus?: Maybe<PatentStatus>;
  patientScope?: Maybe<PatientScope>;
  reintervention?: Maybe<Reintervention>;
  responseInclusionType?: Maybe<ResponseInclusionType>;
  responseType?: Maybe<UnitedResponseType>;
  rollingRangeType?: Maybe<RollingRangeType>;
  scenario: Scenario;
  scenarioAggregate?: Maybe<ScenarioConditionScenarioScenarioAggregationSelection>;
  scenarioConnection: ScenarioConditionScenarioConnection;
  startingPoint?: Maybe<TimeframeStartingPoint>;
  timeframeEnd?: Maybe<Scalars['Int']['output']>;
  timeframeRangeType?: Maybe<TimeframeRangeType>;
  timeframeRelation?: Maybe<TimeframeRelation>;
  timeframeStart?: Maybe<Scalars['Int']['output']>;
  treatmentDurationAspect?: Maybe<TreatmentDurationConditionAspect>;
  treatments: Array<Treatment>;
  treatmentsAggregate?: Maybe<ScenarioConditionTreatmentTreatmentsAggregationSelection>;
  treatmentsConnection: ScenarioConditionTreatmentsConnection;
  uoMType?: Maybe<UoMType>;
  value?: Maybe<Scalars['Float']['output']>;
};


export type ScenarioConditionBrandsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type ScenarioConditionBrandsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type ScenarioConditionBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioConditionBrandsConnectionSort>>;
  where?: InputMaybe<ScenarioConditionBrandsConnectionWhere>;
};


export type ScenarioConditionCustomConditionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CustomConditionOptions>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type ScenarioConditionCustomConditionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type ScenarioConditionCustomConditionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioConditionCustomConditionConnectionSort>>;
  where?: InputMaybe<ScenarioConditionCustomConditionConnectionWhere>;
};


export type ScenarioConditionGenericsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type ScenarioConditionGenericsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type ScenarioConditionGenericsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioConditionGenericsConnectionSort>>;
  where?: InputMaybe<ScenarioConditionGenericsConnectionWhere>;
};


export type ScenarioConditionScenarioArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioOptions>;
  where?: InputMaybe<ScenarioWhere>;
};


export type ScenarioConditionScenarioAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioWhere>;
};


export type ScenarioConditionScenarioConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioConditionScenarioConnectionSort>>;
  where?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
};


export type ScenarioConditionTreatmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type ScenarioConditionTreatmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type ScenarioConditionTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioConditionTreatmentsConnectionSort>>;
  where?: InputMaybe<ScenarioConditionTreatmentsConnectionWhere>;
};

export type ScenarioConditionBrandBrandsAggregationSelection = {
  __typename?: 'ScenarioConditionBrandBrandsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioConditionBrandBrandsNodeAggregateSelection>;
};

export type ScenarioConditionBrandBrandsNodeAggregateSelection = {
  __typename?: 'ScenarioConditionBrandBrandsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type ScenarioConditionBrandsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioConditionBrandsAggregateInput>>;
  NOT?: InputMaybe<ScenarioConditionBrandsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioConditionBrandsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioConditionBrandsNodeAggregationWhereInput>;
};

export type ScenarioConditionBrandsConnection = {
  __typename?: 'ScenarioConditionBrandsConnection';
  edges: Array<ScenarioConditionBrandsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioConditionBrandsConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type ScenarioConditionBrandsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionBrandsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioConditionBrandsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionBrandsConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type ScenarioConditionBrandsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioConditionBrandsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioConditionBrandsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioConditionBrandsNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScenarioConditionBrandsRelationship = {
  __typename?: 'ScenarioConditionBrandsRelationship';
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type ScenarioConditionCustomConditionAggregateInput = {
  AND?: InputMaybe<Array<ScenarioConditionCustomConditionAggregateInput>>;
  NOT?: InputMaybe<ScenarioConditionCustomConditionAggregateInput>;
  OR?: InputMaybe<Array<ScenarioConditionCustomConditionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioConditionCustomConditionNodeAggregationWhereInput>;
};

export type ScenarioConditionCustomConditionConnection = {
  __typename?: 'ScenarioConditionCustomConditionConnection';
  edges: Array<ScenarioConditionCustomConditionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioConditionCustomConditionConnectionSort = {
  node?: InputMaybe<CustomConditionSort>;
};

export type ScenarioConditionCustomConditionConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionCustomConditionConnectionWhere>>;
  NOT?: InputMaybe<ScenarioConditionCustomConditionConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionCustomConditionConnectionWhere>>;
  node?: InputMaybe<CustomConditionWhere>;
};

export type ScenarioConditionCustomConditionCustomConditionAggregationSelection = {
  __typename?: 'ScenarioConditionCustomConditionCustomConditionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection>;
};

export type ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection = {
  __typename?: 'ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  description: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type ScenarioConditionCustomConditionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioConditionCustomConditionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioConditionCustomConditionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioConditionCustomConditionNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioConditionCustomConditionRelationship = {
  __typename?: 'ScenarioConditionCustomConditionRelationship';
  cursor: Scalars['String']['output'];
  node: CustomCondition;
};

export type ScenarioConditionEdge = {
  __typename?: 'ScenarioConditionEdge';
  cursor: Scalars['String']['output'];
  node: ScenarioCondition;
};

export type ScenarioConditionGenericGenericsAggregationSelection = {
  __typename?: 'ScenarioConditionGenericGenericsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioConditionGenericGenericsNodeAggregateSelection>;
};

export type ScenarioConditionGenericGenericsNodeAggregateSelection = {
  __typename?: 'ScenarioConditionGenericGenericsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type ScenarioConditionGenericsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioConditionGenericsAggregateInput>>;
  NOT?: InputMaybe<ScenarioConditionGenericsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioConditionGenericsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioConditionGenericsNodeAggregationWhereInput>;
};

export type ScenarioConditionGenericsConnection = {
  __typename?: 'ScenarioConditionGenericsConnection';
  edges: Array<ScenarioConditionGenericsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioConditionGenericsConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type ScenarioConditionGenericsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionGenericsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioConditionGenericsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionGenericsConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type ScenarioConditionGenericsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioConditionGenericsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioConditionGenericsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioConditionGenericsNodeAggregationWhereInput>>;
};

export type ScenarioConditionGenericsRelationship = {
  __typename?: 'ScenarioConditionGenericsRelationship';
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type ScenarioConditionInput = {
  adverseEvents?: InputMaybe<Array<AdverseEventType>>;
  amountOfThresholdBasis?: InputMaybe<AmountOfThresholdBasis>;
  article71Status?: InputMaybe<Article71Status>;
  bothOperatorFirst?: InputMaybe<ArithmeticalOperator>;
  bothOperatorSecond?: InputMaybe<ArithmeticalOperator>;
  brandNames: Array<Scalars['String']['input']>;
  comparedCountdownPoint?: InputMaybe<CountdownPoint>;
  comparedStartingPoint?: InputMaybe<TimeframeStartingPoint>;
  comparedTimeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeRangeType?: InputMaybe<TimeframeRangeType>;
  comparedTimeframeRelation?: InputMaybe<TimeframeRelation>;
  comparedTimeframeStart?: InputMaybe<Scalars['Int']['input']>;
  conditionStatus?: InputMaybe<Array<OutcomeBasedStatus>>;
  conditionType: ConditionType;
  consideredRating?: InputMaybe<ConditionConsideredRating>;
  consideredSecInterventionRate?: InputMaybe<ConditionConsideredSecIntervention>;
  countdownPoint?: InputMaybe<CountdownPoint>;
  deltaType?: InputMaybe<DeltaType>;
  discontinuationReason?: InputMaybe<TreatmentDiscontinuationReason>;
  endRangeValue?: InputMaybe<Scalars['Float']['input']>;
  eventCategory?: InputMaybe<Scalars['String']['input']>;
  eventFrequency?: InputMaybe<CustomConditionEventFrequency>;
  eventResult?: InputMaybe<CustomConditionEventResult>;
  eventSubCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  eventType?: InputMaybe<CustomConditionEventType>;
  genericNames: Array<Scalars['String']['input']>;
  grades?: InputMaybe<Array<AdverseEventGrades>>;
  intervention?: InputMaybe<InterventionType>;
  interventionOccurrence?: InputMaybe<InterventionOccurrence>;
  isNamedTimeRangeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  isScenarioRelevantDrugsActive?: InputMaybe<Scalars['Boolean']['input']>;
  monitoringType?: InputMaybe<MonitoringType>;
  occurence?: InputMaybe<Occurrence>;
  operator?: InputMaybe<ArithmeticalOperator>;
  order: Scalars['Int']['input'];
  patentStatus?: InputMaybe<PatentStatus>;
  patientScope?: InputMaybe<PatientScope>;
  reintervention?: InputMaybe<Reintervention>;
  responseInclusionType?: InputMaybe<ResponseInclusionType>;
  responseType?: InputMaybe<UnitedResponseType>;
  rollingRangeType?: InputMaybe<RollingRangeType>;
  startingPoint?: InputMaybe<TimeframeStartingPoint>;
  timeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeType?: InputMaybe<TimeframeRangeType>;
  timeframeRelation?: InputMaybe<TimeframeRelation>;
  timeframeStart?: InputMaybe<Scalars['Int']['input']>;
  treatmentDurationAspect?: InputMaybe<TreatmentDurationConditionAspect>;
  treatments: Array<TreatmentInput>;
  uoMType?: InputMaybe<UoMType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type ScenarioConditionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ScenarioConditionSort objects to sort ScenarioConditions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ScenarioConditionSort>>;
};

export type ScenarioConditionScenarioAggregateInput = {
  AND?: InputMaybe<Array<ScenarioConditionScenarioAggregateInput>>;
  NOT?: InputMaybe<ScenarioConditionScenarioAggregateInput>;
  OR?: InputMaybe<Array<ScenarioConditionScenarioAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioConditionScenarioNodeAggregationWhereInput>;
};

export type ScenarioConditionScenarioConnection = {
  __typename?: 'ScenarioConditionScenarioConnection';
  edges: Array<ScenarioConditionScenarioRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioConditionScenarioConnectionSort = {
  node?: InputMaybe<ScenarioSort>;
};

export type ScenarioConditionScenarioConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionScenarioConnectionWhere>>;
  NOT?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionScenarioConnectionWhere>>;
  node?: InputMaybe<ScenarioWhere>;
};

export type ScenarioConditionScenarioNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioConditionScenarioNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioConditionScenarioNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioConditionScenarioNodeAggregationWhereInput>>;
  group_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  group_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioConditionScenarioRelationship = {
  __typename?: 'ScenarioConditionScenarioRelationship';
  cursor: Scalars['String']['output'];
  node: Scenario;
};

export type ScenarioConditionScenarioScenarioAggregationSelection = {
  __typename?: 'ScenarioConditionScenarioScenarioAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioConditionScenarioScenarioNodeAggregateSelection>;
};

export type ScenarioConditionScenarioScenarioNodeAggregateSelection = {
  __typename?: 'ScenarioConditionScenarioScenarioNodeAggregateSelection';
  group: IntAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
};

/** Fields to sort ScenarioConditions by. The order in which sorts are applied is not guaranteed when specifying many fields in one ScenarioConditionSort object. */
export type ScenarioConditionSort = {
  amountOfThresholdBasis?: InputMaybe<SortDirection>;
  article71Status?: InputMaybe<SortDirection>;
  bothOperatorFirst?: InputMaybe<SortDirection>;
  bothOperatorSecond?: InputMaybe<SortDirection>;
  comparedCountdownPoint?: InputMaybe<SortDirection>;
  comparedStartingPoint?: InputMaybe<SortDirection>;
  comparedTimeframeEnd?: InputMaybe<SortDirection>;
  comparedTimeframeRangeType?: InputMaybe<SortDirection>;
  comparedTimeframeRelation?: InputMaybe<SortDirection>;
  comparedTimeframeStart?: InputMaybe<SortDirection>;
  conditionType?: InputMaybe<SortDirection>;
  consideredRating?: InputMaybe<SortDirection>;
  consideredSecInterventionRate?: InputMaybe<SortDirection>;
  countdownPoint?: InputMaybe<SortDirection>;
  deltaType?: InputMaybe<SortDirection>;
  discontinuationReason?: InputMaybe<SortDirection>;
  endRangeValue?: InputMaybe<SortDirection>;
  eventCategory?: InputMaybe<SortDirection>;
  eventFrequency?: InputMaybe<SortDirection>;
  eventResult?: InputMaybe<SortDirection>;
  eventType?: InputMaybe<SortDirection>;
  intervention?: InputMaybe<SortDirection>;
  interventionOccurrence?: InputMaybe<SortDirection>;
  isNamedTimeRangeUsed?: InputMaybe<SortDirection>;
  isScenarioRelevantDrugsActive?: InputMaybe<SortDirection>;
  monitoringType?: InputMaybe<SortDirection>;
  occurence?: InputMaybe<SortDirection>;
  operator?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  patentStatus?: InputMaybe<SortDirection>;
  patientScope?: InputMaybe<SortDirection>;
  reintervention?: InputMaybe<SortDirection>;
  responseInclusionType?: InputMaybe<SortDirection>;
  responseType?: InputMaybe<SortDirection>;
  rollingRangeType?: InputMaybe<SortDirection>;
  startingPoint?: InputMaybe<SortDirection>;
  timeframeEnd?: InputMaybe<SortDirection>;
  timeframeRangeType?: InputMaybe<SortDirection>;
  timeframeRelation?: InputMaybe<SortDirection>;
  timeframeStart?: InputMaybe<SortDirection>;
  treatmentDurationAspect?: InputMaybe<SortDirection>;
  uoMType?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type ScenarioConditionTreatmentTreatmentsAggregationSelection = {
  __typename?: 'ScenarioConditionTreatmentTreatmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioConditionTreatmentTreatmentsNodeAggregateSelection>;
};

export type ScenarioConditionTreatmentTreatmentsNodeAggregateSelection = {
  __typename?: 'ScenarioConditionTreatmentTreatmentsNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type ScenarioConditionTreatmentsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioConditionTreatmentsAggregateInput>>;
  NOT?: InputMaybe<ScenarioConditionTreatmentsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioConditionTreatmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioConditionTreatmentsNodeAggregationWhereInput>;
};

export type ScenarioConditionTreatmentsConnection = {
  __typename?: 'ScenarioConditionTreatmentsConnection';
  edges: Array<ScenarioConditionTreatmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioConditionTreatmentsConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type ScenarioConditionTreatmentsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionTreatmentsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioConditionTreatmentsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionTreatmentsConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type ScenarioConditionTreatmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioConditionTreatmentsNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<ScenarioConditionTreatmentsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioConditionTreatmentsNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioConditionTreatmentsRelationship = {
  __typename?: 'ScenarioConditionTreatmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type ScenarioConditionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionWhere>>;
  NOT?: InputMaybe<ScenarioConditionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionWhere>>;
  adverseEvents?: InputMaybe<Array<AdverseEventType>>;
  adverseEvents_INCLUDES?: InputMaybe<AdverseEventType>;
  amountOfThresholdBasis?: InputMaybe<AmountOfThresholdBasis>;
  amountOfThresholdBasis_IN?: InputMaybe<Array<InputMaybe<AmountOfThresholdBasis>>>;
  article71Status?: InputMaybe<Article71Status>;
  article71Status_IN?: InputMaybe<Array<InputMaybe<Article71Status>>>;
  bothOperatorFirst?: InputMaybe<ArithmeticalOperator>;
  bothOperatorFirst_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  bothOperatorSecond?: InputMaybe<ArithmeticalOperator>;
  bothOperatorSecond_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  brandsAggregate?: InputMaybe<ScenarioConditionBrandsAggregateInput>;
  /** Return ScenarioConditions where all of the related ScenarioConditionBrandsConnections match this filter */
  brandsConnection_ALL?: InputMaybe<ScenarioConditionBrandsConnectionWhere>;
  /** Return ScenarioConditions where none of the related ScenarioConditionBrandsConnections match this filter */
  brandsConnection_NONE?: InputMaybe<ScenarioConditionBrandsConnectionWhere>;
  /** Return ScenarioConditions where one of the related ScenarioConditionBrandsConnections match this filter */
  brandsConnection_SINGLE?: InputMaybe<ScenarioConditionBrandsConnectionWhere>;
  /** Return ScenarioConditions where some of the related ScenarioConditionBrandsConnections match this filter */
  brandsConnection_SOME?: InputMaybe<ScenarioConditionBrandsConnectionWhere>;
  /** Return ScenarioConditions where all of the related Brands match this filter */
  brands_ALL?: InputMaybe<BrandWhere>;
  /** Return ScenarioConditions where none of the related Brands match this filter */
  brands_NONE?: InputMaybe<BrandWhere>;
  /** Return ScenarioConditions where one of the related Brands match this filter */
  brands_SINGLE?: InputMaybe<BrandWhere>;
  /** Return ScenarioConditions where some of the related Brands match this filter */
  brands_SOME?: InputMaybe<BrandWhere>;
  comparedCountdownPoint?: InputMaybe<CountdownPoint>;
  comparedCountdownPoint_IN?: InputMaybe<Array<InputMaybe<CountdownPoint>>>;
  comparedStartingPoint?: InputMaybe<TimeframeStartingPoint>;
  comparedStartingPoint_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
  comparedTimeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  comparedTimeframeEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeRangeType?: InputMaybe<TimeframeRangeType>;
  comparedTimeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
  comparedTimeframeRelation?: InputMaybe<TimeframeRelation>;
  comparedTimeframeRelation_IN?: InputMaybe<Array<InputMaybe<TimeframeRelation>>>;
  comparedTimeframeStart?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  comparedTimeframeStart_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  conditionStatus?: InputMaybe<Array<OutcomeBasedStatus>>;
  conditionStatus_INCLUDES?: InputMaybe<OutcomeBasedStatus>;
  conditionType?: InputMaybe<ConditionType>;
  conditionType_IN?: InputMaybe<Array<ConditionType>>;
  consideredRating?: InputMaybe<ConditionConsideredRating>;
  consideredRating_IN?: InputMaybe<Array<InputMaybe<ConditionConsideredRating>>>;
  consideredSecInterventionRate?: InputMaybe<ConditionConsideredSecIntervention>;
  consideredSecInterventionRate_IN?: InputMaybe<Array<InputMaybe<ConditionConsideredSecIntervention>>>;
  countdownPoint?: InputMaybe<CountdownPoint>;
  countdownPoint_IN?: InputMaybe<Array<InputMaybe<CountdownPoint>>>;
  customCondition?: InputMaybe<CustomConditionWhere>;
  customConditionAggregate?: InputMaybe<ScenarioConditionCustomConditionAggregateInput>;
  customConditionConnection?: InputMaybe<ScenarioConditionCustomConditionConnectionWhere>;
  customConditionConnection_NOT?: InputMaybe<ScenarioConditionCustomConditionConnectionWhere>;
  customCondition_NOT?: InputMaybe<CustomConditionWhere>;
  deltaType?: InputMaybe<DeltaType>;
  deltaType_IN?: InputMaybe<Array<InputMaybe<DeltaType>>>;
  discontinuationReason?: InputMaybe<TreatmentDiscontinuationReason>;
  discontinuationReason_IN?: InputMaybe<Array<InputMaybe<TreatmentDiscontinuationReason>>>;
  endRangeValue?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_GT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  endRangeValue_LT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  eventCategory?: InputMaybe<Scalars['String']['input']>;
  eventCategory_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  eventCategory_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  eventCategory_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventCategory_MATCHES?: InputMaybe<Scalars['String']['input']>;
  eventCategory_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  eventFrequency?: InputMaybe<CustomConditionEventFrequency>;
  eventFrequency_IN?: InputMaybe<Array<InputMaybe<CustomConditionEventFrequency>>>;
  eventResult?: InputMaybe<CustomConditionEventResult>;
  eventResult_IN?: InputMaybe<Array<InputMaybe<CustomConditionEventResult>>>;
  eventSubCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  eventSubCategories_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<CustomConditionEventType>;
  eventType_IN?: InputMaybe<Array<InputMaybe<CustomConditionEventType>>>;
  genericsAggregate?: InputMaybe<ScenarioConditionGenericsAggregateInput>;
  /** Return ScenarioConditions where all of the related ScenarioConditionGenericsConnections match this filter */
  genericsConnection_ALL?: InputMaybe<ScenarioConditionGenericsConnectionWhere>;
  /** Return ScenarioConditions where none of the related ScenarioConditionGenericsConnections match this filter */
  genericsConnection_NONE?: InputMaybe<ScenarioConditionGenericsConnectionWhere>;
  /** Return ScenarioConditions where one of the related ScenarioConditionGenericsConnections match this filter */
  genericsConnection_SINGLE?: InputMaybe<ScenarioConditionGenericsConnectionWhere>;
  /** Return ScenarioConditions where some of the related ScenarioConditionGenericsConnections match this filter */
  genericsConnection_SOME?: InputMaybe<ScenarioConditionGenericsConnectionWhere>;
  /** Return ScenarioConditions where all of the related Generics match this filter */
  generics_ALL?: InputMaybe<GenericWhere>;
  /** Return ScenarioConditions where none of the related Generics match this filter */
  generics_NONE?: InputMaybe<GenericWhere>;
  /** Return ScenarioConditions where one of the related Generics match this filter */
  generics_SINGLE?: InputMaybe<GenericWhere>;
  /** Return ScenarioConditions where some of the related Generics match this filter */
  generics_SOME?: InputMaybe<GenericWhere>;
  grades?: InputMaybe<Array<AdverseEventGrades>>;
  grades_INCLUDES?: InputMaybe<AdverseEventGrades>;
  intervention?: InputMaybe<InterventionType>;
  interventionOccurrence?: InputMaybe<InterventionOccurrence>;
  interventionOccurrence_IN?: InputMaybe<Array<InputMaybe<InterventionOccurrence>>>;
  intervention_IN?: InputMaybe<Array<InputMaybe<InterventionType>>>;
  isNamedTimeRangeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  isScenarioRelevantDrugsActive?: InputMaybe<Scalars['Boolean']['input']>;
  monitoringType?: InputMaybe<MonitoringType>;
  monitoringType_IN?: InputMaybe<Array<InputMaybe<MonitoringType>>>;
  occurence?: InputMaybe<Occurrence>;
  occurence_IN?: InputMaybe<Array<InputMaybe<Occurrence>>>;
  operator?: InputMaybe<ArithmeticalOperator>;
  operator_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  patentStatus?: InputMaybe<PatentStatus>;
  patentStatus_IN?: InputMaybe<Array<InputMaybe<PatentStatus>>>;
  patientScope?: InputMaybe<PatientScope>;
  patientScope_IN?: InputMaybe<Array<InputMaybe<PatientScope>>>;
  reintervention?: InputMaybe<Reintervention>;
  reintervention_IN?: InputMaybe<Array<InputMaybe<Reintervention>>>;
  responseInclusionType?: InputMaybe<ResponseInclusionType>;
  responseInclusionType_IN?: InputMaybe<Array<InputMaybe<ResponseInclusionType>>>;
  responseType?: InputMaybe<UnitedResponseType>;
  responseType_IN?: InputMaybe<Array<InputMaybe<UnitedResponseType>>>;
  rollingRangeType?: InputMaybe<RollingRangeType>;
  rollingRangeType_IN?: InputMaybe<Array<InputMaybe<RollingRangeType>>>;
  scenario?: InputMaybe<ScenarioWhere>;
  scenarioAggregate?: InputMaybe<ScenarioConditionScenarioAggregateInput>;
  scenarioConnection?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
  scenarioConnection_NOT?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
  scenario_NOT?: InputMaybe<ScenarioWhere>;
  startingPoint?: InputMaybe<TimeframeStartingPoint>;
  startingPoint_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
  timeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeType?: InputMaybe<TimeframeRangeType>;
  timeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
  timeframeRelation?: InputMaybe<TimeframeRelation>;
  timeframeRelation_IN?: InputMaybe<Array<InputMaybe<TimeframeRelation>>>;
  timeframeStart?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeStart_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatmentDurationAspect?: InputMaybe<TreatmentDurationConditionAspect>;
  treatmentDurationAspect_IN?: InputMaybe<Array<InputMaybe<TreatmentDurationConditionAspect>>>;
  treatmentsAggregate?: InputMaybe<ScenarioConditionTreatmentsAggregateInput>;
  /** Return ScenarioConditions where all of the related ScenarioConditionTreatmentsConnections match this filter */
  treatmentsConnection_ALL?: InputMaybe<ScenarioConditionTreatmentsConnectionWhere>;
  /** Return ScenarioConditions where none of the related ScenarioConditionTreatmentsConnections match this filter */
  treatmentsConnection_NONE?: InputMaybe<ScenarioConditionTreatmentsConnectionWhere>;
  /** Return ScenarioConditions where one of the related ScenarioConditionTreatmentsConnections match this filter */
  treatmentsConnection_SINGLE?: InputMaybe<ScenarioConditionTreatmentsConnectionWhere>;
  /** Return ScenarioConditions where some of the related ScenarioConditionTreatmentsConnections match this filter */
  treatmentsConnection_SOME?: InputMaybe<ScenarioConditionTreatmentsConnectionWhere>;
  /** Return ScenarioConditions where all of the related Treatments match this filter */
  treatments_ALL?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioConditions where none of the related Treatments match this filter */
  treatments_NONE?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioConditions where one of the related Treatments match this filter */
  treatments_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioConditions where some of the related Treatments match this filter */
  treatments_SOME?: InputMaybe<TreatmentWhere>;
  uoMType?: InputMaybe<UoMType>;
  uoMType_IN?: InputMaybe<Array<InputMaybe<UoMType>>>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ScenarioConditionsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioConditionsAggregateInput>>;
  NOT?: InputMaybe<ScenarioConditionsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioConditionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioConditionsNodeAggregationWhereInput>;
};

export type ScenarioConditionsConnection = {
  __typename?: 'ScenarioConditionsConnection';
  edges: Array<ScenarioConditionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioConditionsConnectionSort = {
  node?: InputMaybe<ScenarioConditionSort>;
};

export type ScenarioConditionsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioConditionsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionsConnectionWhere>>;
  node?: InputMaybe<ScenarioConditionWhere>;
};

export type ScenarioConditionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioConditionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioConditionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioConditionsNodeAggregationWhereInput>>;
  comparedTimeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  endRangeValue_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  eventCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eventCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eventCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eventCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eventCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eventCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ScenarioConditionsRelationship = {
  __typename?: 'ScenarioConditionsRelationship';
  cursor: Scalars['String']['output'];
  node: ScenarioCondition;
};

export type ScenarioEdge = {
  __typename?: 'ScenarioEdge';
  cursor: Scalars['String']['output'];
  node: Scenario;
};

export type ScenarioInput = {
  actionSets?: InputMaybe<Scalars['Boolean']['input']>;
  actionSetsOperator?: InputMaybe<ActionSetsOperator>;
  actions: Array<ScenarioActionInput>;
  conditions: Array<ScenarioConditionInput>;
  group?: InputMaybe<Scalars['Int']['input']>;
  hasMultipleBasePrices?: InputMaybe<Scalars['Boolean']['input']>;
  isGrouped?: InputMaybe<Scalars['Boolean']['input']>;
  isProRating?: InputMaybe<Scalars['Boolean']['input']>;
  isRelevantForArt71?: InputMaybe<Scalars['Boolean']['input']>;
  operator?: InputMaybe<ConditionLogicalOperator>;
  order: Scalars['Int']['input'];
};

export type ScenarioInsightsUserContext = {
  categoryInput?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  rebateObjective?: Maybe<Scalars['String']['output']>;
  timeframeLabel: Scalars['String']['output'];
};

export type ScenarioInsightsUserContextSort = {
  categoryInput?: InputMaybe<SortDirection>;
  groups?: InputMaybe<SortDirection>;
  rebateObjective?: InputMaybe<SortDirection>;
  timeframeLabel?: InputMaybe<SortDirection>;
};

export type ScenarioInsightsUserContextWhere = {
  AND?: InputMaybe<Array<ScenarioInsightsUserContextWhere>>;
  NOT?: InputMaybe<ScenarioInsightsUserContextWhere>;
  OR?: InputMaybe<Array<ScenarioInsightsUserContextWhere>>;
  categoryInput?: InputMaybe<Scalars['String']['input']>;
  categoryInput_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  categoryInput_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  categoryInput_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryInput_MATCHES?: InputMaybe<Scalars['String']['input']>;
  categoryInput_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  groups_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective?: InputMaybe<Scalars['String']['input']>;
  rebateObjective_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  rebateObjective_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  rebateObjective_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rebateObjective_MATCHES?: InputMaybe<Scalars['String']['input']>;
  rebateObjective_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeframeLabel?: InputMaybe<Scalars['String']['input']>;
  timeframeLabel_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timeframeLabel_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeframeLabel_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  timeframeLabel_MATCHES?: InputMaybe<Scalars['String']['input']>;
  timeframeLabel_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ScenarioOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ScenarioSort objects to sort Scenarios by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ScenarioSort>>;
};

export type ScenarioScenarioActionActionsAggregationSelection = {
  __typename?: 'ScenarioScenarioActionActionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioScenarioActionActionsNodeAggregateSelection>;
};

export type ScenarioScenarioActionActionsNodeAggregateSelection = {
  __typename?: 'ScenarioScenarioActionActionsNodeAggregateSelection';
  actionSet: IntAggregateSelectionNullable;
  combinedItemTimeframeEnd: IntAggregateSelectionNullable;
  combinedItemTimeframeStart: IntAggregateSelectionNullable;
  endItemNumber: IntAggregateSelectionNullable;
  genericName: StringAggregateSelectionNullable;
  ingredientEndItemNumber: FloatAggregateSelectionNullable;
  ingredientStartItemNumber: FloatAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  startItemNumber: IntAggregateSelectionNullable;
  timeframeEnd: IntAggregateSelectionNullable;
  timeframeStart: IntAggregateSelectionNullable;
  value: FloatAggregateSelectionNullable;
};

export type ScenarioScenarioConditionConditionsAggregationSelection = {
  __typename?: 'ScenarioScenarioConditionConditionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioScenarioConditionConditionsNodeAggregateSelection>;
};

export type ScenarioScenarioConditionConditionsNodeAggregateSelection = {
  __typename?: 'ScenarioScenarioConditionConditionsNodeAggregateSelection';
  comparedTimeframeEnd: IntAggregateSelectionNullable;
  comparedTimeframeStart: IntAggregateSelectionNullable;
  endRangeValue: FloatAggregateSelectionNullable;
  eventCategory: StringAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  timeframeEnd: IntAggregateSelectionNullable;
  timeframeStart: IntAggregateSelectionNullable;
  value: FloatAggregateSelectionNullable;
};

/** Fields to sort Scenarios by. The order in which sorts are applied is not guaranteed when specifying many fields in one ScenarioSort object. */
export type ScenarioSort = {
  actionSets?: InputMaybe<SortDirection>;
  actionSetsOperator?: InputMaybe<SortDirection>;
  group?: InputMaybe<SortDirection>;
  hasMultipleBasePrices?: InputMaybe<SortDirection>;
  isGrouped?: InputMaybe<SortDirection>;
  isProRating?: InputMaybe<SortDirection>;
  isRelevantForArt71?: InputMaybe<SortDirection>;
  operator?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
};

export type ScenarioWhere = {
  AND?: InputMaybe<Array<ScenarioWhere>>;
  NOT?: InputMaybe<ScenarioWhere>;
  OR?: InputMaybe<Array<ScenarioWhere>>;
  actionSets?: InputMaybe<Scalars['Boolean']['input']>;
  actionSetsOperator?: InputMaybe<ActionSetsOperator>;
  actionSetsOperator_IN?: InputMaybe<Array<InputMaybe<ActionSetsOperator>>>;
  actionsAggregate?: InputMaybe<ScenarioActionsAggregateInput>;
  /** Return Scenarios where all of the related ScenarioActionsConnections match this filter */
  actionsConnection_ALL?: InputMaybe<ScenarioActionsConnectionWhere>;
  /** Return Scenarios where none of the related ScenarioActionsConnections match this filter */
  actionsConnection_NONE?: InputMaybe<ScenarioActionsConnectionWhere>;
  /** Return Scenarios where one of the related ScenarioActionsConnections match this filter */
  actionsConnection_SINGLE?: InputMaybe<ScenarioActionsConnectionWhere>;
  /** Return Scenarios where some of the related ScenarioActionsConnections match this filter */
  actionsConnection_SOME?: InputMaybe<ScenarioActionsConnectionWhere>;
  /** Return Scenarios where all of the related ScenarioActions match this filter */
  actions_ALL?: InputMaybe<ScenarioActionWhere>;
  /** Return Scenarios where none of the related ScenarioActions match this filter */
  actions_NONE?: InputMaybe<ScenarioActionWhere>;
  /** Return Scenarios where one of the related ScenarioActions match this filter */
  actions_SINGLE?: InputMaybe<ScenarioActionWhere>;
  /** Return Scenarios where some of the related ScenarioActions match this filter */
  actions_SOME?: InputMaybe<ScenarioActionWhere>;
  conditionsAggregate?: InputMaybe<ScenarioConditionsAggregateInput>;
  /** Return Scenarios where all of the related ScenarioConditionsConnections match this filter */
  conditionsConnection_ALL?: InputMaybe<ScenarioConditionsConnectionWhere>;
  /** Return Scenarios where none of the related ScenarioConditionsConnections match this filter */
  conditionsConnection_NONE?: InputMaybe<ScenarioConditionsConnectionWhere>;
  /** Return Scenarios where one of the related ScenarioConditionsConnections match this filter */
  conditionsConnection_SINGLE?: InputMaybe<ScenarioConditionsConnectionWhere>;
  /** Return Scenarios where some of the related ScenarioConditionsConnections match this filter */
  conditionsConnection_SOME?: InputMaybe<ScenarioConditionsConnectionWhere>;
  /** Return Scenarios where all of the related ScenarioConditions match this filter */
  conditions_ALL?: InputMaybe<ScenarioConditionWhere>;
  /** Return Scenarios where none of the related ScenarioConditions match this filter */
  conditions_NONE?: InputMaybe<ScenarioConditionWhere>;
  /** Return Scenarios where one of the related ScenarioConditions match this filter */
  conditions_SINGLE?: InputMaybe<ScenarioConditionWhere>;
  /** Return Scenarios where some of the related ScenarioConditions match this filter */
  conditions_SOME?: InputMaybe<ScenarioConditionWhere>;
  group?: InputMaybe<Scalars['Int']['input']>;
  group_GT?: InputMaybe<Scalars['Int']['input']>;
  group_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  group_LT?: InputMaybe<Scalars['Int']['input']>;
  group_LTE?: InputMaybe<Scalars['Int']['input']>;
  hasMultipleBasePrices?: InputMaybe<Scalars['Boolean']['input']>;
  isGrouped?: InputMaybe<Scalars['Boolean']['input']>;
  isProRating?: InputMaybe<Scalars['Boolean']['input']>;
  isRelevantForArt71?: InputMaybe<Scalars['Boolean']['input']>;
  operator?: InputMaybe<ConditionLogicalOperator>;
  operator_IN?: InputMaybe<Array<ConditionLogicalOperator>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenariosConnection = {
  __typename?: 'ScenariosConnection';
  edges: Array<ScenarioEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScopeCheckResult = {
  __typename?: 'ScopeCheckResult';
  code: Scalars['String']['output'];
  isUsed: Scalars['Boolean']['output'];
};

export type ScopeCheckResultEdge = {
  __typename?: 'ScopeCheckResultEdge';
  cursor: Scalars['String']['output'];
  node: ScopeCheckResult;
};

export type ScopeCheckResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ScopeCheckResultSort objects to sort ScopeCheckResults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ScopeCheckResultSort>>;
};

/** Fields to sort ScopeCheckResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one ScopeCheckResultSort object. */
export type ScopeCheckResultSort = {
  code?: InputMaybe<SortDirection>;
  isUsed?: InputMaybe<SortDirection>;
};

export type ScopeCheckResultWhere = {
  AND?: InputMaybe<Array<ScopeCheckResultWhere>>;
  NOT?: InputMaybe<ScopeCheckResultWhere>;
  OR?: InputMaybe<Array<ScopeCheckResultWhere>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScopeCheckResultsConnection = {
  __typename?: 'ScopeCheckResultsConnection';
  edges: Array<ScopeCheckResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ScopeId {
  AdjuvantTherapies = 'ADJUVANT_THERAPIES',
  CarTTherapies = 'CAR_T_THERAPIES',
  CombinationTherapies = 'COMBINATION_THERAPIES',
  Pcsk9I = 'PCSK9I'
}

export type Simulation = {
  __typename?: 'Simulation';
  accessibleUsers: Array<User>;
  accessibleUsersAggregate?: Maybe<SimulationUserAccessibleUsersAggregationSelection>;
  accessibleUsersConnection: SimulationAccessibleUsersConnection;
  addedBy: User;
  addedByAggregate?: Maybe<SimulationUserAddedByAggregationSelection>;
  addedByConnection: SimulationAddedByConnection;
  blueprint?: Maybe<ProductBlueprint>;
  blueprintAggregate?: Maybe<SimulationProductBlueprintBlueprintAggregationSelection>;
  blueprintConnection: SimulationBlueprintConnection;
  businessCase?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  configuration: Scalars['String']['output'];
  counterparty?: Maybe<Scalars['String']['output']>;
  createdByEmail?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['DateTime']['output'];
  deletedByEmail?: Maybe<Scalars['String']['output']>;
  deletedOn?: Maybe<Scalars['DateTime']['output']>;
  domain: Domain;
  domainAggregate?: Maybe<SimulationDomainDomainAggregationSelection>;
  domainConnection: SimulationDomainConnection;
  domainName?: Maybe<Scalars['String']['output']>;
  formattedContent: Scalars['String']['output'];
  hasUnassignedBlueprint: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  indications: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isSimulationComplete: Scalars['Boolean']['output'];
  lastUpdatedByEmail?: Maybe<Scalars['String']['output']>;
  lastUpdatedOn: Scalars['DateTime']['output'];
  lockedSections?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  product: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  simulationUserRole: SimulatorUserRole;
  status: SimulationSavedStatus;
  tenantId: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};


export type SimulationAccessibleUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type SimulationAccessibleUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type SimulationAccessibleUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SimulationAccessibleUsersConnectionSort>>;
  where?: InputMaybe<SimulationAccessibleUsersConnectionWhere>;
};


export type SimulationAddedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type SimulationAddedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type SimulationAddedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SimulationAddedByConnectionSort>>;
  where?: InputMaybe<SimulationAddedByConnectionWhere>;
};


export type SimulationBlueprintArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProductBlueprintOptions>;
  where?: InputMaybe<ProductBlueprintWhere>;
};


export type SimulationBlueprintAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductBlueprintWhere>;
};


export type SimulationBlueprintConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SimulationBlueprintConnectionSort>>;
  where?: InputMaybe<SimulationBlueprintConnectionWhere>;
};


export type SimulationDomainArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DomainOptions>;
  where?: InputMaybe<DomainWhere>;
};


export type SimulationDomainAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DomainWhere>;
};


export type SimulationDomainConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SimulationDomainConnectionSort>>;
  where?: InputMaybe<SimulationDomainConnectionWhere>;
};

export type SimulationAccessibleUsersAggregateInput = {
  AND?: InputMaybe<Array<SimulationAccessibleUsersAggregateInput>>;
  NOT?: InputMaybe<SimulationAccessibleUsersAggregateInput>;
  OR?: InputMaybe<Array<SimulationAccessibleUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<SimulationAccessibleUsersEdgeAggregationWhereInput>;
  node?: InputMaybe<SimulationAccessibleUsersNodeAggregationWhereInput>;
};

export type SimulationAccessibleUsersConnection = {
  __typename?: 'SimulationAccessibleUsersConnection';
  edges: Array<SimulationAccessibleUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationAccessibleUsersConnectionSort = {
  edge?: InputMaybe<SimulatorUserRoleRelationshipSort>;
  node?: InputMaybe<UserSort>;
};

export type SimulationAccessibleUsersConnectionWhere = {
  AND?: InputMaybe<Array<SimulationAccessibleUsersConnectionWhere>>;
  NOT?: InputMaybe<SimulationAccessibleUsersConnectionWhere>;
  OR?: InputMaybe<Array<SimulationAccessibleUsersConnectionWhere>>;
  edge?: InputMaybe<SimulatorUserRoleRelationshipWhere>;
  node?: InputMaybe<UserWhere>;
};

export type SimulationAccessibleUsersEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<SimulationAccessibleUsersEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<SimulationAccessibleUsersEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<SimulationAccessibleUsersEdgeAggregationWhereInput>>;
  grantedByUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grantedByUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grantedByUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grantedByUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grantedByUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grantedByUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulationAccessibleUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SimulationAccessibleUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SimulationAccessibleUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SimulationAccessibleUsersNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulationAccessibleUsersRelationship = SimulatorUserRoleRelationship & {
  __typename?: 'SimulationAccessibleUsersRelationship';
  cursor: Scalars['String']['output'];
  grantedByUserId?: Maybe<Scalars['String']['output']>;
  node: User;
  role: SimulatorUserRole;
};

export type SimulationAddedByAggregateInput = {
  AND?: InputMaybe<Array<SimulationAddedByAggregateInput>>;
  NOT?: InputMaybe<SimulationAddedByAggregateInput>;
  OR?: InputMaybe<Array<SimulationAddedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SimulationAddedByNodeAggregationWhereInput>;
};

export type SimulationAddedByConnection = {
  __typename?: 'SimulationAddedByConnection';
  edges: Array<SimulationAddedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationAddedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type SimulationAddedByConnectionWhere = {
  AND?: InputMaybe<Array<SimulationAddedByConnectionWhere>>;
  NOT?: InputMaybe<SimulationAddedByConnectionWhere>;
  OR?: InputMaybe<Array<SimulationAddedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type SimulationAddedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SimulationAddedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SimulationAddedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SimulationAddedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulationAddedByRelationship = {
  __typename?: 'SimulationAddedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type SimulationBlueprintAggregateInput = {
  AND?: InputMaybe<Array<SimulationBlueprintAggregateInput>>;
  NOT?: InputMaybe<SimulationBlueprintAggregateInput>;
  OR?: InputMaybe<Array<SimulationBlueprintAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SimulationBlueprintNodeAggregationWhereInput>;
};

export type SimulationBlueprintConnection = {
  __typename?: 'SimulationBlueprintConnection';
  edges: Array<SimulationBlueprintRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationBlueprintConnectionSort = {
  node?: InputMaybe<ProductBlueprintSort>;
};

export type SimulationBlueprintConnectionWhere = {
  AND?: InputMaybe<Array<SimulationBlueprintConnectionWhere>>;
  NOT?: InputMaybe<SimulationBlueprintConnectionWhere>;
  OR?: InputMaybe<Array<SimulationBlueprintConnectionWhere>>;
  node?: InputMaybe<ProductBlueprintWhere>;
};

export type SimulationBlueprintNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SimulationBlueprintNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SimulationBlueprintNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SimulationBlueprintNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formValues_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formValues_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indication_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  indication_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  indications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  productName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  productName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  publishedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SimulationBlueprintRelationship = {
  __typename?: 'SimulationBlueprintRelationship';
  cursor: Scalars['String']['output'];
  node: ProductBlueprint;
};

export type SimulationCount = {
  __typename?: 'SimulationCount';
  count?: Maybe<Scalars['Int']['output']>;
};

export type SimulationCountEdge = {
  __typename?: 'SimulationCountEdge';
  cursor: Scalars['String']['output'];
  node: SimulationCount;
};

export type SimulationCountOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SimulationCountSort objects to sort SimulationCounts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SimulationCountSort>>;
};

/** Fields to sort SimulationCounts by. The order in which sorts are applied is not guaranteed when specifying many fields in one SimulationCountSort object. */
export type SimulationCountSort = {
  count?: InputMaybe<SortDirection>;
};

export type SimulationCountWhere = {
  AND?: InputMaybe<Array<SimulationCountWhere>>;
  NOT?: InputMaybe<SimulationCountWhere>;
  OR?: InputMaybe<Array<SimulationCountWhere>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulationCountsConnection = {
  __typename?: 'SimulationCountsConnection';
  edges: Array<SimulationCountEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationDomainAggregateInput = {
  AND?: InputMaybe<Array<SimulationDomainAggregateInput>>;
  NOT?: InputMaybe<SimulationDomainAggregateInput>;
  OR?: InputMaybe<Array<SimulationDomainAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SimulationDomainNodeAggregationWhereInput>;
};

export type SimulationDomainConnection = {
  __typename?: 'SimulationDomainConnection';
  edges: Array<SimulationDomainRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationDomainConnectionSort = {
  node?: InputMaybe<DomainSort>;
};

export type SimulationDomainConnectionWhere = {
  AND?: InputMaybe<Array<SimulationDomainConnectionWhere>>;
  NOT?: InputMaybe<SimulationDomainConnectionWhere>;
  OR?: InputMaybe<Array<SimulationDomainConnectionWhere>>;
  node?: InputMaybe<DomainWhere>;
};

export type SimulationDomainDomainAggregationSelection = {
  __typename?: 'SimulationDomainDomainAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SimulationDomainDomainNodeAggregateSelection>;
};

export type SimulationDomainDomainNodeAggregateSelection = {
  __typename?: 'SimulationDomainDomainNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  level: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type SimulationDomainNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SimulationDomainNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SimulationDomainNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SimulationDomainNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  level_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  level_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulationDomainRelationship = {
  __typename?: 'SimulationDomainRelationship';
  cursor: Scalars['String']['output'];
  node: Domain;
};

export type SimulationEdge = {
  __typename?: 'SimulationEdge';
  cursor: Scalars['String']['output'];
  node: Simulation;
};

export type SimulationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SimulationSort objects to sort Simulations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SimulationSort>>;
};

export type SimulationProductBlueprintBlueprintAggregationSelection = {
  __typename?: 'SimulationProductBlueprintBlueprintAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SimulationProductBlueprintBlueprintNodeAggregateSelection>;
};

export type SimulationProductBlueprintBlueprintNodeAggregateSelection = {
  __typename?: 'SimulationProductBlueprintBlueprintNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  addedOn: DateTimeAggregateSelectionNonNullable;
  formValues: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  indication: StringAggregateSelectionNonNullable;
  indications: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  productName: StringAggregateSelectionNonNullable;
  publishedOn: DateTimeAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  updatedOn: DateTimeAggregateSelectionNonNullable;
};

export enum SimulationSavedStatus {
  Complete = 'COMPLETE',
  Draft = 'DRAFT'
}

/** Fields to sort Simulations by. The order in which sorts are applied is not guaranteed when specifying many fields in one SimulationSort object. */
export type SimulationSort = {
  businessCase?: InputMaybe<SortDirection>;
  comments?: InputMaybe<SortDirection>;
  configuration?: InputMaybe<SortDirection>;
  counterparty?: InputMaybe<SortDirection>;
  createdByEmail?: InputMaybe<SortDirection>;
  createdByName?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  deletedByEmail?: InputMaybe<SortDirection>;
  deletedOn?: InputMaybe<SortDirection>;
  domainName?: InputMaybe<SortDirection>;
  formattedContent?: InputMaybe<SortDirection>;
  hasUnassignedBlueprint?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  indications?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isSimulationComplete?: InputMaybe<SortDirection>;
  lastUpdatedByEmail?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  lockedSections?: InputMaybe<SortDirection>;
  model?: InputMaybe<SortDirection>;
  product?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  simulationUserRole?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  version?: InputMaybe<SortDirection>;
};

export type SimulationUserAccessibleUsersAggregationSelection = {
  __typename?: 'SimulationUserAccessibleUsersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<SimulationUserAccessibleUsersEdgeAggregateSelection>;
  node?: Maybe<SimulationUserAccessibleUsersNodeAggregateSelection>;
};

export type SimulationUserAccessibleUsersEdgeAggregateSelection = {
  __typename?: 'SimulationUserAccessibleUsersEdgeAggregateSelection';
  grantedByUserId: StringAggregateSelectionNullable;
};

export type SimulationUserAccessibleUsersNodeAggregateSelection = {
  __typename?: 'SimulationUserAccessibleUsersNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type SimulationUserAddedByAggregationSelection = {
  __typename?: 'SimulationUserAddedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SimulationUserAddedByNodeAggregateSelection>;
};

export type SimulationUserAddedByNodeAggregateSelection = {
  __typename?: 'SimulationUserAddedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type SimulationUserWithRole = {
  __typename?: 'SimulationUserWithRole';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  grantedByUserId?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  role: SimulatorUserRole;
  userDomainId: Scalars['String']['output'];
  userDomainName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userRole?: Maybe<Scalars['String']['output']>;
};

export type SimulationUserWithRoleEdge = {
  __typename?: 'SimulationUserWithRoleEdge';
  cursor: Scalars['String']['output'];
  node: SimulationUserWithRole;
};

export type SimulationUserWithRoleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SimulationUserWithRoleSort objects to sort SimulationUserWithRoles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SimulationUserWithRoleSort>>;
};

/** Fields to sort SimulationUserWithRoles by. The order in which sorts are applied is not guaranteed when specifying many fields in one SimulationUserWithRoleSort object. */
export type SimulationUserWithRoleSort = {
  email?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  grantedByUserId?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  userDomainId?: InputMaybe<SortDirection>;
  userDomainName?: InputMaybe<SortDirection>;
  userId?: InputMaybe<SortDirection>;
  userRole?: InputMaybe<SortDirection>;
};

export type SimulationUserWithRoleWhere = {
  AND?: InputMaybe<Array<SimulationUserWithRoleWhere>>;
  NOT?: InputMaybe<SimulationUserWithRoleWhere>;
  OR?: InputMaybe<Array<SimulationUserWithRoleWhere>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantedByUserId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<SimulatorUserRole>;
  role_IN?: InputMaybe<Array<SimulatorUserRole>>;
  userDomainId?: InputMaybe<Scalars['String']['input']>;
  userDomainId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userDomainId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userDomainId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  userDomainId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userDomainId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userDomainName?: InputMaybe<Scalars['String']['input']>;
  userDomainName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userDomainName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userDomainName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userDomainName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userDomainName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  userId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
  userRole_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userRole_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userRole_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userRole_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userRole_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type SimulationUserWithRolesConnection = {
  __typename?: 'SimulationUserWithRolesConnection';
  edges: Array<SimulationUserWithRoleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationWhere = {
  AND?: InputMaybe<Array<SimulationWhere>>;
  NOT?: InputMaybe<SimulationWhere>;
  OR?: InputMaybe<Array<SimulationWhere>>;
  accessibleUsersAggregate?: InputMaybe<SimulationAccessibleUsersAggregateInput>;
  /** Return Simulations where all of the related SimulationAccessibleUsersConnections match this filter */
  accessibleUsersConnection_ALL?: InputMaybe<SimulationAccessibleUsersConnectionWhere>;
  /** Return Simulations where none of the related SimulationAccessibleUsersConnections match this filter */
  accessibleUsersConnection_NONE?: InputMaybe<SimulationAccessibleUsersConnectionWhere>;
  /** Return Simulations where one of the related SimulationAccessibleUsersConnections match this filter */
  accessibleUsersConnection_SINGLE?: InputMaybe<SimulationAccessibleUsersConnectionWhere>;
  /** Return Simulations where some of the related SimulationAccessibleUsersConnections match this filter */
  accessibleUsersConnection_SOME?: InputMaybe<SimulationAccessibleUsersConnectionWhere>;
  /** Return Simulations where all of the related Users match this filter */
  accessibleUsers_ALL?: InputMaybe<UserWhere>;
  /** Return Simulations where none of the related Users match this filter */
  accessibleUsers_NONE?: InputMaybe<UserWhere>;
  /** Return Simulations where one of the related Users match this filter */
  accessibleUsers_SINGLE?: InputMaybe<UserWhere>;
  /** Return Simulations where some of the related Users match this filter */
  accessibleUsers_SOME?: InputMaybe<UserWhere>;
  addedBy?: InputMaybe<UserWhere>;
  addedByAggregate?: InputMaybe<SimulationAddedByAggregateInput>;
  addedByConnection?: InputMaybe<SimulationAddedByConnectionWhere>;
  addedByConnection_NOT?: InputMaybe<SimulationAddedByConnectionWhere>;
  addedBy_NOT?: InputMaybe<UserWhere>;
  blueprint?: InputMaybe<ProductBlueprintWhere>;
  blueprintAggregate?: InputMaybe<SimulationBlueprintAggregateInput>;
  blueprintConnection?: InputMaybe<SimulationBlueprintConnectionWhere>;
  blueprintConnection_NOT?: InputMaybe<SimulationBlueprintConnectionWhere>;
  blueprint_NOT?: InputMaybe<ProductBlueprintWhere>;
  businessCase?: InputMaybe<Scalars['String']['input']>;
  businessCase_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  businessCase_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  businessCase_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  businessCase_MATCHES?: InputMaybe<Scalars['String']['input']>;
  businessCase_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  comments_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comments_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comments_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comments_MATCHES?: InputMaybe<Scalars['String']['input']>;
  comments_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  configuration_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  configuration_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  configuration_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  configuration_MATCHES?: InputMaybe<Scalars['String']['input']>;
  configuration_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  counterparty?: InputMaybe<Scalars['String']['input']>;
  counterparty_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  counterparty_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  counterparty_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  counterparty_MATCHES?: InputMaybe<Scalars['String']['input']>;
  counterparty_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByName?: InputMaybe<Scalars['String']['input']>;
  createdByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  createdByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  createdByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deletedByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  deletedOn?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  deletedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<DomainWhere>;
  domainAggregate?: InputMaybe<SimulationDomainAggregateInput>;
  domainConnection?: InputMaybe<SimulationDomainConnectionWhere>;
  domainConnection_NOT?: InputMaybe<SimulationDomainConnectionWhere>;
  domainName?: InputMaybe<Scalars['String']['input']>;
  domainName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  domainName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  domainName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domainName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  domainName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  domain_NOT?: InputMaybe<DomainWhere>;
  formattedContent?: InputMaybe<Scalars['String']['input']>;
  formattedContent_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedContent_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedContent_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedContent_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedContent_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  indications?: InputMaybe<Scalars['String']['input']>;
  indications_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  indications_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  indications_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  indications_MATCHES?: InputMaybe<Scalars['String']['input']>;
  indications_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isSimulationComplete?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedByEmail?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedByEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastUpdatedByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSections?: InputMaybe<Scalars['String']['input']>;
  lockedSections_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lockedSections_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lockedSections_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lockedSections_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lockedSections_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  model_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  model_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  model_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  model_MATCHES?: InputMaybe<Scalars['String']['input']>;
  model_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  product_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  product_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  product_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  product_MATCHES?: InputMaybe<Scalars['String']['input']>;
  product_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SimulationSavedStatus>;
  status_IN?: InputMaybe<Array<SimulationSavedStatus>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_GT?: InputMaybe<Scalars['Int']['input']>;
  version_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_LT?: InputMaybe<Scalars['Int']['input']>;
  version_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulationsConnection = {
  __typename?: 'SimulationsConnection';
  edges: Array<SimulationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum SimulatorUserRole {
  Editor = 'EDITOR',
  NonViewer = 'NON_VIEWER',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type SimulatorUserRoleRelationship = {
  grantedByUserId?: Maybe<Scalars['String']['output']>;
  role: SimulatorUserRole;
};

export type SimulatorUserRoleRelationshipSort = {
  grantedByUserId?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type SimulatorUserRoleRelationshipWhere = {
  AND?: InputMaybe<Array<SimulatorUserRoleRelationshipWhere>>;
  NOT?: InputMaybe<SimulatorUserRoleRelationshipWhere>;
  OR?: InputMaybe<Array<SimulatorUserRoleRelationshipWhere>>;
  grantedByUserId?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantedByUserId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<SimulatorUserRole>;
  role_IN?: InputMaybe<Array<SimulatorUserRole>>;
};

export enum SingleSignOnType {
  Microsoft = 'MICROSOFT',
  PingId = 'PING_ID'
}

export type SlowGraphqlOperation = {
  __typename?: 'SlowGraphqlOperation';
  avgDurationMs: Scalars['Float']['output'];
  errorCount: Scalars['Float']['output'];
  maxDurationMs: Scalars['Float']['output'];
  operationName: Scalars['String']['output'];
  requestCount: Scalars['Float']['output'];
};

export type SlowGraphqlOperationEdge = {
  __typename?: 'SlowGraphqlOperationEdge';
  cursor: Scalars['String']['output'];
  node: SlowGraphqlOperation;
};

export type SlowGraphqlOperationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SlowGraphqlOperationSort objects to sort SlowGraphqlOperations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SlowGraphqlOperationSort>>;
};

/** Fields to sort SlowGraphqlOperations by. The order in which sorts are applied is not guaranteed when specifying many fields in one SlowGraphqlOperationSort object. */
export type SlowGraphqlOperationSort = {
  avgDurationMs?: InputMaybe<SortDirection>;
  errorCount?: InputMaybe<SortDirection>;
  maxDurationMs?: InputMaybe<SortDirection>;
  operationName?: InputMaybe<SortDirection>;
  requestCount?: InputMaybe<SortDirection>;
};

export type SlowGraphqlOperationWhere = {
  AND?: InputMaybe<Array<SlowGraphqlOperationWhere>>;
  NOT?: InputMaybe<SlowGraphqlOperationWhere>;
  OR?: InputMaybe<Array<SlowGraphqlOperationWhere>>;
  avgDurationMs?: InputMaybe<Scalars['Float']['input']>;
  avgDurationMs_GT?: InputMaybe<Scalars['Float']['input']>;
  avgDurationMs_GTE?: InputMaybe<Scalars['Float']['input']>;
  avgDurationMs_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  avgDurationMs_LT?: InputMaybe<Scalars['Float']['input']>;
  avgDurationMs_LTE?: InputMaybe<Scalars['Float']['input']>;
  errorCount?: InputMaybe<Scalars['Float']['input']>;
  errorCount_GT?: InputMaybe<Scalars['Float']['input']>;
  errorCount_GTE?: InputMaybe<Scalars['Float']['input']>;
  errorCount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  errorCount_LT?: InputMaybe<Scalars['Float']['input']>;
  errorCount_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxDurationMs?: InputMaybe<Scalars['Float']['input']>;
  maxDurationMs_GT?: InputMaybe<Scalars['Float']['input']>;
  maxDurationMs_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxDurationMs_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  maxDurationMs_LT?: InputMaybe<Scalars['Float']['input']>;
  maxDurationMs_LTE?: InputMaybe<Scalars['Float']['input']>;
  operationName?: InputMaybe<Scalars['String']['input']>;
  operationName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  operationName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  operationName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  operationName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  operationName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  requestCount?: InputMaybe<Scalars['Float']['input']>;
  requestCount_GT?: InputMaybe<Scalars['Float']['input']>;
  requestCount_GTE?: InputMaybe<Scalars['Float']['input']>;
  requestCount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  requestCount_LT?: InputMaybe<Scalars['Float']['input']>;
  requestCount_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type SlowGraphqlOperationsConnection = {
  __typename?: 'SlowGraphqlOperationsConnection';
  edges: Array<SlowGraphqlOperationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SlowGraphqlRequestsResult = {
  __typename?: 'SlowGraphqlRequestsResult';
  generatedAt: Scalars['Float']['output'];
  operations: Array<SlowGraphqlOperation>;
  rangeDays: Scalars['Int']['output'];
};

export type SlowGraphqlRequestsResultEdge = {
  __typename?: 'SlowGraphqlRequestsResultEdge';
  cursor: Scalars['String']['output'];
  node: SlowGraphqlRequestsResult;
};

export type SlowGraphqlRequestsResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SlowGraphqlRequestsResultSort objects to sort SlowGraphqlRequestsResults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SlowGraphqlRequestsResultSort>>;
};

/** Fields to sort SlowGraphqlRequestsResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one SlowGraphqlRequestsResultSort object. */
export type SlowGraphqlRequestsResultSort = {
  generatedAt?: InputMaybe<SortDirection>;
  rangeDays?: InputMaybe<SortDirection>;
};

export type SlowGraphqlRequestsResultWhere = {
  AND?: InputMaybe<Array<SlowGraphqlRequestsResultWhere>>;
  NOT?: InputMaybe<SlowGraphqlRequestsResultWhere>;
  OR?: InputMaybe<Array<SlowGraphqlRequestsResultWhere>>;
  generatedAt?: InputMaybe<Scalars['Float']['input']>;
  generatedAt_GT?: InputMaybe<Scalars['Float']['input']>;
  generatedAt_GTE?: InputMaybe<Scalars['Float']['input']>;
  generatedAt_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  generatedAt_LT?: InputMaybe<Scalars['Float']['input']>;
  generatedAt_LTE?: InputMaybe<Scalars['Float']['input']>;
  rangeDays?: InputMaybe<Scalars['Int']['input']>;
  rangeDays_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeDays_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeDays_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  rangeDays_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeDays_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SlowGraphqlRequestsResultsConnection = {
  __typename?: 'SlowGraphqlRequestsResultsConnection';
  edges: Array<SlowGraphqlRequestsResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An enum for sorting in either ascending or descending order. */
export enum SortDirection {
  /** Sort by field values in ascending order. */
  Asc = 'ASC',
  /** Sort by field values in descending order. */
  Desc = 'DESC'
}

export enum StatusHistorical {
  Mandatory = 'MANDATORY',
  MandatoryForSubmission = 'MANDATORY_FOR_SUBMISSION',
  Optional = 'OPTIONAL'
}

export type StoreUser = {
  __typename?: 'StoreUser';
  currency?: Maybe<Scalars['String']['output']>;
  domains?: Maybe<Array<Maybe<Domain>>>;
  email: Scalars['String']['output'];
  emailConfirmed?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isLastOwnerAgreementIds: Array<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  modules: Array<Maybe<UserAvailableEntryModule>>;
  organization?: Maybe<AuthOrganization>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type StoreUserEdge = {
  __typename?: 'StoreUserEdge';
  cursor: Scalars['String']['output'];
  node: StoreUser;
};

export type StoreUserOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more StoreUserSort objects to sort StoreUsers by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<StoreUserSort>>;
};

/** Fields to sort StoreUsers by. The order in which sorts are applied is not guaranteed when specifying many fields in one StoreUserSort object. */
export type StoreUserSort = {
  currency?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  emailConfirmed?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  locked?: InputMaybe<SortDirection>;
  phoneNumber?: InputMaybe<SortDirection>;
  preferredLanguage?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type StoreUserWhere = {
  AND?: InputMaybe<Array<StoreUserWhere>>;
  NOT?: InputMaybe<StoreUserWhere>;
  OR?: InputMaybe<Array<StoreUserWhere>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currency_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currency_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isLastOwnerAgreementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isLastOwnerAgreementIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phoneNumber_MATCHES?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferredLanguage_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  role_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  role_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  role_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role_MATCHES?: InputMaybe<Scalars['String']['input']>;
  role_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type StoreUsersConnection = {
  __typename?: 'StoreUsersConnection';
  edges: Array<StoreUserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StringAggregateSelectionNonNullable = {
  __typename?: 'StringAggregateSelectionNonNullable';
  longest: Scalars['String']['output'];
  shortest: Scalars['String']['output'];
};

export type StringAggregateSelectionNullable = {
  __typename?: 'StringAggregateSelectionNullable';
  longest?: Maybe<Scalars['String']['output']>;
  shortest?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  integrityCheckComplete: Array<CheckedType>;
  masterDataUpdateImpacts: Array<Art71MasterDataImpacts>;
  uploadStateUpdated: UploadState;
};

export type SyncRefundImpact = {
  __typename?: 'SyncRefundImpact';
  agreementVersion: Scalars['Int']['output'];
  documentCreator?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  documentReviewer?: Maybe<Scalars['String']['output']>;
  refundId?: Maybe<Scalars['String']['output']>;
};

export type SyncRefundImpactEdge = {
  __typename?: 'SyncRefundImpactEdge';
  cursor: Scalars['String']['output'];
  node: SyncRefundImpact;
};

export type SyncRefundImpactOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SyncRefundImpactSort objects to sort SyncRefundImpacts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SyncRefundImpactSort>>;
};

/** Fields to sort SyncRefundImpacts by. The order in which sorts are applied is not guaranteed when specifying many fields in one SyncRefundImpactSort object. */
export type SyncRefundImpactSort = {
  agreementVersion?: InputMaybe<SortDirection>;
  documentCreator?: InputMaybe<SortDirection>;
  documentId?: InputMaybe<SortDirection>;
  documentReviewer?: InputMaybe<SortDirection>;
  refundId?: InputMaybe<SortDirection>;
};

export type SyncRefundImpactWhere = {
  AND?: InputMaybe<Array<SyncRefundImpactWhere>>;
  NOT?: InputMaybe<SyncRefundImpactWhere>;
  OR?: InputMaybe<Array<SyncRefundImpactWhere>>;
  agreementVersion?: InputMaybe<Scalars['Int']['input']>;
  agreementVersion_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementVersion_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementVersion_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  agreementVersion_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementVersion_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentCreator?: InputMaybe<Scalars['String']['input']>;
  documentCreator_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentCreator_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentCreator_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentCreator_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentCreator_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReviewer?: InputMaybe<Scalars['String']['input']>;
  documentReviewer_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentReviewer_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReviewer_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentReviewer_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentReviewer_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  refundId?: InputMaybe<Scalars['String']['input']>;
  refundId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  refundId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  refundId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  refundId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type SyncRefundImpactsConnection = {
  __typename?: 'SyncRefundImpactsConnection';
  edges: Array<SyncRefundImpactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SyncResponse = {
  __typename?: 'SyncResponse';
  agreementId: Scalars['String']['output'];
  agreementName?: Maybe<Scalars['String']['output']>;
  dependentArt71AgreementsStatus?: Maybe<Scalars['String']['output']>;
  excludedScopes?: Maybe<Scalars['String']['output']>;
  newScopes?: Maybe<Scalars['String']['output']>;
  refundImpacts: Array<SyncRefundImpact>;
  scenariosStatus?: Maybe<Scalars['String']['output']>;
  scopesStatus?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ResponseBaseStatus>;
  type: SyncType;
  validityStatus?: Maybe<Scalars['String']['output']>;
  versionNo: Scalars['Int']['output'];
};

export type SyncResponseEdge = {
  __typename?: 'SyncResponseEdge';
  cursor: Scalars['String']['output'];
  node: SyncResponse;
};

export type SyncResponseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SyncResponseSort objects to sort SyncResponses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SyncResponseSort>>;
};

/** Fields to sort SyncResponses by. The order in which sorts are applied is not guaranteed when specifying many fields in one SyncResponseSort object. */
export type SyncResponseSort = {
  agreementId?: InputMaybe<SortDirection>;
  agreementName?: InputMaybe<SortDirection>;
  dependentArt71AgreementsStatus?: InputMaybe<SortDirection>;
  excludedScopes?: InputMaybe<SortDirection>;
  newScopes?: InputMaybe<SortDirection>;
  scenariosStatus?: InputMaybe<SortDirection>;
  scopesStatus?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  validityStatus?: InputMaybe<SortDirection>;
  versionNo?: InputMaybe<SortDirection>;
};

export type SyncResponseWhere = {
  AND?: InputMaybe<Array<SyncResponseWhere>>;
  NOT?: InputMaybe<SyncResponseWhere>;
  OR?: InputMaybe<Array<SyncResponseWhere>>;
  agreementId?: InputMaybe<Scalars['String']['input']>;
  agreementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName?: InputMaybe<Scalars['String']['input']>;
  agreementName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  dependentArt71AgreementsStatus?: InputMaybe<Scalars['String']['input']>;
  dependentArt71AgreementsStatus_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  dependentArt71AgreementsStatus_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  dependentArt71AgreementsStatus_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dependentArt71AgreementsStatus_MATCHES?: InputMaybe<Scalars['String']['input']>;
  dependentArt71AgreementsStatus_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  excludedScopes?: InputMaybe<Scalars['String']['input']>;
  excludedScopes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  excludedScopes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  excludedScopes_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedScopes_MATCHES?: InputMaybe<Scalars['String']['input']>;
  excludedScopes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  newScopes?: InputMaybe<Scalars['String']['input']>;
  newScopes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  newScopes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  newScopes_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newScopes_MATCHES?: InputMaybe<Scalars['String']['input']>;
  newScopes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenariosStatus?: InputMaybe<Scalars['String']['input']>;
  scenariosStatus_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scenariosStatus_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenariosStatus_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scenariosStatus_MATCHES?: InputMaybe<Scalars['String']['input']>;
  scenariosStatus_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  scopesStatus?: InputMaybe<Scalars['String']['input']>;
  scopesStatus_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scopesStatus_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scopesStatus_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scopesStatus_MATCHES?: InputMaybe<Scalars['String']['input']>;
  scopesStatus_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResponseBaseStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<ResponseBaseStatus>>>;
  type?: InputMaybe<SyncType>;
  type_IN?: InputMaybe<Array<SyncType>>;
  validityStatus?: InputMaybe<Scalars['String']['input']>;
  validityStatus_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  validityStatus_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  validityStatus_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validityStatus_MATCHES?: InputMaybe<Scalars['String']['input']>;
  validityStatus_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  versionNo?: InputMaybe<Scalars['Int']['input']>;
  versionNo_GT?: InputMaybe<Scalars['Int']['input']>;
  versionNo_GTE?: InputMaybe<Scalars['Int']['input']>;
  versionNo_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  versionNo_LT?: InputMaybe<Scalars['Int']['input']>;
  versionNo_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SyncResponsesConnection = {
  __typename?: 'SyncResponsesConnection';
  edges: Array<SyncResponseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum SyncType {
  SyncScenarios = 'SYNC_SCENARIOS',
  SyncScope = 'SYNC_SCOPE',
  SyncValidity = 'SYNC_VALIDITY'
}

export type SystemTask = {
  __typename?: 'SystemTask';
  completedOn: Scalars['DateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type SystemTaskEdge = {
  __typename?: 'SystemTaskEdge';
  cursor: Scalars['String']['output'];
  node: SystemTask;
};

export type SystemTaskOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SystemTaskSort objects to sort SystemTasks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SystemTaskSort>>;
};

/** Fields to sort SystemTasks by. The order in which sorts are applied is not guaranteed when specifying many fields in one SystemTaskSort object. */
export type SystemTaskSort = {
  completedOn?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  state?: InputMaybe<SortDirection>;
};

export type SystemTaskWhere = {
  AND?: InputMaybe<Array<SystemTaskWhere>>;
  NOT?: InputMaybe<SystemTaskWhere>;
  OR?: InputMaybe<Array<SystemTaskWhere>>;
  completedOn?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  completedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  state_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  state_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state_MATCHES?: InputMaybe<Scalars['String']['input']>;
  state_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type SystemTasksConnection = {
  __typename?: 'SystemTasksConnection';
  edges: Array<SystemTaskEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TermsAndPoliciesInput = {
  text: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export enum TestPurposeType {
  Baseline = 'BASELINE',
  Final = 'FINAL',
  Other = 'OTHER',
  Routine = 'ROUTINE'
}

export enum TestType {
  AbsoluteReticulocyteCount = 'ABSOLUTE_RETICULOCYTE_COUNT',
  Hemoglobin = 'HEMOGLOBIN',
  LactateDehydrogenase = 'LACTATE_DEHYDROGENASE',
  NeutrophilCount = 'NEUTROPHIL_COUNT',
  PlateletCount = 'PLATELET_COUNT'
}

export enum TestUoMType {
  GramsPerDecilitre = 'GRAMS_PER_DECILITRE',
  PerBillionPerLitre = 'PER_BILLION_PER_LITRE',
  PerMicrolitre = 'PER_MICROLITRE',
  TimesUln = 'TIMES_ULN'
}

export type ThresholdConfigurationRelationship = {
  threshold: Scalars['Int']['output'];
};

export type ThresholdConfigurationRelationshipSort = {
  threshold?: InputMaybe<SortDirection>;
};

export type ThresholdConfigurationRelationshipWhere = {
  AND?: InputMaybe<Array<ThresholdConfigurationRelationshipWhere>>;
  NOT?: InputMaybe<ThresholdConfigurationRelationshipWhere>;
  OR?: InputMaybe<Array<ThresholdConfigurationRelationshipWhere>>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
  threshold_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  threshold_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export enum TimeframeRangeType {
  BetweenMedicalApprovalPlus_365 = 'BETWEEN_MEDICAL_APPROVAL_PLUS_365',
  Ever = 'EVER',
  StartingFrom = 'STARTING_FROM',
  UpTo = 'UP_TO',
  Within = 'WITHIN',
  WithinRollingRangeOf = 'WITHIN_ROLLING_RANGE_OF',
  WithinTherapyTrial = 'WITHIN_THERAPY_TRIAL',
  WithinTheCoveragePeriod = 'WITHIN_THE_COVERAGE_PERIOD',
  WithinTheLast = 'WITHIN_THE_LAST'
}

export enum TimeframeRelation {
  Before = 'BEFORE',
  StartingFrom = 'STARTING_FROM'
}

export enum TimeframeStartingPoint {
  AgreementStartDate = 'AGREEMENT_START_DATE',
  AgreementVersionStartDate = 'AGREEMENT_VERSION_START_DATE',
  CoveragePeriodStart = 'COVERAGE_PERIOD_START',
  DiscontinuationDate = 'DISCONTINUATION_DATE',
  FirstAdministrationDate = 'FIRST_ADMINISTRATION_DATE',
  FirstPrescriptionDate = 'FIRST_PRESCRIPTION_DATE',
  IntendedStartDate = 'INTENDED_START_DATE',
  ProgressionDate = 'PROGRESSION_DATE',
  RequestReceiptDate = 'REQUEST_RECEIPT_DATE',
  TherapyTrialStartDate = 'THERAPY_TRIAL_START_DATE',
  TreatmentStartDate = 'TREATMENT_START_DATE'
}

export enum TransfusionType {
  RedBloodCell = 'RED_BLOOD_CELL'
}

export type Translation = {
  __typename?: 'Translation';
  key: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TranslationEdge = {
  __typename?: 'TranslationEdge';
  cursor: Scalars['String']['output'];
  node: Translation;
};

export type TranslationInput = {
  key: Scalars['String']['input'];
  languages: Array<TranslationLanguageInput>;
};

export type TranslationLanguageInput = {
  code: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TranslationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TranslationSort objects to sort Translations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TranslationSort>>;
};

/** Fields to sort Translations by. The order in which sorts are applied is not guaranteed when specifying many fields in one TranslationSort object. */
export type TranslationSort = {
  key?: InputMaybe<SortDirection>;
  languageCode?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type TranslationWhere = {
  AND?: InputMaybe<Array<TranslationWhere>>;
  NOT?: InputMaybe<TranslationWhere>;
  OR?: InputMaybe<Array<TranslationWhere>>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  key_MATCHES?: InputMaybe<Scalars['String']['input']>;
  key_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  languageCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  languageCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  languageCode_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  languageCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  languageCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  value_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  value_MATCHES?: InputMaybe<Scalars['String']['input']>;
  value_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export enum Translations {
  De = 'DE',
  En = 'EN'
}

export type TranslationsConnection = {
  __typename?: 'TranslationsConnection';
  edges: Array<TranslationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TranslationsInput = {
  file: Scalars['String']['input'];
  language: Translations;
};

export type TranslationsWithChangedKeys = {
  __typename?: 'TranslationsWithChangedKeys';
  changedKeys: Array<Maybe<Scalars['String']['output']>>;
  masterFile: Scalars['String']['output'];
  translationsFile: Scalars['String']['output'];
};

export type TranslationsWithChangedKeysConnection = {
  __typename?: 'TranslationsWithChangedKeysConnection';
  edges: Array<TranslationsWithChangedKeysEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TranslationsWithChangedKeysEdge = {
  __typename?: 'TranslationsWithChangedKeysEdge';
  cursor: Scalars['String']['output'];
  node: TranslationsWithChangedKeys;
};

export type TranslationsWithChangedKeysOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TranslationsWithChangedKeysSort objects to sort TranslationsWithChangedKeys by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TranslationsWithChangedKeysSort>>;
};

/** Fields to sort TranslationsWithChangedKeys by. The order in which sorts are applied is not guaranteed when specifying many fields in one TranslationsWithChangedKeysSort object. */
export type TranslationsWithChangedKeysSort = {
  masterFile?: InputMaybe<SortDirection>;
  translationsFile?: InputMaybe<SortDirection>;
};

export type TranslationsWithChangedKeysWhere = {
  AND?: InputMaybe<Array<TranslationsWithChangedKeysWhere>>;
  NOT?: InputMaybe<TranslationsWithChangedKeysWhere>;
  OR?: InputMaybe<Array<TranslationsWithChangedKeysWhere>>;
  changedKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  changedKeys_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  masterFile?: InputMaybe<Scalars['String']['input']>;
  masterFile_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  masterFile_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  masterFile_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  masterFile_MATCHES?: InputMaybe<Scalars['String']['input']>;
  masterFile_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  translationsFile?: InputMaybe<Scalars['String']['input']>;
  translationsFile_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  translationsFile_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  translationsFile_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  translationsFile_MATCHES?: InputMaybe<Scalars['String']['input']>;
  translationsFile_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type Treatment = {
  __typename?: 'Treatment';
  BagDossierNo?: Maybe<Scalars['String']['output']>;
  Code: Scalars['String']['output'];
  DIN?: Maybe<Scalars['String']['output']>;
  FlagModal?: Maybe<Scalars['String']['output']>;
  FlagNarcosis?: Maybe<Scalars['String']['output']>;
  GTIN?: Maybe<Scalars['String']['output']>;
  LOT?: Maybe<Scalars['String']['output']>;
  NDC?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
  Partners: Array<Partner>;
  PartnersAggregate?: Maybe<TreatmentPartnerPartnersAggregationSelection>;
  PartnersConnection: TreatmentPartnersConnection;
  PharmaCode?: Maybe<Scalars['String']['output']>;
  PrevPharmacode?: Maybe<Scalars['String']['output']>;
  REF?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<PreparationStatus>;
  StatusAggregate?: Maybe<TreatmentPreparationStatusStatusAggregationSelection>;
  StatusConnection: TreatmentStatusConnection;
  SwissmedicCategory?: Maybe<Scalars['String']['output']>;
  SwissmedicNo8?: Maybe<Scalars['String']['output']>;
  UDI?: Maybe<Scalars['String']['output']>;
  activeIngredientQuantity?: Maybe<Scalars['Float']['output']>;
  canBeMain?: Maybe<Scalars['Boolean']['output']>;
  classificationSystem?: Maybe<Scalars['String']['output']>;
  codeCategories: Array<CodeCategory>;
  concentration?: Maybe<Scalars['String']['output']>;
  country: Country;
  countryAggregate?: Maybe<TreatmentCountryCountryAggregationSelection>;
  countryConnection: TreatmentCountryConnection;
  hasLimitations: Array<Limitation>;
  hasLimitationsAggregate?: Maybe<TreatmentLimitationHasLimitationsAggregationSelection>;
  hasLimitationsConnection: TreatmentHasLimitationsConnection;
  newCode?: Maybe<Scalars['String']['output']>;
  packVolume?: Maybe<Scalars['String']['output']>;
  packVolumeUoMType?: Maybe<PackVolumeUoMType>;
  prices: Array<Price>;
  pricesAggregate?: Maybe<TreatmentPricePricesAggregationSelection>;
  pricesConnection: TreatmentPricesConnection;
  regulatedBy: Preparation;
  regulatedByAggregate?: Maybe<TreatmentPreparationRegulatedByAggregationSelection>;
  regulatedByConnection: TreatmentRegulatedByConnection;
  uoMType?: Maybe<UoMType>;
};


export type TreatmentPartnersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PartnerOptions>;
  where?: InputMaybe<PartnerWhere>;
};


export type TreatmentPartnersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartnerWhere>;
};


export type TreatmentPartnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentPartnersConnectionSort>>;
  where?: InputMaybe<TreatmentPartnersConnectionWhere>;
};


export type TreatmentStatusArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationStatusOptions>;
  where?: InputMaybe<PreparationStatusWhere>;
};


export type TreatmentStatusAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationStatusWhere>;
};


export type TreatmentStatusConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentStatusConnectionSort>>;
  where?: InputMaybe<TreatmentStatusConnectionWhere>;
};


export type TreatmentCountryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type TreatmentCountryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type TreatmentCountryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentCountryConnectionSort>>;
  where?: InputMaybe<TreatmentCountryConnectionWhere>;
};


export type TreatmentHasLimitationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LimitationOptions>;
  where?: InputMaybe<LimitationWhere>;
};


export type TreatmentHasLimitationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LimitationWhere>;
};


export type TreatmentHasLimitationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentHasLimitationsConnectionSort>>;
  where?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
};


export type TreatmentPricesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PriceOptions>;
  where?: InputMaybe<PriceWhere>;
};


export type TreatmentPricesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PriceWhere>;
};


export type TreatmentPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentPricesConnectionSort>>;
  where?: InputMaybe<TreatmentPricesConnectionWhere>;
};


export type TreatmentRegulatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type TreatmentRegulatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationWhere>;
};


export type TreatmentRegulatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentRegulatedByConnectionSort>>;
  where?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
};

export type TreatmentCountryAggregateInput = {
  AND?: InputMaybe<Array<TreatmentCountryAggregateInput>>;
  NOT?: InputMaybe<TreatmentCountryAggregateInput>;
  OR?: InputMaybe<Array<TreatmentCountryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentCountryNodeAggregationWhereInput>;
};

export type TreatmentCountryConnection = {
  __typename?: 'TreatmentCountryConnection';
  edges: Array<TreatmentCountryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentCountryConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type TreatmentCountryConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentCountryConnectionWhere>>;
  NOT?: InputMaybe<TreatmentCountryConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentCountryConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type TreatmentCountryCountryAggregationSelection = {
  __typename?: 'TreatmentCountryCountryAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentCountryCountryNodeAggregateSelection>;
};

export type TreatmentCountryCountryNodeAggregateSelection = {
  __typename?: 'TreatmentCountryCountryNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type TreatmentCountryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentCountryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TreatmentCountryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentCountryNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentCountryRelationship = {
  __typename?: 'TreatmentCountryRelationship';
  cursor: Scalars['String']['output'];
  node: Country;
};

export enum TreatmentDiscontinuationReason {
  AnotherTherapyStart = 'ANOTHER_THERAPY_START',
  Any = 'ANY',
  NonAdherence = 'NON_ADHERENCE',
  NoInfo = 'NO_INFO',
  PatientDeath = 'PATIENT_DEATH',
  ProgressiveDisease = 'PROGRESSIVE_DISEASE',
  Trae = 'TRAE'
}

export enum TreatmentDurationConditionAspect {
  Discontinued = 'DISCONTINUED',
  Lasted = 'LASTED'
}

export type TreatmentEdge = {
  __typename?: 'TreatmentEdge';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type TreatmentHasLimitationsAggregateInput = {
  AND?: InputMaybe<Array<TreatmentHasLimitationsAggregateInput>>;
  NOT?: InputMaybe<TreatmentHasLimitationsAggregateInput>;
  OR?: InputMaybe<Array<TreatmentHasLimitationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentHasLimitationsNodeAggregationWhereInput>;
};

export type TreatmentHasLimitationsConnection = {
  __typename?: 'TreatmentHasLimitationsConnection';
  edges: Array<TreatmentHasLimitationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentHasLimitationsConnectionSort = {
  node?: InputMaybe<LimitationSort>;
};

export type TreatmentHasLimitationsConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentHasLimitationsConnectionWhere>>;
  NOT?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentHasLimitationsConnectionWhere>>;
  node?: InputMaybe<LimitationWhere>;
};

export type TreatmentHasLimitationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentHasLimitationsNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<TreatmentHasLimitationsNodeAggregationWhereInput>;
  Niveau_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<TreatmentHasLimitationsNodeAggregationWhereInput>>;
  Type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TreatmentHasLimitationsRelationship = {
  __typename?: 'TreatmentHasLimitationsRelationship';
  cursor: Scalars['String']['output'];
  node: Limitation;
};

export type TreatmentInput = {
  Code?: InputMaybe<Scalars['String']['input']>;
  DIN?: InputMaybe<Scalars['String']['input']>;
  GTIN?: InputMaybe<Scalars['String']['input']>;
  NDC?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
  PharmaCode?: InputMaybe<Scalars['String']['input']>;
  SwissmedicCategory?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo8?: InputMaybe<Scalars['String']['input']>;
  UDI?: InputMaybe<Scalars['String']['input']>;
  activeIngredientQuantity?: InputMaybe<Scalars['Float']['input']>;
  codeCategories?: InputMaybe<Array<CodeCategory>>;
  concentration?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  isToBeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  packVolume?: InputMaybe<Scalars['String']['input']>;
  packVolumeUoMType?: InputMaybe<PackVolumeUoMType>;
  partnerIdentifier?: InputMaybe<Scalars['String']['input']>;
  preparationId?: InputMaybe<Scalars['String']['input']>;
  prices?: InputMaybe<Array<PriceTreatmentInput>>;
  uoMType?: InputMaybe<UoMType>;
};

export type TreatmentLimitationHasLimitationsAggregationSelection = {
  __typename?: 'TreatmentLimitationHasLimitationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentLimitationHasLimitationsNodeAggregateSelection>;
};

export type TreatmentLimitationHasLimitationsNodeAggregateSelection = {
  __typename?: 'TreatmentLimitationHasLimitationsNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  DescriptionDe: StringAggregateSelectionNonNullable;
  DescriptionEn: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  Niveau: StringAggregateSelectionNullable;
  Type: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
};

export type TreatmentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TreatmentSort objects to sort Treatments by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TreatmentSort>>;
};

export type TreatmentPartnerPartnersAggregationSelection = {
  __typename?: 'TreatmentPartnerPartnersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentPartnerPartnersNodeAggregateSelection>;
};

export type TreatmentPartnerPartnersNodeAggregateSelection = {
  __typename?: 'TreatmentPartnerPartnersNodeAggregateSelection';
  Description: StringAggregateSelectionNullable;
  PartnerType: StringAggregateSelectionNullable;
  Phone: StringAggregateSelectionNullable;
  Place: StringAggregateSelectionNullable;
  Street: StringAggregateSelectionNullable;
  ZipCode: IntAggregateSelectionNullable;
};

export type TreatmentPartnersAggregateInput = {
  AND?: InputMaybe<Array<TreatmentPartnersAggregateInput>>;
  NOT?: InputMaybe<TreatmentPartnersAggregateInput>;
  OR?: InputMaybe<Array<TreatmentPartnersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentPartnersNodeAggregationWhereInput>;
};

export type TreatmentPartnersConnection = {
  __typename?: 'TreatmentPartnersConnection';
  edges: Array<TreatmentPartnersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentPartnersConnectionSort = {
  node?: InputMaybe<PartnerSort>;
};

export type TreatmentPartnersConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentPartnersConnectionWhere>>;
  NOT?: InputMaybe<TreatmentPartnersConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentPartnersConnectionWhere>>;
  node?: InputMaybe<PartnerWhere>;
};

export type TreatmentPartnersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentPartnersNodeAggregationWhereInput>>;
  Description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<TreatmentPartnersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentPartnersNodeAggregationWhereInput>>;
  PartnerType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PartnerType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PartnerType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PartnerType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PartnerType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PartnerType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Place_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Place_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Place_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Place_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Place_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Place_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Place_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Place_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Place_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Place_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Place_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Place_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Place_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Place_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Place_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Street_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Street_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Street_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Street_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Street_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Street_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Street_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Street_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Street_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Street_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Street_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Street_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Street_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Street_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Street_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ZipCode_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ZipCode_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ZipCode_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ZipCode_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ZipCode_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentPartnersRelationship = {
  __typename?: 'TreatmentPartnersRelationship';
  cursor: Scalars['String']['output'];
  node: Partner;
};

export type TreatmentPreparationRegulatedByAggregationSelection = {
  __typename?: 'TreatmentPreparationRegulatedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentPreparationRegulatedByNodeAggregateSelection>;
};

export type TreatmentPreparationRegulatedByNodeAggregateSelection = {
  __typename?: 'TreatmentPreparationRegulatedByNodeAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type TreatmentPreparationStatusStatusAggregationSelection = {
  __typename?: 'TreatmentPreparationStatusStatusAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentPreparationStatusStatusNodeAggregateSelection>;
};

export type TreatmentPreparationStatusStatusNodeAggregateSelection = {
  __typename?: 'TreatmentPreparationStatusStatusNodeAggregateSelection';
  FlagApd: StringAggregateSelectionNullable;
  StatusTypeCodeSl: StringAggregateSelectionNullable;
  StatusTypeDescriptionSl: StringAggregateSelectionNullable;
};

export type TreatmentPriceInput = {
  basePriceType?: InputMaybe<PriceType>;
  price: Scalars['Float']['input'];
  treatment?: InputMaybe<TreatmentInput>;
};

export type TreatmentPricePricesAggregationSelection = {
  __typename?: 'TreatmentPricePricesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentPricePricesNodeAggregateSelection>;
};

export type TreatmentPricePricesNodeAggregateSelection = {
  __typename?: 'TreatmentPricePricesNodeAggregateSelection';
  Price: StringAggregateSelectionNonNullable;
  PriceChangeTypeDescriptionDe: StringAggregateSelectionNullable;
  PriceChangeTypeDescriptionFr: StringAggregateSelectionNullable;
  PriceChangeTypeDescriptionIt: StringAggregateSelectionNullable;
  PriceTypeDescriptionDe: StringAggregateSelectionNullable;
  PriceTypeDescriptionFr: StringAggregateSelectionNullable;
  PriceTypeDescriptionIt: StringAggregateSelectionNullable;
  countriesConsidered: StringAggregateSelectionNullable;
  uniqueCode: StringAggregateSelectionNonNullable;
};

export type TreatmentPricesAggregateInput = {
  AND?: InputMaybe<Array<TreatmentPricesAggregateInput>>;
  NOT?: InputMaybe<TreatmentPricesAggregateInput>;
  OR?: InputMaybe<Array<TreatmentPricesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentPricesNodeAggregationWhereInput>;
};

export type TreatmentPricesConnection = {
  __typename?: 'TreatmentPricesConnection';
  edges: Array<TreatmentPricesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentPricesConnectionSort = {
  node?: InputMaybe<PriceSort>;
};

export type TreatmentPricesConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentPricesConnectionWhere>>;
  NOT?: InputMaybe<TreatmentPricesConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentPricesConnectionWhere>>;
  node?: InputMaybe<PriceWhere>;
};

export type TreatmentPricesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentPricesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TreatmentPricesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentPricesNodeAggregationWhereInput>>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Price_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Price_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentPricesRelationship = {
  __typename?: 'TreatmentPricesRelationship';
  cursor: Scalars['String']['output'];
  node: Price;
};

export type TreatmentRegulatedByAggregateInput = {
  AND?: InputMaybe<Array<TreatmentRegulatedByAggregateInput>>;
  NOT?: InputMaybe<TreatmentRegulatedByAggregateInput>;
  OR?: InputMaybe<Array<TreatmentRegulatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentRegulatedByNodeAggregationWhereInput>;
};

export type TreatmentRegulatedByConnection = {
  __typename?: 'TreatmentRegulatedByConnection';
  edges: Array<TreatmentRegulatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentRegulatedByConnectionSort = {
  node?: InputMaybe<PreparationSort>;
};

export type TreatmentRegulatedByConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentRegulatedByConnectionWhere>>;
  NOT?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentRegulatedByConnectionWhere>>;
  node?: InputMaybe<PreparationWhere>;
};

export type TreatmentRegulatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentRegulatedByNodeAggregationWhereInput>>;
  AtcCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<TreatmentRegulatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentRegulatedByNodeAggregationWhereInput>>;
  SwissmedicNo5_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentRegulatedByRelationship = {
  __typename?: 'TreatmentRegulatedByRelationship';
  cursor: Scalars['String']['output'];
  node: Preparation;
};

export type TreatmentSet = {
  __typename?: 'TreatmentSet';
  generic: Generic;
  genericAggregate?: Maybe<TreatmentSetGenericGenericAggregationSelection>;
  genericConnection: TreatmentSetGenericConnection;
  isFixedPriceTarget: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  preparations: Array<Preparation>;
  preparationsAggregate?: Maybe<TreatmentSetPreparationPreparationsAggregationSelection>;
  preparationsConnection: TreatmentSetPreparationsConnection;
  scope: AgreementScope;
  scopeAggregate?: Maybe<TreatmentSetAgreementScopeScopeAggregationSelection>;
  scopeConnection: TreatmentSetScopeConnection;
  treatments: Array<Treatment>;
  treatmentsAggregate?: Maybe<TreatmentSetTreatmentTreatmentsAggregationSelection>;
  treatmentsConnection: TreatmentSetTreatmentsConnection;
};


export type TreatmentSetGenericArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type TreatmentSetGenericAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type TreatmentSetGenericConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentSetGenericConnectionSort>>;
  where?: InputMaybe<TreatmentSetGenericConnectionWhere>;
};


export type TreatmentSetPreparationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type TreatmentSetPreparationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationWhere>;
};


export type TreatmentSetPreparationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentSetPreparationsConnectionSort>>;
  where?: InputMaybe<TreatmentSetPreparationsConnectionWhere>;
};


export type TreatmentSetScopeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementScopeOptions>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type TreatmentSetScopeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type TreatmentSetScopeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentSetScopeConnectionSort>>;
  where?: InputMaybe<TreatmentSetScopeConnectionWhere>;
};


export type TreatmentSetTreatmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type TreatmentSetTreatmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type TreatmentSetTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentSetTreatmentsConnectionSort>>;
  where?: InputMaybe<TreatmentSetTreatmentsConnectionWhere>;
};

export type TreatmentSetAgreementScopeScopeAggregationSelection = {
  __typename?: 'TreatmentSetAgreementScopeScopeAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentSetAgreementScopeScopeNodeAggregateSelection>;
};

export type TreatmentSetAgreementScopeScopeNodeAggregateSelection = {
  __typename?: 'TreatmentSetAgreementScopeScopeNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
  scopeId: StringAggregateSelectionNonNullable;
};

export type TreatmentSetEdge = {
  __typename?: 'TreatmentSetEdge';
  cursor: Scalars['String']['output'];
  node: TreatmentSet;
};

export type TreatmentSetGenericAggregateInput = {
  AND?: InputMaybe<Array<TreatmentSetGenericAggregateInput>>;
  NOT?: InputMaybe<TreatmentSetGenericAggregateInput>;
  OR?: InputMaybe<Array<TreatmentSetGenericAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentSetGenericNodeAggregationWhereInput>;
};

export type TreatmentSetGenericConnection = {
  __typename?: 'TreatmentSetGenericConnection';
  edges: Array<TreatmentSetGenericRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentSetGenericConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type TreatmentSetGenericConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentSetGenericConnectionWhere>>;
  NOT?: InputMaybe<TreatmentSetGenericConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentSetGenericConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type TreatmentSetGenericGenericAggregationSelection = {
  __typename?: 'TreatmentSetGenericGenericAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentSetGenericGenericNodeAggregateSelection>;
};

export type TreatmentSetGenericGenericNodeAggregateSelection = {
  __typename?: 'TreatmentSetGenericGenericNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type TreatmentSetGenericNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentSetGenericNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TreatmentSetGenericNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<TreatmentSetGenericNodeAggregationWhereInput>>;
};

export type TreatmentSetGenericRelationship = {
  __typename?: 'TreatmentSetGenericRelationship';
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type TreatmentSetInput = {
  generic?: InputMaybe<Scalars['String']['input']>;
  isFixedPriceTarget: Scalars['Boolean']['input'];
  order: Scalars['Int']['input'];
  preparations: Array<PreparationInput>;
  treatments: Array<TreatmentInput>;
};

export type TreatmentSetOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TreatmentSetSort objects to sort TreatmentSets by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TreatmentSetSort>>;
};

export type TreatmentSetPreparationPreparationsAggregationSelection = {
  __typename?: 'TreatmentSetPreparationPreparationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentSetPreparationPreparationsNodeAggregateSelection>;
};

export type TreatmentSetPreparationPreparationsNodeAggregateSelection = {
  __typename?: 'TreatmentSetPreparationPreparationsNodeAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type TreatmentSetPreparationsAggregateInput = {
  AND?: InputMaybe<Array<TreatmentSetPreparationsAggregateInput>>;
  NOT?: InputMaybe<TreatmentSetPreparationsAggregateInput>;
  OR?: InputMaybe<Array<TreatmentSetPreparationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentSetPreparationsNodeAggregationWhereInput>;
};

export type TreatmentSetPreparationsConnection = {
  __typename?: 'TreatmentSetPreparationsConnection';
  edges: Array<TreatmentSetPreparationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentSetPreparationsConnectionSort = {
  node?: InputMaybe<PreparationSort>;
};

export type TreatmentSetPreparationsConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentSetPreparationsConnectionWhere>>;
  NOT?: InputMaybe<TreatmentSetPreparationsConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentSetPreparationsConnectionWhere>>;
  node?: InputMaybe<PreparationWhere>;
};

export type TreatmentSetPreparationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentSetPreparationsNodeAggregationWhereInput>>;
  AtcCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<TreatmentSetPreparationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentSetPreparationsNodeAggregationWhereInput>>;
  SwissmedicNo5_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentSetPreparationsRelationship = {
  __typename?: 'TreatmentSetPreparationsRelationship';
  cursor: Scalars['String']['output'];
  node: Preparation;
};

export type TreatmentSetScopeAggregateInput = {
  AND?: InputMaybe<Array<TreatmentSetScopeAggregateInput>>;
  NOT?: InputMaybe<TreatmentSetScopeAggregateInput>;
  OR?: InputMaybe<Array<TreatmentSetScopeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentSetScopeNodeAggregationWhereInput>;
};

export type TreatmentSetScopeConnection = {
  __typename?: 'TreatmentSetScopeConnection';
  edges: Array<TreatmentSetScopeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentSetScopeConnectionSort = {
  node?: InputMaybe<AgreementScopeSort>;
};

export type TreatmentSetScopeConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentSetScopeConnectionWhere>>;
  NOT?: InputMaybe<TreatmentSetScopeConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentSetScopeConnectionWhere>>;
  node?: InputMaybe<AgreementScopeWhere>;
};

export type TreatmentSetScopeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentSetScopeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TreatmentSetScopeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentSetScopeNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentSetScopeRelationship = {
  __typename?: 'TreatmentSetScopeRelationship';
  cursor: Scalars['String']['output'];
  node: AgreementScope;
};

/** Fields to sort TreatmentSets by. The order in which sorts are applied is not guaranteed when specifying many fields in one TreatmentSetSort object. */
export type TreatmentSetSort = {
  isFixedPriceTarget?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
};

export type TreatmentSetTreatmentTreatmentsAggregationSelection = {
  __typename?: 'TreatmentSetTreatmentTreatmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentSetTreatmentTreatmentsNodeAggregateSelection>;
};

export type TreatmentSetTreatmentTreatmentsNodeAggregateSelection = {
  __typename?: 'TreatmentSetTreatmentTreatmentsNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type TreatmentSetTreatmentsAggregateInput = {
  AND?: InputMaybe<Array<TreatmentSetTreatmentsAggregateInput>>;
  NOT?: InputMaybe<TreatmentSetTreatmentsAggregateInput>;
  OR?: InputMaybe<Array<TreatmentSetTreatmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentSetTreatmentsNodeAggregationWhereInput>;
};

export type TreatmentSetTreatmentsConnection = {
  __typename?: 'TreatmentSetTreatmentsConnection';
  edges: Array<TreatmentSetTreatmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentSetTreatmentsConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type TreatmentSetTreatmentsConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentSetTreatmentsConnectionWhere>>;
  NOT?: InputMaybe<TreatmentSetTreatmentsConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentSetTreatmentsConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type TreatmentSetTreatmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentSetTreatmentsNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<TreatmentSetTreatmentsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<TreatmentSetTreatmentsNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentSetTreatmentsRelationship = {
  __typename?: 'TreatmentSetTreatmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type TreatmentSetWhere = {
  AND?: InputMaybe<Array<TreatmentSetWhere>>;
  NOT?: InputMaybe<TreatmentSetWhere>;
  OR?: InputMaybe<Array<TreatmentSetWhere>>;
  generic?: InputMaybe<GenericWhere>;
  genericAggregate?: InputMaybe<TreatmentSetGenericAggregateInput>;
  genericConnection?: InputMaybe<TreatmentSetGenericConnectionWhere>;
  genericConnection_NOT?: InputMaybe<TreatmentSetGenericConnectionWhere>;
  generic_NOT?: InputMaybe<GenericWhere>;
  isFixedPriceTarget?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationsAggregate?: InputMaybe<TreatmentSetPreparationsAggregateInput>;
  /** Return TreatmentSets where all of the related TreatmentSetPreparationsConnections match this filter */
  preparationsConnection_ALL?: InputMaybe<TreatmentSetPreparationsConnectionWhere>;
  /** Return TreatmentSets where none of the related TreatmentSetPreparationsConnections match this filter */
  preparationsConnection_NONE?: InputMaybe<TreatmentSetPreparationsConnectionWhere>;
  /** Return TreatmentSets where one of the related TreatmentSetPreparationsConnections match this filter */
  preparationsConnection_SINGLE?: InputMaybe<TreatmentSetPreparationsConnectionWhere>;
  /** Return TreatmentSets where some of the related TreatmentSetPreparationsConnections match this filter */
  preparationsConnection_SOME?: InputMaybe<TreatmentSetPreparationsConnectionWhere>;
  /** Return TreatmentSets where all of the related Preparations match this filter */
  preparations_ALL?: InputMaybe<PreparationWhere>;
  /** Return TreatmentSets where none of the related Preparations match this filter */
  preparations_NONE?: InputMaybe<PreparationWhere>;
  /** Return TreatmentSets where one of the related Preparations match this filter */
  preparations_SINGLE?: InputMaybe<PreparationWhere>;
  /** Return TreatmentSets where some of the related Preparations match this filter */
  preparations_SOME?: InputMaybe<PreparationWhere>;
  scope?: InputMaybe<AgreementScopeWhere>;
  scopeAggregate?: InputMaybe<TreatmentSetScopeAggregateInput>;
  scopeConnection?: InputMaybe<TreatmentSetScopeConnectionWhere>;
  scopeConnection_NOT?: InputMaybe<TreatmentSetScopeConnectionWhere>;
  scope_NOT?: InputMaybe<AgreementScopeWhere>;
  treatmentsAggregate?: InputMaybe<TreatmentSetTreatmentsAggregateInput>;
  /** Return TreatmentSets where all of the related TreatmentSetTreatmentsConnections match this filter */
  treatmentsConnection_ALL?: InputMaybe<TreatmentSetTreatmentsConnectionWhere>;
  /** Return TreatmentSets where none of the related TreatmentSetTreatmentsConnections match this filter */
  treatmentsConnection_NONE?: InputMaybe<TreatmentSetTreatmentsConnectionWhere>;
  /** Return TreatmentSets where one of the related TreatmentSetTreatmentsConnections match this filter */
  treatmentsConnection_SINGLE?: InputMaybe<TreatmentSetTreatmentsConnectionWhere>;
  /** Return TreatmentSets where some of the related TreatmentSetTreatmentsConnections match this filter */
  treatmentsConnection_SOME?: InputMaybe<TreatmentSetTreatmentsConnectionWhere>;
  /** Return TreatmentSets where all of the related Treatments match this filter */
  treatments_ALL?: InputMaybe<TreatmentWhere>;
  /** Return TreatmentSets where none of the related Treatments match this filter */
  treatments_NONE?: InputMaybe<TreatmentWhere>;
  /** Return TreatmentSets where one of the related Treatments match this filter */
  treatments_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return TreatmentSets where some of the related Treatments match this filter */
  treatments_SOME?: InputMaybe<TreatmentWhere>;
};

export type TreatmentSetsConnection = {
  __typename?: 'TreatmentSetsConnection';
  edges: Array<TreatmentSetEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Fields to sort Treatments by. The order in which sorts are applied is not guaranteed when specifying many fields in one TreatmentSort object. */
export type TreatmentSort = {
  BagDossierNo?: InputMaybe<SortDirection>;
  Code?: InputMaybe<SortDirection>;
  DIN?: InputMaybe<SortDirection>;
  FlagModal?: InputMaybe<SortDirection>;
  FlagNarcosis?: InputMaybe<SortDirection>;
  GTIN?: InputMaybe<SortDirection>;
  LOT?: InputMaybe<SortDirection>;
  NDC?: InputMaybe<SortDirection>;
  Name?: InputMaybe<SortDirection>;
  PharmaCode?: InputMaybe<SortDirection>;
  PrevPharmacode?: InputMaybe<SortDirection>;
  REF?: InputMaybe<SortDirection>;
  SwissmedicCategory?: InputMaybe<SortDirection>;
  SwissmedicNo8?: InputMaybe<SortDirection>;
  UDI?: InputMaybe<SortDirection>;
  activeIngredientQuantity?: InputMaybe<SortDirection>;
  canBeMain?: InputMaybe<SortDirection>;
  classificationSystem?: InputMaybe<SortDirection>;
  concentration?: InputMaybe<SortDirection>;
  newCode?: InputMaybe<SortDirection>;
  packVolume?: InputMaybe<SortDirection>;
  packVolumeUoMType?: InputMaybe<SortDirection>;
  uoMType?: InputMaybe<SortDirection>;
};

export type TreatmentStatusAggregateInput = {
  AND?: InputMaybe<Array<TreatmentStatusAggregateInput>>;
  NOT?: InputMaybe<TreatmentStatusAggregateInput>;
  OR?: InputMaybe<Array<TreatmentStatusAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentStatusNodeAggregationWhereInput>;
};

export type TreatmentStatusConnection = {
  __typename?: 'TreatmentStatusConnection';
  edges: Array<TreatmentStatusRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentStatusConnectionSort = {
  node?: InputMaybe<PreparationStatusSort>;
};

export type TreatmentStatusConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentStatusConnectionWhere>>;
  NOT?: InputMaybe<TreatmentStatusConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentStatusConnectionWhere>>;
  node?: InputMaybe<PreparationStatusWhere>;
};

export type TreatmentStatusNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentStatusNodeAggregationWhereInput>>;
  FlagApd_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagApd_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagApd_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagApd_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagApd_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagApd_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<TreatmentStatusNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentStatusNodeAggregationWhereInput>>;
  StatusTypeCodeSl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeCodeSl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeCodeSl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeCodeSl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeCodeSl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeCodeSl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeDescriptionSl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeDescriptionSl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeDescriptionSl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeDescriptionSl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeDescriptionSl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentStatusRelationship = {
  __typename?: 'TreatmentStatusRelationship';
  cursor: Scalars['String']['output'];
  node: PreparationStatus;
};

export type TreatmentWhere = {
  AND?: InputMaybe<Array<TreatmentWhere>>;
  BagDossierNo?: InputMaybe<Scalars['String']['input']>;
  BagDossierNo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  BagDossierNo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  BagDossierNo_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  BagDossierNo_MATCHES?: InputMaybe<Scalars['String']['input']>;
  BagDossierNo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Code?: InputMaybe<Scalars['String']['input']>;
  Code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DIN?: InputMaybe<Scalars['String']['input']>;
  DIN_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DIN_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DIN_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  DIN_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DIN_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  FlagModal?: InputMaybe<Scalars['String']['input']>;
  FlagModal_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  FlagModal_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  FlagModal_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FlagModal_MATCHES?: InputMaybe<Scalars['String']['input']>;
  FlagModal_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  FlagNarcosis?: InputMaybe<Scalars['String']['input']>;
  FlagNarcosis_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  FlagNarcosis_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  FlagNarcosis_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FlagNarcosis_MATCHES?: InputMaybe<Scalars['String']['input']>;
  FlagNarcosis_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  GTIN?: InputMaybe<Scalars['String']['input']>;
  GTIN_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  GTIN_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  GTIN_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  GTIN_MATCHES?: InputMaybe<Scalars['String']['input']>;
  GTIN_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  LOT?: InputMaybe<Scalars['String']['input']>;
  LOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  LOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  LOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  LOT_MATCHES?: InputMaybe<Scalars['String']['input']>;
  LOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NDC?: InputMaybe<Scalars['String']['input']>;
  NDC_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  NDC_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  NDC_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  NDC_MATCHES?: InputMaybe<Scalars['String']['input']>;
  NDC_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<TreatmentWhere>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  OR?: InputMaybe<Array<TreatmentWhere>>;
  PartnersAggregate?: InputMaybe<TreatmentPartnersAggregateInput>;
  /** Return Treatments where all of the related TreatmentPartnersConnections match this filter */
  PartnersConnection_ALL?: InputMaybe<TreatmentPartnersConnectionWhere>;
  /** Return Treatments where none of the related TreatmentPartnersConnections match this filter */
  PartnersConnection_NONE?: InputMaybe<TreatmentPartnersConnectionWhere>;
  /** Return Treatments where one of the related TreatmentPartnersConnections match this filter */
  PartnersConnection_SINGLE?: InputMaybe<TreatmentPartnersConnectionWhere>;
  /** Return Treatments where some of the related TreatmentPartnersConnections match this filter */
  PartnersConnection_SOME?: InputMaybe<TreatmentPartnersConnectionWhere>;
  /** Return Treatments where all of the related Partners match this filter */
  Partners_ALL?: InputMaybe<PartnerWhere>;
  /** Return Treatments where none of the related Partners match this filter */
  Partners_NONE?: InputMaybe<PartnerWhere>;
  /** Return Treatments where one of the related Partners match this filter */
  Partners_SINGLE?: InputMaybe<PartnerWhere>;
  /** Return Treatments where some of the related Partners match this filter */
  Partners_SOME?: InputMaybe<PartnerWhere>;
  PharmaCode?: InputMaybe<Scalars['String']['input']>;
  PharmaCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PharmaCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PharmaCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PharmaCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PharmaCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  PrevPharmacode?: InputMaybe<Scalars['String']['input']>;
  PrevPharmacode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PrevPharmacode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PrevPharmacode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PrevPharmacode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PrevPharmacode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  REF?: InputMaybe<Scalars['String']['input']>;
  REF_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  REF_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  REF_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  REF_MATCHES?: InputMaybe<Scalars['String']['input']>;
  REF_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<PreparationStatusWhere>;
  StatusAggregate?: InputMaybe<TreatmentStatusAggregateInput>;
  StatusConnection?: InputMaybe<TreatmentStatusConnectionWhere>;
  StatusConnection_NOT?: InputMaybe<TreatmentStatusConnectionWhere>;
  Status_NOT?: InputMaybe<PreparationStatusWhere>;
  SwissmedicCategory?: InputMaybe<Scalars['String']['input']>;
  SwissmedicCategory_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  SwissmedicCategory_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  SwissmedicCategory_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SwissmedicCategory_MATCHES?: InputMaybe<Scalars['String']['input']>;
  SwissmedicCategory_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo8?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo8_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo8_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo8_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SwissmedicNo8_MATCHES?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo8_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  UDI?: InputMaybe<Scalars['String']['input']>;
  UDI_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  UDI_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  UDI_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  UDI_MATCHES?: InputMaybe<Scalars['String']['input']>;
  UDI_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  activeIngredientQuantity?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  activeIngredientQuantity_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_LTE?: InputMaybe<Scalars['Float']['input']>;
  canBeMain?: InputMaybe<Scalars['Boolean']['input']>;
  classificationSystem?: InputMaybe<Scalars['String']['input']>;
  classificationSystem_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  classificationSystem_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  classificationSystem_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  classificationSystem_MATCHES?: InputMaybe<Scalars['String']['input']>;
  classificationSystem_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  codeCategories?: InputMaybe<Array<CodeCategory>>;
  codeCategories_INCLUDES?: InputMaybe<CodeCategory>;
  concentration?: InputMaybe<Scalars['String']['input']>;
  concentration_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  concentration_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  concentration_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  concentration_MATCHES?: InputMaybe<Scalars['String']['input']>;
  concentration_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryWhere>;
  countryAggregate?: InputMaybe<TreatmentCountryAggregateInput>;
  countryConnection?: InputMaybe<TreatmentCountryConnectionWhere>;
  countryConnection_NOT?: InputMaybe<TreatmentCountryConnectionWhere>;
  country_NOT?: InputMaybe<CountryWhere>;
  hasLimitationsAggregate?: InputMaybe<TreatmentHasLimitationsAggregateInput>;
  /** Return Treatments where all of the related TreatmentHasLimitationsConnections match this filter */
  hasLimitationsConnection_ALL?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
  /** Return Treatments where none of the related TreatmentHasLimitationsConnections match this filter */
  hasLimitationsConnection_NONE?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
  /** Return Treatments where one of the related TreatmentHasLimitationsConnections match this filter */
  hasLimitationsConnection_SINGLE?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
  /** Return Treatments where some of the related TreatmentHasLimitationsConnections match this filter */
  hasLimitationsConnection_SOME?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
  /** Return Treatments where all of the related Limitations match this filter */
  hasLimitations_ALL?: InputMaybe<LimitationWhere>;
  /** Return Treatments where none of the related Limitations match this filter */
  hasLimitations_NONE?: InputMaybe<LimitationWhere>;
  /** Return Treatments where one of the related Limitations match this filter */
  hasLimitations_SINGLE?: InputMaybe<LimitationWhere>;
  /** Return Treatments where some of the related Limitations match this filter */
  hasLimitations_SOME?: InputMaybe<LimitationWhere>;
  newCode?: InputMaybe<Scalars['String']['input']>;
  newCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  newCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  newCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  newCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  packVolume?: InputMaybe<Scalars['String']['input']>;
  packVolumeUoMType?: InputMaybe<PackVolumeUoMType>;
  packVolumeUoMType_IN?: InputMaybe<Array<InputMaybe<PackVolumeUoMType>>>;
  packVolume_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  packVolume_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  packVolume_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  packVolume_MATCHES?: InputMaybe<Scalars['String']['input']>;
  packVolume_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pricesAggregate?: InputMaybe<TreatmentPricesAggregateInput>;
  /** Return Treatments where all of the related TreatmentPricesConnections match this filter */
  pricesConnection_ALL?: InputMaybe<TreatmentPricesConnectionWhere>;
  /** Return Treatments where none of the related TreatmentPricesConnections match this filter */
  pricesConnection_NONE?: InputMaybe<TreatmentPricesConnectionWhere>;
  /** Return Treatments where one of the related TreatmentPricesConnections match this filter */
  pricesConnection_SINGLE?: InputMaybe<TreatmentPricesConnectionWhere>;
  /** Return Treatments where some of the related TreatmentPricesConnections match this filter */
  pricesConnection_SOME?: InputMaybe<TreatmentPricesConnectionWhere>;
  /** Return Treatments where all of the related Prices match this filter */
  prices_ALL?: InputMaybe<PriceWhere>;
  /** Return Treatments where none of the related Prices match this filter */
  prices_NONE?: InputMaybe<PriceWhere>;
  /** Return Treatments where one of the related Prices match this filter */
  prices_SINGLE?: InputMaybe<PriceWhere>;
  /** Return Treatments where some of the related Prices match this filter */
  prices_SOME?: InputMaybe<PriceWhere>;
  regulatedBy?: InputMaybe<PreparationWhere>;
  regulatedByAggregate?: InputMaybe<TreatmentRegulatedByAggregateInput>;
  regulatedByConnection?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
  regulatedByConnection_NOT?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
  regulatedBy_NOT?: InputMaybe<PreparationWhere>;
  uoMType?: InputMaybe<UoMType>;
  uoMType_IN?: InputMaybe<Array<InputMaybe<UoMType>>>;
};

export type TreatmentsConnection = {
  __typename?: 'TreatmentsConnection';
  edges: Array<TreatmentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum UnitedResponseType {
  CompleteResponse = 'COMPLETE_RESPONSE',
  GoodResponse = 'GOOD_RESPONSE',
  MajorResponse = 'MAJOR_RESPONSE',
  MinorResponse = 'MINOR_RESPONSE',
  NoInfo = 'NO_INFO',
  NoPcr = 'NO_PCR',
  PartialResponse = 'PARTIAL_RESPONSE',
  PathologicalCompleteResponse = 'PATHOLOGICAL_COMPLETE_RESPONSE',
  ProgressiveDisease = 'PROGRESSIVE_DISEASE',
  StableDisease = 'STABLE_DISEASE'
}

export enum UoMType {
  Cur = 'CUR',
  Gram = 'GRAM',
  Milligram = 'MILLIGRAM',
  Millilitre = 'MILLILITRE',
  Pack = 'PACK'
}

export type UpdateCustomConditionInput = {
  attribute: CustomConditionAttributeInput;
  conditionType: CustomConditionType;
  description?: InputMaybe<Scalars['String']['input']>;
  fieldType: CustomConditionFieldType;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<CustomConclusiveConditionDropdownOptionInput>>;
};

export type UpdateIndicationInput = {
  code: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  intent?: InputMaybe<Scalars['String']['input']>;
  intentLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  line?: InputMaybe<Scalars['String']['input']>;
  lineLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  mutation?: InputMaybe<Scalars['String']['input']>;
  mutationLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  replacementIndicationId?: InputMaybe<Scalars['ID']['input']>;
  translations: Array<TranslationInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  typeLocalizationKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMissingKeyInput = {
  key: Scalars['String']['input'];
  language: Scalars['String']['input'];
  selectedEnvironments: Array<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type UpdateTranslationPayload = {
  body_de?: InputMaybe<Scalars['String']['input']>;
  body_en?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  params_environment: Scalars['String']['input'];
  params_languages: Array<Scalars['String']['input']>;
  params_tenantId: Scalars['String']['input'];
};

export type Upload = {
  __typename?: 'Upload';
  flexEntities: Array<FlexEntity>;
  flexEntitiesAggregate?: Maybe<UploadFlexEntityFlexEntitiesAggregationSelection>;
  flexEntitiesConnection: UploadFlexEntitiesConnection;
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
};


export type UploadFlexEntitiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type UploadFlexEntitiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type UploadFlexEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UploadFlexEntitiesConnectionSort>>;
  where?: InputMaybe<UploadFlexEntitiesConnectionWhere>;
};

export type UploadEdge = {
  __typename?: 'UploadEdge';
  cursor: Scalars['String']['output'];
  node: Upload;
};

export type UploadFlexEntitiesAggregateInput = {
  AND?: InputMaybe<Array<UploadFlexEntitiesAggregateInput>>;
  NOT?: InputMaybe<UploadFlexEntitiesAggregateInput>;
  OR?: InputMaybe<Array<UploadFlexEntitiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UploadFlexEntitiesNodeAggregationWhereInput>;
};

export type UploadFlexEntitiesConnection = {
  __typename?: 'UploadFlexEntitiesConnection';
  edges: Array<UploadFlexEntitiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UploadFlexEntitiesConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type UploadFlexEntitiesConnectionWhere = {
  AND?: InputMaybe<Array<UploadFlexEntitiesConnectionWhere>>;
  NOT?: InputMaybe<UploadFlexEntitiesConnectionWhere>;
  OR?: InputMaybe<Array<UploadFlexEntitiesConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type UploadFlexEntitiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UploadFlexEntitiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UploadFlexEntitiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UploadFlexEntitiesNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFlexEntitiesRelationship = {
  __typename?: 'UploadFlexEntitiesRelationship';
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type UploadFlexEntityFlexEntitiesAggregationSelection = {
  __typename?: 'UploadFlexEntityFlexEntitiesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UploadFlexEntityFlexEntitiesNodeAggregateSelection>;
};

export type UploadFlexEntityFlexEntitiesNodeAggregateSelection = {
  __typename?: 'UploadFlexEntityFlexEntitiesNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type UploadLimitation = {
  __typename?: 'UploadLimitation';
  entityType: FlexContainerType;
  maxItems: Scalars['Int']['output'];
  updatedBy?: Maybe<User>;
  updatedByAggregate?: Maybe<UploadLimitationUserUpdatedByAggregationSelection>;
  updatedByConnection: UploadLimitationUpdatedByConnection;
};


export type UploadLimitationUpdatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type UploadLimitationUpdatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type UploadLimitationUpdatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UploadLimitationUpdatedByConnectionSort>>;
  where?: InputMaybe<UploadLimitationUpdatedByConnectionWhere>;
};

export type UploadLimitationEdge = {
  __typename?: 'UploadLimitationEdge';
  cursor: Scalars['String']['output'];
  node: UploadLimitation;
};

export type UploadLimitationInput = {
  entityType: FlexContainerType;
  maxItems: Scalars['Int']['input'];
};

export type UploadLimitationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UploadLimitationSort objects to sort UploadLimitations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UploadLimitationSort>>;
};

/** Fields to sort UploadLimitations by. The order in which sorts are applied is not guaranteed when specifying many fields in one UploadLimitationSort object. */
export type UploadLimitationSort = {
  entityType?: InputMaybe<SortDirection>;
  maxItems?: InputMaybe<SortDirection>;
};

export type UploadLimitationUpdatedByAggregateInput = {
  AND?: InputMaybe<Array<UploadLimitationUpdatedByAggregateInput>>;
  NOT?: InputMaybe<UploadLimitationUpdatedByAggregateInput>;
  OR?: InputMaybe<Array<UploadLimitationUpdatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UploadLimitationUpdatedByEdgeAggregationWhereInput>;
  node?: InputMaybe<UploadLimitationUpdatedByNodeAggregationWhereInput>;
};

export type UploadLimitationUpdatedByConnection = {
  __typename?: 'UploadLimitationUpdatedByConnection';
  edges: Array<UploadLimitationUpdatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UploadLimitationUpdatedByConnectionSort = {
  edge?: InputMaybe<UploadLimitationUpdaterRelationshipSort>;
  node?: InputMaybe<UserSort>;
};

export type UploadLimitationUpdatedByConnectionWhere = {
  AND?: InputMaybe<Array<UploadLimitationUpdatedByConnectionWhere>>;
  NOT?: InputMaybe<UploadLimitationUpdatedByConnectionWhere>;
  OR?: InputMaybe<Array<UploadLimitationUpdatedByConnectionWhere>>;
  edge?: InputMaybe<UploadLimitationUpdaterRelationshipWhere>;
  node?: InputMaybe<UserWhere>;
};

export type UploadLimitationUpdatedByEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<UploadLimitationUpdatedByEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<UploadLimitationUpdatedByEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<UploadLimitationUpdatedByEdgeAggregationWhereInput>>;
  setOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UploadLimitationUpdatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UploadLimitationUpdatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UploadLimitationUpdatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UploadLimitationUpdatedByNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  role_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  role_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  role_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadLimitationUpdatedByRelationship = UploadLimitationUpdaterRelationship & {
  __typename?: 'UploadLimitationUpdatedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  setOn: Scalars['DateTime']['output'];
};

export type UploadLimitationUpdaterRelationship = {
  setOn: Scalars['DateTime']['output'];
};

export type UploadLimitationUpdaterRelationshipSort = {
  setOn?: InputMaybe<SortDirection>;
};

export type UploadLimitationUpdaterRelationshipWhere = {
  AND?: InputMaybe<Array<UploadLimitationUpdaterRelationshipWhere>>;
  NOT?: InputMaybe<UploadLimitationUpdaterRelationshipWhere>;
  OR?: InputMaybe<Array<UploadLimitationUpdaterRelationshipWhere>>;
  setOn?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  setOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UploadLimitationUserUpdatedByAggregationSelection = {
  __typename?: 'UploadLimitationUserUpdatedByAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UploadLimitationUserUpdatedByEdgeAggregateSelection>;
  node?: Maybe<UploadLimitationUserUpdatedByNodeAggregateSelection>;
};

export type UploadLimitationUserUpdatedByEdgeAggregateSelection = {
  __typename?: 'UploadLimitationUserUpdatedByEdgeAggregateSelection';
  setOn: DateTimeAggregateSelectionNonNullable;
};

export type UploadLimitationUserUpdatedByNodeAggregateSelection = {
  __typename?: 'UploadLimitationUserUpdatedByNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
  phoneNumber: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type UploadLimitationWhere = {
  AND?: InputMaybe<Array<UploadLimitationWhere>>;
  NOT?: InputMaybe<UploadLimitationWhere>;
  OR?: InputMaybe<Array<UploadLimitationWhere>>;
  entityType?: InputMaybe<FlexContainerType>;
  entityType_IN?: InputMaybe<Array<FlexContainerType>>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  maxItems_GT?: InputMaybe<Scalars['Int']['input']>;
  maxItems_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxItems_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxItems_LT?: InputMaybe<Scalars['Int']['input']>;
  maxItems_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<UserWhere>;
  updatedByAggregate?: InputMaybe<UploadLimitationUpdatedByAggregateInput>;
  updatedByConnection?: InputMaybe<UploadLimitationUpdatedByConnectionWhere>;
  updatedByConnection_NOT?: InputMaybe<UploadLimitationUpdatedByConnectionWhere>;
  updatedBy_NOT?: InputMaybe<UserWhere>;
};

export type UploadLimitationsConnection = {
  __typename?: 'UploadLimitationsConnection';
  edges: Array<UploadLimitationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UploadOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UploadSort objects to sort Uploads by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UploadSort>>;
};

/** Fields to sort Uploads by. The order in which sorts are applied is not guaranteed when specifying many fields in one UploadSort object. */
export type UploadSort = {
  id?: InputMaybe<SortDirection>;
  timestamp?: InputMaybe<SortDirection>;
};

export type UploadState = {
  __typename?: 'UploadState';
  error?: Maybe<Scalars['String']['output']>;
  impact?: Maybe<Array<ImpactItem>>;
  impactedAgreementIds?: Maybe<Array<Scalars['String']['output']>>;
  isFinalizing: Scalars['Boolean']['output'];
  isFinished: Scalars['Boolean']['output'];
  isRewrite: Scalars['Boolean']['output'];
  isTranslate: Scalars['Boolean']['output'];
  progress: Scalars['Int']['output'];
  stateDescription?: Maybe<Scalars['String']['output']>;
};

export type UploadStateEdge = {
  __typename?: 'UploadStateEdge';
  cursor: Scalars['String']['output'];
  node: UploadState;
};

export type UploadStateOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UploadStateSort objects to sort UploadStates by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UploadStateSort>>;
};

/** Fields to sort UploadStates by. The order in which sorts are applied is not guaranteed when specifying many fields in one UploadStateSort object. */
export type UploadStateSort = {
  error?: InputMaybe<SortDirection>;
  isFinalizing?: InputMaybe<SortDirection>;
  isFinished?: InputMaybe<SortDirection>;
  isRewrite?: InputMaybe<SortDirection>;
  isTranslate?: InputMaybe<SortDirection>;
  progress?: InputMaybe<SortDirection>;
  stateDescription?: InputMaybe<SortDirection>;
};

export type UploadStateWhere = {
  AND?: InputMaybe<Array<UploadStateWhere>>;
  NOT?: InputMaybe<UploadStateWhere>;
  OR?: InputMaybe<Array<UploadStateWhere>>;
  error?: InputMaybe<Scalars['String']['input']>;
  error_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  error_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  error_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  error_MATCHES?: InputMaybe<Scalars['String']['input']>;
  error_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  impactedAgreementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  impactedAgreementIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  isFinalizing?: InputMaybe<Scalars['Boolean']['input']>;
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  isRewrite?: InputMaybe<Scalars['Boolean']['input']>;
  isTranslate?: InputMaybe<Scalars['Boolean']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  progress_GT?: InputMaybe<Scalars['Int']['input']>;
  progress_GTE?: InputMaybe<Scalars['Int']['input']>;
  progress_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  progress_LT?: InputMaybe<Scalars['Int']['input']>;
  progress_LTE?: InputMaybe<Scalars['Int']['input']>;
  stateDescription?: InputMaybe<Scalars['String']['input']>;
  stateDescription_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  stateDescription_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  stateDescription_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stateDescription_MATCHES?: InputMaybe<Scalars['String']['input']>;
  stateDescription_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type UploadStatesConnection = {
  __typename?: 'UploadStatesConnection';
  edges: Array<UploadStateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UploadWhere = {
  AND?: InputMaybe<Array<UploadWhere>>;
  NOT?: InputMaybe<UploadWhere>;
  OR?: InputMaybe<Array<UploadWhere>>;
  flexEntitiesAggregate?: InputMaybe<UploadFlexEntitiesAggregateInput>;
  /** Return Uploads where all of the related UploadFlexEntitiesConnections match this filter */
  flexEntitiesConnection_ALL?: InputMaybe<UploadFlexEntitiesConnectionWhere>;
  /** Return Uploads where none of the related UploadFlexEntitiesConnections match this filter */
  flexEntitiesConnection_NONE?: InputMaybe<UploadFlexEntitiesConnectionWhere>;
  /** Return Uploads where one of the related UploadFlexEntitiesConnections match this filter */
  flexEntitiesConnection_SINGLE?: InputMaybe<UploadFlexEntitiesConnectionWhere>;
  /** Return Uploads where some of the related UploadFlexEntitiesConnections match this filter */
  flexEntitiesConnection_SOME?: InputMaybe<UploadFlexEntitiesConnectionWhere>;
  /** Return Uploads where all of the related FlexEntities match this filter */
  flexEntities_ALL?: InputMaybe<FlexEntityWhere>;
  /** Return Uploads where none of the related FlexEntities match this filter */
  flexEntities_NONE?: InputMaybe<FlexEntityWhere>;
  /** Return Uploads where one of the related FlexEntities match this filter */
  flexEntities_SINGLE?: InputMaybe<FlexEntityWhere>;
  /** Return Uploads where some of the related FlexEntities match this filter */
  flexEntities_SOME?: InputMaybe<FlexEntityWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  timestamp_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UploadsConnection = {
  __typename?: 'UploadsConnection';
  edges: Array<UploadEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  domains: Array<Domain>;
  domainsAggregate?: Maybe<UserDomainDomainsAggregationSelection>;
  domainsConnection: UserDomainsConnection;
  email: Scalars['String']['output'];
  emailConfirmed?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isGuest?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Organization>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  subscribedToNotifications?: Maybe<Scalars['Boolean']['output']>;
  tenantId: Scalars['ID']['output'];
};


export type UserDomainsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DomainOptions>;
  where?: InputMaybe<DomainWhere>;
};


export type UserDomainsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DomainWhere>;
};


export type UserDomainsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserDomainsConnectionSort>>;
  where?: InputMaybe<UserDomainsConnectionWhere>;
};

export type UserAssignDomainsInput = {
  domainIds: Array<Scalars['String']['input']>;
  orgId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserAvailableEntryModule = {
  __typename?: 'UserAvailableEntryModule';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type UserAvailableEntryModuleEdge = {
  __typename?: 'UserAvailableEntryModuleEdge';
  cursor: Scalars['String']['output'];
  node: UserAvailableEntryModule;
};

export type UserAvailableEntryModuleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserAvailableEntryModuleSort objects to sort UserAvailableEntryModules by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserAvailableEntryModuleSort>>;
};

/** Fields to sort UserAvailableEntryModules by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserAvailableEntryModuleSort object. */
export type UserAvailableEntryModuleSort = {
  code?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
};

export type UserAvailableEntryModuleWhere = {
  AND?: InputMaybe<Array<UserAvailableEntryModuleWhere>>;
  NOT?: InputMaybe<UserAvailableEntryModuleWhere>;
  OR?: InputMaybe<Array<UserAvailableEntryModuleWhere>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_GT?: InputMaybe<Scalars['Int']['input']>;
  id_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type UserAvailableEntryModulesConnection = {
  __typename?: 'UserAvailableEntryModulesConnection';
  edges: Array<UserAvailableEntryModuleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserContext = {
  __typename?: 'UserContext';
  email: Scalars['String']['output'];
  filtersAgreements?: Maybe<Scalars['String']['output']>;
  filtersCustomConditions?: Maybe<Scalars['String']['output']>;
  filtersModels?: Maybe<Scalars['String']['output']>;
};

export type UserContextEdge = {
  __typename?: 'UserContextEdge';
  cursor: Scalars['String']['output'];
  node: UserContext;
};

export type UserContextOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserContextSort objects to sort UserContexts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserContextSort>>;
};

/** Fields to sort UserContexts by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserContextSort object. */
export type UserContextSort = {
  email?: InputMaybe<SortDirection>;
  filtersAgreements?: InputMaybe<SortDirection>;
  filtersCustomConditions?: InputMaybe<SortDirection>;
  filtersModels?: InputMaybe<SortDirection>;
};

export type UserContextWhere = {
  AND?: InputMaybe<Array<UserContextWhere>>;
  NOT?: InputMaybe<UserContextWhere>;
  OR?: InputMaybe<Array<UserContextWhere>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersAgreements?: InputMaybe<Scalars['String']['input']>;
  filtersAgreements_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filtersAgreements_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersAgreements_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filtersAgreements_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filtersAgreements_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersCustomConditions?: InputMaybe<Scalars['String']['input']>;
  filtersCustomConditions_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filtersCustomConditions_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersCustomConditions_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filtersCustomConditions_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filtersCustomConditions_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersModels?: InputMaybe<Scalars['String']['input']>;
  filtersModels_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filtersModels_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersModels_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filtersModels_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filtersModels_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type UserContextsConnection = {
  __typename?: 'UserContextsConnection';
  edges: Array<UserContextEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserDomainDomainsAggregationSelection = {
  __typename?: 'UserDomainDomainsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserDomainDomainsNodeAggregateSelection>;
};

export type UserDomainDomainsNodeAggregateSelection = {
  __typename?: 'UserDomainDomainsNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  level: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type UserDomainsAggregateInput = {
  AND?: InputMaybe<Array<UserDomainsAggregateInput>>;
  NOT?: InputMaybe<UserDomainsAggregateInput>;
  OR?: InputMaybe<Array<UserDomainsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserDomainsNodeAggregationWhereInput>;
};

export type UserDomainsConnection = {
  __typename?: 'UserDomainsConnection';
  edges: Array<UserDomainsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserDomainsConnectionSort = {
  node?: InputMaybe<DomainSort>;
};

export type UserDomainsConnectionWhere = {
  AND?: InputMaybe<Array<UserDomainsConnectionWhere>>;
  NOT?: InputMaybe<UserDomainsConnectionWhere>;
  OR?: InputMaybe<Array<UserDomainsConnectionWhere>>;
  node?: InputMaybe<DomainWhere>;
};

export type UserDomainsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserDomainsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserDomainsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserDomainsNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  level_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  level_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserDomainsRelationship = {
  __typename?: 'UserDomainsRelationship';
  cursor: Scalars['String']['output'];
  node: Domain;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserInput = {
  domains?: InputMaybe<Array<Scalars['ID']['input']>>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locked: Scalars['Boolean']['input'];
  modules: Array<InputMaybe<ModuleInput>>;
  organization: OrganizationInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  role: Roles;
  subscribedToNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserSort objects to sort Users by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserSort>>;
};

export type UserOrgSettingsData = {
  __typename?: 'UserOrgSettingsData';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasOperativeDataAccess?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserOrgSettingsDataConnection = {
  __typename?: 'UserOrgSettingsDataConnection';
  edges: Array<UserOrgSettingsDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserOrgSettingsDataEdge = {
  __typename?: 'UserOrgSettingsDataEdge';
  cursor: Scalars['String']['output'];
  node: UserOrgSettingsData;
};

export type UserOrgSettingsDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserOrgSettingsDataSort objects to sort UserOrgSettingsData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserOrgSettingsDataSort>>;
};

/** Fields to sort UserOrgSettingsData by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserOrgSettingsDataSort object. */
export type UserOrgSettingsDataSort = {
  email?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  hasOperativeDataAccess?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  userId?: InputMaybe<SortDirection>;
};

export type UserOrgSettingsDataWhere = {
  AND?: InputMaybe<Array<UserOrgSettingsDataWhere>>;
  NOT?: InputMaybe<UserOrgSettingsDataWhere>;
  OR?: InputMaybe<Array<UserOrgSettingsDataWhere>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hasOperativeDataAccess?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  role_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  role_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  role_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role_MATCHES?: InputMaybe<Scalars['String']['input']>;
  role_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type UserOrganizationInfo = {
  __typename?: 'UserOrganizationInfo';
  defaultAgreementUserRoles: Array<AgreementUserRole>;
  email: Scalars['String']['output'];
  enabledEntryModules: Array<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type UserOrganizationInfoEdge = {
  __typename?: 'UserOrganizationInfoEdge';
  cursor: Scalars['String']['output'];
  node: UserOrganizationInfo;
};

export type UserOrganizationInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserOrganizationInfoSort objects to sort UserOrganizationInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserOrganizationInfoSort>>;
};

/** Fields to sort UserOrganizationInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserOrganizationInfoSort object. */
export type UserOrganizationInfoSort = {
  email?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
};

export type UserOrganizationInfoWhere = {
  AND?: InputMaybe<Array<UserOrganizationInfoWhere>>;
  NOT?: InputMaybe<UserOrganizationInfoWhere>;
  OR?: InputMaybe<Array<UserOrganizationInfoWhere>>;
  defaultAgreementUserRoles?: InputMaybe<Array<AgreementUserRole>>;
  defaultAgreementUserRoles_INCLUDES?: InputMaybe<AgreementUserRole>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  enabledEntryModules?: InputMaybe<Array<Scalars['String']['input']>>;
  enabledEntryModules_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type UserOrganizationInfosConnection = {
  __typename?: 'UserOrganizationInfosConnection';
  edges: Array<UserOrganizationInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserRoleRequestUpdateInput = {
  agreementId: Scalars['String']['input'];
  agreementName: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Fields to sort Users by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserSort object. */
export type UserSort = {
  email?: InputMaybe<SortDirection>;
  emailConfirmed?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isGuest?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  locked?: InputMaybe<SortDirection>;
  phoneNumber?: InputMaybe<SortDirection>;
  preferredLanguage?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  subscribedToNotifications?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
};

export type UserWhere = {
  AND?: InputMaybe<Array<UserWhere>>;
  NOT?: InputMaybe<UserWhere>;
  OR?: InputMaybe<Array<UserWhere>>;
  domainsAggregate?: InputMaybe<UserDomainsAggregateInput>;
  /** Return Users where all of the related UserDomainsConnections match this filter */
  domainsConnection_ALL?: InputMaybe<UserDomainsConnectionWhere>;
  /** Return Users where none of the related UserDomainsConnections match this filter */
  domainsConnection_NONE?: InputMaybe<UserDomainsConnectionWhere>;
  /** Return Users where one of the related UserDomainsConnections match this filter */
  domainsConnection_SINGLE?: InputMaybe<UserDomainsConnectionWhere>;
  /** Return Users where some of the related UserDomainsConnections match this filter */
  domainsConnection_SOME?: InputMaybe<UserDomainsConnectionWhere>;
  /** Return Users where all of the related Domains match this filter */
  domains_ALL?: InputMaybe<DomainWhere>;
  /** Return Users where none of the related Domains match this filter */
  domains_NONE?: InputMaybe<DomainWhere>;
  /** Return Users where one of the related Domains match this filter */
  domains_SINGLE?: InputMaybe<DomainWhere>;
  /** Return Users where some of the related Domains match this filter */
  domains_SOME?: InputMaybe<DomainWhere>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isGuest?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phoneNumber_MATCHES?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferredLanguage_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  role_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  role_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  role_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role_MATCHES?: InputMaybe<Scalars['String']['input']>;
  role_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subscribedToNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type UsersConnection = {
  __typename?: 'UsersConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VasProductBlueprintInput = {
  domainIds?: InputMaybe<Array<Scalars['String']['input']>>;
  formValues: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  indication: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  productName: Scalars['String']['input'];
  status: Scalars['String']['input'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;


/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  ActionPrescriptionRelationship: ( ScenarioActionBrandsRelationship ) | ( ScenarioActionGenericsRelationship ) | ( ScenarioActionTreatmentsRelationship );
  AgreementCounterpartyRelationship: ( AgreementCounterpartiesRelationship );
  AgreementFinancialSummaryColumnRelationship: ( AgreementFinancialSummaryConfigRelationship ) | ( AgreementTemplateFinancialSummaryConfigRelationship ) | ( BaseAgreementFinancialSummaryConfigRelationship );
  AgreementScopeRelationship: ( EnrollingConditionSetScopesRelationship );
  AgreementTagUserRoleRelationship: ( AgreementTagDefaultUserRolesRelationship );
  AgreementTemplateEligibilityConditionRelationship: ( AgreementEligibilityConditionSetsRelationship ) | ( AgreementTemplateEligibilityConditionSetsRelationship );
  AgreementTemplateTreatmentPriceRelationship: ( AgreementTemplateTreatmentPricesRelationship );
  AgreementTreatmentPriceRelationship: ( AgreementTreatmentPricesRelationship );
  AgreementUserRoleRelationship: ( AgreementUserRolesRelationship );
  BaseAgreementCounterpartyRelationship: ( BaseAgreementCounterpartiesRelationship );
  BaseAgreementEligibilityConditionRelationship: ( BaseAgreementEligibilityConditionSetsRelationship );
  BaseAgreementTreatmentPriceRelationship: ( BaseAgreementTreatmentPricesRelationship );
  BaseAgreementUserRoleRelationship: ( BaseAgreementUserRolesRelationship );
  CaseFlexEntityRelationship: ( CaseFlexEntitiesRelationship ) | ( FlexEntityCasesRelationship );
  ChartRangeConfigurationRelationship: ( AgreementRangeChartConfigRelationship ) | ( AgreementTemplateRangeChartConfigRelationship ) | ( BaseAgreementRangeChartConfigRelationship );
  CountryScopeRelationship: ( AgreementScopeCountryScopesRelationship ) | ( CountryScopesRelationship );
  DefaultReceiverProperties: ( OrganizationDefaultReceiversRelationship );
  DependencyAttribute: ( CatalogueAttributeDependsOnRelationship ) | ( CatalogueAttributeHasDependantRelationship ) | ( CatalogueAttributeMutuallyRelevantRelationship );
  DocumentRefundFinancialDataPoint: ( RefundDocumentFinancialDataPointRelationship );
  EnrollingConditionDiseaseRelationship: ( AgreementScopeDiseasesRelationship );
  EnrollingConditionSetRelationship: ( AgreementEnrollingConditionSetsRelationship );
  EntityTypeMappingRelationship: ( FlexEntityTypeMappingInstancesRelationship ) | ( OrganizationFlexEntityTypeMappingsRelationship );
  FlexEntityTypeCatalogueAttributeRelationship: ( CatalogueAttributeFlexEntityTypesRelationship ) | ( FlexEntityTypeCatalogueAttributesRelationship );
  ITimeframe: ( ScenarioAction ) | ( ScenarioCondition );
  ITreatmentCondition: ( ScenarioCondition );
  OrganizationQuestRelationship: ( OrganizationQuestNotificationsRelationship ) | ( QuestNotificationSubscribedRelationship );
  OrganizationScopeRelationship: ( AgreementScopeOrganizationScopesRelationship );
  RunCheckValuesWithTypeRelationship: ( RunCheckValuesCheckRelationship ) | ( RunCheckValuesRelationship );
  ScenarioInsightsUserContext: ( BaseAgreementUserContextsRelationship );
  SimulatorUserRoleRelationship: ( SimulationAccessibleUsersRelationship );
  ThresholdConfigurationRelationship: ( AgreementDotThresholdsRelationship ) | ( AgreementTemplateDotThresholdsRelationship ) | ( BaseAgreementDotThresholdsRelationship );
  UploadLimitationUpdaterRelationship: ( UploadLimitationUpdatedByRelationship );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  ActionItemCombinationRelation: ActionItemCombinationRelation;
  ActionItemCombinationRule: ActionItemCombinationRule;
  ActionItemRangeType: ActionItemRangeType;
  ActionLogicalOperator: ActionLogicalOperator;
  ActionPrescriptionRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ActionPrescriptionRelationship']>;
  ActionPrescriptionRelationshipSort: ActionPrescriptionRelationshipSort;
  ActionPrescriptionRelationshipWhere: ActionPrescriptionRelationshipWhere;
  ActionSetsOperator: ActionSetsOperator;
  ActionType: ActionType;
  ActiveUserSession: ResolverTypeWrapper<ActiveUserSession>;
  ActiveUserSessionEdge: ResolverTypeWrapper<ActiveUserSessionEdge>;
  ActiveUserSessionOptions: ActiveUserSessionOptions;
  ActiveUserSessionSort: ActiveUserSessionSort;
  ActiveUserSessionWhere: ActiveUserSessionWhere;
  ActiveUserSessionsConnection: ResolverTypeWrapper<ActiveUserSessionsConnection>;
  AdverseEventGrades: AdverseEventGrades;
  AdverseEventType: AdverseEventType;
  Agreement: ResolverTypeWrapper<Agreement>;
  AgreementAddedByAggregateInput: AgreementAddedByAggregateInput;
  AgreementAddedByConnection: ResolverTypeWrapper<AgreementAddedByConnection>;
  AgreementAddedByConnectionSort: AgreementAddedByConnectionSort;
  AgreementAddedByConnectionWhere: AgreementAddedByConnectionWhere;
  AgreementAddedByNodeAggregationWhereInput: AgreementAddedByNodeAggregationWhereInput;
  AgreementAddedByRelationship: ResolverTypeWrapper<AgreementAddedByRelationship>;
  AgreementAgreementInitialVersionAggregationSelection: ResolverTypeWrapper<AgreementAgreementInitialVersionAggregationSelection>;
  AgreementAgreementInitialVersionNodeAggregateSelection: ResolverTypeWrapper<AgreementAgreementInitialVersionNodeAggregateSelection>;
  AgreementAgreementNextVersionsAggregationSelection: ResolverTypeWrapper<AgreementAgreementNextVersionsAggregationSelection>;
  AgreementAgreementNextVersionsNodeAggregateSelection: ResolverTypeWrapper<AgreementAgreementNextVersionsNodeAggregateSelection>;
  AgreementAgreementTagTagsAggregationSelection: ResolverTypeWrapper<AgreementAgreementTagTagsAggregationSelection>;
  AgreementAgreementTagTagsNodeAggregateSelection: ResolverTypeWrapper<AgreementAgreementTagTagsNodeAggregateSelection>;
  AgreementAgreementTemplateTemplateAggregationSelection: ResolverTypeWrapper<AgreementAgreementTemplateTemplateAggregationSelection>;
  AgreementAgreementTemplateTemplateNodeAggregateSelection: ResolverTypeWrapper<AgreementAgreementTemplateTemplateNodeAggregateSelection>;
  AgreementBrandScenariosRelevantBrandsAggregationSelection: ResolverTypeWrapper<AgreementBrandScenariosRelevantBrandsAggregationSelection>;
  AgreementBrandScenariosRelevantBrandsNodeAggregateSelection: ResolverTypeWrapper<AgreementBrandScenariosRelevantBrandsNodeAggregateSelection>;
  AgreementCatalogueAttributeNegotiableAttributesAggregationSelection: ResolverTypeWrapper<AgreementCatalogueAttributeNegotiableAttributesAggregationSelection>;
  AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection: ResolverTypeWrapper<AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection>;
  AgreementChartRangeConfigurationDotThresholdsAggregationSelection: ResolverTypeWrapper<AgreementChartRangeConfigurationDotThresholdsAggregationSelection>;
  AgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection: ResolverTypeWrapper<AgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection>;
  AgreementChartRangeConfigurationRangeChartConfigAggregationSelection: ResolverTypeWrapper<AgreementChartRangeConfigurationRangeChartConfigAggregationSelection>;
  AgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection: ResolverTypeWrapper<AgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection>;
  AgreementCounterpartiesAggregateInput: AgreementCounterpartiesAggregateInput;
  AgreementCounterpartiesConnection: ResolverTypeWrapper<AgreementCounterpartiesConnection>;
  AgreementCounterpartiesConnectionSort: AgreementCounterpartiesConnectionSort;
  AgreementCounterpartiesConnectionWhere: AgreementCounterpartiesConnectionWhere;
  AgreementCounterpartiesNodeAggregationWhereInput: AgreementCounterpartiesNodeAggregationWhereInput;
  AgreementCounterpartiesRelationship: ResolverTypeWrapper<AgreementCounterpartiesRelationship>;
  AgreementCounterpartyInput: AgreementCounterpartyInput;
  AgreementCounterpartyRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AgreementCounterpartyRelationship']>;
  AgreementCounterpartyRelationshipSort: AgreementCounterpartyRelationshipSort;
  AgreementCounterpartyRelationshipWhere: AgreementCounterpartyRelationshipWhere;
  AgreementCountryAggregateInput: AgreementCountryAggregateInput;
  AgreementCountryConnection: ResolverTypeWrapper<AgreementCountryConnection>;
  AgreementCountryConnectionSort: AgreementCountryConnectionSort;
  AgreementCountryConnectionWhere: AgreementCountryConnectionWhere;
  AgreementCountryCountryAggregationSelection: ResolverTypeWrapper<AgreementCountryCountryAggregationSelection>;
  AgreementCountryCountryNodeAggregateSelection: ResolverTypeWrapper<AgreementCountryCountryNodeAggregateSelection>;
  AgreementCountryNodeAggregationWhereInput: AgreementCountryNodeAggregationWhereInput;
  AgreementCountryRelationship: ResolverTypeWrapper<AgreementCountryRelationship>;
  AgreementCurrencyAggregateInput: AgreementCurrencyAggregateInput;
  AgreementCurrencyConnection: ResolverTypeWrapper<AgreementCurrencyConnection>;
  AgreementCurrencyConnectionSort: AgreementCurrencyConnectionSort;
  AgreementCurrencyConnectionWhere: AgreementCurrencyConnectionWhere;
  AgreementCurrencyCurrencyAggregationSelection: ResolverTypeWrapper<AgreementCurrencyCurrencyAggregationSelection>;
  AgreementCurrencyCurrencyNodeAggregateSelection: ResolverTypeWrapper<AgreementCurrencyCurrencyNodeAggregateSelection>;
  AgreementCurrencyNodeAggregationWhereInput: AgreementCurrencyNodeAggregationWhereInput;
  AgreementCurrencyRelationship: ResolverTypeWrapper<AgreementCurrencyRelationship>;
  AgreementCycleConfigurationCyclesAggregationSelection: ResolverTypeWrapper<AgreementCycleConfigurationCyclesAggregationSelection>;
  AgreementCycleConfigurationCyclesNodeAggregateSelection: ResolverTypeWrapper<AgreementCycleConfigurationCyclesNodeAggregateSelection>;
  AgreementCyclesAggregateInput: AgreementCyclesAggregateInput;
  AgreementCyclesConnection: ResolverTypeWrapper<AgreementCyclesConnection>;
  AgreementCyclesConnectionSort: AgreementCyclesConnectionSort;
  AgreementCyclesConnectionWhere: AgreementCyclesConnectionWhere;
  AgreementCyclesNodeAggregationWhereInput: AgreementCyclesNodeAggregationWhereInput;
  AgreementCyclesRelationship: ResolverTypeWrapper<AgreementCyclesRelationship>;
  AgreementDataContainerDataContainersAggregationSelection: ResolverTypeWrapper<AgreementDataContainerDataContainersAggregationSelection>;
  AgreementDataContainerDataContainersNodeAggregateSelection: ResolverTypeWrapper<AgreementDataContainerDataContainersNodeAggregateSelection>;
  AgreementDataContainersAggregateInput: AgreementDataContainersAggregateInput;
  AgreementDataContainersConnection: ResolverTypeWrapper<AgreementDataContainersConnection>;
  AgreementDataContainersConnectionSort: AgreementDataContainersConnectionSort;
  AgreementDataContainersConnectionWhere: AgreementDataContainersConnectionWhere;
  AgreementDataContainersNodeAggregationWhereInput: AgreementDataContainersNodeAggregationWhereInput;
  AgreementDataContainersRelationship: ResolverTypeWrapper<AgreementDataContainersRelationship>;
  AgreementDataSourceAggregateInput: AgreementDataSourceAggregateInput;
  AgreementDataSourceConnection: ResolverTypeWrapper<AgreementDataSourceConnection>;
  AgreementDataSourceConnectionSort: AgreementDataSourceConnectionSort;
  AgreementDataSourceConnectionWhere: AgreementDataSourceConnectionWhere;
  AgreementDataSourceDataSourceAggregationSelection: ResolverTypeWrapper<AgreementDataSourceDataSourceAggregationSelection>;
  AgreementDataSourceDataSourceNodeAggregateSelection: ResolverTypeWrapper<AgreementDataSourceDataSourceNodeAggregateSelection>;
  AgreementDataSourceNodeAggregationWhereInput: AgreementDataSourceNodeAggregationWhereInput;
  AgreementDataSourceRelationship: ResolverTypeWrapper<AgreementDataSourceRelationship>;
  AgreementDecision: ResolverTypeWrapper<AgreementDecision>;
  AgreementDecisionAsOfAggregateInput: AgreementDecisionAsOfAggregateInput;
  AgreementDecisionAsOfConnection: ResolverTypeWrapper<AgreementDecisionAsOfConnection>;
  AgreementDecisionAsOfConnectionSort: AgreementDecisionAsOfConnectionSort;
  AgreementDecisionAsOfConnectionWhere: AgreementDecisionAsOfConnectionWhere;
  AgreementDecisionAsOfNodeAggregationWhereInput: AgreementDecisionAsOfNodeAggregationWhereInput;
  AgreementDecisionAsOfRelationship: ResolverTypeWrapper<AgreementDecisionAsOfRelationship>;
  AgreementDecisionEdge: ResolverTypeWrapper<AgreementDecisionEdge>;
  AgreementDecisionMadeByAggregateInput: AgreementDecisionMadeByAggregateInput;
  AgreementDecisionMadeByConnection: ResolverTypeWrapper<AgreementDecisionMadeByConnection>;
  AgreementDecisionMadeByConnectionSort: AgreementDecisionMadeByConnectionSort;
  AgreementDecisionMadeByConnectionWhere: AgreementDecisionMadeByConnectionWhere;
  AgreementDecisionMadeByNodeAggregationWhereInput: AgreementDecisionMadeByNodeAggregationWhereInput;
  AgreementDecisionMadeByRelationship: ResolverTypeWrapper<AgreementDecisionMadeByRelationship>;
  AgreementDecisionOptions: AgreementDecisionOptions;
  AgreementDecisionOrganizationAsOfAggregationSelection: ResolverTypeWrapper<AgreementDecisionOrganizationAsOfAggregationSelection>;
  AgreementDecisionOrganizationAsOfNodeAggregateSelection: ResolverTypeWrapper<AgreementDecisionOrganizationAsOfNodeAggregateSelection>;
  AgreementDecisionSort: AgreementDecisionSort;
  AgreementDecisionUserMadeByAggregationSelection: ResolverTypeWrapper<AgreementDecisionUserMadeByAggregationSelection>;
  AgreementDecisionUserMadeByNodeAggregateSelection: ResolverTypeWrapper<AgreementDecisionUserMadeByNodeAggregateSelection>;
  AgreementDecisionWhere: AgreementDecisionWhere;
  AgreementDecisionsConnection: ResolverTypeWrapper<AgreementDecisionsConnection>;
  AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection: ResolverTypeWrapper<AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection>;
  AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection: ResolverTypeWrapper<AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection>;
  AgreementDeviceAlternativeSetsAggregateInput: AgreementDeviceAlternativeSetsAggregateInput;
  AgreementDeviceAlternativeSetsConnection: ResolverTypeWrapper<AgreementDeviceAlternativeSetsConnection>;
  AgreementDeviceAlternativeSetsConnectionSort: AgreementDeviceAlternativeSetsConnectionSort;
  AgreementDeviceAlternativeSetsConnectionWhere: AgreementDeviceAlternativeSetsConnectionWhere;
  AgreementDeviceAlternativeSetsNodeAggregationWhereInput: AgreementDeviceAlternativeSetsNodeAggregationWhereInput;
  AgreementDeviceAlternativeSetsRelationship: ResolverTypeWrapper<AgreementDeviceAlternativeSetsRelationship>;
  AgreementDotThresholdsAggregateInput: AgreementDotThresholdsAggregateInput;
  AgreementDotThresholdsConnection: ResolverTypeWrapper<AgreementDotThresholdsConnection>;
  AgreementDotThresholdsConnectionSort: AgreementDotThresholdsConnectionSort;
  AgreementDotThresholdsConnectionWhere: AgreementDotThresholdsConnectionWhere;
  AgreementDotThresholdsEdgeAggregationWhereInput: AgreementDotThresholdsEdgeAggregationWhereInput;
  AgreementDotThresholdsRelationship: ResolverTypeWrapper<AgreementDotThresholdsRelationship>;
  AgreementEdge: ResolverTypeWrapper<AgreementEdge>;
  AgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection: ResolverTypeWrapper<AgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection>;
  AgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection: ResolverTypeWrapper<AgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection>;
  AgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection: ResolverTypeWrapper<AgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection>;
  AgreementEligibilityConditionSetsAggregateInput: AgreementEligibilityConditionSetsAggregateInput;
  AgreementEligibilityConditionSetsConnection: ResolverTypeWrapper<AgreementEligibilityConditionSetsConnection>;
  AgreementEligibilityConditionSetsConnectionSort: AgreementEligibilityConditionSetsConnectionSort;
  AgreementEligibilityConditionSetsConnectionWhere: AgreementEligibilityConditionSetsConnectionWhere;
  AgreementEligibilityConditionSetsEdgeAggregationWhereInput: AgreementEligibilityConditionSetsEdgeAggregationWhereInput;
  AgreementEligibilityConditionSetsNodeAggregationWhereInput: AgreementEligibilityConditionSetsNodeAggregationWhereInput;
  AgreementEligibilityConditionSetsRelationship: ResolverTypeWrapper<AgreementEligibilityConditionSetsRelationship>;
  AgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection: ResolverTypeWrapper<AgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection>;
  AgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection: ResolverTypeWrapper<AgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection>;
  AgreementEnrollingConditionSetsAggregateInput: AgreementEnrollingConditionSetsAggregateInput;
  AgreementEnrollingConditionSetsConnection: ResolverTypeWrapper<AgreementEnrollingConditionSetsConnection>;
  AgreementEnrollingConditionSetsConnectionSort: AgreementEnrollingConditionSetsConnectionSort;
  AgreementEnrollingConditionSetsConnectionWhere: AgreementEnrollingConditionSetsConnectionWhere;
  AgreementEnrollingConditionSetsNodeAggregationWhereInput: AgreementEnrollingConditionSetsNodeAggregationWhereInput;
  AgreementEnrollingConditionSetsRelationship: ResolverTypeWrapper<AgreementEnrollingConditionSetsRelationship>;
  AgreementEnrollingPeriodEnrollingPeriodsAggregationSelection: ResolverTypeWrapper<AgreementEnrollingPeriodEnrollingPeriodsAggregationSelection>;
  AgreementEnrollingPeriodsAggregateInput: AgreementEnrollingPeriodsAggregateInput;
  AgreementEnrollingPeriodsConnection: ResolverTypeWrapper<AgreementEnrollingPeriodsConnection>;
  AgreementEnrollingPeriodsConnectionSort: AgreementEnrollingPeriodsConnectionSort;
  AgreementEnrollingPeriodsConnectionWhere: AgreementEnrollingPeriodsConnectionWhere;
  AgreementEnrollingPeriodsRelationship: ResolverTypeWrapper<AgreementEnrollingPeriodsRelationship>;
  AgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection: ResolverTypeWrapper<AgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection>;
  AgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection: ResolverTypeWrapper<AgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection>;
  AgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection: ResolverTypeWrapper<AgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection>;
  AgreementFinancialSummaryColumnRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AgreementFinancialSummaryColumnRelationship']>;
  AgreementFinancialSummaryColumnRelationshipSort: AgreementFinancialSummaryColumnRelationshipSort;
  AgreementFinancialSummaryColumnRelationshipWhere: AgreementFinancialSummaryColumnRelationshipWhere;
  AgreementFinancialSummaryConfigAggregateInput: AgreementFinancialSummaryConfigAggregateInput;
  AgreementFinancialSummaryConfigConnection: ResolverTypeWrapper<AgreementFinancialSummaryConfigConnection>;
  AgreementFinancialSummaryConfigConnectionSort: AgreementFinancialSummaryConfigConnectionSort;
  AgreementFinancialSummaryConfigConnectionWhere: AgreementFinancialSummaryConfigConnectionWhere;
  AgreementFinancialSummaryConfigEdgeAggregationWhereInput: AgreementFinancialSummaryConfigEdgeAggregationWhereInput;
  AgreementFinancialSummaryConfigNodeAggregationWhereInput: AgreementFinancialSummaryConfigNodeAggregationWhereInput;
  AgreementFinancialSummaryConfigRelationship: ResolverTypeWrapper<AgreementFinancialSummaryConfigRelationship>;
  AgreementInitialVersionAggregateInput: AgreementInitialVersionAggregateInput;
  AgreementInitialVersionConnection: ResolverTypeWrapper<AgreementInitialVersionConnection>;
  AgreementInitialVersionConnectionSort: AgreementInitialVersionConnectionSort;
  AgreementInitialVersionConnectionWhere: AgreementInitialVersionConnectionWhere;
  AgreementInitialVersionNodeAggregationWhereInput: AgreementInitialVersionNodeAggregationWhereInput;
  AgreementInitialVersionRelationship: ResolverTypeWrapper<AgreementInitialVersionRelationship>;
  AgreementInput: AgreementInput;
  AgreementLimitationAggregateInput: AgreementLimitationAggregateInput;
  AgreementLimitationConnection: ResolverTypeWrapper<AgreementLimitationConnection>;
  AgreementLimitationConnectionSort: AgreementLimitationConnectionSort;
  AgreementLimitationConnectionWhere: AgreementLimitationConnectionWhere;
  AgreementLimitationLimitationAggregationSelection: ResolverTypeWrapper<AgreementLimitationLimitationAggregationSelection>;
  AgreementLimitationLimitationNodeAggregateSelection: ResolverTypeWrapper<AgreementLimitationLimitationNodeAggregateSelection>;
  AgreementLimitationNodeAggregationWhereInput: AgreementLimitationNodeAggregationWhereInput;
  AgreementLimitationRelationship: ResolverTypeWrapper<AgreementLimitationRelationship>;
  AgreementNegotiableAttributesAggregateInput: AgreementNegotiableAttributesAggregateInput;
  AgreementNegotiableAttributesConnection: ResolverTypeWrapper<AgreementNegotiableAttributesConnection>;
  AgreementNegotiableAttributesConnectionSort: AgreementNegotiableAttributesConnectionSort;
  AgreementNegotiableAttributesConnectionWhere: AgreementNegotiableAttributesConnectionWhere;
  AgreementNegotiableAttributesNodeAggregationWhereInput: AgreementNegotiableAttributesNodeAggregationWhereInput;
  AgreementNegotiableAttributesRelationship: ResolverTypeWrapper<AgreementNegotiableAttributesRelationship>;
  AgreementNextVersionsAggregateInput: AgreementNextVersionsAggregateInput;
  AgreementNextVersionsConnection: ResolverTypeWrapper<AgreementNextVersionsConnection>;
  AgreementNextVersionsConnectionSort: AgreementNextVersionsConnectionSort;
  AgreementNextVersionsConnectionWhere: AgreementNextVersionsConnectionWhere;
  AgreementNextVersionsNodeAggregationWhereInput: AgreementNextVersionsNodeAggregationWhereInput;
  AgreementNextVersionsRelationship: ResolverTypeWrapper<AgreementNextVersionsRelationship>;
  AgreementOptions: AgreementOptions;
  AgreementOrganizationCounterpartiesAggregationSelection: ResolverTypeWrapper<AgreementOrganizationCounterpartiesAggregationSelection>;
  AgreementOrganizationCounterpartiesNodeAggregateSelection: ResolverTypeWrapper<AgreementOrganizationCounterpartiesNodeAggregateSelection>;
  AgreementPushedByAggregateInput: AgreementPushedByAggregateInput;
  AgreementPushedByConnection: ResolverTypeWrapper<AgreementPushedByConnection>;
  AgreementPushedByConnectionSort: AgreementPushedByConnectionSort;
  AgreementPushedByConnectionWhere: AgreementPushedByConnectionWhere;
  AgreementPushedByNodeAggregationWhereInput: AgreementPushedByNodeAggregationWhereInput;
  AgreementPushedByRelationship: ResolverTypeWrapper<AgreementPushedByRelationship>;
  AgreementRangeChartConfigAggregateInput: AgreementRangeChartConfigAggregateInput;
  AgreementRangeChartConfigConnection: ResolverTypeWrapper<AgreementRangeChartConfigConnection>;
  AgreementRangeChartConfigConnectionSort: AgreementRangeChartConfigConnectionSort;
  AgreementRangeChartConfigConnectionWhere: AgreementRangeChartConfigConnectionWhere;
  AgreementRangeChartConfigEdgeAggregationWhereInput: AgreementRangeChartConfigEdgeAggregationWhereInput;
  AgreementRangeChartConfigRelationship: ResolverTypeWrapper<AgreementRangeChartConfigRelationship>;
  AgreementRunAttemptInfo: ResolverTypeWrapper<AgreementRunAttemptInfo>;
  AgreementRunAttemptInfoEdge: ResolverTypeWrapper<AgreementRunAttemptInfoEdge>;
  AgreementRunAttemptInfoOptions: AgreementRunAttemptInfoOptions;
  AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection: ResolverTypeWrapper<AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection>;
  AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection: ResolverTypeWrapper<AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection>;
  AgreementRunAttemptInfoOrganizationTriggeredAggregateInput: AgreementRunAttemptInfoOrganizationTriggeredAggregateInput;
  AgreementRunAttemptInfoOrganizationTriggeredConnection: ResolverTypeWrapper<AgreementRunAttemptInfoOrganizationTriggeredConnection>;
  AgreementRunAttemptInfoOrganizationTriggeredConnectionSort: AgreementRunAttemptInfoOrganizationTriggeredConnectionSort;
  AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere: AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere;
  AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput: AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput;
  AgreementRunAttemptInfoOrganizationTriggeredRelationship: ResolverTypeWrapper<AgreementRunAttemptInfoOrganizationTriggeredRelationship>;
  AgreementRunAttemptInfoRunInitiatorAggregateInput: AgreementRunAttemptInfoRunInitiatorAggregateInput;
  AgreementRunAttemptInfoRunInitiatorConnection: ResolverTypeWrapper<AgreementRunAttemptInfoRunInitiatorConnection>;
  AgreementRunAttemptInfoRunInitiatorConnectionSort: AgreementRunAttemptInfoRunInitiatorConnectionSort;
  AgreementRunAttemptInfoRunInitiatorConnectionWhere: AgreementRunAttemptInfoRunInitiatorConnectionWhere;
  AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput: AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput;
  AgreementRunAttemptInfoRunInitiatorRelationship: ResolverTypeWrapper<AgreementRunAttemptInfoRunInitiatorRelationship>;
  AgreementRunAttemptInfoSort: AgreementRunAttemptInfoSort;
  AgreementRunAttemptInfoUserRunInitiatorAggregationSelection: ResolverTypeWrapper<AgreementRunAttemptInfoUserRunInitiatorAggregationSelection>;
  AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection: ResolverTypeWrapper<AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection>;
  AgreementRunAttemptInfoWhere: AgreementRunAttemptInfoWhere;
  AgreementRunAttemptInfosConnection: ResolverTypeWrapper<AgreementRunAttemptInfosConnection>;
  AgreementRunFrequency: AgreementRunFrequency;
  AgreementRunTrigger: AgreementRunTrigger;
  AgreementScenarioScenariosAggregationSelection: ResolverTypeWrapper<AgreementScenarioScenariosAggregationSelection>;
  AgreementScenarioScenariosNodeAggregateSelection: ResolverTypeWrapper<AgreementScenarioScenariosNodeAggregateSelection>;
  AgreementScenariosAggregateInput: AgreementScenariosAggregateInput;
  AgreementScenariosConnection: ResolverTypeWrapper<AgreementScenariosConnection>;
  AgreementScenariosConnectionSort: AgreementScenariosConnectionSort;
  AgreementScenariosConnectionWhere: AgreementScenariosConnectionWhere;
  AgreementScenariosNodeAggregationWhereInput: AgreementScenariosNodeAggregationWhereInput;
  AgreementScenariosRelationship: ResolverTypeWrapper<AgreementScenariosRelationship>;
  AgreementScenariosRelevantBrandsAggregateInput: AgreementScenariosRelevantBrandsAggregateInput;
  AgreementScenariosRelevantBrandsConnection: ResolverTypeWrapper<AgreementScenariosRelevantBrandsConnection>;
  AgreementScenariosRelevantBrandsConnectionSort: AgreementScenariosRelevantBrandsConnectionSort;
  AgreementScenariosRelevantBrandsConnectionWhere: AgreementScenariosRelevantBrandsConnectionWhere;
  AgreementScenariosRelevantBrandsNodeAggregationWhereInput: AgreementScenariosRelevantBrandsNodeAggregationWhereInput;
  AgreementScenariosRelevantBrandsRelationship: ResolverTypeWrapper<AgreementScenariosRelevantBrandsRelationship>;
  AgreementScope: ResolverTypeWrapper<AgreementScope>;
  AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection: ResolverTypeWrapper<AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection>;
  AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection: ResolverTypeWrapper<AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection>;
  AgreementScopeArticle71IndicationsAggregateInput: AgreementScopeArticle71IndicationsAggregateInput;
  AgreementScopeArticle71IndicationsConnection: ResolverTypeWrapper<AgreementScopeArticle71IndicationsConnection>;
  AgreementScopeArticle71IndicationsConnectionSort: AgreementScopeArticle71IndicationsConnectionSort;
  AgreementScopeArticle71IndicationsConnectionWhere: AgreementScopeArticle71IndicationsConnectionWhere;
  AgreementScopeArticle71IndicationsNodeAggregationWhereInput: AgreementScopeArticle71IndicationsNodeAggregationWhereInput;
  AgreementScopeArticle71IndicationsRelationship: ResolverTypeWrapper<AgreementScopeArticle71IndicationsRelationship>;
  AgreementScopeCountryCountryScopesAggregationSelection: ResolverTypeWrapper<AgreementScopeCountryCountryScopesAggregationSelection>;
  AgreementScopeCountryCountryScopesEdgeAggregateSelection: ResolverTypeWrapper<AgreementScopeCountryCountryScopesEdgeAggregateSelection>;
  AgreementScopeCountryCountryScopesNodeAggregateSelection: ResolverTypeWrapper<AgreementScopeCountryCountryScopesNodeAggregateSelection>;
  AgreementScopeCountryScope: ResolverTypeWrapper<AgreementScopeCountryScope>;
  AgreementScopeCountryScopeEdge: ResolverTypeWrapper<AgreementScopeCountryScopeEdge>;
  AgreementScopeCountryScopeOptions: AgreementScopeCountryScopeOptions;
  AgreementScopeCountryScopeSort: AgreementScopeCountryScopeSort;
  AgreementScopeCountryScopeWhere: AgreementScopeCountryScopeWhere;
  AgreementScopeCountryScopesAggregateInput: AgreementScopeCountryScopesAggregateInput;
  AgreementScopeCountryScopesConnection: ResolverTypeWrapper<AgreementScopeCountryScopesConnection>;
  AgreementScopeCountryScopesConnectionSort: AgreementScopeCountryScopesConnectionSort;
  AgreementScopeCountryScopesConnectionWhere: AgreementScopeCountryScopesConnectionWhere;
  AgreementScopeCountryScopesEdgeAggregationWhereInput: AgreementScopeCountryScopesEdgeAggregationWhereInput;
  AgreementScopeCountryScopesNodeAggregationWhereInput: AgreementScopeCountryScopesNodeAggregationWhereInput;
  AgreementScopeCountryScopesRelationship: ResolverTypeWrapper<AgreementScopeCountryScopesRelationship>;
  AgreementScopeCycleConfigurationCyclesAggregationSelection: ResolverTypeWrapper<AgreementScopeCycleConfigurationCyclesAggregationSelection>;
  AgreementScopeCycleConfigurationCyclesNodeAggregateSelection: ResolverTypeWrapper<AgreementScopeCycleConfigurationCyclesNodeAggregateSelection>;
  AgreementScopeCyclesAggregateInput: AgreementScopeCyclesAggregateInput;
  AgreementScopeCyclesConnection: ResolverTypeWrapper<AgreementScopeCyclesConnection>;
  AgreementScopeCyclesConnectionSort: AgreementScopeCyclesConnectionSort;
  AgreementScopeCyclesConnectionWhere: AgreementScopeCyclesConnectionWhere;
  AgreementScopeCyclesNodeAggregationWhereInput: AgreementScopeCyclesNodeAggregationWhereInput;
  AgreementScopeCyclesRelationship: ResolverTypeWrapper<AgreementScopeCyclesRelationship>;
  AgreementScopeDiseaseDiseasesAggregationSelection: ResolverTypeWrapper<AgreementScopeDiseaseDiseasesAggregationSelection>;
  AgreementScopeDiseaseDiseasesEdgeAggregateSelection: ResolverTypeWrapper<AgreementScopeDiseaseDiseasesEdgeAggregateSelection>;
  AgreementScopeDiseaseDiseasesNodeAggregateSelection: ResolverTypeWrapper<AgreementScopeDiseaseDiseasesNodeAggregateSelection>;
  AgreementScopeDiseasesAggregateInput: AgreementScopeDiseasesAggregateInput;
  AgreementScopeDiseasesConnection: ResolverTypeWrapper<AgreementScopeDiseasesConnection>;
  AgreementScopeDiseasesConnectionSort: AgreementScopeDiseasesConnectionSort;
  AgreementScopeDiseasesConnectionWhere: AgreementScopeDiseasesConnectionWhere;
  AgreementScopeDiseasesEdgeAggregationWhereInput: AgreementScopeDiseasesEdgeAggregationWhereInput;
  AgreementScopeDiseasesNodeAggregationWhereInput: AgreementScopeDiseasesNodeAggregationWhereInput;
  AgreementScopeDiseasesRelationship: ResolverTypeWrapper<AgreementScopeDiseasesRelationship>;
  AgreementScopeEdge: ResolverTypeWrapper<AgreementScopeEdge>;
  AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection: ResolverTypeWrapper<AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection>;
  AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection: ResolverTypeWrapper<AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection>;
  AgreementScopeEnrollingConditionSetsAggregateInput: AgreementScopeEnrollingConditionSetsAggregateInput;
  AgreementScopeEnrollingConditionSetsConnection: ResolverTypeWrapper<AgreementScopeEnrollingConditionSetsConnection>;
  AgreementScopeEnrollingConditionSetsConnectionSort: AgreementScopeEnrollingConditionSetsConnectionSort;
  AgreementScopeEnrollingConditionSetsConnectionWhere: AgreementScopeEnrollingConditionSetsConnectionWhere;
  AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput: AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput;
  AgreementScopeEnrollingConditionSetsRelationship: ResolverTypeWrapper<AgreementScopeEnrollingConditionSetsRelationship>;
  AgreementScopeIndicationIndicationsAggregationSelection: ResolverTypeWrapper<AgreementScopeIndicationIndicationsAggregationSelection>;
  AgreementScopeIndicationIndicationsNodeAggregateSelection: ResolverTypeWrapper<AgreementScopeIndicationIndicationsNodeAggregateSelection>;
  AgreementScopeIndicationsAggregateInput: AgreementScopeIndicationsAggregateInput;
  AgreementScopeIndicationsConnection: ResolverTypeWrapper<AgreementScopeIndicationsConnection>;
  AgreementScopeIndicationsConnectionSort: AgreementScopeIndicationsConnectionSort;
  AgreementScopeIndicationsConnectionWhere: AgreementScopeIndicationsConnectionWhere;
  AgreementScopeIndicationsNodeAggregationWhereInput: AgreementScopeIndicationsNodeAggregationWhereInput;
  AgreementScopeIndicationsRelationship: ResolverTypeWrapper<AgreementScopeIndicationsRelationship>;
  AgreementScopeInput: AgreementScopeInput;
  AgreementScopeOptions: AgreementScopeOptions;
  AgreementScopeOrganizationOrganizationScopesAggregationSelection: ResolverTypeWrapper<AgreementScopeOrganizationOrganizationScopesAggregationSelection>;
  AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection: ResolverTypeWrapper<AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection>;
  AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection: ResolverTypeWrapper<AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection>;
  AgreementScopeOrganizationScope: ResolverTypeWrapper<AgreementScopeOrganizationScope>;
  AgreementScopeOrganizationScopeEdge: ResolverTypeWrapper<AgreementScopeOrganizationScopeEdge>;
  AgreementScopeOrganizationScopeOptions: AgreementScopeOrganizationScopeOptions;
  AgreementScopeOrganizationScopeSort: AgreementScopeOrganizationScopeSort;
  AgreementScopeOrganizationScopeWhere: AgreementScopeOrganizationScopeWhere;
  AgreementScopeOrganizationScopesAggregateInput: AgreementScopeOrganizationScopesAggregateInput;
  AgreementScopeOrganizationScopesConnection: ResolverTypeWrapper<AgreementScopeOrganizationScopesConnection>;
  AgreementScopeOrganizationScopesConnectionSort: AgreementScopeOrganizationScopesConnectionSort;
  AgreementScopeOrganizationScopesConnectionWhere: AgreementScopeOrganizationScopesConnectionWhere;
  AgreementScopeOrganizationScopesEdgeAggregationWhereInput: AgreementScopeOrganizationScopesEdgeAggregationWhereInput;
  AgreementScopeOrganizationScopesNodeAggregationWhereInput: AgreementScopeOrganizationScopesNodeAggregationWhereInput;
  AgreementScopeOrganizationScopesRelationship: ResolverTypeWrapper<AgreementScopeOrganizationScopesRelationship>;
  AgreementScopeRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AgreementScopeRelationship']>;
  AgreementScopeRelationshipSort: AgreementScopeRelationshipSort;
  AgreementScopeRelationshipWhere: AgreementScopeRelationshipWhere;
  AgreementScopeSort: AgreementScopeSort;
  AgreementScopeTreatmentSetTreatmentSetsAggregationSelection: ResolverTypeWrapper<AgreementScopeTreatmentSetTreatmentSetsAggregationSelection>;
  AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection: ResolverTypeWrapper<AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection>;
  AgreementScopeTreatmentSetsAggregateInput: AgreementScopeTreatmentSetsAggregateInput;
  AgreementScopeTreatmentSetsConnection: ResolverTypeWrapper<AgreementScopeTreatmentSetsConnection>;
  AgreementScopeTreatmentSetsConnectionSort: AgreementScopeTreatmentSetsConnectionSort;
  AgreementScopeTreatmentSetsConnectionWhere: AgreementScopeTreatmentSetsConnectionWhere;
  AgreementScopeTreatmentSetsNodeAggregationWhereInput: AgreementScopeTreatmentSetsNodeAggregationWhereInput;
  AgreementScopeTreatmentSetsRelationship: ResolverTypeWrapper<AgreementScopeTreatmentSetsRelationship>;
  AgreementScopeWhere: AgreementScopeWhere;
  AgreementScopesConnection: ResolverTypeWrapper<AgreementScopesConnection>;
  AgreementSort: AgreementSort;
  AgreementSpecificRole: ResolverTypeWrapper<AgreementSpecificRole>;
  AgreementSpecificRoleEdge: ResolverTypeWrapper<AgreementSpecificRoleEdge>;
  AgreementSpecificRoleOptions: AgreementSpecificRoleOptions;
  AgreementSpecificRoleSort: AgreementSpecificRoleSort;
  AgreementSpecificRoleWhere: AgreementSpecificRoleWhere;
  AgreementSpecificRolesConnection: ResolverTypeWrapper<AgreementSpecificRolesConnection>;
  AgreementStatusTransition: ResolverTypeWrapper<AgreementStatusTransition>;
  AgreementStatusTransitionCausedByAggregateInput: AgreementStatusTransitionCausedByAggregateInput;
  AgreementStatusTransitionCausedByConnection: ResolverTypeWrapper<AgreementStatusTransitionCausedByConnection>;
  AgreementStatusTransitionCausedByConnectionSort: AgreementStatusTransitionCausedByConnectionSort;
  AgreementStatusTransitionCausedByConnectionWhere: AgreementStatusTransitionCausedByConnectionWhere;
  AgreementStatusTransitionCausedByNodeAggregationWhereInput: AgreementStatusTransitionCausedByNodeAggregationWhereInput;
  AgreementStatusTransitionCausedByRelationship: ResolverTypeWrapper<AgreementStatusTransitionCausedByRelationship>;
  AgreementStatusTransitionEdge: ResolverTypeWrapper<AgreementStatusTransitionEdge>;
  AgreementStatusTransitionOptions: AgreementStatusTransitionOptions;
  AgreementStatusTransitionSort: AgreementStatusTransitionSort;
  AgreementStatusTransitionUserCausedByAggregationSelection: ResolverTypeWrapper<AgreementStatusTransitionUserCausedByAggregationSelection>;
  AgreementStatusTransitionUserCausedByNodeAggregateSelection: ResolverTypeWrapper<AgreementStatusTransitionUserCausedByNodeAggregateSelection>;
  AgreementStatusTransitionWhere: AgreementStatusTransitionWhere;
  AgreementStatusTransitionsConnection: ResolverTypeWrapper<AgreementStatusTransitionsConnection>;
  AgreementSubjectMatter: AgreementSubjectMatter;
  AgreementTag: ResolverTypeWrapper<AgreementTag>;
  AgreementTagDefaultUserRolesAggregateInput: AgreementTagDefaultUserRolesAggregateInput;
  AgreementTagDefaultUserRolesConnection: ResolverTypeWrapper<AgreementTagDefaultUserRolesConnection>;
  AgreementTagDefaultUserRolesConnectionSort: AgreementTagDefaultUserRolesConnectionSort;
  AgreementTagDefaultUserRolesConnectionWhere: AgreementTagDefaultUserRolesConnectionWhere;
  AgreementTagDefaultUserRolesNodeAggregationWhereInput: AgreementTagDefaultUserRolesNodeAggregationWhereInput;
  AgreementTagDefaultUserRolesRelationship: ResolverTypeWrapper<AgreementTagDefaultUserRolesRelationship>;
  AgreementTagEdge: ResolverTypeWrapper<AgreementTagEdge>;
  AgreementTagInput: AgreementTagInput;
  AgreementTagOptions: AgreementTagOptions;
  AgreementTagSort: AgreementTagSort;
  AgreementTagType: AgreementTagType;
  AgreementTagUserDefaultUserRolesAggregationSelection: ResolverTypeWrapper<AgreementTagUserDefaultUserRolesAggregationSelection>;
  AgreementTagUserDefaultUserRolesNodeAggregateSelection: ResolverTypeWrapper<AgreementTagUserDefaultUserRolesNodeAggregateSelection>;
  AgreementTagUserRoleRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AgreementTagUserRoleRelationship']>;
  AgreementTagUserRoleRelationshipSort: AgreementTagUserRoleRelationshipSort;
  AgreementTagUserRoleRelationshipWhere: AgreementTagUserRoleRelationshipWhere;
  AgreementTagWhere: AgreementTagWhere;
  AgreementTagsAggregateInput: AgreementTagsAggregateInput;
  AgreementTagsConnection: ResolverTypeWrapper<AgreementTagsConnection>;
  AgreementTagsConnectionSort: AgreementTagsConnectionSort;
  AgreementTagsConnectionWhere: AgreementTagsConnectionWhere;
  AgreementTagsNodeAggregationWhereInput: AgreementTagsNodeAggregationWhereInput;
  AgreementTemplate: ResolverTypeWrapper<AgreementTemplate>;
  AgreementTemplateAddedByAggregateInput: AgreementTemplateAddedByAggregateInput;
  AgreementTemplateAddedByConnection: ResolverTypeWrapper<AgreementTemplateAddedByConnection>;
  AgreementTemplateAddedByConnectionSort: AgreementTemplateAddedByConnectionSort;
  AgreementTemplateAddedByConnectionWhere: AgreementTemplateAddedByConnectionWhere;
  AgreementTemplateAddedByNodeAggregationWhereInput: AgreementTemplateAddedByNodeAggregationWhereInput;
  AgreementTemplateAddedByRelationship: ResolverTypeWrapper<AgreementTemplateAddedByRelationship>;
  AgreementTemplateAggregateInput: AgreementTemplateAggregateInput;
  AgreementTemplateAgreementAgreementsAggregationSelection: ResolverTypeWrapper<AgreementTemplateAgreementAgreementsAggregationSelection>;
  AgreementTemplateAgreementAgreementsNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateAgreementAgreementsNodeAggregateSelection>;
  AgreementTemplateAgreementTagTagsAggregationSelection: ResolverTypeWrapper<AgreementTemplateAgreementTagTagsAggregationSelection>;
  AgreementTemplateAgreementTagTagsNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateAgreementTagTagsNodeAggregateSelection>;
  AgreementTemplateAgreementTemplateInitialVersionAggregationSelection: ResolverTypeWrapper<AgreementTemplateAgreementTemplateInitialVersionAggregationSelection>;
  AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection>;
  AgreementTemplateAgreementTemplateNextVersionsAggregationSelection: ResolverTypeWrapper<AgreementTemplateAgreementTemplateNextVersionsAggregationSelection>;
  AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection>;
  AgreementTemplateAgreementsAggregateInput: AgreementTemplateAgreementsAggregateInput;
  AgreementTemplateAgreementsConnection: ResolverTypeWrapper<AgreementTemplateAgreementsConnection>;
  AgreementTemplateAgreementsConnectionSort: AgreementTemplateAgreementsConnectionSort;
  AgreementTemplateAgreementsConnectionWhere: AgreementTemplateAgreementsConnectionWhere;
  AgreementTemplateAgreementsNodeAggregationWhereInput: AgreementTemplateAgreementsNodeAggregationWhereInput;
  AgreementTemplateAgreementsRelationship: ResolverTypeWrapper<AgreementTemplateAgreementsRelationship>;
  AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection: ResolverTypeWrapper<AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection>;
  AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection>;
  AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection: ResolverTypeWrapper<AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection>;
  AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection>;
  AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection: ResolverTypeWrapper<AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection>;
  AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection: ResolverTypeWrapper<AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection>;
  AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection: ResolverTypeWrapper<AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection>;
  AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection: ResolverTypeWrapper<AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection>;
  AgreementTemplateConnection: ResolverTypeWrapper<AgreementTemplateConnection>;
  AgreementTemplateConnectionSort: AgreementTemplateConnectionSort;
  AgreementTemplateConnectionWhere: AgreementTemplateConnectionWhere;
  AgreementTemplateCountryAggregateInput: AgreementTemplateCountryAggregateInput;
  AgreementTemplateCountryConnection: ResolverTypeWrapper<AgreementTemplateCountryConnection>;
  AgreementTemplateCountryConnectionSort: AgreementTemplateCountryConnectionSort;
  AgreementTemplateCountryConnectionWhere: AgreementTemplateCountryConnectionWhere;
  AgreementTemplateCountryCountryAggregationSelection: ResolverTypeWrapper<AgreementTemplateCountryCountryAggregationSelection>;
  AgreementTemplateCountryCountryNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateCountryCountryNodeAggregateSelection>;
  AgreementTemplateCountryNodeAggregationWhereInput: AgreementTemplateCountryNodeAggregationWhereInput;
  AgreementTemplateCountryRelationship: ResolverTypeWrapper<AgreementTemplateCountryRelationship>;
  AgreementTemplateCurrencyAggregateInput: AgreementTemplateCurrencyAggregateInput;
  AgreementTemplateCurrencyConnection: ResolverTypeWrapper<AgreementTemplateCurrencyConnection>;
  AgreementTemplateCurrencyConnectionSort: AgreementTemplateCurrencyConnectionSort;
  AgreementTemplateCurrencyConnectionWhere: AgreementTemplateCurrencyConnectionWhere;
  AgreementTemplateCurrencyCurrencyAggregationSelection: ResolverTypeWrapper<AgreementTemplateCurrencyCurrencyAggregationSelection>;
  AgreementTemplateCurrencyCurrencyNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateCurrencyCurrencyNodeAggregateSelection>;
  AgreementTemplateCurrencyNodeAggregationWhereInput: AgreementTemplateCurrencyNodeAggregationWhereInput;
  AgreementTemplateCurrencyRelationship: ResolverTypeWrapper<AgreementTemplateCurrencyRelationship>;
  AgreementTemplateCycleConfigurationCyclesAggregationSelection: ResolverTypeWrapper<AgreementTemplateCycleConfigurationCyclesAggregationSelection>;
  AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection>;
  AgreementTemplateCyclesAggregateInput: AgreementTemplateCyclesAggregateInput;
  AgreementTemplateCyclesConnection: ResolverTypeWrapper<AgreementTemplateCyclesConnection>;
  AgreementTemplateCyclesConnectionSort: AgreementTemplateCyclesConnectionSort;
  AgreementTemplateCyclesConnectionWhere: AgreementTemplateCyclesConnectionWhere;
  AgreementTemplateCyclesNodeAggregationWhereInput: AgreementTemplateCyclesNodeAggregationWhereInput;
  AgreementTemplateCyclesRelationship: ResolverTypeWrapper<AgreementTemplateCyclesRelationship>;
  AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection: ResolverTypeWrapper<AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection>;
  AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection>;
  AgreementTemplateDeviceAlternativeSetsAggregateInput: AgreementTemplateDeviceAlternativeSetsAggregateInput;
  AgreementTemplateDeviceAlternativeSetsConnection: ResolverTypeWrapper<AgreementTemplateDeviceAlternativeSetsConnection>;
  AgreementTemplateDeviceAlternativeSetsConnectionSort: AgreementTemplateDeviceAlternativeSetsConnectionSort;
  AgreementTemplateDeviceAlternativeSetsConnectionWhere: AgreementTemplateDeviceAlternativeSetsConnectionWhere;
  AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput: AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput;
  AgreementTemplateDeviceAlternativeSetsRelationship: ResolverTypeWrapper<AgreementTemplateDeviceAlternativeSetsRelationship>;
  AgreementTemplateDotThresholdsAggregateInput: AgreementTemplateDotThresholdsAggregateInput;
  AgreementTemplateDotThresholdsConnection: ResolverTypeWrapper<AgreementTemplateDotThresholdsConnection>;
  AgreementTemplateDotThresholdsConnectionSort: AgreementTemplateDotThresholdsConnectionSort;
  AgreementTemplateDotThresholdsConnectionWhere: AgreementTemplateDotThresholdsConnectionWhere;
  AgreementTemplateDotThresholdsEdgeAggregationWhereInput: AgreementTemplateDotThresholdsEdgeAggregationWhereInput;
  AgreementTemplateDotThresholdsRelationship: ResolverTypeWrapper<AgreementTemplateDotThresholdsRelationship>;
  AgreementTemplateEdge: ResolverTypeWrapper<AgreementTemplateEdge>;
  AgreementTemplateEligibilityConditionRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AgreementTemplateEligibilityConditionRelationship']>;
  AgreementTemplateEligibilityConditionRelationshipSort: AgreementTemplateEligibilityConditionRelationshipSort;
  AgreementTemplateEligibilityConditionRelationshipWhere: AgreementTemplateEligibilityConditionRelationshipWhere;
  AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection: ResolverTypeWrapper<AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection>;
  AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection: ResolverTypeWrapper<AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection>;
  AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection>;
  AgreementTemplateEligibilityConditionSetsAggregateInput: AgreementTemplateEligibilityConditionSetsAggregateInput;
  AgreementTemplateEligibilityConditionSetsConnection: ResolverTypeWrapper<AgreementTemplateEligibilityConditionSetsConnection>;
  AgreementTemplateEligibilityConditionSetsConnectionSort: AgreementTemplateEligibilityConditionSetsConnectionSort;
  AgreementTemplateEligibilityConditionSetsConnectionWhere: AgreementTemplateEligibilityConditionSetsConnectionWhere;
  AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput: AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput;
  AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput: AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput;
  AgreementTemplateEligibilityConditionSetsRelationship: ResolverTypeWrapper<AgreementTemplateEligibilityConditionSetsRelationship>;
  AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection: ResolverTypeWrapper<AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection>;
  AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection>;
  AgreementTemplateEnrollingConditionSetsAggregateInput: AgreementTemplateEnrollingConditionSetsAggregateInput;
  AgreementTemplateEnrollingConditionSetsConnection: ResolverTypeWrapper<AgreementTemplateEnrollingConditionSetsConnection>;
  AgreementTemplateEnrollingConditionSetsConnectionSort: AgreementTemplateEnrollingConditionSetsConnectionSort;
  AgreementTemplateEnrollingConditionSetsConnectionWhere: AgreementTemplateEnrollingConditionSetsConnectionWhere;
  AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput: AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput;
  AgreementTemplateEnrollingConditionSetsRelationship: ResolverTypeWrapper<AgreementTemplateEnrollingConditionSetsRelationship>;
  AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection: ResolverTypeWrapper<AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection>;
  AgreementTemplateEnrollingPeriodsAggregateInput: AgreementTemplateEnrollingPeriodsAggregateInput;
  AgreementTemplateEnrollingPeriodsConnection: ResolverTypeWrapper<AgreementTemplateEnrollingPeriodsConnection>;
  AgreementTemplateEnrollingPeriodsConnectionSort: AgreementTemplateEnrollingPeriodsConnectionSort;
  AgreementTemplateEnrollingPeriodsConnectionWhere: AgreementTemplateEnrollingPeriodsConnectionWhere;
  AgreementTemplateEnrollingPeriodsRelationship: ResolverTypeWrapper<AgreementTemplateEnrollingPeriodsRelationship>;
  AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection: ResolverTypeWrapper<AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection>;
  AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection: ResolverTypeWrapper<AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection>;
  AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection>;
  AgreementTemplateFinancialSummaryConfigAggregateInput: AgreementTemplateFinancialSummaryConfigAggregateInput;
  AgreementTemplateFinancialSummaryConfigConnection: ResolverTypeWrapper<AgreementTemplateFinancialSummaryConfigConnection>;
  AgreementTemplateFinancialSummaryConfigConnectionSort: AgreementTemplateFinancialSummaryConfigConnectionSort;
  AgreementTemplateFinancialSummaryConfigConnectionWhere: AgreementTemplateFinancialSummaryConfigConnectionWhere;
  AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput: AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput;
  AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput: AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput;
  AgreementTemplateFinancialSummaryConfigRelationship: ResolverTypeWrapper<AgreementTemplateFinancialSummaryConfigRelationship>;
  AgreementTemplateInitialVersionAggregateInput: AgreementTemplateInitialVersionAggregateInput;
  AgreementTemplateInitialVersionConnection: ResolverTypeWrapper<AgreementTemplateInitialVersionConnection>;
  AgreementTemplateInitialVersionConnectionSort: AgreementTemplateInitialVersionConnectionSort;
  AgreementTemplateInitialVersionConnectionWhere: AgreementTemplateInitialVersionConnectionWhere;
  AgreementTemplateInitialVersionNodeAggregationWhereInput: AgreementTemplateInitialVersionNodeAggregationWhereInput;
  AgreementTemplateInitialVersionRelationship: ResolverTypeWrapper<AgreementTemplateInitialVersionRelationship>;
  AgreementTemplateInput: AgreementTemplateInput;
  AgreementTemplateLimitationAggregateInput: AgreementTemplateLimitationAggregateInput;
  AgreementTemplateLimitationConnection: ResolverTypeWrapper<AgreementTemplateLimitationConnection>;
  AgreementTemplateLimitationConnectionSort: AgreementTemplateLimitationConnectionSort;
  AgreementTemplateLimitationConnectionWhere: AgreementTemplateLimitationConnectionWhere;
  AgreementTemplateLimitationLimitationAggregationSelection: ResolverTypeWrapper<AgreementTemplateLimitationLimitationAggregationSelection>;
  AgreementTemplateLimitationLimitationNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateLimitationLimitationNodeAggregateSelection>;
  AgreementTemplateLimitationNodeAggregationWhereInput: AgreementTemplateLimitationNodeAggregationWhereInput;
  AgreementTemplateLimitationRelationship: ResolverTypeWrapper<AgreementTemplateLimitationRelationship>;
  AgreementTemplateNegotiableAttributesAggregateInput: AgreementTemplateNegotiableAttributesAggregateInput;
  AgreementTemplateNegotiableAttributesConnection: ResolverTypeWrapper<AgreementTemplateNegotiableAttributesConnection>;
  AgreementTemplateNegotiableAttributesConnectionSort: AgreementTemplateNegotiableAttributesConnectionSort;
  AgreementTemplateNegotiableAttributesConnectionWhere: AgreementTemplateNegotiableAttributesConnectionWhere;
  AgreementTemplateNegotiableAttributesNodeAggregationWhereInput: AgreementTemplateNegotiableAttributesNodeAggregationWhereInput;
  AgreementTemplateNegotiableAttributesRelationship: ResolverTypeWrapper<AgreementTemplateNegotiableAttributesRelationship>;
  AgreementTemplateNextVersionsAggregateInput: AgreementTemplateNextVersionsAggregateInput;
  AgreementTemplateNextVersionsConnection: ResolverTypeWrapper<AgreementTemplateNextVersionsConnection>;
  AgreementTemplateNextVersionsConnectionSort: AgreementTemplateNextVersionsConnectionSort;
  AgreementTemplateNextVersionsConnectionWhere: AgreementTemplateNextVersionsConnectionWhere;
  AgreementTemplateNextVersionsNodeAggregationWhereInput: AgreementTemplateNextVersionsNodeAggregationWhereInput;
  AgreementTemplateNextVersionsRelationship: ResolverTypeWrapper<AgreementTemplateNextVersionsRelationship>;
  AgreementTemplateNodeAggregationWhereInput: AgreementTemplateNodeAggregationWhereInput;
  AgreementTemplateOptions: AgreementTemplateOptions;
  AgreementTemplateRangeChartConfigAggregateInput: AgreementTemplateRangeChartConfigAggregateInput;
  AgreementTemplateRangeChartConfigConnection: ResolverTypeWrapper<AgreementTemplateRangeChartConfigConnection>;
  AgreementTemplateRangeChartConfigConnectionSort: AgreementTemplateRangeChartConfigConnectionSort;
  AgreementTemplateRangeChartConfigConnectionWhere: AgreementTemplateRangeChartConfigConnectionWhere;
  AgreementTemplateRangeChartConfigEdgeAggregationWhereInput: AgreementTemplateRangeChartConfigEdgeAggregationWhereInput;
  AgreementTemplateRangeChartConfigRelationship: ResolverTypeWrapper<AgreementTemplateRangeChartConfigRelationship>;
  AgreementTemplateRelationship: ResolverTypeWrapper<AgreementTemplateRelationship>;
  AgreementTemplateScenarioScenariosAggregationSelection: ResolverTypeWrapper<AgreementTemplateScenarioScenariosAggregationSelection>;
  AgreementTemplateScenarioScenariosNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateScenarioScenariosNodeAggregateSelection>;
  AgreementTemplateScenariosAggregateInput: AgreementTemplateScenariosAggregateInput;
  AgreementTemplateScenariosConnection: ResolverTypeWrapper<AgreementTemplateScenariosConnection>;
  AgreementTemplateScenariosConnectionSort: AgreementTemplateScenariosConnectionSort;
  AgreementTemplateScenariosConnectionWhere: AgreementTemplateScenariosConnectionWhere;
  AgreementTemplateScenariosNodeAggregationWhereInput: AgreementTemplateScenariosNodeAggregationWhereInput;
  AgreementTemplateScenariosRelationship: ResolverTypeWrapper<AgreementTemplateScenariosRelationship>;
  AgreementTemplateScenariosRelevantBrandsAggregateInput: AgreementTemplateScenariosRelevantBrandsAggregateInput;
  AgreementTemplateScenariosRelevantBrandsConnection: ResolverTypeWrapper<AgreementTemplateScenariosRelevantBrandsConnection>;
  AgreementTemplateScenariosRelevantBrandsConnectionSort: AgreementTemplateScenariosRelevantBrandsConnectionSort;
  AgreementTemplateScenariosRelevantBrandsConnectionWhere: AgreementTemplateScenariosRelevantBrandsConnectionWhere;
  AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput: AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput;
  AgreementTemplateScenariosRelevantBrandsRelationship: ResolverTypeWrapper<AgreementTemplateScenariosRelevantBrandsRelationship>;
  AgreementTemplateSort: AgreementTemplateSort;
  AgreementTemplateTagsAggregateInput: AgreementTemplateTagsAggregateInput;
  AgreementTemplateTagsConnection: ResolverTypeWrapper<AgreementTemplateTagsConnection>;
  AgreementTemplateTagsConnectionSort: AgreementTemplateTagsConnectionSort;
  AgreementTemplateTagsConnectionWhere: AgreementTemplateTagsConnectionWhere;
  AgreementTemplateTagsNodeAggregationWhereInput: AgreementTemplateTagsNodeAggregationWhereInput;
  AgreementTemplateTagsRelationship: ResolverTypeWrapper<AgreementTemplateTagsRelationship>;
  AgreementTemplateTreatmentPriceRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AgreementTemplateTreatmentPriceRelationship']>;
  AgreementTemplateTreatmentPriceRelationshipSort: AgreementTemplateTreatmentPriceRelationshipSort;
  AgreementTemplateTreatmentPriceRelationshipWhere: AgreementTemplateTreatmentPriceRelationshipWhere;
  AgreementTemplateTreatmentPricesAggregateInput: AgreementTemplateTreatmentPricesAggregateInput;
  AgreementTemplateTreatmentPricesConnection: ResolverTypeWrapper<AgreementTemplateTreatmentPricesConnection>;
  AgreementTemplateTreatmentPricesConnectionSort: AgreementTemplateTreatmentPricesConnectionSort;
  AgreementTemplateTreatmentPricesConnectionWhere: AgreementTemplateTreatmentPricesConnectionWhere;
  AgreementTemplateTreatmentPricesEdgeAggregationWhereInput: AgreementTemplateTreatmentPricesEdgeAggregationWhereInput;
  AgreementTemplateTreatmentPricesNodeAggregationWhereInput: AgreementTemplateTreatmentPricesNodeAggregationWhereInput;
  AgreementTemplateTreatmentPricesRelationship: ResolverTypeWrapper<AgreementTemplateTreatmentPricesRelationship>;
  AgreementTemplateTreatmentTreatmentPricesAggregationSelection: ResolverTypeWrapper<AgreementTemplateTreatmentTreatmentPricesAggregationSelection>;
  AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection: ResolverTypeWrapper<AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection>;
  AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection>;
  AgreementTemplateUserAddedByAggregationSelection: ResolverTypeWrapper<AgreementTemplateUserAddedByAggregationSelection>;
  AgreementTemplateUserAddedByNodeAggregateSelection: ResolverTypeWrapper<AgreementTemplateUserAddedByNodeAggregateSelection>;
  AgreementTemplateVersionCreationResponse: ResolverTypeWrapper<AgreementTemplateVersionCreationResponse>;
  AgreementTemplateVersionCreationResponseEdge: ResolverTypeWrapper<AgreementTemplateVersionCreationResponseEdge>;
  AgreementTemplateVersionCreationResponseOptions: AgreementTemplateVersionCreationResponseOptions;
  AgreementTemplateVersionCreationResponseSort: AgreementTemplateVersionCreationResponseSort;
  AgreementTemplateVersionCreationResponseWhere: AgreementTemplateVersionCreationResponseWhere;
  AgreementTemplateVersionCreationResponsesConnection: ResolverTypeWrapper<AgreementTemplateVersionCreationResponsesConnection>;
  AgreementTemplateWhere: AgreementTemplateWhere;
  AgreementTemplatesConnection: ResolverTypeWrapper<AgreementTemplatesConnection>;
  AgreementTreatmentPriceRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AgreementTreatmentPriceRelationship']>;
  AgreementTreatmentPriceRelationshipSort: AgreementTreatmentPriceRelationshipSort;
  AgreementTreatmentPriceRelationshipWhere: AgreementTreatmentPriceRelationshipWhere;
  AgreementTreatmentPricesAggregateInput: AgreementTreatmentPricesAggregateInput;
  AgreementTreatmentPricesConnection: ResolverTypeWrapper<AgreementTreatmentPricesConnection>;
  AgreementTreatmentPricesConnectionSort: AgreementTreatmentPricesConnectionSort;
  AgreementTreatmentPricesConnectionWhere: AgreementTreatmentPricesConnectionWhere;
  AgreementTreatmentPricesEdgeAggregationWhereInput: AgreementTreatmentPricesEdgeAggregationWhereInput;
  AgreementTreatmentPricesNodeAggregationWhereInput: AgreementTreatmentPricesNodeAggregationWhereInput;
  AgreementTreatmentPricesRelationship: ResolverTypeWrapper<AgreementTreatmentPricesRelationship>;
  AgreementTreatmentTreatmentPricesAggregationSelection: ResolverTypeWrapper<AgreementTreatmentTreatmentPricesAggregationSelection>;
  AgreementTreatmentTreatmentPricesEdgeAggregateSelection: ResolverTypeWrapper<AgreementTreatmentTreatmentPricesEdgeAggregateSelection>;
  AgreementTreatmentTreatmentPricesNodeAggregateSelection: ResolverTypeWrapper<AgreementTreatmentTreatmentPricesNodeAggregateSelection>;
  AgreementUserAddedByAggregationSelection: ResolverTypeWrapper<AgreementUserAddedByAggregationSelection>;
  AgreementUserAddedByNodeAggregateSelection: ResolverTypeWrapper<AgreementUserAddedByNodeAggregateSelection>;
  AgreementUserPushedByAggregationSelection: ResolverTypeWrapper<AgreementUserPushedByAggregationSelection>;
  AgreementUserPushedByNodeAggregateSelection: ResolverTypeWrapper<AgreementUserPushedByNodeAggregateSelection>;
  AgreementUserRole: AgreementUserRole;
  AgreementUserRoleInput: AgreementUserRoleInput;
  AgreementUserRoleRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AgreementUserRoleRelationship']>;
  AgreementUserRoleRelationshipSort: AgreementUserRoleRelationshipSort;
  AgreementUserRoleRelationshipWhere: AgreementUserRoleRelationshipWhere;
  AgreementUserRolesAggregateInput: AgreementUserRolesAggregateInput;
  AgreementUserRolesConnection: ResolverTypeWrapper<AgreementUserRolesConnection>;
  AgreementUserRolesConnectionSort: AgreementUserRolesConnectionSort;
  AgreementUserRolesConnectionWhere: AgreementUserRolesConnectionWhere;
  AgreementUserRolesNodeAggregationWhereInput: AgreementUserRolesNodeAggregationWhereInput;
  AgreementUserRolesRelationship: ResolverTypeWrapper<AgreementUserRolesRelationship>;
  AgreementUserUserRolesAggregationSelection: ResolverTypeWrapper<AgreementUserUserRolesAggregationSelection>;
  AgreementUserUserRolesNodeAggregateSelection: ResolverTypeWrapper<AgreementUserUserRolesNodeAggregateSelection>;
  AgreementWhere: AgreementWhere;
  AgreementsConnection: ResolverTypeWrapper<AgreementsConnection>;
  Alert: ResolverTypeWrapper<Alert>;
  AlertCheckAggregateInput: AlertCheckAggregateInput;
  AlertCheckConnection: ResolverTypeWrapper<AlertCheckConnection>;
  AlertCheckConnectionSort: AlertCheckConnectionSort;
  AlertCheckConnectionWhere: AlertCheckConnectionWhere;
  AlertCheckNodeAggregationWhereInput: AlertCheckNodeAggregationWhereInput;
  AlertCheckRelationship: ResolverTypeWrapper<AlertCheckRelationship>;
  AlertEdge: ResolverTypeWrapper<AlertEdge>;
  AlertOptions: AlertOptions;
  AlertRunCheckCheckAggregationSelection: ResolverTypeWrapper<AlertRunCheckCheckAggregationSelection>;
  AlertRunCheckCheckNodeAggregateSelection: ResolverTypeWrapper<AlertRunCheckCheckNodeAggregateSelection>;
  AlertSort: AlertSort;
  AlertWhere: AlertWhere;
  AlertsConnection: ResolverTypeWrapper<AlertsConnection>;
  AmountOfThresholdBasis: AmountOfThresholdBasis;
  AmountsType: AmountsType;
  ApplyUserRolesToAllInput: ApplyUserRolesToAllInput;
  ArithmeticalOperator: ArithmeticalOperator;
  Art71MasterDataImpacts: ResolverTypeWrapper<Art71MasterDataImpacts>;
  Art71MasterDataImpactsConnection: ResolverTypeWrapper<Art71MasterDataImpactsConnection>;
  Art71MasterDataImpactsEdge: ResolverTypeWrapper<Art71MasterDataImpactsEdge>;
  Art71MasterDataImpactsInput: Art71MasterDataImpactsInput;
  Art71MasterDataImpactsOptions: Art71MasterDataImpactsOptions;
  Art71MasterDataImpactsSort: Art71MasterDataImpactsSort;
  Art71MasterDataImpactsWhere: Art71MasterDataImpactsWhere;
  Article71Indication: ResolverTypeWrapper<Article71Indication>;
  Article71IndicationAgreementScopeAggregateInput: Article71IndicationAgreementScopeAggregateInput;
  Article71IndicationAgreementScopeAgreementScopeAggregationSelection: ResolverTypeWrapper<Article71IndicationAgreementScopeAgreementScopeAggregationSelection>;
  Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection: ResolverTypeWrapper<Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection>;
  Article71IndicationAgreementScopeConnection: ResolverTypeWrapper<Article71IndicationAgreementScopeConnection>;
  Article71IndicationAgreementScopeConnectionSort: Article71IndicationAgreementScopeConnectionSort;
  Article71IndicationAgreementScopeConnectionWhere: Article71IndicationAgreementScopeConnectionWhere;
  Article71IndicationAgreementScopeNodeAggregationWhereInput: Article71IndicationAgreementScopeNodeAggregationWhereInput;
  Article71IndicationAgreementScopeRelationship: ResolverTypeWrapper<Article71IndicationAgreementScopeRelationship>;
  Article71IndicationAgreementTemplateAggregateInput: Article71IndicationAgreementTemplateAggregateInput;
  Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection: ResolverTypeWrapper<Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection>;
  Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection: ResolverTypeWrapper<Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection>;
  Article71IndicationAgreementTemplateConnection: ResolverTypeWrapper<Article71IndicationAgreementTemplateConnection>;
  Article71IndicationAgreementTemplateConnectionSort: Article71IndicationAgreementTemplateConnectionSort;
  Article71IndicationAgreementTemplateConnectionWhere: Article71IndicationAgreementTemplateConnectionWhere;
  Article71IndicationAgreementTemplateNodeAggregationWhereInput: Article71IndicationAgreementTemplateNodeAggregationWhereInput;
  Article71IndicationAgreementTemplateRelationship: ResolverTypeWrapper<Article71IndicationAgreementTemplateRelationship>;
  Article71IndicationBrandAggregateInput: Article71IndicationBrandAggregateInput;
  Article71IndicationBrandBrandAggregationSelection: ResolverTypeWrapper<Article71IndicationBrandBrandAggregationSelection>;
  Article71IndicationBrandBrandNodeAggregateSelection: ResolverTypeWrapper<Article71IndicationBrandBrandNodeAggregateSelection>;
  Article71IndicationBrandConnection: ResolverTypeWrapper<Article71IndicationBrandConnection>;
  Article71IndicationBrandConnectionSort: Article71IndicationBrandConnectionSort;
  Article71IndicationBrandConnectionWhere: Article71IndicationBrandConnectionWhere;
  Article71IndicationBrandNodeAggregationWhereInput: Article71IndicationBrandNodeAggregationWhereInput;
  Article71IndicationBrandRelationship: ResolverTypeWrapper<Article71IndicationBrandRelationship>;
  Article71IndicationCaseCasesAggregationSelection: ResolverTypeWrapper<Article71IndicationCaseCasesAggregationSelection>;
  Article71IndicationCaseCasesNodeAggregateSelection: ResolverTypeWrapper<Article71IndicationCaseCasesNodeAggregateSelection>;
  Article71IndicationCasesAggregateInput: Article71IndicationCasesAggregateInput;
  Article71IndicationCasesConnection: ResolverTypeWrapper<Article71IndicationCasesConnection>;
  Article71IndicationCasesConnectionSort: Article71IndicationCasesConnectionSort;
  Article71IndicationCasesConnectionWhere: Article71IndicationCasesConnectionWhere;
  Article71IndicationCasesNodeAggregationWhereInput: Article71IndicationCasesNodeAggregationWhereInput;
  Article71IndicationCasesRelationship: ResolverTypeWrapper<Article71IndicationCasesRelationship>;
  Article71IndicationEdge: ResolverTypeWrapper<Article71IndicationEdge>;
  Article71IndicationInput: Article71IndicationInput;
  Article71IndicationMainIndicationAggregateInput: Article71IndicationMainIndicationAggregateInput;
  Article71IndicationMainIndicationConnection: ResolverTypeWrapper<Article71IndicationMainIndicationConnection>;
  Article71IndicationMainIndicationConnectionSort: Article71IndicationMainIndicationConnectionSort;
  Article71IndicationMainIndicationConnectionWhere: Article71IndicationMainIndicationConnectionWhere;
  Article71IndicationMainIndicationMainIndicationAggregationSelection: ResolverTypeWrapper<Article71IndicationMainIndicationMainIndicationAggregationSelection>;
  Article71IndicationMainIndicationMainIndicationNodeAggregateSelection: ResolverTypeWrapper<Article71IndicationMainIndicationMainIndicationNodeAggregateSelection>;
  Article71IndicationMainIndicationNodeAggregationWhereInput: Article71IndicationMainIndicationNodeAggregationWhereInput;
  Article71IndicationMainIndicationRelationship: ResolverTypeWrapper<Article71IndicationMainIndicationRelationship>;
  Article71IndicationOptions: Article71IndicationOptions;
  Article71IndicationSort: Article71IndicationSort;
  Article71IndicationWhere: Article71IndicationWhere;
  Article71IndicationsConnection: ResolverTypeWrapper<Article71IndicationsConnection>;
  Article71Status: Article71Status;
  AssigneeStatus: AssigneeStatus;
  AttributeSize: AttributeSize;
  AuthOrganization: ResolverTypeWrapper<AuthOrganization>;
  AuthOrganizationEdge: ResolverTypeWrapper<AuthOrganizationEdge>;
  AuthOrganizationOptions: AuthOrganizationOptions;
  AuthOrganizationSort: AuthOrganizationSort;
  AuthOrganizationWhere: AuthOrganizationWhere;
  AuthOrganizationsConnection: ResolverTypeWrapper<AuthOrganizationsConnection>;
  AutogenerationTrigger: AutogenerationTrigger;
  AvailableTranslations: ResolverTypeWrapper<AvailableTranslations>;
  AvailableTranslationsConnection: ResolverTypeWrapper<AvailableTranslationsConnection>;
  AvailableTranslationsEdge: ResolverTypeWrapper<AvailableTranslationsEdge>;
  AvailableTranslationsOptions: AvailableTranslationsOptions;
  AvailableTranslationsSort: AvailableTranslationsSort;
  AvailableTranslationsWhere: AvailableTranslationsWhere;
  AverageGenericPrice: ResolverTypeWrapper<AverageGenericPrice>;
  AverageGenericPriceEdge: ResolverTypeWrapper<AverageGenericPriceEdge>;
  AverageGenericPriceOptions: AverageGenericPriceOptions;
  AverageGenericPriceSort: AverageGenericPriceSort;
  AverageGenericPriceWhere: AverageGenericPriceWhere;
  AverageGenericPricesConnection: ResolverTypeWrapper<AverageGenericPricesConnection>;
  BaseAgreement: ResolverTypeWrapper<BaseAgreement>;
  BaseAgreementAddedByAggregateInput: BaseAgreementAddedByAggregateInput;
  BaseAgreementAddedByConnection: ResolverTypeWrapper<BaseAgreementAddedByConnection>;
  BaseAgreementAddedByConnectionSort: BaseAgreementAddedByConnectionSort;
  BaseAgreementAddedByConnectionWhere: BaseAgreementAddedByConnectionWhere;
  BaseAgreementAddedByNodeAggregationWhereInput: BaseAgreementAddedByNodeAggregationWhereInput;
  BaseAgreementAddedByRelationship: ResolverTypeWrapper<BaseAgreementAddedByRelationship>;
  BaseAgreementAgreementDecisionDecisionsAggregationSelection: ResolverTypeWrapper<BaseAgreementAgreementDecisionDecisionsAggregationSelection>;
  BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection>;
  BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection: ResolverTypeWrapper<BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection>;
  BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection>;
  BaseAgreementAgreementTagTagsAggregationSelection: ResolverTypeWrapper<BaseAgreementAgreementTagTagsAggregationSelection>;
  BaseAgreementAgreementTagTagsNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementAgreementTagTagsNodeAggregateSelection>;
  BaseAgreementAgreementTemplateTemplateAggregationSelection: ResolverTypeWrapper<BaseAgreementAgreementTemplateTemplateAggregationSelection>;
  BaseAgreementAgreementTemplateTemplateNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementAgreementTemplateTemplateNodeAggregateSelection>;
  BaseAgreementBaseAgreementInitialVersionAggregationSelection: ResolverTypeWrapper<BaseAgreementBaseAgreementInitialVersionAggregationSelection>;
  BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection>;
  BaseAgreementBaseAgreementNextVersionsAggregationSelection: ResolverTypeWrapper<BaseAgreementBaseAgreementNextVersionsAggregationSelection>;
  BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection>;
  BaseAgreementBrandScenariosRelevantBrandsAggregationSelection: ResolverTypeWrapper<BaseAgreementBrandScenariosRelevantBrandsAggregationSelection>;
  BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection>;
  BaseAgreementCaseCasesAggregationSelection: ResolverTypeWrapper<BaseAgreementCaseCasesAggregationSelection>;
  BaseAgreementCaseCasesNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementCaseCasesNodeAggregateSelection>;
  BaseAgreementCasesAggregateInput: BaseAgreementCasesAggregateInput;
  BaseAgreementCasesConnection: ResolverTypeWrapper<BaseAgreementCasesConnection>;
  BaseAgreementCasesConnectionSort: BaseAgreementCasesConnectionSort;
  BaseAgreementCasesConnectionWhere: BaseAgreementCasesConnectionWhere;
  BaseAgreementCasesNodeAggregationWhereInput: BaseAgreementCasesNodeAggregationWhereInput;
  BaseAgreementCasesRelationship: ResolverTypeWrapper<BaseAgreementCasesRelationship>;
  BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection: ResolverTypeWrapper<BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection>;
  BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection>;
  BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection: ResolverTypeWrapper<BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection>;
  BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection: ResolverTypeWrapper<BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection>;
  BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection: ResolverTypeWrapper<BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection>;
  BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection: ResolverTypeWrapper<BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection>;
  BaseAgreementCounterpartiesAggregateInput: BaseAgreementCounterpartiesAggregateInput;
  BaseAgreementCounterpartiesConnection: ResolverTypeWrapper<BaseAgreementCounterpartiesConnection>;
  BaseAgreementCounterpartiesConnectionSort: BaseAgreementCounterpartiesConnectionSort;
  BaseAgreementCounterpartiesConnectionWhere: BaseAgreementCounterpartiesConnectionWhere;
  BaseAgreementCounterpartiesNodeAggregationWhereInput: BaseAgreementCounterpartiesNodeAggregationWhereInput;
  BaseAgreementCounterpartiesRelationship: ResolverTypeWrapper<BaseAgreementCounterpartiesRelationship>;
  BaseAgreementCounterpartyRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['BaseAgreementCounterpartyRelationship']>;
  BaseAgreementCounterpartyRelationshipSort: BaseAgreementCounterpartyRelationshipSort;
  BaseAgreementCounterpartyRelationshipWhere: BaseAgreementCounterpartyRelationshipWhere;
  BaseAgreementCountryAggregateInput: BaseAgreementCountryAggregateInput;
  BaseAgreementCountryConnection: ResolverTypeWrapper<BaseAgreementCountryConnection>;
  BaseAgreementCountryConnectionSort: BaseAgreementCountryConnectionSort;
  BaseAgreementCountryConnectionWhere: BaseAgreementCountryConnectionWhere;
  BaseAgreementCountryCountryAggregationSelection: ResolverTypeWrapper<BaseAgreementCountryCountryAggregationSelection>;
  BaseAgreementCountryCountryNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementCountryCountryNodeAggregateSelection>;
  BaseAgreementCountryNodeAggregationWhereInput: BaseAgreementCountryNodeAggregationWhereInput;
  BaseAgreementCountryRelationship: ResolverTypeWrapper<BaseAgreementCountryRelationship>;
  BaseAgreementCurrencyAggregateInput: BaseAgreementCurrencyAggregateInput;
  BaseAgreementCurrencyConnection: ResolverTypeWrapper<BaseAgreementCurrencyConnection>;
  BaseAgreementCurrencyConnectionSort: BaseAgreementCurrencyConnectionSort;
  BaseAgreementCurrencyConnectionWhere: BaseAgreementCurrencyConnectionWhere;
  BaseAgreementCurrencyCurrencyAggregationSelection: ResolverTypeWrapper<BaseAgreementCurrencyCurrencyAggregationSelection>;
  BaseAgreementCurrencyCurrencyNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementCurrencyCurrencyNodeAggregateSelection>;
  BaseAgreementCurrencyNodeAggregationWhereInput: BaseAgreementCurrencyNodeAggregationWhereInput;
  BaseAgreementCurrencyRelationship: ResolverTypeWrapper<BaseAgreementCurrencyRelationship>;
  BaseAgreementCycleConfigurationCyclesAggregationSelection: ResolverTypeWrapper<BaseAgreementCycleConfigurationCyclesAggregationSelection>;
  BaseAgreementCycleConfigurationCyclesNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementCycleConfigurationCyclesNodeAggregateSelection>;
  BaseAgreementCyclesAggregateInput: BaseAgreementCyclesAggregateInput;
  BaseAgreementCyclesConnection: ResolverTypeWrapper<BaseAgreementCyclesConnection>;
  BaseAgreementCyclesConnectionSort: BaseAgreementCyclesConnectionSort;
  BaseAgreementCyclesConnectionWhere: BaseAgreementCyclesConnectionWhere;
  BaseAgreementCyclesNodeAggregationWhereInput: BaseAgreementCyclesNodeAggregationWhereInput;
  BaseAgreementCyclesRelationship: ResolverTypeWrapper<BaseAgreementCyclesRelationship>;
  BaseAgreementDataContainerDataContainersAggregationSelection: ResolverTypeWrapper<BaseAgreementDataContainerDataContainersAggregationSelection>;
  BaseAgreementDataContainerDataContainersNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementDataContainerDataContainersNodeAggregateSelection>;
  BaseAgreementDataContainersAggregateInput: BaseAgreementDataContainersAggregateInput;
  BaseAgreementDataContainersConnection: ResolverTypeWrapper<BaseAgreementDataContainersConnection>;
  BaseAgreementDataContainersConnectionSort: BaseAgreementDataContainersConnectionSort;
  BaseAgreementDataContainersConnectionWhere: BaseAgreementDataContainersConnectionWhere;
  BaseAgreementDataContainersNodeAggregationWhereInput: BaseAgreementDataContainersNodeAggregationWhereInput;
  BaseAgreementDataContainersRelationship: ResolverTypeWrapper<BaseAgreementDataContainersRelationship>;
  BaseAgreementDataSourceAggregateInput: BaseAgreementDataSourceAggregateInput;
  BaseAgreementDataSourceConnection: ResolverTypeWrapper<BaseAgreementDataSourceConnection>;
  BaseAgreementDataSourceConnectionSort: BaseAgreementDataSourceConnectionSort;
  BaseAgreementDataSourceConnectionWhere: BaseAgreementDataSourceConnectionWhere;
  BaseAgreementDataSourceDataSourceAggregationSelection: ResolverTypeWrapper<BaseAgreementDataSourceDataSourceAggregationSelection>;
  BaseAgreementDataSourceDataSourceNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementDataSourceDataSourceNodeAggregateSelection>;
  BaseAgreementDataSourceNodeAggregationWhereInput: BaseAgreementDataSourceNodeAggregationWhereInput;
  BaseAgreementDataSourceRelationship: ResolverTypeWrapper<BaseAgreementDataSourceRelationship>;
  BaseAgreementDecisionsAggregateInput: BaseAgreementDecisionsAggregateInput;
  BaseAgreementDecisionsConnection: ResolverTypeWrapper<BaseAgreementDecisionsConnection>;
  BaseAgreementDecisionsConnectionSort: BaseAgreementDecisionsConnectionSort;
  BaseAgreementDecisionsConnectionWhere: BaseAgreementDecisionsConnectionWhere;
  BaseAgreementDecisionsNodeAggregationWhereInput: BaseAgreementDecisionsNodeAggregationWhereInput;
  BaseAgreementDecisionsRelationship: ResolverTypeWrapper<BaseAgreementDecisionsRelationship>;
  BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection: ResolverTypeWrapper<BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection>;
  BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection>;
  BaseAgreementDeviceAlternativeSetsAggregateInput: BaseAgreementDeviceAlternativeSetsAggregateInput;
  BaseAgreementDeviceAlternativeSetsConnection: ResolverTypeWrapper<BaseAgreementDeviceAlternativeSetsConnection>;
  BaseAgreementDeviceAlternativeSetsConnectionSort: BaseAgreementDeviceAlternativeSetsConnectionSort;
  BaseAgreementDeviceAlternativeSetsConnectionWhere: BaseAgreementDeviceAlternativeSetsConnectionWhere;
  BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput: BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput;
  BaseAgreementDeviceAlternativeSetsRelationship: ResolverTypeWrapper<BaseAgreementDeviceAlternativeSetsRelationship>;
  BaseAgreementDotThresholdsAggregateInput: BaseAgreementDotThresholdsAggregateInput;
  BaseAgreementDotThresholdsConnection: ResolverTypeWrapper<BaseAgreementDotThresholdsConnection>;
  BaseAgreementDotThresholdsConnectionSort: BaseAgreementDotThresholdsConnectionSort;
  BaseAgreementDotThresholdsConnectionWhere: BaseAgreementDotThresholdsConnectionWhere;
  BaseAgreementDotThresholdsEdgeAggregationWhereInput: BaseAgreementDotThresholdsEdgeAggregationWhereInput;
  BaseAgreementDotThresholdsRelationship: ResolverTypeWrapper<BaseAgreementDotThresholdsRelationship>;
  BaseAgreementEdge: ResolverTypeWrapper<BaseAgreementEdge>;
  BaseAgreementEligibilityConditionRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['BaseAgreementEligibilityConditionRelationship']>;
  BaseAgreementEligibilityConditionRelationshipSort: BaseAgreementEligibilityConditionRelationshipSort;
  BaseAgreementEligibilityConditionRelationshipWhere: BaseAgreementEligibilityConditionRelationshipWhere;
  BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection: ResolverTypeWrapper<BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection>;
  BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection: ResolverTypeWrapper<BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection>;
  BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection>;
  BaseAgreementEligibilityConditionSetsAggregateInput: BaseAgreementEligibilityConditionSetsAggregateInput;
  BaseAgreementEligibilityConditionSetsConnection: ResolverTypeWrapper<BaseAgreementEligibilityConditionSetsConnection>;
  BaseAgreementEligibilityConditionSetsConnectionSort: BaseAgreementEligibilityConditionSetsConnectionSort;
  BaseAgreementEligibilityConditionSetsConnectionWhere: BaseAgreementEligibilityConditionSetsConnectionWhere;
  BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput: BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput;
  BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput: BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput;
  BaseAgreementEligibilityConditionSetsRelationship: ResolverTypeWrapper<BaseAgreementEligibilityConditionSetsRelationship>;
  BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection: ResolverTypeWrapper<BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection>;
  BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection>;
  BaseAgreementEnrollingConditionSetsAggregateInput: BaseAgreementEnrollingConditionSetsAggregateInput;
  BaseAgreementEnrollingConditionSetsConnection: ResolverTypeWrapper<BaseAgreementEnrollingConditionSetsConnection>;
  BaseAgreementEnrollingConditionSetsConnectionSort: BaseAgreementEnrollingConditionSetsConnectionSort;
  BaseAgreementEnrollingConditionSetsConnectionWhere: BaseAgreementEnrollingConditionSetsConnectionWhere;
  BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput: BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput;
  BaseAgreementEnrollingConditionSetsRelationship: ResolverTypeWrapper<BaseAgreementEnrollingConditionSetsRelationship>;
  BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection: ResolverTypeWrapper<BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection>;
  BaseAgreementEnrollingPeriodsAggregateInput: BaseAgreementEnrollingPeriodsAggregateInput;
  BaseAgreementEnrollingPeriodsConnection: ResolverTypeWrapper<BaseAgreementEnrollingPeriodsConnection>;
  BaseAgreementEnrollingPeriodsConnectionSort: BaseAgreementEnrollingPeriodsConnectionSort;
  BaseAgreementEnrollingPeriodsConnectionWhere: BaseAgreementEnrollingPeriodsConnectionWhere;
  BaseAgreementEnrollingPeriodsRelationship: ResolverTypeWrapper<BaseAgreementEnrollingPeriodsRelationship>;
  BaseAgreementFinancialDataPointsAggregateInput: BaseAgreementFinancialDataPointsAggregateInput;
  BaseAgreementFinancialDataPointsConnection: ResolverTypeWrapper<BaseAgreementFinancialDataPointsConnection>;
  BaseAgreementFinancialDataPointsConnectionSort: BaseAgreementFinancialDataPointsConnectionSort;
  BaseAgreementFinancialDataPointsConnectionWhere: BaseAgreementFinancialDataPointsConnectionWhere;
  BaseAgreementFinancialDataPointsNodeAggregationWhereInput: BaseAgreementFinancialDataPointsNodeAggregationWhereInput;
  BaseAgreementFinancialDataPointsRelationship: ResolverTypeWrapper<BaseAgreementFinancialDataPointsRelationship>;
  BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection: ResolverTypeWrapper<BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection>;
  BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection: ResolverTypeWrapper<BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection>;
  BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection>;
  BaseAgreementFinancialSummaryConfigAggregateInput: BaseAgreementFinancialSummaryConfigAggregateInput;
  BaseAgreementFinancialSummaryConfigConnection: ResolverTypeWrapper<BaseAgreementFinancialSummaryConfigConnection>;
  BaseAgreementFinancialSummaryConfigConnectionSort: BaseAgreementFinancialSummaryConfigConnectionSort;
  BaseAgreementFinancialSummaryConfigConnectionWhere: BaseAgreementFinancialSummaryConfigConnectionWhere;
  BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput: BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput;
  BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput: BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput;
  BaseAgreementFinancialSummaryConfigRelationship: ResolverTypeWrapper<BaseAgreementFinancialSummaryConfigRelationship>;
  BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection: ResolverTypeWrapper<BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection>;
  BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection>;
  BaseAgreementInitialVersionAggregateInput: BaseAgreementInitialVersionAggregateInput;
  BaseAgreementInitialVersionConnection: ResolverTypeWrapper<BaseAgreementInitialVersionConnection>;
  BaseAgreementInitialVersionConnectionSort: BaseAgreementInitialVersionConnectionSort;
  BaseAgreementInitialVersionConnectionWhere: BaseAgreementInitialVersionConnectionWhere;
  BaseAgreementInitialVersionNodeAggregationWhereInput: BaseAgreementInitialVersionNodeAggregationWhereInput;
  BaseAgreementInitialVersionRelationship: ResolverTypeWrapper<BaseAgreementInitialVersionRelationship>;
  BaseAgreementNegotiableAttributesAggregateInput: BaseAgreementNegotiableAttributesAggregateInput;
  BaseAgreementNegotiableAttributesConnection: ResolverTypeWrapper<BaseAgreementNegotiableAttributesConnection>;
  BaseAgreementNegotiableAttributesConnectionSort: BaseAgreementNegotiableAttributesConnectionSort;
  BaseAgreementNegotiableAttributesConnectionWhere: BaseAgreementNegotiableAttributesConnectionWhere;
  BaseAgreementNegotiableAttributesNodeAggregationWhereInput: BaseAgreementNegotiableAttributesNodeAggregationWhereInput;
  BaseAgreementNegotiableAttributesRelationship: ResolverTypeWrapper<BaseAgreementNegotiableAttributesRelationship>;
  BaseAgreementNextVersionsAggregateInput: BaseAgreementNextVersionsAggregateInput;
  BaseAgreementNextVersionsConnection: ResolverTypeWrapper<BaseAgreementNextVersionsConnection>;
  BaseAgreementNextVersionsConnectionSort: BaseAgreementNextVersionsConnectionSort;
  BaseAgreementNextVersionsConnectionWhere: BaseAgreementNextVersionsConnectionWhere;
  BaseAgreementNextVersionsNodeAggregationWhereInput: BaseAgreementNextVersionsNodeAggregationWhereInput;
  BaseAgreementNextVersionsRelationship: ResolverTypeWrapper<BaseAgreementNextVersionsRelationship>;
  BaseAgreementOptions: BaseAgreementOptions;
  BaseAgreementOrganizationCounterpartiesAggregationSelection: ResolverTypeWrapper<BaseAgreementOrganizationCounterpartiesAggregationSelection>;
  BaseAgreementOrganizationCounterpartiesNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementOrganizationCounterpartiesNodeAggregateSelection>;
  BaseAgreementPushedByAggregateInput: BaseAgreementPushedByAggregateInput;
  BaseAgreementPushedByConnection: ResolverTypeWrapper<BaseAgreementPushedByConnection>;
  BaseAgreementPushedByConnectionSort: BaseAgreementPushedByConnectionSort;
  BaseAgreementPushedByConnectionWhere: BaseAgreementPushedByConnectionWhere;
  BaseAgreementPushedByNodeAggregationWhereInput: BaseAgreementPushedByNodeAggregationWhereInput;
  BaseAgreementPushedByRelationship: ResolverTypeWrapper<BaseAgreementPushedByRelationship>;
  BaseAgreementRangeChartConfigAggregateInput: BaseAgreementRangeChartConfigAggregateInput;
  BaseAgreementRangeChartConfigConnection: ResolverTypeWrapper<BaseAgreementRangeChartConfigConnection>;
  BaseAgreementRangeChartConfigConnectionSort: BaseAgreementRangeChartConfigConnectionSort;
  BaseAgreementRangeChartConfigConnectionWhere: BaseAgreementRangeChartConfigConnectionWhere;
  BaseAgreementRangeChartConfigEdgeAggregationWhereInput: BaseAgreementRangeChartConfigEdgeAggregationWhereInput;
  BaseAgreementRangeChartConfigRelationship: ResolverTypeWrapper<BaseAgreementRangeChartConfigRelationship>;
  BaseAgreementScenarioScenariosAggregationSelection: ResolverTypeWrapper<BaseAgreementScenarioScenariosAggregationSelection>;
  BaseAgreementScenarioScenariosNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementScenarioScenariosNodeAggregateSelection>;
  BaseAgreementScenariosAggregateInput: BaseAgreementScenariosAggregateInput;
  BaseAgreementScenariosConnection: ResolverTypeWrapper<BaseAgreementScenariosConnection>;
  BaseAgreementScenariosConnectionSort: BaseAgreementScenariosConnectionSort;
  BaseAgreementScenariosConnectionWhere: BaseAgreementScenariosConnectionWhere;
  BaseAgreementScenariosNodeAggregationWhereInput: BaseAgreementScenariosNodeAggregationWhereInput;
  BaseAgreementScenariosRelationship: ResolverTypeWrapper<BaseAgreementScenariosRelationship>;
  BaseAgreementScenariosRelevantBrandsAggregateInput: BaseAgreementScenariosRelevantBrandsAggregateInput;
  BaseAgreementScenariosRelevantBrandsConnection: ResolverTypeWrapper<BaseAgreementScenariosRelevantBrandsConnection>;
  BaseAgreementScenariosRelevantBrandsConnectionSort: BaseAgreementScenariosRelevantBrandsConnectionSort;
  BaseAgreementScenariosRelevantBrandsConnectionWhere: BaseAgreementScenariosRelevantBrandsConnectionWhere;
  BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput: BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput;
  BaseAgreementScenariosRelevantBrandsRelationship: ResolverTypeWrapper<BaseAgreementScenariosRelevantBrandsRelationship>;
  BaseAgreementSort: BaseAgreementSort;
  BaseAgreementStatusTransitionsAggregateInput: BaseAgreementStatusTransitionsAggregateInput;
  BaseAgreementStatusTransitionsConnection: ResolverTypeWrapper<BaseAgreementStatusTransitionsConnection>;
  BaseAgreementStatusTransitionsConnectionSort: BaseAgreementStatusTransitionsConnectionSort;
  BaseAgreementStatusTransitionsConnectionWhere: BaseAgreementStatusTransitionsConnectionWhere;
  BaseAgreementStatusTransitionsNodeAggregationWhereInput: BaseAgreementStatusTransitionsNodeAggregationWhereInput;
  BaseAgreementStatusTransitionsRelationship: ResolverTypeWrapper<BaseAgreementStatusTransitionsRelationship>;
  BaseAgreementTagsAggregateInput: BaseAgreementTagsAggregateInput;
  BaseAgreementTagsConnection: ResolverTypeWrapper<BaseAgreementTagsConnection>;
  BaseAgreementTagsConnectionSort: BaseAgreementTagsConnectionSort;
  BaseAgreementTagsConnectionWhere: BaseAgreementTagsConnectionWhere;
  BaseAgreementTagsNodeAggregationWhereInput: BaseAgreementTagsNodeAggregationWhereInput;
  BaseAgreementTagsRelationship: ResolverTypeWrapper<BaseAgreementTagsRelationship>;
  BaseAgreementTemplateAggregateInput: BaseAgreementTemplateAggregateInput;
  BaseAgreementTemplateConnection: ResolverTypeWrapper<BaseAgreementTemplateConnection>;
  BaseAgreementTemplateConnectionSort: BaseAgreementTemplateConnectionSort;
  BaseAgreementTemplateConnectionWhere: BaseAgreementTemplateConnectionWhere;
  BaseAgreementTemplateNodeAggregationWhereInput: BaseAgreementTemplateNodeAggregationWhereInput;
  BaseAgreementTemplateRelationship: ResolverTypeWrapper<BaseAgreementTemplateRelationship>;
  BaseAgreementTreatmentPriceRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['BaseAgreementTreatmentPriceRelationship']>;
  BaseAgreementTreatmentPriceRelationshipSort: BaseAgreementTreatmentPriceRelationshipSort;
  BaseAgreementTreatmentPriceRelationshipWhere: BaseAgreementTreatmentPriceRelationshipWhere;
  BaseAgreementTreatmentPricesAggregateInput: BaseAgreementTreatmentPricesAggregateInput;
  BaseAgreementTreatmentPricesConnection: ResolverTypeWrapper<BaseAgreementTreatmentPricesConnection>;
  BaseAgreementTreatmentPricesConnectionSort: BaseAgreementTreatmentPricesConnectionSort;
  BaseAgreementTreatmentPricesConnectionWhere: BaseAgreementTreatmentPricesConnectionWhere;
  BaseAgreementTreatmentPricesEdgeAggregationWhereInput: BaseAgreementTreatmentPricesEdgeAggregationWhereInput;
  BaseAgreementTreatmentPricesNodeAggregationWhereInput: BaseAgreementTreatmentPricesNodeAggregationWhereInput;
  BaseAgreementTreatmentPricesRelationship: ResolverTypeWrapper<BaseAgreementTreatmentPricesRelationship>;
  BaseAgreementTreatmentTreatmentPricesAggregationSelection: ResolverTypeWrapper<BaseAgreementTreatmentTreatmentPricesAggregationSelection>;
  BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection: ResolverTypeWrapper<BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection>;
  BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection>;
  BaseAgreementUserAddedByAggregationSelection: ResolverTypeWrapper<BaseAgreementUserAddedByAggregationSelection>;
  BaseAgreementUserAddedByNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementUserAddedByNodeAggregateSelection>;
  BaseAgreementUserContextUserContextsAggregationSelection: ResolverTypeWrapper<BaseAgreementUserContextUserContextsAggregationSelection>;
  BaseAgreementUserContextUserContextsEdgeAggregateSelection: ResolverTypeWrapper<BaseAgreementUserContextUserContextsEdgeAggregateSelection>;
  BaseAgreementUserContextUserContextsNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementUserContextUserContextsNodeAggregateSelection>;
  BaseAgreementUserContextsAggregateInput: BaseAgreementUserContextsAggregateInput;
  BaseAgreementUserContextsConnection: ResolverTypeWrapper<BaseAgreementUserContextsConnection>;
  BaseAgreementUserContextsConnectionSort: BaseAgreementUserContextsConnectionSort;
  BaseAgreementUserContextsConnectionWhere: BaseAgreementUserContextsConnectionWhere;
  BaseAgreementUserContextsEdgeAggregationWhereInput: BaseAgreementUserContextsEdgeAggregationWhereInput;
  BaseAgreementUserContextsNodeAggregationWhereInput: BaseAgreementUserContextsNodeAggregationWhereInput;
  BaseAgreementUserContextsRelationship: ResolverTypeWrapper<BaseAgreementUserContextsRelationship>;
  BaseAgreementUserPushedByAggregationSelection: ResolverTypeWrapper<BaseAgreementUserPushedByAggregationSelection>;
  BaseAgreementUserPushedByNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementUserPushedByNodeAggregateSelection>;
  BaseAgreementUserRoleRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['BaseAgreementUserRoleRelationship']>;
  BaseAgreementUserRoleRelationshipSort: BaseAgreementUserRoleRelationshipSort;
  BaseAgreementUserRoleRelationshipWhere: BaseAgreementUserRoleRelationshipWhere;
  BaseAgreementUserRolesAggregateInput: BaseAgreementUserRolesAggregateInput;
  BaseAgreementUserRolesConnection: ResolverTypeWrapper<BaseAgreementUserRolesConnection>;
  BaseAgreementUserRolesConnectionSort: BaseAgreementUserRolesConnectionSort;
  BaseAgreementUserRolesConnectionWhere: BaseAgreementUserRolesConnectionWhere;
  BaseAgreementUserRolesNodeAggregationWhereInput: BaseAgreementUserRolesNodeAggregationWhereInput;
  BaseAgreementUserRolesRelationship: ResolverTypeWrapper<BaseAgreementUserRolesRelationship>;
  BaseAgreementUserUserRolesAggregationSelection: ResolverTypeWrapper<BaseAgreementUserUserRolesAggregationSelection>;
  BaseAgreementUserUserRolesNodeAggregateSelection: ResolverTypeWrapper<BaseAgreementUserUserRolesNodeAggregateSelection>;
  BaseAgreementWhere: BaseAgreementWhere;
  BaseAgreementsConnection: ResolverTypeWrapper<BaseAgreementsConnection>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Brand: ResolverTypeWrapper<Brand>;
  BrandAndGenericInput: BrandAndGenericInput;
  BrandArt71DataLastUpdatedByAggregateInput: BrandArt71DataLastUpdatedByAggregateInput;
  BrandArt71DataLastUpdatedByConnection: ResolverTypeWrapper<BrandArt71DataLastUpdatedByConnection>;
  BrandArt71DataLastUpdatedByConnectionSort: BrandArt71DataLastUpdatedByConnectionSort;
  BrandArt71DataLastUpdatedByConnectionWhere: BrandArt71DataLastUpdatedByConnectionWhere;
  BrandArt71DataLastUpdatedByNodeAggregationWhereInput: BrandArt71DataLastUpdatedByNodeAggregationWhereInput;
  BrandArt71DataLastUpdatedByRelationship: ResolverTypeWrapper<BrandArt71DataLastUpdatedByRelationship>;
  BrandArticle71IndicationArticle71IndicationsAggregationSelection: ResolverTypeWrapper<BrandArticle71IndicationArticle71IndicationsAggregationSelection>;
  BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection: ResolverTypeWrapper<BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection>;
  BrandArticle71IndicationsAggregateInput: BrandArticle71IndicationsAggregateInput;
  BrandArticle71IndicationsConnection: ResolverTypeWrapper<BrandArticle71IndicationsConnection>;
  BrandArticle71IndicationsConnectionSort: BrandArticle71IndicationsConnectionSort;
  BrandArticle71IndicationsConnectionWhere: BrandArticle71IndicationsConnectionWhere;
  BrandArticle71IndicationsNodeAggregationWhereInput: BrandArticle71IndicationsNodeAggregationWhereInput;
  BrandArticle71IndicationsRelationship: ResolverTypeWrapper<BrandArticle71IndicationsRelationship>;
  BrandEdge: ResolverTypeWrapper<BrandEdge>;
  BrandInput: BrandInput;
  BrandMainIndicationMainIndicationsAggregationSelection: ResolverTypeWrapper<BrandMainIndicationMainIndicationsAggregationSelection>;
  BrandMainIndicationMainIndicationsNodeAggregateSelection: ResolverTypeWrapper<BrandMainIndicationMainIndicationsNodeAggregateSelection>;
  BrandMainIndicationsAggregateInput: BrandMainIndicationsAggregateInput;
  BrandMainIndicationsConnection: ResolverTypeWrapper<BrandMainIndicationsConnection>;
  BrandMainIndicationsConnectionSort: BrandMainIndicationsConnectionSort;
  BrandMainIndicationsConnectionWhere: BrandMainIndicationsConnectionWhere;
  BrandMainIndicationsNodeAggregationWhereInput: BrandMainIndicationsNodeAggregationWhereInput;
  BrandMainIndicationsRelationship: ResolverTypeWrapper<BrandMainIndicationsRelationship>;
  BrandOptions: BrandOptions;
  BrandPreparationPreparationsAggregationSelection: ResolverTypeWrapper<BrandPreparationPreparationsAggregationSelection>;
  BrandPreparationPreparationsNodeAggregateSelection: ResolverTypeWrapper<BrandPreparationPreparationsNodeAggregateSelection>;
  BrandPreparationsAggregateInput: BrandPreparationsAggregateInput;
  BrandPreparationsConnection: ResolverTypeWrapper<BrandPreparationsConnection>;
  BrandPreparationsConnectionSort: BrandPreparationsConnectionSort;
  BrandPreparationsConnectionWhere: BrandPreparationsConnectionWhere;
  BrandPreparationsNodeAggregationWhereInput: BrandPreparationsNodeAggregationWhereInput;
  BrandPreparationsRelationship: ResolverTypeWrapper<BrandPreparationsRelationship>;
  BrandSort: BrandSort;
  BrandUserArt71DataLastUpdatedByAggregationSelection: ResolverTypeWrapper<BrandUserArt71DataLastUpdatedByAggregationSelection>;
  BrandUserArt71DataLastUpdatedByNodeAggregateSelection: ResolverTypeWrapper<BrandUserArt71DataLastUpdatedByNodeAggregateSelection>;
  BrandWhere: BrandWhere;
  BrandsConnection: ResolverTypeWrapper<BrandsConnection>;
  CachedAgreementListItem: ResolverTypeWrapper<CachedAgreementListItem>;
  CachedAgreementListItemEdge: ResolverTypeWrapper<CachedAgreementListItemEdge>;
  CachedAgreementListItemOptions: CachedAgreementListItemOptions;
  CachedAgreementListItemSort: CachedAgreementListItemSort;
  CachedAgreementListItemWhere: CachedAgreementListItemWhere;
  CachedAgreementListItemsConnection: ResolverTypeWrapper<CachedAgreementListItemsConnection>;
  CanPushAgreementInput: CanPushAgreementInput;
  CanadianPriceType: CanadianPriceType;
  Case: ResolverTypeWrapper<Case>;
  CaseAgreementBaseAgreementAggregationSelection: ResolverTypeWrapper<CaseAgreementBaseAgreementAggregationSelection>;
  CaseAgreementBaseAgreementNodeAggregateSelection: ResolverTypeWrapper<CaseAgreementBaseAgreementNodeAggregateSelection>;
  CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection: ResolverTypeWrapper<CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection>;
  CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection: ResolverTypeWrapper<CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection>;
  CaseBaseAgreementAggregateInput: CaseBaseAgreementAggregateInput;
  CaseBaseAgreementConnection: ResolverTypeWrapper<CaseBaseAgreementConnection>;
  CaseBaseAgreementConnectionSort: CaseBaseAgreementConnectionSort;
  CaseBaseAgreementConnectionWhere: CaseBaseAgreementConnectionWhere;
  CaseBaseAgreementNodeAggregationWhereInput: CaseBaseAgreementNodeAggregationWhereInput;
  CaseBaseAgreementRelationship: ResolverTypeWrapper<CaseBaseAgreementRelationship>;
  CaseEdge: ResolverTypeWrapper<CaseEdge>;
  CaseFinancialDataPointsAggregateInput: CaseFinancialDataPointsAggregateInput;
  CaseFinancialDataPointsConnection: ResolverTypeWrapper<CaseFinancialDataPointsConnection>;
  CaseFinancialDataPointsConnectionSort: CaseFinancialDataPointsConnectionSort;
  CaseFinancialDataPointsConnectionWhere: CaseFinancialDataPointsConnectionWhere;
  CaseFinancialDataPointsNodeAggregationWhereInput: CaseFinancialDataPointsNodeAggregationWhereInput;
  CaseFinancialDataPointsRelationship: ResolverTypeWrapper<CaseFinancialDataPointsRelationship>;
  CaseFlexEntitiesAggregateInput: CaseFlexEntitiesAggregateInput;
  CaseFlexEntitiesConnection: ResolverTypeWrapper<CaseFlexEntitiesConnection>;
  CaseFlexEntitiesConnectionSort: CaseFlexEntitiesConnectionSort;
  CaseFlexEntitiesConnectionWhere: CaseFlexEntitiesConnectionWhere;
  CaseFlexEntitiesNodeAggregationWhereInput: CaseFlexEntitiesNodeAggregationWhereInput;
  CaseFlexEntitiesRelationship: ResolverTypeWrapper<CaseFlexEntitiesRelationship>;
  CaseFlexEntityFlexEntitiesAggregationSelection: ResolverTypeWrapper<CaseFlexEntityFlexEntitiesAggregationSelection>;
  CaseFlexEntityFlexEntitiesNodeAggregateSelection: ResolverTypeWrapper<CaseFlexEntityFlexEntitiesNodeAggregateSelection>;
  CaseFlexEntityRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CaseFlexEntityRelationship']>;
  CaseFlexEntityRelationshipSort: CaseFlexEntityRelationshipSort;
  CaseFlexEntityRelationshipWhere: CaseFlexEntityRelationshipWhere;
  CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection: ResolverTypeWrapper<CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection>;
  CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection: ResolverTypeWrapper<CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection>;
  CaseNegotiationRoundNegotiationRoundsAggregationSelection: ResolverTypeWrapper<CaseNegotiationRoundNegotiationRoundsAggregationSelection>;
  CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection: ResolverTypeWrapper<CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection>;
  CaseNegotiationRoundsAggregateInput: CaseNegotiationRoundsAggregateInput;
  CaseNegotiationRoundsConnection: ResolverTypeWrapper<CaseNegotiationRoundsConnection>;
  CaseNegotiationRoundsConnectionSort: CaseNegotiationRoundsConnectionSort;
  CaseNegotiationRoundsConnectionWhere: CaseNegotiationRoundsConnectionWhere;
  CaseNegotiationRoundsNodeAggregationWhereInput: CaseNegotiationRoundsNodeAggregationWhereInput;
  CaseNegotiationRoundsRelationship: ResolverTypeWrapper<CaseNegotiationRoundsRelationship>;
  CaseOptions: CaseOptions;
  CaseRefundRefundsAggregationSelection: ResolverTypeWrapper<CaseRefundRefundsAggregationSelection>;
  CaseRefundRefundsNodeAggregateSelection: ResolverTypeWrapper<CaseRefundRefundsNodeAggregateSelection>;
  CaseRefundsAggregateInput: CaseRefundsAggregateInput;
  CaseRefundsConnection: ResolverTypeWrapper<CaseRefundsConnection>;
  CaseRefundsConnectionSort: CaseRefundsConnectionSort;
  CaseRefundsConnectionWhere: CaseRefundsConnectionWhere;
  CaseRefundsNodeAggregationWhereInput: CaseRefundsNodeAggregationWhereInput;
  CaseRefundsRelationship: ResolverTypeWrapper<CaseRefundsRelationship>;
  CaseRelevantArticle71IndicationAggregateInput: CaseRelevantArticle71IndicationAggregateInput;
  CaseRelevantArticle71IndicationConnection: ResolverTypeWrapper<CaseRelevantArticle71IndicationConnection>;
  CaseRelevantArticle71IndicationConnectionSort: CaseRelevantArticle71IndicationConnectionSort;
  CaseRelevantArticle71IndicationConnectionWhere: CaseRelevantArticle71IndicationConnectionWhere;
  CaseRelevantArticle71IndicationNodeAggregationWhereInput: CaseRelevantArticle71IndicationNodeAggregationWhereInput;
  CaseRelevantArticle71IndicationRelationship: ResolverTypeWrapper<CaseRelevantArticle71IndicationRelationship>;
  CaseSort: CaseSort;
  CaseWhere: CaseWhere;
  CasesConnection: ResolverTypeWrapper<CasesConnection>;
  CatalogueAttribute: ResolverTypeWrapper<CatalogueAttribute>;
  CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection: ResolverTypeWrapper<CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection>;
  CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection: ResolverTypeWrapper<CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection>;
  CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection: ResolverTypeWrapper<CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection>;
  CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection: ResolverTypeWrapper<CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection>;
  CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection: ResolverTypeWrapper<CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection>;
  CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection: ResolverTypeWrapper<CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection>;
  CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection: ResolverTypeWrapper<CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection>;
  CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection: ResolverTypeWrapper<CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection>;
  CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection: ResolverTypeWrapper<CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection>;
  CatalogueAttributeCustomConditionAggregateInput: CatalogueAttributeCustomConditionAggregateInput;
  CatalogueAttributeCustomConditionConnection: ResolverTypeWrapper<CatalogueAttributeCustomConditionConnection>;
  CatalogueAttributeCustomConditionConnectionSort: CatalogueAttributeCustomConditionConnectionSort;
  CatalogueAttributeCustomConditionConnectionWhere: CatalogueAttributeCustomConditionConnectionWhere;
  CatalogueAttributeCustomConditionCustomConditionAggregationSelection: ResolverTypeWrapper<CatalogueAttributeCustomConditionCustomConditionAggregationSelection>;
  CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection: ResolverTypeWrapper<CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection>;
  CatalogueAttributeCustomConditionNodeAggregationWhereInput: CatalogueAttributeCustomConditionNodeAggregationWhereInput;
  CatalogueAttributeCustomConditionRelationship: ResolverTypeWrapper<CatalogueAttributeCustomConditionRelationship>;
  CatalogueAttributeDependsOnAggregateInput: CatalogueAttributeDependsOnAggregateInput;
  CatalogueAttributeDependsOnConnection: ResolverTypeWrapper<CatalogueAttributeDependsOnConnection>;
  CatalogueAttributeDependsOnConnectionSort: CatalogueAttributeDependsOnConnectionSort;
  CatalogueAttributeDependsOnConnectionWhere: CatalogueAttributeDependsOnConnectionWhere;
  CatalogueAttributeDependsOnEdgeAggregationWhereInput: CatalogueAttributeDependsOnEdgeAggregationWhereInput;
  CatalogueAttributeDependsOnNodeAggregationWhereInput: CatalogueAttributeDependsOnNodeAggregationWhereInput;
  CatalogueAttributeDependsOnRelationship: ResolverTypeWrapper<CatalogueAttributeDependsOnRelationship>;
  CatalogueAttributeEdge: ResolverTypeWrapper<CatalogueAttributeEdge>;
  CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection: ResolverTypeWrapper<CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection>;
  CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection: ResolverTypeWrapper<CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection>;
  CatalogueAttributeFlexEntityTypesAggregateInput: CatalogueAttributeFlexEntityTypesAggregateInput;
  CatalogueAttributeFlexEntityTypesConnection: ResolverTypeWrapper<CatalogueAttributeFlexEntityTypesConnection>;
  CatalogueAttributeFlexEntityTypesConnectionSort: CatalogueAttributeFlexEntityTypesConnectionSort;
  CatalogueAttributeFlexEntityTypesConnectionWhere: CatalogueAttributeFlexEntityTypesConnectionWhere;
  CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput: CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput;
  CatalogueAttributeFlexEntityTypesRelationship: ResolverTypeWrapper<CatalogueAttributeFlexEntityTypesRelationship>;
  CatalogueAttributeHasDependantAggregateInput: CatalogueAttributeHasDependantAggregateInput;
  CatalogueAttributeHasDependantConnection: ResolverTypeWrapper<CatalogueAttributeHasDependantConnection>;
  CatalogueAttributeHasDependantConnectionSort: CatalogueAttributeHasDependantConnectionSort;
  CatalogueAttributeHasDependantConnectionWhere: CatalogueAttributeHasDependantConnectionWhere;
  CatalogueAttributeHasDependantEdgeAggregationWhereInput: CatalogueAttributeHasDependantEdgeAggregationWhereInput;
  CatalogueAttributeHasDependantNodeAggregationWhereInput: CatalogueAttributeHasDependantNodeAggregationWhereInput;
  CatalogueAttributeHasDependantRelationship: ResolverTypeWrapper<CatalogueAttributeHasDependantRelationship>;
  CatalogueAttributeMutuallyRelevantAggregateInput: CatalogueAttributeMutuallyRelevantAggregateInput;
  CatalogueAttributeMutuallyRelevantConnection: ResolverTypeWrapper<CatalogueAttributeMutuallyRelevantConnection>;
  CatalogueAttributeMutuallyRelevantConnectionSort: CatalogueAttributeMutuallyRelevantConnectionSort;
  CatalogueAttributeMutuallyRelevantConnectionWhere: CatalogueAttributeMutuallyRelevantConnectionWhere;
  CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput: CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput;
  CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput: CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput;
  CatalogueAttributeMutuallyRelevantRelationship: ResolverTypeWrapper<CatalogueAttributeMutuallyRelevantRelationship>;
  CatalogueAttributeOptions: CatalogueAttributeOptions;
  CatalogueAttributeSort: CatalogueAttributeSort;
  CatalogueAttributeType: CatalogueAttributeType;
  CatalogueAttributeWhere: CatalogueAttributeWhere;
  CatalogueAttributesConnection: ResolverTypeWrapper<CatalogueAttributesConnection>;
  ChartRangeConfigInput: ChartRangeConfigInput;
  ChartRangeConfiguration: ResolverTypeWrapper<ChartRangeConfiguration>;
  ChartRangeConfigurationEdge: ResolverTypeWrapper<ChartRangeConfigurationEdge>;
  ChartRangeConfigurationOptions: ChartRangeConfigurationOptions;
  ChartRangeConfigurationRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ChartRangeConfigurationRelationship']>;
  ChartRangeConfigurationRelationshipSort: ChartRangeConfigurationRelationshipSort;
  ChartRangeConfigurationRelationshipWhere: ChartRangeConfigurationRelationshipWhere;
  ChartRangeConfigurationSort: ChartRangeConfigurationSort;
  ChartRangeConfigurationWhere: ChartRangeConfigurationWhere;
  ChartRangeConfigurationsConnection: ResolverTypeWrapper<ChartRangeConfigurationsConnection>;
  CheckedType: ResolverTypeWrapper<CheckedType>;
  CheckedTypeEdge: ResolverTypeWrapper<CheckedTypeEdge>;
  CheckedTypeOptions: CheckedTypeOptions;
  CheckedTypeSort: CheckedTypeSort;
  CheckedTypeWhere: CheckedTypeWhere;
  CheckedTypesConnection: ResolverTypeWrapper<CheckedTypesConnection>;
  ClusterWorkerMetric: ResolverTypeWrapper<ClusterWorkerMetric>;
  ClusterWorkerMetricEdge: ResolverTypeWrapper<ClusterWorkerMetricEdge>;
  ClusterWorkerMetricOptions: ClusterWorkerMetricOptions;
  ClusterWorkerMetricSort: ClusterWorkerMetricSort;
  ClusterWorkerMetricWhere: ClusterWorkerMetricWhere;
  ClusterWorkerMetricsConnection: ResolverTypeWrapper<ClusterWorkerMetricsConnection>;
  ClusterWorkersSnapshot: ResolverTypeWrapper<ClusterWorkersSnapshot>;
  ClusterWorkersSnapshotEdge: ResolverTypeWrapper<ClusterWorkersSnapshotEdge>;
  ClusterWorkersSnapshotOptions: ClusterWorkersSnapshotOptions;
  ClusterWorkersSnapshotSort: ClusterWorkersSnapshotSort;
  ClusterWorkersSnapshotWhere: ClusterWorkersSnapshotWhere;
  ClusterWorkersSnapshotsConnection: ResolverTypeWrapper<ClusterWorkersSnapshotsConnection>;
  CodeCategory: CodeCategory;
  ConditionConsideredRating: ConditionConsideredRating;
  ConditionConsideredSecIntervention: ConditionConsideredSecIntervention;
  ConditionLogicalOperator: ConditionLogicalOperator;
  ConditionType: ConditionType;
  Config: ResolverTypeWrapper<Config>;
  ConfigEdge: ResolverTypeWrapper<ConfigEdge>;
  ConfigOptions: ConfigOptions;
  ConfigSort: ConfigSort;
  ConfigWhere: ConfigWhere;
  ConfigsConnection: ResolverTypeWrapper<ConfigsConnection>;
  ConfigurableChartType: ConfigurableChartType;
  ContactPersonInput: ContactPersonInput;
  ContractStatus: ContractStatus;
  CosmosMetric: ResolverTypeWrapper<CosmosMetric>;
  CosmosMetricEdge: ResolverTypeWrapper<CosmosMetricEdge>;
  CosmosMetricOptions: CosmosMetricOptions;
  CosmosMetricSort: CosmosMetricSort;
  CosmosMetricWhere: CosmosMetricWhere;
  CosmosMetricsConnection: ResolverTypeWrapper<CosmosMetricsConnection>;
  CountdownOperator: CountdownOperator;
  CountdownPoint: CountdownPoint;
  CounterpartyRole: CounterpartyRole;
  CountriesConnection: ResolverTypeWrapper<CountriesConnection>;
  Country: ResolverTypeWrapper<Country>;
  CountryAgreementScopeScopesAggregationSelection: ResolverTypeWrapper<CountryAgreementScopeScopesAggregationSelection>;
  CountryAgreementScopeScopesEdgeAggregateSelection: ResolverTypeWrapper<CountryAgreementScopeScopesEdgeAggregateSelection>;
  CountryAgreementScopeScopesNodeAggregateSelection: ResolverTypeWrapper<CountryAgreementScopeScopesNodeAggregateSelection>;
  CountryCurrenciesAggregateInput: CountryCurrenciesAggregateInput;
  CountryCurrenciesConnection: ResolverTypeWrapper<CountryCurrenciesConnection>;
  CountryCurrenciesConnectionSort: CountryCurrenciesConnectionSort;
  CountryCurrenciesConnectionWhere: CountryCurrenciesConnectionWhere;
  CountryCurrenciesNodeAggregationWhereInput: CountryCurrenciesNodeAggregationWhereInput;
  CountryCurrenciesRelationship: ResolverTypeWrapper<CountryCurrenciesRelationship>;
  CountryCurrencyCurrenciesAggregationSelection: ResolverTypeWrapper<CountryCurrencyCurrenciesAggregationSelection>;
  CountryCurrencyCurrenciesNodeAggregateSelection: ResolverTypeWrapper<CountryCurrencyCurrenciesNodeAggregateSelection>;
  CountryEdge: ResolverTypeWrapper<CountryEdge>;
  CountryInput: CountryInput;
  CountryOptions: CountryOptions;
  CountryOrganizationOrganizationsAggregationSelection: ResolverTypeWrapper<CountryOrganizationOrganizationsAggregationSelection>;
  CountryOrganizationOrganizationsNodeAggregateSelection: ResolverTypeWrapper<CountryOrganizationOrganizationsNodeAggregateSelection>;
  CountryOrganizationsAggregateInput: CountryOrganizationsAggregateInput;
  CountryOrganizationsConnection: ResolverTypeWrapper<CountryOrganizationsConnection>;
  CountryOrganizationsConnectionSort: CountryOrganizationsConnectionSort;
  CountryOrganizationsConnectionWhere: CountryOrganizationsConnectionWhere;
  CountryOrganizationsNodeAggregationWhereInput: CountryOrganizationsNodeAggregationWhereInput;
  CountryOrganizationsRelationship: ResolverTypeWrapper<CountryOrganizationsRelationship>;
  CountryScopeRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CountryScopeRelationship']>;
  CountryScopeRelationshipSort: CountryScopeRelationshipSort;
  CountryScopeRelationshipWhere: CountryScopeRelationshipWhere;
  CountryScopesAggregateInput: CountryScopesAggregateInput;
  CountryScopesConnection: ResolverTypeWrapper<CountryScopesConnection>;
  CountryScopesConnectionSort: CountryScopesConnectionSort;
  CountryScopesConnectionWhere: CountryScopesConnectionWhere;
  CountryScopesEdgeAggregationWhereInput: CountryScopesEdgeAggregationWhereInput;
  CountryScopesNodeAggregationWhereInput: CountryScopesNodeAggregationWhereInput;
  CountryScopesRelationship: ResolverTypeWrapper<CountryScopesRelationship>;
  CountrySort: CountrySort;
  CountryTreatmentTreatmentsAggregationSelection: ResolverTypeWrapper<CountryTreatmentTreatmentsAggregationSelection>;
  CountryTreatmentTreatmentsNodeAggregateSelection: ResolverTypeWrapper<CountryTreatmentTreatmentsNodeAggregateSelection>;
  CountryTreatmentsAggregateInput: CountryTreatmentsAggregateInput;
  CountryTreatmentsConnection: ResolverTypeWrapper<CountryTreatmentsConnection>;
  CountryTreatmentsConnectionSort: CountryTreatmentsConnectionSort;
  CountryTreatmentsConnectionWhere: CountryTreatmentsConnectionWhere;
  CountryTreatmentsNodeAggregationWhereInput: CountryTreatmentsNodeAggregationWhereInput;
  CountryTreatmentsRelationship: ResolverTypeWrapper<CountryTreatmentsRelationship>;
  CountryWhere: CountryWhere;
  CoverageRequestRating: CoverageRequestRating;
  CoverageRequestTherapyDecision: CoverageRequestTherapyDecision;
  CrossCountryPrice: ResolverTypeWrapper<CrossCountryPrice>;
  CrossCountryPriceEdge: ResolverTypeWrapper<CrossCountryPriceEdge>;
  CrossCountryPriceOptions: CrossCountryPriceOptions;
  CrossCountryPriceSort: CrossCountryPriceSort;
  CrossCountryPriceWhere: CrossCountryPriceWhere;
  CrossCountryPricesConnection: ResolverTypeWrapper<CrossCountryPricesConnection>;
  CurrenciesConnection: ResolverTypeWrapper<CurrenciesConnection>;
  Currency: ResolverTypeWrapper<Currency>;
  CurrencyAgreementAgreementsAggregationSelection: ResolverTypeWrapper<CurrencyAgreementAgreementsAggregationSelection>;
  CurrencyAgreementAgreementsNodeAggregateSelection: ResolverTypeWrapper<CurrencyAgreementAgreementsNodeAggregateSelection>;
  CurrencyAgreementsAggregateInput: CurrencyAgreementsAggregateInput;
  CurrencyAgreementsConnection: ResolverTypeWrapper<CurrencyAgreementsConnection>;
  CurrencyAgreementsConnectionSort: CurrencyAgreementsConnectionSort;
  CurrencyAgreementsConnectionWhere: CurrencyAgreementsConnectionWhere;
  CurrencyAgreementsNodeAggregationWhereInput: CurrencyAgreementsNodeAggregationWhereInput;
  CurrencyAgreementsRelationship: ResolverTypeWrapper<CurrencyAgreementsRelationship>;
  CurrencyCountriesAggregateInput: CurrencyCountriesAggregateInput;
  CurrencyCountriesConnection: ResolverTypeWrapper<CurrencyCountriesConnection>;
  CurrencyCountriesConnectionSort: CurrencyCountriesConnectionSort;
  CurrencyCountriesConnectionWhere: CurrencyCountriesConnectionWhere;
  CurrencyCountriesNodeAggregationWhereInput: CurrencyCountriesNodeAggregationWhereInput;
  CurrencyCountriesRelationship: ResolverTypeWrapper<CurrencyCountriesRelationship>;
  CurrencyCountryCountriesAggregationSelection: ResolverTypeWrapper<CurrencyCountryCountriesAggregationSelection>;
  CurrencyCountryCountriesNodeAggregateSelection: ResolverTypeWrapper<CurrencyCountryCountriesNodeAggregateSelection>;
  CurrencyEdge: ResolverTypeWrapper<CurrencyEdge>;
  CurrencyOptions: CurrencyOptions;
  CurrencyPricePricesAggregationSelection: ResolverTypeWrapper<CurrencyPricePricesAggregationSelection>;
  CurrencyPricePricesNodeAggregateSelection: ResolverTypeWrapper<CurrencyPricePricesNodeAggregateSelection>;
  CurrencyPricesAggregateInput: CurrencyPricesAggregateInput;
  CurrencyPricesConnection: ResolverTypeWrapper<CurrencyPricesConnection>;
  CurrencyPricesConnectionSort: CurrencyPricesConnectionSort;
  CurrencyPricesConnectionWhere: CurrencyPricesConnectionWhere;
  CurrencyPricesNodeAggregationWhereInput: CurrencyPricesNodeAggregationWhereInput;
  CurrencyPricesRelationship: ResolverTypeWrapper<CurrencyPricesRelationship>;
  CurrencySort: CurrencySort;
  CurrencyWhere: CurrencyWhere;
  CustomConclusiveConditionDropdownOptionInput: CustomConclusiveConditionDropdownOptionInput;
  CustomCondition: ResolverTypeWrapper<CustomCondition>;
  CustomConditionAttributeAggregateInput: CustomConditionAttributeAggregateInput;
  CustomConditionAttributeConnection: ResolverTypeWrapper<CustomConditionAttributeConnection>;
  CustomConditionAttributeConnectionSort: CustomConditionAttributeConnectionSort;
  CustomConditionAttributeConnectionWhere: CustomConditionAttributeConnectionWhere;
  CustomConditionAttributeInput: CustomConditionAttributeInput;
  CustomConditionAttributeNodeAggregationWhereInput: CustomConditionAttributeNodeAggregationWhereInput;
  CustomConditionAttributeRelationship: ResolverTypeWrapper<CustomConditionAttributeRelationship>;
  CustomConditionCatalogueAttributeAttributeAggregationSelection: ResolverTypeWrapper<CustomConditionCatalogueAttributeAttributeAggregationSelection>;
  CustomConditionCatalogueAttributeAttributeNodeAggregateSelection: ResolverTypeWrapper<CustomConditionCatalogueAttributeAttributeNodeAggregateSelection>;
  CustomConditionCreatedByAggregateInput: CustomConditionCreatedByAggregateInput;
  CustomConditionCreatedByConnection: ResolverTypeWrapper<CustomConditionCreatedByConnection>;
  CustomConditionCreatedByConnectionSort: CustomConditionCreatedByConnectionSort;
  CustomConditionCreatedByConnectionWhere: CustomConditionCreatedByConnectionWhere;
  CustomConditionCreatedByNodeAggregationWhereInput: CustomConditionCreatedByNodeAggregationWhereInput;
  CustomConditionCreatedByRelationship: ResolverTypeWrapper<CustomConditionCreatedByRelationship>;
  CustomConditionEdge: ResolverTypeWrapper<CustomConditionEdge>;
  CustomConditionEventFrequency: CustomConditionEventFrequency;
  CustomConditionEventResult: CustomConditionEventResult;
  CustomConditionEventType: CustomConditionEventType;
  CustomConditionFieldType: CustomConditionFieldType;
  CustomConditionOptions: CustomConditionOptions;
  CustomConditionSort: CustomConditionSort;
  CustomConditionType: CustomConditionType;
  CustomConditionUserCreatedByAggregationSelection: ResolverTypeWrapper<CustomConditionUserCreatedByAggregationSelection>;
  CustomConditionUserCreatedByNodeAggregateSelection: ResolverTypeWrapper<CustomConditionUserCreatedByNodeAggregateSelection>;
  CustomConditionWhere: CustomConditionWhere;
  CustomConditionsConnection: ResolverTypeWrapper<CustomConditionsConnection>;
  CustomIntegrityCheck: ResolverTypeWrapper<CustomIntegrityCheck>;
  CustomIntegrityCheckEdge: ResolverTypeWrapper<CustomIntegrityCheckEdge>;
  CustomIntegrityCheckOptions: CustomIntegrityCheckOptions;
  CustomIntegrityCheckSort: CustomIntegrityCheckSort;
  CustomIntegrityCheckWhere: CustomIntegrityCheckWhere;
  CustomIntegrityChecksConnection: ResolverTypeWrapper<CustomIntegrityChecksConnection>;
  CycleAdherence: CycleAdherence;
  CycleConfiguration: ResolverTypeWrapper<CycleConfiguration>;
  CycleConfigurationAgreementScopeScopeAggregationSelection: ResolverTypeWrapper<CycleConfigurationAgreementScopeScopeAggregationSelection>;
  CycleConfigurationAgreementScopeScopeNodeAggregateSelection: ResolverTypeWrapper<CycleConfigurationAgreementScopeScopeNodeAggregateSelection>;
  CycleConfigurationBrandStartingTreatmentBrandAggregationSelection: ResolverTypeWrapper<CycleConfigurationBrandStartingTreatmentBrandAggregationSelection>;
  CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection: ResolverTypeWrapper<CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection>;
  CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection: ResolverTypeWrapper<CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection>;
  CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection: ResolverTypeWrapper<CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection>;
  CycleConfigurationEdge: ResolverTypeWrapper<CycleConfigurationEdge>;
  CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection: ResolverTypeWrapper<CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection>;
  CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection: ResolverTypeWrapper<CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection>;
  CycleConfigurationGenericStartingTreatmentGenericAggregationSelection: ResolverTypeWrapper<CycleConfigurationGenericStartingTreatmentGenericAggregationSelection>;
  CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection: ResolverTypeWrapper<CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection>;
  CycleConfigurationInput: CycleConfigurationInput;
  CycleConfigurationOptions: CycleConfigurationOptions;
  CycleConfigurationRecordTypeAggregateInput: CycleConfigurationRecordTypeAggregateInput;
  CycleConfigurationRecordTypeConnection: ResolverTypeWrapper<CycleConfigurationRecordTypeConnection>;
  CycleConfigurationRecordTypeConnectionSort: CycleConfigurationRecordTypeConnectionSort;
  CycleConfigurationRecordTypeConnectionWhere: CycleConfigurationRecordTypeConnectionWhere;
  CycleConfigurationRecordTypeNodeAggregationWhereInput: CycleConfigurationRecordTypeNodeAggregationWhereInput;
  CycleConfigurationRecordTypeRelationship: ResolverTypeWrapper<CycleConfigurationRecordTypeRelationship>;
  CycleConfigurationScopeAggregateInput: CycleConfigurationScopeAggregateInput;
  CycleConfigurationScopeConnection: ResolverTypeWrapper<CycleConfigurationScopeConnection>;
  CycleConfigurationScopeConnectionSort: CycleConfigurationScopeConnectionSort;
  CycleConfigurationScopeConnectionWhere: CycleConfigurationScopeConnectionWhere;
  CycleConfigurationScopeNodeAggregationWhereInput: CycleConfigurationScopeNodeAggregationWhereInput;
  CycleConfigurationScopeRelationship: ResolverTypeWrapper<CycleConfigurationScopeRelationship>;
  CycleConfigurationSort: CycleConfigurationSort;
  CycleConfigurationStartingTreatmentAggregateInput: CycleConfigurationStartingTreatmentAggregateInput;
  CycleConfigurationStartingTreatmentBrandAggregateInput: CycleConfigurationStartingTreatmentBrandAggregateInput;
  CycleConfigurationStartingTreatmentBrandConnection: ResolverTypeWrapper<CycleConfigurationStartingTreatmentBrandConnection>;
  CycleConfigurationStartingTreatmentBrandConnectionSort: CycleConfigurationStartingTreatmentBrandConnectionSort;
  CycleConfigurationStartingTreatmentBrandConnectionWhere: CycleConfigurationStartingTreatmentBrandConnectionWhere;
  CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput: CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput;
  CycleConfigurationStartingTreatmentBrandRelationship: ResolverTypeWrapper<CycleConfigurationStartingTreatmentBrandRelationship>;
  CycleConfigurationStartingTreatmentConnection: ResolverTypeWrapper<CycleConfigurationStartingTreatmentConnection>;
  CycleConfigurationStartingTreatmentConnectionSort: CycleConfigurationStartingTreatmentConnectionSort;
  CycleConfigurationStartingTreatmentConnectionWhere: CycleConfigurationStartingTreatmentConnectionWhere;
  CycleConfigurationStartingTreatmentGenericAggregateInput: CycleConfigurationStartingTreatmentGenericAggregateInput;
  CycleConfigurationStartingTreatmentGenericConnection: ResolverTypeWrapper<CycleConfigurationStartingTreatmentGenericConnection>;
  CycleConfigurationStartingTreatmentGenericConnectionSort: CycleConfigurationStartingTreatmentGenericConnectionSort;
  CycleConfigurationStartingTreatmentGenericConnectionWhere: CycleConfigurationStartingTreatmentGenericConnectionWhere;
  CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput: CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput;
  CycleConfigurationStartingTreatmentGenericRelationship: ResolverTypeWrapper<CycleConfigurationStartingTreatmentGenericRelationship>;
  CycleConfigurationStartingTreatmentNodeAggregationWhereInput: CycleConfigurationStartingTreatmentNodeAggregationWhereInput;
  CycleConfigurationStartingTreatmentRelationship: ResolverTypeWrapper<CycleConfigurationStartingTreatmentRelationship>;
  CycleConfigurationTherapiesAggregateInput: CycleConfigurationTherapiesAggregateInput;
  CycleConfigurationTherapiesConnection: ResolverTypeWrapper<CycleConfigurationTherapiesConnection>;
  CycleConfigurationTherapiesConnectionSort: CycleConfigurationTherapiesConnectionSort;
  CycleConfigurationTherapiesConnectionWhere: CycleConfigurationTherapiesConnectionWhere;
  CycleConfigurationTherapiesNodeAggregationWhereInput: CycleConfigurationTherapiesNodeAggregationWhereInput;
  CycleConfigurationTherapiesRelationship: ResolverTypeWrapper<CycleConfigurationTherapiesRelationship>;
  CycleConfigurationTreatmentStartingTreatmentAggregationSelection: ResolverTypeWrapper<CycleConfigurationTreatmentStartingTreatmentAggregationSelection>;
  CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection: ResolverTypeWrapper<CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection>;
  CycleConfigurationWhere: CycleConfigurationWhere;
  CycleConfigurationsConnection: ResolverTypeWrapper<CycleConfigurationsConnection>;
  CycleStartingPoint: CycleStartingPoint;
  CycleTherapyConfiguration: ResolverTypeWrapper<CycleTherapyConfiguration>;
  CycleTherapyConfigurationEdge: ResolverTypeWrapper<CycleTherapyConfigurationEdge>;
  CycleTherapyConfigurationInput: CycleTherapyConfigurationInput;
  CycleTherapyConfigurationOptions: CycleTherapyConfigurationOptions;
  CycleTherapyConfigurationSort: CycleTherapyConfigurationSort;
  CycleTherapyConfigurationTreatmentSetAggregateInput: CycleTherapyConfigurationTreatmentSetAggregateInput;
  CycleTherapyConfigurationTreatmentSetConnection: ResolverTypeWrapper<CycleTherapyConfigurationTreatmentSetConnection>;
  CycleTherapyConfigurationTreatmentSetConnectionSort: CycleTherapyConfigurationTreatmentSetConnectionSort;
  CycleTherapyConfigurationTreatmentSetConnectionWhere: CycleTherapyConfigurationTreatmentSetConnectionWhere;
  CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput: CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput;
  CycleTherapyConfigurationTreatmentSetRelationship: ResolverTypeWrapper<CycleTherapyConfigurationTreatmentSetRelationship>;
  CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection: ResolverTypeWrapper<CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection>;
  CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection: ResolverTypeWrapper<CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection>;
  CycleTherapyConfigurationWhere: CycleTherapyConfigurationWhere;
  CycleTherapyConfigurationsConnection: ResolverTypeWrapper<CycleTherapyConfigurationsConnection>;
  DQCDetailedReportRaw: ResolverTypeWrapper<DqcDetailedReportRaw>;
  DQCDetailedReportRawEdge: ResolverTypeWrapper<DqcDetailedReportRawEdge>;
  DQCDetailedReportRawOptions: DqcDetailedReportRawOptions;
  DQCDetailedReportRawSort: DqcDetailedReportRawSort;
  DQCDetailedReportRawWhere: DqcDetailedReportRawWhere;
  DataContainer: ResolverTypeWrapper<DataContainer>;
  DataContainerCreationWay: DataContainerCreationWay;
  DataContainerEdge: ResolverTypeWrapper<DataContainerEdge>;
  DataContainerInput: DataContainerInput;
  DataContainerOptions: DataContainerOptions;
  DataContainerOrganizationInput: DataContainerOrganizationInput;
  DataContainerOrganizationProvidersAggregationSelection: ResolverTypeWrapper<DataContainerOrganizationProvidersAggregationSelection>;
  DataContainerOrganizationProvidersNodeAggregateSelection: ResolverTypeWrapper<DataContainerOrganizationProvidersNodeAggregateSelection>;
  DataContainerProvidersAggregateInput: DataContainerProvidersAggregateInput;
  DataContainerProvidersConnection: ResolverTypeWrapper<DataContainerProvidersConnection>;
  DataContainerProvidersConnectionSort: DataContainerProvidersConnectionSort;
  DataContainerProvidersConnectionWhere: DataContainerProvidersConnectionWhere;
  DataContainerProvidersNodeAggregationWhereInput: DataContainerProvidersNodeAggregationWhereInput;
  DataContainerProvidersRelationship: ResolverTypeWrapper<DataContainerProvidersRelationship>;
  DataContainerSharingTrigger: DataContainerSharingTrigger;
  DataContainerSort: DataContainerSort;
  DataContainerType: DataContainerType;
  DataContainerWhere: DataContainerWhere;
  DataContainersConnection: ResolverTypeWrapper<DataContainersConnection>;
  DataSource: ResolverTypeWrapper<DataSource>;
  DataSourceEdge: ResolverTypeWrapper<DataSourceEdge>;
  DataSourceOptions: DataSourceOptions;
  DataSourceSort: DataSourceSort;
  DataSourceWhere: DataSourceWhere;
  DataSourcesConnection: ResolverTypeWrapper<DataSourcesConnection>;
  DataSubType: DataSubType;
  DataType: DataType;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DateTimeAggregateSelectionNonNullable: ResolverTypeWrapper<DateTimeAggregateSelectionNonNullable>;
  DateTimeAggregateSelectionNullable: ResolverTypeWrapper<DateTimeAggregateSelectionNullable>;
  Decision: Decision;
  DefaultAgreementRoleInfo: ResolverTypeWrapper<DefaultAgreementRoleInfo>;
  DefaultAgreementRoleInfoEdge: ResolverTypeWrapper<DefaultAgreementRoleInfoEdge>;
  DefaultAgreementRoleInfoOptions: DefaultAgreementRoleInfoOptions;
  DefaultAgreementRoleInfoSort: DefaultAgreementRoleInfoSort;
  DefaultAgreementRoleInfoWhere: DefaultAgreementRoleInfoWhere;
  DefaultAgreementRoleInfosConnection: ResolverTypeWrapper<DefaultAgreementRoleInfosConnection>;
  DefaultReceiverProperties: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['DefaultReceiverProperties']>;
  DefaultReceiverPropertiesSort: DefaultReceiverPropertiesSort;
  DefaultReceiverPropertiesWhere: DefaultReceiverPropertiesWhere;
  DefaultUserRoleUpdateInput: DefaultUserRoleUpdateInput;
  DeltaType: DeltaType;
  DependencyAttribute: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['DependencyAttribute']>;
  DependencyAttributeSort: DependencyAttributeSort;
  DependencyAttributeWhere: DependencyAttributeWhere;
  DeviceAgreementInput: DeviceAgreementInput;
  DeviceAlternative: ResolverTypeWrapper<DeviceAlternative>;
  DeviceAlternativeAlternativesAggregateInput: DeviceAlternativeAlternativesAggregateInput;
  DeviceAlternativeAlternativesConnection: ResolverTypeWrapper<DeviceAlternativeAlternativesConnection>;
  DeviceAlternativeAlternativesConnectionSort: DeviceAlternativeAlternativesConnectionSort;
  DeviceAlternativeAlternativesConnectionWhere: DeviceAlternativeAlternativesConnectionWhere;
  DeviceAlternativeAlternativesNodeAggregationWhereInput: DeviceAlternativeAlternativesNodeAggregationWhereInput;
  DeviceAlternativeAlternativesRelationship: ResolverTypeWrapper<DeviceAlternativeAlternativesRelationship>;
  DeviceAlternativeDeviceProductAggregateInput: DeviceAlternativeDeviceProductAggregateInput;
  DeviceAlternativeDeviceProductConnection: ResolverTypeWrapper<DeviceAlternativeDeviceProductConnection>;
  DeviceAlternativeDeviceProductConnectionSort: DeviceAlternativeDeviceProductConnectionSort;
  DeviceAlternativeDeviceProductConnectionWhere: DeviceAlternativeDeviceProductConnectionWhere;
  DeviceAlternativeDeviceProductNodeAggregationWhereInput: DeviceAlternativeDeviceProductNodeAggregationWhereInput;
  DeviceAlternativeDeviceProductRelationship: ResolverTypeWrapper<DeviceAlternativeDeviceProductRelationship>;
  DeviceAlternativeEdge: ResolverTypeWrapper<DeviceAlternativeEdge>;
  DeviceAlternativeInput: DeviceAlternativeInput;
  DeviceAlternativeOptions: DeviceAlternativeOptions;
  DeviceAlternativeSort: DeviceAlternativeSort;
  DeviceAlternativeTreatmentAlternativesAggregationSelection: ResolverTypeWrapper<DeviceAlternativeTreatmentAlternativesAggregationSelection>;
  DeviceAlternativeTreatmentAlternativesNodeAggregateSelection: ResolverTypeWrapper<DeviceAlternativeTreatmentAlternativesNodeAggregateSelection>;
  DeviceAlternativeTreatmentDeviceProductAggregationSelection: ResolverTypeWrapper<DeviceAlternativeTreatmentDeviceProductAggregationSelection>;
  DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection: ResolverTypeWrapper<DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection>;
  DeviceAlternativeWhere: DeviceAlternativeWhere;
  DeviceAlternativesConnection: ResolverTypeWrapper<DeviceAlternativesConnection>;
  DisabledDataCheck: ResolverTypeWrapper<DisabledDataCheck>;
  DisabledDataCheckEdge: ResolverTypeWrapper<DisabledDataCheckEdge>;
  DisabledDataCheckOptions: DisabledDataCheckOptions;
  DisabledDataCheckSort: DisabledDataCheckSort;
  DisabledDataCheckWhere: DisabledDataCheckWhere;
  DisabledDataChecksConnection: ResolverTypeWrapper<DisabledDataChecksConnection>;
  Disease: ResolverTypeWrapper<Disease>;
  DiseaseEdge: ResolverTypeWrapper<DiseaseEdge>;
  DiseaseInput: DiseaseInput;
  DiseaseOptions: DiseaseOptions;
  DiseaseSort: DiseaseSort;
  DiseaseWhere: DiseaseWhere;
  DiseasesConnection: ResolverTypeWrapper<DiseasesConnection>;
  Document: ResolverTypeWrapper<Document>;
  DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection: ResolverTypeWrapper<DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection>;
  DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection: ResolverTypeWrapper<DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection>;
  DocumentDocumentRefundGroupsAggregateInput: DocumentDocumentRefundGroupsAggregateInput;
  DocumentDocumentRefundGroupsConnection: ResolverTypeWrapper<DocumentDocumentRefundGroupsConnection>;
  DocumentDocumentRefundGroupsConnectionSort: DocumentDocumentRefundGroupsConnectionSort;
  DocumentDocumentRefundGroupsConnectionWhere: DocumentDocumentRefundGroupsConnectionWhere;
  DocumentDocumentRefundGroupsNodeAggregationWhereInput: DocumentDocumentRefundGroupsNodeAggregationWhereInput;
  DocumentDocumentRefundGroupsRelationship: ResolverTypeWrapper<DocumentDocumentRefundGroupsRelationship>;
  DocumentEdge: ResolverTypeWrapper<DocumentEdge>;
  DocumentOptions: DocumentOptions;
  DocumentRefundFinancialDataPoint: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['DocumentRefundFinancialDataPoint']>;
  DocumentRefundFinancialDataPointSort: DocumentRefundFinancialDataPointSort;
  DocumentRefundFinancialDataPointWhere: DocumentRefundFinancialDataPointWhere;
  DocumentRefundGroup: ResolverTypeWrapper<DocumentRefundGroup>;
  DocumentRefundGroupAgreementAggregateInput: DocumentRefundGroupAgreementAggregateInput;
  DocumentRefundGroupAgreementAgreementAggregationSelection: ResolverTypeWrapper<DocumentRefundGroupAgreementAgreementAggregationSelection>;
  DocumentRefundGroupAgreementAgreementNodeAggregateSelection: ResolverTypeWrapper<DocumentRefundGroupAgreementAgreementNodeAggregateSelection>;
  DocumentRefundGroupAgreementConnection: ResolverTypeWrapper<DocumentRefundGroupAgreementConnection>;
  DocumentRefundGroupAgreementConnectionSort: DocumentRefundGroupAgreementConnectionSort;
  DocumentRefundGroupAgreementConnectionWhere: DocumentRefundGroupAgreementConnectionWhere;
  DocumentRefundGroupAgreementNodeAggregationWhereInput: DocumentRefundGroupAgreementNodeAggregationWhereInput;
  DocumentRefundGroupAgreementRelationship: ResolverTypeWrapper<DocumentRefundGroupAgreementRelationship>;
  DocumentRefundGroupCaseAggregateInput: DocumentRefundGroupCaseAggregateInput;
  DocumentRefundGroupCaseCaseAggregationSelection: ResolverTypeWrapper<DocumentRefundGroupCaseCaseAggregationSelection>;
  DocumentRefundGroupCaseCaseNodeAggregateSelection: ResolverTypeWrapper<DocumentRefundGroupCaseCaseNodeAggregateSelection>;
  DocumentRefundGroupCaseConnection: ResolverTypeWrapper<DocumentRefundGroupCaseConnection>;
  DocumentRefundGroupCaseConnectionSort: DocumentRefundGroupCaseConnectionSort;
  DocumentRefundGroupCaseConnectionWhere: DocumentRefundGroupCaseConnectionWhere;
  DocumentRefundGroupCaseNodeAggregationWhereInput: DocumentRefundGroupCaseNodeAggregationWhereInput;
  DocumentRefundGroupCaseRelationship: ResolverTypeWrapper<DocumentRefundGroupCaseRelationship>;
  DocumentRefundGroupDocumentAggregateInput: DocumentRefundGroupDocumentAggregateInput;
  DocumentRefundGroupDocumentConnection: ResolverTypeWrapper<DocumentRefundGroupDocumentConnection>;
  DocumentRefundGroupDocumentConnectionSort: DocumentRefundGroupDocumentConnectionSort;
  DocumentRefundGroupDocumentConnectionWhere: DocumentRefundGroupDocumentConnectionWhere;
  DocumentRefundGroupDocumentDocumentAggregationSelection: ResolverTypeWrapper<DocumentRefundGroupDocumentDocumentAggregationSelection>;
  DocumentRefundGroupDocumentDocumentNodeAggregateSelection: ResolverTypeWrapper<DocumentRefundGroupDocumentDocumentNodeAggregateSelection>;
  DocumentRefundGroupDocumentNodeAggregationWhereInput: DocumentRefundGroupDocumentNodeAggregationWhereInput;
  DocumentRefundGroupDocumentRelationship: ResolverTypeWrapper<DocumentRefundGroupDocumentRelationship>;
  DocumentRefundGroupEdge: ResolverTypeWrapper<DocumentRefundGroupEdge>;
  DocumentRefundGroupMessageAggregateInput: DocumentRefundGroupMessageAggregateInput;
  DocumentRefundGroupMessageConnection: ResolverTypeWrapper<DocumentRefundGroupMessageConnection>;
  DocumentRefundGroupMessageConnectionSort: DocumentRefundGroupMessageConnectionSort;
  DocumentRefundGroupMessageConnectionWhere: DocumentRefundGroupMessageConnectionWhere;
  DocumentRefundGroupMessageMessageAggregationSelection: ResolverTypeWrapper<DocumentRefundGroupMessageMessageAggregationSelection>;
  DocumentRefundGroupMessageMessageNodeAggregateSelection: ResolverTypeWrapper<DocumentRefundGroupMessageMessageNodeAggregateSelection>;
  DocumentRefundGroupMessageNodeAggregationWhereInput: DocumentRefundGroupMessageNodeAggregationWhereInput;
  DocumentRefundGroupMessageRelationship: ResolverTypeWrapper<DocumentRefundGroupMessageRelationship>;
  DocumentRefundGroupOptions: DocumentRefundGroupOptions;
  DocumentRefundGroupRefundRefundsAggregationSelection: ResolverTypeWrapper<DocumentRefundGroupRefundRefundsAggregationSelection>;
  DocumentRefundGroupRefundRefundsNodeAggregateSelection: ResolverTypeWrapper<DocumentRefundGroupRefundRefundsNodeAggregateSelection>;
  DocumentRefundGroupRefundsAggregateInput: DocumentRefundGroupRefundsAggregateInput;
  DocumentRefundGroupRefundsConnection: ResolverTypeWrapper<DocumentRefundGroupRefundsConnection>;
  DocumentRefundGroupRefundsConnectionSort: DocumentRefundGroupRefundsConnectionSort;
  DocumentRefundGroupRefundsConnectionWhere: DocumentRefundGroupRefundsConnectionWhere;
  DocumentRefundGroupRefundsNodeAggregationWhereInput: DocumentRefundGroupRefundsNodeAggregationWhereInput;
  DocumentRefundGroupRefundsRelationship: ResolverTypeWrapper<DocumentRefundGroupRefundsRelationship>;
  DocumentRefundGroupSort: DocumentRefundGroupSort;
  DocumentRefundGroupWhere: DocumentRefundGroupWhere;
  DocumentRefundGroupsConnection: ResolverTypeWrapper<DocumentRefundGroupsConnection>;
  DocumentRefundRefundsAggregationSelection: ResolverTypeWrapper<DocumentRefundRefundsAggregationSelection>;
  DocumentRefundRefundsNodeAggregateSelection: ResolverTypeWrapper<DocumentRefundRefundsNodeAggregateSelection>;
  DocumentRefundsAggregateInput: DocumentRefundsAggregateInput;
  DocumentRefundsConnection: ResolverTypeWrapper<DocumentRefundsConnection>;
  DocumentRefundsConnectionSort: DocumentRefundsConnectionSort;
  DocumentRefundsConnectionWhere: DocumentRefundsConnectionWhere;
  DocumentRefundsNodeAggregationWhereInput: DocumentRefundsNodeAggregationWhereInput;
  DocumentRefundsRelationship: ResolverTypeWrapper<DocumentRefundsRelationship>;
  DocumentSort: DocumentSort;
  DocumentStatus: DocumentStatus;
  DocumentType: DocumentType;
  DocumentWhere: DocumentWhere;
  DocumentsConnection: ResolverTypeWrapper<DocumentsConnection>;
  Domain: ResolverTypeWrapper<Domain>;
  DomainChildrenAggregateInput: DomainChildrenAggregateInput;
  DomainChildrenConnection: ResolverTypeWrapper<DomainChildrenConnection>;
  DomainChildrenConnectionSort: DomainChildrenConnectionSort;
  DomainChildrenConnectionWhere: DomainChildrenConnectionWhere;
  DomainChildrenNodeAggregationWhereInput: DomainChildrenNodeAggregationWhereInput;
  DomainChildrenRelationship: ResolverTypeWrapper<DomainChildrenRelationship>;
  DomainCreatedByAggregateInput: DomainCreatedByAggregateInput;
  DomainCreatedByConnection: ResolverTypeWrapper<DomainCreatedByConnection>;
  DomainCreatedByConnectionSort: DomainCreatedByConnectionSort;
  DomainCreatedByConnectionWhere: DomainCreatedByConnectionWhere;
  DomainCreatedByNodeAggregationWhereInput: DomainCreatedByNodeAggregationWhereInput;
  DomainCreatedByRelationship: ResolverTypeWrapper<DomainCreatedByRelationship>;
  DomainDomainChildrenAggregationSelection: ResolverTypeWrapper<DomainDomainChildrenAggregationSelection>;
  DomainDomainChildrenNodeAggregateSelection: ResolverTypeWrapper<DomainDomainChildrenNodeAggregateSelection>;
  DomainDomainParentAggregationSelection: ResolverTypeWrapper<DomainDomainParentAggregationSelection>;
  DomainDomainParentNodeAggregateSelection: ResolverTypeWrapper<DomainDomainParentNodeAggregateSelection>;
  DomainEdge: ResolverTypeWrapper<DomainEdge>;
  DomainOptions: DomainOptions;
  DomainParentAggregateInput: DomainParentAggregateInput;
  DomainParentConnection: ResolverTypeWrapper<DomainParentConnection>;
  DomainParentConnectionSort: DomainParentConnectionSort;
  DomainParentConnectionWhere: DomainParentConnectionWhere;
  DomainParentNodeAggregationWhereInput: DomainParentNodeAggregationWhereInput;
  DomainParentRelationship: ResolverTypeWrapper<DomainParentRelationship>;
  DomainProductBlueprintAggregateInput: DomainProductBlueprintAggregateInput;
  DomainProductBlueprintConnection: ResolverTypeWrapper<DomainProductBlueprintConnection>;
  DomainProductBlueprintConnectionSort: DomainProductBlueprintConnectionSort;
  DomainProductBlueprintConnectionWhere: DomainProductBlueprintConnectionWhere;
  DomainProductBlueprintNodeAggregationWhereInput: DomainProductBlueprintNodeAggregationWhereInput;
  DomainProductBlueprintProductBlueprintAggregationSelection: ResolverTypeWrapper<DomainProductBlueprintProductBlueprintAggregationSelection>;
  DomainProductBlueprintProductBlueprintNodeAggregateSelection: ResolverTypeWrapper<DomainProductBlueprintProductBlueprintNodeAggregateSelection>;
  DomainProductBlueprintRelationship: ResolverTypeWrapper<DomainProductBlueprintRelationship>;
  DomainSimulationSimulationsAggregationSelection: ResolverTypeWrapper<DomainSimulationSimulationsAggregationSelection>;
  DomainSimulationSimulationsNodeAggregateSelection: ResolverTypeWrapper<DomainSimulationSimulationsNodeAggregateSelection>;
  DomainSimulationsAggregateInput: DomainSimulationsAggregateInput;
  DomainSimulationsConnection: ResolverTypeWrapper<DomainSimulationsConnection>;
  DomainSimulationsConnectionSort: DomainSimulationsConnectionSort;
  DomainSimulationsConnectionWhere: DomainSimulationsConnectionWhere;
  DomainSimulationsNodeAggregationWhereInput: DomainSimulationsNodeAggregationWhereInput;
  DomainSimulationsRelationship: ResolverTypeWrapper<DomainSimulationsRelationship>;
  DomainSort: DomainSort;
  DomainUserCreatedByAggregationSelection: ResolverTypeWrapper<DomainUserCreatedByAggregationSelection>;
  DomainUserCreatedByNodeAggregateSelection: ResolverTypeWrapper<DomainUserCreatedByNodeAggregateSelection>;
  DomainUserUsersAggregationSelection: ResolverTypeWrapper<DomainUserUsersAggregationSelection>;
  DomainUserUsersNodeAggregateSelection: ResolverTypeWrapper<DomainUserUsersNodeAggregateSelection>;
  DomainUsersAggregateInput: DomainUsersAggregateInput;
  DomainUsersConnection: ResolverTypeWrapper<DomainUsersConnection>;
  DomainUsersConnectionSort: DomainUsersConnectionSort;
  DomainUsersConnectionWhere: DomainUsersConnectionWhere;
  DomainUsersNodeAggregationWhereInput: DomainUsersNodeAggregationWhereInput;
  DomainUsersRelationship: ResolverTypeWrapper<DomainUsersRelationship>;
  DomainWhere: DomainWhere;
  DomainsConnection: ResolverTypeWrapper<DomainsConnection>;
  DqcDetailedReportRawsConnection: ResolverTypeWrapper<DqcDetailedReportRawsConnection>;
  DummyEnumReferences: ResolverTypeWrapper<DummyEnumReferences>;
  DummyEnumReferencesConnection: ResolverTypeWrapper<DummyEnumReferencesConnection>;
  DummyEnumReferencesEdge: ResolverTypeWrapper<DummyEnumReferencesEdge>;
  DummyEnumReferencesOptions: DummyEnumReferencesOptions;
  DummyEnumReferencesSort: DummyEnumReferencesSort;
  DummyEnumReferencesWhere: DummyEnumReferencesWhere;
  EligibilityConditionSet: ResolverTypeWrapper<EligibilityConditionSet>;
  EligibilityConditionSetEdge: ResolverTypeWrapper<EligibilityConditionSetEdge>;
  EligibilityConditionSetInput: EligibilityConditionSetInput;
  EligibilityConditionSetOptions: EligibilityConditionSetOptions;
  EligibilityConditionSetSort: EligibilityConditionSetSort;
  EligibilityConditionSetTreatmentTreatmentsAggregationSelection: ResolverTypeWrapper<EligibilityConditionSetTreatmentTreatmentsAggregationSelection>;
  EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection: ResolverTypeWrapper<EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection>;
  EligibilityConditionSetTreatmentsAggregateInput: EligibilityConditionSetTreatmentsAggregateInput;
  EligibilityConditionSetTreatmentsConnection: ResolverTypeWrapper<EligibilityConditionSetTreatmentsConnection>;
  EligibilityConditionSetTreatmentsConnectionSort: EligibilityConditionSetTreatmentsConnectionSort;
  EligibilityConditionSetTreatmentsConnectionWhere: EligibilityConditionSetTreatmentsConnectionWhere;
  EligibilityConditionSetTreatmentsNodeAggregationWhereInput: EligibilityConditionSetTreatmentsNodeAggregationWhereInput;
  EligibilityConditionSetTreatmentsRelationship: ResolverTypeWrapper<EligibilityConditionSetTreatmentsRelationship>;
  EligibilityConditionSetWhere: EligibilityConditionSetWhere;
  EligibilityConditionSetsConnection: ResolverTypeWrapper<EligibilityConditionSetsConnection>;
  EncapsulatedFeature: ResolverTypeWrapper<EncapsulatedFeature>;
  EncapsulatedFeatureConfiguration: ResolverTypeWrapper<EncapsulatedFeatureConfiguration>;
  EncapsulatedFeatureConfigurationEdge: ResolverTypeWrapper<EncapsulatedFeatureConfigurationEdge>;
  EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection: ResolverTypeWrapper<EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection>;
  EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection: ResolverTypeWrapper<EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection>;
  EncapsulatedFeatureConfigurationInput: EncapsulatedFeatureConfigurationInput;
  EncapsulatedFeatureConfigurationOfTypeAggregateInput: EncapsulatedFeatureConfigurationOfTypeAggregateInput;
  EncapsulatedFeatureConfigurationOfTypeConnection: ResolverTypeWrapper<EncapsulatedFeatureConfigurationOfTypeConnection>;
  EncapsulatedFeatureConfigurationOfTypeConnectionSort: EncapsulatedFeatureConfigurationOfTypeConnectionSort;
  EncapsulatedFeatureConfigurationOfTypeConnectionWhere: EncapsulatedFeatureConfigurationOfTypeConnectionWhere;
  EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput: EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput;
  EncapsulatedFeatureConfigurationOfTypeRelationship: ResolverTypeWrapper<EncapsulatedFeatureConfigurationOfTypeRelationship>;
  EncapsulatedFeatureConfigurationOptions: EncapsulatedFeatureConfigurationOptions;
  EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection: ResolverTypeWrapper<EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection>;
  EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection: ResolverTypeWrapper<EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection>;
  EncapsulatedFeatureConfigurationSetForAggregateInput: EncapsulatedFeatureConfigurationSetForAggregateInput;
  EncapsulatedFeatureConfigurationSetForConnection: ResolverTypeWrapper<EncapsulatedFeatureConfigurationSetForConnection>;
  EncapsulatedFeatureConfigurationSetForConnectionSort: EncapsulatedFeatureConfigurationSetForConnectionSort;
  EncapsulatedFeatureConfigurationSetForConnectionWhere: EncapsulatedFeatureConfigurationSetForConnectionWhere;
  EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput: EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput;
  EncapsulatedFeatureConfigurationSetForRelationship: ResolverTypeWrapper<EncapsulatedFeatureConfigurationSetForRelationship>;
  EncapsulatedFeatureConfigurationSort: EncapsulatedFeatureConfigurationSort;
  EncapsulatedFeatureConfigurationWhere: EncapsulatedFeatureConfigurationWhere;
  EncapsulatedFeatureConfigurationsConnection: ResolverTypeWrapper<EncapsulatedFeatureConfigurationsConnection>;
  EncapsulatedFeatureEdge: ResolverTypeWrapper<EncapsulatedFeatureEdge>;
  EncapsulatedFeatureOptions: EncapsulatedFeatureOptions;
  EncapsulatedFeatureSort: EncapsulatedFeatureSort;
  EncapsulatedFeatureWhere: EncapsulatedFeatureWhere;
  EncapsulatedFeaturesConnection: ResolverTypeWrapper<EncapsulatedFeaturesConnection>;
  EncryptionInput: EncryptionInput;
  EncryptionType: EncryptionType;
  EnrollingCondition: ResolverTypeWrapper<EnrollingCondition>;
  EnrollingConditionCustomConditionAggregateInput: EnrollingConditionCustomConditionAggregateInput;
  EnrollingConditionCustomConditionConnection: ResolverTypeWrapper<EnrollingConditionCustomConditionConnection>;
  EnrollingConditionCustomConditionConnectionSort: EnrollingConditionCustomConditionConnectionSort;
  EnrollingConditionCustomConditionConnectionWhere: EnrollingConditionCustomConditionConnectionWhere;
  EnrollingConditionCustomConditionCustomConditionAggregationSelection: ResolverTypeWrapper<EnrollingConditionCustomConditionCustomConditionAggregationSelection>;
  EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection: ResolverTypeWrapper<EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection>;
  EnrollingConditionCustomConditionNodeAggregationWhereInput: EnrollingConditionCustomConditionNodeAggregationWhereInput;
  EnrollingConditionCustomConditionRelationship: ResolverTypeWrapper<EnrollingConditionCustomConditionRelationship>;
  EnrollingConditionDiseaseRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['EnrollingConditionDiseaseRelationship']>;
  EnrollingConditionDiseaseRelationshipSort: EnrollingConditionDiseaseRelationshipSort;
  EnrollingConditionDiseaseRelationshipWhere: EnrollingConditionDiseaseRelationshipWhere;
  EnrollingConditionEdge: ResolverTypeWrapper<EnrollingConditionEdge>;
  EnrollingConditionGenericIncludedGenericsAggregationSelection: ResolverTypeWrapper<EnrollingConditionGenericIncludedGenericsAggregationSelection>;
  EnrollingConditionGenericIncludedGenericsNodeAggregateSelection: ResolverTypeWrapper<EnrollingConditionGenericIncludedGenericsNodeAggregateSelection>;
  EnrollingConditionIncludedGenericsAggregateInput: EnrollingConditionIncludedGenericsAggregateInput;
  EnrollingConditionIncludedGenericsConnection: ResolverTypeWrapper<EnrollingConditionIncludedGenericsConnection>;
  EnrollingConditionIncludedGenericsConnectionSort: EnrollingConditionIncludedGenericsConnectionSort;
  EnrollingConditionIncludedGenericsConnectionWhere: EnrollingConditionIncludedGenericsConnectionWhere;
  EnrollingConditionIncludedGenericsNodeAggregationWhereInput: EnrollingConditionIncludedGenericsNodeAggregationWhereInput;
  EnrollingConditionIncludedGenericsRelationship: ResolverTypeWrapper<EnrollingConditionIncludedGenericsRelationship>;
  EnrollingConditionInput: EnrollingConditionInput;
  EnrollingConditionOptions: EnrollingConditionOptions;
  EnrollingConditionSet: ResolverTypeWrapper<EnrollingConditionSet>;
  EnrollingConditionSetAgreementAggregateInput: EnrollingConditionSetAgreementAggregateInput;
  EnrollingConditionSetAgreementAgreementAggregationSelection: ResolverTypeWrapper<EnrollingConditionSetAgreementAgreementAggregationSelection>;
  EnrollingConditionSetAgreementAgreementNodeAggregateSelection: ResolverTypeWrapper<EnrollingConditionSetAgreementAgreementNodeAggregateSelection>;
  EnrollingConditionSetAgreementConnection: ResolverTypeWrapper<EnrollingConditionSetAgreementConnection>;
  EnrollingConditionSetAgreementConnectionSort: EnrollingConditionSetAgreementConnectionSort;
  EnrollingConditionSetAgreementConnectionWhere: EnrollingConditionSetAgreementConnectionWhere;
  EnrollingConditionSetAgreementNodeAggregationWhereInput: EnrollingConditionSetAgreementNodeAggregationWhereInput;
  EnrollingConditionSetAgreementRelationship: ResolverTypeWrapper<EnrollingConditionSetAgreementRelationship>;
  EnrollingConditionSetAgreementScopeScopesAggregationSelection: ResolverTypeWrapper<EnrollingConditionSetAgreementScopeScopesAggregationSelection>;
  EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection: ResolverTypeWrapper<EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection>;
  EnrollingConditionSetAgreementTemplateTemplateAggregationSelection: ResolverTypeWrapper<EnrollingConditionSetAgreementTemplateTemplateAggregationSelection>;
  EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection: ResolverTypeWrapper<EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection>;
  EnrollingConditionSetConditionsAggregateInput: EnrollingConditionSetConditionsAggregateInput;
  EnrollingConditionSetConditionsConnection: ResolverTypeWrapper<EnrollingConditionSetConditionsConnection>;
  EnrollingConditionSetConditionsConnectionSort: EnrollingConditionSetConditionsConnectionSort;
  EnrollingConditionSetConditionsConnectionWhere: EnrollingConditionSetConditionsConnectionWhere;
  EnrollingConditionSetConditionsNodeAggregationWhereInput: EnrollingConditionSetConditionsNodeAggregationWhereInput;
  EnrollingConditionSetConditionsRelationship: ResolverTypeWrapper<EnrollingConditionSetConditionsRelationship>;
  EnrollingConditionSetEdge: ResolverTypeWrapper<EnrollingConditionSetEdge>;
  EnrollingConditionSetEnrollingConditionConditionsAggregationSelection: ResolverTypeWrapper<EnrollingConditionSetEnrollingConditionConditionsAggregationSelection>;
  EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection: ResolverTypeWrapper<EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection>;
  EnrollingConditionSetInput: EnrollingConditionSetInput;
  EnrollingConditionSetOptions: EnrollingConditionSetOptions;
  EnrollingConditionSetRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['EnrollingConditionSetRelationship']>;
  EnrollingConditionSetRelationshipSort: EnrollingConditionSetRelationshipSort;
  EnrollingConditionSetRelationshipWhere: EnrollingConditionSetRelationshipWhere;
  EnrollingConditionSetScopesAggregateInput: EnrollingConditionSetScopesAggregateInput;
  EnrollingConditionSetScopesConnection: ResolverTypeWrapper<EnrollingConditionSetScopesConnection>;
  EnrollingConditionSetScopesConnectionSort: EnrollingConditionSetScopesConnectionSort;
  EnrollingConditionSetScopesConnectionWhere: EnrollingConditionSetScopesConnectionWhere;
  EnrollingConditionSetScopesNodeAggregationWhereInput: EnrollingConditionSetScopesNodeAggregationWhereInput;
  EnrollingConditionSetScopesRelationship: ResolverTypeWrapper<EnrollingConditionSetScopesRelationship>;
  EnrollingConditionSetSort: EnrollingConditionSetSort;
  EnrollingConditionSetTemplateAggregateInput: EnrollingConditionSetTemplateAggregateInput;
  EnrollingConditionSetTemplateConnection: ResolverTypeWrapper<EnrollingConditionSetTemplateConnection>;
  EnrollingConditionSetTemplateConnectionSort: EnrollingConditionSetTemplateConnectionSort;
  EnrollingConditionSetTemplateConnectionWhere: EnrollingConditionSetTemplateConnectionWhere;
  EnrollingConditionSetTemplateNodeAggregationWhereInput: EnrollingConditionSetTemplateNodeAggregationWhereInput;
  EnrollingConditionSetTemplateRelationship: ResolverTypeWrapper<EnrollingConditionSetTemplateRelationship>;
  EnrollingConditionSetWhere: EnrollingConditionSetWhere;
  EnrollingConditionSetsConnection: ResolverTypeWrapper<EnrollingConditionSetsConnection>;
  EnrollingConditionSort: EnrollingConditionSort;
  EnrollingConditionType: EnrollingConditionType;
  EnrollingConditionWhere: EnrollingConditionWhere;
  EnrollingConditionsConnection: ResolverTypeWrapper<EnrollingConditionsConnection>;
  EnrollingPeriod: ResolverTypeWrapper<EnrollingPeriod>;
  EnrollingPeriodEdge: ResolverTypeWrapper<EnrollingPeriodEdge>;
  EnrollingPeriodInput: EnrollingPeriodInput;
  EnrollingPeriodOptions: EnrollingPeriodOptions;
  EnrollingPeriodSort: EnrollingPeriodSort;
  EnrollingPeriodWhere: EnrollingPeriodWhere;
  EnrollingPeriodsConnection: ResolverTypeWrapper<EnrollingPeriodsConnection>;
  EnrolmentDateType: EnrolmentDateType;
  EntityPriceType: EntityPriceType;
  EntityTypeMappingRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['EntityTypeMappingRelationship']>;
  EntityTypeMappingRelationshipSort: EntityTypeMappingRelationshipSort;
  EntityTypeMappingRelationshipWhere: EntityTypeMappingRelationshipWhere;
  EntryModule: ResolverTypeWrapper<EntryModule>;
  EntryModuleEdge: ResolverTypeWrapper<EntryModuleEdge>;
  EntryModuleOptions: EntryModuleOptions;
  EntryModuleSort: EntryModuleSort;
  EntryModuleWhere: EntryModuleWhere;
  EntryModulesConnection: ResolverTypeWrapper<EntryModulesConnection>;
  ExFactoryPrice: ResolverTypeWrapper<ExFactoryPrice>;
  ExFactoryPriceEdge: ResolverTypeWrapper<ExFactoryPriceEdge>;
  ExFactoryPriceOptions: ExFactoryPriceOptions;
  ExFactoryPriceSort: ExFactoryPriceSort;
  ExFactoryPriceWhere: ExFactoryPriceWhere;
  ExFactoryPricesConnection: ResolverTypeWrapper<ExFactoryPricesConnection>;
  ExistingUserInput: ExistingUserInput;
  FileUpload: ResolverTypeWrapper<Scalars['FileUpload']['output']>;
  FinancialDataPointStatus: FinancialDataPointStatus;
  FinancialSummaryColumn: ResolverTypeWrapper<FinancialSummaryColumn>;
  FinancialSummaryColumnEdge: ResolverTypeWrapper<FinancialSummaryColumnEdge>;
  FinancialSummaryColumnName: FinancialSummaryColumnName;
  FinancialSummaryColumnOptions: FinancialSummaryColumnOptions;
  FinancialSummaryColumnSort: FinancialSummaryColumnSort;
  FinancialSummaryColumnWhere: FinancialSummaryColumnWhere;
  FinancialSummaryColumnsConnection: ResolverTypeWrapper<FinancialSummaryColumnsConnection>;
  FinancialSummaryConfigInput: FinancialSummaryConfigInput;
  FlexContainerType: FlexContainerType;
  FlexEntitiesConnection: ResolverTypeWrapper<FlexEntitiesConnection>;
  FlexEntity: ResolverTypeWrapper<FlexEntity>;
  FlexEntityCaseCasesAggregationSelection: ResolverTypeWrapper<FlexEntityCaseCasesAggregationSelection>;
  FlexEntityCaseCasesNodeAggregateSelection: ResolverTypeWrapper<FlexEntityCaseCasesNodeAggregateSelection>;
  FlexEntityCasesAggregateInput: FlexEntityCasesAggregateInput;
  FlexEntityCasesConnection: ResolverTypeWrapper<FlexEntityCasesConnection>;
  FlexEntityCasesConnectionSort: FlexEntityCasesConnectionSort;
  FlexEntityCasesConnectionWhere: FlexEntityCasesConnectionWhere;
  FlexEntityCasesNodeAggregationWhereInput: FlexEntityCasesNodeAggregationWhereInput;
  FlexEntityCasesRelationship: ResolverTypeWrapper<FlexEntityCasesRelationship>;
  FlexEntityCreatedByAggregateInput: FlexEntityCreatedByAggregateInput;
  FlexEntityCreatedByConnection: ResolverTypeWrapper<FlexEntityCreatedByConnection>;
  FlexEntityCreatedByConnectionSort: FlexEntityCreatedByConnectionSort;
  FlexEntityCreatedByConnectionWhere: FlexEntityCreatedByConnectionWhere;
  FlexEntityCreatedByNodeAggregationWhereInput: FlexEntityCreatedByNodeAggregationWhereInput;
  FlexEntityCreatedByRelationship: ResolverTypeWrapper<FlexEntityCreatedByRelationship>;
  FlexEntityEdge: ResolverTypeWrapper<FlexEntityEdge>;
  FlexEntityFeature: FlexEntityFeature;
  FlexEntityFinancialDataPointsAggregateInput: FlexEntityFinancialDataPointsAggregateInput;
  FlexEntityFinancialDataPointsConnection: ResolverTypeWrapper<FlexEntityFinancialDataPointsConnection>;
  FlexEntityFinancialDataPointsConnectionSort: FlexEntityFinancialDataPointsConnectionSort;
  FlexEntityFinancialDataPointsConnectionWhere: FlexEntityFinancialDataPointsConnectionWhere;
  FlexEntityFinancialDataPointsNodeAggregationWhereInput: FlexEntityFinancialDataPointsNodeAggregationWhereInput;
  FlexEntityFinancialDataPointsRelationship: ResolverTypeWrapper<FlexEntityFinancialDataPointsRelationship>;
  FlexEntityFlexEntityPredecessorAggregationSelection: ResolverTypeWrapper<FlexEntityFlexEntityPredecessorAggregationSelection>;
  FlexEntityFlexEntityPredecessorNodeAggregateSelection: ResolverTypeWrapper<FlexEntityFlexEntityPredecessorNodeAggregateSelection>;
  FlexEntityFlexEntitySourceAggregationSelection: ResolverTypeWrapper<FlexEntityFlexEntitySourceAggregationSelection>;
  FlexEntityFlexEntitySourceNodeAggregateSelection: ResolverTypeWrapper<FlexEntityFlexEntitySourceNodeAggregateSelection>;
  FlexEntityFlexEntitySourcedAggregationSelection: ResolverTypeWrapper<FlexEntityFlexEntitySourcedAggregationSelection>;
  FlexEntityFlexEntitySourcedNodeAggregateSelection: ResolverTypeWrapper<FlexEntityFlexEntitySourcedNodeAggregateSelection>;
  FlexEntityFlexEntitySuccessorAggregationSelection: ResolverTypeWrapper<FlexEntityFlexEntitySuccessorAggregationSelection>;
  FlexEntityFlexEntitySuccessorNodeAggregateSelection: ResolverTypeWrapper<FlexEntityFlexEntitySuccessorNodeAggregateSelection>;
  FlexEntityFlexEntityTypeTypeAggregationSelection: ResolverTypeWrapper<FlexEntityFlexEntityTypeTypeAggregationSelection>;
  FlexEntityFlexEntityTypeTypeNodeAggregateSelection: ResolverTypeWrapper<FlexEntityFlexEntityTypeTypeNodeAggregateSelection>;
  FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection: ResolverTypeWrapper<FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection>;
  FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection: ResolverTypeWrapper<FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection>;
  FlexEntityGenericGenericsAggregationSelection: ResolverTypeWrapper<FlexEntityGenericGenericsAggregationSelection>;
  FlexEntityGenericGenericsNodeAggregateSelection: ResolverTypeWrapper<FlexEntityGenericGenericsNodeAggregateSelection>;
  FlexEntityGenericsAggregateInput: FlexEntityGenericsAggregateInput;
  FlexEntityGenericsConnection: ResolverTypeWrapper<FlexEntityGenericsConnection>;
  FlexEntityGenericsConnectionSort: FlexEntityGenericsConnectionSort;
  FlexEntityGenericsConnectionWhere: FlexEntityGenericsConnectionWhere;
  FlexEntityGenericsNodeAggregationWhereInput: FlexEntityGenericsNodeAggregationWhereInput;
  FlexEntityGenericsRelationship: ResolverTypeWrapper<FlexEntityGenericsRelationship>;
  FlexEntityInput: FlexEntityInput;
  FlexEntityOptions: FlexEntityOptions;
  FlexEntityPatientAggregateInput: FlexEntityPatientAggregateInput;
  FlexEntityPatientConnection: ResolverTypeWrapper<FlexEntityPatientConnection>;
  FlexEntityPatientConnectionSort: FlexEntityPatientConnectionSort;
  FlexEntityPatientConnectionWhere: FlexEntityPatientConnectionWhere;
  FlexEntityPatientNodeAggregationWhereInput: FlexEntityPatientNodeAggregationWhereInput;
  FlexEntityPatientPatientAggregationSelection: ResolverTypeWrapper<FlexEntityPatientPatientAggregationSelection>;
  FlexEntityPatientPatientNodeAggregateSelection: ResolverTypeWrapper<FlexEntityPatientPatientNodeAggregateSelection>;
  FlexEntityPatientRelationship: ResolverTypeWrapper<FlexEntityPatientRelationship>;
  FlexEntityPredecessorAggregateInput: FlexEntityPredecessorAggregateInput;
  FlexEntityPredecessorConnection: ResolverTypeWrapper<FlexEntityPredecessorConnection>;
  FlexEntityPredecessorConnectionSort: FlexEntityPredecessorConnectionSort;
  FlexEntityPredecessorConnectionWhere: FlexEntityPredecessorConnectionWhere;
  FlexEntityPredecessorNodeAggregationWhereInput: FlexEntityPredecessorNodeAggregationWhereInput;
  FlexEntityPredecessorRelationship: ResolverTypeWrapper<FlexEntityPredecessorRelationship>;
  FlexEntityPurchaseAggregateInput: FlexEntityPurchaseAggregateInput;
  FlexEntityPurchaseConnection: ResolverTypeWrapper<FlexEntityPurchaseConnection>;
  FlexEntityPurchaseConnectionSort: FlexEntityPurchaseConnectionSort;
  FlexEntityPurchaseConnectionWhere: FlexEntityPurchaseConnectionWhere;
  FlexEntityPurchaseNodeAggregationWhereInput: FlexEntityPurchaseNodeAggregationWhereInput;
  FlexEntityPurchasePurchaseAggregationSelection: ResolverTypeWrapper<FlexEntityPurchasePurchaseAggregationSelection>;
  FlexEntityPurchasePurchaseNodeAggregateSelection: ResolverTypeWrapper<FlexEntityPurchasePurchaseNodeAggregateSelection>;
  FlexEntityPurchaseRelationship: ResolverTypeWrapper<FlexEntityPurchaseRelationship>;
  FlexEntityRowInput: FlexEntityRowInput;
  FlexEntitySectionInput: FlexEntitySectionInput;
  FlexEntitySort: FlexEntitySort;
  FlexEntitySourceAggregateInput: FlexEntitySourceAggregateInput;
  FlexEntitySourceConnection: ResolverTypeWrapper<FlexEntitySourceConnection>;
  FlexEntitySourceConnectionSort: FlexEntitySourceConnectionSort;
  FlexEntitySourceConnectionWhere: FlexEntitySourceConnectionWhere;
  FlexEntitySourceNodeAggregationWhereInput: FlexEntitySourceNodeAggregationWhereInput;
  FlexEntitySourceRelationship: ResolverTypeWrapper<FlexEntitySourceRelationship>;
  FlexEntitySourcedAggregateInput: FlexEntitySourcedAggregateInput;
  FlexEntitySourcedConnection: ResolverTypeWrapper<FlexEntitySourcedConnection>;
  FlexEntitySourcedConnectionSort: FlexEntitySourcedConnectionSort;
  FlexEntitySourcedConnectionWhere: FlexEntitySourcedConnectionWhere;
  FlexEntitySourcedNodeAggregationWhereInput: FlexEntitySourcedNodeAggregationWhereInput;
  FlexEntitySourcedRelationship: ResolverTypeWrapper<FlexEntitySourcedRelationship>;
  FlexEntitySuccessorAggregateInput: FlexEntitySuccessorAggregateInput;
  FlexEntitySuccessorConnection: ResolverTypeWrapper<FlexEntitySuccessorConnection>;
  FlexEntitySuccessorConnectionSort: FlexEntitySuccessorConnectionSort;
  FlexEntitySuccessorConnectionWhere: FlexEntitySuccessorConnectionWhere;
  FlexEntitySuccessorNodeAggregationWhereInput: FlexEntitySuccessorNodeAggregationWhereInput;
  FlexEntitySuccessorRelationship: ResolverTypeWrapper<FlexEntitySuccessorRelationship>;
  FlexEntityType: ResolverTypeWrapper<FlexEntityType>;
  FlexEntityTypeAddedByAggregateInput: FlexEntityTypeAddedByAggregateInput;
  FlexEntityTypeAddedByConnection: ResolverTypeWrapper<FlexEntityTypeAddedByConnection>;
  FlexEntityTypeAddedByConnectionSort: FlexEntityTypeAddedByConnectionSort;
  FlexEntityTypeAddedByConnectionWhere: FlexEntityTypeAddedByConnectionWhere;
  FlexEntityTypeAddedByNodeAggregationWhereInput: FlexEntityTypeAddedByNodeAggregationWhereInput;
  FlexEntityTypeAddedByRelationship: ResolverTypeWrapper<FlexEntityTypeAddedByRelationship>;
  FlexEntityTypeAggregateInput: FlexEntityTypeAggregateInput;
  FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection: ResolverTypeWrapper<FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection>;
  FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection: ResolverTypeWrapper<FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection>;
  FlexEntityTypeCatalogueAttributeRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['FlexEntityTypeCatalogueAttributeRelationship']>;
  FlexEntityTypeCatalogueAttributeRelationshipSort: FlexEntityTypeCatalogueAttributeRelationshipSort;
  FlexEntityTypeCatalogueAttributeRelationshipWhere: FlexEntityTypeCatalogueAttributeRelationshipWhere;
  FlexEntityTypeCatalogueAttributesAggregateInput: FlexEntityTypeCatalogueAttributesAggregateInput;
  FlexEntityTypeCatalogueAttributesConnection: ResolverTypeWrapper<FlexEntityTypeCatalogueAttributesConnection>;
  FlexEntityTypeCatalogueAttributesConnectionSort: FlexEntityTypeCatalogueAttributesConnectionSort;
  FlexEntityTypeCatalogueAttributesConnectionWhere: FlexEntityTypeCatalogueAttributesConnectionWhere;
  FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput: FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput;
  FlexEntityTypeCatalogueAttributesRelationship: ResolverTypeWrapper<FlexEntityTypeCatalogueAttributesRelationship>;
  FlexEntityTypeConnection: ResolverTypeWrapper<FlexEntityTypeConnection>;
  FlexEntityTypeConnectionSort: FlexEntityTypeConnectionSort;
  FlexEntityTypeConnectionWhere: FlexEntityTypeConnectionWhere;
  FlexEntityTypeEdge: ResolverTypeWrapper<FlexEntityTypeEdge>;
  FlexEntityTypeFlexEntityInstancesAggregationSelection: ResolverTypeWrapper<FlexEntityTypeFlexEntityInstancesAggregationSelection>;
  FlexEntityTypeFlexEntityInstancesNodeAggregateSelection: ResolverTypeWrapper<FlexEntityTypeFlexEntityInstancesNodeAggregateSelection>;
  FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection: ResolverTypeWrapper<FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection>;
  FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection: ResolverTypeWrapper<FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection>;
  FlexEntityTypeInstancesAggregateInput: FlexEntityTypeInstancesAggregateInput;
  FlexEntityTypeInstancesConnection: ResolverTypeWrapper<FlexEntityTypeInstancesConnection>;
  FlexEntityTypeInstancesConnectionSort: FlexEntityTypeInstancesConnectionSort;
  FlexEntityTypeInstancesConnectionWhere: FlexEntityTypeInstancesConnectionWhere;
  FlexEntityTypeInstancesNodeAggregationWhereInput: FlexEntityTypeInstancesNodeAggregationWhereInput;
  FlexEntityTypeInstancesRelationship: ResolverTypeWrapper<FlexEntityTypeInstancesRelationship>;
  FlexEntityTypeMappingInstancesAggregateInput: FlexEntityTypeMappingInstancesAggregateInput;
  FlexEntityTypeMappingInstancesConnection: ResolverTypeWrapper<FlexEntityTypeMappingInstancesConnection>;
  FlexEntityTypeMappingInstancesConnectionSort: FlexEntityTypeMappingInstancesConnectionSort;
  FlexEntityTypeMappingInstancesConnectionWhere: FlexEntityTypeMappingInstancesConnectionWhere;
  FlexEntityTypeMappingInstancesEdgeAggregationWhereInput: FlexEntityTypeMappingInstancesEdgeAggregationWhereInput;
  FlexEntityTypeMappingInstancesNodeAggregationWhereInput: FlexEntityTypeMappingInstancesNodeAggregationWhereInput;
  FlexEntityTypeMappingInstancesRelationship: ResolverTypeWrapper<FlexEntityTypeMappingInstancesRelationship>;
  FlexEntityTypeNodeAggregationWhereInput: FlexEntityTypeNodeAggregationWhereInput;
  FlexEntityTypeOptions: FlexEntityTypeOptions;
  FlexEntityTypeOrganizationMappingInstancesAggregationSelection: ResolverTypeWrapper<FlexEntityTypeOrganizationMappingInstancesAggregationSelection>;
  FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection: ResolverTypeWrapper<FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection>;
  FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection: ResolverTypeWrapper<FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection>;
  FlexEntityTypeRecordTypesAggregateInput: FlexEntityTypeRecordTypesAggregateInput;
  FlexEntityTypeRecordTypesConnection: ResolverTypeWrapper<FlexEntityTypeRecordTypesConnection>;
  FlexEntityTypeRecordTypesConnectionSort: FlexEntityTypeRecordTypesConnectionSort;
  FlexEntityTypeRecordTypesConnectionWhere: FlexEntityTypeRecordTypesConnectionWhere;
  FlexEntityTypeRecordTypesNodeAggregationWhereInput: FlexEntityTypeRecordTypesNodeAggregationWhereInput;
  FlexEntityTypeRecordTypesRelationship: ResolverTypeWrapper<FlexEntityTypeRecordTypesRelationship>;
  FlexEntityTypeRelationship: ResolverTypeWrapper<FlexEntityTypeRelationship>;
  FlexEntityTypeSort: FlexEntityTypeSort;
  FlexEntityTypeUserAddedByAggregationSelection: ResolverTypeWrapper<FlexEntityTypeUserAddedByAggregationSelection>;
  FlexEntityTypeUserAddedByNodeAggregateSelection: ResolverTypeWrapper<FlexEntityTypeUserAddedByNodeAggregateSelection>;
  FlexEntityTypeWhere: FlexEntityTypeWhere;
  FlexEntityTypesConnection: ResolverTypeWrapper<FlexEntityTypesConnection>;
  FlexEntityUploadAggregateInput: FlexEntityUploadAggregateInput;
  FlexEntityUploadConnection: ResolverTypeWrapper<FlexEntityUploadConnection>;
  FlexEntityUploadConnectionSort: FlexEntityUploadConnectionSort;
  FlexEntityUploadConnectionWhere: FlexEntityUploadConnectionWhere;
  FlexEntityUploadNodeAggregationWhereInput: FlexEntityUploadNodeAggregationWhereInput;
  FlexEntityUploadRelationship: ResolverTypeWrapper<FlexEntityUploadRelationship>;
  FlexEntityUploadUploadAggregationSelection: ResolverTypeWrapper<FlexEntityUploadUploadAggregationSelection>;
  FlexEntityUploadUploadNodeAggregateSelection: ResolverTypeWrapper<FlexEntityUploadUploadNodeAggregateSelection>;
  FlexEntityUserCreatedByAggregationSelection: ResolverTypeWrapper<FlexEntityUserCreatedByAggregationSelection>;
  FlexEntityUserCreatedByNodeAggregateSelection: ResolverTypeWrapper<FlexEntityUserCreatedByNodeAggregateSelection>;
  FlexEntityWhere: FlexEntityWhere;
  FlexFieldsInput: FlexFieldsInput;
  FlexFinancialDataPoint: ResolverTypeWrapper<FlexFinancialDataPoint>;
  FlexFinancialDataPointAgreementAggregateInput: FlexFinancialDataPointAgreementAggregateInput;
  FlexFinancialDataPointAgreementAgreementAggregationSelection: ResolverTypeWrapper<FlexFinancialDataPointAgreementAgreementAggregationSelection>;
  FlexFinancialDataPointAgreementAgreementNodeAggregateSelection: ResolverTypeWrapper<FlexFinancialDataPointAgreementAgreementNodeAggregateSelection>;
  FlexFinancialDataPointAgreementConnection: ResolverTypeWrapper<FlexFinancialDataPointAgreementConnection>;
  FlexFinancialDataPointAgreementConnectionSort: FlexFinancialDataPointAgreementConnectionSort;
  FlexFinancialDataPointAgreementConnectionWhere: FlexFinancialDataPointAgreementConnectionWhere;
  FlexFinancialDataPointAgreementNodeAggregationWhereInput: FlexFinancialDataPointAgreementNodeAggregationWhereInput;
  FlexFinancialDataPointAgreementRelationship: ResolverTypeWrapper<FlexFinancialDataPointAgreementRelationship>;
  FlexFinancialDataPointCaseGeneratedForAggregationSelection: ResolverTypeWrapper<FlexFinancialDataPointCaseGeneratedForAggregationSelection>;
  FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection: ResolverTypeWrapper<FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection>;
  FlexFinancialDataPointEdge: ResolverTypeWrapper<FlexFinancialDataPointEdge>;
  FlexFinancialDataPointEvaluatesAggregateInput: FlexFinancialDataPointEvaluatesAggregateInput;
  FlexFinancialDataPointEvaluatesConnection: ResolverTypeWrapper<FlexFinancialDataPointEvaluatesConnection>;
  FlexFinancialDataPointEvaluatesConnectionSort: FlexFinancialDataPointEvaluatesConnectionSort;
  FlexFinancialDataPointEvaluatesConnectionWhere: FlexFinancialDataPointEvaluatesConnectionWhere;
  FlexFinancialDataPointEvaluatesNodeAggregationWhereInput: FlexFinancialDataPointEvaluatesNodeAggregationWhereInput;
  FlexFinancialDataPointEvaluatesRelationship: ResolverTypeWrapper<FlexFinancialDataPointEvaluatesRelationship>;
  FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection: ResolverTypeWrapper<FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection>;
  FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection: ResolverTypeWrapper<FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection>;
  FlexFinancialDataPointGeneratedForAggregateInput: FlexFinancialDataPointGeneratedForAggregateInput;
  FlexFinancialDataPointGeneratedForConnection: ResolverTypeWrapper<FlexFinancialDataPointGeneratedForConnection>;
  FlexFinancialDataPointGeneratedForConnectionSort: FlexFinancialDataPointGeneratedForConnectionSort;
  FlexFinancialDataPointGeneratedForConnectionWhere: FlexFinancialDataPointGeneratedForConnectionWhere;
  FlexFinancialDataPointGeneratedForNodeAggregationWhereInput: FlexFinancialDataPointGeneratedForNodeAggregationWhereInput;
  FlexFinancialDataPointGeneratedForRelationship: ResolverTypeWrapper<FlexFinancialDataPointGeneratedForRelationship>;
  FlexFinancialDataPointOptions: FlexFinancialDataPointOptions;
  FlexFinancialDataPointRefundSourceDocumentAggregationSelection: ResolverTypeWrapper<FlexFinancialDataPointRefundSourceDocumentAggregationSelection>;
  FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection: ResolverTypeWrapper<FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection>;
  FlexFinancialDataPointRefundSourceRefundAggregationSelection: ResolverTypeWrapper<FlexFinancialDataPointRefundSourceRefundAggregationSelection>;
  FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection: ResolverTypeWrapper<FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection>;
  FlexFinancialDataPointSort: FlexFinancialDataPointSort;
  FlexFinancialDataPointSourceDocumentAggregateInput: FlexFinancialDataPointSourceDocumentAggregateInput;
  FlexFinancialDataPointSourceDocumentConnection: ResolverTypeWrapper<FlexFinancialDataPointSourceDocumentConnection>;
  FlexFinancialDataPointSourceDocumentConnectionSort: FlexFinancialDataPointSourceDocumentConnectionSort;
  FlexFinancialDataPointSourceDocumentConnectionWhere: FlexFinancialDataPointSourceDocumentConnectionWhere;
  FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput: FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput;
  FlexFinancialDataPointSourceDocumentRelationship: ResolverTypeWrapper<FlexFinancialDataPointSourceDocumentRelationship>;
  FlexFinancialDataPointSourceRefundAggregateInput: FlexFinancialDataPointSourceRefundAggregateInput;
  FlexFinancialDataPointSourceRefundConnection: ResolverTypeWrapper<FlexFinancialDataPointSourceRefundConnection>;
  FlexFinancialDataPointSourceRefundConnectionSort: FlexFinancialDataPointSourceRefundConnectionSort;
  FlexFinancialDataPointSourceRefundConnectionWhere: FlexFinancialDataPointSourceRefundConnectionWhere;
  FlexFinancialDataPointSourceRefundNodeAggregationWhereInput: FlexFinancialDataPointSourceRefundNodeAggregationWhereInput;
  FlexFinancialDataPointSourceRefundRelationship: ResolverTypeWrapper<FlexFinancialDataPointSourceRefundRelationship>;
  FlexFinancialDataPointTreatmentAggregateInput: FlexFinancialDataPointTreatmentAggregateInput;
  FlexFinancialDataPointTreatmentConnection: ResolverTypeWrapper<FlexFinancialDataPointTreatmentConnection>;
  FlexFinancialDataPointTreatmentConnectionSort: FlexFinancialDataPointTreatmentConnectionSort;
  FlexFinancialDataPointTreatmentConnectionWhere: FlexFinancialDataPointTreatmentConnectionWhere;
  FlexFinancialDataPointTreatmentNodeAggregationWhereInput: FlexFinancialDataPointTreatmentNodeAggregationWhereInput;
  FlexFinancialDataPointTreatmentRelationship: ResolverTypeWrapper<FlexFinancialDataPointTreatmentRelationship>;
  FlexFinancialDataPointTreatmentTreatmentAggregationSelection: ResolverTypeWrapper<FlexFinancialDataPointTreatmentTreatmentAggregationSelection>;
  FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection: ResolverTypeWrapper<FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection>;
  FlexFinancialDataPointWhere: FlexFinancialDataPointWhere;
  FlexFinancialDataPointsConnection: ResolverTypeWrapper<FlexFinancialDataPointsConnection>;
  FlexFormStatus: FlexFormStatus;
  FlexQueriesConnection: ResolverTypeWrapper<FlexQueriesConnection>;
  FlexQuery: ResolverTypeWrapper<FlexQuery>;
  FlexQueryCreatedByAggregateInput: FlexQueryCreatedByAggregateInput;
  FlexQueryCreatedByConnection: ResolverTypeWrapper<FlexQueryCreatedByConnection>;
  FlexQueryCreatedByConnectionSort: FlexQueryCreatedByConnectionSort;
  FlexQueryCreatedByConnectionWhere: FlexQueryCreatedByConnectionWhere;
  FlexQueryCreatedByNodeAggregationWhereInput: FlexQueryCreatedByNodeAggregationWhereInput;
  FlexQueryCreatedByRelationship: ResolverTypeWrapper<FlexQueryCreatedByRelationship>;
  FlexQueryEdge: ResolverTypeWrapper<FlexQueryEdge>;
  FlexQueryFlexQueryRunRunsAggregationSelection: ResolverTypeWrapper<FlexQueryFlexQueryRunRunsAggregationSelection>;
  FlexQueryFlexQueryRunRunsNodeAggregateSelection: ResolverTypeWrapper<FlexQueryFlexQueryRunRunsNodeAggregateSelection>;
  FlexQueryInput: FlexQueryInput;
  FlexQueryOptions: FlexQueryOptions;
  FlexQueryRun: ResolverTypeWrapper<FlexQueryRun>;
  FlexQueryRunEdge: ResolverTypeWrapper<FlexQueryRunEdge>;
  FlexQueryRunFlexQueryQueryAggregationSelection: ResolverTypeWrapper<FlexQueryRunFlexQueryQueryAggregationSelection>;
  FlexQueryRunFlexQueryQueryNodeAggregateSelection: ResolverTypeWrapper<FlexQueryRunFlexQueryQueryNodeAggregateSelection>;
  FlexQueryRunOptions: FlexQueryRunOptions;
  FlexQueryRunQueryAggregateInput: FlexQueryRunQueryAggregateInput;
  FlexQueryRunQueryConnection: ResolverTypeWrapper<FlexQueryRunQueryConnection>;
  FlexQueryRunQueryConnectionSort: FlexQueryRunQueryConnectionSort;
  FlexQueryRunQueryConnectionWhere: FlexQueryRunQueryConnectionWhere;
  FlexQueryRunQueryNodeAggregationWhereInput: FlexQueryRunQueryNodeAggregationWhereInput;
  FlexQueryRunQueryRelationship: ResolverTypeWrapper<FlexQueryRunQueryRelationship>;
  FlexQueryRunSort: FlexQueryRunSort;
  FlexQueryRunStartedByAggregateInput: FlexQueryRunStartedByAggregateInput;
  FlexQueryRunStartedByConnection: ResolverTypeWrapper<FlexQueryRunStartedByConnection>;
  FlexQueryRunStartedByConnectionSort: FlexQueryRunStartedByConnectionSort;
  FlexQueryRunStartedByConnectionWhere: FlexQueryRunStartedByConnectionWhere;
  FlexQueryRunStartedByNodeAggregationWhereInput: FlexQueryRunStartedByNodeAggregationWhereInput;
  FlexQueryRunStartedByRelationship: ResolverTypeWrapper<FlexQueryRunStartedByRelationship>;
  FlexQueryRunUserStartedByAggregationSelection: ResolverTypeWrapper<FlexQueryRunUserStartedByAggregationSelection>;
  FlexQueryRunUserStartedByNodeAggregateSelection: ResolverTypeWrapper<FlexQueryRunUserStartedByNodeAggregateSelection>;
  FlexQueryRunWhere: FlexQueryRunWhere;
  FlexQueryRunsAggregateInput: FlexQueryRunsAggregateInput;
  FlexQueryRunsConnection: ResolverTypeWrapper<FlexQueryRunsConnection>;
  FlexQueryRunsConnectionSort: FlexQueryRunsConnectionSort;
  FlexQueryRunsConnectionWhere: FlexQueryRunsConnectionWhere;
  FlexQueryRunsNodeAggregationWhereInput: FlexQueryRunsNodeAggregationWhereInput;
  FlexQueryRunsRelationship: ResolverTypeWrapper<FlexQueryRunsRelationship>;
  FlexQuerySort: FlexQuerySort;
  FlexQueryUpdatedByAggregateInput: FlexQueryUpdatedByAggregateInput;
  FlexQueryUpdatedByConnection: ResolverTypeWrapper<FlexQueryUpdatedByConnection>;
  FlexQueryUpdatedByConnectionSort: FlexQueryUpdatedByConnectionSort;
  FlexQueryUpdatedByConnectionWhere: FlexQueryUpdatedByConnectionWhere;
  FlexQueryUpdatedByNodeAggregationWhereInput: FlexQueryUpdatedByNodeAggregationWhereInput;
  FlexQueryUpdatedByRelationship: ResolverTypeWrapper<FlexQueryUpdatedByRelationship>;
  FlexQueryUserCreatedByAggregationSelection: ResolverTypeWrapper<FlexQueryUserCreatedByAggregationSelection>;
  FlexQueryUserCreatedByNodeAggregateSelection: ResolverTypeWrapper<FlexQueryUserCreatedByNodeAggregateSelection>;
  FlexQueryUserUpdatedByAggregationSelection: ResolverTypeWrapper<FlexQueryUserUpdatedByAggregationSelection>;
  FlexQueryUserUpdatedByNodeAggregateSelection: ResolverTypeWrapper<FlexQueryUserUpdatedByNodeAggregateSelection>;
  FlexQueryWhere: FlexQueryWhere;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FloatAggregateSelectionNonNullable: ResolverTypeWrapper<FloatAggregateSelectionNonNullable>;
  FloatAggregateSelectionNullable: ResolverTypeWrapper<FloatAggregateSelectionNullable>;
  Generic: ResolverTypeWrapper<Generic>;
  GenericCreatedByAggregateInput: GenericCreatedByAggregateInput;
  GenericCreatedByConnection: ResolverTypeWrapper<GenericCreatedByConnection>;
  GenericCreatedByConnectionSort: GenericCreatedByConnectionSort;
  GenericCreatedByConnectionWhere: GenericCreatedByConnectionWhere;
  GenericCreatedByNodeAggregationWhereInput: GenericCreatedByNodeAggregationWhereInput;
  GenericCreatedByRelationship: ResolverTypeWrapper<GenericCreatedByRelationship>;
  GenericEdge: ResolverTypeWrapper<GenericEdge>;
  GenericInput: GenericInput;
  GenericOptions: GenericOptions;
  GenericPreparationPreparationsAggregationSelection: ResolverTypeWrapper<GenericPreparationPreparationsAggregationSelection>;
  GenericPreparationPreparationsNodeAggregateSelection: ResolverTypeWrapper<GenericPreparationPreparationsNodeAggregateSelection>;
  GenericPreparationsAggregateInput: GenericPreparationsAggregateInput;
  GenericPreparationsConnection: ResolverTypeWrapper<GenericPreparationsConnection>;
  GenericPreparationsConnectionSort: GenericPreparationsConnectionSort;
  GenericPreparationsConnectionWhere: GenericPreparationsConnectionWhere;
  GenericPreparationsNodeAggregationWhereInput: GenericPreparationsNodeAggregationWhereInput;
  GenericPreparationsRelationship: ResolverTypeWrapper<GenericPreparationsRelationship>;
  GenericSort: GenericSort;
  GenericTreatmentSetTreatmentSetsAggregationSelection: ResolverTypeWrapper<GenericTreatmentSetTreatmentSetsAggregationSelection>;
  GenericTreatmentSetTreatmentSetsNodeAggregateSelection: ResolverTypeWrapper<GenericTreatmentSetTreatmentSetsNodeAggregateSelection>;
  GenericTreatmentSetsAggregateInput: GenericTreatmentSetsAggregateInput;
  GenericTreatmentSetsConnection: ResolverTypeWrapper<GenericTreatmentSetsConnection>;
  GenericTreatmentSetsConnectionSort: GenericTreatmentSetsConnectionSort;
  GenericTreatmentSetsConnectionWhere: GenericTreatmentSetsConnectionWhere;
  GenericTreatmentSetsNodeAggregationWhereInput: GenericTreatmentSetsNodeAggregationWhereInput;
  GenericTreatmentSetsRelationship: ResolverTypeWrapper<GenericTreatmentSetsRelationship>;
  GenericUserCreatedByAggregationSelection: ResolverTypeWrapper<GenericUserCreatedByAggregationSelection>;
  GenericUserCreatedByNodeAggregateSelection: ResolverTypeWrapper<GenericUserCreatedByNodeAggregateSelection>;
  GenericWhere: GenericWhere;
  GenericsConnection: ResolverTypeWrapper<GenericsConnection>;
  GetBrandReportItem: ResolverTypeWrapper<GetBrandReportItem>;
  GetBrandReportItemEdge: ResolverTypeWrapper<GetBrandReportItemEdge>;
  GetBrandReportItemOptions: GetBrandReportItemOptions;
  GetBrandReportItemSort: GetBrandReportItemSort;
  GetBrandReportItemWhere: GetBrandReportItemWhere;
  GetBrandReportItemsConnection: ResolverTypeWrapper<GetBrandReportItemsConnection>;
  GetIndicationReportItem: ResolverTypeWrapper<GetIndicationReportItem>;
  GetIndicationReportItemEdge: ResolverTypeWrapper<GetIndicationReportItemEdge>;
  GetIndicationReportItemOptions: GetIndicationReportItemOptions;
  GetIndicationReportItemSort: GetIndicationReportItemSort;
  GetIndicationReportItemWhere: GetIndicationReportItemWhere;
  GetIndicationReportItemsConnection: ResolverTypeWrapper<GetIndicationReportItemsConnection>;
  GetTranslationsVariables: GetTranslationsVariables;
  GlobalLock: ResolverTypeWrapper<GlobalLock>;
  GlobalLockCreatorAggregateInput: GlobalLockCreatorAggregateInput;
  GlobalLockCreatorConnection: ResolverTypeWrapper<GlobalLockCreatorConnection>;
  GlobalLockCreatorConnectionSort: GlobalLockCreatorConnectionSort;
  GlobalLockCreatorConnectionWhere: GlobalLockCreatorConnectionWhere;
  GlobalLockCreatorNodeAggregationWhereInput: GlobalLockCreatorNodeAggregationWhereInput;
  GlobalLockCreatorRelationship: ResolverTypeWrapper<GlobalLockCreatorRelationship>;
  GlobalLockEdge: ResolverTypeWrapper<GlobalLockEdge>;
  GlobalLockOptions: GlobalLockOptions;
  GlobalLockSort: GlobalLockSort;
  GlobalLockUserCreatorAggregationSelection: ResolverTypeWrapper<GlobalLockUserCreatorAggregationSelection>;
  GlobalLockUserCreatorNodeAggregateSelection: ResolverTypeWrapper<GlobalLockUserCreatorNodeAggregateSelection>;
  GlobalLockWhere: GlobalLockWhere;
  GlobalLocksConnection: ResolverTypeWrapper<GlobalLocksConnection>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  IDAggregateSelectionNonNullable: ResolverTypeWrapper<IdAggregateSelectionNonNullable>;
  IDAggregateSelectionNullable: ResolverTypeWrapper<IdAggregateSelectionNullable>;
  ITimeframe: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ITimeframe']>;
  ITreatmentCondition: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ITreatmentCondition']>;
  Icd10Attribute: ResolverTypeWrapper<Icd10Attribute>;
  Icd10AttributeEdge: ResolverTypeWrapper<Icd10AttributeEdge>;
  Icd10AttributeOptions: Icd10AttributeOptions;
  Icd10AttributeSort: Icd10AttributeSort;
  Icd10AttributeWhere: Icd10AttributeWhere;
  Icd10AttributesConnection: ResolverTypeWrapper<Icd10AttributesConnection>;
  Icd10Concept: ResolverTypeWrapper<Icd10Concept>;
  Icd10ConceptEdge: ResolverTypeWrapper<Icd10ConceptEdge>;
  Icd10ConceptOptions: Icd10ConceptOptions;
  Icd10ConceptSort: Icd10ConceptSort;
  Icd10ConceptWhere: Icd10ConceptWhere;
  Icd10ConceptsConnection: ResolverTypeWrapper<Icd10ConceptsConnection>;
  Icd10EntitiesConnection: ResolverTypeWrapper<Icd10EntitiesConnection>;
  Icd10Entity: ResolverTypeWrapper<Icd10Entity>;
  Icd10EntityEdge: ResolverTypeWrapper<Icd10EntityEdge>;
  Icd10EntityOptions: Icd10EntityOptions;
  Icd10EntitySort: Icd10EntitySort;
  Icd10EntityWhere: Icd10EntityWhere;
  Icd10Suggestions: ResolverTypeWrapper<Icd10Suggestions>;
  Icd10SuggestionsConnection: ResolverTypeWrapper<Icd10SuggestionsConnection>;
  Icd10SuggestionsEdge: ResolverTypeWrapper<Icd10SuggestionsEdge>;
  Icd10SuggestionsOptions: Icd10SuggestionsOptions;
  Icd10SuggestionsSort: Icd10SuggestionsSort;
  Icd10SuggestionsWhere: Icd10SuggestionsWhere;
  Icd10Trait: ResolverTypeWrapper<Icd10Trait>;
  Icd10TraitEdge: ResolverTypeWrapper<Icd10TraitEdge>;
  Icd10TraitOptions: Icd10TraitOptions;
  Icd10TraitSort: Icd10TraitSort;
  Icd10TraitWhere: Icd10TraitWhere;
  Icd10TraitsConnection: ResolverTypeWrapper<Icd10TraitsConnection>;
  ImpactCategory: ImpactCategory;
  ImpactItem: ResolverTypeWrapper<ImpactItem>;
  ImpactItemEdge: ResolverTypeWrapper<ImpactItemEdge>;
  ImpactItemOptions: ImpactItemOptions;
  ImpactItemSort: ImpactItemSort;
  ImpactItemWhere: ImpactItemWhere;
  ImpactItemsConnection: ResolverTypeWrapper<ImpactItemsConnection>;
  ImpactSeverity: ImpactSeverity;
  InclusionType: InclusionType;
  Indication: ResolverTypeWrapper<Indication>;
  IndicationEdge: ResolverTypeWrapper<IndicationEdge>;
  IndicationInput: IndicationInput;
  IndicationOptions: IndicationOptions;
  IndicationSort: IndicationSort;
  IndicationWhere: IndicationWhere;
  IndicationsConnection: ResolverTypeWrapper<IndicationsConnection>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  IntAggregateSelectionNonNullable: ResolverTypeWrapper<IntAggregateSelectionNonNullable>;
  IntAggregateSelectionNullable: ResolverTypeWrapper<IntAggregateSelectionNullable>;
  IntegrityCheckCompleteResult: ResolverTypeWrapper<IntegrityCheckCompleteResult>;
  IntegrityCheckCompleteResultEdge: ResolverTypeWrapper<IntegrityCheckCompleteResultEdge>;
  IntegrityCheckCompleteResultOptions: IntegrityCheckCompleteResultOptions;
  IntegrityCheckCompleteResultSort: IntegrityCheckCompleteResultSort;
  IntegrityCheckCompleteResultWhere: IntegrityCheckCompleteResultWhere;
  IntegrityCheckCompleteResultsConnection: ResolverTypeWrapper<IntegrityCheckCompleteResultsConnection>;
  IntegrityCheckTypes: ResolverTypeWrapper<IntegrityCheckTypes>;
  IntegrityCheckTypesConnection: ResolverTypeWrapper<IntegrityCheckTypesConnection>;
  IntegrityCheckTypesEdge: ResolverTypeWrapper<IntegrityCheckTypesEdge>;
  IntegrityCheckTypesOptions: IntegrityCheckTypesOptions;
  IntegrityCheckTypesWhere: IntegrityCheckTypesWhere;
  InterventionOccurrence: InterventionOccurrence;
  InterventionType: InterventionType;
  ItemScope: ItemScope;
  LdlTestUom: LdlTestUom;
  Limitation: ResolverTypeWrapper<Limitation>;
  LimitationAgreementTemplateAggregateInput: LimitationAgreementTemplateAggregateInput;
  LimitationAgreementTemplateAgreementTemplateAggregationSelection: ResolverTypeWrapper<LimitationAgreementTemplateAgreementTemplateAggregationSelection>;
  LimitationAgreementTemplateAgreementTemplateNodeAggregateSelection: ResolverTypeWrapper<LimitationAgreementTemplateAgreementTemplateNodeAggregateSelection>;
  LimitationAgreementTemplateConnection: ResolverTypeWrapper<LimitationAgreementTemplateConnection>;
  LimitationAgreementTemplateConnectionSort: LimitationAgreementTemplateConnectionSort;
  LimitationAgreementTemplateConnectionWhere: LimitationAgreementTemplateConnectionWhere;
  LimitationAgreementTemplateNodeAggregationWhereInput: LimitationAgreementTemplateNodeAggregationWhereInput;
  LimitationAgreementTemplateRelationship: ResolverTypeWrapper<LimitationAgreementTemplateRelationship>;
  LimitationEdge: ResolverTypeWrapper<LimitationEdge>;
  LimitationLimitsPreparationsAggregateInput: LimitationLimitsPreparationsAggregateInput;
  LimitationLimitsPreparationsConnection: ResolverTypeWrapper<LimitationLimitsPreparationsConnection>;
  LimitationLimitsPreparationsConnectionSort: LimitationLimitsPreparationsConnectionSort;
  LimitationLimitsPreparationsConnectionWhere: LimitationLimitsPreparationsConnectionWhere;
  LimitationLimitsPreparationsNodeAggregationWhereInput: LimitationLimitsPreparationsNodeAggregationWhereInput;
  LimitationLimitsPreparationsRelationship: ResolverTypeWrapper<LimitationLimitsPreparationsRelationship>;
  LimitationLimitsTreatmentsBySelfAggregateInput: LimitationLimitsTreatmentsBySelfAggregateInput;
  LimitationLimitsTreatmentsBySelfConnection: ResolverTypeWrapper<LimitationLimitsTreatmentsBySelfConnection>;
  LimitationLimitsTreatmentsBySelfConnectionSort: LimitationLimitsTreatmentsBySelfConnectionSort;
  LimitationLimitsTreatmentsBySelfConnectionWhere: LimitationLimitsTreatmentsBySelfConnectionWhere;
  LimitationLimitsTreatmentsBySelfNodeAggregationWhereInput: LimitationLimitsTreatmentsBySelfNodeAggregationWhereInput;
  LimitationLimitsTreatmentsBySelfRelationship: ResolverTypeWrapper<LimitationLimitsTreatmentsBySelfRelationship>;
  LimitationLimitsTreatmentsThroughPreparationAggregateInput: LimitationLimitsTreatmentsThroughPreparationAggregateInput;
  LimitationLimitsTreatmentsThroughPreparationConnection: ResolverTypeWrapper<LimitationLimitsTreatmentsThroughPreparationConnection>;
  LimitationLimitsTreatmentsThroughPreparationConnectionSort: LimitationLimitsTreatmentsThroughPreparationConnectionSort;
  LimitationLimitsTreatmentsThroughPreparationConnectionWhere: LimitationLimitsTreatmentsThroughPreparationConnectionWhere;
  LimitationLimitsTreatmentsThroughPreparationNodeAggregationWhereInput: LimitationLimitsTreatmentsThroughPreparationNodeAggregationWhereInput;
  LimitationLimitsTreatmentsThroughPreparationRelationship: ResolverTypeWrapper<LimitationLimitsTreatmentsThroughPreparationRelationship>;
  LimitationOptions: LimitationOptions;
  LimitationPreparationLimitsPreparationsAggregationSelection: ResolverTypeWrapper<LimitationPreparationLimitsPreparationsAggregationSelection>;
  LimitationPreparationLimitsPreparationsNodeAggregateSelection: ResolverTypeWrapper<LimitationPreparationLimitsPreparationsNodeAggregateSelection>;
  LimitationSort: LimitationSort;
  LimitationTreatmentLimitsTreatmentsBySelfAggregationSelection: ResolverTypeWrapper<LimitationTreatmentLimitsTreatmentsBySelfAggregationSelection>;
  LimitationTreatmentLimitsTreatmentsBySelfNodeAggregateSelection: ResolverTypeWrapper<LimitationTreatmentLimitsTreatmentsBySelfNodeAggregateSelection>;
  LimitationTreatmentLimitsTreatmentsThroughPreparationAggregationSelection: ResolverTypeWrapper<LimitationTreatmentLimitsTreatmentsThroughPreparationAggregationSelection>;
  LimitationTreatmentLimitsTreatmentsThroughPreparationNodeAggregateSelection: ResolverTypeWrapper<LimitationTreatmentLimitsTreatmentsThroughPreparationNodeAggregateSelection>;
  LimitationWhere: LimitationWhere;
  LimitationsConnection: ResolverTypeWrapper<LimitationsConnection>;
  LocalizationKeySuggestions: ResolverTypeWrapper<LocalizationKeySuggestions>;
  LocalizationKeySuggestionsConnection: ResolverTypeWrapper<LocalizationKeySuggestionsConnection>;
  LocalizationKeySuggestionsEdge: ResolverTypeWrapper<LocalizationKeySuggestionsEdge>;
  LocalizationKeySuggestionsOptions: LocalizationKeySuggestionsOptions;
  LocalizationKeySuggestionsSort: LocalizationKeySuggestionsSort;
  LocalizationKeySuggestionsWhere: LocalizationKeySuggestionsWhere;
  LockType: LockType;
  MainIndication: ResolverTypeWrapper<MainIndication>;
  MainIndicationArticle71IndicationAggregateInput: MainIndicationArticle71IndicationAggregateInput;
  MainIndicationArticle71IndicationArticle71IndicationAggregationSelection: ResolverTypeWrapper<MainIndicationArticle71IndicationArticle71IndicationAggregationSelection>;
  MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection: ResolverTypeWrapper<MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection>;
  MainIndicationArticle71IndicationConnection: ResolverTypeWrapper<MainIndicationArticle71IndicationConnection>;
  MainIndicationArticle71IndicationConnectionSort: MainIndicationArticle71IndicationConnectionSort;
  MainIndicationArticle71IndicationConnectionWhere: MainIndicationArticle71IndicationConnectionWhere;
  MainIndicationArticle71IndicationNodeAggregationWhereInput: MainIndicationArticle71IndicationNodeAggregationWhereInput;
  MainIndicationArticle71IndicationRelationship: ResolverTypeWrapper<MainIndicationArticle71IndicationRelationship>;
  MainIndicationBrandAggregateInput: MainIndicationBrandAggregateInput;
  MainIndicationBrandBrandAggregationSelection: ResolverTypeWrapper<MainIndicationBrandBrandAggregationSelection>;
  MainIndicationBrandBrandNodeAggregateSelection: ResolverTypeWrapper<MainIndicationBrandBrandNodeAggregateSelection>;
  MainIndicationBrandConnection: ResolverTypeWrapper<MainIndicationBrandConnection>;
  MainIndicationBrandConnectionSort: MainIndicationBrandConnectionSort;
  MainIndicationBrandConnectionWhere: MainIndicationBrandConnectionWhere;
  MainIndicationBrandNodeAggregationWhereInput: MainIndicationBrandNodeAggregationWhereInput;
  MainIndicationBrandRelationship: ResolverTypeWrapper<MainIndicationBrandRelationship>;
  MainIndicationEdge: ResolverTypeWrapper<MainIndicationEdge>;
  MainIndicationInput: MainIndicationInput;
  MainIndicationOptions: MainIndicationOptions;
  MainIndicationSort: MainIndicationSort;
  MainIndicationWhere: MainIndicationWhere;
  MainIndicationsConnection: ResolverTypeWrapper<MainIndicationsConnection>;
  MasterDataCreationWay: MasterDataCreationWay;
  MasterDataRefundImpact: ResolverTypeWrapper<MasterDataRefundImpact>;
  MasterDataRefundImpactEdge: ResolverTypeWrapper<MasterDataRefundImpactEdge>;
  MasterDataRefundImpactOptions: MasterDataRefundImpactOptions;
  MasterDataRefundImpactSort: MasterDataRefundImpactSort;
  MasterDataRefundImpactWhere: MasterDataRefundImpactWhere;
  MasterDataRefundImpactsConnection: ResolverTypeWrapper<MasterDataRefundImpactsConnection>;
  MasterDataUploadHistoryRecord: ResolverTypeWrapper<MasterDataUploadHistoryRecord>;
  MasterDataUploadHistoryRecordEdge: ResolverTypeWrapper<MasterDataUploadHistoryRecordEdge>;
  MasterDataUploadHistoryRecordOptions: MasterDataUploadHistoryRecordOptions;
  MasterDataUploadHistoryRecordSort: MasterDataUploadHistoryRecordSort;
  MasterDataUploadHistoryRecordWhere: MasterDataUploadHistoryRecordWhere;
  MasterDataUploadHistoryRecordsConnection: ResolverTypeWrapper<MasterDataUploadHistoryRecordsConnection>;
  MasterDataUploadStatus: MasterDataUploadStatus;
  Message: ResolverTypeWrapper<Message>;
  MessageCaseAggregateInput: MessageCaseAggregateInput;
  MessageCaseCaseAggregationSelection: ResolverTypeWrapper<MessageCaseCaseAggregationSelection>;
  MessageCaseCaseNodeAggregateSelection: ResolverTypeWrapper<MessageCaseCaseNodeAggregateSelection>;
  MessageCaseConnection: ResolverTypeWrapper<MessageCaseConnection>;
  MessageCaseConnectionSort: MessageCaseConnectionSort;
  MessageCaseConnectionWhere: MessageCaseConnectionWhere;
  MessageCaseNodeAggregationWhereInput: MessageCaseNodeAggregationWhereInput;
  MessageCaseRelationship: ResolverTypeWrapper<MessageCaseRelationship>;
  MessageEdge: ResolverTypeWrapper<MessageEdge>;
  MessageMentionsAggregateInput: MessageMentionsAggregateInput;
  MessageMentionsConnection: ResolverTypeWrapper<MessageMentionsConnection>;
  MessageMentionsConnectionSort: MessageMentionsConnectionSort;
  MessageMentionsConnectionWhere: MessageMentionsConnectionWhere;
  MessageMentionsNodeAggregationWhereInput: MessageMentionsNodeAggregationWhereInput;
  MessageMentionsRelationship: ResolverTypeWrapper<MessageMentionsRelationship>;
  MessageOptions: MessageOptions;
  MessageSentByAggregateInput: MessageSentByAggregateInput;
  MessageSentByConnection: ResolverTypeWrapper<MessageSentByConnection>;
  MessageSentByConnectionSort: MessageSentByConnectionSort;
  MessageSentByConnectionWhere: MessageSentByConnectionWhere;
  MessageSentByNodeAggregationWhereInput: MessageSentByNodeAggregationWhereInput;
  MessageSentByRelationship: ResolverTypeWrapper<MessageSentByRelationship>;
  MessageSort: MessageSort;
  MessageUserMentionsAggregationSelection: ResolverTypeWrapper<MessageUserMentionsAggregationSelection>;
  MessageUserMentionsNodeAggregateSelection: ResolverTypeWrapper<MessageUserMentionsNodeAggregateSelection>;
  MessageUserSentByAggregationSelection: ResolverTypeWrapper<MessageUserSentByAggregationSelection>;
  MessageUserSentByNodeAggregateSelection: ResolverTypeWrapper<MessageUserSentByNodeAggregateSelection>;
  MessageWhere: MessageWhere;
  MessagesConnection: ResolverTypeWrapper<MessagesConnection>;
  MissingTranslationKeys: ResolverTypeWrapper<MissingTranslationKeys>;
  MissingTranslationKeysConnection: ResolverTypeWrapper<MissingTranslationKeysConnection>;
  MissingTranslationKeysEdge: ResolverTypeWrapper<MissingTranslationKeysEdge>;
  MissingTranslationKeysOptions: MissingTranslationKeysOptions;
  MissingTranslationKeysSort: MissingTranslationKeysSort;
  MissingTranslationKeysWhere: MissingTranslationKeysWhere;
  Module: ResolverTypeWrapper<Module>;
  ModuleEdge: ResolverTypeWrapper<ModuleEdge>;
  ModuleInput: ModuleInput;
  ModuleOptions: ModuleOptions;
  ModuleSort: ModuleSort;
  ModuleWhere: ModuleWhere;
  ModulesConnection: ResolverTypeWrapper<ModulesConnection>;
  MonitoringType: MonitoringType;
  Mutation: ResolverTypeWrapper<{}>;
  NegotiationRound: ResolverTypeWrapper<NegotiationRound>;
  NegotiationRoundCaseAggregateInput: NegotiationRoundCaseAggregateInput;
  NegotiationRoundCaseCaseAggregationSelection: ResolverTypeWrapper<NegotiationRoundCaseCaseAggregationSelection>;
  NegotiationRoundCaseCaseNodeAggregateSelection: ResolverTypeWrapper<NegotiationRoundCaseCaseNodeAggregateSelection>;
  NegotiationRoundCaseConnection: ResolverTypeWrapper<NegotiationRoundCaseConnection>;
  NegotiationRoundCaseConnectionSort: NegotiationRoundCaseConnectionSort;
  NegotiationRoundCaseConnectionWhere: NegotiationRoundCaseConnectionWhere;
  NegotiationRoundCaseNodeAggregationWhereInput: NegotiationRoundCaseNodeAggregationWhereInput;
  NegotiationRoundCaseRelationship: ResolverTypeWrapper<NegotiationRoundCaseRelationship>;
  NegotiationRoundEdge: ResolverTypeWrapper<NegotiationRoundEdge>;
  NegotiationRoundFlexEntitySourceAggregationSelection: ResolverTypeWrapper<NegotiationRoundFlexEntitySourceAggregationSelection>;
  NegotiationRoundFlexEntitySourceNodeAggregateSelection: ResolverTypeWrapper<NegotiationRoundFlexEntitySourceNodeAggregateSelection>;
  NegotiationRoundOptions: NegotiationRoundOptions;
  NegotiationRoundOrganizationProposedByAggregationSelection: ResolverTypeWrapper<NegotiationRoundOrganizationProposedByAggregationSelection>;
  NegotiationRoundOrganizationProposedByNodeAggregateSelection: ResolverTypeWrapper<NegotiationRoundOrganizationProposedByNodeAggregateSelection>;
  NegotiationRoundProposedByAggregateInput: NegotiationRoundProposedByAggregateInput;
  NegotiationRoundProposedByConnection: ResolverTypeWrapper<NegotiationRoundProposedByConnection>;
  NegotiationRoundProposedByConnectionSort: NegotiationRoundProposedByConnectionSort;
  NegotiationRoundProposedByConnectionWhere: NegotiationRoundProposedByConnectionWhere;
  NegotiationRoundProposedByNodeAggregationWhereInput: NegotiationRoundProposedByNodeAggregationWhereInput;
  NegotiationRoundProposedByRelationship: ResolverTypeWrapper<NegotiationRoundProposedByRelationship>;
  NegotiationRoundSort: NegotiationRoundSort;
  NegotiationRoundSourceAggregateInput: NegotiationRoundSourceAggregateInput;
  NegotiationRoundSourceConnection: ResolverTypeWrapper<NegotiationRoundSourceConnection>;
  NegotiationRoundSourceConnectionSort: NegotiationRoundSourceConnectionSort;
  NegotiationRoundSourceConnectionWhere: NegotiationRoundSourceConnectionWhere;
  NegotiationRoundSourceNodeAggregationWhereInput: NegotiationRoundSourceNodeAggregationWhereInput;
  NegotiationRoundSourceRelationship: ResolverTypeWrapper<NegotiationRoundSourceRelationship>;
  NegotiationRoundStatus: NegotiationRoundStatus;
  NegotiationRoundUpdatedByAggregateInput: NegotiationRoundUpdatedByAggregateInput;
  NegotiationRoundUpdatedByConnection: ResolverTypeWrapper<NegotiationRoundUpdatedByConnection>;
  NegotiationRoundUpdatedByConnectionSort: NegotiationRoundUpdatedByConnectionSort;
  NegotiationRoundUpdatedByConnectionWhere: NegotiationRoundUpdatedByConnectionWhere;
  NegotiationRoundUpdatedByNodeAggregationWhereInput: NegotiationRoundUpdatedByNodeAggregationWhereInput;
  NegotiationRoundUpdatedByRelationship: ResolverTypeWrapper<NegotiationRoundUpdatedByRelationship>;
  NegotiationRoundUserUpdatedByAggregationSelection: ResolverTypeWrapper<NegotiationRoundUserUpdatedByAggregationSelection>;
  NegotiationRoundUserUpdatedByNodeAggregateSelection: ResolverTypeWrapper<NegotiationRoundUserUpdatedByNodeAggregateSelection>;
  NegotiationRoundWhere: NegotiationRoundWhere;
  NegotiationRoundsConnection: ResolverTypeWrapper<NegotiationRoundsConnection>;
  Neo4JClusterMemberMetricsConnection: ResolverTypeWrapper<Neo4JClusterMemberMetricsConnection>;
  Neo4JClusterMetricsConnection: ResolverTypeWrapper<Neo4JClusterMetricsConnection>;
  Neo4jClusterMemberMetric: ResolverTypeWrapper<Neo4jClusterMemberMetric>;
  Neo4jClusterMemberMetricEdge: ResolverTypeWrapper<Neo4jClusterMemberMetricEdge>;
  Neo4jClusterMemberMetricOptions: Neo4jClusterMemberMetricOptions;
  Neo4jClusterMemberMetricSort: Neo4jClusterMemberMetricSort;
  Neo4jClusterMemberMetricWhere: Neo4jClusterMemberMetricWhere;
  Neo4jClusterMetrics: ResolverTypeWrapper<Neo4jClusterMetrics>;
  Neo4jClusterMetricsEdge: ResolverTypeWrapper<Neo4jClusterMetricsEdge>;
  Neo4jClusterMetricsOptions: Neo4jClusterMetricsOptions;
  Neo4jClusterMetricsSort: Neo4jClusterMetricsSort;
  Neo4jClusterMetricsWhere: Neo4jClusterMetricsWhere;
  NinjaQueriesConnection: ResolverTypeWrapper<NinjaQueriesConnection>;
  NinjaQuery: ResolverTypeWrapper<NinjaQuery>;
  NinjaQueryEdge: ResolverTypeWrapper<NinjaQueryEdge>;
  NinjaQueryImpact: ResolverTypeWrapper<NinjaQueryImpact>;
  NinjaQueryImpactEdge: ResolverTypeWrapper<NinjaQueryImpactEdge>;
  NinjaQueryImpactOptions: NinjaQueryImpactOptions;
  NinjaQueryImpactSort: NinjaQueryImpactSort;
  NinjaQueryImpactWhere: NinjaQueryImpactWhere;
  NinjaQueryImpactsConnection: ResolverTypeWrapper<NinjaQueryImpactsConnection>;
  NinjaQueryOptions: NinjaQueryOptions;
  NinjaQuerySort: NinjaQuerySort;
  NinjaQuerySubmitResult: ResolverTypeWrapper<NinjaQuerySubmitResult>;
  NinjaQuerySubmitResultEdge: ResolverTypeWrapper<NinjaQuerySubmitResultEdge>;
  NinjaQuerySubmitResultOptions: NinjaQuerySubmitResultOptions;
  NinjaQuerySubmitResultWhere: NinjaQuerySubmitResultWhere;
  NinjaQuerySubmitResultsConnection: ResolverTypeWrapper<NinjaQuerySubmitResultsConnection>;
  NinjaQueryTargetDb: NinjaQueryTargetDb;
  NinjaQueryWhere: NinjaQueryWhere;
  Occurrence: Occurrence;
  OccurrenceEnum: OccurrenceEnum;
  OidDcUser: ResolverTypeWrapper<OidDcUser>;
  OidDcUserEdge: ResolverTypeWrapper<OidDcUserEdge>;
  OidDcUserOptions: OidDcUserOptions;
  OidDcUserSort: OidDcUserSort;
  OidDcUserWhere: OidDcUserWhere;
  OidDcUsersConnection: ResolverTypeWrapper<OidDcUsersConnection>;
  OrgNotificationInput: OrgNotificationInput;
  Organization: ResolverTypeWrapper<Organization>;
  OrganizationAgreementAgreementsAggregationSelection: ResolverTypeWrapper<OrganizationAgreementAgreementsAggregationSelection>;
  OrganizationAgreementAgreementsNodeAggregateSelection: ResolverTypeWrapper<OrganizationAgreementAgreementsNodeAggregateSelection>;
  OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection: ResolverTypeWrapper<OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection>;
  OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection: ResolverTypeWrapper<OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection>;
  OrganizationAgreementRunAttemptsAggregateInput: OrganizationAgreementRunAttemptsAggregateInput;
  OrganizationAgreementRunAttemptsConnection: ResolverTypeWrapper<OrganizationAgreementRunAttemptsConnection>;
  OrganizationAgreementRunAttemptsConnectionSort: OrganizationAgreementRunAttemptsConnectionSort;
  OrganizationAgreementRunAttemptsConnectionWhere: OrganizationAgreementRunAttemptsConnectionWhere;
  OrganizationAgreementRunAttemptsNodeAggregationWhereInput: OrganizationAgreementRunAttemptsNodeAggregationWhereInput;
  OrganizationAgreementRunAttemptsRelationship: ResolverTypeWrapper<OrganizationAgreementRunAttemptsRelationship>;
  OrganizationAgreementsAggregateInput: OrganizationAgreementsAggregateInput;
  OrganizationAgreementsConnection: ResolverTypeWrapper<OrganizationAgreementsConnection>;
  OrganizationAgreementsConnectionSort: OrganizationAgreementsConnectionSort;
  OrganizationAgreementsConnectionWhere: OrganizationAgreementsConnectionWhere;
  OrganizationAgreementsNodeAggregationWhereInput: OrganizationAgreementsNodeAggregationWhereInput;
  OrganizationAgreementsRelationship: ResolverTypeWrapper<OrganizationAgreementsRelationship>;
  OrganizationCountryAggregateInput: OrganizationCountryAggregateInput;
  OrganizationCountryConnection: ResolverTypeWrapper<OrganizationCountryConnection>;
  OrganizationCountryConnectionSort: OrganizationCountryConnectionSort;
  OrganizationCountryConnectionWhere: OrganizationCountryConnectionWhere;
  OrganizationCountryCountryAggregationSelection: ResolverTypeWrapper<OrganizationCountryCountryAggregationSelection>;
  OrganizationCountryCountryNodeAggregateSelection: ResolverTypeWrapper<OrganizationCountryCountryNodeAggregateSelection>;
  OrganizationCountryNodeAggregationWhereInput: OrganizationCountryNodeAggregationWhereInput;
  OrganizationCountryRelationship: ResolverTypeWrapper<OrganizationCountryRelationship>;
  OrganizationDefaultReceiversAggregateInput: OrganizationDefaultReceiversAggregateInput;
  OrganizationDefaultReceiversConnection: ResolverTypeWrapper<OrganizationDefaultReceiversConnection>;
  OrganizationDefaultReceiversConnectionSort: OrganizationDefaultReceiversConnectionSort;
  OrganizationDefaultReceiversConnectionWhere: OrganizationDefaultReceiversConnectionWhere;
  OrganizationDefaultReceiversEdgeAggregationWhereInput: OrganizationDefaultReceiversEdgeAggregationWhereInput;
  OrganizationDefaultReceiversNodeAggregationWhereInput: OrganizationDefaultReceiversNodeAggregationWhereInput;
  OrganizationDefaultReceiversRelationship: ResolverTypeWrapper<OrganizationDefaultReceiversRelationship>;
  OrganizationEdge: ResolverTypeWrapper<OrganizationEdge>;
  OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection: ResolverTypeWrapper<OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection>;
  OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection: ResolverTypeWrapper<OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection>;
  OrganizationEncapsulatedFeaturesAggregateInput: OrganizationEncapsulatedFeaturesAggregateInput;
  OrganizationEncapsulatedFeaturesConnection: ResolverTypeWrapper<OrganizationEncapsulatedFeaturesConnection>;
  OrganizationEncapsulatedFeaturesConnectionSort: OrganizationEncapsulatedFeaturesConnectionSort;
  OrganizationEncapsulatedFeaturesConnectionWhere: OrganizationEncapsulatedFeaturesConnectionWhere;
  OrganizationEncapsulatedFeaturesNodeAggregationWhereInput: OrganizationEncapsulatedFeaturesNodeAggregationWhereInput;
  OrganizationEncapsulatedFeaturesRelationship: ResolverTypeWrapper<OrganizationEncapsulatedFeaturesRelationship>;
  OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection: ResolverTypeWrapper<OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection>;
  OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection: ResolverTypeWrapper<OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection>;
  OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection: ResolverTypeWrapper<OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection>;
  OrganizationFlexEntityTypeMappingsAggregateInput: OrganizationFlexEntityTypeMappingsAggregateInput;
  OrganizationFlexEntityTypeMappingsConnection: ResolverTypeWrapper<OrganizationFlexEntityTypeMappingsConnection>;
  OrganizationFlexEntityTypeMappingsConnectionSort: OrganizationFlexEntityTypeMappingsConnectionSort;
  OrganizationFlexEntityTypeMappingsConnectionWhere: OrganizationFlexEntityTypeMappingsConnectionWhere;
  OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput: OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput;
  OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput: OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput;
  OrganizationFlexEntityTypeMappingsRelationship: ResolverTypeWrapper<OrganizationFlexEntityTypeMappingsRelationship>;
  OrganizationInput: OrganizationInput;
  OrganizationOptions: OrganizationOptions;
  OrganizationOrganizationDefaultReceiversAggregationSelection: ResolverTypeWrapper<OrganizationOrganizationDefaultReceiversAggregationSelection>;
  OrganizationOrganizationDefaultReceiversEdgeAggregateSelection: ResolverTypeWrapper<OrganizationOrganizationDefaultReceiversEdgeAggregateSelection>;
  OrganizationOrganizationDefaultReceiversNodeAggregateSelection: ResolverTypeWrapper<OrganizationOrganizationDefaultReceiversNodeAggregateSelection>;
  OrganizationQuestNotificationQuestNotificationsAggregationSelection: ResolverTypeWrapper<OrganizationQuestNotificationQuestNotificationsAggregationSelection>;
  OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection: ResolverTypeWrapper<OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection>;
  OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection: ResolverTypeWrapper<OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection>;
  OrganizationQuestNotificationsAggregateInput: OrganizationQuestNotificationsAggregateInput;
  OrganizationQuestNotificationsConnection: ResolverTypeWrapper<OrganizationQuestNotificationsConnection>;
  OrganizationQuestNotificationsConnectionSort: OrganizationQuestNotificationsConnectionSort;
  OrganizationQuestNotificationsConnectionWhere: OrganizationQuestNotificationsConnectionWhere;
  OrganizationQuestNotificationsEdgeAggregationWhereInput: OrganizationQuestNotificationsEdgeAggregationWhereInput;
  OrganizationQuestNotificationsNodeAggregationWhereInput: OrganizationQuestNotificationsNodeAggregationWhereInput;
  OrganizationQuestNotificationsRelationship: ResolverTypeWrapper<OrganizationQuestNotificationsRelationship>;
  OrganizationQuestRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrganizationQuestRelationship']>;
  OrganizationQuestRelationshipSort: OrganizationQuestRelationshipSort;
  OrganizationQuestRelationshipWhere: OrganizationQuestRelationshipWhere;
  OrganizationScope: ResolverTypeWrapper<OrganizationScope>;
  OrganizationScopeEdge: ResolverTypeWrapper<OrganizationScopeEdge>;
  OrganizationScopeOptions: OrganizationScopeOptions;
  OrganizationScopeRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrganizationScopeRelationship']>;
  OrganizationScopeRelationshipSort: OrganizationScopeRelationshipSort;
  OrganizationScopeRelationshipWhere: OrganizationScopeRelationshipWhere;
  OrganizationScopeSort: OrganizationScopeSort;
  OrganizationScopeWhere: OrganizationScopeWhere;
  OrganizationScopesConnection: ResolverTypeWrapper<OrganizationScopesConnection>;
  OrganizationSort: OrganizationSort;
  OrganizationWhere: OrganizationWhere;
  OrganizationsConnection: ResolverTypeWrapper<OrganizationsConnection>;
  OutcomeBasedStatus: OutcomeBasedStatus;
  PackOptionType: PackOptionType;
  PackVolumeUoMType: PackVolumeUoMType;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  Partner: ResolverTypeWrapper<Partner>;
  PartnerEdge: ResolverTypeWrapper<PartnerEdge>;
  PartnerOptions: PartnerOptions;
  PartnerSort: PartnerSort;
  PartnerTreatmentAggregateInput: PartnerTreatmentAggregateInput;
  PartnerTreatmentConnection: ResolverTypeWrapper<PartnerTreatmentConnection>;
  PartnerTreatmentConnectionSort: PartnerTreatmentConnectionSort;
  PartnerTreatmentConnectionWhere: PartnerTreatmentConnectionWhere;
  PartnerTreatmentNodeAggregationWhereInput: PartnerTreatmentNodeAggregationWhereInput;
  PartnerTreatmentRelationship: ResolverTypeWrapper<PartnerTreatmentRelationship>;
  PartnerTreatmentTreatmentAggregationSelection: ResolverTypeWrapper<PartnerTreatmentTreatmentAggregationSelection>;
  PartnerTreatmentTreatmentNodeAggregateSelection: ResolverTypeWrapper<PartnerTreatmentTreatmentNodeAggregateSelection>;
  PartnerWhere: PartnerWhere;
  PartnersConnection: ResolverTypeWrapper<PartnersConnection>;
  PatentStatus: PatentStatus;
  PathologicalResponseType: PathologicalResponseType;
  Patient: ResolverTypeWrapper<Patient>;
  PatientAssignedFlexEntitiesAggregateInput: PatientAssignedFlexEntitiesAggregateInput;
  PatientAssignedFlexEntitiesConnection: ResolverTypeWrapper<PatientAssignedFlexEntitiesConnection>;
  PatientAssignedFlexEntitiesConnectionSort: PatientAssignedFlexEntitiesConnectionSort;
  PatientAssignedFlexEntitiesConnectionWhere: PatientAssignedFlexEntitiesConnectionWhere;
  PatientAssignedFlexEntitiesNodeAggregationWhereInput: PatientAssignedFlexEntitiesNodeAggregationWhereInput;
  PatientAssignedFlexEntitiesRelationship: ResolverTypeWrapper<PatientAssignedFlexEntitiesRelationship>;
  PatientCaseCasesAggregationSelection: ResolverTypeWrapper<PatientCaseCasesAggregationSelection>;
  PatientCaseCasesNodeAggregateSelection: ResolverTypeWrapper<PatientCaseCasesNodeAggregateSelection>;
  PatientCasesAggregateInput: PatientCasesAggregateInput;
  PatientCasesConnection: ResolverTypeWrapper<PatientCasesConnection>;
  PatientCasesConnectionSort: PatientCasesConnectionSort;
  PatientCasesConnectionWhere: PatientCasesConnectionWhere;
  PatientCasesNodeAggregationWhereInput: PatientCasesNodeAggregationWhereInput;
  PatientCasesRelationship: ResolverTypeWrapper<PatientCasesRelationship>;
  PatientEdge: ResolverTypeWrapper<PatientEdge>;
  PatientFlexEntityAssignedFlexEntitiesAggregationSelection: ResolverTypeWrapper<PatientFlexEntityAssignedFlexEntitiesAggregationSelection>;
  PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection: ResolverTypeWrapper<PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection>;
  PatientOptions: PatientOptions;
  PatientScope: PatientScope;
  PatientSort: PatientSort;
  PatientWhere: PatientWhere;
  PatientsConnection: ResolverTypeWrapper<PatientsConnection>;
  PerformanceCounter: ResolverTypeWrapper<PerformanceCounter>;
  PerformanceCounterEdge: ResolverTypeWrapper<PerformanceCounterEdge>;
  PerformanceCounterInput: PerformanceCounterInput;
  PerformanceCounterOptions: PerformanceCounterOptions;
  PerformanceCounterSort: PerformanceCounterSort;
  PerformanceCounterWhere: PerformanceCounterWhere;
  PerformanceCountersConnection: ResolverTypeWrapper<PerformanceCountersConnection>;
  PerformanceMeasurement: ResolverTypeWrapper<PerformanceMeasurement>;
  PerformanceMeasurementCounterAggregateInput: PerformanceMeasurementCounterAggregateInput;
  PerformanceMeasurementCounterConnection: ResolverTypeWrapper<PerformanceMeasurementCounterConnection>;
  PerformanceMeasurementCounterConnectionSort: PerformanceMeasurementCounterConnectionSort;
  PerformanceMeasurementCounterConnectionWhere: PerformanceMeasurementCounterConnectionWhere;
  PerformanceMeasurementCounterNodeAggregationWhereInput: PerformanceMeasurementCounterNodeAggregationWhereInput;
  PerformanceMeasurementCounterRelationship: ResolverTypeWrapper<PerformanceMeasurementCounterRelationship>;
  PerformanceMeasurementEdge: ResolverTypeWrapper<PerformanceMeasurementEdge>;
  PerformanceMeasurementNestedMeasurementsAggregateInput: PerformanceMeasurementNestedMeasurementsAggregateInput;
  PerformanceMeasurementNestedMeasurementsConnection: ResolverTypeWrapper<PerformanceMeasurementNestedMeasurementsConnection>;
  PerformanceMeasurementNestedMeasurementsConnectionSort: PerformanceMeasurementNestedMeasurementsConnectionSort;
  PerformanceMeasurementNestedMeasurementsConnectionWhere: PerformanceMeasurementNestedMeasurementsConnectionWhere;
  PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput: PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput;
  PerformanceMeasurementNestedMeasurementsRelationship: ResolverTypeWrapper<PerformanceMeasurementNestedMeasurementsRelationship>;
  PerformanceMeasurementOptions: PerformanceMeasurementOptions;
  PerformanceMeasurementParentAggregateInput: PerformanceMeasurementParentAggregateInput;
  PerformanceMeasurementParentConnection: ResolverTypeWrapper<PerformanceMeasurementParentConnection>;
  PerformanceMeasurementParentConnectionSort: PerformanceMeasurementParentConnectionSort;
  PerformanceMeasurementParentConnectionWhere: PerformanceMeasurementParentConnectionWhere;
  PerformanceMeasurementParentNodeAggregationWhereInput: PerformanceMeasurementParentNodeAggregationWhereInput;
  PerformanceMeasurementParentRelationship: ResolverTypeWrapper<PerformanceMeasurementParentRelationship>;
  PerformanceMeasurementPerformanceCounterCounterAggregationSelection: ResolverTypeWrapper<PerformanceMeasurementPerformanceCounterCounterAggregationSelection>;
  PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection: ResolverTypeWrapper<PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection>;
  PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection: ResolverTypeWrapper<PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection>;
  PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection: ResolverTypeWrapper<PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection>;
  PerformanceMeasurementPerformanceMeasurementParentAggregationSelection: ResolverTypeWrapper<PerformanceMeasurementPerformanceMeasurementParentAggregationSelection>;
  PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection: ResolverTypeWrapper<PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection>;
  PerformanceMeasurementSort: PerformanceMeasurementSort;
  PerformanceMeasurementWhere: PerformanceMeasurementWhere;
  PerformanceMeasurementsConnection: ResolverTypeWrapper<PerformanceMeasurementsConnection>;
  PerformanceThreshold: ResolverTypeWrapper<PerformanceThreshold>;
  PerformanceThresholdCounterAggregateInput: PerformanceThresholdCounterAggregateInput;
  PerformanceThresholdCounterConnection: ResolverTypeWrapper<PerformanceThresholdCounterConnection>;
  PerformanceThresholdCounterConnectionSort: PerformanceThresholdCounterConnectionSort;
  PerformanceThresholdCounterConnectionWhere: PerformanceThresholdCounterConnectionWhere;
  PerformanceThresholdCounterNodeAggregationWhereInput: PerformanceThresholdCounterNodeAggregationWhereInput;
  PerformanceThresholdCounterRelationship: ResolverTypeWrapper<PerformanceThresholdCounterRelationship>;
  PerformanceThresholdEdge: ResolverTypeWrapper<PerformanceThresholdEdge>;
  PerformanceThresholdInput: PerformanceThresholdInput;
  PerformanceThresholdNotifiedUsersAggregateInput: PerformanceThresholdNotifiedUsersAggregateInput;
  PerformanceThresholdNotifiedUsersConnection: ResolverTypeWrapper<PerformanceThresholdNotifiedUsersConnection>;
  PerformanceThresholdNotifiedUsersConnectionSort: PerformanceThresholdNotifiedUsersConnectionSort;
  PerformanceThresholdNotifiedUsersConnectionWhere: PerformanceThresholdNotifiedUsersConnectionWhere;
  PerformanceThresholdNotifiedUsersNodeAggregationWhereInput: PerformanceThresholdNotifiedUsersNodeAggregationWhereInput;
  PerformanceThresholdNotifiedUsersRelationship: ResolverTypeWrapper<PerformanceThresholdNotifiedUsersRelationship>;
  PerformanceThresholdOptions: PerformanceThresholdOptions;
  PerformanceThresholdPerformanceCounterCounterAggregationSelection: ResolverTypeWrapper<PerformanceThresholdPerformanceCounterCounterAggregationSelection>;
  PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection: ResolverTypeWrapper<PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection>;
  PerformanceThresholdSort: PerformanceThresholdSort;
  PerformanceThresholdUserNotifiedUsersAggregationSelection: ResolverTypeWrapper<PerformanceThresholdUserNotifiedUsersAggregationSelection>;
  PerformanceThresholdUserNotifiedUsersNodeAggregateSelection: ResolverTypeWrapper<PerformanceThresholdUserNotifiedUsersNodeAggregateSelection>;
  PerformanceThresholdWhere: PerformanceThresholdWhere;
  PerformanceThresholdsConnection: ResolverTypeWrapper<PerformanceThresholdsConnection>;
  PgBossMetrics: ResolverTypeWrapper<PgBossMetrics>;
  PgBossMetricsConnection: ResolverTypeWrapper<PgBossMetricsConnection>;
  PgBossMetricsEdge: ResolverTypeWrapper<PgBossMetricsEdge>;
  PgBossMetricsOptions: PgBossMetricsOptions;
  PgBossMetricsSort: PgBossMetricsSort;
  PgBossMetricsWhere: PgBossMetricsWhere;
  PgBossQueueStat: ResolverTypeWrapper<PgBossQueueStat>;
  PgBossQueueStatEdge: ResolverTypeWrapper<PgBossQueueStatEdge>;
  PgBossQueueStatOptions: PgBossQueueStatOptions;
  PgBossQueueStatSort: PgBossQueueStatSort;
  PgBossQueueStatWhere: PgBossQueueStatWhere;
  PgBossQueueStatsConnection: ResolverTypeWrapper<PgBossQueueStatsConnection>;
  Platform: Platform;
  PolicyType: ResolverTypeWrapper<PolicyType>;
  PolicyTypeEdge: ResolverTypeWrapper<PolicyTypeEdge>;
  PolicyTypeOptions: PolicyTypeOptions;
  PolicyTypePolicyVersionVersionsAggregationSelection: ResolverTypeWrapper<PolicyTypePolicyVersionVersionsAggregationSelection>;
  PolicyTypePolicyVersionVersionsNodeAggregateSelection: ResolverTypeWrapper<PolicyTypePolicyVersionVersionsNodeAggregateSelection>;
  PolicyTypeSort: PolicyTypeSort;
  PolicyTypeVersionsAggregateInput: PolicyTypeVersionsAggregateInput;
  PolicyTypeVersionsConnection: ResolverTypeWrapper<PolicyTypeVersionsConnection>;
  PolicyTypeVersionsConnectionSort: PolicyTypeVersionsConnectionSort;
  PolicyTypeVersionsConnectionWhere: PolicyTypeVersionsConnectionWhere;
  PolicyTypeVersionsNodeAggregationWhereInput: PolicyTypeVersionsNodeAggregationWhereInput;
  PolicyTypeVersionsRelationship: ResolverTypeWrapper<PolicyTypeVersionsRelationship>;
  PolicyTypeWhere: PolicyTypeWhere;
  PolicyTypesConnection: ResolverTypeWrapper<PolicyTypesConnection>;
  PolicyVersion: ResolverTypeWrapper<PolicyVersion>;
  PolicyVersionEdge: ResolverTypeWrapper<PolicyVersionEdge>;
  PolicyVersionOptions: PolicyVersionOptions;
  PolicyVersionPolicyTypeAggregateInput: PolicyVersionPolicyTypeAggregateInput;
  PolicyVersionPolicyTypeConnection: ResolverTypeWrapper<PolicyVersionPolicyTypeConnection>;
  PolicyVersionPolicyTypeConnectionSort: PolicyVersionPolicyTypeConnectionSort;
  PolicyVersionPolicyTypeConnectionWhere: PolicyVersionPolicyTypeConnectionWhere;
  PolicyVersionPolicyTypeNodeAggregationWhereInput: PolicyVersionPolicyTypeNodeAggregationWhereInput;
  PolicyVersionPolicyTypePolicyTypeAggregationSelection: ResolverTypeWrapper<PolicyVersionPolicyTypePolicyTypeAggregationSelection>;
  PolicyVersionPolicyTypePolicyTypeNodeAggregateSelection: ResolverTypeWrapper<PolicyVersionPolicyTypePolicyTypeNodeAggregateSelection>;
  PolicyVersionPolicyTypeRelationship: ResolverTypeWrapper<PolicyVersionPolicyTypeRelationship>;
  PolicyVersionSort: PolicyVersionSort;
  PolicyVersionWhere: PolicyVersionWhere;
  PolicyVersionsConnection: ResolverTypeWrapper<PolicyVersionsConnection>;
  PostgresMetric: ResolverTypeWrapper<PostgresMetric>;
  PostgresMetricEdge: ResolverTypeWrapper<PostgresMetricEdge>;
  PostgresMetricOptions: PostgresMetricOptions;
  PostgresMetricSort: PostgresMetricSort;
  PostgresMetricWhere: PostgresMetricWhere;
  PostgresMetricsConnection: ResolverTypeWrapper<PostgresMetricsConnection>;
  Preparation: ResolverTypeWrapper<Preparation>;
  PreparationBrandAggregateInput: PreparationBrandAggregateInput;
  PreparationBrandBrandAggregationSelection: ResolverTypeWrapper<PreparationBrandBrandAggregationSelection>;
  PreparationBrandBrandNodeAggregateSelection: ResolverTypeWrapper<PreparationBrandBrandNodeAggregateSelection>;
  PreparationBrandConnection: ResolverTypeWrapper<PreparationBrandConnection>;
  PreparationBrandConnectionSort: PreparationBrandConnectionSort;
  PreparationBrandConnectionWhere: PreparationBrandConnectionWhere;
  PreparationBrandNodeAggregationWhereInput: PreparationBrandNodeAggregationWhereInput;
  PreparationBrandRelationship: ResolverTypeWrapper<PreparationBrandRelationship>;
  PreparationCountriesAggregateInput: PreparationCountriesAggregateInput;
  PreparationCountriesConnection: ResolverTypeWrapper<PreparationCountriesConnection>;
  PreparationCountriesConnectionSort: PreparationCountriesConnectionSort;
  PreparationCountriesConnectionWhere: PreparationCountriesConnectionWhere;
  PreparationCountriesNodeAggregationWhereInput: PreparationCountriesNodeAggregationWhereInput;
  PreparationCountriesRelationship: ResolverTypeWrapper<PreparationCountriesRelationship>;
  PreparationCountryCountriesAggregationSelection: ResolverTypeWrapper<PreparationCountryCountriesAggregationSelection>;
  PreparationCountryCountriesNodeAggregateSelection: ResolverTypeWrapper<PreparationCountryCountriesNodeAggregateSelection>;
  PreparationEdge: ResolverTypeWrapper<PreparationEdge>;
  PreparationGenericAggregateInput: PreparationGenericAggregateInput;
  PreparationGenericConnection: ResolverTypeWrapper<PreparationGenericConnection>;
  PreparationGenericConnectionSort: PreparationGenericConnectionSort;
  PreparationGenericConnectionWhere: PreparationGenericConnectionWhere;
  PreparationGenericGenericAggregationSelection: ResolverTypeWrapper<PreparationGenericGenericAggregationSelection>;
  PreparationGenericGenericNodeAggregateSelection: ResolverTypeWrapper<PreparationGenericGenericNodeAggregateSelection>;
  PreparationGenericNodeAggregationWhereInput: PreparationGenericNodeAggregationWhereInput;
  PreparationGenericRelationship: ResolverTypeWrapper<PreparationGenericRelationship>;
  PreparationHasLimitationsAggregateInput: PreparationHasLimitationsAggregateInput;
  PreparationHasLimitationsConnection: ResolverTypeWrapper<PreparationHasLimitationsConnection>;
  PreparationHasLimitationsConnectionSort: PreparationHasLimitationsConnectionSort;
  PreparationHasLimitationsConnectionWhere: PreparationHasLimitationsConnectionWhere;
  PreparationHasLimitationsNodeAggregationWhereInput: PreparationHasLimitationsNodeAggregationWhereInput;
  PreparationHasLimitationsRelationship: ResolverTypeWrapper<PreparationHasLimitationsRelationship>;
  PreparationInput: PreparationInput;
  PreparationLimitationHasLimitationsAggregationSelection: ResolverTypeWrapper<PreparationLimitationHasLimitationsAggregationSelection>;
  PreparationLimitationHasLimitationsNodeAggregateSelection: ResolverTypeWrapper<PreparationLimitationHasLimitationsNodeAggregateSelection>;
  PreparationOptions: PreparationOptions;
  PreparationRegulatesAggregateInput: PreparationRegulatesAggregateInput;
  PreparationRegulatesConnection: ResolverTypeWrapper<PreparationRegulatesConnection>;
  PreparationRegulatesConnectionSort: PreparationRegulatesConnectionSort;
  PreparationRegulatesConnectionWhere: PreparationRegulatesConnectionWhere;
  PreparationRegulatesNodeAggregationWhereInput: PreparationRegulatesNodeAggregationWhereInput;
  PreparationRegulatesRelationship: ResolverTypeWrapper<PreparationRegulatesRelationship>;
  PreparationSort: PreparationSort;
  PreparationStatus: ResolverTypeWrapper<PreparationStatus>;
  PreparationStatusEdge: ResolverTypeWrapper<PreparationStatusEdge>;
  PreparationStatusOptions: PreparationStatusOptions;
  PreparationStatusPreparationAggregateInput: PreparationStatusPreparationAggregateInput;
  PreparationStatusPreparationConnection: ResolverTypeWrapper<PreparationStatusPreparationConnection>;
  PreparationStatusPreparationConnectionSort: PreparationStatusPreparationConnectionSort;
  PreparationStatusPreparationConnectionWhere: PreparationStatusPreparationConnectionWhere;
  PreparationStatusPreparationNodeAggregationWhereInput: PreparationStatusPreparationNodeAggregationWhereInput;
  PreparationStatusPreparationPreparationAggregationSelection: ResolverTypeWrapper<PreparationStatusPreparationPreparationAggregationSelection>;
  PreparationStatusPreparationPreparationNodeAggregateSelection: ResolverTypeWrapper<PreparationStatusPreparationPreparationNodeAggregateSelection>;
  PreparationStatusPreparationRelationship: ResolverTypeWrapper<PreparationStatusPreparationRelationship>;
  PreparationStatusSort: PreparationStatusSort;
  PreparationStatusWhere: PreparationStatusWhere;
  PreparationStatusesConnection: ResolverTypeWrapper<PreparationStatusesConnection>;
  PreparationTreatmentRegulatesAggregationSelection: ResolverTypeWrapper<PreparationTreatmentRegulatesAggregationSelection>;
  PreparationTreatmentRegulatesNodeAggregateSelection: ResolverTypeWrapper<PreparationTreatmentRegulatesNodeAggregateSelection>;
  PreparationWhere: PreparationWhere;
  PreparationsConnection: ResolverTypeWrapper<PreparationsConnection>;
  Price: ResolverTypeWrapper<Price>;
  PriceCategory: PriceCategory;
  PriceCurrencyAggregateInput: PriceCurrencyAggregateInput;
  PriceCurrencyConnection: ResolverTypeWrapper<PriceCurrencyConnection>;
  PriceCurrencyConnectionSort: PriceCurrencyConnectionSort;
  PriceCurrencyConnectionWhere: PriceCurrencyConnectionWhere;
  PriceCurrencyCurrencyAggregationSelection: ResolverTypeWrapper<PriceCurrencyCurrencyAggregationSelection>;
  PriceCurrencyCurrencyNodeAggregateSelection: ResolverTypeWrapper<PriceCurrencyCurrencyNodeAggregateSelection>;
  PriceCurrencyNodeAggregationWhereInput: PriceCurrencyNodeAggregationWhereInput;
  PriceCurrencyRelationship: ResolverTypeWrapper<PriceCurrencyRelationship>;
  PriceEdge: ResolverTypeWrapper<PriceEdge>;
  PriceOptions: PriceOptions;
  PriceSort: PriceSort;
  PriceTreatmentAggregateInput: PriceTreatmentAggregateInput;
  PriceTreatmentConnection: ResolverTypeWrapper<PriceTreatmentConnection>;
  PriceTreatmentConnectionSort: PriceTreatmentConnectionSort;
  PriceTreatmentConnectionWhere: PriceTreatmentConnectionWhere;
  PriceTreatmentInput: PriceTreatmentInput;
  PriceTreatmentNodeAggregationWhereInput: PriceTreatmentNodeAggregationWhereInput;
  PriceTreatmentRelationship: ResolverTypeWrapper<PriceTreatmentRelationship>;
  PriceTreatmentTreatmentAggregationSelection: ResolverTypeWrapper<PriceTreatmentTreatmentAggregationSelection>;
  PriceTreatmentTreatmentNodeAggregateSelection: ResolverTypeWrapper<PriceTreatmentTreatmentNodeAggregateSelection>;
  PriceType: PriceType;
  PriceWhere: PriceWhere;
  PricesConnection: ResolverTypeWrapper<PricesConnection>;
  ProductBlueprint: ResolverTypeWrapper<ProductBlueprint>;
  ProductBlueprintAddedByAggregateInput: ProductBlueprintAddedByAggregateInput;
  ProductBlueprintAddedByConnection: ResolverTypeWrapper<ProductBlueprintAddedByConnection>;
  ProductBlueprintAddedByConnectionSort: ProductBlueprintAddedByConnectionSort;
  ProductBlueprintAddedByConnectionWhere: ProductBlueprintAddedByConnectionWhere;
  ProductBlueprintAddedByNodeAggregationWhereInput: ProductBlueprintAddedByNodeAggregationWhereInput;
  ProductBlueprintAddedByRelationship: ResolverTypeWrapper<ProductBlueprintAddedByRelationship>;
  ProductBlueprintDomainDomainsAggregationSelection: ResolverTypeWrapper<ProductBlueprintDomainDomainsAggregationSelection>;
  ProductBlueprintDomainDomainsNodeAggregateSelection: ResolverTypeWrapper<ProductBlueprintDomainDomainsNodeAggregateSelection>;
  ProductBlueprintDomainsAggregateInput: ProductBlueprintDomainsAggregateInput;
  ProductBlueprintDomainsConnection: ResolverTypeWrapper<ProductBlueprintDomainsConnection>;
  ProductBlueprintDomainsConnectionSort: ProductBlueprintDomainsConnectionSort;
  ProductBlueprintDomainsConnectionWhere: ProductBlueprintDomainsConnectionWhere;
  ProductBlueprintDomainsNodeAggregationWhereInput: ProductBlueprintDomainsNodeAggregationWhereInput;
  ProductBlueprintDomainsRelationship: ResolverTypeWrapper<ProductBlueprintDomainsRelationship>;
  ProductBlueprintEdge: ResolverTypeWrapper<ProductBlueprintEdge>;
  ProductBlueprintOptions: ProductBlueprintOptions;
  ProductBlueprintPublishedByAggregateInput: ProductBlueprintPublishedByAggregateInput;
  ProductBlueprintPublishedByConnection: ResolverTypeWrapper<ProductBlueprintPublishedByConnection>;
  ProductBlueprintPublishedByConnectionSort: ProductBlueprintPublishedByConnectionSort;
  ProductBlueprintPublishedByConnectionWhere: ProductBlueprintPublishedByConnectionWhere;
  ProductBlueprintPublishedByNodeAggregationWhereInput: ProductBlueprintPublishedByNodeAggregationWhereInput;
  ProductBlueprintPublishedByRelationship: ResolverTypeWrapper<ProductBlueprintPublishedByRelationship>;
  ProductBlueprintResult: ResolverTypeWrapper<ProductBlueprintResult>;
  ProductBlueprintResultEdge: ResolverTypeWrapper<ProductBlueprintResultEdge>;
  ProductBlueprintResultOptions: ProductBlueprintResultOptions;
  ProductBlueprintResultSort: ProductBlueprintResultSort;
  ProductBlueprintResultWhere: ProductBlueprintResultWhere;
  ProductBlueprintResultsConnection: ResolverTypeWrapper<ProductBlueprintResultsConnection>;
  ProductBlueprintSimulationSimulationsAggregationSelection: ResolverTypeWrapper<ProductBlueprintSimulationSimulationsAggregationSelection>;
  ProductBlueprintSimulationSimulationsNodeAggregateSelection: ResolverTypeWrapper<ProductBlueprintSimulationSimulationsNodeAggregateSelection>;
  ProductBlueprintSimulationsAggregateInput: ProductBlueprintSimulationsAggregateInput;
  ProductBlueprintSimulationsConnection: ResolverTypeWrapper<ProductBlueprintSimulationsConnection>;
  ProductBlueprintSimulationsConnectionSort: ProductBlueprintSimulationsConnectionSort;
  ProductBlueprintSimulationsConnectionWhere: ProductBlueprintSimulationsConnectionWhere;
  ProductBlueprintSimulationsNodeAggregationWhereInput: ProductBlueprintSimulationsNodeAggregationWhereInput;
  ProductBlueprintSimulationsRelationship: ResolverTypeWrapper<ProductBlueprintSimulationsRelationship>;
  ProductBlueprintSort: ProductBlueprintSort;
  ProductBlueprintStatus: ProductBlueprintStatus;
  ProductBlueprintUpdatedByAggregateInput: ProductBlueprintUpdatedByAggregateInput;
  ProductBlueprintUpdatedByConnection: ResolverTypeWrapper<ProductBlueprintUpdatedByConnection>;
  ProductBlueprintUpdatedByConnectionSort: ProductBlueprintUpdatedByConnectionSort;
  ProductBlueprintUpdatedByConnectionWhere: ProductBlueprintUpdatedByConnectionWhere;
  ProductBlueprintUpdatedByNodeAggregationWhereInput: ProductBlueprintUpdatedByNodeAggregationWhereInput;
  ProductBlueprintUpdatedByRelationship: ResolverTypeWrapper<ProductBlueprintUpdatedByRelationship>;
  ProductBlueprintUserAddedByAggregationSelection: ResolverTypeWrapper<ProductBlueprintUserAddedByAggregationSelection>;
  ProductBlueprintUserAddedByNodeAggregateSelection: ResolverTypeWrapper<ProductBlueprintUserAddedByNodeAggregateSelection>;
  ProductBlueprintUserPublishedByAggregationSelection: ResolverTypeWrapper<ProductBlueprintUserPublishedByAggregationSelection>;
  ProductBlueprintUserPublishedByNodeAggregateSelection: ResolverTypeWrapper<ProductBlueprintUserPublishedByNodeAggregateSelection>;
  ProductBlueprintUserUpdatedByAggregationSelection: ResolverTypeWrapper<ProductBlueprintUserUpdatedByAggregationSelection>;
  ProductBlueprintUserUpdatedByNodeAggregateSelection: ResolverTypeWrapper<ProductBlueprintUserUpdatedByNodeAggregateSelection>;
  ProductBlueprintWhere: ProductBlueprintWhere;
  ProductBlueprintsConnection: ResolverTypeWrapper<ProductBlueprintsConnection>;
  PublicPrice: ResolverTypeWrapper<PublicPrice>;
  PublicPriceEdge: ResolverTypeWrapper<PublicPriceEdge>;
  PublicPriceOptions: PublicPriceOptions;
  PublicPriceSort: PublicPriceSort;
  PublicPriceWhere: PublicPriceWhere;
  PublicPricesConnection: ResolverTypeWrapper<PublicPricesConnection>;
  Purchase: ResolverTypeWrapper<Purchase>;
  PurchaseAgreementAggregateInput: PurchaseAgreementAggregateInput;
  PurchaseAgreementAgreementAggregationSelection: ResolverTypeWrapper<PurchaseAgreementAgreementAggregationSelection>;
  PurchaseAgreementAgreementNodeAggregateSelection: ResolverTypeWrapper<PurchaseAgreementAgreementNodeAggregateSelection>;
  PurchaseAgreementConnection: ResolverTypeWrapper<PurchaseAgreementConnection>;
  PurchaseAgreementConnectionSort: PurchaseAgreementConnectionSort;
  PurchaseAgreementConnectionWhere: PurchaseAgreementConnectionWhere;
  PurchaseAgreementNodeAggregationWhereInput: PurchaseAgreementNodeAggregationWhereInput;
  PurchaseAgreementRelationship: ResolverTypeWrapper<PurchaseAgreementRelationship>;
  PurchaseAssignedFlexEntitiesAggregateInput: PurchaseAssignedFlexEntitiesAggregateInput;
  PurchaseAssignedFlexEntitiesConnection: ResolverTypeWrapper<PurchaseAssignedFlexEntitiesConnection>;
  PurchaseAssignedFlexEntitiesConnectionSort: PurchaseAssignedFlexEntitiesConnectionSort;
  PurchaseAssignedFlexEntitiesConnectionWhere: PurchaseAssignedFlexEntitiesConnectionWhere;
  PurchaseAssignedFlexEntitiesNodeAggregationWhereInput: PurchaseAssignedFlexEntitiesNodeAggregationWhereInput;
  PurchaseAssignedFlexEntitiesRelationship: ResolverTypeWrapper<PurchaseAssignedFlexEntitiesRelationship>;
  PurchaseEdge: ResolverTypeWrapper<PurchaseEdge>;
  PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection: ResolverTypeWrapper<PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection>;
  PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection: ResolverTypeWrapper<PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection>;
  PurchaseOptions: PurchaseOptions;
  PurchaseRefundRefundsAggregationSelection: ResolverTypeWrapper<PurchaseRefundRefundsAggregationSelection>;
  PurchaseRefundRefundsNodeAggregateSelection: ResolverTypeWrapper<PurchaseRefundRefundsNodeAggregateSelection>;
  PurchaseRefundsAggregateInput: PurchaseRefundsAggregateInput;
  PurchaseRefundsConnection: ResolverTypeWrapper<PurchaseRefundsConnection>;
  PurchaseRefundsConnectionSort: PurchaseRefundsConnectionSort;
  PurchaseRefundsConnectionWhere: PurchaseRefundsConnectionWhere;
  PurchaseRefundsNodeAggregationWhereInput: PurchaseRefundsNodeAggregationWhereInput;
  PurchaseRefundsRelationship: ResolverTypeWrapper<PurchaseRefundsRelationship>;
  PurchaseSort: PurchaseSort;
  PurchaseWhere: PurchaseWhere;
  PurchasesConnection: ResolverTypeWrapper<PurchasesConnection>;
  Query: ResolverTypeWrapper<{}>;
  QueryCheckInput: QueryCheckInput;
  QueryLog: ResolverTypeWrapper<QueryLog>;
  QueryLogEdge: ResolverTypeWrapper<QueryLogEdge>;
  QueryLogOptions: QueryLogOptions;
  QueryLogSort: QueryLogSort;
  QueryLogWhere: QueryLogWhere;
  QueryLogsConnection: ResolverTypeWrapper<QueryLogsConnection>;
  QueryResult: ResolverTypeWrapper<QueryResult>;
  QueryResultEdge: ResolverTypeWrapper<QueryResultEdge>;
  QueryResultOptions: QueryResultOptions;
  QueryResultSort: QueryResultSort;
  QueryResultWhere: QueryResultWhere;
  QueryResultsConnection: ResolverTypeWrapper<QueryResultsConnection>;
  QuestNotification: ResolverTypeWrapper<QuestNotification>;
  QuestNotificationEdge: ResolverTypeWrapper<QuestNotificationEdge>;
  QuestNotificationInput: QuestNotificationInput;
  QuestNotificationOptions: QuestNotificationOptions;
  QuestNotificationOrganizationSubscribedAggregationSelection: ResolverTypeWrapper<QuestNotificationOrganizationSubscribedAggregationSelection>;
  QuestNotificationOrganizationSubscribedEdgeAggregateSelection: ResolverTypeWrapper<QuestNotificationOrganizationSubscribedEdgeAggregateSelection>;
  QuestNotificationOrganizationSubscribedNodeAggregateSelection: ResolverTypeWrapper<QuestNotificationOrganizationSubscribedNodeAggregateSelection>;
  QuestNotificationSort: QuestNotificationSort;
  QuestNotificationSubscribedAggregateInput: QuestNotificationSubscribedAggregateInput;
  QuestNotificationSubscribedConnection: ResolverTypeWrapper<QuestNotificationSubscribedConnection>;
  QuestNotificationSubscribedConnectionSort: QuestNotificationSubscribedConnectionSort;
  QuestNotificationSubscribedConnectionWhere: QuestNotificationSubscribedConnectionWhere;
  QuestNotificationSubscribedEdgeAggregationWhereInput: QuestNotificationSubscribedEdgeAggregationWhereInput;
  QuestNotificationSubscribedNodeAggregationWhereInput: QuestNotificationSubscribedNodeAggregationWhereInput;
  QuestNotificationSubscribedRelationship: ResolverTypeWrapper<QuestNotificationSubscribedRelationship>;
  QuestNotificationWhere: QuestNotificationWhere;
  QuestNotificationsConnection: ResolverTypeWrapper<QuestNotificationsConnection>;
  RecordNature: RecordNature;
  Refund: ResolverTypeWrapper<Refund>;
  RefundAgreementAggregateInput: RefundAgreementAggregateInput;
  RefundAgreementAgreementAggregationSelection: ResolverTypeWrapper<RefundAgreementAgreementAggregationSelection>;
  RefundAgreementAgreementNodeAggregateSelection: ResolverTypeWrapper<RefundAgreementAgreementNodeAggregateSelection>;
  RefundAgreementConnection: ResolverTypeWrapper<RefundAgreementConnection>;
  RefundAgreementConnectionSort: RefundAgreementConnectionSort;
  RefundAgreementConnectionWhere: RefundAgreementConnectionWhere;
  RefundAgreementNodeAggregationWhereInput: RefundAgreementNodeAggregationWhereInput;
  RefundAgreementRelationship: ResolverTypeWrapper<RefundAgreementRelationship>;
  RefundCaseAggregateInput: RefundCaseAggregateInput;
  RefundCaseCaseAggregationSelection: ResolverTypeWrapper<RefundCaseCaseAggregationSelection>;
  RefundCaseCaseNodeAggregateSelection: ResolverTypeWrapper<RefundCaseCaseNodeAggregateSelection>;
  RefundCaseConnection: ResolverTypeWrapper<RefundCaseConnection>;
  RefundCaseConnectionSort: RefundCaseConnectionSort;
  RefundCaseConnectionWhere: RefundCaseConnectionWhere;
  RefundCaseNodeAggregationWhereInput: RefundCaseNodeAggregationWhereInput;
  RefundCaseRelationship: ResolverTypeWrapper<RefundCaseRelationship>;
  RefundDocumentDocumentsAggregationSelection: ResolverTypeWrapper<RefundDocumentDocumentsAggregationSelection>;
  RefundDocumentDocumentsNodeAggregateSelection: ResolverTypeWrapper<RefundDocumentDocumentsNodeAggregateSelection>;
  RefundDocumentFinancialDataPointAggregateInput: RefundDocumentFinancialDataPointAggregateInput;
  RefundDocumentFinancialDataPointConnection: ResolverTypeWrapper<RefundDocumentFinancialDataPointConnection>;
  RefundDocumentFinancialDataPointConnectionSort: RefundDocumentFinancialDataPointConnectionSort;
  RefundDocumentFinancialDataPointConnectionWhere: RefundDocumentFinancialDataPointConnectionWhere;
  RefundDocumentFinancialDataPointEdgeAggregationWhereInput: RefundDocumentFinancialDataPointEdgeAggregationWhereInput;
  RefundDocumentFinancialDataPointNodeAggregationWhereInput: RefundDocumentFinancialDataPointNodeAggregationWhereInput;
  RefundDocumentFinancialDataPointRelationship: ResolverTypeWrapper<RefundDocumentFinancialDataPointRelationship>;
  RefundDocumentsAggregateInput: RefundDocumentsAggregateInput;
  RefundDocumentsConnection: ResolverTypeWrapper<RefundDocumentsConnection>;
  RefundDocumentsConnectionSort: RefundDocumentsConnectionSort;
  RefundDocumentsConnectionWhere: RefundDocumentsConnectionWhere;
  RefundDocumentsNodeAggregationWhereInput: RefundDocumentsNodeAggregationWhereInput;
  RefundDocumentsRelationship: ResolverTypeWrapper<RefundDocumentsRelationship>;
  RefundEdge: ResolverTypeWrapper<RefundEdge>;
  RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection: ResolverTypeWrapper<RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection>;
  RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection: ResolverTypeWrapper<RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection>;
  RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection: ResolverTypeWrapper<RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection>;
  RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection: ResolverTypeWrapper<RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection>;
  RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection: ResolverTypeWrapper<RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection>;
  RefundOptions: RefundOptions;
  RefundSort: RefundSort;
  RefundSourceFinancialDataPointAggregateInput: RefundSourceFinancialDataPointAggregateInput;
  RefundSourceFinancialDataPointConnection: ResolverTypeWrapper<RefundSourceFinancialDataPointConnection>;
  RefundSourceFinancialDataPointConnectionSort: RefundSourceFinancialDataPointConnectionSort;
  RefundSourceFinancialDataPointConnectionWhere: RefundSourceFinancialDataPointConnectionWhere;
  RefundSourceFinancialDataPointNodeAggregationWhereInput: RefundSourceFinancialDataPointNodeAggregationWhereInput;
  RefundSourceFinancialDataPointRelationship: ResolverTypeWrapper<RefundSourceFinancialDataPointRelationship>;
  RefundStatus: RefundStatus;
  RefundWhere: RefundWhere;
  RefundsConnection: ResolverTypeWrapper<RefundsConnection>;
  Reintervention: Reintervention;
  ResponseBaseStatus: ResponseBaseStatus;
  ResponseInclusionType: ResponseInclusionType;
  ResponseType: ResponseType;
  ResultSelectionType: ResultSelectionType;
  Roles: Roles;
  RollingRangeType: RollingRangeType;
  RunCheck: ResolverTypeWrapper<RunCheck>;
  RunCheckAlertAlertsAggregationSelection: ResolverTypeWrapper<RunCheckAlertAlertsAggregationSelection>;
  RunCheckAlertAlertsNodeAggregateSelection: ResolverTypeWrapper<RunCheckAlertAlertsNodeAggregateSelection>;
  RunCheckAlertsAggregateInput: RunCheckAlertsAggregateInput;
  RunCheckAlertsConnection: ResolverTypeWrapper<RunCheckAlertsConnection>;
  RunCheckAlertsConnectionSort: RunCheckAlertsConnectionSort;
  RunCheckAlertsConnectionWhere: RunCheckAlertsConnectionWhere;
  RunCheckAlertsNodeAggregationWhereInput: RunCheckAlertsNodeAggregationWhereInput;
  RunCheckAlertsRelationship: ResolverTypeWrapper<RunCheckAlertsRelationship>;
  RunCheckEdge: ResolverTypeWrapper<RunCheckEdge>;
  RunCheckOptions: RunCheckOptions;
  RunCheckRunCheckValuesValuesAggregationSelection: ResolverTypeWrapper<RunCheckRunCheckValuesValuesAggregationSelection>;
  RunCheckRunCheckValuesValuesNodeAggregateSelection: ResolverTypeWrapper<RunCheckRunCheckValuesValuesNodeAggregateSelection>;
  RunCheckSort: RunCheckSort;
  RunCheckTrigger: RunCheckTrigger;
  RunCheckValues: ResolverTypeWrapper<RunCheckValues>;
  RunCheckValuesAggregateInput: RunCheckValuesAggregateInput;
  RunCheckValuesCheckAggregateInput: RunCheckValuesCheckAggregateInput;
  RunCheckValuesCheckConnection: ResolverTypeWrapper<RunCheckValuesCheckConnection>;
  RunCheckValuesCheckConnectionSort: RunCheckValuesCheckConnectionSort;
  RunCheckValuesCheckConnectionWhere: RunCheckValuesCheckConnectionWhere;
  RunCheckValuesCheckNodeAggregationWhereInput: RunCheckValuesCheckNodeAggregationWhereInput;
  RunCheckValuesCheckRelationship: ResolverTypeWrapper<RunCheckValuesCheckRelationship>;
  RunCheckValuesConnection: ResolverTypeWrapper<RunCheckValuesConnection>;
  RunCheckValuesConnectionSort: RunCheckValuesConnectionSort;
  RunCheckValuesConnectionWhere: RunCheckValuesConnectionWhere;
  RunCheckValuesEdge: ResolverTypeWrapper<RunCheckValuesEdge>;
  RunCheckValuesNodeAggregationWhereInput: RunCheckValuesNodeAggregationWhereInput;
  RunCheckValuesOptions: RunCheckValuesOptions;
  RunCheckValuesRelationship: ResolverTypeWrapper<RunCheckValuesRelationship>;
  RunCheckValuesRunCheckCheckAggregationSelection: ResolverTypeWrapper<RunCheckValuesRunCheckCheckAggregationSelection>;
  RunCheckValuesRunCheckCheckNodeAggregateSelection: ResolverTypeWrapper<RunCheckValuesRunCheckCheckNodeAggregateSelection>;
  RunCheckValuesSort: RunCheckValuesSort;
  RunCheckValuesType: RunCheckValuesType;
  RunCheckValuesWhere: RunCheckValuesWhere;
  RunCheckValuesWithTypeRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['RunCheckValuesWithTypeRelationship']>;
  RunCheckValuesWithTypeRelationshipSort: RunCheckValuesWithTypeRelationshipSort;
  RunCheckValuesWithTypeRelationshipWhere: RunCheckValuesWithTypeRelationshipWhere;
  RunCheckWhere: RunCheckWhere;
  RunChecksConnection: ResolverTypeWrapper<RunChecksConnection>;
  RunDQCReport: ResolverTypeWrapper<RunDqcReport>;
  RunDQCReportChecksAggregateInput: RunDqcReportChecksAggregateInput;
  RunDQCReportChecksConnection: ResolverTypeWrapper<RunDqcReportChecksConnection>;
  RunDQCReportChecksConnectionSort: RunDqcReportChecksConnectionSort;
  RunDQCReportChecksConnectionWhere: RunDqcReportChecksConnectionWhere;
  RunDQCReportChecksNodeAggregationWhereInput: RunDqcReportChecksNodeAggregationWhereInput;
  RunDQCReportChecksRelationship: ResolverTypeWrapper<RunDqcReportChecksRelationship>;
  RunDQCReportEdge: ResolverTypeWrapper<RunDqcReportEdge>;
  RunDQCReportOptions: RunDqcReportOptions;
  RunDQCReportRunCheckChecksAggregationSelection: ResolverTypeWrapper<RunDqcReportRunCheckChecksAggregationSelection>;
  RunDQCReportRunCheckChecksNodeAggregateSelection: ResolverTypeWrapper<RunDqcReportRunCheckChecksNodeAggregateSelection>;
  RunDQCReportSort: RunDqcReportSort;
  RunDQCReportWhere: RunDqcReportWhere;
  RunDqcReportsConnection: ResolverTypeWrapper<RunDqcReportsConnection>;
  RunnableCheck: ResolverTypeWrapper<RunnableCheck>;
  RunnableCheckEdge: ResolverTypeWrapper<RunnableCheckEdge>;
  RunnableCheckOptions: RunnableCheckOptions;
  RunnableCheckSort: RunnableCheckSort;
  RunnableCheckWhere: RunnableCheckWhere;
  RunnableChecksConnection: ResolverTypeWrapper<RunnableChecksConnection>;
  RunningJobState: ResolverTypeWrapper<RunningJobState>;
  RunningJobStateEdge: ResolverTypeWrapper<RunningJobStateEdge>;
  RunningJobStateOptions: RunningJobStateOptions;
  RunningJobStateSort: RunningJobStateSort;
  RunningJobStateWhere: RunningJobStateWhere;
  RunningJobStatesConnection: ResolverTypeWrapper<RunningJobStatesConnection>;
  SaveCustomIntegrityCheckInput: SaveCustomIntegrityCheckInput;
  Scenario: ResolverTypeWrapper<Scenario>;
  ScenarioAction: ResolverTypeWrapper<ScenarioAction>;
  ScenarioActionBrandBrandsAggregationSelection: ResolverTypeWrapper<ScenarioActionBrandBrandsAggregationSelection>;
  ScenarioActionBrandBrandsEdgeAggregateSelection: ResolverTypeWrapper<ScenarioActionBrandBrandsEdgeAggregateSelection>;
  ScenarioActionBrandBrandsNodeAggregateSelection: ResolverTypeWrapper<ScenarioActionBrandBrandsNodeAggregateSelection>;
  ScenarioActionBrandCombinedItemBrandsAggregationSelection: ResolverTypeWrapper<ScenarioActionBrandCombinedItemBrandsAggregationSelection>;
  ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection: ResolverTypeWrapper<ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection>;
  ScenarioActionBrandsAggregateInput: ScenarioActionBrandsAggregateInput;
  ScenarioActionBrandsConnection: ResolverTypeWrapper<ScenarioActionBrandsConnection>;
  ScenarioActionBrandsConnectionSort: ScenarioActionBrandsConnectionSort;
  ScenarioActionBrandsConnectionWhere: ScenarioActionBrandsConnectionWhere;
  ScenarioActionBrandsEdgeAggregationWhereInput: ScenarioActionBrandsEdgeAggregationWhereInput;
  ScenarioActionBrandsNodeAggregationWhereInput: ScenarioActionBrandsNodeAggregationWhereInput;
  ScenarioActionBrandsRelationship: ResolverTypeWrapper<ScenarioActionBrandsRelationship>;
  ScenarioActionCombinedItemBrandsAggregateInput: ScenarioActionCombinedItemBrandsAggregateInput;
  ScenarioActionCombinedItemBrandsConnection: ResolverTypeWrapper<ScenarioActionCombinedItemBrandsConnection>;
  ScenarioActionCombinedItemBrandsConnectionSort: ScenarioActionCombinedItemBrandsConnectionSort;
  ScenarioActionCombinedItemBrandsConnectionWhere: ScenarioActionCombinedItemBrandsConnectionWhere;
  ScenarioActionCombinedItemBrandsNodeAggregationWhereInput: ScenarioActionCombinedItemBrandsNodeAggregationWhereInput;
  ScenarioActionCombinedItemBrandsRelationship: ResolverTypeWrapper<ScenarioActionCombinedItemBrandsRelationship>;
  ScenarioActionCombinedItemGenericsAggregateInput: ScenarioActionCombinedItemGenericsAggregateInput;
  ScenarioActionCombinedItemGenericsConnection: ResolverTypeWrapper<ScenarioActionCombinedItemGenericsConnection>;
  ScenarioActionCombinedItemGenericsConnectionSort: ScenarioActionCombinedItemGenericsConnectionSort;
  ScenarioActionCombinedItemGenericsConnectionWhere: ScenarioActionCombinedItemGenericsConnectionWhere;
  ScenarioActionCombinedItemGenericsNodeAggregationWhereInput: ScenarioActionCombinedItemGenericsNodeAggregationWhereInput;
  ScenarioActionCombinedItemGenericsRelationship: ResolverTypeWrapper<ScenarioActionCombinedItemGenericsRelationship>;
  ScenarioActionCombinedItemTreatmentsAggregateInput: ScenarioActionCombinedItemTreatmentsAggregateInput;
  ScenarioActionCombinedItemTreatmentsConnection: ResolverTypeWrapper<ScenarioActionCombinedItemTreatmentsConnection>;
  ScenarioActionCombinedItemTreatmentsConnectionSort: ScenarioActionCombinedItemTreatmentsConnectionSort;
  ScenarioActionCombinedItemTreatmentsConnectionWhere: ScenarioActionCombinedItemTreatmentsConnectionWhere;
  ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput: ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput;
  ScenarioActionCombinedItemTreatmentsRelationship: ResolverTypeWrapper<ScenarioActionCombinedItemTreatmentsRelationship>;
  ScenarioActionCycleAggregateInput: ScenarioActionCycleAggregateInput;
  ScenarioActionCycleConfigurationCycleAggregationSelection: ResolverTypeWrapper<ScenarioActionCycleConfigurationCycleAggregationSelection>;
  ScenarioActionCycleConfigurationCycleNodeAggregateSelection: ResolverTypeWrapper<ScenarioActionCycleConfigurationCycleNodeAggregateSelection>;
  ScenarioActionCycleConnection: ResolverTypeWrapper<ScenarioActionCycleConnection>;
  ScenarioActionCycleConnectionSort: ScenarioActionCycleConnectionSort;
  ScenarioActionCycleConnectionWhere: ScenarioActionCycleConnectionWhere;
  ScenarioActionCycleNodeAggregationWhereInput: ScenarioActionCycleNodeAggregationWhereInput;
  ScenarioActionCycleRelationship: ResolverTypeWrapper<ScenarioActionCycleRelationship>;
  ScenarioActionEdge: ResolverTypeWrapper<ScenarioActionEdge>;
  ScenarioActionFailure: ScenarioActionFailure;
  ScenarioActionGenericCombinedItemGenericsAggregationSelection: ResolverTypeWrapper<ScenarioActionGenericCombinedItemGenericsAggregationSelection>;
  ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection: ResolverTypeWrapper<ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection>;
  ScenarioActionGenericGenericsAggregationSelection: ResolverTypeWrapper<ScenarioActionGenericGenericsAggregationSelection>;
  ScenarioActionGenericGenericsEdgeAggregateSelection: ResolverTypeWrapper<ScenarioActionGenericGenericsEdgeAggregateSelection>;
  ScenarioActionGenericGenericsNodeAggregateSelection: ResolverTypeWrapper<ScenarioActionGenericGenericsNodeAggregateSelection>;
  ScenarioActionGenericsAggregateInput: ScenarioActionGenericsAggregateInput;
  ScenarioActionGenericsConnection: ResolverTypeWrapper<ScenarioActionGenericsConnection>;
  ScenarioActionGenericsConnectionSort: ScenarioActionGenericsConnectionSort;
  ScenarioActionGenericsConnectionWhere: ScenarioActionGenericsConnectionWhere;
  ScenarioActionGenericsEdgeAggregationWhereInput: ScenarioActionGenericsEdgeAggregationWhereInput;
  ScenarioActionGenericsNodeAggregationWhereInput: ScenarioActionGenericsNodeAggregationWhereInput;
  ScenarioActionGenericsRelationship: ResolverTypeWrapper<ScenarioActionGenericsRelationship>;
  ScenarioActionInput: ScenarioActionInput;
  ScenarioActionOptions: ScenarioActionOptions;
  ScenarioActionScenarioAggregateInput: ScenarioActionScenarioAggregateInput;
  ScenarioActionScenarioConnection: ResolverTypeWrapper<ScenarioActionScenarioConnection>;
  ScenarioActionScenarioConnectionSort: ScenarioActionScenarioConnectionSort;
  ScenarioActionScenarioConnectionWhere: ScenarioActionScenarioConnectionWhere;
  ScenarioActionScenarioNodeAggregationWhereInput: ScenarioActionScenarioNodeAggregationWhereInput;
  ScenarioActionScenarioRelationship: ResolverTypeWrapper<ScenarioActionScenarioRelationship>;
  ScenarioActionScenarioScenarioAggregationSelection: ResolverTypeWrapper<ScenarioActionScenarioScenarioAggregationSelection>;
  ScenarioActionScenarioScenarioNodeAggregateSelection: ResolverTypeWrapper<ScenarioActionScenarioScenarioNodeAggregateSelection>;
  ScenarioActionSort: ScenarioActionSort;
  ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection: ResolverTypeWrapper<ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection>;
  ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection: ResolverTypeWrapper<ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection>;
  ScenarioActionTreatmentTreatmentsAggregationSelection: ResolverTypeWrapper<ScenarioActionTreatmentTreatmentsAggregationSelection>;
  ScenarioActionTreatmentTreatmentsEdgeAggregateSelection: ResolverTypeWrapper<ScenarioActionTreatmentTreatmentsEdgeAggregateSelection>;
  ScenarioActionTreatmentTreatmentsNodeAggregateSelection: ResolverTypeWrapper<ScenarioActionTreatmentTreatmentsNodeAggregateSelection>;
  ScenarioActionTreatmentsAggregateInput: ScenarioActionTreatmentsAggregateInput;
  ScenarioActionTreatmentsConnection: ResolverTypeWrapper<ScenarioActionTreatmentsConnection>;
  ScenarioActionTreatmentsConnectionSort: ScenarioActionTreatmentsConnectionSort;
  ScenarioActionTreatmentsConnectionWhere: ScenarioActionTreatmentsConnectionWhere;
  ScenarioActionTreatmentsEdgeAggregationWhereInput: ScenarioActionTreatmentsEdgeAggregationWhereInput;
  ScenarioActionTreatmentsNodeAggregationWhereInput: ScenarioActionTreatmentsNodeAggregationWhereInput;
  ScenarioActionTreatmentsRelationship: ResolverTypeWrapper<ScenarioActionTreatmentsRelationship>;
  ScenarioActionWhere: ScenarioActionWhere;
  ScenarioActionsAggregateInput: ScenarioActionsAggregateInput;
  ScenarioActionsConnection: ResolverTypeWrapper<ScenarioActionsConnection>;
  ScenarioActionsConnectionSort: ScenarioActionsConnectionSort;
  ScenarioActionsConnectionWhere: ScenarioActionsConnectionWhere;
  ScenarioActionsNodeAggregationWhereInput: ScenarioActionsNodeAggregationWhereInput;
  ScenarioActionsRelationship: ResolverTypeWrapper<ScenarioActionsRelationship>;
  ScenarioCondition: ResolverTypeWrapper<ScenarioCondition>;
  ScenarioConditionBrandBrandsAggregationSelection: ResolverTypeWrapper<ScenarioConditionBrandBrandsAggregationSelection>;
  ScenarioConditionBrandBrandsNodeAggregateSelection: ResolverTypeWrapper<ScenarioConditionBrandBrandsNodeAggregateSelection>;
  ScenarioConditionBrandsAggregateInput: ScenarioConditionBrandsAggregateInput;
  ScenarioConditionBrandsConnection: ResolverTypeWrapper<ScenarioConditionBrandsConnection>;
  ScenarioConditionBrandsConnectionSort: ScenarioConditionBrandsConnectionSort;
  ScenarioConditionBrandsConnectionWhere: ScenarioConditionBrandsConnectionWhere;
  ScenarioConditionBrandsNodeAggregationWhereInput: ScenarioConditionBrandsNodeAggregationWhereInput;
  ScenarioConditionBrandsRelationship: ResolverTypeWrapper<ScenarioConditionBrandsRelationship>;
  ScenarioConditionCustomConditionAggregateInput: ScenarioConditionCustomConditionAggregateInput;
  ScenarioConditionCustomConditionConnection: ResolverTypeWrapper<ScenarioConditionCustomConditionConnection>;
  ScenarioConditionCustomConditionConnectionSort: ScenarioConditionCustomConditionConnectionSort;
  ScenarioConditionCustomConditionConnectionWhere: ScenarioConditionCustomConditionConnectionWhere;
  ScenarioConditionCustomConditionCustomConditionAggregationSelection: ResolverTypeWrapper<ScenarioConditionCustomConditionCustomConditionAggregationSelection>;
  ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection: ResolverTypeWrapper<ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection>;
  ScenarioConditionCustomConditionNodeAggregationWhereInput: ScenarioConditionCustomConditionNodeAggregationWhereInput;
  ScenarioConditionCustomConditionRelationship: ResolverTypeWrapper<ScenarioConditionCustomConditionRelationship>;
  ScenarioConditionEdge: ResolverTypeWrapper<ScenarioConditionEdge>;
  ScenarioConditionGenericGenericsAggregationSelection: ResolverTypeWrapper<ScenarioConditionGenericGenericsAggregationSelection>;
  ScenarioConditionGenericGenericsNodeAggregateSelection: ResolverTypeWrapper<ScenarioConditionGenericGenericsNodeAggregateSelection>;
  ScenarioConditionGenericsAggregateInput: ScenarioConditionGenericsAggregateInput;
  ScenarioConditionGenericsConnection: ResolverTypeWrapper<ScenarioConditionGenericsConnection>;
  ScenarioConditionGenericsConnectionSort: ScenarioConditionGenericsConnectionSort;
  ScenarioConditionGenericsConnectionWhere: ScenarioConditionGenericsConnectionWhere;
  ScenarioConditionGenericsNodeAggregationWhereInput: ScenarioConditionGenericsNodeAggregationWhereInput;
  ScenarioConditionGenericsRelationship: ResolverTypeWrapper<ScenarioConditionGenericsRelationship>;
  ScenarioConditionInput: ScenarioConditionInput;
  ScenarioConditionOptions: ScenarioConditionOptions;
  ScenarioConditionScenarioAggregateInput: ScenarioConditionScenarioAggregateInput;
  ScenarioConditionScenarioConnection: ResolverTypeWrapper<ScenarioConditionScenarioConnection>;
  ScenarioConditionScenarioConnectionSort: ScenarioConditionScenarioConnectionSort;
  ScenarioConditionScenarioConnectionWhere: ScenarioConditionScenarioConnectionWhere;
  ScenarioConditionScenarioNodeAggregationWhereInput: ScenarioConditionScenarioNodeAggregationWhereInput;
  ScenarioConditionScenarioRelationship: ResolverTypeWrapper<ScenarioConditionScenarioRelationship>;
  ScenarioConditionScenarioScenarioAggregationSelection: ResolverTypeWrapper<ScenarioConditionScenarioScenarioAggregationSelection>;
  ScenarioConditionScenarioScenarioNodeAggregateSelection: ResolverTypeWrapper<ScenarioConditionScenarioScenarioNodeAggregateSelection>;
  ScenarioConditionSort: ScenarioConditionSort;
  ScenarioConditionTreatmentTreatmentsAggregationSelection: ResolverTypeWrapper<ScenarioConditionTreatmentTreatmentsAggregationSelection>;
  ScenarioConditionTreatmentTreatmentsNodeAggregateSelection: ResolverTypeWrapper<ScenarioConditionTreatmentTreatmentsNodeAggregateSelection>;
  ScenarioConditionTreatmentsAggregateInput: ScenarioConditionTreatmentsAggregateInput;
  ScenarioConditionTreatmentsConnection: ResolverTypeWrapper<ScenarioConditionTreatmentsConnection>;
  ScenarioConditionTreatmentsConnectionSort: ScenarioConditionTreatmentsConnectionSort;
  ScenarioConditionTreatmentsConnectionWhere: ScenarioConditionTreatmentsConnectionWhere;
  ScenarioConditionTreatmentsNodeAggregationWhereInput: ScenarioConditionTreatmentsNodeAggregationWhereInput;
  ScenarioConditionTreatmentsRelationship: ResolverTypeWrapper<ScenarioConditionTreatmentsRelationship>;
  ScenarioConditionWhere: ScenarioConditionWhere;
  ScenarioConditionsAggregateInput: ScenarioConditionsAggregateInput;
  ScenarioConditionsConnection: ResolverTypeWrapper<ScenarioConditionsConnection>;
  ScenarioConditionsConnectionSort: ScenarioConditionsConnectionSort;
  ScenarioConditionsConnectionWhere: ScenarioConditionsConnectionWhere;
  ScenarioConditionsNodeAggregationWhereInput: ScenarioConditionsNodeAggregationWhereInput;
  ScenarioConditionsRelationship: ResolverTypeWrapper<ScenarioConditionsRelationship>;
  ScenarioEdge: ResolverTypeWrapper<ScenarioEdge>;
  ScenarioInput: ScenarioInput;
  ScenarioInsightsUserContext: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ScenarioInsightsUserContext']>;
  ScenarioInsightsUserContextSort: ScenarioInsightsUserContextSort;
  ScenarioInsightsUserContextWhere: ScenarioInsightsUserContextWhere;
  ScenarioOptions: ScenarioOptions;
  ScenarioScenarioActionActionsAggregationSelection: ResolverTypeWrapper<ScenarioScenarioActionActionsAggregationSelection>;
  ScenarioScenarioActionActionsNodeAggregateSelection: ResolverTypeWrapper<ScenarioScenarioActionActionsNodeAggregateSelection>;
  ScenarioScenarioConditionConditionsAggregationSelection: ResolverTypeWrapper<ScenarioScenarioConditionConditionsAggregationSelection>;
  ScenarioScenarioConditionConditionsNodeAggregateSelection: ResolverTypeWrapper<ScenarioScenarioConditionConditionsNodeAggregateSelection>;
  ScenarioSort: ScenarioSort;
  ScenarioWhere: ScenarioWhere;
  ScenariosConnection: ResolverTypeWrapper<ScenariosConnection>;
  ScopeCheckResult: ResolverTypeWrapper<ScopeCheckResult>;
  ScopeCheckResultEdge: ResolverTypeWrapper<ScopeCheckResultEdge>;
  ScopeCheckResultOptions: ScopeCheckResultOptions;
  ScopeCheckResultSort: ScopeCheckResultSort;
  ScopeCheckResultWhere: ScopeCheckResultWhere;
  ScopeCheckResultsConnection: ResolverTypeWrapper<ScopeCheckResultsConnection>;
  ScopeId: ScopeId;
  Simulation: ResolverTypeWrapper<Simulation>;
  SimulationAccessibleUsersAggregateInput: SimulationAccessibleUsersAggregateInput;
  SimulationAccessibleUsersConnection: ResolverTypeWrapper<SimulationAccessibleUsersConnection>;
  SimulationAccessibleUsersConnectionSort: SimulationAccessibleUsersConnectionSort;
  SimulationAccessibleUsersConnectionWhere: SimulationAccessibleUsersConnectionWhere;
  SimulationAccessibleUsersEdgeAggregationWhereInput: SimulationAccessibleUsersEdgeAggregationWhereInput;
  SimulationAccessibleUsersNodeAggregationWhereInput: SimulationAccessibleUsersNodeAggregationWhereInput;
  SimulationAccessibleUsersRelationship: ResolverTypeWrapper<SimulationAccessibleUsersRelationship>;
  SimulationAddedByAggregateInput: SimulationAddedByAggregateInput;
  SimulationAddedByConnection: ResolverTypeWrapper<SimulationAddedByConnection>;
  SimulationAddedByConnectionSort: SimulationAddedByConnectionSort;
  SimulationAddedByConnectionWhere: SimulationAddedByConnectionWhere;
  SimulationAddedByNodeAggregationWhereInput: SimulationAddedByNodeAggregationWhereInput;
  SimulationAddedByRelationship: ResolverTypeWrapper<SimulationAddedByRelationship>;
  SimulationBlueprintAggregateInput: SimulationBlueprintAggregateInput;
  SimulationBlueprintConnection: ResolverTypeWrapper<SimulationBlueprintConnection>;
  SimulationBlueprintConnectionSort: SimulationBlueprintConnectionSort;
  SimulationBlueprintConnectionWhere: SimulationBlueprintConnectionWhere;
  SimulationBlueprintNodeAggregationWhereInput: SimulationBlueprintNodeAggregationWhereInput;
  SimulationBlueprintRelationship: ResolverTypeWrapper<SimulationBlueprintRelationship>;
  SimulationCount: ResolverTypeWrapper<SimulationCount>;
  SimulationCountEdge: ResolverTypeWrapper<SimulationCountEdge>;
  SimulationCountOptions: SimulationCountOptions;
  SimulationCountSort: SimulationCountSort;
  SimulationCountWhere: SimulationCountWhere;
  SimulationCountsConnection: ResolverTypeWrapper<SimulationCountsConnection>;
  SimulationDomainAggregateInput: SimulationDomainAggregateInput;
  SimulationDomainConnection: ResolverTypeWrapper<SimulationDomainConnection>;
  SimulationDomainConnectionSort: SimulationDomainConnectionSort;
  SimulationDomainConnectionWhere: SimulationDomainConnectionWhere;
  SimulationDomainDomainAggregationSelection: ResolverTypeWrapper<SimulationDomainDomainAggregationSelection>;
  SimulationDomainDomainNodeAggregateSelection: ResolverTypeWrapper<SimulationDomainDomainNodeAggregateSelection>;
  SimulationDomainNodeAggregationWhereInput: SimulationDomainNodeAggregationWhereInput;
  SimulationDomainRelationship: ResolverTypeWrapper<SimulationDomainRelationship>;
  SimulationEdge: ResolverTypeWrapper<SimulationEdge>;
  SimulationOptions: SimulationOptions;
  SimulationProductBlueprintBlueprintAggregationSelection: ResolverTypeWrapper<SimulationProductBlueprintBlueprintAggregationSelection>;
  SimulationProductBlueprintBlueprintNodeAggregateSelection: ResolverTypeWrapper<SimulationProductBlueprintBlueprintNodeAggregateSelection>;
  SimulationSavedStatus: SimulationSavedStatus;
  SimulationSort: SimulationSort;
  SimulationUserAccessibleUsersAggregationSelection: ResolverTypeWrapper<SimulationUserAccessibleUsersAggregationSelection>;
  SimulationUserAccessibleUsersEdgeAggregateSelection: ResolverTypeWrapper<SimulationUserAccessibleUsersEdgeAggregateSelection>;
  SimulationUserAccessibleUsersNodeAggregateSelection: ResolverTypeWrapper<SimulationUserAccessibleUsersNodeAggregateSelection>;
  SimulationUserAddedByAggregationSelection: ResolverTypeWrapper<SimulationUserAddedByAggregationSelection>;
  SimulationUserAddedByNodeAggregateSelection: ResolverTypeWrapper<SimulationUserAddedByNodeAggregateSelection>;
  SimulationUserWithRole: ResolverTypeWrapper<SimulationUserWithRole>;
  SimulationUserWithRoleEdge: ResolverTypeWrapper<SimulationUserWithRoleEdge>;
  SimulationUserWithRoleOptions: SimulationUserWithRoleOptions;
  SimulationUserWithRoleSort: SimulationUserWithRoleSort;
  SimulationUserWithRoleWhere: SimulationUserWithRoleWhere;
  SimulationUserWithRolesConnection: ResolverTypeWrapper<SimulationUserWithRolesConnection>;
  SimulationWhere: SimulationWhere;
  SimulationsConnection: ResolverTypeWrapper<SimulationsConnection>;
  SimulatorUserRole: SimulatorUserRole;
  SimulatorUserRoleRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['SimulatorUserRoleRelationship']>;
  SimulatorUserRoleRelationshipSort: SimulatorUserRoleRelationshipSort;
  SimulatorUserRoleRelationshipWhere: SimulatorUserRoleRelationshipWhere;
  SingleSignOnType: SingleSignOnType;
  SlowGraphqlOperation: ResolverTypeWrapper<SlowGraphqlOperation>;
  SlowGraphqlOperationEdge: ResolverTypeWrapper<SlowGraphqlOperationEdge>;
  SlowGraphqlOperationOptions: SlowGraphqlOperationOptions;
  SlowGraphqlOperationSort: SlowGraphqlOperationSort;
  SlowGraphqlOperationWhere: SlowGraphqlOperationWhere;
  SlowGraphqlOperationsConnection: ResolverTypeWrapper<SlowGraphqlOperationsConnection>;
  SlowGraphqlRequestsResult: ResolverTypeWrapper<SlowGraphqlRequestsResult>;
  SlowGraphqlRequestsResultEdge: ResolverTypeWrapper<SlowGraphqlRequestsResultEdge>;
  SlowGraphqlRequestsResultOptions: SlowGraphqlRequestsResultOptions;
  SlowGraphqlRequestsResultSort: SlowGraphqlRequestsResultSort;
  SlowGraphqlRequestsResultWhere: SlowGraphqlRequestsResultWhere;
  SlowGraphqlRequestsResultsConnection: ResolverTypeWrapper<SlowGraphqlRequestsResultsConnection>;
  SortDirection: SortDirection;
  StatusHistorical: StatusHistorical;
  StoreUser: ResolverTypeWrapper<StoreUser>;
  StoreUserEdge: ResolverTypeWrapper<StoreUserEdge>;
  StoreUserOptions: StoreUserOptions;
  StoreUserSort: StoreUserSort;
  StoreUserWhere: StoreUserWhere;
  StoreUsersConnection: ResolverTypeWrapper<StoreUsersConnection>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  StringAggregateSelectionNonNullable: ResolverTypeWrapper<StringAggregateSelectionNonNullable>;
  StringAggregateSelectionNullable: ResolverTypeWrapper<StringAggregateSelectionNullable>;
  Subscription: ResolverTypeWrapper<{}>;
  SyncRefundImpact: ResolverTypeWrapper<SyncRefundImpact>;
  SyncRefundImpactEdge: ResolverTypeWrapper<SyncRefundImpactEdge>;
  SyncRefundImpactOptions: SyncRefundImpactOptions;
  SyncRefundImpactSort: SyncRefundImpactSort;
  SyncRefundImpactWhere: SyncRefundImpactWhere;
  SyncRefundImpactsConnection: ResolverTypeWrapper<SyncRefundImpactsConnection>;
  SyncResponse: ResolverTypeWrapper<SyncResponse>;
  SyncResponseEdge: ResolverTypeWrapper<SyncResponseEdge>;
  SyncResponseOptions: SyncResponseOptions;
  SyncResponseSort: SyncResponseSort;
  SyncResponseWhere: SyncResponseWhere;
  SyncResponsesConnection: ResolverTypeWrapper<SyncResponsesConnection>;
  SyncType: SyncType;
  SystemTask: ResolverTypeWrapper<SystemTask>;
  SystemTaskEdge: ResolverTypeWrapper<SystemTaskEdge>;
  SystemTaskOptions: SystemTaskOptions;
  SystemTaskSort: SystemTaskSort;
  SystemTaskWhere: SystemTaskWhere;
  SystemTasksConnection: ResolverTypeWrapper<SystemTasksConnection>;
  TermsAndPoliciesInput: TermsAndPoliciesInput;
  TestPurposeType: TestPurposeType;
  TestType: TestType;
  TestUoMType: TestUoMType;
  ThresholdConfigurationRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ThresholdConfigurationRelationship']>;
  ThresholdConfigurationRelationshipSort: ThresholdConfigurationRelationshipSort;
  ThresholdConfigurationRelationshipWhere: ThresholdConfigurationRelationshipWhere;
  TimeframeRangeType: TimeframeRangeType;
  TimeframeRelation: TimeframeRelation;
  TimeframeStartingPoint: TimeframeStartingPoint;
  TransfusionType: TransfusionType;
  Translation: ResolverTypeWrapper<Translation>;
  TranslationEdge: ResolverTypeWrapper<TranslationEdge>;
  TranslationInput: TranslationInput;
  TranslationLanguageInput: TranslationLanguageInput;
  TranslationOptions: TranslationOptions;
  TranslationSort: TranslationSort;
  TranslationWhere: TranslationWhere;
  Translations: Translations;
  TranslationsConnection: ResolverTypeWrapper<TranslationsConnection>;
  TranslationsInput: TranslationsInput;
  TranslationsWithChangedKeys: ResolverTypeWrapper<TranslationsWithChangedKeys>;
  TranslationsWithChangedKeysConnection: ResolverTypeWrapper<TranslationsWithChangedKeysConnection>;
  TranslationsWithChangedKeysEdge: ResolverTypeWrapper<TranslationsWithChangedKeysEdge>;
  TranslationsWithChangedKeysOptions: TranslationsWithChangedKeysOptions;
  TranslationsWithChangedKeysSort: TranslationsWithChangedKeysSort;
  TranslationsWithChangedKeysWhere: TranslationsWithChangedKeysWhere;
  Treatment: ResolverTypeWrapper<Treatment>;
  TreatmentCountryAggregateInput: TreatmentCountryAggregateInput;
  TreatmentCountryConnection: ResolverTypeWrapper<TreatmentCountryConnection>;
  TreatmentCountryConnectionSort: TreatmentCountryConnectionSort;
  TreatmentCountryConnectionWhere: TreatmentCountryConnectionWhere;
  TreatmentCountryCountryAggregationSelection: ResolverTypeWrapper<TreatmentCountryCountryAggregationSelection>;
  TreatmentCountryCountryNodeAggregateSelection: ResolverTypeWrapper<TreatmentCountryCountryNodeAggregateSelection>;
  TreatmentCountryNodeAggregationWhereInput: TreatmentCountryNodeAggregationWhereInput;
  TreatmentCountryRelationship: ResolverTypeWrapper<TreatmentCountryRelationship>;
  TreatmentDiscontinuationReason: TreatmentDiscontinuationReason;
  TreatmentDurationConditionAspect: TreatmentDurationConditionAspect;
  TreatmentEdge: ResolverTypeWrapper<TreatmentEdge>;
  TreatmentHasLimitationsAggregateInput: TreatmentHasLimitationsAggregateInput;
  TreatmentHasLimitationsConnection: ResolverTypeWrapper<TreatmentHasLimitationsConnection>;
  TreatmentHasLimitationsConnectionSort: TreatmentHasLimitationsConnectionSort;
  TreatmentHasLimitationsConnectionWhere: TreatmentHasLimitationsConnectionWhere;
  TreatmentHasLimitationsNodeAggregationWhereInput: TreatmentHasLimitationsNodeAggregationWhereInput;
  TreatmentHasLimitationsRelationship: ResolverTypeWrapper<TreatmentHasLimitationsRelationship>;
  TreatmentInput: TreatmentInput;
  TreatmentLimitationHasLimitationsAggregationSelection: ResolverTypeWrapper<TreatmentLimitationHasLimitationsAggregationSelection>;
  TreatmentLimitationHasLimitationsNodeAggregateSelection: ResolverTypeWrapper<TreatmentLimitationHasLimitationsNodeAggregateSelection>;
  TreatmentOptions: TreatmentOptions;
  TreatmentPartnerPartnersAggregationSelection: ResolverTypeWrapper<TreatmentPartnerPartnersAggregationSelection>;
  TreatmentPartnerPartnersNodeAggregateSelection: ResolverTypeWrapper<TreatmentPartnerPartnersNodeAggregateSelection>;
  TreatmentPartnersAggregateInput: TreatmentPartnersAggregateInput;
  TreatmentPartnersConnection: ResolverTypeWrapper<TreatmentPartnersConnection>;
  TreatmentPartnersConnectionSort: TreatmentPartnersConnectionSort;
  TreatmentPartnersConnectionWhere: TreatmentPartnersConnectionWhere;
  TreatmentPartnersNodeAggregationWhereInput: TreatmentPartnersNodeAggregationWhereInput;
  TreatmentPartnersRelationship: ResolverTypeWrapper<TreatmentPartnersRelationship>;
  TreatmentPreparationRegulatedByAggregationSelection: ResolverTypeWrapper<TreatmentPreparationRegulatedByAggregationSelection>;
  TreatmentPreparationRegulatedByNodeAggregateSelection: ResolverTypeWrapper<TreatmentPreparationRegulatedByNodeAggregateSelection>;
  TreatmentPreparationStatusStatusAggregationSelection: ResolverTypeWrapper<TreatmentPreparationStatusStatusAggregationSelection>;
  TreatmentPreparationStatusStatusNodeAggregateSelection: ResolverTypeWrapper<TreatmentPreparationStatusStatusNodeAggregateSelection>;
  TreatmentPriceInput: TreatmentPriceInput;
  TreatmentPricePricesAggregationSelection: ResolverTypeWrapper<TreatmentPricePricesAggregationSelection>;
  TreatmentPricePricesNodeAggregateSelection: ResolverTypeWrapper<TreatmentPricePricesNodeAggregateSelection>;
  TreatmentPricesAggregateInput: TreatmentPricesAggregateInput;
  TreatmentPricesConnection: ResolverTypeWrapper<TreatmentPricesConnection>;
  TreatmentPricesConnectionSort: TreatmentPricesConnectionSort;
  TreatmentPricesConnectionWhere: TreatmentPricesConnectionWhere;
  TreatmentPricesNodeAggregationWhereInput: TreatmentPricesNodeAggregationWhereInput;
  TreatmentPricesRelationship: ResolverTypeWrapper<TreatmentPricesRelationship>;
  TreatmentRegulatedByAggregateInput: TreatmentRegulatedByAggregateInput;
  TreatmentRegulatedByConnection: ResolverTypeWrapper<TreatmentRegulatedByConnection>;
  TreatmentRegulatedByConnectionSort: TreatmentRegulatedByConnectionSort;
  TreatmentRegulatedByConnectionWhere: TreatmentRegulatedByConnectionWhere;
  TreatmentRegulatedByNodeAggregationWhereInput: TreatmentRegulatedByNodeAggregationWhereInput;
  TreatmentRegulatedByRelationship: ResolverTypeWrapper<TreatmentRegulatedByRelationship>;
  TreatmentSet: ResolverTypeWrapper<TreatmentSet>;
  TreatmentSetAgreementScopeScopeAggregationSelection: ResolverTypeWrapper<TreatmentSetAgreementScopeScopeAggregationSelection>;
  TreatmentSetAgreementScopeScopeNodeAggregateSelection: ResolverTypeWrapper<TreatmentSetAgreementScopeScopeNodeAggregateSelection>;
  TreatmentSetEdge: ResolverTypeWrapper<TreatmentSetEdge>;
  TreatmentSetGenericAggregateInput: TreatmentSetGenericAggregateInput;
  TreatmentSetGenericConnection: ResolverTypeWrapper<TreatmentSetGenericConnection>;
  TreatmentSetGenericConnectionSort: TreatmentSetGenericConnectionSort;
  TreatmentSetGenericConnectionWhere: TreatmentSetGenericConnectionWhere;
  TreatmentSetGenericGenericAggregationSelection: ResolverTypeWrapper<TreatmentSetGenericGenericAggregationSelection>;
  TreatmentSetGenericGenericNodeAggregateSelection: ResolverTypeWrapper<TreatmentSetGenericGenericNodeAggregateSelection>;
  TreatmentSetGenericNodeAggregationWhereInput: TreatmentSetGenericNodeAggregationWhereInput;
  TreatmentSetGenericRelationship: ResolverTypeWrapper<TreatmentSetGenericRelationship>;
  TreatmentSetInput: TreatmentSetInput;
  TreatmentSetOptions: TreatmentSetOptions;
  TreatmentSetPreparationPreparationsAggregationSelection: ResolverTypeWrapper<TreatmentSetPreparationPreparationsAggregationSelection>;
  TreatmentSetPreparationPreparationsNodeAggregateSelection: ResolverTypeWrapper<TreatmentSetPreparationPreparationsNodeAggregateSelection>;
  TreatmentSetPreparationsAggregateInput: TreatmentSetPreparationsAggregateInput;
  TreatmentSetPreparationsConnection: ResolverTypeWrapper<TreatmentSetPreparationsConnection>;
  TreatmentSetPreparationsConnectionSort: TreatmentSetPreparationsConnectionSort;
  TreatmentSetPreparationsConnectionWhere: TreatmentSetPreparationsConnectionWhere;
  TreatmentSetPreparationsNodeAggregationWhereInput: TreatmentSetPreparationsNodeAggregationWhereInput;
  TreatmentSetPreparationsRelationship: ResolverTypeWrapper<TreatmentSetPreparationsRelationship>;
  TreatmentSetScopeAggregateInput: TreatmentSetScopeAggregateInput;
  TreatmentSetScopeConnection: ResolverTypeWrapper<TreatmentSetScopeConnection>;
  TreatmentSetScopeConnectionSort: TreatmentSetScopeConnectionSort;
  TreatmentSetScopeConnectionWhere: TreatmentSetScopeConnectionWhere;
  TreatmentSetScopeNodeAggregationWhereInput: TreatmentSetScopeNodeAggregationWhereInput;
  TreatmentSetScopeRelationship: ResolverTypeWrapper<TreatmentSetScopeRelationship>;
  TreatmentSetSort: TreatmentSetSort;
  TreatmentSetTreatmentTreatmentsAggregationSelection: ResolverTypeWrapper<TreatmentSetTreatmentTreatmentsAggregationSelection>;
  TreatmentSetTreatmentTreatmentsNodeAggregateSelection: ResolverTypeWrapper<TreatmentSetTreatmentTreatmentsNodeAggregateSelection>;
  TreatmentSetTreatmentsAggregateInput: TreatmentSetTreatmentsAggregateInput;
  TreatmentSetTreatmentsConnection: ResolverTypeWrapper<TreatmentSetTreatmentsConnection>;
  TreatmentSetTreatmentsConnectionSort: TreatmentSetTreatmentsConnectionSort;
  TreatmentSetTreatmentsConnectionWhere: TreatmentSetTreatmentsConnectionWhere;
  TreatmentSetTreatmentsNodeAggregationWhereInput: TreatmentSetTreatmentsNodeAggregationWhereInput;
  TreatmentSetTreatmentsRelationship: ResolverTypeWrapper<TreatmentSetTreatmentsRelationship>;
  TreatmentSetWhere: TreatmentSetWhere;
  TreatmentSetsConnection: ResolverTypeWrapper<TreatmentSetsConnection>;
  TreatmentSort: TreatmentSort;
  TreatmentStatusAggregateInput: TreatmentStatusAggregateInput;
  TreatmentStatusConnection: ResolverTypeWrapper<TreatmentStatusConnection>;
  TreatmentStatusConnectionSort: TreatmentStatusConnectionSort;
  TreatmentStatusConnectionWhere: TreatmentStatusConnectionWhere;
  TreatmentStatusNodeAggregationWhereInput: TreatmentStatusNodeAggregationWhereInput;
  TreatmentStatusRelationship: ResolverTypeWrapper<TreatmentStatusRelationship>;
  TreatmentWhere: TreatmentWhere;
  TreatmentsConnection: ResolverTypeWrapper<TreatmentsConnection>;
  UnitedResponseType: UnitedResponseType;
  UoMType: UoMType;
  UpdateCustomConditionInput: UpdateCustomConditionInput;
  UpdateIndicationInput: UpdateIndicationInput;
  UpdateMissingKeyInput: UpdateMissingKeyInput;
  UpdateTranslationPayload: UpdateTranslationPayload;
  Upload: ResolverTypeWrapper<Upload>;
  UploadEdge: ResolverTypeWrapper<UploadEdge>;
  UploadFlexEntitiesAggregateInput: UploadFlexEntitiesAggregateInput;
  UploadFlexEntitiesConnection: ResolverTypeWrapper<UploadFlexEntitiesConnection>;
  UploadFlexEntitiesConnectionSort: UploadFlexEntitiesConnectionSort;
  UploadFlexEntitiesConnectionWhere: UploadFlexEntitiesConnectionWhere;
  UploadFlexEntitiesNodeAggregationWhereInput: UploadFlexEntitiesNodeAggregationWhereInput;
  UploadFlexEntitiesRelationship: ResolverTypeWrapper<UploadFlexEntitiesRelationship>;
  UploadFlexEntityFlexEntitiesAggregationSelection: ResolverTypeWrapper<UploadFlexEntityFlexEntitiesAggregationSelection>;
  UploadFlexEntityFlexEntitiesNodeAggregateSelection: ResolverTypeWrapper<UploadFlexEntityFlexEntitiesNodeAggregateSelection>;
  UploadLimitation: ResolverTypeWrapper<UploadLimitation>;
  UploadLimitationEdge: ResolverTypeWrapper<UploadLimitationEdge>;
  UploadLimitationInput: UploadLimitationInput;
  UploadLimitationOptions: UploadLimitationOptions;
  UploadLimitationSort: UploadLimitationSort;
  UploadLimitationUpdatedByAggregateInput: UploadLimitationUpdatedByAggregateInput;
  UploadLimitationUpdatedByConnection: ResolverTypeWrapper<UploadLimitationUpdatedByConnection>;
  UploadLimitationUpdatedByConnectionSort: UploadLimitationUpdatedByConnectionSort;
  UploadLimitationUpdatedByConnectionWhere: UploadLimitationUpdatedByConnectionWhere;
  UploadLimitationUpdatedByEdgeAggregationWhereInput: UploadLimitationUpdatedByEdgeAggregationWhereInput;
  UploadLimitationUpdatedByNodeAggregationWhereInput: UploadLimitationUpdatedByNodeAggregationWhereInput;
  UploadLimitationUpdatedByRelationship: ResolverTypeWrapper<UploadLimitationUpdatedByRelationship>;
  UploadLimitationUpdaterRelationship: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['UploadLimitationUpdaterRelationship']>;
  UploadLimitationUpdaterRelationshipSort: UploadLimitationUpdaterRelationshipSort;
  UploadLimitationUpdaterRelationshipWhere: UploadLimitationUpdaterRelationshipWhere;
  UploadLimitationUserUpdatedByAggregationSelection: ResolverTypeWrapper<UploadLimitationUserUpdatedByAggregationSelection>;
  UploadLimitationUserUpdatedByEdgeAggregateSelection: ResolverTypeWrapper<UploadLimitationUserUpdatedByEdgeAggregateSelection>;
  UploadLimitationUserUpdatedByNodeAggregateSelection: ResolverTypeWrapper<UploadLimitationUserUpdatedByNodeAggregateSelection>;
  UploadLimitationWhere: UploadLimitationWhere;
  UploadLimitationsConnection: ResolverTypeWrapper<UploadLimitationsConnection>;
  UploadOptions: UploadOptions;
  UploadSort: UploadSort;
  UploadState: ResolverTypeWrapper<UploadState>;
  UploadStateEdge: ResolverTypeWrapper<UploadStateEdge>;
  UploadStateOptions: UploadStateOptions;
  UploadStateSort: UploadStateSort;
  UploadStateWhere: UploadStateWhere;
  UploadStatesConnection: ResolverTypeWrapper<UploadStatesConnection>;
  UploadWhere: UploadWhere;
  UploadsConnection: ResolverTypeWrapper<UploadsConnection>;
  User: ResolverTypeWrapper<User>;
  UserAssignDomainsInput: UserAssignDomainsInput;
  UserAvailableEntryModule: ResolverTypeWrapper<UserAvailableEntryModule>;
  UserAvailableEntryModuleEdge: ResolverTypeWrapper<UserAvailableEntryModuleEdge>;
  UserAvailableEntryModuleOptions: UserAvailableEntryModuleOptions;
  UserAvailableEntryModuleSort: UserAvailableEntryModuleSort;
  UserAvailableEntryModuleWhere: UserAvailableEntryModuleWhere;
  UserAvailableEntryModulesConnection: ResolverTypeWrapper<UserAvailableEntryModulesConnection>;
  UserContext: ResolverTypeWrapper<UserContext>;
  UserContextEdge: ResolverTypeWrapper<UserContextEdge>;
  UserContextOptions: UserContextOptions;
  UserContextSort: UserContextSort;
  UserContextWhere: UserContextWhere;
  UserContextsConnection: ResolverTypeWrapper<UserContextsConnection>;
  UserDomainDomainsAggregationSelection: ResolverTypeWrapper<UserDomainDomainsAggregationSelection>;
  UserDomainDomainsNodeAggregateSelection: ResolverTypeWrapper<UserDomainDomainsNodeAggregateSelection>;
  UserDomainsAggregateInput: UserDomainsAggregateInput;
  UserDomainsConnection: ResolverTypeWrapper<UserDomainsConnection>;
  UserDomainsConnectionSort: UserDomainsConnectionSort;
  UserDomainsConnectionWhere: UserDomainsConnectionWhere;
  UserDomainsNodeAggregationWhereInput: UserDomainsNodeAggregationWhereInput;
  UserDomainsRelationship: ResolverTypeWrapper<UserDomainsRelationship>;
  UserEdge: ResolverTypeWrapper<UserEdge>;
  UserInput: UserInput;
  UserOptions: UserOptions;
  UserOrgSettingsData: ResolverTypeWrapper<UserOrgSettingsData>;
  UserOrgSettingsDataConnection: ResolverTypeWrapper<UserOrgSettingsDataConnection>;
  UserOrgSettingsDataEdge: ResolverTypeWrapper<UserOrgSettingsDataEdge>;
  UserOrgSettingsDataOptions: UserOrgSettingsDataOptions;
  UserOrgSettingsDataSort: UserOrgSettingsDataSort;
  UserOrgSettingsDataWhere: UserOrgSettingsDataWhere;
  UserOrganizationInfo: ResolverTypeWrapper<UserOrganizationInfo>;
  UserOrganizationInfoEdge: ResolverTypeWrapper<UserOrganizationInfoEdge>;
  UserOrganizationInfoOptions: UserOrganizationInfoOptions;
  UserOrganizationInfoSort: UserOrganizationInfoSort;
  UserOrganizationInfoWhere: UserOrganizationInfoWhere;
  UserOrganizationInfosConnection: ResolverTypeWrapper<UserOrganizationInfosConnection>;
  UserRoleRequestUpdateInput: UserRoleRequestUpdateInput;
  UserSort: UserSort;
  UserWhere: UserWhere;
  UsersConnection: ResolverTypeWrapper<UsersConnection>;
  VASProductBlueprintInput: VasProductBlueprintInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  ActionPrescriptionRelationship: ResolversInterfaceTypes<ResolversParentTypes>['ActionPrescriptionRelationship'];
  ActionPrescriptionRelationshipSort: ActionPrescriptionRelationshipSort;
  ActionPrescriptionRelationshipWhere: ActionPrescriptionRelationshipWhere;
  ActiveUserSession: ActiveUserSession;
  ActiveUserSessionEdge: ActiveUserSessionEdge;
  ActiveUserSessionOptions: ActiveUserSessionOptions;
  ActiveUserSessionSort: ActiveUserSessionSort;
  ActiveUserSessionWhere: ActiveUserSessionWhere;
  ActiveUserSessionsConnection: ActiveUserSessionsConnection;
  Agreement: Agreement;
  AgreementAddedByAggregateInput: AgreementAddedByAggregateInput;
  AgreementAddedByConnection: AgreementAddedByConnection;
  AgreementAddedByConnectionSort: AgreementAddedByConnectionSort;
  AgreementAddedByConnectionWhere: AgreementAddedByConnectionWhere;
  AgreementAddedByNodeAggregationWhereInput: AgreementAddedByNodeAggregationWhereInput;
  AgreementAddedByRelationship: AgreementAddedByRelationship;
  AgreementAgreementInitialVersionAggregationSelection: AgreementAgreementInitialVersionAggregationSelection;
  AgreementAgreementInitialVersionNodeAggregateSelection: AgreementAgreementInitialVersionNodeAggregateSelection;
  AgreementAgreementNextVersionsAggregationSelection: AgreementAgreementNextVersionsAggregationSelection;
  AgreementAgreementNextVersionsNodeAggregateSelection: AgreementAgreementNextVersionsNodeAggregateSelection;
  AgreementAgreementTagTagsAggregationSelection: AgreementAgreementTagTagsAggregationSelection;
  AgreementAgreementTagTagsNodeAggregateSelection: AgreementAgreementTagTagsNodeAggregateSelection;
  AgreementAgreementTemplateTemplateAggregationSelection: AgreementAgreementTemplateTemplateAggregationSelection;
  AgreementAgreementTemplateTemplateNodeAggregateSelection: AgreementAgreementTemplateTemplateNodeAggregateSelection;
  AgreementBrandScenariosRelevantBrandsAggregationSelection: AgreementBrandScenariosRelevantBrandsAggregationSelection;
  AgreementBrandScenariosRelevantBrandsNodeAggregateSelection: AgreementBrandScenariosRelevantBrandsNodeAggregateSelection;
  AgreementCatalogueAttributeNegotiableAttributesAggregationSelection: AgreementCatalogueAttributeNegotiableAttributesAggregationSelection;
  AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection: AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection;
  AgreementChartRangeConfigurationDotThresholdsAggregationSelection: AgreementChartRangeConfigurationDotThresholdsAggregationSelection;
  AgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection: AgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection;
  AgreementChartRangeConfigurationRangeChartConfigAggregationSelection: AgreementChartRangeConfigurationRangeChartConfigAggregationSelection;
  AgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection: AgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection;
  AgreementCounterpartiesAggregateInput: AgreementCounterpartiesAggregateInput;
  AgreementCounterpartiesConnection: AgreementCounterpartiesConnection;
  AgreementCounterpartiesConnectionSort: AgreementCounterpartiesConnectionSort;
  AgreementCounterpartiesConnectionWhere: AgreementCounterpartiesConnectionWhere;
  AgreementCounterpartiesNodeAggregationWhereInput: AgreementCounterpartiesNodeAggregationWhereInput;
  AgreementCounterpartiesRelationship: AgreementCounterpartiesRelationship;
  AgreementCounterpartyInput: AgreementCounterpartyInput;
  AgreementCounterpartyRelationship: ResolversInterfaceTypes<ResolversParentTypes>['AgreementCounterpartyRelationship'];
  AgreementCounterpartyRelationshipSort: AgreementCounterpartyRelationshipSort;
  AgreementCounterpartyRelationshipWhere: AgreementCounterpartyRelationshipWhere;
  AgreementCountryAggregateInput: AgreementCountryAggregateInput;
  AgreementCountryConnection: AgreementCountryConnection;
  AgreementCountryConnectionSort: AgreementCountryConnectionSort;
  AgreementCountryConnectionWhere: AgreementCountryConnectionWhere;
  AgreementCountryCountryAggregationSelection: AgreementCountryCountryAggregationSelection;
  AgreementCountryCountryNodeAggregateSelection: AgreementCountryCountryNodeAggregateSelection;
  AgreementCountryNodeAggregationWhereInput: AgreementCountryNodeAggregationWhereInput;
  AgreementCountryRelationship: AgreementCountryRelationship;
  AgreementCurrencyAggregateInput: AgreementCurrencyAggregateInput;
  AgreementCurrencyConnection: AgreementCurrencyConnection;
  AgreementCurrencyConnectionSort: AgreementCurrencyConnectionSort;
  AgreementCurrencyConnectionWhere: AgreementCurrencyConnectionWhere;
  AgreementCurrencyCurrencyAggregationSelection: AgreementCurrencyCurrencyAggregationSelection;
  AgreementCurrencyCurrencyNodeAggregateSelection: AgreementCurrencyCurrencyNodeAggregateSelection;
  AgreementCurrencyNodeAggregationWhereInput: AgreementCurrencyNodeAggregationWhereInput;
  AgreementCurrencyRelationship: AgreementCurrencyRelationship;
  AgreementCycleConfigurationCyclesAggregationSelection: AgreementCycleConfigurationCyclesAggregationSelection;
  AgreementCycleConfigurationCyclesNodeAggregateSelection: AgreementCycleConfigurationCyclesNodeAggregateSelection;
  AgreementCyclesAggregateInput: AgreementCyclesAggregateInput;
  AgreementCyclesConnection: AgreementCyclesConnection;
  AgreementCyclesConnectionSort: AgreementCyclesConnectionSort;
  AgreementCyclesConnectionWhere: AgreementCyclesConnectionWhere;
  AgreementCyclesNodeAggregationWhereInput: AgreementCyclesNodeAggregationWhereInput;
  AgreementCyclesRelationship: AgreementCyclesRelationship;
  AgreementDataContainerDataContainersAggregationSelection: AgreementDataContainerDataContainersAggregationSelection;
  AgreementDataContainerDataContainersNodeAggregateSelection: AgreementDataContainerDataContainersNodeAggregateSelection;
  AgreementDataContainersAggregateInput: AgreementDataContainersAggregateInput;
  AgreementDataContainersConnection: AgreementDataContainersConnection;
  AgreementDataContainersConnectionSort: AgreementDataContainersConnectionSort;
  AgreementDataContainersConnectionWhere: AgreementDataContainersConnectionWhere;
  AgreementDataContainersNodeAggregationWhereInput: AgreementDataContainersNodeAggregationWhereInput;
  AgreementDataContainersRelationship: AgreementDataContainersRelationship;
  AgreementDataSourceAggregateInput: AgreementDataSourceAggregateInput;
  AgreementDataSourceConnection: AgreementDataSourceConnection;
  AgreementDataSourceConnectionSort: AgreementDataSourceConnectionSort;
  AgreementDataSourceConnectionWhere: AgreementDataSourceConnectionWhere;
  AgreementDataSourceDataSourceAggregationSelection: AgreementDataSourceDataSourceAggregationSelection;
  AgreementDataSourceDataSourceNodeAggregateSelection: AgreementDataSourceDataSourceNodeAggregateSelection;
  AgreementDataSourceNodeAggregationWhereInput: AgreementDataSourceNodeAggregationWhereInput;
  AgreementDataSourceRelationship: AgreementDataSourceRelationship;
  AgreementDecision: AgreementDecision;
  AgreementDecisionAsOfAggregateInput: AgreementDecisionAsOfAggregateInput;
  AgreementDecisionAsOfConnection: AgreementDecisionAsOfConnection;
  AgreementDecisionAsOfConnectionSort: AgreementDecisionAsOfConnectionSort;
  AgreementDecisionAsOfConnectionWhere: AgreementDecisionAsOfConnectionWhere;
  AgreementDecisionAsOfNodeAggregationWhereInput: AgreementDecisionAsOfNodeAggregationWhereInput;
  AgreementDecisionAsOfRelationship: AgreementDecisionAsOfRelationship;
  AgreementDecisionEdge: AgreementDecisionEdge;
  AgreementDecisionMadeByAggregateInput: AgreementDecisionMadeByAggregateInput;
  AgreementDecisionMadeByConnection: AgreementDecisionMadeByConnection;
  AgreementDecisionMadeByConnectionSort: AgreementDecisionMadeByConnectionSort;
  AgreementDecisionMadeByConnectionWhere: AgreementDecisionMadeByConnectionWhere;
  AgreementDecisionMadeByNodeAggregationWhereInput: AgreementDecisionMadeByNodeAggregationWhereInput;
  AgreementDecisionMadeByRelationship: AgreementDecisionMadeByRelationship;
  AgreementDecisionOptions: AgreementDecisionOptions;
  AgreementDecisionOrganizationAsOfAggregationSelection: AgreementDecisionOrganizationAsOfAggregationSelection;
  AgreementDecisionOrganizationAsOfNodeAggregateSelection: AgreementDecisionOrganizationAsOfNodeAggregateSelection;
  AgreementDecisionSort: AgreementDecisionSort;
  AgreementDecisionUserMadeByAggregationSelection: AgreementDecisionUserMadeByAggregationSelection;
  AgreementDecisionUserMadeByNodeAggregateSelection: AgreementDecisionUserMadeByNodeAggregateSelection;
  AgreementDecisionWhere: AgreementDecisionWhere;
  AgreementDecisionsConnection: AgreementDecisionsConnection;
  AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection: AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection;
  AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection: AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection;
  AgreementDeviceAlternativeSetsAggregateInput: AgreementDeviceAlternativeSetsAggregateInput;
  AgreementDeviceAlternativeSetsConnection: AgreementDeviceAlternativeSetsConnection;
  AgreementDeviceAlternativeSetsConnectionSort: AgreementDeviceAlternativeSetsConnectionSort;
  AgreementDeviceAlternativeSetsConnectionWhere: AgreementDeviceAlternativeSetsConnectionWhere;
  AgreementDeviceAlternativeSetsNodeAggregationWhereInput: AgreementDeviceAlternativeSetsNodeAggregationWhereInput;
  AgreementDeviceAlternativeSetsRelationship: AgreementDeviceAlternativeSetsRelationship;
  AgreementDotThresholdsAggregateInput: AgreementDotThresholdsAggregateInput;
  AgreementDotThresholdsConnection: AgreementDotThresholdsConnection;
  AgreementDotThresholdsConnectionSort: AgreementDotThresholdsConnectionSort;
  AgreementDotThresholdsConnectionWhere: AgreementDotThresholdsConnectionWhere;
  AgreementDotThresholdsEdgeAggregationWhereInput: AgreementDotThresholdsEdgeAggregationWhereInput;
  AgreementDotThresholdsRelationship: AgreementDotThresholdsRelationship;
  AgreementEdge: AgreementEdge;
  AgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection: AgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection;
  AgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection: AgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection;
  AgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection: AgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection;
  AgreementEligibilityConditionSetsAggregateInput: AgreementEligibilityConditionSetsAggregateInput;
  AgreementEligibilityConditionSetsConnection: AgreementEligibilityConditionSetsConnection;
  AgreementEligibilityConditionSetsConnectionSort: AgreementEligibilityConditionSetsConnectionSort;
  AgreementEligibilityConditionSetsConnectionWhere: AgreementEligibilityConditionSetsConnectionWhere;
  AgreementEligibilityConditionSetsEdgeAggregationWhereInput: AgreementEligibilityConditionSetsEdgeAggregationWhereInput;
  AgreementEligibilityConditionSetsNodeAggregationWhereInput: AgreementEligibilityConditionSetsNodeAggregationWhereInput;
  AgreementEligibilityConditionSetsRelationship: AgreementEligibilityConditionSetsRelationship;
  AgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection: AgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection;
  AgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection: AgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection;
  AgreementEnrollingConditionSetsAggregateInput: AgreementEnrollingConditionSetsAggregateInput;
  AgreementEnrollingConditionSetsConnection: AgreementEnrollingConditionSetsConnection;
  AgreementEnrollingConditionSetsConnectionSort: AgreementEnrollingConditionSetsConnectionSort;
  AgreementEnrollingConditionSetsConnectionWhere: AgreementEnrollingConditionSetsConnectionWhere;
  AgreementEnrollingConditionSetsNodeAggregationWhereInput: AgreementEnrollingConditionSetsNodeAggregationWhereInput;
  AgreementEnrollingConditionSetsRelationship: AgreementEnrollingConditionSetsRelationship;
  AgreementEnrollingPeriodEnrollingPeriodsAggregationSelection: AgreementEnrollingPeriodEnrollingPeriodsAggregationSelection;
  AgreementEnrollingPeriodsAggregateInput: AgreementEnrollingPeriodsAggregateInput;
  AgreementEnrollingPeriodsConnection: AgreementEnrollingPeriodsConnection;
  AgreementEnrollingPeriodsConnectionSort: AgreementEnrollingPeriodsConnectionSort;
  AgreementEnrollingPeriodsConnectionWhere: AgreementEnrollingPeriodsConnectionWhere;
  AgreementEnrollingPeriodsRelationship: AgreementEnrollingPeriodsRelationship;
  AgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection: AgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection;
  AgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection: AgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection;
  AgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection: AgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection;
  AgreementFinancialSummaryColumnRelationship: ResolversInterfaceTypes<ResolversParentTypes>['AgreementFinancialSummaryColumnRelationship'];
  AgreementFinancialSummaryColumnRelationshipSort: AgreementFinancialSummaryColumnRelationshipSort;
  AgreementFinancialSummaryColumnRelationshipWhere: AgreementFinancialSummaryColumnRelationshipWhere;
  AgreementFinancialSummaryConfigAggregateInput: AgreementFinancialSummaryConfigAggregateInput;
  AgreementFinancialSummaryConfigConnection: AgreementFinancialSummaryConfigConnection;
  AgreementFinancialSummaryConfigConnectionSort: AgreementFinancialSummaryConfigConnectionSort;
  AgreementFinancialSummaryConfigConnectionWhere: AgreementFinancialSummaryConfigConnectionWhere;
  AgreementFinancialSummaryConfigEdgeAggregationWhereInput: AgreementFinancialSummaryConfigEdgeAggregationWhereInput;
  AgreementFinancialSummaryConfigNodeAggregationWhereInput: AgreementFinancialSummaryConfigNodeAggregationWhereInput;
  AgreementFinancialSummaryConfigRelationship: AgreementFinancialSummaryConfigRelationship;
  AgreementInitialVersionAggregateInput: AgreementInitialVersionAggregateInput;
  AgreementInitialVersionConnection: AgreementInitialVersionConnection;
  AgreementInitialVersionConnectionSort: AgreementInitialVersionConnectionSort;
  AgreementInitialVersionConnectionWhere: AgreementInitialVersionConnectionWhere;
  AgreementInitialVersionNodeAggregationWhereInput: AgreementInitialVersionNodeAggregationWhereInput;
  AgreementInitialVersionRelationship: AgreementInitialVersionRelationship;
  AgreementInput: AgreementInput;
  AgreementLimitationAggregateInput: AgreementLimitationAggregateInput;
  AgreementLimitationConnection: AgreementLimitationConnection;
  AgreementLimitationConnectionSort: AgreementLimitationConnectionSort;
  AgreementLimitationConnectionWhere: AgreementLimitationConnectionWhere;
  AgreementLimitationLimitationAggregationSelection: AgreementLimitationLimitationAggregationSelection;
  AgreementLimitationLimitationNodeAggregateSelection: AgreementLimitationLimitationNodeAggregateSelection;
  AgreementLimitationNodeAggregationWhereInput: AgreementLimitationNodeAggregationWhereInput;
  AgreementLimitationRelationship: AgreementLimitationRelationship;
  AgreementNegotiableAttributesAggregateInput: AgreementNegotiableAttributesAggregateInput;
  AgreementNegotiableAttributesConnection: AgreementNegotiableAttributesConnection;
  AgreementNegotiableAttributesConnectionSort: AgreementNegotiableAttributesConnectionSort;
  AgreementNegotiableAttributesConnectionWhere: AgreementNegotiableAttributesConnectionWhere;
  AgreementNegotiableAttributesNodeAggregationWhereInput: AgreementNegotiableAttributesNodeAggregationWhereInput;
  AgreementNegotiableAttributesRelationship: AgreementNegotiableAttributesRelationship;
  AgreementNextVersionsAggregateInput: AgreementNextVersionsAggregateInput;
  AgreementNextVersionsConnection: AgreementNextVersionsConnection;
  AgreementNextVersionsConnectionSort: AgreementNextVersionsConnectionSort;
  AgreementNextVersionsConnectionWhere: AgreementNextVersionsConnectionWhere;
  AgreementNextVersionsNodeAggregationWhereInput: AgreementNextVersionsNodeAggregationWhereInput;
  AgreementNextVersionsRelationship: AgreementNextVersionsRelationship;
  AgreementOptions: AgreementOptions;
  AgreementOrganizationCounterpartiesAggregationSelection: AgreementOrganizationCounterpartiesAggregationSelection;
  AgreementOrganizationCounterpartiesNodeAggregateSelection: AgreementOrganizationCounterpartiesNodeAggregateSelection;
  AgreementPushedByAggregateInput: AgreementPushedByAggregateInput;
  AgreementPushedByConnection: AgreementPushedByConnection;
  AgreementPushedByConnectionSort: AgreementPushedByConnectionSort;
  AgreementPushedByConnectionWhere: AgreementPushedByConnectionWhere;
  AgreementPushedByNodeAggregationWhereInput: AgreementPushedByNodeAggregationWhereInput;
  AgreementPushedByRelationship: AgreementPushedByRelationship;
  AgreementRangeChartConfigAggregateInput: AgreementRangeChartConfigAggregateInput;
  AgreementRangeChartConfigConnection: AgreementRangeChartConfigConnection;
  AgreementRangeChartConfigConnectionSort: AgreementRangeChartConfigConnectionSort;
  AgreementRangeChartConfigConnectionWhere: AgreementRangeChartConfigConnectionWhere;
  AgreementRangeChartConfigEdgeAggregationWhereInput: AgreementRangeChartConfigEdgeAggregationWhereInput;
  AgreementRangeChartConfigRelationship: AgreementRangeChartConfigRelationship;
  AgreementRunAttemptInfo: AgreementRunAttemptInfo;
  AgreementRunAttemptInfoEdge: AgreementRunAttemptInfoEdge;
  AgreementRunAttemptInfoOptions: AgreementRunAttemptInfoOptions;
  AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection: AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection;
  AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection: AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection;
  AgreementRunAttemptInfoOrganizationTriggeredAggregateInput: AgreementRunAttemptInfoOrganizationTriggeredAggregateInput;
  AgreementRunAttemptInfoOrganizationTriggeredConnection: AgreementRunAttemptInfoOrganizationTriggeredConnection;
  AgreementRunAttemptInfoOrganizationTriggeredConnectionSort: AgreementRunAttemptInfoOrganizationTriggeredConnectionSort;
  AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere: AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere;
  AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput: AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput;
  AgreementRunAttemptInfoOrganizationTriggeredRelationship: AgreementRunAttemptInfoOrganizationTriggeredRelationship;
  AgreementRunAttemptInfoRunInitiatorAggregateInput: AgreementRunAttemptInfoRunInitiatorAggregateInput;
  AgreementRunAttemptInfoRunInitiatorConnection: AgreementRunAttemptInfoRunInitiatorConnection;
  AgreementRunAttemptInfoRunInitiatorConnectionSort: AgreementRunAttemptInfoRunInitiatorConnectionSort;
  AgreementRunAttemptInfoRunInitiatorConnectionWhere: AgreementRunAttemptInfoRunInitiatorConnectionWhere;
  AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput: AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput;
  AgreementRunAttemptInfoRunInitiatorRelationship: AgreementRunAttemptInfoRunInitiatorRelationship;
  AgreementRunAttemptInfoSort: AgreementRunAttemptInfoSort;
  AgreementRunAttemptInfoUserRunInitiatorAggregationSelection: AgreementRunAttemptInfoUserRunInitiatorAggregationSelection;
  AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection: AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection;
  AgreementRunAttemptInfoWhere: AgreementRunAttemptInfoWhere;
  AgreementRunAttemptInfosConnection: AgreementRunAttemptInfosConnection;
  AgreementScenarioScenariosAggregationSelection: AgreementScenarioScenariosAggregationSelection;
  AgreementScenarioScenariosNodeAggregateSelection: AgreementScenarioScenariosNodeAggregateSelection;
  AgreementScenariosAggregateInput: AgreementScenariosAggregateInput;
  AgreementScenariosConnection: AgreementScenariosConnection;
  AgreementScenariosConnectionSort: AgreementScenariosConnectionSort;
  AgreementScenariosConnectionWhere: AgreementScenariosConnectionWhere;
  AgreementScenariosNodeAggregationWhereInput: AgreementScenariosNodeAggregationWhereInput;
  AgreementScenariosRelationship: AgreementScenariosRelationship;
  AgreementScenariosRelevantBrandsAggregateInput: AgreementScenariosRelevantBrandsAggregateInput;
  AgreementScenariosRelevantBrandsConnection: AgreementScenariosRelevantBrandsConnection;
  AgreementScenariosRelevantBrandsConnectionSort: AgreementScenariosRelevantBrandsConnectionSort;
  AgreementScenariosRelevantBrandsConnectionWhere: AgreementScenariosRelevantBrandsConnectionWhere;
  AgreementScenariosRelevantBrandsNodeAggregationWhereInput: AgreementScenariosRelevantBrandsNodeAggregationWhereInput;
  AgreementScenariosRelevantBrandsRelationship: AgreementScenariosRelevantBrandsRelationship;
  AgreementScope: AgreementScope;
  AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection: AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection;
  AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection: AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection;
  AgreementScopeArticle71IndicationsAggregateInput: AgreementScopeArticle71IndicationsAggregateInput;
  AgreementScopeArticle71IndicationsConnection: AgreementScopeArticle71IndicationsConnection;
  AgreementScopeArticle71IndicationsConnectionSort: AgreementScopeArticle71IndicationsConnectionSort;
  AgreementScopeArticle71IndicationsConnectionWhere: AgreementScopeArticle71IndicationsConnectionWhere;
  AgreementScopeArticle71IndicationsNodeAggregationWhereInput: AgreementScopeArticle71IndicationsNodeAggregationWhereInput;
  AgreementScopeArticle71IndicationsRelationship: AgreementScopeArticle71IndicationsRelationship;
  AgreementScopeCountryCountryScopesAggregationSelection: AgreementScopeCountryCountryScopesAggregationSelection;
  AgreementScopeCountryCountryScopesEdgeAggregateSelection: AgreementScopeCountryCountryScopesEdgeAggregateSelection;
  AgreementScopeCountryCountryScopesNodeAggregateSelection: AgreementScopeCountryCountryScopesNodeAggregateSelection;
  AgreementScopeCountryScope: AgreementScopeCountryScope;
  AgreementScopeCountryScopeEdge: AgreementScopeCountryScopeEdge;
  AgreementScopeCountryScopeOptions: AgreementScopeCountryScopeOptions;
  AgreementScopeCountryScopeSort: AgreementScopeCountryScopeSort;
  AgreementScopeCountryScopeWhere: AgreementScopeCountryScopeWhere;
  AgreementScopeCountryScopesAggregateInput: AgreementScopeCountryScopesAggregateInput;
  AgreementScopeCountryScopesConnection: AgreementScopeCountryScopesConnection;
  AgreementScopeCountryScopesConnectionSort: AgreementScopeCountryScopesConnectionSort;
  AgreementScopeCountryScopesConnectionWhere: AgreementScopeCountryScopesConnectionWhere;
  AgreementScopeCountryScopesEdgeAggregationWhereInput: AgreementScopeCountryScopesEdgeAggregationWhereInput;
  AgreementScopeCountryScopesNodeAggregationWhereInput: AgreementScopeCountryScopesNodeAggregationWhereInput;
  AgreementScopeCountryScopesRelationship: AgreementScopeCountryScopesRelationship;
  AgreementScopeCycleConfigurationCyclesAggregationSelection: AgreementScopeCycleConfigurationCyclesAggregationSelection;
  AgreementScopeCycleConfigurationCyclesNodeAggregateSelection: AgreementScopeCycleConfigurationCyclesNodeAggregateSelection;
  AgreementScopeCyclesAggregateInput: AgreementScopeCyclesAggregateInput;
  AgreementScopeCyclesConnection: AgreementScopeCyclesConnection;
  AgreementScopeCyclesConnectionSort: AgreementScopeCyclesConnectionSort;
  AgreementScopeCyclesConnectionWhere: AgreementScopeCyclesConnectionWhere;
  AgreementScopeCyclesNodeAggregationWhereInput: AgreementScopeCyclesNodeAggregationWhereInput;
  AgreementScopeCyclesRelationship: AgreementScopeCyclesRelationship;
  AgreementScopeDiseaseDiseasesAggregationSelection: AgreementScopeDiseaseDiseasesAggregationSelection;
  AgreementScopeDiseaseDiseasesEdgeAggregateSelection: AgreementScopeDiseaseDiseasesEdgeAggregateSelection;
  AgreementScopeDiseaseDiseasesNodeAggregateSelection: AgreementScopeDiseaseDiseasesNodeAggregateSelection;
  AgreementScopeDiseasesAggregateInput: AgreementScopeDiseasesAggregateInput;
  AgreementScopeDiseasesConnection: AgreementScopeDiseasesConnection;
  AgreementScopeDiseasesConnectionSort: AgreementScopeDiseasesConnectionSort;
  AgreementScopeDiseasesConnectionWhere: AgreementScopeDiseasesConnectionWhere;
  AgreementScopeDiseasesEdgeAggregationWhereInput: AgreementScopeDiseasesEdgeAggregationWhereInput;
  AgreementScopeDiseasesNodeAggregationWhereInput: AgreementScopeDiseasesNodeAggregationWhereInput;
  AgreementScopeDiseasesRelationship: AgreementScopeDiseasesRelationship;
  AgreementScopeEdge: AgreementScopeEdge;
  AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection: AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection;
  AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection: AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection;
  AgreementScopeEnrollingConditionSetsAggregateInput: AgreementScopeEnrollingConditionSetsAggregateInput;
  AgreementScopeEnrollingConditionSetsConnection: AgreementScopeEnrollingConditionSetsConnection;
  AgreementScopeEnrollingConditionSetsConnectionSort: AgreementScopeEnrollingConditionSetsConnectionSort;
  AgreementScopeEnrollingConditionSetsConnectionWhere: AgreementScopeEnrollingConditionSetsConnectionWhere;
  AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput: AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput;
  AgreementScopeEnrollingConditionSetsRelationship: AgreementScopeEnrollingConditionSetsRelationship;
  AgreementScopeIndicationIndicationsAggregationSelection: AgreementScopeIndicationIndicationsAggregationSelection;
  AgreementScopeIndicationIndicationsNodeAggregateSelection: AgreementScopeIndicationIndicationsNodeAggregateSelection;
  AgreementScopeIndicationsAggregateInput: AgreementScopeIndicationsAggregateInput;
  AgreementScopeIndicationsConnection: AgreementScopeIndicationsConnection;
  AgreementScopeIndicationsConnectionSort: AgreementScopeIndicationsConnectionSort;
  AgreementScopeIndicationsConnectionWhere: AgreementScopeIndicationsConnectionWhere;
  AgreementScopeIndicationsNodeAggregationWhereInput: AgreementScopeIndicationsNodeAggregationWhereInput;
  AgreementScopeIndicationsRelationship: AgreementScopeIndicationsRelationship;
  AgreementScopeInput: AgreementScopeInput;
  AgreementScopeOptions: AgreementScopeOptions;
  AgreementScopeOrganizationOrganizationScopesAggregationSelection: AgreementScopeOrganizationOrganizationScopesAggregationSelection;
  AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection: AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection;
  AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection: AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection;
  AgreementScopeOrganizationScope: AgreementScopeOrganizationScope;
  AgreementScopeOrganizationScopeEdge: AgreementScopeOrganizationScopeEdge;
  AgreementScopeOrganizationScopeOptions: AgreementScopeOrganizationScopeOptions;
  AgreementScopeOrganizationScopeSort: AgreementScopeOrganizationScopeSort;
  AgreementScopeOrganizationScopeWhere: AgreementScopeOrganizationScopeWhere;
  AgreementScopeOrganizationScopesAggregateInput: AgreementScopeOrganizationScopesAggregateInput;
  AgreementScopeOrganizationScopesConnection: AgreementScopeOrganizationScopesConnection;
  AgreementScopeOrganizationScopesConnectionSort: AgreementScopeOrganizationScopesConnectionSort;
  AgreementScopeOrganizationScopesConnectionWhere: AgreementScopeOrganizationScopesConnectionWhere;
  AgreementScopeOrganizationScopesEdgeAggregationWhereInput: AgreementScopeOrganizationScopesEdgeAggregationWhereInput;
  AgreementScopeOrganizationScopesNodeAggregationWhereInput: AgreementScopeOrganizationScopesNodeAggregationWhereInput;
  AgreementScopeOrganizationScopesRelationship: AgreementScopeOrganizationScopesRelationship;
  AgreementScopeRelationship: ResolversInterfaceTypes<ResolversParentTypes>['AgreementScopeRelationship'];
  AgreementScopeRelationshipSort: AgreementScopeRelationshipSort;
  AgreementScopeRelationshipWhere: AgreementScopeRelationshipWhere;
  AgreementScopeSort: AgreementScopeSort;
  AgreementScopeTreatmentSetTreatmentSetsAggregationSelection: AgreementScopeTreatmentSetTreatmentSetsAggregationSelection;
  AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection: AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection;
  AgreementScopeTreatmentSetsAggregateInput: AgreementScopeTreatmentSetsAggregateInput;
  AgreementScopeTreatmentSetsConnection: AgreementScopeTreatmentSetsConnection;
  AgreementScopeTreatmentSetsConnectionSort: AgreementScopeTreatmentSetsConnectionSort;
  AgreementScopeTreatmentSetsConnectionWhere: AgreementScopeTreatmentSetsConnectionWhere;
  AgreementScopeTreatmentSetsNodeAggregationWhereInput: AgreementScopeTreatmentSetsNodeAggregationWhereInput;
  AgreementScopeTreatmentSetsRelationship: AgreementScopeTreatmentSetsRelationship;
  AgreementScopeWhere: AgreementScopeWhere;
  AgreementScopesConnection: AgreementScopesConnection;
  AgreementSort: AgreementSort;
  AgreementSpecificRole: AgreementSpecificRole;
  AgreementSpecificRoleEdge: AgreementSpecificRoleEdge;
  AgreementSpecificRoleOptions: AgreementSpecificRoleOptions;
  AgreementSpecificRoleSort: AgreementSpecificRoleSort;
  AgreementSpecificRoleWhere: AgreementSpecificRoleWhere;
  AgreementSpecificRolesConnection: AgreementSpecificRolesConnection;
  AgreementStatusTransition: AgreementStatusTransition;
  AgreementStatusTransitionCausedByAggregateInput: AgreementStatusTransitionCausedByAggregateInput;
  AgreementStatusTransitionCausedByConnection: AgreementStatusTransitionCausedByConnection;
  AgreementStatusTransitionCausedByConnectionSort: AgreementStatusTransitionCausedByConnectionSort;
  AgreementStatusTransitionCausedByConnectionWhere: AgreementStatusTransitionCausedByConnectionWhere;
  AgreementStatusTransitionCausedByNodeAggregationWhereInput: AgreementStatusTransitionCausedByNodeAggregationWhereInput;
  AgreementStatusTransitionCausedByRelationship: AgreementStatusTransitionCausedByRelationship;
  AgreementStatusTransitionEdge: AgreementStatusTransitionEdge;
  AgreementStatusTransitionOptions: AgreementStatusTransitionOptions;
  AgreementStatusTransitionSort: AgreementStatusTransitionSort;
  AgreementStatusTransitionUserCausedByAggregationSelection: AgreementStatusTransitionUserCausedByAggregationSelection;
  AgreementStatusTransitionUserCausedByNodeAggregateSelection: AgreementStatusTransitionUserCausedByNodeAggregateSelection;
  AgreementStatusTransitionWhere: AgreementStatusTransitionWhere;
  AgreementStatusTransitionsConnection: AgreementStatusTransitionsConnection;
  AgreementTag: AgreementTag;
  AgreementTagDefaultUserRolesAggregateInput: AgreementTagDefaultUserRolesAggregateInput;
  AgreementTagDefaultUserRolesConnection: AgreementTagDefaultUserRolesConnection;
  AgreementTagDefaultUserRolesConnectionSort: AgreementTagDefaultUserRolesConnectionSort;
  AgreementTagDefaultUserRolesConnectionWhere: AgreementTagDefaultUserRolesConnectionWhere;
  AgreementTagDefaultUserRolesNodeAggregationWhereInput: AgreementTagDefaultUserRolesNodeAggregationWhereInput;
  AgreementTagDefaultUserRolesRelationship: AgreementTagDefaultUserRolesRelationship;
  AgreementTagEdge: AgreementTagEdge;
  AgreementTagInput: AgreementTagInput;
  AgreementTagOptions: AgreementTagOptions;
  AgreementTagSort: AgreementTagSort;
  AgreementTagUserDefaultUserRolesAggregationSelection: AgreementTagUserDefaultUserRolesAggregationSelection;
  AgreementTagUserDefaultUserRolesNodeAggregateSelection: AgreementTagUserDefaultUserRolesNodeAggregateSelection;
  AgreementTagUserRoleRelationship: ResolversInterfaceTypes<ResolversParentTypes>['AgreementTagUserRoleRelationship'];
  AgreementTagUserRoleRelationshipSort: AgreementTagUserRoleRelationshipSort;
  AgreementTagUserRoleRelationshipWhere: AgreementTagUserRoleRelationshipWhere;
  AgreementTagWhere: AgreementTagWhere;
  AgreementTagsAggregateInput: AgreementTagsAggregateInput;
  AgreementTagsConnection: AgreementTagsConnection;
  AgreementTagsConnectionSort: AgreementTagsConnectionSort;
  AgreementTagsConnectionWhere: AgreementTagsConnectionWhere;
  AgreementTagsNodeAggregationWhereInput: AgreementTagsNodeAggregationWhereInput;
  AgreementTemplate: AgreementTemplate;
  AgreementTemplateAddedByAggregateInput: AgreementTemplateAddedByAggregateInput;
  AgreementTemplateAddedByConnection: AgreementTemplateAddedByConnection;
  AgreementTemplateAddedByConnectionSort: AgreementTemplateAddedByConnectionSort;
  AgreementTemplateAddedByConnectionWhere: AgreementTemplateAddedByConnectionWhere;
  AgreementTemplateAddedByNodeAggregationWhereInput: AgreementTemplateAddedByNodeAggregationWhereInput;
  AgreementTemplateAddedByRelationship: AgreementTemplateAddedByRelationship;
  AgreementTemplateAggregateInput: AgreementTemplateAggregateInput;
  AgreementTemplateAgreementAgreementsAggregationSelection: AgreementTemplateAgreementAgreementsAggregationSelection;
  AgreementTemplateAgreementAgreementsNodeAggregateSelection: AgreementTemplateAgreementAgreementsNodeAggregateSelection;
  AgreementTemplateAgreementTagTagsAggregationSelection: AgreementTemplateAgreementTagTagsAggregationSelection;
  AgreementTemplateAgreementTagTagsNodeAggregateSelection: AgreementTemplateAgreementTagTagsNodeAggregateSelection;
  AgreementTemplateAgreementTemplateInitialVersionAggregationSelection: AgreementTemplateAgreementTemplateInitialVersionAggregationSelection;
  AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection: AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection;
  AgreementTemplateAgreementTemplateNextVersionsAggregationSelection: AgreementTemplateAgreementTemplateNextVersionsAggregationSelection;
  AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection: AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection;
  AgreementTemplateAgreementsAggregateInput: AgreementTemplateAgreementsAggregateInput;
  AgreementTemplateAgreementsConnection: AgreementTemplateAgreementsConnection;
  AgreementTemplateAgreementsConnectionSort: AgreementTemplateAgreementsConnectionSort;
  AgreementTemplateAgreementsConnectionWhere: AgreementTemplateAgreementsConnectionWhere;
  AgreementTemplateAgreementsNodeAggregationWhereInput: AgreementTemplateAgreementsNodeAggregationWhereInput;
  AgreementTemplateAgreementsRelationship: AgreementTemplateAgreementsRelationship;
  AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection: AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection;
  AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection: AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection;
  AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection: AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection;
  AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection: AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection;
  AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection: AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection;
  AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection: AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection;
  AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection: AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection;
  AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection: AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection;
  AgreementTemplateConnection: AgreementTemplateConnection;
  AgreementTemplateConnectionSort: AgreementTemplateConnectionSort;
  AgreementTemplateConnectionWhere: AgreementTemplateConnectionWhere;
  AgreementTemplateCountryAggregateInput: AgreementTemplateCountryAggregateInput;
  AgreementTemplateCountryConnection: AgreementTemplateCountryConnection;
  AgreementTemplateCountryConnectionSort: AgreementTemplateCountryConnectionSort;
  AgreementTemplateCountryConnectionWhere: AgreementTemplateCountryConnectionWhere;
  AgreementTemplateCountryCountryAggregationSelection: AgreementTemplateCountryCountryAggregationSelection;
  AgreementTemplateCountryCountryNodeAggregateSelection: AgreementTemplateCountryCountryNodeAggregateSelection;
  AgreementTemplateCountryNodeAggregationWhereInput: AgreementTemplateCountryNodeAggregationWhereInput;
  AgreementTemplateCountryRelationship: AgreementTemplateCountryRelationship;
  AgreementTemplateCurrencyAggregateInput: AgreementTemplateCurrencyAggregateInput;
  AgreementTemplateCurrencyConnection: AgreementTemplateCurrencyConnection;
  AgreementTemplateCurrencyConnectionSort: AgreementTemplateCurrencyConnectionSort;
  AgreementTemplateCurrencyConnectionWhere: AgreementTemplateCurrencyConnectionWhere;
  AgreementTemplateCurrencyCurrencyAggregationSelection: AgreementTemplateCurrencyCurrencyAggregationSelection;
  AgreementTemplateCurrencyCurrencyNodeAggregateSelection: AgreementTemplateCurrencyCurrencyNodeAggregateSelection;
  AgreementTemplateCurrencyNodeAggregationWhereInput: AgreementTemplateCurrencyNodeAggregationWhereInput;
  AgreementTemplateCurrencyRelationship: AgreementTemplateCurrencyRelationship;
  AgreementTemplateCycleConfigurationCyclesAggregationSelection: AgreementTemplateCycleConfigurationCyclesAggregationSelection;
  AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection: AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection;
  AgreementTemplateCyclesAggregateInput: AgreementTemplateCyclesAggregateInput;
  AgreementTemplateCyclesConnection: AgreementTemplateCyclesConnection;
  AgreementTemplateCyclesConnectionSort: AgreementTemplateCyclesConnectionSort;
  AgreementTemplateCyclesConnectionWhere: AgreementTemplateCyclesConnectionWhere;
  AgreementTemplateCyclesNodeAggregationWhereInput: AgreementTemplateCyclesNodeAggregationWhereInput;
  AgreementTemplateCyclesRelationship: AgreementTemplateCyclesRelationship;
  AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection: AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection;
  AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection: AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection;
  AgreementTemplateDeviceAlternativeSetsAggregateInput: AgreementTemplateDeviceAlternativeSetsAggregateInput;
  AgreementTemplateDeviceAlternativeSetsConnection: AgreementTemplateDeviceAlternativeSetsConnection;
  AgreementTemplateDeviceAlternativeSetsConnectionSort: AgreementTemplateDeviceAlternativeSetsConnectionSort;
  AgreementTemplateDeviceAlternativeSetsConnectionWhere: AgreementTemplateDeviceAlternativeSetsConnectionWhere;
  AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput: AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput;
  AgreementTemplateDeviceAlternativeSetsRelationship: AgreementTemplateDeviceAlternativeSetsRelationship;
  AgreementTemplateDotThresholdsAggregateInput: AgreementTemplateDotThresholdsAggregateInput;
  AgreementTemplateDotThresholdsConnection: AgreementTemplateDotThresholdsConnection;
  AgreementTemplateDotThresholdsConnectionSort: AgreementTemplateDotThresholdsConnectionSort;
  AgreementTemplateDotThresholdsConnectionWhere: AgreementTemplateDotThresholdsConnectionWhere;
  AgreementTemplateDotThresholdsEdgeAggregationWhereInput: AgreementTemplateDotThresholdsEdgeAggregationWhereInput;
  AgreementTemplateDotThresholdsRelationship: AgreementTemplateDotThresholdsRelationship;
  AgreementTemplateEdge: AgreementTemplateEdge;
  AgreementTemplateEligibilityConditionRelationship: ResolversInterfaceTypes<ResolversParentTypes>['AgreementTemplateEligibilityConditionRelationship'];
  AgreementTemplateEligibilityConditionRelationshipSort: AgreementTemplateEligibilityConditionRelationshipSort;
  AgreementTemplateEligibilityConditionRelationshipWhere: AgreementTemplateEligibilityConditionRelationshipWhere;
  AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection: AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection;
  AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection: AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection;
  AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection: AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection;
  AgreementTemplateEligibilityConditionSetsAggregateInput: AgreementTemplateEligibilityConditionSetsAggregateInput;
  AgreementTemplateEligibilityConditionSetsConnection: AgreementTemplateEligibilityConditionSetsConnection;
  AgreementTemplateEligibilityConditionSetsConnectionSort: AgreementTemplateEligibilityConditionSetsConnectionSort;
  AgreementTemplateEligibilityConditionSetsConnectionWhere: AgreementTemplateEligibilityConditionSetsConnectionWhere;
  AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput: AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput;
  AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput: AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput;
  AgreementTemplateEligibilityConditionSetsRelationship: AgreementTemplateEligibilityConditionSetsRelationship;
  AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection: AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection;
  AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection: AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection;
  AgreementTemplateEnrollingConditionSetsAggregateInput: AgreementTemplateEnrollingConditionSetsAggregateInput;
  AgreementTemplateEnrollingConditionSetsConnection: AgreementTemplateEnrollingConditionSetsConnection;
  AgreementTemplateEnrollingConditionSetsConnectionSort: AgreementTemplateEnrollingConditionSetsConnectionSort;
  AgreementTemplateEnrollingConditionSetsConnectionWhere: AgreementTemplateEnrollingConditionSetsConnectionWhere;
  AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput: AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput;
  AgreementTemplateEnrollingConditionSetsRelationship: AgreementTemplateEnrollingConditionSetsRelationship;
  AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection: AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection;
  AgreementTemplateEnrollingPeriodsAggregateInput: AgreementTemplateEnrollingPeriodsAggregateInput;
  AgreementTemplateEnrollingPeriodsConnection: AgreementTemplateEnrollingPeriodsConnection;
  AgreementTemplateEnrollingPeriodsConnectionSort: AgreementTemplateEnrollingPeriodsConnectionSort;
  AgreementTemplateEnrollingPeriodsConnectionWhere: AgreementTemplateEnrollingPeriodsConnectionWhere;
  AgreementTemplateEnrollingPeriodsRelationship: AgreementTemplateEnrollingPeriodsRelationship;
  AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection: AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection;
  AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection: AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection;
  AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection: AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection;
  AgreementTemplateFinancialSummaryConfigAggregateInput: AgreementTemplateFinancialSummaryConfigAggregateInput;
  AgreementTemplateFinancialSummaryConfigConnection: AgreementTemplateFinancialSummaryConfigConnection;
  AgreementTemplateFinancialSummaryConfigConnectionSort: AgreementTemplateFinancialSummaryConfigConnectionSort;
  AgreementTemplateFinancialSummaryConfigConnectionWhere: AgreementTemplateFinancialSummaryConfigConnectionWhere;
  AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput: AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput;
  AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput: AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput;
  AgreementTemplateFinancialSummaryConfigRelationship: AgreementTemplateFinancialSummaryConfigRelationship;
  AgreementTemplateInitialVersionAggregateInput: AgreementTemplateInitialVersionAggregateInput;
  AgreementTemplateInitialVersionConnection: AgreementTemplateInitialVersionConnection;
  AgreementTemplateInitialVersionConnectionSort: AgreementTemplateInitialVersionConnectionSort;
  AgreementTemplateInitialVersionConnectionWhere: AgreementTemplateInitialVersionConnectionWhere;
  AgreementTemplateInitialVersionNodeAggregationWhereInput: AgreementTemplateInitialVersionNodeAggregationWhereInput;
  AgreementTemplateInitialVersionRelationship: AgreementTemplateInitialVersionRelationship;
  AgreementTemplateInput: AgreementTemplateInput;
  AgreementTemplateLimitationAggregateInput: AgreementTemplateLimitationAggregateInput;
  AgreementTemplateLimitationConnection: AgreementTemplateLimitationConnection;
  AgreementTemplateLimitationConnectionSort: AgreementTemplateLimitationConnectionSort;
  AgreementTemplateLimitationConnectionWhere: AgreementTemplateLimitationConnectionWhere;
  AgreementTemplateLimitationLimitationAggregationSelection: AgreementTemplateLimitationLimitationAggregationSelection;
  AgreementTemplateLimitationLimitationNodeAggregateSelection: AgreementTemplateLimitationLimitationNodeAggregateSelection;
  AgreementTemplateLimitationNodeAggregationWhereInput: AgreementTemplateLimitationNodeAggregationWhereInput;
  AgreementTemplateLimitationRelationship: AgreementTemplateLimitationRelationship;
  AgreementTemplateNegotiableAttributesAggregateInput: AgreementTemplateNegotiableAttributesAggregateInput;
  AgreementTemplateNegotiableAttributesConnection: AgreementTemplateNegotiableAttributesConnection;
  AgreementTemplateNegotiableAttributesConnectionSort: AgreementTemplateNegotiableAttributesConnectionSort;
  AgreementTemplateNegotiableAttributesConnectionWhere: AgreementTemplateNegotiableAttributesConnectionWhere;
  AgreementTemplateNegotiableAttributesNodeAggregationWhereInput: AgreementTemplateNegotiableAttributesNodeAggregationWhereInput;
  AgreementTemplateNegotiableAttributesRelationship: AgreementTemplateNegotiableAttributesRelationship;
  AgreementTemplateNextVersionsAggregateInput: AgreementTemplateNextVersionsAggregateInput;
  AgreementTemplateNextVersionsConnection: AgreementTemplateNextVersionsConnection;
  AgreementTemplateNextVersionsConnectionSort: AgreementTemplateNextVersionsConnectionSort;
  AgreementTemplateNextVersionsConnectionWhere: AgreementTemplateNextVersionsConnectionWhere;
  AgreementTemplateNextVersionsNodeAggregationWhereInput: AgreementTemplateNextVersionsNodeAggregationWhereInput;
  AgreementTemplateNextVersionsRelationship: AgreementTemplateNextVersionsRelationship;
  AgreementTemplateNodeAggregationWhereInput: AgreementTemplateNodeAggregationWhereInput;
  AgreementTemplateOptions: AgreementTemplateOptions;
  AgreementTemplateRangeChartConfigAggregateInput: AgreementTemplateRangeChartConfigAggregateInput;
  AgreementTemplateRangeChartConfigConnection: AgreementTemplateRangeChartConfigConnection;
  AgreementTemplateRangeChartConfigConnectionSort: AgreementTemplateRangeChartConfigConnectionSort;
  AgreementTemplateRangeChartConfigConnectionWhere: AgreementTemplateRangeChartConfigConnectionWhere;
  AgreementTemplateRangeChartConfigEdgeAggregationWhereInput: AgreementTemplateRangeChartConfigEdgeAggregationWhereInput;
  AgreementTemplateRangeChartConfigRelationship: AgreementTemplateRangeChartConfigRelationship;
  AgreementTemplateRelationship: AgreementTemplateRelationship;
  AgreementTemplateScenarioScenariosAggregationSelection: AgreementTemplateScenarioScenariosAggregationSelection;
  AgreementTemplateScenarioScenariosNodeAggregateSelection: AgreementTemplateScenarioScenariosNodeAggregateSelection;
  AgreementTemplateScenariosAggregateInput: AgreementTemplateScenariosAggregateInput;
  AgreementTemplateScenariosConnection: AgreementTemplateScenariosConnection;
  AgreementTemplateScenariosConnectionSort: AgreementTemplateScenariosConnectionSort;
  AgreementTemplateScenariosConnectionWhere: AgreementTemplateScenariosConnectionWhere;
  AgreementTemplateScenariosNodeAggregationWhereInput: AgreementTemplateScenariosNodeAggregationWhereInput;
  AgreementTemplateScenariosRelationship: AgreementTemplateScenariosRelationship;
  AgreementTemplateScenariosRelevantBrandsAggregateInput: AgreementTemplateScenariosRelevantBrandsAggregateInput;
  AgreementTemplateScenariosRelevantBrandsConnection: AgreementTemplateScenariosRelevantBrandsConnection;
  AgreementTemplateScenariosRelevantBrandsConnectionSort: AgreementTemplateScenariosRelevantBrandsConnectionSort;
  AgreementTemplateScenariosRelevantBrandsConnectionWhere: AgreementTemplateScenariosRelevantBrandsConnectionWhere;
  AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput: AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput;
  AgreementTemplateScenariosRelevantBrandsRelationship: AgreementTemplateScenariosRelevantBrandsRelationship;
  AgreementTemplateSort: AgreementTemplateSort;
  AgreementTemplateTagsAggregateInput: AgreementTemplateTagsAggregateInput;
  AgreementTemplateTagsConnection: AgreementTemplateTagsConnection;
  AgreementTemplateTagsConnectionSort: AgreementTemplateTagsConnectionSort;
  AgreementTemplateTagsConnectionWhere: AgreementTemplateTagsConnectionWhere;
  AgreementTemplateTagsNodeAggregationWhereInput: AgreementTemplateTagsNodeAggregationWhereInput;
  AgreementTemplateTagsRelationship: AgreementTemplateTagsRelationship;
  AgreementTemplateTreatmentPriceRelationship: ResolversInterfaceTypes<ResolversParentTypes>['AgreementTemplateTreatmentPriceRelationship'];
  AgreementTemplateTreatmentPriceRelationshipSort: AgreementTemplateTreatmentPriceRelationshipSort;
  AgreementTemplateTreatmentPriceRelationshipWhere: AgreementTemplateTreatmentPriceRelationshipWhere;
  AgreementTemplateTreatmentPricesAggregateInput: AgreementTemplateTreatmentPricesAggregateInput;
  AgreementTemplateTreatmentPricesConnection: AgreementTemplateTreatmentPricesConnection;
  AgreementTemplateTreatmentPricesConnectionSort: AgreementTemplateTreatmentPricesConnectionSort;
  AgreementTemplateTreatmentPricesConnectionWhere: AgreementTemplateTreatmentPricesConnectionWhere;
  AgreementTemplateTreatmentPricesEdgeAggregationWhereInput: AgreementTemplateTreatmentPricesEdgeAggregationWhereInput;
  AgreementTemplateTreatmentPricesNodeAggregationWhereInput: AgreementTemplateTreatmentPricesNodeAggregationWhereInput;
  AgreementTemplateTreatmentPricesRelationship: AgreementTemplateTreatmentPricesRelationship;
  AgreementTemplateTreatmentTreatmentPricesAggregationSelection: AgreementTemplateTreatmentTreatmentPricesAggregationSelection;
  AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection: AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection;
  AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection: AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection;
  AgreementTemplateUserAddedByAggregationSelection: AgreementTemplateUserAddedByAggregationSelection;
  AgreementTemplateUserAddedByNodeAggregateSelection: AgreementTemplateUserAddedByNodeAggregateSelection;
  AgreementTemplateVersionCreationResponse: AgreementTemplateVersionCreationResponse;
  AgreementTemplateVersionCreationResponseEdge: AgreementTemplateVersionCreationResponseEdge;
  AgreementTemplateVersionCreationResponseOptions: AgreementTemplateVersionCreationResponseOptions;
  AgreementTemplateVersionCreationResponseSort: AgreementTemplateVersionCreationResponseSort;
  AgreementTemplateVersionCreationResponseWhere: AgreementTemplateVersionCreationResponseWhere;
  AgreementTemplateVersionCreationResponsesConnection: AgreementTemplateVersionCreationResponsesConnection;
  AgreementTemplateWhere: AgreementTemplateWhere;
  AgreementTemplatesConnection: AgreementTemplatesConnection;
  AgreementTreatmentPriceRelationship: ResolversInterfaceTypes<ResolversParentTypes>['AgreementTreatmentPriceRelationship'];
  AgreementTreatmentPriceRelationshipSort: AgreementTreatmentPriceRelationshipSort;
  AgreementTreatmentPriceRelationshipWhere: AgreementTreatmentPriceRelationshipWhere;
  AgreementTreatmentPricesAggregateInput: AgreementTreatmentPricesAggregateInput;
  AgreementTreatmentPricesConnection: AgreementTreatmentPricesConnection;
  AgreementTreatmentPricesConnectionSort: AgreementTreatmentPricesConnectionSort;
  AgreementTreatmentPricesConnectionWhere: AgreementTreatmentPricesConnectionWhere;
  AgreementTreatmentPricesEdgeAggregationWhereInput: AgreementTreatmentPricesEdgeAggregationWhereInput;
  AgreementTreatmentPricesNodeAggregationWhereInput: AgreementTreatmentPricesNodeAggregationWhereInput;
  AgreementTreatmentPricesRelationship: AgreementTreatmentPricesRelationship;
  AgreementTreatmentTreatmentPricesAggregationSelection: AgreementTreatmentTreatmentPricesAggregationSelection;
  AgreementTreatmentTreatmentPricesEdgeAggregateSelection: AgreementTreatmentTreatmentPricesEdgeAggregateSelection;
  AgreementTreatmentTreatmentPricesNodeAggregateSelection: AgreementTreatmentTreatmentPricesNodeAggregateSelection;
  AgreementUserAddedByAggregationSelection: AgreementUserAddedByAggregationSelection;
  AgreementUserAddedByNodeAggregateSelection: AgreementUserAddedByNodeAggregateSelection;
  AgreementUserPushedByAggregationSelection: AgreementUserPushedByAggregationSelection;
  AgreementUserPushedByNodeAggregateSelection: AgreementUserPushedByNodeAggregateSelection;
  AgreementUserRoleInput: AgreementUserRoleInput;
  AgreementUserRoleRelationship: ResolversInterfaceTypes<ResolversParentTypes>['AgreementUserRoleRelationship'];
  AgreementUserRoleRelationshipSort: AgreementUserRoleRelationshipSort;
  AgreementUserRoleRelationshipWhere: AgreementUserRoleRelationshipWhere;
  AgreementUserRolesAggregateInput: AgreementUserRolesAggregateInput;
  AgreementUserRolesConnection: AgreementUserRolesConnection;
  AgreementUserRolesConnectionSort: AgreementUserRolesConnectionSort;
  AgreementUserRolesConnectionWhere: AgreementUserRolesConnectionWhere;
  AgreementUserRolesNodeAggregationWhereInput: AgreementUserRolesNodeAggregationWhereInput;
  AgreementUserRolesRelationship: AgreementUserRolesRelationship;
  AgreementUserUserRolesAggregationSelection: AgreementUserUserRolesAggregationSelection;
  AgreementUserUserRolesNodeAggregateSelection: AgreementUserUserRolesNodeAggregateSelection;
  AgreementWhere: AgreementWhere;
  AgreementsConnection: AgreementsConnection;
  Alert: Alert;
  AlertCheckAggregateInput: AlertCheckAggregateInput;
  AlertCheckConnection: AlertCheckConnection;
  AlertCheckConnectionSort: AlertCheckConnectionSort;
  AlertCheckConnectionWhere: AlertCheckConnectionWhere;
  AlertCheckNodeAggregationWhereInput: AlertCheckNodeAggregationWhereInput;
  AlertCheckRelationship: AlertCheckRelationship;
  AlertEdge: AlertEdge;
  AlertOptions: AlertOptions;
  AlertRunCheckCheckAggregationSelection: AlertRunCheckCheckAggregationSelection;
  AlertRunCheckCheckNodeAggregateSelection: AlertRunCheckCheckNodeAggregateSelection;
  AlertSort: AlertSort;
  AlertWhere: AlertWhere;
  AlertsConnection: AlertsConnection;
  ApplyUserRolesToAllInput: ApplyUserRolesToAllInput;
  Art71MasterDataImpacts: Art71MasterDataImpacts;
  Art71MasterDataImpactsConnection: Art71MasterDataImpactsConnection;
  Art71MasterDataImpactsEdge: Art71MasterDataImpactsEdge;
  Art71MasterDataImpactsInput: Art71MasterDataImpactsInput;
  Art71MasterDataImpactsOptions: Art71MasterDataImpactsOptions;
  Art71MasterDataImpactsSort: Art71MasterDataImpactsSort;
  Art71MasterDataImpactsWhere: Art71MasterDataImpactsWhere;
  Article71Indication: Article71Indication;
  Article71IndicationAgreementScopeAggregateInput: Article71IndicationAgreementScopeAggregateInput;
  Article71IndicationAgreementScopeAgreementScopeAggregationSelection: Article71IndicationAgreementScopeAgreementScopeAggregationSelection;
  Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection: Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection;
  Article71IndicationAgreementScopeConnection: Article71IndicationAgreementScopeConnection;
  Article71IndicationAgreementScopeConnectionSort: Article71IndicationAgreementScopeConnectionSort;
  Article71IndicationAgreementScopeConnectionWhere: Article71IndicationAgreementScopeConnectionWhere;
  Article71IndicationAgreementScopeNodeAggregationWhereInput: Article71IndicationAgreementScopeNodeAggregationWhereInput;
  Article71IndicationAgreementScopeRelationship: Article71IndicationAgreementScopeRelationship;
  Article71IndicationAgreementTemplateAggregateInput: Article71IndicationAgreementTemplateAggregateInput;
  Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection: Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection;
  Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection: Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection;
  Article71IndicationAgreementTemplateConnection: Article71IndicationAgreementTemplateConnection;
  Article71IndicationAgreementTemplateConnectionSort: Article71IndicationAgreementTemplateConnectionSort;
  Article71IndicationAgreementTemplateConnectionWhere: Article71IndicationAgreementTemplateConnectionWhere;
  Article71IndicationAgreementTemplateNodeAggregationWhereInput: Article71IndicationAgreementTemplateNodeAggregationWhereInput;
  Article71IndicationAgreementTemplateRelationship: Article71IndicationAgreementTemplateRelationship;
  Article71IndicationBrandAggregateInput: Article71IndicationBrandAggregateInput;
  Article71IndicationBrandBrandAggregationSelection: Article71IndicationBrandBrandAggregationSelection;
  Article71IndicationBrandBrandNodeAggregateSelection: Article71IndicationBrandBrandNodeAggregateSelection;
  Article71IndicationBrandConnection: Article71IndicationBrandConnection;
  Article71IndicationBrandConnectionSort: Article71IndicationBrandConnectionSort;
  Article71IndicationBrandConnectionWhere: Article71IndicationBrandConnectionWhere;
  Article71IndicationBrandNodeAggregationWhereInput: Article71IndicationBrandNodeAggregationWhereInput;
  Article71IndicationBrandRelationship: Article71IndicationBrandRelationship;
  Article71IndicationCaseCasesAggregationSelection: Article71IndicationCaseCasesAggregationSelection;
  Article71IndicationCaseCasesNodeAggregateSelection: Article71IndicationCaseCasesNodeAggregateSelection;
  Article71IndicationCasesAggregateInput: Article71IndicationCasesAggregateInput;
  Article71IndicationCasesConnection: Article71IndicationCasesConnection;
  Article71IndicationCasesConnectionSort: Article71IndicationCasesConnectionSort;
  Article71IndicationCasesConnectionWhere: Article71IndicationCasesConnectionWhere;
  Article71IndicationCasesNodeAggregationWhereInput: Article71IndicationCasesNodeAggregationWhereInput;
  Article71IndicationCasesRelationship: Article71IndicationCasesRelationship;
  Article71IndicationEdge: Article71IndicationEdge;
  Article71IndicationInput: Article71IndicationInput;
  Article71IndicationMainIndicationAggregateInput: Article71IndicationMainIndicationAggregateInput;
  Article71IndicationMainIndicationConnection: Article71IndicationMainIndicationConnection;
  Article71IndicationMainIndicationConnectionSort: Article71IndicationMainIndicationConnectionSort;
  Article71IndicationMainIndicationConnectionWhere: Article71IndicationMainIndicationConnectionWhere;
  Article71IndicationMainIndicationMainIndicationAggregationSelection: Article71IndicationMainIndicationMainIndicationAggregationSelection;
  Article71IndicationMainIndicationMainIndicationNodeAggregateSelection: Article71IndicationMainIndicationMainIndicationNodeAggregateSelection;
  Article71IndicationMainIndicationNodeAggregationWhereInput: Article71IndicationMainIndicationNodeAggregationWhereInput;
  Article71IndicationMainIndicationRelationship: Article71IndicationMainIndicationRelationship;
  Article71IndicationOptions: Article71IndicationOptions;
  Article71IndicationSort: Article71IndicationSort;
  Article71IndicationWhere: Article71IndicationWhere;
  Article71IndicationsConnection: Article71IndicationsConnection;
  AuthOrganization: AuthOrganization;
  AuthOrganizationEdge: AuthOrganizationEdge;
  AuthOrganizationOptions: AuthOrganizationOptions;
  AuthOrganizationSort: AuthOrganizationSort;
  AuthOrganizationWhere: AuthOrganizationWhere;
  AuthOrganizationsConnection: AuthOrganizationsConnection;
  AvailableTranslations: AvailableTranslations;
  AvailableTranslationsConnection: AvailableTranslationsConnection;
  AvailableTranslationsEdge: AvailableTranslationsEdge;
  AvailableTranslationsOptions: AvailableTranslationsOptions;
  AvailableTranslationsSort: AvailableTranslationsSort;
  AvailableTranslationsWhere: AvailableTranslationsWhere;
  AverageGenericPrice: AverageGenericPrice;
  AverageGenericPriceEdge: AverageGenericPriceEdge;
  AverageGenericPriceOptions: AverageGenericPriceOptions;
  AverageGenericPriceSort: AverageGenericPriceSort;
  AverageGenericPriceWhere: AverageGenericPriceWhere;
  AverageGenericPricesConnection: AverageGenericPricesConnection;
  BaseAgreement: BaseAgreement;
  BaseAgreementAddedByAggregateInput: BaseAgreementAddedByAggregateInput;
  BaseAgreementAddedByConnection: BaseAgreementAddedByConnection;
  BaseAgreementAddedByConnectionSort: BaseAgreementAddedByConnectionSort;
  BaseAgreementAddedByConnectionWhere: BaseAgreementAddedByConnectionWhere;
  BaseAgreementAddedByNodeAggregationWhereInput: BaseAgreementAddedByNodeAggregationWhereInput;
  BaseAgreementAddedByRelationship: BaseAgreementAddedByRelationship;
  BaseAgreementAgreementDecisionDecisionsAggregationSelection: BaseAgreementAgreementDecisionDecisionsAggregationSelection;
  BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection: BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection;
  BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection: BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection;
  BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection: BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection;
  BaseAgreementAgreementTagTagsAggregationSelection: BaseAgreementAgreementTagTagsAggregationSelection;
  BaseAgreementAgreementTagTagsNodeAggregateSelection: BaseAgreementAgreementTagTagsNodeAggregateSelection;
  BaseAgreementAgreementTemplateTemplateAggregationSelection: BaseAgreementAgreementTemplateTemplateAggregationSelection;
  BaseAgreementAgreementTemplateTemplateNodeAggregateSelection: BaseAgreementAgreementTemplateTemplateNodeAggregateSelection;
  BaseAgreementBaseAgreementInitialVersionAggregationSelection: BaseAgreementBaseAgreementInitialVersionAggregationSelection;
  BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection: BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection;
  BaseAgreementBaseAgreementNextVersionsAggregationSelection: BaseAgreementBaseAgreementNextVersionsAggregationSelection;
  BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection: BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection;
  BaseAgreementBrandScenariosRelevantBrandsAggregationSelection: BaseAgreementBrandScenariosRelevantBrandsAggregationSelection;
  BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection: BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection;
  BaseAgreementCaseCasesAggregationSelection: BaseAgreementCaseCasesAggregationSelection;
  BaseAgreementCaseCasesNodeAggregateSelection: BaseAgreementCaseCasesNodeAggregateSelection;
  BaseAgreementCasesAggregateInput: BaseAgreementCasesAggregateInput;
  BaseAgreementCasesConnection: BaseAgreementCasesConnection;
  BaseAgreementCasesConnectionSort: BaseAgreementCasesConnectionSort;
  BaseAgreementCasesConnectionWhere: BaseAgreementCasesConnectionWhere;
  BaseAgreementCasesNodeAggregationWhereInput: BaseAgreementCasesNodeAggregationWhereInput;
  BaseAgreementCasesRelationship: BaseAgreementCasesRelationship;
  BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection: BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection;
  BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection: BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection;
  BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection: BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection;
  BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection: BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection;
  BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection: BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection;
  BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection: BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection;
  BaseAgreementCounterpartiesAggregateInput: BaseAgreementCounterpartiesAggregateInput;
  BaseAgreementCounterpartiesConnection: BaseAgreementCounterpartiesConnection;
  BaseAgreementCounterpartiesConnectionSort: BaseAgreementCounterpartiesConnectionSort;
  BaseAgreementCounterpartiesConnectionWhere: BaseAgreementCounterpartiesConnectionWhere;
  BaseAgreementCounterpartiesNodeAggregationWhereInput: BaseAgreementCounterpartiesNodeAggregationWhereInput;
  BaseAgreementCounterpartiesRelationship: BaseAgreementCounterpartiesRelationship;
  BaseAgreementCounterpartyRelationship: ResolversInterfaceTypes<ResolversParentTypes>['BaseAgreementCounterpartyRelationship'];
  BaseAgreementCounterpartyRelationshipSort: BaseAgreementCounterpartyRelationshipSort;
  BaseAgreementCounterpartyRelationshipWhere: BaseAgreementCounterpartyRelationshipWhere;
  BaseAgreementCountryAggregateInput: BaseAgreementCountryAggregateInput;
  BaseAgreementCountryConnection: BaseAgreementCountryConnection;
  BaseAgreementCountryConnectionSort: BaseAgreementCountryConnectionSort;
  BaseAgreementCountryConnectionWhere: BaseAgreementCountryConnectionWhere;
  BaseAgreementCountryCountryAggregationSelection: BaseAgreementCountryCountryAggregationSelection;
  BaseAgreementCountryCountryNodeAggregateSelection: BaseAgreementCountryCountryNodeAggregateSelection;
  BaseAgreementCountryNodeAggregationWhereInput: BaseAgreementCountryNodeAggregationWhereInput;
  BaseAgreementCountryRelationship: BaseAgreementCountryRelationship;
  BaseAgreementCurrencyAggregateInput: BaseAgreementCurrencyAggregateInput;
  BaseAgreementCurrencyConnection: BaseAgreementCurrencyConnection;
  BaseAgreementCurrencyConnectionSort: BaseAgreementCurrencyConnectionSort;
  BaseAgreementCurrencyConnectionWhere: BaseAgreementCurrencyConnectionWhere;
  BaseAgreementCurrencyCurrencyAggregationSelection: BaseAgreementCurrencyCurrencyAggregationSelection;
  BaseAgreementCurrencyCurrencyNodeAggregateSelection: BaseAgreementCurrencyCurrencyNodeAggregateSelection;
  BaseAgreementCurrencyNodeAggregationWhereInput: BaseAgreementCurrencyNodeAggregationWhereInput;
  BaseAgreementCurrencyRelationship: BaseAgreementCurrencyRelationship;
  BaseAgreementCycleConfigurationCyclesAggregationSelection: BaseAgreementCycleConfigurationCyclesAggregationSelection;
  BaseAgreementCycleConfigurationCyclesNodeAggregateSelection: BaseAgreementCycleConfigurationCyclesNodeAggregateSelection;
  BaseAgreementCyclesAggregateInput: BaseAgreementCyclesAggregateInput;
  BaseAgreementCyclesConnection: BaseAgreementCyclesConnection;
  BaseAgreementCyclesConnectionSort: BaseAgreementCyclesConnectionSort;
  BaseAgreementCyclesConnectionWhere: BaseAgreementCyclesConnectionWhere;
  BaseAgreementCyclesNodeAggregationWhereInput: BaseAgreementCyclesNodeAggregationWhereInput;
  BaseAgreementCyclesRelationship: BaseAgreementCyclesRelationship;
  BaseAgreementDataContainerDataContainersAggregationSelection: BaseAgreementDataContainerDataContainersAggregationSelection;
  BaseAgreementDataContainerDataContainersNodeAggregateSelection: BaseAgreementDataContainerDataContainersNodeAggregateSelection;
  BaseAgreementDataContainersAggregateInput: BaseAgreementDataContainersAggregateInput;
  BaseAgreementDataContainersConnection: BaseAgreementDataContainersConnection;
  BaseAgreementDataContainersConnectionSort: BaseAgreementDataContainersConnectionSort;
  BaseAgreementDataContainersConnectionWhere: BaseAgreementDataContainersConnectionWhere;
  BaseAgreementDataContainersNodeAggregationWhereInput: BaseAgreementDataContainersNodeAggregationWhereInput;
  BaseAgreementDataContainersRelationship: BaseAgreementDataContainersRelationship;
  BaseAgreementDataSourceAggregateInput: BaseAgreementDataSourceAggregateInput;
  BaseAgreementDataSourceConnection: BaseAgreementDataSourceConnection;
  BaseAgreementDataSourceConnectionSort: BaseAgreementDataSourceConnectionSort;
  BaseAgreementDataSourceConnectionWhere: BaseAgreementDataSourceConnectionWhere;
  BaseAgreementDataSourceDataSourceAggregationSelection: BaseAgreementDataSourceDataSourceAggregationSelection;
  BaseAgreementDataSourceDataSourceNodeAggregateSelection: BaseAgreementDataSourceDataSourceNodeAggregateSelection;
  BaseAgreementDataSourceNodeAggregationWhereInput: BaseAgreementDataSourceNodeAggregationWhereInput;
  BaseAgreementDataSourceRelationship: BaseAgreementDataSourceRelationship;
  BaseAgreementDecisionsAggregateInput: BaseAgreementDecisionsAggregateInput;
  BaseAgreementDecisionsConnection: BaseAgreementDecisionsConnection;
  BaseAgreementDecisionsConnectionSort: BaseAgreementDecisionsConnectionSort;
  BaseAgreementDecisionsConnectionWhere: BaseAgreementDecisionsConnectionWhere;
  BaseAgreementDecisionsNodeAggregationWhereInput: BaseAgreementDecisionsNodeAggregationWhereInput;
  BaseAgreementDecisionsRelationship: BaseAgreementDecisionsRelationship;
  BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection: BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection;
  BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection: BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection;
  BaseAgreementDeviceAlternativeSetsAggregateInput: BaseAgreementDeviceAlternativeSetsAggregateInput;
  BaseAgreementDeviceAlternativeSetsConnection: BaseAgreementDeviceAlternativeSetsConnection;
  BaseAgreementDeviceAlternativeSetsConnectionSort: BaseAgreementDeviceAlternativeSetsConnectionSort;
  BaseAgreementDeviceAlternativeSetsConnectionWhere: BaseAgreementDeviceAlternativeSetsConnectionWhere;
  BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput: BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput;
  BaseAgreementDeviceAlternativeSetsRelationship: BaseAgreementDeviceAlternativeSetsRelationship;
  BaseAgreementDotThresholdsAggregateInput: BaseAgreementDotThresholdsAggregateInput;
  BaseAgreementDotThresholdsConnection: BaseAgreementDotThresholdsConnection;
  BaseAgreementDotThresholdsConnectionSort: BaseAgreementDotThresholdsConnectionSort;
  BaseAgreementDotThresholdsConnectionWhere: BaseAgreementDotThresholdsConnectionWhere;
  BaseAgreementDotThresholdsEdgeAggregationWhereInput: BaseAgreementDotThresholdsEdgeAggregationWhereInput;
  BaseAgreementDotThresholdsRelationship: BaseAgreementDotThresholdsRelationship;
  BaseAgreementEdge: BaseAgreementEdge;
  BaseAgreementEligibilityConditionRelationship: ResolversInterfaceTypes<ResolversParentTypes>['BaseAgreementEligibilityConditionRelationship'];
  BaseAgreementEligibilityConditionRelationshipSort: BaseAgreementEligibilityConditionRelationshipSort;
  BaseAgreementEligibilityConditionRelationshipWhere: BaseAgreementEligibilityConditionRelationshipWhere;
  BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection: BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection;
  BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection: BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection;
  BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection: BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection;
  BaseAgreementEligibilityConditionSetsAggregateInput: BaseAgreementEligibilityConditionSetsAggregateInput;
  BaseAgreementEligibilityConditionSetsConnection: BaseAgreementEligibilityConditionSetsConnection;
  BaseAgreementEligibilityConditionSetsConnectionSort: BaseAgreementEligibilityConditionSetsConnectionSort;
  BaseAgreementEligibilityConditionSetsConnectionWhere: BaseAgreementEligibilityConditionSetsConnectionWhere;
  BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput: BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput;
  BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput: BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput;
  BaseAgreementEligibilityConditionSetsRelationship: BaseAgreementEligibilityConditionSetsRelationship;
  BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection: BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection;
  BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection: BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection;
  BaseAgreementEnrollingConditionSetsAggregateInput: BaseAgreementEnrollingConditionSetsAggregateInput;
  BaseAgreementEnrollingConditionSetsConnection: BaseAgreementEnrollingConditionSetsConnection;
  BaseAgreementEnrollingConditionSetsConnectionSort: BaseAgreementEnrollingConditionSetsConnectionSort;
  BaseAgreementEnrollingConditionSetsConnectionWhere: BaseAgreementEnrollingConditionSetsConnectionWhere;
  BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput: BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput;
  BaseAgreementEnrollingConditionSetsRelationship: BaseAgreementEnrollingConditionSetsRelationship;
  BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection: BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection;
  BaseAgreementEnrollingPeriodsAggregateInput: BaseAgreementEnrollingPeriodsAggregateInput;
  BaseAgreementEnrollingPeriodsConnection: BaseAgreementEnrollingPeriodsConnection;
  BaseAgreementEnrollingPeriodsConnectionSort: BaseAgreementEnrollingPeriodsConnectionSort;
  BaseAgreementEnrollingPeriodsConnectionWhere: BaseAgreementEnrollingPeriodsConnectionWhere;
  BaseAgreementEnrollingPeriodsRelationship: BaseAgreementEnrollingPeriodsRelationship;
  BaseAgreementFinancialDataPointsAggregateInput: BaseAgreementFinancialDataPointsAggregateInput;
  BaseAgreementFinancialDataPointsConnection: BaseAgreementFinancialDataPointsConnection;
  BaseAgreementFinancialDataPointsConnectionSort: BaseAgreementFinancialDataPointsConnectionSort;
  BaseAgreementFinancialDataPointsConnectionWhere: BaseAgreementFinancialDataPointsConnectionWhere;
  BaseAgreementFinancialDataPointsNodeAggregationWhereInput: BaseAgreementFinancialDataPointsNodeAggregationWhereInput;
  BaseAgreementFinancialDataPointsRelationship: BaseAgreementFinancialDataPointsRelationship;
  BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection: BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection;
  BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection: BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection;
  BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection: BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection;
  BaseAgreementFinancialSummaryConfigAggregateInput: BaseAgreementFinancialSummaryConfigAggregateInput;
  BaseAgreementFinancialSummaryConfigConnection: BaseAgreementFinancialSummaryConfigConnection;
  BaseAgreementFinancialSummaryConfigConnectionSort: BaseAgreementFinancialSummaryConfigConnectionSort;
  BaseAgreementFinancialSummaryConfigConnectionWhere: BaseAgreementFinancialSummaryConfigConnectionWhere;
  BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput: BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput;
  BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput: BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput;
  BaseAgreementFinancialSummaryConfigRelationship: BaseAgreementFinancialSummaryConfigRelationship;
  BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection: BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection;
  BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection: BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection;
  BaseAgreementInitialVersionAggregateInput: BaseAgreementInitialVersionAggregateInput;
  BaseAgreementInitialVersionConnection: BaseAgreementInitialVersionConnection;
  BaseAgreementInitialVersionConnectionSort: BaseAgreementInitialVersionConnectionSort;
  BaseAgreementInitialVersionConnectionWhere: BaseAgreementInitialVersionConnectionWhere;
  BaseAgreementInitialVersionNodeAggregationWhereInput: BaseAgreementInitialVersionNodeAggregationWhereInput;
  BaseAgreementInitialVersionRelationship: BaseAgreementInitialVersionRelationship;
  BaseAgreementNegotiableAttributesAggregateInput: BaseAgreementNegotiableAttributesAggregateInput;
  BaseAgreementNegotiableAttributesConnection: BaseAgreementNegotiableAttributesConnection;
  BaseAgreementNegotiableAttributesConnectionSort: BaseAgreementNegotiableAttributesConnectionSort;
  BaseAgreementNegotiableAttributesConnectionWhere: BaseAgreementNegotiableAttributesConnectionWhere;
  BaseAgreementNegotiableAttributesNodeAggregationWhereInput: BaseAgreementNegotiableAttributesNodeAggregationWhereInput;
  BaseAgreementNegotiableAttributesRelationship: BaseAgreementNegotiableAttributesRelationship;
  BaseAgreementNextVersionsAggregateInput: BaseAgreementNextVersionsAggregateInput;
  BaseAgreementNextVersionsConnection: BaseAgreementNextVersionsConnection;
  BaseAgreementNextVersionsConnectionSort: BaseAgreementNextVersionsConnectionSort;
  BaseAgreementNextVersionsConnectionWhere: BaseAgreementNextVersionsConnectionWhere;
  BaseAgreementNextVersionsNodeAggregationWhereInput: BaseAgreementNextVersionsNodeAggregationWhereInput;
  BaseAgreementNextVersionsRelationship: BaseAgreementNextVersionsRelationship;
  BaseAgreementOptions: BaseAgreementOptions;
  BaseAgreementOrganizationCounterpartiesAggregationSelection: BaseAgreementOrganizationCounterpartiesAggregationSelection;
  BaseAgreementOrganizationCounterpartiesNodeAggregateSelection: BaseAgreementOrganizationCounterpartiesNodeAggregateSelection;
  BaseAgreementPushedByAggregateInput: BaseAgreementPushedByAggregateInput;
  BaseAgreementPushedByConnection: BaseAgreementPushedByConnection;
  BaseAgreementPushedByConnectionSort: BaseAgreementPushedByConnectionSort;
  BaseAgreementPushedByConnectionWhere: BaseAgreementPushedByConnectionWhere;
  BaseAgreementPushedByNodeAggregationWhereInput: BaseAgreementPushedByNodeAggregationWhereInput;
  BaseAgreementPushedByRelationship: BaseAgreementPushedByRelationship;
  BaseAgreementRangeChartConfigAggregateInput: BaseAgreementRangeChartConfigAggregateInput;
  BaseAgreementRangeChartConfigConnection: BaseAgreementRangeChartConfigConnection;
  BaseAgreementRangeChartConfigConnectionSort: BaseAgreementRangeChartConfigConnectionSort;
  BaseAgreementRangeChartConfigConnectionWhere: BaseAgreementRangeChartConfigConnectionWhere;
  BaseAgreementRangeChartConfigEdgeAggregationWhereInput: BaseAgreementRangeChartConfigEdgeAggregationWhereInput;
  BaseAgreementRangeChartConfigRelationship: BaseAgreementRangeChartConfigRelationship;
  BaseAgreementScenarioScenariosAggregationSelection: BaseAgreementScenarioScenariosAggregationSelection;
  BaseAgreementScenarioScenariosNodeAggregateSelection: BaseAgreementScenarioScenariosNodeAggregateSelection;
  BaseAgreementScenariosAggregateInput: BaseAgreementScenariosAggregateInput;
  BaseAgreementScenariosConnection: BaseAgreementScenariosConnection;
  BaseAgreementScenariosConnectionSort: BaseAgreementScenariosConnectionSort;
  BaseAgreementScenariosConnectionWhere: BaseAgreementScenariosConnectionWhere;
  BaseAgreementScenariosNodeAggregationWhereInput: BaseAgreementScenariosNodeAggregationWhereInput;
  BaseAgreementScenariosRelationship: BaseAgreementScenariosRelationship;
  BaseAgreementScenariosRelevantBrandsAggregateInput: BaseAgreementScenariosRelevantBrandsAggregateInput;
  BaseAgreementScenariosRelevantBrandsConnection: BaseAgreementScenariosRelevantBrandsConnection;
  BaseAgreementScenariosRelevantBrandsConnectionSort: BaseAgreementScenariosRelevantBrandsConnectionSort;
  BaseAgreementScenariosRelevantBrandsConnectionWhere: BaseAgreementScenariosRelevantBrandsConnectionWhere;
  BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput: BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput;
  BaseAgreementScenariosRelevantBrandsRelationship: BaseAgreementScenariosRelevantBrandsRelationship;
  BaseAgreementSort: BaseAgreementSort;
  BaseAgreementStatusTransitionsAggregateInput: BaseAgreementStatusTransitionsAggregateInput;
  BaseAgreementStatusTransitionsConnection: BaseAgreementStatusTransitionsConnection;
  BaseAgreementStatusTransitionsConnectionSort: BaseAgreementStatusTransitionsConnectionSort;
  BaseAgreementStatusTransitionsConnectionWhere: BaseAgreementStatusTransitionsConnectionWhere;
  BaseAgreementStatusTransitionsNodeAggregationWhereInput: BaseAgreementStatusTransitionsNodeAggregationWhereInput;
  BaseAgreementStatusTransitionsRelationship: BaseAgreementStatusTransitionsRelationship;
  BaseAgreementTagsAggregateInput: BaseAgreementTagsAggregateInput;
  BaseAgreementTagsConnection: BaseAgreementTagsConnection;
  BaseAgreementTagsConnectionSort: BaseAgreementTagsConnectionSort;
  BaseAgreementTagsConnectionWhere: BaseAgreementTagsConnectionWhere;
  BaseAgreementTagsNodeAggregationWhereInput: BaseAgreementTagsNodeAggregationWhereInput;
  BaseAgreementTagsRelationship: BaseAgreementTagsRelationship;
  BaseAgreementTemplateAggregateInput: BaseAgreementTemplateAggregateInput;
  BaseAgreementTemplateConnection: BaseAgreementTemplateConnection;
  BaseAgreementTemplateConnectionSort: BaseAgreementTemplateConnectionSort;
  BaseAgreementTemplateConnectionWhere: BaseAgreementTemplateConnectionWhere;
  BaseAgreementTemplateNodeAggregationWhereInput: BaseAgreementTemplateNodeAggregationWhereInput;
  BaseAgreementTemplateRelationship: BaseAgreementTemplateRelationship;
  BaseAgreementTreatmentPriceRelationship: ResolversInterfaceTypes<ResolversParentTypes>['BaseAgreementTreatmentPriceRelationship'];
  BaseAgreementTreatmentPriceRelationshipSort: BaseAgreementTreatmentPriceRelationshipSort;
  BaseAgreementTreatmentPriceRelationshipWhere: BaseAgreementTreatmentPriceRelationshipWhere;
  BaseAgreementTreatmentPricesAggregateInput: BaseAgreementTreatmentPricesAggregateInput;
  BaseAgreementTreatmentPricesConnection: BaseAgreementTreatmentPricesConnection;
  BaseAgreementTreatmentPricesConnectionSort: BaseAgreementTreatmentPricesConnectionSort;
  BaseAgreementTreatmentPricesConnectionWhere: BaseAgreementTreatmentPricesConnectionWhere;
  BaseAgreementTreatmentPricesEdgeAggregationWhereInput: BaseAgreementTreatmentPricesEdgeAggregationWhereInput;
  BaseAgreementTreatmentPricesNodeAggregationWhereInput: BaseAgreementTreatmentPricesNodeAggregationWhereInput;
  BaseAgreementTreatmentPricesRelationship: BaseAgreementTreatmentPricesRelationship;
  BaseAgreementTreatmentTreatmentPricesAggregationSelection: BaseAgreementTreatmentTreatmentPricesAggregationSelection;
  BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection: BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection;
  BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection: BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection;
  BaseAgreementUserAddedByAggregationSelection: BaseAgreementUserAddedByAggregationSelection;
  BaseAgreementUserAddedByNodeAggregateSelection: BaseAgreementUserAddedByNodeAggregateSelection;
  BaseAgreementUserContextUserContextsAggregationSelection: BaseAgreementUserContextUserContextsAggregationSelection;
  BaseAgreementUserContextUserContextsEdgeAggregateSelection: BaseAgreementUserContextUserContextsEdgeAggregateSelection;
  BaseAgreementUserContextUserContextsNodeAggregateSelection: BaseAgreementUserContextUserContextsNodeAggregateSelection;
  BaseAgreementUserContextsAggregateInput: BaseAgreementUserContextsAggregateInput;
  BaseAgreementUserContextsConnection: BaseAgreementUserContextsConnection;
  BaseAgreementUserContextsConnectionSort: BaseAgreementUserContextsConnectionSort;
  BaseAgreementUserContextsConnectionWhere: BaseAgreementUserContextsConnectionWhere;
  BaseAgreementUserContextsEdgeAggregationWhereInput: BaseAgreementUserContextsEdgeAggregationWhereInput;
  BaseAgreementUserContextsNodeAggregationWhereInput: BaseAgreementUserContextsNodeAggregationWhereInput;
  BaseAgreementUserContextsRelationship: BaseAgreementUserContextsRelationship;
  BaseAgreementUserPushedByAggregationSelection: BaseAgreementUserPushedByAggregationSelection;
  BaseAgreementUserPushedByNodeAggregateSelection: BaseAgreementUserPushedByNodeAggregateSelection;
  BaseAgreementUserRoleRelationship: ResolversInterfaceTypes<ResolversParentTypes>['BaseAgreementUserRoleRelationship'];
  BaseAgreementUserRoleRelationshipSort: BaseAgreementUserRoleRelationshipSort;
  BaseAgreementUserRoleRelationshipWhere: BaseAgreementUserRoleRelationshipWhere;
  BaseAgreementUserRolesAggregateInput: BaseAgreementUserRolesAggregateInput;
  BaseAgreementUserRolesConnection: BaseAgreementUserRolesConnection;
  BaseAgreementUserRolesConnectionSort: BaseAgreementUserRolesConnectionSort;
  BaseAgreementUserRolesConnectionWhere: BaseAgreementUserRolesConnectionWhere;
  BaseAgreementUserRolesNodeAggregationWhereInput: BaseAgreementUserRolesNodeAggregationWhereInput;
  BaseAgreementUserRolesRelationship: BaseAgreementUserRolesRelationship;
  BaseAgreementUserUserRolesAggregationSelection: BaseAgreementUserUserRolesAggregationSelection;
  BaseAgreementUserUserRolesNodeAggregateSelection: BaseAgreementUserUserRolesNodeAggregateSelection;
  BaseAgreementWhere: BaseAgreementWhere;
  BaseAgreementsConnection: BaseAgreementsConnection;
  Boolean: Scalars['Boolean']['output'];
  Brand: Brand;
  BrandAndGenericInput: BrandAndGenericInput;
  BrandArt71DataLastUpdatedByAggregateInput: BrandArt71DataLastUpdatedByAggregateInput;
  BrandArt71DataLastUpdatedByConnection: BrandArt71DataLastUpdatedByConnection;
  BrandArt71DataLastUpdatedByConnectionSort: BrandArt71DataLastUpdatedByConnectionSort;
  BrandArt71DataLastUpdatedByConnectionWhere: BrandArt71DataLastUpdatedByConnectionWhere;
  BrandArt71DataLastUpdatedByNodeAggregationWhereInput: BrandArt71DataLastUpdatedByNodeAggregationWhereInput;
  BrandArt71DataLastUpdatedByRelationship: BrandArt71DataLastUpdatedByRelationship;
  BrandArticle71IndicationArticle71IndicationsAggregationSelection: BrandArticle71IndicationArticle71IndicationsAggregationSelection;
  BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection: BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection;
  BrandArticle71IndicationsAggregateInput: BrandArticle71IndicationsAggregateInput;
  BrandArticle71IndicationsConnection: BrandArticle71IndicationsConnection;
  BrandArticle71IndicationsConnectionSort: BrandArticle71IndicationsConnectionSort;
  BrandArticle71IndicationsConnectionWhere: BrandArticle71IndicationsConnectionWhere;
  BrandArticle71IndicationsNodeAggregationWhereInput: BrandArticle71IndicationsNodeAggregationWhereInput;
  BrandArticle71IndicationsRelationship: BrandArticle71IndicationsRelationship;
  BrandEdge: BrandEdge;
  BrandInput: BrandInput;
  BrandMainIndicationMainIndicationsAggregationSelection: BrandMainIndicationMainIndicationsAggregationSelection;
  BrandMainIndicationMainIndicationsNodeAggregateSelection: BrandMainIndicationMainIndicationsNodeAggregateSelection;
  BrandMainIndicationsAggregateInput: BrandMainIndicationsAggregateInput;
  BrandMainIndicationsConnection: BrandMainIndicationsConnection;
  BrandMainIndicationsConnectionSort: BrandMainIndicationsConnectionSort;
  BrandMainIndicationsConnectionWhere: BrandMainIndicationsConnectionWhere;
  BrandMainIndicationsNodeAggregationWhereInput: BrandMainIndicationsNodeAggregationWhereInput;
  BrandMainIndicationsRelationship: BrandMainIndicationsRelationship;
  BrandOptions: BrandOptions;
  BrandPreparationPreparationsAggregationSelection: BrandPreparationPreparationsAggregationSelection;
  BrandPreparationPreparationsNodeAggregateSelection: BrandPreparationPreparationsNodeAggregateSelection;
  BrandPreparationsAggregateInput: BrandPreparationsAggregateInput;
  BrandPreparationsConnection: BrandPreparationsConnection;
  BrandPreparationsConnectionSort: BrandPreparationsConnectionSort;
  BrandPreparationsConnectionWhere: BrandPreparationsConnectionWhere;
  BrandPreparationsNodeAggregationWhereInput: BrandPreparationsNodeAggregationWhereInput;
  BrandPreparationsRelationship: BrandPreparationsRelationship;
  BrandSort: BrandSort;
  BrandUserArt71DataLastUpdatedByAggregationSelection: BrandUserArt71DataLastUpdatedByAggregationSelection;
  BrandUserArt71DataLastUpdatedByNodeAggregateSelection: BrandUserArt71DataLastUpdatedByNodeAggregateSelection;
  BrandWhere: BrandWhere;
  BrandsConnection: BrandsConnection;
  CachedAgreementListItem: CachedAgreementListItem;
  CachedAgreementListItemEdge: CachedAgreementListItemEdge;
  CachedAgreementListItemOptions: CachedAgreementListItemOptions;
  CachedAgreementListItemSort: CachedAgreementListItemSort;
  CachedAgreementListItemWhere: CachedAgreementListItemWhere;
  CachedAgreementListItemsConnection: CachedAgreementListItemsConnection;
  CanPushAgreementInput: CanPushAgreementInput;
  Case: Case;
  CaseAgreementBaseAgreementAggregationSelection: CaseAgreementBaseAgreementAggregationSelection;
  CaseAgreementBaseAgreementNodeAggregateSelection: CaseAgreementBaseAgreementNodeAggregateSelection;
  CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection: CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection;
  CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection: CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection;
  CaseBaseAgreementAggregateInput: CaseBaseAgreementAggregateInput;
  CaseBaseAgreementConnection: CaseBaseAgreementConnection;
  CaseBaseAgreementConnectionSort: CaseBaseAgreementConnectionSort;
  CaseBaseAgreementConnectionWhere: CaseBaseAgreementConnectionWhere;
  CaseBaseAgreementNodeAggregationWhereInput: CaseBaseAgreementNodeAggregationWhereInput;
  CaseBaseAgreementRelationship: CaseBaseAgreementRelationship;
  CaseEdge: CaseEdge;
  CaseFinancialDataPointsAggregateInput: CaseFinancialDataPointsAggregateInput;
  CaseFinancialDataPointsConnection: CaseFinancialDataPointsConnection;
  CaseFinancialDataPointsConnectionSort: CaseFinancialDataPointsConnectionSort;
  CaseFinancialDataPointsConnectionWhere: CaseFinancialDataPointsConnectionWhere;
  CaseFinancialDataPointsNodeAggregationWhereInput: CaseFinancialDataPointsNodeAggregationWhereInput;
  CaseFinancialDataPointsRelationship: CaseFinancialDataPointsRelationship;
  CaseFlexEntitiesAggregateInput: CaseFlexEntitiesAggregateInput;
  CaseFlexEntitiesConnection: CaseFlexEntitiesConnection;
  CaseFlexEntitiesConnectionSort: CaseFlexEntitiesConnectionSort;
  CaseFlexEntitiesConnectionWhere: CaseFlexEntitiesConnectionWhere;
  CaseFlexEntitiesNodeAggregationWhereInput: CaseFlexEntitiesNodeAggregationWhereInput;
  CaseFlexEntitiesRelationship: CaseFlexEntitiesRelationship;
  CaseFlexEntityFlexEntitiesAggregationSelection: CaseFlexEntityFlexEntitiesAggregationSelection;
  CaseFlexEntityFlexEntitiesNodeAggregateSelection: CaseFlexEntityFlexEntitiesNodeAggregateSelection;
  CaseFlexEntityRelationship: ResolversInterfaceTypes<ResolversParentTypes>['CaseFlexEntityRelationship'];
  CaseFlexEntityRelationshipSort: CaseFlexEntityRelationshipSort;
  CaseFlexEntityRelationshipWhere: CaseFlexEntityRelationshipWhere;
  CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection: CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection;
  CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection: CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection;
  CaseNegotiationRoundNegotiationRoundsAggregationSelection: CaseNegotiationRoundNegotiationRoundsAggregationSelection;
  CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection: CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection;
  CaseNegotiationRoundsAggregateInput: CaseNegotiationRoundsAggregateInput;
  CaseNegotiationRoundsConnection: CaseNegotiationRoundsConnection;
  CaseNegotiationRoundsConnectionSort: CaseNegotiationRoundsConnectionSort;
  CaseNegotiationRoundsConnectionWhere: CaseNegotiationRoundsConnectionWhere;
  CaseNegotiationRoundsNodeAggregationWhereInput: CaseNegotiationRoundsNodeAggregationWhereInput;
  CaseNegotiationRoundsRelationship: CaseNegotiationRoundsRelationship;
  CaseOptions: CaseOptions;
  CaseRefundRefundsAggregationSelection: CaseRefundRefundsAggregationSelection;
  CaseRefundRefundsNodeAggregateSelection: CaseRefundRefundsNodeAggregateSelection;
  CaseRefundsAggregateInput: CaseRefundsAggregateInput;
  CaseRefundsConnection: CaseRefundsConnection;
  CaseRefundsConnectionSort: CaseRefundsConnectionSort;
  CaseRefundsConnectionWhere: CaseRefundsConnectionWhere;
  CaseRefundsNodeAggregationWhereInput: CaseRefundsNodeAggregationWhereInput;
  CaseRefundsRelationship: CaseRefundsRelationship;
  CaseRelevantArticle71IndicationAggregateInput: CaseRelevantArticle71IndicationAggregateInput;
  CaseRelevantArticle71IndicationConnection: CaseRelevantArticle71IndicationConnection;
  CaseRelevantArticle71IndicationConnectionSort: CaseRelevantArticle71IndicationConnectionSort;
  CaseRelevantArticle71IndicationConnectionWhere: CaseRelevantArticle71IndicationConnectionWhere;
  CaseRelevantArticle71IndicationNodeAggregationWhereInput: CaseRelevantArticle71IndicationNodeAggregationWhereInput;
  CaseRelevantArticle71IndicationRelationship: CaseRelevantArticle71IndicationRelationship;
  CaseSort: CaseSort;
  CaseWhere: CaseWhere;
  CasesConnection: CasesConnection;
  CatalogueAttribute: CatalogueAttribute;
  CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection: CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection;
  CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection: CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection;
  CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection: CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection;
  CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection: CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection;
  CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection: CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection;
  CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection: CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection;
  CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection: CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection;
  CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection: CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection;
  CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection: CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection;
  CatalogueAttributeCustomConditionAggregateInput: CatalogueAttributeCustomConditionAggregateInput;
  CatalogueAttributeCustomConditionConnection: CatalogueAttributeCustomConditionConnection;
  CatalogueAttributeCustomConditionConnectionSort: CatalogueAttributeCustomConditionConnectionSort;
  CatalogueAttributeCustomConditionConnectionWhere: CatalogueAttributeCustomConditionConnectionWhere;
  CatalogueAttributeCustomConditionCustomConditionAggregationSelection: CatalogueAttributeCustomConditionCustomConditionAggregationSelection;
  CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection: CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection;
  CatalogueAttributeCustomConditionNodeAggregationWhereInput: CatalogueAttributeCustomConditionNodeAggregationWhereInput;
  CatalogueAttributeCustomConditionRelationship: CatalogueAttributeCustomConditionRelationship;
  CatalogueAttributeDependsOnAggregateInput: CatalogueAttributeDependsOnAggregateInput;
  CatalogueAttributeDependsOnConnection: CatalogueAttributeDependsOnConnection;
  CatalogueAttributeDependsOnConnectionSort: CatalogueAttributeDependsOnConnectionSort;
  CatalogueAttributeDependsOnConnectionWhere: CatalogueAttributeDependsOnConnectionWhere;
  CatalogueAttributeDependsOnEdgeAggregationWhereInput: CatalogueAttributeDependsOnEdgeAggregationWhereInput;
  CatalogueAttributeDependsOnNodeAggregationWhereInput: CatalogueAttributeDependsOnNodeAggregationWhereInput;
  CatalogueAttributeDependsOnRelationship: CatalogueAttributeDependsOnRelationship;
  CatalogueAttributeEdge: CatalogueAttributeEdge;
  CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection: CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection;
  CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection: CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection;
  CatalogueAttributeFlexEntityTypesAggregateInput: CatalogueAttributeFlexEntityTypesAggregateInput;
  CatalogueAttributeFlexEntityTypesConnection: CatalogueAttributeFlexEntityTypesConnection;
  CatalogueAttributeFlexEntityTypesConnectionSort: CatalogueAttributeFlexEntityTypesConnectionSort;
  CatalogueAttributeFlexEntityTypesConnectionWhere: CatalogueAttributeFlexEntityTypesConnectionWhere;
  CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput: CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput;
  CatalogueAttributeFlexEntityTypesRelationship: CatalogueAttributeFlexEntityTypesRelationship;
  CatalogueAttributeHasDependantAggregateInput: CatalogueAttributeHasDependantAggregateInput;
  CatalogueAttributeHasDependantConnection: CatalogueAttributeHasDependantConnection;
  CatalogueAttributeHasDependantConnectionSort: CatalogueAttributeHasDependantConnectionSort;
  CatalogueAttributeHasDependantConnectionWhere: CatalogueAttributeHasDependantConnectionWhere;
  CatalogueAttributeHasDependantEdgeAggregationWhereInput: CatalogueAttributeHasDependantEdgeAggregationWhereInput;
  CatalogueAttributeHasDependantNodeAggregationWhereInput: CatalogueAttributeHasDependantNodeAggregationWhereInput;
  CatalogueAttributeHasDependantRelationship: CatalogueAttributeHasDependantRelationship;
  CatalogueAttributeMutuallyRelevantAggregateInput: CatalogueAttributeMutuallyRelevantAggregateInput;
  CatalogueAttributeMutuallyRelevantConnection: CatalogueAttributeMutuallyRelevantConnection;
  CatalogueAttributeMutuallyRelevantConnectionSort: CatalogueAttributeMutuallyRelevantConnectionSort;
  CatalogueAttributeMutuallyRelevantConnectionWhere: CatalogueAttributeMutuallyRelevantConnectionWhere;
  CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput: CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput;
  CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput: CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput;
  CatalogueAttributeMutuallyRelevantRelationship: CatalogueAttributeMutuallyRelevantRelationship;
  CatalogueAttributeOptions: CatalogueAttributeOptions;
  CatalogueAttributeSort: CatalogueAttributeSort;
  CatalogueAttributeWhere: CatalogueAttributeWhere;
  CatalogueAttributesConnection: CatalogueAttributesConnection;
  ChartRangeConfigInput: ChartRangeConfigInput;
  ChartRangeConfiguration: ChartRangeConfiguration;
  ChartRangeConfigurationEdge: ChartRangeConfigurationEdge;
  ChartRangeConfigurationOptions: ChartRangeConfigurationOptions;
  ChartRangeConfigurationRelationship: ResolversInterfaceTypes<ResolversParentTypes>['ChartRangeConfigurationRelationship'];
  ChartRangeConfigurationRelationshipSort: ChartRangeConfigurationRelationshipSort;
  ChartRangeConfigurationRelationshipWhere: ChartRangeConfigurationRelationshipWhere;
  ChartRangeConfigurationSort: ChartRangeConfigurationSort;
  ChartRangeConfigurationWhere: ChartRangeConfigurationWhere;
  ChartRangeConfigurationsConnection: ChartRangeConfigurationsConnection;
  CheckedType: CheckedType;
  CheckedTypeEdge: CheckedTypeEdge;
  CheckedTypeOptions: CheckedTypeOptions;
  CheckedTypeSort: CheckedTypeSort;
  CheckedTypeWhere: CheckedTypeWhere;
  CheckedTypesConnection: CheckedTypesConnection;
  ClusterWorkerMetric: ClusterWorkerMetric;
  ClusterWorkerMetricEdge: ClusterWorkerMetricEdge;
  ClusterWorkerMetricOptions: ClusterWorkerMetricOptions;
  ClusterWorkerMetricSort: ClusterWorkerMetricSort;
  ClusterWorkerMetricWhere: ClusterWorkerMetricWhere;
  ClusterWorkerMetricsConnection: ClusterWorkerMetricsConnection;
  ClusterWorkersSnapshot: ClusterWorkersSnapshot;
  ClusterWorkersSnapshotEdge: ClusterWorkersSnapshotEdge;
  ClusterWorkersSnapshotOptions: ClusterWorkersSnapshotOptions;
  ClusterWorkersSnapshotSort: ClusterWorkersSnapshotSort;
  ClusterWorkersSnapshotWhere: ClusterWorkersSnapshotWhere;
  ClusterWorkersSnapshotsConnection: ClusterWorkersSnapshotsConnection;
  Config: Config;
  ConfigEdge: ConfigEdge;
  ConfigOptions: ConfigOptions;
  ConfigSort: ConfigSort;
  ConfigWhere: ConfigWhere;
  ConfigsConnection: ConfigsConnection;
  ContactPersonInput: ContactPersonInput;
  CosmosMetric: CosmosMetric;
  CosmosMetricEdge: CosmosMetricEdge;
  CosmosMetricOptions: CosmosMetricOptions;
  CosmosMetricSort: CosmosMetricSort;
  CosmosMetricWhere: CosmosMetricWhere;
  CosmosMetricsConnection: CosmosMetricsConnection;
  CountriesConnection: CountriesConnection;
  Country: Country;
  CountryAgreementScopeScopesAggregationSelection: CountryAgreementScopeScopesAggregationSelection;
  CountryAgreementScopeScopesEdgeAggregateSelection: CountryAgreementScopeScopesEdgeAggregateSelection;
  CountryAgreementScopeScopesNodeAggregateSelection: CountryAgreementScopeScopesNodeAggregateSelection;
  CountryCurrenciesAggregateInput: CountryCurrenciesAggregateInput;
  CountryCurrenciesConnection: CountryCurrenciesConnection;
  CountryCurrenciesConnectionSort: CountryCurrenciesConnectionSort;
  CountryCurrenciesConnectionWhere: CountryCurrenciesConnectionWhere;
  CountryCurrenciesNodeAggregationWhereInput: CountryCurrenciesNodeAggregationWhereInput;
  CountryCurrenciesRelationship: CountryCurrenciesRelationship;
  CountryCurrencyCurrenciesAggregationSelection: CountryCurrencyCurrenciesAggregationSelection;
  CountryCurrencyCurrenciesNodeAggregateSelection: CountryCurrencyCurrenciesNodeAggregateSelection;
  CountryEdge: CountryEdge;
  CountryInput: CountryInput;
  CountryOptions: CountryOptions;
  CountryOrganizationOrganizationsAggregationSelection: CountryOrganizationOrganizationsAggregationSelection;
  CountryOrganizationOrganizationsNodeAggregateSelection: CountryOrganizationOrganizationsNodeAggregateSelection;
  CountryOrganizationsAggregateInput: CountryOrganizationsAggregateInput;
  CountryOrganizationsConnection: CountryOrganizationsConnection;
  CountryOrganizationsConnectionSort: CountryOrganizationsConnectionSort;
  CountryOrganizationsConnectionWhere: CountryOrganizationsConnectionWhere;
  CountryOrganizationsNodeAggregationWhereInput: CountryOrganizationsNodeAggregationWhereInput;
  CountryOrganizationsRelationship: CountryOrganizationsRelationship;
  CountryScopeRelationship: ResolversInterfaceTypes<ResolversParentTypes>['CountryScopeRelationship'];
  CountryScopeRelationshipSort: CountryScopeRelationshipSort;
  CountryScopeRelationshipWhere: CountryScopeRelationshipWhere;
  CountryScopesAggregateInput: CountryScopesAggregateInput;
  CountryScopesConnection: CountryScopesConnection;
  CountryScopesConnectionSort: CountryScopesConnectionSort;
  CountryScopesConnectionWhere: CountryScopesConnectionWhere;
  CountryScopesEdgeAggregationWhereInput: CountryScopesEdgeAggregationWhereInput;
  CountryScopesNodeAggregationWhereInput: CountryScopesNodeAggregationWhereInput;
  CountryScopesRelationship: CountryScopesRelationship;
  CountrySort: CountrySort;
  CountryTreatmentTreatmentsAggregationSelection: CountryTreatmentTreatmentsAggregationSelection;
  CountryTreatmentTreatmentsNodeAggregateSelection: CountryTreatmentTreatmentsNodeAggregateSelection;
  CountryTreatmentsAggregateInput: CountryTreatmentsAggregateInput;
  CountryTreatmentsConnection: CountryTreatmentsConnection;
  CountryTreatmentsConnectionSort: CountryTreatmentsConnectionSort;
  CountryTreatmentsConnectionWhere: CountryTreatmentsConnectionWhere;
  CountryTreatmentsNodeAggregationWhereInput: CountryTreatmentsNodeAggregationWhereInput;
  CountryTreatmentsRelationship: CountryTreatmentsRelationship;
  CountryWhere: CountryWhere;
  CrossCountryPrice: CrossCountryPrice;
  CrossCountryPriceEdge: CrossCountryPriceEdge;
  CrossCountryPriceOptions: CrossCountryPriceOptions;
  CrossCountryPriceSort: CrossCountryPriceSort;
  CrossCountryPriceWhere: CrossCountryPriceWhere;
  CrossCountryPricesConnection: CrossCountryPricesConnection;
  CurrenciesConnection: CurrenciesConnection;
  Currency: Currency;
  CurrencyAgreementAgreementsAggregationSelection: CurrencyAgreementAgreementsAggregationSelection;
  CurrencyAgreementAgreementsNodeAggregateSelection: CurrencyAgreementAgreementsNodeAggregateSelection;
  CurrencyAgreementsAggregateInput: CurrencyAgreementsAggregateInput;
  CurrencyAgreementsConnection: CurrencyAgreementsConnection;
  CurrencyAgreementsConnectionSort: CurrencyAgreementsConnectionSort;
  CurrencyAgreementsConnectionWhere: CurrencyAgreementsConnectionWhere;
  CurrencyAgreementsNodeAggregationWhereInput: CurrencyAgreementsNodeAggregationWhereInput;
  CurrencyAgreementsRelationship: CurrencyAgreementsRelationship;
  CurrencyCountriesAggregateInput: CurrencyCountriesAggregateInput;
  CurrencyCountriesConnection: CurrencyCountriesConnection;
  CurrencyCountriesConnectionSort: CurrencyCountriesConnectionSort;
  CurrencyCountriesConnectionWhere: CurrencyCountriesConnectionWhere;
  CurrencyCountriesNodeAggregationWhereInput: CurrencyCountriesNodeAggregationWhereInput;
  CurrencyCountriesRelationship: CurrencyCountriesRelationship;
  CurrencyCountryCountriesAggregationSelection: CurrencyCountryCountriesAggregationSelection;
  CurrencyCountryCountriesNodeAggregateSelection: CurrencyCountryCountriesNodeAggregateSelection;
  CurrencyEdge: CurrencyEdge;
  CurrencyOptions: CurrencyOptions;
  CurrencyPricePricesAggregationSelection: CurrencyPricePricesAggregationSelection;
  CurrencyPricePricesNodeAggregateSelection: CurrencyPricePricesNodeAggregateSelection;
  CurrencyPricesAggregateInput: CurrencyPricesAggregateInput;
  CurrencyPricesConnection: CurrencyPricesConnection;
  CurrencyPricesConnectionSort: CurrencyPricesConnectionSort;
  CurrencyPricesConnectionWhere: CurrencyPricesConnectionWhere;
  CurrencyPricesNodeAggregationWhereInput: CurrencyPricesNodeAggregationWhereInput;
  CurrencyPricesRelationship: CurrencyPricesRelationship;
  CurrencySort: CurrencySort;
  CurrencyWhere: CurrencyWhere;
  CustomConclusiveConditionDropdownOptionInput: CustomConclusiveConditionDropdownOptionInput;
  CustomCondition: CustomCondition;
  CustomConditionAttributeAggregateInput: CustomConditionAttributeAggregateInput;
  CustomConditionAttributeConnection: CustomConditionAttributeConnection;
  CustomConditionAttributeConnectionSort: CustomConditionAttributeConnectionSort;
  CustomConditionAttributeConnectionWhere: CustomConditionAttributeConnectionWhere;
  CustomConditionAttributeInput: CustomConditionAttributeInput;
  CustomConditionAttributeNodeAggregationWhereInput: CustomConditionAttributeNodeAggregationWhereInput;
  CustomConditionAttributeRelationship: CustomConditionAttributeRelationship;
  CustomConditionCatalogueAttributeAttributeAggregationSelection: CustomConditionCatalogueAttributeAttributeAggregationSelection;
  CustomConditionCatalogueAttributeAttributeNodeAggregateSelection: CustomConditionCatalogueAttributeAttributeNodeAggregateSelection;
  CustomConditionCreatedByAggregateInput: CustomConditionCreatedByAggregateInput;
  CustomConditionCreatedByConnection: CustomConditionCreatedByConnection;
  CustomConditionCreatedByConnectionSort: CustomConditionCreatedByConnectionSort;
  CustomConditionCreatedByConnectionWhere: CustomConditionCreatedByConnectionWhere;
  CustomConditionCreatedByNodeAggregationWhereInput: CustomConditionCreatedByNodeAggregationWhereInput;
  CustomConditionCreatedByRelationship: CustomConditionCreatedByRelationship;
  CustomConditionEdge: CustomConditionEdge;
  CustomConditionOptions: CustomConditionOptions;
  CustomConditionSort: CustomConditionSort;
  CustomConditionUserCreatedByAggregationSelection: CustomConditionUserCreatedByAggregationSelection;
  CustomConditionUserCreatedByNodeAggregateSelection: CustomConditionUserCreatedByNodeAggregateSelection;
  CustomConditionWhere: CustomConditionWhere;
  CustomConditionsConnection: CustomConditionsConnection;
  CustomIntegrityCheck: CustomIntegrityCheck;
  CustomIntegrityCheckEdge: CustomIntegrityCheckEdge;
  CustomIntegrityCheckOptions: CustomIntegrityCheckOptions;
  CustomIntegrityCheckSort: CustomIntegrityCheckSort;
  CustomIntegrityCheckWhere: CustomIntegrityCheckWhere;
  CustomIntegrityChecksConnection: CustomIntegrityChecksConnection;
  CycleConfiguration: CycleConfiguration;
  CycleConfigurationAgreementScopeScopeAggregationSelection: CycleConfigurationAgreementScopeScopeAggregationSelection;
  CycleConfigurationAgreementScopeScopeNodeAggregateSelection: CycleConfigurationAgreementScopeScopeNodeAggregateSelection;
  CycleConfigurationBrandStartingTreatmentBrandAggregationSelection: CycleConfigurationBrandStartingTreatmentBrandAggregationSelection;
  CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection: CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection;
  CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection: CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection;
  CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection: CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection;
  CycleConfigurationEdge: CycleConfigurationEdge;
  CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection: CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection;
  CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection: CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection;
  CycleConfigurationGenericStartingTreatmentGenericAggregationSelection: CycleConfigurationGenericStartingTreatmentGenericAggregationSelection;
  CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection: CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection;
  CycleConfigurationInput: CycleConfigurationInput;
  CycleConfigurationOptions: CycleConfigurationOptions;
  CycleConfigurationRecordTypeAggregateInput: CycleConfigurationRecordTypeAggregateInput;
  CycleConfigurationRecordTypeConnection: CycleConfigurationRecordTypeConnection;
  CycleConfigurationRecordTypeConnectionSort: CycleConfigurationRecordTypeConnectionSort;
  CycleConfigurationRecordTypeConnectionWhere: CycleConfigurationRecordTypeConnectionWhere;
  CycleConfigurationRecordTypeNodeAggregationWhereInput: CycleConfigurationRecordTypeNodeAggregationWhereInput;
  CycleConfigurationRecordTypeRelationship: CycleConfigurationRecordTypeRelationship;
  CycleConfigurationScopeAggregateInput: CycleConfigurationScopeAggregateInput;
  CycleConfigurationScopeConnection: CycleConfigurationScopeConnection;
  CycleConfigurationScopeConnectionSort: CycleConfigurationScopeConnectionSort;
  CycleConfigurationScopeConnectionWhere: CycleConfigurationScopeConnectionWhere;
  CycleConfigurationScopeNodeAggregationWhereInput: CycleConfigurationScopeNodeAggregationWhereInput;
  CycleConfigurationScopeRelationship: CycleConfigurationScopeRelationship;
  CycleConfigurationSort: CycleConfigurationSort;
  CycleConfigurationStartingTreatmentAggregateInput: CycleConfigurationStartingTreatmentAggregateInput;
  CycleConfigurationStartingTreatmentBrandAggregateInput: CycleConfigurationStartingTreatmentBrandAggregateInput;
  CycleConfigurationStartingTreatmentBrandConnection: CycleConfigurationStartingTreatmentBrandConnection;
  CycleConfigurationStartingTreatmentBrandConnectionSort: CycleConfigurationStartingTreatmentBrandConnectionSort;
  CycleConfigurationStartingTreatmentBrandConnectionWhere: CycleConfigurationStartingTreatmentBrandConnectionWhere;
  CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput: CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput;
  CycleConfigurationStartingTreatmentBrandRelationship: CycleConfigurationStartingTreatmentBrandRelationship;
  CycleConfigurationStartingTreatmentConnection: CycleConfigurationStartingTreatmentConnection;
  CycleConfigurationStartingTreatmentConnectionSort: CycleConfigurationStartingTreatmentConnectionSort;
  CycleConfigurationStartingTreatmentConnectionWhere: CycleConfigurationStartingTreatmentConnectionWhere;
  CycleConfigurationStartingTreatmentGenericAggregateInput: CycleConfigurationStartingTreatmentGenericAggregateInput;
  CycleConfigurationStartingTreatmentGenericConnection: CycleConfigurationStartingTreatmentGenericConnection;
  CycleConfigurationStartingTreatmentGenericConnectionSort: CycleConfigurationStartingTreatmentGenericConnectionSort;
  CycleConfigurationStartingTreatmentGenericConnectionWhere: CycleConfigurationStartingTreatmentGenericConnectionWhere;
  CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput: CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput;
  CycleConfigurationStartingTreatmentGenericRelationship: CycleConfigurationStartingTreatmentGenericRelationship;
  CycleConfigurationStartingTreatmentNodeAggregationWhereInput: CycleConfigurationStartingTreatmentNodeAggregationWhereInput;
  CycleConfigurationStartingTreatmentRelationship: CycleConfigurationStartingTreatmentRelationship;
  CycleConfigurationTherapiesAggregateInput: CycleConfigurationTherapiesAggregateInput;
  CycleConfigurationTherapiesConnection: CycleConfigurationTherapiesConnection;
  CycleConfigurationTherapiesConnectionSort: CycleConfigurationTherapiesConnectionSort;
  CycleConfigurationTherapiesConnectionWhere: CycleConfigurationTherapiesConnectionWhere;
  CycleConfigurationTherapiesNodeAggregationWhereInput: CycleConfigurationTherapiesNodeAggregationWhereInput;
  CycleConfigurationTherapiesRelationship: CycleConfigurationTherapiesRelationship;
  CycleConfigurationTreatmentStartingTreatmentAggregationSelection: CycleConfigurationTreatmentStartingTreatmentAggregationSelection;
  CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection: CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection;
  CycleConfigurationWhere: CycleConfigurationWhere;
  CycleConfigurationsConnection: CycleConfigurationsConnection;
  CycleTherapyConfiguration: CycleTherapyConfiguration;
  CycleTherapyConfigurationEdge: CycleTherapyConfigurationEdge;
  CycleTherapyConfigurationInput: CycleTherapyConfigurationInput;
  CycleTherapyConfigurationOptions: CycleTherapyConfigurationOptions;
  CycleTherapyConfigurationSort: CycleTherapyConfigurationSort;
  CycleTherapyConfigurationTreatmentSetAggregateInput: CycleTherapyConfigurationTreatmentSetAggregateInput;
  CycleTherapyConfigurationTreatmentSetConnection: CycleTherapyConfigurationTreatmentSetConnection;
  CycleTherapyConfigurationTreatmentSetConnectionSort: CycleTherapyConfigurationTreatmentSetConnectionSort;
  CycleTherapyConfigurationTreatmentSetConnectionWhere: CycleTherapyConfigurationTreatmentSetConnectionWhere;
  CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput: CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput;
  CycleTherapyConfigurationTreatmentSetRelationship: CycleTherapyConfigurationTreatmentSetRelationship;
  CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection: CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection;
  CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection: CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection;
  CycleTherapyConfigurationWhere: CycleTherapyConfigurationWhere;
  CycleTherapyConfigurationsConnection: CycleTherapyConfigurationsConnection;
  DQCDetailedReportRaw: DqcDetailedReportRaw;
  DQCDetailedReportRawEdge: DqcDetailedReportRawEdge;
  DQCDetailedReportRawOptions: DqcDetailedReportRawOptions;
  DQCDetailedReportRawSort: DqcDetailedReportRawSort;
  DQCDetailedReportRawWhere: DqcDetailedReportRawWhere;
  DataContainer: DataContainer;
  DataContainerEdge: DataContainerEdge;
  DataContainerInput: DataContainerInput;
  DataContainerOptions: DataContainerOptions;
  DataContainerOrganizationInput: DataContainerOrganizationInput;
  DataContainerOrganizationProvidersAggregationSelection: DataContainerOrganizationProvidersAggregationSelection;
  DataContainerOrganizationProvidersNodeAggregateSelection: DataContainerOrganizationProvidersNodeAggregateSelection;
  DataContainerProvidersAggregateInput: DataContainerProvidersAggregateInput;
  DataContainerProvidersConnection: DataContainerProvidersConnection;
  DataContainerProvidersConnectionSort: DataContainerProvidersConnectionSort;
  DataContainerProvidersConnectionWhere: DataContainerProvidersConnectionWhere;
  DataContainerProvidersNodeAggregationWhereInput: DataContainerProvidersNodeAggregationWhereInput;
  DataContainerProvidersRelationship: DataContainerProvidersRelationship;
  DataContainerSort: DataContainerSort;
  DataContainerWhere: DataContainerWhere;
  DataContainersConnection: DataContainersConnection;
  DataSource: DataSource;
  DataSourceEdge: DataSourceEdge;
  DataSourceOptions: DataSourceOptions;
  DataSourceSort: DataSourceSort;
  DataSourceWhere: DataSourceWhere;
  DataSourcesConnection: DataSourcesConnection;
  Date: Scalars['Date']['output'];
  DateTime: Scalars['DateTime']['output'];
  DateTimeAggregateSelectionNonNullable: DateTimeAggregateSelectionNonNullable;
  DateTimeAggregateSelectionNullable: DateTimeAggregateSelectionNullable;
  DefaultAgreementRoleInfo: DefaultAgreementRoleInfo;
  DefaultAgreementRoleInfoEdge: DefaultAgreementRoleInfoEdge;
  DefaultAgreementRoleInfoOptions: DefaultAgreementRoleInfoOptions;
  DefaultAgreementRoleInfoSort: DefaultAgreementRoleInfoSort;
  DefaultAgreementRoleInfoWhere: DefaultAgreementRoleInfoWhere;
  DefaultAgreementRoleInfosConnection: DefaultAgreementRoleInfosConnection;
  DefaultReceiverProperties: ResolversInterfaceTypes<ResolversParentTypes>['DefaultReceiverProperties'];
  DefaultReceiverPropertiesSort: DefaultReceiverPropertiesSort;
  DefaultReceiverPropertiesWhere: DefaultReceiverPropertiesWhere;
  DefaultUserRoleUpdateInput: DefaultUserRoleUpdateInput;
  DependencyAttribute: ResolversInterfaceTypes<ResolversParentTypes>['DependencyAttribute'];
  DependencyAttributeSort: DependencyAttributeSort;
  DependencyAttributeWhere: DependencyAttributeWhere;
  DeviceAgreementInput: DeviceAgreementInput;
  DeviceAlternative: DeviceAlternative;
  DeviceAlternativeAlternativesAggregateInput: DeviceAlternativeAlternativesAggregateInput;
  DeviceAlternativeAlternativesConnection: DeviceAlternativeAlternativesConnection;
  DeviceAlternativeAlternativesConnectionSort: DeviceAlternativeAlternativesConnectionSort;
  DeviceAlternativeAlternativesConnectionWhere: DeviceAlternativeAlternativesConnectionWhere;
  DeviceAlternativeAlternativesNodeAggregationWhereInput: DeviceAlternativeAlternativesNodeAggregationWhereInput;
  DeviceAlternativeAlternativesRelationship: DeviceAlternativeAlternativesRelationship;
  DeviceAlternativeDeviceProductAggregateInput: DeviceAlternativeDeviceProductAggregateInput;
  DeviceAlternativeDeviceProductConnection: DeviceAlternativeDeviceProductConnection;
  DeviceAlternativeDeviceProductConnectionSort: DeviceAlternativeDeviceProductConnectionSort;
  DeviceAlternativeDeviceProductConnectionWhere: DeviceAlternativeDeviceProductConnectionWhere;
  DeviceAlternativeDeviceProductNodeAggregationWhereInput: DeviceAlternativeDeviceProductNodeAggregationWhereInput;
  DeviceAlternativeDeviceProductRelationship: DeviceAlternativeDeviceProductRelationship;
  DeviceAlternativeEdge: DeviceAlternativeEdge;
  DeviceAlternativeInput: DeviceAlternativeInput;
  DeviceAlternativeOptions: DeviceAlternativeOptions;
  DeviceAlternativeSort: DeviceAlternativeSort;
  DeviceAlternativeTreatmentAlternativesAggregationSelection: DeviceAlternativeTreatmentAlternativesAggregationSelection;
  DeviceAlternativeTreatmentAlternativesNodeAggregateSelection: DeviceAlternativeTreatmentAlternativesNodeAggregateSelection;
  DeviceAlternativeTreatmentDeviceProductAggregationSelection: DeviceAlternativeTreatmentDeviceProductAggregationSelection;
  DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection: DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection;
  DeviceAlternativeWhere: DeviceAlternativeWhere;
  DeviceAlternativesConnection: DeviceAlternativesConnection;
  DisabledDataCheck: DisabledDataCheck;
  DisabledDataCheckEdge: DisabledDataCheckEdge;
  DisabledDataCheckOptions: DisabledDataCheckOptions;
  DisabledDataCheckSort: DisabledDataCheckSort;
  DisabledDataCheckWhere: DisabledDataCheckWhere;
  DisabledDataChecksConnection: DisabledDataChecksConnection;
  Disease: Disease;
  DiseaseEdge: DiseaseEdge;
  DiseaseInput: DiseaseInput;
  DiseaseOptions: DiseaseOptions;
  DiseaseSort: DiseaseSort;
  DiseaseWhere: DiseaseWhere;
  DiseasesConnection: DiseasesConnection;
  Document: Document;
  DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection: DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection;
  DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection: DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection;
  DocumentDocumentRefundGroupsAggregateInput: DocumentDocumentRefundGroupsAggregateInput;
  DocumentDocumentRefundGroupsConnection: DocumentDocumentRefundGroupsConnection;
  DocumentDocumentRefundGroupsConnectionSort: DocumentDocumentRefundGroupsConnectionSort;
  DocumentDocumentRefundGroupsConnectionWhere: DocumentDocumentRefundGroupsConnectionWhere;
  DocumentDocumentRefundGroupsNodeAggregationWhereInput: DocumentDocumentRefundGroupsNodeAggregationWhereInput;
  DocumentDocumentRefundGroupsRelationship: DocumentDocumentRefundGroupsRelationship;
  DocumentEdge: DocumentEdge;
  DocumentOptions: DocumentOptions;
  DocumentRefundFinancialDataPoint: ResolversInterfaceTypes<ResolversParentTypes>['DocumentRefundFinancialDataPoint'];
  DocumentRefundFinancialDataPointSort: DocumentRefundFinancialDataPointSort;
  DocumentRefundFinancialDataPointWhere: DocumentRefundFinancialDataPointWhere;
  DocumentRefundGroup: DocumentRefundGroup;
  DocumentRefundGroupAgreementAggregateInput: DocumentRefundGroupAgreementAggregateInput;
  DocumentRefundGroupAgreementAgreementAggregationSelection: DocumentRefundGroupAgreementAgreementAggregationSelection;
  DocumentRefundGroupAgreementAgreementNodeAggregateSelection: DocumentRefundGroupAgreementAgreementNodeAggregateSelection;
  DocumentRefundGroupAgreementConnection: DocumentRefundGroupAgreementConnection;
  DocumentRefundGroupAgreementConnectionSort: DocumentRefundGroupAgreementConnectionSort;
  DocumentRefundGroupAgreementConnectionWhere: DocumentRefundGroupAgreementConnectionWhere;
  DocumentRefundGroupAgreementNodeAggregationWhereInput: DocumentRefundGroupAgreementNodeAggregationWhereInput;
  DocumentRefundGroupAgreementRelationship: DocumentRefundGroupAgreementRelationship;
  DocumentRefundGroupCaseAggregateInput: DocumentRefundGroupCaseAggregateInput;
  DocumentRefundGroupCaseCaseAggregationSelection: DocumentRefundGroupCaseCaseAggregationSelection;
  DocumentRefundGroupCaseCaseNodeAggregateSelection: DocumentRefundGroupCaseCaseNodeAggregateSelection;
  DocumentRefundGroupCaseConnection: DocumentRefundGroupCaseConnection;
  DocumentRefundGroupCaseConnectionSort: DocumentRefundGroupCaseConnectionSort;
  DocumentRefundGroupCaseConnectionWhere: DocumentRefundGroupCaseConnectionWhere;
  DocumentRefundGroupCaseNodeAggregationWhereInput: DocumentRefundGroupCaseNodeAggregationWhereInput;
  DocumentRefundGroupCaseRelationship: DocumentRefundGroupCaseRelationship;
  DocumentRefundGroupDocumentAggregateInput: DocumentRefundGroupDocumentAggregateInput;
  DocumentRefundGroupDocumentConnection: DocumentRefundGroupDocumentConnection;
  DocumentRefundGroupDocumentConnectionSort: DocumentRefundGroupDocumentConnectionSort;
  DocumentRefundGroupDocumentConnectionWhere: DocumentRefundGroupDocumentConnectionWhere;
  DocumentRefundGroupDocumentDocumentAggregationSelection: DocumentRefundGroupDocumentDocumentAggregationSelection;
  DocumentRefundGroupDocumentDocumentNodeAggregateSelection: DocumentRefundGroupDocumentDocumentNodeAggregateSelection;
  DocumentRefundGroupDocumentNodeAggregationWhereInput: DocumentRefundGroupDocumentNodeAggregationWhereInput;
  DocumentRefundGroupDocumentRelationship: DocumentRefundGroupDocumentRelationship;
  DocumentRefundGroupEdge: DocumentRefundGroupEdge;
  DocumentRefundGroupMessageAggregateInput: DocumentRefundGroupMessageAggregateInput;
  DocumentRefundGroupMessageConnection: DocumentRefundGroupMessageConnection;
  DocumentRefundGroupMessageConnectionSort: DocumentRefundGroupMessageConnectionSort;
  DocumentRefundGroupMessageConnectionWhere: DocumentRefundGroupMessageConnectionWhere;
  DocumentRefundGroupMessageMessageAggregationSelection: DocumentRefundGroupMessageMessageAggregationSelection;
  DocumentRefundGroupMessageMessageNodeAggregateSelection: DocumentRefundGroupMessageMessageNodeAggregateSelection;
  DocumentRefundGroupMessageNodeAggregationWhereInput: DocumentRefundGroupMessageNodeAggregationWhereInput;
  DocumentRefundGroupMessageRelationship: DocumentRefundGroupMessageRelationship;
  DocumentRefundGroupOptions: DocumentRefundGroupOptions;
  DocumentRefundGroupRefundRefundsAggregationSelection: DocumentRefundGroupRefundRefundsAggregationSelection;
  DocumentRefundGroupRefundRefundsNodeAggregateSelection: DocumentRefundGroupRefundRefundsNodeAggregateSelection;
  DocumentRefundGroupRefundsAggregateInput: DocumentRefundGroupRefundsAggregateInput;
  DocumentRefundGroupRefundsConnection: DocumentRefundGroupRefundsConnection;
  DocumentRefundGroupRefundsConnectionSort: DocumentRefundGroupRefundsConnectionSort;
  DocumentRefundGroupRefundsConnectionWhere: DocumentRefundGroupRefundsConnectionWhere;
  DocumentRefundGroupRefundsNodeAggregationWhereInput: DocumentRefundGroupRefundsNodeAggregationWhereInput;
  DocumentRefundGroupRefundsRelationship: DocumentRefundGroupRefundsRelationship;
  DocumentRefundGroupSort: DocumentRefundGroupSort;
  DocumentRefundGroupWhere: DocumentRefundGroupWhere;
  DocumentRefundGroupsConnection: DocumentRefundGroupsConnection;
  DocumentRefundRefundsAggregationSelection: DocumentRefundRefundsAggregationSelection;
  DocumentRefundRefundsNodeAggregateSelection: DocumentRefundRefundsNodeAggregateSelection;
  DocumentRefundsAggregateInput: DocumentRefundsAggregateInput;
  DocumentRefundsConnection: DocumentRefundsConnection;
  DocumentRefundsConnectionSort: DocumentRefundsConnectionSort;
  DocumentRefundsConnectionWhere: DocumentRefundsConnectionWhere;
  DocumentRefundsNodeAggregationWhereInput: DocumentRefundsNodeAggregationWhereInput;
  DocumentRefundsRelationship: DocumentRefundsRelationship;
  DocumentSort: DocumentSort;
  DocumentWhere: DocumentWhere;
  DocumentsConnection: DocumentsConnection;
  Domain: Domain;
  DomainChildrenAggregateInput: DomainChildrenAggregateInput;
  DomainChildrenConnection: DomainChildrenConnection;
  DomainChildrenConnectionSort: DomainChildrenConnectionSort;
  DomainChildrenConnectionWhere: DomainChildrenConnectionWhere;
  DomainChildrenNodeAggregationWhereInput: DomainChildrenNodeAggregationWhereInput;
  DomainChildrenRelationship: DomainChildrenRelationship;
  DomainCreatedByAggregateInput: DomainCreatedByAggregateInput;
  DomainCreatedByConnection: DomainCreatedByConnection;
  DomainCreatedByConnectionSort: DomainCreatedByConnectionSort;
  DomainCreatedByConnectionWhere: DomainCreatedByConnectionWhere;
  DomainCreatedByNodeAggregationWhereInput: DomainCreatedByNodeAggregationWhereInput;
  DomainCreatedByRelationship: DomainCreatedByRelationship;
  DomainDomainChildrenAggregationSelection: DomainDomainChildrenAggregationSelection;
  DomainDomainChildrenNodeAggregateSelection: DomainDomainChildrenNodeAggregateSelection;
  DomainDomainParentAggregationSelection: DomainDomainParentAggregationSelection;
  DomainDomainParentNodeAggregateSelection: DomainDomainParentNodeAggregateSelection;
  DomainEdge: DomainEdge;
  DomainOptions: DomainOptions;
  DomainParentAggregateInput: DomainParentAggregateInput;
  DomainParentConnection: DomainParentConnection;
  DomainParentConnectionSort: DomainParentConnectionSort;
  DomainParentConnectionWhere: DomainParentConnectionWhere;
  DomainParentNodeAggregationWhereInput: DomainParentNodeAggregationWhereInput;
  DomainParentRelationship: DomainParentRelationship;
  DomainProductBlueprintAggregateInput: DomainProductBlueprintAggregateInput;
  DomainProductBlueprintConnection: DomainProductBlueprintConnection;
  DomainProductBlueprintConnectionSort: DomainProductBlueprintConnectionSort;
  DomainProductBlueprintConnectionWhere: DomainProductBlueprintConnectionWhere;
  DomainProductBlueprintNodeAggregationWhereInput: DomainProductBlueprintNodeAggregationWhereInput;
  DomainProductBlueprintProductBlueprintAggregationSelection: DomainProductBlueprintProductBlueprintAggregationSelection;
  DomainProductBlueprintProductBlueprintNodeAggregateSelection: DomainProductBlueprintProductBlueprintNodeAggregateSelection;
  DomainProductBlueprintRelationship: DomainProductBlueprintRelationship;
  DomainSimulationSimulationsAggregationSelection: DomainSimulationSimulationsAggregationSelection;
  DomainSimulationSimulationsNodeAggregateSelection: DomainSimulationSimulationsNodeAggregateSelection;
  DomainSimulationsAggregateInput: DomainSimulationsAggregateInput;
  DomainSimulationsConnection: DomainSimulationsConnection;
  DomainSimulationsConnectionSort: DomainSimulationsConnectionSort;
  DomainSimulationsConnectionWhere: DomainSimulationsConnectionWhere;
  DomainSimulationsNodeAggregationWhereInput: DomainSimulationsNodeAggregationWhereInput;
  DomainSimulationsRelationship: DomainSimulationsRelationship;
  DomainSort: DomainSort;
  DomainUserCreatedByAggregationSelection: DomainUserCreatedByAggregationSelection;
  DomainUserCreatedByNodeAggregateSelection: DomainUserCreatedByNodeAggregateSelection;
  DomainUserUsersAggregationSelection: DomainUserUsersAggregationSelection;
  DomainUserUsersNodeAggregateSelection: DomainUserUsersNodeAggregateSelection;
  DomainUsersAggregateInput: DomainUsersAggregateInput;
  DomainUsersConnection: DomainUsersConnection;
  DomainUsersConnectionSort: DomainUsersConnectionSort;
  DomainUsersConnectionWhere: DomainUsersConnectionWhere;
  DomainUsersNodeAggregationWhereInput: DomainUsersNodeAggregationWhereInput;
  DomainUsersRelationship: DomainUsersRelationship;
  DomainWhere: DomainWhere;
  DomainsConnection: DomainsConnection;
  DqcDetailedReportRawsConnection: DqcDetailedReportRawsConnection;
  DummyEnumReferences: DummyEnumReferences;
  DummyEnumReferencesConnection: DummyEnumReferencesConnection;
  DummyEnumReferencesEdge: DummyEnumReferencesEdge;
  DummyEnumReferencesOptions: DummyEnumReferencesOptions;
  DummyEnumReferencesSort: DummyEnumReferencesSort;
  DummyEnumReferencesWhere: DummyEnumReferencesWhere;
  EligibilityConditionSet: EligibilityConditionSet;
  EligibilityConditionSetEdge: EligibilityConditionSetEdge;
  EligibilityConditionSetInput: EligibilityConditionSetInput;
  EligibilityConditionSetOptions: EligibilityConditionSetOptions;
  EligibilityConditionSetSort: EligibilityConditionSetSort;
  EligibilityConditionSetTreatmentTreatmentsAggregationSelection: EligibilityConditionSetTreatmentTreatmentsAggregationSelection;
  EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection: EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection;
  EligibilityConditionSetTreatmentsAggregateInput: EligibilityConditionSetTreatmentsAggregateInput;
  EligibilityConditionSetTreatmentsConnection: EligibilityConditionSetTreatmentsConnection;
  EligibilityConditionSetTreatmentsConnectionSort: EligibilityConditionSetTreatmentsConnectionSort;
  EligibilityConditionSetTreatmentsConnectionWhere: EligibilityConditionSetTreatmentsConnectionWhere;
  EligibilityConditionSetTreatmentsNodeAggregationWhereInput: EligibilityConditionSetTreatmentsNodeAggregationWhereInput;
  EligibilityConditionSetTreatmentsRelationship: EligibilityConditionSetTreatmentsRelationship;
  EligibilityConditionSetWhere: EligibilityConditionSetWhere;
  EligibilityConditionSetsConnection: EligibilityConditionSetsConnection;
  EncapsulatedFeature: EncapsulatedFeature;
  EncapsulatedFeatureConfiguration: EncapsulatedFeatureConfiguration;
  EncapsulatedFeatureConfigurationEdge: EncapsulatedFeatureConfigurationEdge;
  EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection: EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection;
  EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection: EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection;
  EncapsulatedFeatureConfigurationInput: EncapsulatedFeatureConfigurationInput;
  EncapsulatedFeatureConfigurationOfTypeAggregateInput: EncapsulatedFeatureConfigurationOfTypeAggregateInput;
  EncapsulatedFeatureConfigurationOfTypeConnection: EncapsulatedFeatureConfigurationOfTypeConnection;
  EncapsulatedFeatureConfigurationOfTypeConnectionSort: EncapsulatedFeatureConfigurationOfTypeConnectionSort;
  EncapsulatedFeatureConfigurationOfTypeConnectionWhere: EncapsulatedFeatureConfigurationOfTypeConnectionWhere;
  EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput: EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput;
  EncapsulatedFeatureConfigurationOfTypeRelationship: EncapsulatedFeatureConfigurationOfTypeRelationship;
  EncapsulatedFeatureConfigurationOptions: EncapsulatedFeatureConfigurationOptions;
  EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection: EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection;
  EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection: EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection;
  EncapsulatedFeatureConfigurationSetForAggregateInput: EncapsulatedFeatureConfigurationSetForAggregateInput;
  EncapsulatedFeatureConfigurationSetForConnection: EncapsulatedFeatureConfigurationSetForConnection;
  EncapsulatedFeatureConfigurationSetForConnectionSort: EncapsulatedFeatureConfigurationSetForConnectionSort;
  EncapsulatedFeatureConfigurationSetForConnectionWhere: EncapsulatedFeatureConfigurationSetForConnectionWhere;
  EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput: EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput;
  EncapsulatedFeatureConfigurationSetForRelationship: EncapsulatedFeatureConfigurationSetForRelationship;
  EncapsulatedFeatureConfigurationSort: EncapsulatedFeatureConfigurationSort;
  EncapsulatedFeatureConfigurationWhere: EncapsulatedFeatureConfigurationWhere;
  EncapsulatedFeatureConfigurationsConnection: EncapsulatedFeatureConfigurationsConnection;
  EncapsulatedFeatureEdge: EncapsulatedFeatureEdge;
  EncapsulatedFeatureOptions: EncapsulatedFeatureOptions;
  EncapsulatedFeatureSort: EncapsulatedFeatureSort;
  EncapsulatedFeatureWhere: EncapsulatedFeatureWhere;
  EncapsulatedFeaturesConnection: EncapsulatedFeaturesConnection;
  EncryptionInput: EncryptionInput;
  EnrollingCondition: EnrollingCondition;
  EnrollingConditionCustomConditionAggregateInput: EnrollingConditionCustomConditionAggregateInput;
  EnrollingConditionCustomConditionConnection: EnrollingConditionCustomConditionConnection;
  EnrollingConditionCustomConditionConnectionSort: EnrollingConditionCustomConditionConnectionSort;
  EnrollingConditionCustomConditionConnectionWhere: EnrollingConditionCustomConditionConnectionWhere;
  EnrollingConditionCustomConditionCustomConditionAggregationSelection: EnrollingConditionCustomConditionCustomConditionAggregationSelection;
  EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection: EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection;
  EnrollingConditionCustomConditionNodeAggregationWhereInput: EnrollingConditionCustomConditionNodeAggregationWhereInput;
  EnrollingConditionCustomConditionRelationship: EnrollingConditionCustomConditionRelationship;
  EnrollingConditionDiseaseRelationship: ResolversInterfaceTypes<ResolversParentTypes>['EnrollingConditionDiseaseRelationship'];
  EnrollingConditionDiseaseRelationshipSort: EnrollingConditionDiseaseRelationshipSort;
  EnrollingConditionDiseaseRelationshipWhere: EnrollingConditionDiseaseRelationshipWhere;
  EnrollingConditionEdge: EnrollingConditionEdge;
  EnrollingConditionGenericIncludedGenericsAggregationSelection: EnrollingConditionGenericIncludedGenericsAggregationSelection;
  EnrollingConditionGenericIncludedGenericsNodeAggregateSelection: EnrollingConditionGenericIncludedGenericsNodeAggregateSelection;
  EnrollingConditionIncludedGenericsAggregateInput: EnrollingConditionIncludedGenericsAggregateInput;
  EnrollingConditionIncludedGenericsConnection: EnrollingConditionIncludedGenericsConnection;
  EnrollingConditionIncludedGenericsConnectionSort: EnrollingConditionIncludedGenericsConnectionSort;
  EnrollingConditionIncludedGenericsConnectionWhere: EnrollingConditionIncludedGenericsConnectionWhere;
  EnrollingConditionIncludedGenericsNodeAggregationWhereInput: EnrollingConditionIncludedGenericsNodeAggregationWhereInput;
  EnrollingConditionIncludedGenericsRelationship: EnrollingConditionIncludedGenericsRelationship;
  EnrollingConditionInput: EnrollingConditionInput;
  EnrollingConditionOptions: EnrollingConditionOptions;
  EnrollingConditionSet: EnrollingConditionSet;
  EnrollingConditionSetAgreementAggregateInput: EnrollingConditionSetAgreementAggregateInput;
  EnrollingConditionSetAgreementAgreementAggregationSelection: EnrollingConditionSetAgreementAgreementAggregationSelection;
  EnrollingConditionSetAgreementAgreementNodeAggregateSelection: EnrollingConditionSetAgreementAgreementNodeAggregateSelection;
  EnrollingConditionSetAgreementConnection: EnrollingConditionSetAgreementConnection;
  EnrollingConditionSetAgreementConnectionSort: EnrollingConditionSetAgreementConnectionSort;
  EnrollingConditionSetAgreementConnectionWhere: EnrollingConditionSetAgreementConnectionWhere;
  EnrollingConditionSetAgreementNodeAggregationWhereInput: EnrollingConditionSetAgreementNodeAggregationWhereInput;
  EnrollingConditionSetAgreementRelationship: EnrollingConditionSetAgreementRelationship;
  EnrollingConditionSetAgreementScopeScopesAggregationSelection: EnrollingConditionSetAgreementScopeScopesAggregationSelection;
  EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection: EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection;
  EnrollingConditionSetAgreementTemplateTemplateAggregationSelection: EnrollingConditionSetAgreementTemplateTemplateAggregationSelection;
  EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection: EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection;
  EnrollingConditionSetConditionsAggregateInput: EnrollingConditionSetConditionsAggregateInput;
  EnrollingConditionSetConditionsConnection: EnrollingConditionSetConditionsConnection;
  EnrollingConditionSetConditionsConnectionSort: EnrollingConditionSetConditionsConnectionSort;
  EnrollingConditionSetConditionsConnectionWhere: EnrollingConditionSetConditionsConnectionWhere;
  EnrollingConditionSetConditionsNodeAggregationWhereInput: EnrollingConditionSetConditionsNodeAggregationWhereInput;
  EnrollingConditionSetConditionsRelationship: EnrollingConditionSetConditionsRelationship;
  EnrollingConditionSetEdge: EnrollingConditionSetEdge;
  EnrollingConditionSetEnrollingConditionConditionsAggregationSelection: EnrollingConditionSetEnrollingConditionConditionsAggregationSelection;
  EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection: EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection;
  EnrollingConditionSetInput: EnrollingConditionSetInput;
  EnrollingConditionSetOptions: EnrollingConditionSetOptions;
  EnrollingConditionSetRelationship: ResolversInterfaceTypes<ResolversParentTypes>['EnrollingConditionSetRelationship'];
  EnrollingConditionSetRelationshipSort: EnrollingConditionSetRelationshipSort;
  EnrollingConditionSetRelationshipWhere: EnrollingConditionSetRelationshipWhere;
  EnrollingConditionSetScopesAggregateInput: EnrollingConditionSetScopesAggregateInput;
  EnrollingConditionSetScopesConnection: EnrollingConditionSetScopesConnection;
  EnrollingConditionSetScopesConnectionSort: EnrollingConditionSetScopesConnectionSort;
  EnrollingConditionSetScopesConnectionWhere: EnrollingConditionSetScopesConnectionWhere;
  EnrollingConditionSetScopesNodeAggregationWhereInput: EnrollingConditionSetScopesNodeAggregationWhereInput;
  EnrollingConditionSetScopesRelationship: EnrollingConditionSetScopesRelationship;
  EnrollingConditionSetSort: EnrollingConditionSetSort;
  EnrollingConditionSetTemplateAggregateInput: EnrollingConditionSetTemplateAggregateInput;
  EnrollingConditionSetTemplateConnection: EnrollingConditionSetTemplateConnection;
  EnrollingConditionSetTemplateConnectionSort: EnrollingConditionSetTemplateConnectionSort;
  EnrollingConditionSetTemplateConnectionWhere: EnrollingConditionSetTemplateConnectionWhere;
  EnrollingConditionSetTemplateNodeAggregationWhereInput: EnrollingConditionSetTemplateNodeAggregationWhereInput;
  EnrollingConditionSetTemplateRelationship: EnrollingConditionSetTemplateRelationship;
  EnrollingConditionSetWhere: EnrollingConditionSetWhere;
  EnrollingConditionSetsConnection: EnrollingConditionSetsConnection;
  EnrollingConditionSort: EnrollingConditionSort;
  EnrollingConditionWhere: EnrollingConditionWhere;
  EnrollingConditionsConnection: EnrollingConditionsConnection;
  EnrollingPeriod: EnrollingPeriod;
  EnrollingPeriodEdge: EnrollingPeriodEdge;
  EnrollingPeriodInput: EnrollingPeriodInput;
  EnrollingPeriodOptions: EnrollingPeriodOptions;
  EnrollingPeriodSort: EnrollingPeriodSort;
  EnrollingPeriodWhere: EnrollingPeriodWhere;
  EnrollingPeriodsConnection: EnrollingPeriodsConnection;
  EntityTypeMappingRelationship: ResolversInterfaceTypes<ResolversParentTypes>['EntityTypeMappingRelationship'];
  EntityTypeMappingRelationshipSort: EntityTypeMappingRelationshipSort;
  EntityTypeMappingRelationshipWhere: EntityTypeMappingRelationshipWhere;
  EntryModule: EntryModule;
  EntryModuleEdge: EntryModuleEdge;
  EntryModuleOptions: EntryModuleOptions;
  EntryModuleSort: EntryModuleSort;
  EntryModuleWhere: EntryModuleWhere;
  EntryModulesConnection: EntryModulesConnection;
  ExFactoryPrice: ExFactoryPrice;
  ExFactoryPriceEdge: ExFactoryPriceEdge;
  ExFactoryPriceOptions: ExFactoryPriceOptions;
  ExFactoryPriceSort: ExFactoryPriceSort;
  ExFactoryPriceWhere: ExFactoryPriceWhere;
  ExFactoryPricesConnection: ExFactoryPricesConnection;
  ExistingUserInput: ExistingUserInput;
  FileUpload: Scalars['FileUpload']['output'];
  FinancialSummaryColumn: FinancialSummaryColumn;
  FinancialSummaryColumnEdge: FinancialSummaryColumnEdge;
  FinancialSummaryColumnOptions: FinancialSummaryColumnOptions;
  FinancialSummaryColumnSort: FinancialSummaryColumnSort;
  FinancialSummaryColumnWhere: FinancialSummaryColumnWhere;
  FinancialSummaryColumnsConnection: FinancialSummaryColumnsConnection;
  FinancialSummaryConfigInput: FinancialSummaryConfigInput;
  FlexEntitiesConnection: FlexEntitiesConnection;
  FlexEntity: FlexEntity;
  FlexEntityCaseCasesAggregationSelection: FlexEntityCaseCasesAggregationSelection;
  FlexEntityCaseCasesNodeAggregateSelection: FlexEntityCaseCasesNodeAggregateSelection;
  FlexEntityCasesAggregateInput: FlexEntityCasesAggregateInput;
  FlexEntityCasesConnection: FlexEntityCasesConnection;
  FlexEntityCasesConnectionSort: FlexEntityCasesConnectionSort;
  FlexEntityCasesConnectionWhere: FlexEntityCasesConnectionWhere;
  FlexEntityCasesNodeAggregationWhereInput: FlexEntityCasesNodeAggregationWhereInput;
  FlexEntityCasesRelationship: FlexEntityCasesRelationship;
  FlexEntityCreatedByAggregateInput: FlexEntityCreatedByAggregateInput;
  FlexEntityCreatedByConnection: FlexEntityCreatedByConnection;
  FlexEntityCreatedByConnectionSort: FlexEntityCreatedByConnectionSort;
  FlexEntityCreatedByConnectionWhere: FlexEntityCreatedByConnectionWhere;
  FlexEntityCreatedByNodeAggregationWhereInput: FlexEntityCreatedByNodeAggregationWhereInput;
  FlexEntityCreatedByRelationship: FlexEntityCreatedByRelationship;
  FlexEntityEdge: FlexEntityEdge;
  FlexEntityFinancialDataPointsAggregateInput: FlexEntityFinancialDataPointsAggregateInput;
  FlexEntityFinancialDataPointsConnection: FlexEntityFinancialDataPointsConnection;
  FlexEntityFinancialDataPointsConnectionSort: FlexEntityFinancialDataPointsConnectionSort;
  FlexEntityFinancialDataPointsConnectionWhere: FlexEntityFinancialDataPointsConnectionWhere;
  FlexEntityFinancialDataPointsNodeAggregationWhereInput: FlexEntityFinancialDataPointsNodeAggregationWhereInput;
  FlexEntityFinancialDataPointsRelationship: FlexEntityFinancialDataPointsRelationship;
  FlexEntityFlexEntityPredecessorAggregationSelection: FlexEntityFlexEntityPredecessorAggregationSelection;
  FlexEntityFlexEntityPredecessorNodeAggregateSelection: FlexEntityFlexEntityPredecessorNodeAggregateSelection;
  FlexEntityFlexEntitySourceAggregationSelection: FlexEntityFlexEntitySourceAggregationSelection;
  FlexEntityFlexEntitySourceNodeAggregateSelection: FlexEntityFlexEntitySourceNodeAggregateSelection;
  FlexEntityFlexEntitySourcedAggregationSelection: FlexEntityFlexEntitySourcedAggregationSelection;
  FlexEntityFlexEntitySourcedNodeAggregateSelection: FlexEntityFlexEntitySourcedNodeAggregateSelection;
  FlexEntityFlexEntitySuccessorAggregationSelection: FlexEntityFlexEntitySuccessorAggregationSelection;
  FlexEntityFlexEntitySuccessorNodeAggregateSelection: FlexEntityFlexEntitySuccessorNodeAggregateSelection;
  FlexEntityFlexEntityTypeTypeAggregationSelection: FlexEntityFlexEntityTypeTypeAggregationSelection;
  FlexEntityFlexEntityTypeTypeNodeAggregateSelection: FlexEntityFlexEntityTypeTypeNodeAggregateSelection;
  FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection: FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection;
  FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection: FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection;
  FlexEntityGenericGenericsAggregationSelection: FlexEntityGenericGenericsAggregationSelection;
  FlexEntityGenericGenericsNodeAggregateSelection: FlexEntityGenericGenericsNodeAggregateSelection;
  FlexEntityGenericsAggregateInput: FlexEntityGenericsAggregateInput;
  FlexEntityGenericsConnection: FlexEntityGenericsConnection;
  FlexEntityGenericsConnectionSort: FlexEntityGenericsConnectionSort;
  FlexEntityGenericsConnectionWhere: FlexEntityGenericsConnectionWhere;
  FlexEntityGenericsNodeAggregationWhereInput: FlexEntityGenericsNodeAggregationWhereInput;
  FlexEntityGenericsRelationship: FlexEntityGenericsRelationship;
  FlexEntityInput: FlexEntityInput;
  FlexEntityOptions: FlexEntityOptions;
  FlexEntityPatientAggregateInput: FlexEntityPatientAggregateInput;
  FlexEntityPatientConnection: FlexEntityPatientConnection;
  FlexEntityPatientConnectionSort: FlexEntityPatientConnectionSort;
  FlexEntityPatientConnectionWhere: FlexEntityPatientConnectionWhere;
  FlexEntityPatientNodeAggregationWhereInput: FlexEntityPatientNodeAggregationWhereInput;
  FlexEntityPatientPatientAggregationSelection: FlexEntityPatientPatientAggregationSelection;
  FlexEntityPatientPatientNodeAggregateSelection: FlexEntityPatientPatientNodeAggregateSelection;
  FlexEntityPatientRelationship: FlexEntityPatientRelationship;
  FlexEntityPredecessorAggregateInput: FlexEntityPredecessorAggregateInput;
  FlexEntityPredecessorConnection: FlexEntityPredecessorConnection;
  FlexEntityPredecessorConnectionSort: FlexEntityPredecessorConnectionSort;
  FlexEntityPredecessorConnectionWhere: FlexEntityPredecessorConnectionWhere;
  FlexEntityPredecessorNodeAggregationWhereInput: FlexEntityPredecessorNodeAggregationWhereInput;
  FlexEntityPredecessorRelationship: FlexEntityPredecessorRelationship;
  FlexEntityPurchaseAggregateInput: FlexEntityPurchaseAggregateInput;
  FlexEntityPurchaseConnection: FlexEntityPurchaseConnection;
  FlexEntityPurchaseConnectionSort: FlexEntityPurchaseConnectionSort;
  FlexEntityPurchaseConnectionWhere: FlexEntityPurchaseConnectionWhere;
  FlexEntityPurchaseNodeAggregationWhereInput: FlexEntityPurchaseNodeAggregationWhereInput;
  FlexEntityPurchasePurchaseAggregationSelection: FlexEntityPurchasePurchaseAggregationSelection;
  FlexEntityPurchasePurchaseNodeAggregateSelection: FlexEntityPurchasePurchaseNodeAggregateSelection;
  FlexEntityPurchaseRelationship: FlexEntityPurchaseRelationship;
  FlexEntityRowInput: FlexEntityRowInput;
  FlexEntitySectionInput: FlexEntitySectionInput;
  FlexEntitySort: FlexEntitySort;
  FlexEntitySourceAggregateInput: FlexEntitySourceAggregateInput;
  FlexEntitySourceConnection: FlexEntitySourceConnection;
  FlexEntitySourceConnectionSort: FlexEntitySourceConnectionSort;
  FlexEntitySourceConnectionWhere: FlexEntitySourceConnectionWhere;
  FlexEntitySourceNodeAggregationWhereInput: FlexEntitySourceNodeAggregationWhereInput;
  FlexEntitySourceRelationship: FlexEntitySourceRelationship;
  FlexEntitySourcedAggregateInput: FlexEntitySourcedAggregateInput;
  FlexEntitySourcedConnection: FlexEntitySourcedConnection;
  FlexEntitySourcedConnectionSort: FlexEntitySourcedConnectionSort;
  FlexEntitySourcedConnectionWhere: FlexEntitySourcedConnectionWhere;
  FlexEntitySourcedNodeAggregationWhereInput: FlexEntitySourcedNodeAggregationWhereInput;
  FlexEntitySourcedRelationship: FlexEntitySourcedRelationship;
  FlexEntitySuccessorAggregateInput: FlexEntitySuccessorAggregateInput;
  FlexEntitySuccessorConnection: FlexEntitySuccessorConnection;
  FlexEntitySuccessorConnectionSort: FlexEntitySuccessorConnectionSort;
  FlexEntitySuccessorConnectionWhere: FlexEntitySuccessorConnectionWhere;
  FlexEntitySuccessorNodeAggregationWhereInput: FlexEntitySuccessorNodeAggregationWhereInput;
  FlexEntitySuccessorRelationship: FlexEntitySuccessorRelationship;
  FlexEntityType: FlexEntityType;
  FlexEntityTypeAddedByAggregateInput: FlexEntityTypeAddedByAggregateInput;
  FlexEntityTypeAddedByConnection: FlexEntityTypeAddedByConnection;
  FlexEntityTypeAddedByConnectionSort: FlexEntityTypeAddedByConnectionSort;
  FlexEntityTypeAddedByConnectionWhere: FlexEntityTypeAddedByConnectionWhere;
  FlexEntityTypeAddedByNodeAggregationWhereInput: FlexEntityTypeAddedByNodeAggregationWhereInput;
  FlexEntityTypeAddedByRelationship: FlexEntityTypeAddedByRelationship;
  FlexEntityTypeAggregateInput: FlexEntityTypeAggregateInput;
  FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection: FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection;
  FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection: FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection;
  FlexEntityTypeCatalogueAttributeRelationship: ResolversInterfaceTypes<ResolversParentTypes>['FlexEntityTypeCatalogueAttributeRelationship'];
  FlexEntityTypeCatalogueAttributeRelationshipSort: FlexEntityTypeCatalogueAttributeRelationshipSort;
  FlexEntityTypeCatalogueAttributeRelationshipWhere: FlexEntityTypeCatalogueAttributeRelationshipWhere;
  FlexEntityTypeCatalogueAttributesAggregateInput: FlexEntityTypeCatalogueAttributesAggregateInput;
  FlexEntityTypeCatalogueAttributesConnection: FlexEntityTypeCatalogueAttributesConnection;
  FlexEntityTypeCatalogueAttributesConnectionSort: FlexEntityTypeCatalogueAttributesConnectionSort;
  FlexEntityTypeCatalogueAttributesConnectionWhere: FlexEntityTypeCatalogueAttributesConnectionWhere;
  FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput: FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput;
  FlexEntityTypeCatalogueAttributesRelationship: FlexEntityTypeCatalogueAttributesRelationship;
  FlexEntityTypeConnection: FlexEntityTypeConnection;
  FlexEntityTypeConnectionSort: FlexEntityTypeConnectionSort;
  FlexEntityTypeConnectionWhere: FlexEntityTypeConnectionWhere;
  FlexEntityTypeEdge: FlexEntityTypeEdge;
  FlexEntityTypeFlexEntityInstancesAggregationSelection: FlexEntityTypeFlexEntityInstancesAggregationSelection;
  FlexEntityTypeFlexEntityInstancesNodeAggregateSelection: FlexEntityTypeFlexEntityInstancesNodeAggregateSelection;
  FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection: FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection;
  FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection: FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection;
  FlexEntityTypeInstancesAggregateInput: FlexEntityTypeInstancesAggregateInput;
  FlexEntityTypeInstancesConnection: FlexEntityTypeInstancesConnection;
  FlexEntityTypeInstancesConnectionSort: FlexEntityTypeInstancesConnectionSort;
  FlexEntityTypeInstancesConnectionWhere: FlexEntityTypeInstancesConnectionWhere;
  FlexEntityTypeInstancesNodeAggregationWhereInput: FlexEntityTypeInstancesNodeAggregationWhereInput;
  FlexEntityTypeInstancesRelationship: FlexEntityTypeInstancesRelationship;
  FlexEntityTypeMappingInstancesAggregateInput: FlexEntityTypeMappingInstancesAggregateInput;
  FlexEntityTypeMappingInstancesConnection: FlexEntityTypeMappingInstancesConnection;
  FlexEntityTypeMappingInstancesConnectionSort: FlexEntityTypeMappingInstancesConnectionSort;
  FlexEntityTypeMappingInstancesConnectionWhere: FlexEntityTypeMappingInstancesConnectionWhere;
  FlexEntityTypeMappingInstancesEdgeAggregationWhereInput: FlexEntityTypeMappingInstancesEdgeAggregationWhereInput;
  FlexEntityTypeMappingInstancesNodeAggregationWhereInput: FlexEntityTypeMappingInstancesNodeAggregationWhereInput;
  FlexEntityTypeMappingInstancesRelationship: FlexEntityTypeMappingInstancesRelationship;
  FlexEntityTypeNodeAggregationWhereInput: FlexEntityTypeNodeAggregationWhereInput;
  FlexEntityTypeOptions: FlexEntityTypeOptions;
  FlexEntityTypeOrganizationMappingInstancesAggregationSelection: FlexEntityTypeOrganizationMappingInstancesAggregationSelection;
  FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection: FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection;
  FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection: FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection;
  FlexEntityTypeRecordTypesAggregateInput: FlexEntityTypeRecordTypesAggregateInput;
  FlexEntityTypeRecordTypesConnection: FlexEntityTypeRecordTypesConnection;
  FlexEntityTypeRecordTypesConnectionSort: FlexEntityTypeRecordTypesConnectionSort;
  FlexEntityTypeRecordTypesConnectionWhere: FlexEntityTypeRecordTypesConnectionWhere;
  FlexEntityTypeRecordTypesNodeAggregationWhereInput: FlexEntityTypeRecordTypesNodeAggregationWhereInput;
  FlexEntityTypeRecordTypesRelationship: FlexEntityTypeRecordTypesRelationship;
  FlexEntityTypeRelationship: FlexEntityTypeRelationship;
  FlexEntityTypeSort: FlexEntityTypeSort;
  FlexEntityTypeUserAddedByAggregationSelection: FlexEntityTypeUserAddedByAggregationSelection;
  FlexEntityTypeUserAddedByNodeAggregateSelection: FlexEntityTypeUserAddedByNodeAggregateSelection;
  FlexEntityTypeWhere: FlexEntityTypeWhere;
  FlexEntityTypesConnection: FlexEntityTypesConnection;
  FlexEntityUploadAggregateInput: FlexEntityUploadAggregateInput;
  FlexEntityUploadConnection: FlexEntityUploadConnection;
  FlexEntityUploadConnectionSort: FlexEntityUploadConnectionSort;
  FlexEntityUploadConnectionWhere: FlexEntityUploadConnectionWhere;
  FlexEntityUploadNodeAggregationWhereInput: FlexEntityUploadNodeAggregationWhereInput;
  FlexEntityUploadRelationship: FlexEntityUploadRelationship;
  FlexEntityUploadUploadAggregationSelection: FlexEntityUploadUploadAggregationSelection;
  FlexEntityUploadUploadNodeAggregateSelection: FlexEntityUploadUploadNodeAggregateSelection;
  FlexEntityUserCreatedByAggregationSelection: FlexEntityUserCreatedByAggregationSelection;
  FlexEntityUserCreatedByNodeAggregateSelection: FlexEntityUserCreatedByNodeAggregateSelection;
  FlexEntityWhere: FlexEntityWhere;
  FlexFieldsInput: FlexFieldsInput;
  FlexFinancialDataPoint: FlexFinancialDataPoint;
  FlexFinancialDataPointAgreementAggregateInput: FlexFinancialDataPointAgreementAggregateInput;
  FlexFinancialDataPointAgreementAgreementAggregationSelection: FlexFinancialDataPointAgreementAgreementAggregationSelection;
  FlexFinancialDataPointAgreementAgreementNodeAggregateSelection: FlexFinancialDataPointAgreementAgreementNodeAggregateSelection;
  FlexFinancialDataPointAgreementConnection: FlexFinancialDataPointAgreementConnection;
  FlexFinancialDataPointAgreementConnectionSort: FlexFinancialDataPointAgreementConnectionSort;
  FlexFinancialDataPointAgreementConnectionWhere: FlexFinancialDataPointAgreementConnectionWhere;
  FlexFinancialDataPointAgreementNodeAggregationWhereInput: FlexFinancialDataPointAgreementNodeAggregationWhereInput;
  FlexFinancialDataPointAgreementRelationship: FlexFinancialDataPointAgreementRelationship;
  FlexFinancialDataPointCaseGeneratedForAggregationSelection: FlexFinancialDataPointCaseGeneratedForAggregationSelection;
  FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection: FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection;
  FlexFinancialDataPointEdge: FlexFinancialDataPointEdge;
  FlexFinancialDataPointEvaluatesAggregateInput: FlexFinancialDataPointEvaluatesAggregateInput;
  FlexFinancialDataPointEvaluatesConnection: FlexFinancialDataPointEvaluatesConnection;
  FlexFinancialDataPointEvaluatesConnectionSort: FlexFinancialDataPointEvaluatesConnectionSort;
  FlexFinancialDataPointEvaluatesConnectionWhere: FlexFinancialDataPointEvaluatesConnectionWhere;
  FlexFinancialDataPointEvaluatesNodeAggregationWhereInput: FlexFinancialDataPointEvaluatesNodeAggregationWhereInput;
  FlexFinancialDataPointEvaluatesRelationship: FlexFinancialDataPointEvaluatesRelationship;
  FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection: FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection;
  FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection: FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection;
  FlexFinancialDataPointGeneratedForAggregateInput: FlexFinancialDataPointGeneratedForAggregateInput;
  FlexFinancialDataPointGeneratedForConnection: FlexFinancialDataPointGeneratedForConnection;
  FlexFinancialDataPointGeneratedForConnectionSort: FlexFinancialDataPointGeneratedForConnectionSort;
  FlexFinancialDataPointGeneratedForConnectionWhere: FlexFinancialDataPointGeneratedForConnectionWhere;
  FlexFinancialDataPointGeneratedForNodeAggregationWhereInput: FlexFinancialDataPointGeneratedForNodeAggregationWhereInput;
  FlexFinancialDataPointGeneratedForRelationship: FlexFinancialDataPointGeneratedForRelationship;
  FlexFinancialDataPointOptions: FlexFinancialDataPointOptions;
  FlexFinancialDataPointRefundSourceDocumentAggregationSelection: FlexFinancialDataPointRefundSourceDocumentAggregationSelection;
  FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection: FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection;
  FlexFinancialDataPointRefundSourceRefundAggregationSelection: FlexFinancialDataPointRefundSourceRefundAggregationSelection;
  FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection: FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection;
  FlexFinancialDataPointSort: FlexFinancialDataPointSort;
  FlexFinancialDataPointSourceDocumentAggregateInput: FlexFinancialDataPointSourceDocumentAggregateInput;
  FlexFinancialDataPointSourceDocumentConnection: FlexFinancialDataPointSourceDocumentConnection;
  FlexFinancialDataPointSourceDocumentConnectionSort: FlexFinancialDataPointSourceDocumentConnectionSort;
  FlexFinancialDataPointSourceDocumentConnectionWhere: FlexFinancialDataPointSourceDocumentConnectionWhere;
  FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput: FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput;
  FlexFinancialDataPointSourceDocumentRelationship: FlexFinancialDataPointSourceDocumentRelationship;
  FlexFinancialDataPointSourceRefundAggregateInput: FlexFinancialDataPointSourceRefundAggregateInput;
  FlexFinancialDataPointSourceRefundConnection: FlexFinancialDataPointSourceRefundConnection;
  FlexFinancialDataPointSourceRefundConnectionSort: FlexFinancialDataPointSourceRefundConnectionSort;
  FlexFinancialDataPointSourceRefundConnectionWhere: FlexFinancialDataPointSourceRefundConnectionWhere;
  FlexFinancialDataPointSourceRefundNodeAggregationWhereInput: FlexFinancialDataPointSourceRefundNodeAggregationWhereInput;
  FlexFinancialDataPointSourceRefundRelationship: FlexFinancialDataPointSourceRefundRelationship;
  FlexFinancialDataPointTreatmentAggregateInput: FlexFinancialDataPointTreatmentAggregateInput;
  FlexFinancialDataPointTreatmentConnection: FlexFinancialDataPointTreatmentConnection;
  FlexFinancialDataPointTreatmentConnectionSort: FlexFinancialDataPointTreatmentConnectionSort;
  FlexFinancialDataPointTreatmentConnectionWhere: FlexFinancialDataPointTreatmentConnectionWhere;
  FlexFinancialDataPointTreatmentNodeAggregationWhereInput: FlexFinancialDataPointTreatmentNodeAggregationWhereInput;
  FlexFinancialDataPointTreatmentRelationship: FlexFinancialDataPointTreatmentRelationship;
  FlexFinancialDataPointTreatmentTreatmentAggregationSelection: FlexFinancialDataPointTreatmentTreatmentAggregationSelection;
  FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection: FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection;
  FlexFinancialDataPointWhere: FlexFinancialDataPointWhere;
  FlexFinancialDataPointsConnection: FlexFinancialDataPointsConnection;
  FlexQueriesConnection: FlexQueriesConnection;
  FlexQuery: FlexQuery;
  FlexQueryCreatedByAggregateInput: FlexQueryCreatedByAggregateInput;
  FlexQueryCreatedByConnection: FlexQueryCreatedByConnection;
  FlexQueryCreatedByConnectionSort: FlexQueryCreatedByConnectionSort;
  FlexQueryCreatedByConnectionWhere: FlexQueryCreatedByConnectionWhere;
  FlexQueryCreatedByNodeAggregationWhereInput: FlexQueryCreatedByNodeAggregationWhereInput;
  FlexQueryCreatedByRelationship: FlexQueryCreatedByRelationship;
  FlexQueryEdge: FlexQueryEdge;
  FlexQueryFlexQueryRunRunsAggregationSelection: FlexQueryFlexQueryRunRunsAggregationSelection;
  FlexQueryFlexQueryRunRunsNodeAggregateSelection: FlexQueryFlexQueryRunRunsNodeAggregateSelection;
  FlexQueryInput: FlexQueryInput;
  FlexQueryOptions: FlexQueryOptions;
  FlexQueryRun: FlexQueryRun;
  FlexQueryRunEdge: FlexQueryRunEdge;
  FlexQueryRunFlexQueryQueryAggregationSelection: FlexQueryRunFlexQueryQueryAggregationSelection;
  FlexQueryRunFlexQueryQueryNodeAggregateSelection: FlexQueryRunFlexQueryQueryNodeAggregateSelection;
  FlexQueryRunOptions: FlexQueryRunOptions;
  FlexQueryRunQueryAggregateInput: FlexQueryRunQueryAggregateInput;
  FlexQueryRunQueryConnection: FlexQueryRunQueryConnection;
  FlexQueryRunQueryConnectionSort: FlexQueryRunQueryConnectionSort;
  FlexQueryRunQueryConnectionWhere: FlexQueryRunQueryConnectionWhere;
  FlexQueryRunQueryNodeAggregationWhereInput: FlexQueryRunQueryNodeAggregationWhereInput;
  FlexQueryRunQueryRelationship: FlexQueryRunQueryRelationship;
  FlexQueryRunSort: FlexQueryRunSort;
  FlexQueryRunStartedByAggregateInput: FlexQueryRunStartedByAggregateInput;
  FlexQueryRunStartedByConnection: FlexQueryRunStartedByConnection;
  FlexQueryRunStartedByConnectionSort: FlexQueryRunStartedByConnectionSort;
  FlexQueryRunStartedByConnectionWhere: FlexQueryRunStartedByConnectionWhere;
  FlexQueryRunStartedByNodeAggregationWhereInput: FlexQueryRunStartedByNodeAggregationWhereInput;
  FlexQueryRunStartedByRelationship: FlexQueryRunStartedByRelationship;
  FlexQueryRunUserStartedByAggregationSelection: FlexQueryRunUserStartedByAggregationSelection;
  FlexQueryRunUserStartedByNodeAggregateSelection: FlexQueryRunUserStartedByNodeAggregateSelection;
  FlexQueryRunWhere: FlexQueryRunWhere;
  FlexQueryRunsAggregateInput: FlexQueryRunsAggregateInput;
  FlexQueryRunsConnection: FlexQueryRunsConnection;
  FlexQueryRunsConnectionSort: FlexQueryRunsConnectionSort;
  FlexQueryRunsConnectionWhere: FlexQueryRunsConnectionWhere;
  FlexQueryRunsNodeAggregationWhereInput: FlexQueryRunsNodeAggregationWhereInput;
  FlexQueryRunsRelationship: FlexQueryRunsRelationship;
  FlexQuerySort: FlexQuerySort;
  FlexQueryUpdatedByAggregateInput: FlexQueryUpdatedByAggregateInput;
  FlexQueryUpdatedByConnection: FlexQueryUpdatedByConnection;
  FlexQueryUpdatedByConnectionSort: FlexQueryUpdatedByConnectionSort;
  FlexQueryUpdatedByConnectionWhere: FlexQueryUpdatedByConnectionWhere;
  FlexQueryUpdatedByNodeAggregationWhereInput: FlexQueryUpdatedByNodeAggregationWhereInput;
  FlexQueryUpdatedByRelationship: FlexQueryUpdatedByRelationship;
  FlexQueryUserCreatedByAggregationSelection: FlexQueryUserCreatedByAggregationSelection;
  FlexQueryUserCreatedByNodeAggregateSelection: FlexQueryUserCreatedByNodeAggregateSelection;
  FlexQueryUserUpdatedByAggregationSelection: FlexQueryUserUpdatedByAggregationSelection;
  FlexQueryUserUpdatedByNodeAggregateSelection: FlexQueryUserUpdatedByNodeAggregateSelection;
  FlexQueryWhere: FlexQueryWhere;
  Float: Scalars['Float']['output'];
  FloatAggregateSelectionNonNullable: FloatAggregateSelectionNonNullable;
  FloatAggregateSelectionNullable: FloatAggregateSelectionNullable;
  Generic: Generic;
  GenericCreatedByAggregateInput: GenericCreatedByAggregateInput;
  GenericCreatedByConnection: GenericCreatedByConnection;
  GenericCreatedByConnectionSort: GenericCreatedByConnectionSort;
  GenericCreatedByConnectionWhere: GenericCreatedByConnectionWhere;
  GenericCreatedByNodeAggregationWhereInput: GenericCreatedByNodeAggregationWhereInput;
  GenericCreatedByRelationship: GenericCreatedByRelationship;
  GenericEdge: GenericEdge;
  GenericInput: GenericInput;
  GenericOptions: GenericOptions;
  GenericPreparationPreparationsAggregationSelection: GenericPreparationPreparationsAggregationSelection;
  GenericPreparationPreparationsNodeAggregateSelection: GenericPreparationPreparationsNodeAggregateSelection;
  GenericPreparationsAggregateInput: GenericPreparationsAggregateInput;
  GenericPreparationsConnection: GenericPreparationsConnection;
  GenericPreparationsConnectionSort: GenericPreparationsConnectionSort;
  GenericPreparationsConnectionWhere: GenericPreparationsConnectionWhere;
  GenericPreparationsNodeAggregationWhereInput: GenericPreparationsNodeAggregationWhereInput;
  GenericPreparationsRelationship: GenericPreparationsRelationship;
  GenericSort: GenericSort;
  GenericTreatmentSetTreatmentSetsAggregationSelection: GenericTreatmentSetTreatmentSetsAggregationSelection;
  GenericTreatmentSetTreatmentSetsNodeAggregateSelection: GenericTreatmentSetTreatmentSetsNodeAggregateSelection;
  GenericTreatmentSetsAggregateInput: GenericTreatmentSetsAggregateInput;
  GenericTreatmentSetsConnection: GenericTreatmentSetsConnection;
  GenericTreatmentSetsConnectionSort: GenericTreatmentSetsConnectionSort;
  GenericTreatmentSetsConnectionWhere: GenericTreatmentSetsConnectionWhere;
  GenericTreatmentSetsNodeAggregationWhereInput: GenericTreatmentSetsNodeAggregationWhereInput;
  GenericTreatmentSetsRelationship: GenericTreatmentSetsRelationship;
  GenericUserCreatedByAggregationSelection: GenericUserCreatedByAggregationSelection;
  GenericUserCreatedByNodeAggregateSelection: GenericUserCreatedByNodeAggregateSelection;
  GenericWhere: GenericWhere;
  GenericsConnection: GenericsConnection;
  GetBrandReportItem: GetBrandReportItem;
  GetBrandReportItemEdge: GetBrandReportItemEdge;
  GetBrandReportItemOptions: GetBrandReportItemOptions;
  GetBrandReportItemSort: GetBrandReportItemSort;
  GetBrandReportItemWhere: GetBrandReportItemWhere;
  GetBrandReportItemsConnection: GetBrandReportItemsConnection;
  GetIndicationReportItem: GetIndicationReportItem;
  GetIndicationReportItemEdge: GetIndicationReportItemEdge;
  GetIndicationReportItemOptions: GetIndicationReportItemOptions;
  GetIndicationReportItemSort: GetIndicationReportItemSort;
  GetIndicationReportItemWhere: GetIndicationReportItemWhere;
  GetIndicationReportItemsConnection: GetIndicationReportItemsConnection;
  GetTranslationsVariables: GetTranslationsVariables;
  GlobalLock: GlobalLock;
  GlobalLockCreatorAggregateInput: GlobalLockCreatorAggregateInput;
  GlobalLockCreatorConnection: GlobalLockCreatorConnection;
  GlobalLockCreatorConnectionSort: GlobalLockCreatorConnectionSort;
  GlobalLockCreatorConnectionWhere: GlobalLockCreatorConnectionWhere;
  GlobalLockCreatorNodeAggregationWhereInput: GlobalLockCreatorNodeAggregationWhereInput;
  GlobalLockCreatorRelationship: GlobalLockCreatorRelationship;
  GlobalLockEdge: GlobalLockEdge;
  GlobalLockOptions: GlobalLockOptions;
  GlobalLockSort: GlobalLockSort;
  GlobalLockUserCreatorAggregationSelection: GlobalLockUserCreatorAggregationSelection;
  GlobalLockUserCreatorNodeAggregateSelection: GlobalLockUserCreatorNodeAggregateSelection;
  GlobalLockWhere: GlobalLockWhere;
  GlobalLocksConnection: GlobalLocksConnection;
  ID: Scalars['ID']['output'];
  IDAggregateSelectionNonNullable: IdAggregateSelectionNonNullable;
  IDAggregateSelectionNullable: IdAggregateSelectionNullable;
  ITimeframe: ResolversInterfaceTypes<ResolversParentTypes>['ITimeframe'];
  ITreatmentCondition: ResolversInterfaceTypes<ResolversParentTypes>['ITreatmentCondition'];
  Icd10Attribute: Icd10Attribute;
  Icd10AttributeEdge: Icd10AttributeEdge;
  Icd10AttributeOptions: Icd10AttributeOptions;
  Icd10AttributeSort: Icd10AttributeSort;
  Icd10AttributeWhere: Icd10AttributeWhere;
  Icd10AttributesConnection: Icd10AttributesConnection;
  Icd10Concept: Icd10Concept;
  Icd10ConceptEdge: Icd10ConceptEdge;
  Icd10ConceptOptions: Icd10ConceptOptions;
  Icd10ConceptSort: Icd10ConceptSort;
  Icd10ConceptWhere: Icd10ConceptWhere;
  Icd10ConceptsConnection: Icd10ConceptsConnection;
  Icd10EntitiesConnection: Icd10EntitiesConnection;
  Icd10Entity: Icd10Entity;
  Icd10EntityEdge: Icd10EntityEdge;
  Icd10EntityOptions: Icd10EntityOptions;
  Icd10EntitySort: Icd10EntitySort;
  Icd10EntityWhere: Icd10EntityWhere;
  Icd10Suggestions: Icd10Suggestions;
  Icd10SuggestionsConnection: Icd10SuggestionsConnection;
  Icd10SuggestionsEdge: Icd10SuggestionsEdge;
  Icd10SuggestionsOptions: Icd10SuggestionsOptions;
  Icd10SuggestionsSort: Icd10SuggestionsSort;
  Icd10SuggestionsWhere: Icd10SuggestionsWhere;
  Icd10Trait: Icd10Trait;
  Icd10TraitEdge: Icd10TraitEdge;
  Icd10TraitOptions: Icd10TraitOptions;
  Icd10TraitSort: Icd10TraitSort;
  Icd10TraitWhere: Icd10TraitWhere;
  Icd10TraitsConnection: Icd10TraitsConnection;
  ImpactItem: ImpactItem;
  ImpactItemEdge: ImpactItemEdge;
  ImpactItemOptions: ImpactItemOptions;
  ImpactItemSort: ImpactItemSort;
  ImpactItemWhere: ImpactItemWhere;
  ImpactItemsConnection: ImpactItemsConnection;
  Indication: Indication;
  IndicationEdge: IndicationEdge;
  IndicationInput: IndicationInput;
  IndicationOptions: IndicationOptions;
  IndicationSort: IndicationSort;
  IndicationWhere: IndicationWhere;
  IndicationsConnection: IndicationsConnection;
  Int: Scalars['Int']['output'];
  IntAggregateSelectionNonNullable: IntAggregateSelectionNonNullable;
  IntAggregateSelectionNullable: IntAggregateSelectionNullable;
  IntegrityCheckCompleteResult: IntegrityCheckCompleteResult;
  IntegrityCheckCompleteResultEdge: IntegrityCheckCompleteResultEdge;
  IntegrityCheckCompleteResultOptions: IntegrityCheckCompleteResultOptions;
  IntegrityCheckCompleteResultSort: IntegrityCheckCompleteResultSort;
  IntegrityCheckCompleteResultWhere: IntegrityCheckCompleteResultWhere;
  IntegrityCheckCompleteResultsConnection: IntegrityCheckCompleteResultsConnection;
  IntegrityCheckTypes: IntegrityCheckTypes;
  IntegrityCheckTypesConnection: IntegrityCheckTypesConnection;
  IntegrityCheckTypesEdge: IntegrityCheckTypesEdge;
  IntegrityCheckTypesOptions: IntegrityCheckTypesOptions;
  IntegrityCheckTypesWhere: IntegrityCheckTypesWhere;
  Limitation: Limitation;
  LimitationAgreementTemplateAggregateInput: LimitationAgreementTemplateAggregateInput;
  LimitationAgreementTemplateAgreementTemplateAggregationSelection: LimitationAgreementTemplateAgreementTemplateAggregationSelection;
  LimitationAgreementTemplateAgreementTemplateNodeAggregateSelection: LimitationAgreementTemplateAgreementTemplateNodeAggregateSelection;
  LimitationAgreementTemplateConnection: LimitationAgreementTemplateConnection;
  LimitationAgreementTemplateConnectionSort: LimitationAgreementTemplateConnectionSort;
  LimitationAgreementTemplateConnectionWhere: LimitationAgreementTemplateConnectionWhere;
  LimitationAgreementTemplateNodeAggregationWhereInput: LimitationAgreementTemplateNodeAggregationWhereInput;
  LimitationAgreementTemplateRelationship: LimitationAgreementTemplateRelationship;
  LimitationEdge: LimitationEdge;
  LimitationLimitsPreparationsAggregateInput: LimitationLimitsPreparationsAggregateInput;
  LimitationLimitsPreparationsConnection: LimitationLimitsPreparationsConnection;
  LimitationLimitsPreparationsConnectionSort: LimitationLimitsPreparationsConnectionSort;
  LimitationLimitsPreparationsConnectionWhere: LimitationLimitsPreparationsConnectionWhere;
  LimitationLimitsPreparationsNodeAggregationWhereInput: LimitationLimitsPreparationsNodeAggregationWhereInput;
  LimitationLimitsPreparationsRelationship: LimitationLimitsPreparationsRelationship;
  LimitationLimitsTreatmentsBySelfAggregateInput: LimitationLimitsTreatmentsBySelfAggregateInput;
  LimitationLimitsTreatmentsBySelfConnection: LimitationLimitsTreatmentsBySelfConnection;
  LimitationLimitsTreatmentsBySelfConnectionSort: LimitationLimitsTreatmentsBySelfConnectionSort;
  LimitationLimitsTreatmentsBySelfConnectionWhere: LimitationLimitsTreatmentsBySelfConnectionWhere;
  LimitationLimitsTreatmentsBySelfNodeAggregationWhereInput: LimitationLimitsTreatmentsBySelfNodeAggregationWhereInput;
  LimitationLimitsTreatmentsBySelfRelationship: LimitationLimitsTreatmentsBySelfRelationship;
  LimitationLimitsTreatmentsThroughPreparationAggregateInput: LimitationLimitsTreatmentsThroughPreparationAggregateInput;
  LimitationLimitsTreatmentsThroughPreparationConnection: LimitationLimitsTreatmentsThroughPreparationConnection;
  LimitationLimitsTreatmentsThroughPreparationConnectionSort: LimitationLimitsTreatmentsThroughPreparationConnectionSort;
  LimitationLimitsTreatmentsThroughPreparationConnectionWhere: LimitationLimitsTreatmentsThroughPreparationConnectionWhere;
  LimitationLimitsTreatmentsThroughPreparationNodeAggregationWhereInput: LimitationLimitsTreatmentsThroughPreparationNodeAggregationWhereInput;
  LimitationLimitsTreatmentsThroughPreparationRelationship: LimitationLimitsTreatmentsThroughPreparationRelationship;
  LimitationOptions: LimitationOptions;
  LimitationPreparationLimitsPreparationsAggregationSelection: LimitationPreparationLimitsPreparationsAggregationSelection;
  LimitationPreparationLimitsPreparationsNodeAggregateSelection: LimitationPreparationLimitsPreparationsNodeAggregateSelection;
  LimitationSort: LimitationSort;
  LimitationTreatmentLimitsTreatmentsBySelfAggregationSelection: LimitationTreatmentLimitsTreatmentsBySelfAggregationSelection;
  LimitationTreatmentLimitsTreatmentsBySelfNodeAggregateSelection: LimitationTreatmentLimitsTreatmentsBySelfNodeAggregateSelection;
  LimitationTreatmentLimitsTreatmentsThroughPreparationAggregationSelection: LimitationTreatmentLimitsTreatmentsThroughPreparationAggregationSelection;
  LimitationTreatmentLimitsTreatmentsThroughPreparationNodeAggregateSelection: LimitationTreatmentLimitsTreatmentsThroughPreparationNodeAggregateSelection;
  LimitationWhere: LimitationWhere;
  LimitationsConnection: LimitationsConnection;
  LocalizationKeySuggestions: LocalizationKeySuggestions;
  LocalizationKeySuggestionsConnection: LocalizationKeySuggestionsConnection;
  LocalizationKeySuggestionsEdge: LocalizationKeySuggestionsEdge;
  LocalizationKeySuggestionsOptions: LocalizationKeySuggestionsOptions;
  LocalizationKeySuggestionsSort: LocalizationKeySuggestionsSort;
  LocalizationKeySuggestionsWhere: LocalizationKeySuggestionsWhere;
  MainIndication: MainIndication;
  MainIndicationArticle71IndicationAggregateInput: MainIndicationArticle71IndicationAggregateInput;
  MainIndicationArticle71IndicationArticle71IndicationAggregationSelection: MainIndicationArticle71IndicationArticle71IndicationAggregationSelection;
  MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection: MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection;
  MainIndicationArticle71IndicationConnection: MainIndicationArticle71IndicationConnection;
  MainIndicationArticle71IndicationConnectionSort: MainIndicationArticle71IndicationConnectionSort;
  MainIndicationArticle71IndicationConnectionWhere: MainIndicationArticle71IndicationConnectionWhere;
  MainIndicationArticle71IndicationNodeAggregationWhereInput: MainIndicationArticle71IndicationNodeAggregationWhereInput;
  MainIndicationArticle71IndicationRelationship: MainIndicationArticle71IndicationRelationship;
  MainIndicationBrandAggregateInput: MainIndicationBrandAggregateInput;
  MainIndicationBrandBrandAggregationSelection: MainIndicationBrandBrandAggregationSelection;
  MainIndicationBrandBrandNodeAggregateSelection: MainIndicationBrandBrandNodeAggregateSelection;
  MainIndicationBrandConnection: MainIndicationBrandConnection;
  MainIndicationBrandConnectionSort: MainIndicationBrandConnectionSort;
  MainIndicationBrandConnectionWhere: MainIndicationBrandConnectionWhere;
  MainIndicationBrandNodeAggregationWhereInput: MainIndicationBrandNodeAggregationWhereInput;
  MainIndicationBrandRelationship: MainIndicationBrandRelationship;
  MainIndicationEdge: MainIndicationEdge;
  MainIndicationInput: MainIndicationInput;
  MainIndicationOptions: MainIndicationOptions;
  MainIndicationSort: MainIndicationSort;
  MainIndicationWhere: MainIndicationWhere;
  MainIndicationsConnection: MainIndicationsConnection;
  MasterDataRefundImpact: MasterDataRefundImpact;
  MasterDataRefundImpactEdge: MasterDataRefundImpactEdge;
  MasterDataRefundImpactOptions: MasterDataRefundImpactOptions;
  MasterDataRefundImpactSort: MasterDataRefundImpactSort;
  MasterDataRefundImpactWhere: MasterDataRefundImpactWhere;
  MasterDataRefundImpactsConnection: MasterDataRefundImpactsConnection;
  MasterDataUploadHistoryRecord: MasterDataUploadHistoryRecord;
  MasterDataUploadHistoryRecordEdge: MasterDataUploadHistoryRecordEdge;
  MasterDataUploadHistoryRecordOptions: MasterDataUploadHistoryRecordOptions;
  MasterDataUploadHistoryRecordSort: MasterDataUploadHistoryRecordSort;
  MasterDataUploadHistoryRecordWhere: MasterDataUploadHistoryRecordWhere;
  MasterDataUploadHistoryRecordsConnection: MasterDataUploadHistoryRecordsConnection;
  Message: Message;
  MessageCaseAggregateInput: MessageCaseAggregateInput;
  MessageCaseCaseAggregationSelection: MessageCaseCaseAggregationSelection;
  MessageCaseCaseNodeAggregateSelection: MessageCaseCaseNodeAggregateSelection;
  MessageCaseConnection: MessageCaseConnection;
  MessageCaseConnectionSort: MessageCaseConnectionSort;
  MessageCaseConnectionWhere: MessageCaseConnectionWhere;
  MessageCaseNodeAggregationWhereInput: MessageCaseNodeAggregationWhereInput;
  MessageCaseRelationship: MessageCaseRelationship;
  MessageEdge: MessageEdge;
  MessageMentionsAggregateInput: MessageMentionsAggregateInput;
  MessageMentionsConnection: MessageMentionsConnection;
  MessageMentionsConnectionSort: MessageMentionsConnectionSort;
  MessageMentionsConnectionWhere: MessageMentionsConnectionWhere;
  MessageMentionsNodeAggregationWhereInput: MessageMentionsNodeAggregationWhereInput;
  MessageMentionsRelationship: MessageMentionsRelationship;
  MessageOptions: MessageOptions;
  MessageSentByAggregateInput: MessageSentByAggregateInput;
  MessageSentByConnection: MessageSentByConnection;
  MessageSentByConnectionSort: MessageSentByConnectionSort;
  MessageSentByConnectionWhere: MessageSentByConnectionWhere;
  MessageSentByNodeAggregationWhereInput: MessageSentByNodeAggregationWhereInput;
  MessageSentByRelationship: MessageSentByRelationship;
  MessageSort: MessageSort;
  MessageUserMentionsAggregationSelection: MessageUserMentionsAggregationSelection;
  MessageUserMentionsNodeAggregateSelection: MessageUserMentionsNodeAggregateSelection;
  MessageUserSentByAggregationSelection: MessageUserSentByAggregationSelection;
  MessageUserSentByNodeAggregateSelection: MessageUserSentByNodeAggregateSelection;
  MessageWhere: MessageWhere;
  MessagesConnection: MessagesConnection;
  MissingTranslationKeys: MissingTranslationKeys;
  MissingTranslationKeysConnection: MissingTranslationKeysConnection;
  MissingTranslationKeysEdge: MissingTranslationKeysEdge;
  MissingTranslationKeysOptions: MissingTranslationKeysOptions;
  MissingTranslationKeysSort: MissingTranslationKeysSort;
  MissingTranslationKeysWhere: MissingTranslationKeysWhere;
  Module: Module;
  ModuleEdge: ModuleEdge;
  ModuleInput: ModuleInput;
  ModuleOptions: ModuleOptions;
  ModuleSort: ModuleSort;
  ModuleWhere: ModuleWhere;
  ModulesConnection: ModulesConnection;
  Mutation: {};
  NegotiationRound: NegotiationRound;
  NegotiationRoundCaseAggregateInput: NegotiationRoundCaseAggregateInput;
  NegotiationRoundCaseCaseAggregationSelection: NegotiationRoundCaseCaseAggregationSelection;
  NegotiationRoundCaseCaseNodeAggregateSelection: NegotiationRoundCaseCaseNodeAggregateSelection;
  NegotiationRoundCaseConnection: NegotiationRoundCaseConnection;
  NegotiationRoundCaseConnectionSort: NegotiationRoundCaseConnectionSort;
  NegotiationRoundCaseConnectionWhere: NegotiationRoundCaseConnectionWhere;
  NegotiationRoundCaseNodeAggregationWhereInput: NegotiationRoundCaseNodeAggregationWhereInput;
  NegotiationRoundCaseRelationship: NegotiationRoundCaseRelationship;
  NegotiationRoundEdge: NegotiationRoundEdge;
  NegotiationRoundFlexEntitySourceAggregationSelection: NegotiationRoundFlexEntitySourceAggregationSelection;
  NegotiationRoundFlexEntitySourceNodeAggregateSelection: NegotiationRoundFlexEntitySourceNodeAggregateSelection;
  NegotiationRoundOptions: NegotiationRoundOptions;
  NegotiationRoundOrganizationProposedByAggregationSelection: NegotiationRoundOrganizationProposedByAggregationSelection;
  NegotiationRoundOrganizationProposedByNodeAggregateSelection: NegotiationRoundOrganizationProposedByNodeAggregateSelection;
  NegotiationRoundProposedByAggregateInput: NegotiationRoundProposedByAggregateInput;
  NegotiationRoundProposedByConnection: NegotiationRoundProposedByConnection;
  NegotiationRoundProposedByConnectionSort: NegotiationRoundProposedByConnectionSort;
  NegotiationRoundProposedByConnectionWhere: NegotiationRoundProposedByConnectionWhere;
  NegotiationRoundProposedByNodeAggregationWhereInput: NegotiationRoundProposedByNodeAggregationWhereInput;
  NegotiationRoundProposedByRelationship: NegotiationRoundProposedByRelationship;
  NegotiationRoundSort: NegotiationRoundSort;
  NegotiationRoundSourceAggregateInput: NegotiationRoundSourceAggregateInput;
  NegotiationRoundSourceConnection: NegotiationRoundSourceConnection;
  NegotiationRoundSourceConnectionSort: NegotiationRoundSourceConnectionSort;
  NegotiationRoundSourceConnectionWhere: NegotiationRoundSourceConnectionWhere;
  NegotiationRoundSourceNodeAggregationWhereInput: NegotiationRoundSourceNodeAggregationWhereInput;
  NegotiationRoundSourceRelationship: NegotiationRoundSourceRelationship;
  NegotiationRoundUpdatedByAggregateInput: NegotiationRoundUpdatedByAggregateInput;
  NegotiationRoundUpdatedByConnection: NegotiationRoundUpdatedByConnection;
  NegotiationRoundUpdatedByConnectionSort: NegotiationRoundUpdatedByConnectionSort;
  NegotiationRoundUpdatedByConnectionWhere: NegotiationRoundUpdatedByConnectionWhere;
  NegotiationRoundUpdatedByNodeAggregationWhereInput: NegotiationRoundUpdatedByNodeAggregationWhereInput;
  NegotiationRoundUpdatedByRelationship: NegotiationRoundUpdatedByRelationship;
  NegotiationRoundUserUpdatedByAggregationSelection: NegotiationRoundUserUpdatedByAggregationSelection;
  NegotiationRoundUserUpdatedByNodeAggregateSelection: NegotiationRoundUserUpdatedByNodeAggregateSelection;
  NegotiationRoundWhere: NegotiationRoundWhere;
  NegotiationRoundsConnection: NegotiationRoundsConnection;
  Neo4JClusterMemberMetricsConnection: Neo4JClusterMemberMetricsConnection;
  Neo4JClusterMetricsConnection: Neo4JClusterMetricsConnection;
  Neo4jClusterMemberMetric: Neo4jClusterMemberMetric;
  Neo4jClusterMemberMetricEdge: Neo4jClusterMemberMetricEdge;
  Neo4jClusterMemberMetricOptions: Neo4jClusterMemberMetricOptions;
  Neo4jClusterMemberMetricSort: Neo4jClusterMemberMetricSort;
  Neo4jClusterMemberMetricWhere: Neo4jClusterMemberMetricWhere;
  Neo4jClusterMetrics: Neo4jClusterMetrics;
  Neo4jClusterMetricsEdge: Neo4jClusterMetricsEdge;
  Neo4jClusterMetricsOptions: Neo4jClusterMetricsOptions;
  Neo4jClusterMetricsSort: Neo4jClusterMetricsSort;
  Neo4jClusterMetricsWhere: Neo4jClusterMetricsWhere;
  NinjaQueriesConnection: NinjaQueriesConnection;
  NinjaQuery: NinjaQuery;
  NinjaQueryEdge: NinjaQueryEdge;
  NinjaQueryImpact: NinjaQueryImpact;
  NinjaQueryImpactEdge: NinjaQueryImpactEdge;
  NinjaQueryImpactOptions: NinjaQueryImpactOptions;
  NinjaQueryImpactSort: NinjaQueryImpactSort;
  NinjaQueryImpactWhere: NinjaQueryImpactWhere;
  NinjaQueryImpactsConnection: NinjaQueryImpactsConnection;
  NinjaQueryOptions: NinjaQueryOptions;
  NinjaQuerySort: NinjaQuerySort;
  NinjaQuerySubmitResult: NinjaQuerySubmitResult;
  NinjaQuerySubmitResultEdge: NinjaQuerySubmitResultEdge;
  NinjaQuerySubmitResultOptions: NinjaQuerySubmitResultOptions;
  NinjaQuerySubmitResultWhere: NinjaQuerySubmitResultWhere;
  NinjaQuerySubmitResultsConnection: NinjaQuerySubmitResultsConnection;
  NinjaQueryWhere: NinjaQueryWhere;
  OidDcUser: OidDcUser;
  OidDcUserEdge: OidDcUserEdge;
  OidDcUserOptions: OidDcUserOptions;
  OidDcUserSort: OidDcUserSort;
  OidDcUserWhere: OidDcUserWhere;
  OidDcUsersConnection: OidDcUsersConnection;
  OrgNotificationInput: OrgNotificationInput;
  Organization: Organization;
  OrganizationAgreementAgreementsAggregationSelection: OrganizationAgreementAgreementsAggregationSelection;
  OrganizationAgreementAgreementsNodeAggregateSelection: OrganizationAgreementAgreementsNodeAggregateSelection;
  OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection: OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection;
  OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection: OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection;
  OrganizationAgreementRunAttemptsAggregateInput: OrganizationAgreementRunAttemptsAggregateInput;
  OrganizationAgreementRunAttemptsConnection: OrganizationAgreementRunAttemptsConnection;
  OrganizationAgreementRunAttemptsConnectionSort: OrganizationAgreementRunAttemptsConnectionSort;
  OrganizationAgreementRunAttemptsConnectionWhere: OrganizationAgreementRunAttemptsConnectionWhere;
  OrganizationAgreementRunAttemptsNodeAggregationWhereInput: OrganizationAgreementRunAttemptsNodeAggregationWhereInput;
  OrganizationAgreementRunAttemptsRelationship: OrganizationAgreementRunAttemptsRelationship;
  OrganizationAgreementsAggregateInput: OrganizationAgreementsAggregateInput;
  OrganizationAgreementsConnection: OrganizationAgreementsConnection;
  OrganizationAgreementsConnectionSort: OrganizationAgreementsConnectionSort;
  OrganizationAgreementsConnectionWhere: OrganizationAgreementsConnectionWhere;
  OrganizationAgreementsNodeAggregationWhereInput: OrganizationAgreementsNodeAggregationWhereInput;
  OrganizationAgreementsRelationship: OrganizationAgreementsRelationship;
  OrganizationCountryAggregateInput: OrganizationCountryAggregateInput;
  OrganizationCountryConnection: OrganizationCountryConnection;
  OrganizationCountryConnectionSort: OrganizationCountryConnectionSort;
  OrganizationCountryConnectionWhere: OrganizationCountryConnectionWhere;
  OrganizationCountryCountryAggregationSelection: OrganizationCountryCountryAggregationSelection;
  OrganizationCountryCountryNodeAggregateSelection: OrganizationCountryCountryNodeAggregateSelection;
  OrganizationCountryNodeAggregationWhereInput: OrganizationCountryNodeAggregationWhereInput;
  OrganizationCountryRelationship: OrganizationCountryRelationship;
  OrganizationDefaultReceiversAggregateInput: OrganizationDefaultReceiversAggregateInput;
  OrganizationDefaultReceiversConnection: OrganizationDefaultReceiversConnection;
  OrganizationDefaultReceiversConnectionSort: OrganizationDefaultReceiversConnectionSort;
  OrganizationDefaultReceiversConnectionWhere: OrganizationDefaultReceiversConnectionWhere;
  OrganizationDefaultReceiversEdgeAggregationWhereInput: OrganizationDefaultReceiversEdgeAggregationWhereInput;
  OrganizationDefaultReceiversNodeAggregationWhereInput: OrganizationDefaultReceiversNodeAggregationWhereInput;
  OrganizationDefaultReceiversRelationship: OrganizationDefaultReceiversRelationship;
  OrganizationEdge: OrganizationEdge;
  OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection: OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection;
  OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection: OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection;
  OrganizationEncapsulatedFeaturesAggregateInput: OrganizationEncapsulatedFeaturesAggregateInput;
  OrganizationEncapsulatedFeaturesConnection: OrganizationEncapsulatedFeaturesConnection;
  OrganizationEncapsulatedFeaturesConnectionSort: OrganizationEncapsulatedFeaturesConnectionSort;
  OrganizationEncapsulatedFeaturesConnectionWhere: OrganizationEncapsulatedFeaturesConnectionWhere;
  OrganizationEncapsulatedFeaturesNodeAggregationWhereInput: OrganizationEncapsulatedFeaturesNodeAggregationWhereInput;
  OrganizationEncapsulatedFeaturesRelationship: OrganizationEncapsulatedFeaturesRelationship;
  OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection: OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection;
  OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection: OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection;
  OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection: OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection;
  OrganizationFlexEntityTypeMappingsAggregateInput: OrganizationFlexEntityTypeMappingsAggregateInput;
  OrganizationFlexEntityTypeMappingsConnection: OrganizationFlexEntityTypeMappingsConnection;
  OrganizationFlexEntityTypeMappingsConnectionSort: OrganizationFlexEntityTypeMappingsConnectionSort;
  OrganizationFlexEntityTypeMappingsConnectionWhere: OrganizationFlexEntityTypeMappingsConnectionWhere;
  OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput: OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput;
  OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput: OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput;
  OrganizationFlexEntityTypeMappingsRelationship: OrganizationFlexEntityTypeMappingsRelationship;
  OrganizationInput: OrganizationInput;
  OrganizationOptions: OrganizationOptions;
  OrganizationOrganizationDefaultReceiversAggregationSelection: OrganizationOrganizationDefaultReceiversAggregationSelection;
  OrganizationOrganizationDefaultReceiversEdgeAggregateSelection: OrganizationOrganizationDefaultReceiversEdgeAggregateSelection;
  OrganizationOrganizationDefaultReceiversNodeAggregateSelection: OrganizationOrganizationDefaultReceiversNodeAggregateSelection;
  OrganizationQuestNotificationQuestNotificationsAggregationSelection: OrganizationQuestNotificationQuestNotificationsAggregationSelection;
  OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection: OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection;
  OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection: OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection;
  OrganizationQuestNotificationsAggregateInput: OrganizationQuestNotificationsAggregateInput;
  OrganizationQuestNotificationsConnection: OrganizationQuestNotificationsConnection;
  OrganizationQuestNotificationsConnectionSort: OrganizationQuestNotificationsConnectionSort;
  OrganizationQuestNotificationsConnectionWhere: OrganizationQuestNotificationsConnectionWhere;
  OrganizationQuestNotificationsEdgeAggregationWhereInput: OrganizationQuestNotificationsEdgeAggregationWhereInput;
  OrganizationQuestNotificationsNodeAggregationWhereInput: OrganizationQuestNotificationsNodeAggregationWhereInput;
  OrganizationQuestNotificationsRelationship: OrganizationQuestNotificationsRelationship;
  OrganizationQuestRelationship: ResolversInterfaceTypes<ResolversParentTypes>['OrganizationQuestRelationship'];
  OrganizationQuestRelationshipSort: OrganizationQuestRelationshipSort;
  OrganizationQuestRelationshipWhere: OrganizationQuestRelationshipWhere;
  OrganizationScope: OrganizationScope;
  OrganizationScopeEdge: OrganizationScopeEdge;
  OrganizationScopeOptions: OrganizationScopeOptions;
  OrganizationScopeRelationship: ResolversInterfaceTypes<ResolversParentTypes>['OrganizationScopeRelationship'];
  OrganizationScopeRelationshipSort: OrganizationScopeRelationshipSort;
  OrganizationScopeRelationshipWhere: OrganizationScopeRelationshipWhere;
  OrganizationScopeSort: OrganizationScopeSort;
  OrganizationScopeWhere: OrganizationScopeWhere;
  OrganizationScopesConnection: OrganizationScopesConnection;
  OrganizationSort: OrganizationSort;
  OrganizationWhere: OrganizationWhere;
  OrganizationsConnection: OrganizationsConnection;
  PageInfo: PageInfo;
  Partner: Partner;
  PartnerEdge: PartnerEdge;
  PartnerOptions: PartnerOptions;
  PartnerSort: PartnerSort;
  PartnerTreatmentAggregateInput: PartnerTreatmentAggregateInput;
  PartnerTreatmentConnection: PartnerTreatmentConnection;
  PartnerTreatmentConnectionSort: PartnerTreatmentConnectionSort;
  PartnerTreatmentConnectionWhere: PartnerTreatmentConnectionWhere;
  PartnerTreatmentNodeAggregationWhereInput: PartnerTreatmentNodeAggregationWhereInput;
  PartnerTreatmentRelationship: PartnerTreatmentRelationship;
  PartnerTreatmentTreatmentAggregationSelection: PartnerTreatmentTreatmentAggregationSelection;
  PartnerTreatmentTreatmentNodeAggregateSelection: PartnerTreatmentTreatmentNodeAggregateSelection;
  PartnerWhere: PartnerWhere;
  PartnersConnection: PartnersConnection;
  Patient: Patient;
  PatientAssignedFlexEntitiesAggregateInput: PatientAssignedFlexEntitiesAggregateInput;
  PatientAssignedFlexEntitiesConnection: PatientAssignedFlexEntitiesConnection;
  PatientAssignedFlexEntitiesConnectionSort: PatientAssignedFlexEntitiesConnectionSort;
  PatientAssignedFlexEntitiesConnectionWhere: PatientAssignedFlexEntitiesConnectionWhere;
  PatientAssignedFlexEntitiesNodeAggregationWhereInput: PatientAssignedFlexEntitiesNodeAggregationWhereInput;
  PatientAssignedFlexEntitiesRelationship: PatientAssignedFlexEntitiesRelationship;
  PatientCaseCasesAggregationSelection: PatientCaseCasesAggregationSelection;
  PatientCaseCasesNodeAggregateSelection: PatientCaseCasesNodeAggregateSelection;
  PatientCasesAggregateInput: PatientCasesAggregateInput;
  PatientCasesConnection: PatientCasesConnection;
  PatientCasesConnectionSort: PatientCasesConnectionSort;
  PatientCasesConnectionWhere: PatientCasesConnectionWhere;
  PatientCasesNodeAggregationWhereInput: PatientCasesNodeAggregationWhereInput;
  PatientCasesRelationship: PatientCasesRelationship;
  PatientEdge: PatientEdge;
  PatientFlexEntityAssignedFlexEntitiesAggregationSelection: PatientFlexEntityAssignedFlexEntitiesAggregationSelection;
  PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection: PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection;
  PatientOptions: PatientOptions;
  PatientSort: PatientSort;
  PatientWhere: PatientWhere;
  PatientsConnection: PatientsConnection;
  PerformanceCounter: PerformanceCounter;
  PerformanceCounterEdge: PerformanceCounterEdge;
  PerformanceCounterInput: PerformanceCounterInput;
  PerformanceCounterOptions: PerformanceCounterOptions;
  PerformanceCounterSort: PerformanceCounterSort;
  PerformanceCounterWhere: PerformanceCounterWhere;
  PerformanceCountersConnection: PerformanceCountersConnection;
  PerformanceMeasurement: PerformanceMeasurement;
  PerformanceMeasurementCounterAggregateInput: PerformanceMeasurementCounterAggregateInput;
  PerformanceMeasurementCounterConnection: PerformanceMeasurementCounterConnection;
  PerformanceMeasurementCounterConnectionSort: PerformanceMeasurementCounterConnectionSort;
  PerformanceMeasurementCounterConnectionWhere: PerformanceMeasurementCounterConnectionWhere;
  PerformanceMeasurementCounterNodeAggregationWhereInput: PerformanceMeasurementCounterNodeAggregationWhereInput;
  PerformanceMeasurementCounterRelationship: PerformanceMeasurementCounterRelationship;
  PerformanceMeasurementEdge: PerformanceMeasurementEdge;
  PerformanceMeasurementNestedMeasurementsAggregateInput: PerformanceMeasurementNestedMeasurementsAggregateInput;
  PerformanceMeasurementNestedMeasurementsConnection: PerformanceMeasurementNestedMeasurementsConnection;
  PerformanceMeasurementNestedMeasurementsConnectionSort: PerformanceMeasurementNestedMeasurementsConnectionSort;
  PerformanceMeasurementNestedMeasurementsConnectionWhere: PerformanceMeasurementNestedMeasurementsConnectionWhere;
  PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput: PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput;
  PerformanceMeasurementNestedMeasurementsRelationship: PerformanceMeasurementNestedMeasurementsRelationship;
  PerformanceMeasurementOptions: PerformanceMeasurementOptions;
  PerformanceMeasurementParentAggregateInput: PerformanceMeasurementParentAggregateInput;
  PerformanceMeasurementParentConnection: PerformanceMeasurementParentConnection;
  PerformanceMeasurementParentConnectionSort: PerformanceMeasurementParentConnectionSort;
  PerformanceMeasurementParentConnectionWhere: PerformanceMeasurementParentConnectionWhere;
  PerformanceMeasurementParentNodeAggregationWhereInput: PerformanceMeasurementParentNodeAggregationWhereInput;
  PerformanceMeasurementParentRelationship: PerformanceMeasurementParentRelationship;
  PerformanceMeasurementPerformanceCounterCounterAggregationSelection: PerformanceMeasurementPerformanceCounterCounterAggregationSelection;
  PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection: PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection;
  PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection: PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection;
  PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection: PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection;
  PerformanceMeasurementPerformanceMeasurementParentAggregationSelection: PerformanceMeasurementPerformanceMeasurementParentAggregationSelection;
  PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection: PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection;
  PerformanceMeasurementSort: PerformanceMeasurementSort;
  PerformanceMeasurementWhere: PerformanceMeasurementWhere;
  PerformanceMeasurementsConnection: PerformanceMeasurementsConnection;
  PerformanceThreshold: PerformanceThreshold;
  PerformanceThresholdCounterAggregateInput: PerformanceThresholdCounterAggregateInput;
  PerformanceThresholdCounterConnection: PerformanceThresholdCounterConnection;
  PerformanceThresholdCounterConnectionSort: PerformanceThresholdCounterConnectionSort;
  PerformanceThresholdCounterConnectionWhere: PerformanceThresholdCounterConnectionWhere;
  PerformanceThresholdCounterNodeAggregationWhereInput: PerformanceThresholdCounterNodeAggregationWhereInput;
  PerformanceThresholdCounterRelationship: PerformanceThresholdCounterRelationship;
  PerformanceThresholdEdge: PerformanceThresholdEdge;
  PerformanceThresholdInput: PerformanceThresholdInput;
  PerformanceThresholdNotifiedUsersAggregateInput: PerformanceThresholdNotifiedUsersAggregateInput;
  PerformanceThresholdNotifiedUsersConnection: PerformanceThresholdNotifiedUsersConnection;
  PerformanceThresholdNotifiedUsersConnectionSort: PerformanceThresholdNotifiedUsersConnectionSort;
  PerformanceThresholdNotifiedUsersConnectionWhere: PerformanceThresholdNotifiedUsersConnectionWhere;
  PerformanceThresholdNotifiedUsersNodeAggregationWhereInput: PerformanceThresholdNotifiedUsersNodeAggregationWhereInput;
  PerformanceThresholdNotifiedUsersRelationship: PerformanceThresholdNotifiedUsersRelationship;
  PerformanceThresholdOptions: PerformanceThresholdOptions;
  PerformanceThresholdPerformanceCounterCounterAggregationSelection: PerformanceThresholdPerformanceCounterCounterAggregationSelection;
  PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection: PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection;
  PerformanceThresholdSort: PerformanceThresholdSort;
  PerformanceThresholdUserNotifiedUsersAggregationSelection: PerformanceThresholdUserNotifiedUsersAggregationSelection;
  PerformanceThresholdUserNotifiedUsersNodeAggregateSelection: PerformanceThresholdUserNotifiedUsersNodeAggregateSelection;
  PerformanceThresholdWhere: PerformanceThresholdWhere;
  PerformanceThresholdsConnection: PerformanceThresholdsConnection;
  PgBossMetrics: PgBossMetrics;
  PgBossMetricsConnection: PgBossMetricsConnection;
  PgBossMetricsEdge: PgBossMetricsEdge;
  PgBossMetricsOptions: PgBossMetricsOptions;
  PgBossMetricsSort: PgBossMetricsSort;
  PgBossMetricsWhere: PgBossMetricsWhere;
  PgBossQueueStat: PgBossQueueStat;
  PgBossQueueStatEdge: PgBossQueueStatEdge;
  PgBossQueueStatOptions: PgBossQueueStatOptions;
  PgBossQueueStatSort: PgBossQueueStatSort;
  PgBossQueueStatWhere: PgBossQueueStatWhere;
  PgBossQueueStatsConnection: PgBossQueueStatsConnection;
  PolicyType: PolicyType;
  PolicyTypeEdge: PolicyTypeEdge;
  PolicyTypeOptions: PolicyTypeOptions;
  PolicyTypePolicyVersionVersionsAggregationSelection: PolicyTypePolicyVersionVersionsAggregationSelection;
  PolicyTypePolicyVersionVersionsNodeAggregateSelection: PolicyTypePolicyVersionVersionsNodeAggregateSelection;
  PolicyTypeSort: PolicyTypeSort;
  PolicyTypeVersionsAggregateInput: PolicyTypeVersionsAggregateInput;
  PolicyTypeVersionsConnection: PolicyTypeVersionsConnection;
  PolicyTypeVersionsConnectionSort: PolicyTypeVersionsConnectionSort;
  PolicyTypeVersionsConnectionWhere: PolicyTypeVersionsConnectionWhere;
  PolicyTypeVersionsNodeAggregationWhereInput: PolicyTypeVersionsNodeAggregationWhereInput;
  PolicyTypeVersionsRelationship: PolicyTypeVersionsRelationship;
  PolicyTypeWhere: PolicyTypeWhere;
  PolicyTypesConnection: PolicyTypesConnection;
  PolicyVersion: PolicyVersion;
  PolicyVersionEdge: PolicyVersionEdge;
  PolicyVersionOptions: PolicyVersionOptions;
  PolicyVersionPolicyTypeAggregateInput: PolicyVersionPolicyTypeAggregateInput;
  PolicyVersionPolicyTypeConnection: PolicyVersionPolicyTypeConnection;
  PolicyVersionPolicyTypeConnectionSort: PolicyVersionPolicyTypeConnectionSort;
  PolicyVersionPolicyTypeConnectionWhere: PolicyVersionPolicyTypeConnectionWhere;
  PolicyVersionPolicyTypeNodeAggregationWhereInput: PolicyVersionPolicyTypeNodeAggregationWhereInput;
  PolicyVersionPolicyTypePolicyTypeAggregationSelection: PolicyVersionPolicyTypePolicyTypeAggregationSelection;
  PolicyVersionPolicyTypePolicyTypeNodeAggregateSelection: PolicyVersionPolicyTypePolicyTypeNodeAggregateSelection;
  PolicyVersionPolicyTypeRelationship: PolicyVersionPolicyTypeRelationship;
  PolicyVersionSort: PolicyVersionSort;
  PolicyVersionWhere: PolicyVersionWhere;
  PolicyVersionsConnection: PolicyVersionsConnection;
  PostgresMetric: PostgresMetric;
  PostgresMetricEdge: PostgresMetricEdge;
  PostgresMetricOptions: PostgresMetricOptions;
  PostgresMetricSort: PostgresMetricSort;
  PostgresMetricWhere: PostgresMetricWhere;
  PostgresMetricsConnection: PostgresMetricsConnection;
  Preparation: Preparation;
  PreparationBrandAggregateInput: PreparationBrandAggregateInput;
  PreparationBrandBrandAggregationSelection: PreparationBrandBrandAggregationSelection;
  PreparationBrandBrandNodeAggregateSelection: PreparationBrandBrandNodeAggregateSelection;
  PreparationBrandConnection: PreparationBrandConnection;
  PreparationBrandConnectionSort: PreparationBrandConnectionSort;
  PreparationBrandConnectionWhere: PreparationBrandConnectionWhere;
  PreparationBrandNodeAggregationWhereInput: PreparationBrandNodeAggregationWhereInput;
  PreparationBrandRelationship: PreparationBrandRelationship;
  PreparationCountriesAggregateInput: PreparationCountriesAggregateInput;
  PreparationCountriesConnection: PreparationCountriesConnection;
  PreparationCountriesConnectionSort: PreparationCountriesConnectionSort;
  PreparationCountriesConnectionWhere: PreparationCountriesConnectionWhere;
  PreparationCountriesNodeAggregationWhereInput: PreparationCountriesNodeAggregationWhereInput;
  PreparationCountriesRelationship: PreparationCountriesRelationship;
  PreparationCountryCountriesAggregationSelection: PreparationCountryCountriesAggregationSelection;
  PreparationCountryCountriesNodeAggregateSelection: PreparationCountryCountriesNodeAggregateSelection;
  PreparationEdge: PreparationEdge;
  PreparationGenericAggregateInput: PreparationGenericAggregateInput;
  PreparationGenericConnection: PreparationGenericConnection;
  PreparationGenericConnectionSort: PreparationGenericConnectionSort;
  PreparationGenericConnectionWhere: PreparationGenericConnectionWhere;
  PreparationGenericGenericAggregationSelection: PreparationGenericGenericAggregationSelection;
  PreparationGenericGenericNodeAggregateSelection: PreparationGenericGenericNodeAggregateSelection;
  PreparationGenericNodeAggregationWhereInput: PreparationGenericNodeAggregationWhereInput;
  PreparationGenericRelationship: PreparationGenericRelationship;
  PreparationHasLimitationsAggregateInput: PreparationHasLimitationsAggregateInput;
  PreparationHasLimitationsConnection: PreparationHasLimitationsConnection;
  PreparationHasLimitationsConnectionSort: PreparationHasLimitationsConnectionSort;
  PreparationHasLimitationsConnectionWhere: PreparationHasLimitationsConnectionWhere;
  PreparationHasLimitationsNodeAggregationWhereInput: PreparationHasLimitationsNodeAggregationWhereInput;
  PreparationHasLimitationsRelationship: PreparationHasLimitationsRelationship;
  PreparationInput: PreparationInput;
  PreparationLimitationHasLimitationsAggregationSelection: PreparationLimitationHasLimitationsAggregationSelection;
  PreparationLimitationHasLimitationsNodeAggregateSelection: PreparationLimitationHasLimitationsNodeAggregateSelection;
  PreparationOptions: PreparationOptions;
  PreparationRegulatesAggregateInput: PreparationRegulatesAggregateInput;
  PreparationRegulatesConnection: PreparationRegulatesConnection;
  PreparationRegulatesConnectionSort: PreparationRegulatesConnectionSort;
  PreparationRegulatesConnectionWhere: PreparationRegulatesConnectionWhere;
  PreparationRegulatesNodeAggregationWhereInput: PreparationRegulatesNodeAggregationWhereInput;
  PreparationRegulatesRelationship: PreparationRegulatesRelationship;
  PreparationSort: PreparationSort;
  PreparationStatus: PreparationStatus;
  PreparationStatusEdge: PreparationStatusEdge;
  PreparationStatusOptions: PreparationStatusOptions;
  PreparationStatusPreparationAggregateInput: PreparationStatusPreparationAggregateInput;
  PreparationStatusPreparationConnection: PreparationStatusPreparationConnection;
  PreparationStatusPreparationConnectionSort: PreparationStatusPreparationConnectionSort;
  PreparationStatusPreparationConnectionWhere: PreparationStatusPreparationConnectionWhere;
  PreparationStatusPreparationNodeAggregationWhereInput: PreparationStatusPreparationNodeAggregationWhereInput;
  PreparationStatusPreparationPreparationAggregationSelection: PreparationStatusPreparationPreparationAggregationSelection;
  PreparationStatusPreparationPreparationNodeAggregateSelection: PreparationStatusPreparationPreparationNodeAggregateSelection;
  PreparationStatusPreparationRelationship: PreparationStatusPreparationRelationship;
  PreparationStatusSort: PreparationStatusSort;
  PreparationStatusWhere: PreparationStatusWhere;
  PreparationStatusesConnection: PreparationStatusesConnection;
  PreparationTreatmentRegulatesAggregationSelection: PreparationTreatmentRegulatesAggregationSelection;
  PreparationTreatmentRegulatesNodeAggregateSelection: PreparationTreatmentRegulatesNodeAggregateSelection;
  PreparationWhere: PreparationWhere;
  PreparationsConnection: PreparationsConnection;
  Price: Price;
  PriceCurrencyAggregateInput: PriceCurrencyAggregateInput;
  PriceCurrencyConnection: PriceCurrencyConnection;
  PriceCurrencyConnectionSort: PriceCurrencyConnectionSort;
  PriceCurrencyConnectionWhere: PriceCurrencyConnectionWhere;
  PriceCurrencyCurrencyAggregationSelection: PriceCurrencyCurrencyAggregationSelection;
  PriceCurrencyCurrencyNodeAggregateSelection: PriceCurrencyCurrencyNodeAggregateSelection;
  PriceCurrencyNodeAggregationWhereInput: PriceCurrencyNodeAggregationWhereInput;
  PriceCurrencyRelationship: PriceCurrencyRelationship;
  PriceEdge: PriceEdge;
  PriceOptions: PriceOptions;
  PriceSort: PriceSort;
  PriceTreatmentAggregateInput: PriceTreatmentAggregateInput;
  PriceTreatmentConnection: PriceTreatmentConnection;
  PriceTreatmentConnectionSort: PriceTreatmentConnectionSort;
  PriceTreatmentConnectionWhere: PriceTreatmentConnectionWhere;
  PriceTreatmentInput: PriceTreatmentInput;
  PriceTreatmentNodeAggregationWhereInput: PriceTreatmentNodeAggregationWhereInput;
  PriceTreatmentRelationship: PriceTreatmentRelationship;
  PriceTreatmentTreatmentAggregationSelection: PriceTreatmentTreatmentAggregationSelection;
  PriceTreatmentTreatmentNodeAggregateSelection: PriceTreatmentTreatmentNodeAggregateSelection;
  PriceWhere: PriceWhere;
  PricesConnection: PricesConnection;
  ProductBlueprint: ProductBlueprint;
  ProductBlueprintAddedByAggregateInput: ProductBlueprintAddedByAggregateInput;
  ProductBlueprintAddedByConnection: ProductBlueprintAddedByConnection;
  ProductBlueprintAddedByConnectionSort: ProductBlueprintAddedByConnectionSort;
  ProductBlueprintAddedByConnectionWhere: ProductBlueprintAddedByConnectionWhere;
  ProductBlueprintAddedByNodeAggregationWhereInput: ProductBlueprintAddedByNodeAggregationWhereInput;
  ProductBlueprintAddedByRelationship: ProductBlueprintAddedByRelationship;
  ProductBlueprintDomainDomainsAggregationSelection: ProductBlueprintDomainDomainsAggregationSelection;
  ProductBlueprintDomainDomainsNodeAggregateSelection: ProductBlueprintDomainDomainsNodeAggregateSelection;
  ProductBlueprintDomainsAggregateInput: ProductBlueprintDomainsAggregateInput;
  ProductBlueprintDomainsConnection: ProductBlueprintDomainsConnection;
  ProductBlueprintDomainsConnectionSort: ProductBlueprintDomainsConnectionSort;
  ProductBlueprintDomainsConnectionWhere: ProductBlueprintDomainsConnectionWhere;
  ProductBlueprintDomainsNodeAggregationWhereInput: ProductBlueprintDomainsNodeAggregationWhereInput;
  ProductBlueprintDomainsRelationship: ProductBlueprintDomainsRelationship;
  ProductBlueprintEdge: ProductBlueprintEdge;
  ProductBlueprintOptions: ProductBlueprintOptions;
  ProductBlueprintPublishedByAggregateInput: ProductBlueprintPublishedByAggregateInput;
  ProductBlueprintPublishedByConnection: ProductBlueprintPublishedByConnection;
  ProductBlueprintPublishedByConnectionSort: ProductBlueprintPublishedByConnectionSort;
  ProductBlueprintPublishedByConnectionWhere: ProductBlueprintPublishedByConnectionWhere;
  ProductBlueprintPublishedByNodeAggregationWhereInput: ProductBlueprintPublishedByNodeAggregationWhereInput;
  ProductBlueprintPublishedByRelationship: ProductBlueprintPublishedByRelationship;
  ProductBlueprintResult: ProductBlueprintResult;
  ProductBlueprintResultEdge: ProductBlueprintResultEdge;
  ProductBlueprintResultOptions: ProductBlueprintResultOptions;
  ProductBlueprintResultSort: ProductBlueprintResultSort;
  ProductBlueprintResultWhere: ProductBlueprintResultWhere;
  ProductBlueprintResultsConnection: ProductBlueprintResultsConnection;
  ProductBlueprintSimulationSimulationsAggregationSelection: ProductBlueprintSimulationSimulationsAggregationSelection;
  ProductBlueprintSimulationSimulationsNodeAggregateSelection: ProductBlueprintSimulationSimulationsNodeAggregateSelection;
  ProductBlueprintSimulationsAggregateInput: ProductBlueprintSimulationsAggregateInput;
  ProductBlueprintSimulationsConnection: ProductBlueprintSimulationsConnection;
  ProductBlueprintSimulationsConnectionSort: ProductBlueprintSimulationsConnectionSort;
  ProductBlueprintSimulationsConnectionWhere: ProductBlueprintSimulationsConnectionWhere;
  ProductBlueprintSimulationsNodeAggregationWhereInput: ProductBlueprintSimulationsNodeAggregationWhereInput;
  ProductBlueprintSimulationsRelationship: ProductBlueprintSimulationsRelationship;
  ProductBlueprintSort: ProductBlueprintSort;
  ProductBlueprintUpdatedByAggregateInput: ProductBlueprintUpdatedByAggregateInput;
  ProductBlueprintUpdatedByConnection: ProductBlueprintUpdatedByConnection;
  ProductBlueprintUpdatedByConnectionSort: ProductBlueprintUpdatedByConnectionSort;
  ProductBlueprintUpdatedByConnectionWhere: ProductBlueprintUpdatedByConnectionWhere;
  ProductBlueprintUpdatedByNodeAggregationWhereInput: ProductBlueprintUpdatedByNodeAggregationWhereInput;
  ProductBlueprintUpdatedByRelationship: ProductBlueprintUpdatedByRelationship;
  ProductBlueprintUserAddedByAggregationSelection: ProductBlueprintUserAddedByAggregationSelection;
  ProductBlueprintUserAddedByNodeAggregateSelection: ProductBlueprintUserAddedByNodeAggregateSelection;
  ProductBlueprintUserPublishedByAggregationSelection: ProductBlueprintUserPublishedByAggregationSelection;
  ProductBlueprintUserPublishedByNodeAggregateSelection: ProductBlueprintUserPublishedByNodeAggregateSelection;
  ProductBlueprintUserUpdatedByAggregationSelection: ProductBlueprintUserUpdatedByAggregationSelection;
  ProductBlueprintUserUpdatedByNodeAggregateSelection: ProductBlueprintUserUpdatedByNodeAggregateSelection;
  ProductBlueprintWhere: ProductBlueprintWhere;
  ProductBlueprintsConnection: ProductBlueprintsConnection;
  PublicPrice: PublicPrice;
  PublicPriceEdge: PublicPriceEdge;
  PublicPriceOptions: PublicPriceOptions;
  PublicPriceSort: PublicPriceSort;
  PublicPriceWhere: PublicPriceWhere;
  PublicPricesConnection: PublicPricesConnection;
  Purchase: Purchase;
  PurchaseAgreementAggregateInput: PurchaseAgreementAggregateInput;
  PurchaseAgreementAgreementAggregationSelection: PurchaseAgreementAgreementAggregationSelection;
  PurchaseAgreementAgreementNodeAggregateSelection: PurchaseAgreementAgreementNodeAggregateSelection;
  PurchaseAgreementConnection: PurchaseAgreementConnection;
  PurchaseAgreementConnectionSort: PurchaseAgreementConnectionSort;
  PurchaseAgreementConnectionWhere: PurchaseAgreementConnectionWhere;
  PurchaseAgreementNodeAggregationWhereInput: PurchaseAgreementNodeAggregationWhereInput;
  PurchaseAgreementRelationship: PurchaseAgreementRelationship;
  PurchaseAssignedFlexEntitiesAggregateInput: PurchaseAssignedFlexEntitiesAggregateInput;
  PurchaseAssignedFlexEntitiesConnection: PurchaseAssignedFlexEntitiesConnection;
  PurchaseAssignedFlexEntitiesConnectionSort: PurchaseAssignedFlexEntitiesConnectionSort;
  PurchaseAssignedFlexEntitiesConnectionWhere: PurchaseAssignedFlexEntitiesConnectionWhere;
  PurchaseAssignedFlexEntitiesNodeAggregationWhereInput: PurchaseAssignedFlexEntitiesNodeAggregationWhereInput;
  PurchaseAssignedFlexEntitiesRelationship: PurchaseAssignedFlexEntitiesRelationship;
  PurchaseEdge: PurchaseEdge;
  PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection: PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection;
  PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection: PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection;
  PurchaseOptions: PurchaseOptions;
  PurchaseRefundRefundsAggregationSelection: PurchaseRefundRefundsAggregationSelection;
  PurchaseRefundRefundsNodeAggregateSelection: PurchaseRefundRefundsNodeAggregateSelection;
  PurchaseRefundsAggregateInput: PurchaseRefundsAggregateInput;
  PurchaseRefundsConnection: PurchaseRefundsConnection;
  PurchaseRefundsConnectionSort: PurchaseRefundsConnectionSort;
  PurchaseRefundsConnectionWhere: PurchaseRefundsConnectionWhere;
  PurchaseRefundsNodeAggregationWhereInput: PurchaseRefundsNodeAggregationWhereInput;
  PurchaseRefundsRelationship: PurchaseRefundsRelationship;
  PurchaseSort: PurchaseSort;
  PurchaseWhere: PurchaseWhere;
  PurchasesConnection: PurchasesConnection;
  Query: {};
  QueryCheckInput: QueryCheckInput;
  QueryLog: QueryLog;
  QueryLogEdge: QueryLogEdge;
  QueryLogOptions: QueryLogOptions;
  QueryLogSort: QueryLogSort;
  QueryLogWhere: QueryLogWhere;
  QueryLogsConnection: QueryLogsConnection;
  QueryResult: QueryResult;
  QueryResultEdge: QueryResultEdge;
  QueryResultOptions: QueryResultOptions;
  QueryResultSort: QueryResultSort;
  QueryResultWhere: QueryResultWhere;
  QueryResultsConnection: QueryResultsConnection;
  QuestNotification: QuestNotification;
  QuestNotificationEdge: QuestNotificationEdge;
  QuestNotificationInput: QuestNotificationInput;
  QuestNotificationOptions: QuestNotificationOptions;
  QuestNotificationOrganizationSubscribedAggregationSelection: QuestNotificationOrganizationSubscribedAggregationSelection;
  QuestNotificationOrganizationSubscribedEdgeAggregateSelection: QuestNotificationOrganizationSubscribedEdgeAggregateSelection;
  QuestNotificationOrganizationSubscribedNodeAggregateSelection: QuestNotificationOrganizationSubscribedNodeAggregateSelection;
  QuestNotificationSort: QuestNotificationSort;
  QuestNotificationSubscribedAggregateInput: QuestNotificationSubscribedAggregateInput;
  QuestNotificationSubscribedConnection: QuestNotificationSubscribedConnection;
  QuestNotificationSubscribedConnectionSort: QuestNotificationSubscribedConnectionSort;
  QuestNotificationSubscribedConnectionWhere: QuestNotificationSubscribedConnectionWhere;
  QuestNotificationSubscribedEdgeAggregationWhereInput: QuestNotificationSubscribedEdgeAggregationWhereInput;
  QuestNotificationSubscribedNodeAggregationWhereInput: QuestNotificationSubscribedNodeAggregationWhereInput;
  QuestNotificationSubscribedRelationship: QuestNotificationSubscribedRelationship;
  QuestNotificationWhere: QuestNotificationWhere;
  QuestNotificationsConnection: QuestNotificationsConnection;
  Refund: Refund;
  RefundAgreementAggregateInput: RefundAgreementAggregateInput;
  RefundAgreementAgreementAggregationSelection: RefundAgreementAgreementAggregationSelection;
  RefundAgreementAgreementNodeAggregateSelection: RefundAgreementAgreementNodeAggregateSelection;
  RefundAgreementConnection: RefundAgreementConnection;
  RefundAgreementConnectionSort: RefundAgreementConnectionSort;
  RefundAgreementConnectionWhere: RefundAgreementConnectionWhere;
  RefundAgreementNodeAggregationWhereInput: RefundAgreementNodeAggregationWhereInput;
  RefundAgreementRelationship: RefundAgreementRelationship;
  RefundCaseAggregateInput: RefundCaseAggregateInput;
  RefundCaseCaseAggregationSelection: RefundCaseCaseAggregationSelection;
  RefundCaseCaseNodeAggregateSelection: RefundCaseCaseNodeAggregateSelection;
  RefundCaseConnection: RefundCaseConnection;
  RefundCaseConnectionSort: RefundCaseConnectionSort;
  RefundCaseConnectionWhere: RefundCaseConnectionWhere;
  RefundCaseNodeAggregationWhereInput: RefundCaseNodeAggregationWhereInput;
  RefundCaseRelationship: RefundCaseRelationship;
  RefundDocumentDocumentsAggregationSelection: RefundDocumentDocumentsAggregationSelection;
  RefundDocumentDocumentsNodeAggregateSelection: RefundDocumentDocumentsNodeAggregateSelection;
  RefundDocumentFinancialDataPointAggregateInput: RefundDocumentFinancialDataPointAggregateInput;
  RefundDocumentFinancialDataPointConnection: RefundDocumentFinancialDataPointConnection;
  RefundDocumentFinancialDataPointConnectionSort: RefundDocumentFinancialDataPointConnectionSort;
  RefundDocumentFinancialDataPointConnectionWhere: RefundDocumentFinancialDataPointConnectionWhere;
  RefundDocumentFinancialDataPointEdgeAggregationWhereInput: RefundDocumentFinancialDataPointEdgeAggregationWhereInput;
  RefundDocumentFinancialDataPointNodeAggregationWhereInput: RefundDocumentFinancialDataPointNodeAggregationWhereInput;
  RefundDocumentFinancialDataPointRelationship: RefundDocumentFinancialDataPointRelationship;
  RefundDocumentsAggregateInput: RefundDocumentsAggregateInput;
  RefundDocumentsConnection: RefundDocumentsConnection;
  RefundDocumentsConnectionSort: RefundDocumentsConnectionSort;
  RefundDocumentsConnectionWhere: RefundDocumentsConnectionWhere;
  RefundDocumentsNodeAggregationWhereInput: RefundDocumentsNodeAggregationWhereInput;
  RefundDocumentsRelationship: RefundDocumentsRelationship;
  RefundEdge: RefundEdge;
  RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection: RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection;
  RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection: RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection;
  RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection: RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection;
  RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection: RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection;
  RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection: RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection;
  RefundOptions: RefundOptions;
  RefundSort: RefundSort;
  RefundSourceFinancialDataPointAggregateInput: RefundSourceFinancialDataPointAggregateInput;
  RefundSourceFinancialDataPointConnection: RefundSourceFinancialDataPointConnection;
  RefundSourceFinancialDataPointConnectionSort: RefundSourceFinancialDataPointConnectionSort;
  RefundSourceFinancialDataPointConnectionWhere: RefundSourceFinancialDataPointConnectionWhere;
  RefundSourceFinancialDataPointNodeAggregationWhereInput: RefundSourceFinancialDataPointNodeAggregationWhereInput;
  RefundSourceFinancialDataPointRelationship: RefundSourceFinancialDataPointRelationship;
  RefundWhere: RefundWhere;
  RefundsConnection: RefundsConnection;
  RunCheck: RunCheck;
  RunCheckAlertAlertsAggregationSelection: RunCheckAlertAlertsAggregationSelection;
  RunCheckAlertAlertsNodeAggregateSelection: RunCheckAlertAlertsNodeAggregateSelection;
  RunCheckAlertsAggregateInput: RunCheckAlertsAggregateInput;
  RunCheckAlertsConnection: RunCheckAlertsConnection;
  RunCheckAlertsConnectionSort: RunCheckAlertsConnectionSort;
  RunCheckAlertsConnectionWhere: RunCheckAlertsConnectionWhere;
  RunCheckAlertsNodeAggregationWhereInput: RunCheckAlertsNodeAggregationWhereInput;
  RunCheckAlertsRelationship: RunCheckAlertsRelationship;
  RunCheckEdge: RunCheckEdge;
  RunCheckOptions: RunCheckOptions;
  RunCheckRunCheckValuesValuesAggregationSelection: RunCheckRunCheckValuesValuesAggregationSelection;
  RunCheckRunCheckValuesValuesNodeAggregateSelection: RunCheckRunCheckValuesValuesNodeAggregateSelection;
  RunCheckSort: RunCheckSort;
  RunCheckValues: RunCheckValues;
  RunCheckValuesAggregateInput: RunCheckValuesAggregateInput;
  RunCheckValuesCheckAggregateInput: RunCheckValuesCheckAggregateInput;
  RunCheckValuesCheckConnection: RunCheckValuesCheckConnection;
  RunCheckValuesCheckConnectionSort: RunCheckValuesCheckConnectionSort;
  RunCheckValuesCheckConnectionWhere: RunCheckValuesCheckConnectionWhere;
  RunCheckValuesCheckNodeAggregationWhereInput: RunCheckValuesCheckNodeAggregationWhereInput;
  RunCheckValuesCheckRelationship: RunCheckValuesCheckRelationship;
  RunCheckValuesConnection: RunCheckValuesConnection;
  RunCheckValuesConnectionSort: RunCheckValuesConnectionSort;
  RunCheckValuesConnectionWhere: RunCheckValuesConnectionWhere;
  RunCheckValuesEdge: RunCheckValuesEdge;
  RunCheckValuesNodeAggregationWhereInput: RunCheckValuesNodeAggregationWhereInput;
  RunCheckValuesOptions: RunCheckValuesOptions;
  RunCheckValuesRelationship: RunCheckValuesRelationship;
  RunCheckValuesRunCheckCheckAggregationSelection: RunCheckValuesRunCheckCheckAggregationSelection;
  RunCheckValuesRunCheckCheckNodeAggregateSelection: RunCheckValuesRunCheckCheckNodeAggregateSelection;
  RunCheckValuesSort: RunCheckValuesSort;
  RunCheckValuesWhere: RunCheckValuesWhere;
  RunCheckValuesWithTypeRelationship: ResolversInterfaceTypes<ResolversParentTypes>['RunCheckValuesWithTypeRelationship'];
  RunCheckValuesWithTypeRelationshipSort: RunCheckValuesWithTypeRelationshipSort;
  RunCheckValuesWithTypeRelationshipWhere: RunCheckValuesWithTypeRelationshipWhere;
  RunCheckWhere: RunCheckWhere;
  RunChecksConnection: RunChecksConnection;
  RunDQCReport: RunDqcReport;
  RunDQCReportChecksAggregateInput: RunDqcReportChecksAggregateInput;
  RunDQCReportChecksConnection: RunDqcReportChecksConnection;
  RunDQCReportChecksConnectionSort: RunDqcReportChecksConnectionSort;
  RunDQCReportChecksConnectionWhere: RunDqcReportChecksConnectionWhere;
  RunDQCReportChecksNodeAggregationWhereInput: RunDqcReportChecksNodeAggregationWhereInput;
  RunDQCReportChecksRelationship: RunDqcReportChecksRelationship;
  RunDQCReportEdge: RunDqcReportEdge;
  RunDQCReportOptions: RunDqcReportOptions;
  RunDQCReportRunCheckChecksAggregationSelection: RunDqcReportRunCheckChecksAggregationSelection;
  RunDQCReportRunCheckChecksNodeAggregateSelection: RunDqcReportRunCheckChecksNodeAggregateSelection;
  RunDQCReportSort: RunDqcReportSort;
  RunDQCReportWhere: RunDqcReportWhere;
  RunDqcReportsConnection: RunDqcReportsConnection;
  RunnableCheck: RunnableCheck;
  RunnableCheckEdge: RunnableCheckEdge;
  RunnableCheckOptions: RunnableCheckOptions;
  RunnableCheckSort: RunnableCheckSort;
  RunnableCheckWhere: RunnableCheckWhere;
  RunnableChecksConnection: RunnableChecksConnection;
  RunningJobState: RunningJobState;
  RunningJobStateEdge: RunningJobStateEdge;
  RunningJobStateOptions: RunningJobStateOptions;
  RunningJobStateSort: RunningJobStateSort;
  RunningJobStateWhere: RunningJobStateWhere;
  RunningJobStatesConnection: RunningJobStatesConnection;
  SaveCustomIntegrityCheckInput: SaveCustomIntegrityCheckInput;
  Scenario: Scenario;
  ScenarioAction: ScenarioAction;
  ScenarioActionBrandBrandsAggregationSelection: ScenarioActionBrandBrandsAggregationSelection;
  ScenarioActionBrandBrandsEdgeAggregateSelection: ScenarioActionBrandBrandsEdgeAggregateSelection;
  ScenarioActionBrandBrandsNodeAggregateSelection: ScenarioActionBrandBrandsNodeAggregateSelection;
  ScenarioActionBrandCombinedItemBrandsAggregationSelection: ScenarioActionBrandCombinedItemBrandsAggregationSelection;
  ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection: ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection;
  ScenarioActionBrandsAggregateInput: ScenarioActionBrandsAggregateInput;
  ScenarioActionBrandsConnection: ScenarioActionBrandsConnection;
  ScenarioActionBrandsConnectionSort: ScenarioActionBrandsConnectionSort;
  ScenarioActionBrandsConnectionWhere: ScenarioActionBrandsConnectionWhere;
  ScenarioActionBrandsEdgeAggregationWhereInput: ScenarioActionBrandsEdgeAggregationWhereInput;
  ScenarioActionBrandsNodeAggregationWhereInput: ScenarioActionBrandsNodeAggregationWhereInput;
  ScenarioActionBrandsRelationship: ScenarioActionBrandsRelationship;
  ScenarioActionCombinedItemBrandsAggregateInput: ScenarioActionCombinedItemBrandsAggregateInput;
  ScenarioActionCombinedItemBrandsConnection: ScenarioActionCombinedItemBrandsConnection;
  ScenarioActionCombinedItemBrandsConnectionSort: ScenarioActionCombinedItemBrandsConnectionSort;
  ScenarioActionCombinedItemBrandsConnectionWhere: ScenarioActionCombinedItemBrandsConnectionWhere;
  ScenarioActionCombinedItemBrandsNodeAggregationWhereInput: ScenarioActionCombinedItemBrandsNodeAggregationWhereInput;
  ScenarioActionCombinedItemBrandsRelationship: ScenarioActionCombinedItemBrandsRelationship;
  ScenarioActionCombinedItemGenericsAggregateInput: ScenarioActionCombinedItemGenericsAggregateInput;
  ScenarioActionCombinedItemGenericsConnection: ScenarioActionCombinedItemGenericsConnection;
  ScenarioActionCombinedItemGenericsConnectionSort: ScenarioActionCombinedItemGenericsConnectionSort;
  ScenarioActionCombinedItemGenericsConnectionWhere: ScenarioActionCombinedItemGenericsConnectionWhere;
  ScenarioActionCombinedItemGenericsNodeAggregationWhereInput: ScenarioActionCombinedItemGenericsNodeAggregationWhereInput;
  ScenarioActionCombinedItemGenericsRelationship: ScenarioActionCombinedItemGenericsRelationship;
  ScenarioActionCombinedItemTreatmentsAggregateInput: ScenarioActionCombinedItemTreatmentsAggregateInput;
  ScenarioActionCombinedItemTreatmentsConnection: ScenarioActionCombinedItemTreatmentsConnection;
  ScenarioActionCombinedItemTreatmentsConnectionSort: ScenarioActionCombinedItemTreatmentsConnectionSort;
  ScenarioActionCombinedItemTreatmentsConnectionWhere: ScenarioActionCombinedItemTreatmentsConnectionWhere;
  ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput: ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput;
  ScenarioActionCombinedItemTreatmentsRelationship: ScenarioActionCombinedItemTreatmentsRelationship;
  ScenarioActionCycleAggregateInput: ScenarioActionCycleAggregateInput;
  ScenarioActionCycleConfigurationCycleAggregationSelection: ScenarioActionCycleConfigurationCycleAggregationSelection;
  ScenarioActionCycleConfigurationCycleNodeAggregateSelection: ScenarioActionCycleConfigurationCycleNodeAggregateSelection;
  ScenarioActionCycleConnection: ScenarioActionCycleConnection;
  ScenarioActionCycleConnectionSort: ScenarioActionCycleConnectionSort;
  ScenarioActionCycleConnectionWhere: ScenarioActionCycleConnectionWhere;
  ScenarioActionCycleNodeAggregationWhereInput: ScenarioActionCycleNodeAggregationWhereInput;
  ScenarioActionCycleRelationship: ScenarioActionCycleRelationship;
  ScenarioActionEdge: ScenarioActionEdge;
  ScenarioActionGenericCombinedItemGenericsAggregationSelection: ScenarioActionGenericCombinedItemGenericsAggregationSelection;
  ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection: ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection;
  ScenarioActionGenericGenericsAggregationSelection: ScenarioActionGenericGenericsAggregationSelection;
  ScenarioActionGenericGenericsEdgeAggregateSelection: ScenarioActionGenericGenericsEdgeAggregateSelection;
  ScenarioActionGenericGenericsNodeAggregateSelection: ScenarioActionGenericGenericsNodeAggregateSelection;
  ScenarioActionGenericsAggregateInput: ScenarioActionGenericsAggregateInput;
  ScenarioActionGenericsConnection: ScenarioActionGenericsConnection;
  ScenarioActionGenericsConnectionSort: ScenarioActionGenericsConnectionSort;
  ScenarioActionGenericsConnectionWhere: ScenarioActionGenericsConnectionWhere;
  ScenarioActionGenericsEdgeAggregationWhereInput: ScenarioActionGenericsEdgeAggregationWhereInput;
  ScenarioActionGenericsNodeAggregationWhereInput: ScenarioActionGenericsNodeAggregationWhereInput;
  ScenarioActionGenericsRelationship: ScenarioActionGenericsRelationship;
  ScenarioActionInput: ScenarioActionInput;
  ScenarioActionOptions: ScenarioActionOptions;
  ScenarioActionScenarioAggregateInput: ScenarioActionScenarioAggregateInput;
  ScenarioActionScenarioConnection: ScenarioActionScenarioConnection;
  ScenarioActionScenarioConnectionSort: ScenarioActionScenarioConnectionSort;
  ScenarioActionScenarioConnectionWhere: ScenarioActionScenarioConnectionWhere;
  ScenarioActionScenarioNodeAggregationWhereInput: ScenarioActionScenarioNodeAggregationWhereInput;
  ScenarioActionScenarioRelationship: ScenarioActionScenarioRelationship;
  ScenarioActionScenarioScenarioAggregationSelection: ScenarioActionScenarioScenarioAggregationSelection;
  ScenarioActionScenarioScenarioNodeAggregateSelection: ScenarioActionScenarioScenarioNodeAggregateSelection;
  ScenarioActionSort: ScenarioActionSort;
  ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection: ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection;
  ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection: ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection;
  ScenarioActionTreatmentTreatmentsAggregationSelection: ScenarioActionTreatmentTreatmentsAggregationSelection;
  ScenarioActionTreatmentTreatmentsEdgeAggregateSelection: ScenarioActionTreatmentTreatmentsEdgeAggregateSelection;
  ScenarioActionTreatmentTreatmentsNodeAggregateSelection: ScenarioActionTreatmentTreatmentsNodeAggregateSelection;
  ScenarioActionTreatmentsAggregateInput: ScenarioActionTreatmentsAggregateInput;
  ScenarioActionTreatmentsConnection: ScenarioActionTreatmentsConnection;
  ScenarioActionTreatmentsConnectionSort: ScenarioActionTreatmentsConnectionSort;
  ScenarioActionTreatmentsConnectionWhere: ScenarioActionTreatmentsConnectionWhere;
  ScenarioActionTreatmentsEdgeAggregationWhereInput: ScenarioActionTreatmentsEdgeAggregationWhereInput;
  ScenarioActionTreatmentsNodeAggregationWhereInput: ScenarioActionTreatmentsNodeAggregationWhereInput;
  ScenarioActionTreatmentsRelationship: ScenarioActionTreatmentsRelationship;
  ScenarioActionWhere: ScenarioActionWhere;
  ScenarioActionsAggregateInput: ScenarioActionsAggregateInput;
  ScenarioActionsConnection: ScenarioActionsConnection;
  ScenarioActionsConnectionSort: ScenarioActionsConnectionSort;
  ScenarioActionsConnectionWhere: ScenarioActionsConnectionWhere;
  ScenarioActionsNodeAggregationWhereInput: ScenarioActionsNodeAggregationWhereInput;
  ScenarioActionsRelationship: ScenarioActionsRelationship;
  ScenarioCondition: ScenarioCondition;
  ScenarioConditionBrandBrandsAggregationSelection: ScenarioConditionBrandBrandsAggregationSelection;
  ScenarioConditionBrandBrandsNodeAggregateSelection: ScenarioConditionBrandBrandsNodeAggregateSelection;
  ScenarioConditionBrandsAggregateInput: ScenarioConditionBrandsAggregateInput;
  ScenarioConditionBrandsConnection: ScenarioConditionBrandsConnection;
  ScenarioConditionBrandsConnectionSort: ScenarioConditionBrandsConnectionSort;
  ScenarioConditionBrandsConnectionWhere: ScenarioConditionBrandsConnectionWhere;
  ScenarioConditionBrandsNodeAggregationWhereInput: ScenarioConditionBrandsNodeAggregationWhereInput;
  ScenarioConditionBrandsRelationship: ScenarioConditionBrandsRelationship;
  ScenarioConditionCustomConditionAggregateInput: ScenarioConditionCustomConditionAggregateInput;
  ScenarioConditionCustomConditionConnection: ScenarioConditionCustomConditionConnection;
  ScenarioConditionCustomConditionConnectionSort: ScenarioConditionCustomConditionConnectionSort;
  ScenarioConditionCustomConditionConnectionWhere: ScenarioConditionCustomConditionConnectionWhere;
  ScenarioConditionCustomConditionCustomConditionAggregationSelection: ScenarioConditionCustomConditionCustomConditionAggregationSelection;
  ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection: ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection;
  ScenarioConditionCustomConditionNodeAggregationWhereInput: ScenarioConditionCustomConditionNodeAggregationWhereInput;
  ScenarioConditionCustomConditionRelationship: ScenarioConditionCustomConditionRelationship;
  ScenarioConditionEdge: ScenarioConditionEdge;
  ScenarioConditionGenericGenericsAggregationSelection: ScenarioConditionGenericGenericsAggregationSelection;
  ScenarioConditionGenericGenericsNodeAggregateSelection: ScenarioConditionGenericGenericsNodeAggregateSelection;
  ScenarioConditionGenericsAggregateInput: ScenarioConditionGenericsAggregateInput;
  ScenarioConditionGenericsConnection: ScenarioConditionGenericsConnection;
  ScenarioConditionGenericsConnectionSort: ScenarioConditionGenericsConnectionSort;
  ScenarioConditionGenericsConnectionWhere: ScenarioConditionGenericsConnectionWhere;
  ScenarioConditionGenericsNodeAggregationWhereInput: ScenarioConditionGenericsNodeAggregationWhereInput;
  ScenarioConditionGenericsRelationship: ScenarioConditionGenericsRelationship;
  ScenarioConditionInput: ScenarioConditionInput;
  ScenarioConditionOptions: ScenarioConditionOptions;
  ScenarioConditionScenarioAggregateInput: ScenarioConditionScenarioAggregateInput;
  ScenarioConditionScenarioConnection: ScenarioConditionScenarioConnection;
  ScenarioConditionScenarioConnectionSort: ScenarioConditionScenarioConnectionSort;
  ScenarioConditionScenarioConnectionWhere: ScenarioConditionScenarioConnectionWhere;
  ScenarioConditionScenarioNodeAggregationWhereInput: ScenarioConditionScenarioNodeAggregationWhereInput;
  ScenarioConditionScenarioRelationship: ScenarioConditionScenarioRelationship;
  ScenarioConditionScenarioScenarioAggregationSelection: ScenarioConditionScenarioScenarioAggregationSelection;
  ScenarioConditionScenarioScenarioNodeAggregateSelection: ScenarioConditionScenarioScenarioNodeAggregateSelection;
  ScenarioConditionSort: ScenarioConditionSort;
  ScenarioConditionTreatmentTreatmentsAggregationSelection: ScenarioConditionTreatmentTreatmentsAggregationSelection;
  ScenarioConditionTreatmentTreatmentsNodeAggregateSelection: ScenarioConditionTreatmentTreatmentsNodeAggregateSelection;
  ScenarioConditionTreatmentsAggregateInput: ScenarioConditionTreatmentsAggregateInput;
  ScenarioConditionTreatmentsConnection: ScenarioConditionTreatmentsConnection;
  ScenarioConditionTreatmentsConnectionSort: ScenarioConditionTreatmentsConnectionSort;
  ScenarioConditionTreatmentsConnectionWhere: ScenarioConditionTreatmentsConnectionWhere;
  ScenarioConditionTreatmentsNodeAggregationWhereInput: ScenarioConditionTreatmentsNodeAggregationWhereInput;
  ScenarioConditionTreatmentsRelationship: ScenarioConditionTreatmentsRelationship;
  ScenarioConditionWhere: ScenarioConditionWhere;
  ScenarioConditionsAggregateInput: ScenarioConditionsAggregateInput;
  ScenarioConditionsConnection: ScenarioConditionsConnection;
  ScenarioConditionsConnectionSort: ScenarioConditionsConnectionSort;
  ScenarioConditionsConnectionWhere: ScenarioConditionsConnectionWhere;
  ScenarioConditionsNodeAggregationWhereInput: ScenarioConditionsNodeAggregationWhereInput;
  ScenarioConditionsRelationship: ScenarioConditionsRelationship;
  ScenarioEdge: ScenarioEdge;
  ScenarioInput: ScenarioInput;
  ScenarioInsightsUserContext: ResolversInterfaceTypes<ResolversParentTypes>['ScenarioInsightsUserContext'];
  ScenarioInsightsUserContextSort: ScenarioInsightsUserContextSort;
  ScenarioInsightsUserContextWhere: ScenarioInsightsUserContextWhere;
  ScenarioOptions: ScenarioOptions;
  ScenarioScenarioActionActionsAggregationSelection: ScenarioScenarioActionActionsAggregationSelection;
  ScenarioScenarioActionActionsNodeAggregateSelection: ScenarioScenarioActionActionsNodeAggregateSelection;
  ScenarioScenarioConditionConditionsAggregationSelection: ScenarioScenarioConditionConditionsAggregationSelection;
  ScenarioScenarioConditionConditionsNodeAggregateSelection: ScenarioScenarioConditionConditionsNodeAggregateSelection;
  ScenarioSort: ScenarioSort;
  ScenarioWhere: ScenarioWhere;
  ScenariosConnection: ScenariosConnection;
  ScopeCheckResult: ScopeCheckResult;
  ScopeCheckResultEdge: ScopeCheckResultEdge;
  ScopeCheckResultOptions: ScopeCheckResultOptions;
  ScopeCheckResultSort: ScopeCheckResultSort;
  ScopeCheckResultWhere: ScopeCheckResultWhere;
  ScopeCheckResultsConnection: ScopeCheckResultsConnection;
  Simulation: Simulation;
  SimulationAccessibleUsersAggregateInput: SimulationAccessibleUsersAggregateInput;
  SimulationAccessibleUsersConnection: SimulationAccessibleUsersConnection;
  SimulationAccessibleUsersConnectionSort: SimulationAccessibleUsersConnectionSort;
  SimulationAccessibleUsersConnectionWhere: SimulationAccessibleUsersConnectionWhere;
  SimulationAccessibleUsersEdgeAggregationWhereInput: SimulationAccessibleUsersEdgeAggregationWhereInput;
  SimulationAccessibleUsersNodeAggregationWhereInput: SimulationAccessibleUsersNodeAggregationWhereInput;
  SimulationAccessibleUsersRelationship: SimulationAccessibleUsersRelationship;
  SimulationAddedByAggregateInput: SimulationAddedByAggregateInput;
  SimulationAddedByConnection: SimulationAddedByConnection;
  SimulationAddedByConnectionSort: SimulationAddedByConnectionSort;
  SimulationAddedByConnectionWhere: SimulationAddedByConnectionWhere;
  SimulationAddedByNodeAggregationWhereInput: SimulationAddedByNodeAggregationWhereInput;
  SimulationAddedByRelationship: SimulationAddedByRelationship;
  SimulationBlueprintAggregateInput: SimulationBlueprintAggregateInput;
  SimulationBlueprintConnection: SimulationBlueprintConnection;
  SimulationBlueprintConnectionSort: SimulationBlueprintConnectionSort;
  SimulationBlueprintConnectionWhere: SimulationBlueprintConnectionWhere;
  SimulationBlueprintNodeAggregationWhereInput: SimulationBlueprintNodeAggregationWhereInput;
  SimulationBlueprintRelationship: SimulationBlueprintRelationship;
  SimulationCount: SimulationCount;
  SimulationCountEdge: SimulationCountEdge;
  SimulationCountOptions: SimulationCountOptions;
  SimulationCountSort: SimulationCountSort;
  SimulationCountWhere: SimulationCountWhere;
  SimulationCountsConnection: SimulationCountsConnection;
  SimulationDomainAggregateInput: SimulationDomainAggregateInput;
  SimulationDomainConnection: SimulationDomainConnection;
  SimulationDomainConnectionSort: SimulationDomainConnectionSort;
  SimulationDomainConnectionWhere: SimulationDomainConnectionWhere;
  SimulationDomainDomainAggregationSelection: SimulationDomainDomainAggregationSelection;
  SimulationDomainDomainNodeAggregateSelection: SimulationDomainDomainNodeAggregateSelection;
  SimulationDomainNodeAggregationWhereInput: SimulationDomainNodeAggregationWhereInput;
  SimulationDomainRelationship: SimulationDomainRelationship;
  SimulationEdge: SimulationEdge;
  SimulationOptions: SimulationOptions;
  SimulationProductBlueprintBlueprintAggregationSelection: SimulationProductBlueprintBlueprintAggregationSelection;
  SimulationProductBlueprintBlueprintNodeAggregateSelection: SimulationProductBlueprintBlueprintNodeAggregateSelection;
  SimulationSort: SimulationSort;
  SimulationUserAccessibleUsersAggregationSelection: SimulationUserAccessibleUsersAggregationSelection;
  SimulationUserAccessibleUsersEdgeAggregateSelection: SimulationUserAccessibleUsersEdgeAggregateSelection;
  SimulationUserAccessibleUsersNodeAggregateSelection: SimulationUserAccessibleUsersNodeAggregateSelection;
  SimulationUserAddedByAggregationSelection: SimulationUserAddedByAggregationSelection;
  SimulationUserAddedByNodeAggregateSelection: SimulationUserAddedByNodeAggregateSelection;
  SimulationUserWithRole: SimulationUserWithRole;
  SimulationUserWithRoleEdge: SimulationUserWithRoleEdge;
  SimulationUserWithRoleOptions: SimulationUserWithRoleOptions;
  SimulationUserWithRoleSort: SimulationUserWithRoleSort;
  SimulationUserWithRoleWhere: SimulationUserWithRoleWhere;
  SimulationUserWithRolesConnection: SimulationUserWithRolesConnection;
  SimulationWhere: SimulationWhere;
  SimulationsConnection: SimulationsConnection;
  SimulatorUserRoleRelationship: ResolversInterfaceTypes<ResolversParentTypes>['SimulatorUserRoleRelationship'];
  SimulatorUserRoleRelationshipSort: SimulatorUserRoleRelationshipSort;
  SimulatorUserRoleRelationshipWhere: SimulatorUserRoleRelationshipWhere;
  SlowGraphqlOperation: SlowGraphqlOperation;
  SlowGraphqlOperationEdge: SlowGraphqlOperationEdge;
  SlowGraphqlOperationOptions: SlowGraphqlOperationOptions;
  SlowGraphqlOperationSort: SlowGraphqlOperationSort;
  SlowGraphqlOperationWhere: SlowGraphqlOperationWhere;
  SlowGraphqlOperationsConnection: SlowGraphqlOperationsConnection;
  SlowGraphqlRequestsResult: SlowGraphqlRequestsResult;
  SlowGraphqlRequestsResultEdge: SlowGraphqlRequestsResultEdge;
  SlowGraphqlRequestsResultOptions: SlowGraphqlRequestsResultOptions;
  SlowGraphqlRequestsResultSort: SlowGraphqlRequestsResultSort;
  SlowGraphqlRequestsResultWhere: SlowGraphqlRequestsResultWhere;
  SlowGraphqlRequestsResultsConnection: SlowGraphqlRequestsResultsConnection;
  StoreUser: StoreUser;
  StoreUserEdge: StoreUserEdge;
  StoreUserOptions: StoreUserOptions;
  StoreUserSort: StoreUserSort;
  StoreUserWhere: StoreUserWhere;
  StoreUsersConnection: StoreUsersConnection;
  String: Scalars['String']['output'];
  StringAggregateSelectionNonNullable: StringAggregateSelectionNonNullable;
  StringAggregateSelectionNullable: StringAggregateSelectionNullable;
  Subscription: {};
  SyncRefundImpact: SyncRefundImpact;
  SyncRefundImpactEdge: SyncRefundImpactEdge;
  SyncRefundImpactOptions: SyncRefundImpactOptions;
  SyncRefundImpactSort: SyncRefundImpactSort;
  SyncRefundImpactWhere: SyncRefundImpactWhere;
  SyncRefundImpactsConnection: SyncRefundImpactsConnection;
  SyncResponse: SyncResponse;
  SyncResponseEdge: SyncResponseEdge;
  SyncResponseOptions: SyncResponseOptions;
  SyncResponseSort: SyncResponseSort;
  SyncResponseWhere: SyncResponseWhere;
  SyncResponsesConnection: SyncResponsesConnection;
  SystemTask: SystemTask;
  SystemTaskEdge: SystemTaskEdge;
  SystemTaskOptions: SystemTaskOptions;
  SystemTaskSort: SystemTaskSort;
  SystemTaskWhere: SystemTaskWhere;
  SystemTasksConnection: SystemTasksConnection;
  TermsAndPoliciesInput: TermsAndPoliciesInput;
  ThresholdConfigurationRelationship: ResolversInterfaceTypes<ResolversParentTypes>['ThresholdConfigurationRelationship'];
  ThresholdConfigurationRelationshipSort: ThresholdConfigurationRelationshipSort;
  ThresholdConfigurationRelationshipWhere: ThresholdConfigurationRelationshipWhere;
  Translation: Translation;
  TranslationEdge: TranslationEdge;
  TranslationInput: TranslationInput;
  TranslationLanguageInput: TranslationLanguageInput;
  TranslationOptions: TranslationOptions;
  TranslationSort: TranslationSort;
  TranslationWhere: TranslationWhere;
  TranslationsConnection: TranslationsConnection;
  TranslationsInput: TranslationsInput;
  TranslationsWithChangedKeys: TranslationsWithChangedKeys;
  TranslationsWithChangedKeysConnection: TranslationsWithChangedKeysConnection;
  TranslationsWithChangedKeysEdge: TranslationsWithChangedKeysEdge;
  TranslationsWithChangedKeysOptions: TranslationsWithChangedKeysOptions;
  TranslationsWithChangedKeysSort: TranslationsWithChangedKeysSort;
  TranslationsWithChangedKeysWhere: TranslationsWithChangedKeysWhere;
  Treatment: Treatment;
  TreatmentCountryAggregateInput: TreatmentCountryAggregateInput;
  TreatmentCountryConnection: TreatmentCountryConnection;
  TreatmentCountryConnectionSort: TreatmentCountryConnectionSort;
  TreatmentCountryConnectionWhere: TreatmentCountryConnectionWhere;
  TreatmentCountryCountryAggregationSelection: TreatmentCountryCountryAggregationSelection;
  TreatmentCountryCountryNodeAggregateSelection: TreatmentCountryCountryNodeAggregateSelection;
  TreatmentCountryNodeAggregationWhereInput: TreatmentCountryNodeAggregationWhereInput;
  TreatmentCountryRelationship: TreatmentCountryRelationship;
  TreatmentEdge: TreatmentEdge;
  TreatmentHasLimitationsAggregateInput: TreatmentHasLimitationsAggregateInput;
  TreatmentHasLimitationsConnection: TreatmentHasLimitationsConnection;
  TreatmentHasLimitationsConnectionSort: TreatmentHasLimitationsConnectionSort;
  TreatmentHasLimitationsConnectionWhere: TreatmentHasLimitationsConnectionWhere;
  TreatmentHasLimitationsNodeAggregationWhereInput: TreatmentHasLimitationsNodeAggregationWhereInput;
  TreatmentHasLimitationsRelationship: TreatmentHasLimitationsRelationship;
  TreatmentInput: TreatmentInput;
  TreatmentLimitationHasLimitationsAggregationSelection: TreatmentLimitationHasLimitationsAggregationSelection;
  TreatmentLimitationHasLimitationsNodeAggregateSelection: TreatmentLimitationHasLimitationsNodeAggregateSelection;
  TreatmentOptions: TreatmentOptions;
  TreatmentPartnerPartnersAggregationSelection: TreatmentPartnerPartnersAggregationSelection;
  TreatmentPartnerPartnersNodeAggregateSelection: TreatmentPartnerPartnersNodeAggregateSelection;
  TreatmentPartnersAggregateInput: TreatmentPartnersAggregateInput;
  TreatmentPartnersConnection: TreatmentPartnersConnection;
  TreatmentPartnersConnectionSort: TreatmentPartnersConnectionSort;
  TreatmentPartnersConnectionWhere: TreatmentPartnersConnectionWhere;
  TreatmentPartnersNodeAggregationWhereInput: TreatmentPartnersNodeAggregationWhereInput;
  TreatmentPartnersRelationship: TreatmentPartnersRelationship;
  TreatmentPreparationRegulatedByAggregationSelection: TreatmentPreparationRegulatedByAggregationSelection;
  TreatmentPreparationRegulatedByNodeAggregateSelection: TreatmentPreparationRegulatedByNodeAggregateSelection;
  TreatmentPreparationStatusStatusAggregationSelection: TreatmentPreparationStatusStatusAggregationSelection;
  TreatmentPreparationStatusStatusNodeAggregateSelection: TreatmentPreparationStatusStatusNodeAggregateSelection;
  TreatmentPriceInput: TreatmentPriceInput;
  TreatmentPricePricesAggregationSelection: TreatmentPricePricesAggregationSelection;
  TreatmentPricePricesNodeAggregateSelection: TreatmentPricePricesNodeAggregateSelection;
  TreatmentPricesAggregateInput: TreatmentPricesAggregateInput;
  TreatmentPricesConnection: TreatmentPricesConnection;
  TreatmentPricesConnectionSort: TreatmentPricesConnectionSort;
  TreatmentPricesConnectionWhere: TreatmentPricesConnectionWhere;
  TreatmentPricesNodeAggregationWhereInput: TreatmentPricesNodeAggregationWhereInput;
  TreatmentPricesRelationship: TreatmentPricesRelationship;
  TreatmentRegulatedByAggregateInput: TreatmentRegulatedByAggregateInput;
  TreatmentRegulatedByConnection: TreatmentRegulatedByConnection;
  TreatmentRegulatedByConnectionSort: TreatmentRegulatedByConnectionSort;
  TreatmentRegulatedByConnectionWhere: TreatmentRegulatedByConnectionWhere;
  TreatmentRegulatedByNodeAggregationWhereInput: TreatmentRegulatedByNodeAggregationWhereInput;
  TreatmentRegulatedByRelationship: TreatmentRegulatedByRelationship;
  TreatmentSet: TreatmentSet;
  TreatmentSetAgreementScopeScopeAggregationSelection: TreatmentSetAgreementScopeScopeAggregationSelection;
  TreatmentSetAgreementScopeScopeNodeAggregateSelection: TreatmentSetAgreementScopeScopeNodeAggregateSelection;
  TreatmentSetEdge: TreatmentSetEdge;
  TreatmentSetGenericAggregateInput: TreatmentSetGenericAggregateInput;
  TreatmentSetGenericConnection: TreatmentSetGenericConnection;
  TreatmentSetGenericConnectionSort: TreatmentSetGenericConnectionSort;
  TreatmentSetGenericConnectionWhere: TreatmentSetGenericConnectionWhere;
  TreatmentSetGenericGenericAggregationSelection: TreatmentSetGenericGenericAggregationSelection;
  TreatmentSetGenericGenericNodeAggregateSelection: TreatmentSetGenericGenericNodeAggregateSelection;
  TreatmentSetGenericNodeAggregationWhereInput: TreatmentSetGenericNodeAggregationWhereInput;
  TreatmentSetGenericRelationship: TreatmentSetGenericRelationship;
  TreatmentSetInput: TreatmentSetInput;
  TreatmentSetOptions: TreatmentSetOptions;
  TreatmentSetPreparationPreparationsAggregationSelection: TreatmentSetPreparationPreparationsAggregationSelection;
  TreatmentSetPreparationPreparationsNodeAggregateSelection: TreatmentSetPreparationPreparationsNodeAggregateSelection;
  TreatmentSetPreparationsAggregateInput: TreatmentSetPreparationsAggregateInput;
  TreatmentSetPreparationsConnection: TreatmentSetPreparationsConnection;
  TreatmentSetPreparationsConnectionSort: TreatmentSetPreparationsConnectionSort;
  TreatmentSetPreparationsConnectionWhere: TreatmentSetPreparationsConnectionWhere;
  TreatmentSetPreparationsNodeAggregationWhereInput: TreatmentSetPreparationsNodeAggregationWhereInput;
  TreatmentSetPreparationsRelationship: TreatmentSetPreparationsRelationship;
  TreatmentSetScopeAggregateInput: TreatmentSetScopeAggregateInput;
  TreatmentSetScopeConnection: TreatmentSetScopeConnection;
  TreatmentSetScopeConnectionSort: TreatmentSetScopeConnectionSort;
  TreatmentSetScopeConnectionWhere: TreatmentSetScopeConnectionWhere;
  TreatmentSetScopeNodeAggregationWhereInput: TreatmentSetScopeNodeAggregationWhereInput;
  TreatmentSetScopeRelationship: TreatmentSetScopeRelationship;
  TreatmentSetSort: TreatmentSetSort;
  TreatmentSetTreatmentTreatmentsAggregationSelection: TreatmentSetTreatmentTreatmentsAggregationSelection;
  TreatmentSetTreatmentTreatmentsNodeAggregateSelection: TreatmentSetTreatmentTreatmentsNodeAggregateSelection;
  TreatmentSetTreatmentsAggregateInput: TreatmentSetTreatmentsAggregateInput;
  TreatmentSetTreatmentsConnection: TreatmentSetTreatmentsConnection;
  TreatmentSetTreatmentsConnectionSort: TreatmentSetTreatmentsConnectionSort;
  TreatmentSetTreatmentsConnectionWhere: TreatmentSetTreatmentsConnectionWhere;
  TreatmentSetTreatmentsNodeAggregationWhereInput: TreatmentSetTreatmentsNodeAggregationWhereInput;
  TreatmentSetTreatmentsRelationship: TreatmentSetTreatmentsRelationship;
  TreatmentSetWhere: TreatmentSetWhere;
  TreatmentSetsConnection: TreatmentSetsConnection;
  TreatmentSort: TreatmentSort;
  TreatmentStatusAggregateInput: TreatmentStatusAggregateInput;
  TreatmentStatusConnection: TreatmentStatusConnection;
  TreatmentStatusConnectionSort: TreatmentStatusConnectionSort;
  TreatmentStatusConnectionWhere: TreatmentStatusConnectionWhere;
  TreatmentStatusNodeAggregationWhereInput: TreatmentStatusNodeAggregationWhereInput;
  TreatmentStatusRelationship: TreatmentStatusRelationship;
  TreatmentWhere: TreatmentWhere;
  TreatmentsConnection: TreatmentsConnection;
  UpdateCustomConditionInput: UpdateCustomConditionInput;
  UpdateIndicationInput: UpdateIndicationInput;
  UpdateMissingKeyInput: UpdateMissingKeyInput;
  UpdateTranslationPayload: UpdateTranslationPayload;
  Upload: Upload;
  UploadEdge: UploadEdge;
  UploadFlexEntitiesAggregateInput: UploadFlexEntitiesAggregateInput;
  UploadFlexEntitiesConnection: UploadFlexEntitiesConnection;
  UploadFlexEntitiesConnectionSort: UploadFlexEntitiesConnectionSort;
  UploadFlexEntitiesConnectionWhere: UploadFlexEntitiesConnectionWhere;
  UploadFlexEntitiesNodeAggregationWhereInput: UploadFlexEntitiesNodeAggregationWhereInput;
  UploadFlexEntitiesRelationship: UploadFlexEntitiesRelationship;
  UploadFlexEntityFlexEntitiesAggregationSelection: UploadFlexEntityFlexEntitiesAggregationSelection;
  UploadFlexEntityFlexEntitiesNodeAggregateSelection: UploadFlexEntityFlexEntitiesNodeAggregateSelection;
  UploadLimitation: UploadLimitation;
  UploadLimitationEdge: UploadLimitationEdge;
  UploadLimitationInput: UploadLimitationInput;
  UploadLimitationOptions: UploadLimitationOptions;
  UploadLimitationSort: UploadLimitationSort;
  UploadLimitationUpdatedByAggregateInput: UploadLimitationUpdatedByAggregateInput;
  UploadLimitationUpdatedByConnection: UploadLimitationUpdatedByConnection;
  UploadLimitationUpdatedByConnectionSort: UploadLimitationUpdatedByConnectionSort;
  UploadLimitationUpdatedByConnectionWhere: UploadLimitationUpdatedByConnectionWhere;
  UploadLimitationUpdatedByEdgeAggregationWhereInput: UploadLimitationUpdatedByEdgeAggregationWhereInput;
  UploadLimitationUpdatedByNodeAggregationWhereInput: UploadLimitationUpdatedByNodeAggregationWhereInput;
  UploadLimitationUpdatedByRelationship: UploadLimitationUpdatedByRelationship;
  UploadLimitationUpdaterRelationship: ResolversInterfaceTypes<ResolversParentTypes>['UploadLimitationUpdaterRelationship'];
  UploadLimitationUpdaterRelationshipSort: UploadLimitationUpdaterRelationshipSort;
  UploadLimitationUpdaterRelationshipWhere: UploadLimitationUpdaterRelationshipWhere;
  UploadLimitationUserUpdatedByAggregationSelection: UploadLimitationUserUpdatedByAggregationSelection;
  UploadLimitationUserUpdatedByEdgeAggregateSelection: UploadLimitationUserUpdatedByEdgeAggregateSelection;
  UploadLimitationUserUpdatedByNodeAggregateSelection: UploadLimitationUserUpdatedByNodeAggregateSelection;
  UploadLimitationWhere: UploadLimitationWhere;
  UploadLimitationsConnection: UploadLimitationsConnection;
  UploadOptions: UploadOptions;
  UploadSort: UploadSort;
  UploadState: UploadState;
  UploadStateEdge: UploadStateEdge;
  UploadStateOptions: UploadStateOptions;
  UploadStateSort: UploadStateSort;
  UploadStateWhere: UploadStateWhere;
  UploadStatesConnection: UploadStatesConnection;
  UploadWhere: UploadWhere;
  UploadsConnection: UploadsConnection;
  User: User;
  UserAssignDomainsInput: UserAssignDomainsInput;
  UserAvailableEntryModule: UserAvailableEntryModule;
  UserAvailableEntryModuleEdge: UserAvailableEntryModuleEdge;
  UserAvailableEntryModuleOptions: UserAvailableEntryModuleOptions;
  UserAvailableEntryModuleSort: UserAvailableEntryModuleSort;
  UserAvailableEntryModuleWhere: UserAvailableEntryModuleWhere;
  UserAvailableEntryModulesConnection: UserAvailableEntryModulesConnection;
  UserContext: UserContext;
  UserContextEdge: UserContextEdge;
  UserContextOptions: UserContextOptions;
  UserContextSort: UserContextSort;
  UserContextWhere: UserContextWhere;
  UserContextsConnection: UserContextsConnection;
  UserDomainDomainsAggregationSelection: UserDomainDomainsAggregationSelection;
  UserDomainDomainsNodeAggregateSelection: UserDomainDomainsNodeAggregateSelection;
  UserDomainsAggregateInput: UserDomainsAggregateInput;
  UserDomainsConnection: UserDomainsConnection;
  UserDomainsConnectionSort: UserDomainsConnectionSort;
  UserDomainsConnectionWhere: UserDomainsConnectionWhere;
  UserDomainsNodeAggregationWhereInput: UserDomainsNodeAggregationWhereInput;
  UserDomainsRelationship: UserDomainsRelationship;
  UserEdge: UserEdge;
  UserInput: UserInput;
  UserOptions: UserOptions;
  UserOrgSettingsData: UserOrgSettingsData;
  UserOrgSettingsDataConnection: UserOrgSettingsDataConnection;
  UserOrgSettingsDataEdge: UserOrgSettingsDataEdge;
  UserOrgSettingsDataOptions: UserOrgSettingsDataOptions;
  UserOrgSettingsDataSort: UserOrgSettingsDataSort;
  UserOrgSettingsDataWhere: UserOrgSettingsDataWhere;
  UserOrganizationInfo: UserOrganizationInfo;
  UserOrganizationInfoEdge: UserOrganizationInfoEdge;
  UserOrganizationInfoOptions: UserOrganizationInfoOptions;
  UserOrganizationInfoSort: UserOrganizationInfoSort;
  UserOrganizationInfoWhere: UserOrganizationInfoWhere;
  UserOrganizationInfosConnection: UserOrganizationInfosConnection;
  UserRoleRequestUpdateInput: UserRoleRequestUpdateInput;
  UserSort: UserSort;
  UserWhere: UserWhere;
  UsersConnection: UsersConnection;
  VASProductBlueprintInput: VasProductBlueprintInput;
};

export type ClobDirectiveArgs = { };

export type ClobDirectiveResolver<Result, Parent, ContextType = any, Args = ClobDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type MaxDirectiveArgs = {
  value: Scalars['Float']['input'];
};

export type MaxDirectiveResolver<Result, Parent, ContextType = any, Args = MaxDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type MinDirectiveArgs = {
  value: Scalars['Float']['input'];
};

export type MinDirectiveResolver<Result, Parent, ContextType = any, Args = MinDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ActionPrescriptionRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionPrescriptionRelationship'] = ResolversParentTypes['ActionPrescriptionRelationship']> = {
  __resolveType: TypeResolveFn<'ScenarioActionBrandsRelationship' | 'ScenarioActionGenericsRelationship' | 'ScenarioActionTreatmentsRelationship', ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type ActiveUserSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActiveUserSession'] = ResolversParentTypes['ActiveUserSession']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loginTimeUtc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subjectId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokenRefreshTimeUtc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActiveUserSessionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActiveUserSessionEdge'] = ResolversParentTypes['ActiveUserSessionEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ActiveUserSession'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActiveUserSessionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActiveUserSessionsConnection'] = ResolversParentTypes['ActiveUserSessionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ActiveUserSessionEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Agreement'] = ResolversParentTypes['Agreement']> = {
  addedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<AgreementAddedByArgs, 'directed'>>;
  addedByAggregate?: Resolver<Maybe<ResolversTypes['AgreementUserAddedByAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementAddedByAggregateArgs, 'directed'>>;
  addedByConnection?: Resolver<ResolversTypes['AgreementAddedByConnection'], ParentType, ContextType, RequireFields<AgreementAddedByConnectionArgs, 'directed'>>;
  allowedForms?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  allowedRecords?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  areCasesCreated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  caseSuspensionIntervalDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  counterparties?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType, RequireFields<AgreementCounterpartiesArgs, 'directed'>>;
  counterpartiesAggregate?: Resolver<Maybe<ResolversTypes['AgreementOrganizationCounterpartiesAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementCounterpartiesAggregateArgs, 'directed'>>;
  counterpartiesConnection?: Resolver<ResolversTypes['AgreementCounterpartiesConnection'], ParentType, ContextType, RequireFields<AgreementCounterpartiesConnectionArgs, 'directed'>>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType, RequireFields<AgreementCountryArgs, 'directed'>>;
  countryAggregate?: Resolver<Maybe<ResolversTypes['AgreementCountryCountryAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementCountryAggregateArgs, 'directed'>>;
  countryConnection?: Resolver<ResolversTypes['AgreementCountryConnection'], ParentType, ContextType, RequireFields<AgreementCountryConnectionArgs, 'directed'>>;
  coveringFormWaitInterval?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType, RequireFields<AgreementCurrencyArgs, 'directed'>>;
  currencyAggregate?: Resolver<Maybe<ResolversTypes['AgreementCurrencyCurrencyAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementCurrencyAggregateArgs, 'directed'>>;
  currencyConnection?: Resolver<ResolversTypes['AgreementCurrencyConnection'], ParentType, ContextType, RequireFields<AgreementCurrencyConnectionArgs, 'directed'>>;
  cycles?: Resolver<Array<ResolversTypes['CycleConfiguration']>, ParentType, ContextType, RequireFields<AgreementCyclesArgs, 'directed'>>;
  cyclesAggregate?: Resolver<Maybe<ResolversTypes['AgreementCycleConfigurationCyclesAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementCyclesAggregateArgs, 'directed'>>;
  cyclesConnection?: Resolver<ResolversTypes['AgreementCyclesConnection'], ParentType, ContextType, RequireFields<AgreementCyclesConnectionArgs, 'directed'>>;
  dataContainers?: Resolver<Array<ResolversTypes['DataContainer']>, ParentType, ContextType, RequireFields<AgreementDataContainersArgs, 'directed'>>;
  dataContainersAggregate?: Resolver<Maybe<ResolversTypes['AgreementDataContainerDataContainersAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementDataContainersAggregateArgs, 'directed'>>;
  dataContainersConnection?: Resolver<ResolversTypes['AgreementDataContainersConnection'], ParentType, ContextType, RequireFields<AgreementDataContainersConnectionArgs, 'directed'>>;
  dataSource?: Resolver<ResolversTypes['DataSource'], ParentType, ContextType, RequireFields<AgreementDataSourceArgs, 'directed'>>;
  dataSourceAggregate?: Resolver<Maybe<ResolversTypes['AgreementDataSourceDataSourceAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementDataSourceAggregateArgs, 'directed'>>;
  dataSourceConnection?: Resolver<ResolversTypes['AgreementDataSourceConnection'], ParentType, ContextType, RequireFields<AgreementDataSourceConnectionArgs, 'directed'>>;
  daysToExpiry?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  defaultPriceRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  deviceAlternativeSets?: Resolver<Array<ResolversTypes['DeviceAlternative']>, ParentType, ContextType, RequireFields<AgreementDeviceAlternativeSetsArgs, 'directed'>>;
  deviceAlternativeSetsAggregate?: Resolver<Maybe<ResolversTypes['AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementDeviceAlternativeSetsAggregateArgs, 'directed'>>;
  deviceAlternativeSetsConnection?: Resolver<ResolversTypes['AgreementDeviceAlternativeSetsConnection'], ParentType, ContextType, RequireFields<AgreementDeviceAlternativeSetsConnectionArgs, 'directed'>>;
  dotThresholds?: Resolver<Maybe<ResolversTypes['ChartRangeConfiguration']>, ParentType, ContextType, RequireFields<AgreementDotThresholdsArgs, 'directed'>>;
  dotThresholdsAggregate?: Resolver<Maybe<ResolversTypes['AgreementChartRangeConfigurationDotThresholdsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementDotThresholdsAggregateArgs, 'directed'>>;
  dotThresholdsConnection?: Resolver<ResolversTypes['AgreementDotThresholdsConnection'], ParentType, ContextType, RequireFields<AgreementDotThresholdsConnectionArgs, 'directed'>>;
  eligibilityConditionSets?: Resolver<Array<ResolversTypes['EligibilityConditionSet']>, ParentType, ContextType, RequireFields<AgreementEligibilityConditionSetsArgs, 'directed'>>;
  eligibilityConditionSetsAggregate?: Resolver<Maybe<ResolversTypes['AgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementEligibilityConditionSetsAggregateArgs, 'directed'>>;
  eligibilityConditionSetsConnection?: Resolver<ResolversTypes['AgreementEligibilityConditionSetsConnection'], ParentType, ContextType, RequireFields<AgreementEligibilityConditionSetsConnectionArgs, 'directed'>>;
  eligibilityConditionTreatments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Treatment']>>>, ParentType, ContextType>;
  enrollingConditionSets?: Resolver<Array<ResolversTypes['EnrollingConditionSet']>, ParentType, ContextType, RequireFields<AgreementEnrollingConditionSetsArgs, 'directed'>>;
  enrollingConditionSetsAggregate?: Resolver<Maybe<ResolversTypes['AgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementEnrollingConditionSetsAggregateArgs, 'directed'>>;
  enrollingConditionSetsConnection?: Resolver<ResolversTypes['AgreementEnrollingConditionSetsConnection'], ParentType, ContextType, RequireFields<AgreementEnrollingConditionSetsConnectionArgs, 'directed'>>;
  enrollingPeriods?: Resolver<Array<ResolversTypes['EnrollingPeriod']>, ParentType, ContextType, RequireFields<AgreementEnrollingPeriodsArgs, 'directed'>>;
  enrollingPeriodsAggregate?: Resolver<Maybe<ResolversTypes['AgreementEnrollingPeriodEnrollingPeriodsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementEnrollingPeriodsAggregateArgs, 'directed'>>;
  enrollingPeriodsConnection?: Resolver<ResolversTypes['AgreementEnrollingPeriodsConnection'], ParentType, ContextType, RequireFields<AgreementEnrollingPeriodsConnectionArgs, 'directed'>>;
  enrolmentDateType?: Resolver<Maybe<ResolversTypes['EnrolmentDateType']>, ParentType, ContextType>;
  expectedDocument?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  financialSummaryConfig?: Resolver<Array<ResolversTypes['FinancialSummaryColumn']>, ParentType, ContextType, RequireFields<AgreementFinancialSummaryConfigArgs, 'directed'>>;
  financialSummaryConfigAggregate?: Resolver<Maybe<ResolversTypes['AgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementFinancialSummaryConfigAggregateArgs, 'directed'>>;
  financialSummaryConfigConnection?: Resolver<ResolversTypes['AgreementFinancialSummaryConfigConnection'], ParentType, ContextType, RequireFields<AgreementFinancialSummaryConfigConnectionArgs, 'directed'>>;
  firstExecutionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  formattedAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedCounterparties?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedDiseases?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedIndications?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedProducts?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedTags?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generics?: Resolver<Array<ResolversTypes['Generic']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  initialVersion?: Resolver<Maybe<ResolversTypes['Agreement']>, ParentType, ContextType, RequireFields<AgreementInitialVersionArgs, 'directed'>>;
  initialVersionAggregate?: Resolver<Maybe<ResolversTypes['AgreementAgreementInitialVersionAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementInitialVersionAggregateArgs, 'directed'>>;
  initialVersionConnection?: Resolver<ResolversTypes['AgreementInitialVersionConnection'], ParentType, ContextType, RequireFields<AgreementInitialVersionConnectionArgs, 'directed'>>;
  initialVersionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAllowedFormsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isAllowedRecordsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isArchived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isAutoCreated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCaseless?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCoveringIntervalEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isExtended?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFirstVersion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isInsightsAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLastVersion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isNewVersionManuallyCreated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isRequiredFormsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRequiredRecordsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isScenariosInSync?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isScopeSync?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isValidityPeriodInSync?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastExecutionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastUpdatedOn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastVersionValidToDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  limitation?: Resolver<Maybe<ResolversTypes['Limitation']>, ParentType, ContextType, RequireFields<AgreementLimitationArgs, 'directed'>>;
  limitationAggregate?: Resolver<Maybe<ResolversTypes['AgreementLimitationLimitationAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementLimitationAggregateArgs, 'directed'>>;
  limitationConnection?: Resolver<ResolversTypes['AgreementLimitationConnection'], ParentType, ContextType, RequireFields<AgreementLimitationConnectionArgs, 'directed'>>;
  minValidFromDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  negotiableAttributes?: Resolver<Array<ResolversTypes['CatalogueAttribute']>, ParentType, ContextType, RequireFields<AgreementNegotiableAttributesArgs, 'directed'>>;
  negotiableAttributesAggregate?: Resolver<Maybe<ResolversTypes['AgreementCatalogueAttributeNegotiableAttributesAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementNegotiableAttributesAggregateArgs, 'directed'>>;
  negotiableAttributesConnection?: Resolver<ResolversTypes['AgreementNegotiableAttributesConnection'], ParentType, ContextType, RequireFields<AgreementNegotiableAttributesConnectionArgs, 'directed'>>;
  nextVersions?: Resolver<Array<ResolversTypes['Agreement']>, ParentType, ContextType, RequireFields<AgreementNextVersionsArgs, 'directed'>>;
  nextVersionsAggregate?: Resolver<Maybe<ResolversTypes['AgreementAgreementNextVersionsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementNextVersionsAggregateArgs, 'directed'>>;
  nextVersionsConnection?: Resolver<ResolversTypes['AgreementNextVersionsConnection'], ParentType, ContextType, RequireFields<AgreementNextVersionsConnectionArgs, 'directed'>>;
  pushedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<AgreementPushedByArgs, 'directed'>>;
  pushedByAggregate?: Resolver<Maybe<ResolversTypes['AgreementUserPushedByAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementPushedByAggregateArgs, 'directed'>>;
  pushedByConnection?: Resolver<ResolversTypes['AgreementPushedByConnection'], ParentType, ContextType, RequireFields<AgreementPushedByConnectionArgs, 'directed'>>;
  pushedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  rangeChartConfig?: Resolver<Maybe<ResolversTypes['ChartRangeConfiguration']>, ParentType, ContextType, RequireFields<AgreementRangeChartConfigArgs, 'directed'>>;
  rangeChartConfigAggregate?: Resolver<Maybe<ResolversTypes['AgreementChartRangeConfigurationRangeChartConfigAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementRangeChartConfigAggregateArgs, 'directed'>>;
  rangeChartConfigConnection?: Resolver<ResolversTypes['AgreementRangeChartConfigConnection'], ParentType, ContextType, RequireFields<AgreementRangeChartConfigConnectionArgs, 'directed'>>;
  reportData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredForms?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  requiredRecords?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  scenarios?: Resolver<Array<ResolversTypes['Scenario']>, ParentType, ContextType, RequireFields<AgreementScenariosArgs, 'directed'>>;
  scenariosAggregate?: Resolver<Maybe<ResolversTypes['AgreementScenarioScenariosAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementScenariosAggregateArgs, 'directed'>>;
  scenariosConnection?: Resolver<ResolversTypes['AgreementScenariosConnection'], ParentType, ContextType, RequireFields<AgreementScenariosConnectionArgs, 'directed'>>;
  scenariosRelevantBrands?: Resolver<Array<ResolversTypes['Brand']>, ParentType, ContextType, RequireFields<AgreementScenariosRelevantBrandsArgs, 'directed'>>;
  scenariosRelevantBrandsAggregate?: Resolver<Maybe<ResolversTypes['AgreementBrandScenariosRelevantBrandsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementScenariosRelevantBrandsAggregateArgs, 'directed'>>;
  scenariosRelevantBrandsConnection?: Resolver<ResolversTypes['AgreementScenariosRelevantBrandsConnection'], ParentType, ContextType, RequireFields<AgreementScenariosRelevantBrandsConnectionArgs, 'directed'>>;
  status?: Resolver<ResolversTypes['ContractStatus'], ParentType, ContextType>;
  subjectMatter?: Resolver<ResolversTypes['AgreementSubjectMatter'], ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['AgreementTag']>, ParentType, ContextType, RequireFields<AgreementTagsArgs, 'directed'>>;
  tagsAggregate?: Resolver<Maybe<ResolversTypes['AgreementAgreementTagTagsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTagsAggregateArgs, 'directed'>>;
  tagsConnection?: Resolver<ResolversTypes['AgreementTagsConnection'], ParentType, ContextType, RequireFields<AgreementTagsConnectionArgs, 'directed'>>;
  template?: Resolver<Maybe<ResolversTypes['AgreementTemplate']>, ParentType, ContextType, RequireFields<AgreementTemplateArgs, 'directed'>>;
  templateAggregate?: Resolver<Maybe<ResolversTypes['AgreementAgreementTemplateTemplateAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateAggregateArgs, 'directed'>>;
  templateConnection?: Resolver<ResolversTypes['AgreementTemplateConnection'], ParentType, ContextType, RequireFields<AgreementTemplateConnectionArgs, 'directed'>>;
  tenantIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  totalAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  treatmentPrices?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<AgreementTreatmentPricesArgs, 'directed'>>;
  treatmentPricesAggregate?: Resolver<Maybe<ResolversTypes['AgreementTreatmentTreatmentPricesAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTreatmentPricesAggregateArgs, 'directed'>>;
  treatmentPricesConnection?: Resolver<ResolversTypes['AgreementTreatmentPricesConnection'], ParentType, ContextType, RequireFields<AgreementTreatmentPricesConnectionArgs, 'directed'>>;
  userRoles?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<AgreementUserRolesArgs, 'directed'>>;
  userRolesAggregate?: Resolver<Maybe<ResolversTypes['AgreementUserUserRolesAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementUserRolesAggregateArgs, 'directed'>>;
  userRolesConnection?: Resolver<ResolversTypes['AgreementUserRolesConnection'], ParentType, ContextType, RequireFields<AgreementUserRolesConnectionArgs, 'directed'>>;
  validFromDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  validToDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementAddedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementAddedByConnection'] = ResolversParentTypes['AgreementAddedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementAddedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementAddedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementAddedByRelationship'] = ResolversParentTypes['AgreementAddedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementAgreementInitialVersionAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementAgreementInitialVersionAggregationSelection'] = ResolversParentTypes['AgreementAgreementInitialVersionAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementAgreementInitialVersionNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementAgreementInitialVersionNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementAgreementInitialVersionNodeAggregateSelection'] = ResolversParentTypes['AgreementAgreementInitialVersionNodeAggregateSelection']> = {
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  daysToExpiry?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  firstExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  formattedAmount?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedCounterparties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedDiseases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedIndications?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedProducts?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  pushedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  reportData?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementAgreementNextVersionsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementAgreementNextVersionsAggregationSelection'] = ResolversParentTypes['AgreementAgreementNextVersionsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementAgreementNextVersionsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementAgreementNextVersionsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementAgreementNextVersionsNodeAggregateSelection'] = ResolversParentTypes['AgreementAgreementNextVersionsNodeAggregateSelection']> = {
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  daysToExpiry?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  firstExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  formattedAmount?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedCounterparties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedDiseases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedIndications?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedProducts?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  pushedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  reportData?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementAgreementTagTagsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementAgreementTagTagsAggregationSelection'] = ResolversParentTypes['AgreementAgreementTagTagsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementAgreementTagTagsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementAgreementTagTagsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementAgreementTagTagsNodeAggregateSelection'] = ResolversParentTypes['AgreementAgreementTagTagsNodeAggregateSelection']> = {
  id?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementAgreementTemplateTemplateAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementAgreementTemplateTemplateAggregationSelection'] = ResolversParentTypes['AgreementAgreementTemplateTemplateAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementAgreementTemplateTemplateNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementAgreementTemplateTemplateNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementAgreementTemplateTemplateNodeAggregateSelection'] = ResolversParentTypes['AgreementAgreementTemplateTemplateNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  treatments?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementBrandScenariosRelevantBrandsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementBrandScenariosRelevantBrandsAggregationSelection'] = ResolversParentTypes['AgreementBrandScenariosRelevantBrandsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementBrandScenariosRelevantBrandsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementBrandScenariosRelevantBrandsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementBrandScenariosRelevantBrandsNodeAggregateSelection'] = ResolversParentTypes['AgreementBrandScenariosRelevantBrandsNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  art71DataLastUpdatedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  art71DataLastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCatalogueAttributeNegotiableAttributesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCatalogueAttributeNegotiableAttributesAggregationSelection'] = ResolversParentTypes['AgreementCatalogueAttributeNegotiableAttributesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection'] = ResolversParentTypes['AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection']> = {
  caption?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  decimalPrecision?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultValue?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  longLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  maxLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  minLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  rules?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  shortLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  values?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementChartRangeConfigurationDotThresholdsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementChartRangeConfigurationDotThresholdsAggregationSelection'] = ResolversParentTypes['AgreementChartRangeConfigurationDotThresholdsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['AgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection'] = ResolversParentTypes['AgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection']> = {
  threshold?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementChartRangeConfigurationRangeChartConfigAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementChartRangeConfigurationRangeChartConfigAggregationSelection'] = ResolversParentTypes['AgreementChartRangeConfigurationRangeChartConfigAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['AgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection'] = ResolversParentTypes['AgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection']> = {
  from?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCounterpartiesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCounterpartiesConnection'] = ResolversParentTypes['AgreementCounterpartiesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementCounterpartiesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCounterpartiesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCounterpartiesRelationship'] = ResolversParentTypes['AgreementCounterpartiesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isApprovalRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['CounterpartyRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCounterpartyRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCounterpartyRelationship'] = ResolversParentTypes['AgreementCounterpartyRelationship']> = {
  __resolveType: TypeResolveFn<'AgreementCounterpartiesRelationship', ParentType, ContextType>;
  isApprovalRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['CounterpartyRole'], ParentType, ContextType>;
};

export type AgreementCountryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCountryConnection'] = ResolversParentTypes['AgreementCountryConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementCountryRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCountryCountryAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCountryCountryAggregationSelection'] = ResolversParentTypes['AgreementCountryCountryAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementCountryCountryNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCountryCountryNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCountryCountryNodeAggregateSelection'] = ResolversParentTypes['AgreementCountryCountryNodeAggregateSelection']> = {
  alpha2Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  alpha3Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  numericCode?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCountryRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCountryRelationship'] = ResolversParentTypes['AgreementCountryRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCurrencyConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCurrencyConnection'] = ResolversParentTypes['AgreementCurrencyConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementCurrencyRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCurrencyCurrencyAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCurrencyCurrencyAggregationSelection'] = ResolversParentTypes['AgreementCurrencyCurrencyAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementCurrencyCurrencyNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCurrencyCurrencyNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCurrencyCurrencyNodeAggregateSelection'] = ResolversParentTypes['AgreementCurrencyCurrencyNodeAggregateSelection']> = {
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCurrencyRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCurrencyRelationship'] = ResolversParentTypes['AgreementCurrencyRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCycleConfigurationCyclesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCycleConfigurationCyclesAggregationSelection'] = ResolversParentTypes['AgreementCycleConfigurationCyclesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementCycleConfigurationCyclesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCycleConfigurationCyclesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCycleConfigurationCyclesNodeAggregateSelection'] = ResolversParentTypes['AgreementCycleConfigurationCyclesNodeAggregateSelection']> = {
  lengthFrom?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  lengthTo?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCyclesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCyclesConnection'] = ResolversParentTypes['AgreementCyclesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementCyclesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementCyclesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementCyclesRelationship'] = ResolversParentTypes['AgreementCyclesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CycleConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDataContainerDataContainersAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDataContainerDataContainersAggregationSelection'] = ResolversParentTypes['AgreementDataContainerDataContainersAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementDataContainerDataContainersNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDataContainerDataContainersNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDataContainerDataContainersNodeAggregateSelection'] = ResolversParentTypes['AgreementDataContainerDataContainersNodeAggregateSelection']> = {
  subType?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  timeframeEnd?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  timeframeStart?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDataContainersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDataContainersConnection'] = ResolversParentTypes['AgreementDataContainersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementDataContainersRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDataContainersRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDataContainersRelationship'] = ResolversParentTypes['AgreementDataContainersRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DataContainer'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDataSourceConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDataSourceConnection'] = ResolversParentTypes['AgreementDataSourceConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementDataSourceRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDataSourceDataSourceAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDataSourceDataSourceAggregationSelection'] = ResolversParentTypes['AgreementDataSourceDataSourceAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementDataSourceDataSourceNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDataSourceDataSourceNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDataSourceDataSourceNodeAggregateSelection'] = ResolversParentTypes['AgreementDataSourceDataSourceNodeAggregateSelection']> = {
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDataSourceRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDataSourceRelationship'] = ResolversParentTypes['AgreementDataSourceRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DataSource'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDecision'] = ResolversParentTypes['AgreementDecision']> = {
  asOf?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<AgreementDecisionAsOfArgs, 'directed'>>;
  asOfAggregate?: Resolver<Maybe<ResolversTypes['AgreementDecisionOrganizationAsOfAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementDecisionAsOfAggregateArgs, 'directed'>>;
  asOfConnection?: Resolver<ResolversTypes['AgreementDecisionAsOfConnection'], ParentType, ContextType, RequireFields<AgreementDecisionAsOfConnectionArgs, 'directed'>>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  decision?: Resolver<ResolversTypes['Decision'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  madeBy?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<AgreementDecisionMadeByArgs, 'directed'>>;
  madeByAggregate?: Resolver<Maybe<ResolversTypes['AgreementDecisionUserMadeByAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementDecisionMadeByAggregateArgs, 'directed'>>;
  madeByConnection?: Resolver<ResolversTypes['AgreementDecisionMadeByConnection'], ParentType, ContextType, RequireFields<AgreementDecisionMadeByConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionAsOfConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDecisionAsOfConnection'] = ResolversParentTypes['AgreementDecisionAsOfConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementDecisionAsOfRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionAsOfRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDecisionAsOfRelationship'] = ResolversParentTypes['AgreementDecisionAsOfRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDecisionEdge'] = ResolversParentTypes['AgreementDecisionEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementDecision'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionMadeByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDecisionMadeByConnection'] = ResolversParentTypes['AgreementDecisionMadeByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementDecisionMadeByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionMadeByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDecisionMadeByRelationship'] = ResolversParentTypes['AgreementDecisionMadeByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionOrganizationAsOfAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDecisionOrganizationAsOfAggregationSelection'] = ResolversParentTypes['AgreementDecisionOrganizationAsOfAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementDecisionOrganizationAsOfNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionOrganizationAsOfNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDecisionOrganizationAsOfNodeAggregateSelection'] = ResolversParentTypes['AgreementDecisionOrganizationAsOfNodeAggregateSelection']> = {
  BIC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  IBAN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  aggregationPriority?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceThreshold?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactFirstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactLastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactOccupation?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactPhone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderRecurrentStep?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentSftpSavePath?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  domicile?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  dualApprovalThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  eIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  fax?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  legalName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  pharmaId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rebateProcessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  website?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionUserMadeByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDecisionUserMadeByAggregationSelection'] = ResolversParentTypes['AgreementDecisionUserMadeByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementDecisionUserMadeByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionUserMadeByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDecisionUserMadeByNodeAggregateSelection'] = ResolversParentTypes['AgreementDecisionUserMadeByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDecisionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDecisionsConnection'] = ResolversParentTypes['AgreementDecisionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementDecisionEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection'] = ResolversParentTypes['AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection'] = ResolversParentTypes['AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection']> = {
  code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDeviceAlternativeSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDeviceAlternativeSetsConnection'] = ResolversParentTypes['AgreementDeviceAlternativeSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementDeviceAlternativeSetsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDeviceAlternativeSetsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDeviceAlternativeSetsRelationship'] = ResolversParentTypes['AgreementDeviceAlternativeSetsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DeviceAlternative'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDotThresholdsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDotThresholdsConnection'] = ResolversParentTypes['AgreementDotThresholdsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementDotThresholdsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementDotThresholdsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDotThresholdsRelationship'] = ResolversParentTypes['AgreementDotThresholdsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ChartRangeConfiguration'], ParentType, ContextType>;
  threshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementEdge'] = ResolversParentTypes['AgreementEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection'] = ResolversParentTypes['AgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['AgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection'] = ResolversParentTypes['AgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection']> = {
  days?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  minimumPercentage?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  numberOfAdministeredTreatments?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  previousTestNumber?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  referenceAdministrationSequenceNumber?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection'] = ResolversParentTypes['AgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection']> = {
  code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  inputLabel?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementEligibilityConditionSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementEligibilityConditionSetsConnection'] = ResolversParentTypes['AgreementEligibilityConditionSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementEligibilityConditionSetsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementEligibilityConditionSetsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementEligibilityConditionSetsRelationship'] = ResolversParentTypes['AgreementEligibilityConditionSetsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cycleAdherence?: Resolver<Maybe<ResolversTypes['CycleAdherence']>, ParentType, ContextType>;
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minimumPercentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EligibilityConditionSet'], ParentType, ContextType>;
  numberOfAdministeredRangeDays?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  numberOfAdministeredTreatments?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfAdministeredTreatmentsOperator?: Resolver<Maybe<ResolversTypes['ArithmeticalOperator']>, ParentType, ContextType>;
  previousTestNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceAdministrationSequenceNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceTestRangeDays?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  treatments?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection'] = ResolversParentTypes['AgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection'] = ResolversParentTypes['AgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection']> = {
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementEnrollingConditionSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementEnrollingConditionSetsConnection'] = ResolversParentTypes['AgreementEnrollingConditionSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementEnrollingConditionSetsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementEnrollingConditionSetsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementEnrollingConditionSetsRelationship'] = ResolversParentTypes['AgreementEnrollingConditionSetsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isExtended?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EnrollingConditionSet'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementEnrollingPeriodEnrollingPeriodsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementEnrollingPeriodEnrollingPeriodsAggregationSelection'] = ResolversParentTypes['AgreementEnrollingPeriodEnrollingPeriodsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementEnrollingPeriodsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementEnrollingPeriodsConnection'] = ResolversParentTypes['AgreementEnrollingPeriodsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementEnrollingPeriodsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementEnrollingPeriodsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementEnrollingPeriodsRelationship'] = ResolversParentTypes['AgreementEnrollingPeriodsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EnrollingPeriod'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection'] = ResolversParentTypes['AgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['AgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection'] = ResolversParentTypes['AgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection']> = {
  localizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection'] = ResolversParentTypes['AgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection']> = {
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementFinancialSummaryColumnRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementFinancialSummaryColumnRelationship'] = ResolversParentTypes['AgreementFinancialSummaryColumnRelationship']> = {
  __resolveType: TypeResolveFn<'AgreementFinancialSummaryConfigRelationship' | 'AgreementTemplateFinancialSummaryConfigRelationship' | 'BaseAgreementFinancialSummaryConfigRelationship', ParentType, ContextType>;
  hasHelpMessage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isIncluded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  localizationKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type AgreementFinancialSummaryConfigConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementFinancialSummaryConfigConnection'] = ResolversParentTypes['AgreementFinancialSummaryConfigConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementFinancialSummaryConfigRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementFinancialSummaryConfigRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementFinancialSummaryConfigRelationship'] = ResolversParentTypes['AgreementFinancialSummaryConfigRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasHelpMessage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isIncluded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  localizationKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FinancialSummaryColumn'], ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementInitialVersionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementInitialVersionConnection'] = ResolversParentTypes['AgreementInitialVersionConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementInitialVersionRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementInitialVersionRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementInitialVersionRelationship'] = ResolversParentTypes['AgreementInitialVersionRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementLimitationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementLimitationConnection'] = ResolversParentTypes['AgreementLimitationConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementLimitationRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementLimitationLimitationAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementLimitationLimitationAggregationSelection'] = ResolversParentTypes['AgreementLimitationLimitationAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementLimitationLimitationNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementLimitationLimitationNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementLimitationLimitationNodeAggregateSelection'] = ResolversParentTypes['AgreementLimitationLimitationNodeAggregateSelection']> = {
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DescriptionEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Niveau?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Type?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementLimitationRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementLimitationRelationship'] = ResolversParentTypes['AgreementLimitationRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Limitation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementNegotiableAttributesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementNegotiableAttributesConnection'] = ResolversParentTypes['AgreementNegotiableAttributesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementNegotiableAttributesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementNegotiableAttributesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementNegotiableAttributesRelationship'] = ResolversParentTypes['AgreementNegotiableAttributesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CatalogueAttribute'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementNextVersionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementNextVersionsConnection'] = ResolversParentTypes['AgreementNextVersionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementNextVersionsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementNextVersionsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementNextVersionsRelationship'] = ResolversParentTypes['AgreementNextVersionsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementOrganizationCounterpartiesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementOrganizationCounterpartiesAggregationSelection'] = ResolversParentTypes['AgreementOrganizationCounterpartiesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementOrganizationCounterpartiesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementOrganizationCounterpartiesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementOrganizationCounterpartiesNodeAggregateSelection'] = ResolversParentTypes['AgreementOrganizationCounterpartiesNodeAggregateSelection']> = {
  BIC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  IBAN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  aggregationPriority?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceThreshold?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactFirstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactLastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactOccupation?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactPhone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderRecurrentStep?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentSftpSavePath?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  domicile?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  dualApprovalThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  eIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  fax?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  legalName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  pharmaId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rebateProcessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  website?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementPushedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementPushedByConnection'] = ResolversParentTypes['AgreementPushedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementPushedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementPushedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementPushedByRelationship'] = ResolversParentTypes['AgreementPushedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRangeChartConfigConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRangeChartConfigConnection'] = ResolversParentTypes['AgreementRangeChartConfigConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementRangeChartConfigRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRangeChartConfigRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRangeChartConfigRelationship'] = ResolversParentTypes['AgreementRangeChartConfigRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  from?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ChartRangeConfiguration'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRunAttemptInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRunAttemptInfo'] = ResolversParentTypes['AgreementRunAttemptInfo']> = {
  agreementIdsToBeAttempted?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  attemptedAgreementCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  failedAgreementIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  filtersAppliedForRun?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isBulkRun?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nonAttemptedAgreementCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organizationTriggered?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType, RequireFields<AgreementRunAttemptInfoOrganizationTriggeredArgs, 'directed'>>;
  organizationTriggeredAggregate?: Resolver<Maybe<ResolversTypes['AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementRunAttemptInfoOrganizationTriggeredAggregateArgs, 'directed'>>;
  organizationTriggeredConnection?: Resolver<ResolversTypes['AgreementRunAttemptInfoOrganizationTriggeredConnection'], ParentType, ContextType, RequireFields<AgreementRunAttemptInfoOrganizationTriggeredConnectionArgs, 'directed'>>;
  runEnd?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  runInitiator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<AgreementRunAttemptInfoRunInitiatorArgs, 'directed'>>;
  runInitiatorAggregate?: Resolver<Maybe<ResolversTypes['AgreementRunAttemptInfoUserRunInitiatorAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementRunAttemptInfoRunInitiatorAggregateArgs, 'directed'>>;
  runInitiatorConnection?: Resolver<ResolversTypes['AgreementRunAttemptInfoRunInitiatorConnection'], ParentType, ContextType, RequireFields<AgreementRunAttemptInfoRunInitiatorConnectionArgs, 'directed'>>;
  runStart?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  succeededCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  triggeredEvent?: Resolver<Maybe<ResolversTypes['AgreementRunTrigger']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRunAttemptInfoEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRunAttemptInfoEdge'] = ResolversParentTypes['AgreementRunAttemptInfoEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementRunAttemptInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection'] = ResolversParentTypes['AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection'] = ResolversParentTypes['AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection']> = {
  BIC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  IBAN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  aggregationPriority?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceThreshold?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactFirstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactLastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactOccupation?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactPhone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderRecurrentStep?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentSftpSavePath?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  domicile?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  dualApprovalThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  eIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  fax?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  legalName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  pharmaId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rebateProcessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  website?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRunAttemptInfoOrganizationTriggeredConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRunAttemptInfoOrganizationTriggeredConnection'] = ResolversParentTypes['AgreementRunAttemptInfoOrganizationTriggeredConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementRunAttemptInfoOrganizationTriggeredRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRunAttemptInfoOrganizationTriggeredRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRunAttemptInfoOrganizationTriggeredRelationship'] = ResolversParentTypes['AgreementRunAttemptInfoOrganizationTriggeredRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRunAttemptInfoRunInitiatorConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRunAttemptInfoRunInitiatorConnection'] = ResolversParentTypes['AgreementRunAttemptInfoRunInitiatorConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementRunAttemptInfoRunInitiatorRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRunAttemptInfoRunInitiatorRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRunAttemptInfoRunInitiatorRelationship'] = ResolversParentTypes['AgreementRunAttemptInfoRunInitiatorRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRunAttemptInfoUserRunInitiatorAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRunAttemptInfoUserRunInitiatorAggregationSelection'] = ResolversParentTypes['AgreementRunAttemptInfoUserRunInitiatorAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection'] = ResolversParentTypes['AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRunAttemptInfosConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRunAttemptInfosConnection'] = ResolversParentTypes['AgreementRunAttemptInfosConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementRunAttemptInfoEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScenarioScenariosAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScenarioScenariosAggregationSelection'] = ResolversParentTypes['AgreementScenarioScenariosAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementScenarioScenariosNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScenarioScenariosNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScenarioScenariosNodeAggregateSelection'] = ResolversParentTypes['AgreementScenarioScenariosNodeAggregateSelection']> = {
  group?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScenariosConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScenariosConnection'] = ResolversParentTypes['AgreementScenariosConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementScenariosRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScenariosRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScenariosRelationship'] = ResolversParentTypes['AgreementScenariosRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Scenario'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScenariosRelevantBrandsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScenariosRelevantBrandsConnection'] = ResolversParentTypes['AgreementScenariosRelevantBrandsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementScenariosRelevantBrandsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScenariosRelevantBrandsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScenariosRelevantBrandsRelationship'] = ResolversParentTypes['AgreementScenariosRelevantBrandsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Brand'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScope'] = ResolversParentTypes['AgreementScope']> = {
  agreementsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  article71Indications?: Resolver<Array<ResolversTypes['Article71Indication']>, ParentType, ContextType, RequireFields<AgreementScopeArticle71IndicationsArgs, 'directed'>>;
  article71IndicationsAggregate?: Resolver<Maybe<ResolversTypes['AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementScopeArticle71IndicationsAggregateArgs, 'directed'>>;
  article71IndicationsConnection?: Resolver<ResolversTypes['AgreementScopeArticle71IndicationsConnection'], ParentType, ContextType, RequireFields<AgreementScopeArticle71IndicationsConnectionArgs, 'directed'>>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryScopes?: Resolver<Array<ResolversTypes['Country']>, ParentType, ContextType, RequireFields<AgreementScopeCountryScopesArgs, 'directed'>>;
  countryScopesAggregate?: Resolver<Maybe<ResolversTypes['AgreementScopeCountryCountryScopesAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementScopeCountryScopesAggregateArgs, 'directed'>>;
  countryScopesConnection?: Resolver<ResolversTypes['AgreementScopeCountryScopesConnection'], ParentType, ContextType, RequireFields<AgreementScopeCountryScopesConnectionArgs, 'directed'>>;
  countryScopesTemplates?: Resolver<Array<ResolversTypes['AgreementScopeCountryScope']>, ParentType, ContextType>;
  cycles?: Resolver<Array<ResolversTypes['CycleConfiguration']>, ParentType, ContextType, RequireFields<AgreementScopeCyclesArgs, 'directed'>>;
  cyclesAggregate?: Resolver<Maybe<ResolversTypes['AgreementScopeCycleConfigurationCyclesAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementScopeCyclesAggregateArgs, 'directed'>>;
  cyclesConnection?: Resolver<ResolversTypes['AgreementScopeCyclesConnection'], ParentType, ContextType, RequireFields<AgreementScopeCyclesConnectionArgs, 'directed'>>;
  diseases?: Resolver<Array<ResolversTypes['Disease']>, ParentType, ContextType, RequireFields<AgreementScopeDiseasesArgs, 'directed'>>;
  diseasesAggregate?: Resolver<Maybe<ResolversTypes['AgreementScopeDiseaseDiseasesAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementScopeDiseasesAggregateArgs, 'directed'>>;
  diseasesConnection?: Resolver<ResolversTypes['AgreementScopeDiseasesConnection'], ParentType, ContextType, RequireFields<AgreementScopeDiseasesConnectionArgs, 'directed'>>;
  enrollingConditionSets?: Resolver<Array<ResolversTypes['EnrollingConditionSet']>, ParentType, ContextType, RequireFields<AgreementScopeEnrollingConditionSetsArgs, 'directed'>>;
  enrollingConditionSetsAggregate?: Resolver<Maybe<ResolversTypes['AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementScopeEnrollingConditionSetsAggregateArgs, 'directed'>>;
  enrollingConditionSetsConnection?: Resolver<ResolversTypes['AgreementScopeEnrollingConditionSetsConnection'], ParentType, ContextType, RequireFields<AgreementScopeEnrollingConditionSetsConnectionArgs, 'directed'>>;
  indications?: Resolver<Array<ResolversTypes['Indication']>, ParentType, ContextType, RequireFields<AgreementScopeIndicationsArgs, 'directed'>>;
  indicationsAggregate?: Resolver<Maybe<ResolversTypes['AgreementScopeIndicationIndicationsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementScopeIndicationsAggregateArgs, 'directed'>>;
  indicationsConnection?: Resolver<ResolversTypes['AgreementScopeIndicationsConnection'], ParentType, ContextType, RequireFields<AgreementScopeIndicationsConnectionArgs, 'directed'>>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logicalOperator?: Resolver<ResolversTypes['ConditionLogicalOperator'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  orgScopes?: Resolver<Maybe<Array<ResolversTypes['OrganizationScope']>>, ParentType, ContextType>;
  organizationScopes?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType, RequireFields<AgreementScopeOrganizationScopesArgs, 'directed'>>;
  organizationScopesAggregate?: Resolver<Maybe<ResolversTypes['AgreementScopeOrganizationOrganizationScopesAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementScopeOrganizationScopesAggregateArgs, 'directed'>>;
  organizationScopesAgreements?: Resolver<Array<ResolversTypes['AgreementScopeOrganizationScope']>, ParentType, ContextType>;
  organizationScopesConnection?: Resolver<ResolversTypes['AgreementScopeOrganizationScopesConnection'], ParentType, ContextType, RequireFields<AgreementScopeOrganizationScopesConnectionArgs, 'directed'>>;
  organizationsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scopeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  treatmentSets?: Resolver<Array<ResolversTypes['TreatmentSet']>, ParentType, ContextType, RequireFields<AgreementScopeTreatmentSetsArgs, 'directed'>>;
  treatmentSetsAggregate?: Resolver<Maybe<ResolversTypes['AgreementScopeTreatmentSetTreatmentSetsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementScopeTreatmentSetsAggregateArgs, 'directed'>>;
  treatmentSetsConnection?: Resolver<ResolversTypes['AgreementScopeTreatmentSetsConnection'], ParentType, ContextType, RequireFields<AgreementScopeTreatmentSetsConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection'] = ResolversParentTypes['AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection'] = ResolversParentTypes['AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection']> = {
  countryScopeId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  notes?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeArticle71IndicationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeArticle71IndicationsConnection'] = ResolversParentTypes['AgreementScopeArticle71IndicationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementScopeArticle71IndicationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeArticle71IndicationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeArticle71IndicationsRelationship'] = ResolversParentTypes['AgreementScopeArticle71IndicationsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Article71Indication'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeCountryCountryScopesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeCountryCountryScopesAggregationSelection'] = ResolversParentTypes['AgreementScopeCountryCountryScopesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['AgreementScopeCountryCountryScopesEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementScopeCountryCountryScopesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeCountryCountryScopesEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeCountryCountryScopesEdgeAggregateSelection'] = ResolversParentTypes['AgreementScopeCountryCountryScopesEdgeAggregateSelection']> = {
  countryScopeId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeCountryCountryScopesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeCountryCountryScopesNodeAggregateSelection'] = ResolversParentTypes['AgreementScopeCountryCountryScopesNodeAggregateSelection']> = {
  alpha2Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  alpha3Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  numericCode?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeCountryScopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeCountryScope'] = ResolversParentTypes['AgreementScopeCountryScope']> = {
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryScopeIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  templateIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  templateNames?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeCountryScopeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeCountryScopeEdge'] = ResolversParentTypes['AgreementScopeCountryScopeEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementScopeCountryScope'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeCountryScopesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeCountryScopesConnection'] = ResolversParentTypes['AgreementScopeCountryScopesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementScopeCountryScopesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeCountryScopesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeCountryScopesRelationship'] = ResolversParentTypes['AgreementScopeCountryScopesRelationship']> = {
  countryScopeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeCycleConfigurationCyclesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeCycleConfigurationCyclesAggregationSelection'] = ResolversParentTypes['AgreementScopeCycleConfigurationCyclesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementScopeCycleConfigurationCyclesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeCycleConfigurationCyclesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeCycleConfigurationCyclesNodeAggregateSelection'] = ResolversParentTypes['AgreementScopeCycleConfigurationCyclesNodeAggregateSelection']> = {
  lengthFrom?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  lengthTo?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeCyclesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeCyclesConnection'] = ResolversParentTypes['AgreementScopeCyclesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementScopeCyclesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeCyclesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeCyclesRelationship'] = ResolversParentTypes['AgreementScopeCyclesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CycleConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeDiseaseDiseasesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeDiseaseDiseasesAggregationSelection'] = ResolversParentTypes['AgreementScopeDiseaseDiseasesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['AgreementScopeDiseaseDiseasesEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementScopeDiseaseDiseasesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeDiseaseDiseasesEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeDiseaseDiseasesEdgeAggregateSelection'] = ResolversParentTypes['AgreementScopeDiseaseDiseasesEdgeAggregateSelection']> = {
  Score?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeDiseaseDiseasesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeDiseaseDiseasesNodeAggregateSelection'] = ResolversParentTypes['AgreementScopeDiseaseDiseasesNodeAggregateSelection']> = {
  Icd10Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeDiseasesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeDiseasesConnection'] = ResolversParentTypes['AgreementScopeDiseasesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementScopeDiseasesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeDiseasesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeDiseasesRelationship'] = ResolversParentTypes['AgreementScopeDiseasesRelationship']> = {
  Score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Disease'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeEdge'] = ResolversParentTypes['AgreementScopeEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementScope'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection'] = ResolversParentTypes['AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection'] = ResolversParentTypes['AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection']> = {
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeEnrollingConditionSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeEnrollingConditionSetsConnection'] = ResolversParentTypes['AgreementScopeEnrollingConditionSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementScopeEnrollingConditionSetsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeEnrollingConditionSetsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeEnrollingConditionSetsRelationship'] = ResolversParentTypes['AgreementScopeEnrollingConditionSetsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EnrollingConditionSet'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeIndicationIndicationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeIndicationIndicationsAggregationSelection'] = ResolversParentTypes['AgreementScopeIndicationIndicationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementScopeIndicationIndicationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeIndicationIndicationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeIndicationIndicationsNodeAggregateSelection'] = ResolversParentTypes['AgreementScopeIndicationIndicationsNodeAggregateSelection']> = {
  code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  intent?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  intentLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  line?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lineLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  mutation?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  mutationLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  typeLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeIndicationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeIndicationsConnection'] = ResolversParentTypes['AgreementScopeIndicationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementScopeIndicationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeIndicationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeIndicationsRelationship'] = ResolversParentTypes['AgreementScopeIndicationsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Indication'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeOrganizationOrganizationScopesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeOrganizationOrganizationScopesAggregationSelection'] = ResolversParentTypes['AgreementScopeOrganizationOrganizationScopesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection'] = ResolversParentTypes['AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection']> = {
  organizationScopeId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeOrganizationOrganizationScopesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection'] = ResolversParentTypes['AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection']> = {
  BIC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  IBAN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  aggregationPriority?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceThreshold?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactFirstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactLastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactOccupation?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactPhone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderRecurrentStep?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentSftpSavePath?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  domicile?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  dualApprovalThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  eIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  fax?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  legalName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  pharmaId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rebateProcessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  website?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeOrganizationScopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeOrganizationScope'] = ResolversParentTypes['AgreementScopeOrganizationScope']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agreementName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationScopeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeOrganizationScopeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeOrganizationScopeEdge'] = ResolversParentTypes['AgreementScopeOrganizationScopeEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementScopeOrganizationScope'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeOrganizationScopesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeOrganizationScopesConnection'] = ResolversParentTypes['AgreementScopeOrganizationScopesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementScopeOrganizationScopesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeOrganizationScopesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeOrganizationScopesRelationship'] = ResolversParentTypes['AgreementScopeOrganizationScopesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  organizationScopeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeRelationship'] = ResolversParentTypes['AgreementScopeRelationship']> = {
  __resolveType: TypeResolveFn<'EnrollingConditionSetScopesRelationship', ParentType, ContextType>;
  excludedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isExtended?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type AgreementScopeTreatmentSetTreatmentSetsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeTreatmentSetTreatmentSetsAggregationSelection'] = ResolversParentTypes['AgreementScopeTreatmentSetTreatmentSetsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection'] = ResolversParentTypes['AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection']> = {
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeTreatmentSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeTreatmentSetsConnection'] = ResolversParentTypes['AgreementScopeTreatmentSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementScopeTreatmentSetsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopeTreatmentSetsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopeTreatmentSetsRelationship'] = ResolversParentTypes['AgreementScopeTreatmentSetsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TreatmentSet'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementScopesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementScopesConnection'] = ResolversParentTypes['AgreementScopesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementScopeEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementSpecificRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementSpecificRole'] = ResolversParentTypes['AgreementSpecificRole']> = {
  agreementId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  agreementName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  agreementTags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  agreementUserRole?: Resolver<Maybe<ResolversTypes['AgreementUserRole']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementSpecificRoleEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementSpecificRoleEdge'] = ResolversParentTypes['AgreementSpecificRoleEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementSpecificRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementSpecificRolesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementSpecificRolesConnection'] = ResolversParentTypes['AgreementSpecificRolesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementSpecificRoleEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementStatusTransitionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementStatusTransition'] = ResolversParentTypes['AgreementStatusTransition']> = {
  causedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<AgreementStatusTransitionCausedByArgs, 'directed'>>;
  causedByAggregate?: Resolver<Maybe<ResolversTypes['AgreementStatusTransitionUserCausedByAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementStatusTransitionCausedByAggregateArgs, 'directed'>>;
  causedByConnection?: Resolver<ResolversTypes['AgreementStatusTransitionCausedByConnection'], ParentType, ContextType, RequireFields<AgreementStatusTransitionCausedByConnectionArgs, 'directed'>>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  from?: Resolver<Maybe<ResolversTypes['ContractStatus']>, ParentType, ContextType>;
  to?: Resolver<ResolversTypes['ContractStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementStatusTransitionCausedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementStatusTransitionCausedByConnection'] = ResolversParentTypes['AgreementStatusTransitionCausedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementStatusTransitionCausedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementStatusTransitionCausedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementStatusTransitionCausedByRelationship'] = ResolversParentTypes['AgreementStatusTransitionCausedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementStatusTransitionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementStatusTransitionEdge'] = ResolversParentTypes['AgreementStatusTransitionEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementStatusTransition'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementStatusTransitionUserCausedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementStatusTransitionUserCausedByAggregationSelection'] = ResolversParentTypes['AgreementStatusTransitionUserCausedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementStatusTransitionUserCausedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementStatusTransitionUserCausedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementStatusTransitionUserCausedByNodeAggregateSelection'] = ResolversParentTypes['AgreementStatusTransitionUserCausedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementStatusTransitionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementStatusTransitionsConnection'] = ResolversParentTypes['AgreementStatusTransitionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementStatusTransitionEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTagResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTag'] = ResolversParentTypes['AgreementTag']> = {
  defaultUserRoles?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<AgreementTagDefaultUserRolesArgs, 'directed'>>;
  defaultUserRolesAggregate?: Resolver<Maybe<ResolversTypes['AgreementTagUserDefaultUserRolesAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTagDefaultUserRolesAggregateArgs, 'directed'>>;
  defaultUserRolesConnection?: Resolver<ResolversTypes['AgreementTagDefaultUserRolesConnection'], ParentType, ContextType, RequireFields<AgreementTagDefaultUserRolesConnectionArgs, 'directed'>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AgreementTagType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTagDefaultUserRolesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTagDefaultUserRolesConnection'] = ResolversParentTypes['AgreementTagDefaultUserRolesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTagDefaultUserRolesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTagDefaultUserRolesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTagDefaultUserRolesRelationship'] = ResolversParentTypes['AgreementTagDefaultUserRolesRelationship']> = {
  caseAssignee?: Resolver<Maybe<ResolversTypes['AssigneeStatus']>, ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  documentAssignee?: Resolver<Maybe<ResolversTypes['AssigneeStatus']>, ParentType, ContextType>;
  isAgreementAssignee?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['AgreementUserRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTagEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTagEdge'] = ResolversParentTypes['AgreementTagEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementTag'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTagUserDefaultUserRolesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTagUserDefaultUserRolesAggregationSelection'] = ResolversParentTypes['AgreementTagUserDefaultUserRolesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTagUserDefaultUserRolesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTagUserDefaultUserRolesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTagUserDefaultUserRolesNodeAggregateSelection'] = ResolversParentTypes['AgreementTagUserDefaultUserRolesNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTagUserRoleRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTagUserRoleRelationship'] = ResolversParentTypes['AgreementTagUserRoleRelationship']> = {
  __resolveType: TypeResolveFn<'AgreementTagDefaultUserRolesRelationship', ParentType, ContextType>;
  caseAssignee?: Resolver<Maybe<ResolversTypes['AssigneeStatus']>, ParentType, ContextType>;
  documentAssignee?: Resolver<Maybe<ResolversTypes['AssigneeStatus']>, ParentType, ContextType>;
  isAgreementAssignee?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['AgreementUserRole'], ParentType, ContextType>;
};

export type AgreementTagsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTagsConnection'] = ResolversParentTypes['AgreementTagsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTagEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplate'] = ResolversParentTypes['AgreementTemplate']> = {
  addedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<AgreementTemplateAddedByArgs, 'directed'>>;
  addedByAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateUserAddedByAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateAddedByAggregateArgs, 'directed'>>;
  addedByConnection?: Resolver<ResolversTypes['AgreementTemplateAddedByConnection'], ParentType, ContextType, RequireFields<AgreementTemplateAddedByConnectionArgs, 'directed'>>;
  addedByName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agreementQuantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  agreements?: Resolver<Array<ResolversTypes['Agreement']>, ParentType, ContextType, RequireFields<AgreementTemplateAgreementsArgs, 'directed'>>;
  agreementsAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateAgreementAgreementsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateAgreementsAggregateArgs, 'directed'>>;
  agreementsConnection?: Resolver<ResolversTypes['AgreementTemplateAgreementsConnection'], ParentType, ContextType, RequireFields<AgreementTemplateAgreementsConnectionArgs, 'directed'>>;
  allowedForms?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  allowedRecords?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  caseSuspensionIntervalDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  childAgreementsDefaultStatus?: Resolver<Maybe<ResolversTypes['ContractStatus']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType, RequireFields<AgreementTemplateCountryArgs, 'directed'>>;
  countryAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateCountryCountryAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateCountryAggregateArgs, 'directed'>>;
  countryConnection?: Resolver<ResolversTypes['AgreementTemplateCountryConnection'], ParentType, ContextType, RequireFields<AgreementTemplateCountryConnectionArgs, 'directed'>>;
  coveringFormWaitInterval?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType, RequireFields<AgreementTemplateCurrencyArgs, 'directed'>>;
  currencyAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateCurrencyCurrencyAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateCurrencyAggregateArgs, 'directed'>>;
  currencyConnection?: Resolver<ResolversTypes['AgreementTemplateCurrencyConnection'], ParentType, ContextType, RequireFields<AgreementTemplateCurrencyConnectionArgs, 'directed'>>;
  cycles?: Resolver<Array<ResolversTypes['CycleConfiguration']>, ParentType, ContextType, RequireFields<AgreementTemplateCyclesArgs, 'directed'>>;
  cyclesAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateCycleConfigurationCyclesAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateCyclesAggregateArgs, 'directed'>>;
  cyclesConnection?: Resolver<ResolversTypes['AgreementTemplateCyclesConnection'], ParentType, ContextType, RequireFields<AgreementTemplateCyclesConnectionArgs, 'directed'>>;
  defaultPriceRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  deviceAlternativeSets?: Resolver<Array<ResolversTypes['DeviceAlternative']>, ParentType, ContextType, RequireFields<AgreementTemplateDeviceAlternativeSetsArgs, 'directed'>>;
  deviceAlternativeSetsAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateDeviceAlternativeSetsAggregateArgs, 'directed'>>;
  deviceAlternativeSetsConnection?: Resolver<ResolversTypes['AgreementTemplateDeviceAlternativeSetsConnection'], ParentType, ContextType, RequireFields<AgreementTemplateDeviceAlternativeSetsConnectionArgs, 'directed'>>;
  dotThresholds?: Resolver<Maybe<ResolversTypes['ChartRangeConfiguration']>, ParentType, ContextType, RequireFields<AgreementTemplateDotThresholdsArgs, 'directed'>>;
  dotThresholdsAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateDotThresholdsAggregateArgs, 'directed'>>;
  dotThresholdsConnection?: Resolver<ResolversTypes['AgreementTemplateDotThresholdsConnection'], ParentType, ContextType, RequireFields<AgreementTemplateDotThresholdsConnectionArgs, 'directed'>>;
  eligibilityConditionSets?: Resolver<Array<ResolversTypes['EligibilityConditionSet']>, ParentType, ContextType, RequireFields<AgreementTemplateEligibilityConditionSetsArgs, 'directed'>>;
  eligibilityConditionSetsAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateEligibilityConditionSetsAggregateArgs, 'directed'>>;
  eligibilityConditionSetsConnection?: Resolver<ResolversTypes['AgreementTemplateEligibilityConditionSetsConnection'], ParentType, ContextType, RequireFields<AgreementTemplateEligibilityConditionSetsConnectionArgs, 'directed'>>;
  eligibilityConditionTreatments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Treatment']>>>, ParentType, ContextType>;
  enrollingConditionSets?: Resolver<Array<ResolversTypes['EnrollingConditionSet']>, ParentType, ContextType, RequireFields<AgreementTemplateEnrollingConditionSetsArgs, 'directed'>>;
  enrollingConditionSetsAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateEnrollingConditionSetsAggregateArgs, 'directed'>>;
  enrollingConditionSetsConnection?: Resolver<ResolversTypes['AgreementTemplateEnrollingConditionSetsConnection'], ParentType, ContextType, RequireFields<AgreementTemplateEnrollingConditionSetsConnectionArgs, 'directed'>>;
  enrollingPeriods?: Resolver<Array<ResolversTypes['EnrollingPeriod']>, ParentType, ContextType, RequireFields<AgreementTemplateEnrollingPeriodsArgs, 'directed'>>;
  enrollingPeriodsAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateEnrollingPeriodsAggregateArgs, 'directed'>>;
  enrollingPeriodsConnection?: Resolver<ResolversTypes['AgreementTemplateEnrollingPeriodsConnection'], ParentType, ContextType, RequireFields<AgreementTemplateEnrollingPeriodsConnectionArgs, 'directed'>>;
  enrolmentDateType?: Resolver<Maybe<ResolversTypes['EnrolmentDateType']>, ParentType, ContextType>;
  expectedDocument?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  financialSummaryConfig?: Resolver<Array<ResolversTypes['FinancialSummaryColumn']>, ParentType, ContextType, RequireFields<AgreementTemplateFinancialSummaryConfigArgs, 'directed'>>;
  financialSummaryConfigAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateFinancialSummaryConfigAggregateArgs, 'directed'>>;
  financialSummaryConfigConnection?: Resolver<ResolversTypes['AgreementTemplateFinancialSummaryConfigConnection'], ParentType, ContextType, RequireFields<AgreementTemplateFinancialSummaryConfigConnectionArgs, 'directed'>>;
  formattedTags?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  initialVersion?: Resolver<Maybe<ResolversTypes['AgreementTemplate']>, ParentType, ContextType, RequireFields<AgreementTemplateInitialVersionArgs, 'directed'>>;
  initialVersionAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateAgreementTemplateInitialVersionAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateInitialVersionAggregateArgs, 'directed'>>;
  initialVersionConnection?: Resolver<ResolversTypes['AgreementTemplateInitialVersionConnection'], ParentType, ContextType, RequireFields<AgreementTemplateInitialVersionConnectionArgs, 'directed'>>;
  initialVersionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAllowedFormsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isAllowedRecordsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCaseless?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCoveringIntervalEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFirstVersion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isLastVersion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRequiredFormsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRequiredRecordsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  limitation?: Resolver<Maybe<ResolversTypes['Limitation']>, ParentType, ContextType, RequireFields<AgreementTemplateLimitationArgs, 'directed'>>;
  limitationAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateLimitationLimitationAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateLimitationAggregateArgs, 'directed'>>;
  limitationConnection?: Resolver<ResolversTypes['AgreementTemplateLimitationConnection'], ParentType, ContextType, RequireFields<AgreementTemplateLimitationConnectionArgs, 'directed'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  negotiableAttributes?: Resolver<Array<ResolversTypes['CatalogueAttribute']>, ParentType, ContextType, RequireFields<AgreementTemplateNegotiableAttributesArgs, 'directed'>>;
  negotiableAttributesAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateNegotiableAttributesAggregateArgs, 'directed'>>;
  negotiableAttributesConnection?: Resolver<ResolversTypes['AgreementTemplateNegotiableAttributesConnection'], ParentType, ContextType, RequireFields<AgreementTemplateNegotiableAttributesConnectionArgs, 'directed'>>;
  nextVersions?: Resolver<Array<ResolversTypes['AgreementTemplate']>, ParentType, ContextType, RequireFields<AgreementTemplateNextVersionsArgs, 'directed'>>;
  nextVersionsAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateAgreementTemplateNextVersionsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateNextVersionsAggregateArgs, 'directed'>>;
  nextVersionsConnection?: Resolver<ResolversTypes['AgreementTemplateNextVersionsConnection'], ParentType, ContextType, RequireFields<AgreementTemplateNextVersionsConnectionArgs, 'directed'>>;
  rangeChartConfig?: Resolver<Maybe<ResolversTypes['ChartRangeConfiguration']>, ParentType, ContextType, RequireFields<AgreementTemplateRangeChartConfigArgs, 'directed'>>;
  rangeChartConfigAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateRangeChartConfigAggregateArgs, 'directed'>>;
  rangeChartConfigConnection?: Resolver<ResolversTypes['AgreementTemplateRangeChartConfigConnection'], ParentType, ContextType, RequireFields<AgreementTemplateRangeChartConfigConnectionArgs, 'directed'>>;
  requiredForms?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  requiredRecords?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  scenarios?: Resolver<Array<ResolversTypes['Scenario']>, ParentType, ContextType, RequireFields<AgreementTemplateScenariosArgs, 'directed'>>;
  scenariosAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateScenarioScenariosAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateScenariosAggregateArgs, 'directed'>>;
  scenariosConnection?: Resolver<ResolversTypes['AgreementTemplateScenariosConnection'], ParentType, ContextType, RequireFields<AgreementTemplateScenariosConnectionArgs, 'directed'>>;
  scenariosRelevantBrands?: Resolver<Array<ResolversTypes['Brand']>, ParentType, ContextType, RequireFields<AgreementTemplateScenariosRelevantBrandsArgs, 'directed'>>;
  scenariosRelevantBrandsAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateScenariosRelevantBrandsAggregateArgs, 'directed'>>;
  scenariosRelevantBrandsConnection?: Resolver<ResolversTypes['AgreementTemplateScenariosRelevantBrandsConnection'], ParentType, ContextType, RequireFields<AgreementTemplateScenariosRelevantBrandsConnectionArgs, 'directed'>>;
  subjectMatter?: Resolver<ResolversTypes['AgreementSubjectMatter'], ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['AgreementTag']>, ParentType, ContextType, RequireFields<AgreementTemplateTagsArgs, 'directed'>>;
  tagsAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateAgreementTagTagsAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateTagsAggregateArgs, 'directed'>>;
  tagsConnection?: Resolver<ResolversTypes['AgreementTemplateTagsConnection'], ParentType, ContextType, RequireFields<AgreementTemplateTagsConnectionArgs, 'directed'>>;
  treatmentPrices?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<AgreementTemplateTreatmentPricesArgs, 'directed'>>;
  treatmentPricesAggregate?: Resolver<Maybe<ResolversTypes['AgreementTemplateTreatmentTreatmentPricesAggregationSelection']>, ParentType, ContextType, RequireFields<AgreementTemplateTreatmentPricesAggregateArgs, 'directed'>>;
  treatmentPricesConnection?: Resolver<ResolversTypes['AgreementTemplateTreatmentPricesConnection'], ParentType, ContextType, RequireFields<AgreementTemplateTreatmentPricesConnectionArgs, 'directed'>>;
  treatments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validFromDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  validToDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateAddedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateAddedByConnection'] = ResolversParentTypes['AgreementTemplateAddedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateAddedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateAddedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateAddedByRelationship'] = ResolversParentTypes['AgreementTemplateAddedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateAgreementAgreementsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateAgreementAgreementsAggregationSelection'] = ResolversParentTypes['AgreementTemplateAgreementAgreementsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateAgreementAgreementsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateAgreementAgreementsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateAgreementAgreementsNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateAgreementAgreementsNodeAggregateSelection']> = {
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  daysToExpiry?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  firstExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  formattedAmount?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedCounterparties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedDiseases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedIndications?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedProducts?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  pushedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  reportData?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateAgreementTagTagsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateAgreementTagTagsAggregationSelection'] = ResolversParentTypes['AgreementTemplateAgreementTagTagsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateAgreementTagTagsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateAgreementTagTagsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateAgreementTagTagsNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateAgreementTagTagsNodeAggregateSelection']> = {
  id?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateAgreementTemplateInitialVersionAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateAgreementTemplateInitialVersionAggregationSelection'] = ResolversParentTypes['AgreementTemplateAgreementTemplateInitialVersionAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  treatments?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateAgreementTemplateNextVersionsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateAgreementTemplateNextVersionsAggregationSelection'] = ResolversParentTypes['AgreementTemplateAgreementTemplateNextVersionsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  treatments?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateAgreementsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateAgreementsConnection'] = ResolversParentTypes['AgreementTemplateAgreementsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateAgreementsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateAgreementsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateAgreementsRelationship'] = ResolversParentTypes['AgreementTemplateAgreementsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateBrandScenariosRelevantBrandsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection'] = ResolversParentTypes['AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  art71DataLastUpdatedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  art71DataLastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection'] = ResolversParentTypes['AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection']> = {
  caption?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  decimalPrecision?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultValue?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  longLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  maxLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  minLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  rules?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  shortLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  values?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection'] = ResolversParentTypes['AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection'] = ResolversParentTypes['AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection']> = {
  threshold?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection'] = ResolversParentTypes['AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection'] = ResolversParentTypes['AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection']> = {
  from?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateConnection'] = ResolversParentTypes['AgreementTemplateConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCountryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCountryConnection'] = ResolversParentTypes['AgreementTemplateCountryConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateCountryRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCountryCountryAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCountryCountryAggregationSelection'] = ResolversParentTypes['AgreementTemplateCountryCountryAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateCountryCountryNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCountryCountryNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCountryCountryNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateCountryCountryNodeAggregateSelection']> = {
  alpha2Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  alpha3Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  numericCode?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCountryRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCountryRelationship'] = ResolversParentTypes['AgreementTemplateCountryRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCurrencyConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCurrencyConnection'] = ResolversParentTypes['AgreementTemplateCurrencyConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateCurrencyRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCurrencyCurrencyAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCurrencyCurrencyAggregationSelection'] = ResolversParentTypes['AgreementTemplateCurrencyCurrencyAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateCurrencyCurrencyNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCurrencyCurrencyNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCurrencyCurrencyNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateCurrencyCurrencyNodeAggregateSelection']> = {
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCurrencyRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCurrencyRelationship'] = ResolversParentTypes['AgreementTemplateCurrencyRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCycleConfigurationCyclesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCycleConfigurationCyclesAggregationSelection'] = ResolversParentTypes['AgreementTemplateCycleConfigurationCyclesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCycleConfigurationCyclesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection']> = {
  lengthFrom?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  lengthTo?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCyclesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCyclesConnection'] = ResolversParentTypes['AgreementTemplateCyclesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateCyclesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateCyclesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateCyclesRelationship'] = ResolversParentTypes['AgreementTemplateCyclesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CycleConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection'] = ResolversParentTypes['AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection']> = {
  code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateDeviceAlternativeSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateDeviceAlternativeSetsConnection'] = ResolversParentTypes['AgreementTemplateDeviceAlternativeSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateDeviceAlternativeSetsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateDeviceAlternativeSetsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateDeviceAlternativeSetsRelationship'] = ResolversParentTypes['AgreementTemplateDeviceAlternativeSetsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DeviceAlternative'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateDotThresholdsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateDotThresholdsConnection'] = ResolversParentTypes['AgreementTemplateDotThresholdsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateDotThresholdsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateDotThresholdsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateDotThresholdsRelationship'] = ResolversParentTypes['AgreementTemplateDotThresholdsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ChartRangeConfiguration'], ParentType, ContextType>;
  threshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEdge'] = ResolversParentTypes['AgreementTemplateEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateEligibilityConditionRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEligibilityConditionRelationship'] = ResolversParentTypes['AgreementTemplateEligibilityConditionRelationship']> = {
  __resolveType: TypeResolveFn<'AgreementEligibilityConditionSetsRelationship' | 'AgreementTemplateEligibilityConditionSetsRelationship', ParentType, ContextType>;
  cycleAdherence?: Resolver<Maybe<ResolversTypes['CycleAdherence']>, ParentType, ContextType>;
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minimumPercentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfAdministeredRangeDays?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  numberOfAdministeredTreatments?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfAdministeredTreatmentsOperator?: Resolver<Maybe<ResolversTypes['ArithmeticalOperator']>, ParentType, ContextType>;
  previousTestNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceAdministrationSequenceNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceTestRangeDays?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  treatments?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection'] = ResolversParentTypes['AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection'] = ResolversParentTypes['AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection']> = {
  days?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  minimumPercentage?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  numberOfAdministeredTreatments?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  previousTestNumber?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  referenceAdministrationSequenceNumber?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection']> = {
  code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  inputLabel?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateEligibilityConditionSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEligibilityConditionSetsConnection'] = ResolversParentTypes['AgreementTemplateEligibilityConditionSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateEligibilityConditionSetsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateEligibilityConditionSetsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEligibilityConditionSetsRelationship'] = ResolversParentTypes['AgreementTemplateEligibilityConditionSetsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cycleAdherence?: Resolver<Maybe<ResolversTypes['CycleAdherence']>, ParentType, ContextType>;
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minimumPercentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EligibilityConditionSet'], ParentType, ContextType>;
  numberOfAdministeredRangeDays?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  numberOfAdministeredTreatments?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfAdministeredTreatmentsOperator?: Resolver<Maybe<ResolversTypes['ArithmeticalOperator']>, ParentType, ContextType>;
  previousTestNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceAdministrationSequenceNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceTestRangeDays?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  treatments?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection'] = ResolversParentTypes['AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection']> = {
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateEnrollingConditionSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEnrollingConditionSetsConnection'] = ResolversParentTypes['AgreementTemplateEnrollingConditionSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateEnrollingConditionSetsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateEnrollingConditionSetsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEnrollingConditionSetsRelationship'] = ResolversParentTypes['AgreementTemplateEnrollingConditionSetsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EnrollingConditionSet'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection'] = ResolversParentTypes['AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateEnrollingPeriodsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEnrollingPeriodsConnection'] = ResolversParentTypes['AgreementTemplateEnrollingPeriodsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateEnrollingPeriodsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateEnrollingPeriodsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateEnrollingPeriodsRelationship'] = ResolversParentTypes['AgreementTemplateEnrollingPeriodsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EnrollingPeriod'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection'] = ResolversParentTypes['AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection'] = ResolversParentTypes['AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection']> = {
  localizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection']> = {
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateFinancialSummaryConfigConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateFinancialSummaryConfigConnection'] = ResolversParentTypes['AgreementTemplateFinancialSummaryConfigConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateFinancialSummaryConfigRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateFinancialSummaryConfigRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateFinancialSummaryConfigRelationship'] = ResolversParentTypes['AgreementTemplateFinancialSummaryConfigRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasHelpMessage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isIncluded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  localizationKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FinancialSummaryColumn'], ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateInitialVersionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateInitialVersionConnection'] = ResolversParentTypes['AgreementTemplateInitialVersionConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateInitialVersionRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateInitialVersionRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateInitialVersionRelationship'] = ResolversParentTypes['AgreementTemplateInitialVersionRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateLimitationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateLimitationConnection'] = ResolversParentTypes['AgreementTemplateLimitationConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateLimitationRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateLimitationLimitationAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateLimitationLimitationAggregationSelection'] = ResolversParentTypes['AgreementTemplateLimitationLimitationAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateLimitationLimitationNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateLimitationLimitationNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateLimitationLimitationNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateLimitationLimitationNodeAggregateSelection']> = {
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DescriptionEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Niveau?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Type?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateLimitationRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateLimitationRelationship'] = ResolversParentTypes['AgreementTemplateLimitationRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Limitation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateNegotiableAttributesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateNegotiableAttributesConnection'] = ResolversParentTypes['AgreementTemplateNegotiableAttributesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateNegotiableAttributesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateNegotiableAttributesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateNegotiableAttributesRelationship'] = ResolversParentTypes['AgreementTemplateNegotiableAttributesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CatalogueAttribute'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateNextVersionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateNextVersionsConnection'] = ResolversParentTypes['AgreementTemplateNextVersionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateNextVersionsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateNextVersionsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateNextVersionsRelationship'] = ResolversParentTypes['AgreementTemplateNextVersionsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateRangeChartConfigConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateRangeChartConfigConnection'] = ResolversParentTypes['AgreementTemplateRangeChartConfigConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateRangeChartConfigRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateRangeChartConfigRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateRangeChartConfigRelationship'] = ResolversParentTypes['AgreementTemplateRangeChartConfigRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  from?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ChartRangeConfiguration'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateRelationship'] = ResolversParentTypes['AgreementTemplateRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateScenarioScenariosAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateScenarioScenariosAggregationSelection'] = ResolversParentTypes['AgreementTemplateScenarioScenariosAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateScenarioScenariosNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateScenarioScenariosNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateScenarioScenariosNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateScenarioScenariosNodeAggregateSelection']> = {
  group?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateScenariosConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateScenariosConnection'] = ResolversParentTypes['AgreementTemplateScenariosConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateScenariosRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateScenariosRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateScenariosRelationship'] = ResolversParentTypes['AgreementTemplateScenariosRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Scenario'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateScenariosRelevantBrandsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateScenariosRelevantBrandsConnection'] = ResolversParentTypes['AgreementTemplateScenariosRelevantBrandsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateScenariosRelevantBrandsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateScenariosRelevantBrandsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateScenariosRelevantBrandsRelationship'] = ResolversParentTypes['AgreementTemplateScenariosRelevantBrandsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Brand'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateTagsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateTagsConnection'] = ResolversParentTypes['AgreementTemplateTagsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateTagsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateTagsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateTagsRelationship'] = ResolversParentTypes['AgreementTemplateTagsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementTag'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateTreatmentPriceRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateTreatmentPriceRelationship'] = ResolversParentTypes['AgreementTemplateTreatmentPriceRelationship']> = {
  __resolveType: TypeResolveFn<'AgreementTemplateTreatmentPricesRelationship', ParentType, ContextType>;
  basePriceType?: Resolver<Maybe<ResolversTypes['PriceType']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type AgreementTemplateTreatmentPricesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateTreatmentPricesConnection'] = ResolversParentTypes['AgreementTemplateTreatmentPricesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateTreatmentPricesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateTreatmentPricesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateTreatmentPricesRelationship'] = ResolversParentTypes['AgreementTemplateTreatmentPricesRelationship']> = {
  basePriceType?: Resolver<Maybe<ResolversTypes['PriceType']>, ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateTreatmentTreatmentPricesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateTreatmentTreatmentPricesAggregationSelection'] = ResolversParentTypes['AgreementTemplateTreatmentTreatmentPricesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection'] = ResolversParentTypes['AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection']> = {
  price?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateUserAddedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateUserAddedByAggregationSelection'] = ResolversParentTypes['AgreementTemplateUserAddedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTemplateUserAddedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateUserAddedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateUserAddedByNodeAggregateSelection'] = ResolversParentTypes['AgreementTemplateUserAddedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateVersionCreationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateVersionCreationResponse'] = ResolversParentTypes['AgreementTemplateVersionCreationResponse']> = {
  conflicted?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agreement']>>>, ParentType, ContextType>;
  hasNewVersionManuallyCreated?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agreement']>>>, ParentType, ContextType>;
  nominal?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agreement']>>>, ParentType, ContextType>;
  templateAgreementId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateVersionCreationResponseEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateVersionCreationResponseEdge'] = ResolversParentTypes['AgreementTemplateVersionCreationResponseEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementTemplateVersionCreationResponse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplateVersionCreationResponsesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplateVersionCreationResponsesConnection'] = ResolversParentTypes['AgreementTemplateVersionCreationResponsesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateVersionCreationResponseEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTemplatesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTemplatesConnection'] = ResolversParentTypes['AgreementTemplatesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTemplateEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTreatmentPriceRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTreatmentPriceRelationship'] = ResolversParentTypes['AgreementTreatmentPriceRelationship']> = {
  __resolveType: TypeResolveFn<'AgreementTreatmentPricesRelationship', ParentType, ContextType>;
  basePriceType?: Resolver<Maybe<ResolversTypes['PriceType']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type AgreementTreatmentPricesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTreatmentPricesConnection'] = ResolversParentTypes['AgreementTreatmentPricesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementTreatmentPricesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTreatmentPricesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTreatmentPricesRelationship'] = ResolversParentTypes['AgreementTreatmentPricesRelationship']> = {
  basePriceType?: Resolver<Maybe<ResolversTypes['PriceType']>, ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTreatmentTreatmentPricesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTreatmentTreatmentPricesAggregationSelection'] = ResolversParentTypes['AgreementTreatmentTreatmentPricesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['AgreementTreatmentTreatmentPricesEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementTreatmentTreatmentPricesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTreatmentTreatmentPricesEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTreatmentTreatmentPricesEdgeAggregateSelection'] = ResolversParentTypes['AgreementTreatmentTreatmentPricesEdgeAggregateSelection']> = {
  price?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTreatmentTreatmentPricesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementTreatmentTreatmentPricesNodeAggregateSelection'] = ResolversParentTypes['AgreementTreatmentTreatmentPricesNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementUserAddedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementUserAddedByAggregationSelection'] = ResolversParentTypes['AgreementUserAddedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementUserAddedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementUserAddedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementUserAddedByNodeAggregateSelection'] = ResolversParentTypes['AgreementUserAddedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementUserPushedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementUserPushedByAggregationSelection'] = ResolversParentTypes['AgreementUserPushedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementUserPushedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementUserPushedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementUserPushedByNodeAggregateSelection'] = ResolversParentTypes['AgreementUserPushedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementUserRoleRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementUserRoleRelationship'] = ResolversParentTypes['AgreementUserRoleRelationship']> = {
  __resolveType: TypeResolveFn<'AgreementUserRolesRelationship', ParentType, ContextType>;
  canApprove?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canModifyFinancials?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canViewFinancials?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isAssignee?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['AgreementUserRole'], ParentType, ContextType>;
};

export type AgreementUserRolesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementUserRolesConnection'] = ResolversParentTypes['AgreementUserRolesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementUserRolesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementUserRolesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementUserRolesRelationship'] = ResolversParentTypes['AgreementUserRolesRelationship']> = {
  canApprove?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canModifyFinancials?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canViewFinancials?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isAssignee?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['AgreementUserRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementUserUserRolesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementUserUserRolesAggregationSelection'] = ResolversParentTypes['AgreementUserUserRolesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AgreementUserUserRolesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementUserUserRolesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementUserUserRolesNodeAggregateSelection'] = ResolversParentTypes['AgreementUserUserRolesNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementsConnection'] = ResolversParentTypes['AgreementsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AgreementEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['Alert'] = ResolversParentTypes['Alert']> = {
  check?: Resolver<ResolversTypes['RunCheck'], ParentType, ContextType, RequireFields<AlertCheckArgs, 'directed'>>;
  checkAggregate?: Resolver<Maybe<ResolversTypes['AlertRunCheckCheckAggregationSelection']>, ParentType, ContextType, RequireFields<AlertCheckAggregateArgs, 'directed'>>;
  checkConnection?: Resolver<ResolversTypes['AlertCheckConnection'], ParentType, ContextType, RequireFields<AlertCheckConnectionArgs, 'directed'>>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  entityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  entityUniqueIdentifier?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationCountry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertCheckConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlertCheckConnection'] = ResolversParentTypes['AlertCheckConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AlertCheckRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertCheckRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlertCheckRelationship'] = ResolversParentTypes['AlertCheckRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['RunCheck'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlertEdge'] = ResolversParentTypes['AlertEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Alert'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertRunCheckCheckAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlertRunCheckCheckAggregationSelection'] = ResolversParentTypes['AlertRunCheckCheckAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AlertRunCheckCheckNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertRunCheckCheckNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlertRunCheckCheckNodeAggregateSelection'] = ResolversParentTypes['AlertRunCheckCheckNodeAggregateSelection']> = {
  checkKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  checkName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  completedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  count?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  startedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  triggeredBy?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlertsConnection'] = ResolversParentTypes['AlertsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AlertEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Art71MasterDataImpactsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Art71MasterDataImpacts'] = ResolversParentTypes['Art71MasterDataImpacts']> = {
  agreementId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  refundImpacts?: Resolver<Array<ResolversTypes['MasterDataRefundImpact']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Art71MasterDataImpactsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Art71MasterDataImpactsConnection'] = ResolversParentTypes['Art71MasterDataImpactsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Art71MasterDataImpactsEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Art71MasterDataImpactsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Art71MasterDataImpactsEdge'] = ResolversParentTypes['Art71MasterDataImpactsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Art71MasterDataImpacts'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71Indication'] = ResolversParentTypes['Article71Indication']> = {
  agreementScope?: Resolver<Maybe<ResolversTypes['AgreementScope']>, ParentType, ContextType, RequireFields<Article71IndicationAgreementScopeArgs, 'directed'>>;
  agreementScopeAggregate?: Resolver<Maybe<ResolversTypes['Article71IndicationAgreementScopeAgreementScopeAggregationSelection']>, ParentType, ContextType, RequireFields<Article71IndicationAgreementScopeAggregateArgs, 'directed'>>;
  agreementScopeConnection?: Resolver<ResolversTypes['Article71IndicationAgreementScopeConnection'], ParentType, ContextType, RequireFields<Article71IndicationAgreementScopeConnectionArgs, 'directed'>>;
  agreementTemplate?: Resolver<Maybe<ResolversTypes['AgreementTemplate']>, ParentType, ContextType, RequireFields<Article71IndicationAgreementTemplateArgs, 'directed'>>;
  agreementTemplateAggregate?: Resolver<Maybe<ResolversTypes['Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection']>, ParentType, ContextType, RequireFields<Article71IndicationAgreementTemplateAggregateArgs, 'directed'>>;
  agreementTemplateConnection?: Resolver<ResolversTypes['Article71IndicationAgreementTemplateConnection'], ParentType, ContextType, RequireFields<Article71IndicationAgreementTemplateConnectionArgs, 'directed'>>;
  approvalDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  brand?: Resolver<ResolversTypes['Brand'], ParentType, ContextType, RequireFields<Article71IndicationBrandArgs, 'directed'>>;
  brandAggregate?: Resolver<Maybe<ResolversTypes['Article71IndicationBrandBrandAggregationSelection']>, ParentType, ContextType, RequireFields<Article71IndicationBrandAggregateArgs, 'directed'>>;
  brandConnection?: Resolver<ResolversTypes['Article71IndicationBrandConnection'], ParentType, ContextType, RequireFields<Article71IndicationBrandConnectionArgs, 'directed'>>;
  cases?: Resolver<Array<ResolversTypes['Case']>, ParentType, ContextType, RequireFields<Article71IndicationCasesArgs, 'directed'>>;
  casesAggregate?: Resolver<Maybe<ResolversTypes['Article71IndicationCaseCasesAggregationSelection']>, ParentType, ContextType, RequireFields<Article71IndicationCasesAggregateArgs, 'directed'>>;
  casesConnection?: Resolver<ResolversTypes['Article71IndicationCasesConnection'], ParentType, ContextType, RequireFields<Article71IndicationCasesConnectionArgs, 'directed'>>;
  countryScopeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  mainIndication?: Resolver<Maybe<ResolversTypes['MainIndication']>, ParentType, ContextType, RequireFields<Article71IndicationMainIndicationArgs, 'directed'>>;
  mainIndicationAggregate?: Resolver<Maybe<ResolversTypes['Article71IndicationMainIndicationMainIndicationAggregationSelection']>, ParentType, ContextType, RequireFields<Article71IndicationMainIndicationAggregateArgs, 'directed'>>;
  mainIndicationConnection?: Resolver<ResolversTypes['Article71IndicationMainIndicationConnection'], ParentType, ContextType, RequireFields<Article71IndicationMainIndicationConnectionArgs, 'directed'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sllAdditionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationAgreementScopeAgreementScopeAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationAgreementScopeAgreementScopeAggregationSelection'] = ResolversParentTypes['Article71IndicationAgreementScopeAgreementScopeAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection'] = ResolversParentTypes['Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection']> = {
  code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  scopeId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationAgreementScopeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationAgreementScopeConnection'] = ResolversParentTypes['Article71IndicationAgreementScopeConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Article71IndicationAgreementScopeRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationAgreementScopeRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationAgreementScopeRelationship'] = ResolversParentTypes['Article71IndicationAgreementScopeRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementScope'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationAgreementTemplateAgreementTemplateAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection'] = ResolversParentTypes['Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection'] = ResolversParentTypes['Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  treatments?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationAgreementTemplateConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationAgreementTemplateConnection'] = ResolversParentTypes['Article71IndicationAgreementTemplateConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Article71IndicationAgreementTemplateRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationAgreementTemplateRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationAgreementTemplateRelationship'] = ResolversParentTypes['Article71IndicationAgreementTemplateRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationBrandBrandAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationBrandBrandAggregationSelection'] = ResolversParentTypes['Article71IndicationBrandBrandAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Article71IndicationBrandBrandNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationBrandBrandNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationBrandBrandNodeAggregateSelection'] = ResolversParentTypes['Article71IndicationBrandBrandNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  art71DataLastUpdatedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  art71DataLastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationBrandConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationBrandConnection'] = ResolversParentTypes['Article71IndicationBrandConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Article71IndicationBrandRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationBrandRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationBrandRelationship'] = ResolversParentTypes['Article71IndicationBrandRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Brand'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationCaseCasesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationCaseCasesAggregationSelection'] = ResolversParentTypes['Article71IndicationCaseCasesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Article71IndicationCaseCasesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationCaseCasesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationCaseCasesNodeAggregateSelection'] = ResolversParentTypes['Article71IndicationCaseCasesNodeAggregateSelection']> = {
  creationDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  preparationBrandName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  submissionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationCasesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationCasesConnection'] = ResolversParentTypes['Article71IndicationCasesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Article71IndicationCasesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationCasesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationCasesRelationship'] = ResolversParentTypes['Article71IndicationCasesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Case'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationEdge'] = ResolversParentTypes['Article71IndicationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Article71Indication'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationMainIndicationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationMainIndicationConnection'] = ResolversParentTypes['Article71IndicationMainIndicationConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Article71IndicationMainIndicationRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationMainIndicationMainIndicationAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationMainIndicationMainIndicationAggregationSelection'] = ResolversParentTypes['Article71IndicationMainIndicationMainIndicationAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Article71IndicationMainIndicationMainIndicationNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationMainIndicationMainIndicationNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationMainIndicationMainIndicationNodeAggregateSelection'] = ResolversParentTypes['Article71IndicationMainIndicationMainIndicationNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationMainIndicationRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationMainIndicationRelationship'] = ResolversParentTypes['Article71IndicationMainIndicationRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['MainIndication'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Article71IndicationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article71IndicationsConnection'] = ResolversParentTypes['Article71IndicationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Article71IndicationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthOrganization'] = ResolversParentTypes['AuthOrganization']> = {
  emailEncryptionEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicAgreementsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  twoFactorEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthOrganizationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthOrganizationEdge'] = ResolversParentTypes['AuthOrganizationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AuthOrganization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthOrganizationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthOrganizationsConnection'] = ResolversParentTypes['AuthOrganizationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AuthOrganizationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableTranslationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableTranslations'] = ResolversParentTypes['AvailableTranslations']> = {
  de?: Resolver<ResolversTypes['TranslationsWithChangedKeys'], ParentType, ContextType>;
  en?: Resolver<ResolversTypes['TranslationsWithChangedKeys'], ParentType, ContextType>;
  platform?: Resolver<ResolversTypes['Platform'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableTranslationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableTranslationsConnection'] = ResolversParentTypes['AvailableTranslationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AvailableTranslationsEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableTranslationsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableTranslationsEdge'] = ResolversParentTypes['AvailableTranslationsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AvailableTranslations'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AverageGenericPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['AverageGenericPrice'] = ResolversParentTypes['AverageGenericPrice']> = {
  Price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValidFromDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AverageGenericPriceEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AverageGenericPriceEdge'] = ResolversParentTypes['AverageGenericPriceEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AverageGenericPrice'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AverageGenericPricesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AverageGenericPricesConnection'] = ResolversParentTypes['AverageGenericPricesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AverageGenericPriceEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreement'] = ResolversParentTypes['BaseAgreement']> = {
  addedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<BaseAgreementAddedByArgs, 'directed'>>;
  addedByAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementUserAddedByAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementAddedByAggregateArgs, 'directed'>>;
  addedByConnection?: Resolver<ResolversTypes['BaseAgreementAddedByConnection'], ParentType, ContextType, RequireFields<BaseAgreementAddedByConnectionArgs, 'directed'>>;
  allowedFormFlexEntityTypes?: Resolver<Maybe<Array<ResolversTypes['FlexEntityType']>>, ParentType, ContextType>;
  allowedForms?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  allowedRecordFlexEntityTypes?: Resolver<Maybe<Array<ResolversTypes['FlexEntityType']>>, ParentType, ContextType>;
  allowedRecords?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  canUserViewFinancials?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  caseSuspensionIntervalDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  caselessAgreementDataSnapshot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cases?: Resolver<Array<ResolversTypes['Case']>, ParentType, ContextType, RequireFields<BaseAgreementCasesArgs, 'directed'>>;
  casesAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementCaseCasesAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementCasesAggregateArgs, 'directed'>>;
  casesConnection?: Resolver<ResolversTypes['BaseAgreementCasesConnection'], ParentType, ContextType, RequireFields<BaseAgreementCasesConnectionArgs, 'directed'>>;
  counterparties?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType, RequireFields<BaseAgreementCounterpartiesArgs, 'directed'>>;
  counterpartiesAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementOrganizationCounterpartiesAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementCounterpartiesAggregateArgs, 'directed'>>;
  counterpartiesConnection?: Resolver<ResolversTypes['BaseAgreementCounterpartiesConnection'], ParentType, ContextType, RequireFields<BaseAgreementCounterpartiesConnectionArgs, 'directed'>>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType, RequireFields<BaseAgreementCountryArgs, 'directed'>>;
  countryAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementCountryCountryAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementCountryAggregateArgs, 'directed'>>;
  countryConnection?: Resolver<ResolversTypes['BaseAgreementCountryConnection'], ParentType, ContextType, RequireFields<BaseAgreementCountryConnectionArgs, 'directed'>>;
  coveringFormWaitInterval?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType, RequireFields<BaseAgreementCurrencyArgs, 'directed'>>;
  currencyAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementCurrencyCurrencyAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementCurrencyAggregateArgs, 'directed'>>;
  currencyConnection?: Resolver<ResolversTypes['BaseAgreementCurrencyConnection'], ParentType, ContextType, RequireFields<BaseAgreementCurrencyConnectionArgs, 'directed'>>;
  cycles?: Resolver<Array<ResolversTypes['CycleConfiguration']>, ParentType, ContextType, RequireFields<BaseAgreementCyclesArgs, 'directed'>>;
  cyclesAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementCycleConfigurationCyclesAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementCyclesAggregateArgs, 'directed'>>;
  cyclesConnection?: Resolver<ResolversTypes['BaseAgreementCyclesConnection'], ParentType, ContextType, RequireFields<BaseAgreementCyclesConnectionArgs, 'directed'>>;
  dataContainers?: Resolver<Array<ResolversTypes['DataContainer']>, ParentType, ContextType, RequireFields<BaseAgreementDataContainersArgs, 'directed'>>;
  dataContainersAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementDataContainerDataContainersAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementDataContainersAggregateArgs, 'directed'>>;
  dataContainersConnection?: Resolver<ResolversTypes['BaseAgreementDataContainersConnection'], ParentType, ContextType, RequireFields<BaseAgreementDataContainersConnectionArgs, 'directed'>>;
  dataSource?: Resolver<ResolversTypes['DataSource'], ParentType, ContextType, RequireFields<BaseAgreementDataSourceArgs, 'directed'>>;
  dataSourceAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementDataSourceDataSourceAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementDataSourceAggregateArgs, 'directed'>>;
  dataSourceConnection?: Resolver<ResolversTypes['BaseAgreementDataSourceConnection'], ParentType, ContextType, RequireFields<BaseAgreementDataSourceConnectionArgs, 'directed'>>;
  daysToExpiry?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  decisions?: Resolver<Array<ResolversTypes['AgreementDecision']>, ParentType, ContextType, RequireFields<BaseAgreementDecisionsArgs, 'directed'>>;
  decisionsAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementAgreementDecisionDecisionsAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementDecisionsAggregateArgs, 'directed'>>;
  decisionsConnection?: Resolver<ResolversTypes['BaseAgreementDecisionsConnection'], ParentType, ContextType, RequireFields<BaseAgreementDecisionsConnectionArgs, 'directed'>>;
  defaultPriceRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  deviceAlternativeSets?: Resolver<Array<ResolversTypes['DeviceAlternative']>, ParentType, ContextType, RequireFields<BaseAgreementDeviceAlternativeSetsArgs, 'directed'>>;
  deviceAlternativeSetsAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementDeviceAlternativeSetsAggregateArgs, 'directed'>>;
  deviceAlternativeSetsConnection?: Resolver<ResolversTypes['BaseAgreementDeviceAlternativeSetsConnection'], ParentType, ContextType, RequireFields<BaseAgreementDeviceAlternativeSetsConnectionArgs, 'directed'>>;
  dotThresholds?: Resolver<Maybe<ResolversTypes['ChartRangeConfiguration']>, ParentType, ContextType, RequireFields<BaseAgreementDotThresholdsArgs, 'directed'>>;
  dotThresholdsAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementDotThresholdsAggregateArgs, 'directed'>>;
  dotThresholdsConnection?: Resolver<ResolversTypes['BaseAgreementDotThresholdsConnection'], ParentType, ContextType, RequireFields<BaseAgreementDotThresholdsConnectionArgs, 'directed'>>;
  eligibilityConditionSets?: Resolver<Array<ResolversTypes['EligibilityConditionSet']>, ParentType, ContextType, RequireFields<BaseAgreementEligibilityConditionSetsArgs, 'directed'>>;
  eligibilityConditionSetsAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementEligibilityConditionSetsAggregateArgs, 'directed'>>;
  eligibilityConditionSetsConnection?: Resolver<ResolversTypes['BaseAgreementEligibilityConditionSetsConnection'], ParentType, ContextType, RequireFields<BaseAgreementEligibilityConditionSetsConnectionArgs, 'directed'>>;
  eligibilityConditionTreatments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Treatment']>>>, ParentType, ContextType>;
  enrollingConditionSets?: Resolver<Array<ResolversTypes['EnrollingConditionSet']>, ParentType, ContextType, RequireFields<BaseAgreementEnrollingConditionSetsArgs, 'directed'>>;
  enrollingConditionSetsAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementEnrollingConditionSetsAggregateArgs, 'directed'>>;
  enrollingConditionSetsConnection?: Resolver<ResolversTypes['BaseAgreementEnrollingConditionSetsConnection'], ParentType, ContextType, RequireFields<BaseAgreementEnrollingConditionSetsConnectionArgs, 'directed'>>;
  enrollingPeriods?: Resolver<Array<ResolversTypes['EnrollingPeriod']>, ParentType, ContextType, RequireFields<BaseAgreementEnrollingPeriodsArgs, 'directed'>>;
  enrollingPeriodsAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementEnrollingPeriodsAggregateArgs, 'directed'>>;
  enrollingPeriodsConnection?: Resolver<ResolversTypes['BaseAgreementEnrollingPeriodsConnection'], ParentType, ContextType, RequireFields<BaseAgreementEnrollingPeriodsConnectionArgs, 'directed'>>;
  enrolmentDateType?: Resolver<Maybe<ResolversTypes['EnrolmentDateType']>, ParentType, ContextType>;
  expectedDocument?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  financialDataPoints?: Resolver<Array<ResolversTypes['FlexFinancialDataPoint']>, ParentType, ContextType, RequireFields<BaseAgreementFinancialDataPointsArgs, 'directed'>>;
  financialDataPointsAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementFinancialDataPointsAggregateArgs, 'directed'>>;
  financialDataPointsConnection?: Resolver<ResolversTypes['BaseAgreementFinancialDataPointsConnection'], ParentType, ContextType, RequireFields<BaseAgreementFinancialDataPointsConnectionArgs, 'directed'>>;
  financialSummaryConfig?: Resolver<Array<ResolversTypes['FinancialSummaryColumn']>, ParentType, ContextType, RequireFields<BaseAgreementFinancialSummaryConfigArgs, 'directed'>>;
  financialSummaryConfigAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementFinancialSummaryConfigAggregateArgs, 'directed'>>;
  financialSummaryConfigConnection?: Resolver<ResolversTypes['BaseAgreementFinancialSummaryConfigConnection'], ParentType, ContextType, RequireFields<BaseAgreementFinancialSummaryConfigConnectionArgs, 'directed'>>;
  firstExecutionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  formattedAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedCounterparties?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedDiseases?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedIndications?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedProducts?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generics?: Resolver<Array<ResolversTypes['Generic']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  initialVersion?: Resolver<Maybe<ResolversTypes['BaseAgreement']>, ParentType, ContextType, RequireFields<BaseAgreementInitialVersionArgs, 'directed'>>;
  initialVersionAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementBaseAgreementInitialVersionAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementInitialVersionAggregateArgs, 'directed'>>;
  initialVersionConnection?: Resolver<ResolversTypes['BaseAgreementInitialVersionConnection'], ParentType, ContextType, RequireFields<BaseAgreementInitialVersionConnectionArgs, 'directed'>>;
  initialVersionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isAllowedFormsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isAllowedRecordsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCaseless?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCoveringIntervalEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isExtended?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFirstVersion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isInsightsAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLastVersion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRequiredFormsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRequiredRecordsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isScenariosInSync?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isScopeSync?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isValidityPeriodInSync?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastExecutionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastUpdatedOn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  negotiableAttributes?: Resolver<Array<ResolversTypes['CatalogueAttribute']>, ParentType, ContextType, RequireFields<BaseAgreementNegotiableAttributesArgs, 'directed'>>;
  negotiableAttributesAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementNegotiableAttributesAggregateArgs, 'directed'>>;
  negotiableAttributesConnection?: Resolver<ResolversTypes['BaseAgreementNegotiableAttributesConnection'], ParentType, ContextType, RequireFields<BaseAgreementNegotiableAttributesConnectionArgs, 'directed'>>;
  nextVersions?: Resolver<Array<ResolversTypes['BaseAgreement']>, ParentType, ContextType, RequireFields<BaseAgreementNextVersionsArgs, 'directed'>>;
  nextVersionsAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementBaseAgreementNextVersionsAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementNextVersionsAggregateArgs, 'directed'>>;
  nextVersionsConnection?: Resolver<ResolversTypes['BaseAgreementNextVersionsConnection'], ParentType, ContextType, RequireFields<BaseAgreementNextVersionsConnectionArgs, 'directed'>>;
  participatingCounterparties?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType>;
  pushedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<BaseAgreementPushedByArgs, 'directed'>>;
  pushedByAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementUserPushedByAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementPushedByAggregateArgs, 'directed'>>;
  pushedByConnection?: Resolver<ResolversTypes['BaseAgreementPushedByConnection'], ParentType, ContextType, RequireFields<BaseAgreementPushedByConnectionArgs, 'directed'>>;
  pushedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  rangeChartConfig?: Resolver<Maybe<ResolversTypes['ChartRangeConfiguration']>, ParentType, ContextType, RequireFields<BaseAgreementRangeChartConfigArgs, 'directed'>>;
  rangeChartConfigAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementRangeChartConfigAggregateArgs, 'directed'>>;
  rangeChartConfigConnection?: Resolver<ResolversTypes['BaseAgreementRangeChartConfigConnection'], ParentType, ContextType, RequireFields<BaseAgreementRangeChartConfigConnectionArgs, 'directed'>>;
  reportData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredFormFlexEntityTypes?: Resolver<Maybe<Array<ResolversTypes['FlexEntityType']>>, ParentType, ContextType>;
  requiredForms?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  requiredRecordFlexEntityTypes?: Resolver<Maybe<Array<ResolversTypes['FlexEntityType']>>, ParentType, ContextType>;
  requiredRecords?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  scenarios?: Resolver<Array<ResolversTypes['Scenario']>, ParentType, ContextType, RequireFields<BaseAgreementScenariosArgs, 'directed'>>;
  scenariosAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementScenarioScenariosAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementScenariosAggregateArgs, 'directed'>>;
  scenariosConnection?: Resolver<ResolversTypes['BaseAgreementScenariosConnection'], ParentType, ContextType, RequireFields<BaseAgreementScenariosConnectionArgs, 'directed'>>;
  scenariosRelevantBrands?: Resolver<Array<ResolversTypes['Brand']>, ParentType, ContextType, RequireFields<BaseAgreementScenariosRelevantBrandsArgs, 'directed'>>;
  scenariosRelevantBrandsAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementBrandScenariosRelevantBrandsAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementScenariosRelevantBrandsAggregateArgs, 'directed'>>;
  scenariosRelevantBrandsConnection?: Resolver<ResolversTypes['BaseAgreementScenariosRelevantBrandsConnection'], ParentType, ContextType, RequireFields<BaseAgreementScenariosRelevantBrandsConnectionArgs, 'directed'>>;
  status?: Resolver<ResolversTypes['ContractStatus'], ParentType, ContextType>;
  statusTransitions?: Resolver<Array<ResolversTypes['AgreementStatusTransition']>, ParentType, ContextType, RequireFields<BaseAgreementStatusTransitionsArgs, 'directed'>>;
  statusTransitionsAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementStatusTransitionsAggregateArgs, 'directed'>>;
  statusTransitionsConnection?: Resolver<ResolversTypes['BaseAgreementStatusTransitionsConnection'], ParentType, ContextType, RequireFields<BaseAgreementStatusTransitionsConnectionArgs, 'directed'>>;
  subjectMatter?: Resolver<ResolversTypes['AgreementSubjectMatter'], ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['AgreementTag']>, ParentType, ContextType, RequireFields<BaseAgreementTagsArgs, 'directed'>>;
  tagsAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementAgreementTagTagsAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementTagsAggregateArgs, 'directed'>>;
  tagsConnection?: Resolver<ResolversTypes['BaseAgreementTagsConnection'], ParentType, ContextType, RequireFields<BaseAgreementTagsConnectionArgs, 'directed'>>;
  template?: Resolver<Maybe<ResolversTypes['AgreementTemplate']>, ParentType, ContextType, RequireFields<BaseAgreementTemplateArgs, 'directed'>>;
  templateAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementAgreementTemplateTemplateAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementTemplateAggregateArgs, 'directed'>>;
  templateConnection?: Resolver<ResolversTypes['BaseAgreementTemplateConnection'], ParentType, ContextType, RequireFields<BaseAgreementTemplateConnectionArgs, 'directed'>>;
  tenantIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  totalAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  treatmentPrices?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<BaseAgreementTreatmentPricesArgs, 'directed'>>;
  treatmentPricesAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementTreatmentTreatmentPricesAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementTreatmentPricesAggregateArgs, 'directed'>>;
  treatmentPricesConnection?: Resolver<ResolversTypes['BaseAgreementTreatmentPricesConnection'], ParentType, ContextType, RequireFields<BaseAgreementTreatmentPricesConnectionArgs, 'directed'>>;
  userContexts?: Resolver<Array<ResolversTypes['UserContext']>, ParentType, ContextType, RequireFields<BaseAgreementUserContextsArgs, 'directed'>>;
  userContextsAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementUserContextUserContextsAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementUserContextsAggregateArgs, 'directed'>>;
  userContextsConnection?: Resolver<ResolversTypes['BaseAgreementUserContextsConnection'], ParentType, ContextType, RequireFields<BaseAgreementUserContextsConnectionArgs, 'directed'>>;
  userOrganizationRole?: Resolver<Maybe<ResolversTypes['CounterpartyRole']>, ParentType, ContextType>;
  userRoles?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<BaseAgreementUserRolesArgs, 'directed'>>;
  userRolesAggregate?: Resolver<Maybe<ResolversTypes['BaseAgreementUserUserRolesAggregationSelection']>, ParentType, ContextType, RequireFields<BaseAgreementUserRolesAggregateArgs, 'directed'>>;
  userRolesConnection?: Resolver<ResolversTypes['BaseAgreementUserRolesConnection'], ParentType, ContextType, RequireFields<BaseAgreementUserRolesConnectionArgs, 'directed'>>;
  validFromDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  validToDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementAddedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementAddedByConnection'] = ResolversParentTypes['BaseAgreementAddedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementAddedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementAddedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementAddedByRelationship'] = ResolversParentTypes['BaseAgreementAddedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementAgreementDecisionDecisionsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementAgreementDecisionDecisionsAggregationSelection'] = ResolversParentTypes['BaseAgreementAgreementDecisionDecisionsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementAgreementDecisionDecisionsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection'] = ResolversParentTypes['BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementAgreementTagTagsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementAgreementTagTagsAggregationSelection'] = ResolversParentTypes['BaseAgreementAgreementTagTagsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementAgreementTagTagsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementAgreementTagTagsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementAgreementTagTagsNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementAgreementTagTagsNodeAggregateSelection']> = {
  id?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementAgreementTemplateTemplateAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementAgreementTemplateTemplateAggregationSelection'] = ResolversParentTypes['BaseAgreementAgreementTemplateTemplateAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementAgreementTemplateTemplateNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementAgreementTemplateTemplateNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementAgreementTemplateTemplateNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementAgreementTemplateTemplateNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  treatments?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementBaseAgreementInitialVersionAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementBaseAgreementInitialVersionAggregationSelection'] = ResolversParentTypes['BaseAgreementBaseAgreementInitialVersionAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementBaseAgreementInitialVersionNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection']> = {
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  caselessAgreementDataSnapshot?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  daysToExpiry?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  firstExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  formattedAmount?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedCounterparties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedDiseases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedIndications?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedProducts?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  pushedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  reportData?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementBaseAgreementNextVersionsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementBaseAgreementNextVersionsAggregationSelection'] = ResolversParentTypes['BaseAgreementBaseAgreementNextVersionsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementBaseAgreementNextVersionsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection']> = {
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  caselessAgreementDataSnapshot?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  daysToExpiry?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  firstExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  formattedAmount?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedCounterparties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedDiseases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedIndications?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedProducts?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  pushedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  reportData?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementBrandScenariosRelevantBrandsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementBrandScenariosRelevantBrandsAggregationSelection'] = ResolversParentTypes['BaseAgreementBrandScenariosRelevantBrandsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  art71DataLastUpdatedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  art71DataLastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCaseCasesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCaseCasesAggregationSelection'] = ResolversParentTypes['BaseAgreementCaseCasesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementCaseCasesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCaseCasesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCaseCasesNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementCaseCasesNodeAggregateSelection']> = {
  creationDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  preparationBrandName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  submissionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCasesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCasesConnection'] = ResolversParentTypes['BaseAgreementCasesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementCasesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCasesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCasesRelationship'] = ResolversParentTypes['BaseAgreementCasesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Case'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection'] = ResolversParentTypes['BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection']> = {
  caption?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  decimalPrecision?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultValue?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  longLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  maxLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  minLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  rules?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  shortLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  values?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection'] = ResolversParentTypes['BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection'] = ResolversParentTypes['BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection']> = {
  threshold?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection'] = ResolversParentTypes['BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection'] = ResolversParentTypes['BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection']> = {
  from?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCounterpartiesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCounterpartiesConnection'] = ResolversParentTypes['BaseAgreementCounterpartiesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementCounterpartiesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCounterpartiesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCounterpartiesRelationship'] = ResolversParentTypes['BaseAgreementCounterpartiesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isApprovalRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['CounterpartyRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCounterpartyRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCounterpartyRelationship'] = ResolversParentTypes['BaseAgreementCounterpartyRelationship']> = {
  __resolveType: TypeResolveFn<'BaseAgreementCounterpartiesRelationship', ParentType, ContextType>;
  isApprovalRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['CounterpartyRole'], ParentType, ContextType>;
};

export type BaseAgreementCountryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCountryConnection'] = ResolversParentTypes['BaseAgreementCountryConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementCountryRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCountryCountryAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCountryCountryAggregationSelection'] = ResolversParentTypes['BaseAgreementCountryCountryAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementCountryCountryNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCountryCountryNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCountryCountryNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementCountryCountryNodeAggregateSelection']> = {
  alpha2Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  alpha3Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  numericCode?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCountryRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCountryRelationship'] = ResolversParentTypes['BaseAgreementCountryRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCurrencyConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCurrencyConnection'] = ResolversParentTypes['BaseAgreementCurrencyConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementCurrencyRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCurrencyCurrencyAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCurrencyCurrencyAggregationSelection'] = ResolversParentTypes['BaseAgreementCurrencyCurrencyAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementCurrencyCurrencyNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCurrencyCurrencyNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCurrencyCurrencyNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementCurrencyCurrencyNodeAggregateSelection']> = {
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCurrencyRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCurrencyRelationship'] = ResolversParentTypes['BaseAgreementCurrencyRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCycleConfigurationCyclesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCycleConfigurationCyclesAggregationSelection'] = ResolversParentTypes['BaseAgreementCycleConfigurationCyclesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementCycleConfigurationCyclesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCycleConfigurationCyclesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCycleConfigurationCyclesNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementCycleConfigurationCyclesNodeAggregateSelection']> = {
  lengthFrom?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  lengthTo?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCyclesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCyclesConnection'] = ResolversParentTypes['BaseAgreementCyclesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementCyclesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementCyclesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementCyclesRelationship'] = ResolversParentTypes['BaseAgreementCyclesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CycleConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDataContainerDataContainersAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDataContainerDataContainersAggregationSelection'] = ResolversParentTypes['BaseAgreementDataContainerDataContainersAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementDataContainerDataContainersNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDataContainerDataContainersNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDataContainerDataContainersNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementDataContainerDataContainersNodeAggregateSelection']> = {
  subType?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  timeframeEnd?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  timeframeStart?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDataContainersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDataContainersConnection'] = ResolversParentTypes['BaseAgreementDataContainersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementDataContainersRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDataContainersRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDataContainersRelationship'] = ResolversParentTypes['BaseAgreementDataContainersRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DataContainer'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDataSourceConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDataSourceConnection'] = ResolversParentTypes['BaseAgreementDataSourceConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementDataSourceRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDataSourceDataSourceAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDataSourceDataSourceAggregationSelection'] = ResolversParentTypes['BaseAgreementDataSourceDataSourceAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementDataSourceDataSourceNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDataSourceDataSourceNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDataSourceDataSourceNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementDataSourceDataSourceNodeAggregateSelection']> = {
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDataSourceRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDataSourceRelationship'] = ResolversParentTypes['BaseAgreementDataSourceRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DataSource'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDecisionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDecisionsConnection'] = ResolversParentTypes['BaseAgreementDecisionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementDecisionsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDecisionsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDecisionsRelationship'] = ResolversParentTypes['BaseAgreementDecisionsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementDecision'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection'] = ResolversParentTypes['BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection']> = {
  code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDeviceAlternativeSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDeviceAlternativeSetsConnection'] = ResolversParentTypes['BaseAgreementDeviceAlternativeSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementDeviceAlternativeSetsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDeviceAlternativeSetsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDeviceAlternativeSetsRelationship'] = ResolversParentTypes['BaseAgreementDeviceAlternativeSetsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DeviceAlternative'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDotThresholdsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDotThresholdsConnection'] = ResolversParentTypes['BaseAgreementDotThresholdsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementDotThresholdsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementDotThresholdsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementDotThresholdsRelationship'] = ResolversParentTypes['BaseAgreementDotThresholdsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ChartRangeConfiguration'], ParentType, ContextType>;
  threshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEdge'] = ResolversParentTypes['BaseAgreementEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['BaseAgreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEligibilityConditionRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEligibilityConditionRelationship'] = ResolversParentTypes['BaseAgreementEligibilityConditionRelationship']> = {
  __resolveType: TypeResolveFn<'BaseAgreementEligibilityConditionSetsRelationship', ParentType, ContextType>;
  cycleAdherence?: Resolver<Maybe<ResolversTypes['CycleAdherence']>, ParentType, ContextType>;
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minimumPercentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfAdministeredRangeDays?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  numberOfAdministeredTreatments?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfAdministeredTreatmentsOperator?: Resolver<Maybe<ResolversTypes['ArithmeticalOperator']>, ParentType, ContextType>;
  previousTestNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceAdministrationSequenceNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceTestRangeDays?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  treatments?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection'] = ResolversParentTypes['BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection'] = ResolversParentTypes['BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection']> = {
  days?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  minimumPercentage?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  numberOfAdministeredTreatments?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  previousTestNumber?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  referenceAdministrationSequenceNumber?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection']> = {
  code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  inputLabel?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEligibilityConditionSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEligibilityConditionSetsConnection'] = ResolversParentTypes['BaseAgreementEligibilityConditionSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementEligibilityConditionSetsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEligibilityConditionSetsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEligibilityConditionSetsRelationship'] = ResolversParentTypes['BaseAgreementEligibilityConditionSetsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cycleAdherence?: Resolver<Maybe<ResolversTypes['CycleAdherence']>, ParentType, ContextType>;
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minimumPercentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EligibilityConditionSet'], ParentType, ContextType>;
  numberOfAdministeredRangeDays?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  numberOfAdministeredTreatments?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfAdministeredTreatmentsOperator?: Resolver<Maybe<ResolversTypes['ArithmeticalOperator']>, ParentType, ContextType>;
  previousTestNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceAdministrationSequenceNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceTestRangeDays?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  treatments?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection'] = ResolversParentTypes['BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection']> = {
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEnrollingConditionSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEnrollingConditionSetsConnection'] = ResolversParentTypes['BaseAgreementEnrollingConditionSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementEnrollingConditionSetsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEnrollingConditionSetsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEnrollingConditionSetsRelationship'] = ResolversParentTypes['BaseAgreementEnrollingConditionSetsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EnrollingConditionSet'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection'] = ResolversParentTypes['BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEnrollingPeriodsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEnrollingPeriodsConnection'] = ResolversParentTypes['BaseAgreementEnrollingPeriodsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementEnrollingPeriodsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementEnrollingPeriodsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementEnrollingPeriodsRelationship'] = ResolversParentTypes['BaseAgreementEnrollingPeriodsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EnrollingPeriod'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementFinancialDataPointsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementFinancialDataPointsConnection'] = ResolversParentTypes['BaseAgreementFinancialDataPointsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementFinancialDataPointsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementFinancialDataPointsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementFinancialDataPointsRelationship'] = ResolversParentTypes['BaseAgreementFinancialDataPointsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexFinancialDataPoint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection'] = ResolversParentTypes['BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection'] = ResolversParentTypes['BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection']> = {
  localizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection']> = {
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementFinancialSummaryConfigConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementFinancialSummaryConfigConnection'] = ResolversParentTypes['BaseAgreementFinancialSummaryConfigConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementFinancialSummaryConfigRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementFinancialSummaryConfigRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementFinancialSummaryConfigRelationship'] = ResolversParentTypes['BaseAgreementFinancialSummaryConfigRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasHelpMessage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isIncluded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  localizationKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FinancialSummaryColumn'], ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection'] = ResolversParentTypes['BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection']> = {
  basePrice?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  evaluationSnapshot?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  generatedUuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  netPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  payable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  payablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundDeltaNumber?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  revokedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroMainNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroRelevantNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  variable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  variablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementInitialVersionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementInitialVersionConnection'] = ResolversParentTypes['BaseAgreementInitialVersionConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementInitialVersionRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementInitialVersionRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementInitialVersionRelationship'] = ResolversParentTypes['BaseAgreementInitialVersionRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['BaseAgreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementNegotiableAttributesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementNegotiableAttributesConnection'] = ResolversParentTypes['BaseAgreementNegotiableAttributesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementNegotiableAttributesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementNegotiableAttributesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementNegotiableAttributesRelationship'] = ResolversParentTypes['BaseAgreementNegotiableAttributesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CatalogueAttribute'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementNextVersionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementNextVersionsConnection'] = ResolversParentTypes['BaseAgreementNextVersionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementNextVersionsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementNextVersionsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementNextVersionsRelationship'] = ResolversParentTypes['BaseAgreementNextVersionsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['BaseAgreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementOrganizationCounterpartiesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementOrganizationCounterpartiesAggregationSelection'] = ResolversParentTypes['BaseAgreementOrganizationCounterpartiesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementOrganizationCounterpartiesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementOrganizationCounterpartiesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementOrganizationCounterpartiesNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementOrganizationCounterpartiesNodeAggregateSelection']> = {
  BIC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  IBAN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  aggregationPriority?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceThreshold?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactFirstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactLastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactOccupation?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactPhone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderRecurrentStep?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentSftpSavePath?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  domicile?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  dualApprovalThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  eIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  fax?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  legalName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  pharmaId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rebateProcessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  website?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementPushedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementPushedByConnection'] = ResolversParentTypes['BaseAgreementPushedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementPushedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementPushedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementPushedByRelationship'] = ResolversParentTypes['BaseAgreementPushedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementRangeChartConfigConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementRangeChartConfigConnection'] = ResolversParentTypes['BaseAgreementRangeChartConfigConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementRangeChartConfigRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementRangeChartConfigRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementRangeChartConfigRelationship'] = ResolversParentTypes['BaseAgreementRangeChartConfigRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  from?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ChartRangeConfiguration'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementScenarioScenariosAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementScenarioScenariosAggregationSelection'] = ResolversParentTypes['BaseAgreementScenarioScenariosAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementScenarioScenariosNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementScenarioScenariosNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementScenarioScenariosNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementScenarioScenariosNodeAggregateSelection']> = {
  group?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementScenariosConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementScenariosConnection'] = ResolversParentTypes['BaseAgreementScenariosConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementScenariosRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementScenariosRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementScenariosRelationship'] = ResolversParentTypes['BaseAgreementScenariosRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Scenario'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementScenariosRelevantBrandsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementScenariosRelevantBrandsConnection'] = ResolversParentTypes['BaseAgreementScenariosRelevantBrandsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementScenariosRelevantBrandsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementScenariosRelevantBrandsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementScenariosRelevantBrandsRelationship'] = ResolversParentTypes['BaseAgreementScenariosRelevantBrandsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Brand'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementStatusTransitionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementStatusTransitionsConnection'] = ResolversParentTypes['BaseAgreementStatusTransitionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementStatusTransitionsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementStatusTransitionsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementStatusTransitionsRelationship'] = ResolversParentTypes['BaseAgreementStatusTransitionsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementStatusTransition'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementTagsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementTagsConnection'] = ResolversParentTypes['BaseAgreementTagsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementTagsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementTagsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementTagsRelationship'] = ResolversParentTypes['BaseAgreementTagsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementTag'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementTemplateConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementTemplateConnection'] = ResolversParentTypes['BaseAgreementTemplateConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementTemplateRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementTemplateRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementTemplateRelationship'] = ResolversParentTypes['BaseAgreementTemplateRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementTreatmentPriceRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementTreatmentPriceRelationship'] = ResolversParentTypes['BaseAgreementTreatmentPriceRelationship']> = {
  __resolveType: TypeResolveFn<'BaseAgreementTreatmentPricesRelationship', ParentType, ContextType>;
  basePriceType?: Resolver<Maybe<ResolversTypes['PriceType']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type BaseAgreementTreatmentPricesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementTreatmentPricesConnection'] = ResolversParentTypes['BaseAgreementTreatmentPricesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementTreatmentPricesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementTreatmentPricesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementTreatmentPricesRelationship'] = ResolversParentTypes['BaseAgreementTreatmentPricesRelationship']> = {
  basePriceType?: Resolver<Maybe<ResolversTypes['PriceType']>, ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementTreatmentTreatmentPricesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementTreatmentTreatmentPricesAggregationSelection'] = ResolversParentTypes['BaseAgreementTreatmentTreatmentPricesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection'] = ResolversParentTypes['BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection']> = {
  price?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementTreatmentTreatmentPricesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserAddedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserAddedByAggregationSelection'] = ResolversParentTypes['BaseAgreementUserAddedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementUserAddedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserAddedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserAddedByNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementUserAddedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserContextUserContextsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserContextUserContextsAggregationSelection'] = ResolversParentTypes['BaseAgreementUserContextUserContextsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['BaseAgreementUserContextUserContextsEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementUserContextUserContextsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserContextUserContextsEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserContextUserContextsEdgeAggregateSelection'] = ResolversParentTypes['BaseAgreementUserContextUserContextsEdgeAggregateSelection']> = {
  categoryInput?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rebateObjective?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  timeframeLabel?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserContextUserContextsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserContextUserContextsNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementUserContextUserContextsNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  filtersAgreements?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  filtersCustomConditions?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  filtersModels?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserContextsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserContextsConnection'] = ResolversParentTypes['BaseAgreementUserContextsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementUserContextsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserContextsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserContextsRelationship'] = ResolversParentTypes['BaseAgreementUserContextsRelationship']> = {
  categoryInput?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['UserContext'], ParentType, ContextType>;
  rebateObjective?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeframeLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserPushedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserPushedByAggregationSelection'] = ResolversParentTypes['BaseAgreementUserPushedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementUserPushedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserPushedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserPushedByNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementUserPushedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserRoleRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserRoleRelationship'] = ResolversParentTypes['BaseAgreementUserRoleRelationship']> = {
  __resolveType: TypeResolveFn<'BaseAgreementUserRolesRelationship', ParentType, ContextType>;
  canApprove?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canModifyFinancials?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canViewFinancials?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isAssignee?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['AgreementUserRole'], ParentType, ContextType>;
};

export type BaseAgreementUserRolesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserRolesConnection'] = ResolversParentTypes['BaseAgreementUserRolesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementUserRolesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserRolesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserRolesRelationship'] = ResolversParentTypes['BaseAgreementUserRolesRelationship']> = {
  canApprove?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canModifyFinancials?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canViewFinancials?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isAssignee?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['AgreementUserRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserUserRolesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserUserRolesAggregationSelection'] = ResolversParentTypes['BaseAgreementUserUserRolesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BaseAgreementUserUserRolesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementUserUserRolesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementUserUserRolesNodeAggregateSelection'] = ResolversParentTypes['BaseAgreementUserUserRolesNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseAgreementsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseAgreementsConnection'] = ResolversParentTypes['BaseAgreementsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BaseAgreementEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandResolvers<ContextType = any, ParentType extends ResolversParentTypes['Brand'] = ResolversParentTypes['Brand']> = {
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  art71DataLastUpdatedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<BrandArt71DataLastUpdatedByArgs, 'directed'>>;
  art71DataLastUpdatedByAggregate?: Resolver<Maybe<ResolversTypes['BrandUserArt71DataLastUpdatedByAggregationSelection']>, ParentType, ContextType, RequireFields<BrandArt71DataLastUpdatedByAggregateArgs, 'directed'>>;
  art71DataLastUpdatedByConnection?: Resolver<ResolversTypes['BrandArt71DataLastUpdatedByConnection'], ParentType, ContextType, RequireFields<BrandArt71DataLastUpdatedByConnectionArgs, 'directed'>>;
  art71DataLastUpdatedByEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  art71DataLastUpdatedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  article71Indications?: Resolver<Array<ResolversTypes['Article71Indication']>, ParentType, ContextType, RequireFields<BrandArticle71IndicationsArgs, 'directed'>>;
  article71IndicationsAggregate?: Resolver<Maybe<ResolversTypes['BrandArticle71IndicationArticle71IndicationsAggregationSelection']>, ParentType, ContextType, RequireFields<BrandArticle71IndicationsAggregateArgs, 'directed'>>;
  article71IndicationsConnection?: Resolver<ResolversTypes['BrandArticle71IndicationsConnection'], ParentType, ContextType, RequireFields<BrandArticle71IndicationsConnectionArgs, 'directed'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPatented?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mainIndications?: Resolver<Array<ResolversTypes['MainIndication']>, ParentType, ContextType, RequireFields<BrandMainIndicationsArgs, 'directed'>>;
  mainIndicationsAggregate?: Resolver<Maybe<ResolversTypes['BrandMainIndicationMainIndicationsAggregationSelection']>, ParentType, ContextType, RequireFields<BrandMainIndicationsAggregateArgs, 'directed'>>;
  mainIndicationsConnection?: Resolver<ResolversTypes['BrandMainIndicationsConnection'], ParentType, ContextType, RequireFields<BrandMainIndicationsConnectionArgs, 'directed'>>;
  patentExpiryDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  preparations?: Resolver<Array<ResolversTypes['Preparation']>, ParentType, ContextType, RequireFields<BrandPreparationsArgs, 'directed'>>;
  preparationsAggregate?: Resolver<Maybe<ResolversTypes['BrandPreparationPreparationsAggregationSelection']>, ParentType, ContextType, RequireFields<BrandPreparationsAggregateArgs, 'directed'>>;
  preparationsConnection?: Resolver<ResolversTypes['BrandPreparationsConnection'], ParentType, ContextType, RequireFields<BrandPreparationsConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandArt71DataLastUpdatedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandArt71DataLastUpdatedByConnection'] = ResolversParentTypes['BrandArt71DataLastUpdatedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BrandArt71DataLastUpdatedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandArt71DataLastUpdatedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandArt71DataLastUpdatedByRelationship'] = ResolversParentTypes['BrandArt71DataLastUpdatedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandArticle71IndicationArticle71IndicationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandArticle71IndicationArticle71IndicationsAggregationSelection'] = ResolversParentTypes['BrandArticle71IndicationArticle71IndicationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandArticle71IndicationArticle71IndicationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection'] = ResolversParentTypes['BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection']> = {
  countryScopeId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  notes?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandArticle71IndicationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandArticle71IndicationsConnection'] = ResolversParentTypes['BrandArticle71IndicationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BrandArticle71IndicationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandArticle71IndicationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandArticle71IndicationsRelationship'] = ResolversParentTypes['BrandArticle71IndicationsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Article71Indication'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandEdge'] = ResolversParentTypes['BrandEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Brand'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandMainIndicationMainIndicationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandMainIndicationMainIndicationsAggregationSelection'] = ResolversParentTypes['BrandMainIndicationMainIndicationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BrandMainIndicationMainIndicationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandMainIndicationMainIndicationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandMainIndicationMainIndicationsNodeAggregateSelection'] = ResolversParentTypes['BrandMainIndicationMainIndicationsNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandMainIndicationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandMainIndicationsConnection'] = ResolversParentTypes['BrandMainIndicationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BrandMainIndicationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandMainIndicationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandMainIndicationsRelationship'] = ResolversParentTypes['BrandMainIndicationsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['MainIndication'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandPreparationPreparationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandPreparationPreparationsAggregationSelection'] = ResolversParentTypes['BrandPreparationPreparationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BrandPreparationPreparationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandPreparationPreparationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandPreparationPreparationsNodeAggregateSelection'] = ResolversParentTypes['BrandPreparationPreparationsNodeAggregateSelection']> = {
  AtcCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  BrandName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GenericName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo5?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandPreparationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandPreparationsConnection'] = ResolversParentTypes['BrandPreparationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BrandPreparationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandPreparationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandPreparationsRelationship'] = ResolversParentTypes['BrandPreparationsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Preparation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandUserArt71DataLastUpdatedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandUserArt71DataLastUpdatedByAggregationSelection'] = ResolversParentTypes['BrandUserArt71DataLastUpdatedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['BrandUserArt71DataLastUpdatedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandUserArt71DataLastUpdatedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandUserArt71DataLastUpdatedByNodeAggregateSelection'] = ResolversParentTypes['BrandUserArt71DataLastUpdatedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandsConnection'] = ResolversParentTypes['BrandsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BrandEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CachedAgreementListItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CachedAgreementListItem'] = ResolversParentTypes['CachedAgreementListItem']> = {
  formattedCounterparties?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedProducts?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedTags?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  initialVersionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdatedOn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ContractStatus']>, ParentType, ContextType>;
  totalAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  validFromDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validToDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CachedAgreementListItemEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CachedAgreementListItemEdge'] = ResolversParentTypes['CachedAgreementListItemEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CachedAgreementListItem'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CachedAgreementListItemsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CachedAgreementListItemsConnection'] = ResolversParentTypes['CachedAgreementListItemsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CachedAgreementListItemEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Case'] = ResolversParentTypes['Case']> = {
  agreement?: Resolver<Maybe<ResolversTypes['Agreement']>, ParentType, ContextType>;
  baseAgreement?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType, RequireFields<CaseBaseAgreementArgs, 'directed'>>;
  baseAgreementAggregate?: Resolver<Maybe<ResolversTypes['CaseAgreementBaseAgreementAggregationSelection']>, ParentType, ContextType, RequireFields<CaseBaseAgreementAggregateArgs, 'directed'>>;
  baseAgreementConnection?: Resolver<ResolversTypes['CaseBaseAgreementConnection'], ParentType, ContextType, RequireFields<CaseBaseAgreementConnectionArgs, 'directed'>>;
  creationDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  financialDataPoints?: Resolver<Array<ResolversTypes['FlexFinancialDataPoint']>, ParentType, ContextType, RequireFields<CaseFinancialDataPointsArgs, 'directed'>>;
  financialDataPointsAggregate?: Resolver<Maybe<ResolversTypes['CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection']>, ParentType, ContextType, RequireFields<CaseFinancialDataPointsAggregateArgs, 'directed'>>;
  financialDataPointsConnection?: Resolver<ResolversTypes['CaseFinancialDataPointsConnection'], ParentType, ContextType, RequireFields<CaseFinancialDataPointsConnectionArgs, 'directed'>>;
  flexEntities?: Resolver<Array<ResolversTypes['FlexEntity']>, ParentType, ContextType, RequireFields<CaseFlexEntitiesArgs, 'directed'>>;
  flexEntitiesAggregate?: Resolver<Maybe<ResolversTypes['CaseFlexEntityFlexEntitiesAggregationSelection']>, ParentType, ContextType, RequireFields<CaseFlexEntitiesAggregateArgs, 'directed'>>;
  flexEntitiesConnection?: Resolver<ResolversTypes['CaseFlexEntitiesConnection'], ParentType, ContextType, RequireFields<CaseFlexEntitiesConnectionArgs, 'directed'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  negotiationRounds?: Resolver<Array<ResolversTypes['NegotiationRound']>, ParentType, ContextType, RequireFields<CaseNegotiationRoundsArgs, 'directed'>>;
  negotiationRoundsAggregate?: Resolver<Maybe<ResolversTypes['CaseNegotiationRoundNegotiationRoundsAggregationSelection']>, ParentType, ContextType, RequireFields<CaseNegotiationRoundsAggregateArgs, 'directed'>>;
  negotiationRoundsConnection?: Resolver<ResolversTypes['CaseNegotiationRoundsConnection'], ParentType, ContextType, RequireFields<CaseNegotiationRoundsConnectionArgs, 'directed'>>;
  preparationBrandName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refunds?: Resolver<Array<ResolversTypes['Refund']>, ParentType, ContextType, RequireFields<CaseRefundsArgs, 'directed'>>;
  refundsAggregate?: Resolver<Maybe<ResolversTypes['CaseRefundRefundsAggregationSelection']>, ParentType, ContextType, RequireFields<CaseRefundsAggregateArgs, 'directed'>>;
  refundsConnection?: Resolver<ResolversTypes['CaseRefundsConnection'], ParentType, ContextType, RequireFields<CaseRefundsConnectionArgs, 'directed'>>;
  relevantArticle71Indication?: Resolver<Maybe<ResolversTypes['Article71Indication']>, ParentType, ContextType, RequireFields<CaseRelevantArticle71IndicationArgs, 'directed'>>;
  relevantArticle71IndicationAggregate?: Resolver<Maybe<ResolversTypes['CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection']>, ParentType, ContextType, RequireFields<CaseRelevantArticle71IndicationAggregateArgs, 'directed'>>;
  relevantArticle71IndicationConnection?: Resolver<ResolversTypes['CaseRelevantArticle71IndicationConnection'], ParentType, ContextType, RequireFields<CaseRelevantArticle71IndicationConnectionArgs, 'directed'>>;
  submissionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseAgreementBaseAgreementAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseAgreementBaseAgreementAggregationSelection'] = ResolversParentTypes['CaseAgreementBaseAgreementAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseAgreementBaseAgreementNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseAgreementBaseAgreementNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseAgreementBaseAgreementNodeAggregateSelection'] = ResolversParentTypes['CaseAgreementBaseAgreementNodeAggregateSelection']> = {
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  daysToExpiry?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  firstExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  formattedAmount?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedCounterparties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedDiseases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedIndications?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedProducts?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  pushedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  reportData?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseArticle71IndicationRelevantArticle71IndicationAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection'] = ResolversParentTypes['CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection'] = ResolversParentTypes['CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection']> = {
  countryScopeId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  notes?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBaseAgreementConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBaseAgreementConnection'] = ResolversParentTypes['CaseBaseAgreementConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CaseBaseAgreementRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseBaseAgreementRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseBaseAgreementRelationship'] = ResolversParentTypes['CaseBaseAgreementRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseEdge'] = ResolversParentTypes['CaseEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Case'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFinancialDataPointsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseFinancialDataPointsConnection'] = ResolversParentTypes['CaseFinancialDataPointsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CaseFinancialDataPointsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFinancialDataPointsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseFinancialDataPointsRelationship'] = ResolversParentTypes['CaseFinancialDataPointsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexFinancialDataPoint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFlexEntitiesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseFlexEntitiesConnection'] = ResolversParentTypes['CaseFlexEntitiesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CaseFlexEntitiesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFlexEntitiesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseFlexEntitiesRelationship'] = ResolversParentTypes['CaseFlexEntitiesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isStartingPoint?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFlexEntityFlexEntitiesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseFlexEntityFlexEntitiesAggregationSelection'] = ResolversParentTypes['CaseFlexEntityFlexEntitiesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseFlexEntityFlexEntitiesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFlexEntityFlexEntitiesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseFlexEntityFlexEntitiesNodeAggregateSelection'] = ResolversParentTypes['CaseFlexEntityFlexEntitiesNodeAggregateSelection']> = {
  createdByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  dataKeys?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  externalFormId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  flexEntityName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  insuranceClaimId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationBrandNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationGenericNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  viewCaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCreatedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewSuccessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFlexEntityRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseFlexEntityRelationship'] = ResolversParentTypes['CaseFlexEntityRelationship']> = {
  __resolveType: TypeResolveFn<'CaseFlexEntitiesRelationship' | 'FlexEntityCasesRelationship', ParentType, ContextType>;
  isStartingPoint?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type CaseFlexFinancialDataPointFinancialDataPointsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection'] = ResolversParentTypes['CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection'] = ResolversParentTypes['CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection']> = {
  basePrice?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  evaluationSnapshot?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  generatedUuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  netPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  payable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  payablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundDeltaNumber?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  revokedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroMainNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroRelevantNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  variable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  variablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseNegotiationRoundNegotiationRoundsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseNegotiationRoundNegotiationRoundsAggregationSelection'] = ResolversParentTypes['CaseNegotiationRoundNegotiationRoundsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseNegotiationRoundNegotiationRoundsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection'] = ResolversParentTypes['CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection']> = {
  changedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseNegotiationRoundsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseNegotiationRoundsConnection'] = ResolversParentTypes['CaseNegotiationRoundsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CaseNegotiationRoundsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseNegotiationRoundsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseNegotiationRoundsRelationship'] = ResolversParentTypes['CaseNegotiationRoundsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['NegotiationRound'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseRefundRefundsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseRefundRefundsAggregationSelection'] = ResolversParentTypes['CaseRefundRefundsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CaseRefundRefundsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseRefundRefundsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseRefundRefundsNodeAggregateSelection'] = ResolversParentTypes['CaseRefundRefundsNodeAggregateSelection']> = {
  agreementId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  caseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  caseOrAgreementId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseRefundsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseRefundsConnection'] = ResolversParentTypes['CaseRefundsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CaseRefundsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseRefundsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseRefundsRelationship'] = ResolversParentTypes['CaseRefundsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Refund'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseRelevantArticle71IndicationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseRelevantArticle71IndicationConnection'] = ResolversParentTypes['CaseRelevantArticle71IndicationConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CaseRelevantArticle71IndicationRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseRelevantArticle71IndicationRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseRelevantArticle71IndicationRelationship'] = ResolversParentTypes['CaseRelevantArticle71IndicationRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Article71Indication'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CasesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CasesConnection'] = ResolversParentTypes['CasesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CaseEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttribute'] = ResolversParentTypes['CatalogueAttribute']> = {
  arrayPossible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  attributeClasses?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  caption?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customCondition?: Resolver<Maybe<ResolversTypes['CustomCondition']>, ParentType, ContextType, RequireFields<CatalogueAttributeCustomConditionArgs, 'directed'>>;
  customConditionAggregate?: Resolver<Maybe<ResolversTypes['CatalogueAttributeCustomConditionCustomConditionAggregationSelection']>, ParentType, ContextType, RequireFields<CatalogueAttributeCustomConditionAggregateArgs, 'directed'>>;
  customConditionConnection?: Resolver<ResolversTypes['CatalogueAttributeCustomConditionConnection'], ParentType, ContextType, RequireFields<CatalogueAttributeCustomConditionConnectionArgs, 'directed'>>;
  dataSubType?: Resolver<Maybe<ResolversTypes['DataSubType']>, ParentType, ContextType>;
  dataType?: Resolver<ResolversTypes['DataType'], ParentType, ContextType>;
  decimalPrecision?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  defaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dependsOn?: Resolver<Array<ResolversTypes['CatalogueAttribute']>, ParentType, ContextType, RequireFields<CatalogueAttributeDependsOnArgs, 'directed'>>;
  dependsOnAggregate?: Resolver<Maybe<ResolversTypes['CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection']>, ParentType, ContextType, RequireFields<CatalogueAttributeDependsOnAggregateArgs, 'directed'>>;
  dependsOnConnection?: Resolver<ResolversTypes['CatalogueAttributeDependsOnConnection'], ParentType, ContextType, RequireFields<CatalogueAttributeDependsOnConnectionArgs, 'directed'>>;
  expectedWidth?: Resolver<Maybe<ResolversTypes['AttributeSize']>, ParentType, ContextType>;
  flexEntityTypes?: Resolver<Array<ResolversTypes['FlexEntityType']>, ParentType, ContextType, RequireFields<CatalogueAttributeFlexEntityTypesArgs, 'directed'>>;
  flexEntityTypesAggregate?: Resolver<Maybe<ResolversTypes['CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection']>, ParentType, ContextType, RequireFields<CatalogueAttributeFlexEntityTypesAggregateArgs, 'directed'>>;
  flexEntityTypesConnection?: Resolver<ResolversTypes['CatalogueAttributeFlexEntityTypesConnection'], ParentType, ContextType, RequireFields<CatalogueAttributeFlexEntityTypesConnectionArgs, 'directed'>>;
  hasDependant?: Resolver<Array<ResolversTypes['CatalogueAttribute']>, ParentType, ContextType, RequireFields<CatalogueAttributeHasDependantArgs, 'directed'>>;
  hasDependantAggregate?: Resolver<Maybe<ResolversTypes['CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection']>, ParentType, ContextType, RequireFields<CatalogueAttributeHasDependantAggregateArgs, 'directed'>>;
  hasDependantConnection?: Resolver<ResolversTypes['CatalogueAttributeHasDependantConnection'], ParentType, ContextType, RequireFields<CatalogueAttributeHasDependantConnectionArgs, 'directed'>>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isNegotiable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  longLabelLocalizationKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mutuallyRelevant?: Resolver<Array<ResolversTypes['CatalogueAttribute']>, ParentType, ContextType, RequireFields<CatalogueAttributeMutuallyRelevantArgs, 'directed'>>;
  mutuallyRelevantAggregate?: Resolver<Maybe<ResolversTypes['CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection']>, ParentType, ContextType, RequireFields<CatalogueAttributeMutuallyRelevantAggregateArgs, 'directed'>>;
  mutuallyRelevantConnection?: Resolver<ResolversTypes['CatalogueAttributeMutuallyRelevantConnection'], ParentType, ContextType, RequireFields<CatalogueAttributeMutuallyRelevantConnectionArgs, 'directed'>>;
  rules?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortLabelLocalizationKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CatalogueAttributeType']>, ParentType, ContextType>;
  validation?: Resolver<Maybe<ResolversTypes['StatusHistorical']>, ParentType, ContextType>;
  values?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeCatalogueAttributeDependsOnAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection'] = ResolversParentTypes['CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection'] = ResolversParentTypes['CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection']> = {
  comment?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rules?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection'] = ResolversParentTypes['CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection']> = {
  caption?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  decimalPrecision?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultValue?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  longLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  maxLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  minLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  rules?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  shortLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  values?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeCatalogueAttributeHasDependantAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection'] = ResolversParentTypes['CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection'] = ResolversParentTypes['CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection']> = {
  comment?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rules?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection'] = ResolversParentTypes['CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection']> = {
  caption?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  decimalPrecision?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultValue?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  longLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  maxLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  minLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  rules?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  shortLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  values?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection'] = ResolversParentTypes['CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection'] = ResolversParentTypes['CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection']> = {
  comment?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rules?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection'] = ResolversParentTypes['CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection']> = {
  caption?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  decimalPrecision?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultValue?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  longLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  maxLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  minLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  rules?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  shortLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  values?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeCustomConditionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeCustomConditionConnection'] = ResolversParentTypes['CatalogueAttributeCustomConditionConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CatalogueAttributeCustomConditionRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeCustomConditionCustomConditionAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeCustomConditionCustomConditionAggregationSelection'] = ResolversParentTypes['CatalogueAttributeCustomConditionCustomConditionAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection'] = ResolversParentTypes['CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeCustomConditionRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeCustomConditionRelationship'] = ResolversParentTypes['CatalogueAttributeCustomConditionRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CustomCondition'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeDependsOnConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeDependsOnConnection'] = ResolversParentTypes['CatalogueAttributeDependsOnConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CatalogueAttributeDependsOnRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeDependsOnRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeDependsOnRelationship'] = ResolversParentTypes['CatalogueAttributeDependsOnRelationship']> = {
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CatalogueAttribute'], ParentType, ContextType>;
  rules?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeEdge'] = ResolversParentTypes['CatalogueAttributeEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CatalogueAttribute'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection'] = ResolversParentTypes['CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection'] = ResolversParentTypes['CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  attributeCount?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  idPrefix?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  localizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  tooltipText?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeFlexEntityTypesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeFlexEntityTypesConnection'] = ResolversParentTypes['CatalogueAttributeFlexEntityTypesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CatalogueAttributeFlexEntityTypesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeFlexEntityTypesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeFlexEntityTypesRelationship'] = ResolversParentTypes['CatalogueAttributeFlexEntityTypesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isDisplayedInCaseDetails?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDisplayedInCaseTable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntityType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeHasDependantConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeHasDependantConnection'] = ResolversParentTypes['CatalogueAttributeHasDependantConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CatalogueAttributeHasDependantRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeHasDependantRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeHasDependantRelationship'] = ResolversParentTypes['CatalogueAttributeHasDependantRelationship']> = {
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CatalogueAttribute'], ParentType, ContextType>;
  rules?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeMutuallyRelevantConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeMutuallyRelevantConnection'] = ResolversParentTypes['CatalogueAttributeMutuallyRelevantConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CatalogueAttributeMutuallyRelevantRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributeMutuallyRelevantRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributeMutuallyRelevantRelationship'] = ResolversParentTypes['CatalogueAttributeMutuallyRelevantRelationship']> = {
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CatalogueAttribute'], ParentType, ContextType>;
  rules?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogueAttributesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogueAttributesConnection'] = ResolversParentTypes['CatalogueAttributesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CatalogueAttributeEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChartRangeConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChartRangeConfiguration'] = ResolversParentTypes['ChartRangeConfiguration']> = {
  chartType?: Resolver<ResolversTypes['ConfigurableChartType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChartRangeConfigurationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChartRangeConfigurationEdge'] = ResolversParentTypes['ChartRangeConfigurationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ChartRangeConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChartRangeConfigurationRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChartRangeConfigurationRelationship'] = ResolversParentTypes['ChartRangeConfigurationRelationship']> = {
  __resolveType: TypeResolveFn<'AgreementRangeChartConfigRelationship' | 'AgreementTemplateRangeChartConfigRelationship' | 'BaseAgreementRangeChartConfigRelationship', ParentType, ContextType>;
  from?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type ChartRangeConfigurationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChartRangeConfigurationsConnection'] = ResolversParentTypes['ChartRangeConfigurationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ChartRangeConfigurationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckedTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckedType'] = ResolversParentTypes['CheckedType']> = {
  results?: Resolver<Array<ResolversTypes['IntegrityCheckCompleteResult']>, ParentType, ContextType>;
  typeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckedTypeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckedTypeEdge'] = ResolversParentTypes['CheckedTypeEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CheckedType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckedTypesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckedTypesConnection'] = ResolversParentTypes['CheckedTypesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CheckedTypeEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClusterWorkerMetricResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClusterWorkerMetric'] = ResolversParentTypes['ClusterWorkerMetric']> = {
  capturedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cpuPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  heapTotalBytes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  heapUsedBytes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  nodeIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  purposes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  rssBytes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClusterWorkerMetricEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClusterWorkerMetricEdge'] = ResolversParentTypes['ClusterWorkerMetricEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ClusterWorkerMetric'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClusterWorkerMetricsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClusterWorkerMetricsConnection'] = ResolversParentTypes['ClusterWorkerMetricsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ClusterWorkerMetricEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClusterWorkersSnapshotResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClusterWorkersSnapshot'] = ResolversParentTypes['ClusterWorkersSnapshot']> = {
  generatedAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ClusterWorkerMetric']>, ParentType, ContextType>;
  primary?: Resolver<Maybe<ResolversTypes['ClusterWorkerMetric']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClusterWorkersSnapshotEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClusterWorkersSnapshotEdge'] = ResolversParentTypes['ClusterWorkersSnapshotEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ClusterWorkersSnapshot'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClusterWorkersSnapshotsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClusterWorkersSnapshotsConnection'] = ResolversParentTypes['ClusterWorkersSnapshotsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ClusterWorkersSnapshotEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['Config'] = ResolversParentTypes['Config']> = {
  cacheLockLifetimeSeconds?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  questAutocompletionLockLifetimeSeconds?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfigEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigEdge'] = ResolversParentTypes['ConfigEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Config'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfigsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigsConnection'] = ResolversParentTypes['ConfigsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ConfigEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CosmosMetricResolvers<ContextType = any, ParentType extends ResolversParentTypes['CosmosMetric'] = ResolversParentTypes['CosmosMetric']> = {
  cachedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cpuPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  memoryPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storagePercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unavailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CosmosMetricEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CosmosMetricEdge'] = ResolversParentTypes['CosmosMetricEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CosmosMetric'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CosmosMetricsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CosmosMetricsConnection'] = ResolversParentTypes['CosmosMetricsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CosmosMetricEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountriesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountriesConnection'] = ResolversParentTypes['CountriesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CountryEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Country'] = ResolversParentTypes['Country']> = {
  CallingCodes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  agreementCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  alpha2Code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  alpha3Code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  codeCategories?: Resolver<Array<ResolversTypes['CodeCategory']>, ParentType, ContextType>;
  currencies?: Resolver<Array<ResolversTypes['Currency']>, ParentType, ContextType, RequireFields<CountryCurrenciesArgs, 'directed'>>;
  currenciesAggregate?: Resolver<Maybe<ResolversTypes['CountryCurrencyCurrenciesAggregationSelection']>, ParentType, ContextType, RequireFields<CountryCurrenciesAggregateArgs, 'directed'>>;
  currenciesConnection?: Resolver<ResolversTypes['CountryCurrenciesConnection'], ParentType, ContextType, RequireFields<CountryCurrenciesConnectionArgs, 'directed'>>;
  currencyCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numericCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  organizations?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType, RequireFields<CountryOrganizationsArgs, 'directed'>>;
  organizationsAggregate?: Resolver<Maybe<ResolversTypes['CountryOrganizationOrganizationsAggregationSelection']>, ParentType, ContextType, RequireFields<CountryOrganizationsAggregateArgs, 'directed'>>;
  organizationsConnection?: Resolver<ResolversTypes['CountryOrganizationsConnection'], ParentType, ContextType, RequireFields<CountryOrganizationsConnectionArgs, 'directed'>>;
  scopes?: Resolver<Array<ResolversTypes['AgreementScope']>, ParentType, ContextType, RequireFields<CountryScopesArgs, 'directed'>>;
  scopesAggregate?: Resolver<Maybe<ResolversTypes['CountryAgreementScopeScopesAggregationSelection']>, ParentType, ContextType, RequireFields<CountryScopesAggregateArgs, 'directed'>>;
  scopesConnection?: Resolver<ResolversTypes['CountryScopesConnection'], ParentType, ContextType, RequireFields<CountryScopesConnectionArgs, 'directed'>>;
  templateCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  treatments?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<CountryTreatmentsArgs, 'directed'>>;
  treatmentsAggregate?: Resolver<Maybe<ResolversTypes['CountryTreatmentTreatmentsAggregationSelection']>, ParentType, ContextType, RequireFields<CountryTreatmentsAggregateArgs, 'directed'>>;
  treatmentsConnection?: Resolver<ResolversTypes['CountryTreatmentsConnection'], ParentType, ContextType, RequireFields<CountryTreatmentsConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryAgreementScopeScopesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryAgreementScopeScopesAggregationSelection'] = ResolversParentTypes['CountryAgreementScopeScopesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['CountryAgreementScopeScopesEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CountryAgreementScopeScopesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryAgreementScopeScopesEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryAgreementScopeScopesEdgeAggregateSelection'] = ResolversParentTypes['CountryAgreementScopeScopesEdgeAggregateSelection']> = {
  countryScopeId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryAgreementScopeScopesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryAgreementScopeScopesNodeAggregateSelection'] = ResolversParentTypes['CountryAgreementScopeScopesNodeAggregateSelection']> = {
  code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  scopeId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryCurrenciesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryCurrenciesConnection'] = ResolversParentTypes['CountryCurrenciesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CountryCurrenciesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryCurrenciesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryCurrenciesRelationship'] = ResolversParentTypes['CountryCurrenciesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryCurrencyCurrenciesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryCurrencyCurrenciesAggregationSelection'] = ResolversParentTypes['CountryCurrencyCurrenciesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CountryCurrencyCurrenciesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryCurrencyCurrenciesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryCurrencyCurrenciesNodeAggregateSelection'] = ResolversParentTypes['CountryCurrencyCurrenciesNodeAggregateSelection']> = {
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryEdge'] = ResolversParentTypes['CountryEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryOrganizationOrganizationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryOrganizationOrganizationsAggregationSelection'] = ResolversParentTypes['CountryOrganizationOrganizationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CountryOrganizationOrganizationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryOrganizationOrganizationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryOrganizationOrganizationsNodeAggregateSelection'] = ResolversParentTypes['CountryOrganizationOrganizationsNodeAggregateSelection']> = {
  BIC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  IBAN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  aggregationPriority?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceThreshold?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactFirstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactLastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactOccupation?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactPhone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderRecurrentStep?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentSftpSavePath?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  domicile?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  dualApprovalThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  eIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  fax?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  legalName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  pharmaId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rebateProcessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  website?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryOrganizationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryOrganizationsConnection'] = ResolversParentTypes['CountryOrganizationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CountryOrganizationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryOrganizationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryOrganizationsRelationship'] = ResolversParentTypes['CountryOrganizationsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryScopeRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryScopeRelationship'] = ResolversParentTypes['CountryScopeRelationship']> = {
  __resolveType: TypeResolveFn<'AgreementScopeCountryScopesRelationship' | 'CountryScopesRelationship', ParentType, ContextType>;
  countryScopeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CountryScopesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryScopesConnection'] = ResolversParentTypes['CountryScopesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CountryScopesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryScopesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryScopesRelationship'] = ResolversParentTypes['CountryScopesRelationship']> = {
  countryScopeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementScope'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryTreatmentTreatmentsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryTreatmentTreatmentsAggregationSelection'] = ResolversParentTypes['CountryTreatmentTreatmentsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CountryTreatmentTreatmentsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryTreatmentTreatmentsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryTreatmentTreatmentsNodeAggregateSelection'] = ResolversParentTypes['CountryTreatmentTreatmentsNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryTreatmentsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryTreatmentsConnection'] = ResolversParentTypes['CountryTreatmentsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CountryTreatmentsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryTreatmentsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryTreatmentsRelationship'] = ResolversParentTypes['CountryTreatmentsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrossCountryPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrossCountryPrice'] = ResolversParentTypes['CrossCountryPrice']> = {
  Price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValidFromDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrossCountryPriceEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrossCountryPriceEdge'] = ResolversParentTypes['CrossCountryPriceEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CrossCountryPrice'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrossCountryPricesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrossCountryPricesConnection'] = ResolversParentTypes['CrossCountryPricesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CrossCountryPriceEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrenciesConnection'] = ResolversParentTypes['CurrenciesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CurrencyEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Currency'] = ResolversParentTypes['Currency']> = {
  Code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agreements?: Resolver<Array<ResolversTypes['Agreement']>, ParentType, ContextType, RequireFields<CurrencyAgreementsArgs, 'directed'>>;
  agreementsAggregate?: Resolver<Maybe<ResolversTypes['CurrencyAgreementAgreementsAggregationSelection']>, ParentType, ContextType, RequireFields<CurrencyAgreementsAggregateArgs, 'directed'>>;
  agreementsConnection?: Resolver<ResolversTypes['CurrencyAgreementsConnection'], ParentType, ContextType, RequireFields<CurrencyAgreementsConnectionArgs, 'directed'>>;
  countries?: Resolver<Array<ResolversTypes['Country']>, ParentType, ContextType, RequireFields<CurrencyCountriesArgs, 'directed'>>;
  countriesAggregate?: Resolver<Maybe<ResolversTypes['CurrencyCountryCountriesAggregationSelection']>, ParentType, ContextType, RequireFields<CurrencyCountriesAggregateArgs, 'directed'>>;
  countriesConnection?: Resolver<ResolversTypes['CurrencyCountriesConnection'], ParentType, ContextType, RequireFields<CurrencyCountriesConnectionArgs, 'directed'>>;
  prices?: Resolver<Array<ResolversTypes['Price']>, ParentType, ContextType, RequireFields<CurrencyPricesArgs, 'directed'>>;
  pricesAggregate?: Resolver<Maybe<ResolversTypes['CurrencyPricePricesAggregationSelection']>, ParentType, ContextType, RequireFields<CurrencyPricesAggregateArgs, 'directed'>>;
  pricesConnection?: Resolver<ResolversTypes['CurrencyPricesConnection'], ParentType, ContextType, RequireFields<CurrencyPricesConnectionArgs, 'directed'>>;
  symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyAgreementAgreementsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyAgreementAgreementsAggregationSelection'] = ResolversParentTypes['CurrencyAgreementAgreementsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CurrencyAgreementAgreementsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyAgreementAgreementsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyAgreementAgreementsNodeAggregateSelection'] = ResolversParentTypes['CurrencyAgreementAgreementsNodeAggregateSelection']> = {
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  daysToExpiry?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  firstExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  formattedAmount?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedCounterparties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedDiseases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedIndications?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedProducts?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  pushedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  reportData?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyAgreementsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyAgreementsConnection'] = ResolversParentTypes['CurrencyAgreementsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CurrencyAgreementsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyAgreementsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyAgreementsRelationship'] = ResolversParentTypes['CurrencyAgreementsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyCountriesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyCountriesConnection'] = ResolversParentTypes['CurrencyCountriesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CurrencyCountriesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyCountriesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyCountriesRelationship'] = ResolversParentTypes['CurrencyCountriesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyCountryCountriesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyCountryCountriesAggregationSelection'] = ResolversParentTypes['CurrencyCountryCountriesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CurrencyCountryCountriesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyCountryCountriesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyCountryCountriesNodeAggregateSelection'] = ResolversParentTypes['CurrencyCountryCountriesNodeAggregateSelection']> = {
  alpha2Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  alpha3Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  numericCode?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyEdge'] = ResolversParentTypes['CurrencyEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyPricePricesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyPricePricesAggregationSelection'] = ResolversParentTypes['CurrencyPricePricesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CurrencyPricePricesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyPricePricesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyPricePricesNodeAggregateSelection'] = ResolversParentTypes['CurrencyPricePricesNodeAggregateSelection']> = {
  Price?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PriceChangeTypeDescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PriceChangeTypeDescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PriceChangeTypeDescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PriceTypeDescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PriceTypeDescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PriceTypeDescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  countriesConsidered?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  uniqueCode?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyPricesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyPricesConnection'] = ResolversParentTypes['CurrencyPricesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CurrencyPricesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyPricesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyPricesRelationship'] = ResolversParentTypes['CurrencyPricesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Price'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomCondition'] = ResolversParentTypes['CustomCondition']> = {
  agreementCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  attribute?: Resolver<ResolversTypes['CatalogueAttribute'], ParentType, ContextType, RequireFields<CustomConditionAttributeArgs, 'directed'>>;
  attributeAggregate?: Resolver<Maybe<ResolversTypes['CustomConditionCatalogueAttributeAttributeAggregationSelection']>, ParentType, ContextType, RequireFields<CustomConditionAttributeAggregateArgs, 'directed'>>;
  attributeConnection?: Resolver<ResolversTypes['CustomConditionAttributeConnection'], ParentType, ContextType, RequireFields<CustomConditionAttributeConnectionArgs, 'directed'>>;
  conditionType?: Resolver<ResolversTypes['CustomConditionType'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<CustomConditionCreatedByArgs, 'directed'>>;
  createdByAggregate?: Resolver<Maybe<ResolversTypes['CustomConditionUserCreatedByAggregationSelection']>, ParentType, ContextType, RequireFields<CustomConditionCreatedByAggregateArgs, 'directed'>>;
  createdByConnection?: Resolver<ResolversTypes['CustomConditionCreatedByConnection'], ParentType, ContextType, RequireFields<CustomConditionCreatedByConnectionArgs, 'directed'>>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldType?: Resolver<ResolversTypes['CustomConditionFieldType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modelCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomConditionAttributeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomConditionAttributeConnection'] = ResolversParentTypes['CustomConditionAttributeConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CustomConditionAttributeRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomConditionAttributeRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomConditionAttributeRelationship'] = ResolversParentTypes['CustomConditionAttributeRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CatalogueAttribute'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomConditionCatalogueAttributeAttributeAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomConditionCatalogueAttributeAttributeAggregationSelection'] = ResolversParentTypes['CustomConditionCatalogueAttributeAttributeAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CustomConditionCatalogueAttributeAttributeNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomConditionCatalogueAttributeAttributeNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomConditionCatalogueAttributeAttributeNodeAggregateSelection'] = ResolversParentTypes['CustomConditionCatalogueAttributeAttributeNodeAggregateSelection']> = {
  caption?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  decimalPrecision?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultValue?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  longLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  maxLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  minLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  rules?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  shortLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  values?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomConditionCreatedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomConditionCreatedByConnection'] = ResolversParentTypes['CustomConditionCreatedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CustomConditionCreatedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomConditionCreatedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomConditionCreatedByRelationship'] = ResolversParentTypes['CustomConditionCreatedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomConditionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomConditionEdge'] = ResolversParentTypes['CustomConditionEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CustomCondition'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomConditionUserCreatedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomConditionUserCreatedByAggregationSelection'] = ResolversParentTypes['CustomConditionUserCreatedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CustomConditionUserCreatedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomConditionUserCreatedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomConditionUserCreatedByNodeAggregateSelection'] = ResolversParentTypes['CustomConditionUserCreatedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomConditionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomConditionsConnection'] = ResolversParentTypes['CustomConditionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CustomConditionEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomIntegrityCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomIntegrityCheck'] = ResolversParentTypes['CustomIntegrityCheck']> = {
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  expression?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  typeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomIntegrityCheckEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomIntegrityCheckEdge'] = ResolversParentTypes['CustomIntegrityCheckEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CustomIntegrityCheck'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomIntegrityChecksConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomIntegrityChecksConnection'] = ResolversParentTypes['CustomIntegrityChecksConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CustomIntegrityCheckEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfiguration'] = ResolversParentTypes['CycleConfiguration']> = {
  cycleStartingPoint?: Resolver<ResolversTypes['CycleStartingPoint'], ParentType, ContextType>;
  lengthFrom?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lengthTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recordType?: Resolver<Maybe<ResolversTypes['FlexEntityType']>, ParentType, ContextType, RequireFields<CycleConfigurationRecordTypeArgs, 'directed'>>;
  recordTypeAggregate?: Resolver<Maybe<ResolversTypes['CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection']>, ParentType, ContextType, RequireFields<CycleConfigurationRecordTypeAggregateArgs, 'directed'>>;
  recordTypeConnection?: Resolver<ResolversTypes['CycleConfigurationRecordTypeConnection'], ParentType, ContextType, RequireFields<CycleConfigurationRecordTypeConnectionArgs, 'directed'>>;
  scope?: Resolver<ResolversTypes['AgreementScope'], ParentType, ContextType, RequireFields<CycleConfigurationScopeArgs, 'directed'>>;
  scopeAggregate?: Resolver<Maybe<ResolversTypes['CycleConfigurationAgreementScopeScopeAggregationSelection']>, ParentType, ContextType, RequireFields<CycleConfigurationScopeAggregateArgs, 'directed'>>;
  scopeConnection?: Resolver<ResolversTypes['CycleConfigurationScopeConnection'], ParentType, ContextType, RequireFields<CycleConfigurationScopeConnectionArgs, 'directed'>>;
  startingTreatment?: Resolver<Maybe<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<CycleConfigurationStartingTreatmentArgs, 'directed'>>;
  startingTreatmentAggregate?: Resolver<Maybe<ResolversTypes['CycleConfigurationTreatmentStartingTreatmentAggregationSelection']>, ParentType, ContextType, RequireFields<CycleConfigurationStartingTreatmentAggregateArgs, 'directed'>>;
  startingTreatmentBrand?: Resolver<Maybe<ResolversTypes['Brand']>, ParentType, ContextType, RequireFields<CycleConfigurationStartingTreatmentBrandArgs, 'directed'>>;
  startingTreatmentBrandAggregate?: Resolver<Maybe<ResolversTypes['CycleConfigurationBrandStartingTreatmentBrandAggregationSelection']>, ParentType, ContextType, RequireFields<CycleConfigurationStartingTreatmentBrandAggregateArgs, 'directed'>>;
  startingTreatmentBrandConnection?: Resolver<ResolversTypes['CycleConfigurationStartingTreatmentBrandConnection'], ParentType, ContextType, RequireFields<CycleConfigurationStartingTreatmentBrandConnectionArgs, 'directed'>>;
  startingTreatmentConnection?: Resolver<ResolversTypes['CycleConfigurationStartingTreatmentConnection'], ParentType, ContextType, RequireFields<CycleConfigurationStartingTreatmentConnectionArgs, 'directed'>>;
  startingTreatmentGeneric?: Resolver<Maybe<ResolversTypes['Generic']>, ParentType, ContextType, RequireFields<CycleConfigurationStartingTreatmentGenericArgs, 'directed'>>;
  startingTreatmentGenericAggregate?: Resolver<Maybe<ResolversTypes['CycleConfigurationGenericStartingTreatmentGenericAggregationSelection']>, ParentType, ContextType, RequireFields<CycleConfigurationStartingTreatmentGenericAggregateArgs, 'directed'>>;
  startingTreatmentGenericConnection?: Resolver<ResolversTypes['CycleConfigurationStartingTreatmentGenericConnection'], ParentType, ContextType, RequireFields<CycleConfigurationStartingTreatmentGenericConnectionArgs, 'directed'>>;
  therapies?: Resolver<Array<ResolversTypes['CycleTherapyConfiguration']>, ParentType, ContextType, RequireFields<CycleConfigurationTherapiesArgs, 'directed'>>;
  therapiesAggregate?: Resolver<Maybe<ResolversTypes['CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection']>, ParentType, ContextType, RequireFields<CycleConfigurationTherapiesAggregateArgs, 'directed'>>;
  therapiesConnection?: Resolver<ResolversTypes['CycleConfigurationTherapiesConnection'], ParentType, ContextType, RequireFields<CycleConfigurationTherapiesConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationAgreementScopeScopeAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationAgreementScopeScopeAggregationSelection'] = ResolversParentTypes['CycleConfigurationAgreementScopeScopeAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CycleConfigurationAgreementScopeScopeNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationAgreementScopeScopeNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationAgreementScopeScopeNodeAggregateSelection'] = ResolversParentTypes['CycleConfigurationAgreementScopeScopeNodeAggregateSelection']> = {
  code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  scopeId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationBrandStartingTreatmentBrandAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationBrandStartingTreatmentBrandAggregationSelection'] = ResolversParentTypes['CycleConfigurationBrandStartingTreatmentBrandAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection'] = ResolversParentTypes['CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  art71DataLastUpdatedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  art71DataLastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection'] = ResolversParentTypes['CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection'] = ResolversParentTypes['CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection']> = {
  cycleToleranceFrom?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  cycleToleranceTo?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  dosageFrom?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  dosageTo?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  packQuantityFrom?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  packQuantityTo?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  recordGapFrom?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  recordGapTo?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  recordQuantityFrom?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  recordQuantityTo?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationEdge'] = ResolversParentTypes['CycleConfigurationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CycleConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationFlexEntityTypeRecordTypeAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection'] = ResolversParentTypes['CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection'] = ResolversParentTypes['CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  attributeCount?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  idPrefix?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  localizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  tooltipText?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationGenericStartingTreatmentGenericAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationGenericStartingTreatmentGenericAggregationSelection'] = ResolversParentTypes['CycleConfigurationGenericStartingTreatmentGenericAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection'] = ResolversParentTypes['CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationRecordTypeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationRecordTypeConnection'] = ResolversParentTypes['CycleConfigurationRecordTypeConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CycleConfigurationRecordTypeRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationRecordTypeRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationRecordTypeRelationship'] = ResolversParentTypes['CycleConfigurationRecordTypeRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntityType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationScopeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationScopeConnection'] = ResolversParentTypes['CycleConfigurationScopeConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CycleConfigurationScopeRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationScopeRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationScopeRelationship'] = ResolversParentTypes['CycleConfigurationScopeRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementScope'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationStartingTreatmentBrandConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationStartingTreatmentBrandConnection'] = ResolversParentTypes['CycleConfigurationStartingTreatmentBrandConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CycleConfigurationStartingTreatmentBrandRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationStartingTreatmentBrandRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationStartingTreatmentBrandRelationship'] = ResolversParentTypes['CycleConfigurationStartingTreatmentBrandRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Brand'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationStartingTreatmentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationStartingTreatmentConnection'] = ResolversParentTypes['CycleConfigurationStartingTreatmentConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CycleConfigurationStartingTreatmentRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationStartingTreatmentGenericConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationStartingTreatmentGenericConnection'] = ResolversParentTypes['CycleConfigurationStartingTreatmentGenericConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CycleConfigurationStartingTreatmentGenericRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationStartingTreatmentGenericRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationStartingTreatmentGenericRelationship'] = ResolversParentTypes['CycleConfigurationStartingTreatmentGenericRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Generic'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationStartingTreatmentRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationStartingTreatmentRelationship'] = ResolversParentTypes['CycleConfigurationStartingTreatmentRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationTherapiesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationTherapiesConnection'] = ResolversParentTypes['CycleConfigurationTherapiesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CycleConfigurationTherapiesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationTherapiesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationTherapiesRelationship'] = ResolversParentTypes['CycleConfigurationTherapiesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CycleTherapyConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationTreatmentStartingTreatmentAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationTreatmentStartingTreatmentAggregationSelection'] = ResolversParentTypes['CycleConfigurationTreatmentStartingTreatmentAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection'] = ResolversParentTypes['CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleConfigurationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleConfigurationsConnection'] = ResolversParentTypes['CycleConfigurationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CycleConfigurationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleTherapyConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleTherapyConfiguration'] = ResolversParentTypes['CycleTherapyConfiguration']> = {
  cycleToleranceFrom?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cycleToleranceTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dosageFrom?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dosageTo?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  expectedDays?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  packQuantityFrom?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  packQuantityTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recordGapFrom?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recordGapTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recordQuantityFrom?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recordQuantityTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  treatmentSet?: Resolver<ResolversTypes['TreatmentSet'], ParentType, ContextType, RequireFields<CycleTherapyConfigurationTreatmentSetArgs, 'directed'>>;
  treatmentSetAggregate?: Resolver<Maybe<ResolversTypes['CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection']>, ParentType, ContextType, RequireFields<CycleTherapyConfigurationTreatmentSetAggregateArgs, 'directed'>>;
  treatmentSetConnection?: Resolver<ResolversTypes['CycleTherapyConfigurationTreatmentSetConnection'], ParentType, ContextType, RequireFields<CycleTherapyConfigurationTreatmentSetConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleTherapyConfigurationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleTherapyConfigurationEdge'] = ResolversParentTypes['CycleTherapyConfigurationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CycleTherapyConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleTherapyConfigurationTreatmentSetConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleTherapyConfigurationTreatmentSetConnection'] = ResolversParentTypes['CycleTherapyConfigurationTreatmentSetConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CycleTherapyConfigurationTreatmentSetRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleTherapyConfigurationTreatmentSetRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleTherapyConfigurationTreatmentSetRelationship'] = ResolversParentTypes['CycleTherapyConfigurationTreatmentSetRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TreatmentSet'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection'] = ResolversParentTypes['CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection'] = ResolversParentTypes['CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection']> = {
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CycleTherapyConfigurationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CycleTherapyConfigurationsConnection'] = ResolversParentTypes['CycleTherapyConfigurationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CycleTherapyConfigurationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DqcDetailedReportRawResolvers<ContextType = any, ParentType extends ResolversParentTypes['DQCDetailedReportRaw'] = ResolversParentTypes['DQCDetailedReportRaw']> = {
  checkKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  entityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DqcDetailedReportRawEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DQCDetailedReportRawEdge'] = ResolversParentTypes['DQCDetailedReportRawEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DQCDetailedReportRaw'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataContainerResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataContainer'] = ResolversParentTypes['DataContainer']> = {
  creationWays?: Resolver<Maybe<Array<ResolversTypes['DataContainerCreationWay']>>, ParentType, ContextType>;
  isStartingPoint?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  providers?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType, RequireFields<DataContainerProvidersArgs, 'directed'>>;
  providersAggregate?: Resolver<Maybe<ResolversTypes['DataContainerOrganizationProvidersAggregationSelection']>, ParentType, ContextType, RequireFields<DataContainerProvidersAggregateArgs, 'directed'>>;
  providersConnection?: Resolver<ResolversTypes['DataContainerProvidersConnection'], ParentType, ContextType, RequireFields<DataContainerProvidersConnectionArgs, 'directed'>>;
  restrictedDataPointNames?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  sharedDataPointNames?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  sharingTrigger?: Resolver<ResolversTypes['DataContainerSharingTrigger'], ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeframeEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeframeRangeType?: Resolver<Maybe<ResolversTypes['TimeframeRangeType']>, ParentType, ContextType>;
  timeframeStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeframeStartingPoint?: Resolver<Maybe<ResolversTypes['TimeframeStartingPoint']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DataContainerType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataContainerEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataContainerEdge'] = ResolversParentTypes['DataContainerEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DataContainer'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataContainerOrganizationProvidersAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataContainerOrganizationProvidersAggregationSelection'] = ResolversParentTypes['DataContainerOrganizationProvidersAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DataContainerOrganizationProvidersNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataContainerOrganizationProvidersNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataContainerOrganizationProvidersNodeAggregateSelection'] = ResolversParentTypes['DataContainerOrganizationProvidersNodeAggregateSelection']> = {
  BIC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  IBAN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  aggregationPriority?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceThreshold?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactFirstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactLastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactOccupation?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactPhone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderRecurrentStep?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentSftpSavePath?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  domicile?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  dualApprovalThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  eIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  fax?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  legalName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  pharmaId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rebateProcessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  website?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataContainerProvidersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataContainerProvidersConnection'] = ResolversParentTypes['DataContainerProvidersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DataContainerProvidersRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataContainerProvidersRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataContainerProvidersRelationship'] = ResolversParentTypes['DataContainerProvidersRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataContainersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataContainersConnection'] = ResolversParentTypes['DataContainersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DataContainerEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataSourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataSource'] = ResolversParentTypes['DataSource']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataSourceEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataSourceEdge'] = ResolversParentTypes['DataSourceEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DataSource'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataSourcesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataSourcesConnection'] = ResolversParentTypes['DataSourcesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DataSourceEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DateTimeAggregateSelectionNonNullableResolvers<ContextType = any, ParentType extends ResolversParentTypes['DateTimeAggregateSelectionNonNullable'] = ResolversParentTypes['DateTimeAggregateSelectionNonNullable']> = {
  max?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  min?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DateTimeAggregateSelectionNullableResolvers<ContextType = any, ParentType extends ResolversParentTypes['DateTimeAggregateSelectionNullable'] = ResolversParentTypes['DateTimeAggregateSelectionNullable']> = {
  max?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DefaultAgreementRoleInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['DefaultAgreementRoleInfo'] = ResolversParentTypes['DefaultAgreementRoleInfo']> = {
  caseAssignee?: Resolver<Maybe<ResolversTypes['AssigneeStatus']>, ParentType, ContextType>;
  documentAssignee?: Resolver<Maybe<ResolversTypes['AssigneeStatus']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAgreementAssignee?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['AgreementUserRole'], ParentType, ContextType>;
  tagName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tagType?: Resolver<ResolversTypes['AgreementTagType'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DefaultAgreementRoleInfoEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DefaultAgreementRoleInfoEdge'] = ResolversParentTypes['DefaultAgreementRoleInfoEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DefaultAgreementRoleInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DefaultAgreementRoleInfosConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DefaultAgreementRoleInfosConnection'] = ResolversParentTypes['DefaultAgreementRoleInfosConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DefaultAgreementRoleInfoEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DefaultReceiverPropertiesResolvers<ContextType = any, ParentType extends ResolversParentTypes['DefaultReceiverProperties'] = ResolversParentTypes['DefaultReceiverProperties']> = {
  __resolveType: TypeResolveFn<'OrganizationDefaultReceiversRelationship', ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notificationId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tagType?: Resolver<ResolversTypes['AgreementTagType'], ParentType, ContextType>;
};

export type DependencyAttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DependencyAttribute'] = ResolversParentTypes['DependencyAttribute']> = {
  __resolveType: TypeResolveFn<'CatalogueAttributeDependsOnRelationship' | 'CatalogueAttributeHasDependantRelationship' | 'CatalogueAttributeMutuallyRelevantRelationship', ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rules?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DeviceAlternativeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceAlternative'] = ResolversParentTypes['DeviceAlternative']> = {
  alternatives?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<DeviceAlternativeAlternativesArgs, 'directed'>>;
  alternativesAggregate?: Resolver<Maybe<ResolversTypes['DeviceAlternativeTreatmentAlternativesAggregationSelection']>, ParentType, ContextType, RequireFields<DeviceAlternativeAlternativesAggregateArgs, 'directed'>>;
  alternativesConnection?: Resolver<ResolversTypes['DeviceAlternativeAlternativesConnection'], ParentType, ContextType, RequireFields<DeviceAlternativeAlternativesConnectionArgs, 'directed'>>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceProduct?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType, RequireFields<DeviceAlternativeDeviceProductArgs, 'directed'>>;
  deviceProductAggregate?: Resolver<Maybe<ResolversTypes['DeviceAlternativeTreatmentDeviceProductAggregationSelection']>, ParentType, ContextType, RequireFields<DeviceAlternativeDeviceProductAggregateArgs, 'directed'>>;
  deviceProductConnection?: Resolver<ResolversTypes['DeviceAlternativeDeviceProductConnection'], ParentType, ContextType, RequireFields<DeviceAlternativeDeviceProductConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeAlternativesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceAlternativeAlternativesConnection'] = ResolversParentTypes['DeviceAlternativeAlternativesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DeviceAlternativeAlternativesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeAlternativesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceAlternativeAlternativesRelationship'] = ResolversParentTypes['DeviceAlternativeAlternativesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeDeviceProductConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceAlternativeDeviceProductConnection'] = ResolversParentTypes['DeviceAlternativeDeviceProductConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DeviceAlternativeDeviceProductRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeDeviceProductRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceAlternativeDeviceProductRelationship'] = ResolversParentTypes['DeviceAlternativeDeviceProductRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceAlternativeEdge'] = ResolversParentTypes['DeviceAlternativeEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DeviceAlternative'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeTreatmentAlternativesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceAlternativeTreatmentAlternativesAggregationSelection'] = ResolversParentTypes['DeviceAlternativeTreatmentAlternativesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DeviceAlternativeTreatmentAlternativesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeTreatmentAlternativesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceAlternativeTreatmentAlternativesNodeAggregateSelection'] = ResolversParentTypes['DeviceAlternativeTreatmentAlternativesNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeTreatmentDeviceProductAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceAlternativeTreatmentDeviceProductAggregationSelection'] = ResolversParentTypes['DeviceAlternativeTreatmentDeviceProductAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativeTreatmentDeviceProductNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection'] = ResolversParentTypes['DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceAlternativesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceAlternativesConnection'] = ResolversParentTypes['DeviceAlternativesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DeviceAlternativeEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisabledDataCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisabledDataCheck'] = ResolversParentTypes['DisabledDataCheck']> = {
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisabledDataCheckEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisabledDataCheckEdge'] = ResolversParentTypes['DisabledDataCheckEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DisabledDataCheck'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisabledDataChecksConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisabledDataChecksConnection'] = ResolversParentTypes['DisabledDataChecksConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DisabledDataCheckEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiseaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Disease'] = ResolversParentTypes['Disease']> = {
  Icd10Code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiseaseEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiseaseEdge'] = ResolversParentTypes['DiseaseEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Disease'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiseasesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiseasesConnection'] = ResolversParentTypes['DiseasesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DiseaseEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Document'] = ResolversParentTypes['Document']> = {
  counterParties?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coveragePeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  documentRefundGroups?: Resolver<Array<ResolversTypes['DocumentRefundGroup']>, ParentType, ContextType, RequireFields<DocumentDocumentRefundGroupsArgs, 'directed'>>;
  documentRefundGroupsAggregate?: Resolver<Maybe<ResolversTypes['DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection']>, ParentType, ContextType, RequireFields<DocumentDocumentRefundGroupsAggregateArgs, 'directed'>>;
  documentRefundGroupsConnection?: Resolver<ResolversTypes['DocumentDocumentRefundGroupsConnection'], ParentType, ContextType, RequireFields<DocumentDocumentRefundGroupsConnectionArgs, 'directed'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isConfirmedBySeller?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSentToSmartMip?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  issuedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastUpdatedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  refunds?: Resolver<Array<ResolversTypes['Refund']>, ParentType, ContextType, RequireFields<DocumentRefundsArgs, 'directed'>>;
  refundsAggregate?: Resolver<Maybe<ResolversTypes['DocumentRefundRefundsAggregationSelection']>, ParentType, ContextType, RequireFields<DocumentRefundsAggregateArgs, 'directed'>>;
  refundsConnection?: Resolver<ResolversTypes['DocumentRefundsConnection'], ParentType, ContextType, RequireFields<DocumentRefundsConnectionArgs, 'directed'>>;
  settledOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['DocumentStatus']>, ParentType, ContextType>;
  tenantIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['DocumentType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection'] = ResolversParentTypes['DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection'] = ResolversParentTypes['DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection']> = {
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentDocumentRefundGroupsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentDocumentRefundGroupsConnection'] = ResolversParentTypes['DocumentDocumentRefundGroupsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DocumentDocumentRefundGroupsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentDocumentRefundGroupsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentDocumentRefundGroupsRelationship'] = ResolversParentTypes['DocumentDocumentRefundGroupsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DocumentRefundGroup'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentEdge'] = ResolversParentTypes['DocumentEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Document'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundFinancialDataPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundFinancialDataPoint'] = ResolversParentTypes['DocumentRefundFinancialDataPoint']> = {
  __resolveType: TypeResolveFn<'RefundDocumentFinancialDataPointRelationship', ParentType, ContextType>;
  connectionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['FinancialDataPointStatus']>, ParentType, ContextType>;
};

export type DocumentRefundGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroup'] = ResolversParentTypes['DocumentRefundGroup']> = {
  agreement?: Resolver<Maybe<ResolversTypes['Agreement']>, ParentType, ContextType, RequireFields<DocumentRefundGroupAgreementArgs, 'directed'>>;
  agreementAggregate?: Resolver<Maybe<ResolversTypes['DocumentRefundGroupAgreementAgreementAggregationSelection']>, ParentType, ContextType, RequireFields<DocumentRefundGroupAgreementAggregateArgs, 'directed'>>;
  agreementConnection?: Resolver<ResolversTypes['DocumentRefundGroupAgreementConnection'], ParentType, ContextType, RequireFields<DocumentRefundGroupAgreementConnectionArgs, 'directed'>>;
  case?: Resolver<Maybe<ResolversTypes['Case']>, ParentType, ContextType, RequireFields<DocumentRefundGroupCaseArgs, 'directed'>>;
  caseAggregate?: Resolver<Maybe<ResolversTypes['DocumentRefundGroupCaseCaseAggregationSelection']>, ParentType, ContextType, RequireFields<DocumentRefundGroupCaseAggregateArgs, 'directed'>>;
  caseConnection?: Resolver<ResolversTypes['DocumentRefundGroupCaseConnection'], ParentType, ContextType, RequireFields<DocumentRefundGroupCaseConnectionArgs, 'directed'>>;
  document?: Resolver<ResolversTypes['Document'], ParentType, ContextType, RequireFields<DocumentRefundGroupDocumentArgs, 'directed'>>;
  documentAggregate?: Resolver<Maybe<ResolversTypes['DocumentRefundGroupDocumentDocumentAggregationSelection']>, ParentType, ContextType, RequireFields<DocumentRefundGroupDocumentAggregateArgs, 'directed'>>;
  documentConnection?: Resolver<ResolversTypes['DocumentRefundGroupDocumentConnection'], ParentType, ContextType, RequireFields<DocumentRefundGroupDocumentConnectionArgs, 'directed'>>;
  documentStatus?: Resolver<Maybe<ResolversTypes['DocumentStatus']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<DocumentRefundGroupMessageArgs, 'directed'>>;
  messageAggregate?: Resolver<Maybe<ResolversTypes['DocumentRefundGroupMessageMessageAggregationSelection']>, ParentType, ContextType, RequireFields<DocumentRefundGroupMessageAggregateArgs, 'directed'>>;
  messageConnection?: Resolver<ResolversTypes['DocumentRefundGroupMessageConnection'], ParentType, ContextType, RequireFields<DocumentRefundGroupMessageConnectionArgs, 'directed'>>;
  messageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refunds?: Resolver<Array<ResolversTypes['Refund']>, ParentType, ContextType, RequireFields<DocumentRefundGroupRefundsArgs, 'directed'>>;
  refundsAggregate?: Resolver<Maybe<ResolversTypes['DocumentRefundGroupRefundRefundsAggregationSelection']>, ParentType, ContextType, RequireFields<DocumentRefundGroupRefundsAggregateArgs, 'directed'>>;
  refundsConnection?: Resolver<ResolversTypes['DocumentRefundGroupRefundsConnection'], ParentType, ContextType, RequireFields<DocumentRefundGroupRefundsConnectionArgs, 'directed'>>;
  tenantIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  threadMessageCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupAgreementAgreementAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupAgreementAgreementAggregationSelection'] = ResolversParentTypes['DocumentRefundGroupAgreementAgreementAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DocumentRefundGroupAgreementAgreementNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupAgreementAgreementNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupAgreementAgreementNodeAggregateSelection'] = ResolversParentTypes['DocumentRefundGroupAgreementAgreementNodeAggregateSelection']> = {
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  daysToExpiry?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  firstExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  formattedAmount?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedCounterparties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedDiseases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedIndications?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedProducts?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  pushedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  reportData?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupAgreementConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupAgreementConnection'] = ResolversParentTypes['DocumentRefundGroupAgreementConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DocumentRefundGroupAgreementRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupAgreementRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupAgreementRelationship'] = ResolversParentTypes['DocumentRefundGroupAgreementRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupCaseCaseAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupCaseCaseAggregationSelection'] = ResolversParentTypes['DocumentRefundGroupCaseCaseAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DocumentRefundGroupCaseCaseNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupCaseCaseNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupCaseCaseNodeAggregateSelection'] = ResolversParentTypes['DocumentRefundGroupCaseCaseNodeAggregateSelection']> = {
  creationDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  preparationBrandName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  submissionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupCaseConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupCaseConnection'] = ResolversParentTypes['DocumentRefundGroupCaseConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DocumentRefundGroupCaseRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupCaseRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupCaseRelationship'] = ResolversParentTypes['DocumentRefundGroupCaseRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Case'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupDocumentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupDocumentConnection'] = ResolversParentTypes['DocumentRefundGroupDocumentConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DocumentRefundGroupDocumentRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupDocumentDocumentAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupDocumentDocumentAggregationSelection'] = ResolversParentTypes['DocumentRefundGroupDocumentDocumentAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DocumentRefundGroupDocumentDocumentNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupDocumentDocumentNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupDocumentDocumentNodeAggregateSelection'] = ResolversParentTypes['DocumentRefundGroupDocumentDocumentNodeAggregateSelection']> = {
  counterParties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  coveragePeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  issuedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupDocumentRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupDocumentRelationship'] = ResolversParentTypes['DocumentRefundGroupDocumentRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Document'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupEdge'] = ResolversParentTypes['DocumentRefundGroupEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DocumentRefundGroup'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupMessageConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupMessageConnection'] = ResolversParentTypes['DocumentRefundGroupMessageConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DocumentRefundGroupMessageRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupMessageMessageAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupMessageMessageAggregationSelection'] = ResolversParentTypes['DocumentRefundGroupMessageMessageAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DocumentRefundGroupMessageMessageNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupMessageMessageNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupMessageMessageNodeAggregateSelection'] = ResolversParentTypes['DocumentRefundGroupMessageMessageNodeAggregateSelection']> = {
  content?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupMessageRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupMessageRelationship'] = ResolversParentTypes['DocumentRefundGroupMessageRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Message'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupRefundRefundsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupRefundRefundsAggregationSelection'] = ResolversParentTypes['DocumentRefundGroupRefundRefundsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DocumentRefundGroupRefundRefundsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupRefundRefundsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupRefundRefundsNodeAggregateSelection'] = ResolversParentTypes['DocumentRefundGroupRefundRefundsNodeAggregateSelection']> = {
  agreementId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  caseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  caseOrAgreementId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupRefundsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupRefundsConnection'] = ResolversParentTypes['DocumentRefundGroupRefundsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DocumentRefundGroupRefundsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupRefundsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupRefundsRelationship'] = ResolversParentTypes['DocumentRefundGroupRefundsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Refund'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundGroupsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundGroupsConnection'] = ResolversParentTypes['DocumentRefundGroupsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DocumentRefundGroupEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundRefundsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundRefundsAggregationSelection'] = ResolversParentTypes['DocumentRefundRefundsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DocumentRefundRefundsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundRefundsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundRefundsNodeAggregateSelection'] = ResolversParentTypes['DocumentRefundRefundsNodeAggregateSelection']> = {
  agreementId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  caseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  caseOrAgreementId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundsConnection'] = ResolversParentTypes['DocumentRefundsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DocumentRefundsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentRefundsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentRefundsRelationship'] = ResolversParentTypes['DocumentRefundsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Refund'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentsConnection'] = ResolversParentTypes['DocumentsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DocumentEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainResolvers<ContextType = any, ParentType extends ResolversParentTypes['Domain'] = ResolversParentTypes['Domain']> = {
  children?: Resolver<Array<ResolversTypes['Domain']>, ParentType, ContextType, RequireFields<DomainChildrenArgs, 'directed'>>;
  childrenAggregate?: Resolver<Maybe<ResolversTypes['DomainDomainChildrenAggregationSelection']>, ParentType, ContextType, RequireFields<DomainChildrenAggregateArgs, 'directed'>>;
  childrenConnection?: Resolver<ResolversTypes['DomainChildrenConnection'], ParentType, ContextType, RequireFields<DomainChildrenConnectionArgs, 'directed'>>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<DomainCreatedByArgs, 'directed'>>;
  createdByAggregate?: Resolver<Maybe<ResolversTypes['DomainUserCreatedByAggregationSelection']>, ParentType, ContextType, RequireFields<DomainCreatedByAggregateArgs, 'directed'>>;
  createdByConnection?: Resolver<ResolversTypes['DomainCreatedByConnection'], ParentType, ContextType, RequireFields<DomainCreatedByConnectionArgs, 'directed'>>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedByEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['Domain']>, ParentType, ContextType, RequireFields<DomainParentArgs, 'directed'>>;
  parentAggregate?: Resolver<Maybe<ResolversTypes['DomainDomainParentAggregationSelection']>, ParentType, ContextType, RequireFields<DomainParentAggregateArgs, 'directed'>>;
  parentConnection?: Resolver<ResolversTypes['DomainParentConnection'], ParentType, ContextType, RequireFields<DomainParentConnectionArgs, 'directed'>>;
  productBlueprint?: Resolver<Array<ResolversTypes['ProductBlueprint']>, ParentType, ContextType, RequireFields<DomainProductBlueprintArgs, 'directed'>>;
  productBlueprintAggregate?: Resolver<Maybe<ResolversTypes['DomainProductBlueprintProductBlueprintAggregationSelection']>, ParentType, ContextType, RequireFields<DomainProductBlueprintAggregateArgs, 'directed'>>;
  productBlueprintConnection?: Resolver<ResolversTypes['DomainProductBlueprintConnection'], ParentType, ContextType, RequireFields<DomainProductBlueprintConnectionArgs, 'directed'>>;
  simulationCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  simulations?: Resolver<Array<ResolversTypes['Simulation']>, ParentType, ContextType, RequireFields<DomainSimulationsArgs, 'directed'>>;
  simulationsAggregate?: Resolver<Maybe<ResolversTypes['DomainSimulationSimulationsAggregationSelection']>, ParentType, ContextType, RequireFields<DomainSimulationsAggregateArgs, 'directed'>>;
  simulationsConnection?: Resolver<ResolversTypes['DomainSimulationsConnection'], ParentType, ContextType, RequireFields<DomainSimulationsConnectionArgs, 'directed'>>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<DomainUsersArgs, 'directed'>>;
  usersAggregate?: Resolver<Maybe<ResolversTypes['DomainUserUsersAggregationSelection']>, ParentType, ContextType, RequireFields<DomainUsersAggregateArgs, 'directed'>>;
  usersConnection?: Resolver<ResolversTypes['DomainUsersConnection'], ParentType, ContextType, RequireFields<DomainUsersConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainChildrenConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainChildrenConnection'] = ResolversParentTypes['DomainChildrenConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DomainChildrenRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainChildrenRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainChildrenRelationship'] = ResolversParentTypes['DomainChildrenRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Domain'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainCreatedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainCreatedByConnection'] = ResolversParentTypes['DomainCreatedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DomainCreatedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainCreatedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainCreatedByRelationship'] = ResolversParentTypes['DomainCreatedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainDomainChildrenAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainDomainChildrenAggregationSelection'] = ResolversParentTypes['DomainDomainChildrenAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DomainDomainChildrenNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainDomainChildrenNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainDomainChildrenNodeAggregateSelection'] = ResolversParentTypes['DomainDomainChildrenNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  deletedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  deletedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainDomainParentAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainDomainParentAggregationSelection'] = ResolversParentTypes['DomainDomainParentAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DomainDomainParentNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainDomainParentNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainDomainParentNodeAggregateSelection'] = ResolversParentTypes['DomainDomainParentNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  deletedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  deletedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainEdge'] = ResolversParentTypes['DomainEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Domain'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainParentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainParentConnection'] = ResolversParentTypes['DomainParentConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DomainParentRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainParentRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainParentRelationship'] = ResolversParentTypes['DomainParentRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Domain'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainProductBlueprintConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainProductBlueprintConnection'] = ResolversParentTypes['DomainProductBlueprintConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DomainProductBlueprintRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainProductBlueprintProductBlueprintAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainProductBlueprintProductBlueprintAggregationSelection'] = ResolversParentTypes['DomainProductBlueprintProductBlueprintAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DomainProductBlueprintProductBlueprintNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainProductBlueprintProductBlueprintNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainProductBlueprintProductBlueprintNodeAggregateSelection'] = ResolversParentTypes['DomainProductBlueprintProductBlueprintNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  addedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  formValues?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  indication?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  indications?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  productName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  publishedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  updatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainProductBlueprintRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainProductBlueprintRelationship'] = ResolversParentTypes['DomainProductBlueprintRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProductBlueprint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainSimulationSimulationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainSimulationSimulationsAggregationSelection'] = ResolversParentTypes['DomainSimulationSimulationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DomainSimulationSimulationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainSimulationSimulationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainSimulationSimulationsNodeAggregateSelection'] = ResolversParentTypes['DomainSimulationSimulationsNodeAggregateSelection']> = {
  businessCase?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  comments?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  counterparty?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  deletedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  deletedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  domainName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedContent?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  indications?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  lockedSections?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  shortName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainSimulationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainSimulationsConnection'] = ResolversParentTypes['DomainSimulationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DomainSimulationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainSimulationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainSimulationsRelationship'] = ResolversParentTypes['DomainSimulationsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Simulation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainUserCreatedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainUserCreatedByAggregationSelection'] = ResolversParentTypes['DomainUserCreatedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DomainUserCreatedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainUserCreatedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainUserCreatedByNodeAggregateSelection'] = ResolversParentTypes['DomainUserCreatedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainUserUsersAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainUserUsersAggregationSelection'] = ResolversParentTypes['DomainUserUsersAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['DomainUserUsersNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainUserUsersNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainUserUsersNodeAggregateSelection'] = ResolversParentTypes['DomainUserUsersNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainUsersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainUsersConnection'] = ResolversParentTypes['DomainUsersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DomainUsersRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainUsersRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainUsersRelationship'] = ResolversParentTypes['DomainUsersRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainsConnection'] = ResolversParentTypes['DomainsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DomainEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DqcDetailedReportRawsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DqcDetailedReportRawsConnection'] = ResolversParentTypes['DqcDetailedReportRawsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DQCDetailedReportRawEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DummyEnumReferencesResolvers<ContextType = any, ParentType extends ResolversParentTypes['DummyEnumReferences'] = ResolversParentTypes['DummyEnumReferences']> = {
  adverseEventGrades?: Resolver<Maybe<ResolversTypes['AdverseEventGrades']>, ParentType, ContextType>;
  canadianPriceType?: Resolver<Maybe<ResolversTypes['CanadianPriceType']>, ParentType, ContextType>;
  cycleAdherence?: Resolver<Maybe<ResolversTypes['CycleAdherence']>, ParentType, ContextType>;
  cycleStartingPoint?: Resolver<Maybe<ResolversTypes['CycleStartingPoint']>, ParentType, ContextType>;
  decision?: Resolver<Maybe<ResolversTypes['CoverageRequestTherapyDecision']>, ParentType, ContextType>;
  ldlTestUom?: Resolver<Maybe<ResolversTypes['LdlTestUom']>, ParentType, ContextType>;
  pathologicalResponse?: Resolver<Maybe<ResolversTypes['PathologicalResponseType']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['CoverageRequestRating']>, ParentType, ContextType>;
  response?: Resolver<Maybe<ResolversTypes['ResponseType']>, ParentType, ContextType>;
  responseType?: Resolver<Maybe<ResolversTypes['ResponseType']>, ParentType, ContextType>;
  scopeId?: Resolver<Maybe<ResolversTypes['ScopeId']>, ParentType, ContextType>;
  testPurposeType?: Resolver<Maybe<ResolversTypes['TestPurposeType']>, ParentType, ContextType>;
  testType?: Resolver<Maybe<ResolversTypes['TestType']>, ParentType, ContextType>;
  testUoMType?: Resolver<Maybe<ResolversTypes['TestUoMType']>, ParentType, ContextType>;
  transfusionType?: Resolver<Maybe<ResolversTypes['TransfusionType']>, ParentType, ContextType>;
  unitedResponseType?: Resolver<Maybe<ResolversTypes['UnitedResponseType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DummyEnumReferencesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DummyEnumReferencesConnection'] = ResolversParentTypes['DummyEnumReferencesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DummyEnumReferencesEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DummyEnumReferencesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DummyEnumReferencesEdge'] = ResolversParentTypes['DummyEnumReferencesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DummyEnumReferences'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityConditionSetResolvers<ContextType = any, ParentType extends ResolversParentTypes['EligibilityConditionSet'] = ResolversParentTypes['EligibilityConditionSet']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inputLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  treatments?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<EligibilityConditionSetTreatmentsArgs, 'directed'>>;
  treatmentsAggregate?: Resolver<Maybe<ResolversTypes['EligibilityConditionSetTreatmentTreatmentsAggregationSelection']>, ParentType, ContextType, RequireFields<EligibilityConditionSetTreatmentsAggregateArgs, 'directed'>>;
  treatmentsConnection?: Resolver<ResolversTypes['EligibilityConditionSetTreatmentsConnection'], ParentType, ContextType, RequireFields<EligibilityConditionSetTreatmentsConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityConditionSetEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EligibilityConditionSetEdge'] = ResolversParentTypes['EligibilityConditionSetEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EligibilityConditionSet'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityConditionSetTreatmentTreatmentsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EligibilityConditionSetTreatmentTreatmentsAggregationSelection'] = ResolversParentTypes['EligibilityConditionSetTreatmentTreatmentsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection'] = ResolversParentTypes['EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityConditionSetTreatmentsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EligibilityConditionSetTreatmentsConnection'] = ResolversParentTypes['EligibilityConditionSetTreatmentsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EligibilityConditionSetTreatmentsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityConditionSetTreatmentsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['EligibilityConditionSetTreatmentsRelationship'] = ResolversParentTypes['EligibilityConditionSetTreatmentsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EligibilityConditionSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EligibilityConditionSetsConnection'] = ResolversParentTypes['EligibilityConditionSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EligibilityConditionSetEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeature'] = ResolversParentTypes['EncapsulatedFeature']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeatureConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeatureConfiguration'] = ResolversParentTypes['EncapsulatedFeatureConfiguration']> = {
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ofType?: Resolver<ResolversTypes['EncapsulatedFeature'], ParentType, ContextType, RequireFields<EncapsulatedFeatureConfigurationOfTypeArgs, 'directed'>>;
  ofTypeAggregate?: Resolver<Maybe<ResolversTypes['EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection']>, ParentType, ContextType, RequireFields<EncapsulatedFeatureConfigurationOfTypeAggregateArgs, 'directed'>>;
  ofTypeConnection?: Resolver<ResolversTypes['EncapsulatedFeatureConfigurationOfTypeConnection'], ParentType, ContextType, RequireFields<EncapsulatedFeatureConfigurationOfTypeConnectionArgs, 'directed'>>;
  setFor?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<EncapsulatedFeatureConfigurationSetForArgs, 'directed'>>;
  setForAggregate?: Resolver<Maybe<ResolversTypes['EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection']>, ParentType, ContextType, RequireFields<EncapsulatedFeatureConfigurationSetForAggregateArgs, 'directed'>>;
  setForConnection?: Resolver<ResolversTypes['EncapsulatedFeatureConfigurationSetForConnection'], ParentType, ContextType, RequireFields<EncapsulatedFeatureConfigurationSetForConnectionArgs, 'directed'>>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeatureConfigurationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeatureConfigurationEdge'] = ResolversParentTypes['EncapsulatedFeatureConfigurationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EncapsulatedFeatureConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection'] = ResolversParentTypes['EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection'] = ResolversParentTypes['EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection']> = {
  key?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeatureConfigurationOfTypeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeatureConfigurationOfTypeConnection'] = ResolversParentTypes['EncapsulatedFeatureConfigurationOfTypeConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EncapsulatedFeatureConfigurationOfTypeRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeatureConfigurationOfTypeRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeatureConfigurationOfTypeRelationship'] = ResolversParentTypes['EncapsulatedFeatureConfigurationOfTypeRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EncapsulatedFeature'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection'] = ResolversParentTypes['EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection'] = ResolversParentTypes['EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection']> = {
  BIC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  IBAN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  aggregationPriority?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceThreshold?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactFirstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactLastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactOccupation?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactPhone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderRecurrentStep?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentSftpSavePath?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  domicile?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  dualApprovalThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  eIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  fax?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  legalName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  pharmaId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rebateProcessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  website?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeatureConfigurationSetForConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeatureConfigurationSetForConnection'] = ResolversParentTypes['EncapsulatedFeatureConfigurationSetForConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EncapsulatedFeatureConfigurationSetForRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeatureConfigurationSetForRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeatureConfigurationSetForRelationship'] = ResolversParentTypes['EncapsulatedFeatureConfigurationSetForRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeatureConfigurationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeatureConfigurationsConnection'] = ResolversParentTypes['EncapsulatedFeatureConfigurationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EncapsulatedFeatureConfigurationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeatureEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeatureEdge'] = ResolversParentTypes['EncapsulatedFeatureEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EncapsulatedFeature'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EncapsulatedFeaturesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EncapsulatedFeaturesConnection'] = ResolversParentTypes['EncapsulatedFeaturesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EncapsulatedFeatureEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingCondition'] = ResolversParentTypes['EnrollingCondition']> = {
  attributeValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bothOperatorFirst?: Resolver<Maybe<ResolversTypes['ArithmeticalOperator']>, ParentType, ContextType>;
  bothOperatorSecond?: Resolver<Maybe<ResolversTypes['ArithmeticalOperator']>, ParentType, ContextType>;
  conditionType?: Resolver<ResolversTypes['EnrollingConditionType'], ParentType, ContextType>;
  countdownOperator?: Resolver<Maybe<ResolversTypes['CountdownOperator']>, ParentType, ContextType>;
  customCondition?: Resolver<Maybe<ResolversTypes['CustomCondition']>, ParentType, ContextType, RequireFields<EnrollingConditionCustomConditionArgs, 'directed'>>;
  customConditionAggregate?: Resolver<Maybe<ResolversTypes['EnrollingConditionCustomConditionCustomConditionAggregationSelection']>, ParentType, ContextType, RequireFields<EnrollingConditionCustomConditionAggregateArgs, 'directed'>>;
  customConditionConnection?: Resolver<ResolversTypes['EnrollingConditionCustomConditionConnection'], ParentType, ContextType, RequireFields<EnrollingConditionCustomConditionConnectionArgs, 'directed'>>;
  cycleLimitFrom?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cycleLimitTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  includedGenerics?: Resolver<Array<ResolversTypes['Generic']>, ParentType, ContextType, RequireFields<EnrollingConditionIncludedGenericsArgs, 'directed'>>;
  includedGenericsAggregate?: Resolver<Maybe<ResolversTypes['EnrollingConditionGenericIncludedGenericsAggregationSelection']>, ParentType, ContextType, RequireFields<EnrollingConditionIncludedGenericsAggregateArgs, 'directed'>>;
  includedGenericsConnection?: Resolver<ResolversTypes['EnrollingConditionIncludedGenericsConnection'], ParentType, ContextType, RequireFields<EnrollingConditionIncludedGenericsConnectionArgs, 'directed'>>;
  inclusionType?: Resolver<Maybe<ResolversTypes['InclusionType']>, ParentType, ContextType>;
  operator?: Resolver<Maybe<ResolversTypes['ArithmeticalOperator']>, ParentType, ContextType>;
  rangeInputEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rangeInputStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<Array<ResolversTypes['CoverageRequestRating']>>, ParentType, ContextType>;
  resultSelectionType?: Resolver<Maybe<ResolversTypes['ResultSelectionType']>, ParentType, ContextType>;
  therapyDecision?: Resolver<Maybe<Array<ResolversTypes['CoverageRequestTherapyDecision']>>, ParentType, ContextType>;
  timeframeRangeEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeframeRangeStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeframeRangeType?: Resolver<Maybe<ResolversTypes['TimeframeRangeType']>, ParentType, ContextType>;
  timeframeStartingPoint?: Resolver<Maybe<ResolversTypes['TimeframeStartingPoint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionCustomConditionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionCustomConditionConnection'] = ResolversParentTypes['EnrollingConditionCustomConditionConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EnrollingConditionCustomConditionRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionCustomConditionCustomConditionAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionCustomConditionCustomConditionAggregationSelection'] = ResolversParentTypes['EnrollingConditionCustomConditionCustomConditionAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionCustomConditionCustomConditionNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection'] = ResolversParentTypes['EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionCustomConditionRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionCustomConditionRelationship'] = ResolversParentTypes['EnrollingConditionCustomConditionRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CustomCondition'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionDiseaseRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionDiseaseRelationship'] = ResolversParentTypes['EnrollingConditionDiseaseRelationship']> = {
  __resolveType: TypeResolveFn<'AgreementScopeDiseasesRelationship', ParentType, ContextType>;
  Score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type EnrollingConditionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionEdge'] = ResolversParentTypes['EnrollingConditionEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EnrollingCondition'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionGenericIncludedGenericsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionGenericIncludedGenericsAggregationSelection'] = ResolversParentTypes['EnrollingConditionGenericIncludedGenericsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['EnrollingConditionGenericIncludedGenericsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionGenericIncludedGenericsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionGenericIncludedGenericsNodeAggregateSelection'] = ResolversParentTypes['EnrollingConditionGenericIncludedGenericsNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionIncludedGenericsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionIncludedGenericsConnection'] = ResolversParentTypes['EnrollingConditionIncludedGenericsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EnrollingConditionIncludedGenericsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionIncludedGenericsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionIncludedGenericsRelationship'] = ResolversParentTypes['EnrollingConditionIncludedGenericsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Generic'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSet'] = ResolversParentTypes['EnrollingConditionSet']> = {
  agreement?: Resolver<Maybe<ResolversTypes['Agreement']>, ParentType, ContextType, RequireFields<EnrollingConditionSetAgreementArgs, 'directed'>>;
  agreementAggregate?: Resolver<Maybe<ResolversTypes['EnrollingConditionSetAgreementAgreementAggregationSelection']>, ParentType, ContextType, RequireFields<EnrollingConditionSetAgreementAggregateArgs, 'directed'>>;
  agreementConnection?: Resolver<ResolversTypes['EnrollingConditionSetAgreementConnection'], ParentType, ContextType, RequireFields<EnrollingConditionSetAgreementConnectionArgs, 'directed'>>;
  conditions?: Resolver<Array<ResolversTypes['EnrollingCondition']>, ParentType, ContextType, RequireFields<EnrollingConditionSetConditionsArgs, 'directed'>>;
  conditionsAggregate?: Resolver<Maybe<ResolversTypes['EnrollingConditionSetEnrollingConditionConditionsAggregationSelection']>, ParentType, ContextType, RequireFields<EnrollingConditionSetConditionsAggregateArgs, 'directed'>>;
  conditionsConnection?: Resolver<ResolversTypes['EnrollingConditionSetConditionsConnection'], ParentType, ContextType, RequireFields<EnrollingConditionSetConditionsConnectionArgs, 'directed'>>;
  isDiseaseNotEnrollingCondition?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isIndicationNotEnrollingCondition?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['AgreementScope']>, ParentType, ContextType, RequireFields<EnrollingConditionSetScopesArgs, 'directed'>>;
  scopesAggregate?: Resolver<Maybe<ResolversTypes['EnrollingConditionSetAgreementScopeScopesAggregationSelection']>, ParentType, ContextType, RequireFields<EnrollingConditionSetScopesAggregateArgs, 'directed'>>;
  scopesConnection?: Resolver<ResolversTypes['EnrollingConditionSetScopesConnection'], ParentType, ContextType, RequireFields<EnrollingConditionSetScopesConnectionArgs, 'directed'>>;
  template?: Resolver<Maybe<ResolversTypes['AgreementTemplate']>, ParentType, ContextType, RequireFields<EnrollingConditionSetTemplateArgs, 'directed'>>;
  templateAggregate?: Resolver<Maybe<ResolversTypes['EnrollingConditionSetAgreementTemplateTemplateAggregationSelection']>, ParentType, ContextType, RequireFields<EnrollingConditionSetTemplateAggregateArgs, 'directed'>>;
  templateConnection?: Resolver<ResolversTypes['EnrollingConditionSetTemplateConnection'], ParentType, ContextType, RequireFields<EnrollingConditionSetTemplateConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetAgreementAgreementAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetAgreementAgreementAggregationSelection'] = ResolversParentTypes['EnrollingConditionSetAgreementAgreementAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['EnrollingConditionSetAgreementAgreementNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetAgreementAgreementNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetAgreementAgreementNodeAggregateSelection'] = ResolversParentTypes['EnrollingConditionSetAgreementAgreementNodeAggregateSelection']> = {
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  daysToExpiry?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  firstExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  formattedAmount?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedCounterparties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedDiseases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedIndications?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedProducts?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  pushedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  reportData?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetAgreementConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetAgreementConnection'] = ResolversParentTypes['EnrollingConditionSetAgreementConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EnrollingConditionSetAgreementRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetAgreementRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetAgreementRelationship'] = ResolversParentTypes['EnrollingConditionSetAgreementRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetAgreementScopeScopesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetAgreementScopeScopesAggregationSelection'] = ResolversParentTypes['EnrollingConditionSetAgreementScopeScopesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetAgreementScopeScopesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection'] = ResolversParentTypes['EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection']> = {
  code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  scopeId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetAgreementTemplateTemplateAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetAgreementTemplateTemplateAggregationSelection'] = ResolversParentTypes['EnrollingConditionSetAgreementTemplateTemplateAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection'] = ResolversParentTypes['EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  treatments?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetConditionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetConditionsConnection'] = ResolversParentTypes['EnrollingConditionSetConditionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EnrollingConditionSetConditionsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetConditionsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetConditionsRelationship'] = ResolversParentTypes['EnrollingConditionSetConditionsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EnrollingCondition'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetEdge'] = ResolversParentTypes['EnrollingConditionSetEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EnrollingConditionSet'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetEnrollingConditionConditionsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetEnrollingConditionConditionsAggregationSelection'] = ResolversParentTypes['EnrollingConditionSetEnrollingConditionConditionsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection'] = ResolversParentTypes['EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection']> = {
  attributeValue?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  cycleLimitFrom?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  cycleLimitTo?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  rangeInputEnd?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  rangeInputStart?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  timeframeRangeEnd?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  timeframeRangeStart?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetRelationship'] = ResolversParentTypes['EnrollingConditionSetRelationship']> = {
  __resolveType: TypeResolveFn<'AgreementEnrollingConditionSetsRelationship', ParentType, ContextType>;
  isExtended?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type EnrollingConditionSetScopesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetScopesConnection'] = ResolversParentTypes['EnrollingConditionSetScopesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EnrollingConditionSetScopesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetScopesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetScopesRelationship'] = ResolversParentTypes['EnrollingConditionSetScopesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  excludedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isExtended?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementScope'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetTemplateConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetTemplateConnection'] = ResolversParentTypes['EnrollingConditionSetTemplateConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EnrollingConditionSetTemplateRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetTemplateRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetTemplateRelationship'] = ResolversParentTypes['EnrollingConditionSetTemplateRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionSetsConnection'] = ResolversParentTypes['EnrollingConditionSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EnrollingConditionSetEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingConditionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingConditionsConnection'] = ResolversParentTypes['EnrollingConditionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EnrollingConditionEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingPeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingPeriod'] = ResolversParentTypes['EnrollingPeriod']> = {
  from?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingPeriodEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingPeriodEdge'] = ResolversParentTypes['EnrollingPeriodEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EnrollingPeriod'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrollingPeriodsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrollingPeriodsConnection'] = ResolversParentTypes['EnrollingPeriodsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EnrollingPeriodEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EntityTypeMappingRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['EntityTypeMappingRelationship'] = ResolversParentTypes['EntityTypeMappingRelationship']> = {
  __resolveType: TypeResolveFn<'FlexEntityTypeMappingInstancesRelationship' | 'OrganizationFlexEntityTypeMappingsRelationship', ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type EntryModuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['EntryModule'] = ResolversParentTypes['EntryModule']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EntryModuleEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EntryModuleEdge'] = ResolversParentTypes['EntryModuleEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EntryModule'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EntryModulesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EntryModulesConnection'] = ResolversParentTypes['EntryModulesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EntryModuleEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExFactoryPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExFactoryPrice'] = ResolversParentTypes['ExFactoryPrice']> = {
  Price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValidFromDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExFactoryPriceEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExFactoryPriceEdge'] = ResolversParentTypes['ExFactoryPriceEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ExFactoryPrice'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExFactoryPricesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExFactoryPricesConnection'] = ResolversParentTypes['ExFactoryPricesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ExFactoryPriceEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface FileUploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['FileUpload'], any> {
  name: 'FileUpload';
}

export type FinancialSummaryColumnResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSummaryColumn'] = ResolversParentTypes['FinancialSummaryColumn']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['FinancialSummaryColumnName'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialSummaryColumnEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSummaryColumnEdge'] = ResolversParentTypes['FinancialSummaryColumnEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FinancialSummaryColumn'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialSummaryColumnsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSummaryColumnsConnection'] = ResolversParentTypes['FinancialSummaryColumnsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FinancialSummaryColumnEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntitiesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntitiesConnection'] = ResolversParentTypes['FlexEntitiesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntity'] = ResolversParentTypes['FlexEntity']> = {
  autogenerationTrigger?: Resolver<Maybe<ResolversTypes['AutogenerationTrigger']>, ParentType, ContextType>;
  cases?: Resolver<Array<ResolversTypes['Case']>, ParentType, ContextType, RequireFields<FlexEntityCasesArgs, 'directed'>>;
  casesAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityCaseCasesAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityCasesAggregateArgs, 'directed'>>;
  casesConnection?: Resolver<ResolversTypes['FlexEntityCasesConnection'], ParentType, ContextType, RequireFields<FlexEntityCasesConnectionArgs, 'directed'>>;
  containerType?: Resolver<ResolversTypes['FlexContainerType'], ParentType, ContextType>;
  coverageStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<FlexEntityCreatedByArgs, 'directed'>>;
  createdByAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityUserCreatedByAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityCreatedByAggregateArgs, 'directed'>>;
  createdByConnection?: Resolver<ResolversTypes['FlexEntityCreatedByConnection'], ParentType, ContextType, RequireFields<FlexEntityCreatedByConnectionArgs, 'directed'>>;
  createdByEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dataKeys?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  dateAttributeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  decisionTherapy?: Resolver<Maybe<ResolversTypes['CoverageRequestTherapyDecision']>, ParentType, ContextType>;
  documentStatus?: Resolver<Maybe<ResolversTypes['DocumentStatus']>, ParentType, ContextType>;
  externalFormId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  financialDataPoints?: Resolver<Array<ResolversTypes['FlexFinancialDataPoint']>, ParentType, ContextType, RequireFields<FlexEntityFinancialDataPointsArgs, 'directed'>>;
  financialDataPointsAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityFinancialDataPointsAggregateArgs, 'directed'>>;
  financialDataPointsConnection?: Resolver<ResolversTypes['FlexEntityFinancialDataPointsConnection'], ParentType, ContextType, RequireFields<FlexEntityFinancialDataPointsConnectionArgs, 'directed'>>;
  firstPrescriptionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  flexEntityName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  generics?: Resolver<Array<ResolversTypes['Generic']>, ParentType, ContextType, RequireFields<FlexEntityGenericsArgs, 'directed'>>;
  genericsAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityGenericGenericsAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityGenericsAggregateArgs, 'directed'>>;
  genericsConnection?: Resolver<ResolversTypes['FlexEntityGenericsConnection'], ParentType, ContextType, RequireFields<FlexEntityGenericsConnectionArgs, 'directed'>>;
  hasRefunds?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  indirectCases?: Resolver<Array<ResolversTypes['Case']>, ParentType, ContextType, Partial<FlexEntityIndirectCasesArgs>>;
  insuranceClaimId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoiceDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  invoiceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isAutogenerated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isOrphaned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRevoked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isUploaded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  occurrence?: Resolver<Maybe<ResolversTypes['OccurrenceEnum']>, ParentType, ContextType>;
  otherLastFinancialDataPoints?: Resolver<Array<ResolversTypes['FlexFinancialDataPoint']>, ParentType, ContextType, Partial<FlexEntityOtherLastFinancialDataPointsArgs>>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType, RequireFields<FlexEntityPatientArgs, 'directed'>>;
  patientAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityPatientPatientAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityPatientAggregateArgs, 'directed'>>;
  patientConnection?: Resolver<ResolversTypes['FlexEntityPatientConnection'], ParentType, ContextType, RequireFields<FlexEntityPatientConnectionArgs, 'directed'>>;
  patientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  patientIdKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  predecessor?: Resolver<Maybe<ResolversTypes['FlexEntity']>, ParentType, ContextType, RequireFields<FlexEntityPredecessorArgs, 'directed'>>;
  predecessorAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityFlexEntityPredecessorAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityPredecessorAggregateArgs, 'directed'>>;
  predecessorConnection?: Resolver<ResolversTypes['FlexEntityPredecessorConnection'], ParentType, ContextType, RequireFields<FlexEntityPredecessorConnectionArgs, 'directed'>>;
  preparationBrandNames?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preparationGenericNames?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  purchase?: Resolver<Maybe<ResolversTypes['Purchase']>, ParentType, ContextType, RequireFields<FlexEntityPurchaseArgs, 'directed'>>;
  purchaseAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityPurchasePurchaseAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityPurchaseAggregateArgs, 'directed'>>;
  purchaseConnection?: Resolver<ResolversTypes['FlexEntityPurchaseConnection'], ParentType, ContextType, RequireFields<FlexEntityPurchaseConnectionArgs, 'directed'>>;
  purchaseId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['CoverageRequestRating']>, ParentType, ContextType>;
  refundStatus?: Resolver<Maybe<ResolversTypes['RefundStatus']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['FlexEntity']>, ParentType, ContextType, RequireFields<FlexEntitySourceArgs, 'directed'>>;
  sourceAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityFlexEntitySourceAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntitySourceAggregateArgs, 'directed'>>;
  sourceConnection?: Resolver<ResolversTypes['FlexEntitySourceConnection'], ParentType, ContextType, RequireFields<FlexEntitySourceConnectionArgs, 'directed'>>;
  sourced?: Resolver<Array<ResolversTypes['FlexEntity']>, ParentType, ContextType, RequireFields<FlexEntitySourcedArgs, 'directed'>>;
  sourcedAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityFlexEntitySourcedAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntitySourcedAggregateArgs, 'directed'>>;
  sourcedConnection?: Resolver<ResolversTypes['FlexEntitySourcedConnection'], ParentType, ContextType, RequireFields<FlexEntitySourcedConnectionArgs, 'directed'>>;
  status?: Resolver<Maybe<ResolversTypes['FlexFormStatus']>, ParentType, ContextType>;
  successor?: Resolver<Maybe<ResolversTypes['FlexEntity']>, ParentType, ContextType, RequireFields<FlexEntitySuccessorArgs, 'directed'>>;
  successorAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityFlexEntitySuccessorAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntitySuccessorAggregateArgs, 'directed'>>;
  successorConnection?: Resolver<ResolversTypes['FlexEntitySuccessorConnection'], ParentType, ContextType, RequireFields<FlexEntitySuccessorConnectionArgs, 'directed'>>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  therapyTrialStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FlexEntityType'], ParentType, ContextType, RequireFields<FlexEntityTypeArgs, 'directed'>>;
  typeAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityFlexEntityTypeTypeAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityTypeAggregateArgs, 'directed'>>;
  typeConnection?: Resolver<ResolversTypes['FlexEntityTypeConnection'], ParentType, ContextType, RequireFields<FlexEntityTypeConnectionArgs, 'directed'>>;
  upload?: Resolver<Maybe<ResolversTypes['Upload']>, ParentType, ContextType, RequireFields<FlexEntityUploadArgs, 'directed'>>;
  uploadAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityUploadUploadAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityUploadAggregateArgs, 'directed'>>;
  uploadConnection?: Resolver<ResolversTypes['FlexEntityUploadConnection'], ParentType, ContextType, RequireFields<FlexEntityUploadConnectionArgs, 'directed'>>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  viewCaseId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewCases?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewCreatedByName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  viewFormattedContentDe?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewFormattedContentEn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewSourceRefundStatus?: Resolver<Maybe<ResolversTypes['RefundStatus']>, ParentType, ContextType>;
  viewSuccessorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityCaseCasesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityCaseCasesAggregationSelection'] = ResolversParentTypes['FlexEntityCaseCasesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityCaseCasesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityCaseCasesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityCaseCasesNodeAggregateSelection'] = ResolversParentTypes['FlexEntityCaseCasesNodeAggregateSelection']> = {
  creationDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  preparationBrandName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  submissionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityCasesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityCasesConnection'] = ResolversParentTypes['FlexEntityCasesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityCasesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityCasesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityCasesRelationship'] = ResolversParentTypes['FlexEntityCasesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isStartingPoint?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Case'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityCreatedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityCreatedByConnection'] = ResolversParentTypes['FlexEntityCreatedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityCreatedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityCreatedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityCreatedByRelationship'] = ResolversParentTypes['FlexEntityCreatedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityEdge'] = ResolversParentTypes['FlexEntityEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFinancialDataPointsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFinancialDataPointsConnection'] = ResolversParentTypes['FlexEntityFinancialDataPointsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityFinancialDataPointsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFinancialDataPointsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFinancialDataPointsRelationship'] = ResolversParentTypes['FlexEntityFinancialDataPointsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexFinancialDataPoint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFlexEntityPredecessorAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFlexEntityPredecessorAggregationSelection'] = ResolversParentTypes['FlexEntityFlexEntityPredecessorAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityFlexEntityPredecessorNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFlexEntityPredecessorNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFlexEntityPredecessorNodeAggregateSelection'] = ResolversParentTypes['FlexEntityFlexEntityPredecessorNodeAggregateSelection']> = {
  createdByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  dataKeys?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  externalFormId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  flexEntityName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  insuranceClaimId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationBrandNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationGenericNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  viewCaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCreatedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewSuccessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFlexEntitySourceAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFlexEntitySourceAggregationSelection'] = ResolversParentTypes['FlexEntityFlexEntitySourceAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityFlexEntitySourceNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFlexEntitySourceNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFlexEntitySourceNodeAggregateSelection'] = ResolversParentTypes['FlexEntityFlexEntitySourceNodeAggregateSelection']> = {
  createdByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  dataKeys?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  externalFormId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  flexEntityName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  insuranceClaimId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationBrandNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationGenericNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  viewCaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCreatedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewSuccessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFlexEntitySourcedAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFlexEntitySourcedAggregationSelection'] = ResolversParentTypes['FlexEntityFlexEntitySourcedAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityFlexEntitySourcedNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFlexEntitySourcedNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFlexEntitySourcedNodeAggregateSelection'] = ResolversParentTypes['FlexEntityFlexEntitySourcedNodeAggregateSelection']> = {
  createdByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  dataKeys?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  externalFormId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  flexEntityName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  insuranceClaimId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationBrandNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationGenericNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  viewCaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCreatedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewSuccessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFlexEntitySuccessorAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFlexEntitySuccessorAggregationSelection'] = ResolversParentTypes['FlexEntityFlexEntitySuccessorAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityFlexEntitySuccessorNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFlexEntitySuccessorNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFlexEntitySuccessorNodeAggregateSelection'] = ResolversParentTypes['FlexEntityFlexEntitySuccessorNodeAggregateSelection']> = {
  createdByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  dataKeys?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  externalFormId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  flexEntityName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  insuranceClaimId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationBrandNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationGenericNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  viewCaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCreatedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewSuccessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFlexEntityTypeTypeAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFlexEntityTypeTypeAggregationSelection'] = ResolversParentTypes['FlexEntityFlexEntityTypeTypeAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityFlexEntityTypeTypeNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFlexEntityTypeTypeNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFlexEntityTypeTypeNodeAggregateSelection'] = ResolversParentTypes['FlexEntityFlexEntityTypeTypeNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  attributeCount?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  idPrefix?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  localizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  tooltipText?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection'] = ResolversParentTypes['FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection'] = ResolversParentTypes['FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection']> = {
  basePrice?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  evaluationSnapshot?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  generatedUuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  netPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  payable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  payablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundDeltaNumber?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  revokedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroMainNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroRelevantNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  variable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  variablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityGenericGenericsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityGenericGenericsAggregationSelection'] = ResolversParentTypes['FlexEntityGenericGenericsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityGenericGenericsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityGenericGenericsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityGenericGenericsNodeAggregateSelection'] = ResolversParentTypes['FlexEntityGenericGenericsNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityGenericsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityGenericsConnection'] = ResolversParentTypes['FlexEntityGenericsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityGenericsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityGenericsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityGenericsRelationship'] = ResolversParentTypes['FlexEntityGenericsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Generic'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityPatientConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityPatientConnection'] = ResolversParentTypes['FlexEntityPatientConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityPatientRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityPatientPatientAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityPatientPatientAggregationSelection'] = ResolversParentTypes['FlexEntityPatientPatientAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityPatientPatientNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityPatientPatientNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityPatientPatientNodeAggregateSelection'] = ResolversParentTypes['FlexEntityPatientPatientNodeAggregateSelection']> = {
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initials?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  insuranceId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  timeStamp?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  yearOfBirth?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityPatientRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityPatientRelationship'] = ResolversParentTypes['FlexEntityPatientRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityPredecessorConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityPredecessorConnection'] = ResolversParentTypes['FlexEntityPredecessorConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityPredecessorRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityPredecessorRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityPredecessorRelationship'] = ResolversParentTypes['FlexEntityPredecessorRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityPurchaseConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityPurchaseConnection'] = ResolversParentTypes['FlexEntityPurchaseConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityPurchaseRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityPurchasePurchaseAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityPurchasePurchaseAggregationSelection'] = ResolversParentTypes['FlexEntityPurchasePurchaseAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityPurchasePurchaseNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityPurchasePurchaseNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityPurchasePurchaseNodeAggregateSelection'] = ResolversParentTypes['FlexEntityPurchasePurchaseNodeAggregateSelection']> = {
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  timeStamp?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityPurchaseRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityPurchaseRelationship'] = ResolversParentTypes['FlexEntityPurchaseRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Purchase'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntitySourceConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntitySourceConnection'] = ResolversParentTypes['FlexEntitySourceConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntitySourceRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntitySourceRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntitySourceRelationship'] = ResolversParentTypes['FlexEntitySourceRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntitySourcedConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntitySourcedConnection'] = ResolversParentTypes['FlexEntitySourcedConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntitySourcedRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntitySourcedRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntitySourcedRelationship'] = ResolversParentTypes['FlexEntitySourcedRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntitySuccessorConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntitySuccessorConnection'] = ResolversParentTypes['FlexEntitySuccessorConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntitySuccessorRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntitySuccessorRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntitySuccessorRelationship'] = ResolversParentTypes['FlexEntitySuccessorRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityType'] = ResolversParentTypes['FlexEntityType']> = {
  addedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<FlexEntityTypeAddedByArgs, 'directed'>>;
  addedByAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityTypeUserAddedByAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityTypeAddedByAggregateArgs, 'directed'>>;
  addedByConnection?: Resolver<ResolversTypes['FlexEntityTypeAddedByConnection'], ParentType, ContextType, RequireFields<FlexEntityTypeAddedByConnectionArgs, 'directed'>>;
  addedByName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  agreementCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  attributeCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  catalogueAttributes?: Resolver<Array<ResolversTypes['CatalogueAttribute']>, ParentType, ContextType, RequireFields<FlexEntityTypeCatalogueAttributesArgs, 'directed'>>;
  catalogueAttributesAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityTypeCatalogueAttributesAggregateArgs, 'directed'>>;
  catalogueAttributesConnection?: Resolver<ResolversTypes['FlexEntityTypeCatalogueAttributesConnection'], ParentType, ContextType, RequireFields<FlexEntityTypeCatalogueAttributesConnectionArgs, 'directed'>>;
  containerType?: Resolver<ResolversTypes['FlexContainerType'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  creationWays?: Resolver<Array<ResolversTypes['DataContainerCreationWay']>, ParentType, ContextType>;
  data?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  features?: Resolver<Array<ResolversTypes['FlexEntityFeature']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idPrefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ignoredAttributes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  instances?: Resolver<Array<ResolversTypes['FlexEntity']>, ParentType, ContextType, RequireFields<FlexEntityTypeInstancesArgs, 'directed'>>;
  instancesAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityTypeFlexEntityInstancesAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityTypeInstancesAggregateArgs, 'directed'>>;
  instancesConnection?: Resolver<ResolversTypes['FlexEntityTypeInstancesConnection'], ParentType, ContextType, RequireFields<FlexEntityTypeInstancesConnectionArgs, 'directed'>>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isOptional?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isReadOnly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStartingPoint?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  localizationKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mappingInstances?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType, RequireFields<FlexEntityTypeMappingInstancesArgs, 'directed'>>;
  mappingInstancesAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityTypeOrganizationMappingInstancesAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityTypeMappingInstancesAggregateArgs, 'directed'>>;
  mappingInstancesConnection?: Resolver<ResolversTypes['FlexEntityTypeMappingInstancesConnection'], ParentType, ContextType, RequireFields<FlexEntityTypeMappingInstancesConnectionArgs, 'directed'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orgDataMappings?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  recordTypes?: Resolver<Array<ResolversTypes['FlexEntityType']>, ParentType, ContextType, RequireFields<FlexEntityTypeRecordTypesArgs, 'directed'>>;
  recordTypesAggregate?: Resolver<Maybe<ResolversTypes['FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection']>, ParentType, ContextType, RequireFields<FlexEntityTypeRecordTypesAggregateArgs, 'directed'>>;
  recordTypesConnection?: Resolver<ResolversTypes['FlexEntityTypeRecordTypesConnection'], ParentType, ContextType, RequireFields<FlexEntityTypeRecordTypesConnectionArgs, 'directed'>>;
  tooltipText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeAddedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeAddedByConnection'] = ResolversParentTypes['FlexEntityTypeAddedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityTypeAddedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeAddedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeAddedByRelationship'] = ResolversParentTypes['FlexEntityTypeAddedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection'] = ResolversParentTypes['FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection'] = ResolversParentTypes['FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection']> = {
  caption?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  decimalPrecision?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultValue?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  longLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  maxLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  minLength?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  rules?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  shortLabelLocalizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  values?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeCatalogueAttributeRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeCatalogueAttributeRelationship'] = ResolversParentTypes['FlexEntityTypeCatalogueAttributeRelationship']> = {
  __resolveType: TypeResolveFn<'CatalogueAttributeFlexEntityTypesRelationship' | 'FlexEntityTypeCatalogueAttributesRelationship', ParentType, ContextType>;
  isDisplayedInCaseDetails?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDisplayedInCaseTable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type FlexEntityTypeCatalogueAttributesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeCatalogueAttributesConnection'] = ResolversParentTypes['FlexEntityTypeCatalogueAttributesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityTypeCatalogueAttributesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeCatalogueAttributesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeCatalogueAttributesRelationship'] = ResolversParentTypes['FlexEntityTypeCatalogueAttributesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isDisplayedInCaseDetails?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDisplayedInCaseTable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CatalogueAttribute'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeConnection'] = ResolversParentTypes['FlexEntityTypeConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityTypeRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeEdge'] = ResolversParentTypes['FlexEntityTypeEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntityType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeFlexEntityInstancesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeFlexEntityInstancesAggregationSelection'] = ResolversParentTypes['FlexEntityTypeFlexEntityInstancesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityTypeFlexEntityInstancesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeFlexEntityInstancesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeFlexEntityInstancesNodeAggregateSelection'] = ResolversParentTypes['FlexEntityTypeFlexEntityInstancesNodeAggregateSelection']> = {
  createdByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  dataKeys?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  externalFormId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  flexEntityName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  insuranceClaimId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationBrandNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationGenericNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  viewCaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCreatedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewSuccessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection'] = ResolversParentTypes['FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection'] = ResolversParentTypes['FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  attributeCount?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  idPrefix?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  localizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  tooltipText?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeInstancesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeInstancesConnection'] = ResolversParentTypes['FlexEntityTypeInstancesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityTypeInstancesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeInstancesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeInstancesRelationship'] = ResolversParentTypes['FlexEntityTypeInstancesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeMappingInstancesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeMappingInstancesConnection'] = ResolversParentTypes['FlexEntityTypeMappingInstancesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityTypeMappingInstancesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeMappingInstancesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeMappingInstancesRelationship'] = ResolversParentTypes['FlexEntityTypeMappingInstancesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeOrganizationMappingInstancesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeOrganizationMappingInstancesAggregationSelection'] = ResolversParentTypes['FlexEntityTypeOrganizationMappingInstancesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection'] = ResolversParentTypes['FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection']> = {
  data?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection'] = ResolversParentTypes['FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection']> = {
  BIC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  IBAN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  aggregationPriority?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceThreshold?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactFirstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactLastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactOccupation?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactPhone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderRecurrentStep?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentSftpSavePath?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  domicile?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  dualApprovalThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  eIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  fax?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  legalName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  pharmaId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rebateProcessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  website?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeRecordTypesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeRecordTypesConnection'] = ResolversParentTypes['FlexEntityTypeRecordTypesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityTypeRecordTypesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeRecordTypesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeRecordTypesRelationship'] = ResolversParentTypes['FlexEntityTypeRecordTypesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntityType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeRelationship'] = ResolversParentTypes['FlexEntityTypeRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntityType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeUserAddedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeUserAddedByAggregationSelection'] = ResolversParentTypes['FlexEntityTypeUserAddedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityTypeUserAddedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypeUserAddedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypeUserAddedByNodeAggregateSelection'] = ResolversParentTypes['FlexEntityTypeUserAddedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityTypesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityTypesConnection'] = ResolversParentTypes['FlexEntityTypesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityTypeEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityUploadConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityUploadConnection'] = ResolversParentTypes['FlexEntityUploadConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexEntityUploadRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityUploadRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityUploadRelationship'] = ResolversParentTypes['FlexEntityUploadRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Upload'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityUploadUploadAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityUploadUploadAggregationSelection'] = ResolversParentTypes['FlexEntityUploadUploadAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityUploadUploadNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityUploadUploadNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityUploadUploadNodeAggregateSelection'] = ResolversParentTypes['FlexEntityUploadUploadNodeAggregateSelection']> = {
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityUserCreatedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityUserCreatedByAggregationSelection'] = ResolversParentTypes['FlexEntityUserCreatedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexEntityUserCreatedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexEntityUserCreatedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexEntityUserCreatedByNodeAggregateSelection'] = ResolversParentTypes['FlexEntityUserCreatedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPoint'] = ResolversParentTypes['FlexFinancialDataPoint']> = {
  agreement?: Resolver<Maybe<ResolversTypes['Agreement']>, ParentType, ContextType, RequireFields<FlexFinancialDataPointAgreementArgs, 'directed'>>;
  agreementAggregate?: Resolver<Maybe<ResolversTypes['FlexFinancialDataPointAgreementAgreementAggregationSelection']>, ParentType, ContextType, RequireFields<FlexFinancialDataPointAgreementAggregateArgs, 'directed'>>;
  agreementConnection?: Resolver<ResolversTypes['FlexFinancialDataPointAgreementConnection'], ParentType, ContextType, RequireFields<FlexFinancialDataPointAgreementConnectionArgs, 'directed'>>;
  basePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  basePriceType?: Resolver<Maybe<ResolversTypes['PriceType']>, ParentType, ContextType>;
  cannotBeSourceOfRefund?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  documentStatus?: Resolver<Maybe<ResolversTypes['DocumentStatus']>, ParentType, ContextType>;
  evaluates?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType, RequireFields<FlexFinancialDataPointEvaluatesArgs, 'directed'>>;
  evaluatesAggregate?: Resolver<Maybe<ResolversTypes['FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection']>, ParentType, ContextType, RequireFields<FlexFinancialDataPointEvaluatesAggregateArgs, 'directed'>>;
  evaluatesConnection?: Resolver<ResolversTypes['FlexFinancialDataPointEvaluatesConnection'], ParentType, ContextType, RequireFields<FlexFinancialDataPointEvaluatesConnectionArgs, 'directed'>>;
  evaluationSnapshot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failReason?: Resolver<Maybe<ResolversTypes['ScenarioActionFailure']>, ParentType, ContextType>;
  generatedFor?: Resolver<Maybe<ResolversTypes['Case']>, ParentType, ContextType, RequireFields<FlexFinancialDataPointGeneratedForArgs, 'directed'>>;
  generatedForAggregate?: Resolver<Maybe<ResolversTypes['FlexFinancialDataPointCaseGeneratedForAggregationSelection']>, ParentType, ContextType, RequireFields<FlexFinancialDataPointGeneratedForAggregateArgs, 'directed'>>;
  generatedForConnection?: Resolver<ResolversTypes['FlexFinancialDataPointGeneratedForConnection'], ParentType, ContextType, RequireFields<FlexFinancialDataPointGeneratedForConnectionArgs, 'directed'>>;
  generatedUuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDefaultPriceRateApplied?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDelta?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isLast?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  netPrices?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payable?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  payablePercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  prescriptionDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  refundDeltaNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  refundable?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  refundablePercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  revokedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  scenarioZeroMainNetPrices?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scenarioZeroNetPrices?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scenarioZeroRelevantNetPrices?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceDocument?: Resolver<Maybe<ResolversTypes['Refund']>, ParentType, ContextType, RequireFields<FlexFinancialDataPointSourceDocumentArgs, 'directed'>>;
  sourceDocumentAggregate?: Resolver<Maybe<ResolversTypes['FlexFinancialDataPointRefundSourceDocumentAggregationSelection']>, ParentType, ContextType, RequireFields<FlexFinancialDataPointSourceDocumentAggregateArgs, 'directed'>>;
  sourceDocumentConnection?: Resolver<ResolversTypes['FlexFinancialDataPointSourceDocumentConnection'], ParentType, ContextType, RequireFields<FlexFinancialDataPointSourceDocumentConnectionArgs, 'directed'>>;
  sourceDocumentState?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType>;
  sourceRefund?: Resolver<Maybe<ResolversTypes['Refund']>, ParentType, ContextType, RequireFields<FlexFinancialDataPointSourceRefundArgs, 'directed'>>;
  sourceRefundAggregate?: Resolver<Maybe<ResolversTypes['FlexFinancialDataPointRefundSourceRefundAggregationSelection']>, ParentType, ContextType, RequireFields<FlexFinancialDataPointSourceRefundAggregateArgs, 'directed'>>;
  sourceRefundConnection?: Resolver<ResolversTypes['FlexFinancialDataPointSourceRefundConnection'], ParentType, ContextType, RequireFields<FlexFinancialDataPointSourceRefundConnectionArgs, 'directed'>>;
  treatment?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType, RequireFields<FlexFinancialDataPointTreatmentArgs, 'directed'>>;
  treatmentAggregate?: Resolver<Maybe<ResolversTypes['FlexFinancialDataPointTreatmentTreatmentAggregationSelection']>, ParentType, ContextType, RequireFields<FlexFinancialDataPointTreatmentAggregateArgs, 'directed'>>;
  treatmentConnection?: Resolver<ResolversTypes['FlexFinancialDataPointTreatmentConnection'], ParentType, ContextType, RequireFields<FlexFinancialDataPointTreatmentConnectionArgs, 'directed'>>;
  uuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  variable?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  variablePercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointAgreementAgreementAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointAgreementAgreementAggregationSelection'] = ResolversParentTypes['FlexFinancialDataPointAgreementAgreementAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexFinancialDataPointAgreementAgreementNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointAgreementAgreementNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointAgreementAgreementNodeAggregateSelection'] = ResolversParentTypes['FlexFinancialDataPointAgreementAgreementNodeAggregateSelection']> = {
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  daysToExpiry?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  firstExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  formattedAmount?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedCounterparties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedDiseases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedIndications?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedProducts?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  pushedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  reportData?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointAgreementConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointAgreementConnection'] = ResolversParentTypes['FlexFinancialDataPointAgreementConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexFinancialDataPointAgreementRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointAgreementRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointAgreementRelationship'] = ResolversParentTypes['FlexFinancialDataPointAgreementRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointCaseGeneratedForAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointCaseGeneratedForAggregationSelection'] = ResolversParentTypes['FlexFinancialDataPointCaseGeneratedForAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointCaseGeneratedForNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection'] = ResolversParentTypes['FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection']> = {
  creationDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  preparationBrandName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  submissionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointEdge'] = ResolversParentTypes['FlexFinancialDataPointEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexFinancialDataPoint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointEvaluatesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointEvaluatesConnection'] = ResolversParentTypes['FlexFinancialDataPointEvaluatesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexFinancialDataPointEvaluatesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointEvaluatesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointEvaluatesRelationship'] = ResolversParentTypes['FlexFinancialDataPointEvaluatesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointFlexEntityEvaluatesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection'] = ResolversParentTypes['FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection'] = ResolversParentTypes['FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection']> = {
  createdByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  dataKeys?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  externalFormId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  flexEntityName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  insuranceClaimId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationBrandNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationGenericNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  viewCaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCreatedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewSuccessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointGeneratedForConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointGeneratedForConnection'] = ResolversParentTypes['FlexFinancialDataPointGeneratedForConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexFinancialDataPointGeneratedForRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointGeneratedForRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointGeneratedForRelationship'] = ResolversParentTypes['FlexFinancialDataPointGeneratedForRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Case'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointRefundSourceDocumentAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointRefundSourceDocumentAggregationSelection'] = ResolversParentTypes['FlexFinancialDataPointRefundSourceDocumentAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection'] = ResolversParentTypes['FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection']> = {
  agreementId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  caseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  caseOrAgreementId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointRefundSourceRefundAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointRefundSourceRefundAggregationSelection'] = ResolversParentTypes['FlexFinancialDataPointRefundSourceRefundAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointRefundSourceRefundNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection'] = ResolversParentTypes['FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection']> = {
  agreementId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  caseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  caseOrAgreementId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointSourceDocumentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointSourceDocumentConnection'] = ResolversParentTypes['FlexFinancialDataPointSourceDocumentConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexFinancialDataPointSourceDocumentRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointSourceDocumentRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointSourceDocumentRelationship'] = ResolversParentTypes['FlexFinancialDataPointSourceDocumentRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Refund'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointSourceRefundConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointSourceRefundConnection'] = ResolversParentTypes['FlexFinancialDataPointSourceRefundConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexFinancialDataPointSourceRefundRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointSourceRefundRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointSourceRefundRelationship'] = ResolversParentTypes['FlexFinancialDataPointSourceRefundRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Refund'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointTreatmentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointTreatmentConnection'] = ResolversParentTypes['FlexFinancialDataPointTreatmentConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexFinancialDataPointTreatmentRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointTreatmentRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointTreatmentRelationship'] = ResolversParentTypes['FlexFinancialDataPointTreatmentRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointTreatmentTreatmentAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointTreatmentTreatmentAggregationSelection'] = ResolversParentTypes['FlexFinancialDataPointTreatmentTreatmentAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection'] = ResolversParentTypes['FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexFinancialDataPointsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexFinancialDataPointsConnection'] = ResolversParentTypes['FlexFinancialDataPointsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexFinancialDataPointEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueriesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueriesConnection'] = ResolversParentTypes['FlexQueriesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexQueryEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQuery'] = ResolversParentTypes['FlexQuery']> = {
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<FlexQueryCreatedByArgs, 'directed'>>;
  createdByAggregate?: Resolver<Maybe<ResolversTypes['FlexQueryUserCreatedByAggregationSelection']>, ParentType, ContextType, RequireFields<FlexQueryCreatedByAggregateArgs, 'directed'>>;
  createdByConnection?: Resolver<ResolversTypes['FlexQueryCreatedByConnection'], ParentType, ContextType, RequireFields<FlexQueryCreatedByConnectionArgs, 'directed'>>;
  createdOn?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  cypherQuery?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paramsConfig?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  runs?: Resolver<Array<ResolversTypes['FlexQueryRun']>, ParentType, ContextType, RequireFields<FlexQueryRunsArgs, 'directed'>>;
  runsAggregate?: Resolver<Maybe<ResolversTypes['FlexQueryFlexQueryRunRunsAggregationSelection']>, ParentType, ContextType, RequireFields<FlexQueryRunsAggregateArgs, 'directed'>>;
  runsConnection?: Resolver<ResolversTypes['FlexQueryRunsConnection'], ParentType, ContextType, RequireFields<FlexQueryRunsConnectionArgs, 'directed'>>;
  updatedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<FlexQueryUpdatedByArgs, 'directed'>>;
  updatedByAggregate?: Resolver<Maybe<ResolversTypes['FlexQueryUserUpdatedByAggregationSelection']>, ParentType, ContextType, RequireFields<FlexQueryUpdatedByAggregateArgs, 'directed'>>;
  updatedByConnection?: Resolver<ResolversTypes['FlexQueryUpdatedByConnection'], ParentType, ContextType, RequireFields<FlexQueryUpdatedByConnectionArgs, 'directed'>>;
  updatedOn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryCreatedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryCreatedByConnection'] = ResolversParentTypes['FlexQueryCreatedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexQueryCreatedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryCreatedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryCreatedByRelationship'] = ResolversParentTypes['FlexQueryCreatedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryEdge'] = ResolversParentTypes['FlexQueryEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexQuery'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryFlexQueryRunRunsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryFlexQueryRunRunsAggregationSelection'] = ResolversParentTypes['FlexQueryFlexQueryRunRunsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexQueryFlexQueryRunRunsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryFlexQueryRunRunsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryFlexQueryRunRunsNodeAggregateSelection'] = ResolversParentTypes['FlexQueryFlexQueryRunRunsNodeAggregateSelection']> = {
  lastExecutionOn?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  serializedParams?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryRunResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryRun'] = ResolversParentTypes['FlexQueryRun']> = {
  lastExecutionOn?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  query?: Resolver<ResolversTypes['FlexQuery'], ParentType, ContextType, RequireFields<FlexQueryRunQueryArgs, 'directed'>>;
  queryAggregate?: Resolver<Maybe<ResolversTypes['FlexQueryRunFlexQueryQueryAggregationSelection']>, ParentType, ContextType, RequireFields<FlexQueryRunQueryAggregateArgs, 'directed'>>;
  queryConnection?: Resolver<ResolversTypes['FlexQueryRunQueryConnection'], ParentType, ContextType, RequireFields<FlexQueryRunQueryConnectionArgs, 'directed'>>;
  serializedParams?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<FlexQueryRunStartedByArgs, 'directed'>>;
  startedByAggregate?: Resolver<Maybe<ResolversTypes['FlexQueryRunUserStartedByAggregationSelection']>, ParentType, ContextType, RequireFields<FlexQueryRunStartedByAggregateArgs, 'directed'>>;
  startedByConnection?: Resolver<ResolversTypes['FlexQueryRunStartedByConnection'], ParentType, ContextType, RequireFields<FlexQueryRunStartedByConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryRunEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryRunEdge'] = ResolversParentTypes['FlexQueryRunEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexQueryRun'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryRunFlexQueryQueryAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryRunFlexQueryQueryAggregationSelection'] = ResolversParentTypes['FlexQueryRunFlexQueryQueryAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexQueryRunFlexQueryQueryNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryRunFlexQueryQueryNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryRunFlexQueryQueryNodeAggregateSelection'] = ResolversParentTypes['FlexQueryRunFlexQueryQueryNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  cypherQuery?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  paramsConfig?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  updatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryRunQueryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryRunQueryConnection'] = ResolversParentTypes['FlexQueryRunQueryConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexQueryRunQueryRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryRunQueryRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryRunQueryRelationship'] = ResolversParentTypes['FlexQueryRunQueryRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexQuery'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryRunStartedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryRunStartedByConnection'] = ResolversParentTypes['FlexQueryRunStartedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexQueryRunStartedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryRunStartedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryRunStartedByRelationship'] = ResolversParentTypes['FlexQueryRunStartedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryRunUserStartedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryRunUserStartedByAggregationSelection'] = ResolversParentTypes['FlexQueryRunUserStartedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexQueryRunUserStartedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryRunUserStartedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryRunUserStartedByNodeAggregateSelection'] = ResolversParentTypes['FlexQueryRunUserStartedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryRunsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryRunsConnection'] = ResolversParentTypes['FlexQueryRunsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexQueryRunsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryRunsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryRunsRelationship'] = ResolversParentTypes['FlexQueryRunsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexQueryRun'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryUpdatedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryUpdatedByConnection'] = ResolversParentTypes['FlexQueryUpdatedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FlexQueryUpdatedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryUpdatedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryUpdatedByRelationship'] = ResolversParentTypes['FlexQueryUpdatedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryUserCreatedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryUserCreatedByAggregationSelection'] = ResolversParentTypes['FlexQueryUserCreatedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexQueryUserCreatedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryUserCreatedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryUserCreatedByNodeAggregateSelection'] = ResolversParentTypes['FlexQueryUserCreatedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryUserUpdatedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryUserUpdatedByAggregationSelection'] = ResolversParentTypes['FlexQueryUserUpdatedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['FlexQueryUserUpdatedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexQueryUserUpdatedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexQueryUserUpdatedByNodeAggregateSelection'] = ResolversParentTypes['FlexQueryUserUpdatedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FloatAggregateSelectionNonNullableResolvers<ContextType = any, ParentType extends ResolversParentTypes['FloatAggregateSelectionNonNullable'] = ResolversParentTypes['FloatAggregateSelectionNonNullable']> = {
  average?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  max?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sum?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FloatAggregateSelectionNullableResolvers<ContextType = any, ParentType extends ResolversParentTypes['FloatAggregateSelectionNullable'] = ResolversParentTypes['FloatAggregateSelectionNullable']> = {
  average?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericResolvers<ContextType = any, ParentType extends ResolversParentTypes['Generic'] = ResolversParentTypes['Generic']> = {
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  agreementCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<GenericCreatedByArgs, 'directed'>>;
  createdByAggregate?: Resolver<Maybe<ResolversTypes['GenericUserCreatedByAggregationSelection']>, ParentType, ContextType, RequireFields<GenericCreatedByAggregateArgs, 'directed'>>;
  createdByConnection?: Resolver<ResolversTypes['GenericCreatedByConnection'], ParentType, ContextType, RequireFields<GenericCreatedByConnectionArgs, 'directed'>>;
  creationWay?: Resolver<ResolversTypes['MasterDataCreationWay'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  preparations?: Resolver<Array<ResolversTypes['Preparation']>, ParentType, ContextType, RequireFields<GenericPreparationsArgs, 'directed'>>;
  preparationsAggregate?: Resolver<Maybe<ResolversTypes['GenericPreparationPreparationsAggregationSelection']>, ParentType, ContextType, RequireFields<GenericPreparationsAggregateArgs, 'directed'>>;
  preparationsConnection?: Resolver<ResolversTypes['GenericPreparationsConnection'], ParentType, ContextType, RequireFields<GenericPreparationsConnectionArgs, 'directed'>>;
  treatmentSets?: Resolver<Array<ResolversTypes['TreatmentSet']>, ParentType, ContextType, RequireFields<GenericTreatmentSetsArgs, 'directed'>>;
  treatmentSetsAggregate?: Resolver<Maybe<ResolversTypes['GenericTreatmentSetTreatmentSetsAggregationSelection']>, ParentType, ContextType, RequireFields<GenericTreatmentSetsAggregateArgs, 'directed'>>;
  treatmentSetsConnection?: Resolver<ResolversTypes['GenericTreatmentSetsConnection'], ParentType, ContextType, RequireFields<GenericTreatmentSetsConnectionArgs, 'directed'>>;
  usedInRecordOrForms?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericCreatedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericCreatedByConnection'] = ResolversParentTypes['GenericCreatedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['GenericCreatedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericCreatedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericCreatedByRelationship'] = ResolversParentTypes['GenericCreatedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericEdge'] = ResolversParentTypes['GenericEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Generic'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericPreparationPreparationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericPreparationPreparationsAggregationSelection'] = ResolversParentTypes['GenericPreparationPreparationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['GenericPreparationPreparationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericPreparationPreparationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericPreparationPreparationsNodeAggregateSelection'] = ResolversParentTypes['GenericPreparationPreparationsNodeAggregateSelection']> = {
  AtcCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  BrandName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GenericName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo5?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericPreparationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericPreparationsConnection'] = ResolversParentTypes['GenericPreparationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['GenericPreparationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericPreparationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericPreparationsRelationship'] = ResolversParentTypes['GenericPreparationsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Preparation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericTreatmentSetTreatmentSetsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericTreatmentSetTreatmentSetsAggregationSelection'] = ResolversParentTypes['GenericTreatmentSetTreatmentSetsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['GenericTreatmentSetTreatmentSetsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericTreatmentSetTreatmentSetsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericTreatmentSetTreatmentSetsNodeAggregateSelection'] = ResolversParentTypes['GenericTreatmentSetTreatmentSetsNodeAggregateSelection']> = {
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericTreatmentSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericTreatmentSetsConnection'] = ResolversParentTypes['GenericTreatmentSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['GenericTreatmentSetsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericTreatmentSetsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericTreatmentSetsRelationship'] = ResolversParentTypes['GenericTreatmentSetsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TreatmentSet'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericUserCreatedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericUserCreatedByAggregationSelection'] = ResolversParentTypes['GenericUserCreatedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['GenericUserCreatedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericUserCreatedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericUserCreatedByNodeAggregateSelection'] = ResolversParentTypes['GenericUserCreatedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericsConnection'] = ResolversParentTypes['GenericsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['GenericEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetBrandReportItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetBrandReportItem'] = ResolversParentTypes['GetBrandReportItem']> = {
  agreementIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  caseIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  disease?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  indicationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  patientIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetBrandReportItemEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetBrandReportItemEdge'] = ResolversParentTypes['GetBrandReportItemEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['GetBrandReportItem'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetBrandReportItemsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetBrandReportItemsConnection'] = ResolversParentTypes['GetBrandReportItemsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['GetBrandReportItemEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetIndicationReportItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetIndicationReportItem'] = ResolversParentTypes['GetIndicationReportItem']> = {
  agreementIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  brands?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  caseIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  disease?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  indication?: Resolver<Maybe<ResolversTypes['Indication']>, ParentType, ContextType>;
  patientIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetIndicationReportItemEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetIndicationReportItemEdge'] = ResolversParentTypes['GetIndicationReportItemEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['GetIndicationReportItem'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetIndicationReportItemsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetIndicationReportItemsConnection'] = ResolversParentTypes['GetIndicationReportItemsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['GetIndicationReportItemEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GlobalLockResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalLock'] = ResolversParentTypes['GlobalLock']> = {
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<GlobalLockCreatorArgs, 'directed'>>;
  creatorAggregate?: Resolver<Maybe<ResolversTypes['GlobalLockUserCreatorAggregationSelection']>, ParentType, ContextType, RequireFields<GlobalLockCreatorAggregateArgs, 'directed'>>;
  creatorConnection?: Resolver<ResolversTypes['GlobalLockCreatorConnection'], ParentType, ContextType, RequireFields<GlobalLockCreatorConnectionArgs, 'directed'>>;
  heldBy?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lockType?: Resolver<ResolversTypes['LockType'], ParentType, ContextType>;
  resourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GlobalLockCreatorConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalLockCreatorConnection'] = ResolversParentTypes['GlobalLockCreatorConnection']> = {
  edges?: Resolver<Array<ResolversTypes['GlobalLockCreatorRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GlobalLockCreatorRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalLockCreatorRelationship'] = ResolversParentTypes['GlobalLockCreatorRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GlobalLockEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalLockEdge'] = ResolversParentTypes['GlobalLockEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['GlobalLock'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GlobalLockUserCreatorAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalLockUserCreatorAggregationSelection'] = ResolversParentTypes['GlobalLockUserCreatorAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['GlobalLockUserCreatorNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GlobalLockUserCreatorNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalLockUserCreatorNodeAggregateSelection'] = ResolversParentTypes['GlobalLockUserCreatorNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GlobalLocksConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalLocksConnection'] = ResolversParentTypes['GlobalLocksConnection']> = {
  edges?: Resolver<Array<ResolversTypes['GlobalLockEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdAggregateSelectionNonNullableResolvers<ContextType = any, ParentType extends ResolversParentTypes['IDAggregateSelectionNonNullable'] = ResolversParentTypes['IDAggregateSelectionNonNullable']> = {
  longest?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  shortest?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdAggregateSelectionNullableResolvers<ContextType = any, ParentType extends ResolversParentTypes['IDAggregateSelectionNullable'] = ResolversParentTypes['IDAggregateSelectionNullable']> = {
  longest?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  shortest?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ITimeframeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ITimeframe'] = ResolversParentTypes['ITimeframe']> = {
  __resolveType: TypeResolveFn<'ScenarioAction' | 'ScenarioCondition', ParentType, ContextType>;
  rollingRangeType?: Resolver<Maybe<ResolversTypes['RollingRangeType']>, ParentType, ContextType>;
  startingPoint?: Resolver<Maybe<ResolversTypes['TimeframeStartingPoint']>, ParentType, ContextType>;
  timeframeEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeframeRangeType?: Resolver<Maybe<ResolversTypes['TimeframeRangeType']>, ParentType, ContextType>;
  timeframeRelation?: Resolver<Maybe<ResolversTypes['TimeframeRelation']>, ParentType, ContextType>;
  timeframeStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type ITreatmentConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ITreatmentCondition'] = ResolversParentTypes['ITreatmentCondition']> = {
  __resolveType: TypeResolveFn<'ScenarioCondition', ParentType, ContextType>;
  brands?: Resolver<Maybe<Array<ResolversTypes['Brand']>>, ParentType, ContextType>;
  generics?: Resolver<Maybe<Array<ResolversTypes['Generic']>>, ParentType, ContextType>;
  treatments?: Resolver<Maybe<Array<ResolversTypes['Treatment']>>, ParentType, ContextType>;
};

export type Icd10AttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10Attribute'] = ResolversParentTypes['Icd10Attribute']> = {
  BeginOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  EndOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  RelationshipScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  Score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  Text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Traits?: Resolver<Maybe<Array<Maybe<ResolversTypes['Icd10Trait']>>>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10AttributeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10AttributeEdge'] = ResolversParentTypes['Icd10AttributeEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Icd10Attribute'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10AttributesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10AttributesConnection'] = ResolversParentTypes['Icd10AttributesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Icd10AttributeEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10ConceptResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10Concept'] = ResolversParentTypes['Icd10Concept']> = {
  Code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10ConceptEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10ConceptEdge'] = ResolversParentTypes['Icd10ConceptEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Icd10Concept'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10ConceptsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10ConceptsConnection'] = ResolversParentTypes['Icd10ConceptsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Icd10ConceptEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10EntitiesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10EntitiesConnection'] = ResolversParentTypes['Icd10EntitiesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Icd10EntityEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10EntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10Entity'] = ResolversParentTypes['Icd10Entity']> = {
  Attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Icd10Attribute']>>>, ParentType, ContextType>;
  BeginOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  EndOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ICD10CMConcepts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Icd10Concept']>>>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  Text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Traits?: Resolver<Maybe<Array<Maybe<ResolversTypes['Icd10Trait']>>>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10EntityEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10EntityEdge'] = ResolversParentTypes['Icd10EntityEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Icd10Entity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10SuggestionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10Suggestions'] = ResolversParentTypes['Icd10Suggestions']> = {
  Entities?: Resolver<Maybe<Array<Maybe<ResolversTypes['Icd10Entity']>>>, ParentType, ContextType>;
  ModelVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PaginationToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10SuggestionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10SuggestionsConnection'] = ResolversParentTypes['Icd10SuggestionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Icd10SuggestionsEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10SuggestionsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10SuggestionsEdge'] = ResolversParentTypes['Icd10SuggestionsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Icd10Suggestions'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10TraitResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10Trait'] = ResolversParentTypes['Icd10Trait']> = {
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10TraitEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10TraitEdge'] = ResolversParentTypes['Icd10TraitEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Icd10Trait'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Icd10TraitsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icd10TraitsConnection'] = ResolversParentTypes['Icd10TraitsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Icd10TraitEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactItem'] = ResolversParentTypes['ImpactItem']> = {
  category?: Resolver<ResolversTypes['ImpactCategory'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['ImpactSeverity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactItemEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactItemEdge'] = ResolversParentTypes['ImpactItemEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ImpactItem'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImpactItemsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactItemsConnection'] = ResolversParentTypes['ImpactItemsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ImpactItemEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IndicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Indication'] = ResolversParentTypes['Indication']> = {
  agreementCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  intent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  intentLocalizationKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isCustom?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  line?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lineLocalizationKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modelCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mutation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mutationLocalizationKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizations?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeLocalizationKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IndicationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['IndicationEdge'] = ResolversParentTypes['IndicationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Indication'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IndicationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IndicationsConnection'] = ResolversParentTypes['IndicationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['IndicationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntAggregateSelectionNonNullableResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntAggregateSelectionNonNullable'] = ResolversParentTypes['IntAggregateSelectionNonNullable']> = {
  average?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  max?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sum?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntAggregateSelectionNullableResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntAggregateSelectionNullable'] = ResolversParentTypes['IntAggregateSelectionNullable']> = {
  average?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrityCheckCompleteResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrityCheckCompleteResult'] = ResolversParentTypes['IntegrityCheckCompleteResult']> = {
  dbNodeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  failedChecks?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrityCheckCompleteResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrityCheckCompleteResultEdge'] = ResolversParentTypes['IntegrityCheckCompleteResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['IntegrityCheckCompleteResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrityCheckCompleteResultsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrityCheckCompleteResultsConnection'] = ResolversParentTypes['IntegrityCheckCompleteResultsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['IntegrityCheckCompleteResultEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrityCheckTypesResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrityCheckTypes'] = ResolversParentTypes['IntegrityCheckTypes']> = {
  all?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  inQueue?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrityCheckTypesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrityCheckTypesConnection'] = ResolversParentTypes['IntegrityCheckTypesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['IntegrityCheckTypesEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrityCheckTypesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrityCheckTypesEdge'] = ResolversParentTypes['IntegrityCheckTypesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['IntegrityCheckTypes'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Limitation'] = ResolversParentTypes['Limitation']> = {
  Code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DescriptionDe?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  DescriptionEn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DescriptionFr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DescriptionIt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HasPriceModel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  Niveau?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValidFromDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  ValidThruDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  agreementTemplate?: Resolver<Maybe<ResolversTypes['AgreementTemplate']>, ParentType, ContextType, RequireFields<LimitationAgreementTemplateArgs, 'directed'>>;
  agreementTemplateAggregate?: Resolver<Maybe<ResolversTypes['LimitationAgreementTemplateAgreementTemplateAggregationSelection']>, ParentType, ContextType, RequireFields<LimitationAgreementTemplateAggregateArgs, 'directed'>>;
  agreementTemplateConnection?: Resolver<ResolversTypes['LimitationAgreementTemplateConnection'], ParentType, ContextType, RequireFields<LimitationAgreementTemplateConnectionArgs, 'directed'>>;
  createdOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  isClassified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isValidFromDateSetByImportDate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  limitsPreparations?: Resolver<Array<ResolversTypes['Preparation']>, ParentType, ContextType, RequireFields<LimitationLimitsPreparationsArgs, 'directed'>>;
  limitsPreparationsAggregate?: Resolver<Maybe<ResolversTypes['LimitationPreparationLimitsPreparationsAggregationSelection']>, ParentType, ContextType, RequireFields<LimitationLimitsPreparationsAggregateArgs, 'directed'>>;
  limitsPreparationsConnection?: Resolver<ResolversTypes['LimitationLimitsPreparationsConnection'], ParentType, ContextType, RequireFields<LimitationLimitsPreparationsConnectionArgs, 'directed'>>;
  limitsTreatment?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType>;
  limitsTreatmentsBySelf?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<LimitationLimitsTreatmentsBySelfArgs, 'directed'>>;
  limitsTreatmentsBySelfAggregate?: Resolver<Maybe<ResolversTypes['LimitationTreatmentLimitsTreatmentsBySelfAggregationSelection']>, ParentType, ContextType, RequireFields<LimitationLimitsTreatmentsBySelfAggregateArgs, 'directed'>>;
  limitsTreatmentsBySelfConnection?: Resolver<ResolversTypes['LimitationLimitsTreatmentsBySelfConnection'], ParentType, ContextType, RequireFields<LimitationLimitsTreatmentsBySelfConnectionArgs, 'directed'>>;
  limitsTreatmentsThroughPreparation?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<LimitationLimitsTreatmentsThroughPreparationArgs, 'directed'>>;
  limitsTreatmentsThroughPreparationAggregate?: Resolver<Maybe<ResolversTypes['LimitationTreatmentLimitsTreatmentsThroughPreparationAggregationSelection']>, ParentType, ContextType, RequireFields<LimitationLimitsTreatmentsThroughPreparationAggregateArgs, 'directed'>>;
  limitsTreatmentsThroughPreparationConnection?: Resolver<ResolversTypes['LimitationLimitsTreatmentsThroughPreparationConnection'], ParentType, ContextType, RequireFields<LimitationLimitsTreatmentsThroughPreparationConnectionArgs, 'directed'>>;
  uuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationAgreementTemplateAgreementTemplateAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationAgreementTemplateAgreementTemplateAggregationSelection'] = ResolversParentTypes['LimitationAgreementTemplateAgreementTemplateAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['LimitationAgreementTemplateAgreementTemplateNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationAgreementTemplateAgreementTemplateNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationAgreementTemplateAgreementTemplateNodeAggregateSelection'] = ResolversParentTypes['LimitationAgreementTemplateAgreementTemplateNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  treatments?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationAgreementTemplateConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationAgreementTemplateConnection'] = ResolversParentTypes['LimitationAgreementTemplateConnection']> = {
  edges?: Resolver<Array<ResolversTypes['LimitationAgreementTemplateRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationAgreementTemplateRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationAgreementTemplateRelationship'] = ResolversParentTypes['LimitationAgreementTemplateRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationEdge'] = ResolversParentTypes['LimitationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Limitation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationLimitsPreparationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationLimitsPreparationsConnection'] = ResolversParentTypes['LimitationLimitsPreparationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['LimitationLimitsPreparationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationLimitsPreparationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationLimitsPreparationsRelationship'] = ResolversParentTypes['LimitationLimitsPreparationsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Preparation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationLimitsTreatmentsBySelfConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationLimitsTreatmentsBySelfConnection'] = ResolversParentTypes['LimitationLimitsTreatmentsBySelfConnection']> = {
  edges?: Resolver<Array<ResolversTypes['LimitationLimitsTreatmentsBySelfRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationLimitsTreatmentsBySelfRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationLimitsTreatmentsBySelfRelationship'] = ResolversParentTypes['LimitationLimitsTreatmentsBySelfRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationLimitsTreatmentsThroughPreparationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationLimitsTreatmentsThroughPreparationConnection'] = ResolversParentTypes['LimitationLimitsTreatmentsThroughPreparationConnection']> = {
  edges?: Resolver<Array<ResolversTypes['LimitationLimitsTreatmentsThroughPreparationRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationLimitsTreatmentsThroughPreparationRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationLimitsTreatmentsThroughPreparationRelationship'] = ResolversParentTypes['LimitationLimitsTreatmentsThroughPreparationRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationPreparationLimitsPreparationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationPreparationLimitsPreparationsAggregationSelection'] = ResolversParentTypes['LimitationPreparationLimitsPreparationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['LimitationPreparationLimitsPreparationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationPreparationLimitsPreparationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationPreparationLimitsPreparationsNodeAggregateSelection'] = ResolversParentTypes['LimitationPreparationLimitsPreparationsNodeAggregateSelection']> = {
  AtcCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  BrandName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GenericName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo5?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationTreatmentLimitsTreatmentsBySelfAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationTreatmentLimitsTreatmentsBySelfAggregationSelection'] = ResolversParentTypes['LimitationTreatmentLimitsTreatmentsBySelfAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['LimitationTreatmentLimitsTreatmentsBySelfNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationTreatmentLimitsTreatmentsBySelfNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationTreatmentLimitsTreatmentsBySelfNodeAggregateSelection'] = ResolversParentTypes['LimitationTreatmentLimitsTreatmentsBySelfNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationTreatmentLimitsTreatmentsThroughPreparationAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationTreatmentLimitsTreatmentsThroughPreparationAggregationSelection'] = ResolversParentTypes['LimitationTreatmentLimitsTreatmentsThroughPreparationAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['LimitationTreatmentLimitsTreatmentsThroughPreparationNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationTreatmentLimitsTreatmentsThroughPreparationNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationTreatmentLimitsTreatmentsThroughPreparationNodeAggregateSelection'] = ResolversParentTypes['LimitationTreatmentLimitsTreatmentsThroughPreparationNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitationsConnection'] = ResolversParentTypes['LimitationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['LimitationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocalizationKeySuggestionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocalizationKeySuggestions'] = ResolversParentTypes['LocalizationKeySuggestions']> = {
  localizationKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocalizationKeySuggestionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocalizationKeySuggestionsConnection'] = ResolversParentTypes['LocalizationKeySuggestionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['LocalizationKeySuggestionsEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocalizationKeySuggestionsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocalizationKeySuggestionsEdge'] = ResolversParentTypes['LocalizationKeySuggestionsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['LocalizationKeySuggestions'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainIndicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainIndication'] = ResolversParentTypes['MainIndication']> = {
  article71Indication?: Resolver<ResolversTypes['Article71Indication'], ParentType, ContextType, RequireFields<MainIndicationArticle71IndicationArgs, 'directed'>>;
  article71IndicationAggregate?: Resolver<Maybe<ResolversTypes['MainIndicationArticle71IndicationArticle71IndicationAggregationSelection']>, ParentType, ContextType, RequireFields<MainIndicationArticle71IndicationAggregateArgs, 'directed'>>;
  article71IndicationConnection?: Resolver<ResolversTypes['MainIndicationArticle71IndicationConnection'], ParentType, ContextType, RequireFields<MainIndicationArticle71IndicationConnectionArgs, 'directed'>>;
  brand?: Resolver<ResolversTypes['Brand'], ParentType, ContextType, RequireFields<MainIndicationBrandArgs, 'directed'>>;
  brandAggregate?: Resolver<Maybe<ResolversTypes['MainIndicationBrandBrandAggregationSelection']>, ParentType, ContextType, RequireFields<MainIndicationBrandAggregateArgs, 'directed'>>;
  brandConnection?: Resolver<ResolversTypes['MainIndicationBrandConnection'], ParentType, ContextType, RequireFields<MainIndicationBrandConnectionArgs, 'directed'>>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  validFromDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  validToDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainIndicationArticle71IndicationArticle71IndicationAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainIndicationArticle71IndicationArticle71IndicationAggregationSelection'] = ResolversParentTypes['MainIndicationArticle71IndicationArticle71IndicationAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection'] = ResolversParentTypes['MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection']> = {
  countryScopeId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  notes?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainIndicationArticle71IndicationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainIndicationArticle71IndicationConnection'] = ResolversParentTypes['MainIndicationArticle71IndicationConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MainIndicationArticle71IndicationRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainIndicationArticle71IndicationRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainIndicationArticle71IndicationRelationship'] = ResolversParentTypes['MainIndicationArticle71IndicationRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Article71Indication'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainIndicationBrandBrandAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainIndicationBrandBrandAggregationSelection'] = ResolversParentTypes['MainIndicationBrandBrandAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['MainIndicationBrandBrandNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainIndicationBrandBrandNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainIndicationBrandBrandNodeAggregateSelection'] = ResolversParentTypes['MainIndicationBrandBrandNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  art71DataLastUpdatedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  art71DataLastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainIndicationBrandConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainIndicationBrandConnection'] = ResolversParentTypes['MainIndicationBrandConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MainIndicationBrandRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainIndicationBrandRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainIndicationBrandRelationship'] = ResolversParentTypes['MainIndicationBrandRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Brand'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainIndicationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainIndicationEdge'] = ResolversParentTypes['MainIndicationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['MainIndication'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainIndicationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainIndicationsConnection'] = ResolversParentTypes['MainIndicationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MainIndicationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MasterDataRefundImpactResolvers<ContextType = any, ParentType extends ResolversParentTypes['MasterDataRefundImpact'] = ResolversParentTypes['MasterDataRefundImpact']> = {
  agreementVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  documentCreator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentReviewer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refundId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MasterDataRefundImpactEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MasterDataRefundImpactEdge'] = ResolversParentTypes['MasterDataRefundImpactEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['MasterDataRefundImpact'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MasterDataRefundImpactsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MasterDataRefundImpactsConnection'] = ResolversParentTypes['MasterDataRefundImpactsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MasterDataRefundImpactEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MasterDataUploadHistoryRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MasterDataUploadHistoryRecord'] = ResolversParentTypes['MasterDataUploadHistoryRecord']> = {
  confirmedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  confirmedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  report?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['MasterDataUploadStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MasterDataUploadHistoryRecordEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MasterDataUploadHistoryRecordEdge'] = ResolversParentTypes['MasterDataUploadHistoryRecordEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['MasterDataUploadHistoryRecord'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MasterDataUploadHistoryRecordsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MasterDataUploadHistoryRecordsConnection'] = ResolversParentTypes['MasterDataUploadHistoryRecordsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MasterDataUploadHistoryRecordEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  case?: Resolver<ResolversTypes['Case'], ParentType, ContextType, RequireFields<MessageCaseArgs, 'directed'>>;
  caseAggregate?: Resolver<Maybe<ResolversTypes['MessageCaseCaseAggregationSelection']>, ParentType, ContextType, RequireFields<MessageCaseAggregateArgs, 'directed'>>;
  caseConnection?: Resolver<ResolversTypes['MessageCaseConnection'], ParentType, ContextType, RequireFields<MessageCaseConnectionArgs, 'directed'>>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdOn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mentions?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MessageMentionsArgs, 'directed'>>;
  mentionsAggregate?: Resolver<Maybe<ResolversTypes['MessageUserMentionsAggregationSelection']>, ParentType, ContextType, RequireFields<MessageMentionsAggregateArgs, 'directed'>>;
  mentionsConnection?: Resolver<ResolversTypes['MessageMentionsConnection'], ParentType, ContextType, RequireFields<MessageMentionsConnectionArgs, 'directed'>>;
  sentBy?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MessageSentByArgs, 'directed'>>;
  sentByAggregate?: Resolver<Maybe<ResolversTypes['MessageUserSentByAggregationSelection']>, ParentType, ContextType, RequireFields<MessageSentByAggregateArgs, 'directed'>>;
  sentByConnection?: Resolver<ResolversTypes['MessageSentByConnection'], ParentType, ContextType, RequireFields<MessageSentByConnectionArgs, 'directed'>>;
  tenantIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageCaseCaseAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageCaseCaseAggregationSelection'] = ResolversParentTypes['MessageCaseCaseAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['MessageCaseCaseNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageCaseCaseNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageCaseCaseNodeAggregateSelection'] = ResolversParentTypes['MessageCaseCaseNodeAggregateSelection']> = {
  creationDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  preparationBrandName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  submissionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageCaseConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageCaseConnection'] = ResolversParentTypes['MessageCaseConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MessageCaseRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageCaseRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageCaseRelationship'] = ResolversParentTypes['MessageCaseRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Case'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageEdge'] = ResolversParentTypes['MessageEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Message'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageMentionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageMentionsConnection'] = ResolversParentTypes['MessageMentionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MessageMentionsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageMentionsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageMentionsRelationship'] = ResolversParentTypes['MessageMentionsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageSentByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageSentByConnection'] = ResolversParentTypes['MessageSentByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MessageSentByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageSentByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageSentByRelationship'] = ResolversParentTypes['MessageSentByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageUserMentionsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageUserMentionsAggregationSelection'] = ResolversParentTypes['MessageUserMentionsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['MessageUserMentionsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageUserMentionsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageUserMentionsNodeAggregateSelection'] = ResolversParentTypes['MessageUserMentionsNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageUserSentByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageUserSentByAggregationSelection'] = ResolversParentTypes['MessageUserSentByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['MessageUserSentByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageUserSentByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageUserSentByNodeAggregateSelection'] = ResolversParentTypes['MessageUserSentByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagesConnection'] = ResolversParentTypes['MessagesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MessageEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MissingTranslationKeysResolvers<ContextType = any, ParentType extends ResolversParentTypes['MissingTranslationKeys'] = ResolversParentTypes['MissingTranslationKeys']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  language?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serverEnvironment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timeStamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MissingTranslationKeysConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MissingTranslationKeysConnection'] = ResolversParentTypes['MissingTranslationKeysConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MissingTranslationKeysEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MissingTranslationKeysEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MissingTranslationKeysEdge'] = ResolversParentTypes['MissingTranslationKeysEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['MissingTranslationKeys'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ModuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Module'] = ResolversParentTypes['Module']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ModuleEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModuleEdge'] = ResolversParentTypes['ModuleEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Module'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ModulesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModulesConnection'] = ResolversParentTypes['ModulesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ModuleEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  AddModule?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAddModuleArgs, 'id' | 'orgId'>>;
  AddTranslations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAddTranslationsArgs, 'orgId'>>;
  AddUserSubscribed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationAddUserSubscribedArgs, 'notificationId' | 'orgId' | 'userId'>>;
  ApplyDefaultUserRolesToAll?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationApplyDefaultUserRolesToAllArgs>>;
  ArchiveFlexEntity?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType, RequireFields<MutationArchiveFlexEntityArgs, 'id'>>;
  AssignUserDomains?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<MutationAssignUserDomainsArgs>>;
  CancelBagUpload?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  CancelIntegrityChecks?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  CheckSyncAgreements?: Resolver<Array<ResolversTypes['SyncResponse']>, ParentType, ContextType, RequireFields<MutationCheckSyncAgreementsArgs, 'agreementIds' | 'syncTypes' | 'templateId'>>;
  CreateApiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationCreateApiKeyArgs, 'owner'>>;
  CreateDocument?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationCreateDocumentArgs, 'createdByEmail' | 'organizationName' | 'refundIds' | 'tenantId'>>;
  CreateNewTermAndPolicyVersion?: Resolver<ResolversTypes['PolicyVersion'], ParentType, ContextType, RequireFields<MutationCreateNewTermAndPolicyVersionArgs, 'input'>>;
  CreateOrUpdateBrandIndications?: Resolver<Maybe<ResolversTypes['Brand']>, ParentType, ContextType, RequireFields<MutationCreateOrUpdateBrandIndicationsArgs, 'input'>>;
  CreateOrUpdateFlexQuery?: Resolver<ResolversTypes['QueryResult'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateFlexQueryArgs, 'input'>>;
  CreateOrUpdateGeneric?: Resolver<Maybe<ResolversTypes['Generic']>, ParentType, ContextType, RequireFields<MutationCreateOrUpdateGenericArgs, 'input'>>;
  CreateOrUpdatePerformanceCounters?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationCreateOrUpdatePerformanceCountersArgs, 'input'>>;
  CreateOrUpdateProductBlueprint?: Resolver<ResolversTypes['ProductBlueprint'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateProductBlueprintArgs, 'input'>>;
  CreateOrganization?: Resolver<Maybe<ResolversTypes['AuthOrganization']>, ParentType, ContextType, RequireFields<MutationCreateOrganizationArgs, 'agreementRunTriggers' | 'country' | 'name' | 'paymentTerms'>>;
  CreateSftpDirectory?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationCreateSftpDirectoryArgs, 'parent'>>;
  CreateUser?: Resolver<Maybe<ResolversTypes['StoreUser']>, ParentType, ContextType, Partial<MutationCreateUserArgs>>;
  DeleteAgreement?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteAgreementArgs, 'id'>>;
  DeleteCustomCondition?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteCustomConditionArgs, 'id'>>;
  DeleteDocument?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<MutationDeleteDocumentArgs>>;
  DeleteFlexQuery?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteFlexQueryArgs, 'id'>>;
  DeleteGeneric?: Resolver<Maybe<ResolversTypes['Generic']>, ParentType, ContextType, RequireFields<MutationDeleteGenericArgs, 'id'>>;
  DeleteSimulations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationDeleteSimulationsArgs>>;
  DeleteTranslationKeys?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteTranslationKeysArgs, 'environment' | 'keys' | 'languages' | 'tenantId'>>;
  DeleteTranslationValue?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteTranslationValueArgs, 'environment' | 'language' | 'tenantId'>>;
  DeleteUser?: Resolver<Maybe<ResolversTypes['StoreUser']>, ParentType, ContextType, Partial<MutationDeleteUserArgs>>;
  FlushAirtableCache?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FlushCoreChosenCache?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationFlushCoreChosenCacheArgs>>;
  MigrateAllSimulatorData?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  RefreshApiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationRefreshApiKeyArgs, 'owner'>>;
  ReleaseSimulatorMigrationLock?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  RemoveModule?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationRemoveModuleArgs, 'id'>>;
  RemoveSftpDirectory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationRemoveSftpDirectoryArgs, 'path'>>;
  RemoveTranslations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationRemoveTranslationsArgs, 'lang' | 'orgId'>>;
  RemoveUserSubscribed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationRemoveUserSubscribedArgs, 'notificationId' | 'orgId' | 'userId'>>;
  RemoveUsersFromValidityExpirationReminderNotification?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationRemoveUsersFromValidityExpirationReminderNotificationArgs, 'input'>>;
  ResendUserRegEmail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationResendUserRegEmailArgs, 'email'>>;
  RevokeApiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationRevokeApiKeyArgs, 'owner'>>;
  RollbackSimulatorMigration?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  RunAgreements?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationRunAgreementsArgs, 'ids'>>;
  RunDataCheck?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationRunDataCheckArgs, 'id'>>;
  RunDataQualityChecks?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  RunIntegrityChecks?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationRunIntegrityChecksArgs, 'typeNames'>>;
  RunQuestAutoCompletion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationRunQuestAutoCompletionArgs, 'organizationId'>>;
  SaveAgreement?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType, RequireFields<MutationSaveAgreementArgs, 'input'>>;
  SaveAgreementTemplate?: Resolver<Maybe<ResolversTypes['AgreementTemplateVersionCreationResponse']>, ParentType, ContextType, RequireFields<MutationSaveAgreementTemplateArgs, 'input'>>;
  SaveAutoDocumentReviewReminderParams?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSaveAutoDocumentReviewReminderParamsArgs, 'organizationId'>>;
  SaveAutoIssuanceParams?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSaveAutoIssuanceParamsArgs, 'organizationId'>>;
  SaveCustomIntegrityChecks?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<MutationSaveCustomIntegrityChecksArgs>>;
  SaveDeviceAgreement?: Resolver<Maybe<ResolversTypes['Agreement']>, ParentType, ContextType, RequireFields<MutationSaveDeviceAgreementArgs, 'input'>>;
  SaveDocumentSftpPath?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSaveDocumentSftpPathArgs, 'organizationId'>>;
  SaveEnabledSsoTypes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSaveEnabledSsoTypesArgs, 'organizationId' | 'ssoTypes'>>;
  SaveFlexEntity?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType, RequireFields<MutationSaveFlexEntityArgs, 'input'>>;
  SaveNotifications?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSaveNotificationsArgs, 'input'>>;
  SaveUploadLimitations?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSaveUploadLimitationsArgs, 'input'>>;
  SetAgreementHidden?: Resolver<Maybe<ResolversTypes['Agreement']>, ParentType, ContextType, RequireFields<MutationSetAgreementHiddenArgs, 'id' | 'isHidden'>>;
  SetAgreementRunTriggersFeature?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetAgreementRunTriggersFeatureArgs, 'organizationId' | 'runTriggers'>>;
  SetAgreementTemplateDeleted?: Resolver<Maybe<ResolversTypes['AgreementTemplate']>, ParentType, ContextType, RequireFields<MutationSetAgreementTemplateDeletedArgs, 'id' | 'isDeleted'>>;
  SetAutomatedRunFrequencyFeature?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetAutomatedRunFrequencyFeatureArgs, 'organizationId'>>;
  SetDownloadPublicAgreementFeature?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetDownloadPublicAgreementFeatureArgs, 'organizationId'>>;
  SetEmailEncryptionFeature?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetEmailEncryptionFeatureArgs, 'input'>>;
  SetLibraryGPTFeature?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetLibraryGptFeatureArgs, 'organizationId'>>;
  SetMonitoring?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationSetMonitoringArgs>>;
  SetNavlinPricesFeature?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetNavlinPricesFeatureArgs, 'organizationId'>>;
  SetPerformanceThreshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetPerformanceThresholdArgs, 'input'>>;
  SetPublicAgreementFeature?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetPublicAgreementFeatureArgs, 'organizationId'>>;
  SetSimulatorBreakdownFeature?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetSimulatorBreakdownFeatureArgs, 'organizationId'>>;
  SetSimulatorModelValidityFeature?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetSimulatorModelValidityFeatureArgs, 'organizationId'>>;
  SetSimulatorPVThresholdsFeature?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetSimulatorPvThresholdsFeatureArgs, 'organizationId'>>;
  SetSimulatorProductInputFeature?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetSimulatorProductInputFeatureArgs, 'organizationId'>>;
  SetSimulatorWasteReportingFeature?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetSimulatorWasteReportingFeatureArgs, 'organizationId'>>;
  SetValidityCoverageFeature?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetValidityCoverageFeatureArgs, 'organizationId'>>;
  SetValueEncapsulatedFeatureUpdate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSetValueEncapsulatedFeatureUpdateArgs, 'featureKey' | 'organizationId'>>;
  StartBagUpload?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationStartBagUploadArgs>>;
  SubmitQuery?: Resolver<ResolversTypes['NinjaQuerySubmitResult'], ParentType, ContextType, RequireFields<MutationSubmitQueryArgs, 'input'>>;
  SubscribeUsersToValidityExpirationReminderNotification?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationSubscribeUsersToValidityExpirationReminderNotificationArgs, 'input'>>;
  SyncAgreements?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSyncAgreementsArgs, 'agreementIds' | 'forceSync' | 'syncTypes' | 'templateId'>>;
  UpdateAgreementCache?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateAgreementCacheArgs>>;
  UpdateAgreementName?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agreement']>>>, ParentType, ContextType, RequireFields<MutationUpdateAgreementNameArgs, 'initialVersionId' | 'input'>>;
  UpdateAgreementScope?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateAgreementScopeArgs, 'input'>>;
  UpdateAgreementUserRoles?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationUpdateAgreementUserRolesArgs>>;
  UpdateConditionSets?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationUpdateConditionSetsArgs, 'scopeCodes'>>;
  UpdateCustomCondition?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateCustomConditionArgs, 'input'>>;
  UpdateDataChecksState?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationUpdateDataChecksStateArgs, 'ids'>>;
  UpdateDefaultUserRole?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateDefaultUserRoleArgs, 'orgId'>>;
  UpdateEncapsulatedFeatureConfiguration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationUpdateEncapsulatedFeatureConfigurationArgs, 'input'>>;
  UpdateIndication?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateIndicationArgs, 'input'>>;
  UpdateLegalEntities?: Resolver<Maybe<Array<Maybe<ResolversTypes['Organization']>>>, ParentType, ContextType, RequireFields<MutationUpdateLegalEntitiesArgs, 'organizationIds'>>;
  UpdateMasterLanguageTranslations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateMasterLanguageTranslationsArgs, 'language' | 'serializedKeys' | 'targetEnvironment'>>;
  UpdateMissingKey?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationUpdateMissingKeyArgs>>;
  UpdateOrganization?: Resolver<Maybe<ResolversTypes['AuthOrganization']>, ParentType, ContextType, RequireFields<MutationUpdateOrganizationArgs, 'agreementRunTriggers' | 'country' | 'emailEncryptionEnabled' | 'id' | 'name' | 'paymentTerms' | 'publicAgreementsEnabled'>>;
  UpdateTranslation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateTranslationArgs, 'payload'>>;
  UpdateUser?: Resolver<Maybe<ResolversTypes['StoreUser']>, ParentType, ContextType, Partial<MutationUpdateUserArgs>>;
  UpdateUserContextFiltersAgreements?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersAgreementsArgs>>;
  UpdateUserContextFiltersBrandIndications?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersBrandIndicationsArgs>>;
  UpdateUserContextFiltersCountries?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersCountriesArgs>>;
  UpdateUserContextFiltersCustomConditions?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersCustomConditionsArgs>>;
  UpdateUserContextFiltersFlexQueries?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersFlexQueriesArgs>>;
  UpdateUserContextFiltersFlexibleFormsRecords?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersFlexibleFormsRecordsArgs>>;
  UpdateUserContextFiltersIndications?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersIndicationsArgs>>;
  UpdateUserContextFiltersLocalization?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersLocalizationArgs>>;
  UpdateUserContextFiltersMissingKeys?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersMissingKeysArgs>>;
  UpdateUserContextFiltersModels?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersModelsArgs>>;
  UpdateUserContextFiltersPerformanceMeasurements?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersPerformanceMeasurementsArgs>>;
  UpdateUserContextFiltersPerformanceProfiles?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersPerformanceProfilesArgs>>;
  UpdateUserContextFiltersProductBlueprints?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersProductBlueprintsArgs>>;
  UpdateUserContextFiltersProducts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersProductsArgs>>;
  UpdateUserContextFiltersScopes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersScopesArgs>>;
  UpdateUserContextFiltersTermsAndPolicies?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersTermsAndPoliciesArgs>>;
  UpdateUserContextFiltersUsers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MutationUpdateUserContextFiltersUsersArgs>>;
  UpdateUserRole?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateUserRoleArgs, 'id'>>;
};

export type NegotiationRoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRound'] = ResolversParentTypes['NegotiationRound']> = {
  case?: Resolver<ResolversTypes['Case'], ParentType, ContextType, RequireFields<NegotiationRoundCaseArgs, 'directed'>>;
  caseAggregate?: Resolver<Maybe<ResolversTypes['NegotiationRoundCaseCaseAggregationSelection']>, ParentType, ContextType, RequireFields<NegotiationRoundCaseAggregateArgs, 'directed'>>;
  caseConnection?: Resolver<ResolversTypes['NegotiationRoundCaseConnection'], ParentType, ContextType, RequireFields<NegotiationRoundCaseConnectionArgs, 'directed'>>;
  changedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastProposedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  proposedBy?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<NegotiationRoundProposedByArgs, 'directed'>>;
  proposedByAggregate?: Resolver<Maybe<ResolversTypes['NegotiationRoundOrganizationProposedByAggregationSelection']>, ParentType, ContextType, RequireFields<NegotiationRoundProposedByAggregateArgs, 'directed'>>;
  proposedByConnection?: Resolver<ResolversTypes['NegotiationRoundProposedByConnection'], ParentType, ContextType, RequireFields<NegotiationRoundProposedByConnectionArgs, 'directed'>>;
  source?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType, RequireFields<NegotiationRoundSourceArgs, 'directed'>>;
  sourceAggregate?: Resolver<Maybe<ResolversTypes['NegotiationRoundFlexEntitySourceAggregationSelection']>, ParentType, ContextType, RequireFields<NegotiationRoundSourceAggregateArgs, 'directed'>>;
  sourceConnection?: Resolver<ResolversTypes['NegotiationRoundSourceConnection'], ParentType, ContextType, RequireFields<NegotiationRoundSourceConnectionArgs, 'directed'>>;
  status?: Resolver<ResolversTypes['NegotiationRoundStatus'], ParentType, ContextType>;
  updatedBy?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<NegotiationRoundUpdatedByArgs, 'directed'>>;
  updatedByAggregate?: Resolver<Maybe<ResolversTypes['NegotiationRoundUserUpdatedByAggregationSelection']>, ParentType, ContextType, RequireFields<NegotiationRoundUpdatedByAggregateArgs, 'directed'>>;
  updatedByConnection?: Resolver<ResolversTypes['NegotiationRoundUpdatedByConnection'], ParentType, ContextType, RequireFields<NegotiationRoundUpdatedByConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundCaseCaseAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundCaseCaseAggregationSelection'] = ResolversParentTypes['NegotiationRoundCaseCaseAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['NegotiationRoundCaseCaseNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundCaseCaseNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundCaseCaseNodeAggregateSelection'] = ResolversParentTypes['NegotiationRoundCaseCaseNodeAggregateSelection']> = {
  creationDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  preparationBrandName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  submissionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundCaseConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundCaseConnection'] = ResolversParentTypes['NegotiationRoundCaseConnection']> = {
  edges?: Resolver<Array<ResolversTypes['NegotiationRoundCaseRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundCaseRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundCaseRelationship'] = ResolversParentTypes['NegotiationRoundCaseRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Case'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundEdge'] = ResolversParentTypes['NegotiationRoundEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['NegotiationRound'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundFlexEntitySourceAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundFlexEntitySourceAggregationSelection'] = ResolversParentTypes['NegotiationRoundFlexEntitySourceAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['NegotiationRoundFlexEntitySourceNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundFlexEntitySourceNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundFlexEntitySourceNodeAggregateSelection'] = ResolversParentTypes['NegotiationRoundFlexEntitySourceNodeAggregateSelection']> = {
  createdByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  dataKeys?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  externalFormId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  flexEntityName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  insuranceClaimId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationBrandNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationGenericNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  viewCaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCreatedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewSuccessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundOrganizationProposedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundOrganizationProposedByAggregationSelection'] = ResolversParentTypes['NegotiationRoundOrganizationProposedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['NegotiationRoundOrganizationProposedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundOrganizationProposedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundOrganizationProposedByNodeAggregateSelection'] = ResolversParentTypes['NegotiationRoundOrganizationProposedByNodeAggregateSelection']> = {
  BIC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  IBAN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  aggregationPriority?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceThreshold?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactFirstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactLastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactOccupation?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactPhone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderRecurrentStep?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentSftpSavePath?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  domicile?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  dualApprovalThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  eIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  fax?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  legalName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  pharmaId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rebateProcessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  website?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundProposedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundProposedByConnection'] = ResolversParentTypes['NegotiationRoundProposedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['NegotiationRoundProposedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundProposedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundProposedByRelationship'] = ResolversParentTypes['NegotiationRoundProposedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundSourceConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundSourceConnection'] = ResolversParentTypes['NegotiationRoundSourceConnection']> = {
  edges?: Resolver<Array<ResolversTypes['NegotiationRoundSourceRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundSourceRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundSourceRelationship'] = ResolversParentTypes['NegotiationRoundSourceRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundUpdatedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundUpdatedByConnection'] = ResolversParentTypes['NegotiationRoundUpdatedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['NegotiationRoundUpdatedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundUpdatedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundUpdatedByRelationship'] = ResolversParentTypes['NegotiationRoundUpdatedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundUserUpdatedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundUserUpdatedByAggregationSelection'] = ResolversParentTypes['NegotiationRoundUserUpdatedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['NegotiationRoundUserUpdatedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundUserUpdatedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundUserUpdatedByNodeAggregateSelection'] = ResolversParentTypes['NegotiationRoundUserUpdatedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NegotiationRoundsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegotiationRoundsConnection'] = ResolversParentTypes['NegotiationRoundsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['NegotiationRoundEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Neo4JClusterMemberMetricsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Neo4JClusterMemberMetricsConnection'] = ResolversParentTypes['Neo4JClusterMemberMetricsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Neo4jClusterMemberMetricEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Neo4JClusterMetricsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Neo4JClusterMetricsConnection'] = ResolversParentTypes['Neo4JClusterMetricsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['Neo4jClusterMetricsEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Neo4jClusterMemberMetricResolvers<ContextType = any, ParentType extends ResolversParentTypes['Neo4jClusterMemberMetric'] = ResolversParentTypes['Neo4jClusterMemberMetric']> = {
  boltAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cpuLoadPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  freePhysicalMemoryBytes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  heapMaxBytes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  heapUsedBytes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalPhysicalMemoryBytes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Neo4jClusterMemberMetricEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Neo4jClusterMemberMetricEdge'] = ResolversParentTypes['Neo4jClusterMemberMetricEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Neo4jClusterMemberMetric'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Neo4jClusterMetricsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Neo4jClusterMetrics'] = ResolversParentTypes['Neo4jClusterMetrics']> = {
  cachedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  members?: Resolver<Array<ResolversTypes['Neo4jClusterMemberMetric']>, ParentType, ContextType>;
  stale?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Neo4jClusterMetricsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Neo4jClusterMetricsEdge'] = ResolversParentTypes['Neo4jClusterMetricsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Neo4jClusterMetrics'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NinjaQueriesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NinjaQueriesConnection'] = ResolversParentTypes['NinjaQueriesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['NinjaQueryEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NinjaQueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['NinjaQuery'] = ResolversParentTypes['NinjaQuery']> = {
  createdByEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  cypherQuery?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serializedCypherParams?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NinjaQueryEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NinjaQueryEdge'] = ResolversParentTypes['NinjaQueryEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['NinjaQuery'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NinjaQueryImpactResolvers<ContextType = any, ParentType extends ResolversParentTypes['NinjaQueryImpact'] = ResolversParentTypes['NinjaQueryImpact']> = {
  constraintsAdded?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  constraintsRemoved?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  indexesAdded?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  indexesRemoved?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  labelsAdded?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  labelsRemoved?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  nodesCreated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  nodesDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertiesSet?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  queryResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  relationshipsCreated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  relationshipsDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NinjaQueryImpactEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NinjaQueryImpactEdge'] = ResolversParentTypes['NinjaQueryImpactEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['NinjaQueryImpact'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NinjaQueryImpactsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NinjaQueryImpactsConnection'] = ResolversParentTypes['NinjaQueryImpactsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['NinjaQueryImpactEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NinjaQuerySubmitResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['NinjaQuerySubmitResult'] = ResolversParentTypes['NinjaQuerySubmitResult']> = {
  impact?: Resolver<ResolversTypes['NinjaQueryImpact'], ParentType, ContextType>;
  query?: Resolver<ResolversTypes['NinjaQuery'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NinjaQuerySubmitResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NinjaQuerySubmitResultEdge'] = ResolversParentTypes['NinjaQuerySubmitResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['NinjaQuerySubmitResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NinjaQuerySubmitResultsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NinjaQuerySubmitResultsConnection'] = ResolversParentTypes['NinjaQuerySubmitResultsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['NinjaQuerySubmitResultEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OidDcUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['OidDcUser'] = ResolversParentTypes['OidDcUser']> = {
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OidDcUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OidDcUserEdge'] = ResolversParentTypes['OidDcUserEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['OidDcUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OidDcUsersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OidDcUsersConnection'] = ResolversParentTypes['OidDcUsersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['OidDcUserEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = {
  BIC?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IBAN?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aggregationPriority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  agreementRunAttempts?: Resolver<Array<ResolversTypes['AgreementRunAttemptInfo']>, ParentType, ContextType, RequireFields<OrganizationAgreementRunAttemptsArgs, 'directed'>>;
  agreementRunAttemptsAggregate?: Resolver<Maybe<ResolversTypes['OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection']>, ParentType, ContextType, RequireFields<OrganizationAgreementRunAttemptsAggregateArgs, 'directed'>>;
  agreementRunAttemptsConnection?: Resolver<ResolversTypes['OrganizationAgreementRunAttemptsConnection'], ParentType, ContextType, RequireFields<OrganizationAgreementRunAttemptsConnectionArgs, 'directed'>>;
  agreementRunTriggers?: Resolver<Array<ResolversTypes['AgreementRunTrigger']>, ParentType, ContextType>;
  agreementTagNames?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  agreements?: Resolver<Array<ResolversTypes['Agreement']>, ParentType, ContextType, RequireFields<OrganizationAgreementsArgs, 'directed'>>;
  agreementsAggregate?: Resolver<Maybe<ResolversTypes['OrganizationAgreementAgreementsAggregationSelection']>, ParentType, ContextType, RequireFields<OrganizationAgreementsAggregateArgs, 'directed'>>;
  agreementsConnection?: Resolver<ResolversTypes['OrganizationAgreementsConnection'], ParentType, ContextType, RequireFields<OrganizationAgreementsConnectionArgs, 'directed'>>;
  autoIssuanceDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  autoIssuanceThreshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  automatedRunFrequency?: Resolver<ResolversTypes['AgreementRunFrequency'], ParentType, ContextType>;
  billingAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactOccupation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType, RequireFields<OrganizationCountryArgs, 'directed'>>;
  countryAggregate?: Resolver<Maybe<ResolversTypes['OrganizationCountryCountryAggregationSelection']>, ParentType, ContextType, RequireFields<OrganizationCountryAggregateArgs, 'directed'>>;
  countryConnection?: Resolver<ResolversTypes['OrganizationCountryConnection'], ParentType, ContextType, RequireFields<OrganizationCountryConnectionArgs, 'directed'>>;
  createdOn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currencyCodes?: Resolver<Array<ResolversTypes['Currency']>, ParentType, ContextType>;
  customTranslations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Translations']>>>, ParentType, ContextType>;
  defaultReceivers?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType, RequireFields<OrganizationDefaultReceiversArgs, 'directed'>>;
  defaultReceiversAggregate?: Resolver<Maybe<ResolversTypes['OrganizationOrganizationDefaultReceiversAggregationSelection']>, ParentType, ContextType, RequireFields<OrganizationDefaultReceiversAggregateArgs, 'directed'>>;
  defaultReceiversConnection?: Resolver<ResolversTypes['OrganizationDefaultReceiversConnection'], ParentType, ContextType, RequireFields<OrganizationDefaultReceiversConnectionArgs, 'directed'>>;
  deliveryAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentReviewReminderDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  documentReviewReminderRecurrentStep?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  documentSftpSavePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domicile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downloadPAFeatureEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  dualApprovalThreshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eIN?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  encapsulatedFeatures?: Resolver<Array<ResolversTypes['EncapsulatedFeatureConfiguration']>, ParentType, ContextType, RequireFields<OrganizationEncapsulatedFeaturesArgs, 'directed'>>;
  encapsulatedFeaturesAggregate?: Resolver<Maybe<ResolversTypes['OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection']>, ParentType, ContextType, RequireFields<OrganizationEncapsulatedFeaturesAggregateArgs, 'directed'>>;
  encapsulatedFeaturesConnection?: Resolver<ResolversTypes['OrganizationEncapsulatedFeaturesConnection'], ParentType, ContextType, RequireFields<OrganizationEncapsulatedFeaturesConnectionArgs, 'directed'>>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexEntityTypeMappings?: Resolver<Array<ResolversTypes['FlexEntityType']>, ParentType, ContextType, RequireFields<OrganizationFlexEntityTypeMappingsArgs, 'directed'>>;
  flexEntityTypeMappingsAggregate?: Resolver<Maybe<ResolversTypes['OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection']>, ParentType, ContextType, RequireFields<OrganizationFlexEntityTypeMappingsAggregateArgs, 'directed'>>;
  flexEntityTypeMappingsConnection?: Resolver<ResolversTypes['OrganizationFlexEntityTypeMappingsConnection'], ParentType, ContextType, RequireFields<OrganizationFlexEntityTypeMappingsConnectionArgs, 'directed'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCaseAutomaticDiscontinuationAllowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isExternalExposureAllowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  legalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  libraryGPTFeatureEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  libraryNavlinPricesEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pharmaId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  questNotifications?: Resolver<Array<ResolversTypes['QuestNotification']>, ParentType, ContextType, RequireFields<OrganizationQuestNotificationsArgs, 'directed'>>;
  questNotificationsAggregate?: Resolver<Maybe<ResolversTypes['OrganizationQuestNotificationQuestNotificationsAggregationSelection']>, ParentType, ContextType, RequireFields<OrganizationQuestNotificationsAggregateArgs, 'directed'>>;
  questNotificationsConnection?: Resolver<ResolversTypes['OrganizationQuestNotificationsConnection'], ParentType, ContextType, RequireFields<OrganizationQuestNotificationsConnectionArgs, 'directed'>>;
  rebateProcessorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  simulatorBreakdownEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  simulatorModelValidityEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  simulatorPVThresholdsEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  simulatorProductInputEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  simulatorWasteReportingEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validityCoverageEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationAgreementAgreementsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationAgreementAgreementsAggregationSelection'] = ResolversParentTypes['OrganizationAgreementAgreementsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['OrganizationAgreementAgreementsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationAgreementAgreementsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationAgreementAgreementsNodeAggregateSelection'] = ResolversParentTypes['OrganizationAgreementAgreementsNodeAggregateSelection']> = {
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  daysToExpiry?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  firstExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  formattedAmount?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedCounterparties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedDiseases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedIndications?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedProducts?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  pushedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  reportData?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection'] = ResolversParentTypes['OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection'] = ResolversParentTypes['OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection']> = {
  attemptedAgreementCount?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  filtersAppliedForRun?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  nonAttemptedAgreementCount?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  runEnd?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  runStart?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  succeededCount?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationAgreementRunAttemptsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationAgreementRunAttemptsConnection'] = ResolversParentTypes['OrganizationAgreementRunAttemptsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['OrganizationAgreementRunAttemptsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationAgreementRunAttemptsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationAgreementRunAttemptsRelationship'] = ResolversParentTypes['OrganizationAgreementRunAttemptsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementRunAttemptInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationAgreementsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationAgreementsConnection'] = ResolversParentTypes['OrganizationAgreementsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['OrganizationAgreementsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationAgreementsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationAgreementsRelationship'] = ResolversParentTypes['OrganizationAgreementsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationCountryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationCountryConnection'] = ResolversParentTypes['OrganizationCountryConnection']> = {
  edges?: Resolver<Array<ResolversTypes['OrganizationCountryRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationCountryCountryAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationCountryCountryAggregationSelection'] = ResolversParentTypes['OrganizationCountryCountryAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['OrganizationCountryCountryNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationCountryCountryNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationCountryCountryNodeAggregateSelection'] = ResolversParentTypes['OrganizationCountryCountryNodeAggregateSelection']> = {
  alpha2Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  alpha3Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  numericCode?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationCountryRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationCountryRelationship'] = ResolversParentTypes['OrganizationCountryRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationDefaultReceiversConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationDefaultReceiversConnection'] = ResolversParentTypes['OrganizationDefaultReceiversConnection']> = {
  edges?: Resolver<Array<ResolversTypes['OrganizationDefaultReceiversRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationDefaultReceiversRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationDefaultReceiversRelationship'] = ResolversParentTypes['OrganizationDefaultReceiversRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  notificationId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tagType?: Resolver<ResolversTypes['AgreementTagType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationEdge'] = ResolversParentTypes['OrganizationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection'] = ResolversParentTypes['OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection'] = ResolversParentTypes['OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection']> = {
  value?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationEncapsulatedFeaturesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationEncapsulatedFeaturesConnection'] = ResolversParentTypes['OrganizationEncapsulatedFeaturesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['OrganizationEncapsulatedFeaturesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationEncapsulatedFeaturesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationEncapsulatedFeaturesRelationship'] = ResolversParentTypes['OrganizationEncapsulatedFeaturesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EncapsulatedFeatureConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection'] = ResolversParentTypes['OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection'] = ResolversParentTypes['OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection']> = {
  data?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection'] = ResolversParentTypes['OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  attributeCount?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  idPrefix?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  localizationKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  tooltipText?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationFlexEntityTypeMappingsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationFlexEntityTypeMappingsConnection'] = ResolversParentTypes['OrganizationFlexEntityTypeMappingsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['OrganizationFlexEntityTypeMappingsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationFlexEntityTypeMappingsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationFlexEntityTypeMappingsRelationship'] = ResolversParentTypes['OrganizationFlexEntityTypeMappingsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntityType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationOrganizationDefaultReceiversAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationOrganizationDefaultReceiversAggregationSelection'] = ResolversParentTypes['OrganizationOrganizationDefaultReceiversAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['OrganizationOrganizationDefaultReceiversEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['OrganizationOrganizationDefaultReceiversNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationOrganizationDefaultReceiversEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationOrganizationDefaultReceiversEdgeAggregateSelection'] = ResolversParentTypes['OrganizationOrganizationDefaultReceiversEdgeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  notificationId?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationOrganizationDefaultReceiversNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationOrganizationDefaultReceiversNodeAggregateSelection'] = ResolversParentTypes['OrganizationOrganizationDefaultReceiversNodeAggregateSelection']> = {
  BIC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  IBAN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  aggregationPriority?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceThreshold?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactFirstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactLastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactOccupation?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactPhone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderRecurrentStep?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentSftpSavePath?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  domicile?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  dualApprovalThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  eIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  fax?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  legalName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  pharmaId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rebateProcessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  website?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationQuestNotificationQuestNotificationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationQuestNotificationQuestNotificationsAggregationSelection'] = ResolversParentTypes['OrganizationQuestNotificationQuestNotificationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection'] = ResolversParentTypes['OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection']> = {
  autocompletionThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  threshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationQuestNotificationQuestNotificationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection'] = ResolversParentTypes['OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection']> = {
  id?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationQuestNotificationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationQuestNotificationsConnection'] = ResolversParentTypes['OrganizationQuestNotificationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['OrganizationQuestNotificationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationQuestNotificationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationQuestNotificationsRelationship'] = ResolversParentTypes['OrganizationQuestNotificationsRelationship']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  amountType?: Resolver<Maybe<ResolversTypes['AmountsType']>, ParentType, ContextType>;
  autocompletionThreshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isAutocompletionEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['QuestNotification'], ParentType, ContextType>;
  threshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationQuestRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationQuestRelationship'] = ResolversParentTypes['OrganizationQuestRelationship']> = {
  __resolveType: TypeResolveFn<'OrganizationQuestNotificationsRelationship' | 'QuestNotificationSubscribedRelationship', ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  amountType?: Resolver<Maybe<ResolversTypes['AmountsType']>, ParentType, ContextType>;
  autocompletionThreshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isAutocompletionEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  threshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type OrganizationScopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationScope'] = ResolversParentTypes['OrganizationScope']> = {
  orgId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationScopeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationScopeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationScopeEdge'] = ResolversParentTypes['OrganizationScopeEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['OrganizationScope'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationScopeRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationScopeRelationship'] = ResolversParentTypes['OrganizationScopeRelationship']> = {
  __resolveType: TypeResolveFn<'AgreementScopeOrganizationScopesRelationship', ParentType, ContextType>;
  organizationScopeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type OrganizationScopesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationScopesConnection'] = ResolversParentTypes['OrganizationScopesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['OrganizationScopeEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationsConnection'] = ResolversParentTypes['OrganizationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['OrganizationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Partner'] = ResolversParentTypes['Partner']> = {
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PartnerType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Place?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ZipCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  treatment?: Resolver<Maybe<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<PartnerTreatmentArgs, 'directed'>>;
  treatmentAggregate?: Resolver<Maybe<ResolversTypes['PartnerTreatmentTreatmentAggregationSelection']>, ParentType, ContextType, RequireFields<PartnerTreatmentAggregateArgs, 'directed'>>;
  treatmentConnection?: Resolver<ResolversTypes['PartnerTreatmentConnection'], ParentType, ContextType, RequireFields<PartnerTreatmentConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnerEdge'] = ResolversParentTypes['PartnerEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Partner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerTreatmentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnerTreatmentConnection'] = ResolversParentTypes['PartnerTreatmentConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PartnerTreatmentRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerTreatmentRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnerTreatmentRelationship'] = ResolversParentTypes['PartnerTreatmentRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerTreatmentTreatmentAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnerTreatmentTreatmentAggregationSelection'] = ResolversParentTypes['PartnerTreatmentTreatmentAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PartnerTreatmentTreatmentNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnerTreatmentTreatmentNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnerTreatmentTreatmentNodeAggregateSelection'] = ResolversParentTypes['PartnerTreatmentTreatmentNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartnersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartnersConnection'] = ResolversParentTypes['PartnersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PartnerEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['Patient'] = ResolversParentTypes['Patient']> = {
  assignedFlexEntities?: Resolver<Array<ResolversTypes['FlexEntity']>, ParentType, ContextType, RequireFields<PatientAssignedFlexEntitiesArgs, 'directed'>>;
  assignedFlexEntitiesAggregate?: Resolver<Maybe<ResolversTypes['PatientFlexEntityAssignedFlexEntitiesAggregationSelection']>, ParentType, ContextType, RequireFields<PatientAssignedFlexEntitiesAggregateArgs, 'directed'>>;
  assignedFlexEntitiesConnection?: Resolver<ResolversTypes['PatientAssignedFlexEntitiesConnection'], ParentType, ContextType, RequireFields<PatientAssignedFlexEntitiesConnectionArgs, 'directed'>>;
  cases?: Resolver<Array<ResolversTypes['Case']>, ParentType, ContextType, RequireFields<PatientCasesArgs, 'directed'>>;
  casesAggregate?: Resolver<Maybe<ResolversTypes['PatientCaseCasesAggregationSelection']>, ParentType, ContextType, RequireFields<PatientCasesAggregateArgs, 'directed'>>;
  casesConnection?: Resolver<ResolversTypes['PatientCasesConnection'], ParentType, ContextType, RequireFields<PatientCasesConnectionArgs, 'directed'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  initials?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  insuranceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeStamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  yearOfBirth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientAssignedFlexEntitiesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientAssignedFlexEntitiesConnection'] = ResolversParentTypes['PatientAssignedFlexEntitiesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PatientAssignedFlexEntitiesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientAssignedFlexEntitiesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientAssignedFlexEntitiesRelationship'] = ResolversParentTypes['PatientAssignedFlexEntitiesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientCaseCasesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientCaseCasesAggregationSelection'] = ResolversParentTypes['PatientCaseCasesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PatientCaseCasesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientCaseCasesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientCaseCasesNodeAggregateSelection'] = ResolversParentTypes['PatientCaseCasesNodeAggregateSelection']> = {
  creationDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  preparationBrandName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  submissionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientCasesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientCasesConnection'] = ResolversParentTypes['PatientCasesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PatientCasesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientCasesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientCasesRelationship'] = ResolversParentTypes['PatientCasesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Case'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientEdge'] = ResolversParentTypes['PatientEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientFlexEntityAssignedFlexEntitiesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientFlexEntityAssignedFlexEntitiesAggregationSelection'] = ResolversParentTypes['PatientFlexEntityAssignedFlexEntitiesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection'] = ResolversParentTypes['PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection']> = {
  createdByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  dataKeys?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  externalFormId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  flexEntityName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  insuranceClaimId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationBrandNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationGenericNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  viewCaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCreatedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewSuccessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientsConnection'] = ResolversParentTypes['PatientsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PatientEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceCounterResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceCounter'] = ResolversParentTypes['PerformanceCounter']> = {
  conditions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceCounterEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceCounterEdge'] = ResolversParentTypes['PerformanceCounterEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PerformanceCounter'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceCountersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceCountersConnection'] = ResolversParentTypes['PerformanceCountersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PerformanceCounterEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurement'] = ResolversParentTypes['PerformanceMeasurement']> = {
  completedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  counter?: Resolver<ResolversTypes['PerformanceCounter'], ParentType, ContextType, RequireFields<PerformanceMeasurementCounterArgs, 'directed'>>;
  counterAggregate?: Resolver<Maybe<ResolversTypes['PerformanceMeasurementPerformanceCounterCounterAggregationSelection']>, ParentType, ContextType, RequireFields<PerformanceMeasurementCounterAggregateArgs, 'directed'>>;
  counterConnection?: Resolver<ResolversTypes['PerformanceMeasurementCounterConnection'], ParentType, ContextType, RequireFields<PerformanceMeasurementCounterConnectionArgs, 'directed'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAverage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nestedMeasurements?: Resolver<Array<ResolversTypes['PerformanceMeasurement']>, ParentType, ContextType, RequireFields<PerformanceMeasurementNestedMeasurementsArgs, 'directed'>>;
  nestedMeasurementsAggregate?: Resolver<Maybe<ResolversTypes['PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection']>, ParentType, ContextType, RequireFields<PerformanceMeasurementNestedMeasurementsAggregateArgs, 'directed'>>;
  nestedMeasurementsConnection?: Resolver<ResolversTypes['PerformanceMeasurementNestedMeasurementsConnection'], ParentType, ContextType, RequireFields<PerformanceMeasurementNestedMeasurementsConnectionArgs, 'directed'>>;
  parent?: Resolver<Maybe<ResolversTypes['PerformanceMeasurement']>, ParentType, ContextType, RequireFields<PerformanceMeasurementParentArgs, 'directed'>>;
  parentAggregate?: Resolver<Maybe<ResolversTypes['PerformanceMeasurementPerformanceMeasurementParentAggregationSelection']>, ParentType, ContextType, RequireFields<PerformanceMeasurementParentAggregateArgs, 'directed'>>;
  parentConnection?: Resolver<ResolversTypes['PerformanceMeasurementParentConnection'], ParentType, ContextType, RequireFields<PerformanceMeasurementParentConnectionArgs, 'directed'>>;
  payload?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementCounterConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementCounterConnection'] = ResolversParentTypes['PerformanceMeasurementCounterConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PerformanceMeasurementCounterRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementCounterRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementCounterRelationship'] = ResolversParentTypes['PerformanceMeasurementCounterRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PerformanceCounter'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementEdge'] = ResolversParentTypes['PerformanceMeasurementEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PerformanceMeasurement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementNestedMeasurementsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementNestedMeasurementsConnection'] = ResolversParentTypes['PerformanceMeasurementNestedMeasurementsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PerformanceMeasurementNestedMeasurementsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementNestedMeasurementsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementNestedMeasurementsRelationship'] = ResolversParentTypes['PerformanceMeasurementNestedMeasurementsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PerformanceMeasurement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementParentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementParentConnection'] = ResolversParentTypes['PerformanceMeasurementParentConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PerformanceMeasurementParentRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementParentRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementParentRelationship'] = ResolversParentTypes['PerformanceMeasurementParentRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PerformanceMeasurement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementPerformanceCounterCounterAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementPerformanceCounterCounterAggregationSelection'] = ResolversParentTypes['PerformanceMeasurementPerformanceCounterCounterAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection'] = ResolversParentTypes['PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection']> = {
  conditions?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection'] = ResolversParentTypes['PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection'] = ResolversParentTypes['PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection']> = {
  completedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  payload?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  startedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementPerformanceMeasurementParentAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementPerformanceMeasurementParentAggregationSelection'] = ResolversParentTypes['PerformanceMeasurementPerformanceMeasurementParentAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection'] = ResolversParentTypes['PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection']> = {
  completedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  payload?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  startedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceMeasurementsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceMeasurementsConnection'] = ResolversParentTypes['PerformanceMeasurementsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PerformanceMeasurementEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceThresholdResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceThreshold'] = ResolversParentTypes['PerformanceThreshold']> = {
  conditions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  counter?: Resolver<ResolversTypes['PerformanceCounter'], ParentType, ContextType, RequireFields<PerformanceThresholdCounterArgs, 'directed'>>;
  counterAggregate?: Resolver<Maybe<ResolversTypes['PerformanceThresholdPerformanceCounterCounterAggregationSelection']>, ParentType, ContextType, RequireFields<PerformanceThresholdCounterAggregateArgs, 'directed'>>;
  counterConnection?: Resolver<ResolversTypes['PerformanceThresholdCounterConnection'], ParentType, ContextType, RequireFields<PerformanceThresholdCounterConnectionArgs, 'directed'>>;
  dataSizeQuotient?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notifiedUsers?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<PerformanceThresholdNotifiedUsersArgs, 'directed'>>;
  notifiedUsersAggregate?: Resolver<Maybe<ResolversTypes['PerformanceThresholdUserNotifiedUsersAggregationSelection']>, ParentType, ContextType, RequireFields<PerformanceThresholdNotifiedUsersAggregateArgs, 'directed'>>;
  notifiedUsersConnection?: Resolver<ResolversTypes['PerformanceThresholdNotifiedUsersConnection'], ParentType, ContextType, RequireFields<PerformanceThresholdNotifiedUsersConnectionArgs, 'directed'>>;
  percentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceThresholdCounterConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceThresholdCounterConnection'] = ResolversParentTypes['PerformanceThresholdCounterConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PerformanceThresholdCounterRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceThresholdCounterRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceThresholdCounterRelationship'] = ResolversParentTypes['PerformanceThresholdCounterRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PerformanceCounter'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceThresholdEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceThresholdEdge'] = ResolversParentTypes['PerformanceThresholdEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PerformanceThreshold'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceThresholdNotifiedUsersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceThresholdNotifiedUsersConnection'] = ResolversParentTypes['PerformanceThresholdNotifiedUsersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PerformanceThresholdNotifiedUsersRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceThresholdNotifiedUsersRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceThresholdNotifiedUsersRelationship'] = ResolversParentTypes['PerformanceThresholdNotifiedUsersRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceThresholdPerformanceCounterCounterAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceThresholdPerformanceCounterCounterAggregationSelection'] = ResolversParentTypes['PerformanceThresholdPerformanceCounterCounterAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceThresholdPerformanceCounterCounterNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection'] = ResolversParentTypes['PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection']> = {
  conditions?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceThresholdUserNotifiedUsersAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceThresholdUserNotifiedUsersAggregationSelection'] = ResolversParentTypes['PerformanceThresholdUserNotifiedUsersAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PerformanceThresholdUserNotifiedUsersNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceThresholdUserNotifiedUsersNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceThresholdUserNotifiedUsersNodeAggregateSelection'] = ResolversParentTypes['PerformanceThresholdUserNotifiedUsersNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerformanceThresholdsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceThresholdsConnection'] = ResolversParentTypes['PerformanceThresholdsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PerformanceThresholdEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PgBossMetricsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PgBossMetrics'] = ResolversParentTypes['PgBossMetrics']> = {
  maintenanceSecondsAgo?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maintenanceStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  overallStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  queues?: Resolver<Array<ResolversTypes['PgBossQueueStat']>, ParentType, ContextType>;
  sampledAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PgBossMetricsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PgBossMetricsConnection'] = ResolversParentTypes['PgBossMetricsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PgBossMetricsEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PgBossMetricsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PgBossMetricsEdge'] = ResolversParentTypes['PgBossMetricsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PgBossMetrics'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PgBossQueueStatResolvers<ContextType = any, ParentType extends ResolversParentTypes['PgBossQueueStat'] = ResolversParentTypes['PgBossQueueStat']> = {
  active?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  backlog?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  queue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recentFailures?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stale?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PgBossQueueStatEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PgBossQueueStatEdge'] = ResolversParentTypes['PgBossQueueStatEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PgBossQueueStat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PgBossQueueStatsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PgBossQueueStatsConnection'] = ResolversParentTypes['PgBossQueueStatsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PgBossQueueStatEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyType'] = ResolversParentTypes['PolicyType']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  versions?: Resolver<Array<ResolversTypes['PolicyVersion']>, ParentType, ContextType, RequireFields<PolicyTypeVersionsArgs, 'directed'>>;
  versionsAggregate?: Resolver<Maybe<ResolversTypes['PolicyTypePolicyVersionVersionsAggregationSelection']>, ParentType, ContextType, RequireFields<PolicyTypeVersionsAggregateArgs, 'directed'>>;
  versionsConnection?: Resolver<ResolversTypes['PolicyTypeVersionsConnection'], ParentType, ContextType, RequireFields<PolicyTypeVersionsConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyTypeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyTypeEdge'] = ResolversParentTypes['PolicyTypeEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PolicyType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyTypePolicyVersionVersionsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyTypePolicyVersionVersionsAggregationSelection'] = ResolversParentTypes['PolicyTypePolicyVersionVersionsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PolicyTypePolicyVersionVersionsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyTypePolicyVersionVersionsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyTypePolicyVersionVersionsNodeAggregateSelection'] = ResolversParentTypes['PolicyTypePolicyVersionVersionsNodeAggregateSelection']> = {
  editedBy?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  editedDate?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyTypeVersionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyTypeVersionsConnection'] = ResolversParentTypes['PolicyTypeVersionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PolicyTypeVersionsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyTypeVersionsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyTypeVersionsRelationship'] = ResolversParentTypes['PolicyTypeVersionsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PolicyVersion'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyTypesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyTypesConnection'] = ResolversParentTypes['PolicyTypesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PolicyTypeEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyVersionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyVersion'] = ResolversParentTypes['PolicyVersion']> = {
  editedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  editedDate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isLastVersion?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  policyType?: Resolver<ResolversTypes['PolicyType'], ParentType, ContextType, RequireFields<PolicyVersionPolicyTypeArgs, 'directed'>>;
  policyTypeAggregate?: Resolver<Maybe<ResolversTypes['PolicyVersionPolicyTypePolicyTypeAggregationSelection']>, ParentType, ContextType, RequireFields<PolicyVersionPolicyTypeAggregateArgs, 'directed'>>;
  policyTypeConnection?: Resolver<ResolversTypes['PolicyVersionPolicyTypeConnection'], ParentType, ContextType, RequireFields<PolicyVersionPolicyTypeConnectionArgs, 'directed'>>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyVersionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyVersionEdge'] = ResolversParentTypes['PolicyVersionEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PolicyVersion'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyVersionPolicyTypeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyVersionPolicyTypeConnection'] = ResolversParentTypes['PolicyVersionPolicyTypeConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PolicyVersionPolicyTypeRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyVersionPolicyTypePolicyTypeAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyVersionPolicyTypePolicyTypeAggregationSelection'] = ResolversParentTypes['PolicyVersionPolicyTypePolicyTypeAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PolicyVersionPolicyTypePolicyTypeNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyVersionPolicyTypePolicyTypeNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyVersionPolicyTypePolicyTypeNodeAggregateSelection'] = ResolversParentTypes['PolicyVersionPolicyTypePolicyTypeNodeAggregateSelection']> = {
  type?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyVersionPolicyTypeRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyVersionPolicyTypeRelationship'] = ResolversParentTypes['PolicyVersionPolicyTypeRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PolicyType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyVersionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyVersionsConnection'] = ResolversParentTypes['PolicyVersionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PolicyVersionEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostgresMetricResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostgresMetric'] = ResolversParentTypes['PostgresMetric']> = {
  commitRatePerSecond?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  database?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numBackends?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rollbackRatePerSecond?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampledAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  xactCommitCumulative?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  xactRollbackCumulative?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostgresMetricEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostgresMetricEdge'] = ResolversParentTypes['PostgresMetricEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PostgresMetric'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostgresMetricsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostgresMetricsConnection'] = ResolversParentTypes['PostgresMetricsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PostgresMetricEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Preparation'] = ResolversParentTypes['Preparation']> = {
  AtcCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  BrandName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  DescriptionDe?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DescriptionFr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DescriptionIt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GenericName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ReleaseDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  SubjectMatter?: Resolver<ResolversTypes['AgreementSubjectMatter'], ParentType, ContextType>;
  SwissmedicNo5?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<ResolversTypes['Brand'], ParentType, ContextType, RequireFields<PreparationBrandArgs, 'directed'>>;
  brandAggregate?: Resolver<Maybe<ResolversTypes['PreparationBrandBrandAggregationSelection']>, ParentType, ContextType, RequireFields<PreparationBrandAggregateArgs, 'directed'>>;
  brandConnection?: Resolver<ResolversTypes['PreparationBrandConnection'], ParentType, ContextType, RequireFields<PreparationBrandConnectionArgs, 'directed'>>;
  countries?: Resolver<Array<ResolversTypes['Country']>, ParentType, ContextType, RequireFields<PreparationCountriesArgs, 'directed'>>;
  countriesAggregate?: Resolver<Maybe<ResolversTypes['PreparationCountryCountriesAggregationSelection']>, ParentType, ContextType, RequireFields<PreparationCountriesAggregateArgs, 'directed'>>;
  countriesConnection?: Resolver<ResolversTypes['PreparationCountriesConnection'], ParentType, ContextType, RequireFields<PreparationCountriesConnectionArgs, 'directed'>>;
  generic?: Resolver<Maybe<ResolversTypes['Generic']>, ParentType, ContextType, RequireFields<PreparationGenericArgs, 'directed'>>;
  genericAggregate?: Resolver<Maybe<ResolversTypes['PreparationGenericGenericAggregationSelection']>, ParentType, ContextType, RequireFields<PreparationGenericAggregateArgs, 'directed'>>;
  genericConnection?: Resolver<ResolversTypes['PreparationGenericConnection'], ParentType, ContextType, RequireFields<PreparationGenericConnectionArgs, 'directed'>>;
  hasLimitation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasLimitations?: Resolver<Array<ResolversTypes['Limitation']>, ParentType, ContextType, RequireFields<PreparationHasLimitationsArgs, 'directed'>>;
  hasLimitationsAggregate?: Resolver<Maybe<ResolversTypes['PreparationLimitationHasLimitationsAggregationSelection']>, ParentType, ContextType, RequireFields<PreparationHasLimitationsAggregateArgs, 'directed'>>;
  hasLimitationsConnection?: Resolver<ResolversTypes['PreparationHasLimitationsConnection'], ParentType, ContextType, RequireFields<PreparationHasLimitationsConnectionArgs, 'directed'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  regulates?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<PreparationRegulatesArgs, 'directed'>>;
  regulatesAggregate?: Resolver<Maybe<ResolversTypes['PreparationTreatmentRegulatesAggregationSelection']>, ParentType, ContextType, RequireFields<PreparationRegulatesAggregateArgs, 'directed'>>;
  regulatesConnection?: Resolver<ResolversTypes['PreparationRegulatesConnection'], ParentType, ContextType, RequireFields<PreparationRegulatesConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationBrandBrandAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationBrandBrandAggregationSelection'] = ResolversParentTypes['PreparationBrandBrandAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PreparationBrandBrandNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationBrandBrandNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationBrandBrandNodeAggregateSelection'] = ResolversParentTypes['PreparationBrandBrandNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  art71DataLastUpdatedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  art71DataLastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationBrandConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationBrandConnection'] = ResolversParentTypes['PreparationBrandConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PreparationBrandRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationBrandRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationBrandRelationship'] = ResolversParentTypes['PreparationBrandRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Brand'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationCountriesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationCountriesConnection'] = ResolversParentTypes['PreparationCountriesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PreparationCountriesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationCountriesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationCountriesRelationship'] = ResolversParentTypes['PreparationCountriesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationCountryCountriesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationCountryCountriesAggregationSelection'] = ResolversParentTypes['PreparationCountryCountriesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PreparationCountryCountriesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationCountryCountriesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationCountryCountriesNodeAggregateSelection'] = ResolversParentTypes['PreparationCountryCountriesNodeAggregateSelection']> = {
  alpha2Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  alpha3Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  numericCode?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationEdge'] = ResolversParentTypes['PreparationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Preparation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationGenericConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationGenericConnection'] = ResolversParentTypes['PreparationGenericConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PreparationGenericRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationGenericGenericAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationGenericGenericAggregationSelection'] = ResolversParentTypes['PreparationGenericGenericAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PreparationGenericGenericNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationGenericGenericNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationGenericGenericNodeAggregateSelection'] = ResolversParentTypes['PreparationGenericGenericNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationGenericRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationGenericRelationship'] = ResolversParentTypes['PreparationGenericRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Generic'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationHasLimitationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationHasLimitationsConnection'] = ResolversParentTypes['PreparationHasLimitationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PreparationHasLimitationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationHasLimitationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationHasLimitationsRelationship'] = ResolversParentTypes['PreparationHasLimitationsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Limitation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationLimitationHasLimitationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationLimitationHasLimitationsAggregationSelection'] = ResolversParentTypes['PreparationLimitationHasLimitationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PreparationLimitationHasLimitationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationLimitationHasLimitationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationLimitationHasLimitationsNodeAggregateSelection'] = ResolversParentTypes['PreparationLimitationHasLimitationsNodeAggregateSelection']> = {
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DescriptionEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Niveau?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Type?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationRegulatesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationRegulatesConnection'] = ResolversParentTypes['PreparationRegulatesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PreparationRegulatesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationRegulatesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationRegulatesRelationship'] = ResolversParentTypes['PreparationRegulatesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationStatus'] = ResolversParentTypes['PreparationStatus']> = {
  FlagApd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IntegrationDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  StatusTypeCodeSl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StatusTypeDescriptionSl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValidFromDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  ValidThruDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  preparation?: Resolver<Maybe<ResolversTypes['Preparation']>, ParentType, ContextType, RequireFields<PreparationStatusPreparationArgs, 'directed'>>;
  preparationAggregate?: Resolver<Maybe<ResolversTypes['PreparationStatusPreparationPreparationAggregationSelection']>, ParentType, ContextType, RequireFields<PreparationStatusPreparationAggregateArgs, 'directed'>>;
  preparationConnection?: Resolver<ResolversTypes['PreparationStatusPreparationConnection'], ParentType, ContextType, RequireFields<PreparationStatusPreparationConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationStatusEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationStatusEdge'] = ResolversParentTypes['PreparationStatusEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PreparationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationStatusPreparationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationStatusPreparationConnection'] = ResolversParentTypes['PreparationStatusPreparationConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PreparationStatusPreparationRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationStatusPreparationPreparationAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationStatusPreparationPreparationAggregationSelection'] = ResolversParentTypes['PreparationStatusPreparationPreparationAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PreparationStatusPreparationPreparationNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationStatusPreparationPreparationNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationStatusPreparationPreparationNodeAggregateSelection'] = ResolversParentTypes['PreparationStatusPreparationPreparationNodeAggregateSelection']> = {
  AtcCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  BrandName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GenericName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo5?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationStatusPreparationRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationStatusPreparationRelationship'] = ResolversParentTypes['PreparationStatusPreparationRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Preparation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationStatusesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationStatusesConnection'] = ResolversParentTypes['PreparationStatusesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PreparationStatusEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationTreatmentRegulatesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationTreatmentRegulatesAggregationSelection'] = ResolversParentTypes['PreparationTreatmentRegulatesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PreparationTreatmentRegulatesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationTreatmentRegulatesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationTreatmentRegulatesNodeAggregateSelection'] = ResolversParentTypes['PreparationTreatmentRegulatesNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreparationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreparationsConnection'] = ResolversParentTypes['PreparationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PreparationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Price'] = ResolversParentTypes['Price']> = {
  Price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  PriceChangeTypeDescriptionDe?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PriceChangeTypeDescriptionFr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PriceChangeTypeDescriptionIt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PriceTypeDescriptionDe?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PriceTypeDescriptionFr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PriceTypeDescriptionIt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValidFromDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  ValidToDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  countriesConsidered?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType, RequireFields<PriceCurrencyArgs, 'directed'>>;
  currencyAggregate?: Resolver<Maybe<ResolversTypes['PriceCurrencyCurrencyAggregationSelection']>, ParentType, ContextType, RequireFields<PriceCurrencyAggregateArgs, 'directed'>>;
  currencyConnection?: Resolver<ResolversTypes['PriceCurrencyConnection'], ParentType, ContextType, RequireFields<PriceCurrencyConnectionArgs, 'directed'>>;
  priceType?: Resolver<ResolversTypes['PriceCategory'], ParentType, ContextType>;
  treatment?: Resolver<Maybe<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<PriceTreatmentArgs, 'directed'>>;
  treatmentAggregate?: Resolver<Maybe<ResolversTypes['PriceTreatmentTreatmentAggregationSelection']>, ParentType, ContextType, RequireFields<PriceTreatmentAggregateArgs, 'directed'>>;
  treatmentConnection?: Resolver<ResolversTypes['PriceTreatmentConnection'], ParentType, ContextType, RequireFields<PriceTreatmentConnectionArgs, 'directed'>>;
  uniqueCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceCurrencyConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceCurrencyConnection'] = ResolversParentTypes['PriceCurrencyConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PriceCurrencyRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceCurrencyCurrencyAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceCurrencyCurrencyAggregationSelection'] = ResolversParentTypes['PriceCurrencyCurrencyAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PriceCurrencyCurrencyNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceCurrencyCurrencyNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceCurrencyCurrencyNodeAggregateSelection'] = ResolversParentTypes['PriceCurrencyCurrencyNodeAggregateSelection']> = {
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceCurrencyRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceCurrencyRelationship'] = ResolversParentTypes['PriceCurrencyRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceEdge'] = ResolversParentTypes['PriceEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Price'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceTreatmentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceTreatmentConnection'] = ResolversParentTypes['PriceTreatmentConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PriceTreatmentRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceTreatmentRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceTreatmentRelationship'] = ResolversParentTypes['PriceTreatmentRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceTreatmentTreatmentAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceTreatmentTreatmentAggregationSelection'] = ResolversParentTypes['PriceTreatmentTreatmentAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PriceTreatmentTreatmentNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceTreatmentTreatmentNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceTreatmentTreatmentNodeAggregateSelection'] = ResolversParentTypes['PriceTreatmentTreatmentNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PricesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PricesConnection'] = ResolversParentTypes['PricesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PriceEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprint'] = ResolversParentTypes['ProductBlueprint']> = {
  addedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<ProductBlueprintAddedByArgs, 'directed'>>;
  addedByAggregate?: Resolver<Maybe<ResolversTypes['ProductBlueprintUserAddedByAggregationSelection']>, ParentType, ContextType, RequireFields<ProductBlueprintAddedByAggregateArgs, 'directed'>>;
  addedByConnection?: Resolver<ResolversTypes['ProductBlueprintAddedByConnection'], ParentType, ContextType, RequireFields<ProductBlueprintAddedByConnectionArgs, 'directed'>>;
  addedByName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  domains?: Resolver<Array<ResolversTypes['Domain']>, ParentType, ContextType, RequireFields<ProductBlueprintDomainsArgs, 'directed'>>;
  domainsAggregate?: Resolver<Maybe<ResolversTypes['ProductBlueprintDomainDomainsAggregationSelection']>, ParentType, ContextType, RequireFields<ProductBlueprintDomainsAggregateArgs, 'directed'>>;
  domainsConnection?: Resolver<ResolversTypes['ProductBlueprintDomainsConnection'], ParentType, ContextType, RequireFields<ProductBlueprintDomainsConnectionArgs, 'directed'>>;
  formValues?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  indication?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  indications?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publishedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<ProductBlueprintPublishedByArgs, 'directed'>>;
  publishedByAggregate?: Resolver<Maybe<ResolversTypes['ProductBlueprintUserPublishedByAggregationSelection']>, ParentType, ContextType, RequireFields<ProductBlueprintPublishedByAggregateArgs, 'directed'>>;
  publishedByConnection?: Resolver<ResolversTypes['ProductBlueprintPublishedByConnection'], ParentType, ContextType, RequireFields<ProductBlueprintPublishedByConnectionArgs, 'directed'>>;
  publishedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  simulationCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  simulations?: Resolver<Maybe<ResolversTypes['Simulation']>, ParentType, ContextType, RequireFields<ProductBlueprintSimulationsArgs, 'directed'>>;
  simulationsAggregate?: Resolver<Maybe<ResolversTypes['ProductBlueprintSimulationSimulationsAggregationSelection']>, ParentType, ContextType, RequireFields<ProductBlueprintSimulationsAggregateArgs, 'directed'>>;
  simulationsConnection?: Resolver<ResolversTypes['ProductBlueprintSimulationsConnection'], ParentType, ContextType, RequireFields<ProductBlueprintSimulationsConnectionArgs, 'directed'>>;
  status?: Resolver<ResolversTypes['ProductBlueprintStatus'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<ProductBlueprintUpdatedByArgs, 'directed'>>;
  updatedByAggregate?: Resolver<Maybe<ResolversTypes['ProductBlueprintUserUpdatedByAggregationSelection']>, ParentType, ContextType, RequireFields<ProductBlueprintUpdatedByAggregateArgs, 'directed'>>;
  updatedByConnection?: Resolver<ResolversTypes['ProductBlueprintUpdatedByConnection'], ParentType, ContextType, RequireFields<ProductBlueprintUpdatedByConnectionArgs, 'directed'>>;
  updatedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintAddedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintAddedByConnection'] = ResolversParentTypes['ProductBlueprintAddedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProductBlueprintAddedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintAddedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintAddedByRelationship'] = ResolversParentTypes['ProductBlueprintAddedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintDomainDomainsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintDomainDomainsAggregationSelection'] = ResolversParentTypes['ProductBlueprintDomainDomainsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ProductBlueprintDomainDomainsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintDomainDomainsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintDomainDomainsNodeAggregateSelection'] = ResolversParentTypes['ProductBlueprintDomainDomainsNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  deletedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  deletedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintDomainsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintDomainsConnection'] = ResolversParentTypes['ProductBlueprintDomainsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProductBlueprintDomainsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintDomainsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintDomainsRelationship'] = ResolversParentTypes['ProductBlueprintDomainsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Domain'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintEdge'] = ResolversParentTypes['ProductBlueprintEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProductBlueprint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintPublishedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintPublishedByConnection'] = ResolversParentTypes['ProductBlueprintPublishedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProductBlueprintPublishedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintPublishedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintPublishedByRelationship'] = ResolversParentTypes['ProductBlueprintPublishedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintResult'] = ResolversParentTypes['ProductBlueprintResult']> = {
  addedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  addedByName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  domains?: Resolver<Array<ResolversTypes['Domain']>, ParentType, ContextType>;
  formValues?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  indications?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publishedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  publishedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  simulationCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ProductBlueprintStatus'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  updatedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintResultEdge'] = ResolversParentTypes['ProductBlueprintResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProductBlueprintResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintResultsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintResultsConnection'] = ResolversParentTypes['ProductBlueprintResultsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProductBlueprintResultEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintSimulationSimulationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintSimulationSimulationsAggregationSelection'] = ResolversParentTypes['ProductBlueprintSimulationSimulationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ProductBlueprintSimulationSimulationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintSimulationSimulationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintSimulationSimulationsNodeAggregateSelection'] = ResolversParentTypes['ProductBlueprintSimulationSimulationsNodeAggregateSelection']> = {
  businessCase?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  comments?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  counterparty?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  deletedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  deletedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  domainName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedContent?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  indications?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  lockedSections?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  shortName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintSimulationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintSimulationsConnection'] = ResolversParentTypes['ProductBlueprintSimulationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProductBlueprintSimulationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintSimulationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintSimulationsRelationship'] = ResolversParentTypes['ProductBlueprintSimulationsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Simulation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintUpdatedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintUpdatedByConnection'] = ResolversParentTypes['ProductBlueprintUpdatedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProductBlueprintUpdatedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintUpdatedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintUpdatedByRelationship'] = ResolversParentTypes['ProductBlueprintUpdatedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintUserAddedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintUserAddedByAggregationSelection'] = ResolversParentTypes['ProductBlueprintUserAddedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ProductBlueprintUserAddedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintUserAddedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintUserAddedByNodeAggregateSelection'] = ResolversParentTypes['ProductBlueprintUserAddedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintUserPublishedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintUserPublishedByAggregationSelection'] = ResolversParentTypes['ProductBlueprintUserPublishedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ProductBlueprintUserPublishedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintUserPublishedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintUserPublishedByNodeAggregateSelection'] = ResolversParentTypes['ProductBlueprintUserPublishedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintUserUpdatedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintUserUpdatedByAggregationSelection'] = ResolversParentTypes['ProductBlueprintUserUpdatedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ProductBlueprintUserUpdatedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintUserUpdatedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintUserUpdatedByNodeAggregateSelection'] = ResolversParentTypes['ProductBlueprintUserUpdatedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductBlueprintsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBlueprintsConnection'] = ResolversParentTypes['ProductBlueprintsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProductBlueprintEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicPrice'] = ResolversParentTypes['PublicPrice']> = {
  Price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValidFromDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicPriceEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicPriceEdge'] = ResolversParentTypes['PublicPriceEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PublicPrice'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicPricesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicPricesConnection'] = ResolversParentTypes['PublicPricesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PublicPriceEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Purchase'] = ResolversParentTypes['Purchase']> = {
  agreement?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType, RequireFields<PurchaseAgreementArgs, 'directed'>>;
  agreementAggregate?: Resolver<Maybe<ResolversTypes['PurchaseAgreementAgreementAggregationSelection']>, ParentType, ContextType, RequireFields<PurchaseAgreementAggregateArgs, 'directed'>>;
  agreementConnection?: Resolver<ResolversTypes['PurchaseAgreementConnection'], ParentType, ContextType, RequireFields<PurchaseAgreementConnectionArgs, 'directed'>>;
  assignedFlexEntities?: Resolver<Array<ResolversTypes['FlexEntity']>, ParentType, ContextType, RequireFields<PurchaseAssignedFlexEntitiesArgs, 'directed'>>;
  assignedFlexEntitiesAggregate?: Resolver<Maybe<ResolversTypes['PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection']>, ParentType, ContextType, RequireFields<PurchaseAssignedFlexEntitiesAggregateArgs, 'directed'>>;
  assignedFlexEntitiesConnection?: Resolver<ResolversTypes['PurchaseAssignedFlexEntitiesConnection'], ParentType, ContextType, RequireFields<PurchaseAssignedFlexEntitiesConnectionArgs, 'directed'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  maxCoverageStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  maxTherapyTrialStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  purchaseDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refunds?: Resolver<Array<ResolversTypes['Refund']>, ParentType, ContextType, RequireFields<PurchaseRefundsArgs, 'directed'>>;
  refundsAggregate?: Resolver<Maybe<ResolversTypes['PurchaseRefundRefundsAggregationSelection']>, ParentType, ContextType, RequireFields<PurchaseRefundsAggregateArgs, 'directed'>>;
  refundsConnection?: Resolver<ResolversTypes['PurchaseRefundsConnection'], ParentType, ContextType, RequireFields<PurchaseRefundsConnectionArgs, 'directed'>>;
  tenantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeStamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseAgreementAgreementAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseAgreementAgreementAggregationSelection'] = ResolversParentTypes['PurchaseAgreementAgreementAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PurchaseAgreementAgreementNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseAgreementAgreementNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseAgreementAgreementNodeAggregateSelection'] = ResolversParentTypes['PurchaseAgreementAgreementNodeAggregateSelection']> = {
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  daysToExpiry?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  firstExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  formattedAmount?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedCounterparties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedDiseases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedIndications?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedProducts?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  pushedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  reportData?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseAgreementConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseAgreementConnection'] = ResolversParentTypes['PurchaseAgreementConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PurchaseAgreementRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseAgreementRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseAgreementRelationship'] = ResolversParentTypes['PurchaseAgreementRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseAssignedFlexEntitiesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseAssignedFlexEntitiesConnection'] = ResolversParentTypes['PurchaseAssignedFlexEntitiesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PurchaseAssignedFlexEntitiesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseAssignedFlexEntitiesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseAssignedFlexEntitiesRelationship'] = ResolversParentTypes['PurchaseAssignedFlexEntitiesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseEdge'] = ResolversParentTypes['PurchaseEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Purchase'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseFlexEntityAssignedFlexEntitiesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection'] = ResolversParentTypes['PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection'] = ResolversParentTypes['PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection']> = {
  createdByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  dataKeys?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  externalFormId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  flexEntityName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  insuranceClaimId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationBrandNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationGenericNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  viewCaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCreatedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewSuccessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseRefundRefundsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseRefundRefundsAggregationSelection'] = ResolversParentTypes['PurchaseRefundRefundsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PurchaseRefundRefundsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseRefundRefundsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseRefundRefundsNodeAggregateSelection'] = ResolversParentTypes['PurchaseRefundRefundsNodeAggregateSelection']> = {
  agreementId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  caseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  caseOrAgreementId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseRefundsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseRefundsConnection'] = ResolversParentTypes['PurchaseRefundsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PurchaseRefundsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseRefundsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseRefundsRelationship'] = ResolversParentTypes['PurchaseRefundsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Refund'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchasesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchasesConnection'] = ResolversParentTypes['PurchasesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PurchaseEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  CanPushAgreement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<QueryCanPushAgreementArgs>>;
  CheckBrandsAndTreatments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryCheckBrandsAndTreatmentsArgs, 'brandNames'>>;
  CheckCountryScopesEditable?: Resolver<Array<ResolversTypes['ScopeCheckResult']>, ParentType, ContextType, RequireFields<QueryCheckCountryScopesEditableArgs, 'scopeIds'>>;
  CheckMasterDataUpdateImpact?: Resolver<Array<ResolversTypes['Art71MasterDataImpacts']>, ParentType, ContextType, RequireFields<QueryCheckMasterDataUpdateImpactArgs, 'input'>>;
  CheckQuery?: Resolver<ResolversTypes['NinjaQueryImpact'], ParentType, ContextType, RequireFields<QueryCheckQueryArgs, 'input'>>;
  DownloadDetailedReport?: Resolver<Array<ResolversTypes['DQCDetailedReportRaw']>, ParentType, ContextType, RequireFields<QueryDownloadDetailedReportArgs, 'identifier'>>;
  GeActiveUploadOrganizationNames?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  GetActiveUploadOrganizations?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  GetActiveUserSessions?: Resolver<Array<ResolversTypes['ActiveUserSession']>, ParentType, ContextType>;
  GetAgreementListFromCache?: Resolver<Array<ResolversTypes['CachedAgreementListItem']>, ParentType, ContextType>;
  GetAgreementWorkerStates?: Resolver<Array<ResolversTypes['RunningJobState']>, ParentType, ContextType, RequireFields<QueryGetAgreementWorkerStatesArgs, 'createdOnFrom'>>;
  GetAllAgreementsSpecificRoles?: Resolver<Array<ResolversTypes['AgreementSpecificRole']>, ParentType, ContextType, RequireFields<QueryGetAllAgreementsSpecificRolesArgs, 'id'>>;
  GetAllOrganizationDomains?: Resolver<Array<ResolversTypes['Domain']>, ParentType, ContextType, Partial<QueryGetAllOrganizationDomainsArgs>>;
  GetAllUsersFromOrganization?: Resolver<Array<ResolversTypes['UserOrganizationInfo']>, ParentType, ContextType, RequireFields<QueryGetAllUsersFromOrganizationArgs, 'id'>>;
  GetBrandReport?: Resolver<Array<Maybe<ResolversTypes['GetBrandReportItem']>>, ParentType, ContextType>;
  GetClusterWorkerMetrics?: Resolver<ResolversTypes['ClusterWorkersSnapshot'], ParentType, ContextType>;
  GetConfig?: Resolver<Maybe<ResolversTypes['Config']>, ParentType, ContextType>;
  GetCosmosMetrics?: Resolver<ResolversTypes['CosmosMetric'], ParentType, ContextType>;
  GetCurrentUser?: Resolver<Maybe<ResolversTypes['OidDcUser']>, ParentType, ContextType>;
  GetCustomTranslations?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetCustomTranslationsArgs, 'variables'>>;
  GetDefaultAgreementRoles?: Resolver<Array<ResolversTypes['DefaultAgreementRoleInfo']>, ParentType, ContextType, RequireFields<QueryGetDefaultAgreementRolesArgs, 'id'>>;
  GetEligibilityConditionSets?: Resolver<Array<ResolversTypes['EligibilityConditionSet']>, ParentType, ContextType>;
  GetEnabledSsoTypes?: Resolver<Array<ResolversTypes['SingleSignOnType']>, ParentType, ContextType, RequireFields<QueryGetEnabledSsoTypesArgs, 'organizationId'>>;
  GetExtendedOrg?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType, RequireFields<QueryGetExtendedOrgArgs, 'id'>>;
  GetFinancialSummaryLocalizationKeySuggestions?: Resolver<Array<ResolversTypes['LocalizationKeySuggestions']>, ParentType, ContextType>;
  GetGeneralConfiguration?: Resolver<Array<ResolversTypes['UserOrgSettingsData']>, ParentType, ContextType, Partial<QueryGetGeneralConfigurationArgs>>;
  GetIcd10Suggestions?: Resolver<Maybe<ResolversTypes['Icd10Suggestions']>, ParentType, ContextType, RequireFields<QueryGetIcd10SuggestionsArgs, 'text'>>;
  GetIndicationReport?: Resolver<Array<Maybe<ResolversTypes['GetIndicationReportItem']>>, ParentType, ContextType>;
  GetIsStfpPathExist?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryGetIsStfpPathExistArgs, 'path'>>;
  GetLegalEntities?: Resolver<Maybe<Array<Maybe<ResolversTypes['Organization']>>>, ParentType, ContextType, RequireFields<QueryGetLegalEntitiesArgs, 'tenantId'>>;
  GetMissingTranslationKeys?: Resolver<Array<Maybe<ResolversTypes['MissingTranslationKeys']>>, ParentType, ContextType>;
  GetModules?: Resolver<Array<Maybe<ResolversTypes['Module']>>, ParentType, ContextType>;
  GetNeo4jClusterMetrics?: Resolver<ResolversTypes['Neo4jClusterMetrics'], ParentType, ContextType>;
  GetNewVersionMinStartDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType, RequireFields<QueryGetNewVersionMinStartDateArgs, 'initialVersionId'>>;
  GetOrganization?: Resolver<Maybe<ResolversTypes['AuthOrganization']>, ParentType, ContextType, RequireFields<QueryGetOrganizationArgs, 'id'>>;
  GetOrganizationAgreementTags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetOrganizationAgreementTagsArgs, 'id'>>;
  GetOrganizationBrands?: Resolver<Array<ResolversTypes['Brand']>, ParentType, ContextType, Partial<QueryGetOrganizationBrandsArgs>>;
  GetOrganizationDomains?: Resolver<Array<ResolversTypes['Domain']>, ParentType, ContextType, Partial<QueryGetOrganizationDomainsArgs>>;
  GetOrganizationMetricsData?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetOrganizationMetricsDataArgs, 'validFromDate' | 'validToDate'>>;
  GetOrganizations?: Resolver<Maybe<Array<Maybe<ResolversTypes['AuthOrganization']>>>, ParentType, ContextType, Partial<QueryGetOrganizationsArgs>>;
  GetOrganizationsFilteredByCountry?: Resolver<Maybe<Array<Maybe<ResolversTypes['Organization']>>>, ParentType, ContextType, Partial<QueryGetOrganizationsFilteredByCountryArgs>>;
  GetPgBossMetrics?: Resolver<Maybe<ResolversTypes['PgBossMetrics']>, ParentType, ContextType>;
  GetPlatformUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  GetPostgresMetrics?: Resolver<Maybe<ResolversTypes['PostgresMetric']>, ParentType, ContextType>;
  GetProductBlueprintById?: Resolver<Maybe<ResolversTypes['ProductBlueprint']>, ParentType, ContextType, Partial<QueryGetProductBlueprintByIdArgs>>;
  GetProductBlueprints?: Resolver<Maybe<Array<ResolversTypes['ProductBlueprintResult']>>, ParentType, ContextType>;
  GetRunChecksState?: Resolver<Array<ResolversTypes['RunnableCheck']>, ParentType, ContextType>;
  GetRunnableChecks?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  GetRunningChecks?: Resolver<Array<ResolversTypes['RunningJobState']>, ParentType, ContextType, RequireFields<QueryGetRunningChecksArgs, 'createdOnFrom'>>;
  GetSftpSubdirectories?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetSftpSubdirectoriesArgs, 'parent'>>;
  GetSlowestGraphqlRequests?: Resolver<ResolversTypes['SlowGraphqlRequestsResult'], ParentType, ContextType, RequireFields<QueryGetSlowestGraphqlRequestsArgs, 'days'>>;
  GetTermsAndPolicies?: Resolver<Maybe<Array<ResolversTypes['PolicyVersion']>>, ParentType, ContextType>;
  GetTermsAndPoliciesPair?: Resolver<Maybe<Array<Maybe<ResolversTypes['PolicyVersion']>>>, ParentType, ContextType, RequireFields<QueryGetTermsAndPoliciesPairArgs, 'type'>>;
  GetTranslations?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetTranslationsArgs, 'variables'>>;
  GetTranslationsWithChangedKeys?: Resolver<ResolversTypes['AvailableTranslations'], ParentType, ContextType, RequireFields<QueryGetTranslationsWithChangedKeysArgs, 'orgId'>>;
  GetTypesToCheck?: Resolver<ResolversTypes['IntegrityCheckTypes'], ParentType, ContextType>;
  GetUploadState?: Resolver<Maybe<ResolversTypes['UploadState']>, ParentType, ContextType>;
  GetUser?: Resolver<Maybe<ResolversTypes['StoreUser']>, ParentType, ContextType, RequireFields<QueryGetUserArgs, 'id'>>;
  GetUserContextFiltersAgreements?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersBrandIndications?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersCountries?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersCustomConditions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersFlexQueries?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersFlexibleFormsRecords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersIndications?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersLocalization?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersMissingKeys?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersModels?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersPerformanceMeasurements?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersPerformanceProfiles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersProductBlueprints?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersProducts?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersScopes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersTermsAndPolicies?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserContextFiltersUsers?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GetUserCreatedSimulationsCount?: Resolver<Maybe<ResolversTypes['SimulationCount']>, ParentType, ContextType, RequireFields<QueryGetUserCreatedSimulationsCountArgs, 'userId'>>;
  GetUserDefaultRole?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetUserDefaultRoleArgs, 'id' | 'tag'>>;
  GetUsers?: Resolver<Array<Maybe<ResolversTypes['User']>>, ParentType, ContextType, RequireFields<QueryGetUsersArgs, 'userIds'>>;
  GetUsersByModuleAndOrg?: Resolver<Array<ResolversTypes['StoreUser']>, ParentType, ContextType, RequireFields<QueryGetUsersByModuleAndOrgArgs, 'moduleIds'>>;
  PreparationLimitationsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  RunFlexQuery?: Resolver<ResolversTypes['QueryResult'], ParentType, ContextType, Partial<QueryRunFlexQueryArgs>>;
  activeUserSessions?: Resolver<Array<ResolversTypes['ActiveUserSession']>, ParentType, ContextType, Partial<QueryActiveUserSessionsArgs>>;
  activeUserSessionsConnection?: Resolver<ResolversTypes['ActiveUserSessionsConnection'], ParentType, ContextType, Partial<QueryActiveUserSessionsConnectionArgs>>;
  agreementDecisions?: Resolver<Array<ResolversTypes['AgreementDecision']>, ParentType, ContextType, Partial<QueryAgreementDecisionsArgs>>;
  agreementDecisionsConnection?: Resolver<ResolversTypes['AgreementDecisionsConnection'], ParentType, ContextType, Partial<QueryAgreementDecisionsConnectionArgs>>;
  agreementRunAttemptInfos?: Resolver<Array<ResolversTypes['AgreementRunAttemptInfo']>, ParentType, ContextType, Partial<QueryAgreementRunAttemptInfosArgs>>;
  agreementRunAttemptInfosConnection?: Resolver<ResolversTypes['AgreementRunAttemptInfosConnection'], ParentType, ContextType, Partial<QueryAgreementRunAttemptInfosConnectionArgs>>;
  agreementScopeCountryScopes?: Resolver<Array<ResolversTypes['AgreementScopeCountryScope']>, ParentType, ContextType, Partial<QueryAgreementScopeCountryScopesArgs>>;
  agreementScopeCountryScopesConnection?: Resolver<ResolversTypes['AgreementScopeCountryScopesConnection'], ParentType, ContextType, Partial<QueryAgreementScopeCountryScopesConnectionArgs>>;
  agreementScopeOrganizationScopes?: Resolver<Array<ResolversTypes['AgreementScopeOrganizationScope']>, ParentType, ContextType, Partial<QueryAgreementScopeOrganizationScopesArgs>>;
  agreementScopeOrganizationScopesConnection?: Resolver<ResolversTypes['AgreementScopeOrganizationScopesConnection'], ParentType, ContextType, Partial<QueryAgreementScopeOrganizationScopesConnectionArgs>>;
  agreementScopes?: Resolver<Array<ResolversTypes['AgreementScope']>, ParentType, ContextType, Partial<QueryAgreementScopesArgs>>;
  agreementScopesConnection?: Resolver<ResolversTypes['AgreementScopesConnection'], ParentType, ContextType, Partial<QueryAgreementScopesConnectionArgs>>;
  agreementSpecificRoles?: Resolver<Array<ResolversTypes['AgreementSpecificRole']>, ParentType, ContextType, Partial<QueryAgreementSpecificRolesArgs>>;
  agreementSpecificRolesConnection?: Resolver<ResolversTypes['AgreementSpecificRolesConnection'], ParentType, ContextType, Partial<QueryAgreementSpecificRolesConnectionArgs>>;
  agreementStatusTransitions?: Resolver<Array<ResolversTypes['AgreementStatusTransition']>, ParentType, ContextType, Partial<QueryAgreementStatusTransitionsArgs>>;
  agreementStatusTransitionsConnection?: Resolver<ResolversTypes['AgreementStatusTransitionsConnection'], ParentType, ContextType, Partial<QueryAgreementStatusTransitionsConnectionArgs>>;
  agreementTags?: Resolver<Array<ResolversTypes['AgreementTag']>, ParentType, ContextType, Partial<QueryAgreementTagsArgs>>;
  agreementTagsConnection?: Resolver<ResolversTypes['AgreementTagsConnection'], ParentType, ContextType, Partial<QueryAgreementTagsConnectionArgs>>;
  agreementTemplateVersionCreationResponses?: Resolver<Array<ResolversTypes['AgreementTemplateVersionCreationResponse']>, ParentType, ContextType, Partial<QueryAgreementTemplateVersionCreationResponsesArgs>>;
  agreementTemplateVersionCreationResponsesConnection?: Resolver<ResolversTypes['AgreementTemplateVersionCreationResponsesConnection'], ParentType, ContextType, Partial<QueryAgreementTemplateVersionCreationResponsesConnectionArgs>>;
  agreementTemplates?: Resolver<Array<ResolversTypes['AgreementTemplate']>, ParentType, ContextType, Partial<QueryAgreementTemplatesArgs>>;
  agreementTemplatesConnection?: Resolver<ResolversTypes['AgreementTemplatesConnection'], ParentType, ContextType, Partial<QueryAgreementTemplatesConnectionArgs>>;
  agreements?: Resolver<Array<ResolversTypes['Agreement']>, ParentType, ContextType, Partial<QueryAgreementsArgs>>;
  agreementsConnection?: Resolver<ResolversTypes['AgreementsConnection'], ParentType, ContextType, Partial<QueryAgreementsConnectionArgs>>;
  alerts?: Resolver<Array<ResolversTypes['Alert']>, ParentType, ContextType, Partial<QueryAlertsArgs>>;
  alertsConnection?: Resolver<ResolversTypes['AlertsConnection'], ParentType, ContextType, Partial<QueryAlertsConnectionArgs>>;
  art71MasterDataImpacts?: Resolver<Array<ResolversTypes['Art71MasterDataImpacts']>, ParentType, ContextType, Partial<QueryArt71MasterDataImpactsArgs>>;
  art71MasterDataImpactsConnection?: Resolver<ResolversTypes['Art71MasterDataImpactsConnection'], ParentType, ContextType, Partial<QueryArt71MasterDataImpactsConnectionArgs>>;
  article71Indications?: Resolver<Array<ResolversTypes['Article71Indication']>, ParentType, ContextType, Partial<QueryArticle71IndicationsArgs>>;
  article71IndicationsConnection?: Resolver<ResolversTypes['Article71IndicationsConnection'], ParentType, ContextType, Partial<QueryArticle71IndicationsConnectionArgs>>;
  authOrganizations?: Resolver<Array<ResolversTypes['AuthOrganization']>, ParentType, ContextType, Partial<QueryAuthOrganizationsArgs>>;
  authOrganizationsConnection?: Resolver<ResolversTypes['AuthOrganizationsConnection'], ParentType, ContextType, Partial<QueryAuthOrganizationsConnectionArgs>>;
  availableTranslations?: Resolver<Array<ResolversTypes['AvailableTranslations']>, ParentType, ContextType, Partial<QueryAvailableTranslationsArgs>>;
  availableTranslationsConnection?: Resolver<ResolversTypes['AvailableTranslationsConnection'], ParentType, ContextType, Partial<QueryAvailableTranslationsConnectionArgs>>;
  averageGenericPrices?: Resolver<Array<ResolversTypes['AverageGenericPrice']>, ParentType, ContextType, Partial<QueryAverageGenericPricesArgs>>;
  averageGenericPricesConnection?: Resolver<ResolversTypes['AverageGenericPricesConnection'], ParentType, ContextType, Partial<QueryAverageGenericPricesConnectionArgs>>;
  baseAgreements?: Resolver<Array<ResolversTypes['BaseAgreement']>, ParentType, ContextType, Partial<QueryBaseAgreementsArgs>>;
  baseAgreementsConnection?: Resolver<ResolversTypes['BaseAgreementsConnection'], ParentType, ContextType, Partial<QueryBaseAgreementsConnectionArgs>>;
  brands?: Resolver<Array<ResolversTypes['Brand']>, ParentType, ContextType, Partial<QueryBrandsArgs>>;
  brandsConnection?: Resolver<ResolversTypes['BrandsConnection'], ParentType, ContextType, Partial<QueryBrandsConnectionArgs>>;
  cachedAgreementListItems?: Resolver<Array<ResolversTypes['CachedAgreementListItem']>, ParentType, ContextType, Partial<QueryCachedAgreementListItemsArgs>>;
  cachedAgreementListItemsConnection?: Resolver<ResolversTypes['CachedAgreementListItemsConnection'], ParentType, ContextType, Partial<QueryCachedAgreementListItemsConnectionArgs>>;
  cases?: Resolver<Array<ResolversTypes['Case']>, ParentType, ContextType, Partial<QueryCasesArgs>>;
  casesConnection?: Resolver<ResolversTypes['CasesConnection'], ParentType, ContextType, Partial<QueryCasesConnectionArgs>>;
  catalogueAttributes?: Resolver<Array<ResolversTypes['CatalogueAttribute']>, ParentType, ContextType, Partial<QueryCatalogueAttributesArgs>>;
  catalogueAttributesConnection?: Resolver<ResolversTypes['CatalogueAttributesConnection'], ParentType, ContextType, Partial<QueryCatalogueAttributesConnectionArgs>>;
  chartRangeConfigurations?: Resolver<Array<ResolversTypes['ChartRangeConfiguration']>, ParentType, ContextType, Partial<QueryChartRangeConfigurationsArgs>>;
  chartRangeConfigurationsConnection?: Resolver<ResolversTypes['ChartRangeConfigurationsConnection'], ParentType, ContextType, Partial<QueryChartRangeConfigurationsConnectionArgs>>;
  checkedTypes?: Resolver<Array<ResolversTypes['CheckedType']>, ParentType, ContextType, Partial<QueryCheckedTypesArgs>>;
  checkedTypesConnection?: Resolver<ResolversTypes['CheckedTypesConnection'], ParentType, ContextType, Partial<QueryCheckedTypesConnectionArgs>>;
  clusterWorkerMetrics?: Resolver<Array<ResolversTypes['ClusterWorkerMetric']>, ParentType, ContextType, Partial<QueryClusterWorkerMetricsArgs>>;
  clusterWorkerMetricsConnection?: Resolver<ResolversTypes['ClusterWorkerMetricsConnection'], ParentType, ContextType, Partial<QueryClusterWorkerMetricsConnectionArgs>>;
  clusterWorkersSnapshots?: Resolver<Array<ResolversTypes['ClusterWorkersSnapshot']>, ParentType, ContextType, Partial<QueryClusterWorkersSnapshotsArgs>>;
  clusterWorkersSnapshotsConnection?: Resolver<ResolversTypes['ClusterWorkersSnapshotsConnection'], ParentType, ContextType, Partial<QueryClusterWorkersSnapshotsConnectionArgs>>;
  configs?: Resolver<Array<ResolversTypes['Config']>, ParentType, ContextType, Partial<QueryConfigsArgs>>;
  configsConnection?: Resolver<ResolversTypes['ConfigsConnection'], ParentType, ContextType, Partial<QueryConfigsConnectionArgs>>;
  coreNinjaQueries?: Resolver<Array<ResolversTypes['NinjaQuery']>, ParentType, ContextType>;
  cosmosMetrics?: Resolver<Array<ResolversTypes['CosmosMetric']>, ParentType, ContextType, Partial<QueryCosmosMetricsArgs>>;
  cosmosMetricsConnection?: Resolver<ResolversTypes['CosmosMetricsConnection'], ParentType, ContextType, Partial<QueryCosmosMetricsConnectionArgs>>;
  countries?: Resolver<Array<ResolversTypes['Country']>, ParentType, ContextType, Partial<QueryCountriesArgs>>;
  countriesConnection?: Resolver<ResolversTypes['CountriesConnection'], ParentType, ContextType, Partial<QueryCountriesConnectionArgs>>;
  crossCountryPrices?: Resolver<Array<ResolversTypes['CrossCountryPrice']>, ParentType, ContextType, Partial<QueryCrossCountryPricesArgs>>;
  crossCountryPricesConnection?: Resolver<ResolversTypes['CrossCountryPricesConnection'], ParentType, ContextType, Partial<QueryCrossCountryPricesConnectionArgs>>;
  currencies?: Resolver<Array<ResolversTypes['Currency']>, ParentType, ContextType, Partial<QueryCurrenciesArgs>>;
  currenciesConnection?: Resolver<ResolversTypes['CurrenciesConnection'], ParentType, ContextType, Partial<QueryCurrenciesConnectionArgs>>;
  customConditions?: Resolver<Array<ResolversTypes['CustomCondition']>, ParentType, ContextType, Partial<QueryCustomConditionsArgs>>;
  customConditionsConnection?: Resolver<ResolversTypes['CustomConditionsConnection'], ParentType, ContextType, Partial<QueryCustomConditionsConnectionArgs>>;
  customIntegrityChecks?: Resolver<Array<ResolversTypes['CustomIntegrityCheck']>, ParentType, ContextType, Partial<QueryCustomIntegrityChecksArgs>>;
  customIntegrityChecksConnection?: Resolver<ResolversTypes['CustomIntegrityChecksConnection'], ParentType, ContextType, Partial<QueryCustomIntegrityChecksConnectionArgs>>;
  cycleConfigurations?: Resolver<Array<ResolversTypes['CycleConfiguration']>, ParentType, ContextType, Partial<QueryCycleConfigurationsArgs>>;
  cycleConfigurationsConnection?: Resolver<ResolversTypes['CycleConfigurationsConnection'], ParentType, ContextType, Partial<QueryCycleConfigurationsConnectionArgs>>;
  cycleTherapyConfigurations?: Resolver<Array<ResolversTypes['CycleTherapyConfiguration']>, ParentType, ContextType, Partial<QueryCycleTherapyConfigurationsArgs>>;
  cycleTherapyConfigurationsConnection?: Resolver<ResolversTypes['CycleTherapyConfigurationsConnection'], ParentType, ContextType, Partial<QueryCycleTherapyConfigurationsConnectionArgs>>;
  dataContainers?: Resolver<Array<ResolversTypes['DataContainer']>, ParentType, ContextType, Partial<QueryDataContainersArgs>>;
  dataContainersConnection?: Resolver<ResolversTypes['DataContainersConnection'], ParentType, ContextType, Partial<QueryDataContainersConnectionArgs>>;
  dataSources?: Resolver<Array<ResolversTypes['DataSource']>, ParentType, ContextType, Partial<QueryDataSourcesArgs>>;
  dataSourcesConnection?: Resolver<ResolversTypes['DataSourcesConnection'], ParentType, ContextType, Partial<QueryDataSourcesConnectionArgs>>;
  defaultAgreementRoleInfos?: Resolver<Array<ResolversTypes['DefaultAgreementRoleInfo']>, ParentType, ContextType, Partial<QueryDefaultAgreementRoleInfosArgs>>;
  defaultAgreementRoleInfosConnection?: Resolver<ResolversTypes['DefaultAgreementRoleInfosConnection'], ParentType, ContextType, Partial<QueryDefaultAgreementRoleInfosConnectionArgs>>;
  deviceAlternatives?: Resolver<Array<ResolversTypes['DeviceAlternative']>, ParentType, ContextType, Partial<QueryDeviceAlternativesArgs>>;
  deviceAlternativesConnection?: Resolver<ResolversTypes['DeviceAlternativesConnection'], ParentType, ContextType, Partial<QueryDeviceAlternativesConnectionArgs>>;
  disabledDataChecks?: Resolver<Array<ResolversTypes['DisabledDataCheck']>, ParentType, ContextType, Partial<QueryDisabledDataChecksArgs>>;
  disabledDataChecksConnection?: Resolver<ResolversTypes['DisabledDataChecksConnection'], ParentType, ContextType, Partial<QueryDisabledDataChecksConnectionArgs>>;
  diseases?: Resolver<Array<ResolversTypes['Disease']>, ParentType, ContextType, Partial<QueryDiseasesArgs>>;
  diseasesConnection?: Resolver<ResolversTypes['DiseasesConnection'], ParentType, ContextType, Partial<QueryDiseasesConnectionArgs>>;
  documentRefundGroups?: Resolver<Array<ResolversTypes['DocumentRefundGroup']>, ParentType, ContextType, Partial<QueryDocumentRefundGroupsArgs>>;
  documentRefundGroupsConnection?: Resolver<ResolversTypes['DocumentRefundGroupsConnection'], ParentType, ContextType, Partial<QueryDocumentRefundGroupsConnectionArgs>>;
  documents?: Resolver<Array<ResolversTypes['Document']>, ParentType, ContextType, Partial<QueryDocumentsArgs>>;
  documentsConnection?: Resolver<ResolversTypes['DocumentsConnection'], ParentType, ContextType, Partial<QueryDocumentsConnectionArgs>>;
  domains?: Resolver<Array<ResolversTypes['Domain']>, ParentType, ContextType, Partial<QueryDomainsArgs>>;
  domainsConnection?: Resolver<ResolversTypes['DomainsConnection'], ParentType, ContextType, Partial<QueryDomainsConnectionArgs>>;
  dqcDetailedReportRaws?: Resolver<Array<ResolversTypes['DQCDetailedReportRaw']>, ParentType, ContextType, Partial<QueryDqcDetailedReportRawsArgs>>;
  dqcDetailedReportRawsConnection?: Resolver<ResolversTypes['DqcDetailedReportRawsConnection'], ParentType, ContextType, Partial<QueryDqcDetailedReportRawsConnectionArgs>>;
  dummyEnumReferences?: Resolver<Array<ResolversTypes['DummyEnumReferences']>, ParentType, ContextType, Partial<QueryDummyEnumReferencesArgs>>;
  dummyEnumReferencesConnection?: Resolver<ResolversTypes['DummyEnumReferencesConnection'], ParentType, ContextType, Partial<QueryDummyEnumReferencesConnectionArgs>>;
  eligibilityConditionSets?: Resolver<Array<ResolversTypes['EligibilityConditionSet']>, ParentType, ContextType, Partial<QueryEligibilityConditionSetsArgs>>;
  eligibilityConditionSetsConnection?: Resolver<ResolversTypes['EligibilityConditionSetsConnection'], ParentType, ContextType, Partial<QueryEligibilityConditionSetsConnectionArgs>>;
  encapsulatedFeatureConfigurations?: Resolver<Array<ResolversTypes['EncapsulatedFeatureConfiguration']>, ParentType, ContextType, Partial<QueryEncapsulatedFeatureConfigurationsArgs>>;
  encapsulatedFeatureConfigurationsConnection?: Resolver<ResolversTypes['EncapsulatedFeatureConfigurationsConnection'], ParentType, ContextType, Partial<QueryEncapsulatedFeatureConfigurationsConnectionArgs>>;
  encapsulatedFeatures?: Resolver<Array<ResolversTypes['EncapsulatedFeature']>, ParentType, ContextType, Partial<QueryEncapsulatedFeaturesArgs>>;
  encapsulatedFeaturesConnection?: Resolver<ResolversTypes['EncapsulatedFeaturesConnection'], ParentType, ContextType, Partial<QueryEncapsulatedFeaturesConnectionArgs>>;
  enrollingConditionSets?: Resolver<Array<ResolversTypes['EnrollingConditionSet']>, ParentType, ContextType, Partial<QueryEnrollingConditionSetsArgs>>;
  enrollingConditionSetsConnection?: Resolver<ResolversTypes['EnrollingConditionSetsConnection'], ParentType, ContextType, Partial<QueryEnrollingConditionSetsConnectionArgs>>;
  enrollingConditions?: Resolver<Array<ResolversTypes['EnrollingCondition']>, ParentType, ContextType, Partial<QueryEnrollingConditionsArgs>>;
  enrollingConditionsConnection?: Resolver<ResolversTypes['EnrollingConditionsConnection'], ParentType, ContextType, Partial<QueryEnrollingConditionsConnectionArgs>>;
  enrollingPeriods?: Resolver<Array<ResolversTypes['EnrollingPeriod']>, ParentType, ContextType, Partial<QueryEnrollingPeriodsArgs>>;
  enrollingPeriodsConnection?: Resolver<ResolversTypes['EnrollingPeriodsConnection'], ParentType, ContextType, Partial<QueryEnrollingPeriodsConnectionArgs>>;
  entryModules?: Resolver<Array<ResolversTypes['EntryModule']>, ParentType, ContextType, Partial<QueryEntryModulesArgs>>;
  entryModulesConnection?: Resolver<ResolversTypes['EntryModulesConnection'], ParentType, ContextType, Partial<QueryEntryModulesConnectionArgs>>;
  exFactoryPrices?: Resolver<Array<ResolversTypes['ExFactoryPrice']>, ParentType, ContextType, Partial<QueryExFactoryPricesArgs>>;
  exFactoryPricesConnection?: Resolver<ResolversTypes['ExFactoryPricesConnection'], ParentType, ContextType, Partial<QueryExFactoryPricesConnectionArgs>>;
  financialSummaryColumns?: Resolver<Array<ResolversTypes['FinancialSummaryColumn']>, ParentType, ContextType, Partial<QueryFinancialSummaryColumnsArgs>>;
  financialSummaryColumnsConnection?: Resolver<ResolversTypes['FinancialSummaryColumnsConnection'], ParentType, ContextType, Partial<QueryFinancialSummaryColumnsConnectionArgs>>;
  flexEntities?: Resolver<Array<ResolversTypes['FlexEntity']>, ParentType, ContextType, Partial<QueryFlexEntitiesArgs>>;
  flexEntitiesConnection?: Resolver<ResolversTypes['FlexEntitiesConnection'], ParentType, ContextType, Partial<QueryFlexEntitiesConnectionArgs>>;
  flexEntityTypes?: Resolver<Array<ResolversTypes['FlexEntityType']>, ParentType, ContextType, Partial<QueryFlexEntityTypesArgs>>;
  flexEntityTypesConnection?: Resolver<ResolversTypes['FlexEntityTypesConnection'], ParentType, ContextType, Partial<QueryFlexEntityTypesConnectionArgs>>;
  flexFinancialDataPoints?: Resolver<Array<ResolversTypes['FlexFinancialDataPoint']>, ParentType, ContextType, Partial<QueryFlexFinancialDataPointsArgs>>;
  flexFinancialDataPointsConnection?: Resolver<ResolversTypes['FlexFinancialDataPointsConnection'], ParentType, ContextType, Partial<QueryFlexFinancialDataPointsConnectionArgs>>;
  flexQueries?: Resolver<Array<ResolversTypes['FlexQuery']>, ParentType, ContextType, Partial<QueryFlexQueriesArgs>>;
  flexQueriesConnection?: Resolver<ResolversTypes['FlexQueriesConnection'], ParentType, ContextType, Partial<QueryFlexQueriesConnectionArgs>>;
  flexQueryRuns?: Resolver<Array<ResolversTypes['FlexQueryRun']>, ParentType, ContextType, Partial<QueryFlexQueryRunsArgs>>;
  flexQueryRunsConnection?: Resolver<ResolversTypes['FlexQueryRunsConnection'], ParentType, ContextType, Partial<QueryFlexQueryRunsConnectionArgs>>;
  generics?: Resolver<Array<ResolversTypes['Generic']>, ParentType, ContextType, Partial<QueryGenericsArgs>>;
  genericsConnection?: Resolver<ResolversTypes['GenericsConnection'], ParentType, ContextType, Partial<QueryGenericsConnectionArgs>>;
  getBrandReportItems?: Resolver<Array<ResolversTypes['GetBrandReportItem']>, ParentType, ContextType, Partial<QueryGetBrandReportItemsArgs>>;
  getBrandReportItemsConnection?: Resolver<ResolversTypes['GetBrandReportItemsConnection'], ParentType, ContextType, Partial<QueryGetBrandReportItemsConnectionArgs>>;
  getIndicationReportItems?: Resolver<Array<ResolversTypes['GetIndicationReportItem']>, ParentType, ContextType, Partial<QueryGetIndicationReportItemsArgs>>;
  getIndicationReportItemsConnection?: Resolver<ResolversTypes['GetIndicationReportItemsConnection'], ParentType, ContextType, Partial<QueryGetIndicationReportItemsConnectionArgs>>;
  globalLocks?: Resolver<Array<ResolversTypes['GlobalLock']>, ParentType, ContextType, Partial<QueryGlobalLocksArgs>>;
  globalLocksConnection?: Resolver<ResolversTypes['GlobalLocksConnection'], ParentType, ContextType, Partial<QueryGlobalLocksConnectionArgs>>;
  icd10Attributes?: Resolver<Array<ResolversTypes['Icd10Attribute']>, ParentType, ContextType, Partial<QueryIcd10AttributesArgs>>;
  icd10AttributesConnection?: Resolver<ResolversTypes['Icd10AttributesConnection'], ParentType, ContextType, Partial<QueryIcd10AttributesConnectionArgs>>;
  icd10Concepts?: Resolver<Array<ResolversTypes['Icd10Concept']>, ParentType, ContextType, Partial<QueryIcd10ConceptsArgs>>;
  icd10ConceptsConnection?: Resolver<ResolversTypes['Icd10ConceptsConnection'], ParentType, ContextType, Partial<QueryIcd10ConceptsConnectionArgs>>;
  icd10Entities?: Resolver<Array<ResolversTypes['Icd10Entity']>, ParentType, ContextType, Partial<QueryIcd10EntitiesArgs>>;
  icd10EntitiesConnection?: Resolver<ResolversTypes['Icd10EntitiesConnection'], ParentType, ContextType, Partial<QueryIcd10EntitiesConnectionArgs>>;
  icd10Suggestions?: Resolver<Array<ResolversTypes['Icd10Suggestions']>, ParentType, ContextType, Partial<QueryIcd10SuggestionsArgs>>;
  icd10SuggestionsConnection?: Resolver<ResolversTypes['Icd10SuggestionsConnection'], ParentType, ContextType, Partial<QueryIcd10SuggestionsConnectionArgs>>;
  icd10Traits?: Resolver<Array<ResolversTypes['Icd10Trait']>, ParentType, ContextType, Partial<QueryIcd10TraitsArgs>>;
  icd10TraitsConnection?: Resolver<ResolversTypes['Icd10TraitsConnection'], ParentType, ContextType, Partial<QueryIcd10TraitsConnectionArgs>>;
  impactItems?: Resolver<Array<ResolversTypes['ImpactItem']>, ParentType, ContextType, Partial<QueryImpactItemsArgs>>;
  impactItemsConnection?: Resolver<ResolversTypes['ImpactItemsConnection'], ParentType, ContextType, Partial<QueryImpactItemsConnectionArgs>>;
  indications?: Resolver<Array<ResolversTypes['Indication']>, ParentType, ContextType, Partial<QueryIndicationsArgs>>;
  indicationsConnection?: Resolver<ResolversTypes['IndicationsConnection'], ParentType, ContextType, Partial<QueryIndicationsConnectionArgs>>;
  integrityCheckCompleteResults?: Resolver<Array<ResolversTypes['IntegrityCheckCompleteResult']>, ParentType, ContextType, Partial<QueryIntegrityCheckCompleteResultsArgs>>;
  integrityCheckCompleteResultsConnection?: Resolver<ResolversTypes['IntegrityCheckCompleteResultsConnection'], ParentType, ContextType, Partial<QueryIntegrityCheckCompleteResultsConnectionArgs>>;
  integrityCheckTypes?: Resolver<Array<ResolversTypes['IntegrityCheckTypes']>, ParentType, ContextType, Partial<QueryIntegrityCheckTypesArgs>>;
  integrityCheckTypesConnection?: Resolver<ResolversTypes['IntegrityCheckTypesConnection'], ParentType, ContextType, Partial<QueryIntegrityCheckTypesConnectionArgs>>;
  libraryNinjaQueries?: Resolver<Array<ResolversTypes['NinjaQuery']>, ParentType, ContextType>;
  limitations?: Resolver<Array<ResolversTypes['Limitation']>, ParentType, ContextType, Partial<QueryLimitationsArgs>>;
  limitationsConnection?: Resolver<ResolversTypes['LimitationsConnection'], ParentType, ContextType, Partial<QueryLimitationsConnectionArgs>>;
  localizationKeySuggestions?: Resolver<Array<ResolversTypes['LocalizationKeySuggestions']>, ParentType, ContextType, Partial<QueryLocalizationKeySuggestionsArgs>>;
  localizationKeySuggestionsConnection?: Resolver<ResolversTypes['LocalizationKeySuggestionsConnection'], ParentType, ContextType, Partial<QueryLocalizationKeySuggestionsConnectionArgs>>;
  mainIndications?: Resolver<Array<ResolversTypes['MainIndication']>, ParentType, ContextType, Partial<QueryMainIndicationsArgs>>;
  mainIndicationsConnection?: Resolver<ResolversTypes['MainIndicationsConnection'], ParentType, ContextType, Partial<QueryMainIndicationsConnectionArgs>>;
  masterDataRefundImpacts?: Resolver<Array<ResolversTypes['MasterDataRefundImpact']>, ParentType, ContextType, Partial<QueryMasterDataRefundImpactsArgs>>;
  masterDataRefundImpactsConnection?: Resolver<ResolversTypes['MasterDataRefundImpactsConnection'], ParentType, ContextType, Partial<QueryMasterDataRefundImpactsConnectionArgs>>;
  masterDataUploadHistoryRecords?: Resolver<Array<ResolversTypes['MasterDataUploadHistoryRecord']>, ParentType, ContextType, Partial<QueryMasterDataUploadHistoryRecordsArgs>>;
  masterDataUploadHistoryRecordsConnection?: Resolver<ResolversTypes['MasterDataUploadHistoryRecordsConnection'], ParentType, ContextType, Partial<QueryMasterDataUploadHistoryRecordsConnectionArgs>>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, Partial<QueryMessagesArgs>>;
  messagesConnection?: Resolver<ResolversTypes['MessagesConnection'], ParentType, ContextType, Partial<QueryMessagesConnectionArgs>>;
  missingTranslationKeys?: Resolver<Array<ResolversTypes['MissingTranslationKeys']>, ParentType, ContextType, Partial<QueryMissingTranslationKeysArgs>>;
  missingTranslationKeysConnection?: Resolver<ResolversTypes['MissingTranslationKeysConnection'], ParentType, ContextType, Partial<QueryMissingTranslationKeysConnectionArgs>>;
  modules?: Resolver<Array<ResolversTypes['Module']>, ParentType, ContextType, Partial<QueryModulesArgs>>;
  modulesConnection?: Resolver<ResolversTypes['ModulesConnection'], ParentType, ContextType, Partial<QueryModulesConnectionArgs>>;
  negotiationRounds?: Resolver<Array<ResolversTypes['NegotiationRound']>, ParentType, ContextType, Partial<QueryNegotiationRoundsArgs>>;
  negotiationRoundsConnection?: Resolver<ResolversTypes['NegotiationRoundsConnection'], ParentType, ContextType, Partial<QueryNegotiationRoundsConnectionArgs>>;
  neo4JClusterMemberMetrics?: Resolver<Array<ResolversTypes['Neo4jClusterMemberMetric']>, ParentType, ContextType, Partial<QueryNeo4JClusterMemberMetricsArgs>>;
  neo4JClusterMemberMetricsConnection?: Resolver<ResolversTypes['Neo4JClusterMemberMetricsConnection'], ParentType, ContextType, Partial<QueryNeo4JClusterMemberMetricsConnectionArgs>>;
  neo4JClusterMetrics?: Resolver<Array<ResolversTypes['Neo4jClusterMetrics']>, ParentType, ContextType, Partial<QueryNeo4JClusterMetricsArgs>>;
  neo4JClusterMetricsConnection?: Resolver<ResolversTypes['Neo4JClusterMetricsConnection'], ParentType, ContextType, Partial<QueryNeo4JClusterMetricsConnectionArgs>>;
  ninjaQueries?: Resolver<Array<ResolversTypes['NinjaQuery']>, ParentType, ContextType, Partial<QueryNinjaQueriesArgs>>;
  ninjaQueriesConnection?: Resolver<ResolversTypes['NinjaQueriesConnection'], ParentType, ContextType, Partial<QueryNinjaQueriesConnectionArgs>>;
  ninjaQueryImpacts?: Resolver<Array<ResolversTypes['NinjaQueryImpact']>, ParentType, ContextType, Partial<QueryNinjaQueryImpactsArgs>>;
  ninjaQueryImpactsConnection?: Resolver<ResolversTypes['NinjaQueryImpactsConnection'], ParentType, ContextType, Partial<QueryNinjaQueryImpactsConnectionArgs>>;
  ninjaQuerySubmitResults?: Resolver<Array<ResolversTypes['NinjaQuerySubmitResult']>, ParentType, ContextType, Partial<QueryNinjaQuerySubmitResultsArgs>>;
  ninjaQuerySubmitResultsConnection?: Resolver<ResolversTypes['NinjaQuerySubmitResultsConnection'], ParentType, ContextType, Partial<QueryNinjaQuerySubmitResultsConnectionArgs>>;
  oidDcUsers?: Resolver<Array<ResolversTypes['OidDcUser']>, ParentType, ContextType, Partial<QueryOidDcUsersArgs>>;
  oidDcUsersConnection?: Resolver<ResolversTypes['OidDcUsersConnection'], ParentType, ContextType, Partial<QueryOidDcUsersConnectionArgs>>;
  organizationScopes?: Resolver<Array<ResolversTypes['OrganizationScope']>, ParentType, ContextType, Partial<QueryOrganizationScopesArgs>>;
  organizationScopesConnection?: Resolver<ResolversTypes['OrganizationScopesConnection'], ParentType, ContextType, Partial<QueryOrganizationScopesConnectionArgs>>;
  organizations?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType, Partial<QueryOrganizationsArgs>>;
  organizationsConnection?: Resolver<ResolversTypes['OrganizationsConnection'], ParentType, ContextType, Partial<QueryOrganizationsConnectionArgs>>;
  partners?: Resolver<Array<ResolversTypes['Partner']>, ParentType, ContextType, Partial<QueryPartnersArgs>>;
  partnersConnection?: Resolver<ResolversTypes['PartnersConnection'], ParentType, ContextType, Partial<QueryPartnersConnectionArgs>>;
  patients?: Resolver<Array<ResolversTypes['Patient']>, ParentType, ContextType, Partial<QueryPatientsArgs>>;
  patientsConnection?: Resolver<ResolversTypes['PatientsConnection'], ParentType, ContextType, Partial<QueryPatientsConnectionArgs>>;
  performanceCounters?: Resolver<Array<ResolversTypes['PerformanceCounter']>, ParentType, ContextType, Partial<QueryPerformanceCountersArgs>>;
  performanceCountersConnection?: Resolver<ResolversTypes['PerformanceCountersConnection'], ParentType, ContextType, Partial<QueryPerformanceCountersConnectionArgs>>;
  performanceMeasurements?: Resolver<Array<ResolversTypes['PerformanceMeasurement']>, ParentType, ContextType, Partial<QueryPerformanceMeasurementsArgs>>;
  performanceMeasurementsConnection?: Resolver<ResolversTypes['PerformanceMeasurementsConnection'], ParentType, ContextType, Partial<QueryPerformanceMeasurementsConnectionArgs>>;
  performanceThresholds?: Resolver<Array<ResolversTypes['PerformanceThreshold']>, ParentType, ContextType, Partial<QueryPerformanceThresholdsArgs>>;
  performanceThresholdsConnection?: Resolver<ResolversTypes['PerformanceThresholdsConnection'], ParentType, ContextType, Partial<QueryPerformanceThresholdsConnectionArgs>>;
  pgBossMetrics?: Resolver<Array<ResolversTypes['PgBossMetrics']>, ParentType, ContextType, Partial<QueryPgBossMetricsArgs>>;
  pgBossMetricsConnection?: Resolver<ResolversTypes['PgBossMetricsConnection'], ParentType, ContextType, Partial<QueryPgBossMetricsConnectionArgs>>;
  pgBossQueueStats?: Resolver<Array<ResolversTypes['PgBossQueueStat']>, ParentType, ContextType, Partial<QueryPgBossQueueStatsArgs>>;
  pgBossQueueStatsConnection?: Resolver<ResolversTypes['PgBossQueueStatsConnection'], ParentType, ContextType, Partial<QueryPgBossQueueStatsConnectionArgs>>;
  policyTypes?: Resolver<Array<ResolversTypes['PolicyType']>, ParentType, ContextType, Partial<QueryPolicyTypesArgs>>;
  policyTypesConnection?: Resolver<ResolversTypes['PolicyTypesConnection'], ParentType, ContextType, Partial<QueryPolicyTypesConnectionArgs>>;
  policyVersions?: Resolver<Array<ResolversTypes['PolicyVersion']>, ParentType, ContextType, Partial<QueryPolicyVersionsArgs>>;
  policyVersionsConnection?: Resolver<ResolversTypes['PolicyVersionsConnection'], ParentType, ContextType, Partial<QueryPolicyVersionsConnectionArgs>>;
  postgresMetrics?: Resolver<Array<ResolversTypes['PostgresMetric']>, ParentType, ContextType, Partial<QueryPostgresMetricsArgs>>;
  postgresMetricsConnection?: Resolver<ResolversTypes['PostgresMetricsConnection'], ParentType, ContextType, Partial<QueryPostgresMetricsConnectionArgs>>;
  preparationStatuses?: Resolver<Array<ResolversTypes['PreparationStatus']>, ParentType, ContextType, Partial<QueryPreparationStatusesArgs>>;
  preparationStatusesConnection?: Resolver<ResolversTypes['PreparationStatusesConnection'], ParentType, ContextType, Partial<QueryPreparationStatusesConnectionArgs>>;
  preparations?: Resolver<Array<ResolversTypes['Preparation']>, ParentType, ContextType, Partial<QueryPreparationsArgs>>;
  preparationsConnection?: Resolver<ResolversTypes['PreparationsConnection'], ParentType, ContextType, Partial<QueryPreparationsConnectionArgs>>;
  prices?: Resolver<Array<ResolversTypes['Price']>, ParentType, ContextType, Partial<QueryPricesArgs>>;
  pricesConnection?: Resolver<ResolversTypes['PricesConnection'], ParentType, ContextType, Partial<QueryPricesConnectionArgs>>;
  productBlueprintResults?: Resolver<Array<ResolversTypes['ProductBlueprintResult']>, ParentType, ContextType, Partial<QueryProductBlueprintResultsArgs>>;
  productBlueprintResultsConnection?: Resolver<ResolversTypes['ProductBlueprintResultsConnection'], ParentType, ContextType, Partial<QueryProductBlueprintResultsConnectionArgs>>;
  productBlueprints?: Resolver<Array<ResolversTypes['ProductBlueprint']>, ParentType, ContextType, Partial<QueryProductBlueprintsArgs>>;
  productBlueprintsConnection?: Resolver<ResolversTypes['ProductBlueprintsConnection'], ParentType, ContextType, Partial<QueryProductBlueprintsConnectionArgs>>;
  publicPrices?: Resolver<Array<ResolversTypes['PublicPrice']>, ParentType, ContextType, Partial<QueryPublicPricesArgs>>;
  publicPricesConnection?: Resolver<ResolversTypes['PublicPricesConnection'], ParentType, ContextType, Partial<QueryPublicPricesConnectionArgs>>;
  purchases?: Resolver<Array<ResolversTypes['Purchase']>, ParentType, ContextType, Partial<QueryPurchasesArgs>>;
  purchasesConnection?: Resolver<ResolversTypes['PurchasesConnection'], ParentType, ContextType, Partial<QueryPurchasesConnectionArgs>>;
  queryLogs?: Resolver<Array<ResolversTypes['QueryLog']>, ParentType, ContextType, Partial<QueryQueryLogsArgs>>;
  queryLogsConnection?: Resolver<ResolversTypes['QueryLogsConnection'], ParentType, ContextType, Partial<QueryQueryLogsConnectionArgs>>;
  queryResults?: Resolver<Array<ResolversTypes['QueryResult']>, ParentType, ContextType, Partial<QueryQueryResultsArgs>>;
  queryResultsConnection?: Resolver<ResolversTypes['QueryResultsConnection'], ParentType, ContextType, Partial<QueryQueryResultsConnectionArgs>>;
  questNotifications?: Resolver<Array<ResolversTypes['QuestNotification']>, ParentType, ContextType, Partial<QueryQuestNotificationsArgs>>;
  questNotificationsConnection?: Resolver<ResolversTypes['QuestNotificationsConnection'], ParentType, ContextType, Partial<QueryQuestNotificationsConnectionArgs>>;
  refunds?: Resolver<Array<ResolversTypes['Refund']>, ParentType, ContextType, Partial<QueryRefundsArgs>>;
  refundsConnection?: Resolver<ResolversTypes['RefundsConnection'], ParentType, ContextType, Partial<QueryRefundsConnectionArgs>>;
  runCheckValues?: Resolver<Array<ResolversTypes['RunCheckValues']>, ParentType, ContextType, Partial<QueryRunCheckValuesArgs>>;
  runCheckValuesConnection?: Resolver<ResolversTypes['RunCheckValuesConnection'], ParentType, ContextType, Partial<QueryRunCheckValuesConnectionArgs>>;
  runChecks?: Resolver<Array<ResolversTypes['RunCheck']>, ParentType, ContextType, Partial<QueryRunChecksArgs>>;
  runChecksConnection?: Resolver<ResolversTypes['RunChecksConnection'], ParentType, ContextType, Partial<QueryRunChecksConnectionArgs>>;
  runDqcReports?: Resolver<Array<ResolversTypes['RunDQCReport']>, ParentType, ContextType, Partial<QueryRunDqcReportsArgs>>;
  runDqcReportsConnection?: Resolver<ResolversTypes['RunDqcReportsConnection'], ParentType, ContextType, Partial<QueryRunDqcReportsConnectionArgs>>;
  runnableChecks?: Resolver<Array<ResolversTypes['RunnableCheck']>, ParentType, ContextType, Partial<QueryRunnableChecksArgs>>;
  runnableChecksConnection?: Resolver<ResolversTypes['RunnableChecksConnection'], ParentType, ContextType, Partial<QueryRunnableChecksConnectionArgs>>;
  runningJobStates?: Resolver<Array<ResolversTypes['RunningJobState']>, ParentType, ContextType, Partial<QueryRunningJobStatesArgs>>;
  runningJobStatesConnection?: Resolver<ResolversTypes['RunningJobStatesConnection'], ParentType, ContextType, Partial<QueryRunningJobStatesConnectionArgs>>;
  scenarioActions?: Resolver<Array<ResolversTypes['ScenarioAction']>, ParentType, ContextType, Partial<QueryScenarioActionsArgs>>;
  scenarioActionsConnection?: Resolver<ResolversTypes['ScenarioActionsConnection'], ParentType, ContextType, Partial<QueryScenarioActionsConnectionArgs>>;
  scenarioConditions?: Resolver<Array<ResolversTypes['ScenarioCondition']>, ParentType, ContextType, Partial<QueryScenarioConditionsArgs>>;
  scenarioConditionsConnection?: Resolver<ResolversTypes['ScenarioConditionsConnection'], ParentType, ContextType, Partial<QueryScenarioConditionsConnectionArgs>>;
  scenarios?: Resolver<Array<ResolversTypes['Scenario']>, ParentType, ContextType, Partial<QueryScenariosArgs>>;
  scenariosConnection?: Resolver<ResolversTypes['ScenariosConnection'], ParentType, ContextType, Partial<QueryScenariosConnectionArgs>>;
  scopeCheckResults?: Resolver<Array<ResolversTypes['ScopeCheckResult']>, ParentType, ContextType, Partial<QueryScopeCheckResultsArgs>>;
  scopeCheckResultsConnection?: Resolver<ResolversTypes['ScopeCheckResultsConnection'], ParentType, ContextType, Partial<QueryScopeCheckResultsConnectionArgs>>;
  simulationCounts?: Resolver<Array<ResolversTypes['SimulationCount']>, ParentType, ContextType, Partial<QuerySimulationCountsArgs>>;
  simulationCountsConnection?: Resolver<ResolversTypes['SimulationCountsConnection'], ParentType, ContextType, Partial<QuerySimulationCountsConnectionArgs>>;
  simulationUserWithRoles?: Resolver<Array<ResolversTypes['SimulationUserWithRole']>, ParentType, ContextType, Partial<QuerySimulationUserWithRolesArgs>>;
  simulationUserWithRolesConnection?: Resolver<ResolversTypes['SimulationUserWithRolesConnection'], ParentType, ContextType, Partial<QuerySimulationUserWithRolesConnectionArgs>>;
  simulations?: Resolver<Array<ResolversTypes['Simulation']>, ParentType, ContextType, Partial<QuerySimulationsArgs>>;
  simulationsConnection?: Resolver<ResolversTypes['SimulationsConnection'], ParentType, ContextType, Partial<QuerySimulationsConnectionArgs>>;
  slowGraphqlOperations?: Resolver<Array<ResolversTypes['SlowGraphqlOperation']>, ParentType, ContextType, Partial<QuerySlowGraphqlOperationsArgs>>;
  slowGraphqlOperationsConnection?: Resolver<ResolversTypes['SlowGraphqlOperationsConnection'], ParentType, ContextType, Partial<QuerySlowGraphqlOperationsConnectionArgs>>;
  slowGraphqlRequestsResults?: Resolver<Array<ResolversTypes['SlowGraphqlRequestsResult']>, ParentType, ContextType, Partial<QuerySlowGraphqlRequestsResultsArgs>>;
  slowGraphqlRequestsResultsConnection?: Resolver<ResolversTypes['SlowGraphqlRequestsResultsConnection'], ParentType, ContextType, Partial<QuerySlowGraphqlRequestsResultsConnectionArgs>>;
  storeUsers?: Resolver<Array<ResolversTypes['StoreUser']>, ParentType, ContextType, Partial<QueryStoreUsersArgs>>;
  storeUsersConnection?: Resolver<ResolversTypes['StoreUsersConnection'], ParentType, ContextType, Partial<QueryStoreUsersConnectionArgs>>;
  syncRefundImpacts?: Resolver<Array<ResolversTypes['SyncRefundImpact']>, ParentType, ContextType, Partial<QuerySyncRefundImpactsArgs>>;
  syncRefundImpactsConnection?: Resolver<ResolversTypes['SyncRefundImpactsConnection'], ParentType, ContextType, Partial<QuerySyncRefundImpactsConnectionArgs>>;
  syncResponses?: Resolver<Array<ResolversTypes['SyncResponse']>, ParentType, ContextType, Partial<QuerySyncResponsesArgs>>;
  syncResponsesConnection?: Resolver<ResolversTypes['SyncResponsesConnection'], ParentType, ContextType, Partial<QuerySyncResponsesConnectionArgs>>;
  systemTasks?: Resolver<Array<ResolversTypes['SystemTask']>, ParentType, ContextType, Partial<QuerySystemTasksArgs>>;
  systemTasksConnection?: Resolver<ResolversTypes['SystemTasksConnection'], ParentType, ContextType, Partial<QuerySystemTasksConnectionArgs>>;
  translations?: Resolver<Array<ResolversTypes['Translation']>, ParentType, ContextType, Partial<QueryTranslationsArgs>>;
  translationsConnection?: Resolver<ResolversTypes['TranslationsConnection'], ParentType, ContextType, Partial<QueryTranslationsConnectionArgs>>;
  translationsWithChangedKeys?: Resolver<Array<ResolversTypes['TranslationsWithChangedKeys']>, ParentType, ContextType, Partial<QueryTranslationsWithChangedKeysArgs>>;
  translationsWithChangedKeysConnection?: Resolver<ResolversTypes['TranslationsWithChangedKeysConnection'], ParentType, ContextType, Partial<QueryTranslationsWithChangedKeysConnectionArgs>>;
  treatmentSets?: Resolver<Array<ResolversTypes['TreatmentSet']>, ParentType, ContextType, Partial<QueryTreatmentSetsArgs>>;
  treatmentSetsConnection?: Resolver<ResolversTypes['TreatmentSetsConnection'], ParentType, ContextType, Partial<QueryTreatmentSetsConnectionArgs>>;
  treatments?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, Partial<QueryTreatmentsArgs>>;
  treatmentsConnection?: Resolver<ResolversTypes['TreatmentsConnection'], ParentType, ContextType, Partial<QueryTreatmentsConnectionArgs>>;
  uploadLimitations?: Resolver<Array<ResolversTypes['UploadLimitation']>, ParentType, ContextType, Partial<QueryUploadLimitationsArgs>>;
  uploadLimitationsConnection?: Resolver<ResolversTypes['UploadLimitationsConnection'], ParentType, ContextType, Partial<QueryUploadLimitationsConnectionArgs>>;
  uploadStates?: Resolver<Array<ResolversTypes['UploadState']>, ParentType, ContextType, Partial<QueryUploadStatesArgs>>;
  uploadStatesConnection?: Resolver<ResolversTypes['UploadStatesConnection'], ParentType, ContextType, Partial<QueryUploadStatesConnectionArgs>>;
  uploads?: Resolver<Array<ResolversTypes['Upload']>, ParentType, ContextType, Partial<QueryUploadsArgs>>;
  uploadsConnection?: Resolver<ResolversTypes['UploadsConnection'], ParentType, ContextType, Partial<QueryUploadsConnectionArgs>>;
  userAvailableEntryModules?: Resolver<Array<ResolversTypes['UserAvailableEntryModule']>, ParentType, ContextType, Partial<QueryUserAvailableEntryModulesArgs>>;
  userAvailableEntryModulesConnection?: Resolver<ResolversTypes['UserAvailableEntryModulesConnection'], ParentType, ContextType, Partial<QueryUserAvailableEntryModulesConnectionArgs>>;
  userContexts?: Resolver<Array<ResolversTypes['UserContext']>, ParentType, ContextType, Partial<QueryUserContextsArgs>>;
  userContextsConnection?: Resolver<ResolversTypes['UserContextsConnection'], ParentType, ContextType, Partial<QueryUserContextsConnectionArgs>>;
  userOrgSettingsData?: Resolver<Array<ResolversTypes['UserOrgSettingsData']>, ParentType, ContextType, Partial<QueryUserOrgSettingsDataArgs>>;
  userOrgSettingsDataConnection?: Resolver<ResolversTypes['UserOrgSettingsDataConnection'], ParentType, ContextType, Partial<QueryUserOrgSettingsDataConnectionArgs>>;
  userOrganizationInfos?: Resolver<Array<ResolversTypes['UserOrganizationInfo']>, ParentType, ContextType, Partial<QueryUserOrganizationInfosArgs>>;
  userOrganizationInfosConnection?: Resolver<ResolversTypes['UserOrganizationInfosConnection'], ParentType, ContextType, Partial<QueryUserOrganizationInfosConnectionArgs>>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, Partial<QueryUsersArgs>>;
  usersConnection?: Resolver<ResolversTypes['UsersConnection'], ParentType, ContextType, Partial<QueryUsersConnectionArgs>>;
};

export type QueryLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryLog'] = ResolversParentTypes['QueryLog']> = {
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pushedByUserEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryLogEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryLogEdge'] = ResolversParentTypes['QueryLogEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['QueryLog'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryLogsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryLogsConnection'] = ResolversParentTypes['QueryLogsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['QueryLogEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryResult'] = ResolversParentTypes['QueryResult']> = {
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryResultEdge'] = ResolversParentTypes['QueryResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['QueryResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResultsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryResultsConnection'] = ResolversParentTypes['QueryResultsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['QueryResultEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestNotification'] = ResolversParentTypes['QuestNotification']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscribed?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType, RequireFields<QuestNotificationSubscribedArgs, 'directed'>>;
  subscribedAggregate?: Resolver<Maybe<ResolversTypes['QuestNotificationOrganizationSubscribedAggregationSelection']>, ParentType, ContextType, RequireFields<QuestNotificationSubscribedAggregateArgs, 'directed'>>;
  subscribedConnection?: Resolver<ResolversTypes['QuestNotificationSubscribedConnection'], ParentType, ContextType, RequireFields<QuestNotificationSubscribedConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestNotificationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestNotificationEdge'] = ResolversParentTypes['QuestNotificationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['QuestNotification'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestNotificationOrganizationSubscribedAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestNotificationOrganizationSubscribedAggregationSelection'] = ResolversParentTypes['QuestNotificationOrganizationSubscribedAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['QuestNotificationOrganizationSubscribedEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['QuestNotificationOrganizationSubscribedNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestNotificationOrganizationSubscribedEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestNotificationOrganizationSubscribedEdgeAggregateSelection'] = ResolversParentTypes['QuestNotificationOrganizationSubscribedEdgeAggregateSelection']> = {
  autocompletionThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  threshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestNotificationOrganizationSubscribedNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestNotificationOrganizationSubscribedNodeAggregateSelection'] = ResolversParentTypes['QuestNotificationOrganizationSubscribedNodeAggregateSelection']> = {
  BIC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  IBAN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  aggregationPriority?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  autoIssuanceThreshold?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactFirstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactLastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactOccupation?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  contactPhone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderDelay?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentReviewReminderRecurrentStep?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  documentSftpSavePath?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  domicile?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  dualApprovalThreshold?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  eIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  fax?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  legalName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  pharmaId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  rebateProcessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  website?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestNotificationSubscribedConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestNotificationSubscribedConnection'] = ResolversParentTypes['QuestNotificationSubscribedConnection']> = {
  edges?: Resolver<Array<ResolversTypes['QuestNotificationSubscribedRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestNotificationSubscribedRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestNotificationSubscribedRelationship'] = ResolversParentTypes['QuestNotificationSubscribedRelationship']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  amountType?: Resolver<Maybe<ResolversTypes['AmountsType']>, ParentType, ContextType>;
  autocompletionThreshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isAutocompletionEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  threshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestNotificationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestNotificationsConnection'] = ResolversParentTypes['QuestNotificationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['QuestNotificationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundResolvers<ContextType = any, ParentType extends ResolversParentTypes['Refund'] = ResolversParentTypes['Refund']> = {
  agreement?: Resolver<Maybe<ResolversTypes['Agreement']>, ParentType, ContextType, RequireFields<RefundAgreementArgs, 'directed'>>;
  agreementAggregate?: Resolver<Maybe<ResolversTypes['RefundAgreementAgreementAggregationSelection']>, ParentType, ContextType, RequireFields<RefundAgreementAggregateArgs, 'directed'>>;
  agreementConnection?: Resolver<ResolversTypes['RefundAgreementConnection'], ParentType, ContextType, RequireFields<RefundAgreementConnectionArgs, 'directed'>>;
  agreementId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  case?: Resolver<Maybe<ResolversTypes['Case']>, ParentType, ContextType, RequireFields<RefundCaseArgs, 'directed'>>;
  caseAggregate?: Resolver<Maybe<ResolversTypes['RefundCaseCaseAggregationSelection']>, ParentType, ContextType, RequireFields<RefundCaseAggregateArgs, 'directed'>>;
  caseConnection?: Resolver<ResolversTypes['RefundCaseConnection'], ParentType, ContextType, RequireFields<RefundCaseConnectionArgs, 'directed'>>;
  caseId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  caseOrAgreementId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  documentFinancialDataPoint?: Resolver<Maybe<ResolversTypes['FlexFinancialDataPoint']>, ParentType, ContextType, RequireFields<RefundDocumentFinancialDataPointArgs, 'directed'>>;
  documentFinancialDataPointAggregate?: Resolver<Maybe<ResolversTypes['RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection']>, ParentType, ContextType, RequireFields<RefundDocumentFinancialDataPointAggregateArgs, 'directed'>>;
  documentFinancialDataPointConnection?: Resolver<ResolversTypes['RefundDocumentFinancialDataPointConnection'], ParentType, ContextType, RequireFields<RefundDocumentFinancialDataPointConnectionArgs, 'directed'>>;
  documents?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<RefundDocumentsArgs, 'directed'>>;
  documentsAggregate?: Resolver<Maybe<ResolversTypes['RefundDocumentDocumentsAggregationSelection']>, ParentType, ContextType, RequireFields<RefundDocumentsAggregateArgs, 'directed'>>;
  documentsConnection?: Resolver<ResolversTypes['RefundDocumentsConnection'], ParentType, ContextType, RequireFields<RefundDocumentsConnectionArgs, 'directed'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sourceFinancialDataPoint?: Resolver<ResolversTypes['FlexFinancialDataPoint'], ParentType, ContextType, RequireFields<RefundSourceFinancialDataPointArgs, 'directed'>>;
  sourceFinancialDataPointAggregate?: Resolver<Maybe<ResolversTypes['RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection']>, ParentType, ContextType, RequireFields<RefundSourceFinancialDataPointAggregateArgs, 'directed'>>;
  sourceFinancialDataPointConnection?: Resolver<ResolversTypes['RefundSourceFinancialDataPointConnection'], ParentType, ContextType, RequireFields<RefundSourceFinancialDataPointConnectionArgs, 'directed'>>;
  status?: Resolver<ResolversTypes['RefundStatus'], ParentType, ContextType>;
  tenantIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundAgreementAgreementAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundAgreementAgreementAggregationSelection'] = ResolversParentTypes['RefundAgreementAgreementAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['RefundAgreementAgreementNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundAgreementAgreementNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundAgreementAgreementNodeAggregateSelection'] = ResolversParentTypes['RefundAgreementAgreementNodeAggregateSelection']> = {
  caseSuspensionIntervalDays?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  coveringFormWaitInterval?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  daysToExpiry?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  defaultPriceRate?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  firstExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  formattedAmount?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedCounterparties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedDiseases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedIndications?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedProducts?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedTags?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  formattedValidityPeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  initialVersionId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastExecutionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  pushedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  reportData?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundAgreementConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundAgreementConnection'] = ResolversParentTypes['RefundAgreementConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RefundAgreementRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundAgreementRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundAgreementRelationship'] = ResolversParentTypes['RefundAgreementRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Agreement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundCaseCaseAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundCaseCaseAggregationSelection'] = ResolversParentTypes['RefundCaseCaseAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['RefundCaseCaseNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundCaseCaseNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundCaseCaseNodeAggregateSelection'] = ResolversParentTypes['RefundCaseCaseNodeAggregateSelection']> = {
  creationDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  preparationBrandName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  submissionDate?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundCaseConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundCaseConnection'] = ResolversParentTypes['RefundCaseConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RefundCaseRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundCaseRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundCaseRelationship'] = ResolversParentTypes['RefundCaseRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Case'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundDocumentDocumentsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundDocumentDocumentsAggregationSelection'] = ResolversParentTypes['RefundDocumentDocumentsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['RefundDocumentDocumentsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundDocumentDocumentsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundDocumentDocumentsNodeAggregateSelection'] = ResolversParentTypes['RefundDocumentDocumentsNodeAggregateSelection']> = {
  counterParties?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  coveragePeriod?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  issuedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundDocumentFinancialDataPointConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundDocumentFinancialDataPointConnection'] = ResolversParentTypes['RefundDocumentFinancialDataPointConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RefundDocumentFinancialDataPointRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundDocumentFinancialDataPointRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundDocumentFinancialDataPointRelationship'] = ResolversParentTypes['RefundDocumentFinancialDataPointRelationship']> = {
  connectionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexFinancialDataPoint'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['FinancialDataPointStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundDocumentsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundDocumentsConnection'] = ResolversParentTypes['RefundDocumentsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RefundDocumentsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundDocumentsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundDocumentsRelationship'] = ResolversParentTypes['RefundDocumentsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Document'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundEdge'] = ResolversParentTypes['RefundEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Refund'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection'] = ResolversParentTypes['RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection'] = ResolversParentTypes['RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection']> = {
  connectionId?: Resolver<ResolversTypes['IDAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection'] = ResolversParentTypes['RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection']> = {
  basePrice?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  evaluationSnapshot?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  generatedUuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  netPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  payable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  payablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundDeltaNumber?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  revokedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroMainNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroRelevantNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  variable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  variablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection'] = ResolversParentTypes['RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection'] = ResolversParentTypes['RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection']> = {
  basePrice?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  evaluationSnapshot?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  generatedUuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  netPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  payable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  payablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundDeltaNumber?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  refundablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  revokedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroMainNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  scenarioZeroRelevantNetPrices?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  variable?: Resolver<ResolversTypes['FloatAggregateSelectionNonNullable'], ParentType, ContextType>;
  variablePercentage?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundSourceFinancialDataPointConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundSourceFinancialDataPointConnection'] = ResolversParentTypes['RefundSourceFinancialDataPointConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RefundSourceFinancialDataPointRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundSourceFinancialDataPointRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundSourceFinancialDataPointRelationship'] = ResolversParentTypes['RefundSourceFinancialDataPointRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexFinancialDataPoint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundsConnection'] = ResolversParentTypes['RefundsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RefundEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheck'] = ResolversParentTypes['RunCheck']> = {
  alerts?: Resolver<Array<ResolversTypes['Alert']>, ParentType, ContextType, RequireFields<RunCheckAlertsArgs, 'directed'>>;
  alertsAggregate?: Resolver<Maybe<ResolversTypes['RunCheckAlertAlertsAggregationSelection']>, ParentType, ContextType, RequireFields<RunCheckAlertsAggregateArgs, 'directed'>>;
  alertsConnection?: Resolver<ResolversTypes['RunCheckAlertsConnection'], ParentType, ContextType, RequireFields<RunCheckAlertsConnectionArgs, 'directed'>>;
  checkKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  completedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  startedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  triggerKind?: Resolver<ResolversTypes['RunCheckTrigger'], ParentType, ContextType>;
  triggeredBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['RunCheckValues']>, ParentType, ContextType, RequireFields<RunCheckValuesArgs, 'directed'>>;
  valuesAggregate?: Resolver<Maybe<ResolversTypes['RunCheckRunCheckValuesValuesAggregationSelection']>, ParentType, ContextType, RequireFields<RunCheckValuesAggregateArgs, 'directed'>>;
  valuesConnection?: Resolver<ResolversTypes['RunCheckValuesConnection'], ParentType, ContextType, RequireFields<RunCheckValuesConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckAlertAlertsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckAlertAlertsAggregationSelection'] = ResolversParentTypes['RunCheckAlertAlertsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['RunCheckAlertAlertsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckAlertAlertsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckAlertAlertsNodeAggregateSelection'] = ResolversParentTypes['RunCheckAlertAlertsNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  entityId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  entityUniqueIdentifier?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  organizationCountry?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  organizationName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckAlertsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckAlertsConnection'] = ResolversParentTypes['RunCheckAlertsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RunCheckAlertsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckAlertsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckAlertsRelationship'] = ResolversParentTypes['RunCheckAlertsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Alert'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckEdge'] = ResolversParentTypes['RunCheckEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['RunCheck'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckRunCheckValuesValuesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckRunCheckValuesValuesAggregationSelection'] = ResolversParentTypes['RunCheckRunCheckValuesValuesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['RunCheckRunCheckValuesValuesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckRunCheckValuesValuesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckRunCheckValuesValuesNodeAggregateSelection'] = ResolversParentTypes['RunCheckRunCheckValuesValuesNodeAggregateSelection']> = {
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  values?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckValuesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckValues'] = ResolversParentTypes['RunCheckValues']> = {
  check?: Resolver<ResolversTypes['RunCheck'], ParentType, ContextType, RequireFields<RunCheckValuesCheckArgs, 'directed'>>;
  checkAggregate?: Resolver<Maybe<ResolversTypes['RunCheckValuesRunCheckCheckAggregationSelection']>, ParentType, ContextType, RequireFields<RunCheckValuesCheckAggregateArgs, 'directed'>>;
  checkConnection?: Resolver<ResolversTypes['RunCheckValuesCheckConnection'], ParentType, ContextType, RequireFields<RunCheckValuesCheckConnectionArgs, 'directed'>>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckValuesCheckConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckValuesCheckConnection'] = ResolversParentTypes['RunCheckValuesCheckConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RunCheckValuesCheckRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckValuesCheckRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckValuesCheckRelationship'] = ResolversParentTypes['RunCheckValuesCheckRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['RunCheck'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RunCheckValuesType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckValuesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckValuesConnection'] = ResolversParentTypes['RunCheckValuesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RunCheckValuesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckValuesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckValuesEdge'] = ResolversParentTypes['RunCheckValuesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['RunCheckValues'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckValuesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckValuesRelationship'] = ResolversParentTypes['RunCheckValuesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['RunCheckValues'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RunCheckValuesType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckValuesRunCheckCheckAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckValuesRunCheckCheckAggregationSelection'] = ResolversParentTypes['RunCheckValuesRunCheckCheckAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['RunCheckValuesRunCheckCheckNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckValuesRunCheckCheckNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckValuesRunCheckCheckNodeAggregateSelection'] = ResolversParentTypes['RunCheckValuesRunCheckCheckNodeAggregateSelection']> = {
  checkKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  checkName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  completedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  count?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  startedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  triggeredBy?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunCheckValuesWithTypeRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunCheckValuesWithTypeRelationship'] = ResolversParentTypes['RunCheckValuesWithTypeRelationship']> = {
  __resolveType: TypeResolveFn<'RunCheckValuesCheckRelationship' | 'RunCheckValuesRelationship', ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RunCheckValuesType'], ParentType, ContextType>;
};

export type RunChecksConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunChecksConnection'] = ResolversParentTypes['RunChecksConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RunCheckEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunDqcReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunDQCReport'] = ResolversParentTypes['RunDQCReport']> = {
  checks?: Resolver<Array<ResolversTypes['RunCheck']>, ParentType, ContextType, RequireFields<RunDqcReportChecksArgs, 'directed'>>;
  checksAggregate?: Resolver<Maybe<ResolversTypes['RunDQCReportRunCheckChecksAggregationSelection']>, ParentType, ContextType, RequireFields<RunDqcReportChecksAggregateArgs, 'directed'>>;
  checksConnection?: Resolver<ResolversTypes['RunDQCReportChecksConnection'], ParentType, ContextType, RequireFields<RunDqcReportChecksConnectionArgs, 'directed'>>;
  completedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  triggeredBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunDqcReportChecksConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunDQCReportChecksConnection'] = ResolversParentTypes['RunDQCReportChecksConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RunDQCReportChecksRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunDqcReportChecksRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunDQCReportChecksRelationship'] = ResolversParentTypes['RunDQCReportChecksRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['RunCheck'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunDqcReportEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunDQCReportEdge'] = ResolversParentTypes['RunDQCReportEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['RunDQCReport'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunDqcReportRunCheckChecksAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunDQCReportRunCheckChecksAggregationSelection'] = ResolversParentTypes['RunDQCReportRunCheckChecksAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['RunDQCReportRunCheckChecksNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunDqcReportRunCheckChecksNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunDQCReportRunCheckChecksNodeAggregateSelection'] = ResolversParentTypes['RunDQCReportRunCheckChecksNodeAggregateSelection']> = {
  checkKey?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  checkName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  completedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  count?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  startedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  triggeredBy?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunDqcReportsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunDqcReportsConnection'] = ResolversParentTypes['RunDqcReportsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RunDQCReportEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunnableCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunnableCheck'] = ResolversParentTypes['RunnableCheck']> = {
  isDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunnableCheckEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunnableCheckEdge'] = ResolversParentTypes['RunnableCheckEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['RunnableCheck'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunnableChecksConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunnableChecksConnection'] = ResolversParentTypes['RunnableChecksConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RunnableCheckEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunningJobStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunningJobState'] = ResolversParentTypes['RunningJobState']> = {
  createdOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunningJobStateEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunningJobStateEdge'] = ResolversParentTypes['RunningJobStateEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['RunningJobState'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunningJobStatesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunningJobStatesConnection'] = ResolversParentTypes['RunningJobStatesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RunningJobStateEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioResolvers<ContextType = any, ParentType extends ResolversParentTypes['Scenario'] = ResolversParentTypes['Scenario']> = {
  actionSets?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  actionSetsOperator?: Resolver<Maybe<ResolversTypes['ActionSetsOperator']>, ParentType, ContextType>;
  actions?: Resolver<Array<ResolversTypes['ScenarioAction']>, ParentType, ContextType, RequireFields<ScenarioActionsArgs, 'directed'>>;
  actionsAggregate?: Resolver<Maybe<ResolversTypes['ScenarioScenarioActionActionsAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioActionsAggregateArgs, 'directed'>>;
  actionsConnection?: Resolver<ResolversTypes['ScenarioActionsConnection'], ParentType, ContextType, RequireFields<ScenarioActionsConnectionArgs, 'directed'>>;
  conditions?: Resolver<Array<ResolversTypes['ScenarioCondition']>, ParentType, ContextType, RequireFields<ScenarioConditionsArgs, 'directed'>>;
  conditionsAggregate?: Resolver<Maybe<ResolversTypes['ScenarioScenarioConditionConditionsAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioConditionsAggregateArgs, 'directed'>>;
  conditionsConnection?: Resolver<ResolversTypes['ScenarioConditionsConnection'], ParentType, ContextType, RequireFields<ScenarioConditionsConnectionArgs, 'directed'>>;
  group?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hasMultipleBasePrices?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isGrouped?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProRating?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isRelevantForArt71?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  operator?: Resolver<ResolversTypes['ConditionLogicalOperator'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioAction'] = ResolversParentTypes['ScenarioAction']> = {
  actionLogicalOperator?: Resolver<Maybe<ResolversTypes['ActionLogicalOperator']>, ParentType, ContextType>;
  actionSet?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  actionType?: Resolver<ResolversTypes['ActionType'], ParentType, ContextType>;
  adHocPriceTypes?: Resolver<Maybe<Array<ResolversTypes['PriceType']>>, ParentType, ContextType>;
  brands?: Resolver<Array<ResolversTypes['Brand']>, ParentType, ContextType, RequireFields<ScenarioActionBrandsArgs, 'directed'>>;
  brandsAggregate?: Resolver<Maybe<ResolversTypes['ScenarioActionBrandBrandsAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioActionBrandsAggregateArgs, 'directed'>>;
  brandsConnection?: Resolver<ResolversTypes['ScenarioActionBrandsConnection'], ParentType, ContextType, RequireFields<ScenarioActionBrandsConnectionArgs, 'directed'>>;
  combinedItemBrands?: Resolver<Array<ResolversTypes['Brand']>, ParentType, ContextType, RequireFields<ScenarioActionCombinedItemBrandsArgs, 'directed'>>;
  combinedItemBrandsAggregate?: Resolver<Maybe<ResolversTypes['ScenarioActionBrandCombinedItemBrandsAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioActionCombinedItemBrandsAggregateArgs, 'directed'>>;
  combinedItemBrandsConnection?: Resolver<ResolversTypes['ScenarioActionCombinedItemBrandsConnection'], ParentType, ContextType, RequireFields<ScenarioActionCombinedItemBrandsConnectionArgs, 'directed'>>;
  combinedItemGenericNames?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  combinedItemGenerics?: Resolver<Array<ResolversTypes['Generic']>, ParentType, ContextType, RequireFields<ScenarioActionCombinedItemGenericsArgs, 'directed'>>;
  combinedItemGenericsAggregate?: Resolver<Maybe<ResolversTypes['ScenarioActionGenericCombinedItemGenericsAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioActionCombinedItemGenericsAggregateArgs, 'directed'>>;
  combinedItemGenericsConnection?: Resolver<ResolversTypes['ScenarioActionCombinedItemGenericsConnection'], ParentType, ContextType, RequireFields<ScenarioActionCombinedItemGenericsConnectionArgs, 'directed'>>;
  combinedItemTimeframeEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  combinedItemTimeframeRangeType?: Resolver<Maybe<ResolversTypes['TimeframeRangeType']>, ParentType, ContextType>;
  combinedItemTimeframeStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  combinedItemTreatments?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<ScenarioActionCombinedItemTreatmentsArgs, 'directed'>>;
  combinedItemTreatmentsAggregate?: Resolver<Maybe<ResolversTypes['ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioActionCombinedItemTreatmentsAggregateArgs, 'directed'>>;
  combinedItemTreatmentsConnection?: Resolver<ResolversTypes['ScenarioActionCombinedItemTreatmentsConnection'], ParentType, ContextType, RequireFields<ScenarioActionCombinedItemTreatmentsConnectionArgs, 'directed'>>;
  cycle?: Resolver<Maybe<ResolversTypes['CycleConfiguration']>, ParentType, ContextType, RequireFields<ScenarioActionCycleArgs, 'directed'>>;
  cycleAggregate?: Resolver<Maybe<ResolversTypes['ScenarioActionCycleConfigurationCycleAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioActionCycleAggregateArgs, 'directed'>>;
  cycleConnection?: Resolver<ResolversTypes['ScenarioActionCycleConnection'], ParentType, ContextType, RequireFields<ScenarioActionCycleConnectionArgs, 'directed'>>;
  endItemNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  entityPriceType?: Resolver<Maybe<ResolversTypes['EntityPriceType']>, ParentType, ContextType>;
  genericName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generics?: Resolver<Array<ResolversTypes['Generic']>, ParentType, ContextType, RequireFields<ScenarioActionGenericsArgs, 'directed'>>;
  genericsAggregate?: Resolver<Maybe<ResolversTypes['ScenarioActionGenericGenericsAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioActionGenericsAggregateArgs, 'directed'>>;
  genericsConnection?: Resolver<ResolversTypes['ScenarioActionGenericsConnection'], ParentType, ContextType, RequireFields<ScenarioActionGenericsConnectionArgs, 'directed'>>;
  ingredientEndItemNumber?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ingredientRangeType?: Resolver<Maybe<ResolversTypes['ActionItemRangeType']>, ParentType, ContextType>;
  ingredientStartItemNumber?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAdHocDiscount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCombinedScenarioRelevantDrugsActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isNamedTimeRangeUsed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isScenarioRelevantDrugsActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSortedByPackOrder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itemCombinationRelation?: Resolver<Maybe<ResolversTypes['ActionItemCombinationRelation']>, ParentType, ContextType>;
  itemCombinationRule?: Resolver<Maybe<ResolversTypes['ActionItemCombinationRule']>, ParentType, ContextType>;
  itemRangeType?: Resolver<Maybe<ResolversTypes['ActionItemRangeType']>, ParentType, ContextType>;
  itemScope?: Resolver<ResolversTypes['ItemScope'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  packOptionType?: Resolver<Maybe<ResolversTypes['PackOptionType']>, ParentType, ContextType>;
  priceType?: Resolver<Maybe<ResolversTypes['PriceType']>, ParentType, ContextType>;
  recordNature?: Resolver<Maybe<ResolversTypes['RecordNature']>, ParentType, ContextType>;
  rollingRangeType?: Resolver<Maybe<ResolversTypes['RollingRangeType']>, ParentType, ContextType>;
  scenario?: Resolver<ResolversTypes['Scenario'], ParentType, ContextType, RequireFields<ScenarioActionScenarioArgs, 'directed'>>;
  scenarioAggregate?: Resolver<Maybe<ResolversTypes['ScenarioActionScenarioScenarioAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioActionScenarioAggregateArgs, 'directed'>>;
  scenarioConnection?: Resolver<ResolversTypes['ScenarioActionScenarioConnection'], ParentType, ContextType, RequireFields<ScenarioActionScenarioConnectionArgs, 'directed'>>;
  startItemNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startingPoint?: Resolver<Maybe<ResolversTypes['TimeframeStartingPoint']>, ParentType, ContextType>;
  timeframeEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeframeRangeType?: Resolver<Maybe<ResolversTypes['TimeframeRangeType']>, ParentType, ContextType>;
  timeframeRelation?: Resolver<Maybe<ResolversTypes['TimeframeRelation']>, ParentType, ContextType>;
  timeframeStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  treatments?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<ScenarioActionTreatmentsArgs, 'directed'>>;
  treatmentsAggregate?: Resolver<Maybe<ResolversTypes['ScenarioActionTreatmentTreatmentsAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioActionTreatmentsAggregateArgs, 'directed'>>;
  treatmentsConnection?: Resolver<ResolversTypes['ScenarioActionTreatmentsConnection'], ParentType, ContextType, RequireFields<ScenarioActionTreatmentsConnectionArgs, 'directed'>>;
  uoMType?: Resolver<Maybe<ResolversTypes['UoMType']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionBrandBrandsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionBrandBrandsAggregationSelection'] = ResolversParentTypes['ScenarioActionBrandBrandsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['ScenarioActionBrandBrandsEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioActionBrandBrandsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionBrandBrandsEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionBrandBrandsEdgeAggregateSelection'] = ResolversParentTypes['ScenarioActionBrandBrandsEdgeAggregateSelection']> = {
  order?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionBrandBrandsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionBrandBrandsNodeAggregateSelection'] = ResolversParentTypes['ScenarioActionBrandBrandsNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  art71DataLastUpdatedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  art71DataLastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionBrandCombinedItemBrandsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionBrandCombinedItemBrandsAggregationSelection'] = ResolversParentTypes['ScenarioActionBrandCombinedItemBrandsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionBrandCombinedItemBrandsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection'] = ResolversParentTypes['ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  art71DataLastUpdatedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  art71DataLastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionBrandsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionBrandsConnection'] = ResolversParentTypes['ScenarioActionBrandsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioActionBrandsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionBrandsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionBrandsRelationship'] = ResolversParentTypes['ScenarioActionBrandsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Brand'], ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCombinedItemBrandsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionCombinedItemBrandsConnection'] = ResolversParentTypes['ScenarioActionCombinedItemBrandsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioActionCombinedItemBrandsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCombinedItemBrandsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionCombinedItemBrandsRelationship'] = ResolversParentTypes['ScenarioActionCombinedItemBrandsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Brand'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCombinedItemGenericsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionCombinedItemGenericsConnection'] = ResolversParentTypes['ScenarioActionCombinedItemGenericsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioActionCombinedItemGenericsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCombinedItemGenericsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionCombinedItemGenericsRelationship'] = ResolversParentTypes['ScenarioActionCombinedItemGenericsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Generic'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCombinedItemTreatmentsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionCombinedItemTreatmentsConnection'] = ResolversParentTypes['ScenarioActionCombinedItemTreatmentsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioActionCombinedItemTreatmentsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCombinedItemTreatmentsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionCombinedItemTreatmentsRelationship'] = ResolversParentTypes['ScenarioActionCombinedItemTreatmentsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCycleConfigurationCycleAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionCycleConfigurationCycleAggregationSelection'] = ResolversParentTypes['ScenarioActionCycleConfigurationCycleAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioActionCycleConfigurationCycleNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCycleConfigurationCycleNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionCycleConfigurationCycleNodeAggregateSelection'] = ResolversParentTypes['ScenarioActionCycleConfigurationCycleNodeAggregateSelection']> = {
  lengthFrom?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  lengthTo?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCycleConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionCycleConnection'] = ResolversParentTypes['ScenarioActionCycleConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioActionCycleRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionCycleRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionCycleRelationship'] = ResolversParentTypes['ScenarioActionCycleRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CycleConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionEdge'] = ResolversParentTypes['ScenarioActionEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ScenarioAction'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionGenericCombinedItemGenericsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionGenericCombinedItemGenericsAggregationSelection'] = ResolversParentTypes['ScenarioActionGenericCombinedItemGenericsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionGenericCombinedItemGenericsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection'] = ResolversParentTypes['ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionGenericGenericsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionGenericGenericsAggregationSelection'] = ResolversParentTypes['ScenarioActionGenericGenericsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['ScenarioActionGenericGenericsEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioActionGenericGenericsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionGenericGenericsEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionGenericGenericsEdgeAggregateSelection'] = ResolversParentTypes['ScenarioActionGenericGenericsEdgeAggregateSelection']> = {
  order?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionGenericGenericsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionGenericGenericsNodeAggregateSelection'] = ResolversParentTypes['ScenarioActionGenericGenericsNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionGenericsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionGenericsConnection'] = ResolversParentTypes['ScenarioActionGenericsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioActionGenericsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionGenericsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionGenericsRelationship'] = ResolversParentTypes['ScenarioActionGenericsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Generic'], ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionScenarioConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionScenarioConnection'] = ResolversParentTypes['ScenarioActionScenarioConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioActionScenarioRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionScenarioRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionScenarioRelationship'] = ResolversParentTypes['ScenarioActionScenarioRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Scenario'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionScenarioScenarioAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionScenarioScenarioAggregationSelection'] = ResolversParentTypes['ScenarioActionScenarioScenarioAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioActionScenarioScenarioNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionScenarioScenarioNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionScenarioScenarioNodeAggregateSelection'] = ResolversParentTypes['ScenarioActionScenarioScenarioNodeAggregateSelection']> = {
  group?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection'] = ResolversParentTypes['ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection'] = ResolversParentTypes['ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionTreatmentTreatmentsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionTreatmentTreatmentsAggregationSelection'] = ResolversParentTypes['ScenarioActionTreatmentTreatmentsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['ScenarioActionTreatmentTreatmentsEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioActionTreatmentTreatmentsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionTreatmentTreatmentsEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionTreatmentTreatmentsEdgeAggregateSelection'] = ResolversParentTypes['ScenarioActionTreatmentTreatmentsEdgeAggregateSelection']> = {
  order?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionTreatmentTreatmentsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionTreatmentTreatmentsNodeAggregateSelection'] = ResolversParentTypes['ScenarioActionTreatmentTreatmentsNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionTreatmentsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionTreatmentsConnection'] = ResolversParentTypes['ScenarioActionTreatmentsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioActionTreatmentsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionTreatmentsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionTreatmentsRelationship'] = ResolversParentTypes['ScenarioActionTreatmentsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionsConnection'] = ResolversParentTypes['ScenarioActionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioActionsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioActionsRelationship'] = ResolversParentTypes['ScenarioActionsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ScenarioAction'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioCondition'] = ResolversParentTypes['ScenarioCondition']> = {
  adverseEvents?: Resolver<Maybe<Array<ResolversTypes['AdverseEventType']>>, ParentType, ContextType>;
  amountOfThresholdBasis?: Resolver<Maybe<ResolversTypes['AmountOfThresholdBasis']>, ParentType, ContextType>;
  article71Status?: Resolver<Maybe<ResolversTypes['Article71Status']>, ParentType, ContextType>;
  bothOperatorFirst?: Resolver<Maybe<ResolversTypes['ArithmeticalOperator']>, ParentType, ContextType>;
  bothOperatorSecond?: Resolver<Maybe<ResolversTypes['ArithmeticalOperator']>, ParentType, ContextType>;
  brands?: Resolver<Array<ResolversTypes['Brand']>, ParentType, ContextType, RequireFields<ScenarioConditionBrandsArgs, 'directed'>>;
  brandsAggregate?: Resolver<Maybe<ResolversTypes['ScenarioConditionBrandBrandsAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioConditionBrandsAggregateArgs, 'directed'>>;
  brandsConnection?: Resolver<ResolversTypes['ScenarioConditionBrandsConnection'], ParentType, ContextType, RequireFields<ScenarioConditionBrandsConnectionArgs, 'directed'>>;
  comparedCountdownPoint?: Resolver<Maybe<ResolversTypes['CountdownPoint']>, ParentType, ContextType>;
  comparedStartingPoint?: Resolver<Maybe<ResolversTypes['TimeframeStartingPoint']>, ParentType, ContextType>;
  comparedTimeframeEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  comparedTimeframeRangeType?: Resolver<Maybe<ResolversTypes['TimeframeRangeType']>, ParentType, ContextType>;
  comparedTimeframeRelation?: Resolver<Maybe<ResolversTypes['TimeframeRelation']>, ParentType, ContextType>;
  comparedTimeframeStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  conditionStatus?: Resolver<Maybe<Array<ResolversTypes['OutcomeBasedStatus']>>, ParentType, ContextType>;
  conditionType?: Resolver<ResolversTypes['ConditionType'], ParentType, ContextType>;
  consideredRating?: Resolver<Maybe<ResolversTypes['ConditionConsideredRating']>, ParentType, ContextType>;
  consideredSecInterventionRate?: Resolver<Maybe<ResolversTypes['ConditionConsideredSecIntervention']>, ParentType, ContextType>;
  countdownPoint?: Resolver<Maybe<ResolversTypes['CountdownPoint']>, ParentType, ContextType>;
  customCondition?: Resolver<Maybe<ResolversTypes['CustomCondition']>, ParentType, ContextType, RequireFields<ScenarioConditionCustomConditionArgs, 'directed'>>;
  customConditionAggregate?: Resolver<Maybe<ResolversTypes['ScenarioConditionCustomConditionCustomConditionAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioConditionCustomConditionAggregateArgs, 'directed'>>;
  customConditionConnection?: Resolver<ResolversTypes['ScenarioConditionCustomConditionConnection'], ParentType, ContextType, RequireFields<ScenarioConditionCustomConditionConnectionArgs, 'directed'>>;
  deltaType?: Resolver<Maybe<ResolversTypes['DeltaType']>, ParentType, ContextType>;
  discontinuationReason?: Resolver<Maybe<ResolversTypes['TreatmentDiscontinuationReason']>, ParentType, ContextType>;
  endRangeValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  eventCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventFrequency?: Resolver<Maybe<ResolversTypes['CustomConditionEventFrequency']>, ParentType, ContextType>;
  eventResult?: Resolver<Maybe<ResolversTypes['CustomConditionEventResult']>, ParentType, ContextType>;
  eventSubCategories?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  eventType?: Resolver<Maybe<ResolversTypes['CustomConditionEventType']>, ParentType, ContextType>;
  generics?: Resolver<Array<ResolversTypes['Generic']>, ParentType, ContextType, RequireFields<ScenarioConditionGenericsArgs, 'directed'>>;
  genericsAggregate?: Resolver<Maybe<ResolversTypes['ScenarioConditionGenericGenericsAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioConditionGenericsAggregateArgs, 'directed'>>;
  genericsConnection?: Resolver<ResolversTypes['ScenarioConditionGenericsConnection'], ParentType, ContextType, RequireFields<ScenarioConditionGenericsConnectionArgs, 'directed'>>;
  grades?: Resolver<Maybe<Array<ResolversTypes['AdverseEventGrades']>>, ParentType, ContextType>;
  intervention?: Resolver<Maybe<ResolversTypes['InterventionType']>, ParentType, ContextType>;
  interventionOccurrence?: Resolver<Maybe<ResolversTypes['InterventionOccurrence']>, ParentType, ContextType>;
  isNamedTimeRangeUsed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isScenarioRelevantDrugsActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  monitoringType?: Resolver<Maybe<ResolversTypes['MonitoringType']>, ParentType, ContextType>;
  occurence?: Resolver<Maybe<ResolversTypes['Occurrence']>, ParentType, ContextType>;
  operator?: Resolver<Maybe<ResolversTypes['ArithmeticalOperator']>, ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  patentStatus?: Resolver<Maybe<ResolversTypes['PatentStatus']>, ParentType, ContextType>;
  patientScope?: Resolver<Maybe<ResolversTypes['PatientScope']>, ParentType, ContextType>;
  reintervention?: Resolver<Maybe<ResolversTypes['Reintervention']>, ParentType, ContextType>;
  responseInclusionType?: Resolver<Maybe<ResolversTypes['ResponseInclusionType']>, ParentType, ContextType>;
  responseType?: Resolver<Maybe<ResolversTypes['UnitedResponseType']>, ParentType, ContextType>;
  rollingRangeType?: Resolver<Maybe<ResolversTypes['RollingRangeType']>, ParentType, ContextType>;
  scenario?: Resolver<ResolversTypes['Scenario'], ParentType, ContextType, RequireFields<ScenarioConditionScenarioArgs, 'directed'>>;
  scenarioAggregate?: Resolver<Maybe<ResolversTypes['ScenarioConditionScenarioScenarioAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioConditionScenarioAggregateArgs, 'directed'>>;
  scenarioConnection?: Resolver<ResolversTypes['ScenarioConditionScenarioConnection'], ParentType, ContextType, RequireFields<ScenarioConditionScenarioConnectionArgs, 'directed'>>;
  startingPoint?: Resolver<Maybe<ResolversTypes['TimeframeStartingPoint']>, ParentType, ContextType>;
  timeframeEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeframeRangeType?: Resolver<Maybe<ResolversTypes['TimeframeRangeType']>, ParentType, ContextType>;
  timeframeRelation?: Resolver<Maybe<ResolversTypes['TimeframeRelation']>, ParentType, ContextType>;
  timeframeStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  treatmentDurationAspect?: Resolver<Maybe<ResolversTypes['TreatmentDurationConditionAspect']>, ParentType, ContextType>;
  treatments?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<ScenarioConditionTreatmentsArgs, 'directed'>>;
  treatmentsAggregate?: Resolver<Maybe<ResolversTypes['ScenarioConditionTreatmentTreatmentsAggregationSelection']>, ParentType, ContextType, RequireFields<ScenarioConditionTreatmentsAggregateArgs, 'directed'>>;
  treatmentsConnection?: Resolver<ResolversTypes['ScenarioConditionTreatmentsConnection'], ParentType, ContextType, RequireFields<ScenarioConditionTreatmentsConnectionArgs, 'directed'>>;
  uoMType?: Resolver<Maybe<ResolversTypes['UoMType']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionBrandBrandsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionBrandBrandsAggregationSelection'] = ResolversParentTypes['ScenarioConditionBrandBrandsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioConditionBrandBrandsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionBrandBrandsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionBrandBrandsNodeAggregateSelection'] = ResolversParentTypes['ScenarioConditionBrandBrandsNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  art71DataLastUpdatedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  art71DataLastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionBrandsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionBrandsConnection'] = ResolversParentTypes['ScenarioConditionBrandsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioConditionBrandsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionBrandsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionBrandsRelationship'] = ResolversParentTypes['ScenarioConditionBrandsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Brand'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionCustomConditionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionCustomConditionConnection'] = ResolversParentTypes['ScenarioConditionCustomConditionConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioConditionCustomConditionRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionCustomConditionCustomConditionAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionCustomConditionCustomConditionAggregationSelection'] = ResolversParentTypes['ScenarioConditionCustomConditionCustomConditionAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionCustomConditionCustomConditionNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection'] = ResolversParentTypes['ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionCustomConditionRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionCustomConditionRelationship'] = ResolversParentTypes['ScenarioConditionCustomConditionRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CustomCondition'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionEdge'] = ResolversParentTypes['ScenarioConditionEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ScenarioCondition'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionGenericGenericsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionGenericGenericsAggregationSelection'] = ResolversParentTypes['ScenarioConditionGenericGenericsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioConditionGenericGenericsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionGenericGenericsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionGenericGenericsNodeAggregateSelection'] = ResolversParentTypes['ScenarioConditionGenericGenericsNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionGenericsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionGenericsConnection'] = ResolversParentTypes['ScenarioConditionGenericsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioConditionGenericsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionGenericsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionGenericsRelationship'] = ResolversParentTypes['ScenarioConditionGenericsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Generic'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionScenarioConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionScenarioConnection'] = ResolversParentTypes['ScenarioConditionScenarioConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioConditionScenarioRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionScenarioRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionScenarioRelationship'] = ResolversParentTypes['ScenarioConditionScenarioRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Scenario'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionScenarioScenarioAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionScenarioScenarioAggregationSelection'] = ResolversParentTypes['ScenarioConditionScenarioScenarioAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioConditionScenarioScenarioNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionScenarioScenarioNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionScenarioScenarioNodeAggregateSelection'] = ResolversParentTypes['ScenarioConditionScenarioScenarioNodeAggregateSelection']> = {
  group?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionTreatmentTreatmentsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionTreatmentTreatmentsAggregationSelection'] = ResolversParentTypes['ScenarioConditionTreatmentTreatmentsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioConditionTreatmentTreatmentsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionTreatmentTreatmentsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionTreatmentTreatmentsNodeAggregateSelection'] = ResolversParentTypes['ScenarioConditionTreatmentTreatmentsNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionTreatmentsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionTreatmentsConnection'] = ResolversParentTypes['ScenarioConditionTreatmentsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioConditionTreatmentsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionTreatmentsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionTreatmentsRelationship'] = ResolversParentTypes['ScenarioConditionTreatmentsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionsConnection'] = ResolversParentTypes['ScenarioConditionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioConditionsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioConditionsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioConditionsRelationship'] = ResolversParentTypes['ScenarioConditionsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ScenarioCondition'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioEdge'] = ResolversParentTypes['ScenarioEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Scenario'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioInsightsUserContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioInsightsUserContext'] = ResolversParentTypes['ScenarioInsightsUserContext']> = {
  __resolveType: TypeResolveFn<'BaseAgreementUserContextsRelationship', ParentType, ContextType>;
  categoryInput?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  rebateObjective?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeframeLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ScenarioScenarioActionActionsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioScenarioActionActionsAggregationSelection'] = ResolversParentTypes['ScenarioScenarioActionActionsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioScenarioActionActionsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioScenarioActionActionsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioScenarioActionActionsNodeAggregateSelection'] = ResolversParentTypes['ScenarioScenarioActionActionsNodeAggregateSelection']> = {
  actionSet?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  combinedItemTimeframeEnd?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  combinedItemTimeframeStart?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  endItemNumber?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  genericName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  ingredientEndItemNumber?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  ingredientStartItemNumber?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  startItemNumber?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  timeframeEnd?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  timeframeStart?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioScenarioConditionConditionsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioScenarioConditionConditionsAggregationSelection'] = ResolversParentTypes['ScenarioScenarioConditionConditionsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ScenarioScenarioConditionConditionsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioScenarioConditionConditionsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioScenarioConditionConditionsNodeAggregateSelection'] = ResolversParentTypes['ScenarioScenarioConditionConditionsNodeAggregateSelection']> = {
  comparedTimeframeEnd?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  comparedTimeframeStart?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  endRangeValue?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  eventCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  timeframeEnd?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  timeframeStart?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenariosConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenariosConnection'] = ResolversParentTypes['ScenariosConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScenarioEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScopeCheckResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScopeCheckResult'] = ResolversParentTypes['ScopeCheckResult']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isUsed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScopeCheckResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScopeCheckResultEdge'] = ResolversParentTypes['ScopeCheckResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ScopeCheckResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScopeCheckResultsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScopeCheckResultsConnection'] = ResolversParentTypes['ScopeCheckResultsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ScopeCheckResultEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Simulation'] = ResolversParentTypes['Simulation']> = {
  accessibleUsers?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<SimulationAccessibleUsersArgs, 'directed'>>;
  accessibleUsersAggregate?: Resolver<Maybe<ResolversTypes['SimulationUserAccessibleUsersAggregationSelection']>, ParentType, ContextType, RequireFields<SimulationAccessibleUsersAggregateArgs, 'directed'>>;
  accessibleUsersConnection?: Resolver<ResolversTypes['SimulationAccessibleUsersConnection'], ParentType, ContextType, RequireFields<SimulationAccessibleUsersConnectionArgs, 'directed'>>;
  addedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<SimulationAddedByArgs, 'directed'>>;
  addedByAggregate?: Resolver<Maybe<ResolversTypes['SimulationUserAddedByAggregationSelection']>, ParentType, ContextType, RequireFields<SimulationAddedByAggregateArgs, 'directed'>>;
  addedByConnection?: Resolver<ResolversTypes['SimulationAddedByConnection'], ParentType, ContextType, RequireFields<SimulationAddedByConnectionArgs, 'directed'>>;
  blueprint?: Resolver<Maybe<ResolversTypes['ProductBlueprint']>, ParentType, ContextType, RequireFields<SimulationBlueprintArgs, 'directed'>>;
  blueprintAggregate?: Resolver<Maybe<ResolversTypes['SimulationProductBlueprintBlueprintAggregationSelection']>, ParentType, ContextType, RequireFields<SimulationBlueprintAggregateArgs, 'directed'>>;
  blueprintConnection?: Resolver<ResolversTypes['SimulationBlueprintConnection'], ParentType, ContextType, RequireFields<SimulationBlueprintConnectionArgs, 'directed'>>;
  businessCase?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  counterparty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdByEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdByName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedByEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['Domain'], ParentType, ContextType, RequireFields<SimulationDomainArgs, 'directed'>>;
  domainAggregate?: Resolver<Maybe<ResolversTypes['SimulationDomainDomainAggregationSelection']>, ParentType, ContextType, RequireFields<SimulationDomainAggregateArgs, 'directed'>>;
  domainConnection?: Resolver<ResolversTypes['SimulationDomainConnection'], ParentType, ContextType, RequireFields<SimulationDomainConnectionArgs, 'directed'>>;
  domainName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedContent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasUnassignedBlueprint?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  indications?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSimulationComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastUpdatedByEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lockedSections?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  simulationUserRole?: Resolver<ResolversTypes['SimulatorUserRole'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SimulationSavedStatus'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationAccessibleUsersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationAccessibleUsersConnection'] = ResolversParentTypes['SimulationAccessibleUsersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SimulationAccessibleUsersRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationAccessibleUsersRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationAccessibleUsersRelationship'] = ResolversParentTypes['SimulationAccessibleUsersRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  grantedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['SimulatorUserRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationAddedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationAddedByConnection'] = ResolversParentTypes['SimulationAddedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SimulationAddedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationAddedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationAddedByRelationship'] = ResolversParentTypes['SimulationAddedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationBlueprintConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationBlueprintConnection'] = ResolversParentTypes['SimulationBlueprintConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SimulationBlueprintRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationBlueprintRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationBlueprintRelationship'] = ResolversParentTypes['SimulationBlueprintRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProductBlueprint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationCount'] = ResolversParentTypes['SimulationCount']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationCountEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationCountEdge'] = ResolversParentTypes['SimulationCountEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SimulationCount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationCountsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationCountsConnection'] = ResolversParentTypes['SimulationCountsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SimulationCountEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationDomainConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationDomainConnection'] = ResolversParentTypes['SimulationDomainConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SimulationDomainRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationDomainDomainAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationDomainDomainAggregationSelection'] = ResolversParentTypes['SimulationDomainDomainAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['SimulationDomainDomainNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationDomainDomainNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationDomainDomainNodeAggregateSelection'] = ResolversParentTypes['SimulationDomainDomainNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  deletedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  deletedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationDomainRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationDomainRelationship'] = ResolversParentTypes['SimulationDomainRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Domain'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationEdge'] = ResolversParentTypes['SimulationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Simulation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationProductBlueprintBlueprintAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationProductBlueprintBlueprintAggregationSelection'] = ResolversParentTypes['SimulationProductBlueprintBlueprintAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['SimulationProductBlueprintBlueprintNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationProductBlueprintBlueprintNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationProductBlueprintBlueprintNodeAggregateSelection'] = ResolversParentTypes['SimulationProductBlueprintBlueprintNodeAggregateSelection']> = {
  addedByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  addedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  formValues?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  indication?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  indications?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  productName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  publishedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  updatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationUserAccessibleUsersAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationUserAccessibleUsersAggregationSelection'] = ResolversParentTypes['SimulationUserAccessibleUsersAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['SimulationUserAccessibleUsersEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['SimulationUserAccessibleUsersNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationUserAccessibleUsersEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationUserAccessibleUsersEdgeAggregateSelection'] = ResolversParentTypes['SimulationUserAccessibleUsersEdgeAggregateSelection']> = {
  grantedByUserId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationUserAccessibleUsersNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationUserAccessibleUsersNodeAggregateSelection'] = ResolversParentTypes['SimulationUserAccessibleUsersNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationUserAddedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationUserAddedByAggregationSelection'] = ResolversParentTypes['SimulationUserAddedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['SimulationUserAddedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationUserAddedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationUserAddedByNodeAggregateSelection'] = ResolversParentTypes['SimulationUserAddedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationUserWithRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationUserWithRole'] = ResolversParentTypes['SimulationUserWithRole']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  grantedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['SimulatorUserRole'], ParentType, ContextType>;
  userDomainId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userDomainName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationUserWithRoleEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationUserWithRoleEdge'] = ResolversParentTypes['SimulationUserWithRoleEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SimulationUserWithRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationUserWithRolesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationUserWithRolesConnection'] = ResolversParentTypes['SimulationUserWithRolesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SimulationUserWithRoleEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulationsConnection'] = ResolversParentTypes['SimulationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SimulationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimulatorUserRoleRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimulatorUserRoleRelationship'] = ResolversParentTypes['SimulatorUserRoleRelationship']> = {
  __resolveType: TypeResolveFn<'SimulationAccessibleUsersRelationship', ParentType, ContextType>;
  grantedByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['SimulatorUserRole'], ParentType, ContextType>;
};

export type SlowGraphqlOperationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SlowGraphqlOperation'] = ResolversParentTypes['SlowGraphqlOperation']> = {
  avgDurationMs?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  errorCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  maxDurationMs?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  operationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SlowGraphqlOperationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SlowGraphqlOperationEdge'] = ResolversParentTypes['SlowGraphqlOperationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SlowGraphqlOperation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SlowGraphqlOperationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SlowGraphqlOperationsConnection'] = ResolversParentTypes['SlowGraphqlOperationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SlowGraphqlOperationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SlowGraphqlRequestsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SlowGraphqlRequestsResult'] = ResolversParentTypes['SlowGraphqlRequestsResult']> = {
  generatedAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  operations?: Resolver<Array<ResolversTypes['SlowGraphqlOperation']>, ParentType, ContextType>;
  rangeDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SlowGraphqlRequestsResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SlowGraphqlRequestsResultEdge'] = ResolversParentTypes['SlowGraphqlRequestsResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SlowGraphqlRequestsResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SlowGraphqlRequestsResultsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SlowGraphqlRequestsResultsConnection'] = ResolversParentTypes['SlowGraphqlRequestsResultsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SlowGraphqlRequestsResultEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreUser'] = ResolversParentTypes['StoreUser']> = {
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domains?: Resolver<Maybe<Array<Maybe<ResolversTypes['Domain']>>>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailConfirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isLastOwnerAgreementIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  modules?: Resolver<Array<Maybe<ResolversTypes['UserAvailableEntryModule']>>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['AuthOrganization']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreUserEdge'] = ResolversParentTypes['StoreUserEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['StoreUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoreUsersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StoreUsersConnection'] = ResolversParentTypes['StoreUsersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['StoreUserEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StringAggregateSelectionNonNullableResolvers<ContextType = any, ParentType extends ResolversParentTypes['StringAggregateSelectionNonNullable'] = ResolversParentTypes['StringAggregateSelectionNonNullable']> = {
  longest?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortest?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StringAggregateSelectionNullableResolvers<ContextType = any, ParentType extends ResolversParentTypes['StringAggregateSelectionNullable'] = ResolversParentTypes['StringAggregateSelectionNullable']> = {
  longest?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortest?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  integrityCheckComplete?: SubscriptionResolver<Array<ResolversTypes['CheckedType']>, "integrityCheckComplete", ParentType, ContextType>;
  masterDataUpdateImpacts?: SubscriptionResolver<Array<ResolversTypes['Art71MasterDataImpacts']>, "masterDataUpdateImpacts", ParentType, ContextType>;
  uploadStateUpdated?: SubscriptionResolver<ResolversTypes['UploadState'], "uploadStateUpdated", ParentType, ContextType>;
};

export type SyncRefundImpactResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyncRefundImpact'] = ResolversParentTypes['SyncRefundImpact']> = {
  agreementVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  documentCreator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentReviewer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refundId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SyncRefundImpactEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyncRefundImpactEdge'] = ResolversParentTypes['SyncRefundImpactEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SyncRefundImpact'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SyncRefundImpactsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyncRefundImpactsConnection'] = ResolversParentTypes['SyncRefundImpactsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SyncRefundImpactEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SyncResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyncResponse'] = ResolversParentTypes['SyncResponse']> = {
  agreementId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  agreementName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dependentArt71AgreementsStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excludedScopes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newScopes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refundImpacts?: Resolver<Array<ResolversTypes['SyncRefundImpact']>, ParentType, ContextType>;
  scenariosStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scopesStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ResponseBaseStatus']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SyncType'], ParentType, ContextType>;
  validityStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  versionNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SyncResponseEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyncResponseEdge'] = ResolversParentTypes['SyncResponseEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SyncResponse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SyncResponsesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyncResponsesConnection'] = ResolversParentTypes['SyncResponsesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SyncResponseEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SystemTaskResolvers<ContextType = any, ParentType extends ResolversParentTypes['SystemTask'] = ResolversParentTypes['SystemTask']> = {
  completedOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SystemTaskEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SystemTaskEdge'] = ResolversParentTypes['SystemTaskEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SystemTask'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SystemTasksConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SystemTasksConnection'] = ResolversParentTypes['SystemTasksConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SystemTaskEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ThresholdConfigurationRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ThresholdConfigurationRelationship'] = ResolversParentTypes['ThresholdConfigurationRelationship']> = {
  __resolveType: TypeResolveFn<'AgreementDotThresholdsRelationship' | 'AgreementTemplateDotThresholdsRelationship' | 'BaseAgreementDotThresholdsRelationship', ParentType, ContextType>;
  threshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TranslationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Translation'] = ResolversParentTypes['Translation']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  languageCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranslationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TranslationEdge'] = ResolversParentTypes['TranslationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Translation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranslationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TranslationsConnection'] = ResolversParentTypes['TranslationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TranslationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranslationsWithChangedKeysResolvers<ContextType = any, ParentType extends ResolversParentTypes['TranslationsWithChangedKeys'] = ResolversParentTypes['TranslationsWithChangedKeys']> = {
  changedKeys?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  masterFile?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  translationsFile?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranslationsWithChangedKeysConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TranslationsWithChangedKeysConnection'] = ResolversParentTypes['TranslationsWithChangedKeysConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TranslationsWithChangedKeysEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranslationsWithChangedKeysEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TranslationsWithChangedKeysEdge'] = ResolversParentTypes['TranslationsWithChangedKeysEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TranslationsWithChangedKeys'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Treatment'] = ResolversParentTypes['Treatment']> = {
  BagDossierNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  DIN?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FlagModal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FlagNarcosis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GTIN?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LOT?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NDC?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Partners?: Resolver<Array<ResolversTypes['Partner']>, ParentType, ContextType, RequireFields<TreatmentPartnersArgs, 'directed'>>;
  PartnersAggregate?: Resolver<Maybe<ResolversTypes['TreatmentPartnerPartnersAggregationSelection']>, ParentType, ContextType, RequireFields<TreatmentPartnersAggregateArgs, 'directed'>>;
  PartnersConnection?: Resolver<ResolversTypes['TreatmentPartnersConnection'], ParentType, ContextType, RequireFields<TreatmentPartnersConnectionArgs, 'directed'>>;
  PharmaCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PrevPharmacode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  REF?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Status?: Resolver<Maybe<ResolversTypes['PreparationStatus']>, ParentType, ContextType, RequireFields<TreatmentStatusArgs, 'directed'>>;
  StatusAggregate?: Resolver<Maybe<ResolversTypes['TreatmentPreparationStatusStatusAggregationSelection']>, ParentType, ContextType, RequireFields<TreatmentStatusAggregateArgs, 'directed'>>;
  StatusConnection?: Resolver<ResolversTypes['TreatmentStatusConnection'], ParentType, ContextType, RequireFields<TreatmentStatusConnectionArgs, 'directed'>>;
  SwissmedicCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SwissmedicNo8?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UDI?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  canBeMain?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  classificationSystem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  codeCategories?: Resolver<Array<ResolversTypes['CodeCategory']>, ParentType, ContextType>;
  concentration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType, RequireFields<TreatmentCountryArgs, 'directed'>>;
  countryAggregate?: Resolver<Maybe<ResolversTypes['TreatmentCountryCountryAggregationSelection']>, ParentType, ContextType, RequireFields<TreatmentCountryAggregateArgs, 'directed'>>;
  countryConnection?: Resolver<ResolversTypes['TreatmentCountryConnection'], ParentType, ContextType, RequireFields<TreatmentCountryConnectionArgs, 'directed'>>;
  hasLimitations?: Resolver<Array<ResolversTypes['Limitation']>, ParentType, ContextType, RequireFields<TreatmentHasLimitationsArgs, 'directed'>>;
  hasLimitationsAggregate?: Resolver<Maybe<ResolversTypes['TreatmentLimitationHasLimitationsAggregationSelection']>, ParentType, ContextType, RequireFields<TreatmentHasLimitationsAggregateArgs, 'directed'>>;
  hasLimitationsConnection?: Resolver<ResolversTypes['TreatmentHasLimitationsConnection'], ParentType, ContextType, RequireFields<TreatmentHasLimitationsConnectionArgs, 'directed'>>;
  newCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packVolume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packVolumeUoMType?: Resolver<Maybe<ResolversTypes['PackVolumeUoMType']>, ParentType, ContextType>;
  prices?: Resolver<Array<ResolversTypes['Price']>, ParentType, ContextType, RequireFields<TreatmentPricesArgs, 'directed'>>;
  pricesAggregate?: Resolver<Maybe<ResolversTypes['TreatmentPricePricesAggregationSelection']>, ParentType, ContextType, RequireFields<TreatmentPricesAggregateArgs, 'directed'>>;
  pricesConnection?: Resolver<ResolversTypes['TreatmentPricesConnection'], ParentType, ContextType, RequireFields<TreatmentPricesConnectionArgs, 'directed'>>;
  regulatedBy?: Resolver<ResolversTypes['Preparation'], ParentType, ContextType, RequireFields<TreatmentRegulatedByArgs, 'directed'>>;
  regulatedByAggregate?: Resolver<Maybe<ResolversTypes['TreatmentPreparationRegulatedByAggregationSelection']>, ParentType, ContextType, RequireFields<TreatmentRegulatedByAggregateArgs, 'directed'>>;
  regulatedByConnection?: Resolver<ResolversTypes['TreatmentRegulatedByConnection'], ParentType, ContextType, RequireFields<TreatmentRegulatedByConnectionArgs, 'directed'>>;
  uoMType?: Resolver<Maybe<ResolversTypes['UoMType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentCountryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentCountryConnection'] = ResolversParentTypes['TreatmentCountryConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TreatmentCountryRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentCountryCountryAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentCountryCountryAggregationSelection'] = ResolversParentTypes['TreatmentCountryCountryAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TreatmentCountryCountryNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentCountryCountryNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentCountryCountryNodeAggregateSelection'] = ResolversParentTypes['TreatmentCountryCountryNodeAggregateSelection']> = {
  alpha2Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  alpha3Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  numericCode?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentCountryRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentCountryRelationship'] = ResolversParentTypes['TreatmentCountryRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentEdge'] = ResolversParentTypes['TreatmentEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentHasLimitationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentHasLimitationsConnection'] = ResolversParentTypes['TreatmentHasLimitationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TreatmentHasLimitationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentHasLimitationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentHasLimitationsRelationship'] = ResolversParentTypes['TreatmentHasLimitationsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Limitation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentLimitationHasLimitationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentLimitationHasLimitationsAggregationSelection'] = ResolversParentTypes['TreatmentLimitationHasLimitationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TreatmentLimitationHasLimitationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentLimitationHasLimitationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentLimitationHasLimitationsNodeAggregateSelection'] = ResolversParentTypes['TreatmentLimitationHasLimitationsNodeAggregateSelection']> = {
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DescriptionEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Niveau?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Type?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPartnerPartnersAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentPartnerPartnersAggregationSelection'] = ResolversParentTypes['TreatmentPartnerPartnersAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TreatmentPartnerPartnersNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPartnerPartnersNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentPartnerPartnersNodeAggregateSelection'] = ResolversParentTypes['TreatmentPartnerPartnersNodeAggregateSelection']> = {
  Description?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PartnerType?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Phone?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Place?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Street?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  ZipCode?: Resolver<ResolversTypes['IntAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPartnersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentPartnersConnection'] = ResolversParentTypes['TreatmentPartnersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TreatmentPartnersRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPartnersRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentPartnersRelationship'] = ResolversParentTypes['TreatmentPartnersRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Partner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPreparationRegulatedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentPreparationRegulatedByAggregationSelection'] = ResolversParentTypes['TreatmentPreparationRegulatedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TreatmentPreparationRegulatedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPreparationRegulatedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentPreparationRegulatedByNodeAggregateSelection'] = ResolversParentTypes['TreatmentPreparationRegulatedByNodeAggregateSelection']> = {
  AtcCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  BrandName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GenericName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo5?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPreparationStatusStatusAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentPreparationStatusStatusAggregationSelection'] = ResolversParentTypes['TreatmentPreparationStatusStatusAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TreatmentPreparationStatusStatusNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPreparationStatusStatusNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentPreparationStatusStatusNodeAggregateSelection'] = ResolversParentTypes['TreatmentPreparationStatusStatusNodeAggregateSelection']> = {
  FlagApd?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  StatusTypeCodeSl?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  StatusTypeDescriptionSl?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPricePricesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentPricePricesAggregationSelection'] = ResolversParentTypes['TreatmentPricePricesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TreatmentPricePricesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPricePricesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentPricePricesNodeAggregateSelection'] = ResolversParentTypes['TreatmentPricePricesNodeAggregateSelection']> = {
  Price?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PriceChangeTypeDescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PriceChangeTypeDescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PriceChangeTypeDescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PriceTypeDescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PriceTypeDescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PriceTypeDescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  countriesConsidered?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  uniqueCode?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPricesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentPricesConnection'] = ResolversParentTypes['TreatmentPricesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TreatmentPricesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentPricesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentPricesRelationship'] = ResolversParentTypes['TreatmentPricesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Price'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentRegulatedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentRegulatedByConnection'] = ResolversParentTypes['TreatmentRegulatedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TreatmentRegulatedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentRegulatedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentRegulatedByRelationship'] = ResolversParentTypes['TreatmentRegulatedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Preparation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSet'] = ResolversParentTypes['TreatmentSet']> = {
  generic?: Resolver<ResolversTypes['Generic'], ParentType, ContextType, RequireFields<TreatmentSetGenericArgs, 'directed'>>;
  genericAggregate?: Resolver<Maybe<ResolversTypes['TreatmentSetGenericGenericAggregationSelection']>, ParentType, ContextType, RequireFields<TreatmentSetGenericAggregateArgs, 'directed'>>;
  genericConnection?: Resolver<ResolversTypes['TreatmentSetGenericConnection'], ParentType, ContextType, RequireFields<TreatmentSetGenericConnectionArgs, 'directed'>>;
  isFixedPriceTarget?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  preparations?: Resolver<Array<ResolversTypes['Preparation']>, ParentType, ContextType, RequireFields<TreatmentSetPreparationsArgs, 'directed'>>;
  preparationsAggregate?: Resolver<Maybe<ResolversTypes['TreatmentSetPreparationPreparationsAggregationSelection']>, ParentType, ContextType, RequireFields<TreatmentSetPreparationsAggregateArgs, 'directed'>>;
  preparationsConnection?: Resolver<ResolversTypes['TreatmentSetPreparationsConnection'], ParentType, ContextType, RequireFields<TreatmentSetPreparationsConnectionArgs, 'directed'>>;
  scope?: Resolver<ResolversTypes['AgreementScope'], ParentType, ContextType, RequireFields<TreatmentSetScopeArgs, 'directed'>>;
  scopeAggregate?: Resolver<Maybe<ResolversTypes['TreatmentSetAgreementScopeScopeAggregationSelection']>, ParentType, ContextType, RequireFields<TreatmentSetScopeAggregateArgs, 'directed'>>;
  scopeConnection?: Resolver<ResolversTypes['TreatmentSetScopeConnection'], ParentType, ContextType, RequireFields<TreatmentSetScopeConnectionArgs, 'directed'>>;
  treatments?: Resolver<Array<ResolversTypes['Treatment']>, ParentType, ContextType, RequireFields<TreatmentSetTreatmentsArgs, 'directed'>>;
  treatmentsAggregate?: Resolver<Maybe<ResolversTypes['TreatmentSetTreatmentTreatmentsAggregationSelection']>, ParentType, ContextType, RequireFields<TreatmentSetTreatmentsAggregateArgs, 'directed'>>;
  treatmentsConnection?: Resolver<ResolversTypes['TreatmentSetTreatmentsConnection'], ParentType, ContextType, RequireFields<TreatmentSetTreatmentsConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetAgreementScopeScopeAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetAgreementScopeScopeAggregationSelection'] = ResolversParentTypes['TreatmentSetAgreementScopeScopeAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TreatmentSetAgreementScopeScopeNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetAgreementScopeScopeNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetAgreementScopeScopeNodeAggregateSelection'] = ResolversParentTypes['TreatmentSetAgreementScopeScopeNodeAggregateSelection']> = {
  code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  scopeId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetEdge'] = ResolversParentTypes['TreatmentSetEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TreatmentSet'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetGenericConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetGenericConnection'] = ResolversParentTypes['TreatmentSetGenericConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TreatmentSetGenericRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetGenericGenericAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetGenericGenericAggregationSelection'] = ResolversParentTypes['TreatmentSetGenericGenericAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TreatmentSetGenericGenericNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetGenericGenericNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetGenericGenericNodeAggregateSelection'] = ResolversParentTypes['TreatmentSetGenericGenericNodeAggregateSelection']> = {
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetGenericRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetGenericRelationship'] = ResolversParentTypes['TreatmentSetGenericRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Generic'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetPreparationPreparationsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetPreparationPreparationsAggregationSelection'] = ResolversParentTypes['TreatmentSetPreparationPreparationsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TreatmentSetPreparationPreparationsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetPreparationPreparationsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetPreparationPreparationsNodeAggregateSelection'] = ResolversParentTypes['TreatmentSetPreparationPreparationsNodeAggregateSelection']> = {
  AtcCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  BrandName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DescriptionDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionFr?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  DescriptionIt?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GenericName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo5?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetPreparationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetPreparationsConnection'] = ResolversParentTypes['TreatmentSetPreparationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TreatmentSetPreparationsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetPreparationsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetPreparationsRelationship'] = ResolversParentTypes['TreatmentSetPreparationsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Preparation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetScopeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetScopeConnection'] = ResolversParentTypes['TreatmentSetScopeConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TreatmentSetScopeRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetScopeRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetScopeRelationship'] = ResolversParentTypes['TreatmentSetScopeRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AgreementScope'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetTreatmentTreatmentsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetTreatmentTreatmentsAggregationSelection'] = ResolversParentTypes['TreatmentSetTreatmentTreatmentsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['TreatmentSetTreatmentTreatmentsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetTreatmentTreatmentsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetTreatmentTreatmentsNodeAggregateSelection'] = ResolversParentTypes['TreatmentSetTreatmentTreatmentsNodeAggregateSelection']> = {
  BagDossierNo?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Code?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  DIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagModal?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  FlagNarcosis?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  GTIN?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  LOT?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  NDC?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  PharmaCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  PrevPharmacode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  REF?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicCategory?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  SwissmedicNo8?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  UDI?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  activeIngredientQuantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  classificationSystem?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  concentration?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  newCode?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  packVolume?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetTreatmentsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetTreatmentsConnection'] = ResolversParentTypes['TreatmentSetTreatmentsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TreatmentSetTreatmentsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetTreatmentsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetTreatmentsRelationship'] = ResolversParentTypes['TreatmentSetTreatmentsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Treatment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentSetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentSetsConnection'] = ResolversParentTypes['TreatmentSetsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TreatmentSetEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentStatusConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentStatusConnection'] = ResolversParentTypes['TreatmentStatusConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TreatmentStatusRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentStatusRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentStatusRelationship'] = ResolversParentTypes['TreatmentStatusRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PreparationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentsConnection'] = ResolversParentTypes['TreatmentsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TreatmentEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadResolvers<ContextType = any, ParentType extends ResolversParentTypes['Upload'] = ResolversParentTypes['Upload']> = {
  flexEntities?: Resolver<Array<ResolversTypes['FlexEntity']>, ParentType, ContextType, RequireFields<UploadFlexEntitiesArgs, 'directed'>>;
  flexEntitiesAggregate?: Resolver<Maybe<ResolversTypes['UploadFlexEntityFlexEntitiesAggregationSelection']>, ParentType, ContextType, RequireFields<UploadFlexEntitiesAggregateArgs, 'directed'>>;
  flexEntitiesConnection?: Resolver<ResolversTypes['UploadFlexEntitiesConnection'], ParentType, ContextType, RequireFields<UploadFlexEntitiesConnectionArgs, 'directed'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadEdge'] = ResolversParentTypes['UploadEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Upload'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFlexEntitiesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFlexEntitiesConnection'] = ResolversParentTypes['UploadFlexEntitiesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UploadFlexEntitiesRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFlexEntitiesRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFlexEntitiesRelationship'] = ResolversParentTypes['UploadFlexEntitiesRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FlexEntity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFlexEntityFlexEntitiesAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFlexEntityFlexEntitiesAggregationSelection'] = ResolversParentTypes['UploadFlexEntityFlexEntitiesAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UploadFlexEntityFlexEntitiesNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFlexEntityFlexEntitiesNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadFlexEntityFlexEntitiesNodeAggregateSelection'] = ResolversParentTypes['UploadFlexEntityFlexEntitiesNodeAggregateSelection']> = {
  createdByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdByName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  dataKeys?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  externalFormId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  flexEntityName?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  insuranceClaimId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  lastUpdatedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNullable'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationBrandNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preparationGenericNames?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  purchaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['FloatAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  viewCaseId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCases?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewCreatedByName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentDe?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewFormattedContentEn?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  viewSuccessorId?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadLimitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadLimitation'] = ResolversParentTypes['UploadLimitation']> = {
  entityType?: Resolver<ResolversTypes['FlexContainerType'], ParentType, ContextType>;
  maxItems?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<UploadLimitationUpdatedByArgs, 'directed'>>;
  updatedByAggregate?: Resolver<Maybe<ResolversTypes['UploadLimitationUserUpdatedByAggregationSelection']>, ParentType, ContextType, RequireFields<UploadLimitationUpdatedByAggregateArgs, 'directed'>>;
  updatedByConnection?: Resolver<ResolversTypes['UploadLimitationUpdatedByConnection'], ParentType, ContextType, RequireFields<UploadLimitationUpdatedByConnectionArgs, 'directed'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadLimitationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadLimitationEdge'] = ResolversParentTypes['UploadLimitationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['UploadLimitation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadLimitationUpdatedByConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadLimitationUpdatedByConnection'] = ResolversParentTypes['UploadLimitationUpdatedByConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UploadLimitationUpdatedByRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadLimitationUpdatedByRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadLimitationUpdatedByRelationship'] = ResolversParentTypes['UploadLimitationUpdatedByRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  setOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadLimitationUpdaterRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadLimitationUpdaterRelationship'] = ResolversParentTypes['UploadLimitationUpdaterRelationship']> = {
  __resolveType: TypeResolveFn<'UploadLimitationUpdatedByRelationship', ParentType, ContextType>;
  setOn?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
};

export type UploadLimitationUserUpdatedByAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadLimitationUserUpdatedByAggregationSelection'] = ResolversParentTypes['UploadLimitationUserUpdatedByAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edge?: Resolver<Maybe<ResolversTypes['UploadLimitationUserUpdatedByEdgeAggregateSelection']>, ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UploadLimitationUserUpdatedByNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadLimitationUserUpdatedByEdgeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadLimitationUserUpdatedByEdgeAggregateSelection'] = ResolversParentTypes['UploadLimitationUserUpdatedByEdgeAggregateSelection']> = {
  setOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadLimitationUserUpdatedByNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadLimitationUserUpdatedByNodeAggregateSelection'] = ResolversParentTypes['UploadLimitationUserUpdatedByNodeAggregateSelection']> = {
  email?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  preferredLanguage?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadLimitationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadLimitationsConnection'] = ResolversParentTypes['UploadLimitationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UploadLimitationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadState'] = ResolversParentTypes['UploadState']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  impact?: Resolver<Maybe<Array<ResolversTypes['ImpactItem']>>, ParentType, ContextType>;
  impactedAgreementIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  isFinalizing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFinished?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRewrite?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTranslate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  progress?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stateDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadStateEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadStateEdge'] = ResolversParentTypes['UploadStateEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['UploadState'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadStatesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadStatesConnection'] = ResolversParentTypes['UploadStatesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UploadStateEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadsConnection'] = ResolversParentTypes['UploadsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UploadEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  domains?: Resolver<Array<ResolversTypes['Domain']>, ParentType, ContextType, RequireFields<UserDomainsArgs, 'directed'>>;
  domainsAggregate?: Resolver<Maybe<ResolversTypes['UserDomainDomainsAggregationSelection']>, ParentType, ContextType, RequireFields<UserDomainsAggregateArgs, 'directed'>>;
  domainsConnection?: Resolver<ResolversTypes['UserDomainsConnection'], ParentType, ContextType, RequireFields<UserDomainsConnectionArgs, 'directed'>>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailConfirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isGuest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscribedToNotifications?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAvailableEntryModuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAvailableEntryModule'] = ResolversParentTypes['UserAvailableEntryModule']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAvailableEntryModuleEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAvailableEntryModuleEdge'] = ResolversParentTypes['UserAvailableEntryModuleEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['UserAvailableEntryModule'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAvailableEntryModulesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAvailableEntryModulesConnection'] = ResolversParentTypes['UserAvailableEntryModulesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UserAvailableEntryModuleEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContext'] = ResolversParentTypes['UserContext']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filtersAgreements?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filtersCustomConditions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filtersModels?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContextEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContextEdge'] = ResolversParentTypes['UserContextEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['UserContext'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContextsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContextsConnection'] = ResolversParentTypes['UserContextsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UserContextEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserDomainDomainsAggregationSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserDomainDomainsAggregationSelection'] = ResolversParentTypes['UserDomainDomainsAggregationSelection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserDomainDomainsNodeAggregateSelection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserDomainDomainsNodeAggregateSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserDomainDomainsNodeAggregateSelection'] = ResolversParentTypes['UserDomainDomainsNodeAggregateSelection']> = {
  createdOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  deletedByEmail?: Resolver<ResolversTypes['StringAggregateSelectionNullable'], ParentType, ContextType>;
  deletedOn?: Resolver<ResolversTypes['DateTimeAggregateSelectionNonNullable'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['IDAggregateSelectionNonNullable'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['IntAggregateSelectionNonNullable'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['StringAggregateSelectionNonNullable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserDomainsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserDomainsConnection'] = ResolversParentTypes['UserDomainsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UserDomainsRelationship']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserDomainsRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserDomainsRelationship'] = ResolversParentTypes['UserDomainsRelationship']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Domain'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserEdge'] = ResolversParentTypes['UserEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOrgSettingsDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserOrgSettingsData'] = ResolversParentTypes['UserOrgSettingsData']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasOperativeDataAccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOrgSettingsDataConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserOrgSettingsDataConnection'] = ResolversParentTypes['UserOrgSettingsDataConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UserOrgSettingsDataEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOrgSettingsDataEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserOrgSettingsDataEdge'] = ResolversParentTypes['UserOrgSettingsDataEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['UserOrgSettingsData'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOrganizationInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserOrganizationInfo'] = ResolversParentTypes['UserOrganizationInfo']> = {
  defaultAgreementUserRoles?: Resolver<Array<ResolversTypes['AgreementUserRole']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enabledEntryModules?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOrganizationInfoEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserOrganizationInfoEdge'] = ResolversParentTypes['UserOrganizationInfoEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['UserOrganizationInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOrganizationInfosConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserOrganizationInfosConnection'] = ResolversParentTypes['UserOrganizationInfosConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UserOrganizationInfoEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersConnection'] = ResolversParentTypes['UsersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UserEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  ActionPrescriptionRelationship?: ActionPrescriptionRelationshipResolvers<ContextType>;
  ActiveUserSession?: ActiveUserSessionResolvers<ContextType>;
  ActiveUserSessionEdge?: ActiveUserSessionEdgeResolvers<ContextType>;
  ActiveUserSessionsConnection?: ActiveUserSessionsConnectionResolvers<ContextType>;
  Agreement?: AgreementResolvers<ContextType>;
  AgreementAddedByConnection?: AgreementAddedByConnectionResolvers<ContextType>;
  AgreementAddedByRelationship?: AgreementAddedByRelationshipResolvers<ContextType>;
  AgreementAgreementInitialVersionAggregationSelection?: AgreementAgreementInitialVersionAggregationSelectionResolvers<ContextType>;
  AgreementAgreementInitialVersionNodeAggregateSelection?: AgreementAgreementInitialVersionNodeAggregateSelectionResolvers<ContextType>;
  AgreementAgreementNextVersionsAggregationSelection?: AgreementAgreementNextVersionsAggregationSelectionResolvers<ContextType>;
  AgreementAgreementNextVersionsNodeAggregateSelection?: AgreementAgreementNextVersionsNodeAggregateSelectionResolvers<ContextType>;
  AgreementAgreementTagTagsAggregationSelection?: AgreementAgreementTagTagsAggregationSelectionResolvers<ContextType>;
  AgreementAgreementTagTagsNodeAggregateSelection?: AgreementAgreementTagTagsNodeAggregateSelectionResolvers<ContextType>;
  AgreementAgreementTemplateTemplateAggregationSelection?: AgreementAgreementTemplateTemplateAggregationSelectionResolvers<ContextType>;
  AgreementAgreementTemplateTemplateNodeAggregateSelection?: AgreementAgreementTemplateTemplateNodeAggregateSelectionResolvers<ContextType>;
  AgreementBrandScenariosRelevantBrandsAggregationSelection?: AgreementBrandScenariosRelevantBrandsAggregationSelectionResolvers<ContextType>;
  AgreementBrandScenariosRelevantBrandsNodeAggregateSelection?: AgreementBrandScenariosRelevantBrandsNodeAggregateSelectionResolvers<ContextType>;
  AgreementCatalogueAttributeNegotiableAttributesAggregationSelection?: AgreementCatalogueAttributeNegotiableAttributesAggregationSelectionResolvers<ContextType>;
  AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection?: AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelectionResolvers<ContextType>;
  AgreementChartRangeConfigurationDotThresholdsAggregationSelection?: AgreementChartRangeConfigurationDotThresholdsAggregationSelectionResolvers<ContextType>;
  AgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection?: AgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelectionResolvers<ContextType>;
  AgreementChartRangeConfigurationRangeChartConfigAggregationSelection?: AgreementChartRangeConfigurationRangeChartConfigAggregationSelectionResolvers<ContextType>;
  AgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection?: AgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelectionResolvers<ContextType>;
  AgreementCounterpartiesConnection?: AgreementCounterpartiesConnectionResolvers<ContextType>;
  AgreementCounterpartiesRelationship?: AgreementCounterpartiesRelationshipResolvers<ContextType>;
  AgreementCounterpartyRelationship?: AgreementCounterpartyRelationshipResolvers<ContextType>;
  AgreementCountryConnection?: AgreementCountryConnectionResolvers<ContextType>;
  AgreementCountryCountryAggregationSelection?: AgreementCountryCountryAggregationSelectionResolvers<ContextType>;
  AgreementCountryCountryNodeAggregateSelection?: AgreementCountryCountryNodeAggregateSelectionResolvers<ContextType>;
  AgreementCountryRelationship?: AgreementCountryRelationshipResolvers<ContextType>;
  AgreementCurrencyConnection?: AgreementCurrencyConnectionResolvers<ContextType>;
  AgreementCurrencyCurrencyAggregationSelection?: AgreementCurrencyCurrencyAggregationSelectionResolvers<ContextType>;
  AgreementCurrencyCurrencyNodeAggregateSelection?: AgreementCurrencyCurrencyNodeAggregateSelectionResolvers<ContextType>;
  AgreementCurrencyRelationship?: AgreementCurrencyRelationshipResolvers<ContextType>;
  AgreementCycleConfigurationCyclesAggregationSelection?: AgreementCycleConfigurationCyclesAggregationSelectionResolvers<ContextType>;
  AgreementCycleConfigurationCyclesNodeAggregateSelection?: AgreementCycleConfigurationCyclesNodeAggregateSelectionResolvers<ContextType>;
  AgreementCyclesConnection?: AgreementCyclesConnectionResolvers<ContextType>;
  AgreementCyclesRelationship?: AgreementCyclesRelationshipResolvers<ContextType>;
  AgreementDataContainerDataContainersAggregationSelection?: AgreementDataContainerDataContainersAggregationSelectionResolvers<ContextType>;
  AgreementDataContainerDataContainersNodeAggregateSelection?: AgreementDataContainerDataContainersNodeAggregateSelectionResolvers<ContextType>;
  AgreementDataContainersConnection?: AgreementDataContainersConnectionResolvers<ContextType>;
  AgreementDataContainersRelationship?: AgreementDataContainersRelationshipResolvers<ContextType>;
  AgreementDataSourceConnection?: AgreementDataSourceConnectionResolvers<ContextType>;
  AgreementDataSourceDataSourceAggregationSelection?: AgreementDataSourceDataSourceAggregationSelectionResolvers<ContextType>;
  AgreementDataSourceDataSourceNodeAggregateSelection?: AgreementDataSourceDataSourceNodeAggregateSelectionResolvers<ContextType>;
  AgreementDataSourceRelationship?: AgreementDataSourceRelationshipResolvers<ContextType>;
  AgreementDecision?: AgreementDecisionResolvers<ContextType>;
  AgreementDecisionAsOfConnection?: AgreementDecisionAsOfConnectionResolvers<ContextType>;
  AgreementDecisionAsOfRelationship?: AgreementDecisionAsOfRelationshipResolvers<ContextType>;
  AgreementDecisionEdge?: AgreementDecisionEdgeResolvers<ContextType>;
  AgreementDecisionMadeByConnection?: AgreementDecisionMadeByConnectionResolvers<ContextType>;
  AgreementDecisionMadeByRelationship?: AgreementDecisionMadeByRelationshipResolvers<ContextType>;
  AgreementDecisionOrganizationAsOfAggregationSelection?: AgreementDecisionOrganizationAsOfAggregationSelectionResolvers<ContextType>;
  AgreementDecisionOrganizationAsOfNodeAggregateSelection?: AgreementDecisionOrganizationAsOfNodeAggregateSelectionResolvers<ContextType>;
  AgreementDecisionUserMadeByAggregationSelection?: AgreementDecisionUserMadeByAggregationSelectionResolvers<ContextType>;
  AgreementDecisionUserMadeByNodeAggregateSelection?: AgreementDecisionUserMadeByNodeAggregateSelectionResolvers<ContextType>;
  AgreementDecisionsConnection?: AgreementDecisionsConnectionResolvers<ContextType>;
  AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection?: AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelectionResolvers<ContextType>;
  AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection?: AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelectionResolvers<ContextType>;
  AgreementDeviceAlternativeSetsConnection?: AgreementDeviceAlternativeSetsConnectionResolvers<ContextType>;
  AgreementDeviceAlternativeSetsRelationship?: AgreementDeviceAlternativeSetsRelationshipResolvers<ContextType>;
  AgreementDotThresholdsConnection?: AgreementDotThresholdsConnectionResolvers<ContextType>;
  AgreementDotThresholdsRelationship?: AgreementDotThresholdsRelationshipResolvers<ContextType>;
  AgreementEdge?: AgreementEdgeResolvers<ContextType>;
  AgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection?: AgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelectionResolvers<ContextType>;
  AgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection?: AgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelectionResolvers<ContextType>;
  AgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection?: AgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelectionResolvers<ContextType>;
  AgreementEligibilityConditionSetsConnection?: AgreementEligibilityConditionSetsConnectionResolvers<ContextType>;
  AgreementEligibilityConditionSetsRelationship?: AgreementEligibilityConditionSetsRelationshipResolvers<ContextType>;
  AgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection?: AgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelectionResolvers<ContextType>;
  AgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection?: AgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelectionResolvers<ContextType>;
  AgreementEnrollingConditionSetsConnection?: AgreementEnrollingConditionSetsConnectionResolvers<ContextType>;
  AgreementEnrollingConditionSetsRelationship?: AgreementEnrollingConditionSetsRelationshipResolvers<ContextType>;
  AgreementEnrollingPeriodEnrollingPeriodsAggregationSelection?: AgreementEnrollingPeriodEnrollingPeriodsAggregationSelectionResolvers<ContextType>;
  AgreementEnrollingPeriodsConnection?: AgreementEnrollingPeriodsConnectionResolvers<ContextType>;
  AgreementEnrollingPeriodsRelationship?: AgreementEnrollingPeriodsRelationshipResolvers<ContextType>;
  AgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection?: AgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelectionResolvers<ContextType>;
  AgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection?: AgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelectionResolvers<ContextType>;
  AgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection?: AgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelectionResolvers<ContextType>;
  AgreementFinancialSummaryColumnRelationship?: AgreementFinancialSummaryColumnRelationshipResolvers<ContextType>;
  AgreementFinancialSummaryConfigConnection?: AgreementFinancialSummaryConfigConnectionResolvers<ContextType>;
  AgreementFinancialSummaryConfigRelationship?: AgreementFinancialSummaryConfigRelationshipResolvers<ContextType>;
  AgreementInitialVersionConnection?: AgreementInitialVersionConnectionResolvers<ContextType>;
  AgreementInitialVersionRelationship?: AgreementInitialVersionRelationshipResolvers<ContextType>;
  AgreementLimitationConnection?: AgreementLimitationConnectionResolvers<ContextType>;
  AgreementLimitationLimitationAggregationSelection?: AgreementLimitationLimitationAggregationSelectionResolvers<ContextType>;
  AgreementLimitationLimitationNodeAggregateSelection?: AgreementLimitationLimitationNodeAggregateSelectionResolvers<ContextType>;
  AgreementLimitationRelationship?: AgreementLimitationRelationshipResolvers<ContextType>;
  AgreementNegotiableAttributesConnection?: AgreementNegotiableAttributesConnectionResolvers<ContextType>;
  AgreementNegotiableAttributesRelationship?: AgreementNegotiableAttributesRelationshipResolvers<ContextType>;
  AgreementNextVersionsConnection?: AgreementNextVersionsConnectionResolvers<ContextType>;
  AgreementNextVersionsRelationship?: AgreementNextVersionsRelationshipResolvers<ContextType>;
  AgreementOrganizationCounterpartiesAggregationSelection?: AgreementOrganizationCounterpartiesAggregationSelectionResolvers<ContextType>;
  AgreementOrganizationCounterpartiesNodeAggregateSelection?: AgreementOrganizationCounterpartiesNodeAggregateSelectionResolvers<ContextType>;
  AgreementPushedByConnection?: AgreementPushedByConnectionResolvers<ContextType>;
  AgreementPushedByRelationship?: AgreementPushedByRelationshipResolvers<ContextType>;
  AgreementRangeChartConfigConnection?: AgreementRangeChartConfigConnectionResolvers<ContextType>;
  AgreementRangeChartConfigRelationship?: AgreementRangeChartConfigRelationshipResolvers<ContextType>;
  AgreementRunAttemptInfo?: AgreementRunAttemptInfoResolvers<ContextType>;
  AgreementRunAttemptInfoEdge?: AgreementRunAttemptInfoEdgeResolvers<ContextType>;
  AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection?: AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelectionResolvers<ContextType>;
  AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection?: AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelectionResolvers<ContextType>;
  AgreementRunAttemptInfoOrganizationTriggeredConnection?: AgreementRunAttemptInfoOrganizationTriggeredConnectionResolvers<ContextType>;
  AgreementRunAttemptInfoOrganizationTriggeredRelationship?: AgreementRunAttemptInfoOrganizationTriggeredRelationshipResolvers<ContextType>;
  AgreementRunAttemptInfoRunInitiatorConnection?: AgreementRunAttemptInfoRunInitiatorConnectionResolvers<ContextType>;
  AgreementRunAttemptInfoRunInitiatorRelationship?: AgreementRunAttemptInfoRunInitiatorRelationshipResolvers<ContextType>;
  AgreementRunAttemptInfoUserRunInitiatorAggregationSelection?: AgreementRunAttemptInfoUserRunInitiatorAggregationSelectionResolvers<ContextType>;
  AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection?: AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelectionResolvers<ContextType>;
  AgreementRunAttemptInfosConnection?: AgreementRunAttemptInfosConnectionResolvers<ContextType>;
  AgreementScenarioScenariosAggregationSelection?: AgreementScenarioScenariosAggregationSelectionResolvers<ContextType>;
  AgreementScenarioScenariosNodeAggregateSelection?: AgreementScenarioScenariosNodeAggregateSelectionResolvers<ContextType>;
  AgreementScenariosConnection?: AgreementScenariosConnectionResolvers<ContextType>;
  AgreementScenariosRelationship?: AgreementScenariosRelationshipResolvers<ContextType>;
  AgreementScenariosRelevantBrandsConnection?: AgreementScenariosRelevantBrandsConnectionResolvers<ContextType>;
  AgreementScenariosRelevantBrandsRelationship?: AgreementScenariosRelevantBrandsRelationshipResolvers<ContextType>;
  AgreementScope?: AgreementScopeResolvers<ContextType>;
  AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection?: AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelectionResolvers<ContextType>;
  AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection?: AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelectionResolvers<ContextType>;
  AgreementScopeArticle71IndicationsConnection?: AgreementScopeArticle71IndicationsConnectionResolvers<ContextType>;
  AgreementScopeArticle71IndicationsRelationship?: AgreementScopeArticle71IndicationsRelationshipResolvers<ContextType>;
  AgreementScopeCountryCountryScopesAggregationSelection?: AgreementScopeCountryCountryScopesAggregationSelectionResolvers<ContextType>;
  AgreementScopeCountryCountryScopesEdgeAggregateSelection?: AgreementScopeCountryCountryScopesEdgeAggregateSelectionResolvers<ContextType>;
  AgreementScopeCountryCountryScopesNodeAggregateSelection?: AgreementScopeCountryCountryScopesNodeAggregateSelectionResolvers<ContextType>;
  AgreementScopeCountryScope?: AgreementScopeCountryScopeResolvers<ContextType>;
  AgreementScopeCountryScopeEdge?: AgreementScopeCountryScopeEdgeResolvers<ContextType>;
  AgreementScopeCountryScopesConnection?: AgreementScopeCountryScopesConnectionResolvers<ContextType>;
  AgreementScopeCountryScopesRelationship?: AgreementScopeCountryScopesRelationshipResolvers<ContextType>;
  AgreementScopeCycleConfigurationCyclesAggregationSelection?: AgreementScopeCycleConfigurationCyclesAggregationSelectionResolvers<ContextType>;
  AgreementScopeCycleConfigurationCyclesNodeAggregateSelection?: AgreementScopeCycleConfigurationCyclesNodeAggregateSelectionResolvers<ContextType>;
  AgreementScopeCyclesConnection?: AgreementScopeCyclesConnectionResolvers<ContextType>;
  AgreementScopeCyclesRelationship?: AgreementScopeCyclesRelationshipResolvers<ContextType>;
  AgreementScopeDiseaseDiseasesAggregationSelection?: AgreementScopeDiseaseDiseasesAggregationSelectionResolvers<ContextType>;
  AgreementScopeDiseaseDiseasesEdgeAggregateSelection?: AgreementScopeDiseaseDiseasesEdgeAggregateSelectionResolvers<ContextType>;
  AgreementScopeDiseaseDiseasesNodeAggregateSelection?: AgreementScopeDiseaseDiseasesNodeAggregateSelectionResolvers<ContextType>;
  AgreementScopeDiseasesConnection?: AgreementScopeDiseasesConnectionResolvers<ContextType>;
  AgreementScopeDiseasesRelationship?: AgreementScopeDiseasesRelationshipResolvers<ContextType>;
  AgreementScopeEdge?: AgreementScopeEdgeResolvers<ContextType>;
  AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection?: AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelectionResolvers<ContextType>;
  AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection?: AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelectionResolvers<ContextType>;
  AgreementScopeEnrollingConditionSetsConnection?: AgreementScopeEnrollingConditionSetsConnectionResolvers<ContextType>;
  AgreementScopeEnrollingConditionSetsRelationship?: AgreementScopeEnrollingConditionSetsRelationshipResolvers<ContextType>;
  AgreementScopeIndicationIndicationsAggregationSelection?: AgreementScopeIndicationIndicationsAggregationSelectionResolvers<ContextType>;
  AgreementScopeIndicationIndicationsNodeAggregateSelection?: AgreementScopeIndicationIndicationsNodeAggregateSelectionResolvers<ContextType>;
  AgreementScopeIndicationsConnection?: AgreementScopeIndicationsConnectionResolvers<ContextType>;
  AgreementScopeIndicationsRelationship?: AgreementScopeIndicationsRelationshipResolvers<ContextType>;
  AgreementScopeOrganizationOrganizationScopesAggregationSelection?: AgreementScopeOrganizationOrganizationScopesAggregationSelectionResolvers<ContextType>;
  AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection?: AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelectionResolvers<ContextType>;
  AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection?: AgreementScopeOrganizationOrganizationScopesNodeAggregateSelectionResolvers<ContextType>;
  AgreementScopeOrganizationScope?: AgreementScopeOrganizationScopeResolvers<ContextType>;
  AgreementScopeOrganizationScopeEdge?: AgreementScopeOrganizationScopeEdgeResolvers<ContextType>;
  AgreementScopeOrganizationScopesConnection?: AgreementScopeOrganizationScopesConnectionResolvers<ContextType>;
  AgreementScopeOrganizationScopesRelationship?: AgreementScopeOrganizationScopesRelationshipResolvers<ContextType>;
  AgreementScopeRelationship?: AgreementScopeRelationshipResolvers<ContextType>;
  AgreementScopeTreatmentSetTreatmentSetsAggregationSelection?: AgreementScopeTreatmentSetTreatmentSetsAggregationSelectionResolvers<ContextType>;
  AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection?: AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelectionResolvers<ContextType>;
  AgreementScopeTreatmentSetsConnection?: AgreementScopeTreatmentSetsConnectionResolvers<ContextType>;
  AgreementScopeTreatmentSetsRelationship?: AgreementScopeTreatmentSetsRelationshipResolvers<ContextType>;
  AgreementScopesConnection?: AgreementScopesConnectionResolvers<ContextType>;
  AgreementSpecificRole?: AgreementSpecificRoleResolvers<ContextType>;
  AgreementSpecificRoleEdge?: AgreementSpecificRoleEdgeResolvers<ContextType>;
  AgreementSpecificRolesConnection?: AgreementSpecificRolesConnectionResolvers<ContextType>;
  AgreementStatusTransition?: AgreementStatusTransitionResolvers<ContextType>;
  AgreementStatusTransitionCausedByConnection?: AgreementStatusTransitionCausedByConnectionResolvers<ContextType>;
  AgreementStatusTransitionCausedByRelationship?: AgreementStatusTransitionCausedByRelationshipResolvers<ContextType>;
  AgreementStatusTransitionEdge?: AgreementStatusTransitionEdgeResolvers<ContextType>;
  AgreementStatusTransitionUserCausedByAggregationSelection?: AgreementStatusTransitionUserCausedByAggregationSelectionResolvers<ContextType>;
  AgreementStatusTransitionUserCausedByNodeAggregateSelection?: AgreementStatusTransitionUserCausedByNodeAggregateSelectionResolvers<ContextType>;
  AgreementStatusTransitionsConnection?: AgreementStatusTransitionsConnectionResolvers<ContextType>;
  AgreementTag?: AgreementTagResolvers<ContextType>;
  AgreementTagDefaultUserRolesConnection?: AgreementTagDefaultUserRolesConnectionResolvers<ContextType>;
  AgreementTagDefaultUserRolesRelationship?: AgreementTagDefaultUserRolesRelationshipResolvers<ContextType>;
  AgreementTagEdge?: AgreementTagEdgeResolvers<ContextType>;
  AgreementTagUserDefaultUserRolesAggregationSelection?: AgreementTagUserDefaultUserRolesAggregationSelectionResolvers<ContextType>;
  AgreementTagUserDefaultUserRolesNodeAggregateSelection?: AgreementTagUserDefaultUserRolesNodeAggregateSelectionResolvers<ContextType>;
  AgreementTagUserRoleRelationship?: AgreementTagUserRoleRelationshipResolvers<ContextType>;
  AgreementTagsConnection?: AgreementTagsConnectionResolvers<ContextType>;
  AgreementTemplate?: AgreementTemplateResolvers<ContextType>;
  AgreementTemplateAddedByConnection?: AgreementTemplateAddedByConnectionResolvers<ContextType>;
  AgreementTemplateAddedByRelationship?: AgreementTemplateAddedByRelationshipResolvers<ContextType>;
  AgreementTemplateAgreementAgreementsAggregationSelection?: AgreementTemplateAgreementAgreementsAggregationSelectionResolvers<ContextType>;
  AgreementTemplateAgreementAgreementsNodeAggregateSelection?: AgreementTemplateAgreementAgreementsNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateAgreementTagTagsAggregationSelection?: AgreementTemplateAgreementTagTagsAggregationSelectionResolvers<ContextType>;
  AgreementTemplateAgreementTagTagsNodeAggregateSelection?: AgreementTemplateAgreementTagTagsNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateAgreementTemplateInitialVersionAggregationSelection?: AgreementTemplateAgreementTemplateInitialVersionAggregationSelectionResolvers<ContextType>;
  AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection?: AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateAgreementTemplateNextVersionsAggregationSelection?: AgreementTemplateAgreementTemplateNextVersionsAggregationSelectionResolvers<ContextType>;
  AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection?: AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateAgreementsConnection?: AgreementTemplateAgreementsConnectionResolvers<ContextType>;
  AgreementTemplateAgreementsRelationship?: AgreementTemplateAgreementsRelationshipResolvers<ContextType>;
  AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection?: AgreementTemplateBrandScenariosRelevantBrandsAggregationSelectionResolvers<ContextType>;
  AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection?: AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection?: AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelectionResolvers<ContextType>;
  AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection?: AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection?: AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelectionResolvers<ContextType>;
  AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection?: AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection?: AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelectionResolvers<ContextType>;
  AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection?: AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateConnection?: AgreementTemplateConnectionResolvers<ContextType>;
  AgreementTemplateCountryConnection?: AgreementTemplateCountryConnectionResolvers<ContextType>;
  AgreementTemplateCountryCountryAggregationSelection?: AgreementTemplateCountryCountryAggregationSelectionResolvers<ContextType>;
  AgreementTemplateCountryCountryNodeAggregateSelection?: AgreementTemplateCountryCountryNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateCountryRelationship?: AgreementTemplateCountryRelationshipResolvers<ContextType>;
  AgreementTemplateCurrencyConnection?: AgreementTemplateCurrencyConnectionResolvers<ContextType>;
  AgreementTemplateCurrencyCurrencyAggregationSelection?: AgreementTemplateCurrencyCurrencyAggregationSelectionResolvers<ContextType>;
  AgreementTemplateCurrencyCurrencyNodeAggregateSelection?: AgreementTemplateCurrencyCurrencyNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateCurrencyRelationship?: AgreementTemplateCurrencyRelationshipResolvers<ContextType>;
  AgreementTemplateCycleConfigurationCyclesAggregationSelection?: AgreementTemplateCycleConfigurationCyclesAggregationSelectionResolvers<ContextType>;
  AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection?: AgreementTemplateCycleConfigurationCyclesNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateCyclesConnection?: AgreementTemplateCyclesConnectionResolvers<ContextType>;
  AgreementTemplateCyclesRelationship?: AgreementTemplateCyclesRelationshipResolvers<ContextType>;
  AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection?: AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelectionResolvers<ContextType>;
  AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection?: AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateDeviceAlternativeSetsConnection?: AgreementTemplateDeviceAlternativeSetsConnectionResolvers<ContextType>;
  AgreementTemplateDeviceAlternativeSetsRelationship?: AgreementTemplateDeviceAlternativeSetsRelationshipResolvers<ContextType>;
  AgreementTemplateDotThresholdsConnection?: AgreementTemplateDotThresholdsConnectionResolvers<ContextType>;
  AgreementTemplateDotThresholdsRelationship?: AgreementTemplateDotThresholdsRelationshipResolvers<ContextType>;
  AgreementTemplateEdge?: AgreementTemplateEdgeResolvers<ContextType>;
  AgreementTemplateEligibilityConditionRelationship?: AgreementTemplateEligibilityConditionRelationshipResolvers<ContextType>;
  AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection?: AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelectionResolvers<ContextType>;
  AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection?: AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection?: AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateEligibilityConditionSetsConnection?: AgreementTemplateEligibilityConditionSetsConnectionResolvers<ContextType>;
  AgreementTemplateEligibilityConditionSetsRelationship?: AgreementTemplateEligibilityConditionSetsRelationshipResolvers<ContextType>;
  AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection?: AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelectionResolvers<ContextType>;
  AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection?: AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateEnrollingConditionSetsConnection?: AgreementTemplateEnrollingConditionSetsConnectionResolvers<ContextType>;
  AgreementTemplateEnrollingConditionSetsRelationship?: AgreementTemplateEnrollingConditionSetsRelationshipResolvers<ContextType>;
  AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection?: AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelectionResolvers<ContextType>;
  AgreementTemplateEnrollingPeriodsConnection?: AgreementTemplateEnrollingPeriodsConnectionResolvers<ContextType>;
  AgreementTemplateEnrollingPeriodsRelationship?: AgreementTemplateEnrollingPeriodsRelationshipResolvers<ContextType>;
  AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection?: AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelectionResolvers<ContextType>;
  AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection?: AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection?: AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateFinancialSummaryConfigConnection?: AgreementTemplateFinancialSummaryConfigConnectionResolvers<ContextType>;
  AgreementTemplateFinancialSummaryConfigRelationship?: AgreementTemplateFinancialSummaryConfigRelationshipResolvers<ContextType>;
  AgreementTemplateInitialVersionConnection?: AgreementTemplateInitialVersionConnectionResolvers<ContextType>;
  AgreementTemplateInitialVersionRelationship?: AgreementTemplateInitialVersionRelationshipResolvers<ContextType>;
  AgreementTemplateLimitationConnection?: AgreementTemplateLimitationConnectionResolvers<ContextType>;
  AgreementTemplateLimitationLimitationAggregationSelection?: AgreementTemplateLimitationLimitationAggregationSelectionResolvers<ContextType>;
  AgreementTemplateLimitationLimitationNodeAggregateSelection?: AgreementTemplateLimitationLimitationNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateLimitationRelationship?: AgreementTemplateLimitationRelationshipResolvers<ContextType>;
  AgreementTemplateNegotiableAttributesConnection?: AgreementTemplateNegotiableAttributesConnectionResolvers<ContextType>;
  AgreementTemplateNegotiableAttributesRelationship?: AgreementTemplateNegotiableAttributesRelationshipResolvers<ContextType>;
  AgreementTemplateNextVersionsConnection?: AgreementTemplateNextVersionsConnectionResolvers<ContextType>;
  AgreementTemplateNextVersionsRelationship?: AgreementTemplateNextVersionsRelationshipResolvers<ContextType>;
  AgreementTemplateRangeChartConfigConnection?: AgreementTemplateRangeChartConfigConnectionResolvers<ContextType>;
  AgreementTemplateRangeChartConfigRelationship?: AgreementTemplateRangeChartConfigRelationshipResolvers<ContextType>;
  AgreementTemplateRelationship?: AgreementTemplateRelationshipResolvers<ContextType>;
  AgreementTemplateScenarioScenariosAggregationSelection?: AgreementTemplateScenarioScenariosAggregationSelectionResolvers<ContextType>;
  AgreementTemplateScenarioScenariosNodeAggregateSelection?: AgreementTemplateScenarioScenariosNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateScenariosConnection?: AgreementTemplateScenariosConnectionResolvers<ContextType>;
  AgreementTemplateScenariosRelationship?: AgreementTemplateScenariosRelationshipResolvers<ContextType>;
  AgreementTemplateScenariosRelevantBrandsConnection?: AgreementTemplateScenariosRelevantBrandsConnectionResolvers<ContextType>;
  AgreementTemplateScenariosRelevantBrandsRelationship?: AgreementTemplateScenariosRelevantBrandsRelationshipResolvers<ContextType>;
  AgreementTemplateTagsConnection?: AgreementTemplateTagsConnectionResolvers<ContextType>;
  AgreementTemplateTagsRelationship?: AgreementTemplateTagsRelationshipResolvers<ContextType>;
  AgreementTemplateTreatmentPriceRelationship?: AgreementTemplateTreatmentPriceRelationshipResolvers<ContextType>;
  AgreementTemplateTreatmentPricesConnection?: AgreementTemplateTreatmentPricesConnectionResolvers<ContextType>;
  AgreementTemplateTreatmentPricesRelationship?: AgreementTemplateTreatmentPricesRelationshipResolvers<ContextType>;
  AgreementTemplateTreatmentTreatmentPricesAggregationSelection?: AgreementTemplateTreatmentTreatmentPricesAggregationSelectionResolvers<ContextType>;
  AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection?: AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection?: AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateUserAddedByAggregationSelection?: AgreementTemplateUserAddedByAggregationSelectionResolvers<ContextType>;
  AgreementTemplateUserAddedByNodeAggregateSelection?: AgreementTemplateUserAddedByNodeAggregateSelectionResolvers<ContextType>;
  AgreementTemplateVersionCreationResponse?: AgreementTemplateVersionCreationResponseResolvers<ContextType>;
  AgreementTemplateVersionCreationResponseEdge?: AgreementTemplateVersionCreationResponseEdgeResolvers<ContextType>;
  AgreementTemplateVersionCreationResponsesConnection?: AgreementTemplateVersionCreationResponsesConnectionResolvers<ContextType>;
  AgreementTemplatesConnection?: AgreementTemplatesConnectionResolvers<ContextType>;
  AgreementTreatmentPriceRelationship?: AgreementTreatmentPriceRelationshipResolvers<ContextType>;
  AgreementTreatmentPricesConnection?: AgreementTreatmentPricesConnectionResolvers<ContextType>;
  AgreementTreatmentPricesRelationship?: AgreementTreatmentPricesRelationshipResolvers<ContextType>;
  AgreementTreatmentTreatmentPricesAggregationSelection?: AgreementTreatmentTreatmentPricesAggregationSelectionResolvers<ContextType>;
  AgreementTreatmentTreatmentPricesEdgeAggregateSelection?: AgreementTreatmentTreatmentPricesEdgeAggregateSelectionResolvers<ContextType>;
  AgreementTreatmentTreatmentPricesNodeAggregateSelection?: AgreementTreatmentTreatmentPricesNodeAggregateSelectionResolvers<ContextType>;
  AgreementUserAddedByAggregationSelection?: AgreementUserAddedByAggregationSelectionResolvers<ContextType>;
  AgreementUserAddedByNodeAggregateSelection?: AgreementUserAddedByNodeAggregateSelectionResolvers<ContextType>;
  AgreementUserPushedByAggregationSelection?: AgreementUserPushedByAggregationSelectionResolvers<ContextType>;
  AgreementUserPushedByNodeAggregateSelection?: AgreementUserPushedByNodeAggregateSelectionResolvers<ContextType>;
  AgreementUserRoleRelationship?: AgreementUserRoleRelationshipResolvers<ContextType>;
  AgreementUserRolesConnection?: AgreementUserRolesConnectionResolvers<ContextType>;
  AgreementUserRolesRelationship?: AgreementUserRolesRelationshipResolvers<ContextType>;
  AgreementUserUserRolesAggregationSelection?: AgreementUserUserRolesAggregationSelectionResolvers<ContextType>;
  AgreementUserUserRolesNodeAggregateSelection?: AgreementUserUserRolesNodeAggregateSelectionResolvers<ContextType>;
  AgreementsConnection?: AgreementsConnectionResolvers<ContextType>;
  Alert?: AlertResolvers<ContextType>;
  AlertCheckConnection?: AlertCheckConnectionResolvers<ContextType>;
  AlertCheckRelationship?: AlertCheckRelationshipResolvers<ContextType>;
  AlertEdge?: AlertEdgeResolvers<ContextType>;
  AlertRunCheckCheckAggregationSelection?: AlertRunCheckCheckAggregationSelectionResolvers<ContextType>;
  AlertRunCheckCheckNodeAggregateSelection?: AlertRunCheckCheckNodeAggregateSelectionResolvers<ContextType>;
  AlertsConnection?: AlertsConnectionResolvers<ContextType>;
  Art71MasterDataImpacts?: Art71MasterDataImpactsResolvers<ContextType>;
  Art71MasterDataImpactsConnection?: Art71MasterDataImpactsConnectionResolvers<ContextType>;
  Art71MasterDataImpactsEdge?: Art71MasterDataImpactsEdgeResolvers<ContextType>;
  Article71Indication?: Article71IndicationResolvers<ContextType>;
  Article71IndicationAgreementScopeAgreementScopeAggregationSelection?: Article71IndicationAgreementScopeAgreementScopeAggregationSelectionResolvers<ContextType>;
  Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection?: Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelectionResolvers<ContextType>;
  Article71IndicationAgreementScopeConnection?: Article71IndicationAgreementScopeConnectionResolvers<ContextType>;
  Article71IndicationAgreementScopeRelationship?: Article71IndicationAgreementScopeRelationshipResolvers<ContextType>;
  Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection?: Article71IndicationAgreementTemplateAgreementTemplateAggregationSelectionResolvers<ContextType>;
  Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection?: Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelectionResolvers<ContextType>;
  Article71IndicationAgreementTemplateConnection?: Article71IndicationAgreementTemplateConnectionResolvers<ContextType>;
  Article71IndicationAgreementTemplateRelationship?: Article71IndicationAgreementTemplateRelationshipResolvers<ContextType>;
  Article71IndicationBrandBrandAggregationSelection?: Article71IndicationBrandBrandAggregationSelectionResolvers<ContextType>;
  Article71IndicationBrandBrandNodeAggregateSelection?: Article71IndicationBrandBrandNodeAggregateSelectionResolvers<ContextType>;
  Article71IndicationBrandConnection?: Article71IndicationBrandConnectionResolvers<ContextType>;
  Article71IndicationBrandRelationship?: Article71IndicationBrandRelationshipResolvers<ContextType>;
  Article71IndicationCaseCasesAggregationSelection?: Article71IndicationCaseCasesAggregationSelectionResolvers<ContextType>;
  Article71IndicationCaseCasesNodeAggregateSelection?: Article71IndicationCaseCasesNodeAggregateSelectionResolvers<ContextType>;
  Article71IndicationCasesConnection?: Article71IndicationCasesConnectionResolvers<ContextType>;
  Article71IndicationCasesRelationship?: Article71IndicationCasesRelationshipResolvers<ContextType>;
  Article71IndicationEdge?: Article71IndicationEdgeResolvers<ContextType>;
  Article71IndicationMainIndicationConnection?: Article71IndicationMainIndicationConnectionResolvers<ContextType>;
  Article71IndicationMainIndicationMainIndicationAggregationSelection?: Article71IndicationMainIndicationMainIndicationAggregationSelectionResolvers<ContextType>;
  Article71IndicationMainIndicationMainIndicationNodeAggregateSelection?: Article71IndicationMainIndicationMainIndicationNodeAggregateSelectionResolvers<ContextType>;
  Article71IndicationMainIndicationRelationship?: Article71IndicationMainIndicationRelationshipResolvers<ContextType>;
  Article71IndicationsConnection?: Article71IndicationsConnectionResolvers<ContextType>;
  AuthOrganization?: AuthOrganizationResolvers<ContextType>;
  AuthOrganizationEdge?: AuthOrganizationEdgeResolvers<ContextType>;
  AuthOrganizationsConnection?: AuthOrganizationsConnectionResolvers<ContextType>;
  AvailableTranslations?: AvailableTranslationsResolvers<ContextType>;
  AvailableTranslationsConnection?: AvailableTranslationsConnectionResolvers<ContextType>;
  AvailableTranslationsEdge?: AvailableTranslationsEdgeResolvers<ContextType>;
  AverageGenericPrice?: AverageGenericPriceResolvers<ContextType>;
  AverageGenericPriceEdge?: AverageGenericPriceEdgeResolvers<ContextType>;
  AverageGenericPricesConnection?: AverageGenericPricesConnectionResolvers<ContextType>;
  BaseAgreement?: BaseAgreementResolvers<ContextType>;
  BaseAgreementAddedByConnection?: BaseAgreementAddedByConnectionResolvers<ContextType>;
  BaseAgreementAddedByRelationship?: BaseAgreementAddedByRelationshipResolvers<ContextType>;
  BaseAgreementAgreementDecisionDecisionsAggregationSelection?: BaseAgreementAgreementDecisionDecisionsAggregationSelectionResolvers<ContextType>;
  BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection?: BaseAgreementAgreementDecisionDecisionsNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection?: BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelectionResolvers<ContextType>;
  BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection?: BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementAgreementTagTagsAggregationSelection?: BaseAgreementAgreementTagTagsAggregationSelectionResolvers<ContextType>;
  BaseAgreementAgreementTagTagsNodeAggregateSelection?: BaseAgreementAgreementTagTagsNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementAgreementTemplateTemplateAggregationSelection?: BaseAgreementAgreementTemplateTemplateAggregationSelectionResolvers<ContextType>;
  BaseAgreementAgreementTemplateTemplateNodeAggregateSelection?: BaseAgreementAgreementTemplateTemplateNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementBaseAgreementInitialVersionAggregationSelection?: BaseAgreementBaseAgreementInitialVersionAggregationSelectionResolvers<ContextType>;
  BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection?: BaseAgreementBaseAgreementInitialVersionNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementBaseAgreementNextVersionsAggregationSelection?: BaseAgreementBaseAgreementNextVersionsAggregationSelectionResolvers<ContextType>;
  BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection?: BaseAgreementBaseAgreementNextVersionsNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementBrandScenariosRelevantBrandsAggregationSelection?: BaseAgreementBrandScenariosRelevantBrandsAggregationSelectionResolvers<ContextType>;
  BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection?: BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementCaseCasesAggregationSelection?: BaseAgreementCaseCasesAggregationSelectionResolvers<ContextType>;
  BaseAgreementCaseCasesNodeAggregateSelection?: BaseAgreementCaseCasesNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementCasesConnection?: BaseAgreementCasesConnectionResolvers<ContextType>;
  BaseAgreementCasesRelationship?: BaseAgreementCasesRelationshipResolvers<ContextType>;
  BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection?: BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelectionResolvers<ContextType>;
  BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection?: BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection?: BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelectionResolvers<ContextType>;
  BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection?: BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelectionResolvers<ContextType>;
  BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection?: BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelectionResolvers<ContextType>;
  BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection?: BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelectionResolvers<ContextType>;
  BaseAgreementCounterpartiesConnection?: BaseAgreementCounterpartiesConnectionResolvers<ContextType>;
  BaseAgreementCounterpartiesRelationship?: BaseAgreementCounterpartiesRelationshipResolvers<ContextType>;
  BaseAgreementCounterpartyRelationship?: BaseAgreementCounterpartyRelationshipResolvers<ContextType>;
  BaseAgreementCountryConnection?: BaseAgreementCountryConnectionResolvers<ContextType>;
  BaseAgreementCountryCountryAggregationSelection?: BaseAgreementCountryCountryAggregationSelectionResolvers<ContextType>;
  BaseAgreementCountryCountryNodeAggregateSelection?: BaseAgreementCountryCountryNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementCountryRelationship?: BaseAgreementCountryRelationshipResolvers<ContextType>;
  BaseAgreementCurrencyConnection?: BaseAgreementCurrencyConnectionResolvers<ContextType>;
  BaseAgreementCurrencyCurrencyAggregationSelection?: BaseAgreementCurrencyCurrencyAggregationSelectionResolvers<ContextType>;
  BaseAgreementCurrencyCurrencyNodeAggregateSelection?: BaseAgreementCurrencyCurrencyNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementCurrencyRelationship?: BaseAgreementCurrencyRelationshipResolvers<ContextType>;
  BaseAgreementCycleConfigurationCyclesAggregationSelection?: BaseAgreementCycleConfigurationCyclesAggregationSelectionResolvers<ContextType>;
  BaseAgreementCycleConfigurationCyclesNodeAggregateSelection?: BaseAgreementCycleConfigurationCyclesNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementCyclesConnection?: BaseAgreementCyclesConnectionResolvers<ContextType>;
  BaseAgreementCyclesRelationship?: BaseAgreementCyclesRelationshipResolvers<ContextType>;
  BaseAgreementDataContainerDataContainersAggregationSelection?: BaseAgreementDataContainerDataContainersAggregationSelectionResolvers<ContextType>;
  BaseAgreementDataContainerDataContainersNodeAggregateSelection?: BaseAgreementDataContainerDataContainersNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementDataContainersConnection?: BaseAgreementDataContainersConnectionResolvers<ContextType>;
  BaseAgreementDataContainersRelationship?: BaseAgreementDataContainersRelationshipResolvers<ContextType>;
  BaseAgreementDataSourceConnection?: BaseAgreementDataSourceConnectionResolvers<ContextType>;
  BaseAgreementDataSourceDataSourceAggregationSelection?: BaseAgreementDataSourceDataSourceAggregationSelectionResolvers<ContextType>;
  BaseAgreementDataSourceDataSourceNodeAggregateSelection?: BaseAgreementDataSourceDataSourceNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementDataSourceRelationship?: BaseAgreementDataSourceRelationshipResolvers<ContextType>;
  BaseAgreementDecisionsConnection?: BaseAgreementDecisionsConnectionResolvers<ContextType>;
  BaseAgreementDecisionsRelationship?: BaseAgreementDecisionsRelationshipResolvers<ContextType>;
  BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection?: BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelectionResolvers<ContextType>;
  BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection?: BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementDeviceAlternativeSetsConnection?: BaseAgreementDeviceAlternativeSetsConnectionResolvers<ContextType>;
  BaseAgreementDeviceAlternativeSetsRelationship?: BaseAgreementDeviceAlternativeSetsRelationshipResolvers<ContextType>;
  BaseAgreementDotThresholdsConnection?: BaseAgreementDotThresholdsConnectionResolvers<ContextType>;
  BaseAgreementDotThresholdsRelationship?: BaseAgreementDotThresholdsRelationshipResolvers<ContextType>;
  BaseAgreementEdge?: BaseAgreementEdgeResolvers<ContextType>;
  BaseAgreementEligibilityConditionRelationship?: BaseAgreementEligibilityConditionRelationshipResolvers<ContextType>;
  BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection?: BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelectionResolvers<ContextType>;
  BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection?: BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelectionResolvers<ContextType>;
  BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection?: BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementEligibilityConditionSetsConnection?: BaseAgreementEligibilityConditionSetsConnectionResolvers<ContextType>;
  BaseAgreementEligibilityConditionSetsRelationship?: BaseAgreementEligibilityConditionSetsRelationshipResolvers<ContextType>;
  BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection?: BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelectionResolvers<ContextType>;
  BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection?: BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementEnrollingConditionSetsConnection?: BaseAgreementEnrollingConditionSetsConnectionResolvers<ContextType>;
  BaseAgreementEnrollingConditionSetsRelationship?: BaseAgreementEnrollingConditionSetsRelationshipResolvers<ContextType>;
  BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection?: BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelectionResolvers<ContextType>;
  BaseAgreementEnrollingPeriodsConnection?: BaseAgreementEnrollingPeriodsConnectionResolvers<ContextType>;
  BaseAgreementEnrollingPeriodsRelationship?: BaseAgreementEnrollingPeriodsRelationshipResolvers<ContextType>;
  BaseAgreementFinancialDataPointsConnection?: BaseAgreementFinancialDataPointsConnectionResolvers<ContextType>;
  BaseAgreementFinancialDataPointsRelationship?: BaseAgreementFinancialDataPointsRelationshipResolvers<ContextType>;
  BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection?: BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelectionResolvers<ContextType>;
  BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection?: BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelectionResolvers<ContextType>;
  BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection?: BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementFinancialSummaryConfigConnection?: BaseAgreementFinancialSummaryConfigConnectionResolvers<ContextType>;
  BaseAgreementFinancialSummaryConfigRelationship?: BaseAgreementFinancialSummaryConfigRelationshipResolvers<ContextType>;
  BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection?: BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelectionResolvers<ContextType>;
  BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection?: BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementInitialVersionConnection?: BaseAgreementInitialVersionConnectionResolvers<ContextType>;
  BaseAgreementInitialVersionRelationship?: BaseAgreementInitialVersionRelationshipResolvers<ContextType>;
  BaseAgreementNegotiableAttributesConnection?: BaseAgreementNegotiableAttributesConnectionResolvers<ContextType>;
  BaseAgreementNegotiableAttributesRelationship?: BaseAgreementNegotiableAttributesRelationshipResolvers<ContextType>;
  BaseAgreementNextVersionsConnection?: BaseAgreementNextVersionsConnectionResolvers<ContextType>;
  BaseAgreementNextVersionsRelationship?: BaseAgreementNextVersionsRelationshipResolvers<ContextType>;
  BaseAgreementOrganizationCounterpartiesAggregationSelection?: BaseAgreementOrganizationCounterpartiesAggregationSelectionResolvers<ContextType>;
  BaseAgreementOrganizationCounterpartiesNodeAggregateSelection?: BaseAgreementOrganizationCounterpartiesNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementPushedByConnection?: BaseAgreementPushedByConnectionResolvers<ContextType>;
  BaseAgreementPushedByRelationship?: BaseAgreementPushedByRelationshipResolvers<ContextType>;
  BaseAgreementRangeChartConfigConnection?: BaseAgreementRangeChartConfigConnectionResolvers<ContextType>;
  BaseAgreementRangeChartConfigRelationship?: BaseAgreementRangeChartConfigRelationshipResolvers<ContextType>;
  BaseAgreementScenarioScenariosAggregationSelection?: BaseAgreementScenarioScenariosAggregationSelectionResolvers<ContextType>;
  BaseAgreementScenarioScenariosNodeAggregateSelection?: BaseAgreementScenarioScenariosNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementScenariosConnection?: BaseAgreementScenariosConnectionResolvers<ContextType>;
  BaseAgreementScenariosRelationship?: BaseAgreementScenariosRelationshipResolvers<ContextType>;
  BaseAgreementScenariosRelevantBrandsConnection?: BaseAgreementScenariosRelevantBrandsConnectionResolvers<ContextType>;
  BaseAgreementScenariosRelevantBrandsRelationship?: BaseAgreementScenariosRelevantBrandsRelationshipResolvers<ContextType>;
  BaseAgreementStatusTransitionsConnection?: BaseAgreementStatusTransitionsConnectionResolvers<ContextType>;
  BaseAgreementStatusTransitionsRelationship?: BaseAgreementStatusTransitionsRelationshipResolvers<ContextType>;
  BaseAgreementTagsConnection?: BaseAgreementTagsConnectionResolvers<ContextType>;
  BaseAgreementTagsRelationship?: BaseAgreementTagsRelationshipResolvers<ContextType>;
  BaseAgreementTemplateConnection?: BaseAgreementTemplateConnectionResolvers<ContextType>;
  BaseAgreementTemplateRelationship?: BaseAgreementTemplateRelationshipResolvers<ContextType>;
  BaseAgreementTreatmentPriceRelationship?: BaseAgreementTreatmentPriceRelationshipResolvers<ContextType>;
  BaseAgreementTreatmentPricesConnection?: BaseAgreementTreatmentPricesConnectionResolvers<ContextType>;
  BaseAgreementTreatmentPricesRelationship?: BaseAgreementTreatmentPricesRelationshipResolvers<ContextType>;
  BaseAgreementTreatmentTreatmentPricesAggregationSelection?: BaseAgreementTreatmentTreatmentPricesAggregationSelectionResolvers<ContextType>;
  BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection?: BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelectionResolvers<ContextType>;
  BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection?: BaseAgreementTreatmentTreatmentPricesNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementUserAddedByAggregationSelection?: BaseAgreementUserAddedByAggregationSelectionResolvers<ContextType>;
  BaseAgreementUserAddedByNodeAggregateSelection?: BaseAgreementUserAddedByNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementUserContextUserContextsAggregationSelection?: BaseAgreementUserContextUserContextsAggregationSelectionResolvers<ContextType>;
  BaseAgreementUserContextUserContextsEdgeAggregateSelection?: BaseAgreementUserContextUserContextsEdgeAggregateSelectionResolvers<ContextType>;
  BaseAgreementUserContextUserContextsNodeAggregateSelection?: BaseAgreementUserContextUserContextsNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementUserContextsConnection?: BaseAgreementUserContextsConnectionResolvers<ContextType>;
  BaseAgreementUserContextsRelationship?: BaseAgreementUserContextsRelationshipResolvers<ContextType>;
  BaseAgreementUserPushedByAggregationSelection?: BaseAgreementUserPushedByAggregationSelectionResolvers<ContextType>;
  BaseAgreementUserPushedByNodeAggregateSelection?: BaseAgreementUserPushedByNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementUserRoleRelationship?: BaseAgreementUserRoleRelationshipResolvers<ContextType>;
  BaseAgreementUserRolesConnection?: BaseAgreementUserRolesConnectionResolvers<ContextType>;
  BaseAgreementUserRolesRelationship?: BaseAgreementUserRolesRelationshipResolvers<ContextType>;
  BaseAgreementUserUserRolesAggregationSelection?: BaseAgreementUserUserRolesAggregationSelectionResolvers<ContextType>;
  BaseAgreementUserUserRolesNodeAggregateSelection?: BaseAgreementUserUserRolesNodeAggregateSelectionResolvers<ContextType>;
  BaseAgreementsConnection?: BaseAgreementsConnectionResolvers<ContextType>;
  Brand?: BrandResolvers<ContextType>;
  BrandArt71DataLastUpdatedByConnection?: BrandArt71DataLastUpdatedByConnectionResolvers<ContextType>;
  BrandArt71DataLastUpdatedByRelationship?: BrandArt71DataLastUpdatedByRelationshipResolvers<ContextType>;
  BrandArticle71IndicationArticle71IndicationsAggregationSelection?: BrandArticle71IndicationArticle71IndicationsAggregationSelectionResolvers<ContextType>;
  BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection?: BrandArticle71IndicationArticle71IndicationsNodeAggregateSelectionResolvers<ContextType>;
  BrandArticle71IndicationsConnection?: BrandArticle71IndicationsConnectionResolvers<ContextType>;
  BrandArticle71IndicationsRelationship?: BrandArticle71IndicationsRelationshipResolvers<ContextType>;
  BrandEdge?: BrandEdgeResolvers<ContextType>;
  BrandMainIndicationMainIndicationsAggregationSelection?: BrandMainIndicationMainIndicationsAggregationSelectionResolvers<ContextType>;
  BrandMainIndicationMainIndicationsNodeAggregateSelection?: BrandMainIndicationMainIndicationsNodeAggregateSelectionResolvers<ContextType>;
  BrandMainIndicationsConnection?: BrandMainIndicationsConnectionResolvers<ContextType>;
  BrandMainIndicationsRelationship?: BrandMainIndicationsRelationshipResolvers<ContextType>;
  BrandPreparationPreparationsAggregationSelection?: BrandPreparationPreparationsAggregationSelectionResolvers<ContextType>;
  BrandPreparationPreparationsNodeAggregateSelection?: BrandPreparationPreparationsNodeAggregateSelectionResolvers<ContextType>;
  BrandPreparationsConnection?: BrandPreparationsConnectionResolvers<ContextType>;
  BrandPreparationsRelationship?: BrandPreparationsRelationshipResolvers<ContextType>;
  BrandUserArt71DataLastUpdatedByAggregationSelection?: BrandUserArt71DataLastUpdatedByAggregationSelectionResolvers<ContextType>;
  BrandUserArt71DataLastUpdatedByNodeAggregateSelection?: BrandUserArt71DataLastUpdatedByNodeAggregateSelectionResolvers<ContextType>;
  BrandsConnection?: BrandsConnectionResolvers<ContextType>;
  CachedAgreementListItem?: CachedAgreementListItemResolvers<ContextType>;
  CachedAgreementListItemEdge?: CachedAgreementListItemEdgeResolvers<ContextType>;
  CachedAgreementListItemsConnection?: CachedAgreementListItemsConnectionResolvers<ContextType>;
  Case?: CaseResolvers<ContextType>;
  CaseAgreementBaseAgreementAggregationSelection?: CaseAgreementBaseAgreementAggregationSelectionResolvers<ContextType>;
  CaseAgreementBaseAgreementNodeAggregateSelection?: CaseAgreementBaseAgreementNodeAggregateSelectionResolvers<ContextType>;
  CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection?: CaseArticle71IndicationRelevantArticle71IndicationAggregationSelectionResolvers<ContextType>;
  CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection?: CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelectionResolvers<ContextType>;
  CaseBaseAgreementConnection?: CaseBaseAgreementConnectionResolvers<ContextType>;
  CaseBaseAgreementRelationship?: CaseBaseAgreementRelationshipResolvers<ContextType>;
  CaseEdge?: CaseEdgeResolvers<ContextType>;
  CaseFinancialDataPointsConnection?: CaseFinancialDataPointsConnectionResolvers<ContextType>;
  CaseFinancialDataPointsRelationship?: CaseFinancialDataPointsRelationshipResolvers<ContextType>;
  CaseFlexEntitiesConnection?: CaseFlexEntitiesConnectionResolvers<ContextType>;
  CaseFlexEntitiesRelationship?: CaseFlexEntitiesRelationshipResolvers<ContextType>;
  CaseFlexEntityFlexEntitiesAggregationSelection?: CaseFlexEntityFlexEntitiesAggregationSelectionResolvers<ContextType>;
  CaseFlexEntityFlexEntitiesNodeAggregateSelection?: CaseFlexEntityFlexEntitiesNodeAggregateSelectionResolvers<ContextType>;
  CaseFlexEntityRelationship?: CaseFlexEntityRelationshipResolvers<ContextType>;
  CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection?: CaseFlexFinancialDataPointFinancialDataPointsAggregationSelectionResolvers<ContextType>;
  CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection?: CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelectionResolvers<ContextType>;
  CaseNegotiationRoundNegotiationRoundsAggregationSelection?: CaseNegotiationRoundNegotiationRoundsAggregationSelectionResolvers<ContextType>;
  CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection?: CaseNegotiationRoundNegotiationRoundsNodeAggregateSelectionResolvers<ContextType>;
  CaseNegotiationRoundsConnection?: CaseNegotiationRoundsConnectionResolvers<ContextType>;
  CaseNegotiationRoundsRelationship?: CaseNegotiationRoundsRelationshipResolvers<ContextType>;
  CaseRefundRefundsAggregationSelection?: CaseRefundRefundsAggregationSelectionResolvers<ContextType>;
  CaseRefundRefundsNodeAggregateSelection?: CaseRefundRefundsNodeAggregateSelectionResolvers<ContextType>;
  CaseRefundsConnection?: CaseRefundsConnectionResolvers<ContextType>;
  CaseRefundsRelationship?: CaseRefundsRelationshipResolvers<ContextType>;
  CaseRelevantArticle71IndicationConnection?: CaseRelevantArticle71IndicationConnectionResolvers<ContextType>;
  CaseRelevantArticle71IndicationRelationship?: CaseRelevantArticle71IndicationRelationshipResolvers<ContextType>;
  CasesConnection?: CasesConnectionResolvers<ContextType>;
  CatalogueAttribute?: CatalogueAttributeResolvers<ContextType>;
  CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection?: CatalogueAttributeCatalogueAttributeDependsOnAggregationSelectionResolvers<ContextType>;
  CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection?: CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelectionResolvers<ContextType>;
  CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection?: CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelectionResolvers<ContextType>;
  CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection?: CatalogueAttributeCatalogueAttributeHasDependantAggregationSelectionResolvers<ContextType>;
  CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection?: CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelectionResolvers<ContextType>;
  CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection?: CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelectionResolvers<ContextType>;
  CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection?: CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelectionResolvers<ContextType>;
  CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection?: CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelectionResolvers<ContextType>;
  CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection?: CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelectionResolvers<ContextType>;
  CatalogueAttributeCustomConditionConnection?: CatalogueAttributeCustomConditionConnectionResolvers<ContextType>;
  CatalogueAttributeCustomConditionCustomConditionAggregationSelection?: CatalogueAttributeCustomConditionCustomConditionAggregationSelectionResolvers<ContextType>;
  CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection?: CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelectionResolvers<ContextType>;
  CatalogueAttributeCustomConditionRelationship?: CatalogueAttributeCustomConditionRelationshipResolvers<ContextType>;
  CatalogueAttributeDependsOnConnection?: CatalogueAttributeDependsOnConnectionResolvers<ContextType>;
  CatalogueAttributeDependsOnRelationship?: CatalogueAttributeDependsOnRelationshipResolvers<ContextType>;
  CatalogueAttributeEdge?: CatalogueAttributeEdgeResolvers<ContextType>;
  CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection?: CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelectionResolvers<ContextType>;
  CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection?: CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelectionResolvers<ContextType>;
  CatalogueAttributeFlexEntityTypesConnection?: CatalogueAttributeFlexEntityTypesConnectionResolvers<ContextType>;
  CatalogueAttributeFlexEntityTypesRelationship?: CatalogueAttributeFlexEntityTypesRelationshipResolvers<ContextType>;
  CatalogueAttributeHasDependantConnection?: CatalogueAttributeHasDependantConnectionResolvers<ContextType>;
  CatalogueAttributeHasDependantRelationship?: CatalogueAttributeHasDependantRelationshipResolvers<ContextType>;
  CatalogueAttributeMutuallyRelevantConnection?: CatalogueAttributeMutuallyRelevantConnectionResolvers<ContextType>;
  CatalogueAttributeMutuallyRelevantRelationship?: CatalogueAttributeMutuallyRelevantRelationshipResolvers<ContextType>;
  CatalogueAttributesConnection?: CatalogueAttributesConnectionResolvers<ContextType>;
  ChartRangeConfiguration?: ChartRangeConfigurationResolvers<ContextType>;
  ChartRangeConfigurationEdge?: ChartRangeConfigurationEdgeResolvers<ContextType>;
  ChartRangeConfigurationRelationship?: ChartRangeConfigurationRelationshipResolvers<ContextType>;
  ChartRangeConfigurationsConnection?: ChartRangeConfigurationsConnectionResolvers<ContextType>;
  CheckedType?: CheckedTypeResolvers<ContextType>;
  CheckedTypeEdge?: CheckedTypeEdgeResolvers<ContextType>;
  CheckedTypesConnection?: CheckedTypesConnectionResolvers<ContextType>;
  ClusterWorkerMetric?: ClusterWorkerMetricResolvers<ContextType>;
  ClusterWorkerMetricEdge?: ClusterWorkerMetricEdgeResolvers<ContextType>;
  ClusterWorkerMetricsConnection?: ClusterWorkerMetricsConnectionResolvers<ContextType>;
  ClusterWorkersSnapshot?: ClusterWorkersSnapshotResolvers<ContextType>;
  ClusterWorkersSnapshotEdge?: ClusterWorkersSnapshotEdgeResolvers<ContextType>;
  ClusterWorkersSnapshotsConnection?: ClusterWorkersSnapshotsConnectionResolvers<ContextType>;
  Config?: ConfigResolvers<ContextType>;
  ConfigEdge?: ConfigEdgeResolvers<ContextType>;
  ConfigsConnection?: ConfigsConnectionResolvers<ContextType>;
  CosmosMetric?: CosmosMetricResolvers<ContextType>;
  CosmosMetricEdge?: CosmosMetricEdgeResolvers<ContextType>;
  CosmosMetricsConnection?: CosmosMetricsConnectionResolvers<ContextType>;
  CountriesConnection?: CountriesConnectionResolvers<ContextType>;
  Country?: CountryResolvers<ContextType>;
  CountryAgreementScopeScopesAggregationSelection?: CountryAgreementScopeScopesAggregationSelectionResolvers<ContextType>;
  CountryAgreementScopeScopesEdgeAggregateSelection?: CountryAgreementScopeScopesEdgeAggregateSelectionResolvers<ContextType>;
  CountryAgreementScopeScopesNodeAggregateSelection?: CountryAgreementScopeScopesNodeAggregateSelectionResolvers<ContextType>;
  CountryCurrenciesConnection?: CountryCurrenciesConnectionResolvers<ContextType>;
  CountryCurrenciesRelationship?: CountryCurrenciesRelationshipResolvers<ContextType>;
  CountryCurrencyCurrenciesAggregationSelection?: CountryCurrencyCurrenciesAggregationSelectionResolvers<ContextType>;
  CountryCurrencyCurrenciesNodeAggregateSelection?: CountryCurrencyCurrenciesNodeAggregateSelectionResolvers<ContextType>;
  CountryEdge?: CountryEdgeResolvers<ContextType>;
  CountryOrganizationOrganizationsAggregationSelection?: CountryOrganizationOrganizationsAggregationSelectionResolvers<ContextType>;
  CountryOrganizationOrganizationsNodeAggregateSelection?: CountryOrganizationOrganizationsNodeAggregateSelectionResolvers<ContextType>;
  CountryOrganizationsConnection?: CountryOrganizationsConnectionResolvers<ContextType>;
  CountryOrganizationsRelationship?: CountryOrganizationsRelationshipResolvers<ContextType>;
  CountryScopeRelationship?: CountryScopeRelationshipResolvers<ContextType>;
  CountryScopesConnection?: CountryScopesConnectionResolvers<ContextType>;
  CountryScopesRelationship?: CountryScopesRelationshipResolvers<ContextType>;
  CountryTreatmentTreatmentsAggregationSelection?: CountryTreatmentTreatmentsAggregationSelectionResolvers<ContextType>;
  CountryTreatmentTreatmentsNodeAggregateSelection?: CountryTreatmentTreatmentsNodeAggregateSelectionResolvers<ContextType>;
  CountryTreatmentsConnection?: CountryTreatmentsConnectionResolvers<ContextType>;
  CountryTreatmentsRelationship?: CountryTreatmentsRelationshipResolvers<ContextType>;
  CrossCountryPrice?: CrossCountryPriceResolvers<ContextType>;
  CrossCountryPriceEdge?: CrossCountryPriceEdgeResolvers<ContextType>;
  CrossCountryPricesConnection?: CrossCountryPricesConnectionResolvers<ContextType>;
  CurrenciesConnection?: CurrenciesConnectionResolvers<ContextType>;
  Currency?: CurrencyResolvers<ContextType>;
  CurrencyAgreementAgreementsAggregationSelection?: CurrencyAgreementAgreementsAggregationSelectionResolvers<ContextType>;
  CurrencyAgreementAgreementsNodeAggregateSelection?: CurrencyAgreementAgreementsNodeAggregateSelectionResolvers<ContextType>;
  CurrencyAgreementsConnection?: CurrencyAgreementsConnectionResolvers<ContextType>;
  CurrencyAgreementsRelationship?: CurrencyAgreementsRelationshipResolvers<ContextType>;
  CurrencyCountriesConnection?: CurrencyCountriesConnectionResolvers<ContextType>;
  CurrencyCountriesRelationship?: CurrencyCountriesRelationshipResolvers<ContextType>;
  CurrencyCountryCountriesAggregationSelection?: CurrencyCountryCountriesAggregationSelectionResolvers<ContextType>;
  CurrencyCountryCountriesNodeAggregateSelection?: CurrencyCountryCountriesNodeAggregateSelectionResolvers<ContextType>;
  CurrencyEdge?: CurrencyEdgeResolvers<ContextType>;
  CurrencyPricePricesAggregationSelection?: CurrencyPricePricesAggregationSelectionResolvers<ContextType>;
  CurrencyPricePricesNodeAggregateSelection?: CurrencyPricePricesNodeAggregateSelectionResolvers<ContextType>;
  CurrencyPricesConnection?: CurrencyPricesConnectionResolvers<ContextType>;
  CurrencyPricesRelationship?: CurrencyPricesRelationshipResolvers<ContextType>;
  CustomCondition?: CustomConditionResolvers<ContextType>;
  CustomConditionAttributeConnection?: CustomConditionAttributeConnectionResolvers<ContextType>;
  CustomConditionAttributeRelationship?: CustomConditionAttributeRelationshipResolvers<ContextType>;
  CustomConditionCatalogueAttributeAttributeAggregationSelection?: CustomConditionCatalogueAttributeAttributeAggregationSelectionResolvers<ContextType>;
  CustomConditionCatalogueAttributeAttributeNodeAggregateSelection?: CustomConditionCatalogueAttributeAttributeNodeAggregateSelectionResolvers<ContextType>;
  CustomConditionCreatedByConnection?: CustomConditionCreatedByConnectionResolvers<ContextType>;
  CustomConditionCreatedByRelationship?: CustomConditionCreatedByRelationshipResolvers<ContextType>;
  CustomConditionEdge?: CustomConditionEdgeResolvers<ContextType>;
  CustomConditionUserCreatedByAggregationSelection?: CustomConditionUserCreatedByAggregationSelectionResolvers<ContextType>;
  CustomConditionUserCreatedByNodeAggregateSelection?: CustomConditionUserCreatedByNodeAggregateSelectionResolvers<ContextType>;
  CustomConditionsConnection?: CustomConditionsConnectionResolvers<ContextType>;
  CustomIntegrityCheck?: CustomIntegrityCheckResolvers<ContextType>;
  CustomIntegrityCheckEdge?: CustomIntegrityCheckEdgeResolvers<ContextType>;
  CustomIntegrityChecksConnection?: CustomIntegrityChecksConnectionResolvers<ContextType>;
  CycleConfiguration?: CycleConfigurationResolvers<ContextType>;
  CycleConfigurationAgreementScopeScopeAggregationSelection?: CycleConfigurationAgreementScopeScopeAggregationSelectionResolvers<ContextType>;
  CycleConfigurationAgreementScopeScopeNodeAggregateSelection?: CycleConfigurationAgreementScopeScopeNodeAggregateSelectionResolvers<ContextType>;
  CycleConfigurationBrandStartingTreatmentBrandAggregationSelection?: CycleConfigurationBrandStartingTreatmentBrandAggregationSelectionResolvers<ContextType>;
  CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection?: CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelectionResolvers<ContextType>;
  CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection?: CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelectionResolvers<ContextType>;
  CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection?: CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelectionResolvers<ContextType>;
  CycleConfigurationEdge?: CycleConfigurationEdgeResolvers<ContextType>;
  CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection?: CycleConfigurationFlexEntityTypeRecordTypeAggregationSelectionResolvers<ContextType>;
  CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection?: CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelectionResolvers<ContextType>;
  CycleConfigurationGenericStartingTreatmentGenericAggregationSelection?: CycleConfigurationGenericStartingTreatmentGenericAggregationSelectionResolvers<ContextType>;
  CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection?: CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelectionResolvers<ContextType>;
  CycleConfigurationRecordTypeConnection?: CycleConfigurationRecordTypeConnectionResolvers<ContextType>;
  CycleConfigurationRecordTypeRelationship?: CycleConfigurationRecordTypeRelationshipResolvers<ContextType>;
  CycleConfigurationScopeConnection?: CycleConfigurationScopeConnectionResolvers<ContextType>;
  CycleConfigurationScopeRelationship?: CycleConfigurationScopeRelationshipResolvers<ContextType>;
  CycleConfigurationStartingTreatmentBrandConnection?: CycleConfigurationStartingTreatmentBrandConnectionResolvers<ContextType>;
  CycleConfigurationStartingTreatmentBrandRelationship?: CycleConfigurationStartingTreatmentBrandRelationshipResolvers<ContextType>;
  CycleConfigurationStartingTreatmentConnection?: CycleConfigurationStartingTreatmentConnectionResolvers<ContextType>;
  CycleConfigurationStartingTreatmentGenericConnection?: CycleConfigurationStartingTreatmentGenericConnectionResolvers<ContextType>;
  CycleConfigurationStartingTreatmentGenericRelationship?: CycleConfigurationStartingTreatmentGenericRelationshipResolvers<ContextType>;
  CycleConfigurationStartingTreatmentRelationship?: CycleConfigurationStartingTreatmentRelationshipResolvers<ContextType>;
  CycleConfigurationTherapiesConnection?: CycleConfigurationTherapiesConnectionResolvers<ContextType>;
  CycleConfigurationTherapiesRelationship?: CycleConfigurationTherapiesRelationshipResolvers<ContextType>;
  CycleConfigurationTreatmentStartingTreatmentAggregationSelection?: CycleConfigurationTreatmentStartingTreatmentAggregationSelectionResolvers<ContextType>;
  CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection?: CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelectionResolvers<ContextType>;
  CycleConfigurationsConnection?: CycleConfigurationsConnectionResolvers<ContextType>;
  CycleTherapyConfiguration?: CycleTherapyConfigurationResolvers<ContextType>;
  CycleTherapyConfigurationEdge?: CycleTherapyConfigurationEdgeResolvers<ContextType>;
  CycleTherapyConfigurationTreatmentSetConnection?: CycleTherapyConfigurationTreatmentSetConnectionResolvers<ContextType>;
  CycleTherapyConfigurationTreatmentSetRelationship?: CycleTherapyConfigurationTreatmentSetRelationshipResolvers<ContextType>;
  CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection?: CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelectionResolvers<ContextType>;
  CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection?: CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelectionResolvers<ContextType>;
  CycleTherapyConfigurationsConnection?: CycleTherapyConfigurationsConnectionResolvers<ContextType>;
  DQCDetailedReportRaw?: DqcDetailedReportRawResolvers<ContextType>;
  DQCDetailedReportRawEdge?: DqcDetailedReportRawEdgeResolvers<ContextType>;
  DataContainer?: DataContainerResolvers<ContextType>;
  DataContainerEdge?: DataContainerEdgeResolvers<ContextType>;
  DataContainerOrganizationProvidersAggregationSelection?: DataContainerOrganizationProvidersAggregationSelectionResolvers<ContextType>;
  DataContainerOrganizationProvidersNodeAggregateSelection?: DataContainerOrganizationProvidersNodeAggregateSelectionResolvers<ContextType>;
  DataContainerProvidersConnection?: DataContainerProvidersConnectionResolvers<ContextType>;
  DataContainerProvidersRelationship?: DataContainerProvidersRelationshipResolvers<ContextType>;
  DataContainersConnection?: DataContainersConnectionResolvers<ContextType>;
  DataSource?: DataSourceResolvers<ContextType>;
  DataSourceEdge?: DataSourceEdgeResolvers<ContextType>;
  DataSourcesConnection?: DataSourcesConnectionResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  DateTimeAggregateSelectionNonNullable?: DateTimeAggregateSelectionNonNullableResolvers<ContextType>;
  DateTimeAggregateSelectionNullable?: DateTimeAggregateSelectionNullableResolvers<ContextType>;
  DefaultAgreementRoleInfo?: DefaultAgreementRoleInfoResolvers<ContextType>;
  DefaultAgreementRoleInfoEdge?: DefaultAgreementRoleInfoEdgeResolvers<ContextType>;
  DefaultAgreementRoleInfosConnection?: DefaultAgreementRoleInfosConnectionResolvers<ContextType>;
  DefaultReceiverProperties?: DefaultReceiverPropertiesResolvers<ContextType>;
  DependencyAttribute?: DependencyAttributeResolvers<ContextType>;
  DeviceAlternative?: DeviceAlternativeResolvers<ContextType>;
  DeviceAlternativeAlternativesConnection?: DeviceAlternativeAlternativesConnectionResolvers<ContextType>;
  DeviceAlternativeAlternativesRelationship?: DeviceAlternativeAlternativesRelationshipResolvers<ContextType>;
  DeviceAlternativeDeviceProductConnection?: DeviceAlternativeDeviceProductConnectionResolvers<ContextType>;
  DeviceAlternativeDeviceProductRelationship?: DeviceAlternativeDeviceProductRelationshipResolvers<ContextType>;
  DeviceAlternativeEdge?: DeviceAlternativeEdgeResolvers<ContextType>;
  DeviceAlternativeTreatmentAlternativesAggregationSelection?: DeviceAlternativeTreatmentAlternativesAggregationSelectionResolvers<ContextType>;
  DeviceAlternativeTreatmentAlternativesNodeAggregateSelection?: DeviceAlternativeTreatmentAlternativesNodeAggregateSelectionResolvers<ContextType>;
  DeviceAlternativeTreatmentDeviceProductAggregationSelection?: DeviceAlternativeTreatmentDeviceProductAggregationSelectionResolvers<ContextType>;
  DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection?: DeviceAlternativeTreatmentDeviceProductNodeAggregateSelectionResolvers<ContextType>;
  DeviceAlternativesConnection?: DeviceAlternativesConnectionResolvers<ContextType>;
  DisabledDataCheck?: DisabledDataCheckResolvers<ContextType>;
  DisabledDataCheckEdge?: DisabledDataCheckEdgeResolvers<ContextType>;
  DisabledDataChecksConnection?: DisabledDataChecksConnectionResolvers<ContextType>;
  Disease?: DiseaseResolvers<ContextType>;
  DiseaseEdge?: DiseaseEdgeResolvers<ContextType>;
  DiseasesConnection?: DiseasesConnectionResolvers<ContextType>;
  Document?: DocumentResolvers<ContextType>;
  DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection?: DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelectionResolvers<ContextType>;
  DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection?: DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelectionResolvers<ContextType>;
  DocumentDocumentRefundGroupsConnection?: DocumentDocumentRefundGroupsConnectionResolvers<ContextType>;
  DocumentDocumentRefundGroupsRelationship?: DocumentDocumentRefundGroupsRelationshipResolvers<ContextType>;
  DocumentEdge?: DocumentEdgeResolvers<ContextType>;
  DocumentRefundFinancialDataPoint?: DocumentRefundFinancialDataPointResolvers<ContextType>;
  DocumentRefundGroup?: DocumentRefundGroupResolvers<ContextType>;
  DocumentRefundGroupAgreementAgreementAggregationSelection?: DocumentRefundGroupAgreementAgreementAggregationSelectionResolvers<ContextType>;
  DocumentRefundGroupAgreementAgreementNodeAggregateSelection?: DocumentRefundGroupAgreementAgreementNodeAggregateSelectionResolvers<ContextType>;
  DocumentRefundGroupAgreementConnection?: DocumentRefundGroupAgreementConnectionResolvers<ContextType>;
  DocumentRefundGroupAgreementRelationship?: DocumentRefundGroupAgreementRelationshipResolvers<ContextType>;
  DocumentRefundGroupCaseCaseAggregationSelection?: DocumentRefundGroupCaseCaseAggregationSelectionResolvers<ContextType>;
  DocumentRefundGroupCaseCaseNodeAggregateSelection?: DocumentRefundGroupCaseCaseNodeAggregateSelectionResolvers<ContextType>;
  DocumentRefundGroupCaseConnection?: DocumentRefundGroupCaseConnectionResolvers<ContextType>;
  DocumentRefundGroupCaseRelationship?: DocumentRefundGroupCaseRelationshipResolvers<ContextType>;
  DocumentRefundGroupDocumentConnection?: DocumentRefundGroupDocumentConnectionResolvers<ContextType>;
  DocumentRefundGroupDocumentDocumentAggregationSelection?: DocumentRefundGroupDocumentDocumentAggregationSelectionResolvers<ContextType>;
  DocumentRefundGroupDocumentDocumentNodeAggregateSelection?: DocumentRefundGroupDocumentDocumentNodeAggregateSelectionResolvers<ContextType>;
  DocumentRefundGroupDocumentRelationship?: DocumentRefundGroupDocumentRelationshipResolvers<ContextType>;
  DocumentRefundGroupEdge?: DocumentRefundGroupEdgeResolvers<ContextType>;
  DocumentRefundGroupMessageConnection?: DocumentRefundGroupMessageConnectionResolvers<ContextType>;
  DocumentRefundGroupMessageMessageAggregationSelection?: DocumentRefundGroupMessageMessageAggregationSelectionResolvers<ContextType>;
  DocumentRefundGroupMessageMessageNodeAggregateSelection?: DocumentRefundGroupMessageMessageNodeAggregateSelectionResolvers<ContextType>;
  DocumentRefundGroupMessageRelationship?: DocumentRefundGroupMessageRelationshipResolvers<ContextType>;
  DocumentRefundGroupRefundRefundsAggregationSelection?: DocumentRefundGroupRefundRefundsAggregationSelectionResolvers<ContextType>;
  DocumentRefundGroupRefundRefundsNodeAggregateSelection?: DocumentRefundGroupRefundRefundsNodeAggregateSelectionResolvers<ContextType>;
  DocumentRefundGroupRefundsConnection?: DocumentRefundGroupRefundsConnectionResolvers<ContextType>;
  DocumentRefundGroupRefundsRelationship?: DocumentRefundGroupRefundsRelationshipResolvers<ContextType>;
  DocumentRefundGroupsConnection?: DocumentRefundGroupsConnectionResolvers<ContextType>;
  DocumentRefundRefundsAggregationSelection?: DocumentRefundRefundsAggregationSelectionResolvers<ContextType>;
  DocumentRefundRefundsNodeAggregateSelection?: DocumentRefundRefundsNodeAggregateSelectionResolvers<ContextType>;
  DocumentRefundsConnection?: DocumentRefundsConnectionResolvers<ContextType>;
  DocumentRefundsRelationship?: DocumentRefundsRelationshipResolvers<ContextType>;
  DocumentsConnection?: DocumentsConnectionResolvers<ContextType>;
  Domain?: DomainResolvers<ContextType>;
  DomainChildrenConnection?: DomainChildrenConnectionResolvers<ContextType>;
  DomainChildrenRelationship?: DomainChildrenRelationshipResolvers<ContextType>;
  DomainCreatedByConnection?: DomainCreatedByConnectionResolvers<ContextType>;
  DomainCreatedByRelationship?: DomainCreatedByRelationshipResolvers<ContextType>;
  DomainDomainChildrenAggregationSelection?: DomainDomainChildrenAggregationSelectionResolvers<ContextType>;
  DomainDomainChildrenNodeAggregateSelection?: DomainDomainChildrenNodeAggregateSelectionResolvers<ContextType>;
  DomainDomainParentAggregationSelection?: DomainDomainParentAggregationSelectionResolvers<ContextType>;
  DomainDomainParentNodeAggregateSelection?: DomainDomainParentNodeAggregateSelectionResolvers<ContextType>;
  DomainEdge?: DomainEdgeResolvers<ContextType>;
  DomainParentConnection?: DomainParentConnectionResolvers<ContextType>;
  DomainParentRelationship?: DomainParentRelationshipResolvers<ContextType>;
  DomainProductBlueprintConnection?: DomainProductBlueprintConnectionResolvers<ContextType>;
  DomainProductBlueprintProductBlueprintAggregationSelection?: DomainProductBlueprintProductBlueprintAggregationSelectionResolvers<ContextType>;
  DomainProductBlueprintProductBlueprintNodeAggregateSelection?: DomainProductBlueprintProductBlueprintNodeAggregateSelectionResolvers<ContextType>;
  DomainProductBlueprintRelationship?: DomainProductBlueprintRelationshipResolvers<ContextType>;
  DomainSimulationSimulationsAggregationSelection?: DomainSimulationSimulationsAggregationSelectionResolvers<ContextType>;
  DomainSimulationSimulationsNodeAggregateSelection?: DomainSimulationSimulationsNodeAggregateSelectionResolvers<ContextType>;
  DomainSimulationsConnection?: DomainSimulationsConnectionResolvers<ContextType>;
  DomainSimulationsRelationship?: DomainSimulationsRelationshipResolvers<ContextType>;
  DomainUserCreatedByAggregationSelection?: DomainUserCreatedByAggregationSelectionResolvers<ContextType>;
  DomainUserCreatedByNodeAggregateSelection?: DomainUserCreatedByNodeAggregateSelectionResolvers<ContextType>;
  DomainUserUsersAggregationSelection?: DomainUserUsersAggregationSelectionResolvers<ContextType>;
  DomainUserUsersNodeAggregateSelection?: DomainUserUsersNodeAggregateSelectionResolvers<ContextType>;
  DomainUsersConnection?: DomainUsersConnectionResolvers<ContextType>;
  DomainUsersRelationship?: DomainUsersRelationshipResolvers<ContextType>;
  DomainsConnection?: DomainsConnectionResolvers<ContextType>;
  DqcDetailedReportRawsConnection?: DqcDetailedReportRawsConnectionResolvers<ContextType>;
  DummyEnumReferences?: DummyEnumReferencesResolvers<ContextType>;
  DummyEnumReferencesConnection?: DummyEnumReferencesConnectionResolvers<ContextType>;
  DummyEnumReferencesEdge?: DummyEnumReferencesEdgeResolvers<ContextType>;
  EligibilityConditionSet?: EligibilityConditionSetResolvers<ContextType>;
  EligibilityConditionSetEdge?: EligibilityConditionSetEdgeResolvers<ContextType>;
  EligibilityConditionSetTreatmentTreatmentsAggregationSelection?: EligibilityConditionSetTreatmentTreatmentsAggregationSelectionResolvers<ContextType>;
  EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection?: EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelectionResolvers<ContextType>;
  EligibilityConditionSetTreatmentsConnection?: EligibilityConditionSetTreatmentsConnectionResolvers<ContextType>;
  EligibilityConditionSetTreatmentsRelationship?: EligibilityConditionSetTreatmentsRelationshipResolvers<ContextType>;
  EligibilityConditionSetsConnection?: EligibilityConditionSetsConnectionResolvers<ContextType>;
  EncapsulatedFeature?: EncapsulatedFeatureResolvers<ContextType>;
  EncapsulatedFeatureConfiguration?: EncapsulatedFeatureConfigurationResolvers<ContextType>;
  EncapsulatedFeatureConfigurationEdge?: EncapsulatedFeatureConfigurationEdgeResolvers<ContextType>;
  EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection?: EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelectionResolvers<ContextType>;
  EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection?: EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelectionResolvers<ContextType>;
  EncapsulatedFeatureConfigurationOfTypeConnection?: EncapsulatedFeatureConfigurationOfTypeConnectionResolvers<ContextType>;
  EncapsulatedFeatureConfigurationOfTypeRelationship?: EncapsulatedFeatureConfigurationOfTypeRelationshipResolvers<ContextType>;
  EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection?: EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelectionResolvers<ContextType>;
  EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection?: EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelectionResolvers<ContextType>;
  EncapsulatedFeatureConfigurationSetForConnection?: EncapsulatedFeatureConfigurationSetForConnectionResolvers<ContextType>;
  EncapsulatedFeatureConfigurationSetForRelationship?: EncapsulatedFeatureConfigurationSetForRelationshipResolvers<ContextType>;
  EncapsulatedFeatureConfigurationsConnection?: EncapsulatedFeatureConfigurationsConnectionResolvers<ContextType>;
  EncapsulatedFeatureEdge?: EncapsulatedFeatureEdgeResolvers<ContextType>;
  EncapsulatedFeaturesConnection?: EncapsulatedFeaturesConnectionResolvers<ContextType>;
  EnrollingCondition?: EnrollingConditionResolvers<ContextType>;
  EnrollingConditionCustomConditionConnection?: EnrollingConditionCustomConditionConnectionResolvers<ContextType>;
  EnrollingConditionCustomConditionCustomConditionAggregationSelection?: EnrollingConditionCustomConditionCustomConditionAggregationSelectionResolvers<ContextType>;
  EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection?: EnrollingConditionCustomConditionCustomConditionNodeAggregateSelectionResolvers<ContextType>;
  EnrollingConditionCustomConditionRelationship?: EnrollingConditionCustomConditionRelationshipResolvers<ContextType>;
  EnrollingConditionDiseaseRelationship?: EnrollingConditionDiseaseRelationshipResolvers<ContextType>;
  EnrollingConditionEdge?: EnrollingConditionEdgeResolvers<ContextType>;
  EnrollingConditionGenericIncludedGenericsAggregationSelection?: EnrollingConditionGenericIncludedGenericsAggregationSelectionResolvers<ContextType>;
  EnrollingConditionGenericIncludedGenericsNodeAggregateSelection?: EnrollingConditionGenericIncludedGenericsNodeAggregateSelectionResolvers<ContextType>;
  EnrollingConditionIncludedGenericsConnection?: EnrollingConditionIncludedGenericsConnectionResolvers<ContextType>;
  EnrollingConditionIncludedGenericsRelationship?: EnrollingConditionIncludedGenericsRelationshipResolvers<ContextType>;
  EnrollingConditionSet?: EnrollingConditionSetResolvers<ContextType>;
  EnrollingConditionSetAgreementAgreementAggregationSelection?: EnrollingConditionSetAgreementAgreementAggregationSelectionResolvers<ContextType>;
  EnrollingConditionSetAgreementAgreementNodeAggregateSelection?: EnrollingConditionSetAgreementAgreementNodeAggregateSelectionResolvers<ContextType>;
  EnrollingConditionSetAgreementConnection?: EnrollingConditionSetAgreementConnectionResolvers<ContextType>;
  EnrollingConditionSetAgreementRelationship?: EnrollingConditionSetAgreementRelationshipResolvers<ContextType>;
  EnrollingConditionSetAgreementScopeScopesAggregationSelection?: EnrollingConditionSetAgreementScopeScopesAggregationSelectionResolvers<ContextType>;
  EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection?: EnrollingConditionSetAgreementScopeScopesNodeAggregateSelectionResolvers<ContextType>;
  EnrollingConditionSetAgreementTemplateTemplateAggregationSelection?: EnrollingConditionSetAgreementTemplateTemplateAggregationSelectionResolvers<ContextType>;
  EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection?: EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelectionResolvers<ContextType>;
  EnrollingConditionSetConditionsConnection?: EnrollingConditionSetConditionsConnectionResolvers<ContextType>;
  EnrollingConditionSetConditionsRelationship?: EnrollingConditionSetConditionsRelationshipResolvers<ContextType>;
  EnrollingConditionSetEdge?: EnrollingConditionSetEdgeResolvers<ContextType>;
  EnrollingConditionSetEnrollingConditionConditionsAggregationSelection?: EnrollingConditionSetEnrollingConditionConditionsAggregationSelectionResolvers<ContextType>;
  EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection?: EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelectionResolvers<ContextType>;
  EnrollingConditionSetRelationship?: EnrollingConditionSetRelationshipResolvers<ContextType>;
  EnrollingConditionSetScopesConnection?: EnrollingConditionSetScopesConnectionResolvers<ContextType>;
  EnrollingConditionSetScopesRelationship?: EnrollingConditionSetScopesRelationshipResolvers<ContextType>;
  EnrollingConditionSetTemplateConnection?: EnrollingConditionSetTemplateConnectionResolvers<ContextType>;
  EnrollingConditionSetTemplateRelationship?: EnrollingConditionSetTemplateRelationshipResolvers<ContextType>;
  EnrollingConditionSetsConnection?: EnrollingConditionSetsConnectionResolvers<ContextType>;
  EnrollingConditionsConnection?: EnrollingConditionsConnectionResolvers<ContextType>;
  EnrollingPeriod?: EnrollingPeriodResolvers<ContextType>;
  EnrollingPeriodEdge?: EnrollingPeriodEdgeResolvers<ContextType>;
  EnrollingPeriodsConnection?: EnrollingPeriodsConnectionResolvers<ContextType>;
  EntityTypeMappingRelationship?: EntityTypeMappingRelationshipResolvers<ContextType>;
  EntryModule?: EntryModuleResolvers<ContextType>;
  EntryModuleEdge?: EntryModuleEdgeResolvers<ContextType>;
  EntryModulesConnection?: EntryModulesConnectionResolvers<ContextType>;
  ExFactoryPrice?: ExFactoryPriceResolvers<ContextType>;
  ExFactoryPriceEdge?: ExFactoryPriceEdgeResolvers<ContextType>;
  ExFactoryPricesConnection?: ExFactoryPricesConnectionResolvers<ContextType>;
  FileUpload?: GraphQLScalarType;
  FinancialSummaryColumn?: FinancialSummaryColumnResolvers<ContextType>;
  FinancialSummaryColumnEdge?: FinancialSummaryColumnEdgeResolvers<ContextType>;
  FinancialSummaryColumnsConnection?: FinancialSummaryColumnsConnectionResolvers<ContextType>;
  FlexEntitiesConnection?: FlexEntitiesConnectionResolvers<ContextType>;
  FlexEntity?: FlexEntityResolvers<ContextType>;
  FlexEntityCaseCasesAggregationSelection?: FlexEntityCaseCasesAggregationSelectionResolvers<ContextType>;
  FlexEntityCaseCasesNodeAggregateSelection?: FlexEntityCaseCasesNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityCasesConnection?: FlexEntityCasesConnectionResolvers<ContextType>;
  FlexEntityCasesRelationship?: FlexEntityCasesRelationshipResolvers<ContextType>;
  FlexEntityCreatedByConnection?: FlexEntityCreatedByConnectionResolvers<ContextType>;
  FlexEntityCreatedByRelationship?: FlexEntityCreatedByRelationshipResolvers<ContextType>;
  FlexEntityEdge?: FlexEntityEdgeResolvers<ContextType>;
  FlexEntityFinancialDataPointsConnection?: FlexEntityFinancialDataPointsConnectionResolvers<ContextType>;
  FlexEntityFinancialDataPointsRelationship?: FlexEntityFinancialDataPointsRelationshipResolvers<ContextType>;
  FlexEntityFlexEntityPredecessorAggregationSelection?: FlexEntityFlexEntityPredecessorAggregationSelectionResolvers<ContextType>;
  FlexEntityFlexEntityPredecessorNodeAggregateSelection?: FlexEntityFlexEntityPredecessorNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityFlexEntitySourceAggregationSelection?: FlexEntityFlexEntitySourceAggregationSelectionResolvers<ContextType>;
  FlexEntityFlexEntitySourceNodeAggregateSelection?: FlexEntityFlexEntitySourceNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityFlexEntitySourcedAggregationSelection?: FlexEntityFlexEntitySourcedAggregationSelectionResolvers<ContextType>;
  FlexEntityFlexEntitySourcedNodeAggregateSelection?: FlexEntityFlexEntitySourcedNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityFlexEntitySuccessorAggregationSelection?: FlexEntityFlexEntitySuccessorAggregationSelectionResolvers<ContextType>;
  FlexEntityFlexEntitySuccessorNodeAggregateSelection?: FlexEntityFlexEntitySuccessorNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityFlexEntityTypeTypeAggregationSelection?: FlexEntityFlexEntityTypeTypeAggregationSelectionResolvers<ContextType>;
  FlexEntityFlexEntityTypeTypeNodeAggregateSelection?: FlexEntityFlexEntityTypeTypeNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection?: FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelectionResolvers<ContextType>;
  FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection?: FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityGenericGenericsAggregationSelection?: FlexEntityGenericGenericsAggregationSelectionResolvers<ContextType>;
  FlexEntityGenericGenericsNodeAggregateSelection?: FlexEntityGenericGenericsNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityGenericsConnection?: FlexEntityGenericsConnectionResolvers<ContextType>;
  FlexEntityGenericsRelationship?: FlexEntityGenericsRelationshipResolvers<ContextType>;
  FlexEntityPatientConnection?: FlexEntityPatientConnectionResolvers<ContextType>;
  FlexEntityPatientPatientAggregationSelection?: FlexEntityPatientPatientAggregationSelectionResolvers<ContextType>;
  FlexEntityPatientPatientNodeAggregateSelection?: FlexEntityPatientPatientNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityPatientRelationship?: FlexEntityPatientRelationshipResolvers<ContextType>;
  FlexEntityPredecessorConnection?: FlexEntityPredecessorConnectionResolvers<ContextType>;
  FlexEntityPredecessorRelationship?: FlexEntityPredecessorRelationshipResolvers<ContextType>;
  FlexEntityPurchaseConnection?: FlexEntityPurchaseConnectionResolvers<ContextType>;
  FlexEntityPurchasePurchaseAggregationSelection?: FlexEntityPurchasePurchaseAggregationSelectionResolvers<ContextType>;
  FlexEntityPurchasePurchaseNodeAggregateSelection?: FlexEntityPurchasePurchaseNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityPurchaseRelationship?: FlexEntityPurchaseRelationshipResolvers<ContextType>;
  FlexEntitySourceConnection?: FlexEntitySourceConnectionResolvers<ContextType>;
  FlexEntitySourceRelationship?: FlexEntitySourceRelationshipResolvers<ContextType>;
  FlexEntitySourcedConnection?: FlexEntitySourcedConnectionResolvers<ContextType>;
  FlexEntitySourcedRelationship?: FlexEntitySourcedRelationshipResolvers<ContextType>;
  FlexEntitySuccessorConnection?: FlexEntitySuccessorConnectionResolvers<ContextType>;
  FlexEntitySuccessorRelationship?: FlexEntitySuccessorRelationshipResolvers<ContextType>;
  FlexEntityType?: FlexEntityTypeResolvers<ContextType>;
  FlexEntityTypeAddedByConnection?: FlexEntityTypeAddedByConnectionResolvers<ContextType>;
  FlexEntityTypeAddedByRelationship?: FlexEntityTypeAddedByRelationshipResolvers<ContextType>;
  FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection?: FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelectionResolvers<ContextType>;
  FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection?: FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityTypeCatalogueAttributeRelationship?: FlexEntityTypeCatalogueAttributeRelationshipResolvers<ContextType>;
  FlexEntityTypeCatalogueAttributesConnection?: FlexEntityTypeCatalogueAttributesConnectionResolvers<ContextType>;
  FlexEntityTypeCatalogueAttributesRelationship?: FlexEntityTypeCatalogueAttributesRelationshipResolvers<ContextType>;
  FlexEntityTypeConnection?: FlexEntityTypeConnectionResolvers<ContextType>;
  FlexEntityTypeEdge?: FlexEntityTypeEdgeResolvers<ContextType>;
  FlexEntityTypeFlexEntityInstancesAggregationSelection?: FlexEntityTypeFlexEntityInstancesAggregationSelectionResolvers<ContextType>;
  FlexEntityTypeFlexEntityInstancesNodeAggregateSelection?: FlexEntityTypeFlexEntityInstancesNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection?: FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelectionResolvers<ContextType>;
  FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection?: FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityTypeInstancesConnection?: FlexEntityTypeInstancesConnectionResolvers<ContextType>;
  FlexEntityTypeInstancesRelationship?: FlexEntityTypeInstancesRelationshipResolvers<ContextType>;
  FlexEntityTypeMappingInstancesConnection?: FlexEntityTypeMappingInstancesConnectionResolvers<ContextType>;
  FlexEntityTypeMappingInstancesRelationship?: FlexEntityTypeMappingInstancesRelationshipResolvers<ContextType>;
  FlexEntityTypeOrganizationMappingInstancesAggregationSelection?: FlexEntityTypeOrganizationMappingInstancesAggregationSelectionResolvers<ContextType>;
  FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection?: FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelectionResolvers<ContextType>;
  FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection?: FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityTypeRecordTypesConnection?: FlexEntityTypeRecordTypesConnectionResolvers<ContextType>;
  FlexEntityTypeRecordTypesRelationship?: FlexEntityTypeRecordTypesRelationshipResolvers<ContextType>;
  FlexEntityTypeRelationship?: FlexEntityTypeRelationshipResolvers<ContextType>;
  FlexEntityTypeUserAddedByAggregationSelection?: FlexEntityTypeUserAddedByAggregationSelectionResolvers<ContextType>;
  FlexEntityTypeUserAddedByNodeAggregateSelection?: FlexEntityTypeUserAddedByNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityTypesConnection?: FlexEntityTypesConnectionResolvers<ContextType>;
  FlexEntityUploadConnection?: FlexEntityUploadConnectionResolvers<ContextType>;
  FlexEntityUploadRelationship?: FlexEntityUploadRelationshipResolvers<ContextType>;
  FlexEntityUploadUploadAggregationSelection?: FlexEntityUploadUploadAggregationSelectionResolvers<ContextType>;
  FlexEntityUploadUploadNodeAggregateSelection?: FlexEntityUploadUploadNodeAggregateSelectionResolvers<ContextType>;
  FlexEntityUserCreatedByAggregationSelection?: FlexEntityUserCreatedByAggregationSelectionResolvers<ContextType>;
  FlexEntityUserCreatedByNodeAggregateSelection?: FlexEntityUserCreatedByNodeAggregateSelectionResolvers<ContextType>;
  FlexFinancialDataPoint?: FlexFinancialDataPointResolvers<ContextType>;
  FlexFinancialDataPointAgreementAgreementAggregationSelection?: FlexFinancialDataPointAgreementAgreementAggregationSelectionResolvers<ContextType>;
  FlexFinancialDataPointAgreementAgreementNodeAggregateSelection?: FlexFinancialDataPointAgreementAgreementNodeAggregateSelectionResolvers<ContextType>;
  FlexFinancialDataPointAgreementConnection?: FlexFinancialDataPointAgreementConnectionResolvers<ContextType>;
  FlexFinancialDataPointAgreementRelationship?: FlexFinancialDataPointAgreementRelationshipResolvers<ContextType>;
  FlexFinancialDataPointCaseGeneratedForAggregationSelection?: FlexFinancialDataPointCaseGeneratedForAggregationSelectionResolvers<ContextType>;
  FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection?: FlexFinancialDataPointCaseGeneratedForNodeAggregateSelectionResolvers<ContextType>;
  FlexFinancialDataPointEdge?: FlexFinancialDataPointEdgeResolvers<ContextType>;
  FlexFinancialDataPointEvaluatesConnection?: FlexFinancialDataPointEvaluatesConnectionResolvers<ContextType>;
  FlexFinancialDataPointEvaluatesRelationship?: FlexFinancialDataPointEvaluatesRelationshipResolvers<ContextType>;
  FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection?: FlexFinancialDataPointFlexEntityEvaluatesAggregationSelectionResolvers<ContextType>;
  FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection?: FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelectionResolvers<ContextType>;
  FlexFinancialDataPointGeneratedForConnection?: FlexFinancialDataPointGeneratedForConnectionResolvers<ContextType>;
  FlexFinancialDataPointGeneratedForRelationship?: FlexFinancialDataPointGeneratedForRelationshipResolvers<ContextType>;
  FlexFinancialDataPointRefundSourceDocumentAggregationSelection?: FlexFinancialDataPointRefundSourceDocumentAggregationSelectionResolvers<ContextType>;
  FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection?: FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelectionResolvers<ContextType>;
  FlexFinancialDataPointRefundSourceRefundAggregationSelection?: FlexFinancialDataPointRefundSourceRefundAggregationSelectionResolvers<ContextType>;
  FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection?: FlexFinancialDataPointRefundSourceRefundNodeAggregateSelectionResolvers<ContextType>;
  FlexFinancialDataPointSourceDocumentConnection?: FlexFinancialDataPointSourceDocumentConnectionResolvers<ContextType>;
  FlexFinancialDataPointSourceDocumentRelationship?: FlexFinancialDataPointSourceDocumentRelationshipResolvers<ContextType>;
  FlexFinancialDataPointSourceRefundConnection?: FlexFinancialDataPointSourceRefundConnectionResolvers<ContextType>;
  FlexFinancialDataPointSourceRefundRelationship?: FlexFinancialDataPointSourceRefundRelationshipResolvers<ContextType>;
  FlexFinancialDataPointTreatmentConnection?: FlexFinancialDataPointTreatmentConnectionResolvers<ContextType>;
  FlexFinancialDataPointTreatmentRelationship?: FlexFinancialDataPointTreatmentRelationshipResolvers<ContextType>;
  FlexFinancialDataPointTreatmentTreatmentAggregationSelection?: FlexFinancialDataPointTreatmentTreatmentAggregationSelectionResolvers<ContextType>;
  FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection?: FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelectionResolvers<ContextType>;
  FlexFinancialDataPointsConnection?: FlexFinancialDataPointsConnectionResolvers<ContextType>;
  FlexQueriesConnection?: FlexQueriesConnectionResolvers<ContextType>;
  FlexQuery?: FlexQueryResolvers<ContextType>;
  FlexQueryCreatedByConnection?: FlexQueryCreatedByConnectionResolvers<ContextType>;
  FlexQueryCreatedByRelationship?: FlexQueryCreatedByRelationshipResolvers<ContextType>;
  FlexQueryEdge?: FlexQueryEdgeResolvers<ContextType>;
  FlexQueryFlexQueryRunRunsAggregationSelection?: FlexQueryFlexQueryRunRunsAggregationSelectionResolvers<ContextType>;
  FlexQueryFlexQueryRunRunsNodeAggregateSelection?: FlexQueryFlexQueryRunRunsNodeAggregateSelectionResolvers<ContextType>;
  FlexQueryRun?: FlexQueryRunResolvers<ContextType>;
  FlexQueryRunEdge?: FlexQueryRunEdgeResolvers<ContextType>;
  FlexQueryRunFlexQueryQueryAggregationSelection?: FlexQueryRunFlexQueryQueryAggregationSelectionResolvers<ContextType>;
  FlexQueryRunFlexQueryQueryNodeAggregateSelection?: FlexQueryRunFlexQueryQueryNodeAggregateSelectionResolvers<ContextType>;
  FlexQueryRunQueryConnection?: FlexQueryRunQueryConnectionResolvers<ContextType>;
  FlexQueryRunQueryRelationship?: FlexQueryRunQueryRelationshipResolvers<ContextType>;
  FlexQueryRunStartedByConnection?: FlexQueryRunStartedByConnectionResolvers<ContextType>;
  FlexQueryRunStartedByRelationship?: FlexQueryRunStartedByRelationshipResolvers<ContextType>;
  FlexQueryRunUserStartedByAggregationSelection?: FlexQueryRunUserStartedByAggregationSelectionResolvers<ContextType>;
  FlexQueryRunUserStartedByNodeAggregateSelection?: FlexQueryRunUserStartedByNodeAggregateSelectionResolvers<ContextType>;
  FlexQueryRunsConnection?: FlexQueryRunsConnectionResolvers<ContextType>;
  FlexQueryRunsRelationship?: FlexQueryRunsRelationshipResolvers<ContextType>;
  FlexQueryUpdatedByConnection?: FlexQueryUpdatedByConnectionResolvers<ContextType>;
  FlexQueryUpdatedByRelationship?: FlexQueryUpdatedByRelationshipResolvers<ContextType>;
  FlexQueryUserCreatedByAggregationSelection?: FlexQueryUserCreatedByAggregationSelectionResolvers<ContextType>;
  FlexQueryUserCreatedByNodeAggregateSelection?: FlexQueryUserCreatedByNodeAggregateSelectionResolvers<ContextType>;
  FlexQueryUserUpdatedByAggregationSelection?: FlexQueryUserUpdatedByAggregationSelectionResolvers<ContextType>;
  FlexQueryUserUpdatedByNodeAggregateSelection?: FlexQueryUserUpdatedByNodeAggregateSelectionResolvers<ContextType>;
  FloatAggregateSelectionNonNullable?: FloatAggregateSelectionNonNullableResolvers<ContextType>;
  FloatAggregateSelectionNullable?: FloatAggregateSelectionNullableResolvers<ContextType>;
  Generic?: GenericResolvers<ContextType>;
  GenericCreatedByConnection?: GenericCreatedByConnectionResolvers<ContextType>;
  GenericCreatedByRelationship?: GenericCreatedByRelationshipResolvers<ContextType>;
  GenericEdge?: GenericEdgeResolvers<ContextType>;
  GenericPreparationPreparationsAggregationSelection?: GenericPreparationPreparationsAggregationSelectionResolvers<ContextType>;
  GenericPreparationPreparationsNodeAggregateSelection?: GenericPreparationPreparationsNodeAggregateSelectionResolvers<ContextType>;
  GenericPreparationsConnection?: GenericPreparationsConnectionResolvers<ContextType>;
  GenericPreparationsRelationship?: GenericPreparationsRelationshipResolvers<ContextType>;
  GenericTreatmentSetTreatmentSetsAggregationSelection?: GenericTreatmentSetTreatmentSetsAggregationSelectionResolvers<ContextType>;
  GenericTreatmentSetTreatmentSetsNodeAggregateSelection?: GenericTreatmentSetTreatmentSetsNodeAggregateSelectionResolvers<ContextType>;
  GenericTreatmentSetsConnection?: GenericTreatmentSetsConnectionResolvers<ContextType>;
  GenericTreatmentSetsRelationship?: GenericTreatmentSetsRelationshipResolvers<ContextType>;
  GenericUserCreatedByAggregationSelection?: GenericUserCreatedByAggregationSelectionResolvers<ContextType>;
  GenericUserCreatedByNodeAggregateSelection?: GenericUserCreatedByNodeAggregateSelectionResolvers<ContextType>;
  GenericsConnection?: GenericsConnectionResolvers<ContextType>;
  GetBrandReportItem?: GetBrandReportItemResolvers<ContextType>;
  GetBrandReportItemEdge?: GetBrandReportItemEdgeResolvers<ContextType>;
  GetBrandReportItemsConnection?: GetBrandReportItemsConnectionResolvers<ContextType>;
  GetIndicationReportItem?: GetIndicationReportItemResolvers<ContextType>;
  GetIndicationReportItemEdge?: GetIndicationReportItemEdgeResolvers<ContextType>;
  GetIndicationReportItemsConnection?: GetIndicationReportItemsConnectionResolvers<ContextType>;
  GlobalLock?: GlobalLockResolvers<ContextType>;
  GlobalLockCreatorConnection?: GlobalLockCreatorConnectionResolvers<ContextType>;
  GlobalLockCreatorRelationship?: GlobalLockCreatorRelationshipResolvers<ContextType>;
  GlobalLockEdge?: GlobalLockEdgeResolvers<ContextType>;
  GlobalLockUserCreatorAggregationSelection?: GlobalLockUserCreatorAggregationSelectionResolvers<ContextType>;
  GlobalLockUserCreatorNodeAggregateSelection?: GlobalLockUserCreatorNodeAggregateSelectionResolvers<ContextType>;
  GlobalLocksConnection?: GlobalLocksConnectionResolvers<ContextType>;
  IDAggregateSelectionNonNullable?: IdAggregateSelectionNonNullableResolvers<ContextType>;
  IDAggregateSelectionNullable?: IdAggregateSelectionNullableResolvers<ContextType>;
  ITimeframe?: ITimeframeResolvers<ContextType>;
  ITreatmentCondition?: ITreatmentConditionResolvers<ContextType>;
  Icd10Attribute?: Icd10AttributeResolvers<ContextType>;
  Icd10AttributeEdge?: Icd10AttributeEdgeResolvers<ContextType>;
  Icd10AttributesConnection?: Icd10AttributesConnectionResolvers<ContextType>;
  Icd10Concept?: Icd10ConceptResolvers<ContextType>;
  Icd10ConceptEdge?: Icd10ConceptEdgeResolvers<ContextType>;
  Icd10ConceptsConnection?: Icd10ConceptsConnectionResolvers<ContextType>;
  Icd10EntitiesConnection?: Icd10EntitiesConnectionResolvers<ContextType>;
  Icd10Entity?: Icd10EntityResolvers<ContextType>;
  Icd10EntityEdge?: Icd10EntityEdgeResolvers<ContextType>;
  Icd10Suggestions?: Icd10SuggestionsResolvers<ContextType>;
  Icd10SuggestionsConnection?: Icd10SuggestionsConnectionResolvers<ContextType>;
  Icd10SuggestionsEdge?: Icd10SuggestionsEdgeResolvers<ContextType>;
  Icd10Trait?: Icd10TraitResolvers<ContextType>;
  Icd10TraitEdge?: Icd10TraitEdgeResolvers<ContextType>;
  Icd10TraitsConnection?: Icd10TraitsConnectionResolvers<ContextType>;
  ImpactItem?: ImpactItemResolvers<ContextType>;
  ImpactItemEdge?: ImpactItemEdgeResolvers<ContextType>;
  ImpactItemsConnection?: ImpactItemsConnectionResolvers<ContextType>;
  Indication?: IndicationResolvers<ContextType>;
  IndicationEdge?: IndicationEdgeResolvers<ContextType>;
  IndicationsConnection?: IndicationsConnectionResolvers<ContextType>;
  IntAggregateSelectionNonNullable?: IntAggregateSelectionNonNullableResolvers<ContextType>;
  IntAggregateSelectionNullable?: IntAggregateSelectionNullableResolvers<ContextType>;
  IntegrityCheckCompleteResult?: IntegrityCheckCompleteResultResolvers<ContextType>;
  IntegrityCheckCompleteResultEdge?: IntegrityCheckCompleteResultEdgeResolvers<ContextType>;
  IntegrityCheckCompleteResultsConnection?: IntegrityCheckCompleteResultsConnectionResolvers<ContextType>;
  IntegrityCheckTypes?: IntegrityCheckTypesResolvers<ContextType>;
  IntegrityCheckTypesConnection?: IntegrityCheckTypesConnectionResolvers<ContextType>;
  IntegrityCheckTypesEdge?: IntegrityCheckTypesEdgeResolvers<ContextType>;
  Limitation?: LimitationResolvers<ContextType>;
  LimitationAgreementTemplateAgreementTemplateAggregationSelection?: LimitationAgreementTemplateAgreementTemplateAggregationSelectionResolvers<ContextType>;
  LimitationAgreementTemplateAgreementTemplateNodeAggregateSelection?: LimitationAgreementTemplateAgreementTemplateNodeAggregateSelectionResolvers<ContextType>;
  LimitationAgreementTemplateConnection?: LimitationAgreementTemplateConnectionResolvers<ContextType>;
  LimitationAgreementTemplateRelationship?: LimitationAgreementTemplateRelationshipResolvers<ContextType>;
  LimitationEdge?: LimitationEdgeResolvers<ContextType>;
  LimitationLimitsPreparationsConnection?: LimitationLimitsPreparationsConnectionResolvers<ContextType>;
  LimitationLimitsPreparationsRelationship?: LimitationLimitsPreparationsRelationshipResolvers<ContextType>;
  LimitationLimitsTreatmentsBySelfConnection?: LimitationLimitsTreatmentsBySelfConnectionResolvers<ContextType>;
  LimitationLimitsTreatmentsBySelfRelationship?: LimitationLimitsTreatmentsBySelfRelationshipResolvers<ContextType>;
  LimitationLimitsTreatmentsThroughPreparationConnection?: LimitationLimitsTreatmentsThroughPreparationConnectionResolvers<ContextType>;
  LimitationLimitsTreatmentsThroughPreparationRelationship?: LimitationLimitsTreatmentsThroughPreparationRelationshipResolvers<ContextType>;
  LimitationPreparationLimitsPreparationsAggregationSelection?: LimitationPreparationLimitsPreparationsAggregationSelectionResolvers<ContextType>;
  LimitationPreparationLimitsPreparationsNodeAggregateSelection?: LimitationPreparationLimitsPreparationsNodeAggregateSelectionResolvers<ContextType>;
  LimitationTreatmentLimitsTreatmentsBySelfAggregationSelection?: LimitationTreatmentLimitsTreatmentsBySelfAggregationSelectionResolvers<ContextType>;
  LimitationTreatmentLimitsTreatmentsBySelfNodeAggregateSelection?: LimitationTreatmentLimitsTreatmentsBySelfNodeAggregateSelectionResolvers<ContextType>;
  LimitationTreatmentLimitsTreatmentsThroughPreparationAggregationSelection?: LimitationTreatmentLimitsTreatmentsThroughPreparationAggregationSelectionResolvers<ContextType>;
  LimitationTreatmentLimitsTreatmentsThroughPreparationNodeAggregateSelection?: LimitationTreatmentLimitsTreatmentsThroughPreparationNodeAggregateSelectionResolvers<ContextType>;
  LimitationsConnection?: LimitationsConnectionResolvers<ContextType>;
  LocalizationKeySuggestions?: LocalizationKeySuggestionsResolvers<ContextType>;
  LocalizationKeySuggestionsConnection?: LocalizationKeySuggestionsConnectionResolvers<ContextType>;
  LocalizationKeySuggestionsEdge?: LocalizationKeySuggestionsEdgeResolvers<ContextType>;
  MainIndication?: MainIndicationResolvers<ContextType>;
  MainIndicationArticle71IndicationArticle71IndicationAggregationSelection?: MainIndicationArticle71IndicationArticle71IndicationAggregationSelectionResolvers<ContextType>;
  MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection?: MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelectionResolvers<ContextType>;
  MainIndicationArticle71IndicationConnection?: MainIndicationArticle71IndicationConnectionResolvers<ContextType>;
  MainIndicationArticle71IndicationRelationship?: MainIndicationArticle71IndicationRelationshipResolvers<ContextType>;
  MainIndicationBrandBrandAggregationSelection?: MainIndicationBrandBrandAggregationSelectionResolvers<ContextType>;
  MainIndicationBrandBrandNodeAggregateSelection?: MainIndicationBrandBrandNodeAggregateSelectionResolvers<ContextType>;
  MainIndicationBrandConnection?: MainIndicationBrandConnectionResolvers<ContextType>;
  MainIndicationBrandRelationship?: MainIndicationBrandRelationshipResolvers<ContextType>;
  MainIndicationEdge?: MainIndicationEdgeResolvers<ContextType>;
  MainIndicationsConnection?: MainIndicationsConnectionResolvers<ContextType>;
  MasterDataRefundImpact?: MasterDataRefundImpactResolvers<ContextType>;
  MasterDataRefundImpactEdge?: MasterDataRefundImpactEdgeResolvers<ContextType>;
  MasterDataRefundImpactsConnection?: MasterDataRefundImpactsConnectionResolvers<ContextType>;
  MasterDataUploadHistoryRecord?: MasterDataUploadHistoryRecordResolvers<ContextType>;
  MasterDataUploadHistoryRecordEdge?: MasterDataUploadHistoryRecordEdgeResolvers<ContextType>;
  MasterDataUploadHistoryRecordsConnection?: MasterDataUploadHistoryRecordsConnectionResolvers<ContextType>;
  Message?: MessageResolvers<ContextType>;
  MessageCaseCaseAggregationSelection?: MessageCaseCaseAggregationSelectionResolvers<ContextType>;
  MessageCaseCaseNodeAggregateSelection?: MessageCaseCaseNodeAggregateSelectionResolvers<ContextType>;
  MessageCaseConnection?: MessageCaseConnectionResolvers<ContextType>;
  MessageCaseRelationship?: MessageCaseRelationshipResolvers<ContextType>;
  MessageEdge?: MessageEdgeResolvers<ContextType>;
  MessageMentionsConnection?: MessageMentionsConnectionResolvers<ContextType>;
  MessageMentionsRelationship?: MessageMentionsRelationshipResolvers<ContextType>;
  MessageSentByConnection?: MessageSentByConnectionResolvers<ContextType>;
  MessageSentByRelationship?: MessageSentByRelationshipResolvers<ContextType>;
  MessageUserMentionsAggregationSelection?: MessageUserMentionsAggregationSelectionResolvers<ContextType>;
  MessageUserMentionsNodeAggregateSelection?: MessageUserMentionsNodeAggregateSelectionResolvers<ContextType>;
  MessageUserSentByAggregationSelection?: MessageUserSentByAggregationSelectionResolvers<ContextType>;
  MessageUserSentByNodeAggregateSelection?: MessageUserSentByNodeAggregateSelectionResolvers<ContextType>;
  MessagesConnection?: MessagesConnectionResolvers<ContextType>;
  MissingTranslationKeys?: MissingTranslationKeysResolvers<ContextType>;
  MissingTranslationKeysConnection?: MissingTranslationKeysConnectionResolvers<ContextType>;
  MissingTranslationKeysEdge?: MissingTranslationKeysEdgeResolvers<ContextType>;
  Module?: ModuleResolvers<ContextType>;
  ModuleEdge?: ModuleEdgeResolvers<ContextType>;
  ModulesConnection?: ModulesConnectionResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NegotiationRound?: NegotiationRoundResolvers<ContextType>;
  NegotiationRoundCaseCaseAggregationSelection?: NegotiationRoundCaseCaseAggregationSelectionResolvers<ContextType>;
  NegotiationRoundCaseCaseNodeAggregateSelection?: NegotiationRoundCaseCaseNodeAggregateSelectionResolvers<ContextType>;
  NegotiationRoundCaseConnection?: NegotiationRoundCaseConnectionResolvers<ContextType>;
  NegotiationRoundCaseRelationship?: NegotiationRoundCaseRelationshipResolvers<ContextType>;
  NegotiationRoundEdge?: NegotiationRoundEdgeResolvers<ContextType>;
  NegotiationRoundFlexEntitySourceAggregationSelection?: NegotiationRoundFlexEntitySourceAggregationSelectionResolvers<ContextType>;
  NegotiationRoundFlexEntitySourceNodeAggregateSelection?: NegotiationRoundFlexEntitySourceNodeAggregateSelectionResolvers<ContextType>;
  NegotiationRoundOrganizationProposedByAggregationSelection?: NegotiationRoundOrganizationProposedByAggregationSelectionResolvers<ContextType>;
  NegotiationRoundOrganizationProposedByNodeAggregateSelection?: NegotiationRoundOrganizationProposedByNodeAggregateSelectionResolvers<ContextType>;
  NegotiationRoundProposedByConnection?: NegotiationRoundProposedByConnectionResolvers<ContextType>;
  NegotiationRoundProposedByRelationship?: NegotiationRoundProposedByRelationshipResolvers<ContextType>;
  NegotiationRoundSourceConnection?: NegotiationRoundSourceConnectionResolvers<ContextType>;
  NegotiationRoundSourceRelationship?: NegotiationRoundSourceRelationshipResolvers<ContextType>;
  NegotiationRoundUpdatedByConnection?: NegotiationRoundUpdatedByConnectionResolvers<ContextType>;
  NegotiationRoundUpdatedByRelationship?: NegotiationRoundUpdatedByRelationshipResolvers<ContextType>;
  NegotiationRoundUserUpdatedByAggregationSelection?: NegotiationRoundUserUpdatedByAggregationSelectionResolvers<ContextType>;
  NegotiationRoundUserUpdatedByNodeAggregateSelection?: NegotiationRoundUserUpdatedByNodeAggregateSelectionResolvers<ContextType>;
  NegotiationRoundsConnection?: NegotiationRoundsConnectionResolvers<ContextType>;
  Neo4JClusterMemberMetricsConnection?: Neo4JClusterMemberMetricsConnectionResolvers<ContextType>;
  Neo4JClusterMetricsConnection?: Neo4JClusterMetricsConnectionResolvers<ContextType>;
  Neo4jClusterMemberMetric?: Neo4jClusterMemberMetricResolvers<ContextType>;
  Neo4jClusterMemberMetricEdge?: Neo4jClusterMemberMetricEdgeResolvers<ContextType>;
  Neo4jClusterMetrics?: Neo4jClusterMetricsResolvers<ContextType>;
  Neo4jClusterMetricsEdge?: Neo4jClusterMetricsEdgeResolvers<ContextType>;
  NinjaQueriesConnection?: NinjaQueriesConnectionResolvers<ContextType>;
  NinjaQuery?: NinjaQueryResolvers<ContextType>;
  NinjaQueryEdge?: NinjaQueryEdgeResolvers<ContextType>;
  NinjaQueryImpact?: NinjaQueryImpactResolvers<ContextType>;
  NinjaQueryImpactEdge?: NinjaQueryImpactEdgeResolvers<ContextType>;
  NinjaQueryImpactsConnection?: NinjaQueryImpactsConnectionResolvers<ContextType>;
  NinjaQuerySubmitResult?: NinjaQuerySubmitResultResolvers<ContextType>;
  NinjaQuerySubmitResultEdge?: NinjaQuerySubmitResultEdgeResolvers<ContextType>;
  NinjaQuerySubmitResultsConnection?: NinjaQuerySubmitResultsConnectionResolvers<ContextType>;
  OidDcUser?: OidDcUserResolvers<ContextType>;
  OidDcUserEdge?: OidDcUserEdgeResolvers<ContextType>;
  OidDcUsersConnection?: OidDcUsersConnectionResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  OrganizationAgreementAgreementsAggregationSelection?: OrganizationAgreementAgreementsAggregationSelectionResolvers<ContextType>;
  OrganizationAgreementAgreementsNodeAggregateSelection?: OrganizationAgreementAgreementsNodeAggregateSelectionResolvers<ContextType>;
  OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection?: OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelectionResolvers<ContextType>;
  OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection?: OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelectionResolvers<ContextType>;
  OrganizationAgreementRunAttemptsConnection?: OrganizationAgreementRunAttemptsConnectionResolvers<ContextType>;
  OrganizationAgreementRunAttemptsRelationship?: OrganizationAgreementRunAttemptsRelationshipResolvers<ContextType>;
  OrganizationAgreementsConnection?: OrganizationAgreementsConnectionResolvers<ContextType>;
  OrganizationAgreementsRelationship?: OrganizationAgreementsRelationshipResolvers<ContextType>;
  OrganizationCountryConnection?: OrganizationCountryConnectionResolvers<ContextType>;
  OrganizationCountryCountryAggregationSelection?: OrganizationCountryCountryAggregationSelectionResolvers<ContextType>;
  OrganizationCountryCountryNodeAggregateSelection?: OrganizationCountryCountryNodeAggregateSelectionResolvers<ContextType>;
  OrganizationCountryRelationship?: OrganizationCountryRelationshipResolvers<ContextType>;
  OrganizationDefaultReceiversConnection?: OrganizationDefaultReceiversConnectionResolvers<ContextType>;
  OrganizationDefaultReceiversRelationship?: OrganizationDefaultReceiversRelationshipResolvers<ContextType>;
  OrganizationEdge?: OrganizationEdgeResolvers<ContextType>;
  OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection?: OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelectionResolvers<ContextType>;
  OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection?: OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelectionResolvers<ContextType>;
  OrganizationEncapsulatedFeaturesConnection?: OrganizationEncapsulatedFeaturesConnectionResolvers<ContextType>;
  OrganizationEncapsulatedFeaturesRelationship?: OrganizationEncapsulatedFeaturesRelationshipResolvers<ContextType>;
  OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection?: OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelectionResolvers<ContextType>;
  OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection?: OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelectionResolvers<ContextType>;
  OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection?: OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelectionResolvers<ContextType>;
  OrganizationFlexEntityTypeMappingsConnection?: OrganizationFlexEntityTypeMappingsConnectionResolvers<ContextType>;
  OrganizationFlexEntityTypeMappingsRelationship?: OrganizationFlexEntityTypeMappingsRelationshipResolvers<ContextType>;
  OrganizationOrganizationDefaultReceiversAggregationSelection?: OrganizationOrganizationDefaultReceiversAggregationSelectionResolvers<ContextType>;
  OrganizationOrganizationDefaultReceiversEdgeAggregateSelection?: OrganizationOrganizationDefaultReceiversEdgeAggregateSelectionResolvers<ContextType>;
  OrganizationOrganizationDefaultReceiversNodeAggregateSelection?: OrganizationOrganizationDefaultReceiversNodeAggregateSelectionResolvers<ContextType>;
  OrganizationQuestNotificationQuestNotificationsAggregationSelection?: OrganizationQuestNotificationQuestNotificationsAggregationSelectionResolvers<ContextType>;
  OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection?: OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelectionResolvers<ContextType>;
  OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection?: OrganizationQuestNotificationQuestNotificationsNodeAggregateSelectionResolvers<ContextType>;
  OrganizationQuestNotificationsConnection?: OrganizationQuestNotificationsConnectionResolvers<ContextType>;
  OrganizationQuestNotificationsRelationship?: OrganizationQuestNotificationsRelationshipResolvers<ContextType>;
  OrganizationQuestRelationship?: OrganizationQuestRelationshipResolvers<ContextType>;
  OrganizationScope?: OrganizationScopeResolvers<ContextType>;
  OrganizationScopeEdge?: OrganizationScopeEdgeResolvers<ContextType>;
  OrganizationScopeRelationship?: OrganizationScopeRelationshipResolvers<ContextType>;
  OrganizationScopesConnection?: OrganizationScopesConnectionResolvers<ContextType>;
  OrganizationsConnection?: OrganizationsConnectionResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Partner?: PartnerResolvers<ContextType>;
  PartnerEdge?: PartnerEdgeResolvers<ContextType>;
  PartnerTreatmentConnection?: PartnerTreatmentConnectionResolvers<ContextType>;
  PartnerTreatmentRelationship?: PartnerTreatmentRelationshipResolvers<ContextType>;
  PartnerTreatmentTreatmentAggregationSelection?: PartnerTreatmentTreatmentAggregationSelectionResolvers<ContextType>;
  PartnerTreatmentTreatmentNodeAggregateSelection?: PartnerTreatmentTreatmentNodeAggregateSelectionResolvers<ContextType>;
  PartnersConnection?: PartnersConnectionResolvers<ContextType>;
  Patient?: PatientResolvers<ContextType>;
  PatientAssignedFlexEntitiesConnection?: PatientAssignedFlexEntitiesConnectionResolvers<ContextType>;
  PatientAssignedFlexEntitiesRelationship?: PatientAssignedFlexEntitiesRelationshipResolvers<ContextType>;
  PatientCaseCasesAggregationSelection?: PatientCaseCasesAggregationSelectionResolvers<ContextType>;
  PatientCaseCasesNodeAggregateSelection?: PatientCaseCasesNodeAggregateSelectionResolvers<ContextType>;
  PatientCasesConnection?: PatientCasesConnectionResolvers<ContextType>;
  PatientCasesRelationship?: PatientCasesRelationshipResolvers<ContextType>;
  PatientEdge?: PatientEdgeResolvers<ContextType>;
  PatientFlexEntityAssignedFlexEntitiesAggregationSelection?: PatientFlexEntityAssignedFlexEntitiesAggregationSelectionResolvers<ContextType>;
  PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection?: PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelectionResolvers<ContextType>;
  PatientsConnection?: PatientsConnectionResolvers<ContextType>;
  PerformanceCounter?: PerformanceCounterResolvers<ContextType>;
  PerformanceCounterEdge?: PerformanceCounterEdgeResolvers<ContextType>;
  PerformanceCountersConnection?: PerformanceCountersConnectionResolvers<ContextType>;
  PerformanceMeasurement?: PerformanceMeasurementResolvers<ContextType>;
  PerformanceMeasurementCounterConnection?: PerformanceMeasurementCounterConnectionResolvers<ContextType>;
  PerformanceMeasurementCounterRelationship?: PerformanceMeasurementCounterRelationshipResolvers<ContextType>;
  PerformanceMeasurementEdge?: PerformanceMeasurementEdgeResolvers<ContextType>;
  PerformanceMeasurementNestedMeasurementsConnection?: PerformanceMeasurementNestedMeasurementsConnectionResolvers<ContextType>;
  PerformanceMeasurementNestedMeasurementsRelationship?: PerformanceMeasurementNestedMeasurementsRelationshipResolvers<ContextType>;
  PerformanceMeasurementParentConnection?: PerformanceMeasurementParentConnectionResolvers<ContextType>;
  PerformanceMeasurementParentRelationship?: PerformanceMeasurementParentRelationshipResolvers<ContextType>;
  PerformanceMeasurementPerformanceCounterCounterAggregationSelection?: PerformanceMeasurementPerformanceCounterCounterAggregationSelectionResolvers<ContextType>;
  PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection?: PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelectionResolvers<ContextType>;
  PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection?: PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelectionResolvers<ContextType>;
  PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection?: PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelectionResolvers<ContextType>;
  PerformanceMeasurementPerformanceMeasurementParentAggregationSelection?: PerformanceMeasurementPerformanceMeasurementParentAggregationSelectionResolvers<ContextType>;
  PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection?: PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelectionResolvers<ContextType>;
  PerformanceMeasurementsConnection?: PerformanceMeasurementsConnectionResolvers<ContextType>;
  PerformanceThreshold?: PerformanceThresholdResolvers<ContextType>;
  PerformanceThresholdCounterConnection?: PerformanceThresholdCounterConnectionResolvers<ContextType>;
  PerformanceThresholdCounterRelationship?: PerformanceThresholdCounterRelationshipResolvers<ContextType>;
  PerformanceThresholdEdge?: PerformanceThresholdEdgeResolvers<ContextType>;
  PerformanceThresholdNotifiedUsersConnection?: PerformanceThresholdNotifiedUsersConnectionResolvers<ContextType>;
  PerformanceThresholdNotifiedUsersRelationship?: PerformanceThresholdNotifiedUsersRelationshipResolvers<ContextType>;
  PerformanceThresholdPerformanceCounterCounterAggregationSelection?: PerformanceThresholdPerformanceCounterCounterAggregationSelectionResolvers<ContextType>;
  PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection?: PerformanceThresholdPerformanceCounterCounterNodeAggregateSelectionResolvers<ContextType>;
  PerformanceThresholdUserNotifiedUsersAggregationSelection?: PerformanceThresholdUserNotifiedUsersAggregationSelectionResolvers<ContextType>;
  PerformanceThresholdUserNotifiedUsersNodeAggregateSelection?: PerformanceThresholdUserNotifiedUsersNodeAggregateSelectionResolvers<ContextType>;
  PerformanceThresholdsConnection?: PerformanceThresholdsConnectionResolvers<ContextType>;
  PgBossMetrics?: PgBossMetricsResolvers<ContextType>;
  PgBossMetricsConnection?: PgBossMetricsConnectionResolvers<ContextType>;
  PgBossMetricsEdge?: PgBossMetricsEdgeResolvers<ContextType>;
  PgBossQueueStat?: PgBossQueueStatResolvers<ContextType>;
  PgBossQueueStatEdge?: PgBossQueueStatEdgeResolvers<ContextType>;
  PgBossQueueStatsConnection?: PgBossQueueStatsConnectionResolvers<ContextType>;
  PolicyType?: PolicyTypeResolvers<ContextType>;
  PolicyTypeEdge?: PolicyTypeEdgeResolvers<ContextType>;
  PolicyTypePolicyVersionVersionsAggregationSelection?: PolicyTypePolicyVersionVersionsAggregationSelectionResolvers<ContextType>;
  PolicyTypePolicyVersionVersionsNodeAggregateSelection?: PolicyTypePolicyVersionVersionsNodeAggregateSelectionResolvers<ContextType>;
  PolicyTypeVersionsConnection?: PolicyTypeVersionsConnectionResolvers<ContextType>;
  PolicyTypeVersionsRelationship?: PolicyTypeVersionsRelationshipResolvers<ContextType>;
  PolicyTypesConnection?: PolicyTypesConnectionResolvers<ContextType>;
  PolicyVersion?: PolicyVersionResolvers<ContextType>;
  PolicyVersionEdge?: PolicyVersionEdgeResolvers<ContextType>;
  PolicyVersionPolicyTypeConnection?: PolicyVersionPolicyTypeConnectionResolvers<ContextType>;
  PolicyVersionPolicyTypePolicyTypeAggregationSelection?: PolicyVersionPolicyTypePolicyTypeAggregationSelectionResolvers<ContextType>;
  PolicyVersionPolicyTypePolicyTypeNodeAggregateSelection?: PolicyVersionPolicyTypePolicyTypeNodeAggregateSelectionResolvers<ContextType>;
  PolicyVersionPolicyTypeRelationship?: PolicyVersionPolicyTypeRelationshipResolvers<ContextType>;
  PolicyVersionsConnection?: PolicyVersionsConnectionResolvers<ContextType>;
  PostgresMetric?: PostgresMetricResolvers<ContextType>;
  PostgresMetricEdge?: PostgresMetricEdgeResolvers<ContextType>;
  PostgresMetricsConnection?: PostgresMetricsConnectionResolvers<ContextType>;
  Preparation?: PreparationResolvers<ContextType>;
  PreparationBrandBrandAggregationSelection?: PreparationBrandBrandAggregationSelectionResolvers<ContextType>;
  PreparationBrandBrandNodeAggregateSelection?: PreparationBrandBrandNodeAggregateSelectionResolvers<ContextType>;
  PreparationBrandConnection?: PreparationBrandConnectionResolvers<ContextType>;
  PreparationBrandRelationship?: PreparationBrandRelationshipResolvers<ContextType>;
  PreparationCountriesConnection?: PreparationCountriesConnectionResolvers<ContextType>;
  PreparationCountriesRelationship?: PreparationCountriesRelationshipResolvers<ContextType>;
  PreparationCountryCountriesAggregationSelection?: PreparationCountryCountriesAggregationSelectionResolvers<ContextType>;
  PreparationCountryCountriesNodeAggregateSelection?: PreparationCountryCountriesNodeAggregateSelectionResolvers<ContextType>;
  PreparationEdge?: PreparationEdgeResolvers<ContextType>;
  PreparationGenericConnection?: PreparationGenericConnectionResolvers<ContextType>;
  PreparationGenericGenericAggregationSelection?: PreparationGenericGenericAggregationSelectionResolvers<ContextType>;
  PreparationGenericGenericNodeAggregateSelection?: PreparationGenericGenericNodeAggregateSelectionResolvers<ContextType>;
  PreparationGenericRelationship?: PreparationGenericRelationshipResolvers<ContextType>;
  PreparationHasLimitationsConnection?: PreparationHasLimitationsConnectionResolvers<ContextType>;
  PreparationHasLimitationsRelationship?: PreparationHasLimitationsRelationshipResolvers<ContextType>;
  PreparationLimitationHasLimitationsAggregationSelection?: PreparationLimitationHasLimitationsAggregationSelectionResolvers<ContextType>;
  PreparationLimitationHasLimitationsNodeAggregateSelection?: PreparationLimitationHasLimitationsNodeAggregateSelectionResolvers<ContextType>;
  PreparationRegulatesConnection?: PreparationRegulatesConnectionResolvers<ContextType>;
  PreparationRegulatesRelationship?: PreparationRegulatesRelationshipResolvers<ContextType>;
  PreparationStatus?: PreparationStatusResolvers<ContextType>;
  PreparationStatusEdge?: PreparationStatusEdgeResolvers<ContextType>;
  PreparationStatusPreparationConnection?: PreparationStatusPreparationConnectionResolvers<ContextType>;
  PreparationStatusPreparationPreparationAggregationSelection?: PreparationStatusPreparationPreparationAggregationSelectionResolvers<ContextType>;
  PreparationStatusPreparationPreparationNodeAggregateSelection?: PreparationStatusPreparationPreparationNodeAggregateSelectionResolvers<ContextType>;
  PreparationStatusPreparationRelationship?: PreparationStatusPreparationRelationshipResolvers<ContextType>;
  PreparationStatusesConnection?: PreparationStatusesConnectionResolvers<ContextType>;
  PreparationTreatmentRegulatesAggregationSelection?: PreparationTreatmentRegulatesAggregationSelectionResolvers<ContextType>;
  PreparationTreatmentRegulatesNodeAggregateSelection?: PreparationTreatmentRegulatesNodeAggregateSelectionResolvers<ContextType>;
  PreparationsConnection?: PreparationsConnectionResolvers<ContextType>;
  Price?: PriceResolvers<ContextType>;
  PriceCurrencyConnection?: PriceCurrencyConnectionResolvers<ContextType>;
  PriceCurrencyCurrencyAggregationSelection?: PriceCurrencyCurrencyAggregationSelectionResolvers<ContextType>;
  PriceCurrencyCurrencyNodeAggregateSelection?: PriceCurrencyCurrencyNodeAggregateSelectionResolvers<ContextType>;
  PriceCurrencyRelationship?: PriceCurrencyRelationshipResolvers<ContextType>;
  PriceEdge?: PriceEdgeResolvers<ContextType>;
  PriceTreatmentConnection?: PriceTreatmentConnectionResolvers<ContextType>;
  PriceTreatmentRelationship?: PriceTreatmentRelationshipResolvers<ContextType>;
  PriceTreatmentTreatmentAggregationSelection?: PriceTreatmentTreatmentAggregationSelectionResolvers<ContextType>;
  PriceTreatmentTreatmentNodeAggregateSelection?: PriceTreatmentTreatmentNodeAggregateSelectionResolvers<ContextType>;
  PricesConnection?: PricesConnectionResolvers<ContextType>;
  ProductBlueprint?: ProductBlueprintResolvers<ContextType>;
  ProductBlueprintAddedByConnection?: ProductBlueprintAddedByConnectionResolvers<ContextType>;
  ProductBlueprintAddedByRelationship?: ProductBlueprintAddedByRelationshipResolvers<ContextType>;
  ProductBlueprintDomainDomainsAggregationSelection?: ProductBlueprintDomainDomainsAggregationSelectionResolvers<ContextType>;
  ProductBlueprintDomainDomainsNodeAggregateSelection?: ProductBlueprintDomainDomainsNodeAggregateSelectionResolvers<ContextType>;
  ProductBlueprintDomainsConnection?: ProductBlueprintDomainsConnectionResolvers<ContextType>;
  ProductBlueprintDomainsRelationship?: ProductBlueprintDomainsRelationshipResolvers<ContextType>;
  ProductBlueprintEdge?: ProductBlueprintEdgeResolvers<ContextType>;
  ProductBlueprintPublishedByConnection?: ProductBlueprintPublishedByConnectionResolvers<ContextType>;
  ProductBlueprintPublishedByRelationship?: ProductBlueprintPublishedByRelationshipResolvers<ContextType>;
  ProductBlueprintResult?: ProductBlueprintResultResolvers<ContextType>;
  ProductBlueprintResultEdge?: ProductBlueprintResultEdgeResolvers<ContextType>;
  ProductBlueprintResultsConnection?: ProductBlueprintResultsConnectionResolvers<ContextType>;
  ProductBlueprintSimulationSimulationsAggregationSelection?: ProductBlueprintSimulationSimulationsAggregationSelectionResolvers<ContextType>;
  ProductBlueprintSimulationSimulationsNodeAggregateSelection?: ProductBlueprintSimulationSimulationsNodeAggregateSelectionResolvers<ContextType>;
  ProductBlueprintSimulationsConnection?: ProductBlueprintSimulationsConnectionResolvers<ContextType>;
  ProductBlueprintSimulationsRelationship?: ProductBlueprintSimulationsRelationshipResolvers<ContextType>;
  ProductBlueprintUpdatedByConnection?: ProductBlueprintUpdatedByConnectionResolvers<ContextType>;
  ProductBlueprintUpdatedByRelationship?: ProductBlueprintUpdatedByRelationshipResolvers<ContextType>;
  ProductBlueprintUserAddedByAggregationSelection?: ProductBlueprintUserAddedByAggregationSelectionResolvers<ContextType>;
  ProductBlueprintUserAddedByNodeAggregateSelection?: ProductBlueprintUserAddedByNodeAggregateSelectionResolvers<ContextType>;
  ProductBlueprintUserPublishedByAggregationSelection?: ProductBlueprintUserPublishedByAggregationSelectionResolvers<ContextType>;
  ProductBlueprintUserPublishedByNodeAggregateSelection?: ProductBlueprintUserPublishedByNodeAggregateSelectionResolvers<ContextType>;
  ProductBlueprintUserUpdatedByAggregationSelection?: ProductBlueprintUserUpdatedByAggregationSelectionResolvers<ContextType>;
  ProductBlueprintUserUpdatedByNodeAggregateSelection?: ProductBlueprintUserUpdatedByNodeAggregateSelectionResolvers<ContextType>;
  ProductBlueprintsConnection?: ProductBlueprintsConnectionResolvers<ContextType>;
  PublicPrice?: PublicPriceResolvers<ContextType>;
  PublicPriceEdge?: PublicPriceEdgeResolvers<ContextType>;
  PublicPricesConnection?: PublicPricesConnectionResolvers<ContextType>;
  Purchase?: PurchaseResolvers<ContextType>;
  PurchaseAgreementAgreementAggregationSelection?: PurchaseAgreementAgreementAggregationSelectionResolvers<ContextType>;
  PurchaseAgreementAgreementNodeAggregateSelection?: PurchaseAgreementAgreementNodeAggregateSelectionResolvers<ContextType>;
  PurchaseAgreementConnection?: PurchaseAgreementConnectionResolvers<ContextType>;
  PurchaseAgreementRelationship?: PurchaseAgreementRelationshipResolvers<ContextType>;
  PurchaseAssignedFlexEntitiesConnection?: PurchaseAssignedFlexEntitiesConnectionResolvers<ContextType>;
  PurchaseAssignedFlexEntitiesRelationship?: PurchaseAssignedFlexEntitiesRelationshipResolvers<ContextType>;
  PurchaseEdge?: PurchaseEdgeResolvers<ContextType>;
  PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection?: PurchaseFlexEntityAssignedFlexEntitiesAggregationSelectionResolvers<ContextType>;
  PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection?: PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelectionResolvers<ContextType>;
  PurchaseRefundRefundsAggregationSelection?: PurchaseRefundRefundsAggregationSelectionResolvers<ContextType>;
  PurchaseRefundRefundsNodeAggregateSelection?: PurchaseRefundRefundsNodeAggregateSelectionResolvers<ContextType>;
  PurchaseRefundsConnection?: PurchaseRefundsConnectionResolvers<ContextType>;
  PurchaseRefundsRelationship?: PurchaseRefundsRelationshipResolvers<ContextType>;
  PurchasesConnection?: PurchasesConnectionResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  QueryLog?: QueryLogResolvers<ContextType>;
  QueryLogEdge?: QueryLogEdgeResolvers<ContextType>;
  QueryLogsConnection?: QueryLogsConnectionResolvers<ContextType>;
  QueryResult?: QueryResultResolvers<ContextType>;
  QueryResultEdge?: QueryResultEdgeResolvers<ContextType>;
  QueryResultsConnection?: QueryResultsConnectionResolvers<ContextType>;
  QuestNotification?: QuestNotificationResolvers<ContextType>;
  QuestNotificationEdge?: QuestNotificationEdgeResolvers<ContextType>;
  QuestNotificationOrganizationSubscribedAggregationSelection?: QuestNotificationOrganizationSubscribedAggregationSelectionResolvers<ContextType>;
  QuestNotificationOrganizationSubscribedEdgeAggregateSelection?: QuestNotificationOrganizationSubscribedEdgeAggregateSelectionResolvers<ContextType>;
  QuestNotificationOrganizationSubscribedNodeAggregateSelection?: QuestNotificationOrganizationSubscribedNodeAggregateSelectionResolvers<ContextType>;
  QuestNotificationSubscribedConnection?: QuestNotificationSubscribedConnectionResolvers<ContextType>;
  QuestNotificationSubscribedRelationship?: QuestNotificationSubscribedRelationshipResolvers<ContextType>;
  QuestNotificationsConnection?: QuestNotificationsConnectionResolvers<ContextType>;
  Refund?: RefundResolvers<ContextType>;
  RefundAgreementAgreementAggregationSelection?: RefundAgreementAgreementAggregationSelectionResolvers<ContextType>;
  RefundAgreementAgreementNodeAggregateSelection?: RefundAgreementAgreementNodeAggregateSelectionResolvers<ContextType>;
  RefundAgreementConnection?: RefundAgreementConnectionResolvers<ContextType>;
  RefundAgreementRelationship?: RefundAgreementRelationshipResolvers<ContextType>;
  RefundCaseCaseAggregationSelection?: RefundCaseCaseAggregationSelectionResolvers<ContextType>;
  RefundCaseCaseNodeAggregateSelection?: RefundCaseCaseNodeAggregateSelectionResolvers<ContextType>;
  RefundCaseConnection?: RefundCaseConnectionResolvers<ContextType>;
  RefundCaseRelationship?: RefundCaseRelationshipResolvers<ContextType>;
  RefundDocumentDocumentsAggregationSelection?: RefundDocumentDocumentsAggregationSelectionResolvers<ContextType>;
  RefundDocumentDocumentsNodeAggregateSelection?: RefundDocumentDocumentsNodeAggregateSelectionResolvers<ContextType>;
  RefundDocumentFinancialDataPointConnection?: RefundDocumentFinancialDataPointConnectionResolvers<ContextType>;
  RefundDocumentFinancialDataPointRelationship?: RefundDocumentFinancialDataPointRelationshipResolvers<ContextType>;
  RefundDocumentsConnection?: RefundDocumentsConnectionResolvers<ContextType>;
  RefundDocumentsRelationship?: RefundDocumentsRelationshipResolvers<ContextType>;
  RefundEdge?: RefundEdgeResolvers<ContextType>;
  RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection?: RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelectionResolvers<ContextType>;
  RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection?: RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelectionResolvers<ContextType>;
  RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection?: RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelectionResolvers<ContextType>;
  RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection?: RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelectionResolvers<ContextType>;
  RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection?: RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelectionResolvers<ContextType>;
  RefundSourceFinancialDataPointConnection?: RefundSourceFinancialDataPointConnectionResolvers<ContextType>;
  RefundSourceFinancialDataPointRelationship?: RefundSourceFinancialDataPointRelationshipResolvers<ContextType>;
  RefundsConnection?: RefundsConnectionResolvers<ContextType>;
  RunCheck?: RunCheckResolvers<ContextType>;
  RunCheckAlertAlertsAggregationSelection?: RunCheckAlertAlertsAggregationSelectionResolvers<ContextType>;
  RunCheckAlertAlertsNodeAggregateSelection?: RunCheckAlertAlertsNodeAggregateSelectionResolvers<ContextType>;
  RunCheckAlertsConnection?: RunCheckAlertsConnectionResolvers<ContextType>;
  RunCheckAlertsRelationship?: RunCheckAlertsRelationshipResolvers<ContextType>;
  RunCheckEdge?: RunCheckEdgeResolvers<ContextType>;
  RunCheckRunCheckValuesValuesAggregationSelection?: RunCheckRunCheckValuesValuesAggregationSelectionResolvers<ContextType>;
  RunCheckRunCheckValuesValuesNodeAggregateSelection?: RunCheckRunCheckValuesValuesNodeAggregateSelectionResolvers<ContextType>;
  RunCheckValues?: RunCheckValuesResolvers<ContextType>;
  RunCheckValuesCheckConnection?: RunCheckValuesCheckConnectionResolvers<ContextType>;
  RunCheckValuesCheckRelationship?: RunCheckValuesCheckRelationshipResolvers<ContextType>;
  RunCheckValuesConnection?: RunCheckValuesConnectionResolvers<ContextType>;
  RunCheckValuesEdge?: RunCheckValuesEdgeResolvers<ContextType>;
  RunCheckValuesRelationship?: RunCheckValuesRelationshipResolvers<ContextType>;
  RunCheckValuesRunCheckCheckAggregationSelection?: RunCheckValuesRunCheckCheckAggregationSelectionResolvers<ContextType>;
  RunCheckValuesRunCheckCheckNodeAggregateSelection?: RunCheckValuesRunCheckCheckNodeAggregateSelectionResolvers<ContextType>;
  RunCheckValuesWithTypeRelationship?: RunCheckValuesWithTypeRelationshipResolvers<ContextType>;
  RunChecksConnection?: RunChecksConnectionResolvers<ContextType>;
  RunDQCReport?: RunDqcReportResolvers<ContextType>;
  RunDQCReportChecksConnection?: RunDqcReportChecksConnectionResolvers<ContextType>;
  RunDQCReportChecksRelationship?: RunDqcReportChecksRelationshipResolvers<ContextType>;
  RunDQCReportEdge?: RunDqcReportEdgeResolvers<ContextType>;
  RunDQCReportRunCheckChecksAggregationSelection?: RunDqcReportRunCheckChecksAggregationSelectionResolvers<ContextType>;
  RunDQCReportRunCheckChecksNodeAggregateSelection?: RunDqcReportRunCheckChecksNodeAggregateSelectionResolvers<ContextType>;
  RunDqcReportsConnection?: RunDqcReportsConnectionResolvers<ContextType>;
  RunnableCheck?: RunnableCheckResolvers<ContextType>;
  RunnableCheckEdge?: RunnableCheckEdgeResolvers<ContextType>;
  RunnableChecksConnection?: RunnableChecksConnectionResolvers<ContextType>;
  RunningJobState?: RunningJobStateResolvers<ContextType>;
  RunningJobStateEdge?: RunningJobStateEdgeResolvers<ContextType>;
  RunningJobStatesConnection?: RunningJobStatesConnectionResolvers<ContextType>;
  Scenario?: ScenarioResolvers<ContextType>;
  ScenarioAction?: ScenarioActionResolvers<ContextType>;
  ScenarioActionBrandBrandsAggregationSelection?: ScenarioActionBrandBrandsAggregationSelectionResolvers<ContextType>;
  ScenarioActionBrandBrandsEdgeAggregateSelection?: ScenarioActionBrandBrandsEdgeAggregateSelectionResolvers<ContextType>;
  ScenarioActionBrandBrandsNodeAggregateSelection?: ScenarioActionBrandBrandsNodeAggregateSelectionResolvers<ContextType>;
  ScenarioActionBrandCombinedItemBrandsAggregationSelection?: ScenarioActionBrandCombinedItemBrandsAggregationSelectionResolvers<ContextType>;
  ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection?: ScenarioActionBrandCombinedItemBrandsNodeAggregateSelectionResolvers<ContextType>;
  ScenarioActionBrandsConnection?: ScenarioActionBrandsConnectionResolvers<ContextType>;
  ScenarioActionBrandsRelationship?: ScenarioActionBrandsRelationshipResolvers<ContextType>;
  ScenarioActionCombinedItemBrandsConnection?: ScenarioActionCombinedItemBrandsConnectionResolvers<ContextType>;
  ScenarioActionCombinedItemBrandsRelationship?: ScenarioActionCombinedItemBrandsRelationshipResolvers<ContextType>;
  ScenarioActionCombinedItemGenericsConnection?: ScenarioActionCombinedItemGenericsConnectionResolvers<ContextType>;
  ScenarioActionCombinedItemGenericsRelationship?: ScenarioActionCombinedItemGenericsRelationshipResolvers<ContextType>;
  ScenarioActionCombinedItemTreatmentsConnection?: ScenarioActionCombinedItemTreatmentsConnectionResolvers<ContextType>;
  ScenarioActionCombinedItemTreatmentsRelationship?: ScenarioActionCombinedItemTreatmentsRelationshipResolvers<ContextType>;
  ScenarioActionCycleConfigurationCycleAggregationSelection?: ScenarioActionCycleConfigurationCycleAggregationSelectionResolvers<ContextType>;
  ScenarioActionCycleConfigurationCycleNodeAggregateSelection?: ScenarioActionCycleConfigurationCycleNodeAggregateSelectionResolvers<ContextType>;
  ScenarioActionCycleConnection?: ScenarioActionCycleConnectionResolvers<ContextType>;
  ScenarioActionCycleRelationship?: ScenarioActionCycleRelationshipResolvers<ContextType>;
  ScenarioActionEdge?: ScenarioActionEdgeResolvers<ContextType>;
  ScenarioActionGenericCombinedItemGenericsAggregationSelection?: ScenarioActionGenericCombinedItemGenericsAggregationSelectionResolvers<ContextType>;
  ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection?: ScenarioActionGenericCombinedItemGenericsNodeAggregateSelectionResolvers<ContextType>;
  ScenarioActionGenericGenericsAggregationSelection?: ScenarioActionGenericGenericsAggregationSelectionResolvers<ContextType>;
  ScenarioActionGenericGenericsEdgeAggregateSelection?: ScenarioActionGenericGenericsEdgeAggregateSelectionResolvers<ContextType>;
  ScenarioActionGenericGenericsNodeAggregateSelection?: ScenarioActionGenericGenericsNodeAggregateSelectionResolvers<ContextType>;
  ScenarioActionGenericsConnection?: ScenarioActionGenericsConnectionResolvers<ContextType>;
  ScenarioActionGenericsRelationship?: ScenarioActionGenericsRelationshipResolvers<ContextType>;
  ScenarioActionScenarioConnection?: ScenarioActionScenarioConnectionResolvers<ContextType>;
  ScenarioActionScenarioRelationship?: ScenarioActionScenarioRelationshipResolvers<ContextType>;
  ScenarioActionScenarioScenarioAggregationSelection?: ScenarioActionScenarioScenarioAggregationSelectionResolvers<ContextType>;
  ScenarioActionScenarioScenarioNodeAggregateSelection?: ScenarioActionScenarioScenarioNodeAggregateSelectionResolvers<ContextType>;
  ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection?: ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelectionResolvers<ContextType>;
  ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection?: ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelectionResolvers<ContextType>;
  ScenarioActionTreatmentTreatmentsAggregationSelection?: ScenarioActionTreatmentTreatmentsAggregationSelectionResolvers<ContextType>;
  ScenarioActionTreatmentTreatmentsEdgeAggregateSelection?: ScenarioActionTreatmentTreatmentsEdgeAggregateSelectionResolvers<ContextType>;
  ScenarioActionTreatmentTreatmentsNodeAggregateSelection?: ScenarioActionTreatmentTreatmentsNodeAggregateSelectionResolvers<ContextType>;
  ScenarioActionTreatmentsConnection?: ScenarioActionTreatmentsConnectionResolvers<ContextType>;
  ScenarioActionTreatmentsRelationship?: ScenarioActionTreatmentsRelationshipResolvers<ContextType>;
  ScenarioActionsConnection?: ScenarioActionsConnectionResolvers<ContextType>;
  ScenarioActionsRelationship?: ScenarioActionsRelationshipResolvers<ContextType>;
  ScenarioCondition?: ScenarioConditionResolvers<ContextType>;
  ScenarioConditionBrandBrandsAggregationSelection?: ScenarioConditionBrandBrandsAggregationSelectionResolvers<ContextType>;
  ScenarioConditionBrandBrandsNodeAggregateSelection?: ScenarioConditionBrandBrandsNodeAggregateSelectionResolvers<ContextType>;
  ScenarioConditionBrandsConnection?: ScenarioConditionBrandsConnectionResolvers<ContextType>;
  ScenarioConditionBrandsRelationship?: ScenarioConditionBrandsRelationshipResolvers<ContextType>;
  ScenarioConditionCustomConditionConnection?: ScenarioConditionCustomConditionConnectionResolvers<ContextType>;
  ScenarioConditionCustomConditionCustomConditionAggregationSelection?: ScenarioConditionCustomConditionCustomConditionAggregationSelectionResolvers<ContextType>;
  ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection?: ScenarioConditionCustomConditionCustomConditionNodeAggregateSelectionResolvers<ContextType>;
  ScenarioConditionCustomConditionRelationship?: ScenarioConditionCustomConditionRelationshipResolvers<ContextType>;
  ScenarioConditionEdge?: ScenarioConditionEdgeResolvers<ContextType>;
  ScenarioConditionGenericGenericsAggregationSelection?: ScenarioConditionGenericGenericsAggregationSelectionResolvers<ContextType>;
  ScenarioConditionGenericGenericsNodeAggregateSelection?: ScenarioConditionGenericGenericsNodeAggregateSelectionResolvers<ContextType>;
  ScenarioConditionGenericsConnection?: ScenarioConditionGenericsConnectionResolvers<ContextType>;
  ScenarioConditionGenericsRelationship?: ScenarioConditionGenericsRelationshipResolvers<ContextType>;
  ScenarioConditionScenarioConnection?: ScenarioConditionScenarioConnectionResolvers<ContextType>;
  ScenarioConditionScenarioRelationship?: ScenarioConditionScenarioRelationshipResolvers<ContextType>;
  ScenarioConditionScenarioScenarioAggregationSelection?: ScenarioConditionScenarioScenarioAggregationSelectionResolvers<ContextType>;
  ScenarioConditionScenarioScenarioNodeAggregateSelection?: ScenarioConditionScenarioScenarioNodeAggregateSelectionResolvers<ContextType>;
  ScenarioConditionTreatmentTreatmentsAggregationSelection?: ScenarioConditionTreatmentTreatmentsAggregationSelectionResolvers<ContextType>;
  ScenarioConditionTreatmentTreatmentsNodeAggregateSelection?: ScenarioConditionTreatmentTreatmentsNodeAggregateSelectionResolvers<ContextType>;
  ScenarioConditionTreatmentsConnection?: ScenarioConditionTreatmentsConnectionResolvers<ContextType>;
  ScenarioConditionTreatmentsRelationship?: ScenarioConditionTreatmentsRelationshipResolvers<ContextType>;
  ScenarioConditionsConnection?: ScenarioConditionsConnectionResolvers<ContextType>;
  ScenarioConditionsRelationship?: ScenarioConditionsRelationshipResolvers<ContextType>;
  ScenarioEdge?: ScenarioEdgeResolvers<ContextType>;
  ScenarioInsightsUserContext?: ScenarioInsightsUserContextResolvers<ContextType>;
  ScenarioScenarioActionActionsAggregationSelection?: ScenarioScenarioActionActionsAggregationSelectionResolvers<ContextType>;
  ScenarioScenarioActionActionsNodeAggregateSelection?: ScenarioScenarioActionActionsNodeAggregateSelectionResolvers<ContextType>;
  ScenarioScenarioConditionConditionsAggregationSelection?: ScenarioScenarioConditionConditionsAggregationSelectionResolvers<ContextType>;
  ScenarioScenarioConditionConditionsNodeAggregateSelection?: ScenarioScenarioConditionConditionsNodeAggregateSelectionResolvers<ContextType>;
  ScenariosConnection?: ScenariosConnectionResolvers<ContextType>;
  ScopeCheckResult?: ScopeCheckResultResolvers<ContextType>;
  ScopeCheckResultEdge?: ScopeCheckResultEdgeResolvers<ContextType>;
  ScopeCheckResultsConnection?: ScopeCheckResultsConnectionResolvers<ContextType>;
  Simulation?: SimulationResolvers<ContextType>;
  SimulationAccessibleUsersConnection?: SimulationAccessibleUsersConnectionResolvers<ContextType>;
  SimulationAccessibleUsersRelationship?: SimulationAccessibleUsersRelationshipResolvers<ContextType>;
  SimulationAddedByConnection?: SimulationAddedByConnectionResolvers<ContextType>;
  SimulationAddedByRelationship?: SimulationAddedByRelationshipResolvers<ContextType>;
  SimulationBlueprintConnection?: SimulationBlueprintConnectionResolvers<ContextType>;
  SimulationBlueprintRelationship?: SimulationBlueprintRelationshipResolvers<ContextType>;
  SimulationCount?: SimulationCountResolvers<ContextType>;
  SimulationCountEdge?: SimulationCountEdgeResolvers<ContextType>;
  SimulationCountsConnection?: SimulationCountsConnectionResolvers<ContextType>;
  SimulationDomainConnection?: SimulationDomainConnectionResolvers<ContextType>;
  SimulationDomainDomainAggregationSelection?: SimulationDomainDomainAggregationSelectionResolvers<ContextType>;
  SimulationDomainDomainNodeAggregateSelection?: SimulationDomainDomainNodeAggregateSelectionResolvers<ContextType>;
  SimulationDomainRelationship?: SimulationDomainRelationshipResolvers<ContextType>;
  SimulationEdge?: SimulationEdgeResolvers<ContextType>;
  SimulationProductBlueprintBlueprintAggregationSelection?: SimulationProductBlueprintBlueprintAggregationSelectionResolvers<ContextType>;
  SimulationProductBlueprintBlueprintNodeAggregateSelection?: SimulationProductBlueprintBlueprintNodeAggregateSelectionResolvers<ContextType>;
  SimulationUserAccessibleUsersAggregationSelection?: SimulationUserAccessibleUsersAggregationSelectionResolvers<ContextType>;
  SimulationUserAccessibleUsersEdgeAggregateSelection?: SimulationUserAccessibleUsersEdgeAggregateSelectionResolvers<ContextType>;
  SimulationUserAccessibleUsersNodeAggregateSelection?: SimulationUserAccessibleUsersNodeAggregateSelectionResolvers<ContextType>;
  SimulationUserAddedByAggregationSelection?: SimulationUserAddedByAggregationSelectionResolvers<ContextType>;
  SimulationUserAddedByNodeAggregateSelection?: SimulationUserAddedByNodeAggregateSelectionResolvers<ContextType>;
  SimulationUserWithRole?: SimulationUserWithRoleResolvers<ContextType>;
  SimulationUserWithRoleEdge?: SimulationUserWithRoleEdgeResolvers<ContextType>;
  SimulationUserWithRolesConnection?: SimulationUserWithRolesConnectionResolvers<ContextType>;
  SimulationsConnection?: SimulationsConnectionResolvers<ContextType>;
  SimulatorUserRoleRelationship?: SimulatorUserRoleRelationshipResolvers<ContextType>;
  SlowGraphqlOperation?: SlowGraphqlOperationResolvers<ContextType>;
  SlowGraphqlOperationEdge?: SlowGraphqlOperationEdgeResolvers<ContextType>;
  SlowGraphqlOperationsConnection?: SlowGraphqlOperationsConnectionResolvers<ContextType>;
  SlowGraphqlRequestsResult?: SlowGraphqlRequestsResultResolvers<ContextType>;
  SlowGraphqlRequestsResultEdge?: SlowGraphqlRequestsResultEdgeResolvers<ContextType>;
  SlowGraphqlRequestsResultsConnection?: SlowGraphqlRequestsResultsConnectionResolvers<ContextType>;
  StoreUser?: StoreUserResolvers<ContextType>;
  StoreUserEdge?: StoreUserEdgeResolvers<ContextType>;
  StoreUsersConnection?: StoreUsersConnectionResolvers<ContextType>;
  StringAggregateSelectionNonNullable?: StringAggregateSelectionNonNullableResolvers<ContextType>;
  StringAggregateSelectionNullable?: StringAggregateSelectionNullableResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SyncRefundImpact?: SyncRefundImpactResolvers<ContextType>;
  SyncRefundImpactEdge?: SyncRefundImpactEdgeResolvers<ContextType>;
  SyncRefundImpactsConnection?: SyncRefundImpactsConnectionResolvers<ContextType>;
  SyncResponse?: SyncResponseResolvers<ContextType>;
  SyncResponseEdge?: SyncResponseEdgeResolvers<ContextType>;
  SyncResponsesConnection?: SyncResponsesConnectionResolvers<ContextType>;
  SystemTask?: SystemTaskResolvers<ContextType>;
  SystemTaskEdge?: SystemTaskEdgeResolvers<ContextType>;
  SystemTasksConnection?: SystemTasksConnectionResolvers<ContextType>;
  ThresholdConfigurationRelationship?: ThresholdConfigurationRelationshipResolvers<ContextType>;
  Translation?: TranslationResolvers<ContextType>;
  TranslationEdge?: TranslationEdgeResolvers<ContextType>;
  TranslationsConnection?: TranslationsConnectionResolvers<ContextType>;
  TranslationsWithChangedKeys?: TranslationsWithChangedKeysResolvers<ContextType>;
  TranslationsWithChangedKeysConnection?: TranslationsWithChangedKeysConnectionResolvers<ContextType>;
  TranslationsWithChangedKeysEdge?: TranslationsWithChangedKeysEdgeResolvers<ContextType>;
  Treatment?: TreatmentResolvers<ContextType>;
  TreatmentCountryConnection?: TreatmentCountryConnectionResolvers<ContextType>;
  TreatmentCountryCountryAggregationSelection?: TreatmentCountryCountryAggregationSelectionResolvers<ContextType>;
  TreatmentCountryCountryNodeAggregateSelection?: TreatmentCountryCountryNodeAggregateSelectionResolvers<ContextType>;
  TreatmentCountryRelationship?: TreatmentCountryRelationshipResolvers<ContextType>;
  TreatmentEdge?: TreatmentEdgeResolvers<ContextType>;
  TreatmentHasLimitationsConnection?: TreatmentHasLimitationsConnectionResolvers<ContextType>;
  TreatmentHasLimitationsRelationship?: TreatmentHasLimitationsRelationshipResolvers<ContextType>;
  TreatmentLimitationHasLimitationsAggregationSelection?: TreatmentLimitationHasLimitationsAggregationSelectionResolvers<ContextType>;
  TreatmentLimitationHasLimitationsNodeAggregateSelection?: TreatmentLimitationHasLimitationsNodeAggregateSelectionResolvers<ContextType>;
  TreatmentPartnerPartnersAggregationSelection?: TreatmentPartnerPartnersAggregationSelectionResolvers<ContextType>;
  TreatmentPartnerPartnersNodeAggregateSelection?: TreatmentPartnerPartnersNodeAggregateSelectionResolvers<ContextType>;
  TreatmentPartnersConnection?: TreatmentPartnersConnectionResolvers<ContextType>;
  TreatmentPartnersRelationship?: TreatmentPartnersRelationshipResolvers<ContextType>;
  TreatmentPreparationRegulatedByAggregationSelection?: TreatmentPreparationRegulatedByAggregationSelectionResolvers<ContextType>;
  TreatmentPreparationRegulatedByNodeAggregateSelection?: TreatmentPreparationRegulatedByNodeAggregateSelectionResolvers<ContextType>;
  TreatmentPreparationStatusStatusAggregationSelection?: TreatmentPreparationStatusStatusAggregationSelectionResolvers<ContextType>;
  TreatmentPreparationStatusStatusNodeAggregateSelection?: TreatmentPreparationStatusStatusNodeAggregateSelectionResolvers<ContextType>;
  TreatmentPricePricesAggregationSelection?: TreatmentPricePricesAggregationSelectionResolvers<ContextType>;
  TreatmentPricePricesNodeAggregateSelection?: TreatmentPricePricesNodeAggregateSelectionResolvers<ContextType>;
  TreatmentPricesConnection?: TreatmentPricesConnectionResolvers<ContextType>;
  TreatmentPricesRelationship?: TreatmentPricesRelationshipResolvers<ContextType>;
  TreatmentRegulatedByConnection?: TreatmentRegulatedByConnectionResolvers<ContextType>;
  TreatmentRegulatedByRelationship?: TreatmentRegulatedByRelationshipResolvers<ContextType>;
  TreatmentSet?: TreatmentSetResolvers<ContextType>;
  TreatmentSetAgreementScopeScopeAggregationSelection?: TreatmentSetAgreementScopeScopeAggregationSelectionResolvers<ContextType>;
  TreatmentSetAgreementScopeScopeNodeAggregateSelection?: TreatmentSetAgreementScopeScopeNodeAggregateSelectionResolvers<ContextType>;
  TreatmentSetEdge?: TreatmentSetEdgeResolvers<ContextType>;
  TreatmentSetGenericConnection?: TreatmentSetGenericConnectionResolvers<ContextType>;
  TreatmentSetGenericGenericAggregationSelection?: TreatmentSetGenericGenericAggregationSelectionResolvers<ContextType>;
  TreatmentSetGenericGenericNodeAggregateSelection?: TreatmentSetGenericGenericNodeAggregateSelectionResolvers<ContextType>;
  TreatmentSetGenericRelationship?: TreatmentSetGenericRelationshipResolvers<ContextType>;
  TreatmentSetPreparationPreparationsAggregationSelection?: TreatmentSetPreparationPreparationsAggregationSelectionResolvers<ContextType>;
  TreatmentSetPreparationPreparationsNodeAggregateSelection?: TreatmentSetPreparationPreparationsNodeAggregateSelectionResolvers<ContextType>;
  TreatmentSetPreparationsConnection?: TreatmentSetPreparationsConnectionResolvers<ContextType>;
  TreatmentSetPreparationsRelationship?: TreatmentSetPreparationsRelationshipResolvers<ContextType>;
  TreatmentSetScopeConnection?: TreatmentSetScopeConnectionResolvers<ContextType>;
  TreatmentSetScopeRelationship?: TreatmentSetScopeRelationshipResolvers<ContextType>;
  TreatmentSetTreatmentTreatmentsAggregationSelection?: TreatmentSetTreatmentTreatmentsAggregationSelectionResolvers<ContextType>;
  TreatmentSetTreatmentTreatmentsNodeAggregateSelection?: TreatmentSetTreatmentTreatmentsNodeAggregateSelectionResolvers<ContextType>;
  TreatmentSetTreatmentsConnection?: TreatmentSetTreatmentsConnectionResolvers<ContextType>;
  TreatmentSetTreatmentsRelationship?: TreatmentSetTreatmentsRelationshipResolvers<ContextType>;
  TreatmentSetsConnection?: TreatmentSetsConnectionResolvers<ContextType>;
  TreatmentStatusConnection?: TreatmentStatusConnectionResolvers<ContextType>;
  TreatmentStatusRelationship?: TreatmentStatusRelationshipResolvers<ContextType>;
  TreatmentsConnection?: TreatmentsConnectionResolvers<ContextType>;
  Upload?: UploadResolvers<ContextType>;
  UploadEdge?: UploadEdgeResolvers<ContextType>;
  UploadFlexEntitiesConnection?: UploadFlexEntitiesConnectionResolvers<ContextType>;
  UploadFlexEntitiesRelationship?: UploadFlexEntitiesRelationshipResolvers<ContextType>;
  UploadFlexEntityFlexEntitiesAggregationSelection?: UploadFlexEntityFlexEntitiesAggregationSelectionResolvers<ContextType>;
  UploadFlexEntityFlexEntitiesNodeAggregateSelection?: UploadFlexEntityFlexEntitiesNodeAggregateSelectionResolvers<ContextType>;
  UploadLimitation?: UploadLimitationResolvers<ContextType>;
  UploadLimitationEdge?: UploadLimitationEdgeResolvers<ContextType>;
  UploadLimitationUpdatedByConnection?: UploadLimitationUpdatedByConnectionResolvers<ContextType>;
  UploadLimitationUpdatedByRelationship?: UploadLimitationUpdatedByRelationshipResolvers<ContextType>;
  UploadLimitationUpdaterRelationship?: UploadLimitationUpdaterRelationshipResolvers<ContextType>;
  UploadLimitationUserUpdatedByAggregationSelection?: UploadLimitationUserUpdatedByAggregationSelectionResolvers<ContextType>;
  UploadLimitationUserUpdatedByEdgeAggregateSelection?: UploadLimitationUserUpdatedByEdgeAggregateSelectionResolvers<ContextType>;
  UploadLimitationUserUpdatedByNodeAggregateSelection?: UploadLimitationUserUpdatedByNodeAggregateSelectionResolvers<ContextType>;
  UploadLimitationsConnection?: UploadLimitationsConnectionResolvers<ContextType>;
  UploadState?: UploadStateResolvers<ContextType>;
  UploadStateEdge?: UploadStateEdgeResolvers<ContextType>;
  UploadStatesConnection?: UploadStatesConnectionResolvers<ContextType>;
  UploadsConnection?: UploadsConnectionResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserAvailableEntryModule?: UserAvailableEntryModuleResolvers<ContextType>;
  UserAvailableEntryModuleEdge?: UserAvailableEntryModuleEdgeResolvers<ContextType>;
  UserAvailableEntryModulesConnection?: UserAvailableEntryModulesConnectionResolvers<ContextType>;
  UserContext?: UserContextResolvers<ContextType>;
  UserContextEdge?: UserContextEdgeResolvers<ContextType>;
  UserContextsConnection?: UserContextsConnectionResolvers<ContextType>;
  UserDomainDomainsAggregationSelection?: UserDomainDomainsAggregationSelectionResolvers<ContextType>;
  UserDomainDomainsNodeAggregateSelection?: UserDomainDomainsNodeAggregateSelectionResolvers<ContextType>;
  UserDomainsConnection?: UserDomainsConnectionResolvers<ContextType>;
  UserDomainsRelationship?: UserDomainsRelationshipResolvers<ContextType>;
  UserEdge?: UserEdgeResolvers<ContextType>;
  UserOrgSettingsData?: UserOrgSettingsDataResolvers<ContextType>;
  UserOrgSettingsDataConnection?: UserOrgSettingsDataConnectionResolvers<ContextType>;
  UserOrgSettingsDataEdge?: UserOrgSettingsDataEdgeResolvers<ContextType>;
  UserOrganizationInfo?: UserOrganizationInfoResolvers<ContextType>;
  UserOrganizationInfoEdge?: UserOrganizationInfoEdgeResolvers<ContextType>;
  UserOrganizationInfosConnection?: UserOrganizationInfosConnectionResolvers<ContextType>;
  UsersConnection?: UsersConnectionResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  clob?: ClobDirectiveResolver<any, any, ContextType>;
  max?: MaxDirectiveResolver<any, any, ContextType>;
  min?: MinDirectiveResolver<any, any, ContextType>;
};
